import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
  JSON: { input: any; output: any }
}

export type AiFeatureUsageLimit = {
  __typename?: 'AIFeatureUsageLimit'
  limit: Scalars['Int']['output']
  usage: Scalars['Int']['output']
}

export type AiMessageInput = {
  isComplete: Scalars['Boolean']['input']
  response: Scalars['String']['input']
  sourcingRequest?: InputMaybe<SourcingRequestInput>
}

export type Achievement = {
  __typename?: 'Achievement'
  description?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  issueYear?: Maybe<Scalars['Int']['output']>
  issuingAuthority?: Maybe<Scalars['String']['output']>
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  organization?: Maybe<CompanyGlobal>
  searchDescription?: Maybe<Scalars['String']['output']>
}

export type AchievementInput = {
  companyGlobalId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  issueYear?: InputMaybe<Scalars['Int']['input']>
  issuingAuthority?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  searchDescription?: InputMaybe<Scalars['String']['input']>
}

export type ActivateCompanyUserInput = {
  companyUserId: Scalars['Int']['input']
}

export type ActivityLog = {
  __typename?: 'ActivityLog'
  CandidateApplication?: Maybe<CandidateApplication>
  CandidateProfile?: Maybe<CandidateProfile>
  CompanyCandidateTouchpoint?: Maybe<CompanyCandidateTouchpoint>
  CompanyUser?: Maybe<CompanyUser>
  TemplateStage?: Maybe<TemplateStage>
  activity?: Maybe<Scalars['JSON']['output']>
  activityTimestamp?: Maybe<Scalars['DateTime']['output']>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  companyCandidateTouchpointId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  jobAction?: Maybe<JobActionEnum>
  previousTemplateStageId?: Maybe<Scalars['Int']['output']>
  templateStageId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
  userAction?: Maybe<UserActionEnum>
}

export type ActivityLogOptionsInput = {
  message?: InputMaybe<Scalars['String']['input']>
  templateStageId?: InputMaybe<Scalars['Int']['input']>
  userAction: UserActionEnum
}

export enum ActivityLogsFilterContentTypeEnum {
  CandidateNames = 'candidateNames',
  Labels = 'labels',
}

export type AddCandidatesToSequenceInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  sequenceId: Scalars['String']['input']
}

export type AddInterviewTemplateInterviewerInput = {
  companyUserId: Scalars['Int']['input']
  interviewTemplateId: Scalars['Int']['input']
  isOrganizer?: InputMaybe<Scalars['Boolean']['input']>
}

export type AddSavedViewInput = {
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  requisitionTalentPoolCompanySavedViewId: Scalars['Int']['input']
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type AddSavedViewResponse = {
  __typename?: 'AddSavedViewResponse'
  companyUserView: CompanyUserView
  requisitionTalentPoolCompanySavedView: RequisitionTalentPoolCompanySavedView
}

export type Address = {
  __typename?: 'Address'
  activeStatus?: Maybe<Scalars['Boolean']['output']>
  addressLine1?: Maybe<Scalars['String']['output']>
  addressLine2?: Maybe<Scalars['String']['output']>
  addressType?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  contactName?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  jobListingId?: Maybe<Scalars['Int']['output']>
  latitude?: Maybe<Scalars['String']['output']>
  longitude?: Maybe<Scalars['String']['output']>
  officeId?: Maybe<Scalars['Int']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  scalisUserId?: Maybe<Scalars['Int']['output']>
  state?: Maybe<Scalars['String']['output']>
  timeZone?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type AdvanceCandidateApplicationInput = {
  applicationStatus?: InputMaybe<ApplicationStatusEnum>
  candidateApplicationIds: Array<Scalars['Int']['input']>
  customApplicationStatusId?: InputMaybe<Scalars['Int']['input']>
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  doNotNotifyCandidate?: InputMaybe<Scalars['Boolean']['input']>
  hostCalendarId?: InputMaybe<Scalars['Int']['input']>
  interviewLength?: InputMaybe<Scalars['Int']['input']>
  interviewSchedule?: InputMaybe<InterviewScheduleEnum>
  interviewers?: InputMaybe<Array<Scalars['Int']['input']>>
  message?: InputMaybe<Scalars['String']['input']>
  nextTemplateStageId: Scalars['Int']['input']
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type AdvanceFromOfferToHiredInput = {
  candidateApplicationId: Scalars['Int']['input']
}

export type AiCreditBalance = {
  __typename?: 'AiCreditBalance'
  Company: Company
  availableCredits: Scalars['Int']['output']
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['String']['output']
  lastResetDate: Scalars['DateTime']['output']
  totalCredits: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
  usedCredits: Scalars['Int']['output']
}

export type AiCreditPackage = {
  __typename?: 'AiCreditPackage'
  createdAt: Scalars['DateTime']['output']
  creditsAmount: Scalars['Int']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  pricePerCredit: Scalars['Float']['output']
  sortOrder: Scalars['Int']['output']
  totalPrice: Scalars['Float']['output']
  updatedAt: Scalars['DateTime']['output']
  vatAmount: Scalars['Float']['output']
}

export type AiCreditPurchaseResponse = {
  __typename?: 'AiCreditPurchaseResponse'
  clientSecret: Scalars['String']['output']
  orderReference: Scalars['String']['output']
  packageInfo: Scalars['JSON']['output']
  price: Scalars['JSON']['output']
}

export type AiSourcingCredits = {
  __typename?: 'AiSourcingCredits'
  AiCreditPackage: AiCreditPackage
  Company: Company
  Order?: Maybe<Order>
  aiCreditPackageId: Scalars['String']['output']
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  creditsAmount: Scalars['Int']['output']
  id: Scalars['String']['output']
  orderId?: Maybe<Scalars['Int']['output']>
  pricePerCredit: Scalars['Float']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type AnswerInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>
  checkboxes?: InputMaybe<Array<Scalars['String']['input']>>
  date?: InputMaybe<Scalars['DateTime']['input']>
  freeResponse?: InputMaybe<Scalars['String']['input']>
  multipleChoice?: InputMaybe<Scalars['String']['input']>
  numerical?: InputMaybe<Scalars['Float']['input']>
  yesNo?: InputMaybe<Scalars['Boolean']['input']>
}

export type ApplicantNotes = {
  __typename?: 'ApplicantNotes'
  UserNote?: Maybe<UserNote>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  scalisUserId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  userNoteId?: Maybe<Scalars['Int']['output']>
}

export enum ApplicationCreationTypeEnum {
  Dummy = 'DUMMY',
}

export type ApplicationFiltersOnCandidateProfile = {
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationStatusNotIn?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum>>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']>>
  companies?: InputMaybe<Array<Scalars['String']['input']>>
  companyId?: InputMaybe<Scalars['Int']['input']>
  creditedCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']>>
  educationLevel?: InputMaybe<Array<EducationLevelEnum>>
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  jobTitles?: InputMaybe<Array<Scalars['String']['input']>>
  labels?: InputMaybe<Array<Scalars['Int']['input']>>
  lastActivity?: InputMaybe<LastActivity>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  majors?: InputMaybe<Array<Scalars['String']['input']>>
  matchScore?: InputMaybe<MatchScore>
  medalistDesignation?: InputMaybe<Array<Scalars['String']['input']>>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  profileType?: InputMaybe<ProfileTypeEnum>
  prospectOwner?: InputMaybe<Array<Scalars['Int']['input']>>
  prospectStatus?: InputMaybe<Array<Scalars['Int']['input']>>
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']>>
  raceEthnicity?: InputMaybe<Array<RaceEthnicityEnum>>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
  schools?: InputMaybe<Array<Scalars['String']['input']>>
  search?: InputMaybe<Scalars['String']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  sourceCategory?: InputMaybe<Array<SourceCategoryEnum>>
  sourceName?: InputMaybe<Array<Scalars['String']['input']>>
  templateMilestoneNotIn?: InputMaybe<Array<NameEnum>>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']>>
  timezones?: InputMaybe<Array<Scalars['String']['input']>>
  veteranStatus?: InputMaybe<Array<VeteranStatusEnum>>
  willingToRelocate?: InputMaybe<Array<WillingToRelocateEnum>>
  yearsOfExperience?: InputMaybe<Scalars['Int']['input']>
}

export type ApplicationForm = {
  __typename?: 'ApplicationForm'
  ApplicationFormScreeningQuestion?: Maybe<Array<ApplicationFormScreeningQuestion>>
  Company?: Maybe<Company>
  CompanyDepartment?: Maybe<CompanyDepartment>
  CompanyOffice?: Maybe<CompanyOffice>
  CompanyUser?: Maybe<CompanyUser>
  companyDepartmentId?: Maybe<Scalars['Int']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  companyOfficeId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isArchived?: Maybe<Scalars['Boolean']['output']>
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  isEdited?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ApplicationFormScreeningQuestion = {
  __typename?: 'ApplicationFormScreeningQuestion'
  ApplicationForm?: Maybe<ApplicationForm>
  ScreeningQuestion?: Maybe<ScreeningQuestion>
  applicationFormId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isActive?: Maybe<Scalars['Boolean']['output']>
  rankOrder?: Maybe<Scalars['Int']['output']>
  screeningQuestionId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum ApplicationFormSortFields {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Department = 'department',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt',
}

export type ApplicationFormsCount = {
  __typename?: 'ApplicationFormsCount'
  count: Scalars['Int']['output']
}

export type ApplicationRejection = {
  __typename?: 'ApplicationRejection'
  CandidateApplication?: Maybe<CandidateApplication>
  CandidateMessage?: Maybe<CandidateMessage>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  details?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  messageId?: Maybe<Scalars['Int']['output']>
  reason?: Maybe<RejectionReasonEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum ApplicationStatusEnum {
  Custom = 'CUSTOM',
  InterviewCompleted = 'INTERVIEW_COMPLETED',
  InterviewNotScheduled = 'INTERVIEW_NOT_SCHEDULED',
  InterviewRequested = 'INTERVIEW_REQUESTED',
  InterviewResend = 'INTERVIEW_RESEND',
  InterviewScheduled = 'INTERVIEW_SCHEDULED',
  InvitedToApply = 'INVITED_TO_APPLY',
  InviteDeclined = 'INVITE_DECLINED',
  NeedsReview = 'NEEDS_REVIEW',
  Prospect = 'PROSPECT',
  Rejected = 'REJECTED',
  RejectionCancelled = 'REJECTION_CANCELLED',
  RejectionPending = 'REJECTION_PENDING',
}

export enum ApplicationTypeEnum {
  Dynamic = 'DYNAMIC',
  Static = 'STATIC',
}

export type ApprovalReviewerStatus = {
  __typename?: 'ApprovalReviewerStatus'
  ApprovalWorkflowVersionStep: ApprovalWorkflowVersionStep
  CompanyUser?: Maybe<CompanyUser>
  CompanyUserGroup?: Maybe<CompanyUserGroup>
  RespondedBy?: Maybe<CompanyUser>
  approvalReviewStatus: ApprovalWorkflowStatusEnum
  approvalWorkflowVersionStepId: Scalars['Int']['output']
  comments?: Maybe<Scalars['String']['output']>
  companyUserGroupId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  hiringTeamRole?: Maybe<RoleEnum>
  id: Scalars['ID']['output']
  respondedToBy?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum ApprovalStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export enum ApprovalStrictnessLevelEnum {
  All = 'ALL',
  AtLeastOne = 'AT_LEAST_ONE',
}

export type ApprovalWorkflowEntityMapping = {
  __typename?: 'ApprovalWorkflowEntityMapping'
  ApprovalWorkflowVersion: ApprovalWorkflowVersion
  CandidateOfferVersion?: Maybe<CandidateOfferVersion>
  JobOpening?: Maybe<JobOpening>
  Requisition?: Maybe<Requisition>
  approvalWorkflowVersionId: Scalars['Int']['output']
  candidateOfferVersionId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  jobOpeningId?: Maybe<Scalars['Int']['output']>
  requisitionId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type ApprovalWorkflowInstanceDetails = {
  __typename?: 'ApprovalWorkflowInstanceDetails'
  canRespondToAnyStep: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  entityMappings: Array<ApprovalWorkflowInstanceEntityMapping>
  externalId: Scalars['String']['output']
  status: Scalars['String']['output']
  steps: Array<ApprovalWorkflowInstanceStep>
  updatedAt: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  workflowVersionId: Scalars['Int']['output']
}

export type ApprovalWorkflowInstanceEntityMapping = {
  __typename?: 'ApprovalWorkflowInstanceEntityMapping'
  candidateOfferVersionId?: Maybe<Scalars['Int']['output']>
  jobOpeningId?: Maybe<Scalars['Int']['output']>
  requisitionId?: Maybe<Scalars['Int']['output']>
}

export type ApprovalWorkflowInstanceResponse = {
  __typename?: 'ApprovalWorkflowInstanceResponse'
  workflowVersionId: Scalars['Int']['output']
}

export type ApprovalWorkflowInstanceStep = {
  __typename?: 'ApprovalWorkflowInstanceStep'
  approvalStepStatus: ApprovalWorkflowStatusEnum
  approvalStrictnessLevel: Scalars['String']['output']
  approvalWorkflowVersionId: Scalars['Int']['output']
  canRespond: Scalars['Boolean']['output']
  createdAt: Scalars['DateTime']['output']
  finalStep: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  rankOrder: Scalars['Int']['output']
  reviewers: Array<ApprovalWorkflowInstanceStepReviewer>
  updatedAt: Scalars['DateTime']['output']
}

export type ApprovalWorkflowInstanceStepReviewer = {
  __typename?: 'ApprovalWorkflowInstanceStepReviewer'
  canRespond: Scalars['Boolean']['output']
  comments?: Maybe<Scalars['String']['output']>
  companyUserGroupId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  hiringTeamRole?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  respondedAt?: Maybe<Scalars['DateTime']['output']>
  respondedToBy?: Maybe<Scalars['Int']['output']>
  status: Scalars['String']['output']
}

export type ApprovalWorkflowRequirementResponse = {
  __typename?: 'ApprovalWorkflowRequirementResponse'
  matchingWorkflowIds?: Maybe<Array<Scalars['Int']['output']>>
  requiresApproval: Scalars['Boolean']['output']
  workflowId?: Maybe<Scalars['Int']['output']>
  workflowSteps?: Maybe<Array<ApprovalWorkflowStep>>
}

export type ApprovalWorkflowReviewer = {
  __typename?: 'ApprovalWorkflowReviewer'
  companyUserGroupId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  hiringTeamRole?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
}

export type ApprovalWorkflowReviewerInput = {
  companyUserGroupId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  hiringTeamRole?: InputMaybe<RoleEnum>
}

export type ApprovalWorkflowReviewerResponse = {
  __typename?: 'ApprovalWorkflowReviewerResponse'
  response: Scalars['String']['output']
  reviewerStatusId: Scalars['Int']['output']
  stepId: Scalars['Int']['output']
  stepStatus: Scalars['String']['output']
  workflowStatus: Scalars['String']['output']
  workflowVersionId: Scalars['Int']['output']
}

export type ApprovalWorkflowReviewerResponseInput = {
  approvalReviewerStatusId: Scalars['Int']['input']
  comments?: InputMaybe<Scalars['String']['input']>
  response: Scalars['String']['input']
}

export enum ApprovalWorkflowScopeEnum {
  Job = 'JOB',
  Offer = 'OFFER',
  Opening = 'OPENING',
}

export enum ApprovalWorkflowStatusEnum {
  ApprovalPending = 'APPROVAL_PENDING',
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Rejected = 'REJECTED',
}

export type ApprovalWorkflowStep = {
  __typename?: 'ApprovalWorkflowStep'
  approvalStrictnessLevel: Scalars['String']['output']
  finalStep: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  rankOrder: Scalars['Int']['output']
  reviewers: Array<ApprovalWorkflowReviewer>
}

export type ApprovalWorkflowStepInput = {
  approvalStrictnessLevel: ApprovalStrictnessLevelEnum
  finalStep: Scalars['Boolean']['input']
  rankOrder: Scalars['Int']['input']
  reviewers: Array<ApprovalWorkflowReviewerInput>
}

export enum ApprovalWorkflowTypeEnum {
  JobRequisition = 'JOB_REQUISITION',
  Offer = 'OFFER',
  Opening = 'OPENING',
}

export type ApprovalWorkflowVersion = {
  __typename?: 'ApprovalWorkflowVersion'
  approvalWorkflowStatus: ApprovalWorkflowStatusEnum
  createdAt: Scalars['DateTime']['output']
  entityMappings: Array<ApprovalWorkflowEntityMapping>
  externalId: Scalars['String']['output']
  id: Scalars['ID']['output']
  nextVersions: Array<ApprovalWorkflowVersion>
  previousVersion?: Maybe<ApprovalWorkflowVersion>
  previousWorkflowVersion?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
  version: Scalars['Int']['output']
  workflowVersionSteps: Array<ApprovalWorkflowVersionStep>
}

export type ApprovalWorkflowVersionStep = {
  __typename?: 'ApprovalWorkflowVersionStep'
  approvalReviewerStatus: Array<ApprovalReviewerStatus>
  approvalStepStatus: ApprovalWorkflowStatusEnum
  approvalStrictnessLevel: ApprovalStrictnessLevelEnum
  approvalWorkflowVersion: ApprovalWorkflowVersion
  approvalWorkflowVersionId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  finalStep: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  rankOrder: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type ArchiveCustomCandidateApplicationFieldInput = {
  id: Scalars['Int']['input']
}

export type ArchiveCustomCandidateProfileFieldInput = {
  id: Scalars['Int']['input']
}

export type ArchiveCustomJobRequisitionFieldInput = {
  id: Scalars['Int']['input']
}

export type ArchiveInterviewTemplateInput = {
  id: Scalars['Int']['input']
}

export type ArchiveInterviewerPoolInput = {
  id: Scalars['Int']['input']
}

/** Input type for archiving an offer custom field */
export type ArchiveOfferCustomFieldInput = {
  /** Unique identifier of the offer custom field to archive */
  id: Scalars['Int']['input']
}

export type ArchiveSequenceInput = {
  archivedReason?: InputMaybe<Scalars['String']['input']>
  sequenceId: Scalars['String']['input']
}

export type ArchiveTalentPoolInput = {
  talentPoolId: Scalars['Int']['input']
}

export type AssociateCustomFieldWithRequisitionInput = {
  customFieldId: Scalars['Int']['input']
  requisitionId: Scalars['Int']['input']
}

export type AssociateCustomFieldWithRequisitionResponse = {
  __typename?: 'AssociateCustomFieldWithRequisitionResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type AutoRejectCandidatesInput = {
  applicationId: Scalars['Int']['input']
  candidateProfileId: Scalars['Int']['input']
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  customMessage: Scalars['String']['input']
  publicJobListingId: Scalars['String']['input']
  scalisUserId: Scalars['Int']['input']
  screeningQuestionsAnswers: Array<ScreeningQuestionAnswerInput>
}

export type AutoRejectCandidatesResponse = {
  __typename?: 'AutoRejectCandidatesResponse'
  jobId: Scalars['String']['output']
}

export type AvailableFilterOutput = {
  __typename?: 'AvailableFilterOutput'
  column: Scalars['String']['output']
  label: Scalars['String']['output']
  type: CoreReportFilterTypeEnum
  values?: Maybe<Array<Scalars['String']['output']>>
}

export type BookmarkedJob = {
  __typename?: 'BookmarkedJob'
  JobListing?: Maybe<JobListing>
  ScalisUser?: Maybe<ScalisUser>
  id: Scalars['ID']['output']
  jobListingId?: Maybe<Scalars['Int']['output']>
  publicListingId?: Maybe<Scalars['String']['output']>
  scalisUserId?: Maybe<Scalars['Int']['output']>
}

export type BookmarkedJobCompany = {
  __typename?: 'BookmarkedJobCompany'
  alias: Scalars['String']['output']
  id: Scalars['ID']['output']
  logo?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export type BookmarkedJobLocations = {
  __typename?: 'BookmarkedJobLocations'
  city?: Maybe<Scalars['String']['output']>
  continent?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  region?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type BookmarkedJobResultsType = {
  __typename?: 'BookmarkedJobResultsType'
  active: Scalars['Boolean']['output']
  company: BookmarkedJobCompany
  id: Scalars['ID']['output']
  jobListingId?: Maybe<Scalars['ID']['output']>
  locations: Array<BookmarkedJobLocations>
  publicListingId?: Maybe<Scalars['String']['output']>
  scalisUserId?: Maybe<Scalars['ID']['output']>
  source: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type BulkAddCandidatesToTalentPoolInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  talentPoolId: Scalars['Int']['input']
}

export type BulkAddInterviewTemplateInterviewersInput = {
  companyUserIds: Array<Scalars['Int']['input']>
  interviewTemplateId: Scalars['Int']['input']
  isOrganizer?: InputMaybe<Scalars['Boolean']['input']>
}

export type BulkAddInterviewerPoolMemberInput = {
  companyUserIds: Array<Scalars['Int']['input']>
  interviewerPoolId: Scalars['Int']['input']
  skillNames?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BulkEnrollCandidatesInSequenceInput = {
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  sequenceId: Scalars['String']['input']
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type BulkMoveCandidatesToTalentPoolInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  currentTalentPoolId: Scalars['Int']['input']
  newTalentPoolId: Scalars['Int']['input']
}

export type BulkRejectCandidatesInput = {
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  customMessage?: InputMaybe<Scalars['String']['input']>
  details?: InputMaybe<Scalars['String']['input']>
  jobRequisitionId: Scalars['Int']['input']
  notifyCandidate?: InputMaybe<Scalars['Boolean']['input']>
  reason?: InputMaybe<RejectionReasonEnum>
  templateStageIds: Array<Scalars['Int']['input']>
}

export type BulkRejectCandidatesResponse = {
  __typename?: 'BulkRejectCandidatesResponse'
  processedApplicationIds: Array<Scalars['Int']['output']>
  remainingCount: Scalars['Int']['output']
}

export type BulkRemoveCandidatesFromTalentPoolInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  companyUserId: Scalars['Int']['input']
  talentPoolId: Scalars['Int']['input']
}

export type BulkSequenceOperationResponse = {
  __typename?: 'BulkSequenceOperationResponse'
  count: Scalars['Int']['output']
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type BulkTalentPoolOperationResponse = {
  __typename?: 'BulkTalentPoolOperationResponse'
  count: Scalars['Int']['output']
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type BulkUnenrollCandidatesFromSequenceInput = {
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  sequenceId: Scalars['String']['input']
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type BulkUpdateCandidatesProspectOwnerInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  prospectOwnerId: Scalars['Int']['input']
  talentPoolId: Scalars['Int']['input']
}

export type BulkUpdateCandidatesProspectStatusInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  talentPoolId: Scalars['Int']['input']
  talentPoolProspectStatusId: Scalars['Int']['input']
}

export type BulkUpdateSequenceCandidateStatusInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  sequenceId: Scalars['String']['input']
  status: SequenceCandidateStatusEnum
}

export type Calendar = {
  __typename?: 'Calendar'
  CalendarEvents?: Maybe<Array<CalendarEvent>>
  calendarSettingsId: Scalars['Int']['output']
  color?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isPrimary: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  nylasCalendarId: Scalars['String']['output']
}

export type CalendarEvent = {
  __typename?: 'CalendarEvent'
  Calendar?: Maybe<Calendar>
  CandidateInterview?: Maybe<CandidateInterview>
  CompanyUser?: Maybe<CompanyUser>
  EventAttachments?: Maybe<Array<EventAttachment>>
  EventJobs?: Maybe<Array<EventJob>>
  calendarId?: Maybe<Scalars['Int']['output']>
  candidates?: Maybe<Scalars['JSON']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  conferencing?: Maybe<Scalars['JSON']['output']>
  description?: Maybe<Scalars['String']['output']>
  employers?: Maybe<Scalars['JSON']['output']>
  endTime?: Maybe<Scalars['DateTime']['output']>
  eventType?: Maybe<EventTypeEnum>
  id: Scalars['ID']['output']
  internalGuests?: Maybe<Scalars['JSON']['output']>
  isScalisEvent?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  masterEventId?: Maybe<Scalars['String']['output']>
  nylasCalendarEventId?: Maybe<Scalars['String']['output']>
  nylasEventStatus?: Maybe<NylasEventStatusesEnum>
  regardingCandidates?: Maybe<Scalars['JSON']['output']>
  regardingJobs?: Maybe<Scalars['JSON']['output']>
  reminders?: Maybe<Scalars['JSON']['output']>
  repeats?: Maybe<RepeatsEnum>
  startTime?: Maybe<Scalars['DateTime']['output']>
  timeZone?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export enum CalendarProviderEnum {
  Google = 'google',
  Microsoft = 'microsoft',
}

export type CalendarSettings = {
  __typename?: 'CalendarSettings'
  Calendars?: Maybe<Array<Calendar>>
  availability?: Maybe<Scalars['JSON']['output']>
  companyUserId: Scalars['Int']['output']
  email: Scalars['String']['output']
  hourDisplay: Scalars['Int']['output']
  id: Scalars['ID']['output']
  nylasGrantId: Scalars['String']['output']
  provider: Scalars['String']['output']
  timeZone?: Maybe<Scalars['String']['output']>
}

export type CampaignErrors = {
  __typename?: 'CampaignErrors'
  company?: Maybe<Scalars['String']['output']>
  orderedProducts?: Maybe<Array<ValidationError>>
  orderedProductsSpecs?: Maybe<Array<ValidationError>>
  postingDetails?: Maybe<NestedValidationErrors>
  recruiterInfo?: Maybe<NestedValidationErrors>
  targetGroup?: Maybe<NestedValidationErrors>
}

export type CampaignFiltersInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  orderReference?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type CampaignOrderItemInput = {
  jobListingIds: Array<Scalars['Int']['input']>
  productId: Scalars['String']['input']
}

export enum CampaignStatuses {
  InProgress = 'IN_PROGRESS',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
}

export type CampaignTotalPrice = {
  __typename?: 'CampaignTotalPrice'
  amount: Scalars['Int']['output']
  currency: Scalars['String']['output']
}

export type CampaignValidationErrors = {
  __typename?: 'CampaignValidationErrors'
  errors: Array<CampaignErrors>
}

export enum CanStartNewJobEnum {
  Immediately = 'IMMEDIATELY',
  NotSure = 'NOT_SURE',
  OneWeek = 'ONE_WEEK',
  TwoWeek = 'TWO_WEEK',
}

export type CancelApprovalWorkflowInstanceInput = {
  reason?: InputMaybe<Scalars['String']['input']>
  workflowVersionId: Scalars['Int']['input']
}

export type CancelCampaign = {
  __typename?: 'CancelCampaign'
  campaignId: Scalars['String']['output']
  campaignStatus: CampaignStatuses
}

export type CancelCampaignInput = {
  orderId: Scalars['Int']['input']
}

export type CancelCampaignOutput = {
  __typename?: 'CancelCampaignOutput'
  campaigns: Array<CancelCampaign>
  orderId: Scalars['Int']['output']
}

export type CancelScheduledReportInput = {
  id: Scalars['Int']['input']
}

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['Int']['input']
}

export type CandidateApplication = {
  __typename?: 'CandidateApplication'
  ActivityLog?: Maybe<Array<ActivityLog>>
  ApplicantNotes?: Maybe<Array<ApplicantNotes>>
  CandidateApplicationNote?: Maybe<Array<CandidateApplicationNote>>
  CandidateApplicationRating?: Maybe<Array<CandidateApplicationRating>>
  CandidateInterview?: Maybe<Array<CandidateInterview>>
  CandidateMessage?: Maybe<CandidateProfile>
  CandidateProfile?: Maybe<CandidateProfile>
  CandidateScorecard?: Maybe<Array<CandidateScorecard>>
  CandidateSource?: Maybe<Array<CandidateSource>>
  Company?: Maybe<Company>
  CustomApplicationStatus?: Maybe<CustomApplicationStatus>
  CustomCandidateApplicationFieldValues?: Maybe<Array<CustomCandidateApplicationFieldValue>>
  CustomCandidateApplicationFields?: Maybe<Array<CustomCandidateApplicationField>>
  JobListing?: Maybe<JobListing>
  LastPublicTemplateStage?: Maybe<TemplateStage>
  SchedulerLinkInvite?: Maybe<Array<SchedulerLinkInvite>>
  ScreeningQuestionAnswer?: Maybe<Array<ScreeningQuestionAnswer>>
  TemplateStage?: Maybe<TemplateStage>
  UploadedDocumentCandidateApplication?: Maybe<Array<UploadedDocumentCandidateApplication>>
  applicationCreationType?: Maybe<Scalars['String']['output']>
  applicationStatus?: Maybe<ApplicationStatusEnum>
  applicationTimestamp?: Maybe<Scalars['DateTime']['output']>
  applicationType?: Maybe<Scalars['String']['output']>
  appliedAt?: Maybe<Scalars['DateTime']['output']>
  averageRating?: Maybe<Scalars['Float']['output']>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customApplicationStatusId?: Maybe<Scalars['Int']['output']>
  deleted?: Maybe<Scalars['DateTime']['output']>
  duplicationStatus?: Maybe<CandidateApplicationDuplicationStatusEnum>
  id: Scalars['ID']['output']
  interviewScheduling?: Maybe<InterviewSchedulingEnum>
  jobListingId?: Maybe<Scalars['Int']['output']>
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>
  lastUpdatedStatusAt?: Maybe<Scalars['DateTime']['output']>
  matchScore?: Maybe<Scalars['Float']['output']>
  templateStageId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  viewedAt?: Maybe<Scalars['DateTime']['output']>
  viewedProfile?: Maybe<Scalars['Boolean']['output']>
}

export type CandidateApplicationCustomCandidateApplicationFieldValuesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateApplicationCustomCandidateApplicationFieldsArgs = {
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export enum CandidateApplicationDuplicationStatusEnum {
  Duplicate = 'DUPLICATE',
  Hidden = 'HIDDEN',
  Primary = 'PRIMARY',
}

export type CandidateApplicationNotCreatedOutput = {
  __typename?: 'CandidateApplicationNotCreatedOutput'
  candidateProfileId: Scalars['Int']['output']
}

export type CandidateApplicationNote = {
  __typename?: 'CandidateApplicationNote'
  candidateApplication?: Maybe<CandidateApplication>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  company?: Maybe<Company>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  privateStatus?: Maybe<Scalars['Boolean']['output']>
  userNote: UserNote
  userNoteId: Scalars['Int']['output']
}

export type CandidateApplicationPipelineView = {
  __typename?: 'CandidateApplicationPipelineView'
  candidateApplications: Array<CandidateApplication>
  count: Scalars['Int']['output']
  milestone: TemplateMilestone
  stage: TemplateStage
}

export type CandidateApplicationRating = {
  __typename?: 'CandidateApplicationRating'
  CandidateProfile?: Maybe<CandidateProfile>
  candidateApplication?: Maybe<CandidateApplication>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  score?: Maybe<Scalars['Float']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateApplicationStatus = {
  __typename?: 'CandidateApplicationStatus'
  Campaign?: Maybe<JobAdCampaign>
  CandidateApplication?: Maybe<CandidateApplication>
  JobListing: JobListing
  ScalisUser: ScalisUser
  campaignId?: Maybe<Scalars['Int']['output']>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  completedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  jobListingId: Scalars['Int']['output']
  scalisUserId: Scalars['Int']['output']
  source?: Maybe<Scalars['String']['output']>
  startedAt: Scalars['DateTime']['output']
}

export type CandidateApplicationUserNoteInput = {
  noteText: Scalars['JSON']['input']
}

export type CandidateCollaborator = {
  __typename?: 'CandidateCollaborator'
  candidateProfile?: Maybe<CandidateProfile>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  requisitionJobDescription?: Maybe<RequisitionJobDescription>
  requisitionJobDescriptionId?: Maybe<Scalars['Int']['output']>
  role?: Maybe<Role>
  roleId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateEmail = {
  __typename?: 'CandidateEmail'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  email: Scalars['String']['output']
  isPrimary: Scalars['Boolean']['output']
  isVerified?: Maybe<Scalars['Boolean']['output']>
  source: CandidateEmailSource
}

export enum CandidateEmailSource {
  CompanyProvidedEmail = 'COMPANY_PROVIDED_EMAIL',
  EmailVerification = 'EMAIL_VERIFICATION',
  EnrichedEmail = 'ENRICHED_EMAIL',
  UploadedCandidate = 'UPLOADED_CANDIDATE',
}

export type CandidateFilter = {
  __typename?: 'CandidateFilter'
  companyId: Scalars['Int']['output']
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  filters: Scalars['JSON']['output']
  id: Scalars['ID']['output']
  isDefaultFilter: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CandidateIncomingEmail = {
  __typename?: 'CandidateIncomingEmail'
  CandidateProfile?: Maybe<CandidateProfile>
  Company: Company
  SequenceActivityLog: Array<SequenceActivityLog>
  attachments?: Maybe<Scalars['JSON']['output']>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  emailId: Scalars['String']['output']
  from?: Maybe<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
  threadId: Scalars['String']['output']
  to?: Maybe<Scalars['JSON']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type CandidateInterview = {
  __typename?: 'CandidateInterview'
  CalendarEvent: Array<CalendarEvent>
  CandidateApplication?: Maybe<CandidateApplication>
  TemplateStage?: Maybe<TemplateStage>
  applicationId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  companyUsers: Array<CandidateInterviewCompanyUser>
  id: Scalars['ID']['output']
  integrationsNylasNotetakerId?: Maybe<Scalars['Int']['output']>
  interviewData?: Maybe<Scalars['JSON']['output']>
  organizer?: Maybe<CompanyUser>
  stageId?: Maybe<Scalars['Int']['output']>
  status?: Maybe<CandidateInterviewStatusEnum>
}

export type CandidateInterviewCompanyUser = {
  __typename?: 'CandidateInterviewCompanyUser'
  CandidateInterview: CandidateInterview
  CompanyUser: CompanyUser
  candidateInterviewId: Scalars['Int']['output']
  companyUserId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isOrganizer: Scalars['Boolean']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateInterviewLoop = {
  __typename?: 'CandidateInterviewLoop'
  AssignedUser?: Maybe<CompanyUser>
  CandidateInterview?: Maybe<CandidateInterview>
  InterviewTemplateLoop?: Maybe<InterviewTemplateLoop>
  ScorecardTemplate?: Maybe<ScorecardTemplate>
  assignedUserId?: Maybe<Scalars['Int']['output']>
  candidateInterviewId?: Maybe<Scalars['Int']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['ID']['output']>
  interviewTemplateLoopId?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  rankOrder?: Maybe<Scalars['Int']['output']>
  scorecardTemplateId?: Maybe<Scalars['Int']['output']>
}

export enum CandidateInterviewStatusEnum {
  InterviewCompleted = 'INTERVIEW_COMPLETED',
  InterviewNotScheduled = 'INTERVIEW_NOT_SCHEDULED',
  InterviewRequested = 'INTERVIEW_REQUESTED',
  InterviewResend = 'INTERVIEW_RESEND',
  InterviewScheduled = 'INTERVIEW_SCHEDULED',
}

export type CandidateLabel = {
  __typename?: 'CandidateLabel'
  candidateProfiles: Array<CandidateLabelCandidateProfile>
  candidateProfilesCount: Scalars['Int']['output']
  colorNumber: Scalars['Int']['output']
  company: Company
  companyId: Scalars['Int']['output']
  companyUser: CompanyUser
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  labelName: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CandidateLabelCandidateProfile = {
  __typename?: 'CandidateLabelCandidateProfile'
  CandidateLabel: CandidateLabel
  CandidateProfile: CandidateProfile
  candidateLabelId: Scalars['Int']['output']
  candidateProfileId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
}

export enum CandidateLabelSortFields {
  CreatedAt = 'createdAt',
  LabelName = 'labelName',
  UpdatedAt = 'updatedAt',
}

export type CandidateMedalistDesignation = {
  __typename?: 'CandidateMedalistDesignation'
  id: Scalars['Int']['output']
  jobListing?: Maybe<JobListing>
  jobListingId?: Maybe<Scalars['Int']['output']>
  medalistDesignation?: Maybe<Scalars['String']['output']>
  profileDetailsId?: Maybe<Scalars['Int']['output']>
}

export type CandidateMedalistDesignationInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  medalistDesignation?: InputMaybe<Scalars['String']['input']>
}

export type CandidateMessage = {
  __typename?: 'CandidateMessage'
  ApplicationRejection?: Maybe<Array<ApplicationRejection>>
  candidateApplication?: Maybe<CandidateApplication>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  templateMessage?: Maybe<TemplateMessage>
  templateMessageId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateOffer = {
  __typename?: 'CandidateOffer'
  CandidateApplication: CandidateApplication
  CandidateOfferVersion?: Maybe<Array<CandidateOfferVersion>>
  candidateApplicationId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateOfferCustomField = {
  __typename?: 'CandidateOfferCustomField'
  CandidateOfferVersion: CandidateOfferVersion
  OfferCustomField: OfferCustomField
  candidateOfferVersionId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  fieldValue?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  offerCustomFieldId: Scalars['Int']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateOfferFile = {
  __typename?: 'CandidateOfferFile'
  CandidateOfferVersion: CandidateOfferVersion
  candidateOfferVersionId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  fileName: Scalars['String']['output']
  filePath: Scalars['String']['output']
  fileType: OfferFileTypeEnum
  id: Scalars['Int']['output']
}

export type CandidateOfferRejection = {
  __typename?: 'CandidateOfferRejection'
  candidateOfferId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  reason?: Maybe<Scalars['String']['output']>
  wantsToProvideReason: Scalars['Boolean']['output']
}

export type CandidateOfferVersion = {
  __typename?: 'CandidateOfferVersion'
  CandidateOffer: CandidateOffer
  CandidateOfferCustomField?: Maybe<Array<CandidateOfferCustomField>>
  CandidateOfferFile?: Maybe<Array<CandidateOfferFile>>
  CandidateOfferVersionSignature?: Maybe<Array<CandidateOfferVersionSignature>>
  CompanyOffice?: Maybe<CompanyOffice>
  additionalCompensation?: Maybe<Scalars['JSON']['output']>
  benefits?: Maybe<Scalars['JSON']['output']>
  candidateName: Scalars['String']['output']
  candidateOfferId: Scalars['Int']['output']
  companyOfficeId?: Maybe<Scalars['Int']['output']>
  compensation: Scalars['Float']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  expirationDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  jobTitle: Scalars['String']['output']
  jobType: JobTypeEnum
  lastUpdatedStatusAt?: Maybe<Scalars['DateTime']['output']>
  manager?: Maybe<Scalars['String']['output']>
  offerStatus: OfferStatusEnum
  payType: PayTypeEnum
  signatureRequestId?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  version: Scalars['Int']['output']
}

export type CandidateOfferVersionSignature = {
  __typename?: 'CandidateOfferVersionSignature'
  CandidateOfferVersion: CandidateOfferVersion
  candidateOfferVersionId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  emailAddress: Scalars['String']['output']
  externalId?: Maybe<Scalars['String']['output']>
  externalStatus?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  order?: Maybe<Scalars['Int']['output']>
  remindedAt?: Maybe<Scalars['DateTime']['output']>
  signedAt?: Maybe<Scalars['DateTime']['output']>
  status: OfferStatusEnum
  viewedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateOfferVersionSignatureSendReminderInput = {
  id: Array<Scalars['Int']['input']>
}

export type CandidateOfferVersionSignaturesSendEmailReminderResult = {
  __typename?: 'CandidateOfferVersionSignaturesSendEmailReminderResult'
  emailAddress: Scalars['String']['output']
  error?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
}

export type CandidateProfile = {
  __typename?: 'CandidateProfile'
  ActivityLog: Array<ActivityLog>
  CandidateApplication: Array<CandidateApplication>
  CandidateApplicationRating: Array<CandidateApplicationRating>
  CandidateCollaborator: Array<CandidateCollaborator>
  CandidateLabels?: Maybe<Array<CandidateLabel>>
  CandidateProfileNote: Array<CandidateProfileNote>
  Company?: Maybe<Company>
  CompanyProvidedEmail: Array<CompanyProvidedEmail>
  CustomCandidateProfileFieldValues?: Maybe<Array<CustomCandidateProfileFieldValue>>
  CustomCandidateProfileFields?: Maybe<Array<CustomCandidateProfileField>>
  ProfileDetails?: Maybe<ProfileDetails>
  ProspectOwner?: Maybe<CompanyUser>
  ProspectStatus?: Maybe<TalentPoolProspectStatus>
  ScalisUser?: Maybe<ScalisUser>
  SequenceCandidateStatus?: Maybe<SequenceCandidateStatusEnum>
  UploadedCandidate?: Maybe<UploadedCandidate>
  UploadedDocumentCandidateProfile: Array<UploadedDocumentCandidateProfile>
  companyId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  doNotContact?: Maybe<Scalars['Boolean']['output']>
  enrollmentDate?: Maybe<Scalars['DateTime']['output']>
  hasBounced: Scalars['Boolean']['output']
  hasClicked: Scalars['Boolean']['output']
  hasOpened: Scalars['Boolean']['output']
  hasReplied: Scalars['Boolean']['output']
  hasSent: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  isEnrolledInSequence: Scalars['Boolean']['output']
  lastContactedDate?: Maybe<Scalars['DateTime']['output']>
  lastStepCompleted?: Maybe<SequenceStep>
  primaryEmail?: Maybe<Scalars['String']['output']>
  profileType: ProfileTypeEnum
  scalisUserId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
}

export type CandidateProfileCustomCandidateProfileFieldValuesArgs = {
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateProfileCustomCandidateProfileFieldsArgs = {
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateProfileProspectOwnerArgs = {
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateProfileProspectStatusArgs = {
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateProfileSequenceCandidateStatusArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileEnrollmentDateArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileHasBouncedArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileHasClickedArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileHasOpenedArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileHasRepliedArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileHasSentArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileIsEnrolledInSequenceArgs = {
  currentSequenceId: Scalars['String']['input']
}

export type CandidateProfileLastContactedDateArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileLastStepCompletedArgs = {
  sequenceId?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileLocation = {
  __typename?: 'CandidateProfileLocation'
  addressLine1?: Maybe<Scalars['String']['output']>
  addressLine2?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  postalCode?: Maybe<Scalars['String']['output']>
  profileDetailsId?: Maybe<Scalars['Int']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type CandidateProfileLocationInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>
  addressLine2?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type CandidateProfileNote = {
  __typename?: 'CandidateProfileNote'
  candidateProfile?: Maybe<CandidateProfile>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  company?: Maybe<Company>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  privateStatus?: Maybe<Scalars['Boolean']['output']>
  userNote: UserNote
  userNoteId: Scalars['Int']['output']
}

export type CandidateProfileUserNoteInput = {
  noteText: Scalars['JSON']['input']
}

/** Candidate recommendation information */
export type CandidateRecommendation = {
  __typename?: 'CandidateRecommendation'
  achievements?: Maybe<CandidateRecommendationAchievements>
  certifications?: Maybe<CandidateRecommendationCertifications>
  contact?: Maybe<CandidateRecommendationContact>
  createdAt?: Maybe<Scalars['String']['output']>
  educations?: Maybe<CandidateRecommendationEducations>
  experiences?: Maybe<CandidateRecommendationExperiences>
  headline?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  industry?: Maybe<Scalars['String']['output']>
  interests?: Maybe<Array<Scalars['String']['output']>>
  isActive?: Maybe<Scalars['Boolean']['output']>
  languages?: Maybe<Array<Language>>
  location?: Maybe<CandidateRecommendationLocation>
  publicListingId?: Maybe<Scalars['String']['output']>
  scores?: Maybe<CandidateRecommendationScores>
  skills?: Maybe<CandidateRecommendationSkills>
  socials?: Maybe<Array<Social>>
  source?: Maybe<CandidateRecommendationSourceEnumType>
  summary?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['String']['output']>
  volunteerWork?: Maybe<CandidateRecommendationVolunteerWorks>
}

/** Achievement information */
export type CandidateRecommendationAchievement = {
  __typename?: 'CandidateRecommendationAchievement'
  endDate?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

/** Candidate recommendation achievement information */
export type CandidateRecommendationAchievements = {
  __typename?: 'CandidateRecommendationAchievements'
  list?: Maybe<Array<CandidateRecommendationAchievement>>
}

/** Certification information */
export type CandidateRecommendationCertification = {
  __typename?: 'CandidateRecommendationCertification'
  endDate?: Maybe<Scalars['String']['output']>
  organization: Organization
  startDate?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

/** Certification information */
export type CandidateRecommendationCertifications = {
  __typename?: 'CandidateRecommendationCertifications'
  list?: Maybe<Array<CandidateRecommendationCertification>>
}

/** Contact information */
export type CandidateRecommendationContact = {
  __typename?: 'CandidateRecommendationContact'
  demographics?: Maybe<Demographics>
  emails?: Maybe<Array<Email>>
  name: Name
  phones?: Maybe<Array<Phone>>
}

/** Education information */
export type CandidateRecommendationEducation = {
  __typename?: 'CandidateRecommendationEducation'
  endDate?: Maybe<Scalars['String']['output']>
  gpa?: Maybe<Gpa>
  isCurrent: Scalars['Boolean']['output']
  level?: Maybe<Scalars['String']['output']>
  majors?: Maybe<Array<Scalars['String']['output']>>
  minors?: Maybe<Array<Scalars['String']['output']>>
  organization: Organization
  startDate?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** Candidate recommendation education information */
export type CandidateRecommendationEducations = {
  __typename?: 'CandidateRecommendationEducations'
  list?: Maybe<Array<CandidateRecommendationEducation>>
  tenure?: Maybe<Tenure>
}

export enum CandidateRecommendationEventTypeEnum {
  AddedToJobListing = 'ADDED_TO_JOB_LISTING',
  AddedToSequence = 'ADDED_TO_SEQUENCE',
  AddedToTalentPool = 'ADDED_TO_TALENT_POOL',
  Discarded = 'DISCARDED',
  Skipped = 'SKIPPED',
  Viewed = 'VIEWED',
}

/** Work experience information */
export type CandidateRecommendationExperience = {
  __typename?: 'CandidateRecommendationExperience'
  employmentType?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['String']['output']>
  isCurrent?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<CandidateRecommendationLocation>
  locationType?: Maybe<Scalars['String']['output']>
  organization?: Maybe<Organization>
  payType?: Maybe<Scalars['String']['output']>
  position?: Maybe<Position>
  startDate?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  tenure?: Maybe<Tenure>
  title?: Maybe<Scalars['String']['output']>
}

/** Candidate recommendation experience tenure information */
export type CandidateRecommendationExperienceTenure = {
  __typename?: 'CandidateRecommendationExperienceTenure'
  avg?: Maybe<Scalars['Float']['output']>
  count?: Maybe<Scalars['Float']['output']>
  current?: Maybe<Scalars['Float']['output']>
  unit: Scalars['String']['output']
  value: Scalars['Float']['output']
}

/** Candidate recommendation experience information */
export type CandidateRecommendationExperiences = {
  __typename?: 'CandidateRecommendationExperiences'
  lastChangedAt?: Maybe<Scalars['String']['output']>
  lastVerifiedAt?: Maybe<Scalars['String']['output']>
  list?: Maybe<Array<CandidateRecommendationExperience>>
  tenure?: Maybe<CandidateRecommendationExperienceTenure>
}

/** Candidate recommendation highlight information */
export type CandidateRecommendationHighlight = {
  __typename?: 'CandidateRecommendationHighlight'
  icon: Scalars['String']['output']
  name: Scalars['String']['output']
  summary: Scalars['String']['output']
}

/** Candidate recommendation highlights input */
export type CandidateRecommendationHighlightsInput = {
  id: Scalars['String']['input']
  overall: Scalars['Float']['input']
  sections: Array<SectionInput>
}

/** Location information */
export type CandidateRecommendationLocation = {
  __typename?: 'CandidateRecommendationLocation'
  address?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  continent?: Maybe<Scalars['String']['output']>
  coordinates?: Maybe<Coordinates>
  country?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  region?: Maybe<Scalars['String']['output']>
}

/** Candidate recommendation scores information */
export type CandidateRecommendationScores = {
  __typename?: 'CandidateRecommendationScores'
  highlights?: Maybe<Array<CandidateRecommendationHighlight>>
  overall?: Maybe<Scalars['Float']['output']>
  sections: Array<Section>
}

/** Skill information */
export type CandidateRecommendationSkill = {
  __typename?: 'CandidateRecommendationSkill'
  name: Scalars['String']['output']
}

/** Candidate recommendation skill information */
export type CandidateRecommendationSkills = {
  __typename?: 'CandidateRecommendationSkills'
  list?: Maybe<Array<CandidateRecommendationSkill>>
}

export enum CandidateRecommendationSourceEnumType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
}

/** Volunteer work information */
export type CandidateRecommendationVolunteerWork = {
  __typename?: 'CandidateRecommendationVolunteerWork'
  endDate?: Maybe<Scalars['String']['output']>
  isCurrent?: Maybe<Scalars['Boolean']['output']>
  organization: Organization
  position: Position
  startDate?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

/** Candidate recommendation volunteer work information */
export type CandidateRecommendationVolunteerWorks = {
  __typename?: 'CandidateRecommendationVolunteerWorks'
  list?: Maybe<Array<CandidateRecommendationVolunteerWork>>
  tenure?: Maybe<Tenure>
}

/** Candidate recommendations highlights information */
export type CandidateRecommendationsHighlights = {
  __typename?: 'CandidateRecommendationsHighlights'
  highlights: Array<CandidateRecommendationHighlight>
  id: Scalars['String']['output']
  scores: CandidateRecommendationScores
  summary: Scalars['String']['output']
}

export type CandidateScorecard = {
  __typename?: 'CandidateScorecard'
  CandidateApplication?: Maybe<CandidateApplication>
  CandidateScorecardAnswers: Array<CandidateScorecardAnswers>
  CompanyUser?: Maybe<CompanyUser>
  ScorecardTemplate?: Maybe<ScorecardTemplate>
  TemplateStage?: Maybe<TemplateStage>
  additionalInformation?: Maybe<Scalars['String']['output']>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  scorecardTemplateId?: Maybe<Scalars['Int']['output']>
  status?: Maybe<ScorecardStatusTypeEnum>
  templateStageId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateScorecardAnswers = {
  __typename?: 'CandidateScorecardAnswers'
  CandidateScorecard?: Maybe<CandidateScorecard>
  ScorecardTemplateQuestion?: Maybe<ScorecardTemplateQuestion>
  answer?: Maybe<Scalars['JSON']['output']>
  answerPreferredStatus?: Maybe<Scalars['Boolean']['output']>
  candidateScorecardId?: Maybe<Scalars['Int']['output']>
  dateAnswer?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  overallRecommendation?: Maybe<OverallRecommendationEnum>
  scoreAnswer?: Maybe<Scalars['Int']['output']>
  scorecardTemplateQuestionId?: Maybe<Scalars['Int']['output']>
}

export type CandidateSource = {
  __typename?: 'CandidateSource'
  candidateSourceName?: Maybe<CandidateSourceName>
  companyUser?: Maybe<CompanyUser>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  creditCompanyUserId?: Maybe<Scalars['Int']['output']>
  creditExternal?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  jobListing?: Maybe<JobListing>
  jobListingId?: Maybe<Scalars['Int']['output']>
  profileDetails?: Maybe<ProfileDetails>
  profileDetailsId?: Maybe<Scalars['Int']['output']>
  sourceNameId?: Maybe<Scalars['Int']['output']>
  sourceStrategy?: Maybe<Scalars['Int']['output']>
}

export enum CandidateSourceCategoryEnum {
  Agency = 'AGENCY',
  CompanyWebsite = 'COMPANY_WEBSITE',
  Custom = 'CUSTOM',
  DirectApplicant = 'DIRECT_APPLICANT',
  Event = 'EVENT',
  Internal = 'INTERNAL',
  Other = 'OTHER',
  Referred = 'REFERRED',
  Scalis = 'SCALIS',
  Sourced = 'SOURCED',
  ThirdParty = 'THIRD_PARTY',
  University = 'UNIVERSITY',
}

export type CandidateSourceInput = {
  creditCompanyUserId?: InputMaybe<Scalars['Int']['input']>
  creditExternal?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used */
  customSource?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  profileDetailsId: Scalars['Int']['input']
  publicJobListingId?: InputMaybe<Scalars['String']['input']>
  /** @deprecated Deprecated in light of new sourceName relation */
  sourceCategory?: InputMaybe<SourceCategoryEnum>
  /** @deprecated Use sourceNameId instead */
  sourceName?: InputMaybe<Scalars['String']['input']>
  sourceNameId?: InputMaybe<Scalars['Int']['input']>
  sourceStrategy?: InputMaybe<Scalars['Int']['input']>
}

export type CandidateSourceName = {
  __typename?: 'CandidateSourceName'
  candidateSource?: Maybe<Array<CandidateSource>>
  companyId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customSourceCategory?: Maybe<CustomSourceCategory>
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  sourceCategory?: Maybe<SourceCategoryEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CandidateSourceNameCreateInput = {
  customSourceCategoryId?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  sourceCategory: CandidateSourceCategoryEnum
}

export type CandidateSourceNameInput = {
  creditCompanyUserId?: InputMaybe<Array<Scalars['Int']['input']>>
  customSourceCategoryId?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  sourceCategory?: InputMaybe<CandidateSourceCategoryEnum>
}

export type CandidateStats = {
  __typename?: 'CandidateStats'
  distance?: Maybe<Scalars['String']['output']>
  experience?: Maybe<Scalars['String']['output']>
  matchPercentage?: Maybe<Scalars['Float']['output']>
  opportunity?: Maybe<CandidateStatsOpportunity>
  screeningQuestions?: Maybe<Scalars['String']['output']>
  skillsMatched?: Maybe<Scalars['Int']['output']>
}

export type CandidateStatsOpportunity = {
  __typename?: 'CandidateStatsOpportunity'
  applicationStatus?: Maybe<ApplicationStatusEnum>
  appliedAt?: Maybe<Scalars['String']['output']>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  currentStageId?: Maybe<Scalars['Int']['output']>
  customApplicationStatusId?: Maybe<Scalars['Int']['output']>
  customApplicationStatusName?: Maybe<Scalars['String']['output']>
  customStatusColorHexCode?: Maybe<Scalars['String']['output']>
  customStatusIconType?: Maybe<Scalars['String']['output']>
  customStatusIconUnicode?: Maybe<Scalars['String']['output']>
  duplicationStatus?: Maybe<CandidateApplicationDuplicationStatusEnum>
  internalRequisitionId?: Maybe<Scalars['Int']['output']>
  jobListingId?: Maybe<Scalars['String']['output']>
  jobListingTitle?: Maybe<Scalars['String']['output']>
  lastUpdatedStatusAt?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  milestoneType?: Maybe<NameEnum>
  requisitionId?: Maybe<Scalars['String']['output']>
  requisitionJobName?: Maybe<Scalars['String']['output']>
  stageName?: Maybe<Scalars['String']['output']>
  stages: Array<CandidateStatsOpportunityStage>
}

export type CandidateStatsOpportunityStage = {
  __typename?: 'CandidateStatsOpportunityStage'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export enum CandidateTouchpointSortFields {
  ActivityTimestamp = 'activityTimestamp',
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt',
}

export enum CandidateTypeEnum {
  Guest = 'GUEST',
  Jobseeker = 'JOBSEEKER',
  UploadedCandidate = 'UPLOADED_CANDIDATE',
}

export type CertificateOrLicense = {
  __typename?: 'CertificateOrLicense'
  description?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  issueYear?: Maybe<Scalars['Int']['output']>
  issuingAuthority?: Maybe<Scalars['String']['output']>
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  organization?: Maybe<CompanyGlobal>
  searchDescription?: Maybe<Scalars['String']['output']>
}

export type CertificateOrLicenseInput = {
  companyGlobalId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  issueYear?: InputMaybe<Scalars['Int']['input']>
  issuingAuthority?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  searchDescription?: InputMaybe<Scalars['String']['input']>
}

export type ChangePasswordInput = {
  code: Scalars['String']['input']
  password: Scalars['String']['input']
  passwordConfirmation: Scalars['String']['input']
}

export type Channel = {
  __typename?: 'Channel'
  id: Scalars['Int']['output']
  logo_rectangle_url?: Maybe<Array<Logo>>
  logo_square_url?: Maybe<Array<Logo>>
  logo_url?: Maybe<Array<LogoUrl>>
  mc_enabled: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  type: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ChatC2J = {
  __typename?: 'ChatC2J'
  chatId?: Maybe<Scalars['String']['output']>
  coUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  scUserId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ChatInfo = {
  __typename?: 'ChatInfo'
  chatId?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  userId?: Maybe<Scalars['Int']['output']>
}

export type ChatInfoJs = {
  __typename?: 'ChatInfoJS'
  chatId?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  userId?: Maybe<Scalars['Int']['output']>
}

export type ChatUserInfo = {
  __typename?: 'ChatUserInfo'
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  userId?: Maybe<Scalars['Int']['output']>
}

export type ChatUserInfoJs = {
  __typename?: 'ChatUserInfoJS'
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  userId?: Maybe<Scalars['Int']['output']>
}

export type CheckApprovalWorkflowRequirementInput = {
  offerId?: InputMaybe<Scalars['Int']['input']>
  openingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type CheckApprovalWorkflowRequirementWithOpeningDataInput = {
  openingData: Array<OpeningDataInput>
}

export enum ClosedReasonEnum {
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  OnHold = 'ON_HOLD',
  OpenedByMistake = 'OPENED_BY_MISTAKE',
}

export type Company = {
  __typename?: 'Company'
  Address: Array<Address>
  CompanyDepartment: Array<CompanyDepartment>
  CompanyInfo?: Maybe<CompanyInfo>
  CompanyOffice: Array<CompanyOffice>
  Orders: Array<Order>
  TemplateMessage?: Maybe<Array<TemplateMessage>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastActivity?: Maybe<Scalars['DateTime']['output']>
  subdomain?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CompanyApprovalSetting = {
  __typename?: 'CompanyApprovalSetting'
  company: Company
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  defaultJobApprovalWorkflow?: Maybe<TemplateApprovalWorkflow>
  defaultJobApprovalWorkflowId?: Maybe<Scalars['Int']['output']>
  defaultOfferApprovalWorkflow?: Maybe<TemplateApprovalWorkflow>
  defaultOfferApprovalWorkflowId?: Maybe<Scalars['Int']['output']>
  defaultOpeningApprovalWorkflow?: Maybe<TemplateApprovalWorkflow>
  defaultOpeningApprovalWorkflowId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  requireJobApproval: Scalars['Boolean']['output']
  requireOfferApproval: Scalars['Boolean']['output']
  requireOpeningApproval: Scalars['Boolean']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CompanyCandidateTouchpoint = {
  __typename?: 'CompanyCandidateTouchpoint'
  activityLogs: Array<ActivityLog>
  activityLogsCount: Scalars['Int']['output']
  companyId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isArchived?: Maybe<Scalars['Boolean']['output']>
  isDefault?: Maybe<Scalars['Boolean']['output']>
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  name: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CompanyCustomFieldToken = {
  __typename?: 'CompanyCustomFieldToken'
  Company: Company
  CustomCandidateApplicationField?: Maybe<CustomCandidateApplicationField>
  CustomCandidateProfileField?: Maybe<CustomCandidateProfileField>
  OfferCustomField?: Maybe<OfferCustomField>
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  customCandidateApplicationFieldId?: Maybe<Scalars['Int']['output']>
  customCandidateProfileFieldId?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  offerCustomFieldId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type CompanyDepartment = {
  __typename?: 'CompanyDepartment'
  ParentCompanyDepartment?: Maybe<CompanyDepartment>
  companyId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  departmentName?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  subordinateTo?: Maybe<Scalars['Int']['output']>
  type?: Maybe<CompanyDepartmentTypeEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CompanyDepartmentInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>
  departmentName?: InputMaybe<Scalars['String']['input']>
  externalId?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  subordinateTo?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<CompanyDepartmentTypeEnum>
}

export enum CompanyDepartmentTypeEnum {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
}

export type CompanyGlobal = {
  __typename?: 'CompanyGlobal'
  externalId?: Maybe<Scalars['String']['output']>
  headquarters?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['ID']['output']>
  logo?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export enum CompanyHeadcountEnum {
  Above_10000 = 'ABOVE_10000',
  Below_10 = 'BELOW_10',
  From_11To_50 = 'FROM_11_TO_50',
  From_51To_200 = 'FROM_51_TO_200',
  From_201To_1000 = 'FROM_201_TO_1000',
  From_1001To_10000 = 'FROM_1001_TO_10000',
}

export type CompanyInfo = {
  __typename?: 'CompanyInfo'
  atsNeeds?: Maybe<Scalars['String']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  companyType?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  currentAtsName?: Maybe<Scalars['String']['output']>
  employeeCount?: Maybe<EmployeeCountEnum>
  hearAboutUs?: Maybe<Scalars['String']['output']>
  hiringNeeds?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  industry?: Maybe<IndustryEnum>
  linkedin?: Maybe<Scalars['String']['output']>
  linkedinId?: Maybe<Scalars['String']['output']>
  logo?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  positionsToFill?: Maybe<PositionsToFillEnum>
  reasonToSwitch?: Maybe<Scalars['String']['output']>
  recruitingOrStaffing?: Maybe<Scalars['Boolean']['output']>
  subIndustry?: Maybe<SubIndustryTypeEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  usingATS?: Maybe<Scalars['Boolean']['output']>
  website?: Maybe<Scalars['String']['output']>
  yearsInOperation?: Maybe<Scalars['Int']['output']>
}

export type CompanyInfoInput = {
  atsNeeds?: InputMaybe<Scalars['String']['input']>
  companyId?: InputMaybe<Scalars['Int']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  companyType?: InputMaybe<Scalars['String']['input']>
  currentAtsName?: InputMaybe<Scalars['String']['input']>
  employeeCount?: InputMaybe<EmployeeCountEnum>
  hearAboutUs?: InputMaybe<Scalars['String']['input']>
  hiringNeeds?: InputMaybe<Scalars['String']['input']>
  industry?: InputMaybe<IndustryEnum>
  linkedin?: InputMaybe<Scalars['String']['input']>
  linkedinId?: InputMaybe<Scalars['String']['input']>
  logo?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  positionsToFill?: InputMaybe<PositionsToFillEnum>
  reasonToSwitch?: InputMaybe<Scalars['String']['input']>
  recruitingOrStaffing?: InputMaybe<Scalars['Boolean']['input']>
  subIndustry?: InputMaybe<SubIndustryTypeEnum>
  usingATS?: InputMaybe<Scalars['Boolean']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  yearsInOperation?: InputMaybe<Scalars['Int']['input']>
}

export type CompanyOffice = {
  __typename?: 'CompanyOffice'
  Address?: Maybe<Address>
  addressId?: Maybe<Scalars['Int']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  officeName?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CompanyOfficeInput = {
  addressId?: InputMaybe<Scalars['Int']['input']>
  companyId?: InputMaybe<Scalars['Int']['input']>
  externalId?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  officeName?: InputMaybe<Scalars['String']['input']>
}

export type CompanyProvidedEmail = {
  __typename?: 'CompanyProvidedEmail'
  CandidateProfile: CandidateProfile
  candidateProfileId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type CompanySavedView = {
  __typename?: 'CompanySavedView'
  candidateFilter?: Maybe<CandidateFilter>
  candidateFilterId?: Maybe<Scalars['Int']['output']>
  columnOrder: Scalars['JSON']['output']
  columnSizing: Scalars['JSON']['output']
  columnVisibility: Scalars['JSON']['output']
  company: Company
  companyId: Scalars['Int']['output']
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isVisibleTo: CompanySavedViewVisibilityEnum
  name: Scalars['String']['output']
  requisitionTalentPoolCompanySavedViews: Array<RequisitionTalentPoolCompanySavedView>
  sorting: Scalars['JSON']['output']
  updatedAt: Scalars['DateTime']['output']
  viewLayout: CompanySavedViewLayoutEnum
  viewLocation: CompanySavedViewLocationEnum
  viewType: CompanySavedViewTypeEnum
}

export enum CompanySavedViewLayoutEnum {
  Kanban = 'KANBAN',
  List = 'LIST',
}

export enum CompanySavedViewLocationEnum {
  AllLocations = 'ALL_LOCATIONS',
  Requisition = 'REQUISITION',
  TalentPool = 'TALENT_POOL',
}

export enum CompanySavedViewTypeEnum {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
}

export enum CompanySavedViewVisibilityEnum {
  Everyone = 'EVERYONE',
  Private = 'PRIVATE',
  Team = 'TEAM',
}

export type CompanySocial = {
  __typename?: 'CompanySocial'
  facebook?: Maybe<Scalars['String']['output']>
  linkedin?: Maybe<Scalars['String']['output']>
  twitter?: Maybe<Scalars['String']['output']>
}

export type CompanyType = {
  __typename?: 'CompanyType'
  alias?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  location?: Maybe<LocationType>
  logo?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type CompanyUser = {
  __typename?: 'CompanyUser'
  CalendarSettings?: Maybe<CalendarSettings>
  CandidateMessage?: Maybe<Array<CandidateMessage>>
  ConnectedEmailSettings?: Maybe<Array<ConnectedEmailSettings>>
  TemplateMessage?: Maybe<Array<TemplateMessage>>
  UserInvitation?: Maybe<UserInvitation>
  UserRoles?: Maybe<Array<UserRoles>>
  companyId: Scalars['Int']['output']
  companyUserStatus?: Maybe<CompanyUserStatusEnum>
  id: Scalars['ID']['output']
  profileImage?: Maybe<Scalars['String']['output']>
  userInvitationId?: Maybe<Scalars['Int']['output']>
}

export type CompanyUserGroup = {
  __typename?: 'CompanyUserGroup'
  Departments: Array<CompanyUserGroupCompanyDepartment>
  Members: Array<CompanyUserGroupCompanyUser>
  Offices: Array<CompanyUserGroupCompanyOffice>
  company: Company
  companyId: Scalars['Int']['output']
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  createdBy: CompanyUser
  deleted: Scalars['Boolean']['output']
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CompanyUserGroupCompanyDepartment = {
  __typename?: 'CompanyUserGroupCompanyDepartment'
  CompanyDepartment: CompanyDepartment
  CompanyUserGroup: CompanyUserGroup
  companyUserGroupId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  departmentId: Scalars['Int']['output']
  id: Scalars['ID']['output']
}

export type CompanyUserGroupCompanyOffice = {
  __typename?: 'CompanyUserGroupCompanyOffice'
  CompanyOffice: CompanyOffice
  CompanyUserGroup: CompanyUserGroup
  companyUserGroupId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  officeId: Scalars['Int']['output']
}

export type CompanyUserGroupCompanyUser = {
  __typename?: 'CompanyUserGroupCompanyUser'
  CompanyUser: CompanyUser
  CompanyUserGroup: CompanyUserGroup
  companyUserGroupId: Scalars['Int']['output']
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
}

export type CompanyUserPermissions = {
  __typename?: 'CompanyUserPermissions'
  jobLevelPermissions: Array<JobLevelPermission>
  orgLevelRole: RoleEnum
}

export enum CompanyUserStatusEnum {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
}

export type CompanyUserView = {
  __typename?: 'CompanyUserView'
  companyUser: CompanyUser
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  rankOrder: Scalars['Int']['output']
  requisitionTalentPoolCompanySavedView: RequisitionTalentPoolCompanySavedView
  requisitionTalentPoolCompanySavedViewId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type CompanyUserViewResponse = {
  __typename?: 'CompanyUserViewResponse'
  companyId: Scalars['Int']['output']
  companySavedViewId: Scalars['Int']['output']
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  isPinned: Scalars['Boolean']['output']
  isUserOwnedLink: Scalars['Boolean']['output']
  rankOrder?: Maybe<Scalars['Int']['output']>
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  savedView: CompanySavedView
  talentPool?: Maybe<TalentPool>
  talentPoolId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type CompleteInterviewInput = {
  interviewId: Scalars['Int']['input']
}

export enum ConditionTypeEnum {
  Department = 'DEPARTMENT',
  EmploymentType = 'EMPLOYMENT_TYPE',
  Office = 'OFFICE',
  PayType = 'PAY_TYPE',
}

export type ConnectCalendarInput = {
  provider: CalendarProviderEnum
}

/** The provider auth URL */
export type ConnectCalendarOutput = {
  __typename?: 'ConnectCalendarOutput'
  authUrl: Scalars['String']['output']
}

export type ConnectedEmail = {
  __typename?: 'ConnectedEmail'
  CompanyUser?: Maybe<CompanyUser>
  ConnectedEmailTrack?: Maybe<ConnectedEmailTrack>
  attachments?: Maybe<Array<EmailAttachment>>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  companyUserId: Scalars['Int']['output']
  connectedEmailSettingsId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  emailId?: Maybe<Scalars['String']['output']>
  from?: Maybe<Array<EmailContact>>
  id: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
  to?: Maybe<Array<EmailContact>>
  trackLinks?: Maybe<Scalars['Boolean']['output']>
  trackOpen?: Maybe<Scalars['Boolean']['output']>
  trackReply?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum ConnectedEmailProviderEnum {
  Google = 'google',
  Microsoft = 'microsoft',
}

export type ConnectedEmailSettings = {
  __typename?: 'ConnectedEmailSettings'
  allowSendOnBehalf?: Maybe<Scalars['Boolean']['output']>
  companyUserId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  dailyLimit?: Maybe<Scalars['Int']['output']>
  email: Scalars['String']['output']
  emailSignature?: Maybe<Scalars['String']['output']>
  emailSignatureEnabled?: Maybe<Scalars['Boolean']['output']>
  hourlyLimit?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  minutesBetweenEmails?: Maybe<Scalars['Int']['output']>
  nylasGrantId: Scalars['String']['output']
  optOutEnabled?: Maybe<Scalars['Boolean']['output']>
  optOutMessage?: Maybe<Scalars['String']['output']>
  provider: ConnectedEmailProviderEnum
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ConnectedEmailTrack = {
  __typename?: 'ConnectedEmailTrack'
  ConnectedEmail?: Maybe<ConnectedEmail>
  clicked?: Maybe<Array<TrackEmailClicked>>
  connectedEmailId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  opened?: Maybe<Array<TrackEmailOpened>>
  replied?: Maybe<Array<TrackEmailReplied>>
}

export type ContactInfo = {
  __typename?: 'ContactInfo'
  id: Scalars['Int']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
  scalisUserId?: Maybe<Scalars['Int']['output']>
}

export type ContactInfoInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
}

/** Coordinates information */
export type Coordinates = {
  __typename?: 'Coordinates'
  lat?: Maybe<Scalars['Float']['output']>
  lon?: Maybe<Scalars['Float']['output']>
}

export type CoreReport = {
  __typename?: 'CoreReport'
  Company: Company
  FavoriteCoreReport: Array<FavoriteCoreReport>
  ScheduledReport: Array<ScheduledReport>
  SharedCoreReport: Array<SharedCoreReport>
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  isFavorite: Scalars['Boolean']['output']
  reportName: CoreReportNameEnum
  updatedAt: Scalars['DateTime']['output']
}

export type CoreReportCsvOutput = {
  __typename?: 'CoreReportCsvOutput'
  base64: Scalars['String']['output']
}

export type CoreReportDataOutput = {
  __typename?: 'CoreReportDataOutput'
  availableFilters?: Maybe<Array<AvailableFilterOutput>>
  coreReportId: Scalars['Int']['output']
  data: Scalars['JSON']['output']
  schema: Scalars['JSON']['output']
  total: Scalars['Int']['output']
}

export type CoreReportFilter = {
  __typename?: 'CoreReportFilter'
  CompanyUser: CompanyUser
  CoreReport: CoreReport
  companyUserId: Scalars['Int']['output']
  coreReportId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  filters: Scalars['JSON']['output']
  id: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum CoreReportFilterTypeEnum {
  Date = 'DATE',
  Text = 'TEXT',
}

export enum CoreReportNameEnum {
  CandidateSummary = 'CANDIDATE_SUMMARY',
  EeocReport = 'EEOC_REPORT',
  JobOpeningsReport = 'JOB_OPENINGS_REPORT',
  JobStatusReport = 'JOB_STATUS_REPORT',
  MilestoneMetrics = 'MILESTONE_METRICS',
  OfferDetailsReport = 'OFFER_DETAILS_REPORT',
  PipelineMetrics = 'PIPELINE_METRICS',
  SourceQualityReport = 'SOURCE_QUALITY_REPORT',
}

export type CountCampaignView = {
  __typename?: 'CountCampaignView'
  message: Scalars['String']['output']
  viewCount: Scalars['Int']['output']
}

export type CountCampaignViewInput = {
  campaign: Scalars['String']['input']
  source: Scalars['String']['input']
}

export type CreateAiSourcingEventInput = {
  aiResponse?: InputMaybe<AiMessageInput>
  candidateId: Scalars['String']['input']
  durationSeconds?: InputMaybe<Scalars['Int']['input']>
  eventType: CandidateRecommendationEventTypeEnum
  jobListingId?: InputMaybe<Scalars['String']['input']>
  rate?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  scores?: InputMaybe<ScoreInput>
}

export type CreateAndAssignCandidateLabelInput = {
  candidateProfileId: Scalars['Int']['input']
  colorNumber: Scalars['Int']['input']
  labelName: Scalars['String']['input']
}

export type CreateApplicantNotesInput = {
  candidateApplicationId: Scalars['Int']['input']
  text: Scalars['String']['input']
}

export type CreateApprovalWorkflowInstanceInput = {
  offerId?: InputMaybe<Scalars['Int']['input']>
  openingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateApprovalWorkflowSettingsInput = {
  defaultJobApprovalWorkflowId?: InputMaybe<Scalars['Int']['input']>
  defaultOfferApprovalWorkflowId?: InputMaybe<Scalars['Int']['input']>
  defaultOpeningApprovalWorkflowId?: InputMaybe<Scalars['Int']['input']>
  requireJobApproval?: Scalars['Boolean']['input']
  requireOfferApproval?: Scalars['Boolean']['input']
  requireOpeningApproval?: Scalars['Boolean']['input']
}

export type CreateBookmarkedJobInput = {
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  publicListingId?: InputMaybe<Scalars['String']['input']>
}

export type CreateCalendarEventCandidateInput = {
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  type: CandidateTypeEnum
}

export type CreateCalendarEventInput = {
  /** Calendar id from Scalis */
  calendarId: Scalars['Int']['input']
  candidates?: InputMaybe<Array<CreateCalendarEventCandidateInput>>
  /** Whether or not a meeting should be created. Defaults to false. */
  createConference?: InputMaybe<Scalars['Boolean']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** Workspace/Company employees that will be participating the event. Previously known as internalHrAssociates */
  internalEmployees?: InputMaybe<Array<CreateCalendarEventInternalEmployeesInput>>
  isScalisEvent: Scalars['Boolean']['input']
  location?: InputMaybe<Scalars['String']['input']>
  regardingCandidates?: InputMaybe<Array<CreateCalendarEventRegardingCandidatesInput>>
  regardingJobs?: InputMaybe<Array<Scalars['Int']['input']>>
  reminders?: InputMaybe<CreateCalendarEventRemindersInput>
  repeats?: InputMaybe<RepeatsEnum>
  title: Scalars['String']['input']
  type: EventTypeEnum
  when: CreateCalendarEventWhenInput
}

export type CreateCalendarEventInternalEmployeesInput = {
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type CreateCalendarEventRegardingCandidatesInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  type: CandidateTypeEnum
}

export type CreateCalendarEventRemindersInput = {
  overrides?: InputMaybe<Array<CreateCalendarEventRemindersOverridesInput>>
  useDefault: Scalars['Boolean']['input']
}

export type CreateCalendarEventRemindersOverridesInput = {
  reminderMethod: ReminderMethodEnum
  reminderMinutes: Scalars['Int']['input']
}

export type CreateCalendarEventWhenInput = {
  endTime: Scalars['String']['input']
  startTime: Scalars['String']['input']
  timezone: Scalars['String']['input']
}

export type CreateCandidateApplicationFromEmployerInput = {
  candidateProfileId: Scalars['Int']['input']
  invite: Scalars['Boolean']['input']
  jobListingId: Scalars['Int']['input']
  message?: InputMaybe<Scalars['String']['input']>
}

export type CreateCandidateApplicationFromJobSeekerInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>
  publicJobListingId: Scalars['String']['input']
  screeningQuestionsAnswers?: InputMaybe<Array<ScreeningQuestionsAnswersInput>>
  source?: InputMaybe<Scalars['String']['input']>
  sourceNameId?: InputMaybe<Scalars['Int']['input']>
  trackingId?: InputMaybe<Scalars['String']['input']>
}

export type CreateCandidateFilterInput = {
  filters: Scalars['JSON']['input']
  name: Scalars['String']['input']
}

export type CreateCandidateLabelInput = {
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  colorNumber: Scalars['Int']['input']
  labelName: Scalars['String']['input']
}

export type CreateCandidateOfferFileInput = {
  candidateApplicationId: Scalars['Int']['input']
  candidateOfferVersionId: Scalars['Int']['input']
  documentName: Scalars['String']['input']
  htmlTemplate: Scalars['String']['input']
  offerDocumentTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateCandidateOfferRejectionInput = {
  candidateOfferId: Scalars['Int']['input']
  reason?: InputMaybe<Scalars['String']['input']>
  wantsToProvideReason: Scalars['Boolean']['input']
}

export type CreateCandidateTouchpointActivityLogInput = {
  activity?: InputMaybe<Scalars['JSON']['input']>
  activityTimestamp: Scalars['DateTime']['input']
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId: Scalars['Int']['input']
  companyCandidateTouchpointId: Scalars['Int']['input']
  companyUserId: Scalars['Int']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

export type CreateChatC2JInput = {
  chatId?: InputMaybe<Scalars['String']['input']>
  coUser: Scalars['Int']['input']
  scUser: Scalars['Int']['input']
}

export type CreateChatV2Input = {
  chatId?: InputMaybe<Scalars['String']['input']>
  coUserId: Scalars['Int']['input']
  scUserId: Scalars['Int']['input']
}

export type CreateCompanyCandidateTouchpointInput = {
  name: Scalars['String']['input']
}

export type CreateCompanyInput = {
  externalId?: InputMaybe<Scalars['String']['input']>
  subdomain: Scalars['String']['input']
}

export type CreateCompanyProvidedEmailInput = {
  candidateProfileId: Scalars['Int']['input']
  email: Scalars['String']['input']
}

export type CreateCompanyUserFromInvitationInput = {
  companyId: Scalars['Int']['input']
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  verificationCode: Scalars['String']['input']
}

export type CreateCompanyUserGroupInput = {
  companyId: Scalars['Int']['input']
  companyUserId: Scalars['Int']['input']
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  externalId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  officeIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type CreateCustomApplicationStatusInput = {
  applicationStatusName: Scalars['String']['input']
  colorHexCode: Scalars['String']['input']
  iconType?: InputMaybe<IconTypeEnum>
  iconUnicode?: InputMaybe<Scalars['String']['input']>
}

export type CreateCustomCandidateApplicationFieldInput = {
  name: Scalars['String']['input']
  provider: CustomFieldProviderEnum
  requireWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  requisitionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  schema: Scalars['JSON']['input']
  showWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  tooltip?: InputMaybe<Scalars['Boolean']['input']>
  tooltipText?: InputMaybe<Scalars['String']['input']>
  type: CustomCandidateFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type CreateCustomCandidateApplicationFieldValueInput = {
  candidateApplicationId: Scalars['Int']['input']
  customCandidateApplicationFieldId: Scalars['Int']['input']
  value: Scalars['String']['input']
}

export type CreateCustomCandidateProfileFieldInput = {
  name: Scalars['String']['input']
  provider: CustomFieldProviderEnum
  requireWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  schema: Scalars['JSON']['input']
  showWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  tooltip?: InputMaybe<Scalars['Boolean']['input']>
  tooltipText?: InputMaybe<Scalars['String']['input']>
  type: CustomCandidateFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type CreateCustomCandidateProfileFieldValueInput = {
  candidateProfileId: Scalars['Int']['input']
  customCandidateProfileFieldId: Scalars['Int']['input']
  value: Scalars['String']['input']
}

export type CreateCustomJobRequisitionFieldInput = {
  isRequired?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  provider: CustomFieldProviderEnum
  schema: Scalars['JSON']['input']
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  tooltip?: InputMaybe<Scalars['Boolean']['input']>
  tooltipText?: InputMaybe<Scalars['String']['input']>
  type: CustomJobRequisitionFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type CreateCustomJobRequisitionFieldValueInput = {
  customJobRequisitionFieldId: Scalars['Int']['input']
  requisitionId: Scalars['Int']['input']
  value: Scalars['String']['input']
}

export type CreateCustomSourceCategoryInput = {
  externalId?: InputMaybe<Scalars['String']['input']>
  sourceCategoryName: Scalars['String']['input']
}

export type CreateCustomStatusAndEditApplicationStatusInput = {
  applicationStatusName: Scalars['String']['input']
  candidateApplicationIds: Array<Scalars['Int']['input']>
  colorHexCode: Scalars['String']['input']
  iconType?: IconTypeEnum
  iconUnicode?: InputMaybe<Scalars['String']['input']>
}

export type CreateDocumentTemplateInput = {
  conditions?: InputMaybe<DocumentTemplateConditions>
  documentTemplateName: Scalars['String']['input']
  documentTemplateText: Scalars['String']['input']
  documentType: OfferDocumentTemplateTypeEnum
}

export type CreateFavoriteSequenceInput = {
  sequenceId: Scalars['String']['input']
}

export type CreateFavoriteTalentPoolInput = {
  talentPoolId: Scalars['Int']['input']
}

export type CreateInterviewEventWhenInput = {
  endTime: Scalars['String']['input']
  startTime: Scalars['String']['input']
  timezone: Scalars['String']['input']
}

export type CreateInterviewInput = {
  applicationId: Scalars['Int']['input']
  calendarId: Scalars['Int']['input']
  createConference?: InputMaybe<Scalars['Boolean']['input']>
  details?: InputMaybe<Scalars['String']['input']>
  includeNotetaker?: InputMaybe<Scalars['Boolean']['input']>
  interviewers: Array<Scalars['Int']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
  stageId: Scalars['Int']['input']
  when: CreateInterviewEventWhenInput
}

export type CreateInterviewTemplateInput = {
  debriefInterview?: InputMaybe<Scalars['Boolean']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  interviewType?: InputMaybe<InterviewTypeEnum>
  interviewerPoolId?: InputMaybe<Scalars['Int']['input']>
  interviewers?: InputMaybe<Array<Scalars['Int']['input']>>
  loopInterviews?: InputMaybe<Array<CreateInterviewTemplateLoopInput>>
  name: Scalars['String']['input']
  schedulingLogic: SchedulingLogicEnum
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateInterviewTemplateLoopInput = {
  assignedUserId?: InputMaybe<Scalars['Int']['input']>
  duration: Scalars['Int']['input']
  interviewerPoolId?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  rankOrder: Scalars['Int']['input']
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateInterviewTemplateLoopStandaloneInput = {
  assignedUserId?: InputMaybe<Scalars['Int']['input']>
  duration: Scalars['Int']['input']
  interviewTemplateId: Scalars['Int']['input']
  interviewerPoolId?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  rankOrder: Scalars['Int']['input']
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateInterviewerPoolInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  enableLoadBalancing?: InputMaybe<Scalars['Boolean']['input']>
  jobIds?: InputMaybe<Array<Scalars['Int']['input']>>
  maxDailyInterviews?: InputMaybe<Scalars['Int']['input']>
  maxWeeklyInterviews?: InputMaybe<Scalars['Int']['input']>
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>
  minDailyInterviews?: InputMaybe<Scalars['Int']['input']>
  minWeeklyInterviews?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  officeIds?: InputMaybe<Array<Scalars['Int']['input']>>
  skillNames?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CreateJobSearchPreferenceInput = {
  benefits?: InputMaybe<Scalars['JSON']['input']>
  companyStage?: InputMaybe<Scalars['JSON']['input']>
  datePosted?: InputMaybe<DatePostedEnum>
  desiredCompanySize?: InputMaybe<Scalars['JSON']['input']>
  excludeJobTitles?: InputMaybe<Scalars['JSON']['input']>
  includeJobTitles?: InputMaybe<Scalars['JSON']['input']>
  industryPreference?: InputMaybe<Scalars['JSON']['input']>
  jobType?: InputMaybe<JobTypeEnum>
  maxRequiredExperience?: InputMaybe<Scalars['String']['input']>
  minimumPayPreference?: InputMaybe<Scalars['String']['input']>
  minimumRequiredExperience?: InputMaybe<Scalars['String']['input']>
  relocationLocationPreference?: InputMaybe<Scalars['JSON']['input']>
  relocationTypePreference?: InputMaybe<RelocationTypePreferenceEnum>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  workplaceLocationPreference?: InputMaybe<Scalars['JSON']['input']>
  workplaceTypePreference?: InputMaybe<Scalars['JSON']['input']>
}

export type CreateJobSeekerAccountInput = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type CreateNotificationSettingInput = {
  companyUserId: Scalars['Int']['input']
  email?: InputMaybe<Scalars['Boolean']['input']>
  eventType: NotificationEventTypeEnum
  inApp?: InputMaybe<Scalars['Boolean']['input']>
  slack?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreateSavedViewInput = {
  candidateFilter: CreateCandidateFilterInput
  columnOrder?: InputMaybe<Scalars['JSON']['input']>
  columnSizing?: InputMaybe<Scalars['JSON']['input']>
  columnVisibility?: InputMaybe<Scalars['JSON']['input']>
  isPinned?: InputMaybe<Scalars['Boolean']['input']>
  isVisibleTo?: InputMaybe<CompanySavedViewVisibilityEnum>
  name: Scalars['String']['input']
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  sorting?: InputMaybe<Scalars['JSON']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
  viewLayout?: InputMaybe<CompanySavedViewLayoutEnum>
  viewLocation?: InputMaybe<CompanySavedViewLocationEnum>
}

export type CreateSavedViewResponse = {
  __typename?: 'CreateSavedViewResponse'
  companyUserView: CompanyUserView
  requisitionTalentPoolSavedView: RequisitionTalentPoolCompanySavedView
  savedView: CompanySavedView
}

export type CreateScalisUserUploadedDocumentInput = {
  documentName: Scalars['String']['input']
  documentPath: Scalars['String']['input']
  documentType?: InputMaybe<DocumentTypeEnum>
}

export type CreateScalisUserUploadedDocumentOutput = {
  __typename?: 'CreateScalisUserUploadedDocumentOutput'
  documentName: Scalars['String']['output']
  documentPath: Scalars['String']['output']
  documentType: DocumentTypeEnum
  id: Scalars['Int']['output']
}

export type CreateScheduledReportInput = {
  coreReportId: Scalars['Int']['input']
  customDaysOfWeek?: InputMaybe<Array<RepeatDaysOfWeekEnum>>
  customTime?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  recipients: Array<Scalars['String']['input']>
  repeat?: InputMaybe<RepeatTypeEnum>
  reportSchedulerType: ReportSchedulerTypeEnum
  sendImmediately?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type CreateSchedulerLinkInviteCandidateInput = {
  id: Scalars['Int']['input']
  type: CandidateTypeEnum
}

export type CreateSchedulerLinkInviteInput = {
  applicationId: Scalars['Int']['input']
  calendarId: Scalars['Int']['input']
  candidates?: InputMaybe<Array<CreateSchedulerLinkInviteCandidateInput>>
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  durationMinutes: Scalars['Int']['input']
  interviewers: Array<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  stageId?: InputMaybe<Scalars['Int']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateSchedulerLinkSessionInput = {
  configuration_id: Scalars['String']['input']
  time_to_live: Scalars['Int']['input']
}

export type CreateSchedulerLinkSettingsInput = {
  maxInterviewsPerDay: Scalars['Int']['input']
  minimumHour: Scalars['Int']['input']
  rollingDays: Scalars['Int']['input']
}

export type CreateSequenceActivityLogInput = {
  candidateProfileId: Scalars['Int']['input']
  connectedEmailId: Scalars['Int']['input']
  eventObject: Scalars['JSON']['input']
  sequenceId: Scalars['String']['input']
}

export type CreateSequenceInput = {
  associatedRequisitionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  associatedTalentPoolIds?: InputMaybe<Array<Scalars['Int']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  ownerCompanyUserId?: InputMaybe<Scalars['Int']['input']>
  /** Optional existing sequence settings ID. If not provided, sequenceSettings must be provided instead. */
  sequenceSettingId?: InputMaybe<Scalars['Int']['input']>
  /** Optional settings to create with this sequence. If not provided, sequenceSettingId must be provided instead. */
  sequenceSettings?: InputMaybe<CreateSequenceSettingInput>
  visibility: SequenceVisibilityEnum
}

export type CreateSequenceScheduleSettingInput = {
  daysOfWeek?: InputMaybe<Scalars['JSON']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
  timeZone?: InputMaybe<Scalars['String']['input']>
  useContactLocalTime?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreateSequenceSettingInput = {
  bcc?: InputMaybe<Scalars['JSON']['input']>
  cc?: InputMaybe<Scalars['JSON']['input']>
  connectedEmailSettingsId: Scalars['Int']['input']
  dailySendLimit?: InputMaybe<Scalars['Int']['input']>
  includeUnsubscribeLink: Scalars['Boolean']['input']
  pauseOnReply?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional existing sequence schedule setting ID. If not provided, sequenceScheduleSettings must be provided instead. */
  sequenceScheduleSettingId?: InputMaybe<Scalars['Int']['input']>
  /** Optional settings to create with this sequence setting. If not provided, sequenceScheduleSettingId must be provided instead. */
  sequenceScheduleSettings?: InputMaybe<CreateSequenceScheduleSettingInput>
  unenrollOnConversion?: InputMaybe<Scalars['Boolean']['input']>
  unsubscribeLinkText?: InputMaybe<Scalars['String']['input']>
}

export type CreateSequenceStepInput = {
  afterPreviousStep?: InputMaybe<Scalars['Int']['input']>
  customSendTime?: InputMaybe<Scalars['String']['input']>
  emailBody?: InputMaybe<Scalars['String']['input']>
  emailLimitPerDay?: InputMaybe<Scalars['Int']['input']>
  replyPreviousThread: Scalars['Boolean']['input']
  schedulerType: SequenceStepSchedulerTypeEnum
  sendTimeType: SequenceStepSendTimeTypeEnum
  spreadStrategy?: InputMaybe<SequenceStepSpreadStrategyEnum>
  stepNumber: Scalars['Int']['input']
  subject?: InputMaybe<Scalars['String']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateSequenceStepsInput = {
  sequenceId: Scalars['String']['input']
  steps: Array<CreateSequenceStepInput>
}

export type CreateSkillInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type CreateSourceTrackingEventInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  eventType: SourceTrackingLinkEventTypeEnum
  sourceTrackingLinkId: Scalars['String']['input']
}

export type CreateSourceTrackingLinkInput = {
  candidateSourceNameId?: InputMaybe<Scalars['Int']['input']>
  genericListingLink?: InputMaybe<Scalars['Boolean']['input']>
  jobListingId: Scalars['Int']['input']
  name: Scalars['String']['input']
  whoGetsCredit?: InputMaybe<Scalars['Int']['input']>
}

export type CreateTalentPoolInput = {
  associatedRequisitionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  contributorCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  isVisibleTo: TalentPoolVisibilityEnum
  name: Scalars['String']['input']
  ownerCompanyUserId?: InputMaybe<Scalars['Int']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CreateTalentPoolProspectStatusInput = {
  colorNumber: Scalars['Int']['input']
  status: Scalars['String']['input']
}

export type CreateTemplateApprovalWorkflowInput = {
  approvalConditions: Scalars['JSON']['input']
  approvalWorkflowType: ApprovalWorkflowTypeEnum
  description?: InputMaybe<Scalars['JSON']['input']>
  name: Scalars['String']['input']
  steps: Array<TemplateApprovalWorkflowStepInput>
}

export type CreateTemplateScreeningQuestionInput = {
  ansOptions?: InputMaybe<Scalars['String']['input']>
  isRejectionQuestion?: InputMaybe<Scalars['Boolean']['input']>
  maxVal?: InputMaybe<Scalars['Int']['input']>
  minVal?: InputMaybe<Scalars['Int']['input']>
  multipleSelectPreferredAnswers?: InputMaybe<Array<Scalars['String']['input']>>
  preferredAnswer?: InputMaybe<Scalars['String']['input']>
  preferredAnswerType?: InputMaybe<PreferredAnswerTypeEnum>
  questionDesc?: InputMaybe<Scalars['String']['input']>
  questionTitle: Scalars['String']['input']
  questionType: QuestionTypeEnum
  rejectMessage?: InputMaybe<Scalars['String']['input']>
  selectionDisplay?: InputMaybe<SelectionDisplayEnum>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
  valStatus?: InputMaybe<Scalars['String']['input']>
}

export type CreateTouchpointActivityLogInput = {
  activity: Scalars['JSON']['input']
  activityTimestamp: Scalars['DateTime']['input']
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId: Scalars['Int']['input']
  companyCandidateTouchpointId: Scalars['Int']['input']
  companyUserId: Scalars['Int']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

export type CreateUploadedCandidateInput = {
  applicationStatus?: InputMaybe<ApplicationStatusEnum>
  creditCompanyUserId?: InputMaybe<Scalars['Int']['input']>
  customApplicationStatusId?: InputMaybe<Scalars['String']['input']>
  customFields?: InputMaybe<UploadCandidateCustomFieldsInput>
  documents?: InputMaybe<Array<Scalars['String']['input']>>
  emailAddress?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  lastName: Scalars['String']['input']
  linkedinProfile?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  profileUrl?: InputMaybe<Scalars['String']['input']>
  sourceNameId: Scalars['Int']['input']
  sourceStrategy?: InputMaybe<Scalars['Int']['input']>
  stageId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateUploadedDocumentCandidateApplicationInput = {
  UploadedDocument: CreateUploadedDocumentInput
  candidateApplicationId: Scalars['Int']['input']
  companyUserId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateUploadedDocumentCandidateProfileInput = {
  UploadedDocument: CreateUploadedDocumentInput
  candidateProfileId: Scalars['Int']['input']
  companyUserId?: InputMaybe<Scalars['Int']['input']>
}

export type CreateUploadedDocumentInput = {
  documentName?: InputMaybe<Scalars['String']['input']>
  documentPath: Scalars['String']['input']
}

export type CreateUsersInCompanyUserGroupInput = {
  companyId: Scalars['Int']['input']
  companyUserGroupId: Scalars['Int']['input']
  companyUserIds: Array<Scalars['Int']['input']>
}

export type CreatedByUser = {
  __typename?: 'CreatedByUser'
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
  profileImage?: Maybe<Scalars['String']['output']>
}

export enum CurrencyEnum {
  Aud = 'AUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD',
}

export enum CurrentStageEnum {
  BasicInformation = 'BASIC_INFORMATION',
  EmailVerification = 'EMAIL_VERIFICATION',
  Profile = 'PROFILE',
  ReviewProfile = 'REVIEW_PROFILE',
  ScreeningQuestions = 'SCREENING_QUESTIONS',
  UploadResume = 'UPLOAD_RESUME',
}

export type CustomApplicationStatus = {
  __typename?: 'CustomApplicationStatus'
  _count: Scalars['Int']['output']
  applicationStatusName: Scalars['String']['output']
  colorHexCode: Scalars['String']['output']
  company: Company
  companyId: Scalars['Int']['output']
  companyUser: CompanyUser
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  iconType: IconTypeEnum
  iconUnicode?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
}

export enum CustomApplicationStatusSortFields {
  ApplicationStatusName = 'applicationStatusName',
  ColorHexCode = 'colorHexCode',
  CreatedAt = 'createdAt',
  IconType = 'iconType',
  IconUnicode = 'iconUnicode',
  UpdatedAt = 'updatedAt',
}

export type CustomCandidateApplicationField = {
  __typename?: 'CustomCandidateApplicationField'
  company?: Maybe<Company>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CustomFieldCreatedByUser>
  customCandidateApplicationFieldRequisitions?: Maybe<Array<CustomCandidateApplicationFieldRequisition>>
  customCandidateApplicationFieldValues: Array<CustomCandidateApplicationFieldValue>
  id: Scalars['ID']['output']
  isArchived?: Maybe<Scalars['Boolean']['output']>
  linkedToScreeningQuestion?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  provider?: Maybe<CustomFieldProviderEnum>
  requireWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  schema?: Maybe<Scalars['JSON']['output']>
  screeningQuestions?: Maybe<Array<ScreeningQuestion>>
  showWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  systemTokenName?: Maybe<Scalars['String']['output']>
  tooltip?: Maybe<Scalars['Boolean']['output']>
  tooltipText?: Maybe<Scalars['String']['output']>
  type?: Maybe<CustomCandidateFieldTypeEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  visibility?: Maybe<CustomFieldVisibilityEnum>
}

export type CustomCandidateApplicationFieldFilter = {
  fieldId: Scalars['Int']['input']
  values: Array<Scalars['String']['input']>
}

export type CustomCandidateApplicationFieldOutput = {
  __typename?: 'CustomCandidateApplicationFieldOutput'
  companyId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  isArchived: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  provider: CustomFieldProviderEnum
  requireWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  requisitionIds?: Maybe<Array<Scalars['Int']['output']>>
  schema: Scalars['JSON']['output']
  showWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  systemTokenName?: Maybe<Scalars['String']['output']>
  tooltip?: Maybe<Scalars['Boolean']['output']>
  tooltipText?: Maybe<Scalars['String']['output']>
  type: CustomCandidateFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type CustomCandidateApplicationFieldRequisition = {
  __typename?: 'CustomCandidateApplicationFieldRequisition'
  customCandidateApplicationField?: Maybe<CustomCandidateApplicationField>
  id?: Maybe<Scalars['Int']['output']>
  requisition?: Maybe<Requisition>
}

export type CustomCandidateApplicationFieldValue = {
  __typename?: 'CustomCandidateApplicationFieldValue'
  candidateApplication?: Maybe<CandidateApplication>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customCandidateApplicationField?: Maybe<CustomCandidateApplicationField>
  customCandidateApplicationFieldId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  value?: Maybe<Scalars['JSON']['output']>
}

export enum CustomCandidateFieldTypeEnum {
  Checkbox = 'CHECKBOX',
  Currency = 'CURRENCY',
  Date = 'DATE',
  DateRange = 'DATE_RANGE',
  Files = 'FILES',
  MultipleSelect = 'MULTIPLE_SELECT',
  Number = 'NUMBER',
  Person = 'PERSON',
  Radio = 'RADIO',
  Range = 'RANGE',
  Select = 'SELECT',
  Text = 'TEXT',
  Url = 'URL',
}

export type CustomCandidateProfileField = {
  __typename?: 'CustomCandidateProfileField'
  company?: Maybe<Company>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CustomFieldCreatedByUser>
  customCandidateProfileFieldValues?: Maybe<Array<CustomCandidateProfileFieldValue>>
  id: Scalars['ID']['output']
  isArchived?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  provider?: Maybe<CustomFieldProviderEnum>
  requireWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  schema?: Maybe<Scalars['JSON']['output']>
  showWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  systemTokenName?: Maybe<Scalars['String']['output']>
  tooltip?: Maybe<Scalars['Boolean']['output']>
  tooltipText?: Maybe<Scalars['String']['output']>
  type?: Maybe<CustomCandidateFieldTypeEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  visibility?: Maybe<CustomFieldVisibilityEnum>
}

export type CustomCandidateProfileFieldFilter = {
  fieldId: Scalars['Int']['input']
  values: Array<Scalars['String']['input']>
}

export type CustomCandidateProfileFieldOutput = {
  __typename?: 'CustomCandidateProfileFieldOutput'
  companyId: Scalars['Int']['output']
  id: Scalars['Int']['output']
  isArchived: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  provider: CustomFieldProviderEnum
  requireWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  requisitionId?: Maybe<Scalars['Int']['output']>
  schema: Scalars['JSON']['output']
  showWhenUploadingCandidate?: Maybe<Scalars['Boolean']['output']>
  systemTokenName?: Maybe<Scalars['String']['output']>
  tooltip?: Maybe<Scalars['Boolean']['output']>
  tooltipText?: Maybe<Scalars['String']['output']>
  type: CustomCandidateFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type CustomCandidateProfileFieldValue = {
  __typename?: 'CustomCandidateProfileFieldValue'
  candidateProfile?: Maybe<CandidateProfile>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customCandidateProfileField?: Maybe<CustomCandidateProfileField>
  customCandidateProfileFieldId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  value?: Maybe<Scalars['JSON']['output']>
}

export type CustomEmailSenderInput = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  connectedEmailAddress: Scalars['String']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export type CustomFieldCreatedByUser = {
  __typename?: 'CustomFieldCreatedByUser'
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
  profileImage?: Maybe<Scalars['String']['output']>
}

export enum CustomFieldInputTypeEnum {
  Currency = 'CURRENCY',
  Date = 'DATE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  Text = 'TEXT',
}

export enum CustomFieldProviderEnum {
  HiringTeam = 'HIRING_TEAM',
  RecruitersOnly = 'RECRUITERS_ONLY',
}

export type CustomFieldValueInput = {
  fieldId: Scalars['Int']['input']
  value: Scalars['String']['input']
}

export enum CustomFieldVisibilityEnum {
  Internal = 'INTERNAL',
  Public = 'PUBLIC',
}

export type CustomJobRequisitionField = {
  __typename?: 'CustomJobRequisitionField'
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  createdBy?: Maybe<CustomFieldCreatedByUser>
  id: Scalars['ID']['output']
  isArchived: Scalars['Boolean']['output']
  isRequired: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  provider: CustomFieldProviderEnum
  schema: Scalars['JSON']['output']
  systemTokenName?: Maybe<Scalars['String']['output']>
  tooltip?: Maybe<Scalars['Boolean']['output']>
  tooltipText?: Maybe<Scalars['String']['output']>
  type: CustomJobRequisitionFieldTypeEnum
  updatedAt: Scalars['DateTime']['output']
  visibility: CustomFieldVisibilityEnum
}

export enum CustomJobRequisitionFieldTypeEnum {
  Checkbox = 'CHECKBOX',
  Currency = 'CURRENCY',
  Date = 'DATE',
  DateRange = 'DATE_RANGE',
  Files = 'FILES',
  MultipleSelect = 'MULTIPLE_SELECT',
  Number = 'NUMBER',
  Person = 'PERSON',
  Radio = 'RADIO',
  Range = 'RANGE',
  Select = 'SELECT',
  Text = 'TEXT',
  Url = 'URL',
}

export type CustomJobRequisitionFieldValue = {
  __typename?: 'CustomJobRequisitionFieldValue'
  companyUser?: Maybe<CompanyUser>
  companyUserId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customJobRequisitionField?: Maybe<CustomJobRequisitionField>
  customJobRequisitionFieldId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  value?: Maybe<Scalars['JSON']['output']>
}

export type CustomSourceCategory = {
  __typename?: 'CustomSourceCategory'
  candidateSourceNames: Array<CandidateSourceName>
  company: Company
  companyId: Scalars['Int']['output']
  companyUser: CompanyUser
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  externalId?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  sourceCategoryName: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export enum DatePostedEnum {
  PastMonth = 'PAST_MONTH',
  PastThreeDays = 'PAST_THREE_DAYS',
  PastTwentyFourHours = 'PAST_TWENTY_FOUR_HOURS',
  PastWeek = 'PAST_WEEK',
}

export type DateTimeRangeInput = {
  endDate: Scalars['DateTime']['input']
  startDate: Scalars['DateTime']['input']
}

export type DefaultToken = {
  __typename?: 'DefaultToken'
  categoryName: TokenCategoryNameEnum
  columnName?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  isAggregatedToken: Scalars['Boolean']['output']
  tableName?: Maybe<Scalars['String']['output']>
  tokenName: TokenNameEnum
  tokenType: Array<DefaultTokenTypeEnum>
}

export enum DefaultTokenTypeEnum {
  Email = 'EMAIL',
  Offer = 'OFFER',
}

export type DeleteAchievementInput = {
  achievementId: Scalars['Int']['input']
}

export type DeleteApplicantNotesInput = {
  id: Scalars['Int']['input']
}

export type DeleteApplicationFormInput = {
  id: Scalars['Int']['input']
}

export type DeleteApplicationFormScreeningQuestionInput = {
  id: Scalars['Int']['input']
}

export type DeleteBookmarkedJobInput = {
  publicListingId: Scalars['String']['input']
}

export type DeleteCalendarEventInput = {
  eventId: Scalars['Int']['input']
}

export type DeleteCandidateApplicationFromRequisitionInput = {
  candidateApplicationIds: Array<Scalars['Int']['input']>
  requisitionId: Scalars['Int']['input']
}

export type DeleteCandidateApplicationFromRequisitionResponse = {
  __typename?: 'DeleteCandidateApplicationFromRequisitionResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteCandidateApplicationInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateApplicationNoteInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateCollaboratorInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateFilterInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateLabelInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateMedalistDesignationInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateMessageInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateOfferCustomFieldInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateOfferFileInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateOfferInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateOfferVersionInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateProfileInput = {
  id: Array<Scalars['Int']['input']>
}

export type DeleteCandidateProfileLocationInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateProfileNoteInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateScorecardInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateSourceInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateSourceNameInput = {
  id: Scalars['Int']['input']
}

export type DeleteCandidateTouchpointActivityLogInput = {
  id: Scalars['Int']['input']
}

export type DeleteCertificateOrLicenseInput = {
  certificateOrLicenseId: Scalars['Int']['input']
}

export type DeleteCompanyCandidateTouchpointInput = {
  id: Scalars['Int']['input']
}

export type DeleteCompanyDepartmentInput = {
  id: Scalars['Int']['input']
}

export type DeleteCompanyOfficeInput = {
  id: Scalars['Int']['input']
}

export type DeleteCompanyProvidedEmailInput = {
  id: Scalars['Int']['input']
}

export type DeleteCompanyUserFromWorkspaceInput = {
  companyUserId: Scalars['Int']['input']
}

export type DeleteCompanyUserGroupInput = {
  companyId: Scalars['Int']['input']
  companyUserGroupId: Scalars['Int']['input']
}

export type DeleteCustomApplicationStatusInput = {
  id: Scalars['Int']['input']
}

export type DeleteCustomApplicationStatusResponse = {
  __typename?: 'DeleteCustomApplicationStatusResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteCustomCandidateApplicationFieldInput = {
  id: Scalars['Int']['input']
}

export type DeleteCustomCandidateApplicationFieldResponse = {
  __typename?: 'DeleteCustomCandidateApplicationFieldResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteCustomCandidateApplicationFieldValueInput = {
  id: Scalars['Int']['input']
}

export type DeleteCustomCandidateApplicationFieldValueResponse = {
  __typename?: 'DeleteCustomCandidateApplicationFieldValueResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteCustomCandidateProfileFieldInput = {
  id: Scalars['Int']['input']
}

export type DeleteCustomCandidateProfileFieldResponse = {
  __typename?: 'DeleteCustomCandidateProfileFieldResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteCustomCandidateProfileFieldValueInput = {
  id: Scalars['Int']['input']
}

export type DeleteCustomCandidateProfileFieldValueResponse = {
  __typename?: 'DeleteCustomCandidateProfileFieldValueResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteCustomJobRequisitionFieldInput = {
  id: Scalars['Int']['input']
}

export type DeleteCustomJobRequisitionFieldResponse = {
  __typename?: 'DeleteCustomJobRequisitionFieldResponse'
  message: Scalars['String']['output']
  success: Scalars['Boolean']['output']
}

export type DeleteCustomSourceCategoryInput = {
  id: Scalars['Int']['input']
}

export type DeleteEducationInput = {
  educationId: Scalars['Int']['input']
}

export type DeleteExperienceInput = {
  experienceId: Scalars['Int']['input']
}

export type DeleteExternalApplicationInput = {
  applicationId: Scalars['Int']['input']
}

export type DeleteExternalJobApplicationResponse = {
  __typename?: 'DeleteExternalJobApplicationResponse'
  message: Scalars['String']['output']
}

export type DeleteFavoriteSequenceInput = {
  sequenceId: Scalars['String']['input']
}

export type DeleteFavoriteTalentPoolInput = {
  talentPoolId: Scalars['Int']['input']
}

export type DeleteGlobalScreeningQuestionInput = {
  id: Scalars['Int']['input']
}

export type DeleteHiringTeamMemberInput = {
  id: Scalars['Int']['input']
}

export type DeleteInterviewInput = {
  interviewId: Scalars['Int']['input']
}

export type DeleteInterviewTeamInput = {
  id: Scalars['Int']['input']
}

export type DeleteInterviewTemplateInput = {
  id: Scalars['Int']['input']
}

export type DeleteInterviewTemplateLoopInput = {
  id: Scalars['Int']['input']
}

export type DeleteInterviewerPoolInput = {
  id: Scalars['Int']['input']
}

export type DeleteInvitationFromWorkspaceInput = {
  invitationId: Scalars['Int']['input']
}

export type DeleteJobListingInput = {
  id: Scalars['Int']['input']
}

export type DeleteJobListingScreeningQuestionInput = {
  id: Scalars['Int']['input']
}

export type DeleteJobOpeningInput = {
  id: Scalars['Int']['input']
}

export type DeleteJobSeekerSkillInput = {
  skillId: Scalars['Int']['input']
}

export type DeleteNotificationSettingInput = {
  id: Scalars['Int']['input']
}

/** Input type for deleting an offer custom field */
export type DeleteOfferCustomFieldInput = {
  /** Unique identifier of the offer custom field to delete */
  id: Scalars['Int']['input']
}

export type DeleteOfferDocumentTemplateInput = {
  id: Scalars['Int']['input']
}

export type DeleteOfferDocumentTemplateSectionInput = {
  offerDocumentTemplateId: Scalars['Int']['input']
  offerSectionTemplateId: Scalars['Int']['input']
}

export type DeleteOfferSectionTemplateInput = {
  id: Scalars['Int']['input']
}

export type DeleteOfferTemplateConditionInput = {
  id: Scalars['Int']['input']
}

export type DeleteRequisitionInput = {
  id: Scalars['Int']['input']
}

export type DeleteRequisitionJobDescriptionInput = {
  id: Scalars['Int']['input']
}

export type DeleteRequisitionSkillInput = {
  id: Scalars['Int']['input']
}

export type DeleteSavedViewInput = {
  companyId: Scalars['Int']['input']
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
}

export type DeleteSavedViewResponse = {
  __typename?: 'DeleteSavedViewResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteScalisUserUploadedDocumentInput = {
  id: Scalars['Int']['input']
}

export type DeleteScalisUserUploadedDocumentOutput = {
  __typename?: 'DeleteScalisUserUploadedDocumentOutput'
  success: Scalars['Boolean']['output']
}

export type DeleteSchedulerLinkInviteInput = {
  inviteId: Scalars['Int']['input']
}

export type DeleteSchedulerLinkSettingsInput = {
  id: Scalars['Int']['input']
}

export type DeleteScorecardTemplateInput = {
  id: Scalars['Int']['input']
}

export type DeleteScorecardTemplateQuestionInput = {
  id: Scalars['Int']['input']
}

export type DeleteScorecardTemplateSectionInput = {
  id: Scalars['Int']['input']
}

export type DeleteScreeningQuestionInput = {
  id: Scalars['Int']['input']
}

export type DeleteSequenceScheduleSettingInput = {
  id: Scalars['Int']['input']
}

export type DeleteSkillInput = {
  skillId: Scalars['Int']['input']
}

export type DeleteSourceTrackingLinkInput = {
  id: Scalars['String']['input']
}

export type DeleteStageCollaboratorInput = {
  id: Scalars['Int']['input']
}

export type DeleteStageSettingsInput = {
  id: Scalars['Int']['input']
}

export type DeleteTalentPoolInput = {
  id: Scalars['Int']['input']
}

export type DeleteTalentPoolProspectStatusInput = {
  id: Scalars['Int']['input']
}

export type DeleteTalentPoolResponse = {
  __typename?: 'DeleteTalentPoolResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type DeleteTemplateJobDescriptionInput = {
  id: Scalars['Int']['input']
}

export type DeleteTemplateMessageInput = {
  id: Scalars['Int']['input']
}

export type DeleteTemplateMilestoneInput = {
  id: Scalars['Int']['input']
}

export type DeleteTemplatePipelineInput = {
  id: Scalars['Int']['input']
}

export type DeleteTemplateScreeningQuestionInput = {
  id: Scalars['Int']['input']
}

export type DeleteTemplateStageInput = {
  id: Scalars['Int']['input']
}

export type DeleteTokenTestResultInput = {
  id: Scalars['Int']['input']
}

export type DeleteUploadedDocumentCandidateApplicationInput = {
  id: Scalars['Int']['input']
}

export type DeleteUploadedDocumentCandidateProfileInput = {
  id: Scalars['Int']['input']
}

export type DeleteUploadedDocumentInput = {
  id: Scalars['Int']['input']
}

export type DeleteUsersFromCompanyUserGroupInput = {
  companyId: Scalars['Int']['input']
  companyUserGroupId: Scalars['Int']['input']
  companyUserIds: Array<Scalars['Int']['input']>
}

export type DeleteVolunteerWorkInput = {
  volunteerWorkId: Scalars['Int']['input']
}

export type DemographicInfo = {
  __typename?: 'DemographicInfo'
  gender?: Maybe<GenderEnum>
  id: Scalars['Int']['output']
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  raceEthnicity?: Maybe<Scalars['String']['output']>
  veteranStatus?: Maybe<VeteranStatusEnum>
  workHistory?: Maybe<Scalars['Boolean']['output']>
}

export type DemographicInfoInput = {
  gender?: InputMaybe<GenderEnum>
  raceEthnicity?: InputMaybe<Scalars['String']['input']>
  veteranStatus?: InputMaybe<VeteranStatusEnum>
  workHistory?: InputMaybe<Scalars['Boolean']['input']>
}

/** Demographics information */
export type Demographics = {
  __typename?: 'Demographics'
  gender?: Maybe<Scalars['String']['output']>
  race?: Maybe<Scalars['String']['output']>
  veteranStatus?: Maybe<Scalars['String']['output']>
}

export type DiscardCandidateRecommendationInput = {
  candidateIds: Array<Scalars['String']['input']>
  rate?: InputMaybe<Scalars['Int']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  requisitionId: Scalars['Int']['input']
}

export type DiscardedCandidateRecommendation = {
  __typename?: 'DiscardedCandidateRecommendation'
  Company: Company
  CompanyUser: CompanyUser
  Requisition: Requisition
  candidateId: Scalars['String']['output']
  companyId: Scalars['Int']['output']
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  isDeleted: Scalars['Boolean']['output']
  rate?: Maybe<Scalars['Int']['output']>
  reason?: Maybe<Scalars['String']['output']>
  requisitionId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type DisconnectCalendarInput = {
  email: Scalars['String']['input']
}

export type DisconnectCalendarOutput = {
  __typename?: 'DisconnectCalendarOutput'
  success: Scalars['Boolean']['output']
}

export type DisconnectConnectedEmailInput = {
  email: Scalars['String']['input']
}

export type DisconnectConnectedEmailOutput = {
  __typename?: 'DisconnectConnectedEmailOutput'
  success: Scalars['Boolean']['output']
  warning?: Maybe<Scalars['String']['output']>
}

export type DocumentTemplateConditions = {
  departments?: InputMaybe<Array<Scalars['Int']['input']>>
  employmentType?: InputMaybe<Array<JobTypeEnum>>
  offices?: InputMaybe<Array<Scalars['Int']['input']>>
  payType?: InputMaybe<Array<PayTypeEnum>>
}

export enum DocumentTypeEnum {
  OfferLetter = 'OFFER_LETTER',
  Other = 'OTHER',
  Resume = 'RESUME',
}

export type DownloadDocumentTemplateInput = {
  id: Scalars['Int']['input']
}

export type DownloadDocumentTemplateOutput = {
  __typename?: 'DownloadDocumentTemplateOutput'
  temporaryUrl: Scalars['String']['output']
}

export type DuplicateTalentPoolInput = {
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
}

export type DuplicateTalentPoolResponse = {
  __typename?: 'DuplicateTalentPoolResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
  talentPoolId: Scalars['Int']['output']
}

export type Duration = {
  __typename?: 'Duration'
  period: Scalars['Int']['output']
  range: Scalars['String']['output']
}

export type EditApprovalWorkflowInstanceInput = {
  steps: Array<ApprovalWorkflowStepInput>
  workflowVersionId: Scalars['Int']['input']
}

export type EditApprovalWorkflowSettingsInput = {
  defaultJobApprovalWorkflowId?: InputMaybe<Scalars['Int']['input']>
  defaultOfferApprovalWorkflowId?: InputMaybe<Scalars['Int']['input']>
  defaultOpeningApprovalWorkflowId?: InputMaybe<Scalars['Int']['input']>
  requireJobApproval?: InputMaybe<Scalars['Boolean']['input']>
  requireOfferApproval?: InputMaybe<Scalars['Boolean']['input']>
  requireOpeningApproval?: InputMaybe<Scalars['Boolean']['input']>
}

export type EditCalendarEventCandidateInput = {
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  type: CandidateTypeEnum
}

export type EditCalendarEventInput = {
  /** External calendar event id from Nylas */
  calendarEventId: Scalars['String']['input']
  /** Calendar id from Scalis */
  calendarId: Scalars['Int']['input']
  candidates?: InputMaybe<Array<EditCalendarEventCandidateInput>>
  /** Whether or not a meeting should be created. Defaults to false. */
  createConference?: InputMaybe<Scalars['Boolean']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  /** Event id from Scalis */
  eventId: Scalars['Int']['input']
  existingConferencing?: InputMaybe<Scalars['JSON']['input']>
  /** Workspace/Company employees that will be participating the event. Previously known as internalHrAssociates */
  internalEmployees?: InputMaybe<Array<EditCalendarEventInternalEmployeesInput>>
  isScalisEvent: Scalars['Boolean']['input']
  location?: InputMaybe<Scalars['String']['input']>
  regardingCandidates?: InputMaybe<Array<EditCalendarEventRegardingCandidatesInput>>
  regardingJobs?: InputMaybe<Array<Scalars['Int']['input']>>
  reminders?: InputMaybe<EditCalendarEventRemindersInput>
  repeats?: InputMaybe<RepeatsEnum>
  title: Scalars['String']['input']
  type: EventTypeEnum
  when: EditCalendarEventWhenInput
}

export type EditCalendarEventInternalEmployeesInput = {
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type EditCalendarEventRegardingCandidatesInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  type: CandidateTypeEnum
}

export type EditCalendarEventRemindersInput = {
  overrides?: InputMaybe<Array<EditCalendarEventRemindersOverridesInput>>
  useDefault: Scalars['Boolean']['input']
}

export type EditCalendarEventRemindersOverridesInput = {
  reminderMethod: ReminderMethodEnum
  reminderMinutes: Scalars['Int']['input']
}

export type EditCalendarEventWhenInput = {
  endTime: Scalars['String']['input']
  startTime: Scalars['String']['input']
  timezone: Scalars['String']['input']
}

export type EditCalendarSettingsInput = {
  availability?: InputMaybe<Scalars['String']['input']>
  hourDisplay?: InputMaybe<Scalars['Int']['input']>
  timeZone?: InputMaybe<Scalars['String']['input']>
}

export type EditCandidateApplicationStatusInput = {
  applicationStatus?: InputMaybe<ApplicationStatusEnum>
  candidateApplicationIds: Array<Scalars['Int']['input']>
  customApplicationStatusId?: InputMaybe<Scalars['Int']['input']>
}

export type EditCandidateLabelInput = {
  colorNumber: Scalars['Int']['input']
  id: Scalars['Int']['input']
  labelName: Scalars['String']['input']
}

export type EditCandidateSourceNameInput = {
  customSourceCategoryId?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  name?: InputMaybe<Scalars['String']['input']>
  sourceCategory?: InputMaybe<CandidateSourceCategoryEnum>
}

export type EditCandidateTouchpointActivityLogInput = {
  activity?: InputMaybe<Scalars['JSON']['input']>
  activityTimestamp: Scalars['DateTime']['input']
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId: Scalars['Int']['input']
  companyCandidateTouchpointId: Scalars['Int']['input']
  companyUserId: Scalars['Int']['input']
  id: Scalars['Int']['input']
  notes?: InputMaybe<Scalars['String']['input']>
}

export type EditCompanyCandidateTouchpointInput = {
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
}

export type EditCompanyProvidedEmailInput = {
  candidateProfileId: Scalars['Int']['input']
  email: Scalars['String']['input']
  id: Scalars['Int']['input']
}

export type EditCompanyUserViewOrderInput = {
  updates: Array<EditCompanyUserViewOrderItemInput>
}

export type EditCompanyUserViewOrderItemInput = {
  companyUserViewId: Scalars['Int']['input']
  rankOrder: Scalars['Int']['input']
}

export type EditConnectedEmailInput = {
  id: Scalars['Int']['input']
  trackLinks?: InputMaybe<Scalars['Boolean']['input']>
  trackOpen?: InputMaybe<Scalars['Boolean']['input']>
  trackReply?: InputMaybe<Scalars['Boolean']['input']>
}

export type EditCustomApplicationStatusInput = {
  applicationStatusName: Scalars['String']['input']
  colorHexCode: Scalars['String']['input']
  iconType?: InputMaybe<IconTypeEnum>
  iconUnicode?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
}

export type EditCustomCandidateApplicationFieldInput = {
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
  provider: CustomFieldProviderEnum
  requireWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  requisitionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  schema: Scalars['JSON']['input']
  showWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  tooltip?: InputMaybe<Scalars['Boolean']['input']>
  tooltipText?: InputMaybe<Scalars['String']['input']>
  type: CustomCandidateFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type EditCustomCandidateProfileFieldInput = {
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
  provider: CustomFieldProviderEnum
  requireWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  schema: Scalars['JSON']['input']
  showWhenUploadingCandidate?: InputMaybe<Scalars['Boolean']['input']>
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  tooltip?: InputMaybe<Scalars['Boolean']['input']>
  tooltipText?: InputMaybe<Scalars['String']['input']>
  type: CustomCandidateFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type EditCustomJobRequisitionFieldInput = {
  id: Scalars['Int']['input']
  isRequired?: InputMaybe<Scalars['Boolean']['input']>
  name: Scalars['String']['input']
  provider: CustomFieldProviderEnum
  schema: Scalars['JSON']['input']
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  tooltip?: InputMaybe<Scalars['Boolean']['input']>
  tooltipText?: InputMaybe<Scalars['String']['input']>
  type: CustomJobRequisitionFieldTypeEnum
  visibility: CustomFieldVisibilityEnum
}

export type EditCustomJobRequisitionFieldValueInput = {
  id: Scalars['Int']['input']
  value: Scalars['String']['input']
}

export type EditCustomSourceCategoryInput = {
  externalId?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  sourceCategoryName: Scalars['String']['input']
}

export type EditGlobalScreeningQuestionInput = {
  ansOptions?: InputMaybe<Scalars['String']['input']>
  globalQuestionOrder?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  isActiveGlobally?: InputMaybe<Scalars['Boolean']['input']>
  isRejectionQuestion?: InputMaybe<Scalars['Boolean']['input']>
  maxVal?: InputMaybe<Scalars['Int']['input']>
  minVal?: InputMaybe<Scalars['Int']['input']>
  preferredAnswer?: InputMaybe<Scalars['String']['input']>
  questionDesc?: InputMaybe<Scalars['String']['input']>
  questionTitle?: InputMaybe<Scalars['String']['input']>
  questionType?: InputMaybe<QuestionTypeEnum>
  rejectMessage?: InputMaybe<Scalars['String']['input']>
  valStatus?: InputMaybe<Scalars['String']['input']>
}

export type EditSavedViewInput = {
  candidateFilterId?: InputMaybe<Scalars['Int']['input']>
  columnOrder?: InputMaybe<Scalars['JSON']['input']>
  columnSizing?: InputMaybe<Scalars['JSON']['input']>
  columnVisibility?: InputMaybe<Scalars['JSON']['input']>
  companyId: Scalars['Int']['input']
  companyUserId: Scalars['Int']['input']
  id: Scalars['Int']['input']
  isPinned?: InputMaybe<Scalars['Boolean']['input']>
  isVisibleTo?: InputMaybe<CompanySavedViewVisibilityEnum>
  name?: InputMaybe<Scalars['String']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  sorting?: InputMaybe<Scalars['JSON']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
  viewLayout?: InputMaybe<CompanySavedViewLayoutEnum>
  viewLocation?: InputMaybe<CompanySavedViewLocationEnum>
}

export type EditSourceTrackingLinkInput = {
  id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type EditTalentPoolInput = {
  associatedRequisitionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  contributorCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  isVisibleTo?: InputMaybe<TalentPoolVisibilityEnum>
  name?: InputMaybe<Scalars['String']['input']>
  ownerCompanyUserId?: InputMaybe<Scalars['Int']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type EditTalentPoolProspectStatusInput = {
  colorNumber?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  status?: InputMaybe<Scalars['String']['input']>
}

export type EditTemplateApprovalWorkflowInput = {
  approvalConditions: Scalars['JSON']['input']
  approvalWorkflowType: ApprovalWorkflowTypeEnum
  description?: InputMaybe<Scalars['JSON']['input']>
  id: Scalars['Int']['input']
  name: Scalars['String']['input']
  steps: Array<TemplateApprovalWorkflowStepInput>
}

export type EditTemplateScreeningQuestionInput = {
  ansOptions?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  isActiveTemplate?: InputMaybe<Scalars['Boolean']['input']>
  isRejectionQuestion?: InputMaybe<Scalars['Boolean']['input']>
  maxVal?: InputMaybe<Scalars['Int']['input']>
  minVal?: InputMaybe<Scalars['Int']['input']>
  multipleSelectPreferredAnswers?: InputMaybe<Array<Scalars['String']['input']>>
  preferredAnswer?: InputMaybe<Scalars['String']['input']>
  preferredAnswerType?: InputMaybe<PreferredAnswerTypeEnum>
  questionDesc?: InputMaybe<Scalars['String']['input']>
  questionTitle?: InputMaybe<Scalars['String']['input']>
  questionType: QuestionTypeEnum
  rejectMessage?: InputMaybe<Scalars['String']['input']>
  selectionDisplay?: InputMaybe<SelectionDisplayEnum>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
  templateQuestionOrder?: InputMaybe<Scalars['Int']['input']>
  valStatus?: InputMaybe<Scalars['String']['input']>
}

export type Education = {
  __typename?: 'Education'
  additionalInformation?: Maybe<Scalars['String']['output']>
  areasOfStudy?: Maybe<Scalars['JSON']['output']>
  cumGPA?: Maybe<Scalars['Float']['output']>
  cumGPAScale?: Maybe<Scalars['Float']['output']>
  currentlyStudying?: Maybe<Scalars['Boolean']['output']>
  departmentCumGPA?: Maybe<Scalars['Float']['output']>
  departmentCumGPAScale?: Maybe<Scalars['Float']['output']>
  educationLevel?: Maybe<EducationLevelEnum>
  endDate?: Maybe<Scalars['DateTime']['output']>
  hideCumGPA?: Maybe<Scalars['Boolean']['output']>
  hideDepartmentGPA?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['Int']['output']
  institutionName?: Maybe<Scalars['String']['output']>
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  majors?: Maybe<Scalars['JSON']['output']>
  minors?: Maybe<Scalars['JSON']['output']>
  organization?: Maybe<CompanyGlobal>
  startDate?: Maybe<Scalars['DateTime']['output']>
}

export type EducationInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>
  areasOfStudy?: InputMaybe<Scalars['JSON']['input']>
  companyGlobalId?: InputMaybe<Scalars['String']['input']>
  cumGPA?: InputMaybe<Scalars['Float']['input']>
  cumGPAScale?: InputMaybe<Scalars['Float']['input']>
  currentlyStudying?: InputMaybe<Scalars['Boolean']['input']>
  departmentCumGPA?: InputMaybe<Scalars['Float']['input']>
  departmentCumGPAScale?: InputMaybe<Scalars['Float']['input']>
  educationLevel?: InputMaybe<EducationLevelEnum>
  endDate?: InputMaybe<Scalars['String']['input']>
  hideCumGPA?: InputMaybe<Scalars['Boolean']['input']>
  hideDepartmentGPA?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  institutionName?: InputMaybe<Scalars['String']['input']>
  majors?: InputMaybe<Scalars['JSON']['input']>
  minors?: InputMaybe<Scalars['JSON']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export enum EducationLevelEnum {
  AdvancedCertificate = 'ADVANCED_CERTIFICATE',
  Associates = 'ASSOCIATES',
  Bachelors = 'BACHELORS',
  Certificate = 'CERTIFICATE',
  Doctorate = 'DOCTORATE',
  HighSchoolDegree = 'HIGH_SCHOOL_DEGREE',
  Masters = 'MASTERS',
  NonDegreeSeeking = 'NON_DEGREE_SEEKING',
  PostdoctoralStudies = 'POSTDOCTORAL_STUDIES',
  TechnicalDiploma = 'TECHNICAL_DIPLOMA',
}

export enum EducationLevelPrefEnum {
  AdvancedCertificate = 'ADVANCED_CERTIFICATE',
  Associates = 'ASSOCIATES',
  Bachelors = 'BACHELORS',
  Certificate = 'CERTIFICATE',
  Doctorate = 'DOCTORATE',
  GraduateDegree = 'GRADUATE_DEGREE',
  HighSchool = 'HIGH_SCHOOL',
  Masters = 'MASTERS',
  None = 'NONE',
  NonDegreeSeeking = 'NON_DEGREE_SEEKING',
  PostdoctoralStudies = 'POSTDOCTORAL_STUDIES',
  TechnicalDiploma = 'TECHNICAL_DIPLOMA',
  UndergraduateDegree = 'UNDERGRADUATE_DEGREE',
}

/** Email information */
export type Email = {
  __typename?: 'Email'
  email?: Maybe<Scalars['String']['output']>
  isCurrent: Scalars['Boolean']['output']
  type: Scalars['String']['output']
}

export enum EmailAddressConnectionTypeEnum {
  Bcc = 'BCC',
  Cc = 'CC',
  From = 'FROM',
  To = 'TO',
}

export type EmailAttachment = {
  __typename?: 'EmailAttachment'
  content_id: Scalars['String']['output']
  content_type: Scalars['String']['output']
  filename: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type EmailAttachmentInput = {
  base64: Scalars['String']['input']
  contentType: Scalars['String']['input']
  fileName: Scalars['String']['input']
}

export type EmailConnection = {
  __typename?: 'EmailConnection'
  CompanyUser?: Maybe<CompanyUser>
  ConnectedEmailSettings?: Maybe<ConnectedEmailSettings>
  EmailRecord: EmailRecord
  EmailVerification?: Maybe<EmailVerification>
  companyUserId?: Maybe<Scalars['Int']['output']>
  connectedEmailSettingsId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  emailAddress: Scalars['String']['output']
  emailAddressConnectionType: EmailAddressConnectionTypeEnum
  emailRecordId: Scalars['String']['output']
  emailVerificationId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type EmailContact = {
  __typename?: 'EmailContact'
  companyUserId?: Maybe<Scalars['Int']['output']>
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  profileImage?: Maybe<Scalars['String']['output']>
}

export type EmailContactInput = {
  email: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

export type EmailRecord = {
  __typename?: 'EmailRecord'
  CandidateApplication?: Maybe<CandidateApplication>
  EmailConnection: Array<EmailConnection>
  EmailThread: EmailThread
  attachments?: Maybe<Scalars['JSON']['output']>
  bcc: Array<EmailContact>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  cc: Array<EmailContact>
  createdAt: Scalars['DateTime']['output']
  emailThreadId: Scalars['String']['output']
  externalEmailId?: Maybe<Scalars['String']['output']>
  externalThreadId?: Maybe<Scalars['String']['output']>
  from: Array<EmailContact>
  hasBounced?: Maybe<Scalars['Boolean']['output']>
  hasClicked?: Maybe<Scalars['Boolean']['output']>
  hasOpened?: Maybe<Scalars['Boolean']['output']>
  hasReplied?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
  provider: EmailRecordProviderEnum
  sequenceId?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
  to: Array<EmailContact>
  trackLinks?: Maybe<Scalars['Boolean']['output']>
  trackOpen?: Maybe<Scalars['Boolean']['output']>
  trackReply?: Maybe<Scalars['Boolean']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum EmailRecordProviderEnum {
  Nylas = 'NYLAS',
  Postmark = 'POSTMARK',
}

export type EmailRecordsResponse = {
  __typename?: 'EmailRecordsResponse'
  count: Scalars['Int']['output']
  emails: Array<EmailRecord>
}

export type EmailThread = {
  __typename?: 'EmailThread'
  CandidateProfile: CandidateProfile
  EmailRecord: Array<EmailRecord>
  candidateProfileId: Scalars['Int']['output']
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  externalThreadId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type EmailVerification = {
  __typename?: 'EmailVerification'
  activeStatus?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  emailAddress?: Maybe<Scalars['String']['output']>
  emailVerified?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['Int']['output']
  isPrimary?: Maybe<Scalars['Boolean']['output']>
  isVisibleToEmployers?: Maybe<Scalars['Boolean']['output']>
  scalisUserId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum EmployeeCountEnum {
  Count_1To_3 = 'COUNT_1_TO_3',
  Count_3To_5 = 'COUNT_3_TO_5',
  Count_6To_10 = 'COUNT_6_TO_10',
  Count_11To_20 = 'COUNT_11_TO_20',
  Count_20To_100 = 'COUNT_20_TO_100',
  Count_100To_500 = 'COUNT_100_TO_500',
  Count_500Plus = 'COUNT_500_PLUS',
}

export enum EmploymentTypeEnum {
  FixedTerm = 'fixed_term',
  FixedTermWithOptionForPermanent = 'fixed_term_with_option_for_permanent',
  Freelance = 'freelance',
  Internship = 'internship',
  Permanent = 'permanent',
  Temporary = 'temporary',
  Traineeship = 'traineeship',
}

export type EnrichedEmail = {
  __typename?: 'EnrichedEmail'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  emailAddress?: Maybe<Scalars['String']['output']>
  enrichedEmailType?: Maybe<EnrichedEmailTypeEnum>
  id: Scalars['ID']['output']
  recommended?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
}

export enum EnrichedEmailTypeEnum {
  Business = 'BUSINESS',
  Personal = 'PERSONAL',
}

export type EnrichedLocation = {
  __typename?: 'EnrichedLocation'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  location?: Maybe<Scalars['String']['output']>
  recommended?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
}

export type EnrichedPhoneNumber = {
  __typename?: 'EnrichedPhoneNumber'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
  phoneNumberType?: Maybe<EnrichedPhoneNumberTypeEnum>
  recommended?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
}

export enum EnrichedPhoneNumberTypeEnum {
  Mobile = 'MOBILE',
  Other = 'OTHER',
}

export type EventAttachment = {
  __typename?: 'EventAttachment'
  CalendarEvent: CalendarEvent
  eventId: Scalars['Int']['output']
  file?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
}

export type EventData = {
  __typename?: 'EventData'
  data: Scalars['JSON']['output']
  id: Scalars['String']['output']
  timestamp: Scalars['DateTime']['output']
  type: Scalars['String']['output']
}

export type EventJob = {
  __typename?: 'EventJob'
  CalendarEvent: CalendarEvent
  JobListing: JobListing
  calendarEventId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  jobId: Scalars['Int']['output']
}

export type EventSubscribersResponse = {
  __typename?: 'EventSubscribersResponse'
  subscriberCounts: Scalars['JSON']['output']
  success: Scalars['Boolean']['output']
}

export type EventSubscriptionsResponse = {
  __typename?: 'EventSubscriptionsResponse'
  eventTypes: Scalars['JSON']['output']
  firstEventTimestamp?: Maybe<Scalars['DateTime']['output']>
  lastEventTimestamp?: Maybe<Scalars['DateTime']['output']>
  totalEvents: Scalars['Int']['output']
}

export enum EventTypeEnum {
  AllHands = 'ALL__HANDS',
  Department = 'DEPARTMENT',
  Huddle = 'HUDDLE',
  InternalCandidate = 'INTERNAL_CANDIDATE',
  Meeting = 'MEETING',
  OneOnOne = 'ONE__ON__ONE',
  PanelReview = 'PANEL_REVIEW',
  Review = 'REVIEW',
  StrategyMeeting = 'STRATEGY_MEETING',
}

export type EventsResponse = {
  __typename?: 'EventsResponse'
  events: Array<EventData>
}

export type ExchangeConnectedEmailTokenInput = {
  callbackUrl: Scalars['String']['input']
  code: Scalars['String']['input']
}

export type ExchangeNylasTokenInput = {
  callbackUrl: Scalars['String']['input']
  code: Scalars['String']['input']
}

export type ExchangeWebSocketTokenInput = {
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>
}

export enum ExecutionSourceEnum {
  Application = 'APPLICATION',
  ChromeExtension = 'CHROME_EXTENSION',
}

export type Experience = {
  __typename?: 'Experience'
  additionalComp?: Maybe<Scalars['Boolean']['output']>
  description?: Maybe<Scalars['String']['output']>
  employerName?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  industry?: Maybe<IndustryEnum>
  isCurrentJob?: Maybe<Scalars['Boolean']['output']>
  isCurrentlyWorking?: Maybe<Scalars['Boolean']['output']>
  jobPay?: Maybe<Scalars['Float']['output']>
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  jobSeekerSkillExperiences?: Maybe<Array<JobSeekerSkillExperience>>
  jobTitle?: Maybe<Scalars['String']['output']>
  jobType?: Maybe<JobTypeEnum>
  location?: Maybe<Scalars['String']['output']>
  locationType?: Maybe<Scalars['String']['output']>
  longFormDesc?: Maybe<Scalars['String']['output']>
  managementPosition?: Maybe<Scalars['Boolean']['output']>
  organization?: Maybe<CompanyGlobal>
  payType?: Maybe<Scalars['String']['output']>
  searchLongFormDesc?: Maybe<Scalars['String']['output']>
  searchShortFormDesc?: Maybe<Scalars['String']['output']>
  shortFormDesc?: Maybe<Scalars['JSON']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  subIndustry?: Maybe<Scalars['String']['output']>
  teamSize?: Maybe<TeamSizeEnum>
  workPlaceCandidate?: Maybe<WorkPlaceCandidateEnum>
}

export type ExperienceInput = {
  additionalComp?: InputMaybe<Scalars['Boolean']['input']>
  companyGlobalId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  employerName?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  industry?: InputMaybe<IndustryEnum>
  isCurrentJob?: InputMaybe<Scalars['Boolean']['input']>
  isCurrentlyWorking?: InputMaybe<Scalars['Boolean']['input']>
  jobPay?: InputMaybe<Scalars['Float']['input']>
  jobTitle?: InputMaybe<Scalars['String']['input']>
  jobType?: InputMaybe<JobTypeEnum>
  location?: InputMaybe<Scalars['String']['input']>
  locationType?: InputMaybe<Scalars['String']['input']>
  longFormDesc?: InputMaybe<Scalars['String']['input']>
  managementPosition?: InputMaybe<Scalars['Boolean']['input']>
  payType?: InputMaybe<PayTypeEnum>
  searchLongFormDesc?: InputMaybe<Scalars['String']['input']>
  searchShortFormDesc?: InputMaybe<Scalars['String']['input']>
  shortFormDesc?: InputMaybe<Scalars['JSON']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  subIndustry?: InputMaybe<Scalars['String']['input']>
  teamSize?: InputMaybe<TeamSizeEnum>
  workPlaceCandidate?: InputMaybe<WorkPlaceCandidateEnum>
}

export type ExternalApplicationInput = {
  jobId: Scalars['String']['input']
  status?: InputMaybe<ExternalApplicationStatus>
}

export enum ExternalApplicationStatus {
  ApplicationReview = 'APPLICATION_REVIEW',
  Hired = 'HIRED',
  Interviews = 'INTERVIEWS',
  Offer = 'OFFER',
  PreScreen = 'PRE_SCREEN',
}

export type ExternalCompany = {
  __typename?: 'ExternalCompany'
  image?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  shortDescription?: Maybe<Scalars['String']['output']>
  social?: Maybe<CompanySocial>
  uuid: Scalars['String']['output']
  website?: Maybe<Scalars['String']['output']>
}

export type ExternalJob = {
  __typename?: 'ExternalJob'
  company: ExternalCompany
  companyName: Scalars['String']['output']
  descriptionHtml: Scalars['String']['output']
  employmentType?: Maybe<Scalars['String']['output']>
  expirationDate: Scalars['String']['output']
  extractedAt: Scalars['String']['output']
  h1bSponsorship: Scalars['Boolean']['output']
  jobDescription: Scalars['String']['output']
  jobKey: Scalars['String']['output']
  location?: Maybe<ExternalJobLocation>
  salaryRange?: Maybe<SalaryRange>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
  workLevel?: Maybe<JobLevel>
  workplaceType?: Maybe<WorkplaceType>
}

export type ExternalJobApplication = {
  __typename?: 'ExternalJobApplication'
  appliedAt?: Maybe<Scalars['DateTime']['output']>
  employerName: Scalars['String']['output']
  id: Scalars['ID']['output']
  jobId: Scalars['String']['output']
  jobTitle: Scalars['String']['output']
  jobUrl: Scalars['String']['output']
  location: Scalars['String']['output']
  status?: Maybe<ExternalApplicationStatus>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type ExternalJobLocation = {
  __typename?: 'ExternalJobLocation'
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  state: Scalars['String']['output']
}

export type FavoriteCoreReport = {
  __typename?: 'FavoriteCoreReport'
  CompanyUser: CompanyUser
  CoreReport: CoreReport
  companyUserId: Scalars['Int']['output']
  coreReportId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type FavoriteReportInput = {
  coreReportId: Scalars['Int']['input']
}

export type FavoriteSequence = {
  __typename?: 'FavoriteSequence'
  companyUserId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  sequenceId: Scalars['String']['output']
}

export type FavoriteTalentPool = {
  __typename?: 'FavoriteTalentPool'
  companyUserId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  talentPoolId: Scalars['Int']['output']
}

export type FieldTokenInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  systemFeatures: Array<ScalisSystemFeatureEnum>
}

export enum FilterContentTypeEnum {
  CandidateNames = 'candidateNames',
  Companies = 'companies',
  CreditedCompanyUser = 'creditedCompanyUser',
  Degrees = 'degrees',
  Emails = 'emails',
  JobTitles = 'jobTitles',
  Labels = 'labels',
  Majors = 'majors',
  ProspectOwner = 'prospectOwner',
  ProspectStatus = 'prospectStatus',
  Schools = 'schools',
  Skills = 'skills',
}

export type FilterCriteriaInput = {
  column: Scalars['String']['input']
  dateTimeRange?: InputMaybe<DateTimeRangeInput>
  type: CoreReportFilterTypeEnum
  values?: InputMaybe<Array<Scalars['String']['input']>>
}

export type FilterReferralsInput = {
  referredBy?: InputMaybe<Scalars['Int']['input']>
  referredTo?: InputMaybe<Scalars['Int']['input']>
}

export type FilterValueType = {
  __typename?: 'FilterValueType'
  count: Scalars['Int']['output']
  value: Scalars['String']['output']
}

export type FiltersType = {
  __typename?: 'FiltersType'
  key: Scalars['String']['output']
  values: Array<FilterValueType>
}

export enum GenderEnum {
  DeclineToSelfIdentify = 'DECLINE_TO_SELF_IDENTIFY',
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
}

export type GenerateFilesFromHtmlInput = {
  html: Scalars['String']['input']
}

export type GenerateFilesFromHtmlOutput = {
  __typename?: 'GenerateFilesFromHtmlOutput'
  docxKey: Scalars['String']['output']
  pdfKey: Scalars['String']['output']
}

export type GenerateKnockTokenInput = {
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['String']['input']
}

export type GetAiNotetakerTranscriptInput = {
  candidateInterviewId: Scalars['Int']['input']
}

export type GetApplicationFormInput = {
  id: Scalars['Int']['input']
}

export type GetApprovalWorkflowInstanceInput = {
  offerId?: InputMaybe<Scalars['Int']['input']>
  openingId?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type GetCampaignInput = {
  id: Scalars['String']['input']
}

export type GetCandidateOfferCustomFieldInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateOfferVersionId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type GetCandidateOfferFileInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateOfferVersionId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type GetCandidateOfferFileUrlInput = {
  candidateOfferVersionId: Scalars['Int']['input']
}

export type GetCandidateOfferFileUrlOutput = {
  __typename?: 'GetCandidateOfferFileUrlOutput'
  fileName: Scalars['String']['output']
  fileType: OfferFileTypeEnum
  url: Scalars['String']['output']
}

export type GetCandidateOfferInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type GetCandidateOfferVersionEmbeddedClaimUrlInput = {
  candidateOfferVersionId: Scalars['Int']['input']
  message?: InputMaybe<Scalars['String']['input']>
  signers: Array<SignatureRequestSignersInput>
  subject: Scalars['String']['input']
}

export type GetCandidateOfferVersionEmbeddedClaimUrlResult = {
  __typename?: 'GetCandidateOfferVersionEmbeddedClaimUrlResult'
  claimUrl?: Maybe<Scalars['String']['output']>
  clientId?: Maybe<Scalars['String']['output']>
  signatureRequestId?: Maybe<Scalars['String']['output']>
}

export type GetCandidateOfferVersionInput = {
  candidateOfferId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  version?: InputMaybe<Scalars['Int']['input']>
}

export enum GetCandidateRecommendationFilterCompanySizeBucketEnum {
  Size_1_10 = 'SIZE_1_10',
  Size_11_50 = 'SIZE_11_50',
  Size_51_200 = 'SIZE_51_200',
  Size_201_500 = 'SIZE_201_500',
  Size_501_1000 = 'SIZE_501_1000',
  Size_1001_5000 = 'SIZE_1001_5000',
  Size_5001_10000 = 'SIZE_5001_10000',
  Size_10001Plus = 'SIZE_10001_PLUS',
}

/** Get candidate recommendation input contact info available */
export type GetCandidateRecommendationInputContactInfoAvailable = {
  condition?: InputMaybe<Scalars['String']['input']>
  email_personal?: InputMaybe<Scalars['Boolean']['input']>
  email_professional?: InputMaybe<Scalars['Boolean']['input']>
  phone?: InputMaybe<Scalars['Boolean']['input']>
}

/** Get candidate recommendation input experiences tenure */
export type GetCandidateRecommendationInputExperiencesTenure = {
  max?: InputMaybe<Scalars['Int']['input']>
  min?: InputMaybe<Scalars['Int']['input']>
}

/** Get candidate recommendation input experiences tenure average */
export type GetCandidateRecommendationInputExperiencesTenureAverage = {
  max?: InputMaybe<Scalars['Int']['input']>
  min?: InputMaybe<Scalars['Int']['input']>
}

/** Get candidate recommendation input experiences tenure current role */
export type GetCandidateRecommendationInputExperiencesTenureCurrentRole = {
  max?: InputMaybe<Scalars['Int']['input']>
  min?: InputMaybe<Scalars['Int']['input']>
}

/** Get candidate recommendation input filters */
export type GetCandidateRecommendationInputFilters = {
  company_size?: InputMaybe<Array<GetCandidateRecommendationFilterCompanySizeBucketEnum>>
  contact_info_available?: InputMaybe<GetCandidateRecommendationInputContactInfoAvailable>
  experiences_tenure?: InputMaybe<GetCandidateRecommendationInputExperiencesTenure>
  experiences_tenure_average?: InputMaybe<GetCandidateRecommendationInputExperiencesTenureAverage>
  experiences_tenure_current_role?: InputMaybe<GetCandidateRecommendationInputExperiencesTenureCurrentRole>
}

/** Get candidate recommendation input job listing */
export type GetCandidateRecommendationInputJobListing = {
  experience: Scalars['String']['input']
  industry: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
  location: Scalars['String']['input']
  role: Scalars['String']['input']
  skills?: InputMaybe<Array<Scalars['String']['input']>>
}

/** Get candidate recommendation input pagination */
export type GetCandidateRecommendationInputPagination = {
  page?: InputMaybe<Scalars['Int']['input']>
  size?: InputMaybe<Scalars['Int']['input']>
}

/** Get candidate recommendation output */
export type GetCandidateRecommendationOutput = {
  __typename?: 'GetCandidateRecommendationOutput'
  pagination?: Maybe<GetCandidateRecommendationOutputPagination>
  results?: Maybe<Array<CandidateRecommendation>>
}

/** Get candidate recommendation output pagination */
export type GetCandidateRecommendationOutputPagination = {
  __typename?: 'GetCandidateRecommendationOutputPagination'
  count?: Maybe<Scalars['Int']['output']>
  page?: Maybe<Scalars['Int']['output']>
  size?: Maybe<Scalars['Int']['output']>
  totalPages?: Maybe<Scalars['Int']['output']>
}

/** Get candidate recommendation scores input */
export type GetCandidateRecommendationScoresInput = {
  recommendations?: InputMaybe<Array<CandidateRecommendationHighlightsInput>>
}

export type GetCandidateScorecardInput = {
  candidateApplicationIds?: InputMaybe<Array<Scalars['Int']['input']>>
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  ids?: InputMaybe<Array<Scalars['Int']['input']>>
  jobListingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']>>
  sortBy?: InputMaybe<SortByCandidateScorecard>
  sortDirection?: InputMaybe<SortDirection>
  status?: InputMaybe<Array<ScorecardStatusTypeEnum>>
}

export type GetCandidateTouchpointActivityLogInput = {
  id: Scalars['Int']['input']
}

export type GetCompanyUsersInput = {
  /** Search text to filter company users by first name, last name, or email address. Supports partial matches and multiple search terms. */
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetConnectedEmailAuthUrlInput = {
  email?: InputMaybe<Scalars['String']['input']>
  provider: ConnectedEmailProviderEnum
}

/** The provider auth URL */
export type GetConnectedEmailAuthUrlOutputType = {
  __typename?: 'GetConnectedEmailAuthUrlOutputType'
  authUrl: Scalars['String']['output']
}

export type GetConnectedEmailTrackInput = {
  connectedEmailId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type GetCustomCandidateApplicationFieldsInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  forUploadCandidateForm?: InputMaybe<Scalars['Boolean']['input']>
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type GetCustomCandidateProfileFieldsInput = {
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  forUploadCandidateForm?: InputMaybe<Scalars['Boolean']['input']>
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type GetCustomJobRequisitionFieldValuesInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type GetCustomJobRequisitionFieldsInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetCustomTalentPoolInput = {
  talentPoolId: Scalars['Int']['input']
}

export type GetDefaultTokenInput = {
  categoryName?: InputMaybe<TokenCategoryNameEnum>
  id?: InputMaybe<Scalars['Int']['input']>
  isAggregatedToken?: InputMaybe<Scalars['Boolean']['input']>
  tokenName?: InputMaybe<TokenNameEnum>
  tokenType?: InputMaybe<Array<DefaultTokenTypeEnum>>
}

export type GetEmailRecordsInput = {
  candidateProfileId: Scalars['Int']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortDirection?: InputMaybe<Scalars['String']['input']>
}

export type GetExternalJobListingInput = {
  id: Scalars['String']['input']
}

export type GetGlobalScreeningQuestionInput = {
  id: Scalars['Int']['input']
  showReplaced?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetInterviewTemplateInput = {
  id: Scalars['Int']['input']
}

export type GetInterviewTemplatesInput = {
  archivedOnly?: InputMaybe<Scalars['Boolean']['input']>
  createdByUser?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetInterviewerPoolInput = {
  /** The ID of the interviewer pool to fetch */
  id: Scalars['Int']['input']
}

export type GetInterviewerPoolsInput = {
  /** If true, return only archived pools. If false or not provided, return only non-archived pools */
  archivedOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** If true, only return pools created by the current user */
  createdByUser?: InputMaybe<Scalars['Boolean']['input']>
  /** If true, only return pools where the current user is a member */
  memberOnly?: InputMaybe<Scalars['Boolean']['input']>
  /** Search term to filter pools by name (case-insensitive partial match) */
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetJobSearchPreferenceInput = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type GetManySchedulerLinkSettingsInput = {
  companyUserIds: Array<Scalars['Int']['input']>
}

export type GetNotificationSettingsByCompanyUserIdInput = {
  companyUserId: Scalars['Int']['input']
}

/** Input type for querying offer custom fields */
export type GetOfferCustomFieldInput = {
  /** ID of the candidate application to filter conditions that should be applied */
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  /** Types of conditions to filter by */
  conditionType?: InputMaybe<Array<ConditionTypeEnum>>
  /** ID of the department to filter by */
  departmentId?: InputMaybe<Scalars['Int']['input']>
  /** Type of employment to filter by */
  employmentType?: InputMaybe<JobTypeEnum>
  /** Type of input field (e.g., text, number, select) */
  fieldConfigurationType?: InputMaybe<CustomFieldInputTypeEnum>
  /** Flag indicating if the field is required */
  fieldRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** Flag indicating if a system token should be generated */
  generateSystemToken?: InputMaybe<Scalars['Boolean']['input']>
  /** Unique identifier of the offer custom field */
  id?: InputMaybe<Scalars['Int']['input']>
  /** Filter by archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>
  /** ID of the office to filter by */
  officeId?: InputMaybe<Scalars['Int']['input']>
  /** Type of pay to filter by */
  payType?: InputMaybe<PayTypeEnum>
  /** Name of the system token if generated */
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  /** ID of the associated template condition */
  templateConditionId?: InputMaybe<Scalars['Int']['input']>
}

export type GetOfferDocumentTemplateInput = {
  conditionType?: InputMaybe<Array<ConditionTypeEnum>>
  departmentId?: InputMaybe<Scalars['Int']['input']>
  documentFileName?: InputMaybe<Scalars['String']['input']>
  documentFilePath?: InputMaybe<Scalars['String']['input']>
  documentTemplateStatus?: InputMaybe<OfferDocumentTemplateStatusEnum>
  documentType?: InputMaybe<OfferDocumentTemplateTypeEnum>
  employmentType?: InputMaybe<JobTypeEnum>
  id?: InputMaybe<Scalars['Int']['input']>
  officeId?: InputMaybe<Scalars['Int']['input']>
  payType?: InputMaybe<PayTypeEnum>
}

export type GetOfferDocumentTemplateSectionInput = {
  offerDocumentTemplateId?: InputMaybe<Scalars['Int']['input']>
  offerSectionTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type GetOfferSectionTemplateInput = {
  conditionType?: InputMaybe<Array<ConditionTypeEnum>>
  departmentId?: InputMaybe<Scalars['Int']['input']>
  employmentType?: InputMaybe<JobTypeEnum>
  id?: InputMaybe<Scalars['Int']['input']>
  officeId?: InputMaybe<Scalars['Int']['input']>
  payType?: InputMaybe<PayTypeEnum>
  sectionTemplateStatus?: InputMaybe<TokenStatusEnum>
}

export type GetOfferTemplateConditionInput = {
  conditionType?: InputMaybe<ConditionTypeEnum>
  departmentId?: InputMaybe<Scalars['Int']['input']>
  employmentType?: InputMaybe<JobTypeEnum>
  id?: InputMaybe<Scalars['Int']['input']>
  offerDocumentTemplateId?: InputMaybe<Scalars['Int']['input']>
  officeId?: InputMaybe<Scalars['Int']['input']>
  payType?: InputMaybe<PayTypeEnum>
  sectionTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type GetOrdersInput = {
  id: Scalars['Int']['input']
}

export type GetPipelineCompanyUserViewInput = {
  requisitionId: Scalars['Int']['input']
}

export type GetPipelineCompanyUserViewResponse = {
  __typename?: 'GetPipelineCompanyUserViewResponse'
  createdByMe: Array<RequisitionTalentPoolCompanySavedView>
  defaultViews: Array<RequisitionTalentPoolCompanySavedView>
  list: Array<ViewLinkWithUserPreference>
  savedByOthers: Array<RequisitionTalentPoolCompanySavedView>
}

export type GetSavedViewInput = {
  companyUserViewId: Scalars['Int']['input']
}

export type GetScorecardTemplatesInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyTemplate?: InputMaybe<Scalars['Boolean']['input']>
  ids?: InputMaybe<Array<Scalars['Int']['input']>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  scorecardName?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortByScorecardTemplate>
  sortDirection?: InputMaybe<SortDirection>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

export type GetSequenceActivityLogsInput = {
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  hasReplied?: InputMaybe<Scalars['Boolean']['input']>
  labels?: InputMaybe<Array<Scalars['Int']['input']>>
  lastContacted?: InputMaybe<LastContactedRange>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sequenceId: Scalars['String']['input']
  sequenceStatus?: InputMaybe<Array<SequenceCandidateStatusEnum>>
  sortBy?: InputMaybe<SequenceActivityLogSortBy>
  sortDirection?: InputMaybe<Scalars['String']['input']>
}

export type GetSequenceByIdInput = {
  sequenceId: Scalars['String']['input']
}

export type GetSequenceCandidateActivityLogsInput = {
  candidateProfileId: Scalars['Int']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sequenceId: Scalars['String']['input']
}

export type GetSequenceCandidateEngagementInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sequenceId: Scalars['String']['input']
}

export type GetSequenceMetricsInput = {
  sequenceId: Scalars['String']['input']
}

export type GetSequencesInput = {
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetSourceTrackingLinkInput = {
  id: Scalars['String']['input']
}

export type GetTalentPoolProspectStatusInput = {
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetTalentPoolsInput = {
  search?: InputMaybe<Scalars['String']['input']>
}

export type GetTemporaryS3UrlInput = {
  fileKey?: InputMaybe<Scalars['String']['input']>
  filePath?: InputMaybe<Scalars['String']['input']>
}

export type GetTemporaryS3UrlOutput = {
  __typename?: 'GetTemporaryS3UrlOutput'
  tempUrl: Scalars['String']['output']
}

export type GetThreadInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortDirection?: InputMaybe<Scalars['String']['input']>
  threadId: Scalars['String']['input']
}

export type GetTokenTestResultInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  offerDocumentTemplateId?: InputMaybe<Scalars['Int']['input']>
  offerSectionTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type GlobalListingSetup = {
  __typename?: 'GlobalListingSetup'
  Company: Company
  aboutCompanyStatement?: Maybe<Scalars['JSON']['output']>
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  footerStatement?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  isAboutCompanyActive: Scalars['Boolean']['output']
  isFooterStatementActive: Scalars['Boolean']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type GlobalListingSetupInput = {
  aboutCompanyStatement?: InputMaybe<Scalars['JSON']['input']>
  companyId: Scalars['Int']['input']
  footerStatement?: InputMaybe<Scalars['JSON']['input']>
  isAboutCompanyActive?: InputMaybe<Scalars['Boolean']['input']>
  isFooterStatementActive?: InputMaybe<Scalars['Boolean']['input']>
}

/** GPA information */
export type Gpa = {
  __typename?: 'Gpa'
  scale?: Maybe<Scalars['Float']['output']>
  value?: Maybe<Scalars['Float']['output']>
}

export type HighlightInput = {
  icon: Scalars['String']['input']
  name: Scalars['String']['input']
  summary: Scalars['String']['input']
}

export type HiringTeamMember = {
  __typename?: 'HiringTeamMember'
  CompanyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  requisitionJobDescription?: Maybe<RequisitionJobDescription>
  requisitionJobDescriptionId?: Maybe<Scalars['Int']['output']>
  role?: Maybe<Role>
  roleId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type HtmlToBase64Input = {
  html: Scalars['String']['input']
}

export type HtmlToBase64Output = {
  __typename?: 'HtmlToBase64Output'
  pdf: Scalars['String']['output']
}

export type HtmlToDocxInput = {
  html: Scalars['String']['input']
}

export type HtmlToDocxOutput = {
  __typename?: 'HtmlToDocxOutput'
  dir?: Maybe<Scalars['String']['output']>
  filename: Scalars['String']['output']
  size?: Maybe<Scalars['Int']['output']>
  url?: Maybe<Scalars['String']['output']>
}

export enum IconTypeEnum {
  Fontawesome = 'FONTAWESOME',
  Unicode = 'UNICODE',
}

export type IdentifyKnockUserInput = {
  properties: Scalars['JSON']['input']
}

export type IdentifyKnockUserResponse = {
  __typename?: 'IdentifyKnockUserResponse'
  success: Scalars['Boolean']['output']
}

export type IdsArrayInput = {
  ids: Array<Scalars['String']['input']>
}

export enum IndustryEnum {
  AerospaceAndDefense = 'AEROSPACE_AND_DEFENSE',
  Agriculture = 'AGRICULTURE',
  ArtsEntertainmentAndRecreation = 'ARTS_ENTERTAINMENT_AND_RECREATION',
  Automotive = 'AUTOMOTIVE',
  Construction = 'CONSTRUCTION',
  ConsultingServices = 'CONSULTING_SERVICES',
  Education = 'EDUCATION',
  EnergyMiningAndUtilities = 'ENERGY_MINING_AND_UTILITIES',
  EnvironmentalServices = 'ENVIRONMENTAL_SERVICES',
  ECommerce = 'E_COMMERCE',
  FashionAndApparel = 'FASHION_AND_APPAREL',
  FinancialServices = 'FINANCIAL_SERVICES',
  FoodAndBeverage = 'FOOD_AND_BEVERAGE',
  GovernmentAndPublicAdminstration = 'GOVERNMENT_AND_PUBLIC_ADMINSTRATION',
  Healthcare = 'HEALTHCARE',
  HotelsAndTravelAccomodation = 'HOTELS_AND_TRAVEL_ACCOMODATION',
  HumanResourcesAndStaffing = 'HUMAN_RESOURCES_AND_STAFFING',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Insurance = 'INSURANCE',
  Legal = 'LEGAL',
  ManagementAndConsulting = 'MANAGEMENT_AND_CONSULTING',
  Manufacturing = 'MANUFACTURING',
  MediaAndCommunication = 'MEDIA_AND_COMMUNICATION',
  NonprofitAndNgo = 'NONPROFIT_AND_NGO',
  PersonalConsumerServices = 'PERSONAL_CONSUMER_SERVICES',
  PharmaceuticalAndBiotech = 'PHARMACEUTICAL_AND_BIOTECH',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  RealEstate = 'REAL_ESTATE',
  RestaurantsAndFoodService = 'RESTAURANTS_AND_FOOD_SERVICE',
  RetailAndWholesale = 'RETAIL_AND_WHOLESALE',
  SocialMediaAndNetworking = 'SOCIAL_MEDIA_AND_NETWORKING',
  Telecommunications = 'TELECOMMUNICATIONS',
  TransportationAndLogistics = 'TRANSPORTATION_AND_LOGISTICS',
}

export type InsertConnectedEmailInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>
  bcc?: InputMaybe<Array<EmailContactInput>>
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  cc?: InputMaybe<Array<EmailContactInput>>
  connectedEmailSettingsId: Scalars['Int']['input']
  emailId: Scalars['String']['input']
  from: Array<EmailContactInput>
  message?: InputMaybe<Scalars['String']['input']>
  subject?: InputMaybe<Scalars['String']['input']>
  threadId?: InputMaybe<Scalars['String']['input']>
  to: Array<EmailContactInput>
  trackLinks?: InputMaybe<Scalars['Boolean']['input']>
  trackOpen?: InputMaybe<Scalars['Boolean']['input']>
  trackReply?: InputMaybe<Scalars['Boolean']['input']>
}

export type InsertEmailRecordInput = {
  attachments?: InputMaybe<Scalars['JSON']['input']>
  bcc?: InputMaybe<Array<EmailContactInput>>
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId: Scalars['Int']['input']
  cc?: InputMaybe<Array<EmailContactInput>>
  companyId: Scalars['Int']['input']
  externalEmailId?: InputMaybe<Scalars['String']['input']>
  externalThreadId?: InputMaybe<Scalars['String']['input']>
  from: Array<EmailContactInput>
  fromConnectedEmailSettingsId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  provider: EmailRecordProviderEnum
  subject?: InputMaybe<Scalars['String']['input']>
  to: Array<EmailContactInput>
  trackLinks?: InputMaybe<Scalars['Boolean']['input']>
  trackOpen?: InputMaybe<Scalars['Boolean']['input']>
  trackReply?: InputMaybe<Scalars['Boolean']['input']>
}

export type InsertGlobalScreeningQuestionInput = {
  ansOptions?: InputMaybe<Scalars['String']['input']>
  globalQuestionOrder?: InputMaybe<Scalars['Int']['input']>
  isRejectionQuestion?: InputMaybe<Scalars['Boolean']['input']>
  maxVal?: InputMaybe<Scalars['Int']['input']>
  minVal?: InputMaybe<Scalars['Int']['input']>
  preferredAnswer?: InputMaybe<Scalars['String']['input']>
  questionDesc?: InputMaybe<Scalars['String']['input']>
  questionTitle?: InputMaybe<Scalars['String']['input']>
  questionType?: InputMaybe<QuestionTypeEnum>
  rejectMessage?: InputMaybe<Scalars['String']['input']>
  valStatus?: InputMaybe<Scalars['String']['input']>
}

export type IntegrationsNylasNotetaker = {
  __typename?: 'IntegrationsNylasNotetaker'
  candidateInterview?: Maybe<CandidateInterview>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  nylasNotetakerId: Scalars['String']['output']
  recordingPath?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  transcriptPath?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum InterviewLengthEnum {
  Dummy = 'DUMMY',
}

export type InterviewPoolMemberSkill = {
  __typename?: 'InterviewPoolMemberSkill'
  InterviewerPoolMember?: Maybe<InterviewerPoolMember>
  InterviewerPoolSkill?: Maybe<InterviewerPoolSkill>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  interviewerPoolMemberId: Scalars['Int']['output']
  interviewerPoolSkillId: Scalars['Int']['output']
}

export enum InterviewScheduleEnum {
  Later = 'LATER',
  Scheduler = 'SCHEDULER',
}

export enum InterviewSchedulingEnum {
  ManuallySchedule = 'MANUALLY_SCHEDULE',
  SendInvite = 'SEND_INVITE',
}

export type InterviewTeam = {
  __typename?: 'InterviewTeam'
  CompanyUser: CompanyUser
  StageSettings: StageSettings
  companyUserId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  stageSettingsId: Scalars['Int']['output']
}

export type InterviewTeamInput = {
  companyUserId: Scalars['Int']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  stageSettingsId?: InputMaybe<Scalars['Int']['input']>
}

export type InterviewTemplate = {
  __typename?: 'InterviewTemplate'
  CandidateInterviews?: Maybe<Array<CandidateInterview>>
  Company: Company
  InterviewerPool?: Maybe<InterviewerPool>
  LoopInterviews?: Maybe<Array<InterviewTemplateLoop>>
  ScorecardTemplate?: Maybe<ScorecardTemplate>
  companyId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdByUser?: Maybe<CompanyUser>
  createdByUserId?: Maybe<Scalars['Int']['output']>
  debriefInterview: Scalars['Boolean']['output']
  duration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['ID']['output']>
  interviewType?: Maybe<InterviewTypeEnum>
  interviewerPoolId?: Maybe<Scalars['Int']['output']>
  isArchived?: Maybe<Scalars['Boolean']['output']>
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  name?: Maybe<Scalars['String']['output']>
  schedulingLogic?: Maybe<SchedulingLogicEnum>
  scorecardTemplateId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type InterviewTemplateCompanyUser = {
  __typename?: 'InterviewTemplateCompanyUser'
  CompanyUser?: Maybe<CompanyUser>
  InterviewTemplate?: Maybe<InterviewTemplate>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id?: Maybe<Scalars['ID']['output']>
  interviewTemplateId?: Maybe<Scalars['Int']['output']>
  isOrganizer?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type InterviewTemplateLoop = {
  __typename?: 'InterviewTemplateLoop'
  AssignedUser?: Maybe<CompanyUser>
  CandidateInterviewLoops?: Maybe<Array<CandidateInterviewLoop>>
  InterviewTemplate?: Maybe<InterviewTemplate>
  InterviewerPool?: Maybe<InterviewerPool>
  ScorecardTemplate?: Maybe<ScorecardTemplate>
  assignedUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['ID']['output']>
  interviewTemplateId?: Maybe<Scalars['Int']['output']>
  interviewerPoolId?: Maybe<Scalars['Int']['output']>
  name?: Maybe<Scalars['String']['output']>
  rankOrder?: Maybe<Scalars['Int']['output']>
  scorecardTemplateId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export enum InterviewTypeEnum {
  Onsite = 'ONSITE',
  Phone = 'PHONE',
  Video = 'VIDEO',
}

export type InterviewerPool = {
  __typename?: 'InterviewerPool'
  CandidateInterviews?: Maybe<Array<CandidateInterview>>
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  Departments?: Maybe<Array<InterviewerPoolDepartment>>
  Jobs?: Maybe<Array<InterviewerPoolJob>>
  Members?: Maybe<Array<InterviewerPoolMember>>
  Offices?: Maybe<Array<InterviewerPoolOffice>>
  Skills?: Maybe<Array<InterviewerPoolSkill>>
  companyId: Scalars['Int']['output']
  companyUserId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  enableLoadBalancing: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  isArchived: Scalars['Boolean']['output']
  maxDailyInterviews?: Maybe<Scalars['Int']['output']>
  maxWeeklyInterviews?: Maybe<Scalars['Int']['output']>
  minDailyInterviews?: Maybe<Scalars['Int']['output']>
  minWeeklyInterviews?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type InterviewerPoolDepartment = {
  __typename?: 'InterviewerPoolDepartment'
  CompanyDepartment?: Maybe<CompanyDepartment>
  InterviewerPool?: Maybe<InterviewerPool>
  companyDepartmentId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  interviewerPoolId: Scalars['Int']['output']
}

export type InterviewerPoolJob = {
  __typename?: 'InterviewerPoolJob'
  InterviewerPool?: Maybe<InterviewerPool>
  Requisition?: Maybe<Requisition>
  id: Scalars['ID']['output']
  interviewerPoolId: Scalars['Int']['output']
  requisitionId: Scalars['Int']['output']
}

export type InterviewerPoolMember = {
  __typename?: 'InterviewerPoolMember'
  CompanyUser?: Maybe<CompanyUser>
  InterviewerPool?: Maybe<InterviewerPool>
  MemberSkills?: Maybe<Array<InterviewPoolMemberSkill>>
  companyUserId: Scalars['Int']['output']
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  interviewerPoolId: Scalars['Int']['output']
  interviewsLastWeekCount?: Maybe<Scalars['Int']['output']>
  interviewsThisWeekCount?: Maybe<Scalars['Int']['output']>
  interviewsTodayCount?: Maybe<Scalars['Int']['output']>
}

export type InterviewerPoolOffice = {
  __typename?: 'InterviewerPoolOffice'
  CompanyOffice?: Maybe<CompanyOffice>
  InterviewerPool?: Maybe<InterviewerPool>
  companyOfficeId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  interviewerPoolId: Scalars['Int']['output']
}

export type InterviewerPoolSkill = {
  __typename?: 'InterviewerPoolSkill'
  InterviewerPool?: Maybe<InterviewerPool>
  MemberSkills?: Maybe<Array<InterviewPoolMemberSkill>>
  Skill?: Maybe<Skill>
  id: Scalars['ID']['output']
  interviewerPoolId: Scalars['Int']['output']
  skillId: Scalars['Int']['output']
}

export enum InvitationStatusEnum {
  Deleted = 'DELETED',
  Expired = 'EXPIRED',
  Invited = 'INVITED',
  InviteAccepted = 'INVITE_ACCEPTED',
}

export type InviteCandidatesToApplyInput = {
  applicationStatus?: InputMaybe<ApplicationStatusEnum>
  candidateProfileIds: Array<Scalars['Int']['input']>
  customApplicationStatusId?: InputMaybe<Scalars['Int']['input']>
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  customMessage?: InputMaybe<Scalars['String']['input']>
  jobListingId: Scalars['Int']['input']
  notifyUploadedCandidates?: InputMaybe<Scalars['Boolean']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type InviteCandidatesToApplyOutput = {
  __typename?: 'InviteCandidatesToApplyOutput'
  isPreviouslyInvited?: Maybe<Array<JobInviteNotSentOutput>>
  profileNotFound?: Maybe<Array<JobInviteNotSentOutput>>
  sent?: Maybe<Array<JobInvite>>
  uploadedCandidatesToReviewStage?: Maybe<Array<JobInviteNotSentOutput>>
}

export type InviteCandidatesToApplyWithoutProfileIdsInput = {
  applicationStatus?: InputMaybe<ApplicationStatusEnum>
  customApplicationStatusId?: InputMaybe<Scalars['Int']['input']>
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  customMessage?: InputMaybe<Scalars['String']['input']>
  jobListingId: Scalars['Int']['input']
  notifyUploadedCandidates?: InputMaybe<Scalars['Boolean']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export enum InviteStatusEnum {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Sent = 'SENT',
}

export type InviteUserInput = {
  emails: Array<Scalars['String']['input']>
  invitedAs: InvitedAsRoleInput
}

export enum InvitedAsRoleInput {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  Member = 'MEMBER',
  ScalisAdmin = 'SCALIS_ADMIN',
  SuperAdmin = 'SUPER_ADMIN',
}

export type Invoice = {
  __typename?: 'Invoice'
  accountCountry?: Maybe<Scalars['String']['output']>
  accountName?: Maybe<Scalars['String']['output']>
  amountDue: Scalars['Float']['output']
  amountPaid: Scalars['Float']['output']
  amountRemaining: Scalars['Float']['output']
  billingReason?: Maybe<Scalars['String']['output']>
  created: Scalars['DateTime']['output']
  currency: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  dueDate?: Maybe<Scalars['DateTime']['output']>
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  invoicePdf?: Maybe<Scalars['String']['output']>
  nextPaymentAttempt?: Maybe<Scalars['Int']['output']>
  number?: Maybe<Scalars['String']['output']>
  paid: Scalars['Boolean']['output']
  periodEnd?: Maybe<Scalars['DateTime']['output']>
  periodStart: Scalars['DateTime']['output']
  receiptNumber?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  subtotal: Scalars['Float']['output']
  subtotalExcludingTax?: Maybe<Scalars['Float']['output']>
  tax?: Maybe<Scalars['Float']['output']>
  total: Scalars['Float']['output']
}

export enum JobActionEnum {
  Created = 'CREATED',
  JobApprovalRequested = 'JOB_APPROVAL_REQUESTED',
  JobApproved = 'JOB_APPROVED',
  JobClosed = 'JOB_CLOSED',
  JobDenied = 'JOB_DENIED',
  JobOfferApprovalDenied = 'JOB_OFFER_APPROVAL_DENIED',
  JobOfferApprovalRequested = 'JOB_OFFER_APPROVAL_REQUESTED',
  JobOfferApproved = 'JOB_OFFER_APPROVED',
  JobOnHold = 'JOB_ON_HOLD',
  JobOpened = 'JOB_OPENED',
  JobOpeningApprovalRequested = 'JOB_OPENING_APPROVAL_REQUESTED',
  JobOpeningApproved = 'JOB_OPENING_APPROVED',
  JobOpeningClosed = 'JOB_OPENING_CLOSED',
  JobOpeningDeleted = 'JOB_OPENING_DELETED',
  JobOpeningDenied = 'JOB_OPENING_DENIED',
  JobOpeningFilled = 'JOB_OPENING_FILLED',
  JobOpeningOnHold = 'JOB_OPENING_ON_HOLD',
  JobOpeningOpened = 'JOB_OPENING_OPENED',
}

export type JobAdCampaign = {
  __typename?: 'JobAdCampaign'
  Company: Company
  JobListing: JobListing
  Order?: Maybe<Order>
  Requisition: Requisition
  campaignName: Scalars['String']['output']
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  jobListingId: Scalars['Int']['output']
  requisitionId: Scalars['Int']['output']
  targetGroup: Scalars['JSON']['output']
  updatedAt: Scalars['DateTime']['output']
  vonqCampaignId?: Maybe<Scalars['String']['output']>
}

export type JobCampaign = {
  __typename?: 'JobCampaign'
  campaignId: Scalars['String']['output']
  campaignName: Scalars['String']['output']
  companyId: Scalars['String']['output']
  createdOn: Scalars['String']['output']
  currency?: Maybe<Scalars['String']['output']>
  customerId?: Maybe<Scalars['String']['output']>
  isEditable: Scalars['Boolean']['output']
  labels?: Maybe<JobCampaignLabels>
  orderId?: Maybe<Scalars['Int']['output']>
  orderReference?: Maybe<Scalars['String']['output']>
  orderedProducts: Array<Scalars['String']['output']>
  orderedProductsSpecs?: Maybe<Array<OrderedProductsSpec>>
  paymentStatus?: Maybe<PaymentStatusEnum>
  postingDetails?: Maybe<PostingDetails>
  postings: Array<Posting>
  recruiterInfo?: Maybe<RecruiterInfo>
  status: CampaignStatuses
  targetGroup?: Maybe<TargetGroup>
  totalPrice?: Maybe<CampaignTotalPrice>
  /** @deprecated Use campaignTraffic.views instead */
  viewsCount?: Maybe<Scalars['JSON']['output']>
}

export type JobCampaignCreation = {
  __typename?: 'JobCampaignCreation'
  clientSecret: Scalars['String']['output']
  deliveryTime: JobCampaignDeliveryTime
  orderReference: Scalars['String']['output']
  price: OrderCampaignPrice
}

export type JobCampaignCreationOrCampaignErrors = CampaignValidationErrors | JobCampaignCreation

export type JobCampaignDeliveryTime = {
  __typename?: 'JobCampaignDeliveryTime'
  daysToProcess: Scalars['Int']['output']
  daysToSetup: Scalars['Int']['output']
  totalDays: Scalars['Int']['output']
}

export type JobCampaignEducationLevel = {
  __typename?: 'JobCampaignEducationLevel'
  id: Scalars['Int']['output']
  name: Array<EducationLevel>
}

export type JobCampaignIndustry = {
  __typename?: 'JobCampaignIndustry'
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type JobCampaignLabels = {
  __typename?: 'JobCampaignLabels'
  jobListingId?: Maybe<Scalars['String']['output']>
  productName?: Maybe<Scalars['String']['output']>
  requisitionId?: Maybe<Scalars['String']['output']>
}

export type JobCampaignLocation = {
  __typename?: 'JobCampaignLocation'
  canonical_name: Scalars['String']['output']
  fully_qualified_place_name?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
}

export type JobCampaignProduct = {
  __typename?: 'JobCampaignProduct'
  allow_orders: Scalars['Boolean']['output']
  audience_group: Scalars['String']['output']
  bundle_products_ids: Array<Scalars['String']['output']>
  channel: Channel
  cross_postings: Array<Scalars['String']['output']>
  description: Scalars['String']['output']
  duration: Duration
  homepage: Scalars['String']['output']
  id: Scalars['ID']['output']
  industries: Array<JobCampaignIndustry>
  job_functions: Array<JobFunction>
  locations: Array<JobCampaignLocation>
  logo_rectangle_url?: Maybe<Array<Logo>>
  logo_square_url?: Maybe<Array<Logo>>
  logo_url: Array<LogoUrl>
  mc_enabled: Scalars['Boolean']['output']
  mc_only: Scalars['Boolean']['output']
  product_id: Scalars['String']['output']
  ratecard_price: Array<Price>
  time_to_process: ProcessTime
  time_to_setup: SetupTime
  title: Scalars['String']['output']
  type: Scalars['String']['output']
  vonq_price: Array<Price>
}

export type JobCampaignProductInput = {
  id: Scalars['String']['input']
}

export type JobCampaignProducts = {
  __typename?: 'JobCampaignProducts'
  count: Scalars['Int']['output']
  results?: Maybe<Array<JobCampaignProduct>>
}

export type JobCampaignResponse = {
  __typename?: 'JobCampaignResponse'
  data: Array<JobCampaign>
  limit: Scalars['Int']['output']
  offset: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type JobCampaignSalaryRange = {
  __typename?: 'JobCampaignSalaryRange'
  currency?: Maybe<Scalars['String']['output']>
  from?: Maybe<Scalars['Int']['output']>
  to?: Maybe<Scalars['Int']['output']>
}

export type JobCampaignSeniority = {
  __typename?: 'JobCampaignSeniority'
  id: Scalars['Int']['output']
  name: Array<SeniorityLevel>
}

export type JobFunction = {
  __typename?: 'JobFunction'
  children?: Maybe<Array<JobFunction>>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type JobInvite = {
  __typename?: 'JobInvite'
  CandidateApplication?: Maybe<CandidateApplication>
  JobListing?: Maybe<JobListing>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  dismissed?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  inviteStatus?: Maybe<InviteStatusEnum>
  jobListingId?: Maybe<Scalars['Int']['output']>
  sentAt?: Maybe<Scalars['DateTime']['output']>
  token?: Maybe<Scalars['Int']['output']>
}

export enum JobLevel {
  EntryLevel = 'ENTRY_LEVEL',
  FirstManagement = 'FIRST_MANAGEMENT',
  IntermediateOrExperienced = 'INTERMEDIATE_OR_EXPERIENCED',
  MiddleManagement = 'MIDDLE_MANAGEMENT',
  SeniorOrExecutive = 'SENIOR_OR_EXECUTIVE',
}

export enum JobLevelEnum {
  EntryLevel = 'ENTRY_LEVEL',
  FirstManagement = 'FIRST_MANAGEMENT',
  IntermediateOrExperienced = 'INTERMEDIATE_OR_EXPERIENCED',
  MiddleManagement = 'MIDDLE_MANAGEMENT',
  SeniorOrExecutive = 'SENIOR_OR_EXECUTIVE',
}

export type JobLevelPermission = {
  __typename?: 'JobLevelPermission'
  hiringTeamRole?: Maybe<RoleEnum>
  requisitionId: Scalars['Int']['output']
  stageCollaborator: Array<StageCollaboratorPermission>
}

export enum JobLevelRoleEnum {
  HiringManager = 'HIRING_MANAGER',
  HiringTeamMember = 'HIRING_TEAM_MEMBER',
  JobViewer = 'JOB_VIEWER',
  Recruiter = 'RECRUITER',
}

export type JobListing = {
  __typename?: 'JobListing'
  Address?: Maybe<Array<Address>>
  Campaigns?: Maybe<Array<JobAdCampaign>>
  CandidateApplication?: Maybe<Array<CandidateApplication>>
  EventJob?: Maybe<Array<EventJob>>
  JobInvite?: Maybe<Array<JobInvite>>
  JobListingJobPipeline?: Maybe<JobListingJobPipeline>
  JobListingScreeningQuestion?: Maybe<Array<JobListingScreeningQuestion>>
  Requisition?: Maybe<Requisition>
  acceptingCandidates?: Maybe<Scalars['Boolean']['output']>
  companyDefault?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  defaultConnectedEmailSettingsId?: Maybe<Scalars['Int']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  displayPayOnListing?: Maybe<Scalars['Boolean']['output']>
  externalListingId?: Maybe<Scalars['String']['output']>
  externalTitle?: Maybe<Scalars['String']['output']>
  hasApplied?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['Int']['output']
  industry?: Maybe<IndustryEnum>
  internalMatchingDescription?: Maybe<Scalars['String']['output']>
  jobRequisitionId?: Maybe<Scalars['Int']['output']>
  listingTitle?: Maybe<Scalars['String']['output']>
  postedAt?: Maybe<Scalars['DateTime']['output']>
  publicDescription?: Maybe<Scalars['String']['output']>
  publicListingId?: Maybe<Scalars['String']['output']>
  searchInternalMatchingDescription?: Maybe<Scalars['String']['output']>
  searchPublicDescription?: Maybe<Scalars['String']['output']>
  stage?: Maybe<StageEnum>
  stateAndOrCountry?: Maybe<Scalars['String']['output']>
  subIndustry?: Maybe<SubIndustryTypeEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  workplaceType?: Maybe<WorkplaceTypeEnum>
}

export type JobListingJobPipeline = {
  __typename?: 'JobListingJobPipeline'
  JobListing?: Maybe<JobListing>
  JobPipeline?: Maybe<JobPipeline>
  id: Scalars['ID']['output']
  jobListingId?: Maybe<Scalars['Int']['output']>
  jobPipelineId?: Maybe<Scalars['Int']['output']>
}

export type JobListingScreeningQuestion = {
  __typename?: 'JobListingScreeningQuestion'
  CandidateAnswer?: Maybe<ScreeningQuestionAnswer>
  JobListing?: Maybe<JobListing>
  ScreeningQuestion?: Maybe<ScreeningQuestion>
  active?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  displaySequenceNumber?: Maybe<Scalars['Int']['output']>
  hasApplications?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  jobListingId?: Maybe<Scalars['Int']['output']>
  screeningQuestionId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type JobListingScreeningQuestionCandidateAnswerArgs = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
}

export type JobListingsSearchResult = ExternalJob | JobListing

export type JobOpening = {
  __typename?: 'JobOpening'
  CandidateApplication?: Maybe<CandidateApplication>
  CandidateProfile?: Maybe<CandidateProfile>
  Company?: Maybe<Company>
  Requisition?: Maybe<Requisition>
  closedDate?: Maybe<Scalars['DateTime']['output']>
  closedReason?: Maybe<ClosedReasonEnum>
  companyId?: Maybe<Scalars['Int']['output']>
  extOpeningId?: Maybe<Scalars['String']['output']>
  filledByApplication?: Maybe<Scalars['Int']['output']>
  filledByCandidate?: Maybe<Scalars['Int']['output']>
  filledDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  jobRequisitionId?: Maybe<Scalars['Int']['output']>
  openingStatus?: Maybe<OpeningStatusEnum>
  openingType?: Maybe<OpeningTypeEnum>
  startDate?: Maybe<Scalars['DateTime']['output']>
  targetHireDate?: Maybe<Scalars['DateTime']['output']>
}

export type JobPipeline = {
  __typename?: 'JobPipeline'
  JobListingJobPipeline?: Maybe<Array<JobListingJobPipeline>>
  Requisition?: Maybe<Requisition>
  StageSettings?: Maybe<Array<StageSettings>>
  TemplatePipeline?: Maybe<TemplatePipeline>
  id: Scalars['ID']['output']
  jobRequisitionId?: Maybe<Scalars['Int']['output']>
  templatePipelineId?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type JobSearchPreference = {
  __typename?: 'JobSearchPreference'
  ScalisUser: ScalisUser
  benefits?: Maybe<Scalars['JSON']['output']>
  companyStage?: Maybe<Scalars['JSON']['output']>
  createdAt: Scalars['DateTime']['output']
  datePosted?: Maybe<DatePostedEnum>
  desiredCompanySize?: Maybe<Scalars['JSON']['output']>
  excludeJobTitles?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  includeJobTitles?: Maybe<Scalars['JSON']['output']>
  industryPreference?: Maybe<Scalars['JSON']['output']>
  jobType?: Maybe<JobTypeEnum>
  maxRequiredExperience?: Maybe<Scalars['String']['output']>
  minimumPayPreference?: Maybe<Scalars['String']['output']>
  minimumRequiredExperience?: Maybe<Scalars['String']['output']>
  relocationLocationPreference?: Maybe<Scalars['JSON']['output']>
  relocationTypePreference?: Maybe<RelocationTypePreferenceEnum>
  scalisUserId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
  visaSponsorship?: Maybe<Scalars['Boolean']['output']>
  workplaceLocationPreference?: Maybe<Scalars['JSON']['output']>
  workplaceTypePreference?: Maybe<Scalars['JSON']['output']>
}

export type JobSearchResultType = {
  __typename?: 'JobSearchResultType'
  benefits?: Maybe<Array<Scalars['String']['output']>>
  company?: Maybe<CompanyType>
  createdAt?: Maybe<Scalars['String']['output']>
  department?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  descriptionHtml?: Maybe<Scalars['String']['output']>
  educationLevel?: Maybe<EducationLevelPrefEnum>
  employment?: Maybe<JobTypeEnum>
  experienceLevel?: Maybe<JobLevelEnum>
  id: Scalars['String']['output']
  industry?: Maybe<Scalars['String']['output']>
  isApplied?: Maybe<Scalars['Boolean']['output']>
  isBookmarked?: Maybe<Scalars['Boolean']['output']>
  isScalis?: Maybe<Scalars['Boolean']['output']>
  locations?: Maybe<Array<LocationType>>
  payment?: Maybe<PayTypeEnum>
  salary?: Maybe<SalaryType>
  skills?: Maybe<Array<Scalars['String']['output']>>
  source?: Maybe<SourceTypeEnum>
  tags?: Maybe<Array<Scalars['String']['output']>>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
  visaSponsorship?: Maybe<Scalars['Boolean']['output']>
  workplace?: Maybe<LocationTypeEnum>
}

export type JobSeekerHeader = {
  __typename?: 'JobSeekerHeader'
  educationDisplayedId?: Maybe<Scalars['Int']['output']>
  id: Scalars['Int']['output']
  jobDisplayedId?: Maybe<Scalars['Int']['output']>
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  profileHeadline?: Maybe<Scalars['String']['output']>
}

export type JobSeekerHeaderInput = {
  educationDisplayedId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  jobDisplayedId?: InputMaybe<Scalars['Int']['input']>
  profileHeadline?: InputMaybe<Scalars['String']['input']>
}

export type JobSeekerInfo = {
  __typename?: 'JobSeekerInfo'
  aboutMe?: Maybe<Scalars['String']['output']>
  canStartNewJob?: Maybe<CanStartNewJobEnum>
  consideringOffers?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  currPrefRoles?: Maybe<Scalars['JSON']['output']>
  desiredPay?: Maybe<Scalars['Int']['output']>
  employStatus?: Maybe<Scalars['Boolean']['output']>
  hasFinishedOnboarding: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  jobLevel?: Maybe<Scalars['String']['output']>
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  jobType?: Maybe<Scalars['String']['output']>
  jobTypePref?: Maybe<JobTypePrefEnum>
  locationsWillRelocate?: Maybe<Scalars['JSON']['output']>
  messageUserId?: Maybe<Scalars['String']['output']>
  nonTraditionalStatus?: Maybe<Scalars['Boolean']['output']>
  payType?: Maybe<Scalars['String']['output']>
  searchStatus?: Maybe<Scalars['String']['output']>
  searchingJobs?: Maybe<Scalars['Boolean']['output']>
  teamSize?: Maybe<TeamSizeEnum>
  tryingToRelocate?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  willingToRelocate?: Maybe<Scalars['String']['output']>
  yearsInWorkforce?: Maybe<Scalars['Int']['output']>
  yearsOfExperience?: Maybe<Scalars['Int']['output']>
}

export type JobSeekerInfoInput = {
  aboutMe?: InputMaybe<Scalars['String']['input']>
  canStartNewJob?: InputMaybe<CanStartNewJobEnum>
  consideringOffers?: InputMaybe<Scalars['Boolean']['input']>
  currPrefRoles?: InputMaybe<Scalars['JSON']['input']>
  desiredPay?: InputMaybe<Scalars['Int']['input']>
  employStatus?: InputMaybe<Scalars['Boolean']['input']>
  hasFinishedOnboarding?: InputMaybe<Scalars['Boolean']['input']>
  jobLevel?: InputMaybe<Scalars['String']['input']>
  jobType?: InputMaybe<JobTypeEnum>
  jobTypePref?: InputMaybe<JobTypePrefEnum>
  locationsWillRelocate?: InputMaybe<Array<LocationsWillRelocateInput>>
  messageUserId?: InputMaybe<Scalars['String']['input']>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  payType?: InputMaybe<Scalars['String']['input']>
  searchStatus?: InputMaybe<Scalars['String']['input']>
  searchingJobs?: InputMaybe<Scalars['Boolean']['input']>
  teamSize?: InputMaybe<TeamSizeEnum>
  token?: InputMaybe<Scalars['String']['input']>
  tryingToRelocate?: InputMaybe<Scalars['String']['input']>
  willingToRelocate?: InputMaybe<Scalars['String']['input']>
  yearsInWorkforce?: InputMaybe<Scalars['Int']['input']>
  yearsOfExperience?: InputMaybe<Scalars['Int']['input']>
}

export type JobSeekerSkill = {
  __typename?: 'JobSeekerSkill'
  displayName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  jobSeekerSkillExperiences?: Maybe<Array<JobSeekerSkillExperience>>
  level?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  sequenceNumber?: Maybe<Scalars['Int']['output']>
  skill?: Maybe<Skill>
  yearsOfExp?: Maybe<Scalars['Int']['output']>
}

export type JobSeekerSkillExperience = {
  __typename?: 'JobSeekerSkillExperience'
  experience?: Maybe<Experience>
  id: Scalars['Int']['output']
  jobSeekerSkill?: Maybe<JobSeekerSkill>
}

export type JobSeekerSkillInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>
  yearsOfExp?: InputMaybe<Scalars['Int']['input']>
}

export type JobSeekerSkills = {
  __typename?: 'JobSeekerSkills'
  id: Scalars['Int']['output']
  level?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  sequenceNumber?: Maybe<Scalars['Int']['output']>
  yearsOfExp?: Maybe<Scalars['Int']['output']>
}

export enum JobStatusEnum {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
}

export enum JobTypeEnum {
  Contractor = 'CONTRACTOR',
  FullTime = 'FULL_TIME',
  Internship = 'INTERNSHIP',
  Other = 'OTHER',
  PartTime = 'PART_TIME',
  PerDiem = 'PER_DIEM',
  Seasonal = 'SEASONAL',
  Temporary = 'TEMPORARY',
}

export enum JobTypePrefEnum {
  EntirelyRemote = 'ENTIRELY_REMOTE',
  HybridRemote = 'HYBRID_REMOTE',
  InPerson = 'IN_PERSON',
}

export type KnockTokenResponse = {
  __typename?: 'KnockTokenResponse'
  token: Scalars['String']['output']
}

/** Language information */
export type Language = {
  __typename?: 'Language'
  name: Scalars['String']['output']
  proficiency?: Maybe<Scalars['String']['output']>
}

export type LastActivity = {
  from: Scalars['DateTime']['input']
  to: Scalars['DateTime']['input']
}

export type LastContactedRange = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type ListApplicationFormInput = {
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  companyOfficeId?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<SortDirection>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<ApplicationFormSortFields>
  sortDirection?: InputMaybe<SortDirection>
}

export type ListApplicationFormScreeningQuestionInput = {
  applicationFormId: Scalars['Int']['input']
  orderBy?: InputMaybe<SortDirection>
}

export type ListCandidateEmailsInput = {
  candidateProfileId: Scalars['Int']['input']
  primaryOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type ListCandidateLabelsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<CandidateLabelSortFields>
  sortDirection?: InputMaybe<SortDirection>
}

export type ListCandidateProfileLabelsInput = {
  candidateProfileId: Scalars['Int']['input']
}

export type ListCandidateTouchpointsInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<CandidateTouchpointSortFields>
  sortDirection?: InputMaybe<SortDirection>
}

export type ListCompanyCandidateTouchpointsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<Scalars['String']['input']>
  sortDirection?: InputMaybe<Scalars['String']['input']>
}

export type ListCompanyUserGroupsInput = {
  companyId: Scalars['Int']['input']
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>
}

export type ListCompanyUserViewsInput = {
  companyId: Scalars['Int']['input']
  companyUserId: Scalars['Int']['input']
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type ListConnectedEmailInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type ListCustomApplicationStatusInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<CustomApplicationStatusSortFields>
  sortDirection?: InputMaybe<SortDirection>
}

export type ListFieldTokensResponse = {
  __typename?: 'ListFieldTokensResponse'
  customTokens: Array<CompanyCustomFieldToken>
  defaultTokens: Array<DefaultToken>
}

export type ListGlobalScreeningQuestionInput = {
  isActiveGlobally?: InputMaybe<Scalars['Boolean']['input']>
  orderBy?: InputMaybe<SortDirection>
  showReplaced?: InputMaybe<Scalars['Boolean']['input']>
}

export type ListInvoices = {
  __typename?: 'ListInvoices'
  invoices: Array<Invoice>
  upcomingInvoices: Array<Invoice>
}

export type ListSavedViewsInput = {
  includeCompanyViews?: InputMaybe<Scalars['Boolean']['input']>
  includeTeamViews?: InputMaybe<Scalars['Boolean']['input']>
  isPinned?: InputMaybe<Scalars['Boolean']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
  viewLocation?: InputMaybe<CompanySavedViewLocationEnum>
  viewType?: InputMaybe<CompanySavedViewTypeEnum>
}

export type ListSourceTrackingLinksInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SourceTrackingLinkSortFields>
  sortDirection?: InputMaybe<SortDirection>
}

export type ListTemplateApprovalWorkflowsInput = {
  approvalWorkflowType: ApprovalWorkflowTypeEnum
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<TemplateApprovalWorkflowSortFields>
  sortDirection?: InputMaybe<SortDirection>
}

export type ListTemplateMessageInput = {
  id?: InputMaybe<Scalars['String']['input']>
  messageOwner?: InputMaybe<MessageOwnerEnum>
  messageType?: InputMaybe<MessageTypeEnum>
  search?: InputMaybe<Scalars['String']['input']>
}

export type ListTemplateScreeningQuestionInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<SortDirection>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<ScreeningQuestionSortFields>
  sortDirection?: InputMaybe<SortDirection>
}

export type LocationInputType = {
  city?: InputMaybe<Scalars['String']['input']>
  continent?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  region?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type LocationType = {
  __typename?: 'LocationType'
  city?: Maybe<Scalars['String']['output']>
  continent?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  region?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export enum LocationTypeEnum {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  Remote = 'REMOTE',
}

export type LocationsWillRelocateInput = {
  city?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type Logo = {
  __typename?: 'Logo'
  size: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type LogoUrl = {
  __typename?: 'LogoUrl'
  url: Scalars['String']['output']
}

export type ManageCandidateLabelsInput = {
  addLabelIds?: Array<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  removeLabelIds?: Array<Scalars['Int']['input']>
}

export type MarkDefaultSequenceScheduleSettingInput = {
  id: Scalars['Int']['input']
}

export type MatchScore = {
  max: Scalars['Int']['input']
  min: Scalars['Int']['input']
}

export type MergeCandidateLabelsInput = {
  sourceId: Scalars['Int']['input']
  targetId: Scalars['Int']['input']
}

export type MergeCandidateSourceNameInput = {
  sourceId: Scalars['Int']['input']
  targetId: Scalars['Int']['input']
}

export type MergeCustomApplicationStatusInput = {
  sourceId: Scalars['Int']['input']
  targetId: Scalars['Int']['input']
}

export type MergeCustomSourceCategoryInput = {
  sourceId: Scalars['Int']['input']
  targetId: Scalars['Int']['input']
}

export enum MessageOwnerEnum {
  Company = 'COMPANY',
  Personal = 'PERSONAL',
}

export enum MessageTypeEnum {
  AddSequenceStep = 'ADD_SEQUENCE_STEP',
  AdvanceCandidate = 'ADVANCE_CANDIDATE',
  AutoRejectCandidate = 'AUTO_REJECT_CANDIDATE',
  CandidateAvailabilityRequest = 'CANDIDATE_AVAILABILITY_REQUEST',
  CandidateEmailGeneric = 'CANDIDATE_EMAIL_GENERIC',
  CandidateInterviewConfirmation = 'CANDIDATE_INTERVIEW_CONFIRMATION',
  CandidateOffer = 'CANDIDATE_OFFER',
  CandidateOfferLetter = 'CANDIDATE_OFFER_LETTER',
  CandidateReferralReceipt = 'CANDIDATE_REFERRAL_RECEIPT',
  CandidateSelfScheduleRequest = 'CANDIDATE_SELF_SCHEDULE_REQUEST',
  Generic = 'GENERIC',
  InterviewerInvite = 'INTERVIEWER_INVITE',
  InviteToApply = 'INVITE_TO_APPLY',
  InviteToFillProfile = 'INVITE_TO_FILL_PROFILE',
  RejectCandidate = 'REJECT_CANDIDATE',
  ScorecardDue = 'SCORECARD_DUE',
  SendSchedulerLinkInvite = 'SEND_SCHEDULER_LINK_INVITE',
  TeamEmail = 'TEAM_EMAIL',
  ThankYouForApplying = 'THANK_YOU_FOR_APPLYING',
}

export type MoveCandidateBackStageInput = {
  candidateApplicationIds: Array<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  previousTemplateStageId: Scalars['Int']['input']
}

export type MoveCandidateToTalentPoolInput = {
  candidateProfileId: Scalars['Int']['input']
  currentTalentPoolId: Scalars['Int']['input']
  newTalentPoolId: Scalars['Int']['input']
}

export type Mutation = {
  __typename?: 'Mutation'
  ActivateCompanyUser: CompanyUser
  AddSavedView: Scalars['Boolean']['output']
  AddStepToSequence: SequenceStep
  AdvanceCandidateApplication: Array<CandidateApplication>
  AdvanceFromOfferToHired: CandidateApplication
  ApprovalWorkflowReviewerResponse: ApprovalWorkflowReviewerResponse
  ArchiveCustomCandidateApplicationField: CustomCandidateApplicationField
  ArchiveCustomCandidateProfileField: CustomCandidateProfileField
  ArchiveCustomJobRequisitionField?: Maybe<CustomJobRequisitionField>
  ArchiveInterviewTemplate?: Maybe<InterviewTemplate>
  ArchiveInterviewerPool?: Maybe<InterviewerPool>
  ArchiveOfferCustomField?: Maybe<OfferCustomField>
  ArchiveSequence: SequenceOperationResponse
  ArchiveTalentPool: TalentPool
  AssociateCustomFieldWithRequisition: AssociateCustomFieldWithRequisitionResponse
  BulkAddCandidatesToTalentPool: BulkTalentPoolOperationResponse
  BulkAddInterviewerPoolMember?: Maybe<InterviewerPool>
  BulkEnrollCandidatesInSequence: BulkSequenceOperationResponse
  BulkMoveCandidatesToTalentPool: BulkTalentPoolOperationResponse
  BulkRemoveCandidatesFromTalentPool: BulkTalentPoolOperationResponse
  BulkUnenrollCandidatesFromSequence: BulkSequenceOperationResponse
  BulkUpdateCandidatesProspectOwner: BulkTalentPoolOperationResponse
  BulkUpdateCandidatesProspectStatus: BulkTalentPoolOperationResponse
  BulkUpdateSequenceCandidateStatus: BulkSequenceOperationResponse
  CancelJobCampaign?: Maybe<CancelCampaignOutput>
  CancelScheduledReport: ScheduledReport
  CancelSubscription?: Maybe<UserSubscription>
  CandidateOfferVersionSignatureSendEmailReminder: Array<CandidateOfferVersionSignaturesSendEmailReminderResult>
  ChangePassword?: Maybe<ScalisUser>
  ClearEvents: Scalars['Boolean']['output']
  /** Complete an interview */
  CompleteInterview: CandidateInterview
  /** Get the provider auth URL */
  ConnectCalendar: ConnectCalendarOutput
  CountCampaignView?: Maybe<CountCampaignView>
  CreateAiSourcingEvent: Scalars['Boolean']['output']
  CreateAndAssignCandidateLabel?: Maybe<CandidateLabel>
  CreateApplicantNotes: ApplicantNotes
  CreateApprovalWorkflowInstance: ApprovalWorkflowInstanceResponse
  CreateApprovalWorkflowSettings?: Maybe<CompanyApprovalSetting>
  CreateBookmarkedJob: BookmarkedJob
  /** Create a calendar event */
  CreateCalendarEvent: CalendarEvent
  CreateCandidateApplicationFromEmployer: CandidateApplication
  CreateCandidateApplicationFromJobSeeker: CandidateApplication
  CreateCandidateFilter: CandidateFilter
  CreateCandidateLabel?: Maybe<CandidateLabel>
  CreateCandidateOfferFile: Array<CandidateOfferFile>
  CreateCandidateOfferRejection: CandidateOfferRejection
  CreateCandidateSource?: Maybe<CandidateSource>
  CreateCandidateSourceName: CandidateSourceName
  CreateCandidateTouchpointActivityLog?: Maybe<ActivityLog>
  CreateChatV2: ChatC2J
  CreateCompany: Company
  CreateCompanyCandidateTouchpoint?: Maybe<CompanyCandidateTouchpoint>
  CreateCompanyProvidedCandidateEmail: CompanyProvidedEmail
  CreateCompanyUserFromInvitation: CompanyUser
  CreateCompanyUserGroup: CompanyUserGroup
  CreateCustomApplicationStatus: CustomApplicationStatus
  CreateCustomCandidateApplicationField?: Maybe<CustomCandidateApplicationFieldOutput>
  CreateCustomCandidateApplicationFieldValue?: Maybe<CustomCandidateApplicationFieldValue>
  CreateCustomCandidateProfileField?: Maybe<CustomCandidateProfileFieldOutput>
  CreateCustomCandidateProfileFieldValue?: Maybe<CustomCandidateProfileFieldValue>
  CreateCustomJobRequisitionField?: Maybe<CustomJobRequisitionField>
  CreateCustomJobRequisitionFieldValue?: Maybe<CustomJobRequisitionFieldValue>
  CreateCustomSourceCategory?: Maybe<CustomSourceCategory>
  CreateCustomStatusAndEditApplicationStatus: Array<CandidateApplication>
  CreateDocumentTemplate: OfferDocumentTemplate
  CreateFavoriteReport: FavoriteCoreReport
  CreateFavoriteSequence?: Maybe<Sequence>
  CreateFavoriteTalentPool?: Maybe<TalentPool>
  /** Schedule an interview for a candidate */
  CreateInterview: CandidateInterview
  CreateInterviewTemplate?: Maybe<InterviewTemplate>
  CreateInterviewerPool?: Maybe<InterviewerPool>
  CreateJobSearchPreference: JobSearchPreference
  /** @deprecated Use SignUp mutation instead */
  CreateJobSeekerAccount: ScalisUser
  CreateNotificationSetting: NotificationSetting
  CreateSavedView: CreateSavedViewResponse
  CreateScalisUserUploadedDocument?: Maybe<CreateScalisUserUploadedDocumentOutput>
  /** Create scheduler link invite */
  CreateSchedulerLinkInvite: Scalars['Boolean']['output']
  /** Create scheduler link settings */
  CreateSchedulerLinkSession: SchedulerLinkSessionOutput
  /** Create scheduler link settings */
  CreateSchedulerLinkSettings: SchedulerLinkSettings
  CreateSequence: Sequence
  CreateSequenceScheduleSetting: SequenceScheduleSetting
  CreateSequenceSetting: SequenceSetting
  CreateSharedReport: SharedCoreReport
  CreateSourceTrackingEvent: Scalars['Boolean']['output']
  CreateSourceTrackingLink?: Maybe<SourceTrackingLink>
  CreateTalentPool: TalentPool
  CreateTalentPoolProspectStatus: TalentPoolProspectStatus
  CreateTemplateApprovalWorkflow?: Maybe<TemplateApprovalWorkflow>
  CreateTemplateScreeningQuestion: ScreeningQuestion
  CreateUploadedCandidate: UploadedCandidate
  CreateUploadedDocument?: Maybe<UploadedDocument>
  CreateUploadedDocumentCandidateApplication?: Maybe<UploadedDocumentCandidateApplication>
  CreateUploadedDocumentCandidateProfile?: Maybe<UploadedDocumentCandidateProfile>
  CreateUsersInCompanyUserGroup: CompanyUserGroup
  DeleteAchievement: Scalars['Boolean']['output']
  DeleteApplicantNotes: ApplicantNotes
  DeleteApplicationForm: ApplicationForm
  DeleteApplicationFormScreeningQuestion: ApplicationFormScreeningQuestion
  DeleteBookmarkedJob: BookmarkedJob
  DeleteCalendarEvent?: Maybe<CalendarSettings>
  DeleteCandidateApplication: CandidateApplication
  DeleteCandidateApplicationFromRequisition: DeleteCandidateApplicationFromRequisitionResponse
  DeleteCandidateApplicationNote: CandidateApplicationNote
  DeleteCandidateCollaborator: CandidateCollaborator
  DeleteCandidateFilter: CandidateFilter
  DeleteCandidateLabel?: Maybe<CandidateLabel>
  DeleteCandidateMedalistDesignation: CandidateMedalistDesignation
  DeleteCandidateMessage: CandidateMessage
  DeleteCandidateOffer: CandidateOffer
  DeleteCandidateOfferCustomField: CandidateOfferCustomField
  DeleteCandidateOfferFile: CandidateOfferFile
  DeleteCandidateOfferVersion: CandidateOfferVersion
  DeleteCandidateProfile: BulkSequenceOperationResponse
  DeleteCandidateProfileLocation: CandidateProfileLocation
  DeleteCandidateProfileNote: CandidateProfileNote
  DeleteCandidateScorecard?: Maybe<CandidateScorecard>
  DeleteCandidateSource: CandidateSource
  DeleteCandidateSourceName?: Maybe<CandidateSourceName>
  DeleteCandidateTouchpointActivityLog: Scalars['Boolean']['output']
  DeleteCertificateOrLicense: Scalars['Boolean']['output']
  DeleteCompanyCandidateTouchpoint?: Maybe<CompanyCandidateTouchpoint>
  DeleteCompanyDepartment: CompanyDepartment
  DeleteCompanyOffice: CompanyOffice
  DeleteCompanyProvidedCandidateEmail: Scalars['Boolean']['output']
  DeleteCompanyUserFromWorkspace: CompanyUser
  DeleteCompanyUserGroup: CompanyUserGroup
  DeleteCustomApplicationStatus: DeleteCustomApplicationStatusResponse
  DeleteCustomCandidateApplicationField: DeleteCustomCandidateApplicationFieldResponse
  DeleteCustomCandidateApplicationFieldValue?: Maybe<DeleteCustomCandidateApplicationFieldValueResponse>
  DeleteCustomCandidateProfileField: DeleteCustomCandidateProfileFieldResponse
  DeleteCustomCandidateProfileFieldValue?: Maybe<DeleteCustomCandidateProfileFieldValueResponse>
  DeleteCustomJobRequisitionField?: Maybe<DeleteCustomJobRequisitionFieldResponse>
  DeleteCustomSourceCategory?: Maybe<CustomSourceCategory>
  DeleteEducation: Scalars['Boolean']['output']
  DeleteExperience: Scalars['Boolean']['output']
  DeleteExternalJobApplication: DeleteExternalJobApplicationResponse
  DeleteFavoriteReport: FavoriteCoreReport
  DeleteFavoriteSequence?: Maybe<Sequence>
  DeleteFavoriteTalentPool?: Maybe<TalentPool>
  DeleteGlobalScreeningQuestion: ScreeningQuestion
  DeleteHiringTeamMember: HiringTeamMember
  /** Delete a scheduled interview */
  DeleteInterview: Scalars['Boolean']['output']
  DeleteInterviewTeam: InterviewTeam
  DeleteInterviewTemplate: InterviewTemplate
  DeleteInvitationFromWorkspace: UserInvitation
  DeleteJobListing: JobListing
  DeleteJobListingScreeningQuestion: JobListingScreeningQuestion
  DeleteJobOpening: JobOpening
  DeleteJobSeekerSkill: Scalars['Boolean']['output']
  DeleteNotificationSetting: NotificationSetting
  DeleteOfferCustomField: OfferCustomField
  DeleteOfferDocumentTemplate: OfferDocumentTemplate
  DeleteOfferDocumentTemplateSection: OfferDocumentTemplateSection
  DeleteOfferSectionTemplate: OfferSectionTemplate
  DeleteOfferTemplateCondition: OfferTemplateCondition
  DeleteRequisition: Requisition
  DeleteRequisitionJobDescription: RequisitionJobDescription
  DeleteRequisitionSkill: RequisitionSkill
  DeleteSavedView: DeleteSavedViewResponse
  /** Delete profile image of the current user */
  DeleteScalisUserProfileImage: ScalisUser
  DeleteScalisUserUploadedDocument?: Maybe<DeleteScalisUserUploadedDocumentOutput>
  /** Delete scheduler link invite */
  DeleteSchedulerLinkInvite: Scalars['Boolean']['output']
  /** Delete scheduler link settings */
  DeleteSchedulerLinkSettings: SchedulerLinkSettings
  DeleteScorecardTemplate: ScorecardTemplate
  DeleteScorecardTemplateQuestion: ScorecardTemplateQuestion
  DeleteScorecardTemplateSection: ScorecardTemplateSection
  DeleteScreeningQuestion: ScreeningQuestion
  DeleteSequence: SequenceOperationResponse
  DeleteSequenceScheduleSetting: SequenceOperationResponse
  DeleteSequenceStep: Scalars['Boolean']['output']
  DeleteSharedReport: Scalars['Boolean']['output']
  DeleteSkill: Array<Scalars['Boolean']['output']>
  DeleteSourceTrackingLink?: Maybe<SourceTrackingLink>
  DeleteStageCollaborator: StageCollaborator
  DeleteStageSettings: StageSettings
  DeleteTalentPool: DeleteTalentPoolResponse
  DeleteTalentPoolProspectStatus: TalentPoolProspectStatus
  DeleteTemplateApprovalWorkflow?: Maybe<TemplateApprovalWorkflow>
  DeleteTemplateJobDescription: TemplateJobDescription
  DeleteTemplateMessage: TemplateMessage
  DeleteTemplateMilestone: TemplateMilestone
  DeleteTemplatePipeline: TemplatePipeline
  DeleteTemplateStage: TemplateStage
  DeleteTokenTestResult: TokenTestResult
  DeleteUploadedDocument: UploadedDocument
  DeleteUploadedDocumentCandidateApplication: UploadedDocumentCandidateApplication
  DeleteUploadedDocumentCandidateProfile: UploadedDocumentCandidateProfile
  DeleteUsersFromCompanyUserGroup: CompanyUserGroup
  DeleteVolunteerWork: Scalars['Boolean']['output']
  DisableUserAccount?: Maybe<ScalisUser>
  DiscardCandidateRecommendation: Array<DiscardedCandidateRecommendation>
  /** Delete the Nylas Account associated with the provided email and destroys the grantId on Nylas */
  DisconnectCalendar: DisconnectCalendarOutput
  /** Delete the Nylas Account associated with the provided email and destroys the grantId on Nylas */
  DisconnectConnectedEmail?: Maybe<DisconnectConnectedEmailOutput>
  DownloadDocumentTemplate: DownloadDocumentTemplateOutput
  DuplicateTalentPool: DuplicateTalentPoolResponse
  EditApprovalWorkflowInstance: ApprovalWorkflowInstanceResponse
  EditApprovalWorkflowSettings?: Maybe<CompanyApprovalSetting>
  /** Edit a calendar event */
  EditCalendarEvent: CalendarEvent
  EditCalendarSettings: CalendarSettings
  EditCandidateApplicationStatus: Array<CandidateApplication>
  EditCandidateLabel?: Maybe<CandidateLabel>
  EditCandidateSourceName?: Maybe<CandidateSourceName>
  EditCandidateTouchpointActivityLog?: Maybe<ActivityLog>
  EditCompanyCandidateTouchpoint?: Maybe<CompanyCandidateTouchpoint>
  EditCompanyProvidedCandidateEmail: CompanyProvidedEmail
  EditCompanyUserViewOrder?: Maybe<Array<CompanyUserView>>
  EditConnectedEmail?: Maybe<ConnectedEmail>
  EditCustomApplicationStatus: CustomApplicationStatus
  EditCustomCandidateApplicationField?: Maybe<CustomCandidateApplicationFieldOutput>
  EditCustomCandidateProfileField?: Maybe<CustomCandidateProfileFieldOutput>
  EditCustomJobRequisitionField?: Maybe<CustomJobRequisitionField>
  EditCustomJobRequisitionFieldValue?: Maybe<CustomJobRequisitionFieldValue>
  EditCustomSourceCategory?: Maybe<CustomSourceCategory>
  EditGlobalScreeningQuestion?: Maybe<ScreeningQuestion>
  EditSavedView?: Maybe<RequisitionTalentPoolCompanySavedView>
  EditSourceTrackingLink?: Maybe<SourceTrackingLink>
  EditTalentPool: TalentPool
  EditTalentPoolProspectStatus: TalentPoolProspectStatus
  EditTemplateApprovalWorkflow?: Maybe<TemplateApprovalWorkflow>
  /** Exchange a Email Nylas code for an access token and update ConnectedEmailSettings */
  ExchangeConnectedEmailToken?: Maybe<ConnectedEmailSettings>
  /** Exchange a Nylas code for an access token and update CalendarSettings */
  ExchangeNylasToken: CalendarSettings
  ExchangeWebSocketToken: Scalars['String']['output']
  ExtractSocialProfile: UploadedCandidate
  GenerateFilesFromHtml?: Maybe<GenerateFilesFromHtmlOutput>
  GenerateKnockToken: KnockTokenResponse
  /** Get the provider auth URL */
  GetConnectedEmailAuthUrl: GetConnectedEmailAuthUrlOutputType
  GetEvents: EventsResponse
  HtmlToBase64?: Maybe<HtmlToBase64Output>
  HtmlToDocx?: Maybe<HtmlToDocxOutput>
  IdentifyKnockUser: IdentifyKnockUserResponse
  InsertGlobalScreeningQuestion?: Maybe<Array<Maybe<ScreeningQuestion>>>
  InviteCandidatesToApply?: Maybe<InviteCandidatesToApplyOutput>
  InviteUser: Array<UserInvitation>
  ManageCandidateLabels?: Maybe<Array<CandidateLabel>>
  MarkDefaultSequenceScheduleSetting: SequenceScheduleSetting
  MergeCandidateLabels?: Maybe<CandidateLabel>
  MergeCandidateSourceName?: Maybe<CandidateSourceName>
  MergeCustomApplicationStatus: CustomApplicationStatus
  MergeCustomSourceCategory?: Maybe<CustomSourceCategory>
  MoveCandidateBackStage?: Maybe<Array<CandidateApplication>>
  OrderJobCampaign?: Maybe<JobCampaignCreationOrCampaignErrors>
  ParseResumeBasicInfo: ParsedResumeData
  PauseSequence: SequenceOperationResponse
  PinSavedView?: Maybe<RequisitionTalentPoolCompanySavedView>
  ProcessAutoRejectCandidates: Scalars['String']['output']
  ProcessBulkRejectCandidatesNextBatch: BulkRejectCandidatesResponse
  ProcessRejectCandidates: RejectCandidatesResponse
  PublishEvent: Scalars['Boolean']['output']
  PurchaseAiCredits: AiCreditPurchaseResponse
  QueueuBulkRejectCandidates: Scalars['Boolean']['output']
  RejectCandidates: RejectCandidatesResponse
  RemoveInterviewerPoolMember?: Maybe<InterviewerPool>
  RemoveSavedView: RemoveSavedViewResponse
  RemoveSkillFromExperience: Scalars['Boolean']['output']
  ResendEmailVerification: ScalisUser
  ResendResetPasswordEmail: Array<EmailVerification>
  /** Resend scheduler link invite */
  ResendSchedulerLinkInvite: Scalars['Boolean']['output']
  ResetPassword?: Maybe<ScalisUser>
  ResolveDuplicateApplications: Scalars['Boolean']['output']
  ResumeSequence: SequenceOperationResponse
  ScheduleReport: ScheduledReport
  SelectRecommendedCandidate?: Maybe<Array<CandidateProfile>>
  SendCandidateOffer: Scalars['Boolean']['output']
  SendCandidateScorecard: CandidateScorecard
  SendCandidatesToSourcingStage?: Maybe<SendCandidatesToSourcingStageOutput>
  SendConnectedEmail?: Maybe<ConnectedEmail>
  SendEmailForSequenceStep: SendEmailForSequenceStepResponse
  SendEmailToCandidateProfile: Scalars['Boolean']['output']
  SendJobListing: SendJobListingResult
  SendReminderCandidateScorecard: CandidateScorecard
  SendResetPasswordEmail: Array<EmailVerification>
  SignUp: ScalisUser
  StartCandidateApplication: CandidateApplicationStatus
  Subscribe?: Maybe<ScalisSubscription>
  SwapRequisitionPipeline?: Maybe<JobPipeline>
  /** Fetch all events from the calendar within a 6 months range */
  SyncCalendar: CalendarSettings
  /** Fetch all events from company calendars of all users within a 6 months range */
  SyncCompanyUsersCalendars: SyncCompanyUsersCalendarsOutput
  ToggleScorecardTemplateArchive?: Maybe<ScorecardTemplate>
  ToggleTemplateApprovalWorkflowStatus?: Maybe<TemplateApprovalWorkflow>
  UnarchiveCustomCandidateApplicationField: CustomCandidateApplicationField
  UnarchiveCustomCandidateProfileField: CustomCandidateProfileField
  UnarchiveCustomJobRequisitionField?: Maybe<CustomJobRequisitionField>
  UnarchiveInterviewTemplate?: Maybe<InterviewTemplate>
  UnarchiveInterviewerPool?: Maybe<InterviewerPool>
  UnarchiveOfferCustomField?: Maybe<OfferCustomField>
  UnarchiveSequence: SequenceOperationResponse
  UnarchiveTalentPool: TalentPool
  UndoHire: CandidateApplication
  UndoOfferCandidateDeclined: CandidateOfferVersion
  UndoRejectCandidates: Scalars['Boolean']['output']
  UnpinSavedView?: Maybe<RequisitionTalentPoolCompanySavedView>
  UnsubscribeCandidateFromSequence: UnsubscribeCandidateFromEmailsResponse
  UpdateCandidateFilter: CandidateFilter
  UpdateCandidateOfferVersionStatus: CandidateOfferVersion
  UpdateCompanyData: Company
  UpdateCompanyUserGroup: CompanyUserGroup
  UpdateCompanyUserRole: CompanyUser
  UpdateCompanyUserViewOrder?: Maybe<Scalars['Boolean']['output']>
  /** Update connected email settings */
  UpdateConnectedEmailSettings?: Maybe<ConnectedEmailSettings>
  UpdateCustomCandidateApplicationFieldValue?: Maybe<CustomCandidateApplicationFieldValue>
  UpdateCustomCandidateProfileFieldValue?: Maybe<CustomCandidateProfileFieldValue>
  UpdateDocumentTemplate: OfferDocumentTemplate
  /** Update a scheduled interview */
  UpdateInterview: CandidateInterview
  UpdateInterviewTemplate: InterviewTemplate
  UpdateInterviewerPool?: Maybe<InterviewerPool>
  UpdateJobInvite: JobInvite
  UpdateJobSearchPreference: JobSearchPreference
  UpdateNotificationSetting: NotificationSetting
  UpdateScalisUserData: ScalisUser
  UpdateScheduledReport: ScheduledReport
  /** Update scheduler link invite */
  UpdateSchedulerLinkInvite: Scalars['Boolean']['output']
  /** Update scheduler link settings */
  UpdateSchedulerLinkSettings: SchedulerLinkSettings
  UpdateSequence: Sequence
  UpdateSequenceScheduleSetting: SequenceScheduleSetting
  UpdateSequenceSetting: SequenceSetting
  UpdateSequenceStep: SequenceStep
  UpdateUsersInCompanyUserGroup: CompanyUserGroup
  UploadS3File?: Maybe<UploadS3FileOutput>
  UpsertAddress?: Maybe<Address>
  UpsertApplicationForm?: Maybe<ApplicationForm>
  UpsertApplicationFormScreeningQuestion?: Maybe<ApplicationFormScreeningQuestion>
  UpsertCandidateApplicationNote?: Maybe<CandidateApplicationNote>
  UpsertCandidateApplicationRating?: Maybe<CandidateApplicationRating>
  UpsertCandidateCollaborator?: Maybe<CandidateCollaborator>
  UpsertCandidateMessage?: Maybe<CandidateMessage>
  UpsertCandidateOffer?: Maybe<CandidateOffer>
  UpsertCandidateOfferCustomField?: Maybe<CandidateOfferCustomField>
  UpsertCandidateOfferFile?: Maybe<CandidateOfferFile>
  UpsertCandidateOfferVersion?: Maybe<CandidateOfferVersion>
  UpsertCandidatePrimaryEmail: CandidateProfile
  UpsertCandidateProfile?: Maybe<CandidateProfile>
  UpsertCandidateProfileNote: CandidateProfileNote
  UpsertCandidateScorecard?: Maybe<CandidateScorecard>
  UpsertCandidateScorecardAnswers?: Maybe<CandidateScorecardAnswers>
  UpsertEmail: ScalisUser
  UpsertExperienceSkill?: Maybe<Array<JobSeekerSkill>>
  UpsertExternalJobApplication: ExternalJobApplication
  UpsertHiringTeamMember?: Maybe<HiringTeamMember>
  UpsertJobListing?: Maybe<JobListing>
  UpsertJobListingScreeningQuestion?: Maybe<JobListingScreeningQuestion>
  UpsertJobOpening?: Maybe<JobOpening>
  UpsertJobPipeline?: Maybe<JobPipeline>
  UpsertOfferCustomField?: Maybe<OfferCustomField>
  UpsertOfferDocumentTemplate?: Maybe<OfferDocumentTemplate>
  UpsertOfferDocumentTemplateSection?: Maybe<OfferDocumentTemplateSection>
  UpsertOfferSectionTemplate?: Maybe<OfferSectionTemplate>
  UpsertOfferTemplateCondition?: Maybe<Array<Maybe<OfferTemplateCondition>>>
  UpsertRequisition?: Maybe<Requisition>
  UpsertRequisitionJobDescription?: Maybe<RequisitionJobDescription>
  UpsertRequisitionSkill?: Maybe<RequisitionSkill>
  UpsertScorecardTemplate?: Maybe<ScorecardTemplate>
  UpsertScreeningQuestion?: Maybe<ScreeningQuestion>
  UpsertSkill?: Maybe<Array<Skill>>
  UpsertStageCollaborator?: Maybe<StageCollaborator>
  UpsertStageSettings?: Maybe<StageSettings>
  UpsertTemplateJobDescription?: Maybe<TemplateJobDescription>
  UpsertTemplateMessage?: Maybe<TemplateMessage>
  UpsertTemplateMilestone?: Maybe<TemplateMilestone>
  UpsertTemplatePipeline?: Maybe<TemplatePipeline>
  UpsertTemplateStage?: Maybe<TemplateStage>
  UpsertTokenTestResult?: Maybe<TokenTestResult>
  ValidateOfferDocumentTemplate: OfferDocumentTemplate
  ValidateOfferSectionTemplate: OfferSectionTemplate
  VerifyEmailCode: ScalisUser
  VerifyPasswordCode: ScalisUser
  deleteTemplateScreeningQuestion: ScreeningQuestion
  editTemplateScreeningQuestion: ScreeningQuestion
  upsertGlobalListingSetup?: Maybe<GlobalListingSetup>
}

export type MutationActivateCompanyUserArgs = {
  input: ActivateCompanyUserInput
}

export type MutationAddSavedViewArgs = {
  input: AddSavedViewInput
}

export type MutationAddStepToSequenceArgs = {
  input: CreateSequenceStepInput
  sequenceId: Scalars['String']['input']
}

export type MutationAdvanceCandidateApplicationArgs = {
  input: AdvanceCandidateApplicationInput
}

export type MutationAdvanceFromOfferToHiredArgs = {
  input: AdvanceFromOfferToHiredInput
}

export type MutationApprovalWorkflowReviewerResponseArgs = {
  input: ApprovalWorkflowReviewerResponseInput
}

export type MutationArchiveCustomCandidateApplicationFieldArgs = {
  input: ArchiveCustomCandidateApplicationFieldInput
}

export type MutationArchiveCustomCandidateProfileFieldArgs = {
  input: ArchiveCustomCandidateProfileFieldInput
}

export type MutationArchiveCustomJobRequisitionFieldArgs = {
  input: ArchiveCustomJobRequisitionFieldInput
}

export type MutationArchiveInterviewTemplateArgs = {
  input: ArchiveInterviewTemplateInput
}

export type MutationArchiveInterviewerPoolArgs = {
  input: ArchiveInterviewerPoolInput
}

export type MutationArchiveOfferCustomFieldArgs = {
  input: ArchiveOfferCustomFieldInput
}

export type MutationArchiveSequenceArgs = {
  input: ArchiveSequenceInput
}

export type MutationArchiveTalentPoolArgs = {
  input: ArchiveTalentPoolInput
}

export type MutationAssociateCustomFieldWithRequisitionArgs = {
  input: AssociateCustomFieldWithRequisitionInput
}

export type MutationBulkAddCandidatesToTalentPoolArgs = {
  input: BulkAddCandidatesToTalentPoolInput
}

export type MutationBulkAddInterviewerPoolMemberArgs = {
  input: BulkAddInterviewerPoolMemberInput
}

export type MutationBulkEnrollCandidatesInSequenceArgs = {
  input: BulkEnrollCandidatesInSequenceInput
}

export type MutationBulkMoveCandidatesToTalentPoolArgs = {
  input: BulkMoveCandidatesToTalentPoolInput
}

export type MutationBulkRemoveCandidatesFromTalentPoolArgs = {
  input: BulkRemoveCandidatesFromTalentPoolInput
}

export type MutationBulkUnenrollCandidatesFromSequenceArgs = {
  input: BulkUnenrollCandidatesFromSequenceInput
}

export type MutationBulkUpdateCandidatesProspectOwnerArgs = {
  input: BulkUpdateCandidatesProspectOwnerInput
}

export type MutationBulkUpdateCandidatesProspectStatusArgs = {
  input: BulkUpdateCandidatesProspectStatusInput
}

export type MutationBulkUpdateSequenceCandidateStatusArgs = {
  input: BulkUpdateSequenceCandidateStatusInput
}

export type MutationCancelJobCampaignArgs = {
  input: CancelCampaignInput
}

export type MutationCancelScheduledReportArgs = {
  input: CancelScheduledReportInput
}

export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput
}

export type MutationCandidateOfferVersionSignatureSendEmailReminderArgs = {
  input: CandidateOfferVersionSignatureSendReminderInput
}

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput
}

export type MutationCompleteInterviewArgs = {
  input: CompleteInterviewInput
}

export type MutationConnectCalendarArgs = {
  input: ConnectCalendarInput
}

export type MutationCountCampaignViewArgs = {
  input: CountCampaignViewInput
}

export type MutationCreateAiSourcingEventArgs = {
  input: CreateAiSourcingEventInput
}

export type MutationCreateAndAssignCandidateLabelArgs = {
  input: CreateAndAssignCandidateLabelInput
}

export type MutationCreateApplicantNotesArgs = {
  input: CreateApplicantNotesInput
}

export type MutationCreateApprovalWorkflowInstanceArgs = {
  input: CreateApprovalWorkflowInstanceInput
}

export type MutationCreateApprovalWorkflowSettingsArgs = {
  input: CreateApprovalWorkflowSettingsInput
}

export type MutationCreateBookmarkedJobArgs = {
  input: CreateBookmarkedJobInput
}

export type MutationCreateCalendarEventArgs = {
  input: CreateCalendarEventInput
}

export type MutationCreateCandidateApplicationFromEmployerArgs = {
  input: CreateCandidateApplicationFromEmployerInput
}

export type MutationCreateCandidateApplicationFromJobSeekerArgs = {
  input: CreateCandidateApplicationFromJobSeekerInput
}

export type MutationCreateCandidateFilterArgs = {
  input: CreateCandidateFilterInput
}

export type MutationCreateCandidateLabelArgs = {
  input: CreateCandidateLabelInput
}

export type MutationCreateCandidateOfferFileArgs = {
  input: CreateCandidateOfferFileInput
}

export type MutationCreateCandidateOfferRejectionArgs = {
  input: CreateCandidateOfferRejectionInput
}

export type MutationCreateCandidateSourceArgs = {
  input: CandidateSourceInput
}

export type MutationCreateCandidateSourceNameArgs = {
  input: CandidateSourceNameCreateInput
}

export type MutationCreateCandidateTouchpointActivityLogArgs = {
  input: CreateTouchpointActivityLogInput
}

export type MutationCreateChatV2Args = {
  input: CreateChatV2Input
}

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput
}

export type MutationCreateCompanyCandidateTouchpointArgs = {
  input: CreateCompanyCandidateTouchpointInput
}

export type MutationCreateCompanyProvidedCandidateEmailArgs = {
  input: CreateCompanyProvidedEmailInput
}

export type MutationCreateCompanyUserFromInvitationArgs = {
  input: CreateCompanyUserFromInvitationInput
}

export type MutationCreateCompanyUserGroupArgs = {
  input: CreateCompanyUserGroupInput
}

export type MutationCreateCustomApplicationStatusArgs = {
  input: CreateCustomApplicationStatusInput
}

export type MutationCreateCustomCandidateApplicationFieldArgs = {
  input: CreateCustomCandidateApplicationFieldInput
}

export type MutationCreateCustomCandidateApplicationFieldValueArgs = {
  input: CreateCustomCandidateApplicationFieldValueInput
}

export type MutationCreateCustomCandidateProfileFieldArgs = {
  input: CreateCustomCandidateProfileFieldInput
}

export type MutationCreateCustomCandidateProfileFieldValueArgs = {
  input: CreateCustomCandidateProfileFieldValueInput
}

export type MutationCreateCustomJobRequisitionFieldArgs = {
  input: CreateCustomJobRequisitionFieldInput
}

export type MutationCreateCustomJobRequisitionFieldValueArgs = {
  input: CreateCustomJobRequisitionFieldValueInput
}

export type MutationCreateCustomSourceCategoryArgs = {
  input: CreateCustomSourceCategoryInput
}

export type MutationCreateCustomStatusAndEditApplicationStatusArgs = {
  input: CreateCustomStatusAndEditApplicationStatusInput
}

export type MutationCreateDocumentTemplateArgs = {
  input: CreateDocumentTemplateInput
}

export type MutationCreateFavoriteReportArgs = {
  input: FavoriteReportInput
}

export type MutationCreateFavoriteSequenceArgs = {
  input: CreateFavoriteSequenceInput
}

export type MutationCreateFavoriteTalentPoolArgs = {
  input: CreateFavoriteTalentPoolInput
}

export type MutationCreateInterviewArgs = {
  input: CreateInterviewInput
}

export type MutationCreateInterviewTemplateArgs = {
  input: CreateInterviewTemplateInput
}

export type MutationCreateInterviewerPoolArgs = {
  input: CreateInterviewerPoolInput
}

export type MutationCreateJobSearchPreferenceArgs = {
  input: CreateJobSearchPreferenceInput
}

export type MutationCreateJobSeekerAccountArgs = {
  input: CreateJobSeekerAccountInput
}

export type MutationCreateNotificationSettingArgs = {
  input: CreateNotificationSettingInput
}

export type MutationCreateSavedViewArgs = {
  input: CreateSavedViewInput
}

export type MutationCreateScalisUserUploadedDocumentArgs = {
  input: CreateScalisUserUploadedDocumentInput
}

export type MutationCreateSchedulerLinkInviteArgs = {
  input: CreateSchedulerLinkInviteInput
}

export type MutationCreateSchedulerLinkSessionArgs = {
  input: CreateSchedulerLinkSessionInput
}

export type MutationCreateSchedulerLinkSettingsArgs = {
  input: CreateSchedulerLinkSettingsInput
}

export type MutationCreateSequenceArgs = {
  input: CreateSequenceInput
}

export type MutationCreateSequenceScheduleSettingArgs = {
  input: CreateSequenceScheduleSettingInput
}

export type MutationCreateSequenceSettingArgs = {
  input: CreateSequenceSettingInput
}

export type MutationCreateSharedReportArgs = {
  input: SharedReportInput
}

export type MutationCreateSourceTrackingEventArgs = {
  input: CreateSourceTrackingEventInput
}

export type MutationCreateSourceTrackingLinkArgs = {
  input: CreateSourceTrackingLinkInput
}

export type MutationCreateTalentPoolArgs = {
  input: CreateTalentPoolInput
}

export type MutationCreateTalentPoolProspectStatusArgs = {
  input: CreateTalentPoolProspectStatusInput
}

export type MutationCreateTemplateApprovalWorkflowArgs = {
  input: CreateTemplateApprovalWorkflowInput
}

export type MutationCreateTemplateScreeningQuestionArgs = {
  input: CreateTemplateScreeningQuestionInput
}

export type MutationCreateUploadedCandidateArgs = {
  input: CreateUploadedCandidateInput
}

export type MutationCreateUploadedDocumentArgs = {
  input: CreateUploadedDocumentInput
}

export type MutationCreateUploadedDocumentCandidateApplicationArgs = {
  input: CreateUploadedDocumentCandidateApplicationInput
}

export type MutationCreateUploadedDocumentCandidateProfileArgs = {
  input: CreateUploadedDocumentCandidateProfileInput
}

export type MutationCreateUsersInCompanyUserGroupArgs = {
  input: CreateUsersInCompanyUserGroupInput
}

export type MutationDeleteAchievementArgs = {
  input: DeleteAchievementInput
}

export type MutationDeleteApplicantNotesArgs = {
  input: DeleteApplicantNotesInput
}

export type MutationDeleteApplicationFormArgs = {
  input: DeleteApplicationFormInput
}

export type MutationDeleteApplicationFormScreeningQuestionArgs = {
  input: DeleteApplicationFormScreeningQuestionInput
}

export type MutationDeleteBookmarkedJobArgs = {
  input: DeleteBookmarkedJobInput
}

export type MutationDeleteCalendarEventArgs = {
  input: DeleteCalendarEventInput
}

export type MutationDeleteCandidateApplicationArgs = {
  input: DeleteCandidateApplicationInput
}

export type MutationDeleteCandidateApplicationFromRequisitionArgs = {
  input: DeleteCandidateApplicationFromRequisitionInput
}

export type MutationDeleteCandidateApplicationNoteArgs = {
  input: DeleteCandidateApplicationNoteInput
}

export type MutationDeleteCandidateCollaboratorArgs = {
  input: DeleteCandidateCollaboratorInput
}

export type MutationDeleteCandidateFilterArgs = {
  input: DeleteCandidateFilterInput
}

export type MutationDeleteCandidateLabelArgs = {
  input: DeleteCandidateLabelInput
}

export type MutationDeleteCandidateMedalistDesignationArgs = {
  input: DeleteCandidateMedalistDesignationInput
}

export type MutationDeleteCandidateMessageArgs = {
  input: DeleteCandidateMessageInput
}

export type MutationDeleteCandidateOfferArgs = {
  input: DeleteCandidateOfferInput
}

export type MutationDeleteCandidateOfferCustomFieldArgs = {
  input: DeleteCandidateOfferCustomFieldInput
}

export type MutationDeleteCandidateOfferFileArgs = {
  input: DeleteCandidateOfferFileInput
}

export type MutationDeleteCandidateOfferVersionArgs = {
  input: DeleteCandidateOfferVersionInput
}

export type MutationDeleteCandidateProfileArgs = {
  input: DeleteCandidateProfileInput
}

export type MutationDeleteCandidateProfileLocationArgs = {
  input: DeleteCandidateProfileLocationInput
}

export type MutationDeleteCandidateProfileNoteArgs = {
  input: DeleteCandidateProfileNoteInput
}

export type MutationDeleteCandidateScorecardArgs = {
  input: DeleteCandidateScorecardInput
}

export type MutationDeleteCandidateSourceArgs = {
  input: DeleteCandidateSourceInput
}

export type MutationDeleteCandidateSourceNameArgs = {
  input: DeleteCandidateSourceNameInput
}

export type MutationDeleteCandidateTouchpointActivityLogArgs = {
  input: DeleteCandidateTouchpointActivityLogInput
}

export type MutationDeleteCertificateOrLicenseArgs = {
  input: DeleteCertificateOrLicenseInput
}

export type MutationDeleteCompanyCandidateTouchpointArgs = {
  input: DeleteCompanyCandidateTouchpointInput
}

export type MutationDeleteCompanyDepartmentArgs = {
  input: DeleteCompanyDepartmentInput
}

export type MutationDeleteCompanyOfficeArgs = {
  input: DeleteCompanyOfficeInput
}

export type MutationDeleteCompanyProvidedCandidateEmailArgs = {
  input: DeleteCompanyProvidedEmailInput
}

export type MutationDeleteCompanyUserFromWorkspaceArgs = {
  input: DeleteCompanyUserFromWorkspaceInput
}

export type MutationDeleteCompanyUserGroupArgs = {
  input: DeleteCompanyUserGroupInput
}

export type MutationDeleteCustomApplicationStatusArgs = {
  input: DeleteCustomApplicationStatusInput
}

export type MutationDeleteCustomCandidateApplicationFieldArgs = {
  input: DeleteCustomCandidateApplicationFieldInput
}

export type MutationDeleteCustomCandidateApplicationFieldValueArgs = {
  input: DeleteCustomCandidateApplicationFieldValueInput
}

export type MutationDeleteCustomCandidateProfileFieldArgs = {
  input: DeleteCustomCandidateProfileFieldInput
}

export type MutationDeleteCustomCandidateProfileFieldValueArgs = {
  input: DeleteCustomCandidateProfileFieldValueInput
}

export type MutationDeleteCustomJobRequisitionFieldArgs = {
  input: DeleteCustomJobRequisitionFieldInput
}

export type MutationDeleteCustomSourceCategoryArgs = {
  input: DeleteCustomSourceCategoryInput
}

export type MutationDeleteEducationArgs = {
  input: DeleteEducationInput
}

export type MutationDeleteExperienceArgs = {
  input: DeleteExperienceInput
}

export type MutationDeleteExternalJobApplicationArgs = {
  input: DeleteExternalApplicationInput
}

export type MutationDeleteFavoriteReportArgs = {
  input: FavoriteReportInput
}

export type MutationDeleteFavoriteSequenceArgs = {
  input: DeleteFavoriteSequenceInput
}

export type MutationDeleteFavoriteTalentPoolArgs = {
  input: DeleteFavoriteTalentPoolInput
}

export type MutationDeleteGlobalScreeningQuestionArgs = {
  input: DeleteGlobalScreeningQuestionInput
}

export type MutationDeleteHiringTeamMemberArgs = {
  input: DeleteHiringTeamMemberInput
}

export type MutationDeleteInterviewArgs = {
  input: DeleteInterviewInput
}

export type MutationDeleteInterviewTeamArgs = {
  input: DeleteInterviewTeamInput
}

export type MutationDeleteInterviewTemplateArgs = {
  input: DeleteInterviewTemplateInput
}

export type MutationDeleteInvitationFromWorkspaceArgs = {
  input: DeleteInvitationFromWorkspaceInput
}

export type MutationDeleteJobListingArgs = {
  input: DeleteJobListingInput
}

export type MutationDeleteJobListingScreeningQuestionArgs = {
  input: DeleteJobListingScreeningQuestionInput
}

export type MutationDeleteJobOpeningArgs = {
  input: DeleteJobOpeningInput
}

export type MutationDeleteJobSeekerSkillArgs = {
  input: DeleteJobSeekerSkillInput
}

export type MutationDeleteNotificationSettingArgs = {
  input: DeleteNotificationSettingInput
}

export type MutationDeleteOfferCustomFieldArgs = {
  input: DeleteOfferCustomFieldInput
}

export type MutationDeleteOfferDocumentTemplateArgs = {
  input: DeleteOfferDocumentTemplateInput
}

export type MutationDeleteOfferDocumentTemplateSectionArgs = {
  input: DeleteOfferDocumentTemplateSectionInput
}

export type MutationDeleteOfferSectionTemplateArgs = {
  input: DeleteOfferSectionTemplateInput
}

export type MutationDeleteOfferTemplateConditionArgs = {
  input: DeleteOfferTemplateConditionInput
}

export type MutationDeleteRequisitionArgs = {
  input: DeleteRequisitionInput
}

export type MutationDeleteRequisitionJobDescriptionArgs = {
  input: DeleteRequisitionJobDescriptionInput
}

export type MutationDeleteRequisitionSkillArgs = {
  input: DeleteRequisitionSkillInput
}

export type MutationDeleteSavedViewArgs = {
  input: DeleteSavedViewInput
}

export type MutationDeleteScalisUserUploadedDocumentArgs = {
  input: DeleteScalisUserUploadedDocumentInput
}

export type MutationDeleteSchedulerLinkInviteArgs = {
  input: DeleteSchedulerLinkInviteInput
}

export type MutationDeleteSchedulerLinkSettingsArgs = {
  input: DeleteSchedulerLinkSettingsInput
}

export type MutationDeleteScorecardTemplateArgs = {
  input: DeleteScorecardTemplateInput
}

export type MutationDeleteScorecardTemplateQuestionArgs = {
  input: DeleteScorecardTemplateQuestionInput
}

export type MutationDeleteScorecardTemplateSectionArgs = {
  input: DeleteScorecardTemplateSectionInput
}

export type MutationDeleteScreeningQuestionArgs = {
  input: DeleteScreeningQuestionInput
}

export type MutationDeleteSequenceArgs = {
  input: SequenceOperationInput
}

export type MutationDeleteSequenceScheduleSettingArgs = {
  input: DeleteSequenceScheduleSettingInput
}

export type MutationDeleteSequenceStepArgs = {
  input: MutationDeleteSequenceStepInput
}

export type MutationDeleteSharedReportArgs = {
  input: SharedReportInput
}

export type MutationDeleteSkillArgs = {
  input: Array<DeleteSkillInput>
}

export type MutationDeleteSourceTrackingLinkArgs = {
  input: DeleteSourceTrackingLinkInput
}

export type MutationDeleteStageCollaboratorArgs = {
  input: DeleteStageCollaboratorInput
}

export type MutationDeleteStageSettingsArgs = {
  input: DeleteStageSettingsInput
}

export type MutationDeleteTalentPoolArgs = {
  input: DeleteTalentPoolInput
}

export type MutationDeleteTalentPoolProspectStatusArgs = {
  input: DeleteTalentPoolProspectStatusInput
}

export type MutationDeleteTemplateApprovalWorkflowArgs = {
  id: Scalars['Int']['input']
}

export type MutationDeleteTemplateJobDescriptionArgs = {
  input: DeleteTemplateJobDescriptionInput
}

export type MutationDeleteTemplateMessageArgs = {
  input: DeleteTemplateMessageInput
}

export type MutationDeleteTemplateMilestoneArgs = {
  input: DeleteTemplateMilestoneInput
}

export type MutationDeleteTemplatePipelineArgs = {
  input: DeleteTemplatePipelineInput
}

export type MutationDeleteTemplateStageArgs = {
  input: DeleteTemplateStageInput
}

export type MutationDeleteTokenTestResultArgs = {
  input: DeleteTokenTestResultInput
}

export type MutationDeleteUploadedDocumentArgs = {
  input: DeleteUploadedDocumentInput
}

export type MutationDeleteUploadedDocumentCandidateApplicationArgs = {
  input: DeleteUploadedDocumentCandidateApplicationInput
}

export type MutationDeleteUploadedDocumentCandidateProfileArgs = {
  input: DeleteUploadedDocumentCandidateProfileInput
}

export type MutationDeleteUsersFromCompanyUserGroupArgs = {
  input: DeleteUsersFromCompanyUserGroupInput
}

export type MutationDeleteVolunteerWorkArgs = {
  input: DeleteVolunteerWorkInput
}

export type MutationDiscardCandidateRecommendationArgs = {
  input: DiscardCandidateRecommendationInput
}

export type MutationDisconnectCalendarArgs = {
  input: DisconnectCalendarInput
}

export type MutationDisconnectConnectedEmailArgs = {
  input: DisconnectConnectedEmailInput
}

export type MutationDownloadDocumentTemplateArgs = {
  input: DownloadDocumentTemplateInput
}

export type MutationDuplicateTalentPoolArgs = {
  input: DuplicateTalentPoolInput
}

export type MutationEditApprovalWorkflowInstanceArgs = {
  input: EditApprovalWorkflowInstanceInput
}

export type MutationEditApprovalWorkflowSettingsArgs = {
  input: EditApprovalWorkflowSettingsInput
}

export type MutationEditCalendarEventArgs = {
  input: EditCalendarEventInput
}

export type MutationEditCalendarSettingsArgs = {
  input?: InputMaybe<EditCalendarSettingsInput>
}

export type MutationEditCandidateApplicationStatusArgs = {
  input: EditCandidateApplicationStatusInput
}

export type MutationEditCandidateLabelArgs = {
  input: EditCandidateLabelInput
}

export type MutationEditCandidateSourceNameArgs = {
  input: EditCandidateSourceNameInput
}

export type MutationEditCandidateTouchpointActivityLogArgs = {
  input: EditCandidateTouchpointActivityLogInput
}

export type MutationEditCompanyCandidateTouchpointArgs = {
  input: EditCompanyCandidateTouchpointInput
}

export type MutationEditCompanyProvidedCandidateEmailArgs = {
  input: EditCompanyProvidedEmailInput
}

export type MutationEditCompanyUserViewOrderArgs = {
  input: EditCompanyUserViewOrderInput
}

export type MutationEditConnectedEmailArgs = {
  input: EditConnectedEmailInput
}

export type MutationEditCustomApplicationStatusArgs = {
  input: EditCustomApplicationStatusInput
}

export type MutationEditCustomCandidateApplicationFieldArgs = {
  input: EditCustomCandidateApplicationFieldInput
}

export type MutationEditCustomCandidateProfileFieldArgs = {
  input: EditCustomCandidateProfileFieldInput
}

export type MutationEditCustomJobRequisitionFieldArgs = {
  input: EditCustomJobRequisitionFieldInput
}

export type MutationEditCustomJobRequisitionFieldValueArgs = {
  input: EditCustomJobRequisitionFieldValueInput
}

export type MutationEditCustomSourceCategoryArgs = {
  input: EditCustomSourceCategoryInput
}

export type MutationEditGlobalScreeningQuestionArgs = {
  input: EditGlobalScreeningQuestionInput
}

export type MutationEditSavedViewArgs = {
  input: EditSavedViewInput
}

export type MutationEditSourceTrackingLinkArgs = {
  input: EditSourceTrackingLinkInput
}

export type MutationEditTalentPoolArgs = {
  input: EditTalentPoolInput
}

export type MutationEditTalentPoolProspectStatusArgs = {
  input: EditTalentPoolProspectStatusInput
}

export type MutationEditTemplateApprovalWorkflowArgs = {
  input: EditTemplateApprovalWorkflowInput
}

export type MutationExchangeConnectedEmailTokenArgs = {
  input: ExchangeConnectedEmailTokenInput
}

export type MutationExchangeNylasTokenArgs = {
  input: ExchangeNylasTokenInput
}

export type MutationExchangeWebSocketTokenArgs = {
  input?: InputMaybe<ExchangeWebSocketTokenInput>
}

export type MutationExtractSocialProfileArgs = {
  html: Scalars['String']['input']
  mockEnrichmentEnabled?: InputMaybe<Scalars['Boolean']['input']>
  uploadedCandidateType: UploadedCandidateTypeEnum
}

export type MutationGenerateFilesFromHtmlArgs = {
  input: GenerateFilesFromHtmlInput
}

export type MutationGenerateKnockTokenArgs = {
  input?: InputMaybe<GenerateKnockTokenInput>
}

export type MutationGetConnectedEmailAuthUrlArgs = {
  input: GetConnectedEmailAuthUrlInput
}

export type MutationGetEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type MutationHtmlToBase64Args = {
  input: HtmlToBase64Input
}

export type MutationHtmlToDocxArgs = {
  input: HtmlToDocxInput
}

export type MutationIdentifyKnockUserArgs = {
  input: IdentifyKnockUserInput
}

export type MutationInsertGlobalScreeningQuestionArgs = {
  input: Array<InsertGlobalScreeningQuestionInput>
}

export type MutationInviteCandidatesToApplyArgs = {
  input: InviteCandidatesToApplyInput
}

export type MutationInviteUserArgs = {
  input: InviteUserInput
}

export type MutationManageCandidateLabelsArgs = {
  input: ManageCandidateLabelsInput
}

export type MutationMarkDefaultSequenceScheduleSettingArgs = {
  input: MarkDefaultSequenceScheduleSettingInput
}

export type MutationMergeCandidateLabelsArgs = {
  input: MergeCandidateLabelsInput
}

export type MutationMergeCandidateSourceNameArgs = {
  input: MergeCandidateSourceNameInput
}

export type MutationMergeCustomApplicationStatusArgs = {
  input: MergeCustomApplicationStatusInput
}

export type MutationMergeCustomSourceCategoryArgs = {
  input: MergeCustomSourceCategoryInput
}

export type MutationMoveCandidateBackStageArgs = {
  input: MoveCandidateBackStageInput
}

export type MutationOrderJobCampaignArgs = {
  input: OrderCampaignInput
}

export type MutationParseResumeBasicInfoArgs = {
  input: ParseResumeBasicInfoInput
}

export type MutationPauseSequenceArgs = {
  input: SequenceOperationInput
}

export type MutationPinSavedViewArgs = {
  input: PinSavedViewInput
}

export type MutationProcessAutoRejectCandidatesArgs = {
  apiKey: Scalars['String']['input']
  input: AutoRejectCandidatesInput
}

export type MutationProcessBulkRejectCandidatesNextBatchArgs = {
  apiKey: Scalars['String']['input']
  companyUserId: Scalars['Int']['input']
  input: BulkRejectCandidatesInput
}

export type MutationProcessRejectCandidatesArgs = {
  apiKey: Scalars['String']['input']
  companyUserId: Scalars['Int']['input']
  input: RejectCandidatesInput
  jobId: Scalars['String']['input']
}

export type MutationPublishEventArgs = {
  input: PublishEventInput
}

export type MutationPurchaseAiCreditsArgs = {
  input: PurchaseAiCreditsInput
}

export type MutationQueueuBulkRejectCandidatesArgs = {
  input: BulkRejectCandidatesInput
}

export type MutationRejectCandidatesArgs = {
  delaySeconds?: InputMaybe<Scalars['Int']['input']>
  input: RejectCandidatesInput
}

export type MutationRemoveInterviewerPoolMemberArgs = {
  input: RemoveInterviewerPoolMemberInput
}

export type MutationRemoveSavedViewArgs = {
  input: RemoveSavedViewInput
}

export type MutationRemoveSkillFromExperienceArgs = {
  input: Array<RemoveSkillFromExperienceInput>
}

export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput
}

export type MutationResendResetPasswordEmailArgs = {
  input: ResendResetPasswordEmailInput
}

export type MutationResendSchedulerLinkInviteArgs = {
  input: ResendSchedulerLinkInviteInput
}

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput
}

export type MutationResolveDuplicateApplicationsArgs = {
  input: ResolveDuplicateApplicationsInput
}

export type MutationResumeSequenceArgs = {
  input: SequenceOperationInput
}

export type MutationScheduleReportArgs = {
  input: CreateScheduledReportInput
}

export type MutationSelectRecommendedCandidateArgs = {
  input: SelectRecommendedCandidateInput
}

export type MutationSendCandidateOfferArgs = {
  input: SendCandidateOfferInput
}

export type MutationSendCandidateScorecardArgs = {
  input: SendCandidateScorecardInput
}

export type MutationSendCandidatesToSourcingStageArgs = {
  input: SendCandidatesToSourcingStageInput
}

export type MutationSendConnectedEmailArgs = {
  input: SendConnectedEmailInput
}

export type MutationSendEmailForSequenceStepArgs = {
  apiKey: Scalars['String']['input']
  input: SendEmailForSequenceStepInput
}

export type MutationSendEmailToCandidateProfileArgs = {
  input: SendEmailToCandidateProfileInput
}

export type MutationSendJobListingArgs = {
  input: SendJobListingInput
}

export type MutationSendReminderCandidateScorecardArgs = {
  input: SendReminderCandidateScorecardInput
}

export type MutationSendResetPasswordEmailArgs = {
  input: SendResetPasswordEmailInput
}

export type MutationSignUpArgs = {
  input: SignUpInput
}

export type MutationStartCandidateApplicationArgs = {
  input: StartCandidateApplicationInput
}

export type MutationSubscribeArgs = {
  input: SubscriptionInput
}

export type MutationSwapRequisitionPipelineArgs = {
  input: SwapRequisitionPipelineInput
}

export type MutationToggleScorecardTemplateArchiveArgs = {
  input: ToggleScorecardTemplateArchiveInput
}

export type MutationToggleTemplateApprovalWorkflowStatusArgs = {
  input: ToggleTemplateApprovalWorkflowStatusInput
}

export type MutationUnarchiveCustomCandidateApplicationFieldArgs = {
  input: UnarchiveCustomCandidateApplicationFieldInput
}

export type MutationUnarchiveCustomCandidateProfileFieldArgs = {
  input: UnarchiveCustomCandidateProfileFieldInput
}

export type MutationUnarchiveCustomJobRequisitionFieldArgs = {
  input: UnarchiveCustomJobRequisitionFieldInput
}

export type MutationUnarchiveInterviewTemplateArgs = {
  input: UnarchiveInterviewTemplateInput
}

export type MutationUnarchiveInterviewerPoolArgs = {
  input: UnarchiveInterviewerPoolInput
}

export type MutationUnarchiveOfferCustomFieldArgs = {
  input: UnarchiveOfferCustomFieldInput
}

export type MutationUnarchiveSequenceArgs = {
  input: SequenceOperationInput
}

export type MutationUnarchiveTalentPoolArgs = {
  input: UnarchiveTalentPoolInput
}

export type MutationUndoHireArgs = {
  input: UndoHireInput
}

export type MutationUndoOfferCandidateDeclinedArgs = {
  input: UndoOfferCandidateDeclinedInput
}

export type MutationUndoRejectCandidatesArgs = {
  input: UndoRejectCandidatesInput
}

export type MutationUnpinSavedViewArgs = {
  input: UnpinSavedViewInput
}

export type MutationUnsubscribeCandidateFromSequenceArgs = {
  input: UnsubscribeCandidateFromEmailsInput
}

export type MutationUpdateCandidateFilterArgs = {
  input: UpdateCandidateFilterInput
}

export type MutationUpdateCandidateOfferVersionStatusArgs = {
  input: UpdateCandidateOfferVersionStatusInput
}

export type MutationUpdateCompanyDataArgs = {
  input: UpdateCompanyDataInput
}

export type MutationUpdateCompanyUserGroupArgs = {
  input: UpdateCompanyUserGroupInput
}

export type MutationUpdateCompanyUserRoleArgs = {
  input: UpdateCompanyUserRoleInput
}

export type MutationUpdateCompanyUserViewOrderArgs = {
  input: UpdateCompanyUserViewOrderInput
}

export type MutationUpdateConnectedEmailSettingsArgs = {
  input: UpdateConnectedEmailSettingsInput
}

export type MutationUpdateCustomCandidateApplicationFieldValueArgs = {
  input: UpdateCustomCandidateApplicationFieldValueInput
}

export type MutationUpdateCustomCandidateProfileFieldValueArgs = {
  input: UpdateCustomCandidateProfileFieldValueInput
}

export type MutationUpdateDocumentTemplateArgs = {
  input: UpdateDocumentTemplateInput
}

export type MutationUpdateInterviewArgs = {
  input: UpdateInterviewInput
}

export type MutationUpdateInterviewTemplateArgs = {
  input: UpdateInterviewTemplateInput
}

export type MutationUpdateInterviewerPoolArgs = {
  input: UpdateInterviewerPoolInput
}

export type MutationUpdateJobInviteArgs = {
  input: UpdateJobInviteInput
}

export type MutationUpdateJobSearchPreferenceArgs = {
  input: UpdateJobSearchPreferenceInput
}

export type MutationUpdateNotificationSettingArgs = {
  input: UpdateNotificationSettingInput
}

export type MutationUpdateScalisUserDataArgs = {
  input: UpdateScalisUserDataInput
}

export type MutationUpdateScheduledReportArgs = {
  input: UpdateScheduledReportInput
}

export type MutationUpdateSchedulerLinkInviteArgs = {
  input: UpdateSchedulerLinkInviteInput
}

export type MutationUpdateSchedulerLinkSettingsArgs = {
  input: UpdateSchedulerLinkSettingsInput
}

export type MutationUpdateSequenceArgs = {
  input: UpdateSequenceInput
}

export type MutationUpdateSequenceScheduleSettingArgs = {
  input: UpdateSequenceScheduleSettingInput
}

export type MutationUpdateSequenceSettingArgs = {
  input: UpdateSequenceSettingInput
}

export type MutationUpdateSequenceStepArgs = {
  input: UpdateSequenceStepInput
}

export type MutationUpdateUsersInCompanyUserGroupArgs = {
  input: UpdateUsersInCompanyUserGroupInput
}

export type MutationUploadS3FileArgs = {
  input: UploadS3FileInput
}

export type MutationUpsertAddressArgs = {
  input: UpsertAddressInput
}

export type MutationUpsertApplicationFormArgs = {
  input: UpsertApplicationFormInput
}

export type MutationUpsertApplicationFormScreeningQuestionArgs = {
  input: UpsertApplicationFormScreeningQuestionInput
}

export type MutationUpsertCandidateApplicationNoteArgs = {
  input: UpsertCandidateApplicationNoteInput
}

export type MutationUpsertCandidateApplicationRatingArgs = {
  input: UpsertCandidateApplicationRatingInput
}

export type MutationUpsertCandidateCollaboratorArgs = {
  input: UpsertCandidateCollaboratorInput
}

export type MutationUpsertCandidateMessageArgs = {
  input: UpsertCandidateMessageInput
}

export type MutationUpsertCandidateOfferArgs = {
  input: UpsertCandidateOfferInput
}

export type MutationUpsertCandidateOfferCustomFieldArgs = {
  input: UpsertCandidateOfferCustomFieldInput
}

export type MutationUpsertCandidateOfferFileArgs = {
  input: UpsertCandidateOfferFileInput
}

export type MutationUpsertCandidateOfferVersionArgs = {
  input: UpsertCandidateOfferVersionInput
}

export type MutationUpsertCandidatePrimaryEmailArgs = {
  input: UpsertCandidatePrimaryEmailInput
}

export type MutationUpsertCandidateProfileArgs = {
  input: UpsertCandidateProfileInput
}

export type MutationUpsertCandidateProfileNoteArgs = {
  input: UpsertCandidateProfileNoteInput
}

export type MutationUpsertCandidateScorecardArgs = {
  input: UpsertCandidateScorecardInput
}

export type MutationUpsertCandidateScorecardAnswersArgs = {
  input: UpsertCandidateScorecardAnswersInput
}

export type MutationUpsertEmailArgs = {
  input: UpsertEmailInput
}

export type MutationUpsertExperienceSkillArgs = {
  input: Array<UpsertExperienceSkillInput>
}

export type MutationUpsertExternalJobApplicationArgs = {
  input: ExternalApplicationInput
}

export type MutationUpsertHiringTeamMemberArgs = {
  input: UpsertHiringTeamMemberInput
}

export type MutationUpsertJobListingArgs = {
  input: UpsertJobListingInput
}

export type MutationUpsertJobListingScreeningQuestionArgs = {
  input: UpsertJobListingScreeningQuestionInput
}

export type MutationUpsertJobOpeningArgs = {
  input: UpsertJobOpeningInput
}

export type MutationUpsertJobPipelineArgs = {
  input: UpsertJobPipelineInput
}

export type MutationUpsertOfferCustomFieldArgs = {
  input: UpsertOfferCustomFieldInput
}

export type MutationUpsertOfferDocumentTemplateArgs = {
  input: UpsertOfferDocumentTemplateInput
}

export type MutationUpsertOfferDocumentTemplateSectionArgs = {
  input: UpsertOfferDocumentTemplateSectionInput
}

export type MutationUpsertOfferSectionTemplateArgs = {
  input: UpsertOfferSectionTemplateInput
}

export type MutationUpsertOfferTemplateConditionArgs = {
  input: Array<UpsertOfferTemplateConditionInput>
}

export type MutationUpsertRequisitionArgs = {
  input: UpsertRequisitionInput
}

export type MutationUpsertRequisitionJobDescriptionArgs = {
  input: UpsertRequisitionJobDescriptionInput
}

export type MutationUpsertRequisitionSkillArgs = {
  input: UpsertRequisitionSkillInput
}

export type MutationUpsertScorecardTemplateArgs = {
  input: UpsertScorecardTemplateInput
}

export type MutationUpsertScreeningQuestionArgs = {
  input: UpsertScreeningQuestionInput
}

export type MutationUpsertSkillArgs = {
  input: Array<UpsertSkillInput>
}

export type MutationUpsertStageCollaboratorArgs = {
  input: UpsertStageCollaboratorInput
}

export type MutationUpsertStageSettingsArgs = {
  input: UpsertStageSettingsInput
}

export type MutationUpsertTemplateJobDescriptionArgs = {
  input: UpsertTemplateJobDescriptionInput
}

export type MutationUpsertTemplateMessageArgs = {
  input: UpsertTemplateMessageInput
}

export type MutationUpsertTemplateMilestoneArgs = {
  input: UpsertTemplateMilestoneInput
}

export type MutationUpsertTemplatePipelineArgs = {
  input: UpsertTemplatePipelineInput
}

export type MutationUpsertTemplateStageArgs = {
  input: UpsertTemplateStageInput
}

export type MutationUpsertTokenTestResultArgs = {
  input: UpsertTokenTestResultInput
}

export type MutationValidateOfferDocumentTemplateArgs = {
  input: ValidateOfferDocumentTemplateInput
}

export type MutationValidateOfferSectionTemplateArgs = {
  input: ValidateOfferSectionTemplateInput
}

export type MutationVerifyEmailCodeArgs = {
  input: VerifyEmailCodeInput
}

export type MutationVerifyPasswordCodeArgs = {
  input: VerifyPasswordCodeInput
}

export type MutationDeleteTemplateScreeningQuestionArgs = {
  input: DeleteTemplateScreeningQuestionInput
}

export type MutationEditTemplateScreeningQuestionArgs = {
  input: EditTemplateScreeningQuestionInput
}

export type MutationUpsertGlobalListingSetupArgs = {
  input: GlobalListingSetupInput
}

export type MutationDeleteSequenceStepInput = {
  stepId: Scalars['Int']['input']
}

/** Name information */
export type Name = {
  __typename?: 'Name'
  first?: Maybe<Scalars['String']['output']>
  full?: Maybe<Scalars['String']['output']>
  last?: Maybe<Scalars['String']['output']>
  middle?: Maybe<Scalars['String']['output']>
}

export enum NameEnum {
  ApplicationReview = 'APPLICATION_REVIEW',
  Hired = 'HIRED',
  Interviewing = 'INTERVIEWING',
  Offer = 'OFFER',
  PreScreen = 'PRE_SCREEN',
  Sourcing = 'SOURCING',
}

export type NestedValidationErrors = {
  __typename?: 'NestedValidationErrors'
  fields: Scalars['JSON']['output']
}

export enum NotificationEventNameEnum {
  AssignedAsHiringManager = 'assigned_as_hiring_manager',
  AssignedAsInterviewer = 'assigned_as_interviewer',
  AssignedAsRecruiter = 'assigned_as_recruiter',
  AssignedToHiringTeam = 'assigned_to_hiring_team',
  CandidateHiredOnMyJob = 'candidate_hired_on_my_job',
  CandidateSignedOffer = 'candidate_signed_offer',
  InterviewDayMorningReminder = 'interview_day_morning_reminder',
  InterviewSelfScheduledWithMe = 'interview_self_scheduled_with_me',
  InterviewTeamScorecardSubmitted = 'interview_team_scorecard_submitted',
  JobAdCampaignExpiringSoon = 'job_ad_campaign_expiring_soon',
  JobClosedThatIWasAssignedTo = 'job_closed_that_i_was_assigned_to',
  MentionedInNotes = 'mentioned_in_notes',
  NewApplicantToMyJob = 'new_applicant_to_my_job',
  NewCandidateMatchForMyJob = 'new_candidate_match_for_my_job',
  NewCandidateMessageReceived = 'new_candidate_message_received',
  OfferSentToCandidate = 'offer_sent_to_candidate',
  ReferralSubmittedForMyJob = 'referral_submitted_for_my_job',
  ScorecardAssignedToMe = 'scorecard_assigned_to_me',
}

export enum NotificationEventTypeEnum {
  CandidateAddedByTeamMember = 'CANDIDATE_ADDED_BY_TEAM_MEMBER',
  CandidateBackgroundCheckCompleted = 'CANDIDATE_BACKGROUND_CHECK_COMPLETED',
  CandidateFollowupNeeded = 'CANDIDATE_FOLLOWUP_NEEDED',
  CandidateHired = 'CANDIDATE_HIRED',
  CandidateInterviewReschedule = 'CANDIDATE_INTERVIEW_RESCHEDULE',
  CandidateNewApplicant = 'CANDIDATE_NEW_APPLICANT',
  CandidateNewMessage = 'CANDIDATE_NEW_MESSAGE',
  CandidateOfferApproved = 'CANDIDATE_OFFER_APPROVED',
  CandidateOfferPendingApproval = 'CANDIDATE_OFFER_PENDING_APPROVAL',
  CandidateOfferResponse = 'CANDIDATE_OFFER_RESPONSE',
  CandidateOfferSent = 'CANDIDATE_OFFER_SENT',
  CandidateOfferSigned = 'CANDIDATE_OFFER_SIGNED',
  CandidateReferralSubmitted = 'CANDIDATE_REFERRAL_SUBMITTED',
  CandidateRejected = 'CANDIDATE_REJECTED',
  CandidateRejectionQueued = 'CANDIDATE_REJECTION_QUEUED',
  CandidateRejectionUndone = 'CANDIDATE_REJECTION_UNDONE',
  CandidateStartDateSet = 'CANDIDATE_START_DATE_SET',
  CandidateStatusUpdated = 'CANDIDATE_STATUS_UPDATED',
  JobAdExpiring = 'JOB_AD_EXPIRING',
  JobAssignedAsHiringManager = 'JOB_ASSIGNED_AS_HIRING_MANAGER',
  JobAssignedAsRecruiter = 'JOB_ASSIGNED_AS_RECRUITER',
  JobAssignedToHiringTeam = 'JOB_ASSIGNED_TO_HIRING_TEAM',
  JobClosed = 'JOB_CLOSED',
  JobInterviewAssigned = 'JOB_INTERVIEW_ASSIGNED',
  JobInterviewToday = 'JOB_INTERVIEW_TODAY',
  JobNewMatches = 'JOB_NEW_MATCHES',
  JobOfferSentToCandidate = 'JOB_OFFER_SENT_TO_CANDIDATE',
  JobOpened = 'JOB_OPENED',
  JobPipelineChanged = 'JOB_PIPELINE_CHANGED',
  JobRequirementsChanged = 'JOB_REQUIREMENTS_CHANGED',
  JobScorecardAssigned = 'JOB_SCORECARD_ASSIGNED',
  JobScorecardSubmitted = 'JOB_SCORECARD_SUBMITTED',
  JobSelfSchedulerBooked = 'JOB_SELF_SCHEDULER_BOOKED',
  MentionedInNotes = 'MENTIONED_IN_NOTES',
}

/** A notification setting for a company user */
export type NotificationSetting = {
  __typename?: 'NotificationSetting'
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  email: Scalars['Boolean']['output']
  eventType: NotificationEventTypeEnum
  id: Scalars['Int']['output']
  inApp: Scalars['Boolean']['output']
  slack: Scalars['Boolean']['output']
  updatedAt: Scalars['DateTime']['output']
}

export enum NylasEventStatusesEnum {
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Tentative = 'tentative',
}

export type OfferCustomField = {
  __typename?: 'OfferCustomField'
  CandidateOfferCustomField?: Maybe<Array<CandidateOfferCustomField>>
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  OfferTemplateCondition?: Maybe<Array<OfferTemplateCondition>>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  fieldConfigurationType: CustomFieldInputTypeEnum
  fieldDescription?: Maybe<Scalars['String']['output']>
  fieldName: Scalars['String']['output']
  fieldRequired: Scalars['Boolean']['output']
  generateSystemToken: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  isArchived: Scalars['Boolean']['output']
  multipleChoiceOptions?: Maybe<Scalars['JSON']['output']>
  systemTokenName?: Maybe<Scalars['String']['output']>
  templateConditionId?: Maybe<Scalars['Int']['output']>
  triggerNewOfferVersion: Scalars['Boolean']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type OfferDocumentTemplate = {
  __typename?: 'OfferDocumentTemplate'
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  OfferDocumentTemplateSection?: Maybe<Array<OfferDocumentTemplateSection>>
  OfferTemplateCondition?: Maybe<Array<OfferTemplateCondition>>
  TokenTestResult?: Maybe<Array<TokenTestResult>>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentFileName?: Maybe<Scalars['String']['output']>
  documentFilePath?: Maybe<Scalars['String']['output']>
  documentTemplateName: Scalars['String']['output']
  documentTemplateStatus: OfferDocumentTemplateStatusEnum
  documentTemplateText: Scalars['String']['output']
  documentType: OfferDocumentTemplateTypeEnum
  id: Scalars['ID']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  validationResult?: Maybe<Scalars['JSON']['output']>
}

export type OfferDocumentTemplateSection = {
  __typename?: 'OfferDocumentTemplateSection'
  OfferDocumentTemplate: OfferDocumentTemplate
  OfferSectionTemplate: OfferSectionTemplate
  offerDocumentTemplateId: Scalars['Int']['output']
  offerSectionTemplateId: Scalars['Int']['output']
}

export enum OfferDocumentTemplateStatusEnum {
  Failed = 'FAILED',
  NotTested = 'NOT_TESTED',
  Verified = 'VERIFIED',
}

export enum OfferDocumentTemplateTypeEnum {
  Nda = 'NDA',
  OfferLetter = 'OFFER_LETTER',
  Other = 'OTHER',
}

export enum OfferFileTypeEnum {
  AdditionalDocument = 'ADDITIONAL_DOCUMENT',
  Docx = 'DOCX',
  Pdf = 'PDF',
  SignedDocument = 'SIGNED_DOCUMENT',
}

export type OfferSectionTemplate = {
  __typename?: 'OfferSectionTemplate'
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  OfferDocumentTemplateSection?: Maybe<Array<OfferDocumentTemplateSection>>
  OfferTemplateCondition?: Maybe<Array<OfferTemplateCondition>>
  TokenTestResult?: Maybe<Array<TokenTestResult>>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  sectionTemplateName: Scalars['String']['output']
  sectionTemplateStatus: TokenStatusEnum
  sectionTemplateText: Scalars['String']['output']
  sectionToken: Scalars['String']['output']
  templateConditionId?: Maybe<Scalars['Int']['output']>
  tokenDescription?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  validationResult?: Maybe<Scalars['JSON']['output']>
}

export enum OfferStatusEnum {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  NotCreated = 'NOT_CREATED',
  NotSent = 'NOT_SENT',
  PendingApproval = 'PENDING_APPROVAL',
  PendingSend = 'PENDING_SEND',
  Sent = 'SENT',
  SentAwaitingSignature = 'SENT_AWAITING_SIGNATURE',
  Signed = 'SIGNED',
  Voided = 'VOIDED',
}

export type OfferTemplateCondition = {
  __typename?: 'OfferTemplateCondition'
  CompanyDepartment?: Maybe<CompanyDepartment>
  CompanyOffice?: Maybe<CompanyOffice>
  OfferCustomField?: Maybe<OfferCustomField>
  OfferDocumentTemplate?: Maybe<OfferDocumentTemplate>
  OfferSectionTemplate?: Maybe<OfferSectionTemplate>
  conditionType: ConditionTypeEnum
  createdAt?: Maybe<Scalars['DateTime']['output']>
  customFieldId?: Maybe<Scalars['Int']['output']>
  departmentId?: Maybe<Scalars['Int']['output']>
  employmentType?: Maybe<JobTypeEnum>
  id: Scalars['ID']['output']
  offerDocumentTemplateId?: Maybe<Scalars['Int']['output']>
  officeId?: Maybe<Scalars['Int']['output']>
  payType?: Maybe<PayTypeEnum>
  sectionTemplateId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type OpeningDataInput = {
  openingType?: InputMaybe<Scalars['String']['input']>
  requisitionId: Scalars['Int']['input']
}

export enum OpeningStatusEnum {
  Closed = 'CLOSED',
  Filled = 'FILLED',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
}

export enum OpeningTypeEnum {
  InternalHire = 'INTERNAL_HIRE',
  New = 'NEW',
  Replacement = 'REPLACEMENT',
}

export type Order = {
  __typename?: 'Order'
  Campaigns?: Maybe<JobCampaignResponse>
  Company: Company
  /** @deprecated Use campaignTraffic.applicants instead */
  applicantsCount?: Maybe<Scalars['JSON']['output']>
  campaignTraffic?: Maybe<Scalars['JSON']['output']>
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  orderReference: Scalars['String']['output']
  status: PaymentStatusEnum
  subTotal: Scalars['Float']['output']
  total: Scalars['Float']['output']
  updatedAt: Scalars['DateTime']['output']
  vat: Scalars['Float']['output']
}

export type OrderCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type OrderCampaignInput = {
  campaignName: Scalars['String']['input']
  items: Array<CampaignOrderItemInput>
  orderReference?: InputMaybe<Scalars['String']['input']>
  requisitionId: Scalars['Int']['input']
  targetGroup: TargetGroupInput
}

export type OrderCampaignPrice = {
  __typename?: 'OrderCampaignPrice'
  subTotal: Scalars['Float']['output']
  total: Scalars['Float']['output']
  vat: Scalars['Float']['output']
}

export enum OrderTypeEnum {
  AiSourcingCredits = 'AI_SOURCING_CREDITS',
  JobAdCampaign = 'JOB_AD_CAMPAIGN',
}

export type OrderedProductsSpec = {
  __typename?: 'OrderedProductsSpec'
  productId?: Maybe<Scalars['String']['output']>
  utm?: Maybe<Scalars['String']['output']>
}

/** Organization information */
export type Organization = {
  __typename?: 'Organization'
  description?: Maybe<Scalars['String']['output']>
  founded?: Maybe<Scalars['Int']['output']>
  funding?: Maybe<OrganizationFunding>
  headcount?: Maybe<OrganizationHeadcount>
  id?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  industries?: Maybe<Array<Scalars['String']['output']>>
  location?: Maybe<CandidateRecommendationLocation>
  name?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  url?: Maybe<Scalars['String']['output']>
}

/** Organization funding information */
export type OrganizationFunding = {
  __typename?: 'OrganizationFunding'
  lastFundingRound?: Maybe<Scalars['String']['output']>
}

/** Organization headcount information */
export type OrganizationHeadcount = {
  __typename?: 'OrganizationHeadcount'
  bucket?: Maybe<Scalars['String']['output']>
  size?: Maybe<Scalars['Int']['output']>
}

export enum OrganizationRoleEnum {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  Member = 'MEMBER',
  SuperAdmin = 'SUPER_ADMIN',
}

export enum OverallRecommendationEnum {
  Neutral = 'NEUTRAL',
  No = 'NO',
  Yes = 'YES',
}

export type PaginatedApplicationForms = {
  __typename?: 'PaginatedApplicationForms'
  items: Array<ApplicationForm>
  total: Scalars['Int']['output']
}

export type PaginatedCandidateLabels = {
  __typename?: 'PaginatedCandidateLabels'
  items: Array<CandidateLabel>
  total: Scalars['Int']['output']
}

export type PaginatedCandidateTouchpoints = {
  __typename?: 'PaginatedCandidateTouchpoints'
  items: Array<CompanyCandidateTouchpoint>
  total: Scalars['Int']['output']
}

export type PaginatedCompanyCandidateTouchpoints = {
  __typename?: 'PaginatedCompanyCandidateTouchpoints'
  items: Array<CompanyCandidateTouchpoint>
  limit: Scalars['Int']['output']
  page: Scalars['Int']['output']
  total: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type PaginatedCustomApplicationStatus = {
  __typename?: 'PaginatedCustomApplicationStatus'
  items: Array<CustomApplicationStatus>
  total: Scalars['Int']['output']
}

export type PaginatedScreeningQuestions = {
  __typename?: 'PaginatedScreeningQuestions'
  items: Array<ScreeningQuestion>
  total: Scalars['Int']['output']
}

export type PaginatedSourceTrackingLinks = {
  __typename?: 'PaginatedSourceTrackingLinks'
  items: Array<SourceTrackingLink>
  total: Scalars['Int']['output']
}

export type PaginatedTemplateApprovalWorkflows = {
  __typename?: 'PaginatedTemplateApprovalWorkflows'
  items: Array<TemplateApprovalWorkflow>
  total: Scalars['Int']['output']
}

export type ParseResumeBasicInfoInput = {
  base64File: Scalars['String']['input']
  contentType: Scalars['String']['input']
  fileName: Scalars['String']['input']
}

export type ParsedResumeData = {
  __typename?: 'ParsedResumeData'
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  linkedin?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

export enum ParsingResumeStateEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
}

export enum PayTypeEnum {
  Hourly = 'HOURLY',
  Salary = 'SALARY',
}

export enum PaymentStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
}

export enum PermissionEnum {
  ApprovalWorkflowCreate = 'APPROVAL_WORKFLOW__CREATE',
  ApprovalWorkflowDelete = 'APPROVAL_WORKFLOW__DELETE',
  ApprovalWorkflowEdit = 'APPROVAL_WORKFLOW__EDIT',
  ApprovalWorkflowView = 'APPROVAL_WORKFLOW__VIEW',
  CandidatesAdvance = 'CANDIDATES__ADVANCE',
  CandidatesMessage = 'CANDIDATES__MESSAGE',
  CandidatesReject = 'CANDIDATES__REJECT',
  CandidatesResolveDuplicates = 'CANDIDATES__RESOLVE_DUPLICATES',
  CandidatesUpload = 'CANDIDATES__UPLOAD',
  CandidateCollaboratorDelete = 'CANDIDATE_COLLABORATOR_DELETE',
  CandidateCollaboratorUpsert = 'CANDIDATE_COLLABORATOR_UPSERT',
  CandidateMessageDelete = 'CANDIDATE_MESSAGE_DELETE',
  CandidateMessageUpsert = 'CANDIDATE_MESSAGE_UPSERT',
  CandidateOfferCustomFieldDelete = 'CANDIDATE_OFFER_CUSTOM_FIELD_DELETE',
  CandidateOfferCustomFieldUpsert = 'CANDIDATE_OFFER_CUSTOM_FIELD_UPSERT',
  CandidateOfferDelete = 'CANDIDATE_OFFER_DELETE',
  CandidateOfferFileDelete = 'CANDIDATE_OFFER_FILE_DELETE',
  CandidateOfferFileUpsert = 'CANDIDATE_OFFER_FILE_UPSERT',
  CandidateOfferUpsert = 'CANDIDATE_OFFER_UPSERT',
  CandidateOfferVersionDelete = 'CANDIDATE_OFFER_VERSION_DELETE',
  CandidateOfferVersionUpsert = 'CANDIDATE_OFFER_VERSION_UPSERT',
  CandidateProfilesDelete = 'CANDIDATE_PROFILES__DELETE',
  CandidateProfilesEdit = 'CANDIDATE_PROFILES__EDIT',
  CandidateProfilesView = 'CANDIDATE_PROFILES__VIEW',
  CompanySettingsEdit = 'COMPANY_SETTINGS__EDIT',
  CustomFieldDelete = 'CUSTOM_FIELD_DELETE',
  CustomFieldUpsert = 'CUSTOM_FIELD_UPSERT',
  DefaultTokenDelete = 'DEFAULT_TOKEN_DELETE',
  DefaultTokenUpsert = 'DEFAULT_TOKEN_UPSERT',
  DemographicInformationView = 'DEMOGRAPHIC_INFORMATION__VIEW',
  FeedbackSubmit = 'FEEDBACK__SUBMIT',
  FeedbackView = 'FEEDBACK__VIEW',
  HiringTeamMemberDelete = 'HIRING_TEAM_MEMBER_DELETE',
  HiringTeamMemberUpsert = 'HIRING_TEAM_MEMBER_UPSERT',
  InterviewsDelete = 'INTERVIEWS__DELETE',
  InterviewsEdit = 'INTERVIEWS__EDIT',
  InterviewsSchedule = 'INTERVIEWS__SCHEDULE',
  InterviewsView = 'INTERVIEWS__VIEW',
  JobsDelete = 'JOBS__DELETE',
  JobsEdit = 'JOBS__EDIT',
  JobsView = 'JOBS__VIEW',
  JobListingDelete = 'JOB_LISTING_DELETE',
  JobListingScreeningQuestionDelete = 'JOB_LISTING_SCREENING_QUESTION_DELETE',
  JobListingScreeningQuestionUpsert = 'JOB_LISTING_SCREENING_QUESTION_UPSERT',
  JobListingUpsert = 'JOB_LISTING_UPSERT',
  JobOpeningDelete = 'JOB_OPENING_DELETE',
  JobOpeningUpsert = 'JOB_OPENING_UPSERT',
  JobPipelineDelete = 'JOB_PIPELINE_DELETE',
  JobPipelineUpsert = 'JOB_PIPELINE_UPSERT',
  JobPostingsCreate = 'JOB_POSTINGS__CREATE',
  JobPostingsDelete = 'JOB_POSTINGS__DELETE',
  JobPostingsEdit = 'JOB_POSTINGS__EDIT',
  JobPostingsView = 'JOB_POSTINGS__VIEW',
  MessageTemplatesEdit = 'MESSAGE_TEMPLATES__EDIT',
  OfferCustomFieldDelete = 'OFFER_CUSTOM_FIELD_DELETE',
  OfferCustomFieldUpsert = 'OFFER_CUSTOM_FIELD_UPSERT',
  OfferDocumentTemplateDelete = 'OFFER_DOCUMENT_TEMPLATE_DELETE',
  OfferDocumentTemplateSectionDelete = 'OFFER_DOCUMENT_TEMPLATE_SECTION_DELETE',
  OfferDocumentTemplateSectionUpsert = 'OFFER_DOCUMENT_TEMPLATE_SECTION_UPSERT',
  OfferDocumentTemplateUpsert = 'OFFER_DOCUMENT_TEMPLATE_UPSERT',
  OfferDocumentTemplateValidate = 'OFFER_DOCUMENT_TEMPLATE_VALIDATE',
  OfferSectionTemplateDelete = 'OFFER_SECTION_TEMPLATE_DELETE',
  OfferSectionTemplateUpsert = 'OFFER_SECTION_TEMPLATE_UPSERT',
  OfferTemplateConditionDelete = 'OFFER_TEMPLATE_CONDITION_DELETE',
  OfferTemplateConditionUpsert = 'OFFER_TEMPLATE_CONDITION_UPSERT',
  PrivateNotesView = 'PRIVATE_NOTES__VIEW',
  ReferralsSubmit = 'REFERRALS__SUBMIT',
  ReportsGenerate = 'REPORTS__GENERATE',
  ReportsView = 'REPORTS__VIEW',
  RequisitionDelete = 'REQUISITION_DELETE',
  RequisitionJobDescriptionDelete = 'REQUISITION_JOB_DESCRIPTION_DELETE',
  RequisitionJobDescriptionUpsert = 'REQUISITION_JOB_DESCRIPTION_UPSERT',
  RequisitionSkillDelete = 'REQUISITION_SKILL_DELETE',
  RequisitionSkillUpsert = 'REQUISITION_SKILL_UPSERT',
  RequisitionUpsert = 'REQUISITION_UPSERT',
  ScorecardSubmit = 'SCORECARD__SUBMIT',
  ScorecardView = 'SCORECARD__VIEW',
  ScreeningQuestionAnswerDelete = 'SCREENING_QUESTION_ANSWER_DELETE',
  ScreeningQuestionAnswerUpsert = 'SCREENING_QUESTION_ANSWER_UPSERT',
  ScreeningQuestionDelete = 'SCREENING_QUESTION_DELETE',
  ScreeningQuestionUpsert = 'SCREENING_QUESTION_UPSERT',
  SectionTemplateDelete = 'SECTION_TEMPLATE_DELETE',
  SectionTemplateUpsert = 'SECTION_TEMPLATE_UPSERT',
  StageCollaboratorDelete = 'STAGE_COLLABORATOR_DELETE',
  StageCollaboratorUpsert = 'STAGE_COLLABORATOR_UPSERT',
  StageSettingsDelete = 'STAGE_SETTINGS_DELETE',
  StageSettingsUpsert = 'STAGE_SETTINGS_UPSERT',
  TemplateJobDescriptionDelete = 'TEMPLATE_JOB_DESCRIPTION_DELETE',
  TemplateJobDescriptionUpsert = 'TEMPLATE_JOB_DESCRIPTION_UPSERT',
  TemplateMessageDelete = 'TEMPLATE_MESSAGE_DELETE',
  TemplateMessageUpsert = 'TEMPLATE_MESSAGE_UPSERT',
  TemplateMilestoneDelete = 'TEMPLATE_MILESTONE_DELETE',
  TemplateMilestoneUpsert = 'TEMPLATE_MILESTONE_UPSERT',
  TemplatePipelineDelete = 'TEMPLATE_PIPELINE_DELETE',
  TemplatePipelineUpsert = 'TEMPLATE_PIPELINE_UPSERT',
  TemplateStageDelete = 'TEMPLATE_STAGE_DELETE',
  TemplateStageUpsert = 'TEMPLATE_STAGE_UPSERT',
  TokenTestResultDelete = 'TOKEN_TEST_RESULT_DELETE',
  TokenTestResultUpsert = 'TOKEN_TEST_RESULT_UPSERT',
  UsersPermissionsEdit = 'USERS_PERMISSIONS__EDIT',
  UsersInvite = 'USERS__INVITE',
}

/** Phone information */
export type Phone = {
  __typename?: 'Phone'
  isCurrent?: Maybe<Scalars['Boolean']['output']>
  number?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type PinSavedViewInput = {
  id: Scalars['Int']['input']
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

/** Position information */
export type Position = {
  __typename?: 'Position'
  class?: Maybe<Scalars['String']['output']>
  isManagement?: Maybe<Scalars['Boolean']['output']>
  levels?: Maybe<Array<Scalars['String']['output']>>
  role?: Maybe<Scalars['String']['output']>
  subRole?: Maybe<Scalars['String']['output']>
  teamSize?: Maybe<Scalars['String']['output']>
}

export enum PositionsToFillEnum {
  Count_1To_2 = 'COUNT_1_TO_2',
  Count_2To_5 = 'COUNT_2_TO_5',
  Count_5To_20 = 'COUNT_5_TO_20',
  Count_21Plus = 'COUNT_21_PLUS',
}

export enum PostedAtEnum {
  Last_7Days = 'LAST_7_DAYS',
  Last_24Hours = 'LAST_24_HOURS',
  Last_30Days = 'LAST_30_DAYS',
}

export type Posting = {
  __typename?: 'Posting'
  clicks: Scalars['Int']['output']
  name: Scalars['String']['output']
  productId: Scalars['String']['output']
}

export type PostingContactInfo = {
  __typename?: 'PostingContactInfo'
  emailAddress?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
}

export type PostingDetails = {
  __typename?: 'PostingDetails'
  applicationUrl: Scalars['String']['output']
  contactInfo?: Maybe<PostingContactInfo>
  description: Scalars['String']['output']
  employmentType: EmploymentTypeEnum
  jobPageUrl: Scalars['String']['output']
  organization: PostingOrganization
  salaryIndication?: Maybe<SalaryIndication>
  title: Scalars['String']['output']
  weeklyWorkingHours: PostingWeeklyWorkingHours
  workingLocation: PostingWorkingLocation
  yearsOfExperience: Scalars['Int']['output']
}

export type PostingOrganization = {
  __typename?: 'PostingOrganization'
  companyLogo: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type PostingWeeklyWorkingHours = {
  __typename?: 'PostingWeeklyWorkingHours'
  from?: Maybe<Scalars['Int']['output']>
  to: Scalars['Int']['output']
}

export type PostingWorkingLocation = {
  __typename?: 'PostingWorkingLocation'
  addressLine1: Scalars['String']['output']
  addressLine2?: Maybe<Scalars['String']['output']>
  allowsRemoteWork?: Maybe<Scalars['Int']['output']>
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export enum PreferredAnswerTypeEnum {
  AllOf = 'ALL_OF',
  AtLeastOne = 'AT_LEAST_ONE',
  None = 'NONE',
}

export type Price = {
  __typename?: 'Price'
  amount: Scalars['Float']['output']
  currency: Scalars['String']['output']
}

export type ProcessTime = {
  __typename?: 'ProcessTime'
  period: Scalars['Int']['output']
  range: Scalars['String']['output']
}

export type ProductFiltersInput = {
  includeLocationId?: InputMaybe<Scalars['String']['input']>
  industryId?: InputMaybe<Scalars['String']['input']>
  jobFunctionId?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SortByJobProductsEnum>
}

export type ProfileDetails = {
  __typename?: 'ProfileDetails'
  CandidateMedalistDesignation: Array<CandidateMedalistDesignation>
  CandidateProfileLocation: Array<CandidateProfileLocation>
  CandidateSource: Array<CandidateSource>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  phoneNumber?: Maybe<Scalars['String']['output']>
  profileLink?: Maybe<Scalars['String']['output']>
  timezone?: Maybe<Scalars['String']['output']>
}

export type ProfileDetailsInput = {
  CandidateMedalistDesignation?: InputMaybe<Array<CandidateMedalistDesignationInput>>
  CandidateProfileLocation?: InputMaybe<Array<CandidateProfileLocationInput>>
  CandidateSource?: InputMaybe<Array<CandidateSourceInput>>
  companyProvidedEmails?: InputMaybe<Array<Scalars['String']['input']>>
  id?: InputMaybe<Scalars['Int']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  profileLink?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
}

export enum ProfileTypeEnum {
  JobSeeker = 'JOB_SEEKER',
  UploadedCandidate = 'UPLOADED_CANDIDATE',
}

export type PublishEventInput = {
  data?: InputMaybe<Scalars['JSON']['input']>
  type: Scalars['String']['input']
}

export type PurchaseAiCreditsInput = {
  orderReference?: InputMaybe<Scalars['String']['input']>
  packageId: Scalars['String']['input']
}

export type Query = {
  __typename?: 'Query'
  CampaignJobFunctions?: Maybe<Array<JobFunction>>
  CheckApprovalWorkflowRequirement: ApprovalWorkflowRequirementResponse
  CheckApprovalWorkflowRequirementWithOpeningData: ApprovalWorkflowRequirementResponse
  CountApplicationForms: ApplicationFormsCount
  CountBookmarkedJob?: Maybe<CountBookmarkedJob>
  CountCalendarEvents?: Maybe<CountOutput>
  CountCandidateApplication?: Maybe<CountOutput>
  CountCandidateProfile?: Maybe<CountOutput>
  CountCandidateScorecard?: Maybe<CountOutput>
  CountCompanyInfo?: Maybe<CountOutput>
  CountCoreReport: Scalars['Int']['output']
  CountExternalJobApplication?: Maybe<CountOutput>
  CountFavoriteCoreReport: Scalars['Int']['output']
  CountJobInvite?: Maybe<CountOutput>
  CountReferrals: ReferralsCount
  CountRequisition?: Maybe<CountOutput>
  CountScheduledReport: Scalars['Int']['output']
  CountScorecardTemplate?: Maybe<CountOutput>
  CountSharedCoreReport: Scalars['Int']['output']
  CountSkills?: Maybe<CountOutput>
  GetAiCreditBalance?: Maybe<AiCreditBalance>
  GetAiCreditPackages: Array<AiCreditPackage>
  GetAiNotetakerTranscript: TranscriptResponse
  GetApplicantNotes?: Maybe<Array<ApplicantNotes>>
  GetApplicationForm?: Maybe<ApplicationForm>
  GetApprovalWorkflowInstance?: Maybe<ApprovalWorkflowInstanceDetails>
  GetApprovalWorkflowSettings?: Maybe<CompanyApprovalSetting>
  GetBookmarkedJob?: Maybe<Array<BookmarkedJobResultsType>>
  GetCalendarEvents?: Maybe<Array<CalendarEvent>>
  GetCalendarSettings?: Maybe<CalendarSettings>
  GetCampaign: JobCampaign
  GetCandidateApplication?: Maybe<Array<CandidateApplication>>
  GetCandidateApplicationPipelineView?: Maybe<Array<CandidateApplicationPipelineView>>
  GetCandidateCollaborator?: Maybe<CandidateCollaborator>
  GetCandidateFilter?: Maybe<Array<CandidateFilter>>
  GetCandidateMessage?: Maybe<CandidateMessage>
  GetCandidateOffer?: Maybe<Array<CandidateOffer>>
  GetCandidateOfferCustomField?: Maybe<Array<CandidateOfferCustomField>>
  GetCandidateOfferFile?: Maybe<Array<CandidateOfferFile>>
  GetCandidateOfferFileUrl?: Maybe<Array<GetCandidateOfferFileUrlOutput>>
  GetCandidateOfferVersionEmbeddedClaimUrl: GetCandidateOfferVersionEmbeddedClaimUrlResult
  GetCandidateProfile?: Maybe<Array<CandidateProfile>>
  GetCandidateRecommendation?: Maybe<GetCandidateRecommendationOutput>
  GetCandidateRecommendationsHighlights?: Maybe<Array<CandidateRecommendationsHighlights>>
  GetCandidateScorecard?: Maybe<Array<CandidateScorecard>>
  GetCandidateSourceNames?: Maybe<Array<CandidateSourceName>>
  GetCandidateStats?: Maybe<CandidateStats>
  GetCandidateTouchpointActivityLog?: Maybe<ActivityLog>
  GetChatUsersJSV2: Array<ChatUserInfoJs>
  GetChatUsersV2: Array<ChatUserInfo>
  GetChatsJSV2: Array<ChatInfoJs>
  GetChatsV2: Array<ChatInfo>
  GetCompanyInfo?: Maybe<Array<Company>>
  GetCompanyUserPermissions: CompanyUserPermissions
  GetCompanyUsers?: Maybe<Array<CompanyUser>>
  GetConnectedEmailSettings?: Maybe<Array<ConnectedEmailSettings>>
  GetCoreReport?: Maybe<Array<CoreReport>>
  GetCoreReportCsv?: Maybe<CoreReportCsvOutput>
  GetCoreReportData?: Maybe<CoreReportDataOutput>
  GetCustomCandidateApplicationFields?: Maybe<Array<CustomCandidateApplicationField>>
  GetCustomCandidateProfileFields?: Maybe<Array<CustomCandidateProfileField>>
  GetCustomJobRequisitionFieldValues?: Maybe<Array<CustomJobRequisitionFieldValue>>
  GetCustomJobRequisitionFields?: Maybe<Array<CustomJobRequisitionField>>
  GetCustomTalentPool: TalentPool
  GetDefaultToken?: Maybe<Array<DefaultToken>>
  GetEmailActivation: Scalars['Boolean']['output']
  GetEmailRecords?: Maybe<EmailRecordsResponse>
  GetEmailThread?: Maybe<ThreadResponse>
  GetEventSubscribers: EventSubscribersResponse
  GetEventSubscriptions: EventSubscriptionsResponse
  GetExternalJobApplication?: Maybe<Array<ExternalJobApplication>>
  GetExternalJobListing?: Maybe<ExternalJob>
  GetFavoriteCoreReport?: Maybe<Array<FavoriteCoreReport>>
  GetFeatureUsageLimit?: Maybe<AiFeatureUsageLimit>
  GetGlobalScreeningQuestions?: Maybe<Array<ScreeningQuestion>>
  GetHiringTeamMember?: Maybe<HiringTeamMember>
  GetInterviewTemplate?: Maybe<InterviewTemplate>
  GetInterviewTemplates: Array<InterviewTemplate>
  GetInterviewerPool?: Maybe<InterviewerPool>
  GetInterviewerPools?: Maybe<Array<InterviewerPool>>
  GetJobCampaignEducationLevels?: Maybe<Array<JobCampaignEducationLevel>>
  GetJobCampaignProduct?: Maybe<JobCampaignProduct>
  GetJobCampaignProducts?: Maybe<JobCampaignProducts>
  GetJobCampaignProductsById?: Maybe<JobCampaignProducts>
  GetJobCampaignSeniority: Array<JobCampaignSeniority>
  GetJobCampaigns?: Maybe<JobCampaignResponse>
  GetJobInvite?: Maybe<Array<JobInvite>>
  GetJobListing?: Maybe<Array<JobListing>>
  GetJobListingScreeningQuestion?: Maybe<Array<JobListingScreeningQuestion>>
  GetJobPipeline?: Maybe<Array<JobPipeline>>
  GetJobSearchPreference?: Maybe<JobSearchPreference>
  /** Get scheduler link settings */
  GetManySchedulerLinkSettings: Array<SchedulerLinkSettings>
  GetNotificationSettingById?: Maybe<NotificationSetting>
  GetNotificationSettingsByCompanyUserId: Array<NotificationSetting>
  /** Retrieves offer custom fields based on the provided criteria */
  GetOfferCustomField?: Maybe<Array<OfferCustomField>>
  GetOfferDocumentTemplate?: Maybe<Array<OfferDocumentTemplate>>
  GetOfferDocumentTemplateSection?: Maybe<Array<OfferDocumentTemplateSection>>
  GetOfferSectionTemplate?: Maybe<Array<OfferSectionTemplate>>
  GetOfferTemplateCondition?: Maybe<Array<OfferTemplateCondition>>
  GetOneCandidateProfile?: Maybe<CandidateProfile>
  GetOrders: Array<Order>
  GetPipelineCompanyUserView: GetPipelineCompanyUserViewResponse
  GetPlace: Place
  GetPlacesPrediction: Array<PlacePrediction>
  GetPublicJobListing?: Maybe<JobListing>
  GetRejectCandidateQuestions?: Maybe<Array<RejectCandidateQuestion>>
  GetRequisition?: Maybe<Requisition>
  GetRequisitionExtId?: Maybe<RequisitionExtId>
  GetRequisitionJobDescription?: Maybe<Array<RequisitionJobDescription>>
  GetRequisitionJobDescriptionByRequisition?: Maybe<RequisitionJobDescription>
  GetRequisitionSkill?: Maybe<RequisitionSkill>
  GetRequisitions?: Maybe<Array<Requisition>>
  GetRoles?: Maybe<Array<Role>>
  GetScalisUser?: Maybe<ScalisUser>
  GetScheduledReport?: Maybe<Array<ScheduledReport>>
  /** Get scheduler link settings */
  GetSchedulerLinkSettings?: Maybe<SchedulerLinkSettings>
  GetScorecardTemplate?: Maybe<Array<ScorecardTemplate>>
  GetScorecardTemplates?: Maybe<Array<ScorecardTemplate>>
  GetSequenceActivityLogs?: Maybe<SequenceActivityLogsResponse>
  GetSequenceById?: Maybe<Sequence>
  GetSequenceCandidateActivityLogs?: Maybe<SequenceCandidateActivityLogsResponse>
  GetSequenceCandidateEngagement?: Maybe<SequenceCandidateEngagementResponse>
  GetSequenceMetrics?: Maybe<SequenceMetricsResponse>
  GetSequenceScheduleSettings: Array<SequenceScheduleSetting>
  GetSequences?: Maybe<SequencesResponse>
  GetSharedCoreReport?: Maybe<Array<SharedCoreReport>>
  GetSkills?: Maybe<Array<Skill>>
  GetStageCollaborator?: Maybe<StageCollaborator>
  GetStageSettings?: Maybe<StageSettings>
  GetTalentPoolProspectStatus: Array<TalentPoolProspectStatus>
  GetTalentPools: TalentPoolsResponse
  GetTemplateApprovalWorkflow: TemplateApprovalWorkflow
  GetTemplateJobDescription?: Maybe<Array<TemplateJobDescription>>
  GetTemplateMessage?: Maybe<TemplateMessage>
  GetTemplateMilestone?: Maybe<TemplateMilestone>
  GetTemplatePipeline?: Maybe<TemplatePipeline>
  GetTemplateStage?: Maybe<Array<TemplateStage>>
  GetTemporaryS3Url?: Maybe<GetTemporaryS3UrlOutput>
  GetTokenTestResult?: Maybe<Array<TokenTestResult>>
  GetUploadedCandidate?: Maybe<UploadedCandidate>
  GetUploadedCandidateResumeProcessingState?: Maybe<UploadedCandidateResumeProcessingState>
  GetUserInvitations?: Maybe<Array<UserInvitation>>
  JobCampaignIndustries?: Maybe<Array<JobCampaignIndustry>>
  ListApplicationFormScreeningQuestions?: Maybe<Array<ApplicationFormScreeningQuestion>>
  ListApplicationForms: PaginatedApplicationForms
  ListCandidateEmails: Array<CandidateEmail>
  ListCandidateLabels: PaginatedCandidateLabels
  ListCandidateProfileCandidateLabels: Array<CandidateLabel>
  ListCompanyCandidateTouchpoints?: Maybe<PaginatedCompanyCandidateTouchpoints>
  ListCompanyDepartments?: Maybe<Array<CompanyDepartment>>
  ListCompanyOffices?: Maybe<Array<CompanyOffice>>
  ListCompanyUserGroups: Array<CompanyUserGroup>
  ListCustomApplicationStatuses: PaginatedCustomApplicationStatus
  ListCustomSourceCategories?: Maybe<Array<CustomSourceCategory>>
  ListDuplicateApplications?: Maybe<Array<CandidateApplication>>
  ListFieldTokens?: Maybe<ListFieldTokensResponse>
  ListGlobalScreeningQuestions?: Maybe<Array<ScreeningQuestion>>
  ListInvoices?: Maybe<ListInvoices>
  ListReferrals: Array<UploadedCandidate>
  ListSourceTrackingLinks?: Maybe<PaginatedSourceTrackingLinks>
  ListSubscriptions?: Maybe<Array<StripeSubscription>>
  ListTemplateApprovalWorkflows: PaginatedTemplateApprovalWorkflows
  ListTemplateMessages?: Maybe<Array<TemplateMessage>>
  ListTemplatePipelines?: Maybe<Array<TemplatePipeline>>
  ListTemplateScreeningQuestions: PaginatedScreeningQuestions
  Me?: Maybe<ScalisUser>
  ReferralsStats: ReferralsStats
  /** Replaces tokens in a given text with system-defined and offer-specific tokens. */
  ReplaceTokens?: Maybe<ReplaceTokensOutput>
  Search?: Maybe<SearchResult>
  SearchActivityLogsFilterContent: SearchActivityLogsFilterContentOutput
  SearchCandidatesFilterContent: SearchCandidatesFilterContentOutput
  SearchCompanyGlobal?: Maybe<Array<SearchCompanyGlobalResultType>>
  SearchJobCampaignLocations?: Maybe<Array<JobCampaignLocation>>
  SearchTalentPoolFilterContent: Array<FilterContentItem>
  getGlobalListingSetup?: Maybe<GlobalListingSetup>
}

export type QueryCheckApprovalWorkflowRequirementArgs = {
  input: CheckApprovalWorkflowRequirementInput
}

export type QueryCheckApprovalWorkflowRequirementWithOpeningDataArgs = {
  input: CheckApprovalWorkflowRequirementWithOpeningDataInput
}

export type QueryCountApplicationFormsArgs = {
  input: ListApplicationFormInput
}

export type QueryCountBookmarkedJobArgs = {
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
}

export type QueryCountCalendarEventsArgs = {
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  endTime?: InputMaybe<Scalars['DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  startTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type QueryCountCandidateApplicationArgs = {
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationStatusNotIn?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum>>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']>>
  companies?: InputMaybe<Array<Scalars['String']['input']>>
  companyId?: InputMaybe<Scalars['Int']['input']>
  creditedCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']>>
  educationLevel?: InputMaybe<Array<EducationLevelEnum>>
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  jobTitles?: InputMaybe<Array<Scalars['String']['input']>>
  lastActivity?: InputMaybe<LastActivity>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  majors?: InputMaybe<Array<Scalars['String']['input']>>
  matchScore?: InputMaybe<MatchScore>
  medalistDesignation?: InputMaybe<Array<Scalars['String']['input']>>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  profileType?: InputMaybe<ProfileTypeEnum>
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']>>
  raceEthnicity?: InputMaybe<Array<RaceEthnicityEnum>>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
  schools?: InputMaybe<Array<Scalars['String']['input']>>
  search?: InputMaybe<Scalars['String']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  sourceCategory?: InputMaybe<Array<SourceCategoryEnum>>
  sourceName?: InputMaybe<Array<Scalars['String']['input']>>
  templateMilestoneNotIn?: InputMaybe<Array<NameEnum>>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']>>
  timezones?: InputMaybe<Array<Scalars['String']['input']>>
  veteranStatus?: InputMaybe<Array<VeteranStatusEnum>>
  willingToRelocate?: InputMaybe<Array<WillingToRelocateEnum>>
  yearsOfExperience?: InputMaybe<YearsOfExperience>
}

export type QueryCountCandidateProfileArgs = {
  applicationFilters?: InputMaybe<ApplicationFiltersOnCandidateProfile>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  customCandidateProfileFields?: InputMaybe<Array<CustomCandidateProfileFieldFilter>>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
  sequenceId?: InputMaybe<Scalars['String']['input']>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCountCandidateScorecardArgs = {
  candidateApplicationIds?: InputMaybe<Array<Scalars['Int']['input']>>
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  ids?: InputMaybe<Array<Scalars['Int']['input']>>
  jobListingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']>>
  status?: InputMaybe<Array<ScorecardStatusTypeEnum>>
}

export type QueryCountCompanyInfoArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  subdomain?: InputMaybe<Scalars['String']['input']>
}

export type QueryCountCoreReportArgs = {
  coreReportName?: InputMaybe<CoreReportNameEnum>
  id?: InputMaybe<Scalars['Int']['input']>
  tab?: InputMaybe<ReportFilterTabEnum>
}

export type QueryCountExternalJobApplicationArgs = {
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Array<ExternalApplicationStatus>>
}

export type QueryCountFavoriteCoreReportArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCountJobInviteArgs = {
  inviteStatus?: InputMaybe<Array<InviteStatusEnum>>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCountReferralsArgs = {
  input?: InputMaybe<FilterReferralsInput>
}

export type QueryCountRequisitionArgs = {
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCountScheduledReportArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCountScorecardTemplateArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyTemplate?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  scorecardName?: InputMaybe<Scalars['String']['input']>
}

export type QueryCountSharedCoreReportArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryCountSkillsArgs = {
  experienceId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetAiNotetakerTranscriptArgs = {
  input: GetAiNotetakerTranscriptInput
}

export type QueryGetApplicantNotesArgs = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetApplicationFormArgs = {
  input: GetApplicationFormInput
}

export type QueryGetApprovalWorkflowInstanceArgs = {
  input: GetApprovalWorkflowInstanceInput
}

export type QueryGetBookmarkedJobArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SortByBoomarkedJob>
  sortDirection?: InputMaybe<SortDirection>
}

export type QueryGetCalendarEventsArgs = {
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  endTime?: InputMaybe<Scalars['DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortDirection?: InputMaybe<SortDirection>
  startTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type QueryGetCampaignArgs = {
  input: GetCampaignInput
}

export type QueryGetCandidateApplicationArgs = {
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationStatusNotIn?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum>>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']>>
  companies?: InputMaybe<Array<Scalars['String']['input']>>
  companyId?: InputMaybe<Scalars['Int']['input']>
  creditedCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']>>
  customApplicationStatusIds?: InputMaybe<Array<Scalars['Int']['input']>>
  customCandidateApplicationFields?: InputMaybe<Array<CustomCandidateApplicationFieldFilter>>
  customCandidateProfileFields?: InputMaybe<Array<CustomCandidateProfileFieldFilter>>
  educationLevel?: InputMaybe<Array<EducationLevelEnum>>
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  jobTitles?: InputMaybe<Array<Scalars['String']['input']>>
  labels?: InputMaybe<Array<Scalars['Int']['input']>>
  lastActivity?: InputMaybe<LastActivity>
  limit?: InputMaybe<Scalars['Int']['input']>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  majors?: InputMaybe<Array<Scalars['String']['input']>>
  matchScore?: InputMaybe<MatchScore>
  medalistDesignation?: InputMaybe<Array<Scalars['String']['input']>>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  profileType?: InputMaybe<ProfileTypeEnum>
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']>>
  raceEthnicity?: InputMaybe<Array<RaceEthnicityEnum>>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
  schools?: InputMaybe<Array<Scalars['String']['input']>>
  search?: InputMaybe<Scalars['String']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  sortBy?: InputMaybe<SortByApplication>
  sortDirection?: InputMaybe<SortDirection>
  sourceCategory?: InputMaybe<Array<SourceCategoryEnum>>
  sourceName?: InputMaybe<Array<Scalars['String']['input']>>
  templateMilestoneNotIn?: InputMaybe<Array<NameEnum>>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']>>
  timezones?: InputMaybe<Array<Scalars['String']['input']>>
  veteranStatus?: InputMaybe<Array<VeteranStatusEnum>>
  willingToRelocate?: InputMaybe<Array<WillingToRelocateEnum>>
  yearsOfExperience?: InputMaybe<YearsOfExperience>
}

export type QueryGetCandidateApplicationPipelineViewArgs = {
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationStatusNotIn?: InputMaybe<Array<ApplicationStatusEnum>>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum>>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']>>
  companies?: InputMaybe<Array<Scalars['String']['input']>>
  companyId?: InputMaybe<Scalars['Int']['input']>
  creditedCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']>>
  customApplicationStatusIds?: InputMaybe<Array<Scalars['Int']['input']>>
  customCandidateApplicationFields?: InputMaybe<Array<CustomCandidateApplicationFieldFilter>>
  customCandidateProfileFields?: InputMaybe<Array<CustomCandidateProfileFieldFilter>>
  educationLevel?: InputMaybe<Array<EducationLevelEnum>>
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingIds?: InputMaybe<Array<Scalars['Int']['input']>>
  jobTitles?: InputMaybe<Array<Scalars['String']['input']>>
  labels?: InputMaybe<Array<Scalars['Int']['input']>>
  lastActivity?: InputMaybe<LastActivity>
  limit?: InputMaybe<Scalars['Int']['input']>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  majors?: InputMaybe<Array<Scalars['String']['input']>>
  matchScore?: InputMaybe<MatchScore>
  medalistDesignation?: InputMaybe<Array<Scalars['String']['input']>>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  profileType?: InputMaybe<ProfileTypeEnum>
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']>>
  raceEthnicity?: InputMaybe<Array<RaceEthnicityEnum>>
  requisitionId: Scalars['Int']['input']
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
  schools?: InputMaybe<Array<Scalars['String']['input']>>
  search?: InputMaybe<Scalars['String']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']>>
  sortBy?: InputMaybe<SortByApplication>
  sortDirection?: InputMaybe<SortDirection>
  sourceCategory?: InputMaybe<Array<SourceCategoryEnum>>
  sourceName?: InputMaybe<Array<Scalars['String']['input']>>
  templateMilestoneNotIn?: InputMaybe<Array<NameEnum>>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']>>
  timezones?: InputMaybe<Array<Scalars['String']['input']>>
  veteranStatus?: InputMaybe<Array<VeteranStatusEnum>>
  willingToRelocate?: InputMaybe<Array<WillingToRelocateEnum>>
  yearsOfExperience?: InputMaybe<YearsOfExperience>
}

export type QueryGetCandidateCollaboratorArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetCandidateFilterArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetCandidateMessageArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetCandidateOfferArgs = {
  input: GetCandidateOfferInput
}

export type QueryGetCandidateOfferCustomFieldArgs = {
  input: GetCandidateOfferCustomFieldInput
}

export type QueryGetCandidateOfferFileArgs = {
  input: GetCandidateOfferFileUrlInput
}

export type QueryGetCandidateOfferFileUrlArgs = {
  input: GetCandidateOfferFileUrlInput
}

export type QueryGetCandidateOfferVersionEmbeddedClaimUrlArgs = {
  input: GetCandidateOfferVersionEmbeddedClaimUrlInput
}

export type QueryGetCandidateProfileArgs = {
  applicationFilters?: InputMaybe<ApplicationFiltersOnCandidateProfile>
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>
  customCandidateProfileFields?: InputMaybe<Array<CustomCandidateProfileFieldFilter>>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
  sequenceId?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortByCandidateProfile>
  sortDirection?: InputMaybe<SortDirection>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetCandidateRecommendationArgs = {
  filters?: InputMaybe<GetCandidateRecommendationInputFilters>
  jobListing?: InputMaybe<GetCandidateRecommendationInputJobListing>
  jobListingId?: InputMaybe<Scalars['String']['input']>
  pagination?: InputMaybe<GetCandidateRecommendationInputPagination>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetCandidateRecommendationsHighlightsArgs = {
  jobListing?: InputMaybe<GetCandidateRecommendationInputJobListing>
  jobListingId?: InputMaybe<Scalars['String']['input']>
  recommendations: Array<CandidateRecommendationHighlightsInput>
}

export type QueryGetCandidateScorecardArgs = {
  input: GetCandidateScorecardInput
}

export type QueryGetCandidateSourceNamesArgs = {
  input?: InputMaybe<CandidateSourceNameInput>
}

export type QueryGetCandidateStatsArgs = {
  candidateProfileId: Scalars['Int']['input']
  jobListingId: Scalars['String']['input']
}

export type QueryGetCandidateTouchpointActivityLogArgs = {
  input: GetCandidateTouchpointActivityLogInput
}

export type QueryGetCompanyInfoArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  subdomain?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetCompanyUsersArgs = {
  input?: InputMaybe<GetCompanyUsersInput>
}

export type QueryGetCoreReportArgs = {
  coreReportName?: InputMaybe<CoreReportNameEnum>
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  tab?: InputMaybe<ReportFilterTabEnum>
}

export type QueryGetCoreReportCsvArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetCoreReportDataArgs = {
  filters?: InputMaybe<Array<FilterCriteriaInput>>
  generateAvailableFilters?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetCustomCandidateApplicationFieldsArgs = {
  input?: InputMaybe<GetCustomCandidateApplicationFieldsInput>
}

export type QueryGetCustomCandidateProfileFieldsArgs = {
  input?: InputMaybe<GetCustomCandidateProfileFieldsInput>
}

export type QueryGetCustomJobRequisitionFieldValuesArgs = {
  input?: InputMaybe<GetCustomJobRequisitionFieldValuesInput>
}

export type QueryGetCustomJobRequisitionFieldsArgs = {
  input?: InputMaybe<GetCustomJobRequisitionFieldsInput>
}

export type QueryGetCustomTalentPoolArgs = {
  input: GetCustomTalentPoolInput
}

export type QueryGetDefaultTokenArgs = {
  input: GetDefaultTokenInput
}

export type QueryGetEmailActivationArgs = {
  email: Scalars['String']['input']
}

export type QueryGetEmailRecordsArgs = {
  input: GetEmailRecordsInput
}

export type QueryGetEmailThreadArgs = {
  input: GetThreadInput
}

export type QueryGetExternalJobApplicationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortByExternalApplication>
  sortDirection?: InputMaybe<SortDirection>
  status?: InputMaybe<Array<ExternalApplicationStatus>>
}

export type QueryGetExternalJobListingArgs = {
  input: GetExternalJobListingInput
}

export type QueryGetFavoriteCoreReportArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetGlobalScreeningQuestionsArgs = {
  input: GetGlobalScreeningQuestionInput
}

export type QueryGetHiringTeamMemberArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetInterviewTemplateArgs = {
  input: GetInterviewTemplateInput
}

export type QueryGetInterviewTemplatesArgs = {
  input: GetInterviewTemplatesInput
}

export type QueryGetInterviewerPoolArgs = {
  input: GetInterviewerPoolInput
}

export type QueryGetInterviewerPoolsArgs = {
  input?: InputMaybe<GetInterviewerPoolsInput>
}

export type QueryGetJobCampaignProductArgs = {
  input: JobCampaignProductInput
}

export type QueryGetJobCampaignProductsArgs = {
  input?: InputMaybe<ProductFiltersInput>
}

export type QueryGetJobCampaignProductsByIdArgs = {
  input: IdsArrayInput
}

export type QueryGetJobCampaignsArgs = {
  input?: InputMaybe<CampaignFiltersInput>
}

export type QueryGetJobInviteArgs = {
  inviteStatus?: InputMaybe<Array<InviteStatusEnum>>
  limit?: InputMaybe<Scalars['Int']['input']>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SortByJobInvite>
  sortDirection?: InputMaybe<SortDirection>
}

export type QueryGetJobListingArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  publicListingId?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetJobListingScreeningQuestionArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<SortDirection>
}

export type QueryGetJobPipelineArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  templatePipelineId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetJobSearchPreferenceArgs = {
  input?: InputMaybe<GetJobSearchPreferenceInput>
}

export type QueryGetManySchedulerLinkSettingsArgs = {
  input: GetManySchedulerLinkSettingsInput
}

export type QueryGetNotificationSettingByIdArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetNotificationSettingsByCompanyUserIdArgs = {
  input: GetNotificationSettingsByCompanyUserIdInput
}

export type QueryGetOfferCustomFieldArgs = {
  input: GetOfferCustomFieldInput
}

export type QueryGetOfferDocumentTemplateArgs = {
  input: GetOfferDocumentTemplateInput
}

export type QueryGetOfferDocumentTemplateSectionArgs = {
  input: GetOfferDocumentTemplateSectionInput
}

export type QueryGetOfferSectionTemplateArgs = {
  input: GetOfferSectionTemplateInput
}

export type QueryGetOfferTemplateConditionArgs = {
  input: GetOfferTemplateConditionInput
}

export type QueryGetOneCandidateProfileArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetOrdersArgs = {
  input: GetOrdersInput
}

export type QueryGetPipelineCompanyUserViewArgs = {
  input: GetPipelineCompanyUserViewInput
}

export type QueryGetPlaceArgs = {
  placeId: Scalars['String']['input']
}

export type QueryGetPlacesPredictionArgs = {
  input: Scalars['String']['input']
}

export type QueryGetPublicJobListingArgs = {
  publicListingId: Scalars['String']['input']
}

export type QueryGetRejectCandidateQuestionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetRequisitionArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetRequisitionJobDescriptionArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  requisitionId: Scalars['Int']['input']
}

export type QueryGetRequisitionJobDescriptionByRequisitionArgs = {
  requisitionId: Scalars['Int']['input']
}

export type QueryGetRequisitionSkillArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetRequisitionsArgs = {
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  companyId?: InputMaybe<Scalars['Int']['input']>
  companyOfficeId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  lastActivity?: InputMaybe<RequisitionLastActivity>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pipeline?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<JobStatusEnum>
}

export type QueryGetScalisUserArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetScheduledReportArgs = {
  coreReportId: Scalars['Int']['input']
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetSchedulerLinkSettingsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetScorecardTemplateArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyTemplate?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  scorecardName?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortByScorecardTemplate>
  sortDirection?: InputMaybe<SortDirection>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryGetScorecardTemplatesArgs = {
  input?: InputMaybe<GetScorecardTemplatesInput>
}

export type QueryGetSequenceActivityLogsArgs = {
  input: GetSequenceActivityLogsInput
}

export type QueryGetSequenceByIdArgs = {
  input: GetSequenceByIdInput
}

export type QueryGetSequenceCandidateActivityLogsArgs = {
  input: GetSequenceCandidateActivityLogsInput
}

export type QueryGetSequenceCandidateEngagementArgs = {
  input: GetSequenceCandidateEngagementInput
}

export type QueryGetSequenceMetricsArgs = {
  input: GetSequenceMetricsInput
}

export type QueryGetSequencesArgs = {
  input?: InputMaybe<GetSequencesInput>
}

export type QueryGetSharedCoreReportArgs = {
  coreReportId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetSkillsArgs = {
  experienceId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetStageCollaboratorArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetStageSettingsArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetTalentPoolProspectStatusArgs = {
  input?: InputMaybe<GetTalentPoolProspectStatusInput>
}

export type QueryGetTalentPoolsArgs = {
  input?: InputMaybe<GetTalentPoolsInput>
}

export type QueryGetTemplateApprovalWorkflowArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetTemplateJobDescriptionArgs = {
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetTemplateMessageArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetTemplateMilestoneArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetTemplatePipelineArgs = {
  id: Scalars['Int']['input']
}

export type QueryGetTemplateStageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  milestoneIn?: InputMaybe<Array<NameEnum>>
  milestoneNotIn?: InputMaybe<Array<NameEnum>>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetTemporaryS3UrlArgs = {
  input: GetTemporaryS3UrlInput
}

export type QueryGetTokenTestResultArgs = {
  input: GetTokenTestResultInput
}

export type QueryGetUploadedCandidateArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
  profileUrl?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetUploadedCandidateResumeProcessingStateArgs = {
  input: UploadedCandidateResumeProcessingStateInput
}

export type QueryListApplicationFormScreeningQuestionsArgs = {
  input: ListApplicationFormScreeningQuestionInput
}

export type QueryListApplicationFormsArgs = {
  input: ListApplicationFormInput
}

export type QueryListCandidateEmailsArgs = {
  input: ListCandidateEmailsInput
}

export type QueryListCandidateLabelsArgs = {
  input: ListCandidateLabelsInput
}

export type QueryListCandidateProfileCandidateLabelsArgs = {
  input: ListCandidateProfileLabelsInput
}

export type QueryListCompanyCandidateTouchpointsArgs = {
  input?: InputMaybe<ListCompanyCandidateTouchpointsInput>
}

export type QueryListCompanyDepartmentsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryListCompanyOfficesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>
}

export type QueryListCompanyUserGroupsArgs = {
  input: ListCompanyUserGroupsInput
}

export type QueryListCustomApplicationStatusesArgs = {
  input: ListCustomApplicationStatusInput
}

export type QueryListDuplicateApplicationsArgs = {
  candidateProfileId: Scalars['Int']['input']
  requisitionId: Scalars['Int']['input']
}

export type QueryListFieldTokensArgs = {
  input?: InputMaybe<FieldTokenInput>
}

export type QueryListGlobalScreeningQuestionsArgs = {
  input: ListGlobalScreeningQuestionInput
}

export type QueryListReferralsArgs = {
  input?: InputMaybe<FilterReferralsInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type QueryListSourceTrackingLinksArgs = {
  input?: InputMaybe<ListSourceTrackingLinksInput>
}

export type QueryListTemplateApprovalWorkflowsArgs = {
  input: ListTemplateApprovalWorkflowsInput
}

export type QueryListTemplateMessagesArgs = {
  input: ListTemplateMessageInput
}

export type QueryListTemplatePipelinesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryListTemplateScreeningQuestionsArgs = {
  input: ListTemplateScreeningQuestionInput
}

export type QueryReferralsStatsArgs = {
  input: FilterReferralsInput
}

export type QueryReplaceTokensArgs = {
  input: ReplaceTokensInput
}

export type QuerySearchArgs = {
  companyAlias?: InputMaybe<Array<Scalars['String']['input']>>
  companyHeadcount?: InputMaybe<Array<CompanyHeadcountEnum>>
  companyId?: InputMaybe<Array<Scalars['String']['input']>>
  department?: InputMaybe<Array<Scalars['String']['input']>>
  educationLevel?: InputMaybe<Array<EducationLevelPrefEnum>>
  employment?: InputMaybe<Array<JobTypeEnum>>
  experienceLevel?: InputMaybe<Array<JobLevelEnum>>
  id?: InputMaybe<Array<Scalars['String']['input']>>
  industry?: InputMaybe<Array<Scalars['String']['input']>>
  isScalis?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  payment?: InputMaybe<Array<PayTypeEnum>>
  postedAt?: InputMaybe<PostedAtEnum>
  salary?: InputMaybe<SalaryInputType>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SearchSortEnum>
  source?: InputMaybe<Array<SourceTypeEnum>>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  workplace?: InputMaybe<Array<LocationTypeEnum>>
}

export type QuerySearchActivityLogsFilterContentArgs = {
  input: SearchActivityLogsFilterContentInput
}

export type QuerySearchCandidatesFilterContentArgs = {
  filterType: FilterContentTypeEnum
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  publicListingId?: InputMaybe<Scalars['String']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  search: Scalars['String']['input']
}

export type QuerySearchCompanyGlobalArgs = {
  id?: InputMaybe<Scalars['String']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QuerySearchJobCampaignLocationsArgs = {
  input: SearchJobCampaignLocationsInput
}

export type QuerySearchTalentPoolFilterContentArgs = {
  filterType: FilterContentTypeEnum
  search: Scalars['String']['input']
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}

export type QueryGetGlobalListingSetupArgs = {
  companyId: Scalars['Int']['input']
}

export enum QuestionTypeEnum {
  File = 'FILE',
  FreeResponse = 'FREE_RESPONSE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  MultipleSelect = 'MULTIPLE_SELECT',
  Numerical = 'NUMERICAL',
  Url = 'URL',
  YesNo = 'YES_NO',
}

export enum RaceEthnicityEnum {
  AmericanIndianOrAlaskaNative = 'AMERICAN_INDIAN_OR_ALASKA_NATIVE',
  Asian = 'ASIAN',
  BlackOrAfricanAmerican = 'BLACK_OR_AFRICAN_AMERICAN',
  DeclineToSelfIdentify = 'DECLINE_TO_SELF_IDENTIFY',
  HispanicOrLatino = 'HISPANIC_OR_LATINO',
  NativeHawaiianOrOtherPacificIslander = 'NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER',
  TwoOrMoreRaces = 'TWO_OR_MORE_RACES',
  White = 'WHITE',
}

export type RecruiterInfo = {
  __typename?: 'RecruiterInfo'
  emailAddress?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export enum Recurrence {
  ScalisMonthly = 'scalis_monthly',
  ScalisYearly = 'scalis_yearly',
}

export type ReferCandidateInput = {
  creditCompanyUserId?: InputMaybe<Scalars['Int']['input']>
  documents?: InputMaybe<Array<Scalars['String']['input']>>
  emailAddress?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  jobListingId: Scalars['Int']['input']
  lastName: Scalars['String']['input']
  linkedinProfile?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  sourceNameId: Scalars['Int']['input']
  sourceStrategy?: InputMaybe<Scalars['Int']['input']>
}

export type ReferralsCount = {
  __typename?: 'ReferralsCount'
  count: Scalars['Int']['output']
}

export type ReferralsStats = {
  __typename?: 'ReferralsStats'
  myReferrals: Scalars['Int']['output']
  totalReferrals: Scalars['Int']['output']
  totalReferralsByMilestone: Scalars['JSON']['output']
}

export type RejectCandaditesQuestionInput = {
  questionId: Scalars['Int']['input']
  score: Scalars['Int']['input']
}

export type RejectCandidateQuestion = {
  __typename?: 'RejectCandidateQuestion'
  id: Scalars['Int']['output']
  question?: Maybe<Scalars['String']['output']>
  required?: Maybe<Scalars['Boolean']['output']>
  sequence?: Maybe<Scalars['Int']['output']>
}

export type RejectCandidatesInput = {
  applicationIds: Array<Scalars['Int']['input']>
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  customMessage?: InputMaybe<Scalars['String']['input']>
  details?: InputMaybe<Scalars['String']['input']>
  medalistDesignation: Scalars['String']['input']
  notifyCandidate?: InputMaybe<Scalars['Boolean']['input']>
  questions: Array<RejectCandaditesQuestionInput>
  reason?: InputMaybe<RejectionReasonEnum>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type RejectCandidatesResponse = {
  __typename?: 'RejectCandidatesResponse'
  applicationIds: Array<Scalars['Int']['output']>
  jobId: Scalars['String']['output']
}

export enum RejectionReasonEnum {
  BetterQualifiedCandidatesChosenEducation = 'BETTER_QUALIFIED_CANDIDATES_CHOSEN_EDUCATION',
  BetterQualifiedCandidatesChosenExperience = 'BETTER_QUALIFIED_CANDIDATES_CHOSEN_EXPERIENCE',
  BetterQualifiedCandidatesChosenSkills = 'BETTER_QUALIFIED_CANDIDATES_CHOSEN_SKILLS',
  CandidateAppliedToWrongPosition = 'CANDIDATE_APPLIED_TO_WRONG_POSITION',
  CandidateWithdrawn = 'CANDIDATE_WITHDRAWN',
  DeclinedInterview = 'DECLINED_INTERVIEW',
  DoesntMeetMinimumQualifications = 'DOESNT_MEET_MINIMUM_QUALIFICATIONS',
  DuplicateApplication = 'DUPLICATE_APPLICATION',
  FailedAssessment = 'FAILED_ASSESSMENT',
  FailedBackgroundCheck = 'FAILED_BACKGROUND_CHECK',
  FailedDrugTest = 'FAILED_DRUG_TEST',
  FailedToCompleteRequiredAssessment = 'FAILED_TO_COMPLETE_REQUIRED_ASSESSMENT',
  FailedToRespond = 'FAILED_TO_RESPOND',
  ImpracticalJobExpectations = 'IMPRACTICAL_JOB_EXPECTATIONS',
  InflatedResponsibilities = 'INFLATED_RESPONSIBILITIES',
  InterviewNoShow = 'INTERVIEW_NO_SHOW',
  JobNotAlignedWithCareerObjectives = 'JOB_NOT_ALIGNED_WITH_CAREER_OBJECTIVES',
  LackedClarityInAnswers = 'LACKED_CLARITY_IN_ANSWERS',
  LackedSpecificTechnicalKnowledge = 'LACKED_SPECIFIC_TECHNICAL_KNOWLEDGE',
  LackOfRelevantExperience = 'LACK_OF_RELEVANT_EXPERIENCE',
  LackOfRelevantSkillsAndAbilities = 'LACK_OF_RELEVANT_SKILLS_AND_ABILITIES',
  LimitedAvailabilityOrSchedulingConflicts = 'LIMITED_AVAILABILITY_OR_SCHEDULING_CONFLICTS',
  MissingRequiredCertifications = 'MISSING_REQUIRED_CERTIFICATIONS',
  NegativeReferences = 'NEGATIVE_REFERENCES',
  OfferRejectedDoesntMeetSalaryExpectations = 'OFFER_REJECTED_DOESNT_MEET_SALARY_EXPECTATIONS',
  OfferRejectedJobLocation = 'OFFER_REJECTED_JOB_LOCATION',
  OfferRejectedJobSchedule = 'OFFER_REJECTED_JOB_SCHEDULE',
  OfferRejectedOther = 'OFFER_REJECTED_OTHER',
  Other = 'OTHER',
  OverqualifiedForPosition = 'OVERQUALIFIED_FOR_POSITION',
  PoorCommunicationSkills = 'POOR_COMMUNICATION_SKILLS',
  PoorInterviewPerformance = 'POOR_INTERVIEW_PERFORMANCE',
  PositionAlreadyFilled = 'POSITION_ALREADY_FILLED',
  PositionEliminated = 'POSITION_ELIMINATED',
  PositionOnHold = 'POSITION_ON_HOLD',
  RequiresVisaSponsorship = 'REQUIRES_VISA_SPONSORSHIP',
  SalaryExpectationsTooHigh = 'SALARY_EXPECTATIONS_TOO_HIGH',
  UnableToRelocateAsRequired = 'UNABLE_TO_RELOCATE_AS_REQUIRED',
  UnprofessionalBehaviorDuringHiringProcess = 'UNPROFESSIONAL_BEHAVIOR_DURING_HIRING_PROCESS',
}

export enum RelocationTypePreferenceEnum {
  No = 'NO',
  SpecificAreas = 'SPECIFIC_AREAS',
  Yes = 'YES',
}

export enum ReminderMethodEnum {
  Display = 'display',
  Email = 'email',
  Popup = 'popup',
  Sound = 'sound',
}

export type RemoveCandidatesFromSequenceInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  sequenceId: Scalars['String']['input']
}

export type RemoveInterviewTemplateInterviewerInput = {
  companyUserId: Scalars['Int']['input']
  interviewTemplateId: Scalars['Int']['input']
}

export type RemoveInterviewerPoolMemberInput = {
  companyUserId: Scalars['Int']['input']
  interviewerPoolId: Scalars['Int']['input']
}

export type RemoveSavedViewInput = {
  companyId: Scalars['Int']['input']
  companyUserId: Scalars['Int']['input']
  id: Scalars['Int']['input']
}

export type RemoveSavedViewResponse = {
  __typename?: 'RemoveSavedViewResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type RemoveSkillFromExperienceInput = {
  experienceId: Scalars['Int']['input']
  jobSeekerSkillId: Scalars['Int']['input']
}

export enum RepeatDaysOfWeekEnum {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED',
}

export enum RepeatTypeEnum {
  Custom = 'CUSTOM',
  Daily = 'DAILY',
  EveryWeekday = 'EVERY_WEEKDAY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export enum RepeatsEnum {
  Annually = 'ANNUALLY',
  Daily = 'DAILY',
  DoesNotRepeat = 'DOES_NOT_REPEAT',
  EveryWeekday = 'EVERY_WEEKDAY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
}

export type ReplaceTokensInput = {
  /** Candidate application ID */
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  /** Candidate offer ID */
  candidateOfferId?: InputMaybe<Scalars['Int']['input']>
  /** Candidate offer version ID */
  candidateOfferVersionId?: InputMaybe<Scalars['Int']['input']>
  /** Candidate profile ID */
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  /** Company user ID */
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  /** Text to replace tokens in */
  text: Scalars['String']['input']
}

export type ReplaceTokensOutput = {
  __typename?: 'ReplaceTokensOutput'
  customFieldTokensNotAvailable?: Maybe<Array<Scalars['String']['output']>>
  defaultTokensNotAvailable?: Maybe<Array<TokenNameEnum>>
  offerCustomTokensNotAvailable?: Maybe<Array<Scalars['String']['output']>>
  result: Scalars['String']['output']
}

export enum ReportFilterTabEnum {
  Default = 'DEFAULT',
  Favorite = 'FAVORITE',
  Scheduled = 'SCHEDULED',
  Shared = 'SHARED',
}

export enum ReportSchedulerTypeEnum {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING',
}

export type Requisition = {
  __typename?: 'Requisition'
  Campaigns?: Maybe<JobCampaignResponse>
  CandidateCollaborator?: Maybe<Array<CandidateCollaborator>>
  Company?: Maybe<Company>
  CompanyDepartment?: Maybe<CompanyDepartment>
  CompanyOffice?: Maybe<CompanyOffice>
  CompanyUser?: Maybe<CompanyUser>
  CustomCandidateApplicationFieldRequisition?: Maybe<Array<CustomCandidateApplicationFieldRequisition>>
  CustomCandidateProfileField?: Maybe<Array<CustomCandidateProfileField>>
  CustomJobRequisitionFieldValue?: Maybe<Array<CustomJobRequisitionFieldValue>>
  HiringTeamMember?: Maybe<Array<HiringTeamMember>>
  JobListing?: Maybe<Array<JobListing>>
  JobOpening?: Maybe<Array<JobOpening>>
  JobPipeline?: Maybe<JobPipeline>
  Orders?: Maybe<Array<Order>>
  PrimaryContactCompanyUser?: Maybe<CompanyUser>
  RequisitionJobDescription?: Maybe<Array<RequisitionJobDescription>>
  RequisitionSkills?: Maybe<Array<RequisitionSkill>>
  StageCollaborator?: Maybe<Array<StageCollaborator>>
  additionalComp?: Maybe<Scalars['JSON']['output']>
  benefits?: Maybe<Scalars['JSON']['output']>
  collegeGradPref?: Maybe<Scalars['Boolean']['output']>
  companyDepartmentId?: Maybe<Scalars['Int']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  companyOfficeId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  diverseHirePref?: Maybe<Scalars['Boolean']['output']>
  educationLevelPref?: Maybe<EducationLevelPrefEnum>
  extRequisitionId?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isIncomplete: Scalars['Boolean']['output']
  jobLevel?: Maybe<JobLevelEnum>
  jobName?: Maybe<Scalars['String']['output']>
  jobStatus?: Maybe<JobStatusEnum>
  jobType?: Maybe<JobTypeEnum>
  locationDistancePref?: Maybe<Scalars['Int']['output']>
  maxPay?: Maybe<Scalars['Float']['output']>
  minPay?: Maybe<Scalars['Float']['output']>
  nonTraditionalPref?: Maybe<Scalars['Boolean']['output']>
  openedAt?: Maybe<Scalars['DateTime']['output']>
  payType?: Maybe<PayTypeEnum>
  primaryContact?: Maybe<Scalars['Int']['output']>
  teamSize?: Maybe<TeamSizeEnum>
  travelType?: Maybe<TravelTypeEnum>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  veteranPref?: Maybe<Scalars['Boolean']['output']>
  yearsOfExperiencePref?: Maybe<YearsOfExperienceEnum>
}

export type RequisitionCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}

export type RequisitionExtId = {
  __typename?: 'RequisitionExtId'
  Company?: Maybe<Company>
  companyId?: Maybe<Scalars['Int']['output']>
  extId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
}

export type RequisitionJobDescription = {
  __typename?: 'RequisitionJobDescription'
  candidateCollaborator?: Maybe<Array<CandidateCollaborator>>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  hiringTeamMember?: Maybe<Array<HiringTeamMember>>
  id: Scalars['ID']['output']
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  stageCollaborator?: Maybe<Array<StageCollaborator>>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type RequisitionLastActivity = {
  from: Scalars['DateTime']['input']
  to: Scalars['DateTime']['input']
}

export type RequisitionSkill = {
  __typename?: 'RequisitionSkill'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  displayName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  level?: Maybe<Scalars['String']['output']>
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  sequenceNumber?: Maybe<Scalars['Int']['output']>
  skill?: Maybe<Skill>
  skillId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  yearsOfExp?: Maybe<Scalars['Int']['output']>
}

export type RequisitionSkillInput = {
  displayName?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>
  skillId?: InputMaybe<Scalars['Int']['input']>
  yearsOfExp?: InputMaybe<Scalars['Int']['input']>
}

export type RequisitionTalentPoolCompanySavedView = {
  __typename?: 'RequisitionTalentPoolCompanySavedView'
  belongsToCurrentRequisition: Scalars['Boolean']['output']
  company: Company
  companyId: Scalars['Int']['output']
  companySavedView: CompanySavedView
  companySavedViewId: Scalars['Int']['output']
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  companyUserViews: Array<CompanyUserView>
  createdAt: Scalars['DateTime']['output']
  hasPinnedSavedViewForCurrentRequisition: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  isPinned: Scalars['Boolean']['output']
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  talentPool?: Maybe<TalentPool>
  talentPoolId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
  wasRemovedForCurrentUser: Scalars['Boolean']['output']
}

export type ResendEmailVerificationInput = {
  email: Scalars['String']['input']
}

export type ResendResetPasswordEmailInput = {
  id: Scalars['Int']['input']
}

export type ResendSchedulerLinkInviteInput = {
  inviteId: Scalars['Int']['input']
}

export type ResetPasswordInput = {
  code: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type ResolveDuplicateApplicationsInput = {
  /** The IDs of the applications to hide */
  hideApplcationIds: Array<Scalars['Int']['input']>
  /** The ID of the application to keep */
  keepApplicationId: Scalars['Int']['input']
}

export type Role = {
  __typename?: 'Role'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export enum RoleEnum {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  HiringManager = 'HIRING_MANAGER',
  HiringTeamMember = 'HIRING_TEAM_MEMBER',
  JobViewer = 'JOB_VIEWER',
  Member = 'MEMBER',
  Recruiter = 'RECRUITER',
  ScalisAdmin = 'SCALIS_ADMIN',
  StageCollaborator = 'STAGE_COLLABORATOR',
  SuperAdmin = 'SUPER_ADMIN',
}

export enum RoleTypeEnum {
  CaretakingAndFamilyResponsibilities = 'CARETAKING_AND_FAMILY_RESPONSIBILITIES',
  Freelance = 'FREELANCE',
  GigEconomyJobs = 'GIG_ECONOMY_JOBS',
  ResearchAndAcademicProjects = 'RESEARCH_AND_ACADEMIC_PROJECTS',
  TravelAndExchangePrograms = 'TRAVEL_AND_EXCHANGE_PROGRAMS',
  VolunteerWork = 'VOLUNTEER_WORK',
}

export type SalaryIndication = {
  __typename?: 'SalaryIndication'
  period: SalaryPeriod
  range?: Maybe<JobCampaignSalaryRange>
}

export type SalaryInputType = {
  currency?: InputMaybe<Scalars['String']['input']>
  max?: InputMaybe<Scalars['Int']['input']>
  min?: InputMaybe<Scalars['Int']['input']>
}

export enum SalaryPeriod {
  Hourly = 'hourly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export type SalaryRange = {
  __typename?: 'SalaryRange'
  currency: Scalars['String']['output']
  max: Scalars['Int']['output']
  min: Scalars['Int']['output']
}

export type SalaryType = {
  __typename?: 'SalaryType'
  currency?: Maybe<Scalars['String']['output']>
  max?: Maybe<Scalars['Float']['output']>
  min?: Maybe<Scalars['Float']['output']>
}

export type ScalisSubscription = {
  __typename?: 'ScalisSubscription'
  clientSecret: Scalars['String']['output']
  status: Scalars['String']['output']
  subscriptionId: Scalars['String']['output']
}

export enum ScalisSystemFeatureEnum {
  AddSequenceStep = 'ADD_SEQUENCE_STEP',
  AdvanceCandidate = 'ADVANCE_CANDIDATE',
  CreateCandidateApplication = 'CREATE_CANDIDATE_APPLICATION',
  GenerateOfferDocument = 'GENERATE_OFFER_DOCUMENT',
  InviteCandidateToApply = 'INVITE_CANDIDATE_TO_APPLY',
  RejectCandidate = 'REJECT_CANDIDATE',
  SendCandidateOffer = 'SEND_CANDIDATE_OFFER',
  SendEmailToCandidateProfile = 'SEND_EMAIL_TO_CANDIDATE_PROFILE',
  SendSchedulerLinkInvite = 'SEND_SCHEDULER_LINK_INVITE',
}

export type ScalisUser = {
  __typename?: 'ScalisUser'
  Achievement?: Maybe<Array<Achievement>>
  Address?: Maybe<Array<Address>>
  CertificateOrLicense?: Maybe<Array<CertificateOrLicense>>
  ContactInfo?: Maybe<Array<ContactInfo>>
  DemographicInfo?: Maybe<Array<DemographicInfo>>
  Education?: Maybe<Array<Education>>
  EmailVerification?: Maybe<Array<EmailVerification>>
  Experience?: Maybe<Array<Experience>>
  ExperienceTenure?: Maybe<ExperienceTenure>
  JobSeekerHeader?: Maybe<Array<JobSeekerHeader>>
  JobSeekerInfo?: Maybe<JobSeekerInfo>
  JobSeekerSkill?: Maybe<Array<JobSeekerSkills>>
  ScalisUserUploadedDocument?: Maybe<Array<ScalisUserUploadedDocument>>
  UserInvitation?: Maybe<Array<UserInvitation>>
  UserSubscription?: Maybe<Array<UserSubscription>>
  VolunteerWork?: Maybe<Array<VolunteerWork>>
  WebsiteOrSocialMedia?: Maybe<Array<WebsiteOrSocialMedia>>
  activeStatus?: Maybe<Scalars['Boolean']['output']>
  completedAt?: Maybe<Scalars['DateTime']['output']>
  currentStage?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
  profileImage?: Maybe<Scalars['String']['output']>
}

export type ScalisUserEducationArgs = {
  highestEducation?: InputMaybe<Scalars['Boolean']['input']>
}

export type ScalisUserExperienceArgs = {
  onlyCurrentJob?: InputMaybe<Scalars['Boolean']['input']>
  onlyMostRecentJob?: InputMaybe<Scalars['Boolean']['input']>
}

export type ScalisUserUploadedDocument = {
  __typename?: 'ScalisUserUploadedDocument'
  createdAt: Scalars['DateTime']['output']
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  documentName?: Maybe<Scalars['String']['output']>
  documentPath?: Maybe<Scalars['String']['output']>
  documentType: DocumentTypeEnum
  id: Scalars['Int']['output']
  scalisUserId: Scalars['Int']['output']
}

export type ScheduledReport = {
  __typename?: 'ScheduledReport'
  CompanyUser: CompanyUser
  CoreReport: CoreReport
  companyUserId: Scalars['Int']['output']
  coreReportId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  cronExpression?: Maybe<Scalars['String']['output']>
  customDaysOfWeek?: Maybe<Scalars['JSON']['output']>
  customTime?: Maybe<Scalars['String']['output']>
  deleted?: Maybe<Scalars['DateTime']['output']>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  recipients: Scalars['JSON']['output']
  repeat?: Maybe<RepeatTypeEnum>
  reportSchedulerType: ReportSchedulerTypeEnum
  startDate?: Maybe<Scalars['DateTime']['output']>
  taskId: Scalars['String']['output']
  taskObject?: Maybe<Scalars['JSON']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type SchedulerLinkInvite = {
  __typename?: 'SchedulerLinkInvite'
  Calendar?: Maybe<Calendar>
  CandidateApplication?: Maybe<CandidateApplication>
  CompanyUser?: Maybe<CompanyUser>
  TemplateStage?: Maybe<TemplateStage>
  applicationId: Scalars['Int']['output']
  calendarId: Scalars['Int']['output']
  candidateData?: Maybe<Scalars['JSON']['output']>
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  durationMinutes?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  interviewData?: Maybe<Scalars['JSON']['output']>
  message?: Maybe<Scalars['String']['output']>
  nylasConfigurationId: Scalars['String']['output']
  stageId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type SchedulerLinkSessionOutput = {
  __typename?: 'SchedulerLinkSessionOutput'
  session_id: Scalars['String']['output']
}

export type SchedulerLinkSettings = {
  __typename?: 'SchedulerLinkSettings'
  CompanyUser: CompanyUser
  companyUserId: Scalars['Int']['output']
  id: Scalars['ID']['output']
  maxInterviewsPerDay: Scalars['Int']['output']
  minimumHour: Scalars['Int']['output']
  rollingDays: Scalars['Int']['output']
}

export enum SchedulingLogicEnum {
  Loop = 'LOOP',
  OneOnOne = 'ONE_ON_ONE',
  Panel = 'PANEL',
  SelfScheduling = 'SELF_SCHEDULING',
}

/** Score details information */
export type ScoreDetails = {
  __typename?: 'ScoreDetails'
  exactMatch?: Maybe<Scalars['Boolean']['output']>
  explanation?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  similarTo?: Maybe<Scalars['String']['output']>
  verifiedFrom?: Maybe<Scalars['String']['output']>
}

export type ScoreDetailsEventInput = {
  evidence?: InputMaybe<Scalars['String']['input']>
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>
  explanation?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  similarTo?: InputMaybe<Scalars['String']['input']>
  verifiedFrom?: InputMaybe<Scalars['String']['input']>
}

/** Score details input */
export type ScoreDetailsInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ScoreInput = {
  highlights?: InputMaybe<Array<HighlightInput>>
  overall?: InputMaybe<Scalars['Float']['input']>
  sections: Array<ScoreSectionsInput>
}

export type ScoreSectionsInput = {
  details?: InputMaybe<Array<ScoreDetailsEventInput>>
  name?: InputMaybe<Scalars['String']['input']>
  score?: InputMaybe<Scalars['Float']['input']>
}

export enum ScorecardQuestionTypeEnum {
  Checkboxes = 'CHECKBOXES',
  Date = 'DATE',
  FreeResponse = 'FREE_RESPONSE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Numerical = 'NUMERICAL',
  YesNo = 'YES_NO',
}

export enum ScorecardStatusTypeEnum {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
}

export type ScorecardTemplate = {
  __typename?: 'ScorecardTemplate'
  CandidateScorecard: Array<CandidateScorecard>
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  ScorecardTemplateSection: Array<ScorecardTemplateSection>
  StageSettings: Array<StageSettings>
  archived?: Maybe<Scalars['Boolean']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  companyTemplate?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  department?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  scorecardDescription?: Maybe<Scalars['String']['output']>
  scorecardName?: Maybe<Scalars['String']['output']>
  timestampAt?: Maybe<Scalars['DateTime']['output']>
  visible?: Maybe<Scalars['Boolean']['output']>
}

export type ScorecardTemplateQuestion = {
  __typename?: 'ScorecardTemplateQuestion'
  CandidateScorecardAnswers?: Maybe<Array<CandidateScorecardAnswers>>
  ScorecardTemplateSection?: Maybe<ScorecardTemplateSection>
  Skill?: Maybe<Skill>
  answerOptions?: Maybe<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  preferredAnswer?: Maybe<Scalars['String']['output']>
  questionDescription?: Maybe<Scalars['String']['output']>
  questionText?: Maybe<Scalars['String']['output']>
  questionType?: Maybe<ScorecardQuestionTypeEnum>
  scoreAnswer?: Maybe<Scalars['Boolean']['output']>
  scorecardTemplateSectionId?: Maybe<Scalars['Int']['output']>
  skillDisplayName?: Maybe<Scalars['String']['output']>
  skillId?: Maybe<Scalars['Int']['output']>
}

export type ScorecardTemplateQuestionInput = {
  ScorecardTemplateSkill?: InputMaybe<ScorecardTemplateSkillInput>
  answerOptions?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  preferredAnswer?: InputMaybe<Scalars['String']['input']>
  questionDescription?: InputMaybe<Scalars['String']['input']>
  questionText: Scalars['String']['input']
  questionType: ScorecardQuestionTypeEnum
  scorecardTemplateSectionId?: InputMaybe<Scalars['Int']['input']>
  skillDisplayName?: InputMaybe<Scalars['String']['input']>
  skillId?: InputMaybe<Scalars['Int']['input']>
}

export type ScorecardTemplateSection = {
  __typename?: 'ScorecardTemplateSection'
  ScorecardTemplate?: Maybe<ScorecardTemplate>
  ScorecardTemplateQuestion: Array<ScorecardTemplateQuestion>
  id: Scalars['ID']['output']
  rankOrder?: Maybe<Scalars['Int']['output']>
  scorecardTemplateId?: Maybe<Scalars['Int']['output']>
  sectionName?: Maybe<Scalars['String']['output']>
  sectionType?: Maybe<SectionTypeEnum>
}

export type ScorecardTemplateSectionInput = {
  ScorecardTemplateQuestions?: InputMaybe<Array<ScorecardTemplateQuestionInput>>
  id?: InputMaybe<Scalars['Int']['input']>
  rankOrder: Scalars['Int']['input']
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
  sectionName: Scalars['String']['input']
  sectionType: SectionTypeEnum
}

export type ScorecardTemplateSkillInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  yearsOfExp?: InputMaybe<Scalars['Int']['input']>
}

/** A screening question used to evaluate job candidates */
export type ScreeningQuestion = {
  __typename?: 'ScreeningQuestion'
  /** The company that owns this screening question */
  Company?: Maybe<Company>
  /** The company user who created this screening question */
  CompanyUser?: Maybe<CompanyUser>
  /** Relation to job listings that use this screening question */
  JobListingScreeningQuestion?: Maybe<Array<JobListingScreeningQuestion>>
  /** Related template message for rejection */
  TemplateMessage?: Maybe<TemplateMessage>
  /** Comma-separated list of answer options for MULTIPLE_CHOICE or MULTIPLE_SELECT questions */
  ansOptions?: Maybe<Scalars['String']['output']>
  /** Foreign key to the Company that owns this question */
  companyId?: Maybe<Scalars['Int']['output']>
  /** Foreign key to the CompanyUser who created this question */
  companyUserId?: Maybe<Scalars['Int']['output']>
  /** Timestamp when the question was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>
  createdBy?: Maybe<CreatedByUser>
  globalQuestionOrder?: Maybe<Scalars['Int']['output']>
  /** Unique identifier for the screening question */
  id: Scalars['ID']['output']
  isActiveGlobally?: Maybe<Scalars['Boolean']['output']>
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  isEdited?: Maybe<Scalars['Boolean']['output']>
  isGlobalQuestion?: Maybe<Scalars['Boolean']['output']>
  /** If true, answering incorrectly will trigger automatic rejection */
  isRejectionQuestion?: Maybe<Scalars['Boolean']['output']>
  isReplacedBy?: Maybe<Scalars['Int']['output']>
  /** If true, this is a reusable template question */
  isTemplateQuestion?: Maybe<Scalars['Boolean']['output']>
  /** For NUMERICAL questions, the maximum acceptable value */
  maxVal?: Maybe<Scalars['Int']['output']>
  /** For NUMERICAL questions, the minimum acceptable value */
  minVal?: Maybe<Scalars['Int']['output']>
  /** Array of preferred answers for MULTIPLE_SELECT questions */
  multipleSelectPreferredAnswers?: Maybe<Scalars['JSON']['output']>
  /** For YES_NO and MULTIPLE_CHOICE: the correct/preferred answer(s) as comma-separated values */
  preferredAnswer?: Maybe<Scalars['String']['output']>
  /** For MULTIPLE_SELECT: determines if ALL_OF or ANY_OF the preferred answers are required */
  preferredAnswerType?: Maybe<PreferredAnswerTypeEnum>
  /** Additional description or context to help candidates understand the question */
  questionDesc?: Maybe<Scalars['String']['output']>
  /** The main text of the screening question shown to candidates */
  questionTitle?: Maybe<Scalars['String']['output']>
  /** Type of question that determines the input type and validation rules */
  questionType?: Maybe<QuestionTypeEnum>
  /** Custom message to display when a candidate is rejected based on this question */
  rejectMessage?: Maybe<Scalars['String']['output']>
  /** Controls how selection options are displayed to the user */
  selectionDisplay?: Maybe<SelectionDisplayEnum>
  /** Reference to a template message for rejection */
  templateMessageId?: Maybe<Scalars['Int']['output']>
  /** Timestamp when the question was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  /** Status related to validation of numerical values */
  valStatus?: Maybe<Scalars['String']['output']>
}

export type ScreeningQuestionAnswer = {
  __typename?: 'ScreeningQuestionAnswer'
  CandidateApplication?: Maybe<CandidateApplication>
  UploadedDocumentCandidateApplication?: Maybe<UploadedDocumentCandidateApplication>
  answer?: Maybe<Scalars['String']['output']>
  answerStatus?: Maybe<Scalars['Boolean']['output']>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  listingScreeningQuestionId?: Maybe<Scalars['Int']['output']>
  multipleSelectAnswers?: Maybe<Scalars['JSON']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  uploadedDocumentCandidateApplicationId?: Maybe<Scalars['Int']['output']>
}

export type ScreeningQuestionAnswerInput = {
  answer: Scalars['String']['input']
  listingScreeningQuestionId: Scalars['Int']['input']
}

export enum ScreeningQuestionSortFields {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  IsRejectionQuestion = 'isRejectionQuestion',
  QuestionDesc = 'questionDesc',
  QuestionTitle = 'questionTitle',
  QuestionType = 'questionType',
  UpdatedAt = 'updatedAt',
}

export type ScreeningQuestionsAnswersInput = {
  answer: Scalars['String']['input']
  documentName?: InputMaybe<Scalars['String']['input']>
  documentPath?: InputMaybe<Scalars['String']['input']>
  listingScreeningQuestionId: Scalars['Int']['input']
  multipleSelectAnswers?: InputMaybe<Array<Scalars['String']['input']>>
}

export type SearchActivityLogsFilterContentInput = {
  filterType: ActivityLogsFilterContentTypeEnum
  search: Scalars['String']['input']
  sequenceId: Scalars['String']['input']
}

export type SearchActivityLogsFilterContentOutput = {
  __typename?: 'SearchActivityLogsFilterContentOutput'
  filterContent?: Maybe<Array<ActivityLogsFilterContentItem>>
}

export type SearchCandidatesFilterContentOutput = {
  __typename?: 'SearchCandidatesFilterContentOutput'
  filterContent?: Maybe<Array<FilterContentItem>>
}

export type SearchCompanyGlobalResultType = {
  __typename?: 'SearchCompanyGlobalResultType'
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  logo?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
}

export type SearchJobCampaignLocationsInput = {
  text: Scalars['String']['input']
}

export type SearchResult = {
  __typename?: 'SearchResult'
  count: Scalars['Int']['output']
  filters: Array<FiltersType>
  results: Array<JobSearchResultType>
}

export enum SearchSortEnum {
  SortBestMatch = 'SORT_BEST_MATCH',
  SortNearest = 'SORT_NEAREST',
  SortNewest = 'SORT_NEWEST',
  SortOldest = 'SORT_OLDEST',
}

/** Section information */
export type Section = {
  __typename?: 'Section'
  details?: Maybe<Array<ScoreDetails>>
  name?: Maybe<Scalars['String']['output']>
  score?: Maybe<Scalars['Float']['output']>
}

/** Section input for recommendations */
export type SectionInput = {
  details?: InputMaybe<Array<ScoreDetailsInput>>
  name: Scalars['String']['input']
  score: Scalars['Float']['input']
}

export enum SectionTypeEnum {
  Questions = 'QUESTIONS',
  Skills = 'SKILLS',
}

/** Get candidate recommendation input job listing */
export type SelectRecommendedCandidateInput = {
  candidateIds: Array<Scalars['String']['input']>
  entityId: Scalars['String']['input']
  entityType: SelectRecommendedCandidateInputEntityTypeEnum
  inviteCandidateToApplyInput?: InputMaybe<InviteCandidatesToApplyWithoutProfileIdsInput>
  sourceCandidate: CandidateRecommendationSourceEnumType
}

export enum SelectRecommendedCandidateInputEntityTypeEnum {
  JobListing = 'JOB_LISTING',
  Sequence = 'SEQUENCE',
  TalentPool = 'TALENT_POOL',
}

export enum SelectionDisplayEnum {
  Dropdown = 'DROPDOWN',
  Picklist = 'PICKLIST',
}

export type SendCandidateOfferInput = {
  candidateOfferId: Scalars['Int']['input']
  customEmailSender?: InputMaybe<CustomEmailSenderInput>
  customMessage?: InputMaybe<Scalars['String']['input']>
  recipientsIds?: InputMaybe<Array<Scalars['Int']['input']>>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type SendCandidateScorecardInput = {
  id: Scalars['Int']['input']
}

export type SendCandidatesToSourcingStageInput = {
  candidateProfileIds: Array<Scalars['Int']['input']>
  executionSource: ExecutionSourceEnum
  jobListingId: Scalars['Int']['input']
}

export type SendCandidatesToSourcingStageOutput = {
  __typename?: 'SendCandidatesToSourcingStageOutput'
  alreadyHasActiveApplication?: Maybe<Array<CandidateApplicationNotCreatedOutput>>
  candidateApplications?: Maybe<Array<CandidateApplication>>
  profileNotFound?: Maybe<Array<CandidateApplicationNotCreatedOutput>>
}

export type SendConnectedEmailInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  body?: InputMaybe<Scalars['String']['input']>
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  connectedEmailSettingsId: Scalars['Int']['input']
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  replyToMessageId?: InputMaybe<Scalars['String']['input']>
  subject?: InputMaybe<Scalars['String']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
  to?: InputMaybe<Array<Scalars['String']['input']>>
  trackLinks?: InputMaybe<Scalars['Boolean']['input']>
  trackOpen?: InputMaybe<Scalars['Boolean']['input']>
  trackReply?: InputMaybe<Scalars['Boolean']['input']>
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>
}

export type SendEmailForSequenceStepInput = {
  candidateProfileId: Scalars['Int']['input']
  sequenceId: Scalars['String']['input']
  stepId: Scalars['Int']['input']
}

export type SendEmailForSequenceStepResponse = {
  __typename?: 'SendEmailForSequenceStepResponse'
  message?: Maybe<Scalars['String']['output']>
}

export type SendEmailToCandidateProfileInput = {
  activityLogOptions?: InputMaybe<ActivityLogOptionsInput>
  attachments?: InputMaybe<Array<EmailAttachmentInput>>
  bcc?: InputMaybe<Array<Scalars['String']['input']>>
  body?: InputMaybe<Scalars['String']['input']>
  candidateOfferVersionId?: InputMaybe<Scalars['Int']['input']>
  cc?: InputMaybe<Array<Scalars['String']['input']>>
  from?: InputMaybe<Scalars['String']['input']>
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  subject?: InputMaybe<Scalars['String']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
  text?: InputMaybe<Scalars['String']['input']>
  to: Array<Scalars['String']['input']>
  tokenContext?: InputMaybe<SendEmailTokenContextInput>
  trackLinks?: InputMaybe<Scalars['Boolean']['input']>
  trackOpen?: InputMaybe<Scalars['Boolean']['input']>
  trackReply?: InputMaybe<Scalars['Boolean']['input']>
}

export type SendEmailTokenContextCandidateInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId: Scalars['Int']['input']
  email?: InputMaybe<Scalars['String']['input']>
}

export type SendEmailTokenContextInput = {
  candidates?: InputMaybe<Array<SendEmailTokenContextCandidateInput>>
  interviewLength?: InputMaybe<Scalars['Int']['input']>
}

export type SendJobListingInput = {
  email: Scalars['String']['input']
  message: Scalars['String']['input']
  publicListingId: Scalars['String']['input']
  recipients: Array<Scalars['String']['input']>
}

export type SendJobListingResult = {
  __typename?: 'SendJobListingResult'
  email: Scalars['String']['output']
  message: Scalars['String']['output']
  publicListingId: Scalars['String']['output']
  recipients: Array<Scalars['String']['output']>
}

export type SendReminderCandidateScorecardInput = {
  id: Scalars['Int']['input']
}

export type SendResetPasswordEmailInput = {
  email: Scalars['String']['input']
}

export type SeniorityLevel = {
  __typename?: 'SeniorityLevel'
  languageCode: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type Sequence = {
  __typename?: 'Sequence'
  Company: Company
  CompanyUser: CompanyUser
  FavoriteSequence: Array<FavoriteSequence>
  SequenceSetting: SequenceSetting
  SequenceSteps: Array<SequenceStep>
  associatedRequisitionIds: Array<Scalars['Int']['output']>
  associatedTalentPoolIds: Array<Scalars['Int']['output']>
  candidatesCount: Scalars['Int']['output']
  companyId: Scalars['Int']['output']
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  emailBouncedCount: Scalars['Int']['output']
  emailClickedCount: Scalars['Int']['output']
  emailOpenedCount: Scalars['Int']['output']
  emailRepliedCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  isDeleted: Scalars['Boolean']['output']
  isFavorite: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  numberOfActives: Scalars['Int']['output']
  numberOfCompleted: Scalars['Int']['output']
  numberOfSteps: Scalars['Int']['output']
  ownerCompanyUser?: Maybe<CompanyUser>
  ownerCompanyUserId?: Maybe<Scalars['Int']['output']>
  ownerName?: Maybe<Scalars['String']['output']>
  sequenceSettingId: Scalars['Int']['output']
  sequenceStatus: SequenceStatusEnum
  totalEnrolled: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
  visibility: SequenceVisibilityEnum
}

export type SequenceActivityLog = {
  __typename?: 'SequenceActivityLog'
  CandidateIncomingEmail?: Maybe<CandidateIncomingEmail>
  Company: Company
  ConnectedEmail?: Maybe<ConnectedEmail>
  EmailRecord?: Maybe<EmailRecord>
  SequenceCandidate: SequenceCandidate
  SequenceStep?: Maybe<SequenceStep>
  candidateIncomingEmailId?: Maybe<Scalars['Int']['output']>
  companyId: Scalars['Int']['output']
  connectedEmailId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  emailRecordId?: Maybe<Scalars['String']['output']>
  eventObject: Scalars['JSON']['output']
  eventType: SequenceActivityLogEventTypeEnum
  id: Scalars['ID']['output']
  sequenceCandidateId: Scalars['Int']['output']
  sequenceStepId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum SequenceActivityLogEventTypeEnum {
  EmailBounced = 'EMAIL_BOUNCED',
  EmailClicked = 'EMAIL_CLICKED',
  EmailOpened = 'EMAIL_OPENED',
  EmailReplied = 'EMAIL_REPLIED',
  EmailSentForSequenceStep = 'EMAIL_SENT_FOR_SEQUENCE_STEP',
  EmailUnsubscribed = 'EMAIL_UNSUBSCRIBED',
}

export enum SequenceActivityLogSortBy {
  CreatedAt = 'createdAt',
  SequenceCandidateStatus = 'sequenceCandidateStatus',
}

export type SequenceActivityLogsResponse = {
  __typename?: 'SequenceActivityLogsResponse'
  count: Scalars['Int']['output']
  emailsSent: Array<SequenceActivityLog>
}

export type SequenceCandidate = {
  __typename?: 'SequenceCandidate'
  CandidateProfile: CandidateProfile
  CurrentStep?: Maybe<SequenceStep>
  Sequence: Sequence
  candidateProfileId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  currentStepId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  isDeleted: Scalars['Boolean']['output']
  sequenceCandidateStatus: SequenceCandidateStatusEnum
  sequenceId: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type SequenceCandidateActivityLogsResponse = {
  __typename?: 'SequenceCandidateActivityLogsResponse'
  count: Scalars['Int']['output']
  sequenceCandidate: SequenceCandidate
  thread: Array<SequenceActivityLog>
}

export type SequenceCandidateEngagementResponse = {
  __typename?: 'SequenceCandidateEngagementResponse'
  countOpened: Scalars['Int']['output']
  countReplied: Scalars['Int']['output']
  countSent: Scalars['Int']['output']
  opened: Array<SequenceCandidate>
  replied: Array<SequenceCandidate>
  sent: Array<SequenceCandidate>
}

export enum SequenceCandidateStatusEnum {
  Active = 'ACTIVE',
  Converted = 'CONVERTED',
  DoNotContact = 'DO_NOT_CONTACT',
  Finished = 'FINISHED',
  FinishedBounced = 'FINISHED_BOUNCED',
  FinishedDidNotReply = 'FINISHED_DID_NOT_REPLY',
  FinishedReplied = 'FINISHED_REPLIED',
}

export type SequenceMetricsResponse = {
  __typename?: 'SequenceMetricsResponse'
  bounceRate: Scalars['Float']['output']
  completed: Scalars['Int']['output']
  currentlyActive: Scalars['Int']['output']
  emailClickRate: Scalars['Float']['output']
  emailOpenRate: Scalars['Float']['output']
  replyRate: Scalars['Float']['output']
  totalEnrolled: Scalars['Int']['output']
}

export type SequenceOperationInput = {
  sequenceId: Scalars['String']['input']
}

export type SequenceOperationResponse = {
  __typename?: 'SequenceOperationResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type SequenceScheduleSetting = {
  __typename?: 'SequenceScheduleSetting'
  daysOfWeek?: Maybe<Scalars['JSON']['output']>
  endTime?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isDefault: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  startTime?: Maybe<Scalars['String']['output']>
  timeZone?: Maybe<Scalars['String']['output']>
  useContactLocalTime: Scalars['Boolean']['output']
}

export type SequenceSetting = {
  __typename?: 'SequenceSetting'
  Company: Company
  ConnectedEmailSettings: ConnectedEmailSettings
  SequenceScheduleSetting: SequenceScheduleSetting
  bcc?: Maybe<Scalars['JSON']['output']>
  cc?: Maybe<Scalars['JSON']['output']>
  companyId: Scalars['Int']['output']
  connectedEmailSettingsId: Scalars['Int']['output']
  dailySendLimit?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  includeUnsubscribeLink: Scalars['Boolean']['output']
  pauseOnReply: Scalars['Boolean']['output']
  sequenceScheduleSettingId: Scalars['Int']['output']
  unenrollOnConversion: Scalars['Boolean']['output']
  unsubscribeLinkText?: Maybe<Scalars['String']['output']>
}

export enum SequenceStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED',
}

export type SequenceStep = {
  __typename?: 'SequenceStep'
  Sequence: Sequence
  TemplateMessage?: Maybe<TemplateMessage>
  afterPreviousStep?: Maybe<Scalars['Int']['output']>
  body?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  customSendTime?: Maybe<Scalars['String']['output']>
  dropOffsCount: Scalars['Int']['output']
  emailClickedCount: Scalars['Int']['output']
  emailLimitPerDay?: Maybe<Scalars['Int']['output']>
  emailOpenedCount: Scalars['Int']['output']
  emailRepliedCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  replyPreviousThread: Scalars['Boolean']['output']
  schedulerType: SequenceStepSchedulerTypeEnum
  sendTimeType: SequenceStepSendTimeTypeEnum
  sequenceId: Scalars['String']['output']
  spreadStrategy?: Maybe<SequenceStepSpreadStrategyEnum>
  stepNumber: Scalars['Int']['output']
  subject?: Maybe<Scalars['String']['output']>
  templateMessageId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export enum SequenceStepSchedulerTypeEnum {
  AfterXDays = 'AFTER_X_DAYS',
  AfterXHours = 'AFTER_X_HOURS',
  AfterXMinutes = 'AFTER_X_MINUTES',
  Immediately = 'IMMEDIATELY',
}

export enum SequenceStepSendTimeTypeEnum {
  CustomTime = 'CUSTOM_TIME',
  ThroughoutDay = 'THROUGHOUT_DAY',
}

export enum SequenceStepSpreadStrategyEnum {
  Evenly = 'EVENLY',
  Warm = 'WARM',
}

export enum SequenceVisibilityEnum {
  Everyone = 'EVERYONE',
  Private = 'PRIVATE',
}

export type SequencesResponse = {
  __typename?: 'SequencesResponse'
  activeSequences: Array<Sequence>
  allSequences: Array<Sequence>
  archived: Array<Sequence>
  ownedByMe: Array<Sequence>
  sharedWithMe: Array<Sequence>
}

export type SetupTime = {
  __typename?: 'SetupTime'
  period: Scalars['Int']['output']
  range: Scalars['String']['output']
}

export type SharedCoreReport = {
  __typename?: 'SharedCoreReport'
  CompanyUser: CompanyUser
  CoreReport: CoreReport
  companyUserId: Scalars['Int']['output']
  coreReportId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  email: Scalars['String']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type SharedReportInput = {
  companyUserId: Scalars['Int']['input']
  coreReportId: Scalars['Int']['input']
  email: Scalars['String']['input']
}

export type SignUpInput = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type SignatureRequestSignersInput = {
  emailAddress: Scalars['String']['input']
  name: Scalars['String']['input']
  order?: InputMaybe<Scalars['Int']['input']>
}

export type Skill = {
  __typename?: 'Skill'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
}

/** Social information */
export type Social = {
  __typename?: 'Social'
  id?: Maybe<Scalars['String']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
  username?: Maybe<Scalars['String']['output']>
}

export enum SortByApplication {
  ApplicationStatus = 'applicationStatus',
  AppliedAt = 'appliedAt',
  CandidateName = 'candidateName',
  ExternalTitle = 'externalTitle',
  ListingTitle = 'listingTitle',
  MatchScore = 'matchScore',
  PostedAt = 'postedAt',
  Round = 'round',
}

export enum SortByBoomarkedJob {
  ListingTitle = 'listingTitle',
  PostedAt = 'postedAt',
}

export enum SortByCalendarEvent {
  StartTime = 'startTime',
}

export enum SortByCandidateProfile {
  CandidateName = 'candidateName',
  CreatedAt = 'createdAt',
}

export enum SortByCandidateScorecard {
  AssignedTo = 'assignedTo',
  CreatedAt = 'createdAt',
  ScorecardTemplateName = 'scorecardTemplateName',
  Status = 'status',
  TemplateStage = 'templateStage',
}

export enum SortByExternalApplication {
  AppliedAt = 'appliedAt',
  EmployerName = 'employerName',
  Status = 'status',
}

export enum SortByJobInvite {
  Applicants = 'applicants',
  ListingTitle = 'listingTitle',
  PostedAt = 'postedAt',
}

export enum SortByJobProductsEnum {
  CreatedAsc = 'created_asc',
  CreatedDesc = 'created_desc',
  ListPriceAsc = 'list_price_asc',
  ListPriceDesc = 'list_price_desc',
  OrderFrequencyAsc = 'order_frequency_asc',
  OrderFrequencyDesc = 'order_frequency_desc',
  Recent = 'recent',
  Relevant = 'relevant',
}

export enum SortByScorecardTemplate {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Department = 'department',
  Id = 'id',
  ScorecardName = 'scorecardName',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum SourceCategoryEnum {
  Agency = 'AGENCY',
  CompanyWebsite = 'COMPANY_WEBSITE',
  Custom = 'CUSTOM',
  DirectApplicant = 'DIRECT_APPLICANT',
  Event = 'EVENT',
  Internal = 'INTERNAL',
  Other = 'OTHER',
  Referred = 'REFERRED',
  Scalis = 'SCALIS',
  Sourced = 'SOURCED',
  ThirdParty = 'THIRD_PARTY',
  University = 'UNIVERSITY',
}

export type SourceInput = {
  campaignId?: InputMaybe<Scalars['Int']['input']>
  source?: InputMaybe<Scalars['String']['input']>
}

export type SourceStats = {
  __typename?: 'SourceStats'
  applicants: Scalars['Int']['output']
  applyStarts: Scalars['Int']['output']
  completionRate: Scalars['Float']['output']
  views: Scalars['Int']['output']
}

export type SourceTrackingLink = {
  __typename?: 'SourceTrackingLink'
  candidateSourceName?: Maybe<CandidateSourceName>
  candidateSourceNameId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  companyUserId: Scalars['Int']['output']
  countApplies: Scalars['Int']['output']
  countClicksToApply: Scalars['Int']['output']
  countUniqueViews: Scalars['Int']['output']
  countViews: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  genericListingLink?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  isDeleted?: Maybe<Scalars['Boolean']['output']>
  jobListing: JobListing
  jobListingId: Scalars['Int']['output']
  name: Scalars['String']['output']
  redirectUrl: Scalars['String']['output']
  shortCode: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
  whoGetsCredit?: Maybe<Scalars['Int']['output']>
  whoGetsCreditCompanyUser?: Maybe<CompanyUser>
}

export type SourceTrackingLinkEvent = {
  __typename?: 'SourceTrackingLinkEvent'
  browser?: Maybe<Scalars['String']['output']>
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  deviceType?: Maybe<Scalars['String']['output']>
  eventType: SourceTrackingLinkEventTypeEnum
  ipAddress?: Maybe<Scalars['String']['output']>
  latitude?: Maybe<Scalars['Float']['output']>
  loggedIn: Scalars['Boolean']['output']
  longitude?: Maybe<Scalars['Float']['output']>
  operatingSystem?: Maybe<Scalars['String']['output']>
  region?: Maybe<Scalars['String']['output']>
  scalisUserId?: Maybe<Scalars['String']['output']>
  sourceTrackingLinkId: Scalars['String']['output']
  timestamp: Scalars['DateTime']['output']
  userAgent?: Maybe<Scalars['String']['output']>
}

export enum SourceTrackingLinkEventTypeEnum {
  Applied = 'APPLIED',
  ClickedApply = 'CLICKED_APPLY',
  Viewed = 'VIEWED',
}

export enum SourceTrackingLinkSortFields {
  CountApplies = 'countApplies',
  CountClicksToApply = 'countClicksToApply',
  CountUniqueViews = 'countUniqueViews',
  CountViews = 'countViews',
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt',
}

export enum SourceTypeEnum {
  External = 'external',
  Internal = 'internal',
}

export type SourcingRequestInput = {
  experience: Scalars['String']['input']
  industry: Scalars['String']['input']
  jobTitle: Scalars['String']['input']
  location: Scalars['String']['input']
  role: Scalars['String']['input']
  skills: Array<Scalars['String']['input']>
  text: Scalars['String']['input']
}

export type StageCollaborator = {
  __typename?: 'StageCollaborator'
  CompanyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  requisition?: Maybe<Requisition>
  requisitionId?: Maybe<Scalars['Int']['output']>
  requisitionJobDescription?: Maybe<RequisitionJobDescription>
  requisitionJobDescriptionId?: Maybe<Scalars['Int']['output']>
  role?: Maybe<Role>
  roleId?: Maybe<Scalars['Int']['output']>
  templateStage?: Maybe<TemplateStage>
  templateStageId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type StageCollaboratorPermission = {
  __typename?: 'StageCollaboratorPermission'
  role: RoleEnum
  templateStageId?: Maybe<Scalars['Int']['output']>
}

export enum StageEnum {
  BasicInformation = 'BASIC_INFORMATION',
  Complete = 'COMPLETE',
  Description = 'DESCRIPTION',
  Location = 'LOCATION',
  Preferences = 'PREFERENCES',
  ScreeningQuestions = 'SCREENING_QUESTIONS',
  Skills = 'SKILLS',
}

export type StageMappingInput = {
  sourceStageId: Scalars['Int']['input']
  targetStageId: Scalars['Int']['input']
}

export type StageSettings = {
  __typename?: 'StageSettings'
  InterviewTeam?: Maybe<Array<InterviewTeam>>
  JobPipeline?: Maybe<JobPipeline>
  TemplateStage?: Maybe<TemplateStage>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  jobPipelineId?: Maybe<Scalars['Int']['output']>
  scorecardTemplateId?: Maybe<Scalars['Int']['output']>
  templateStageId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type StartCandidateApplicationInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>
  publicListingId: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type StripeSubscription = {
  __typename?: 'StripeSubscription'
  cancelAt?: Maybe<Scalars['DateTime']['output']>
  cancelAtPeriodEnd: Scalars['Boolean']['output']
  currentPeriodEnd: Scalars['DateTime']['output']
  currentPeriodStart: Scalars['DateTime']['output']
  endedAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['String']['output']
  startDate: Scalars['DateTime']['output']
  status: Scalars['String']['output']
}

export enum SubIndustryTypeEnum {
  AeroDefenseAviationServices = 'AERO_DEFENSE_AVIATION_SERVICES',
  AgriAnimalProduction = 'AGRI_ANIMAL_PRODUCTION',
  AgriCropProduction = 'AGRI_CROP_PRODUCTION',
  AgriFarmSupport = 'AGRI_FARM_SUPPORT',
  AgriFishery = 'AGRI_FISHERY',
  AgriFloralNursery = 'AGRI_FLORAL_NURSERY',
  AgriForestryLoggingTimber = 'AGRI_FORESTRY_LOGGING_TIMBER',
  ArtsEntRecArtGalleries = 'ARTS_ENT_REC_ART_GALLERIES',
  ArtsEntRecCultureEntertainment = 'ARTS_ENT_REC_CULTURE_ENTERTAINMENT',
  ArtsEntRecFilmProduction = 'ARTS_ENT_REC_FILM_PRODUCTION',
  ArtsEntRecGambling = 'ARTS_ENT_REC_GAMBLING',
  ArtsEntRecMusicSoundProduction = 'ARTS_ENT_REC_MUSIC_SOUND_PRODUCTION',
  ArtsEntRecPhotography = 'ARTS_ENT_REC_PHOTOGRAPHY',
  ArtsEntRecPublishing = 'ARTS_ENT_REC_PUBLISHING',
  ArtsEntRecSportsRecreation = 'ARTS_ENT_REC_SPORTS_RECREATION',
  ArtsEntRecTicketSales = 'ARTS_ENT_REC_TICKET_SALES',
  ArtsEntRecTranslationLinguistic = 'ARTS_ENT_REC_TRANSLATION_LINGUISTIC',
  ArtsEntRecVideoGamePublishing = 'ARTS_ENT_REC_VIDEO_GAME_PUBLISHING',
  AutoElectricVehicleManufacturing = 'AUTO_ELECTRIC_VEHICLE_MANUFACTURING',
  AutoVehicleDealers = 'AUTO_VEHICLE_DEALERS',
  AutoVehicleManufacturing = 'AUTO_VEHICLE_MANUFACTURING',
  AutoVehicleRepairMaintenance = 'AUTO_VEHICLE_REPAIR_MAINTENANCE',
  ConstrArchitecturalEngineering = 'CONSTR_ARCHITECTURAL_ENGINEERING',
  ConstrCommercialEquipment = 'CONSTR_COMMERCIAL_EQUIPMENT',
  ConstrRepairFacilities = 'CONSTR_REPAIR_FACILITIES',
  ConsultCfoConsulting = 'CONSULT_CFO_CONSULTING',
  ConsultHrConsulting = 'CONSULT_HR_CONSULTING',
  ConsultMarketingConsulting = 'CONSULT_MARKETING_CONSULTING',
  ConsultSalesConsulting = 'CONSULT_SALES_CONSULTING',
  ConsultStrategyConsulting = 'CONSULT_STRATEGY_CONSULTING',
  EcomAgency = 'ECOM_AGENCY',
  EcomBrand = 'ECOM_BRAND',
  EcomLogisticsFulfillment = 'ECOM_LOGISTICS_FULFILLMENT',
  EcomOnlineMarketplace = 'ECOM_ONLINE_MARKETPLACE',
  EcomOnlinePayments = 'ECOM_ONLINE_PAYMENTS',
  EcomSaas = 'ECOM_SAAS',
  EduCollegesUniversities = 'EDU_COLLEGES_UNIVERSITIES',
  EduLms = 'EDU_LMS',
  EduOnlinePlatforms = 'EDU_ONLINE_PLATFORMS',
  EduPreschoolsChildcare = 'EDU_PRESCHOOLS_CHILDCARE',
  EduPrimarySecondary = 'EDU_PRIMARY_SECONDARY',
  EduSoftware = 'EDU_SOFTWARE',
  EduTrainingServices = 'EDU_TRAINING_SERVICES',
  EnergyMiningMetals = 'ENERGY_MINING_METALS',
  EnergyRenewable = 'ENERGY_RENEWABLE',
  EnergyUtilities = 'ENERGY_UTILITIES',
  EnvSvcsEnvConsulting = 'ENV_SVCS_ENV_CONSULTING',
  EnvSvcsRenewableEnergy = 'ENV_SVCS_RENEWABLE_ENERGY',
  EnvSvcsWasteManagement = 'ENV_SVCS_WASTE_MANAGEMENT',
  FashionClothingRetailers = 'FASHION_CLOTHING_RETAILERS',
  FashionDesigners = 'FASHION_DESIGNERS',
  FashionTextileFabric = 'FASHION_TEXTILE_FABRIC',
  FinSvcsAccountingTax = 'FIN_SVCS_ACCOUNTING_TAX',
  FinSvcsAssetManagement = 'FIN_SVCS_ASSET_MANAGEMENT',
  FinSvcsBankingLending = 'FIN_SVCS_BANKING_LENDING',
  FinSvcsDebtRelief = 'FIN_SVCS_DEBT_RELIEF',
  FinSvcsDigitalPayments = 'FIN_SVCS_DIGITAL_PAYMENTS',
  FinSvcsP2PLending = 'FIN_SVCS_P2P_LENDING',
  FinSvcsPlanningAdvisory = 'FIN_SVCS_PLANNING_ADVISORY',
  FinSvcsRoboAdvisory = 'FIN_SVCS_ROBO_ADVISORY',
  FinSvcsStockExchanges = 'FIN_SVCS_STOCK_EXCHANGES',
  FinSvcsTransactionProcessing = 'FIN_SVCS_TRANSACTION_PROCESSING',
  FoodBevBeverageProduction = 'FOOD_BEV_BEVERAGE_PRODUCTION',
  FoodBevDelivery = 'FOOD_BEV_DELIVERY',
  FoodBevOrganicNatural = 'FOOD_BEV_ORGANIC_NATURAL',
  GovPublicAdminMunicipal = 'GOV_PUBLIC_ADMIN_MUNICIPAL',
  GovPublicAdminNational = 'GOV_PUBLIC_ADMIN_NATIONAL',
  GovPublicAdminStateRegional = 'GOV_PUBLIC_ADMIN_STATE_REGIONAL',
  HealthAmbulanceMedicalTransport = 'HEALTH_AMBULANCE_MEDICAL_TRANSPORT',
  HealthDentalClinics = 'HEALTH_DENTAL_CLINICS',
  HealthHomeCare = 'HEALTH_HOME_CARE',
  HealthHospitalsClinics = 'HEALTH_HOSPITALS_CLINICS',
  HealthMedEquipSupplies = 'HEALTH_MED_EQUIP_SUPPLIES',
  HealthMedTestingLabs = 'HEALTH_MED_TESTING_LABS',
  HealthNursingCare = 'HEALTH_NURSING_CARE',
  HealthRehabServices = 'HEALTH_REHAB_SERVICES',
  HealthTech = 'HEALTH_TECH',
  HotelsTravelAgencies = 'HOTELS_TRAVEL_AGENCIES',
  HotelsTravelCruiseLines = 'HOTELS_TRAVEL_CRUISE_LINES',
  HotelsTravelEventManagement = 'HOTELS_TRAVEL_EVENT_MANAGEMENT',
  HotelsTravelHotelsResorts = 'HOTELS_TRAVEL_HOTELS_RESORTS',
  HotelsTravelThemeParks = 'HOTELS_TRAVEL_THEME_PARKS',
  HumanresStaffingHrConsulting = 'HUMANRES_STAFFING_HR_CONSULTING',
  HumanresStaffingStaffingSubcontracting = 'HUMANRES_STAFFING_STAFFING_SUBCONTRACTING',
  InfoCloudComputing = 'INFO_CLOUD_COMPUTING',
  InfoCybersecurity = 'INFO_CYBERSECURITY',
  InfoDataAnalytics = 'INFO_DATA_ANALYTICS',
  InfoHardwareDev = 'INFO_HARDWARE_DEV',
  InfoSaas = 'INFO_SAAS',
  InfoSoftwareDev = 'INFO_SOFTWARE_DEV',
  InfoSupportServices = 'INFO_SUPPORT_SERVICES',
  InfoTelecomEquip = 'INFO_TELECOM_EQUIP',
  InfoWebServices = 'INFO_WEB_SERVICES',
  InsAgenciesBrokerages = 'INS_AGENCIES_BROKERAGES',
  InsCarriers = 'INS_CARRIERS',
  InsHealthInsurance = 'INS_HEALTH_INSURANCE',
  LegalLawFirms = 'LEGAL_LAW_FIRMS',
  LegalServices = 'LEGAL_SERVICES',
  ManageBusinessConsulting = 'MANAGE_BUSINESS_CONSULTING',
  ManageMembershipOrganizations = 'MANAGE_MEMBERSHIP_ORGANIZATIONS',
  ManageResearchDev = 'MANAGE_RESEARCH_DEV',
  ManageSecurityProtective = 'MANAGE_SECURITY_PROTECTIVE',
  ManufChemical = 'MANUF_CHEMICAL',
  ManufCommercialPrinting = 'MANUF_COMMERCIAL_PRINTING',
  ManufConsumerProducts = 'MANUF_CONSUMER_PRODUCTS',
  ManufElectronics = 'MANUF_ELECTRONICS',
  ManufFoodBev = 'MANUF_FOOD_BEV',
  ManufHealthProducts = 'MANUF_HEALTH_PRODUCTS',
  ManufMachinery = 'MANUF_MACHINERY',
  ManufMetalMineral = 'MANUF_METAL_MINERAL',
  ManufTextileApparel = 'MANUF_TEXTILE_APPAREL',
  ManufTransportEquip = 'MANUF_TRANSPORT_EQUIP',
  ManufWoodPaper = 'MANUF_WOOD_PAPER',
  MediaCommAdvertisingPr = 'MEDIA_COMM_ADVERTISING_PR',
  MediaCommBroadcast = 'MEDIA_COMM_BROADCAST',
  MediaCommFilmProduction = 'MEDIA_COMM_FILM_PRODUCTION',
  MediaCommMusicSound = 'MEDIA_COMM_MUSIC_SOUND',
  MediaCommPhotography = 'MEDIA_COMM_PHOTOGRAPHY',
  MediaCommPublishing = 'MEDIA_COMM_PUBLISHING',
  MediaCommTranslationLinguistic = 'MEDIA_COMM_TRANSLATION_LINGUISTIC',
  MediaCommVideoGame = 'MEDIA_COMM_VIDEO_GAME',
  NonprofitNgoCivicSocial = 'NONPROFIT_NGO_CIVIC_SOCIAL',
  NonprofitNgoFoundations = 'NONPROFIT_NGO_FOUNDATIONS',
  NonprofitNgoReligious = 'NONPROFIT_NGO_RELIGIOUS',
  PersonalServicesBeautyWellness = 'PERSONAL_SERVICES_BEAUTY_WELLNESS',
  PersonalServicesEventServices = 'PERSONAL_SERVICES_EVENT_SERVICES',
  PersonalServicesLaundryCleaning = 'PERSONAL_SERVICES_LAUNDRY_CLEANING',
  PersonalServicesPetCareVeterinary = 'PERSONAL_SERVICES_PET_CARE_VETERINARY',
  PersonalServicesPrivateHouseholds = 'PERSONAL_SERVICES_PRIVATE_HOUSEHOLDS',
  PharmaBiotechBiotech = 'PHARMA_BIOTECH_BIOTECH',
  PharmaBiotechPharma = 'PHARMA_BIOTECH_PHARMA',
  ProfServicesAdvertisingAgencies = 'PROF_SERVICES_ADVERTISING_AGENCIES',
  ProfServicesDesign = 'PROF_SERVICES_DESIGN',
  ProfServicesPrAgencies = 'PROF_SERVICES_PR_AGENCIES',
  RealEstateAgencies = 'REAL_ESTATE_AGENCIES',
  RealEstatePropertyManagement = 'REAL_ESTATE_PROPERTY_MANAGEMENT',
  RestaurantsBarsNightclubs = 'RESTAURANTS_BARS_NIGHTCLUBS',
  RestaurantsCafes = 'RESTAURANTS_CAFES',
  RestaurantsCateringContractors = 'RESTAURANTS_CATERING_CONTRACTORS',
  RetailAuctionsGalleries = 'RETAIL_AUCTIONS_GALLERIES',
  RetailAutoPartsAccessories = 'RETAIL_AUTO_PARTS_ACCESSORIES',
  RetailBeautyPersonalAccessories = 'RETAIL_BEAUTY_PERSONAL_ACCESSORIES',
  RetailConvenienceStores = 'RETAIL_CONVENIENCE_STORES',
  RetailDepartmentClothingShoe = 'RETAIL_DEPARTMENT_CLOTHING_SHOE',
  RetailDrugHealthStores = 'RETAIL_DRUG_HEALTH_STORES',
  RetailEcommerce = 'RETAIL_ECOMMERCE',
  RetailElectronicsAppliances = 'RETAIL_ELECTRONICS_APPLIANCES',
  RetailFoodBevStores = 'RETAIL_FOOD_BEV_STORES',
  RetailGeneralMerchandise = 'RETAIL_GENERAL_MERCHANDISE',
  RetailGiftNoveltySouvenir = 'RETAIL_GIFT_NOVELTY_SOUVENIR',
  RetailGroceryStores = 'RETAIL_GROCERY_STORES',
  RetailHomeFurnitureHousewares = 'RETAIL_HOME_FURNITURE_HOUSEWARES',
  RetailHomeImprovement = 'RETAIL_HOME_IMPROVEMENT',
  RetailLuxuryGoods = 'RETAIL_LUXURY_GOODS',
  RetailMediaEntertainment = 'RETAIL_MEDIA_ENTERTAINMENT',
  RetailOfficeSupplyCopy = 'RETAIL_OFFICE_SUPPLY_COPY',
  RetailPetSupplies = 'RETAIL_PET_SUPPLIES',
  RetailSpecialtyStores = 'RETAIL_SPECIALTY_STORES',
  RetailSportingGoods = 'RETAIL_SPORTING_GOODS',
  RetailToysHobbies = 'RETAIL_TOYS_HOBBIES',
  RetailWholesale = 'RETAIL_WHOLESALE',
  SocialMediaOnlineCommunities = 'SOCIAL_MEDIA_ONLINE_COMMUNITIES',
  SocialMediaPlatforms = 'SOCIAL_MEDIA_PLATFORMS',
  SocialMediaProfessionalNetworking = 'SOCIAL_MEDIA_PROFESSIONAL_NETWORKING',
  TelecomTelecommunications = 'TELECOM_TELECOMMUNICATIONS',
  TransportAirlinesAirports = 'TRANSPORT_AIRLINES_AIRPORTS',
  TransportCarTruckRental = 'TRANSPORT_CAR_TRUCK_RENTAL',
  TransportManagement = 'TRANSPORT_MANAGEMENT',
  TransportMarine = 'TRANSPORT_MARINE',
  TransportParkingValet = 'TRANSPORT_PARKING_VALET',
  TransportRail = 'TRANSPORT_RAIL',
  TransportShippingTrucking = 'TRANSPORT_SHIPPING_TRUCKING',
  TransportTaxiCarServices = 'TRANSPORT_TAXI_CAR_SERVICES',
}

export type SubscriptionInput = {
  recurrence?: Recurrence
}

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Unpaid = 'UNPAID',
}

export type SwapRequisitionPipelineInput = {
  jobPipelineId: Scalars['Int']['input']
  stageMappings: Array<StageMappingInput>
  targetTemplatePipelineId: Scalars['Int']['input']
}

export type SyncCompanyUsersCalendarsOutput = {
  __typename?: 'SyncCompanyUsersCalendarsOutput'
  success: Scalars['Boolean']['output']
}

export type TalentPool = {
  __typename?: 'TalentPool'
  associatedRequisitionIds: Array<Scalars['Int']['output']>
  company: Company
  companyId: Scalars['Int']['output']
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  contributorCompanyUserIds: Array<Scalars['Int']['output']>
  count: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isArchived?: Maybe<Scalars['Boolean']['output']>
  isFavorite: Scalars['Boolean']['output']
  isVisibleTo: TalentPoolVisibilityEnum
  name: Scalars['String']['output']
  ownerCompanyUserId?: Maybe<Scalars['Int']['output']>
  ownerName?: Maybe<Scalars['String']['output']>
  tags: Array<Scalars['String']['output']>
  talentPoolType: TalentPoolTypeEnum
  updatedAt: Scalars['DateTime']['output']
}

export type TalentPoolCandidateProfile = {
  __typename?: 'TalentPoolCandidateProfile'
  candidateProfile: CandidateProfile
  candidateProfileId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  prospectOwner?: Maybe<CompanyUser>
  prospectOwnerId?: Maybe<Scalars['Int']['output']>
  talentPool: TalentPool
  talentPoolId: Scalars['Int']['output']
  talentPoolProspectStatus?: Maybe<TalentPoolProspectStatus>
  talentPoolProspectStatusId?: Maybe<Scalars['Int']['output']>
  updatedAt: Scalars['DateTime']['output']
}

export type TalentPoolOperationResponse = {
  __typename?: 'TalentPoolOperationResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type TalentPoolProspectStatus = {
  __typename?: 'TalentPoolProspectStatus'
  colorNumber: Scalars['Int']['output']
  company: Company
  companyId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  status: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export enum TalentPoolTypeEnum {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
}

export enum TalentPoolVisibilityEnum {
  Everyone = 'EVERYONE',
  Private = 'PRIVATE',
  Team = 'TEAM',
}

export type TalentPoolsResponse = {
  __typename?: 'TalentPoolsResponse'
  allCustomTalentPools: Array<TalentPool>
  archived: Array<TalentPool>
  defaultTalentPools: Array<TalentPool>
  favorites: Array<TalentPool>
  myTalentPools: Array<TalentPool>
  sharedWithMe: Array<TalentPool>
  views: TalentPoolsViews
}

export type TalentPoolsViews = {
  __typename?: 'TalentPoolsViews'
  createdByMe: Array<RequisitionTalentPoolCompanySavedView>
  defaultViews: Array<RequisitionTalentPoolCompanySavedView>
  list: Array<ViewLinkWithUserPreference>
  savedByOthers: Array<RequisitionTalentPoolCompanySavedView>
}

export type TargetGroup = {
  __typename?: 'TargetGroup'
  educationLevel: Array<TargetGroupItem>
  industry: Array<TargetGroupItem>
  jobCategory: Array<TargetGroupItem>
  seniority: Array<TargetGroupItem>
}

export type TargetGroupInput = {
  educationLevel: Array<TargetGroupItemInput>
  industry: Array<TargetGroupItemInput>
  jobCategory: Array<TargetGroupItemInput>
  seniority: Array<TargetGroupItemInput>
}

export type TargetGroupItem = {
  __typename?: 'TargetGroupItem'
  description: Scalars['String']['output']
  vonqId: Scalars['String']['output']
}

export type TargetGroupItemInput = {
  description: Scalars['String']['input']
  vonqId: Scalars['String']['input']
}

export enum TeamSizeEnum {
  Count_1To_5 = 'COUNT_1_TO_5',
  Count_6To_10 = 'COUNT_6_TO_10',
  Count_11To_20 = 'COUNT_11_TO_20',
  Count_21To_50Plus = 'COUNT_21_TO_50_PLUS',
}

export type TemplateApprovalReviewer = {
  __typename?: 'TemplateApprovalReviewer'
  CompanyUser?: Maybe<CompanyUser>
  CompanyUserGroup?: Maybe<CompanyUserGroup>
  TemplateApprovalWorkflowStep: TemplateApprovalWorkflowStep
  companyUserGroupId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt: Scalars['DateTime']['output']
  hiringTeamRole?: Maybe<RoleEnum>
  id: Scalars['ID']['output']
  templateApprovalWorkflowStepId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type TemplateApprovalReviewerInput = {
  companyUserGroupId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  hiringTeamRole?: InputMaybe<RoleEnum>
}

export type TemplateApprovalWorkflow = {
  __typename?: 'TemplateApprovalWorkflow'
  approvalConditions: Scalars['JSON']['output']
  approvalWorkflowType: ApprovalWorkflowTypeEnum
  company: Company
  companyId: Scalars['Int']['output']
  companyUser: CompanyUser
  companyUserId: Scalars['Int']['output']
  createdAt: Scalars['DateTime']['output']
  description?: Maybe<Scalars['JSON']['output']>
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  isDeleted: Scalars['Boolean']['output']
  isEdited: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  replacedBy?: Maybe<Scalars['Int']['output']>
  replacedByWorkflow?: Maybe<TemplateApprovalWorkflow>
  replacingWorkflows: Array<TemplateApprovalWorkflow>
  updatedAt: Scalars['DateTime']['output']
  workflowSteps: Array<TemplateApprovalWorkflowStep>
}

export enum TemplateApprovalWorkflowSortFields {
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt',
}

export type TemplateApprovalWorkflowStep = {
  __typename?: 'TemplateApprovalWorkflowStep'
  Reviewers: Array<TemplateApprovalReviewer>
  TemplateApprovalWorkflow: TemplateApprovalWorkflow
  approvalStrictnessLevel: ApprovalStrictnessLevelEnum
  createdAt: Scalars['DateTime']['output']
  finalStep: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  rankOrder: Scalars['Int']['output']
  templateApprovalWorkflowId: Scalars['Int']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type TemplateApprovalWorkflowStepInput = {
  approvalStrictnessLevel: ApprovalStrictnessLevelEnum
  finalStep: Scalars['Boolean']['input']
  rankOrder: Scalars['Int']['input']
  reviewers: Array<TemplateApprovalReviewerInput>
}

export type TemplateJobDescription = {
  __typename?: 'TemplateJobDescription'
  company?: Maybe<Company>
  companyDepartment?: Maybe<CompanyDepartment>
  companyDepartmentId?: Maybe<Scalars['ID']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUser?: Maybe<CompanyUser>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TemplateMessage = {
  __typename?: 'TemplateMessage'
  CandidateMessage?: Maybe<Array<CandidateMessage>>
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  ConnectedEmailSettings?: Maybe<ConnectedEmailSettings>
  ScreeningQuestion?: Maybe<Array<ScreeningQuestion>>
  bccEmails?: Maybe<Scalars['JSON']['output']>
  ccEmails?: Maybe<Scalars['JSON']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  emailSubject?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
  messageOwner?: Maybe<MessageOwnerEnum>
  messageType?: Maybe<MessageTypeEnum>
  senderAddressId?: Maybe<Scalars['Int']['output']>
  title?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TemplateMilestone = {
  __typename?: 'TemplateMilestone'
  TemplatePipeline?: Maybe<TemplatePipeline>
  TemplateStage?: Maybe<Array<TemplateStage>>
  archived?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<NameEnum>
  rankOrder?: Maybe<Scalars['Int']['output']>
  templatePipelineId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TemplatePipeline = {
  __typename?: 'TemplatePipeline'
  Company?: Maybe<Company>
  CompanyDepartment?: Maybe<CompanyDepartment>
  CompanyUser?: Maybe<CompanyUser>
  JobPipeline?: Maybe<Array<JobPipeline>>
  TemplateMilestones?: Maybe<Array<TemplateMilestone>>
  TemplateStage?: Maybe<Array<TemplateStage>>
  archived?: Maybe<Scalars['Boolean']['output']>
  companyDepartmentId?: Maybe<Scalars['Int']['output']>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  ghostPipeline?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  pipelinedUsed?: Maybe<Scalars['Boolean']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TemplateStage = {
  __typename?: 'TemplateStage'
  CandidateApplicationByStage?: Maybe<Array<CandidateApplication>>
  CandidateInterview?: Maybe<Array<CandidateInterview>>
  StageCollaborator?: Maybe<Array<StageCollaborator>>
  StageSettings?: Maybe<Array<StageSettings>>
  TemplateMilestone?: Maybe<TemplateMilestone>
  TemplatePipeline?: Maybe<TemplatePipeline>
  archived?: Maybe<Scalars['Boolean']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  rankOrder?: Maybe<Scalars['Int']['output']>
  templateMilestoneId?: Maybe<Scalars['Int']['output']>
  templatePipelineId?: Maybe<Scalars['Int']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  visibility?: Maybe<TemplateStageVisibilityEnum>
}

export type TemplateStageCandidateApplicationByStageArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  milestoneIn?: InputMaybe<Array<NameEnum>>
  milestoneNotIn?: InputMaybe<Array<NameEnum>>
  page?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export enum TemplateStageVisibilityEnum {
  VisibleOnlyInternally = 'VISIBLE_ONLY_INTERNALLY',
  VisibleToCandidate = 'VISIBLE_TO_CANDIDATE',
}

/** Tenure information */
export type Tenure = {
  __typename?: 'Tenure'
  unit: Scalars['String']['output']
  value: Scalars['Float']['output']
}

export type ThreadResponse = {
  __typename?: 'ThreadResponse'
  count: Scalars['Int']['output']
  emailRecords: Array<EmailRecord>
  thread: EmailThread
}

export type ToggleScorecardTemplateArchiveInput = {
  id: Scalars['Int']['input']
}

export type ToggleTemplateApprovalWorkflowStatusInput = {
  id: Scalars['Int']['input']
  isActive: Scalars['Boolean']['input']
}

export enum TokenCategoryNameEnum {
  ApplicationInfo = 'APPLICATION_INFO',
  CandidateProfile = 'CANDIDATE_PROFILE',
  CompanyInfo = 'COMPANY_INFO',
  CustomField = 'CUSTOM_FIELD',
  InterviewTokens = 'INTERVIEW_TOKENS',
  JobDetails = 'JOB_DETAILS',
  MyInformation = 'MY_INFORMATION',
  OfferDetails = 'OFFER_DETAILS',
  SectionTokens = 'SECTION_TOKENS',
  SignatureTokens = 'SIGNATURE_TOKENS',
  SystemTokens = 'SYSTEM_TOKENS',
}

export enum TokenNameEnum {
  AnnualBonus = 'ANNUAL_BONUS',
  AnnualSalary = 'ANNUAL_SALARY',
  ApplicationDate = 'APPLICATION_DATE',
  AvailabilitySubmissionLink = 'AVAILABILITY_SUBMISSION_LINK',
  Benefits = 'BENEFITS',
  CandidateApplicationId = 'CANDIDATE_APPLICATION_ID',
  CandidateCompany = 'CANDIDATE_COMPANY',
  CandidateCurrentTitle = 'CANDIDATE_CURRENT_TITLE',
  CandidateEmailAddress = 'CANDIDATE_EMAIL_ADDRESS',
  CandidateFirstName = 'CANDIDATE_FIRST_NAME',
  CandidateFullName = 'CANDIDATE_FULL_NAME',
  CandidateLastName = 'CANDIDATE_LAST_NAME',
  CandidateLinkedinProfile = 'CANDIDATE_LINKEDIN_PROFILE',
  CandidateMailingAddress = 'CANDIDATE_MAILING_ADDRESS',
  CandidateName = 'CANDIDATE_NAME',
  CandidatePhone = 'CANDIDATE_PHONE',
  CandidateProfileId = 'CANDIDATE_PROFILE_ID',
  CandidateProfileLink = 'CANDIDATE_PROFILE_LINK',
  CandidateSchool = 'CANDIDATE_SCHOOL',
  CandidateSignature = 'CANDIDATE_SIGNATURE',
  CandidateSignatureDate = 'CANDIDATE_SIGNATURE_DATE',
  CompanyLinkedinUrl = 'COMPANY_LINKEDIN_URL',
  CompanyName = 'COMPANY_NAME',
  CompanyUserSignature = 'COMPANY_USER_SIGNATURE',
  CompanyUserSignatureDate = 'COMPANY_USER_SIGNATURE_DATE',
  CompanyWebsiteUrl = 'COMPANY_WEBSITE_URL',
  DayOfWeek = 'DAY_OF_WEEK',
  EquityPackage = 'EQUITY_PACKAGE',
  HiringManagerName = 'HIRING_MANAGER_NAME',
  HourlyRate = 'HOURLY_RATE',
  InternalJobName = 'INTERNAL_JOB_NAME',
  InterviewerJobTitle = 'INTERVIEWER_JOB_TITLE',
  InterviewerName = 'INTERVIEWER_NAME',
  InterviewDate = 'INTERVIEW_DATE',
  InterviewEndTime = 'INTERVIEW_END_TIME',
  InterviewInviteLocation = 'INTERVIEW_INVITE_LOCATION',
  InterviewKitLink = 'INTERVIEW_KIT_LINK',
  InterviewName = 'INTERVIEW_NAME',
  InterviewOrganizerName = 'INTERVIEW_ORGANIZER_NAME',
  InterviewPanel = 'INTERVIEW_PANEL',
  InterviewStartTime = 'INTERVIEW_START_TIME',
  InterviewSummary = 'INTERVIEW_SUMMARY',
  InvitationLink = 'INVITATION_LINK',
  JobDescription = 'JOB_DESCRIPTION',
  JobPostUrl = 'JOB_POST_URL',
  JobReqName = 'JOB_REQ_NAME',
  JobTitle = 'JOB_TITLE',
  JobType = 'JOB_TYPE',
  LinkToApply = 'LINK_TO_APPLY',
  ListingDescription = 'LISTING_DESCRIPTION',
  Manager = 'MANAGER',
  MedalistDesignation = 'MEDALIST_DESIGNATION',
  MyEmailAddress = 'MY_EMAIL_ADDRESS',
  MyFirstName = 'MY_FIRST_NAME',
  MyFullName = 'MY_FULL_NAME',
  MyJobTitle = 'MY_JOB_TITLE',
  MyScalisProfileUrl = 'MY_SCALIS_PROFILE_URL',
  OfferExpirationDate = 'OFFER_EXPIRATION_DATE',
  Office = 'OFFICE',
  OfficeAddress = 'OFFICE_ADDRESS',
  OfficeName = 'OFFICE_NAME',
  PayType = 'PAY_TYPE',
  PrimaryContact = 'PRIMARY_CONTACT',
  PublicListingTitle = 'PUBLIC_LISTING_TITLE',
  RecruiterName = 'RECRUITER_NAME',
  ReportingManager = 'REPORTING_MANAGER',
  RequisitionId = 'REQUISITION_ID',
  SalesCommission = 'SALES_COMMISSION',
  ScorecardLink = 'SCORECARD_LINK',
  SelfSchedulerLink = 'SELF_SCHEDULER_LINK',
  SignOff = 'SIGN_OFF',
  SignOnBonus = 'SIGN_ON_BONUS',
  SourceName = 'SOURCE_NAME',
  SpotBonus = 'SPOT_BONUS',
  StageNameCurrent = 'STAGE_NAME_CURRENT',
  StageNameNext = 'STAGE_NAME_NEXT',
  StartDate = 'START_DATE',
  StockOptions = 'STOCK_OPTIONS',
  TodayDate = 'TODAY_DATE',
  VariableCompensation = 'VARIABLE_COMPENSATION',
}

export enum TokenStatusEnum {
  FailedTest = 'FAILED_TEST',
  NotAvailableDueToConditions = 'NOT_AVAILABLE_DUE_TO_CONDITIONS',
  NotTested = 'NOT_TESTED',
  Verified = 'VERIFIED',
}

export type TokenTestResult = {
  __typename?: 'TokenTestResult'
  OfferDocumentTemplate?: Maybe<OfferDocumentTemplate>
  OfferSectionTemplate?: Maybe<OfferSectionTemplate>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  offerDocumentTemplateId?: Maybe<Scalars['Int']['output']>
  offerSectionTemplateId?: Maybe<Scalars['Int']['output']>
  result?: Maybe<Scalars['JSON']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type TrackEmailClicked = {
  __typename?: 'TrackEmailClicked'
  click_id: Scalars['String']['output']
  ip: Scalars['String']['output']
  link_index: Scalars['String']['output']
  timestamp: Scalars['Int']['output']
  user_agent: Scalars['String']['output']
}

export type TrackEmailClickedInput = {
  click_id: Scalars['String']['input']
  ip: Scalars['String']['input']
  link_index: Scalars['String']['input']
  timestamp: Scalars['Int']['input']
  user_agent: Scalars['String']['input']
}

export type TrackEmailOpened = {
  __typename?: 'TrackEmailOpened'
  ip: Scalars['String']['output']
  opened_id: Scalars['Int']['output']
  timestamp: Scalars['Int']['output']
  user_agent: Scalars['String']['output']
}

export type TrackEmailOpenedInput = {
  ip: Scalars['String']['input']
  opened_id: Scalars['Int']['input']
  timestamp: Scalars['Int']['input']
  user_agent: Scalars['String']['input']
}

export type TrackEmailReplied = {
  __typename?: 'TrackEmailReplied'
  count: Scalars['Int']['output']
  timestamp: Scalars['Int']['output']
}

export type TrackEmailRepliedInput = {
  count: Scalars['Int']['input']
  timestamp: Scalars['Int']['input']
}

export type TranscriptEntry = {
  __typename?: 'TranscriptEntry'
  end: Scalars['Float']['output']
  speaker: Scalars['String']['output']
  start: Scalars['Float']['output']
  text: Scalars['String']['output']
}

export type TranscriptMetadata = {
  __typename?: 'TranscriptMetadata'
  interviewStartTime?: Maybe<Scalars['String']['output']>
  lastUpdated: Scalars['DateTime']['output']
  speakerCount?: Maybe<Scalars['Int']['output']>
  timeZone?: Maybe<Scalars['String']['output']>
  totalDuration?: Maybe<Scalars['Float']['output']>
  totalEntries?: Maybe<Scalars['Int']['output']>
}

export type TranscriptResponse = {
  __typename?: 'TranscriptResponse'
  metadata: TranscriptMetadata
  recordingUrl?: Maybe<Scalars['String']['output']>
  summary?: Maybe<Scalars['String']['output']>
  transcript?: Maybe<Array<TranscriptEntry>>
  transcriptText?: Maybe<Scalars['String']['output']>
  transcriptUrl?: Maybe<Scalars['String']['output']>
  urlExpiresAt: Scalars['DateTime']['output']
}

export enum TravelTypeEnum {
  No = 'NO',
  Yes = 'YES',
}

export type UnarchiveCustomCandidateApplicationFieldInput = {
  id: Scalars['Int']['input']
}

export type UnarchiveCustomCandidateProfileFieldInput = {
  id: Scalars['Int']['input']
}

export type UnarchiveCustomJobRequisitionFieldInput = {
  id: Scalars['Int']['input']
}

export type UnarchiveInterviewTemplateInput = {
  id: Scalars['Int']['input']
}

export type UnarchiveInterviewerPoolInput = {
  id: Scalars['Int']['input']
}

/** Input type for unarchiving an offer custom field */
export type UnarchiveOfferCustomFieldInput = {
  /** Unique identifier of the offer custom field to unarchive */
  id: Scalars['Int']['input']
}

export type UnarchiveTalentPoolInput = {
  talentPoolId: Scalars['Int']['input']
}

export type UndoHireInput = {
  candidateApplicationId: Scalars['Int']['input']
}

export type UndoOfferCandidateDeclinedInput = {
  candidateOfferVersionId: Scalars['Int']['input']
}

export type UndoRejectCandidatesInput = {
  applicationIds: Array<Scalars['Int']['input']>
  jobId: Scalars['String']['input']
}

export type UnpinSavedViewInput = {
  id: Scalars['Int']['input']
}

export type UnsubscribeCandidateFromEmailsInput = {
  optOutToken: Scalars['String']['input']
}

export type UnsubscribeCandidateFromEmailsResponse = {
  __typename?: 'UnsubscribeCandidateFromEmailsResponse'
  candidateProfileId: Scalars['Int']['output']
  message: Scalars['String']['output']
  sequenceId: Scalars['String']['output']
}

export type UpdateCandidateFilterInput = {
  filters?: InputMaybe<Scalars['JSON']['input']>
  id: Scalars['Int']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCandidateOfferVersionStatusInput = {
  id: Scalars['Int']['input']
  offerStatus: OfferStatusEnum
}

export type UpdateCandidateProspectOwnerInput = {
  candidateProfileId: Scalars['Int']['input']
  prospectOwnerId: Scalars['Int']['input']
  talentPoolId: Scalars['Int']['input']
}

export type UpdateCandidateProspectStatusInput = {
  candidateProfileId: Scalars['Int']['input']
  talentPoolId: Scalars['Int']['input']
  talentPoolProspectStatusId: Scalars['Int']['input']
}

export type UpdateCompanyDataInput = {
  Address?: InputMaybe<Array<UpsertAddressInput>>
  CompanyDepartment?: InputMaybe<Array<CompanyDepartmentInput>>
  CompanyInfo?: InputMaybe<CompanyInfoInput>
  CompanyOffice?: InputMaybe<Array<CompanyOfficeInput>>
  externalId?: InputMaybe<Scalars['String']['input']>
  lastActivity?: InputMaybe<Scalars['DateTime']['input']>
  subdomain?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCompanyUserGroupInput = {
  companyId: Scalars['Int']['input']
  companyUserGroupId: Scalars['Int']['input']
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  externalId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  officeIds?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type UpdateCompanyUserRoleInput = {
  companyUserId: Scalars['Int']['input']
  role: OrganizationRoleEnum
}

export type UpdateCompanyUserViewOrderInput = {
  sortedViewLinksIds: Array<Scalars['Int']['input']>
}

export type UpdateConnectedEmailSettingsInput = {
  allowSendOnBehalf?: InputMaybe<Scalars['Boolean']['input']>
  dailyLimit?: InputMaybe<Scalars['Int']['input']>
  emailSignature?: InputMaybe<Scalars['String']['input']>
  emailSignatureEnabled?: InputMaybe<Scalars['Boolean']['input']>
  hourlyLimit?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  minutesBetweenEmails?: InputMaybe<Scalars['Int']['input']>
  optOutEnabled?: InputMaybe<Scalars['Boolean']['input']>
  optOutMessage?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCustomCandidateApplicationFieldValueInput = {
  id: Scalars['Int']['input']
  value: Scalars['String']['input']
}

export type UpdateCustomCandidateProfileFieldValueInput = {
  id: Scalars['Int']['input']
  value: Scalars['String']['input']
}

export type UpdateDocumentTemplateInput = {
  conditions?: InputMaybe<DocumentTemplateConditions>
  documentTemplateName?: InputMaybe<Scalars['String']['input']>
  documentTemplateText?: InputMaybe<Scalars['String']['input']>
  documentType?: InputMaybe<OfferDocumentTemplateTypeEnum>
  id: Scalars['Int']['input']
}

export type UpdateInterviewEventWhenInput = {
  endTime: Scalars['String']['input']
  startTime: Scalars['String']['input']
  timezone: Scalars['String']['input']
}

export type UpdateInterviewInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>
  calendarId?: InputMaybe<Scalars['Int']['input']>
  createConference?: InputMaybe<Scalars['Boolean']['input']>
  details?: InputMaybe<Scalars['String']['input']>
  interviewId: Scalars['Int']['input']
  interviewers?: InputMaybe<Array<Scalars['Int']['input']>>
  location?: InputMaybe<Scalars['String']['input']>
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
  stageId?: InputMaybe<Scalars['Int']['input']>
  when?: InputMaybe<UpdateInterviewEventWhenInput>
}

export type UpdateInterviewTemplateInput = {
  debriefInterview?: InputMaybe<Scalars['Boolean']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  interviewType?: InputMaybe<InterviewTypeEnum>
  interviewerPoolId?: InputMaybe<Scalars['Int']['input']>
  interviewers?: InputMaybe<Array<Scalars['Int']['input']>>
  isArchived?: InputMaybe<Scalars['Boolean']['input']>
  loopInterviews?: InputMaybe<Array<CreateInterviewTemplateLoopInput>>
  name?: InputMaybe<Scalars['String']['input']>
  schedulingLogic?: InputMaybe<SchedulingLogicEnum>
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateInterviewTemplateLoopInput = {
  assignedUserId?: InputMaybe<Scalars['Int']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  interviewerPoolId?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rankOrder?: InputMaybe<Scalars['Int']['input']>
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateInterviewerPoolInput = {
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  enableLoadBalancing?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
  jobIds?: InputMaybe<Array<Scalars['Int']['input']>>
  maxDailyInterviews?: InputMaybe<Scalars['Int']['input']>
  maxWeeklyInterviews?: InputMaybe<Scalars['Int']['input']>
  memberIds?: InputMaybe<Array<Scalars['Int']['input']>>
  minDailyInterviews?: InputMaybe<Scalars['Int']['input']>
  minWeeklyInterviews?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  officeIds?: InputMaybe<Array<Scalars['Int']['input']>>
  skillNames?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UpdateJobInviteInput = {
  dismissed?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
  inviteStatus?: InputMaybe<InviteStatusEnum>
  token?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateJobSearchPreferenceInput = {
  benefits?: InputMaybe<Scalars['JSON']['input']>
  companyStage?: InputMaybe<Scalars['JSON']['input']>
  datePosted?: InputMaybe<DatePostedEnum>
  desiredCompanySize?: InputMaybe<Scalars['JSON']['input']>
  excludeJobTitles?: InputMaybe<Scalars['JSON']['input']>
  id: Scalars['Int']['input']
  includeJobTitles?: InputMaybe<Scalars['JSON']['input']>
  industryPreference?: InputMaybe<Scalars['JSON']['input']>
  jobType?: InputMaybe<JobTypeEnum>
  maxRequiredExperience?: InputMaybe<Scalars['String']['input']>
  minimumPayPreference?: InputMaybe<Scalars['String']['input']>
  minimumRequiredExperience?: InputMaybe<Scalars['String']['input']>
  relocationLocationPreference?: InputMaybe<Scalars['JSON']['input']>
  relocationTypePreference?: InputMaybe<RelocationTypePreferenceEnum>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  workplaceLocationPreference?: InputMaybe<Scalars['JSON']['input']>
  workplaceTypePreference?: InputMaybe<Scalars['JSON']['input']>
}

export type UpdateNotificationSettingInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['Int']['input']
  inApp?: InputMaybe<Scalars['Boolean']['input']>
  slack?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateScalisUserDataInput = {
  Achievement?: InputMaybe<Array<AchievementInput>>
  Address?: InputMaybe<Array<UpsertAddressInput>>
  CertificateOrLicense?: InputMaybe<Array<CertificateOrLicenseInput>>
  ContactInfo?: InputMaybe<Array<ContactInfoInput>>
  DemographicInfo?: InputMaybe<DemographicInfoInput>
  Education?: InputMaybe<Array<EducationInput>>
  Experience?: InputMaybe<Array<ExperienceInput>>
  JobSeekerHeader?: InputMaybe<Array<JobSeekerHeaderInput>>
  JobSeekerInfo?: InputMaybe<JobSeekerInfoInput>
  JobSeekerSkill?: InputMaybe<Array<JobSeekerSkillInput>>
  VolunteerWork?: InputMaybe<Array<VolunteerWorkInput>>
  WebsiteOrSocialMedia?: InputMaybe<Array<WebsiteOrSocialMediaInput>>
  activeStatus?: InputMaybe<Scalars['Boolean']['input']>
  currentStage?: InputMaybe<CurrentStageEnum>
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<Scalars['String']['input']>
  profileImage?: InputMaybe<Scalars['String']['input']>
}

export type UpdateScheduledReportInput = {
  customDaysOfWeek?: InputMaybe<Array<RepeatDaysOfWeekEnum>>
  customTime?: InputMaybe<Scalars['String']['input']>
  endDate?: InputMaybe<Scalars['DateTime']['input']>
  id: Scalars['Int']['input']
  recipients: Array<Scalars['String']['input']>
  repeat?: InputMaybe<RepeatTypeEnum>
  reportSchedulerType: ReportSchedulerTypeEnum
  sendImmediately?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['DateTime']['input']>
}

export type UpdateSchedulerLinkInviteCandidateInput = {
  id: Scalars['Int']['input']
  type: CandidateTypeEnum
}

export type UpdateSchedulerLinkInviteInput = {
  calendarId: Scalars['Int']['input']
  candidates: Array<UpdateSchedulerLinkInviteCandidateInput>
  durationMinutes?: InputMaybe<Scalars['Int']['input']>
  interviewers: Array<Scalars['Int']['input']>
  inviteId: Scalars['Int']['input']
  message?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSchedulerLinkSettingsInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  maxInterviewsPerDay?: InputMaybe<Scalars['Int']['input']>
  minimumHour?: InputMaybe<Scalars['Int']['input']>
  rollingDays?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateSequenceInput = {
  associatedRequisitionIds?: InputMaybe<Array<Scalars['Int']['input']>>
  associatedTalentPoolIds?: InputMaybe<Array<Scalars['Int']['input']>>
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  ownerCompanyUserId?: InputMaybe<Scalars['Int']['input']>
  /** Optional existing sequence settings ID. If not provided, sequenceSettings can be provided to update settings inline. */
  sequenceSettingId?: InputMaybe<Scalars['Int']['input']>
  /** Optional settings to update with this sequence. If provided, will update the existing sequence settings. */
  sequenceSettings?: InputMaybe<UpdateSequenceSettingInput>
  sequenceStatus?: InputMaybe<SequenceStatusEnum>
  visibility?: InputMaybe<SequenceVisibilityEnum>
}

export type UpdateSequenceScheduleSettingInlineInput = {
  daysOfWeek?: InputMaybe<Scalars['JSON']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
  timeZone?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSequenceScheduleSettingInput = {
  daysOfWeek?: InputMaybe<Scalars['JSON']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  id: Scalars['Int']['input']
  isDefault?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
  timeZone?: InputMaybe<Scalars['String']['input']>
  useContactLocalTime?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpdateSequenceSettingInput = {
  bcc?: InputMaybe<Scalars['JSON']['input']>
  cc?: InputMaybe<Scalars['JSON']['input']>
  connectedEmailSettingsId?: InputMaybe<Scalars['Int']['input']>
  dailySendLimit?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  includeUnsubscribeLink?: InputMaybe<Scalars['Boolean']['input']>
  pauseOnReply?: InputMaybe<Scalars['Boolean']['input']>
  /** Optional existing sequence schedule setting ID. If not provided, sequenceScheduleSettings can be provided to update schedule settings inline. */
  sequenceScheduleSettingId?: InputMaybe<Scalars['Int']['input']>
  /** Optional schedule settings to update with this sequence setting. If provided, will update the existing schedule settings. */
  sequenceScheduleSettings?: InputMaybe<UpdateSequenceScheduleSettingInlineInput>
  unenrollOnConversion?: InputMaybe<Scalars['Boolean']['input']>
  unsubscribeLinkText?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSequenceStepInput = {
  afterPreviousStep?: InputMaybe<Scalars['Int']['input']>
  body?: InputMaybe<Scalars['String']['input']>
  customSendTime?: InputMaybe<Scalars['String']['input']>
  emailLimitPerDay?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['Int']['input']
  replyPreviousThread?: InputMaybe<Scalars['Boolean']['input']>
  schedulerType?: InputMaybe<SequenceStepSchedulerTypeEnum>
  sendTimeType?: InputMaybe<SequenceStepSendTimeTypeEnum>
  spreadStrategy?: InputMaybe<SequenceStepSpreadStrategyEnum>
  subject?: InputMaybe<Scalars['String']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateUsersInCompanyUserGroupInput = {
  companyId: Scalars['Int']['input']
  companyUserGroupId: Scalars['Int']['input']
  companyUserIds: Array<Scalars['Int']['input']>
}

export type UploadCandidateCustomFieldsInput = {
  applicationFields?: InputMaybe<Array<CustomFieldValueInput>>
  profileFields?: InputMaybe<Array<CustomFieldValueInput>>
}

export type UploadS3FileInput = {
  base64File: Scalars['String']['input']
  contentType: Scalars['String']['input']
  fileKey: Scalars['String']['input']
}

export type UploadS3FileOutput = {
  __typename?: 'UploadS3FileOutput'
  fileKey: Scalars['String']['output']
  filePath: Scalars['String']['output']
}

export type UploadedCandidate = {
  __typename?: 'UploadedCandidate'
  CandidateProfile?: Maybe<CandidateProfile>
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  EnrichedEmail: Array<EnrichedEmail>
  EnrichedLocation: Array<EnrichedLocation>
  EnrichedPhoneNumber: Array<EnrichedPhoneNumber>
  ExperienceTenure?: Maybe<ExperienceTenure>
  UploadedCandidateAchievement: Array<UploadedCandidateAchievement>
  UploadedCandidateCertificateOrLicense: Array<UploadedCandidateCertificateOrLicense>
  UploadedCandidateEducation?: Maybe<Array<UploadedCandidateEducation>>
  UploadedCandidateExperience?: Maybe<Array<UploadedCandidateExperience>>
  UploadedCandidateJobSeekerSkill?: Maybe<Array<UploadedCandidateJobSeekerSkills>>
  UploadedCandidateVolunteerWork: Array<UploadedCandidateVolunteerWork>
  UploadedCandidateWebsiteOrSocialMedia: Array<UploadedCandidateWebsiteOrSocialMedia>
  companyId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  emailAddress?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  lastName?: Maybe<Scalars['String']['output']>
  linkedinProfile?: Maybe<Scalars['String']['output']>
  profileImage?: Maybe<Scalars['String']['output']>
  profileUrl?: Maybe<Scalars['String']['output']>
  uploadedCandidateType?: Maybe<UploadedCandidateTypeEnum>
}

export type UploadedCandidateUploadedCandidateEducationArgs = {
  highestEducation?: InputMaybe<Scalars['Boolean']['input']>
}

export type UploadedCandidateUploadedCandidateExperienceArgs = {
  onlyCurrentJob?: InputMaybe<Scalars['Boolean']['input']>
  onlyMostRecentJob?: InputMaybe<Scalars['Boolean']['input']>
}

export type UploadedCandidateAchievement = {
  __typename?: 'UploadedCandidateAchievement'
  description?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  issueYear?: Maybe<Scalars['Int']['output']>
  issuingAuthority?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  searchDescription?: Maybe<Scalars['String']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
}

export type UploadedCandidateCertificateOrLicense = {
  __typename?: 'UploadedCandidateCertificateOrLicense'
  description?: Maybe<Scalars['JSON']['output']>
  id: Scalars['Int']['output']
  issueYear?: Maybe<Scalars['Int']['output']>
  issuingAuthority?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  searchDescription?: Maybe<Scalars['String']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
}

export type UploadedCandidateEducation = {
  __typename?: 'UploadedCandidateEducation'
  additionalInformation?: Maybe<Scalars['String']['output']>
  areasOfStudy?: Maybe<Scalars['JSON']['output']>
  cumGPA?: Maybe<Scalars['Float']['output']>
  cumGPAScale?: Maybe<Scalars['Float']['output']>
  currentlyStudying?: Maybe<Scalars['Boolean']['output']>
  departmentCumGPA?: Maybe<Scalars['Float']['output']>
  departmentCumGPAScale?: Maybe<Scalars['Float']['output']>
  educationLevel?: Maybe<EducationLevelEnum>
  endDate?: Maybe<Scalars['DateTime']['output']>
  hideCumGPA?: Maybe<Scalars['Boolean']['output']>
  hideDepartmentGPA?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['Int']['output']
  institutionName?: Maybe<Scalars['String']['output']>
  majors?: Maybe<Scalars['JSON']['output']>
  minors?: Maybe<Scalars['JSON']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
}

export type UploadedCandidateExperience = {
  __typename?: 'UploadedCandidateExperience'
  additionalComp?: Maybe<Scalars['Boolean']['output']>
  companyLogo?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  employerName?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  industry?: Maybe<IndustryEnum>
  isCurrentJob?: Maybe<Scalars['Boolean']['output']>
  isCurrentlyWorking?: Maybe<Scalars['Boolean']['output']>
  jobPay?: Maybe<Scalars['Float']['output']>
  jobTitle?: Maybe<Scalars['String']['output']>
  jobType?: Maybe<JobTypeEnum>
  location?: Maybe<Scalars['String']['output']>
  locationType?: Maybe<Scalars['String']['output']>
  longFormDesc?: Maybe<Scalars['String']['output']>
  managementPosition?: Maybe<Scalars['Boolean']['output']>
  payType?: Maybe<Scalars['String']['output']>
  searchLongFormDesc?: Maybe<Scalars['String']['output']>
  searchShortFormDesc?: Maybe<Scalars['String']['output']>
  shortFormDesc?: Maybe<Scalars['JSON']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  subIndustry?: Maybe<Scalars['String']['output']>
  teamSize?: Maybe<TeamSizeEnum>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
  workPlaceCandidate?: Maybe<WorkPlaceCandidateEnum>
}

export type UploadedCandidateJobSeekerSkills = {
  __typename?: 'UploadedCandidateJobSeekerSkills'
  id: Scalars['Int']['output']
  level?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  sequenceNumber?: Maybe<Scalars['Int']['output']>
  yearsOfExp?: Maybe<Scalars['Int']['output']>
}

export type UploadedCandidateResumeProcessingState = {
  __typename?: 'UploadedCandidateResumeProcessingState'
  id: Scalars['Int']['output']
  processingResume: ParsingResumeStateEnum
}

export type UploadedCandidateResumeProcessingStateInput = {
  uploadedCandidateId: Scalars['Int']['input']
}

export type UploadedCandidateSkill = {
  __typename?: 'UploadedCandidateSkill'
  experienceId?: Maybe<Scalars['Int']['output']>
  id: Scalars['ID']['output']
  level?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  yearsOfExp?: Maybe<Scalars['Int']['output']>
}

export enum UploadedCandidateTypeEnum {
  GmailScraped = 'GMAIL_SCRAPED',
  IndeedScraped = 'INDEED_SCRAPED',
  LinkedinScraped = 'LINKEDIN_SCRAPED',
  Scraped = 'SCRAPED',
  ScrapedMerged = 'SCRAPED_MERGED',
  Uploaded = 'UPLOADED',
}

export type UploadedCandidateVolunteerWork = {
  __typename?: 'UploadedCandidateVolunteerWork'
  description?: Maybe<Scalars['JSON']['output']>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  isCurrentlyWorking?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  organizationName?: Maybe<Scalars['String']['output']>
  roleType?: Maybe<RoleTypeEnum>
  searchDescription?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
  volunteerJobTitle?: Maybe<Scalars['String']['output']>
}

export type UploadedCandidateWebsiteOrSocialMedia = {
  __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
  id: Scalars['Int']['output']
  type: WebsiteTypeEnum
  uploadedCandidateId?: Maybe<Scalars['Int']['output']>
  websiteURL: Scalars['String']['output']
}

export type UploadedDocument = {
  __typename?: 'UploadedDocument'
  UploadedDocumentCandidateApplication?: Maybe<UploadedDocumentCandidateApplication>
  UploadedDocumentCandidateProfile?: Maybe<UploadedDocumentCandidateProfile>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  documentName?: Maybe<Scalars['String']['output']>
  documentPath?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
}

export type UploadedDocumentCandidateApplication = {
  __typename?: 'UploadedDocumentCandidateApplication'
  CandidateApplication?: Maybe<CandidateApplication>
  CompanyUser?: Maybe<CompanyUser>
  UploadedDocument: UploadedDocument
  candidateApplicationId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  uploadedDocumentId?: Maybe<Scalars['Int']['output']>
}

export type UploadedDocumentCandidateProfile = {
  __typename?: 'UploadedDocumentCandidateProfile'
  CandidateProfile?: Maybe<CandidateProfile>
  CompanyUser?: Maybe<CompanyUser>
  UploadedDocument?: Maybe<UploadedDocument>
  candidateProfileId?: Maybe<Scalars['Int']['output']>
  companyUserId?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  updatedAt?: Maybe<Scalars['DateTime']['output']>
  uploadedDocumentId?: Maybe<Scalars['Int']['output']>
}

export type UpsertAddressInput = {
  activeStatus?: InputMaybe<Scalars['Boolean']['input']>
  addressLine1?: InputMaybe<Scalars['String']['input']>
  addressLine2?: InputMaybe<Scalars['String']['input']>
  addressType?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  companyId?: InputMaybe<Scalars['Int']['input']>
  contactName?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  latitude?: InputMaybe<Scalars['String']['input']>
  longitude?: InputMaybe<Scalars['String']['input']>
  officeId?: InputMaybe<Scalars['Int']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  timeZone?: InputMaybe<Scalars['String']['input']>
}

export type UpsertApplicationFormInput = {
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  companyOfficeId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  isArchived?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpsertApplicationFormScreeningQuestionInput = {
  applicationFormId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  rankOrder?: InputMaybe<Scalars['Int']['input']>
  screeningQuestionId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCandidateApplicationNoteInput = {
  UserNote: CandidateApplicationUserNoteInput
  candidateApplicationId: Scalars['Int']['input']
  companyUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  id?: InputMaybe<Scalars['Int']['input']>
  privateStatus?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpsertCandidateApplicationRatingInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  score: Scalars['Float']['input']
}

export type UpsertCandidateCollaboratorInput = {
  candidateProfileId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  requisitionJobDescriptionId?: InputMaybe<Scalars['Int']['input']>
  roleId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCandidateMessageInput = {
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  customMessage?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCandidateOfferCustomFieldInput = {
  CandidateOfferVersion?: InputMaybe<UpsertCandidateOfferVersionInput>
  OfferCustomField?: InputMaybe<UpsertOfferCustomFieldInput>
  candidateOfferVersionId?: InputMaybe<Scalars['Int']['input']>
  fieldValue?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  offerCustomFieldId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCandidateOfferFileInput = {
  CandidateOfferVersion?: InputMaybe<UpsertCandidateOfferVersionInput>
  candidateOfferVersionId?: InputMaybe<Scalars['Int']['input']>
  fileName?: InputMaybe<Scalars['String']['input']>
  filePath?: InputMaybe<Scalars['String']['input']>
  fileType?: InputMaybe<OfferFileTypeEnum>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCandidateOfferInput = {
  CandidateOfferVersion?: InputMaybe<UpsertCandidateOfferVersionInput>
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCandidateOfferVersionInput = {
  CandidateOffer?: InputMaybe<UpsertCandidateOfferInput>
  CandidateOfferCustomField?: InputMaybe<Array<UpsertCandidateOfferCustomFieldInput>>
  additionalCompensation?: InputMaybe<Scalars['JSON']['input']>
  benefits?: InputMaybe<Scalars['JSON']['input']>
  candidateName: Scalars['String']['input']
  candidateOfferId?: InputMaybe<Scalars['Int']['input']>
  companyOfficeId?: InputMaybe<Scalars['Int']['input']>
  compensation: Scalars['Float']['input']
  expirationDate?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  jobTitle: Scalars['String']['input']
  jobType: JobTypeEnum
  lastUpdatedStatusAt?: InputMaybe<Scalars['String']['input']>
  manager?: InputMaybe<Scalars['String']['input']>
  offerStatus: OfferStatusEnum
  payType: PayTypeEnum
  signatureRequestId?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type UpsertCandidatePrimaryEmailInput = {
  candidateProfileId: Scalars['Int']['input']
  primaryEmail: Scalars['String']['input']
}

export type UpsertCandidateProfileInput = {
  ProfileDetails: ProfileDetailsInput
  candidateProfileId: Scalars['Int']['input']
}

export type UpsertCandidateProfileNoteInput = {
  UserNote: CandidateProfileUserNoteInput
  candidateProfileId: Scalars['Int']['input']
  companyUserIds?: InputMaybe<Array<Scalars['String']['input']>>
  id?: InputMaybe<Scalars['Int']['input']>
  privateStatus?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpsertCandidateScorecardAnswersInput = {
  answer?: InputMaybe<AnswerInput>
  answerPreferredStatus?: InputMaybe<Scalars['Boolean']['input']>
  candidateScorecardId?: InputMaybe<Scalars['Int']['input']>
  dateAnswer?: InputMaybe<Scalars['DateTime']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  overallRecommendation?: InputMaybe<OverallRecommendationEnum>
  scoreAnswer?: InputMaybe<Scalars['Int']['input']>
  scorecardTemplateQuestionId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCandidateScorecardInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<ScorecardStatusTypeEnum>
  templateStageId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertCompanyProvidedEmailInput = {
  candidateProfileId: Scalars['Int']['input']
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertEmailInput = {
  activeStatus?: InputMaybe<Scalars['Boolean']['input']>
  email: Scalars['String']['input']
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  isVisibleToEmployers?: InputMaybe<Scalars['Boolean']['input']>
  password?: InputMaybe<Scalars['String']['input']>
}

export type UpsertExperienceSkillInput = {
  experienceId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>
  yearsOfExp?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertHiringTeamMemberInput = {
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  requisitionJobDescriptionId?: InputMaybe<Scalars['Int']['input']>
  roleId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertJobListingInput = {
  Address?: InputMaybe<UpsertAddressInput>
  JobListingScreeningQuestion?: InputMaybe<Array<UpsertJobListingScreeningQuestionInput>>
  acceptingCandidates?: InputMaybe<Scalars['Boolean']['input']>
  companyDefault?: InputMaybe<Scalars['Boolean']['input']>
  defaultConnectedEmailSettingsId?: InputMaybe<Scalars['Int']['input']>
  displayPayOnListing?: InputMaybe<Scalars['Boolean']['input']>
  externalTitle?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  industry?: InputMaybe<IndustryEnum>
  internalMatchingDescription?: InputMaybe<Scalars['String']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  listingTitle?: InputMaybe<Scalars['String']['input']>
  postedAt?: InputMaybe<Scalars['String']['input']>
  publicDescription?: InputMaybe<Scalars['String']['input']>
  searchInternalMatchingDescription?: InputMaybe<Scalars['String']['input']>
  searchPublicDescription?: InputMaybe<Scalars['String']['input']>
  stage?: InputMaybe<StageEnum>
  stateAndOrCountry?: InputMaybe<Scalars['String']['input']>
  subIndustry?: InputMaybe<SubIndustryTypeEnum>
  workplaceType?: InputMaybe<WorkplaceTypeEnum>
}

export type UpsertJobListingJobPipelineInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingId: Scalars['Int']['input']
  jobPipelineId: Scalars['Int']['input']
}

export type UpsertJobListingScreeningQuestionInput = {
  ScreeningQuestion?: InputMaybe<UpsertScreeningQuestionInput>
  active?: InputMaybe<Scalars['Boolean']['input']>
  displaySequenceNumber?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  screeningQuestionId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertJobOpeningInput = {
  closedDate?: InputMaybe<Scalars['String']['input']>
  closedReason?: InputMaybe<ClosedReasonEnum>
  companyId?: InputMaybe<Scalars['Int']['input']>
  extOpeningId?: InputMaybe<Scalars['String']['input']>
  filledByApplication?: InputMaybe<Scalars['Int']['input']>
  filledByCandidate?: InputMaybe<Scalars['Int']['input']>
  filledDate?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  openingStatus?: InputMaybe<OpeningStatusEnum>
  openingType?: InputMaybe<OpeningTypeEnum>
  startDate?: InputMaybe<Scalars['String']['input']>
  targetHireDate?: InputMaybe<Scalars['String']['input']>
}

export type UpsertJobPipelineInput = {
  StageSettings?: InputMaybe<UpsertStageSettingsInput>
  TemplatePipeline?: InputMaybe<UpsertTemplatePipelineInput>
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId: Scalars['Int']['input']
  templatePipelineId: Scalars['Int']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

export type UpsertOfferCustomFieldInput = {
  CandidateOfferCustomField?: InputMaybe<UpsertCandidateOfferCustomFieldInput>
  OfferTemplateCondition?: InputMaybe<UpsertOfferTemplateConditionInput>
  /** Type of input field (e.g., text, number, select) */
  fieldConfigurationType?: InputMaybe<CustomFieldInputTypeEnum>
  /** Description of the field */
  fieldDescription?: InputMaybe<Scalars['String']['input']>
  /** Name of the custom field */
  fieldName?: InputMaybe<Scalars['String']['input']>
  /** Flag indicating if the field is required */
  fieldRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** Flag indicating if a system token should be generated */
  generateSystemToken?: InputMaybe<Scalars['Boolean']['input']>
  /** Unique identifier of the offer custom field */
  id?: InputMaybe<Scalars['Int']['input']>
  /** Options for multiple choice fields */
  multipleChoiceOptions?: InputMaybe<Scalars['JSON']['input']>
  /** Name of the system token if generated */
  systemTokenName?: InputMaybe<Scalars['String']['input']>
  /** ID of the associated template condition */
  templateConditionId?: InputMaybe<Scalars['Int']['input']>
  /** Flag indicating if changes should trigger a new offer version */
  triggerNewOfferVersion?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpsertOfferDocumentTemplateInput = {
  TokenTestResult?: InputMaybe<UpsertTokenTestResultInput>
  documentFileName?: InputMaybe<Scalars['String']['input']>
  documentFilePath?: InputMaybe<Scalars['String']['input']>
  documentTemplateName?: InputMaybe<Scalars['String']['input']>
  documentTemplateStatus?: InputMaybe<OfferDocumentTemplateStatusEnum>
  documentTemplateText?: InputMaybe<Scalars['String']['input']>
  documentType?: InputMaybe<OfferDocumentTemplateTypeEnum>
  id?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertOfferDocumentTemplateSectionInput = {
  OfferDocumentTemplate?: InputMaybe<UpsertOfferDocumentTemplateInput>
  OfferSectionTemplate?: InputMaybe<UpsertOfferSectionTemplateInput>
  offerDocumentTemplateId: Scalars['Int']['input']
  offerSectionTemplateId: Scalars['Int']['input']
}

export type UpsertOfferSectionTemplateInput = {
  OfferDocumentTemplateSection?: InputMaybe<UpsertOfferDocumentTemplateSectionInput>
  OfferTemplateCondition?: InputMaybe<UpsertOfferTemplateConditionInput>
  TokenTestResult?: InputMaybe<UpsertTokenTestResultInput>
  id?: InputMaybe<Scalars['Int']['input']>
  sectionTemplateName?: InputMaybe<Scalars['String']['input']>
  sectionTemplateStatus?: InputMaybe<TokenStatusEnum>
  sectionTemplateText?: InputMaybe<Scalars['String']['input']>
  sectionToken?: InputMaybe<Scalars['String']['input']>
  tokenDescription?: InputMaybe<Scalars['String']['input']>
}

export type UpsertOfferTemplateConditionInput = {
  /** Type of condition that determines when this template should be applied */
  conditionType?: InputMaybe<ConditionTypeEnum>
  /** ID of the custom field this condition is associated with */
  customFieldId?: InputMaybe<Scalars['Int']['input']>
  /** ID of the department this condition applies to */
  departmentId?: InputMaybe<Scalars['Int']['input']>
  /** Type of employment (e.g., full-time, part-time) this condition applies to */
  employmentType?: InputMaybe<JobTypeEnum>
  /** Unique identifier for the template condition */
  id?: InputMaybe<Scalars['Int']['input']>
  /** ID of the offer document template this condition is associated with */
  offerDocumentTemplateId?: InputMaybe<Scalars['Int']['input']>
  /** ID of the office location this condition applies to */
  officeId?: InputMaybe<Scalars['Int']['input']>
  /** Type of payment (e.g., hourly, salary) this condition applies to */
  payType?: InputMaybe<PayTypeEnum>
  /** ID of the section template this condition is associated with */
  sectionTemplateId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertRequisitionInput = {
  additionalComp?: InputMaybe<Array<Scalars['String']['input']>>
  benefits?: InputMaybe<Array<Scalars['String']['input']>>
  candidateCollaborator?: InputMaybe<Array<UpsertCandidateCollaboratorInput>>
  collegeGradPref?: InputMaybe<Scalars['Boolean']['input']>
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  companyOfficeId?: InputMaybe<Scalars['Int']['input']>
  diverseHirePref?: InputMaybe<Scalars['Boolean']['input']>
  educationLevelPref?: InputMaybe<EducationLevelPrefEnum>
  extRequisitionId?: InputMaybe<Scalars['String']['input']>
  hiringTeamMember?: InputMaybe<Array<UpsertHiringTeamMemberInput>>
  id?: InputMaybe<Scalars['Int']['input']>
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>
  jobLevel?: InputMaybe<JobLevelEnum>
  jobListings?: InputMaybe<Array<UpsertJobListingInput>>
  jobName?: InputMaybe<Scalars['String']['input']>
  jobOpening?: InputMaybe<Array<UpsertJobOpeningInput>>
  jobPipelines?: InputMaybe<UpsertJobPipelineInput>
  jobStatus?: InputMaybe<JobStatusEnum>
  jobType?: InputMaybe<JobTypeEnum>
  locationDistancePref?: InputMaybe<Scalars['Int']['input']>
  maxPay?: InputMaybe<Scalars['Float']['input']>
  minPay?: InputMaybe<Scalars['Float']['input']>
  nonTraditionalPref?: InputMaybe<Scalars['Boolean']['input']>
  openedAt?: InputMaybe<Scalars['String']['input']>
  payType?: InputMaybe<PayTypeEnum>
  primaryContact?: InputMaybe<Scalars['Int']['input']>
  requisitionJobDescription?: InputMaybe<UpsertRequisitionJobDescriptionInput>
  requisitionSkills?: InputMaybe<Array<RequisitionSkillInput>>
  stageCollaborator?: InputMaybe<Array<UpsertStageCollaboratorInput>>
  teamSize?: InputMaybe<TeamSizeEnum>
  travelType?: InputMaybe<TravelTypeEnum>
  veteranPref?: InputMaybe<Scalars['Boolean']['input']>
  yearsOfExperiencePref?: InputMaybe<YearsOfExperienceEnum>
}

export type UpsertRequisitionJobDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertRequisitionSkillInput = {
  displayName?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<JobLevelEnum>
  requisitionId: Scalars['Int']['input']
  sequenceNumber?: InputMaybe<Scalars['Int']['input']>
  skillId?: InputMaybe<Scalars['Int']['input']>
  yearsOfExp?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertScorecardTemplateInput = {
  ScorecardTemplateSections?: InputMaybe<Array<ScorecardTemplateSectionInput>>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyTemplate?: InputMaybe<Scalars['Boolean']['input']>
  department?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  scorecardDescription?: InputMaybe<Scalars['String']['input']>
  scorecardName?: InputMaybe<Scalars['String']['input']>
  timestampAt?: InputMaybe<Scalars['DateTime']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpsertScreeningQuestionAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>
  answerStatus?: InputMaybe<Scalars['Boolean']['input']>
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  listingScreeningQuestionId?: InputMaybe<Scalars['Int']['input']>
}

/** Input for creating or updating a screening question */
export type UpsertScreeningQuestionInput = {
  /** Comma-separated list of answer options for MULTIPLE_CHOICE or MULTIPLE_SELECT questions */
  ansOptions?: InputMaybe<Scalars['String']['input']>
  /** ID of the company that owns this question */
  companyId?: InputMaybe<Scalars['Int']['input']>
  /** ID of the company user who created this question */
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  customCandidateApplicationFieldId?: InputMaybe<Scalars['Int']['input']>
  globalQuestionOrder?: InputMaybe<Scalars['Int']['input']>
  /** ID of the screening question to update (omit for new questions) */
  id?: InputMaybe<Scalars['Int']['input']>
  isActiveGlobally?: InputMaybe<Scalars['Boolean']['input']>
  isGlobalQuestion?: InputMaybe<Scalars['Boolean']['input']>
  /** If true, answering incorrectly will trigger automatic rejection */
  isRejectionQuestion?: InputMaybe<Scalars['Boolean']['input']>
  /** Whether this is a reusable template question */
  isTemplateQuestion?: InputMaybe<Scalars['Boolean']['input']>
  /** For NUMERICAL questions, the maximum acceptable value */
  maxVal?: InputMaybe<Scalars['Int']['input']>
  /** For NUMERICAL questions, the minimum acceptable value */
  minVal?: InputMaybe<Scalars['Int']['input']>
  /** Array of preferred answers for MULTIPLE_SELECT questions */
  multipleSelectPreferredAnswers?: InputMaybe<Array<Scalars['String']['input']>>
  /** For YES_NO and MULTIPLE_CHOICE: the correct/preferred answer(s) as comma-separated values */
  preferredAnswer?: InputMaybe<Scalars['String']['input']>
  /** For MULTIPLE_SELECT: determines if ALL_OF or ANY_OF the preferred answers are required */
  preferredAnswerType?: InputMaybe<PreferredAnswerTypeEnum>
  /** Additional description or context to help candidates understand the question */
  questionDesc?: InputMaybe<Scalars['String']['input']>
  /** The main text of the screening question shown to candidates */
  questionTitle?: InputMaybe<Scalars['String']['input']>
  /** Type of question that determines the input type and validation rules */
  questionType?: InputMaybe<QuestionTypeEnum>
  /** Custom message to display when a candidate is rejected based on this question */
  rejectMessage?: InputMaybe<Scalars['String']['input']>
  /** Controls how selection options are displayed to the user */
  selectionDisplay?: InputMaybe<SelectionDisplayEnum>
  /** Reference to a template message for rejection */
  templateMessageId?: InputMaybe<Scalars['Int']['input']>
  /** Status related to validation of numerical values */
  valStatus?: InputMaybe<Scalars['String']['input']>
}

export type UpsertSkillInput = {
  experienceId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  level?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  yearsOfExp?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertStageCollaboratorInput = {
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  requisitionJobDescriptionId?: InputMaybe<Scalars['Int']['input']>
  templateStageId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertStageSettingsInput = {
  InterviewTeam?: InputMaybe<Array<InterviewTeamInput>>
  id?: InputMaybe<Scalars['Int']['input']>
  jobPipelineId?: InputMaybe<Scalars['Int']['input']>
  scorecardTemplateId?: InputMaybe<Scalars['Int']['input']>
  templateStageId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertTemplateJobDescriptionInput = {
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type UpsertTemplateMessageInput = {
  bccEmails?: InputMaybe<Array<Scalars['String']['input']>>
  ccEmails?: InputMaybe<Array<Scalars['String']['input']>>
  companyId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  emailSubject?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  messageOwner?: InputMaybe<MessageOwnerEnum>
  messageType?: InputMaybe<MessageTypeEnum>
  senderAddress?: InputMaybe<Array<Scalars['String']['input']>>
  title?: InputMaybe<Scalars['String']['input']>
}

export type UpsertTemplateMilestoneInput = {
  TemplateStage?: InputMaybe<Array<UpsertTemplateStageInput>>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<NameEnum>
  rankOrder?: InputMaybe<Scalars['Int']['input']>
  templatePipelineId?: InputMaybe<Scalars['Int']['input']>
}

export type UpsertTemplatePipelineInput = {
  TemplateMilestones?: InputMaybe<Array<UpsertTemplateMilestoneInput>>
  archived?: InputMaybe<Scalars['Boolean']['input']>
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  companyId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  ghostPipeline?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pipelinedUsed?: InputMaybe<Scalars['Boolean']['input']>
}

export type UpsertTemplateStageInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rankOrder?: InputMaybe<Scalars['Int']['input']>
  templateMilestoneId?: InputMaybe<Scalars['Int']['input']>
  templatePipelineId?: InputMaybe<Scalars['Int']['input']>
  visibility?: InputMaybe<TemplateStageVisibilityEnum>
}

export type UpsertTokenTestResultInput = {
  id?: InputMaybe<Scalars['Int']['input']>
  offerDocumentTemplateId?: InputMaybe<Scalars['Int']['input']>
  offerSectionTemplateId?: InputMaybe<Scalars['Int']['input']>
  result?: InputMaybe<Scalars['JSON']['input']>
}

export enum UserActionEnum {
  AdvanceCandidate = 'ADVANCE_CANDIDATE',
  ApplicationWithdrawn = 'APPLICATION_WITHDRAWN',
  AvailabilitySubmitted = 'AVAILABILITY_SUBMITTED',
  CandidateApplied = 'CANDIDATE_APPLIED',
  CandidateDetailsUpdated = 'CANDIDATE_DETAILS_UPDATED',
  CandidateMarkAsDuplicate = 'CANDIDATE_MARK_AS_DUPLICATE',
  CandidateMarkAsPrimary = 'CANDIDATE_MARK_AS_PRIMARY',
  CandidateRatingSubmitted = 'CANDIDATE_RATING_SUBMITTED',
  CandidateRatingUpdated = 'CANDIDATE_RATING_UPDATED',
  CandidateTouchpoint = 'CANDIDATE_TOUCHPOINT',
  CandidateTouchpointDeleted = 'CANDIDATE_TOUCHPOINT_DELETED',
  CandidateUploaded = 'CANDIDATE_UPLOADED',
  EmailCandidate = 'EMAIL_CANDIDATE',
  InterviewConfirmationSent = 'INTERVIEW_CONFIRMATION_SENT',
  InterviewScheduledLink = 'INTERVIEW_SCHEDULED_LINK',
  InterviewScheduledManually = 'INTERVIEW_SCHEDULED_MANUALLY',
  InviteCandidate = 'INVITE_CANDIDATE',
  InviteExpired = 'INVITE_EXPIRED',
  InviteRejected = 'INVITE_REJECTED',
  JobApprovalDenied = 'JOB_APPROVAL_DENIED',
  JobApprovalRequested = 'JOB_APPROVAL_REQUESTED',
  JobApproved = 'JOB_APPROVED',
  JobDetailsUpdated = 'JOB_DETAILS_UPDATED',
  JobListingUpdated = 'JOB_LISTING_UPDATED',
  JobOfferApprovalDenied = 'JOB_OFFER_APPROVAL_DENIED',
  JobOfferApprovalRequested = 'JOB_OFFER_APPROVAL_REQUESTED',
  JobOfferApproved = 'JOB_OFFER_APPROVED',
  JobOpeningApprovalDenied = 'JOB_OPENING_APPROVAL_DENIED',
  JobOpeningApprovalRequested = 'JOB_OPENING_APPROVAL_REQUESTED',
  JobOpeningApproved = 'JOB_OPENING_APPROVED',
  JobOpeningUpdated = 'JOB_OPENING_UPDATED',
  MarkInterviewComplete = 'MARK_INTERVIEW_COMPLETE',
  MatchCandidate = 'MATCH_CANDIDATE',
  OfferAcceptedByCandidate = 'OFFER_ACCEPTED_BY_CANDIDATE',
  OfferCreated = 'OFFER_CREATED',
  OfferDeclinedByCandidate = 'OFFER_DECLINED_BY_CANDIDATE',
  OfferDeleted = 'OFFER_DELETED',
  OfferNewVersionCreated = 'OFFER_NEW_VERSION_CREATED',
  OfferSentToCandidate = 'OFFER_SENT_TO_CANDIDATE',
  OfferSentToCandidateAwaitingSignature = 'OFFER_SENT_TO_CANDIDATE_AWAITING_SIGNATURE',
  OfferVoided = 'OFFER_VOIDED',
  ReferredCandidate = 'REFERRED_CANDIDATE',
  RejectionCancelled = 'REJECTION_CANCELLED',
  RejectionPending = 'REJECTION_PENDING',
  RejectCandidate = 'REJECT_CANDIDATE',
  RemoveCandidate = 'REMOVE_CANDIDATE',
  RequestAvailability = 'REQUEST_AVAILABILITY',
  ReturnCandidateToPreviousStage = 'RETURN_CANDIDATE_TO_PREVIOUS_STAGE',
  ScorecardComplete = 'SCORECARD_COMPLETE',
  ScorecardCreated = 'SCORECARD_CREATED',
  ScorecardEdited = 'SCORECARD_EDITED',
  ScorecardInProgress = 'SCORECARD_IN_PROGRESS',
  SendSchedulerLink = 'SEND_SCHEDULER_LINK',
  UnmarkInterviewComplete = 'UNMARK_INTERVIEW_COMPLETE',
  UploadDocument = 'UPLOAD_DOCUMENT',
}

export type UserInvitation = {
  __typename?: 'UserInvitation'
  Company?: Maybe<Company>
  CompanyUser?: Maybe<CompanyUser>
  ScalisUser?: Maybe<ScalisUser>
  companyId?: Maybe<Scalars['Int']['output']>
  deletedAt?: Maybe<Scalars['DateTime']['output']>
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['Int']['output']
  invitationStatus?: Maybe<InvitationStatusEnum>
  invitedAs?: Maybe<RoleEnum>
  scalisUserId?: Maybe<Scalars['Int']['output']>
}

export type UserNote = {
  __typename?: 'UserNote'
  createdAt?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['ID']['output']
  noteText?: Maybe<Scalars['JSON']['output']>
  updatedAt?: Maybe<Scalars['DateTime']['output']>
}

export type UserRoles = {
  __typename?: 'UserRoles'
  role: Role
  roleId: Scalars['Int']['output']
  userId: Scalars['Int']['output']
}

export type UserSubscription = {
  __typename?: 'UserSubscription'
  ScalisUser: ScalisUser
  canceledAt?: Maybe<Scalars['DateTime']['output']>
  createdAt: Scalars['DateTime']['output']
  currentPeriodEnd: Scalars['DateTime']['output']
  currentPeriodStart: Scalars['DateTime']['output']
  id: Scalars['Int']['output']
  productId: Scalars['String']['output']
  scalisUserId: Scalars['Int']['output']
  status: SubscriptionStatus
  stripeCustomerId: Scalars['String']['output']
  subscriptionId: Scalars['String']['output']
  updatedAt: Scalars['DateTime']['output']
}

export type ValidateOfferDocumentTemplateInput = {
  id: Scalars['Int']['input']
}

export type ValidateOfferSectionTemplateInput = {
  id: Scalars['Int']['input']
}

export type ValidationError = {
  __typename?: 'ValidationError'
  message: Array<Scalars['String']['output']>
}

export type VerifyEmailCodeInput = {
  code: Scalars['String']['input']
  email: Scalars['String']['input']
}

export type VerifyPasswordCodeInput = {
  code: Scalars['String']['input']
}

export enum VeteranStatusEnum {
  ArmedForcesServiceMedalVeteran = 'ARMED_FORCES_SERVICE_MEDAL_VETERAN',
  DisabledVeteran = 'DISABLED_VETERAN',
  DoNotWishToAnswer = 'DO_NOT_WISH_TO_ANSWER',
  NotAProtectedVeteran = 'NOT_A_PROTECTED_VETERAN',
  OtherProtectedVeteran = 'OTHER_PROTECTED_VETERAN',
  RecentlySeparatedVeteran = 'RECENTLY_SEPARATED_VETERAN',
}

export type ViewLinkWithUserPreference = {
  __typename?: 'ViewLinkWithUserPreference'
  userPreferenceObject?: Maybe<CompanyUserView>
  viewLink: RequisitionTalentPoolCompanySavedView
}

export type VolunteerWork = {
  __typename?: 'VolunteerWork'
  description?: Maybe<Scalars['JSON']['output']>
  endDate?: Maybe<Scalars['DateTime']['output']>
  id: Scalars['Int']['output']
  isCurrentlyWorking?: Maybe<Scalars['Boolean']['output']>
  jobSeekerId?: Maybe<Scalars['Int']['output']>
  location?: Maybe<Scalars['String']['output']>
  organization?: Maybe<CompanyGlobal>
  organizationName?: Maybe<Scalars['String']['output']>
  roleType?: Maybe<RoleTypeEnum>
  searchDescription?: Maybe<Scalars['String']['output']>
  startDate?: Maybe<Scalars['DateTime']['output']>
  volunteerJobTitle?: Maybe<Scalars['String']['output']>
}

export type VolunteerWorkInput = {
  companyGlobalId?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['JSON']['input']>
  endDate?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  isCurrentlyWorking?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  organizationName?: InputMaybe<Scalars['String']['input']>
  roleType?: InputMaybe<RoleTypeEnum>
  searchDescription?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  volunteerJobTitle?: InputMaybe<Scalars['String']['input']>
}

export type WebsiteOrSocialMedia = {
  __typename?: 'WebsiteOrSocialMedia'
  id: Scalars['Int']['output']
  scalisUserId: Scalars['Int']['output']
  type: WebsiteTypeEnum
  websiteURL: Scalars['String']['output']
}

export type WebsiteOrSocialMediaInput = {
  type: WebsiteTypeEnum
  websiteURL: Scalars['String']['input']
}

export enum WebsiteTypeEnum {
  Facebook = 'FACEBOOK',
  Github = 'GITHUB',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Personal_1 = 'PERSONAL_1',
  Personal_2 = 'PERSONAL_2',
  Tiktok = 'TIKTOK',
  Twitter = 'TWITTER',
}

export enum WillingToRelocateEnum {
  No = 'NO',
  Yes = 'YES',
  YesToOnlySpecificAreas = 'YES_TO_ONLY_SPECIFIC_AREAS',
}

export enum WorkPlaceCandidateEnum {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  Remote = 'REMOTE',
}

export enum WorkplaceType {
  EntirelyRemote = 'ENTIRELY_REMOTE',
  HybridRemote = 'HYBRID_REMOTE',
  InPerson = 'IN_PERSON',
}

export enum WorkplaceTypeEnum {
  EntirelyRemote = 'ENTIRELY_REMOTE',
  HybridRemote = 'HYBRID_REMOTE',
  InPerson = 'IN_PERSON',
}

export type YearsOfExperience = {
  max: Scalars['Int']['input']
  min: Scalars['Int']['input']
}

export enum YearsOfExperienceEnum {
  Count_1To_2 = 'COUNT_1_TO_2',
  Count_3To_5 = 'COUNT_3_TO_5',
  Count_5To_7 = 'COUNT_5_TO_7',
  Count_7To_9 = 'COUNT_7_TO_9',
  Count_10Plus = 'COUNT_10_PLUS',
}

export type ActivityLogsFilterContentItem = {
  __typename?: 'activityLogsFilterContentItem'
  id?: Maybe<Scalars['Int']['output']>
  value: Scalars['String']['output']
}

export type AddressComponent = {
  __typename?: 'addressComponent'
  languageCode?: Maybe<Scalars['String']['output']>
  longText?: Maybe<Scalars['String']['output']>
  shortText?: Maybe<Scalars['String']['output']>
  types?: Maybe<Array<Scalars['String']['output']>>
}

export type CountBookmarkedJob = {
  __typename?: 'countBookmarkedJob'
  count: Scalars['Int']['output']
}

export type CountOutput = {
  __typename?: 'countOutput'
  count: Scalars['Int']['output']
}

export type EducationLevel = {
  __typename?: 'educationLevel'
  languageCode: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ExperienceTenure = {
  __typename?: 'experienceTenure'
  average: Scalars['Float']['output']
  longest: Scalars['Float']['output']
  shortest: Scalars['Float']['output']
}

export type FilterContentItem = {
  __typename?: 'filterContentItem'
  id?: Maybe<Scalars['Int']['output']>
  value: Scalars['String']['output']
}

export type JobInviteNotSentOutput = {
  __typename?: 'jobInviteNotSentOutput'
  candidateProfileId: Scalars['Int']['output']
  jobListingId: Scalars['Int']['output']
}

export type Location = {
  __typename?: 'location'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type Place = {
  __typename?: 'place'
  addressComponents: Array<AddressComponent>
  formattedAddress: Scalars['String']['output']
  id: Scalars['String']['output']
  location: Location
}

export type PlacePrediction = {
  __typename?: 'placePrediction'
  description: Scalars['String']['output']
  placeId: Scalars['String']['output']
  structuredFormatting?: Maybe<StructuredFormatting>
}

export type StructuredFormatting = {
  __typename?: 'structuredFormatting'
  mainText?: Maybe<Scalars['String']['output']>
  secondaryText?: Maybe<Scalars['String']['output']>
}

export type ActivityLogFragment = {
  __typename?: 'ActivityLog'
  id: string
  activity?: any | null
  userAction?: UserActionEnum | null
  templateStageId?: number | null
  previousTemplateStageId?: number | null
  activityTimestamp?: any | null
  companyCandidateTouchpointId?: number | null
  CompanyUser?: {
    __typename?: 'CompanyUser'
    id: string
    UserInvitation?: {
      __typename?: 'UserInvitation'
      id: number
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  } | null
  CandidateProfile?: {
    __typename?: 'CandidateProfile'
    id: string
    ScalisUser?: { __typename?: 'ScalisUser'; id: number; firstName?: string | null; lastName?: string | null } | null
    UploadedCandidate?: {
      __typename?: 'UploadedCandidate'
      id: number
      firstName?: string | null
      lastName?: string | null
    } | null
  } | null
  CompanyCandidateTouchpoint?: { __typename?: 'CompanyCandidateTouchpoint'; id: string; name: string } | null
}

export type AddressFragmentFragment = {
  __typename?: 'Address'
  id: number
  addressLine1?: string | null
  addressLine2?: string | null
  city?: string | null
  state?: string | null
  country?: string | null
  postalCode?: string | null
  timeZone?: string | null
  longitude?: string | null
  latitude?: string | null
}

export type ApplicantNotesFragmentFragment = {
  __typename?: 'ApplicantNotes'
  id: string
  createdAt?: any | null
  candidateApplicationId?: number | null
  scalisUserId?: number | null
  UserNote?: { __typename?: 'UserNote'; id: string; noteText?: any | null } | null
}

export type CandidateApplicationFragment = {
  __typename?: 'CandidateApplication'
  id: string
  matchScore?: number | null
  applicationStatus?: ApplicationStatusEnum | null
  applicationType?: string | null
  applicationCreationType?: string | null
  updatedAt?: any | null
  appliedAt?: any | null
  lastUpdatedStatusAt?: any | null
  templateStageId?: number | null
  jobListingId?: number | null
  averageRating?: number | null
  lastActivityDate?: any | null
  duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
}

export type CandidateCollaboratorFragmentFragment = {
  __typename?: 'CandidateCollaborator'
  id: string
  requisitionId?: number | null
  companyUserId?: number | null
  candidateProfileId?: number | null
  roleId?: number | null
  requisitionJobDescriptionId?: number | null
}

export type CandidateFilterFragment = { __typename?: 'CandidateFilter'; id: string; name: string; filters: any }

export type CandidateInterviewFragment = {
  __typename?: 'CandidateInterview'
  id: string
  stageId?: number | null
  status?: CandidateInterviewStatusEnum | null
}

export type CandidateLabelFragment = {
  __typename?: 'CandidateLabel'
  id: string
  colorNumber: number
  labelName: string
}

export type CandidateProfileIdsFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: { __typename?: 'ScalisUser'; id: number } | null
  UploadedCandidate?: { __typename?: 'UploadedCandidate'; id: number } | null
}

export type CandidateProfileNameFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
  UploadedCandidate?: { __typename?: 'UploadedCandidate'; firstName?: string | null; lastName?: string | null } | null
}

export type CandidateProfileEmailFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: {
    __typename?: 'ScalisUser'
    EmailVerification?: Array<{
      __typename?: 'EmailVerification'
      id: number
      isPrimary?: boolean | null
      emailAddress?: string | null
    }> | null
  } | null
  UploadedCandidate?: {
    __typename?: 'UploadedCandidate'
    emailAddress?: string | null
    EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
  } | null
}

export type CandidateProfilePhoneFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: {
    __typename?: 'ScalisUser'
    ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
  } | null
  UploadedCandidate?: {
    __typename?: 'UploadedCandidate'
    EnrichedPhoneNumber: Array<{
      __typename?: 'EnrichedPhoneNumber'
      id: string
      recommended?: boolean | null
      phoneNumber?: string | null
    }>
  } | null
}

export type CandidateProfileProfileImageFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: { __typename?: 'ScalisUser'; profileImage?: string | null } | null
  UploadedCandidate?: { __typename?: 'UploadedCandidate'; profileImage?: string | null } | null
}

export type CandidateProfileLinkedInFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: {
    __typename?: 'ScalisUser'
    WebsiteOrSocialMedia?: Array<{
      __typename?: 'WebsiteOrSocialMedia'
      id: number
      type: WebsiteTypeEnum
      websiteURL: string
    }> | null
  } | null
  UploadedCandidate?: { __typename?: 'UploadedCandidate'; linkedinProfile?: string | null } | null
}

export type CandidateProfileCurrentJobFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: {
    __typename?: 'ScalisUser'
    currentJob?: Array<{
      __typename?: 'Experience'
      id: number
      jobTitle?: string | null
      employerName?: string | null
    }> | null
  } | null
  UploadedCandidate?: {
    __typename?: 'UploadedCandidate'
    currentJob?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      jobTitle?: string | null
      employerName?: string | null
    }> | null
  } | null
}

export type CandidateSourceFragment = {
  __typename?: 'CandidateSource'
  id: number
  candidateSourceName?: {
    __typename?: 'CandidateSourceName'
    id: number
    name: string
    sourceCategory?: SourceCategoryEnum | null
    customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
  } | null
}

export type CompanyDepartmentFragmentFragment = {
  __typename?: 'CompanyDepartment'
  id: string
  companyId?: number | null
  departmentName?: string | null
  subordinateTo?: number | null
  externalId?: string | null
  createdAt?: any | null
  updatedAt?: any | null
}

export type CompanyInfoFragmentFragment = {
  __typename?: 'CompanyInfo'
  id: string
  companyName?: string | null
  logo?: string | null
}

export type CompanySavedViewFragment = {
  __typename?: 'CompanySavedView'
  id: string
  name: string
  viewLayout: CompanySavedViewLayoutEnum
  companyUserId?: number | null
  viewLocation: CompanySavedViewLocationEnum
  viewType: CompanySavedViewTypeEnum
  isVisibleTo: CompanySavedViewVisibilityEnum
  sorting: any
  columnVisibility: any
  columnOrder: any
  columnSizing: any
  candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
  requisitionTalentPoolCompanySavedViews: Array<{ __typename?: 'RequisitionTalentPoolCompanySavedView'; id: string }>
}

export type CompanyUserViewFragment = {
  __typename?: 'CompanyUserView'
  id: string
  companyUserId: number
  rankOrder: number
  requisitionTalentPoolCompanySavedViewId: number
  requisitionTalentPoolCompanySavedView: {
    __typename?: 'RequisitionTalentPoolCompanySavedView'
    id: string
    isPinned: boolean
    companySavedViewId: number
    hasPinnedSavedViewForCurrentRequisition: boolean
    belongsToCurrentRequisition: boolean
    wasRemovedForCurrentUser: boolean
    companySavedView: {
      __typename?: 'CompanySavedView'
      id: string
      name: string
      viewLayout: CompanySavedViewLayoutEnum
      companyUserId?: number | null
      viewLocation: CompanySavedViewLocationEnum
      viewType: CompanySavedViewTypeEnum
      isVisibleTo: CompanySavedViewVisibilityEnum
      sorting: any
      columnVisibility: any
      columnOrder: any
      columnSizing: any
      candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
      requisitionTalentPoolCompanySavedViews: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
      }>
    }
  }
}

export type CompanyUserFragmentFragment = {
  __typename?: 'CompanyUser'
  id: string
  companyId: number
  companyUserStatus?: CompanyUserStatusEnum | null
  profileImage?: string | null
}

export type CompanyRequiredFieldsFragment = {
  __typename?: 'Company'
  createdAt?: any | null
  externalId?: string | null
  id: string
  lastActivity?: any | null
  subdomain?: string | null
  updatedAt?: any | null
  Address: Array<{
    __typename?: 'Address'
    activeStatus?: boolean | null
    addressLine1?: string | null
    addressLine2?: string | null
    addressType?: string | null
    city?: string | null
    contactName?: string | null
    createdAt?: any | null
    country?: string | null
    id: number
    latitude?: string | null
    longitude?: string | null
    postalCode?: string | null
    scalisUserId?: number | null
    timeZone?: string | null
    state?: string | null
    updatedAt?: any | null
  }>
  CompanyInfo?: {
    __typename?: 'CompanyInfo'
    atsNeeds?: string | null
    companyId?: number | null
    companyType?: string | null
    employeeCount?: EmployeeCountEnum | null
    companyName?: string | null
    createdAt?: any | null
    hearAboutUs?: string | null
    industry?: IndustryEnum | null
    hiringNeeds?: string | null
    id: string
    logo?: string | null
    phoneNumber?: string | null
    positionsToFill?: PositionsToFillEnum | null
    updatedAt?: any | null
    recruitingOrStaffing?: boolean | null
    subIndustry?: SubIndustryTypeEnum | null
    usingATS?: boolean | null
    website?: string | null
    yearsInOperation?: number | null
  } | null
  CompanyDepartment: Array<{
    __typename?: 'CompanyDepartment'
    companyId?: number | null
    createdAt?: any | null
    departmentName?: string | null
    externalId?: string | null
    id: string
    subordinateTo?: number | null
    updatedAt?: any | null
  }>
  CompanyOffice: Array<{
    __typename?: 'CompanyOffice'
    companyId?: number | null
    createdAt?: any | null
    externalId?: string | null
    id: string
    officeName?: string | null
    updatedAt?: any | null
  }>
}

export type ConnectedEmailSettingsFragment = {
  __typename?: 'ConnectedEmailSettings'
  id: string
  email: string
  provider: ConnectedEmailProviderEnum
  dailyLimit?: number | null
  hourlyLimit?: number | null
  minutesBetweenEmails?: number | null
  allowSendOnBehalf?: boolean | null
  optOutEnabled?: boolean | null
  emailSignatureEnabled?: boolean | null
  optOutMessage?: string | null
  emailSignature?: string | null
  createdAt?: any | null
  updatedAt?: any | null
}

export type CoreReportFragment = {
  __typename?: 'CoreReport'
  reportName: CoreReportNameEnum
  isFavorite: boolean
  updatedAt: any
  createdAt: any
  companyId: number
  id: number
}

export type CurrentJobFragment = {
  __typename?: 'ScalisUser'
  currentJob?: Array<{
    __typename?: 'Experience'
    id: number
    jobTitle?: string | null
    employerName?: string | null
  }> | null
}

export type CustomApplicationStatusFragment = {
  __typename?: 'CustomApplicationStatus'
  id: string
  applicationStatusName: string
  iconType: IconTypeEnum
  iconUnicode?: string | null
  colorHexCode: string
  createdAt: any
  updatedAt: any
}

export type CustomCandidateApplicationFieldValueFragment = {
  __typename?: 'CustomCandidateApplicationFieldValue'
  id: string
  value?: any | null
  updatedAt?: any | null
  customCandidateApplicationField?: {
    __typename?: 'CustomCandidateApplicationField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    schema?: any | null
    visibility?: CustomFieldVisibilityEnum | null
    provider?: CustomFieldProviderEnum | null
    systemTokenName?: string | null
  } | null
}

export type CustomCandidateApplicationFieldFragment = {
  __typename?: 'CustomCandidateApplicationField'
  id: string
  name?: string | null
  type?: CustomCandidateFieldTypeEnum | null
  systemTokenName?: string | null
  visibility?: CustomFieldVisibilityEnum | null
  schema?: any | null
  provider?: CustomFieldProviderEnum | null
  isArchived?: boolean | null
  updatedAt?: any | null
  tooltip?: boolean | null
  tooltipText?: string | null
  showWhenUploadingCandidate?: boolean | null
  requireWhenUploadingCandidate?: boolean | null
  customCandidateApplicationFieldRequisitions?: Array<{
    __typename?: 'CustomCandidateApplicationFieldRequisition'
    id?: number | null
    requisition?: {
      __typename?: 'Requisition'
      id: string
      jobName?: string | null
      JobListing?: Array<{
        __typename?: 'JobListing'
        id: number
        externalTitle?: string | null
        listingTitle?: string | null
      }> | null
    } | null
  }> | null
  customCandidateApplicationFieldValues: Array<{
    __typename?: 'CustomCandidateApplicationFieldValue'
    id: string
    value?: any | null
    updatedAt?: any | null
    customCandidateApplicationField?: {
      __typename?: 'CustomCandidateApplicationField'
      id: string
      name?: string | null
      type?: CustomCandidateFieldTypeEnum | null
      schema?: any | null
      visibility?: CustomFieldVisibilityEnum | null
      provider?: CustomFieldProviderEnum | null
      systemTokenName?: string | null
    } | null
  }>
  createdBy?: {
    __typename?: 'CustomFieldCreatedByUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    profileImage?: string | null
  } | null
}

export type CustomCandidateApplicationFieldOutputFragment = {
  __typename?: 'CustomCandidateApplicationFieldOutput'
  id: number
  name: string
  companyId: number
  schema: any
  type: CustomCandidateFieldTypeEnum
  requisitionIds?: Array<number> | null
  isArchived: boolean
  visibility: CustomFieldVisibilityEnum
  provider: CustomFieldProviderEnum
  systemTokenName?: string | null
  tooltip?: boolean | null
  tooltipText?: string | null
  showWhenUploadingCandidate?: boolean | null
  requireWhenUploadingCandidate?: boolean | null
}

export type CustomCandidateProfileFieldValueFragment = {
  __typename?: 'CustomCandidateProfileFieldValue'
  id: string
  value?: any | null
  updatedAt?: any | null
  customCandidateProfileField?: {
    __typename?: 'CustomCandidateProfileField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    schema?: any | null
    visibility?: CustomFieldVisibilityEnum | null
    provider?: CustomFieldProviderEnum | null
    systemTokenName?: string | null
  } | null
}

export type CustomCandidateProfileFieldFragment = {
  __typename?: 'CustomCandidateProfileField'
  id: string
  name?: string | null
  type?: CustomCandidateFieldTypeEnum | null
  systemTokenName?: string | null
  visibility?: CustomFieldVisibilityEnum | null
  schema?: any | null
  provider?: CustomFieldProviderEnum | null
  isArchived?: boolean | null
  updatedAt?: any | null
  tooltip?: boolean | null
  tooltipText?: string | null
  showWhenUploadingCandidate?: boolean | null
  requireWhenUploadingCandidate?: boolean | null
  createdBy?: {
    __typename?: 'CustomFieldCreatedByUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    profileImage?: string | null
  } | null
  customCandidateProfileFieldValues?: Array<{
    __typename?: 'CustomCandidateProfileFieldValue'
    id: string
    value?: any | null
    updatedAt?: any | null
    customCandidateProfileField?: {
      __typename?: 'CustomCandidateProfileField'
      id: string
      name?: string | null
      type?: CustomCandidateFieldTypeEnum | null
      schema?: any | null
      visibility?: CustomFieldVisibilityEnum | null
      provider?: CustomFieldProviderEnum | null
      systemTokenName?: string | null
    } | null
  }> | null
}

export type CustomCandidateProfileFieldOutputFragment = {
  __typename?: 'CustomCandidateProfileFieldOutput'
  id: number
  name: string
  companyId: number
  schema: any
  type: CustomCandidateFieldTypeEnum
  requisitionId?: number | null
  isArchived: boolean
  visibility: CustomFieldVisibilityEnum
  provider: CustomFieldProviderEnum
  systemTokenName?: string | null
  tooltip?: boolean | null
  tooltipText?: string | null
  showWhenUploadingCandidate?: boolean | null
  requireWhenUploadingCandidate?: boolean | null
}

export type CustomJobRequisitionFieldFragment = {
  __typename?: 'CustomJobRequisitionField'
  id: string
  name: string
  type: CustomJobRequisitionFieldTypeEnum
  systemTokenName?: string | null
  visibility: CustomFieldVisibilityEnum
  schema: any
  provider: CustomFieldProviderEnum
  isArchived: boolean
  isRequired: boolean
  updatedAt: any
  tooltip?: boolean | null
  tooltipText?: string | null
  createdBy?: {
    __typename?: 'CustomFieldCreatedByUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    profileImage?: string | null
  } | null
}

export type CustomJobRequisitionFieldOutputFragment = {
  __typename?: 'CustomJobRequisitionField'
  id: string
  name: string
  companyId: number
  schema: any
  type: CustomJobRequisitionFieldTypeEnum
  isRequired: boolean
  isArchived: boolean
  visibility: CustomFieldVisibilityEnum
  provider: CustomFieldProviderEnum
  systemTokenName?: string | null
  tooltip?: boolean | null
  tooltipText?: string | null
  createdAt: any
  updatedAt: any
}

export type CustomJobRequisitionFieldValueFragment = {
  __typename?: 'CustomJobRequisitionFieldValue'
  id: string
  requisitionId?: number | null
  customJobRequisitionFieldId?: number | null
  value?: any | null
  companyUserId: number
  createdAt?: any | null
  updatedAt?: any | null
  customJobRequisitionField?: {
    __typename?: 'CustomJobRequisitionField'
    id: string
    name: string
    type: CustomJobRequisitionFieldTypeEnum
    systemTokenName?: string | null
    visibility: CustomFieldVisibilityEnum
    schema: any
    provider: CustomFieldProviderEnum
    isArchived: boolean
    isRequired: boolean
    updatedAt: any
    tooltip?: boolean | null
    tooltipText?: string | null
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  } | null
}

export type ExperienceFragment = {
  __typename?: 'Experience'
  id: number
  jobTitle?: string | null
  employerName?: string | null
  longFormDesc?: string | null
  startDate?: any | null
  endDate?: any | null
  jobType?: JobTypeEnum | null
  location?: string | null
  locationType?: string | null
  description?: string | null
  isCurrentlyWorking?: boolean | null
  isCurrentJob?: boolean | null
}

export type HiringTeamMemberFragmentFragment = {
  __typename?: 'HiringTeamMember'
  id: string
  companyUserId?: number | null
  roleId?: number | null
  requisitionId?: number | null
  requisitionJobDescriptionId?: number | null
  role?: { __typename?: 'Role'; id: string; name: string } | null
}

export type JobCampaignProductFragmentFragment = {
  __typename?: 'JobCampaignProduct'
  product_id: string
  audience_group: string
  title: string
  description: string
  homepage: string
  cross_postings: Array<string>
  duration: { __typename?: 'Duration'; period: number; range: string }
  industries: Array<{ __typename?: 'JobCampaignIndustry'; id: number; name: string }>
  job_functions: Array<{ __typename?: 'JobFunction'; id: string; name: string }>
  locations: Array<{ __typename?: 'JobCampaignLocation'; canonical_name: string; id: number }>
  logo_rectangle_url?: Array<{ __typename?: 'Logo'; url: string }> | null
  vonq_price: Array<{ __typename?: 'Price'; amount: number; currency: string }>
  time_to_process: { __typename?: 'ProcessTime'; period: number; range: string }
}

export type RequisitionJobDescriptionFragmentFragment = {
  __typename?: 'RequisitionJobDescription'
  id: string
  requisitionId?: number | null
  description?: string | null
}

export type JobListingJobPipelineFragmentFragment = {
  __typename?: 'JobListingJobPipeline'
  id: string
  jobListingId?: number | null
  jobPipelineId?: number | null
}

export type JobListingScreeningQuestionFragmentFragment = {
  __typename?: 'JobListingScreeningQuestion'
  id: string
  jobListingId?: number | null
  displaySequenceNumber?: number | null
  screeningQuestionId?: number | null
}

export type JobListingFragmentFragment = {
  __typename?: 'JobListing'
  id: number
  publicListingId?: string | null
  jobRequisitionId?: number | null
  listingTitle?: string | null
  externalTitle?: string | null
  workplaceType?: WorkplaceTypeEnum | null
  publicDescription?: string | null
  displayPayOnListing?: boolean | null
  industry?: IndustryEnum | null
  subIndustry?: SubIndustryTypeEnum | null
  companyDefault?: boolean | null
  stateAndOrCountry?: string | null
  internalMatchingDescription?: string | null
  searchPublicDescription?: string | null
  searchInternalMatchingDescription?: string | null
  postedAt?: any | null
  acceptingCandidates?: boolean | null
  stage?: StageEnum | null
  createdAt?: any | null
  updatedAt?: any | null
  CandidateApplication?: Array<{
    __typename?: 'CandidateApplication'
    id: string
    applicationStatus?: ApplicationStatusEnum | null
    TemplateStage?: { __typename?: 'TemplateStage'; id: string; templateMilestoneId?: number | null } | null
  }> | null
}

export type JobOpeningFragment = {
  __typename?: 'JobOpening'
  id: string
  jobRequisitionId?: number | null
  openingStatus?: OpeningStatusEnum | null
  extOpeningId?: string | null
  companyId?: number | null
  targetHireDate?: any | null
  openingType?: OpeningTypeEnum | null
  filledDate?: any | null
  startDate?: any | null
  filledByApplication?: number | null
  filledByCandidate?: number | null
  closedReason?: ClosedReasonEnum | null
  closedDate?: any | null
}

export type JobPipelineFragmentFragment = {
  __typename?: 'JobPipeline'
  id: string
  title?: string | null
  jobRequisitionId?: number | null
  templatePipelineId?: number | null
}

export type JobSearchPreferenceFragmentFragment = {
  __typename?: 'JobSearchPreference'
  id: number
  scalisUserId: number
  includeJobTitles?: any | null
  excludeJobTitles?: any | null
  jobType?: JobTypeEnum | null
  datePosted?: DatePostedEnum | null
  workplaceTypePreference?: any | null
  workplaceLocationPreference?: any | null
  relocationTypePreference?: RelocationTypePreferenceEnum | null
  relocationLocationPreference?: any | null
  minimumPayPreference?: string | null
  visaSponsorship?: boolean | null
  benefits?: any | null
  industryPreference?: any | null
  desiredCompanySize?: any | null
  minimumRequiredExperience?: string | null
  maxRequiredExperience?: string | null
  companyStage?: any | null
  createdAt: any
  updatedAt: any
}

export type ProspectStatusFragment = {
  __typename?: 'TalentPoolProspectStatus'
  id: string
  colorNumber: number
  status: string
}

export type RequisitionSkillsFragmentFragment = {
  __typename?: 'RequisitionSkill'
  id: string
  requisitionId?: number | null
  skillId?: number | null
  displayName?: string | null
  level?: string | null
  yearsOfExp?: number | null
  sequenceNumber?: number | null
  createdAt?: any | null
  updatedAt?: any | null
  skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
}

export type RequisitionTalentPoolCompanySavedViewFragment = {
  __typename?: 'RequisitionTalentPoolCompanySavedView'
  id: string
  isPinned: boolean
  companySavedViewId: number
  hasPinnedSavedViewForCurrentRequisition: boolean
  belongsToCurrentRequisition: boolean
  wasRemovedForCurrentUser: boolean
  companySavedView: {
    __typename?: 'CompanySavedView'
    id: string
    name: string
    viewLayout: CompanySavedViewLayoutEnum
    companyUserId?: number | null
    viewLocation: CompanySavedViewLocationEnum
    viewType: CompanySavedViewTypeEnum
    isVisibleTo: CompanySavedViewVisibilityEnum
    sorting: any
    columnVisibility: any
    columnOrder: any
    columnSizing: any
    candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
    requisitionTalentPoolCompanySavedViews: Array<{ __typename?: 'RequisitionTalentPoolCompanySavedView'; id: string }>
  }
}

export type RequisitionFragmentFragment = {
  __typename?: 'Requisition'
  id: string
  jobStatus?: JobStatusEnum | null
  openedAt?: any | null
  jobName?: string | null
  extRequisitionId?: string | null
  jobType?: JobTypeEnum | null
  jobLevel?: JobLevelEnum | null
  travelType?: TravelTypeEnum | null
  payType?: PayTypeEnum | null
  minPay?: number | null
  maxPay?: number | null
  additionalComp?: any | null
  benefits?: any | null
  locationDistancePref?: number | null
  educationLevelPref?: EducationLevelPrefEnum | null
  yearsOfExperiencePref?: YearsOfExperienceEnum | null
  nonTraditionalPref?: boolean | null
  veteranPref?: boolean | null
  diverseHirePref?: boolean | null
  collegeGradPref?: boolean | null
  isIncomplete: boolean
  createdAt?: any | null
  updatedAt?: any | null
  CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
  CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
}

export type RoleFragmentFragment = { __typename?: 'Role'; id: string; name: string }

export type ScalisUserAboutFragmentFragment = {
  __typename?: 'ScalisUser'
  JobSeekerInfo?: {
    __typename?: 'JobSeekerInfo'
    id: number
    aboutMe?: string | null
    searchingJobs?: boolean | null
  } | null
}

export type ScalisUserAchievementsFragmentFragment = {
  __typename?: 'ScalisUser'
  Achievement?: Array<{
    __typename?: 'Achievement'
    id: number
    name?: string | null
    issuingAuthority?: string | null
    issueYear?: number | null
    description?: any | null
  }> | null
}

export type ScalisUserCertificatesOrLicensesFragmentFragment = {
  __typename?: 'ScalisUser'
  CertificateOrLicense?: Array<{
    __typename?: 'CertificateOrLicense'
    id: number
    name?: string | null
    issuingAuthority?: string | null
    issueYear?: number | null
    description?: any | null
  }> | null
}

export type ScalisUserDemographicInfoFragmentFragment = {
  __typename?: 'ScalisUser'
  DemographicInfo?: Array<{
    __typename?: 'DemographicInfo'
    gender?: GenderEnum | null
    raceEthnicity?: string | null
    veteranStatus?: VeteranStatusEnum | null
  }> | null
}

export type ScalisUserEducationFragmentFragment = {
  __typename?: 'ScalisUser'
  Education?: Array<{
    __typename?: 'Education'
    id: number
    institutionName?: string | null
    educationLevel?: EducationLevelEnum | null
    areasOfStudy?: any | null
    startDate?: any | null
    endDate?: any | null
    cumGPA?: number | null
    cumGPAScale?: number | null
    majors?: any | null
    minors?: any | null
    hideCumGPA?: boolean | null
    hideDepartmentGPA?: boolean | null
    departmentCumGPA?: number | null
    additionalInformation?: string | null
    currentlyStudying?: boolean | null
    organization?: {
      __typename?: 'CompanyGlobal'
      logo?: string | null
      name?: string | null
      website?: string | null
    } | null
  }> | null
}

export type ScalisUserExperienceFragmentFragment = {
  __typename?: 'ScalisUser'
  Experience?: Array<{
    __typename?: 'Experience'
    id: number
    jobTitle?: string | null
    employerName?: string | null
    jobType?: JobTypeEnum | null
    locationType?: string | null
    location?: string | null
    startDate?: any | null
    endDate?: any | null
    isCurrentlyWorking?: boolean | null
    isCurrentJob?: boolean | null
    description?: string | null
    industry?: IndustryEnum | null
    subIndustry?: string | null
    managementPosition?: boolean | null
    teamSize?: TeamSizeEnum | null
    jobSeekerSkillExperiences?: Array<{
      __typename?: 'JobSeekerSkillExperience'
      id: number
      jobSeekerSkill?: { __typename?: 'JobSeekerSkill'; id: number; displayName?: string | null } | null
    }> | null
    organization?: {
      __typename?: 'CompanyGlobal'
      logo?: string | null
      name?: string | null
      website?: string | null
    } | null
  }> | null
}

export type ScalisUserSkillsFragmentFragment = {
  __typename?: 'ScalisUser'
  JobSeekerSkill?: Array<{
    __typename?: 'JobSeekerSkills'
    id: number
    sequenceNumber?: number | null
    level?: string | null
    name?: string | null
    yearsOfExp?: number | null
  }> | null
}

export type ScalisUserVolunteerWorkFragmentFragment = {
  __typename?: 'ScalisUser'
  VolunteerWork?: Array<{
    __typename?: 'VolunteerWork'
    id: number
    roleType?: RoleTypeEnum | null
    volunteerJobTitle?: string | null
    organizationName?: string | null
    location?: string | null
    startDate?: any | null
    endDate?: any | null
    isCurrentlyWorking?: boolean | null
    description?: any | null
    searchDescription?: string | null
  }> | null
}

export type ScalisUserWebsiteOrSocialMediaFragment = {
  __typename?: 'ScalisUser'
  WebsiteOrSocialMedia?: Array<{
    __typename?: 'WebsiteOrSocialMedia'
    id: number
    websiteURL: string
    type: WebsiteTypeEnum
  }> | null
}

export type ScalisUserFragment = {
  __typename?: 'ScalisUser'
  id: number
  activeStatus?: boolean | null
  profileImage?: string | null
  firstName?: string | null
  lastName?: string | null
}

export type ScalisUserNameFragment = { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null }

export type ScheduledReportFragment = {
  __typename?: 'ScheduledReport'
  coreReportId: number
  customDaysOfWeek?: any | null
  customTime?: string | null
  deleted?: any | null
  endDate?: any | null
  id: number
  recipients: any
  repeat?: RepeatTypeEnum | null
  reportSchedulerType: ReportSchedulerTypeEnum
  startDate?: any | null
}

export type ScreenStageCollaboratorFragmentFragment = {
  __typename: 'StageCollaborator'
  id: string
  CompanyUser?: {
    __typename: 'CompanyUser'
    id: string
    profileImage?: string | null
    UserInvitation?: {
      __typename: 'UserInvitation'
      id: number
      email?: string | null
      ScalisUser?: { __typename: 'ScalisUser'; id: number; firstName?: string | null; lastName?: string | null } | null
    } | null
  } | null
}

export type ScreeningQuestionFragmentFragment = {
  __typename?: 'ScreeningQuestion'
  id: string
  isTemplateQuestion?: boolean | null
  questionTitle?: string | null
  questionDesc?: string | null
  questionType?: QuestionTypeEnum | null
  minVal?: number | null
  maxVal?: number | null
  valStatus?: string | null
  ansOptions?: string | null
  isRejectionQuestion?: boolean | null
  isGlobalQuestion?: boolean | null
  rejectMessage?: string | null
  templateMessageId?: number | null
  preferredAnswer?: string | null
  companyId?: number | null
  companyUserId?: number | null
  createdAt?: any | null
  updatedAt?: any | null
}

export type SequenceMetricsResponseFragment = {
  __typename?: 'SequenceMetricsResponse'
  bounceRate: number
  completed: number
  currentlyActive: number
  emailClickRate: number
  emailOpenRate: number
  replyRate: number
  totalEnrolled: number
}

export type SequenceScheduleSettingFragment = {
  __typename?: 'SequenceScheduleSetting'
  id: string
  name?: string | null
  endTime?: string | null
  daysOfWeek?: any | null
  timeZone?: string | null
  startTime?: string | null
  isDefault: boolean
  useContactLocalTime: boolean
}

export type SequenceSettingFragment = {
  __typename?: 'SequenceSetting'
  id: string
  includeUnsubscribeLink: boolean
  connectedEmailSettingsId: number
  sequenceScheduleSettingId: number
  cc?: any | null
  bcc?: any | null
  SequenceScheduleSetting: {
    __typename?: 'SequenceScheduleSetting'
    id: string
    name?: string | null
    endTime?: string | null
    daysOfWeek?: any | null
    timeZone?: string | null
    startTime?: string | null
    isDefault: boolean
    useContactLocalTime: boolean
  }
  ConnectedEmailSettings: {
    __typename?: 'ConnectedEmailSettings'
    id: string
    email: string
    provider: ConnectedEmailProviderEnum
    dailyLimit?: number | null
    hourlyLimit?: number | null
    minutesBetweenEmails?: number | null
    allowSendOnBehalf?: boolean | null
    optOutEnabled?: boolean | null
    emailSignatureEnabled?: boolean | null
    optOutMessage?: string | null
    emailSignature?: string | null
    createdAt?: any | null
    updatedAt?: any | null
  }
}

export type SequenceStepFragment = {
  __typename?: 'SequenceStep'
  id: string
  replyPreviousThread: boolean
  subject?: string | null
  templateMessageId?: number | null
  body?: string | null
  spreadStrategy?: SequenceStepSpreadStrategyEnum | null
  afterPreviousStep?: number | null
  emailLimitPerDay?: number | null
  stepNumber: number
  customSendTime?: string | null
  schedulerType: SequenceStepSchedulerTypeEnum
  sendTimeType: SequenceStepSendTimeTypeEnum
  emailOpenedCount: number
  emailRepliedCount: number
  emailClickedCount: number
  dropOffsCount: number
  TemplateMessage?: {
    __typename?: 'TemplateMessage'
    id: string
    message?: string | null
    title?: string | null
  } | null
}

export type SequenceFragment = {
  __typename?: 'Sequence'
  id: string
  name: string
  description?: string | null
  companyUserId: number
  associatedRequisitionIds: Array<number>
  associatedTalentPoolIds: Array<number>
  visibility: SequenceVisibilityEnum
  createdAt: any
  numberOfSteps: number
  sequenceStatus: SequenceStatusEnum
  numberOfActives: number
  numberOfCompleted: number
  ownerName?: string | null
  ownerCompanyUserId?: number | null
  isFavorite: boolean
  candidatesCount: number
  emailBouncedCount: number
  emailClickedCount: number
  emailOpenedCount: number
  emailRepliedCount: number
  SequenceSetting: {
    __typename?: 'SequenceSetting'
    id: string
    includeUnsubscribeLink: boolean
    connectedEmailSettingsId: number
    sequenceScheduleSettingId: number
    cc?: any | null
    bcc?: any | null
    SequenceScheduleSetting: {
      __typename?: 'SequenceScheduleSetting'
      id: string
      name?: string | null
      endTime?: string | null
      daysOfWeek?: any | null
      timeZone?: string | null
      startTime?: string | null
      isDefault: boolean
      useContactLocalTime: boolean
    }
    ConnectedEmailSettings: {
      __typename?: 'ConnectedEmailSettings'
      id: string
      email: string
      provider: ConnectedEmailProviderEnum
      dailyLimit?: number | null
      hourlyLimit?: number | null
      minutesBetweenEmails?: number | null
      allowSendOnBehalf?: boolean | null
      optOutEnabled?: boolean | null
      emailSignatureEnabled?: boolean | null
      optOutMessage?: string | null
      emailSignature?: string | null
      createdAt?: any | null
      updatedAt?: any | null
    }
  }
  SequenceSteps: Array<{
    __typename?: 'SequenceStep'
    id: string
    replyPreviousThread: boolean
    subject?: string | null
    templateMessageId?: number | null
    body?: string | null
    spreadStrategy?: SequenceStepSpreadStrategyEnum | null
    afterPreviousStep?: number | null
    emailLimitPerDay?: number | null
    stepNumber: number
    customSendTime?: string | null
    schedulerType: SequenceStepSchedulerTypeEnum
    sendTimeType: SequenceStepSendTimeTypeEnum
    emailOpenedCount: number
    emailRepliedCount: number
    emailClickedCount: number
    dropOffsCount: number
    TemplateMessage?: {
      __typename?: 'TemplateMessage'
      id: string
      message?: string | null
      title?: string | null
    } | null
  }>
}

export type SharedCoreReportFragment = {
  __typename?: 'SharedCoreReport'
  email: string
  id: string
  coreReportId: number
  companyUserId: number
}

export type SkillFragmentFragment = { __typename?: 'Skill'; id: string; name?: string | null }

export type SourceTrackingLinkFragment = {
  __typename?: 'SourceTrackingLink'
  id: string
  jobListingId: number
  genericListingLink?: boolean | null
  name: string
  shortCode: string
  isDeleted?: boolean | null
  companyUserId: number
  whoGetsCredit?: number | null
  candidateSourceNameId?: number | null
  countViews: number
  countUniqueViews: number
  countClicksToApply: number
  countApplies: number
  createdAt: any
  updatedAt: any
  redirectUrl: string
  jobListing: {
    __typename?: 'JobListing'
    id: number
    publicListingId?: string | null
    listingTitle?: string | null
    Requisition?: { __typename?: 'Requisition'; id: string; jobName?: string | null } | null
  }
  companyUser?: {
    __typename?: 'CompanyUser'
    id: string
    UserInvitation?: {
      __typename?: 'UserInvitation'
      ScalisUser?: { __typename?: 'ScalisUser'; id: number; firstName?: string | null; lastName?: string | null } | null
    } | null
  } | null
  whoGetsCreditCompanyUser?: {
    __typename?: 'CompanyUser'
    id: string
    UserInvitation?: {
      __typename?: 'UserInvitation'
      ScalisUser?: { __typename?: 'ScalisUser'; id: number; firstName?: string | null; lastName?: string | null } | null
    } | null
  } | null
  candidateSourceName?: {
    __typename?: 'CandidateSourceName'
    id: number
    name: string
    sourceCategory?: SourceCategoryEnum | null
    customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
  } | null
}

export type StageCollaboratorFragmentFragment = {
  __typename?: 'StageCollaborator'
  id: string
  requisitionId?: number | null
  companyUserId?: number | null
  templateStageId?: number | null
  roleId?: number | null
  requisitionJobDescriptionId?: number | null
}

export type StageSettingsFragmentFragment = {
  __typename?: 'StageSettings'
  id: string
  jobPipelineId?: number | null
  templateStageId?: number | null
  scorecardTemplateId?: number | null
}

export type TalentPoolFragment = {
  __typename?: 'TalentPool'
  associatedRequisitionIds: Array<number>
  companyId: number
  companyUserId?: number | null
  contributorCompanyUserIds: Array<number>
  description?: string | null
  id: string
  isArchived?: boolean | null
  isFavorite: boolean
  isVisibleTo: TalentPoolVisibilityEnum
  name: string
  ownerCompanyUserId?: number | null
  ownerName?: string | null
  tags: Array<string>
  count: number
  talentPoolType: TalentPoolTypeEnum
  updatedAt: any
}

export type TemplateMessageFragment = {
  __typename?: 'TemplateMessage'
  id: string
  message?: string | null
  title?: string | null
}

export type TemplateMilestoneKanbanFragment = {
  __typename: 'TemplateMilestone'
  id: string
  name?: NameEnum | null
  rankOrder?: number | null
  TemplateStage?: Array<{
    __typename: 'TemplateStage'
    id: string
    name?: string | null
    rankOrder?: number | null
    visibility?: TemplateStageVisibilityEnum | null
    CandidateApplicationByStage?: Array<{ __typename?: 'CandidateApplication'; id: string }> | null
  }> | null
}

export type TemplateMilestoneFragment = {
  __typename?: 'TemplateMilestone'
  id: string
  templatePipelineId?: number | null
  name?: NameEnum | null
  rankOrder?: number | null
  archived?: boolean | null
  createdAt?: any | null
  updatedAt?: any | null
}

export type TemplatePipelineFragmentFragment = {
  __typename?: 'TemplatePipeline'
  id: string
  companyId?: number | null
  companyUserId?: number | null
  name?: string | null
  companyDepartmentId?: number | null
  archived?: boolean | null
  pipelinedUsed?: boolean | null
  ghostPipeline?: boolean | null
  createdAt?: any | null
  updatedAt?: any | null
  deletedAt?: any | null
}

export type TemplateStageKanbanFragment = {
  __typename?: 'TemplateStage'
  id: string
  name?: string | null
  rankOrder?: number | null
  visibility?: TemplateStageVisibilityEnum | null
  CandidateApplicationByStage?: Array<{ __typename?: 'CandidateApplication'; id: string }> | null
}

export type TemplateStageFragment = {
  __typename?: 'TemplateStage'
  id: string
  templatePipelineId?: number | null
  visibility?: TemplateStageVisibilityEnum | null
  name?: string | null
  templateMilestoneId?: number | null
  rankOrder?: number | null
  archived?: boolean | null
  createdAt?: any | null
  updatedAt?: any | null
}

export type UploadedCandidateFragment = {
  __typename?: 'UploadedCandidate'
  id: number
  linkedinProfile?: string | null
  lastName?: string | null
  firstName?: string | null
  emailAddress?: string | null
  companyUserId?: number | null
  companyId?: number | null
  profileImage?: string | null
  profileUrl?: string | null
  uploadedCandidateType?: UploadedCandidateTypeEnum | null
  CandidateProfile?: {
    __typename?: 'CandidateProfile'
    id: string
    profileType: ProfileTypeEnum
    CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
  } | null
  UploadedCandidateWebsiteOrSocialMedia: Array<{
    __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
    id: number
    websiteURL: string
    type: WebsiteTypeEnum
  }>
  UploadedCandidateAchievement: Array<{
    __typename?: 'UploadedCandidateAchievement'
    id: number
    name?: string | null
    issuingAuthority?: string | null
    issueYear?: number | null
    description?: any | null
    searchDescription?: string | null
  }>
  UploadedCandidateCertificateOrLicense: Array<{
    __typename?: 'UploadedCandidateCertificateOrLicense'
    id: number
    name?: string | null
    issuingAuthority?: string | null
    issueYear?: number | null
    description?: any | null
    searchDescription?: string | null
  }>
  UploadedCandidateEducation?: Array<{
    __typename?: 'UploadedCandidateEducation'
    id: number
    institutionName?: string | null
    currentlyStudying?: boolean | null
    educationLevel?: EducationLevelEnum | null
    startDate?: any | null
    endDate?: any | null
    areasOfStudy?: any | null
    majors?: any | null
    minors?: any | null
    cumGPA?: number | null
    cumGPAScale?: number | null
    hideCumGPA?: boolean | null
    hideDepartmentGPA?: boolean | null
    departmentCumGPA?: number | null
    departmentCumGPAScale?: number | null
    additionalInformation?: string | null
  }> | null
  highestEducation?: Array<{
    __typename?: 'UploadedCandidateEducation'
    id: number
    institutionName?: string | null
    currentlyStudying?: boolean | null
    educationLevel?: EducationLevelEnum | null
    startDate?: any | null
    endDate?: any | null
    areasOfStudy?: any | null
    majors?: any | null
    minors?: any | null
    cumGPA?: number | null
    cumGPAScale?: number | null
    hideCumGPA?: boolean | null
    hideDepartmentGPA?: boolean | null
    departmentCumGPA?: number | null
    departmentCumGPAScale?: number | null
    additionalInformation?: string | null
  }> | null
  UploadedCandidateExperience?: Array<{
    __typename?: 'UploadedCandidateExperience'
    id: number
    startDate?: any | null
    endDate?: any | null
    companyLogo?: string | null
    locationType?: string | null
    location?: string | null
    shortFormDesc?: any | null
    longFormDesc?: string | null
    searchShortFormDesc?: string | null
    searchLongFormDesc?: string | null
    industry?: IndustryEnum | null
    subIndustry?: string | null
    payType?: string | null
    jobPay?: number | null
    additionalComp?: boolean | null
    jobTitle?: string | null
    employerName?: string | null
    managementPosition?: boolean | null
    teamSize?: TeamSizeEnum | null
    workPlaceCandidate?: WorkPlaceCandidateEnum | null
    isCurrentJob?: boolean | null
    jobType?: JobTypeEnum | null
    isCurrentlyWorking?: boolean | null
    description?: string | null
  }> | null
  ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
  currentJob?: Array<{
    __typename?: 'UploadedCandidateExperience'
    id: number
    startDate?: any | null
    endDate?: any | null
    companyLogo?: string | null
    locationType?: string | null
    location?: string | null
    shortFormDesc?: any | null
    longFormDesc?: string | null
    searchShortFormDesc?: string | null
    searchLongFormDesc?: string | null
    industry?: IndustryEnum | null
    subIndustry?: string | null
    payType?: string | null
    jobPay?: number | null
    additionalComp?: boolean | null
    jobTitle?: string | null
    employerName?: string | null
    managementPosition?: boolean | null
    teamSize?: TeamSizeEnum | null
    workPlaceCandidate?: WorkPlaceCandidateEnum | null
    isCurrentJob?: boolean | null
    jobType?: JobTypeEnum | null
    isCurrentlyWorking?: boolean | null
    description?: string | null
  }> | null
  mostRecentJob?: Array<{
    __typename?: 'UploadedCandidateExperience'
    id: number
    startDate?: any | null
    endDate?: any | null
    companyLogo?: string | null
    locationType?: string | null
    location?: string | null
    shortFormDesc?: any | null
    longFormDesc?: string | null
    searchShortFormDesc?: string | null
    searchLongFormDesc?: string | null
    industry?: IndustryEnum | null
    subIndustry?: string | null
    payType?: string | null
    jobPay?: number | null
    additionalComp?: boolean | null
    jobTitle?: string | null
    employerName?: string | null
    managementPosition?: boolean | null
    teamSize?: TeamSizeEnum | null
    workPlaceCandidate?: WorkPlaceCandidateEnum | null
    isCurrentJob?: boolean | null
    jobType?: JobTypeEnum | null
    isCurrentlyWorking?: boolean | null
    description?: string | null
  }> | null
  UploadedCandidateJobSeekerSkill?: Array<{
    __typename?: 'UploadedCandidateJobSeekerSkills'
    id: number
    sequenceNumber?: number | null
    level?: string | null
    name?: string | null
    yearsOfExp?: number | null
  }> | null
  UploadedCandidateVolunteerWork: Array<{
    __typename?: 'UploadedCandidateVolunteerWork'
    id: number
    volunteerJobTitle?: string | null
    organizationName?: string | null
    isCurrentlyWorking?: boolean | null
    roleType?: RoleTypeEnum | null
    startDate?: any | null
    endDate?: any | null
    description?: any | null
    searchDescription?: string | null
    location?: string | null
  }>
  EnrichedEmail: Array<{
    __typename?: 'EnrichedEmail'
    id: string
    emailAddress?: string | null
    enrichedEmailType?: EnrichedEmailTypeEnum | null
    uploadedCandidateId?: number | null
    recommended?: boolean | null
  }>
  EnrichedPhoneNumber: Array<{
    __typename?: 'EnrichedPhoneNumber'
    id: string
    phoneNumber?: string | null
    uploadedCandidateId?: number | null
    recommended?: boolean | null
  }>
}

export type UploadedCandidateWebsiteOrSocialMediaFragment = {
  __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
  id: number
  websiteURL: string
  type: WebsiteTypeEnum
}

export type UploadedCandidateCertificateOrLicenseFragment = {
  __typename?: 'UploadedCandidateCertificateOrLicense'
  id: number
  name?: string | null
  issuingAuthority?: string | null
  issueYear?: number | null
  description?: any | null
  searchDescription?: string | null
}

export type UploadedCandidateAchievementFragment = {
  __typename?: 'UploadedCandidateAchievement'
  id: number
  name?: string | null
  issuingAuthority?: string | null
  issueYear?: number | null
  description?: any | null
  searchDescription?: string | null
}

export type UploadedCandidateJobSeekerSkillsFragment = {
  __typename?: 'UploadedCandidateJobSeekerSkills'
  id: number
  sequenceNumber?: number | null
  level?: string | null
  name?: string | null
  yearsOfExp?: number | null
}

export type UploadedCandidateVolunteerWorkFragment = {
  __typename?: 'UploadedCandidateVolunteerWork'
  id: number
  volunteerJobTitle?: string | null
  organizationName?: string | null
  isCurrentlyWorking?: boolean | null
  roleType?: RoleTypeEnum | null
  startDate?: any | null
  endDate?: any | null
  description?: any | null
  searchDescription?: string | null
  location?: string | null
}

export type UploadedCandidateEducationFragment = {
  __typename?: 'UploadedCandidateEducation'
  id: number
  institutionName?: string | null
  currentlyStudying?: boolean | null
  educationLevel?: EducationLevelEnum | null
  startDate?: any | null
  endDate?: any | null
  areasOfStudy?: any | null
  majors?: any | null
  minors?: any | null
  cumGPA?: number | null
  cumGPAScale?: number | null
  hideCumGPA?: boolean | null
  hideDepartmentGPA?: boolean | null
  departmentCumGPA?: number | null
  departmentCumGPAScale?: number | null
  additionalInformation?: string | null
}

export type UploadedCandidateExperienceFragment = {
  __typename?: 'UploadedCandidateExperience'
  id: number
  startDate?: any | null
  endDate?: any | null
  companyLogo?: string | null
  locationType?: string | null
  location?: string | null
  shortFormDesc?: any | null
  longFormDesc?: string | null
  searchShortFormDesc?: string | null
  searchLongFormDesc?: string | null
  industry?: IndustryEnum | null
  subIndustry?: string | null
  payType?: string | null
  jobPay?: number | null
  additionalComp?: boolean | null
  jobTitle?: string | null
  employerName?: string | null
  managementPosition?: boolean | null
  teamSize?: TeamSizeEnum | null
  workPlaceCandidate?: WorkPlaceCandidateEnum | null
  isCurrentJob?: boolean | null
  jobType?: JobTypeEnum | null
  isCurrentlyWorking?: boolean | null
  description?: string | null
}

export type UserInvitationFragmentFragment = {
  __typename?: 'UserInvitation'
  id: number
  email?: string | null
  invitedAs?: RoleEnum | null
  invitationStatus?: InvitationStatusEnum | null
}

export type UserNoteFragmentFragment = { __typename?: 'UserNote'; id: string; noteText?: any | null }

export type ViewLinkWithUserPreferenceFragment = {
  __typename?: 'ViewLinkWithUserPreference'
  userPreferenceObject?: {
    __typename?: 'CompanyUserView'
    id: string
    companyUserId: number
    rankOrder: number
    requisitionTalentPoolCompanySavedViewId: number
    requisitionTalentPoolCompanySavedView: {
      __typename?: 'RequisitionTalentPoolCompanySavedView'
      id: string
      isPinned: boolean
      companySavedViewId: number
      hasPinnedSavedViewForCurrentRequisition: boolean
      belongsToCurrentRequisition: boolean
      wasRemovedForCurrentUser: boolean
      companySavedView: {
        __typename?: 'CompanySavedView'
        id: string
        name: string
        viewLayout: CompanySavedViewLayoutEnum
        companyUserId?: number | null
        viewLocation: CompanySavedViewLocationEnum
        viewType: CompanySavedViewTypeEnum
        isVisibleTo: CompanySavedViewVisibilityEnum
        sorting: any
        columnVisibility: any
        columnOrder: any
        columnSizing: any
        candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
        requisitionTalentPoolCompanySavedViews: Array<{
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
        }>
      }
    }
  } | null
  viewLink: {
    __typename?: 'RequisitionTalentPoolCompanySavedView'
    id: string
    isPinned: boolean
    companySavedViewId: number
    hasPinnedSavedViewForCurrentRequisition: boolean
    belongsToCurrentRequisition: boolean
    wasRemovedForCurrentUser: boolean
    companySavedView: {
      __typename?: 'CompanySavedView'
      id: string
      name: string
      viewLayout: CompanySavedViewLayoutEnum
      companyUserId?: number | null
      viewLocation: CompanySavedViewLocationEnum
      viewType: CompanySavedViewTypeEnum
      isVisibleTo: CompanySavedViewVisibilityEnum
      sorting: any
      columnVisibility: any
      columnOrder: any
      columnSizing: any
      candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
      requisitionTalentPoolCompanySavedViews: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
      }>
    }
  }
}

export type UpsertAddressFormMutationVariables = Exact<{
  input: UpsertAddressInput
}>

export type UpsertAddressFormMutation = {
  __typename?: 'Mutation'
  UpsertAddress?: { __typename: 'Address'; id: number } | null
}

export type PurchaseAiCreditsMutationVariables = Exact<{
  input: PurchaseAiCreditsInput
}>

export type PurchaseAiCreditsMutation = {
  __typename?: 'Mutation'
  PurchaseAiCredits: {
    __typename?: 'AiCreditPurchaseResponse'
    orderReference: string
    clientSecret: string
    packageInfo: any
    price: any
  }
}

export type CreateAiSourcingEventMutationVariables = Exact<{
  input: CreateAiSourcingEventInput
}>

export type CreateAiSourcingEventMutation = { __typename?: 'Mutation'; CreateAiSourcingEvent: boolean }

export type DiscardCandidateRecommendationMutationVariables = Exact<{
  input: DiscardCandidateRecommendationInput
}>

export type DiscardCandidateRecommendationMutation = {
  __typename?: 'Mutation'
  DiscardCandidateRecommendation: Array<{
    __typename?: 'DiscardedCandidateRecommendation'
    id: string
    companyId: number
    companyUserId: number
    requisitionId: number
    candidateId: string
    rate?: number | null
    reason?: string | null
    isDeleted: boolean
    createdAt: any
    updatedAt: any
  }>
}

export type SelectRecommendedCandidateMutationVariables = Exact<{
  input: SelectRecommendedCandidateInput
}>

export type SelectRecommendedCandidateMutation = {
  __typename?: 'Mutation'
  SelectRecommendedCandidate?: Array<{ __typename?: 'CandidateProfile'; id: string }> | null
}

export type DeleteAchievementMutationVariables = Exact<{
  input: DeleteAchievementInput
}>

export type DeleteAchievementMutation = { __typename?: 'Mutation'; DeleteAchievement: boolean }

export type DeleteCertificateOrLicenseMutationVariables = Exact<{
  input: DeleteCertificateOrLicenseInput
}>

export type DeleteCertificateOrLicenseMutation = { __typename?: 'Mutation'; DeleteCertificateOrLicense: boolean }

export type DeleteEducationMutationVariables = Exact<{
  input: DeleteEducationInput
}>

export type DeleteEducationMutation = { __typename?: 'Mutation'; DeleteEducation: boolean }

export type DeleteExperienceMutationVariables = Exact<{
  input: DeleteExperienceInput
}>

export type DeleteExperienceMutation = { __typename?: 'Mutation'; DeleteExperience: boolean }

export type DeleteJobSeekerSkillMutationVariables = Exact<{
  input: DeleteJobSeekerSkillInput
}>

export type DeleteJobSeekerSkillMutation = { __typename?: 'Mutation'; DeleteJobSeekerSkill: boolean }

export type DeleteVolunteerWorkMutationVariables = Exact<{
  input: DeleteVolunteerWorkInput
}>

export type DeleteVolunteerWorkMutation = { __typename?: 'Mutation'; DeleteVolunteerWork: boolean }

export type RemoveSkillFromExperienceMutationVariables = Exact<{
  input: Array<RemoveSkillFromExperienceInput> | RemoveSkillFromExperienceInput
}>

export type RemoveSkillFromExperienceMutation = { __typename?: 'Mutation'; RemoveSkillFromExperience: boolean }

export type CreateCandidateApplicationFromJobSeekerMutationVariables = Exact<{
  input: CreateCandidateApplicationFromJobSeekerInput
}>

export type CreateCandidateApplicationFromJobSeekerMutation = {
  __typename?: 'Mutation'
  CreateCandidateApplicationFromJobSeeker: { __typename?: 'CandidateApplication'; id: string }
}

export type UpdateScalisUserBasicInformationMutationVariables = Exact<{
  input: UpdateScalisUserDataInput
}>

export type UpdateScalisUserBasicInformationMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: {
    __typename?: 'ScalisUser'
    firstName?: string | null
    lastName?: string | null
    ContactInfo?: Array<{
      __typename?: 'ContactInfo'
      id: number
      phoneNumber?: string | null
      scalisUserId?: number | null
    }> | null
    DemographicInfo?: Array<{
      __typename?: 'DemographicInfo'
      gender?: GenderEnum | null
      id: number
      raceEthnicity?: string | null
      veteranStatus?: VeteranStatusEnum | null
    }> | null
  }
}

export type UpsertExperienceSkillsMutationVariables = Exact<{
  upsertInput: Array<UpsertExperienceSkillInput> | UpsertExperienceSkillInput
  deleteInput: Array<RemoveSkillFromExperienceInput> | RemoveSkillFromExperienceInput
}>

export type UpsertExperienceSkillsMutation = {
  __typename?: 'Mutation'
  RemoveSkillFromExperience: boolean
  UpsertExperienceSkill?: Array<{
    __typename?: 'JobSeekerSkill'
    id: number
    level?: string | null
    name?: string | null
    yearsOfExp?: number | null
  }> | null
}

export type UpdateScalisUserAboutMeMutationVariables = Exact<{
  id: Scalars['Int']['input']
  aboutMe?: InputMaybe<Scalars['String']['input']>
}>

export type UpdateScalisUserAboutMeMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: {
    __typename?: 'ScalisUser'
    id: number
    JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; id: number; aboutMe?: string | null } | null
  }
}

export type UpdateScalisUserDataBasicMutationVariables = Exact<{
  input: UpdateScalisUserDataInput
}>

export type UpdateScalisUserDataBasicMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: {
    __typename?: 'ScalisUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    profileImage?: string | null
  }
}

export type UpdateScalisUserDataMutationVariables = Exact<{
  input: UpdateScalisUserDataInput
}>

export type UpdateScalisUserDataMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: {
    __typename?: 'ScalisUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    profileImage?: string | null
    Address?: Array<{
      __typename?: 'Address'
      id: number
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      country?: string | null
      postalCode?: string | null
      timeZone?: string | null
      longitude?: string | null
      latitude?: string | null
    }> | null
    JobSeekerInfo?: {
      __typename?: 'JobSeekerInfo'
      id: number
      aboutMe?: string | null
      searchingJobs?: boolean | null
    } | null
    JobSeekerSkill?: Array<{
      __typename?: 'JobSeekerSkills'
      id: number
      sequenceNumber?: number | null
      level?: string | null
      name?: string | null
      yearsOfExp?: number | null
    }> | null
    Experience?: Array<{
      __typename?: 'Experience'
      id: number
      jobTitle?: string | null
      employerName?: string | null
      jobType?: JobTypeEnum | null
      locationType?: string | null
      location?: string | null
      startDate?: any | null
      endDate?: any | null
      isCurrentlyWorking?: boolean | null
      isCurrentJob?: boolean | null
      description?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      jobSeekerSkillExperiences?: Array<{
        __typename?: 'JobSeekerSkillExperience'
        id: number
        jobSeekerSkill?: { __typename?: 'JobSeekerSkill'; id: number; displayName?: string | null } | null
      }> | null
      organization?: {
        __typename?: 'CompanyGlobal'
        logo?: string | null
        name?: string | null
        website?: string | null
      } | null
    }> | null
    VolunteerWork?: Array<{
      __typename?: 'VolunteerWork'
      id: number
      roleType?: RoleTypeEnum | null
      volunteerJobTitle?: string | null
      organizationName?: string | null
      location?: string | null
      startDate?: any | null
      endDate?: any | null
      isCurrentlyWorking?: boolean | null
      description?: any | null
      searchDescription?: string | null
    }> | null
    Education?: Array<{
      __typename?: 'Education'
      id: number
      institutionName?: string | null
      educationLevel?: EducationLevelEnum | null
      areasOfStudy?: any | null
      startDate?: any | null
      endDate?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
      majors?: any | null
      minors?: any | null
      hideCumGPA?: boolean | null
      hideDepartmentGPA?: boolean | null
      departmentCumGPA?: number | null
      additionalInformation?: string | null
      currentlyStudying?: boolean | null
      organization?: {
        __typename?: 'CompanyGlobal'
        logo?: string | null
        name?: string | null
        website?: string | null
      } | null
    }> | null
    CertificateOrLicense?: Array<{
      __typename?: 'CertificateOrLicense'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
    }> | null
    Achievement?: Array<{
      __typename?: 'Achievement'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
    }> | null
    DemographicInfo?: Array<{
      __typename?: 'DemographicInfo'
      gender?: GenderEnum | null
      raceEthnicity?: string | null
      veteranStatus?: VeteranStatusEnum | null
    }> | null
    WebsiteOrSocialMedia?: Array<{
      __typename?: 'WebsiteOrSocialMedia'
      id: number
      websiteURL: string
      type: WebsiteTypeEnum
    }> | null
  }
}

export type UpdateScalisUserIsSearchingJobsMutationVariables = Exact<{
  id: Scalars['Int']['input']
  searchingJobs?: InputMaybe<Scalars['Boolean']['input']>
}>

export type UpdateScalisUserIsSearchingJobsMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: {
    __typename?: 'ScalisUser'
    id: number
    JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; id: number; searchingJobs?: boolean | null } | null
  }
}

export type UpdateScalisUserNameMutationVariables = Exact<{
  input: UpdateScalisUserDataInput
}>

export type UpdateScalisUserNameMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: { __typename?: 'ScalisUser'; id: number; firstName?: string | null; lastName?: string | null }
}

export type UpdateScalisUserResumeMutationVariables = Exact<{
  id: Scalars['Int']['input']
  aboutMe?: InputMaybe<Scalars['String']['input']>
  jobSeekerSkills?: InputMaybe<Array<JobSeekerSkillInput> | JobSeekerSkillInput>
  experiences?: InputMaybe<Array<ExperienceInput> | ExperienceInput>
  volunteerWorks?: InputMaybe<Array<VolunteerWorkInput> | VolunteerWorkInput>
  educations?: InputMaybe<Array<EducationInput> | EducationInput>
  certificateOrLicenses?: InputMaybe<Array<CertificateOrLicenseInput> | CertificateOrLicenseInput>
  achievements?: InputMaybe<Array<AchievementInput> | AchievementInput>
}>

export type UpdateScalisUserResumeMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: {
    __typename?: 'ScalisUser'
    id: number
    JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; id: number; aboutMe?: string | null } | null
    JobSeekerSkill?: Array<{
      __typename?: 'JobSeekerSkills'
      id: number
      level?: string | null
      name?: string | null
      sequenceNumber?: number | null
      yearsOfExp?: number | null
    }> | null
    Experience?: Array<{ __typename?: 'Experience'; id: number; description?: string | null }> | null
    VolunteerWork?: Array<{ __typename?: 'VolunteerWork'; id: number; description?: any | null }> | null
    Education?: Array<{ __typename?: 'Education'; id: number; additionalInformation?: string | null }> | null
    CertificateOrLicense?: Array<{ __typename?: 'CertificateOrLicense'; id: number; description?: any | null }> | null
    Achievement?: Array<{ __typename?: 'Achievement'; id: number; description?: any | null }> | null
  }
}

export type UpsertApplicationFormScreeningQuestionMutationVariables = Exact<{
  input: UpsertApplicationFormScreeningQuestionInput
}>

export type UpsertApplicationFormScreeningQuestionMutation = {
  __typename?: 'Mutation'
  UpsertApplicationFormScreeningQuestion?: {
    __typename?: 'ApplicationFormScreeningQuestion'
    id: string
    applicationFormId?: number | null
    screeningQuestionId?: number | null
    rankOrder?: number | null
    isActive?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    ScreeningQuestion?: {
      __typename?: 'ScreeningQuestion'
      id: string
      questionTitle?: string | null
      questionDesc?: string | null
      questionType?: QuestionTypeEnum | null
      ansOptions?: string | null
      minVal?: number | null
      maxVal?: number | null
      valStatus?: string | null
      preferredAnswer?: string | null
    } | null
  } | null
}

export type UpsertApplicationFormMutationVariables = Exact<{
  input: UpsertApplicationFormInput
}>

export type UpsertApplicationFormMutation = {
  __typename?: 'Mutation'
  UpsertApplicationForm?: {
    __typename?: 'ApplicationForm'
    id: string
    name?: string | null
    companyId?: number | null
    companyDepartmentId?: number | null
    companyUserId?: number | null
    isEdited?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string } | null
    CompanyUser?: { __typename?: 'CompanyUser'; id: string } | null
  } | null
}

export type SignUpMutationVariables = Exact<{
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}>

export type SignUpMutation = { __typename?: 'Mutation'; SignUp: { __typename?: 'ScalisUser'; id: number } }

export type ExchangeWebSocketTokenMutationVariables = Exact<{
  input: ExchangeWebSocketTokenInput
}>

export type ExchangeWebSocketTokenMutation = { __typename?: 'Mutation'; ExchangeWebSocketToken: string }

export type DeleteBookmarkedJobMutationVariables = Exact<{
  input: DeleteBookmarkedJobInput
}>

export type DeleteBookmarkedJobMutation = {
  __typename?: 'Mutation'
  DeleteBookmarkedJob: { __typename?: 'BookmarkedJob'; publicListingId?: string | null }
}

export type ConnectCalendarMutationVariables = Exact<{
  input: ConnectCalendarInput
}>

export type ConnectCalendarMutation = {
  __typename?: 'Mutation'
  ConnectCalendar: { __typename?: 'ConnectCalendarOutput'; authUrl: string }
}

export type DisconnectCalendarMutationVariables = Exact<{
  input: DisconnectCalendarInput
}>

export type DisconnectCalendarMutation = {
  __typename?: 'Mutation'
  DisconnectCalendar: { __typename?: 'DisconnectCalendarOutput'; success: boolean }
}

export type EditCalendarSettingsMutationVariables = Exact<{
  input: EditCalendarSettingsInput
}>

export type EditCalendarSettingsMutation = {
  __typename?: 'Mutation'
  EditCalendarSettings: {
    __typename?: 'CalendarSettings'
    id: string
    companyUserId: number
    email: string
    provider: string
    nylasGrantId: string
    availability?: any | null
    timeZone?: string | null
  }
}

export type ExchangeNylasTokenMutationVariables = Exact<{
  input: ExchangeNylasTokenInput
}>

export type ExchangeNylasTokenMutation = {
  __typename?: 'Mutation'
  ExchangeNylasToken: {
    __typename?: 'CalendarSettings'
    id: string
    availability?: any | null
    provider: string
    timeZone?: string | null
    hourDisplay: number
    email: string
    Calendars?: Array<{
      __typename?: 'Calendar'
      id: string
      name: string
      isPrimary: boolean
      color?: string | null
      CalendarEvents?: Array<{
        __typename?: 'CalendarEvent'
        id: string
        nylasEventStatus?: NylasEventStatusesEnum | null
        title?: string | null
        eventType?: EventTypeEnum | null
        description?: string | null
        startTime?: any | null
        endTime?: any | null
        timeZone?: string | null
        location?: string | null
        repeats?: RepeatsEnum | null
        reminders?: any | null
        employers?: any | null
        conferencing?: any | null
        masterEventId?: string | null
        regardingCandidates?: any | null
        regardingJobs?: any | null
        internalGuests?: any | null
        candidates?: any | null
        isScalisEvent?: boolean | null
      }> | null
    }> | null
  }
}

export type SyncCalendarMutationVariables = Exact<{ [key: string]: never }>

export type SyncCalendarMutation = {
  __typename?: 'Mutation'
  SyncCalendar: { __typename?: 'CalendarSettings'; id: string }
}

export type DeleteCandidateApplicationNoteMutationVariables = Exact<{
  input: DeleteCandidateApplicationNoteInput
}>

export type DeleteCandidateApplicationNoteMutation = {
  __typename?: 'Mutation'
  DeleteCandidateApplicationNote: { __typename?: 'CandidateApplicationNote'; id: number }
}

export type UpsertCandidateApplicationNoteMutationVariables = Exact<{
  input: UpsertCandidateApplicationNoteInput
}>

export type UpsertCandidateApplicationNoteMutation = {
  __typename?: 'Mutation'
  UpsertCandidateApplicationNote?: { __typename?: 'CandidateApplicationNote'; id: number } | null
}

export type UpsertCandidateApplicationRatingMutationVariables = Exact<{
  input: UpsertCandidateApplicationRatingInput
}>

export type UpsertCandidateApplicationRatingMutation = {
  __typename?: 'Mutation'
  UpsertCandidateApplicationRating?: {
    __typename?: 'CandidateApplicationRating'
    id: string
    candidateProfileId?: number | null
    candidateApplicationId?: number | null
    companyUserId?: number | null
    score?: number | null
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type AdvanceCandidateApplicationMutationVariables = Exact<{
  input: AdvanceCandidateApplicationInput
}>

export type AdvanceCandidateApplicationMutation = {
  __typename?: 'Mutation'
  AdvanceCandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
}

export type CreateCustomStatusAndEditApplicationStatusMutationVariables = Exact<{
  input: CreateCustomStatusAndEditApplicationStatusInput
}>

export type CreateCustomStatusAndEditApplicationStatusMutation = {
  __typename?: 'Mutation'
  CreateCustomStatusAndEditApplicationStatus: Array<{
    __typename?: 'CandidateApplication'
    id: string
    applicationStatus?: ApplicationStatusEnum | null
    customApplicationStatusId?: number | null
    lastUpdatedStatusAt?: any | null
    CustomApplicationStatus?: {
      __typename?: 'CustomApplicationStatus'
      id: string
      applicationStatusName: string
      iconType: IconTypeEnum
      iconUnicode?: string | null
      colorHexCode: string
      createdAt: any
      updatedAt: any
    } | null
  }>
}

export type CreateUploadedDocumentCandidateApplicationMutationVariables = Exact<{
  input: CreateUploadedDocumentCandidateApplicationInput
}>

export type CreateUploadedDocumentCandidateApplicationMutation = {
  __typename?: 'Mutation'
  CreateUploadedDocumentCandidateApplication?: {
    __typename?: 'UploadedDocumentCandidateApplication'
    id: string
  } | null
}

export type DeleteUploadedDocumentCandidateApplicationMutationVariables = Exact<{
  input: DeleteUploadedDocumentCandidateApplicationInput
}>

export type DeleteUploadedDocumentCandidateApplicationMutation = {
  __typename?: 'Mutation'
  DeleteUploadedDocumentCandidateApplication: { __typename?: 'UploadedDocumentCandidateApplication'; id: string }
}

export type EditCandidateApplicationStatusMutationVariables = Exact<{
  input: EditCandidateApplicationStatusInput
}>

export type EditCandidateApplicationStatusMutation = {
  __typename?: 'Mutation'
  EditCandidateApplicationStatus: Array<{
    __typename?: 'CandidateApplication'
    id: string
    applicationStatus?: ApplicationStatusEnum | null
    customApplicationStatusId?: number | null
    lastUpdatedStatusAt?: any | null
    CustomApplicationStatus?: {
      __typename?: 'CustomApplicationStatus'
      id: string
      applicationStatusName: string
      iconType: IconTypeEnum
      iconUnicode?: string | null
      colorHexCode: string
      createdAt: any
      updatedAt: any
    } | null
  }>
}

export type InviteCandidatesToApplyMutationVariables = Exact<{
  input: InviteCandidatesToApplyInput
}>

export type InviteCandidatesToApplyMutation = {
  __typename?: 'Mutation'
  InviteCandidatesToApply?: {
    __typename?: 'InviteCandidatesToApplyOutput'
    uploadedCandidatesToReviewStage?: Array<{
      __typename?: 'jobInviteNotSentOutput'
      jobListingId: number
      candidateProfileId: number
    }> | null
    sent?: Array<{
      __typename?: 'JobInvite'
      token?: number | null
      sentAt?: any | null
      jobListingId?: number | null
      inviteStatus?: InviteStatusEnum | null
      id: string
      dismissed?: boolean | null
      candidateApplicationId?: number | null
    }> | null
    profileNotFound?: Array<{
      __typename?: 'jobInviteNotSentOutput'
      jobListingId: number
      candidateProfileId: number
    }> | null
    isPreviouslyInvited?: Array<{
      __typename?: 'jobInviteNotSentOutput'
      jobListingId: number
      candidateProfileId: number
    }> | null
  } | null
}

export type MoveCandidateBackStageMutationVariables = Exact<{
  input: MoveCandidateBackStageInput
}>

export type MoveCandidateBackStageMutation = {
  __typename?: 'Mutation'
  MoveCandidateBackStage?: Array<{
    __typename?: 'CandidateApplication'
    id: string
    templateStageId?: number | null
    applicationStatus?: ApplicationStatusEnum | null
    lastUpdatedStatusAt?: any | null
  }> | null
}

export type QueueBulkRejectCandidatesMutationVariables = Exact<{
  input: BulkRejectCandidatesInput
}>

export type QueueBulkRejectCandidatesMutation = { __typename?: 'Mutation'; QueueuBulkRejectCandidates: boolean }

export type RejectCandidatesMutationVariables = Exact<{
  input: RejectCandidatesInput
  delaySeconds?: InputMaybe<Scalars['Int']['input']>
}>

export type RejectCandidatesMutation = {
  __typename?: 'Mutation'
  RejectCandidates: { __typename?: 'RejectCandidatesResponse'; jobId: string }
}

export type ResolveDuplicateApplicationsMutationVariables = Exact<{
  input: ResolveDuplicateApplicationsInput
}>

export type ResolveDuplicateApplicationsMutation = { __typename?: 'Mutation'; ResolveDuplicateApplications: boolean }

export type SendCandidatesToSourcingStageMutationVariables = Exact<{
  input: SendCandidatesToSourcingStageInput
}>

export type SendCandidatesToSourcingStageMutation = {
  __typename?: 'Mutation'
  SendCandidatesToSourcingStage?: {
    __typename?: 'SendCandidatesToSourcingStageOutput'
    profileNotFound?: Array<{ __typename?: 'CandidateApplicationNotCreatedOutput'; candidateProfileId: number }> | null
    candidateApplications?: Array<{ __typename?: 'CandidateApplication'; id: string }> | null
    alreadyHasActiveApplication?: Array<{
      __typename?: 'CandidateApplicationNotCreatedOutput'
      candidateProfileId: number
    }> | null
  } | null
}

export type StartCandidateApplicationMutationVariables = Exact<{
  input: StartCandidateApplicationInput
}>

export type StartCandidateApplicationMutation = {
  __typename?: 'Mutation'
  StartCandidateApplication: { __typename?: 'CandidateApplicationStatus'; id: string }
}

export type UndoRejectCandidatesMutationVariables = Exact<{
  input: UndoRejectCandidatesInput
}>

export type UndoRejectCandidatesMutation = { __typename?: 'Mutation'; UndoRejectCandidates: boolean }

export type DeleteCandidateCollaboratorMutationVariables = Exact<{
  input: DeleteCandidateCollaboratorInput
}>

export type DeleteCandidateCollaboratorMutation = {
  __typename?: 'Mutation'
  DeleteCandidateCollaborator: { __typename?: 'CandidateCollaborator'; id: string }
}

export type UpsertCandidateCollaboratorMutationVariables = Exact<{
  input: UpsertCandidateCollaboratorInput
}>

export type UpsertCandidateCollaboratorMutation = {
  __typename?: 'Mutation'
  UpsertCandidateCollaborator?: {
    __typename?: 'CandidateCollaborator'
    id: string
    requisitionId?: number | null
    companyUserId?: number | null
    candidateProfileId?: number | null
    roleId?: number | null
    requisitionJobDescriptionId?: number | null
  } | null
}

export type CreateCompanyProvidedCandidateEmailMutationVariables = Exact<{
  input: CreateCompanyProvidedEmailInput
}>

export type CreateCompanyProvidedCandidateEmailMutation = {
  __typename?: 'Mutation'
  CreateCompanyProvidedCandidateEmail: {
    __typename?: 'CompanyProvidedEmail'
    id: string
    email: string
    candidateProfileId: number
    createdAt?: any | null
    updatedAt?: any | null
  }
}

export type DeleteCompanyProvidedCandidateEmailMutationVariables = Exact<{
  input: DeleteCompanyProvidedEmailInput
}>

export type DeleteCompanyProvidedCandidateEmailMutation = {
  __typename?: 'Mutation'
  DeleteCompanyProvidedCandidateEmail: boolean
}

export type EditCompanyProvidedCandidateEmailMutationVariables = Exact<{
  input: EditCompanyProvidedEmailInput
}>

export type EditCompanyProvidedCandidateEmailMutation = {
  __typename?: 'Mutation'
  EditCompanyProvidedCandidateEmail: {
    __typename?: 'CompanyProvidedEmail'
    id: string
    email: string
    candidateProfileId: number
    createdAt?: any | null
    updatedAt?: any | null
  }
}

export type UpsertCandidatePrimaryEmailMutationVariables = Exact<{
  input: UpsertCandidatePrimaryEmailInput
}>

export type UpsertCandidatePrimaryEmailMutation = {
  __typename?: 'Mutation'
  UpsertCandidatePrimaryEmail: {
    __typename?: 'CandidateProfile'
    id: string
    primaryEmail?: string | null
    updatedAt?: any | null
  }
}

export type CreateCandidateFilterMutationVariables = Exact<{
  input: CreateCandidateFilterInput
}>

export type CreateCandidateFilterMutation = {
  __typename?: 'Mutation'
  CreateCandidateFilter: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any }
}

export type DeleteCandidateFilterMutationVariables = Exact<{
  input: DeleteCandidateFilterInput
}>

export type DeleteCandidateFilterMutation = {
  __typename?: 'Mutation'
  DeleteCandidateFilter: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any }
}

export type UpdateCandidateFilterMutationVariables = Exact<{
  input: UpdateCandidateFilterInput
}>

export type UpdateCandidateFilterMutation = {
  __typename?: 'Mutation'
  UpdateCandidateFilter: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any }
}

export type CreateAndAssignCandidateLabelMutationVariables = Exact<{
  input: CreateAndAssignCandidateLabelInput
}>

export type CreateAndAssignCandidateLabelMutation = {
  __typename?: 'Mutation'
  CreateAndAssignCandidateLabel?: {
    __typename?: 'CandidateLabel'
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    id: string
    colorNumber: number
    labelName: string
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateProfiles: Array<{ __typename?: 'CandidateLabelCandidateProfile'; id: string }>
  } | null
}

export type CreateCandidateLabelMutationVariables = Exact<{
  input: CreateCandidateLabelInput
}>

export type CreateCandidateLabelMutation = {
  __typename?: 'Mutation'
  CreateCandidateLabel?: {
    __typename?: 'CandidateLabel'
    id: string
    labelName: string
    colorNumber: number
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateProfiles: Array<{ __typename?: 'CandidateLabelCandidateProfile'; id: string }>
  } | null
}

export type DeleteCandidateLabelMutationVariables = Exact<{
  input: DeleteCandidateLabelInput
}>

export type DeleteCandidateLabelMutation = {
  __typename?: 'Mutation'
  DeleteCandidateLabel?: {
    __typename?: 'CandidateLabel'
    id: string
    labelName: string
    colorNumber: number
    companyId: number
    companyUserId: number
  } | null
}

export type EditCandidateLabelMutationVariables = Exact<{
  input: EditCandidateLabelInput
}>

export type EditCandidateLabelMutation = {
  __typename?: 'Mutation'
  EditCandidateLabel?: {
    __typename?: 'CandidateLabel'
    id: string
    labelName: string
    colorNumber: number
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateProfiles: Array<{ __typename?: 'CandidateLabelCandidateProfile'; id: string }>
  } | null
}

export type ManageCandidateLabelsMutationVariables = Exact<{
  input: ManageCandidateLabelsInput
}>

export type ManageCandidateLabelsMutation = {
  __typename?: 'Mutation'
  ManageCandidateLabels?: Array<{
    __typename?: 'CandidateLabel'
    id: string
    labelName: string
    colorNumber: number
    companyId: number
    companyUserId: number
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateProfiles: Array<{ __typename?: 'CandidateLabelCandidateProfile'; id: string }>
  }> | null
}

export type MergeCandidateLabelsMutationVariables = Exact<{
  input: MergeCandidateLabelsInput
}>

export type MergeCandidateLabelsMutation = {
  __typename?: 'Mutation'
  MergeCandidateLabels?: {
    __typename?: 'CandidateLabel'
    id: string
    labelName: string
    colorNumber: number
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateProfiles: Array<{ __typename?: 'CandidateLabelCandidateProfile'; id: string }>
  } | null
}

export type DeleteCandidateMedalistDesignationMutationVariables = Exact<{
  input: DeleteCandidateMedalistDesignationInput
}>

export type DeleteCandidateMedalistDesignationMutation = {
  __typename?: 'Mutation'
  DeleteCandidateMedalistDesignation: { __typename?: 'CandidateMedalistDesignation'; id: number }
}

export type DeleteCandidateProfileLocationMutationVariables = Exact<{
  input: DeleteCandidateProfileLocationInput
}>

export type DeleteCandidateProfileLocationMutation = {
  __typename?: 'Mutation'
  DeleteCandidateProfileLocation: { __typename?: 'CandidateProfileLocation'; id: number }
}

export type DeleteCandidateProfileNoteMutationVariables = Exact<{
  input: DeleteCandidateProfileNoteInput
}>

export type DeleteCandidateProfileNoteMutation = {
  __typename?: 'Mutation'
  DeleteCandidateProfileNote: { __typename?: 'CandidateProfileNote'; id: number }
}

export type UpsertCandidateProfileNoteMutationVariables = Exact<{
  input: UpsertCandidateProfileNoteInput
}>

export type UpsertCandidateProfileNoteMutation = {
  __typename?: 'Mutation'
  UpsertCandidateProfileNote: { __typename?: 'CandidateProfileNote'; id: number }
}

export type CreateCandidateSourceMutationVariables = Exact<{
  input: CandidateSourceInput
}>

export type CreateCandidateSourceMutation = {
  __typename?: 'Mutation'
  CreateCandidateSource?: { __typename?: 'CandidateSource'; id: number } | null
}

export type CreateUploadedDocumentCandidateProfileMutationVariables = Exact<{
  input: CreateUploadedDocumentCandidateProfileInput
}>

export type CreateUploadedDocumentCandidateProfileMutation = {
  __typename?: 'Mutation'
  CreateUploadedDocumentCandidateProfile?: { __typename?: 'UploadedDocumentCandidateProfile'; id: string } | null
}

export type DeleteCandidateApplicationFromRequisitionMutationVariables = Exact<{
  input: DeleteCandidateApplicationFromRequisitionInput
}>

export type DeleteCandidateApplicationFromRequisitionMutation = {
  __typename?: 'Mutation'
  DeleteCandidateApplicationFromRequisition: {
    __typename?: 'DeleteCandidateApplicationFromRequisitionResponse'
    success: boolean
    message?: string | null
  }
}

export type DeleteCandidateSourceMutationVariables = Exact<{
  input: DeleteCandidateSourceInput
}>

export type DeleteCandidateSourceMutation = {
  __typename?: 'Mutation'
  DeleteCandidateSource: { __typename?: 'CandidateSource'; id: number }
}

export type DeleteUploadedDocumentCandidateProfileMutationVariables = Exact<{
  input: DeleteUploadedDocumentCandidateProfileInput
}>

export type DeleteUploadedDocumentCandidateProfileMutation = {
  __typename?: 'Mutation'
  DeleteUploadedDocumentCandidateProfile: { __typename?: 'UploadedDocumentCandidateProfile'; id: string }
}

export type SendEmailToCandidateProfileMutationVariables = Exact<{
  input: SendEmailToCandidateProfileInput
}>

export type SendEmailToCandidateProfileMutation = { __typename?: 'Mutation'; SendEmailToCandidateProfile: boolean }

export type UpsertCandidateProfileMutationVariables = Exact<{
  input: UpsertCandidateProfileInput
}>

export type UpsertCandidateProfileMutation = {
  __typename?: 'Mutation'
  UpsertCandidateProfile?: {
    __typename?: 'CandidateProfile'
    id: string
    CompanyProvidedEmail: Array<{ __typename?: 'CompanyProvidedEmail'; id: string; email: string }>
  } | null
}

export type DeleteCandidateScorecardMutationVariables = Exact<{
  input: DeleteCandidateScorecardInput
}>

export type DeleteCandidateScorecardMutation = {
  __typename?: 'Mutation'
  DeleteCandidateScorecard?: { __typename?: 'CandidateScorecard'; id: string } | null
}

export type GetCandidateScorecardQueryVariables = Exact<{
  input: GetCandidateScorecardInput
}>

export type GetCandidateScorecardQuery = {
  __typename?: 'Query'
  GetCandidateScorecard?: Array<{
    __typename?: 'CandidateScorecard'
    id: string
    additionalInformation?: string | null
    candidateApplicationId?: number | null
    companyUserId?: number | null
    scorecardTemplateId?: number | null
    status?: ScorecardStatusTypeEnum | null
    templateStageId?: number | null
    updatedAt?: any | null
    createdAt?: any | null
    ScorecardTemplate?: {
      __typename?: 'ScorecardTemplate'
      id: string
      scorecardName?: string | null
      department?: string | null
      createdAt?: any | null
      companyTemplate?: boolean | null
      archived?: boolean | null
      companyId?: number | null
      timestampAt?: any | null
    } | null
    CandidateApplication?: {
      __typename?: 'CandidateApplication'
      id: string
      candidateProfileId?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      CustomApplicationStatus?: {
        __typename?: 'CustomApplicationStatus'
        id: string
        applicationStatusName: string
        iconType: IconTypeEnum
        iconUnicode?: string | null
        colorHexCode: string
        createdAt: any
        updatedAt: any
      } | null
      JobListing?: {
        __typename?: 'JobListing'
        id: number
        externalTitle?: string | null
        Requisition?: {
          __typename?: 'Requisition'
          id: string
          extRequisitionId?: string | null
          jobName?: string | null
        } | null
      } | null
    } | null
    CandidateScorecardAnswers: Array<{
      __typename?: 'CandidateScorecardAnswers'
      answer?: any | null
      answerPreferredStatus?: boolean | null
      candidateScorecardId?: number | null
      dateAnswer?: any | null
      id: string
      scoreAnswer?: number | null
      scorecardTemplateQuestionId?: number | null
      overallRecommendation?: OverallRecommendationEnum | null
    }>
    TemplateStage?: {
      __typename?: 'TemplateStage'
      name?: string | null
      id: string
      createdAt?: any | null
      archived?: boolean | null
      rankOrder?: number | null
      templateMilestoneId?: number | null
      templatePipelineId?: number | null
      updatedAt?: any | null
      visibility?: TemplateStageVisibilityEnum | null
      TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
    } | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
  }> | null
}

export type SendReminderCandidateScorecardMutationVariables = Exact<{
  input: SendReminderCandidateScorecardInput
}>

export type SendReminderCandidateScorecardMutation = {
  __typename?: 'Mutation'
  SendReminderCandidateScorecard: { __typename?: 'CandidateScorecard'; id: string }
}

export type UpsertCandidateScorecardAnswersMutationVariables = Exact<{
  input: UpsertCandidateScorecardAnswersInput
}>

export type UpsertCandidateScorecardAnswersMutation = {
  __typename?: 'Mutation'
  UpsertCandidateScorecardAnswers?: {
    __typename?: 'CandidateScorecardAnswers'
    id: string
    answer?: any | null
    answerPreferredStatus?: boolean | null
    candidateScorecardId?: number | null
    dateAnswer?: any | null
    scoreAnswer?: number | null
    scorecardTemplateQuestionId?: number | null
  } | null
}

export type UpsertCandidateScorecardMutationVariables = Exact<{
  input: UpsertCandidateScorecardInput
}>

export type UpsertCandidateScorecardMutation = {
  __typename?: 'Mutation'
  UpsertCandidateScorecard?: {
    __typename?: 'CandidateScorecard'
    id: string
    scorecardTemplateId?: number | null
    status?: ScorecardStatusTypeEnum | null
    templateStageId?: number | null
    companyUserId?: number | null
    candidateApplicationId?: number | null
    additionalInformation?: string | null
  } | null
}

export type CreateCandidateSourceNameMutationVariables = Exact<{
  input: CandidateSourceNameCreateInput
}>

export type CreateCandidateSourceNameMutation = {
  __typename?: 'Mutation'
  CreateCandidateSourceName: {
    __typename?: 'CandidateSourceName'
    id: number
    name: string
    sourceCategory?: SourceCategoryEnum | null
  }
}

export type CreateCustomSourceCategoryMutationVariables = Exact<{
  input: CreateCustomSourceCategoryInput
}>

export type CreateCustomSourceCategoryMutation = {
  __typename?: 'Mutation'
  CreateCustomSourceCategory?: {
    __typename?: 'CustomSourceCategory'
    id: number
    sourceCategoryName: string
    externalId?: string | null
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateSourceNames: Array<{ __typename?: 'CandidateSourceName'; id: number; name: string }>
  } | null
}

export type DeleteCustomSourceCategoryMutationVariables = Exact<{
  input: DeleteCustomSourceCategoryInput
}>

export type DeleteCustomSourceCategoryMutation = {
  __typename?: 'Mutation'
  DeleteCustomSourceCategory?: {
    __typename?: 'CustomSourceCategory'
    id: number
    sourceCategoryName: string
    externalId?: string | null
    companyId: number
    companyUserId: number
  } | null
}

export type EditCustomSourceCategoryMutationVariables = Exact<{
  input: EditCustomSourceCategoryInput
}>

export type EditCustomSourceCategoryMutation = {
  __typename?: 'Mutation'
  EditCustomSourceCategory?: {
    __typename?: 'CustomSourceCategory'
    id: number
    sourceCategoryName: string
    externalId?: string | null
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateSourceNames: Array<{ __typename?: 'CandidateSourceName'; id: number; name: string }>
  } | null
}

export type MergeCustomSourceCategoryMutationVariables = Exact<{
  input: MergeCustomSourceCategoryInput
}>

export type MergeCustomSourceCategoryMutation = {
  __typename?: 'Mutation'
  MergeCustomSourceCategory?: {
    __typename?: 'CustomSourceCategory'
    id: number
    sourceCategoryName: string
    externalId?: string | null
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
    candidateSourceNames: Array<{ __typename?: 'CandidateSourceName'; id: number; name: string }>
  } | null
}

export type DeleteCandidateSourceNameMutationVariables = Exact<{
  input: DeleteCandidateSourceNameInput
}>

export type DeleteCandidateSourceNameMutation = {
  __typename?: 'Mutation'
  DeleteCandidateSourceName?: {
    __typename?: 'CandidateSourceName'
    id: number
    name: string
    sourceCategory?: SourceCategoryEnum | null
    companyId?: number | null
  } | null
}

export type EditCandidateSourceNameMutationVariables = Exact<{
  input: EditCandidateSourceNameInput
}>

export type EditCandidateSourceNameMutation = {
  __typename?: 'Mutation'
  EditCandidateSourceName?: {
    __typename?: 'CandidateSourceName'
    id: number
    name: string
    sourceCategory?: SourceCategoryEnum | null
    companyId?: number | null
    customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
  } | null
}

export type MergeCandidateSourceNameMutationVariables = Exact<{
  input: MergeCandidateSourceNameInput
}>

export type MergeCandidateSourceNameMutation = {
  __typename?: 'Mutation'
  MergeCandidateSourceName?: {
    __typename?: 'CandidateSourceName'
    id: number
    name: string
    sourceCategory?: SourceCategoryEnum | null
    companyId?: number | null
    customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
  } | null
}

export type CreateCandidateTouchpointActivityLogMutationVariables = Exact<{
  input: CreateTouchpointActivityLogInput
}>

export type CreateCandidateTouchpointActivityLogMutation = {
  __typename?: 'Mutation'
  CreateCandidateTouchpointActivityLog?: {
    __typename?: 'ActivityLog'
    id: string
    candidateProfileId?: number | null
    candidateApplicationId?: number | null
    companyCandidateTouchpointId?: number | null
    activityTimestamp?: any | null
    activity?: any | null
    userAction?: UserActionEnum | null
    isDeleted?: boolean | null
    createdAt: any
    updatedAt: any
    companyUserId?: number | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      primaryEmail?: string | null
      ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
    } | null
    CandidateApplication?: {
      __typename?: 'CandidateApplication'
      id: string
      applicationStatus?: ApplicationStatusEnum | null
      appliedAt?: any | null
    } | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    } | null
  } | null
}

export type CreateCompanyCandidateTouchpointMutationVariables = Exact<{
  input: CreateCompanyCandidateTouchpointInput
}>

export type CreateCompanyCandidateTouchpointMutation = {
  __typename?: 'Mutation'
  CreateCompanyCandidateTouchpoint?: {
    __typename?: 'CompanyCandidateTouchpoint'
    id: string
    name: string
    companyId?: number | null
    companyUserId?: number | null
    isDeleted?: boolean | null
    createdAt: any
    updatedAt: any
  } | null
}

export type DeleteCandidateTouchpointActivityLogMutationVariables = Exact<{
  input: DeleteCandidateTouchpointActivityLogInput
}>

export type DeleteCandidateTouchpointActivityLogMutation = {
  __typename?: 'Mutation'
  DeleteCandidateTouchpointActivityLog: boolean
}

export type DeleteCompanyCandidateTouchpointMutationVariables = Exact<{
  input: DeleteCompanyCandidateTouchpointInput
}>

export type DeleteCompanyCandidateTouchpointMutation = {
  __typename?: 'Mutation'
  DeleteCompanyCandidateTouchpoint?: { __typename?: 'CompanyCandidateTouchpoint'; id: string; name: string } | null
}

export type EditCandidateTouchpointActivityLogMutationVariables = Exact<{
  input: EditCandidateTouchpointActivityLogInput
}>

export type EditCandidateTouchpointActivityLogMutation = {
  __typename?: 'Mutation'
  EditCandidateTouchpointActivityLog?: {
    __typename?: 'ActivityLog'
    id: string
    candidateProfileId?: number | null
    candidateApplicationId?: number | null
    companyCandidateTouchpointId?: number | null
    activityTimestamp?: any | null
    activity?: any | null
    userAction?: UserActionEnum | null
    isDeleted?: boolean | null
    createdAt: any
    updatedAt: any
    companyUserId?: number | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      primaryEmail?: string | null
      ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
    } | null
    CandidateApplication?: {
      __typename?: 'CandidateApplication'
      id: string
      applicationStatus?: ApplicationStatusEnum | null
      appliedAt?: any | null
    } | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    } | null
  } | null
}

export type EditCompanyCandidateTouchpointMutationVariables = Exact<{
  input: EditCompanyCandidateTouchpointInput
}>

export type EditCompanyCandidateTouchpointMutation = {
  __typename?: 'Mutation'
  EditCompanyCandidateTouchpoint?: {
    __typename?: 'CompanyCandidateTouchpoint'
    id: string
    name: string
    companyId?: number | null
    companyUserId?: number | null
    isDeleted?: boolean | null
    createdAt: any
    updatedAt: any
  } | null
}

export type AddSavedViewMutationVariables = Exact<{
  input: AddSavedViewInput
}>

export type AddSavedViewMutation = { __typename?: 'Mutation'; AddSavedView: boolean }

export type CreateSavedViewMutationVariables = Exact<{
  input: CreateSavedViewInput
}>

export type CreateSavedViewMutation = {
  __typename?: 'Mutation'
  CreateSavedView: {
    __typename?: 'CreateSavedViewResponse'
    companyUserView: {
      __typename?: 'CompanyUserView'
      id: string
      companyUserId: number
      rankOrder: number
      requisitionTalentPoolCompanySavedViewId: number
      requisitionTalentPoolCompanySavedView: {
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
        isPinned: boolean
        companySavedViewId: number
        hasPinnedSavedViewForCurrentRequisition: boolean
        belongsToCurrentRequisition: boolean
        wasRemovedForCurrentUser: boolean
        companySavedView: {
          __typename?: 'CompanySavedView'
          id: string
          name: string
          viewLayout: CompanySavedViewLayoutEnum
          companyUserId?: number | null
          viewLocation: CompanySavedViewLocationEnum
          viewType: CompanySavedViewTypeEnum
          isVisibleTo: CompanySavedViewVisibilityEnum
          sorting: any
          columnVisibility: any
          columnOrder: any
          columnSizing: any
          candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
          requisitionTalentPoolCompanySavedViews: Array<{
            __typename?: 'RequisitionTalentPoolCompanySavedView'
            id: string
          }>
        }
      }
    }
    requisitionTalentPoolSavedView: {
      __typename?: 'RequisitionTalentPoolCompanySavedView'
      id: string
      isPinned: boolean
      companySavedViewId: number
      hasPinnedSavedViewForCurrentRequisition: boolean
      belongsToCurrentRequisition: boolean
      wasRemovedForCurrentUser: boolean
      companySavedView: {
        __typename?: 'CompanySavedView'
        id: string
        name: string
        viewLayout: CompanySavedViewLayoutEnum
        companyUserId?: number | null
        viewLocation: CompanySavedViewLocationEnum
        viewType: CompanySavedViewTypeEnum
        isVisibleTo: CompanySavedViewVisibilityEnum
        sorting: any
        columnVisibility: any
        columnOrder: any
        columnSizing: any
        candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
        requisitionTalentPoolCompanySavedViews: Array<{
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
        }>
      }
    }
    savedView: {
      __typename?: 'CompanySavedView'
      id: string
      name: string
      viewLayout: CompanySavedViewLayoutEnum
      companyUserId?: number | null
      viewLocation: CompanySavedViewLocationEnum
      viewType: CompanySavedViewTypeEnum
      isVisibleTo: CompanySavedViewVisibilityEnum
      sorting: any
      columnVisibility: any
      columnOrder: any
      columnSizing: any
      candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
      requisitionTalentPoolCompanySavedViews: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
      }>
    }
  }
}

export type DeleteSavedViewMutationVariables = Exact<{
  input: DeleteSavedViewInput
}>

export type DeleteSavedViewMutation = {
  __typename?: 'Mutation'
  DeleteSavedView: { __typename?: 'DeleteSavedViewResponse'; message?: string | null; success: boolean }
}

export type EditCompanyUserViewOrderMutationVariables = Exact<{
  input: EditCompanyUserViewOrderInput
}>

export type EditCompanyUserViewOrderMutation = {
  __typename?: 'Mutation'
  EditCompanyUserViewOrder?: Array<{
    __typename?: 'CompanyUserView'
    id: string
    companyUserId: number
    rankOrder: number
    requisitionTalentPoolCompanySavedViewId: number
    requisitionTalentPoolCompanySavedView: {
      __typename?: 'RequisitionTalentPoolCompanySavedView'
      id: string
      isPinned: boolean
      companySavedViewId: number
      hasPinnedSavedViewForCurrentRequisition: boolean
      belongsToCurrentRequisition: boolean
      wasRemovedForCurrentUser: boolean
      companySavedView: {
        __typename?: 'CompanySavedView'
        id: string
        name: string
        viewLayout: CompanySavedViewLayoutEnum
        companyUserId?: number | null
        viewLocation: CompanySavedViewLocationEnum
        viewType: CompanySavedViewTypeEnum
        isVisibleTo: CompanySavedViewVisibilityEnum
        sorting: any
        columnVisibility: any
        columnOrder: any
        columnSizing: any
        candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
        requisitionTalentPoolCompanySavedViews: Array<{
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
        }>
      }
    }
  }> | null
}

export type EditSavedViewMutationVariables = Exact<{
  input: EditSavedViewInput
}>

export type EditSavedViewMutation = {
  __typename?: 'Mutation'
  EditSavedView?: {
    __typename?: 'RequisitionTalentPoolCompanySavedView'
    companyUserViews: Array<{
      __typename?: 'CompanyUserView'
      id: string
      companyUserId: number
      rankOrder: number
      requisitionTalentPoolCompanySavedViewId: number
      requisitionTalentPoolCompanySavedView: {
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
        isPinned: boolean
        companySavedViewId: number
        hasPinnedSavedViewForCurrentRequisition: boolean
        belongsToCurrentRequisition: boolean
        wasRemovedForCurrentUser: boolean
        companySavedView: {
          __typename?: 'CompanySavedView'
          id: string
          name: string
          viewLayout: CompanySavedViewLayoutEnum
          companyUserId?: number | null
          viewLocation: CompanySavedViewLocationEnum
          viewType: CompanySavedViewTypeEnum
          isVisibleTo: CompanySavedViewVisibilityEnum
          sorting: any
          columnVisibility: any
          columnOrder: any
          columnSizing: any
          candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
          requisitionTalentPoolCompanySavedViews: Array<{
            __typename?: 'RequisitionTalentPoolCompanySavedView'
            id: string
          }>
        }
      }
    }>
    companySavedView: {
      __typename?: 'CompanySavedView'
      id: string
      name: string
      viewLayout: CompanySavedViewLayoutEnum
      companyUserId?: number | null
      viewLocation: CompanySavedViewLocationEnum
      viewType: CompanySavedViewTypeEnum
      isVisibleTo: CompanySavedViewVisibilityEnum
      sorting: any
      columnVisibility: any
      columnOrder: any
      columnSizing: any
      candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
      requisitionTalentPoolCompanySavedViews: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
      }>
    }
  } | null
}

export type PinSavedViewMutationVariables = Exact<{
  input: PinSavedViewInput
}>

export type PinSavedViewMutation = {
  __typename?: 'Mutation'
  PinSavedView?: {
    __typename?: 'RequisitionTalentPoolCompanySavedView'
    id: string
    isPinned: boolean
    companySavedViewId: number
    hasPinnedSavedViewForCurrentRequisition: boolean
    belongsToCurrentRequisition: boolean
    wasRemovedForCurrentUser: boolean
    companySavedView: {
      __typename?: 'CompanySavedView'
      id: string
      name: string
      viewLayout: CompanySavedViewLayoutEnum
      companyUserId?: number | null
      viewLocation: CompanySavedViewLocationEnum
      viewType: CompanySavedViewTypeEnum
      isVisibleTo: CompanySavedViewVisibilityEnum
      sorting: any
      columnVisibility: any
      columnOrder: any
      columnSizing: any
      candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
      requisitionTalentPoolCompanySavedViews: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
      }>
    }
  } | null
}

export type RemoveSavedViewMutationVariables = Exact<{
  input: RemoveSavedViewInput
}>

export type RemoveSavedViewMutation = {
  __typename?: 'Mutation'
  RemoveSavedView: { __typename?: 'RemoveSavedViewResponse'; message?: string | null; success: boolean }
}

export type UnpinSavedViewMutationVariables = Exact<{
  input: UnpinSavedViewInput
}>

export type UnpinSavedViewMutation = {
  __typename?: 'Mutation'
  UnpinSavedView?: {
    __typename?: 'RequisitionTalentPoolCompanySavedView'
    id: string
    isPinned: boolean
    companySavedViewId: number
    hasPinnedSavedViewForCurrentRequisition: boolean
    belongsToCurrentRequisition: boolean
    wasRemovedForCurrentUser: boolean
    companySavedView: {
      __typename?: 'CompanySavedView'
      id: string
      name: string
      viewLayout: CompanySavedViewLayoutEnum
      companyUserId?: number | null
      viewLocation: CompanySavedViewLocationEnum
      viewType: CompanySavedViewTypeEnum
      isVisibleTo: CompanySavedViewVisibilityEnum
      sorting: any
      columnVisibility: any
      columnOrder: any
      columnSizing: any
      candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
      requisitionTalentPoolCompanySavedViews: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
      }>
    }
  } | null
}

export type UpdateCompanyUserViewOrderMutationVariables = Exact<{
  input: UpdateCompanyUserViewOrderInput
}>

export type UpdateCompanyUserViewOrderMutation = {
  __typename?: 'Mutation'
  UpdateCompanyUserViewOrder?: boolean | null
}

export type CreateCompanyUserGroupMutationVariables = Exact<{
  input: CreateCompanyUserGroupInput
}>

export type CreateCompanyUserGroupMutation = {
  __typename?: 'Mutation'
  CreateCompanyUserGroup: {
    __typename?: 'CompanyUserGroup'
    id: string
    name: string
    createdAt: any
    updatedAt: any
    deleted: boolean
    createdBy: {
      __typename?: 'CompanyUser'
      id: string
      profileImage?: string | null
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
        } | null
      } | null
    }
    Offices: Array<{
      __typename?: 'CompanyUserGroupCompanyOffice'
      CompanyOffice: {
        __typename?: 'CompanyOffice'
        id: string
        officeName?: string | null
        externalId?: string | null
      }
    }>
    Departments: Array<{
      __typename?: 'CompanyUserGroupCompanyDepartment'
      CompanyDepartment: {
        __typename?: 'CompanyDepartment'
        id: string
        departmentName?: string | null
        externalId?: string | null
      }
    }>
    Members: Array<{
      __typename?: 'CompanyUserGroupCompanyUser'
      CompanyUser: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
            EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
          } | null
        } | null
      }
    }>
  }
}

export type CreateUsersInCompanyUserGroupMutationVariables = Exact<{
  input: CreateUsersInCompanyUserGroupInput
}>

export type CreateUsersInCompanyUserGroupMutation = {
  __typename?: 'Mutation'
  CreateUsersInCompanyUserGroup: {
    __typename?: 'CompanyUserGroup'
    id: string
    name: string
    createdAt: any
    updatedAt: any
    deleted: boolean
    Members: Array<{
      __typename?: 'CompanyUserGroupCompanyUser'
      CompanyUser: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
            EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
          } | null
        } | null
      }
    }>
  }
}

export type DeleteCompanyUserGroupMutationVariables = Exact<{
  input: DeleteCompanyUserGroupInput
}>

export type DeleteCompanyUserGroupMutation = {
  __typename?: 'Mutation'
  DeleteCompanyUserGroup: {
    __typename?: 'CompanyUserGroup'
    id: string
    name: string
    createdAt: any
    updatedAt: any
    deleted: boolean
  }
}

export type DeleteUsersFromCompanyUserGroupMutationVariables = Exact<{
  input: DeleteUsersFromCompanyUserGroupInput
}>

export type DeleteUsersFromCompanyUserGroupMutation = {
  __typename?: 'Mutation'
  DeleteUsersFromCompanyUserGroup: {
    __typename?: 'CompanyUserGroup'
    id: string
    name: string
    createdAt: any
    updatedAt: any
    deleted: boolean
    Members: Array<{
      __typename?: 'CompanyUserGroupCompanyUser'
      CompanyUser: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
            EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
          } | null
        } | null
      }
    }>
  }
}

export type UpdateCompanyUserGroupMutationVariables = Exact<{
  input: UpdateCompanyUserGroupInput
}>

export type UpdateCompanyUserGroupMutation = {
  __typename?: 'Mutation'
  UpdateCompanyUserGroup: {
    __typename?: 'CompanyUserGroup'
    id: string
    name: string
    createdAt: any
    updatedAt: any
    deleted: boolean
    Members: Array<{
      __typename?: 'CompanyUserGroupCompanyUser'
      CompanyUser: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
            EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
          } | null
        } | null
      }
    }>
  }
}

export type UpdateUsersInCompanyUserGroupMutationVariables = Exact<{
  input: UpdateUsersInCompanyUserGroupInput
}>

export type UpdateUsersInCompanyUserGroupMutation = {
  __typename?: 'Mutation'
  UpdateUsersInCompanyUserGroup: {
    __typename?: 'CompanyUserGroup'
    id: string
    name: string
    createdAt: any
    updatedAt: any
    deleted: boolean
    Members: Array<{
      __typename?: 'CompanyUserGroupCompanyUser'
      CompanyUser: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
            EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
          } | null
        } | null
      }
    }>
  }
}

export type ActivateCompanyUserMutationVariables = Exact<{
  input: ActivateCompanyUserInput
}>

export type ActivateCompanyUserMutation = {
  __typename?: 'Mutation'
  ActivateCompanyUser: { __typename?: 'CompanyUser'; id: string }
}

export type CreateCompanyUserFromInvitationMutationVariables = Exact<{
  input: CreateCompanyUserFromInvitationInput
}>

export type CreateCompanyUserFromInvitationMutation = {
  __typename?: 'Mutation'
  CreateCompanyUserFromInvitation: { __typename?: 'CompanyUser'; id: string }
}

export type DeleteCompanyUserFromWorkspaceMutationVariables = Exact<{
  input: DeleteCompanyUserFromWorkspaceInput
}>

export type DeleteCompanyUserFromWorkspaceMutation = {
  __typename?: 'Mutation'
  DeleteCompanyUserFromWorkspace: { __typename?: 'CompanyUser'; id: string }
}

export type DeleteInvitationFromWorkspaceMutationVariables = Exact<{
  input: DeleteInvitationFromWorkspaceInput
}>

export type DeleteInvitationFromWorkspaceMutation = {
  __typename?: 'Mutation'
  DeleteInvitationFromWorkspace: { __typename?: 'UserInvitation'; id: number }
}

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput
}>

export type InviteUserMutation = {
  __typename?: 'Mutation'
  InviteUser: Array<{ __typename?: 'UserInvitation'; id: number }>
}

export type UpdateCompanyUserRoleMutationVariables = Exact<{
  input: UpdateCompanyUserRoleInput
}>

export type UpdateCompanyUserRoleMutation = {
  __typename?: 'Mutation'
  UpdateCompanyUserRole: { __typename?: 'CompanyUser'; id: string }
}

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput
}>

export type CreateCompanyMutation = { __typename?: 'Mutation'; CreateCompany: { __typename: 'Company'; id: string } }

export type DeleteCompanyDepartmentMutationVariables = Exact<{
  input: DeleteCompanyDepartmentInput
}>

export type DeleteCompanyDepartmentMutation = {
  __typename?: 'Mutation'
  DeleteCompanyDepartment: { __typename: 'CompanyDepartment'; id: string }
}

export type DeleteCompanyOfficeMutationVariables = Exact<{
  input: DeleteCompanyOfficeInput
}>

export type DeleteCompanyOfficeMutation = {
  __typename?: 'Mutation'
  DeleteCompanyOffice: { __typename: 'CompanyOffice'; id: string }
}

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyDataInput
}>

export type UpdateCompanyMutation = {
  __typename?: 'Mutation'
  UpdateCompanyData: { __typename: 'Company'; id: string }
}

export type DisconnectConnectedEmailMutationVariables = Exact<{
  input: DisconnectConnectedEmailInput
}>

export type DisconnectConnectedEmailMutation = {
  __typename?: 'Mutation'
  DisconnectConnectedEmail?: { __typename?: 'DisconnectConnectedEmailOutput'; success: boolean } | null
}

export type ExchangeConnectedEmailTokenMutationVariables = Exact<{
  input: ExchangeConnectedEmailTokenInput
}>

export type ExchangeConnectedEmailTokenMutation = {
  __typename?: 'Mutation'
  ExchangeConnectedEmailToken?: {
    __typename?: 'ConnectedEmailSettings'
    id: string
    email: string
    provider: ConnectedEmailProviderEnum
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type GetConnectedEmailAuthUrlMutationVariables = Exact<{
  input: GetConnectedEmailAuthUrlInput
}>

export type GetConnectedEmailAuthUrlMutation = {
  __typename?: 'Mutation'
  GetConnectedEmailAuthUrl: { __typename?: 'GetConnectedEmailAuthUrlOutputType'; authUrl: string }
}

export type UpdateConnectedEmailSettingsMutationVariables = Exact<{
  input: UpdateConnectedEmailSettingsInput
}>

export type UpdateConnectedEmailSettingsMutation = {
  __typename?: 'Mutation'
  UpdateConnectedEmailSettings?: {
    __typename?: 'ConnectedEmailSettings'
    id: string
    email: string
    provider: ConnectedEmailProviderEnum
    dailyLimit?: number | null
    hourlyLimit?: number | null
    minutesBetweenEmails?: number | null
    allowSendOnBehalf?: boolean | null
    optOutEnabled?: boolean | null
    emailSignatureEnabled?: boolean | null
    optOutMessage?: string | null
    emailSignature?: string | null
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type CreateCustomApplicationStatusMutationVariables = Exact<{
  input: CreateCustomApplicationStatusInput
}>

export type CreateCustomApplicationStatusMutation = {
  __typename?: 'Mutation'
  CreateCustomApplicationStatus: {
    __typename?: 'CustomApplicationStatus'
    id: string
    applicationStatusName: string
    colorHexCode: string
    iconUnicode?: string | null
    iconType: IconTypeEnum
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    _count: number
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
  }
}

export type DeleteCustomApplicationStatusMutationVariables = Exact<{
  input: DeleteCustomApplicationStatusInput
}>

export type DeleteCustomApplicationStatusMutation = {
  __typename?: 'Mutation'
  DeleteCustomApplicationStatus: {
    __typename?: 'DeleteCustomApplicationStatusResponse'
    success: boolean
    message?: string | null
  }
}

export type EditCustomApplicationStatusMutationVariables = Exact<{
  input: EditCustomApplicationStatusInput
}>

export type EditCustomApplicationStatusMutation = {
  __typename?: 'Mutation'
  EditCustomApplicationStatus: {
    __typename?: 'CustomApplicationStatus'
    id: string
    applicationStatusName: string
    colorHexCode: string
    iconUnicode?: string | null
    iconType: IconTypeEnum
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    _count: number
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
  }
}

export type MergeCustomApplicationStatusMutationVariables = Exact<{
  input: MergeCustomApplicationStatusInput
}>

export type MergeCustomApplicationStatusMutation = {
  __typename?: 'Mutation'
  MergeCustomApplicationStatus: {
    __typename?: 'CustomApplicationStatus'
    id: string
    applicationStatusName: string
    colorHexCode: string
    iconUnicode?: string | null
    iconType: IconTypeEnum
    companyId: number
    companyUserId: number
    createdAt: any
    updatedAt: any
    _count: number
    company: { __typename?: 'Company'; id: string }
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }
  }
}

export type AssociateCustomFieldWithRequisitionMutationVariables = Exact<{
  input: AssociateCustomFieldWithRequisitionInput
}>

export type AssociateCustomFieldWithRequisitionMutation = {
  __typename?: 'Mutation'
  AssociateCustomFieldWithRequisition: {
    __typename?: 'AssociateCustomFieldWithRequisitionResponse'
    message?: string | null
    success: boolean
  }
}

export type ArchiveCustomCandidateApplicationFieldMutationVariables = Exact<{
  input: ArchiveCustomCandidateApplicationFieldInput
}>

export type ArchiveCustomCandidateApplicationFieldMutation = {
  __typename?: 'Mutation'
  ArchiveCustomCandidateApplicationField: {
    __typename?: 'CustomCandidateApplicationField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    systemTokenName?: string | null
    visibility?: CustomFieldVisibilityEnum | null
    schema?: any | null
    provider?: CustomFieldProviderEnum | null
    isArchived?: boolean | null
    updatedAt?: any | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
    customCandidateApplicationFieldRequisitions?: Array<{
      __typename?: 'CustomCandidateApplicationFieldRequisition'
      id?: number | null
      requisition?: {
        __typename?: 'Requisition'
        id: string
        jobName?: string | null
        JobListing?: Array<{
          __typename?: 'JobListing'
          id: number
          externalTitle?: string | null
          listingTitle?: string | null
        }> | null
      } | null
    }> | null
    customCandidateApplicationFieldValues: Array<{
      __typename?: 'CustomCandidateApplicationFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateApplicationField?: {
        __typename?: 'CustomCandidateApplicationField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }>
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  }
}

export type CreateCustomCandidateApplicationFieldMutationVariables = Exact<{
  input: CreateCustomCandidateApplicationFieldInput
}>

export type CreateCustomCandidateApplicationFieldMutation = {
  __typename?: 'Mutation'
  CreateCustomCandidateApplicationField?: {
    __typename?: 'CustomCandidateApplicationFieldOutput'
    id: number
    name: string
    companyId: number
    schema: any
    type: CustomCandidateFieldTypeEnum
    requisitionIds?: Array<number> | null
    isArchived: boolean
    visibility: CustomFieldVisibilityEnum
    provider: CustomFieldProviderEnum
    systemTokenName?: string | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
  } | null
}

export type DeleteCustomCandidateApplicationFieldMutationVariables = Exact<{
  input: DeleteCustomCandidateApplicationFieldInput
}>

export type DeleteCustomCandidateApplicationFieldMutation = {
  __typename?: 'Mutation'
  DeleteCustomCandidateApplicationField: {
    __typename?: 'DeleteCustomCandidateApplicationFieldResponse'
    success: boolean
    message?: string | null
  }
}

export type EditCustomCandidateApplicationFieldMutationVariables = Exact<{
  input: EditCustomCandidateApplicationFieldInput
}>

export type EditCustomCandidateApplicationFieldMutation = {
  __typename?: 'Mutation'
  EditCustomCandidateApplicationField?: {
    __typename?: 'CustomCandidateApplicationFieldOutput'
    id: number
    name: string
    companyId: number
    schema: any
    type: CustomCandidateFieldTypeEnum
    requisitionIds?: Array<number> | null
    isArchived: boolean
    visibility: CustomFieldVisibilityEnum
    provider: CustomFieldProviderEnum
    systemTokenName?: string | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
  } | null
}

export type UnarchiveCustomCandidateApplicationFieldMutationVariables = Exact<{
  input: UnarchiveCustomCandidateApplicationFieldInput
}>

export type UnarchiveCustomCandidateApplicationFieldMutation = {
  __typename?: 'Mutation'
  UnarchiveCustomCandidateApplicationField: {
    __typename?: 'CustomCandidateApplicationField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    systemTokenName?: string | null
    visibility?: CustomFieldVisibilityEnum | null
    schema?: any | null
    provider?: CustomFieldProviderEnum | null
    isArchived?: boolean | null
    updatedAt?: any | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
    customCandidateApplicationFieldRequisitions?: Array<{
      __typename?: 'CustomCandidateApplicationFieldRequisition'
      id?: number | null
      requisition?: {
        __typename?: 'Requisition'
        id: string
        jobName?: string | null
        JobListing?: Array<{
          __typename?: 'JobListing'
          id: number
          externalTitle?: string | null
          listingTitle?: string | null
        }> | null
      } | null
    }> | null
    customCandidateApplicationFieldValues: Array<{
      __typename?: 'CustomCandidateApplicationFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateApplicationField?: {
        __typename?: 'CustomCandidateApplicationField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }>
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  }
}

export type ArchiveCustomCandidateProfileFieldMutationVariables = Exact<{
  input: ArchiveCustomCandidateProfileFieldInput
}>

export type ArchiveCustomCandidateProfileFieldMutation = {
  __typename?: 'Mutation'
  ArchiveCustomCandidateProfileField: {
    __typename?: 'CustomCandidateProfileField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    systemTokenName?: string | null
    visibility?: CustomFieldVisibilityEnum | null
    schema?: any | null
    provider?: CustomFieldProviderEnum | null
    isArchived?: boolean | null
    updatedAt?: any | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
    customCandidateProfileFieldValues?: Array<{
      __typename?: 'CustomCandidateProfileFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateProfileField?: {
        __typename?: 'CustomCandidateProfileField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }> | null
  }
}

export type CreateCustomCandidateProfileFieldMutationVariables = Exact<{
  input: CreateCustomCandidateProfileFieldInput
}>

export type CreateCustomCandidateProfileFieldMutation = {
  __typename?: 'Mutation'
  CreateCustomCandidateProfileField?: {
    __typename?: 'CustomCandidateProfileFieldOutput'
    id: number
    name: string
    companyId: number
    schema: any
    type: CustomCandidateFieldTypeEnum
    requisitionId?: number | null
    isArchived: boolean
    visibility: CustomFieldVisibilityEnum
    provider: CustomFieldProviderEnum
    systemTokenName?: string | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
  } | null
}

export type DeleteCustomCandidateProfileFieldMutationVariables = Exact<{
  input: DeleteCustomCandidateProfileFieldInput
}>

export type DeleteCustomCandidateProfileFieldMutation = {
  __typename?: 'Mutation'
  DeleteCustomCandidateProfileField: {
    __typename?: 'DeleteCustomCandidateProfileFieldResponse'
    success: boolean
    message?: string | null
  }
}

export type EditCustomCandidateProfileFieldMutationVariables = Exact<{
  input: EditCustomCandidateProfileFieldInput
}>

export type EditCustomCandidateProfileFieldMutation = {
  __typename?: 'Mutation'
  EditCustomCandidateProfileField?: {
    __typename?: 'CustomCandidateProfileFieldOutput'
    id: number
    name: string
    companyId: number
    schema: any
    type: CustomCandidateFieldTypeEnum
    requisitionId?: number | null
    isArchived: boolean
    visibility: CustomFieldVisibilityEnum
    provider: CustomFieldProviderEnum
    systemTokenName?: string | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
  } | null
}

export type UnarchiveCustomCandidateProfileFieldMutationVariables = Exact<{
  input: UnarchiveCustomCandidateProfileFieldInput
}>

export type UnarchiveCustomCandidateProfileFieldMutation = {
  __typename?: 'Mutation'
  UnarchiveCustomCandidateProfileField: {
    __typename?: 'CustomCandidateProfileField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    systemTokenName?: string | null
    visibility?: CustomFieldVisibilityEnum | null
    schema?: any | null
    provider?: CustomFieldProviderEnum | null
    isArchived?: boolean | null
    updatedAt?: any | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
    customCandidateProfileFieldValues?: Array<{
      __typename?: 'CustomCandidateProfileFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateProfileField?: {
        __typename?: 'CustomCandidateProfileField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }> | null
  }
}

export type CreateCustomCandidateApplicationFieldValueMutationVariables = Exact<{
  input: CreateCustomCandidateApplicationFieldValueInput
}>

export type CreateCustomCandidateApplicationFieldValueMutation = {
  __typename?: 'Mutation'
  CreateCustomCandidateApplicationFieldValue?: {
    __typename?: 'CustomCandidateApplicationFieldValue'
    id: string
    value?: any | null
    updatedAt?: any | null
    customCandidateApplicationField?: {
      __typename?: 'CustomCandidateApplicationField'
      id: string
      name?: string | null
      type?: CustomCandidateFieldTypeEnum | null
      schema?: any | null
      visibility?: CustomFieldVisibilityEnum | null
      provider?: CustomFieldProviderEnum | null
      systemTokenName?: string | null
    } | null
  } | null
}

export type CreateCustomCandidateProfileFieldValueMutationVariables = Exact<{
  input: CreateCustomCandidateProfileFieldValueInput
}>

export type CreateCustomCandidateProfileFieldValueMutation = {
  __typename?: 'Mutation'
  CreateCustomCandidateProfileFieldValue?: {
    __typename?: 'CustomCandidateProfileFieldValue'
    id: string
    value?: any | null
    updatedAt?: any | null
    customCandidateProfileField?: {
      __typename?: 'CustomCandidateProfileField'
      id: string
      name?: string | null
      type?: CustomCandidateFieldTypeEnum | null
      schema?: any | null
      visibility?: CustomFieldVisibilityEnum | null
      provider?: CustomFieldProviderEnum | null
      systemTokenName?: string | null
    } | null
  } | null
}

export type DeleteCustomCandidateApplicationFieldValueMutationVariables = Exact<{
  input: DeleteCustomCandidateApplicationFieldValueInput
}>

export type DeleteCustomCandidateApplicationFieldValueMutation = {
  __typename?: 'Mutation'
  DeleteCustomCandidateApplicationFieldValue?: {
    __typename?: 'DeleteCustomCandidateApplicationFieldValueResponse'
    success: boolean
    message?: string | null
  } | null
}

export type DeleteCustomCandidateProfileFieldValueMutationVariables = Exact<{
  input: DeleteCustomCandidateProfileFieldValueInput
}>

export type DeleteCustomCandidateProfileFieldValueMutation = {
  __typename?: 'Mutation'
  DeleteCustomCandidateProfileFieldValue?: {
    __typename?: 'DeleteCustomCandidateProfileFieldValueResponse'
    message?: string | null
    success: boolean
  } | null
}

export type ArchiveCustomJobRequisitionFieldMutationVariables = Exact<{
  input: ArchiveCustomJobRequisitionFieldInput
}>

export type ArchiveCustomJobRequisitionFieldMutation = {
  __typename?: 'Mutation'
  ArchiveCustomJobRequisitionField?: {
    __typename?: 'CustomJobRequisitionField'
    id: string
    name: string
    type: CustomJobRequisitionFieldTypeEnum
    systemTokenName?: string | null
    visibility: CustomFieldVisibilityEnum
    schema: any
    provider: CustomFieldProviderEnum
    isArchived: boolean
    isRequired: boolean
    updatedAt: any
    tooltip?: boolean | null
    tooltipText?: string | null
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  } | null
}

export type CreateCustomJobRequisitionFieldValueMutationVariables = Exact<{
  input: CreateCustomJobRequisitionFieldValueInput
}>

export type CreateCustomJobRequisitionFieldValueMutation = {
  __typename?: 'Mutation'
  CreateCustomJobRequisitionFieldValue?: {
    __typename?: 'CustomJobRequisitionFieldValue'
    id: string
    requisitionId?: number | null
    customJobRequisitionFieldId?: number | null
    value?: any | null
    companyUserId: number
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type CreateCustomJobRequisitionFieldMutationVariables = Exact<{
  input: CreateCustomJobRequisitionFieldInput
}>

export type CreateCustomJobRequisitionFieldMutation = {
  __typename?: 'Mutation'
  CreateCustomJobRequisitionField?: {
    __typename?: 'CustomJobRequisitionField'
    id: string
    name: string
    companyId: number
    schema: any
    type: CustomJobRequisitionFieldTypeEnum
    isRequired: boolean
    isArchived: boolean
    visibility: CustomFieldVisibilityEnum
    provider: CustomFieldProviderEnum
    systemTokenName?: string | null
    tooltip?: boolean | null
    tooltipText?: string | null
    createdAt: any
    updatedAt: any
  } | null
}

export type DeleteCustomJobRequisitionFieldMutationVariables = Exact<{
  input: DeleteCustomJobRequisitionFieldInput
}>

export type DeleteCustomJobRequisitionFieldMutation = {
  __typename?: 'Mutation'
  DeleteCustomJobRequisitionField?: {
    __typename?: 'DeleteCustomJobRequisitionFieldResponse'
    success: boolean
    message: string
  } | null
}

export type EditCustomJobRequisitionFieldValueMutationVariables = Exact<{
  input: EditCustomJobRequisitionFieldValueInput
}>

export type EditCustomJobRequisitionFieldValueMutation = {
  __typename?: 'Mutation'
  EditCustomJobRequisitionFieldValue?: {
    __typename?: 'CustomJobRequisitionFieldValue'
    id: string
    requisitionId?: number | null
    customJobRequisitionFieldId?: number | null
    value?: any | null
    companyUserId: number
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type EditCustomJobRequisitionFieldMutationVariables = Exact<{
  input: EditCustomJobRequisitionFieldInput
}>

export type EditCustomJobRequisitionFieldMutation = {
  __typename?: 'Mutation'
  EditCustomJobRequisitionField?: {
    __typename?: 'CustomJobRequisitionField'
    id: string
    name: string
    companyId: number
    schema: any
    type: CustomJobRequisitionFieldTypeEnum
    isRequired: boolean
    isArchived: boolean
    visibility: CustomFieldVisibilityEnum
    provider: CustomFieldProviderEnum
    systemTokenName?: string | null
    tooltip?: boolean | null
    tooltipText?: string | null
    createdAt: any
    updatedAt: any
  } | null
}

export type UnarchiveCustomJobRequisitionFieldMutationVariables = Exact<{
  input: UnarchiveCustomJobRequisitionFieldInput
}>

export type UnarchiveCustomJobRequisitionFieldMutation = {
  __typename?: 'Mutation'
  UnarchiveCustomJobRequisitionField?: {
    __typename?: 'CustomJobRequisitionField'
    id: string
    name: string
    type: CustomJobRequisitionFieldTypeEnum
    systemTokenName?: string | null
    visibility: CustomFieldVisibilityEnum
    schema: any
    provider: CustomFieldProviderEnum
    isArchived: boolean
    isRequired: boolean
    updatedAt: any
    tooltip?: boolean | null
    tooltipText?: string | null
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  } | null
}

export type UpdateCustomCandidateApplicationFieldValueMutationVariables = Exact<{
  input: UpdateCustomCandidateApplicationFieldValueInput
}>

export type UpdateCustomCandidateApplicationFieldValueMutation = {
  __typename?: 'Mutation'
  UpdateCustomCandidateApplicationFieldValue?: {
    __typename?: 'CustomCandidateApplicationFieldValue'
    id: string
    value?: any | null
    updatedAt?: any | null
    customCandidateApplicationField?: {
      __typename?: 'CustomCandidateApplicationField'
      id: string
      name?: string | null
      type?: CustomCandidateFieldTypeEnum | null
      schema?: any | null
      visibility?: CustomFieldVisibilityEnum | null
      provider?: CustomFieldProviderEnum | null
      systemTokenName?: string | null
    } | null
  } | null
}

export type UpdateCustomCandidateProfileFieldValueMutationVariables = Exact<{
  input: UpdateCustomCandidateProfileFieldValueInput
}>

export type UpdateCustomCandidateProfileFieldValueMutation = {
  __typename?: 'Mutation'
  UpdateCustomCandidateProfileFieldValue?: {
    __typename?: 'CustomCandidateProfileFieldValue'
    id: string
    value?: any | null
    updatedAt?: any | null
    customCandidateProfileField?: {
      __typename?: 'CustomCandidateProfileField'
      id: string
      name?: string | null
      type?: CustomCandidateFieldTypeEnum | null
      schema?: any | null
      visibility?: CustomFieldVisibilityEnum | null
      provider?: CustomFieldProviderEnum | null
      systemTokenName?: string | null
    } | null
  } | null
}

export type UpsertGlobalListingSetupMutationVariables = Exact<{
  input: GlobalListingSetupInput
}>

export type UpsertGlobalListingSetupMutation = {
  __typename?: 'Mutation'
  upsertGlobalListingSetup?: {
    __typename?: 'GlobalListingSetup'
    id: number
    aboutCompanyStatement?: any | null
    footerStatement?: any | null
    companyId: number
    isAboutCompanyActive: boolean
    isFooterStatementActive: boolean
    updatedAt: any
  } | null
}

export type DeleteGlobalScreeningQuestionMutationVariables = Exact<{
  input: DeleteGlobalScreeningQuestionInput
}>

export type DeleteGlobalScreeningQuestionMutation = {
  __typename?: 'Mutation'
  DeleteGlobalScreeningQuestion: {
    __typename?: 'ScreeningQuestion'
    id: string
    questionTitle?: string | null
    questionDesc?: string | null
  }
}

export type EditGlobalScreeningQuestionMutationVariables = Exact<{
  input: EditGlobalScreeningQuestionInput
}>

export type EditGlobalScreeningQuestionMutation = {
  __typename?: 'Mutation'
  EditGlobalScreeningQuestion?: {
    __typename?: 'ScreeningQuestion'
    id: string
    questionTitle?: string | null
    questionDesc?: string | null
    questionType?: QuestionTypeEnum | null
    minVal?: number | null
    maxVal?: number | null
    valStatus?: string | null
    ansOptions?: string | null
    isRejectionQuestion?: boolean | null
    rejectMessage?: string | null
    preferredAnswer?: string | null
    isGlobalQuestion?: boolean | null
    isActiveGlobally?: boolean | null
    globalQuestionOrder?: number | null
    isEdited?: boolean | null
    isReplacedBy?: number | null
    isDeleted?: boolean | null
    companyId?: number | null
    companyUserId?: number | null
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type InsertGlobalScreeningQuestionMutationVariables = Exact<{
  input: Array<InsertGlobalScreeningQuestionInput> | InsertGlobalScreeningQuestionInput
}>

export type InsertGlobalScreeningQuestionMutation = {
  __typename?: 'Mutation'
  InsertGlobalScreeningQuestion?: Array<{
    __typename?: 'ScreeningQuestion'
    id: string
    questionTitle?: string | null
    questionDesc?: string | null
    questionType?: QuestionTypeEnum | null
    ansOptions?: string | null
    isRejectionQuestion?: boolean | null
    rejectMessage?: string | null
    preferredAnswer?: string | null
    isActiveGlobally?: boolean | null
    globalQuestionOrder?: number | null
    createdAt?: any | null
    updatedAt?: any | null
  } | null> | null
}

export type DeleteHiringTeamMemberMutationVariables = Exact<{
  input: DeleteHiringTeamMemberInput
}>

export type DeleteHiringTeamMemberMutation = {
  __typename?: 'Mutation'
  DeleteHiringTeamMember: { __typename?: 'HiringTeamMember'; id: string }
}

export type UpsertHiringTeamMemberMutationVariables = Exact<{
  input: UpsertHiringTeamMemberInput
}>

export type UpsertHiringTeamMemberMutation = {
  __typename?: 'Mutation'
  UpsertHiringTeamMember?: {
    __typename?: 'HiringTeamMember'
    id: string
    companyUserId?: number | null
    roleId?: number | null
    requisitionId?: number | null
    requisitionJobDescriptionId?: number | null
    role?: { __typename?: 'Role'; id: string; name: string } | null
  } | null
}

export type ArchiveInterviewerPoolMutationVariables = Exact<{
  input: ArchiveInterviewerPoolInput
}>

export type ArchiveInterviewerPoolMutation = {
  __typename?: 'Mutation'
  ArchiveInterviewerPool?: { __typename?: 'InterviewerPool'; id: string; isArchived: boolean; name: string } | null
}

export type CreateInterviewerPoolMutationVariables = Exact<{
  input: CreateInterviewerPoolInput
}>

export type CreateInterviewerPoolMutation = {
  __typename?: 'Mutation'
  CreateInterviewerPool?: {
    __typename?: 'InterviewerPool'
    id: string
    name: string
    description?: string | null
    maxWeeklyInterviews?: number | null
    maxDailyInterviews?: number | null
    updatedAt?: any | null
    isArchived: boolean
    Offices?: Array<{
      __typename?: 'InterviewerPoolOffice'
      id: string
      CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
    }> | null
    Departments?: Array<{
      __typename?: 'InterviewerPoolDepartment'
      id: string
      CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
    }> | null
    Skills?: Array<{
      __typename?: 'InterviewerPoolSkill'
      id: string
      Skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
    }> | null
    Members?: Array<{
      __typename?: 'InterviewerPoolMember'
      companyUserId: number
      interviewsTodayCount?: number | null
      interviewsThisWeekCount?: number | null
      interviewsLastWeekCount?: number | null
      id: string
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          email?: string | null
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
            profileImage?: string | null
          } | null
        } | null
      } | null
    }> | null
  } | null
}

export type UnarchiveInterviewerPoolMutationVariables = Exact<{
  input: UnarchiveInterviewerPoolInput
}>

export type UnarchiveInterviewerPoolMutation = {
  __typename?: 'Mutation'
  UnarchiveInterviewerPool?: { __typename?: 'InterviewerPool'; id: string; isArchived: boolean; name: string } | null
}

export type CreateInterviewMutationVariables = Exact<{
  input: CreateInterviewInput
}>

export type CreateInterviewMutation = {
  __typename?: 'Mutation'
  CreateInterview: {
    __typename?: 'CandidateInterview'
    status?: CandidateInterviewStatusEnum | null
    stageId?: number | null
    interviewData?: any | null
    id: string
    companyUserId?: number | null
    applicationId?: number | null
  }
}

export type CreateSchedulerLinkMutationVariables = Exact<{
  input: CreateSchedulerLinkInviteInput
}>

export type CreateSchedulerLinkMutation = { __typename?: 'Mutation'; CreateSchedulerLinkInvite: boolean }

export type DeleteInterviewMutationVariables = Exact<{
  input: DeleteInterviewInput
}>

export type DeleteInterviewMutation = { __typename?: 'Mutation'; DeleteInterview: boolean }

export type DeleteSchedulerLinkInviteMutationVariables = Exact<{
  input: DeleteSchedulerLinkInviteInput
}>

export type DeleteSchedulerLinkInviteMutation = { __typename?: 'Mutation'; DeleteSchedulerLinkInvite: boolean }

export type ResendSchedulerLinkInviteMutationVariables = Exact<{
  input: ResendSchedulerLinkInviteInput
}>

export type ResendSchedulerLinkInviteMutation = { __typename?: 'Mutation'; ResendSchedulerLinkInvite: boolean }

export type UpdateInterviewMutationVariables = Exact<{
  input: UpdateInterviewInput
}>

export type UpdateInterviewMutation = {
  __typename?: 'Mutation'
  UpdateInterview: {
    __typename?: 'CandidateInterview'
    status?: CandidateInterviewStatusEnum | null
    stageId?: number | null
    interviewData?: any | null
    id: string
    companyUserId?: number | null
    applicationId?: number | null
  }
}

export type CountCampaignViewMutationVariables = Exact<{
  input: CountCampaignViewInput
}>

export type CountCampaignViewMutation = {
  __typename?: 'Mutation'
  CountCampaignView?: { __typename?: 'CountCampaignView'; message: string; viewCount: number } | null
}

export type OrderJobCampaignMutationVariables = Exact<{
  input: OrderCampaignInput
}>

export type OrderJobCampaignMutation = {
  __typename?: 'Mutation'
  OrderJobCampaign?:
    | {
        __typename?: 'CampaignValidationErrors'
        errors: Array<{
          __typename?: 'CampaignErrors'
          company?: string | null
          orderedProducts?: Array<{ __typename?: 'ValidationError'; message: Array<string> }> | null
          orderedProductsSpecs?: Array<{ __typename?: 'ValidationError'; message: Array<string> }> | null
          postingDetails?: { __typename?: 'NestedValidationErrors'; fields: any } | null
          targetGroup?: { __typename?: 'NestedValidationErrors'; fields: any } | null
          recruiterInfo?: { __typename?: 'NestedValidationErrors'; fields: any } | null
        }>
      }
    | {
        __typename?: 'JobCampaignCreation'
        orderReference: string
        clientSecret: string
        deliveryTime: {
          __typename?: 'JobCampaignDeliveryTime'
          totalDays: number
          daysToSetup: number
          daysToProcess: number
        }
        price: { __typename?: 'OrderCampaignPrice'; subTotal: number; total: number; vat: number }
      }
    | null
}

export type UpdateJobInviteMutationVariables = Exact<{
  input: UpdateJobInviteInput
}>

export type UpdateJobInviteMutation = {
  __typename?: 'Mutation'
  UpdateJobInvite: { __typename?: 'JobInvite'; id: string }
}

export type DeleteJobListingMutationVariables = Exact<{
  input: DeleteJobListingInput
}>

export type DeleteJobListingMutation = {
  __typename?: 'Mutation'
  DeleteJobListing: { __typename?: 'JobListing'; id: number }
}

export type UpsertJobListingMutationVariables = Exact<{
  input: UpsertJobListingInput
}>

export type UpsertJobListingMutation = {
  __typename?: 'Mutation'
  UpsertJobListing?: {
    __typename?: 'JobListing'
    id: number
    publicListingId?: string | null
    jobRequisitionId?: number | null
    listingTitle?: string | null
    externalTitle?: string | null
    workplaceType?: WorkplaceTypeEnum | null
    publicDescription?: string | null
    displayPayOnListing?: boolean | null
    industry?: IndustryEnum | null
    subIndustry?: SubIndustryTypeEnum | null
    companyDefault?: boolean | null
    stateAndOrCountry?: string | null
    internalMatchingDescription?: string | null
    searchPublicDescription?: string | null
    searchInternalMatchingDescription?: string | null
    postedAt?: any | null
    acceptingCandidates?: boolean | null
    stage?: StageEnum | null
    createdAt?: any | null
    updatedAt?: any | null
    Address?: Array<{
      __typename?: 'Address'
      id: number
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      country?: string | null
      postalCode?: string | null
      timeZone?: string | null
      longitude?: string | null
      latitude?: string | null
    }> | null
    JobListingScreeningQuestion?: Array<{
      __typename?: 'JobListingScreeningQuestion'
      id: string
      jobListingId?: number | null
      displaySequenceNumber?: number | null
      screeningQuestionId?: number | null
      ScreeningQuestion?: {
        __typename?: 'ScreeningQuestion'
        id: string
        isTemplateQuestion?: boolean | null
        questionTitle?: string | null
        questionDesc?: string | null
        questionType?: QuestionTypeEnum | null
        minVal?: number | null
        maxVal?: number | null
        valStatus?: string | null
        ansOptions?: string | null
        isRejectionQuestion?: boolean | null
        isGlobalQuestion?: boolean | null
        rejectMessage?: string | null
        templateMessageId?: number | null
        preferredAnswer?: string | null
        companyId?: number | null
        companyUserId?: number | null
        createdAt?: any | null
        updatedAt?: any | null
      } | null
    }> | null
    CandidateApplication?: Array<{
      __typename?: 'CandidateApplication'
      id: string
      applicationStatus?: ApplicationStatusEnum | null
      TemplateStage?: { __typename?: 'TemplateStage'; id: string; templateMilestoneId?: number | null } | null
    }> | null
  } | null
}

export type SwapRequisitionPipelineMutationVariables = Exact<{
  input: SwapRequisitionPipelineInput
}>

export type SwapRequisitionPipelineMutation = {
  __typename?: 'Mutation'
  SwapRequisitionPipeline?: {
    __typename?: 'JobPipeline'
    id: string
    title?: string | null
    jobRequisitionId?: number | null
    templatePipelineId?: number | null
    TemplatePipeline?: {
      __typename?: 'TemplatePipeline'
      id: string
      companyId?: number | null
      companyUserId?: number | null
      name?: string | null
      companyDepartmentId?: number | null
      archived?: boolean | null
      pipelinedUsed?: boolean | null
      ghostPipeline?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      deletedAt?: any | null
      TemplateMilestones?: Array<{
        __typename?: 'TemplateMilestone'
        id: string
        templatePipelineId?: number | null
        name?: NameEnum | null
        rankOrder?: number | null
        archived?: boolean | null
        createdAt?: any | null
        updatedAt?: any | null
        TemplateStage?: Array<{
          __typename?: 'TemplateStage'
          id: string
          templatePipelineId?: number | null
          visibility?: TemplateStageVisibilityEnum | null
          name?: string | null
          templateMilestoneId?: number | null
          rankOrder?: number | null
          archived?: boolean | null
          createdAt?: any | null
          updatedAt?: any | null
        }> | null
      }> | null
    } | null
  } | null
}

export type UpsertJobPipelineMutationVariables = Exact<{
  input: UpsertJobPipelineInput
}>

export type UpsertJobPipelineMutation = {
  __typename?: 'Mutation'
  UpsertJobPipeline?: {
    __typename?: 'JobPipeline'
    id: string
    title?: string | null
    jobRequisitionId?: number | null
    templatePipelineId?: number | null
    TemplatePipeline?: {
      __typename?: 'TemplatePipeline'
      id: string
      companyId?: number | null
      companyUserId?: number | null
      name?: string | null
      companyDepartmentId?: number | null
      archived?: boolean | null
      pipelinedUsed?: boolean | null
      ghostPipeline?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      deletedAt?: any | null
      TemplateMilestones?: Array<{
        __typename?: 'TemplateMilestone'
        id: string
        templatePipelineId?: number | null
        name?: NameEnum | null
        rankOrder?: number | null
        archived?: boolean | null
        createdAt?: any | null
        updatedAt?: any | null
        TemplateStage?: Array<{
          __typename?: 'TemplateStage'
          id: string
          templatePipelineId?: number | null
          visibility?: TemplateStageVisibilityEnum | null
          name?: string | null
          templateMilestoneId?: number | null
          rankOrder?: number | null
          archived?: boolean | null
          createdAt?: any | null
          updatedAt?: any | null
        }> | null
      }> | null
    } | null
  } | null
}

export type CreateJobSearchPreferenceMutationVariables = Exact<{
  input: CreateJobSearchPreferenceInput
}>

export type CreateJobSearchPreferenceMutation = {
  __typename?: 'Mutation'
  CreateJobSearchPreference: {
    __typename?: 'JobSearchPreference'
    id: number
    scalisUserId: number
    includeJobTitles?: any | null
    excludeJobTitles?: any | null
    jobType?: JobTypeEnum | null
    datePosted?: DatePostedEnum | null
    workplaceTypePreference?: any | null
    workplaceLocationPreference?: any | null
    relocationTypePreference?: RelocationTypePreferenceEnum | null
    relocationLocationPreference?: any | null
    minimumPayPreference?: string | null
    visaSponsorship?: boolean | null
    benefits?: any | null
    industryPreference?: any | null
    desiredCompanySize?: any | null
    minimumRequiredExperience?: string | null
    maxRequiredExperience?: string | null
    companyStage?: any | null
    createdAt: any
    updatedAt: any
  }
}

export type UpdateJobSearchPreferenceMutationVariables = Exact<{
  input: UpdateJobSearchPreferenceInput
}>

export type UpdateJobSearchPreferenceMutation = {
  __typename?: 'Mutation'
  UpdateJobSearchPreference: {
    __typename?: 'JobSearchPreference'
    id: number
    scalisUserId: number
    includeJobTitles?: any | null
    excludeJobTitles?: any | null
    jobType?: JobTypeEnum | null
    datePosted?: DatePostedEnum | null
    workplaceTypePreference?: any | null
    workplaceLocationPreference?: any | null
    relocationTypePreference?: RelocationTypePreferenceEnum | null
    relocationLocationPreference?: any | null
    minimumPayPreference?: string | null
    visaSponsorship?: boolean | null
    benefits?: any | null
    industryPreference?: any | null
    desiredCompanySize?: any | null
    minimumRequiredExperience?: string | null
    maxRequiredExperience?: string | null
    companyStage?: any | null
    createdAt: any
    updatedAt: any
  }
}

export type CreateApplicantNotesMutationVariables = Exact<{
  input: CreateApplicantNotesInput
}>

export type CreateApplicantNotesMutation = {
  __typename?: 'Mutation'
  CreateApplicantNotes: { __typename?: 'ApplicantNotes'; id: string }
}

export type CreateBookmarkedJobMutationVariables = Exact<{
  input: CreateBookmarkedJobInput
}>

export type CreateBookmarkedJobMutation = {
  __typename?: 'Mutation'
  CreateBookmarkedJob: { __typename?: 'BookmarkedJob'; id: string; jobListingId?: number | null }
}

export type CreateJobSeekerAccountMutationVariables = Exact<{
  input: CreateJobSeekerAccountInput
}>

export type CreateJobSeekerAccountMutation = {
  __typename?: 'Mutation'
  CreateJobSeekerAccount: { __typename?: 'ScalisUser'; id: number }
}

export type DeleteApplicantNotesMutationVariables = Exact<{
  input: DeleteApplicantNotesInput
}>

export type DeleteApplicantNotesMutation = {
  __typename?: 'Mutation'
  DeleteApplicantNotes: { __typename?: 'ApplicantNotes'; id: string }
}

export type DeleteExternalJobApplicationMutationVariables = Exact<{
  input: DeleteExternalApplicationInput
}>

export type DeleteExternalJobApplicationMutation = {
  __typename?: 'Mutation'
  DeleteExternalJobApplication: { __typename?: 'DeleteExternalJobApplicationResponse'; message: string }
}

export type ResendEmailVerificationMutationVariables = Exact<{
  input: ResendEmailVerificationInput
}>

export type ResendEmailVerificationMutation = {
  __typename?: 'Mutation'
  ResendEmailVerification: {
    __typename?: 'ScalisUser'
    EmailVerification?: Array<{
      __typename?: 'EmailVerification'
      activeStatus?: boolean | null
      createdAt?: any | null
      emailAddress?: string | null
      emailVerified?: boolean | null
      id: number
      isPrimary?: boolean | null
      scalisUserId?: number | null
      updatedAt?: any | null
    }> | null
  }
}

export type SendJobListingMutationVariables = Exact<{
  input: SendJobListingInput
}>

export type SendJobListingMutation = {
  __typename?: 'Mutation'
  SendJobListing: { __typename?: 'SendJobListingResult'; publicListingId: string }
}

export type ShareJobListingMutationVariables = Exact<{
  input: SendJobListingInput
}>

export type ShareJobListingMutation = {
  __typename?: 'Mutation'
  SendJobListing: {
    __typename?: 'SendJobListingResult'
    email: string
    recipients: Array<string>
    publicListingId: string
    message: string
  }
}

export type UpsertExternalJobApplicationMutationVariables = Exact<{
  input: ExternalApplicationInput
}>

export type UpsertExternalJobApplicationMutation = {
  __typename?: 'Mutation'
  UpsertExternalJobApplication: { __typename?: 'ExternalJobApplication'; id: string }
}

export type VerifyEmailCodeMutationVariables = Exact<{
  input: VerifyEmailCodeInput
}>

export type VerifyEmailCodeMutation = {
  __typename?: 'Mutation'
  VerifyEmailCode: {
    __typename?: 'ScalisUser'
    EmailVerification?: Array<{
      __typename?: 'EmailVerification'
      activeStatus?: boolean | null
      createdAt?: any | null
      emailVerified?: boolean | null
      emailAddress?: string | null
      id: number
      isPrimary?: boolean | null
      scalisUserId?: number | null
      updatedAt?: any | null
    }> | null
  }
}

export type WithdrawApplicationMutationVariables = Exact<{
  input: DeleteCandidateApplicationInput
}>

export type WithdrawApplicationMutation = {
  __typename?: 'Mutation'
  DeleteCandidateApplication: { __typename?: 'CandidateApplication'; id: string }
}

export type CreateChatV2MutationVariables = Exact<{
  input: CreateChatV2Input
}>

export type CreateChatV2Mutation = {
  __typename?: 'Mutation'
  CreateChatV2: { __typename?: 'ChatC2J'; coUserId?: number | null; scUserId?: number | null; chatId?: string | null }
}

export type GenerateKnockTokenMutationVariables = Exact<{
  input?: InputMaybe<GenerateKnockTokenInput>
}>

export type GenerateKnockTokenMutation = {
  __typename?: 'Mutation'
  GenerateKnockToken: { __typename?: 'KnockTokenResponse'; token: string }
}

export type IdentifyKnockUserMutationVariables = Exact<{
  input: IdentifyKnockUserInput
}>

export type IdentifyKnockUserMutation = {
  __typename?: 'Mutation'
  IdentifyKnockUser: { __typename?: 'IdentifyKnockUserResponse'; success: boolean }
}

export type CancelScheduleReportMutationVariables = Exact<{
  input: CancelScheduledReportInput
}>

export type CancelScheduleReportMutation = {
  __typename?: 'Mutation'
  CancelScheduledReport: { __typename?: 'ScheduledReport'; id: number }
}

export type CreateFavoriteReportMutationVariables = Exact<{
  input: FavoriteReportInput
}>

export type CreateFavoriteReportMutation = {
  __typename?: 'Mutation'
  CreateFavoriteReport: {
    __typename?: 'FavoriteCoreReport'
    id: number
    coreReportId: number
    CoreReport: {
      __typename?: 'CoreReport'
      reportName: CoreReportNameEnum
      isFavorite: boolean
      updatedAt: any
      createdAt: any
      companyId: number
      id: number
    }
  }
}

export type CreateScheduleReportMutationVariables = Exact<{
  input: CreateScheduledReportInput
}>

export type CreateScheduleReportMutation = {
  __typename?: 'Mutation'
  ScheduleReport: {
    __typename?: 'ScheduledReport'
    CoreReport: {
      __typename?: 'CoreReport'
      reportName: CoreReportNameEnum
      isFavorite: boolean
      updatedAt: any
      createdAt: any
      companyId: number
      id: number
      ScheduledReport: Array<{
        __typename?: 'ScheduledReport'
        coreReportId: number
        customDaysOfWeek?: any | null
        customTime?: string | null
        deleted?: any | null
        endDate?: any | null
        id: number
        recipients: any
        repeat?: RepeatTypeEnum | null
        reportSchedulerType: ReportSchedulerTypeEnum
        startDate?: any | null
      }>
    }
  }
}

export type CreateSharedReportMutationVariables = Exact<{
  input: SharedReportInput
}>

export type CreateSharedReportMutation = {
  __typename?: 'Mutation'
  CreateSharedReport: {
    __typename?: 'SharedCoreReport'
    createdAt: any
    email: string
    id: string
    coreReportId: number
    companyUserId: number
  }
}

export type DeleteFavoriteReportMutationVariables = Exact<{
  input: FavoriteReportInput
}>

export type DeleteFavoriteReportMutation = {
  __typename?: 'Mutation'
  DeleteFavoriteReport: {
    __typename?: 'FavoriteCoreReport'
    id: number
    coreReportId: number
    CoreReport: {
      __typename?: 'CoreReport'
      reportName: CoreReportNameEnum
      isFavorite: boolean
      updatedAt: any
      createdAt: any
      companyId: number
      id: number
    }
  }
}

export type DeleteSharedReportMutationVariables = Exact<{
  input: SharedReportInput
}>

export type DeleteSharedReportMutation = { __typename?: 'Mutation'; DeleteSharedReport: boolean }

export type UpdateScheduleReportMutationVariables = Exact<{
  input: UpdateScheduledReportInput
}>

export type UpdateScheduleReportMutation = {
  __typename?: 'Mutation'
  UpdateScheduledReport: {
    __typename?: 'ScheduledReport'
    CoreReport: {
      __typename?: 'CoreReport'
      reportName: CoreReportNameEnum
      isFavorite: boolean
      updatedAt: any
      createdAt: any
      companyId: number
      id: number
      ScheduledReport: Array<{
        __typename?: 'ScheduledReport'
        coreReportId: number
        customDaysOfWeek?: any | null
        customTime?: string | null
        deleted?: any | null
        endDate?: any | null
        id: number
        recipients: any
        repeat?: RepeatTypeEnum | null
        reportSchedulerType: ReportSchedulerTypeEnum
        startDate?: any | null
      }>
    }
  }
}

export type DeleteRequisitionMutationVariables = Exact<{
  input: DeleteRequisitionInput
}>

export type DeleteRequisitionMutation = {
  __typename?: 'Mutation'
  DeleteRequisition: { __typename?: 'Requisition'; id: string }
}

export type DeleteRequisitionJobDescriptionMutationVariables = Exact<{
  input: DeleteRequisitionJobDescriptionInput
}>

export type DeleteRequisitionJobDescriptionMutation = {
  __typename?: 'Mutation'
  DeleteRequisitionJobDescription: { __typename?: 'RequisitionJobDescription'; id: string }
}

export type DeleteTemplateJobDescriptionMutationVariables = Exact<{
  input: DeleteTemplateJobDescriptionInput
}>

export type DeleteTemplateJobDescriptionMutation = {
  __typename?: 'Mutation'
  DeleteTemplateJobDescription: { __typename?: 'TemplateJobDescription'; id: string }
}

export type UpsertRequisitionJobDescriptionMutationVariables = Exact<{
  input: UpsertRequisitionJobDescriptionInput
}>

export type UpsertRequisitionJobDescriptionMutation = {
  __typename?: 'Mutation'
  UpsertRequisitionJobDescription?: {
    __typename?: 'RequisitionJobDescription'
    id: string
    requisitionId?: number | null
    description?: string | null
  } | null
}

export type UpsertTemplateJobDescriptionMutationVariables = Exact<{
  input: UpsertTemplateJobDescriptionInput
}>

export type UpsertTemplateJobDescriptionMutation = {
  __typename?: 'Mutation'
  UpsertTemplateJobDescription?: {
    __typename?: 'TemplateJobDescription'
    id: string
    name?: string | null
    description?: string | null
    companyDepartmentId?: string | null
  } | null
}

export type DeleteJobOpeningMutationVariables = Exact<{
  input: DeleteJobOpeningInput
}>

export type DeleteJobOpeningMutation = {
  __typename?: 'Mutation'
  DeleteJobOpening: { __typename?: 'JobOpening'; id: string }
}

export type UpsertJobOpeningMutationVariables = Exact<{
  input: UpsertJobOpeningInput
}>

export type UpsertJobOpeningMutation = {
  __typename?: 'Mutation'
  UpsertJobOpening?: {
    __typename?: 'JobOpening'
    id: string
    jobRequisitionId?: number | null
    openingStatus?: OpeningStatusEnum | null
    extOpeningId?: string | null
    companyId?: number | null
    targetHireDate?: any | null
    openingType?: OpeningTypeEnum | null
    filledDate?: any | null
    startDate?: any | null
    filledByApplication?: number | null
    filledByCandidate?: number | null
    closedReason?: ClosedReasonEnum | null
    closedDate?: any | null
  } | null
}

export type DeleteRequisitionSkillMutationVariables = Exact<{
  input: DeleteRequisitionSkillInput
}>

export type DeleteRequisitionSkillMutation = {
  __typename?: 'Mutation'
  DeleteRequisitionSkill: { __typename?: 'RequisitionSkill'; id: string }
}

export type UpsertRequisitionSkillMutationVariables = Exact<{
  input: UpsertRequisitionSkillInput
}>

export type UpsertRequisitionSkillMutation = {
  __typename?: 'Mutation'
  UpsertRequisitionSkill?: {
    __typename?: 'RequisitionSkill'
    id: string
    requisitionId?: number | null
    skillId?: number | null
    displayName?: string | null
    level?: string | null
    yearsOfExp?: number | null
    sequenceNumber?: number | null
    createdAt?: any | null
    updatedAt?: any | null
    skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
  } | null
}

export type DeleteJobListingScreeningQuestionMutationVariables = Exact<{
  input: DeleteJobListingScreeningQuestionInput
}>

export type DeleteJobListingScreeningQuestionMutation = {
  __typename?: 'Mutation'
  DeleteJobListingScreeningQuestion: { __typename?: 'JobListingScreeningQuestion'; id: string }
}

export type DeleteScreeningQuestionMutationVariables = Exact<{
  input: DeleteScreeningQuestionInput
}>

export type DeleteScreeningQuestionMutation = {
  __typename?: 'Mutation'
  DeleteScreeningQuestion: { __typename?: 'ScreeningQuestion'; id: string }
}

export type UpsertJobListingScreeningQuestionMutationVariables = Exact<{
  input: UpsertJobListingScreeningQuestionInput
}>

export type UpsertJobListingScreeningQuestionMutation = {
  __typename?: 'Mutation'
  UpsertJobListingScreeningQuestion?: {
    __typename?: 'JobListingScreeningQuestion'
    id: string
    jobListingId?: number | null
    displaySequenceNumber?: number | null
    screeningQuestionId?: number | null
    ScreeningQuestion?: {
      __typename?: 'ScreeningQuestion'
      id: string
      isTemplateQuestion?: boolean | null
      questionTitle?: string | null
      questionDesc?: string | null
      questionType?: QuestionTypeEnum | null
      minVal?: number | null
      maxVal?: number | null
      valStatus?: string | null
      ansOptions?: string | null
      isRejectionQuestion?: boolean | null
      isGlobalQuestion?: boolean | null
      rejectMessage?: string | null
      templateMessageId?: number | null
      preferredAnswer?: string | null
      companyId?: number | null
      companyUserId?: number | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null
  } | null
}

export type UpsertScreeningQuestionMutationVariables = Exact<{
  input: UpsertScreeningQuestionInput
}>

export type UpsertScreeningQuestionMutation = {
  __typename?: 'Mutation'
  UpsertScreeningQuestion?: {
    __typename?: 'ScreeningQuestion'
    id: string
    isTemplateQuestion?: boolean | null
    questionTitle?: string | null
    questionDesc?: string | null
    questionType?: QuestionTypeEnum | null
    minVal?: number | null
    maxVal?: number | null
    valStatus?: string | null
    ansOptions?: string | null
    isRejectionQuestion?: boolean | null
    isGlobalQuestion?: boolean | null
    rejectMessage?: string | null
    templateMessageId?: number | null
    preferredAnswer?: string | null
    companyId?: number | null
    companyUserId?: number | null
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type UpdateRequisitionApplicabilityMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  jobListings?: InputMaybe<Array<UpsertJobListingInput> | UpsertJobListingInput>
}>

export type UpdateRequisitionApplicabilityMutation = {
  __typename?: 'Mutation'
  UpsertRequisition?: {
    __typename: 'Requisition'
    id: string
    JobListing?: Array<{ __typename: 'JobListing'; id: number; acceptingCandidates?: boolean | null }> | null
  } | null
}

export type UpsertRequisitionMutationVariables = Exact<{
  input: UpsertRequisitionInput
}>

export type UpsertRequisitionMutation = {
  __typename?: 'Mutation'
  UpsertRequisition?: {
    __typename?: 'Requisition'
    id: string
    jobStatus?: JobStatusEnum | null
    openedAt?: any | null
    jobName?: string | null
    extRequisitionId?: string | null
    jobType?: JobTypeEnum | null
    jobLevel?: JobLevelEnum | null
    travelType?: TravelTypeEnum | null
    payType?: PayTypeEnum | null
    minPay?: number | null
    maxPay?: number | null
    additionalComp?: any | null
    benefits?: any | null
    locationDistancePref?: number | null
    educationLevelPref?: EducationLevelPrefEnum | null
    yearsOfExperiencePref?: YearsOfExperienceEnum | null
    nonTraditionalPref?: boolean | null
    veteranPref?: boolean | null
    diverseHirePref?: boolean | null
    collegeGradPref?: boolean | null
    isIncomplete: boolean
    createdAt?: any | null
    updatedAt?: any | null
    JobOpening?: Array<{
      __typename?: 'JobOpening'
      id: string
      jobRequisitionId?: number | null
      openingStatus?: OpeningStatusEnum | null
      extOpeningId?: string | null
      companyId?: number | null
      targetHireDate?: any | null
      openingType?: OpeningTypeEnum | null
      filledDate?: any | null
      startDate?: any | null
      filledByApplication?: number | null
      filledByCandidate?: number | null
      closedReason?: ClosedReasonEnum | null
      closedDate?: any | null
    }> | null
    RequisitionJobDescription?: Array<{
      __typename?: 'RequisitionJobDescription'
      id: string
      requisitionId?: number | null
      description?: string | null
    }> | null
    RequisitionSkills?: Array<{
      __typename?: 'RequisitionSkill'
      id: string
      requisitionId?: number | null
      skillId?: number | null
      displayName?: string | null
      level?: string | null
      yearsOfExp?: number | null
      sequenceNumber?: number | null
      createdAt?: any | null
      updatedAt?: any | null
      skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
    }> | null
    JobListing?: Array<{
      __typename?: 'JobListing'
      deletedAt?: any | null
      id: number
      publicListingId?: string | null
      jobRequisitionId?: number | null
      listingTitle?: string | null
      externalTitle?: string | null
      workplaceType?: WorkplaceTypeEnum | null
      publicDescription?: string | null
      displayPayOnListing?: boolean | null
      industry?: IndustryEnum | null
      subIndustry?: SubIndustryTypeEnum | null
      companyDefault?: boolean | null
      stateAndOrCountry?: string | null
      internalMatchingDescription?: string | null
      searchPublicDescription?: string | null
      searchInternalMatchingDescription?: string | null
      postedAt?: any | null
      acceptingCandidates?: boolean | null
      stage?: StageEnum | null
      createdAt?: any | null
      updatedAt?: any | null
      Address?: Array<{
        __typename?: 'Address'
        id: number
        addressLine1?: string | null
        addressLine2?: string | null
        city?: string | null
        state?: string | null
        country?: string | null
        postalCode?: string | null
        timeZone?: string | null
        longitude?: string | null
        latitude?: string | null
      }> | null
      JobListingScreeningQuestion?: Array<{
        __typename?: 'JobListingScreeningQuestion'
        id: string
        jobListingId?: number | null
        displaySequenceNumber?: number | null
        screeningQuestionId?: number | null
        ScreeningQuestion?: {
          __typename?: 'ScreeningQuestion'
          id: string
          isTemplateQuestion?: boolean | null
          questionTitle?: string | null
          questionDesc?: string | null
          questionType?: QuestionTypeEnum | null
          minVal?: number | null
          maxVal?: number | null
          valStatus?: string | null
          ansOptions?: string | null
          isRejectionQuestion?: boolean | null
          isGlobalQuestion?: boolean | null
          rejectMessage?: string | null
          templateMessageId?: number | null
          preferredAnswer?: string | null
          companyId?: number | null
          companyUserId?: number | null
          createdAt?: any | null
          updatedAt?: any | null
        } | null
      }> | null
      CandidateApplication?: Array<{
        __typename?: 'CandidateApplication'
        id: string
        applicationStatus?: ApplicationStatusEnum | null
        TemplateStage?: { __typename?: 'TemplateStage'; id: string; templateMilestoneId?: number | null } | null
      }> | null
    }> | null
    JobPipeline?: {
      __typename?: 'JobPipeline'
      id: string
      title?: string | null
      jobRequisitionId?: number | null
      templatePipelineId?: number | null
      TemplatePipeline?: {
        __typename?: 'TemplatePipeline'
        id: string
        companyId?: number | null
        companyUserId?: number | null
        name?: string | null
        companyDepartmentId?: number | null
        archived?: boolean | null
        pipelinedUsed?: boolean | null
        ghostPipeline?: boolean | null
        createdAt?: any | null
        updatedAt?: any | null
        deletedAt?: any | null
        TemplateMilestones?: Array<{
          __typename?: 'TemplateMilestone'
          id: string
          templatePipelineId?: number | null
          name?: NameEnum | null
          rankOrder?: number | null
          archived?: boolean | null
          createdAt?: any | null
          updatedAt?: any | null
          TemplateStage?: Array<{
            __typename?: 'TemplateStage'
            id: string
            templatePipelineId?: number | null
            visibility?: TemplateStageVisibilityEnum | null
            name?: string | null
            templateMilestoneId?: number | null
            rankOrder?: number | null
            archived?: boolean | null
            createdAt?: any | null
            updatedAt?: any | null
          }> | null
        }> | null
      } | null
    } | null
    HiringTeamMember?: Array<{
      __typename?: 'HiringTeamMember'
      id: string
      companyUserId?: number | null
      roleId?: number | null
      requisitionId?: number | null
      requisitionJobDescriptionId?: number | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        companyId: number
        companyUserStatus?: CompanyUserStatusEnum | null
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          email?: string | null
          invitedAs?: RoleEnum | null
          invitationStatus?: InvitationStatusEnum | null
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
      role?: { __typename?: 'Role'; id: string; name: string } | null
    }> | null
    CandidateCollaborator?: Array<{
      __typename?: 'CandidateCollaborator'
      id: string
      requisitionId?: number | null
      companyUserId?: number | null
      candidateProfileId?: number | null
      roleId?: number | null
      requisitionJobDescriptionId?: number | null
    }> | null
    StageCollaborator?: Array<{
      __typename?: 'StageCollaborator'
      id: string
      requisitionId?: number | null
      companyUserId?: number | null
      templateStageId?: number | null
      roleId?: number | null
      requisitionJobDescriptionId?: number | null
    }> | null
    CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
    CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
  } | null
}

export type CreateScalisUserUploadedDocumentMutationVariables = Exact<{
  input: CreateScalisUserUploadedDocumentInput
}>

export type CreateScalisUserUploadedDocumentMutation = {
  __typename?: 'Mutation'
  CreateScalisUserUploadedDocument?: {
    __typename?: 'CreateScalisUserUploadedDocumentOutput'
    id: number
    documentPath: string
    documentName: string
    documentType: DocumentTypeEnum
  } | null
}

export type DeleteScalisUserUploadedDocumentMutationVariables = Exact<{
  input: DeleteScalisUserUploadedDocumentInput
}>

export type DeleteScalisUserUploadedDocumentMutation = {
  __typename?: 'Mutation'
  DeleteScalisUserUploadedDocument?: { __typename?: 'DeleteScalisUserUploadedDocumentOutput'; success: boolean } | null
}

export type UpdateSchedulerLinkSettingsMutationVariables = Exact<{
  input: UpdateSchedulerLinkSettingsInput
}>

export type UpdateSchedulerLinkSettingsMutation = {
  __typename?: 'Mutation'
  UpdateSchedulerLinkSettings: {
    __typename?: 'SchedulerLinkSettings'
    id: string
    minimumHour: number
    rollingDays: number
    maxInterviewsPerDay: number
  }
}

export type DeleteScorecardTemplateMutationVariables = Exact<{
  input: DeleteScorecardTemplateInput
}>

export type DeleteScorecardTemplateMutation = {
  __typename?: 'Mutation'
  DeleteScorecardTemplate: { __typename?: 'ScorecardTemplate'; id: string }
}

export type ToggleScorecardTemplateArchiveMutationVariables = Exact<{
  input: ToggleScorecardTemplateArchiveInput
}>

export type ToggleScorecardTemplateArchiveMutation = {
  __typename?: 'Mutation'
  ToggleScorecardTemplateArchive?: {
    __typename?: 'ScorecardTemplate'
    id: string
    scorecardName?: string | null
    archived?: boolean | null
    department?: string | null
    companyId?: number | null
    createdAt?: any | null
  } | null
}

export type UpsertScorecardTemplateMutationVariables = Exact<{
  input: UpsertScorecardTemplateInput
}>

export type UpsertScorecardTemplateMutation = {
  __typename?: 'Mutation'
  UpsertScorecardTemplate?: {
    __typename?: 'ScorecardTemplate'
    id: string
    scorecardName?: string | null
    scorecardDescription?: string | null
    visible?: boolean | null
    department?: string | null
    companyId?: number | null
    createdAt?: any | null
  } | null
}

export type CreateTemplateScreeningQuestionMutationVariables = Exact<{
  input: CreateTemplateScreeningQuestionInput
}>

export type CreateTemplateScreeningQuestionMutation = {
  __typename?: 'Mutation'
  CreateTemplateScreeningQuestion: {
    __typename?: 'ScreeningQuestion'
    id: string
    questionTitle?: string | null
    questionDesc?: string | null
    questionType?: QuestionTypeEnum | null
    minVal?: number | null
    maxVal?: number | null
    valStatus?: string | null
    ansOptions?: string | null
    isRejectionQuestion?: boolean | null
    rejectMessage?: string | null
    preferredAnswer?: string | null
    preferredAnswerType?: PreferredAnswerTypeEnum | null
    multipleSelectPreferredAnswers?: any | null
    selectionDisplay?: SelectionDisplayEnum | null
    isTemplateQuestion?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
  }
}

export type EditTemplateScreeningQuestionMutationVariables = Exact<{
  input: EditTemplateScreeningQuestionInput
}>

export type EditTemplateScreeningQuestionMutation = {
  __typename?: 'Mutation'
  editTemplateScreeningQuestion: {
    __typename?: 'ScreeningQuestion'
    id: string
    questionTitle?: string | null
    questionDesc?: string | null
    questionType?: QuestionTypeEnum | null
    minVal?: number | null
    maxVal?: number | null
    valStatus?: string | null
    ansOptions?: string | null
    isRejectionQuestion?: boolean | null
    rejectMessage?: string | null
    preferredAnswer?: string | null
    preferredAnswerType?: PreferredAnswerTypeEnum | null
    multipleSelectPreferredAnswers?: any | null
    selectionDisplay?: SelectionDisplayEnum | null
    isTemplateQuestion?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
  }
}

export type CreateSequenceScheduleSettingMutationVariables = Exact<{
  input: CreateSequenceScheduleSettingInput
}>

export type CreateSequenceScheduleSettingMutation = {
  __typename?: 'Mutation'
  CreateSequenceScheduleSetting: {
    __typename?: 'SequenceScheduleSetting'
    id: string
    name?: string | null
    endTime?: string | null
    daysOfWeek?: any | null
    timeZone?: string | null
    startTime?: string | null
    isDefault: boolean
    useContactLocalTime: boolean
  }
}

export type DeleteSequenceScheduleSettingMutationVariables = Exact<{
  input: DeleteSequenceScheduleSettingInput
}>

export type DeleteSequenceScheduleSettingMutation = {
  __typename?: 'Mutation'
  DeleteSequenceScheduleSetting: { __typename?: 'SequenceOperationResponse'; message?: string | null; success: boolean }
}

export type MarkDefaultSequenceScheduleSettingMutationVariables = Exact<{
  input: MarkDefaultSequenceScheduleSettingInput
}>

export type MarkDefaultSequenceScheduleSettingMutation = {
  __typename?: 'Mutation'
  MarkDefaultSequenceScheduleSetting: {
    __typename?: 'SequenceScheduleSetting'
    id: string
    name?: string | null
    endTime?: string | null
    daysOfWeek?: any | null
    timeZone?: string | null
    startTime?: string | null
    isDefault: boolean
    useContactLocalTime: boolean
  }
}

export type UpdateSequenceScheduleSettingMutationVariables = Exact<{
  input: UpdateSequenceScheduleSettingInput
}>

export type UpdateSequenceScheduleSettingMutation = {
  __typename?: 'Mutation'
  UpdateSequenceScheduleSetting: {
    __typename?: 'SequenceScheduleSetting'
    id: string
    name?: string | null
    endTime?: string | null
    daysOfWeek?: any | null
    timeZone?: string | null
    startTime?: string | null
    isDefault: boolean
    useContactLocalTime: boolean
  }
}

export type UpdateSequenceSettingMutationVariables = Exact<{
  input: UpdateSequenceSettingInput
}>

export type UpdateSequenceSettingMutation = {
  __typename?: 'Mutation'
  UpdateSequenceSetting: {
    __typename?: 'SequenceSetting'
    id: string
    includeUnsubscribeLink: boolean
    connectedEmailSettingsId: number
    sequenceScheduleSettingId: number
    cc?: any | null
    bcc?: any | null
    SequenceScheduleSetting: {
      __typename?: 'SequenceScheduleSetting'
      id: string
      name?: string | null
      endTime?: string | null
      daysOfWeek?: any | null
      timeZone?: string | null
      startTime?: string | null
      isDefault: boolean
      useContactLocalTime: boolean
    }
    ConnectedEmailSettings: {
      __typename?: 'ConnectedEmailSettings'
      id: string
      email: string
      provider: ConnectedEmailProviderEnum
      dailyLimit?: number | null
      hourlyLimit?: number | null
      minutesBetweenEmails?: number | null
      allowSendOnBehalf?: boolean | null
      optOutEnabled?: boolean | null
      emailSignatureEnabled?: boolean | null
      optOutMessage?: string | null
      emailSignature?: string | null
      createdAt?: any | null
      updatedAt?: any | null
    }
  }
}

export type AddStepToSequenceMutationVariables = Exact<{
  input: CreateSequenceStepInput
  sequenceId: Scalars['String']['input']
}>

export type AddStepToSequenceMutation = {
  __typename?: 'Mutation'
  AddStepToSequence: {
    __typename?: 'SequenceStep'
    id: string
    replyPreviousThread: boolean
    subject?: string | null
    templateMessageId?: number | null
    body?: string | null
    spreadStrategy?: SequenceStepSpreadStrategyEnum | null
    afterPreviousStep?: number | null
    emailLimitPerDay?: number | null
    stepNumber: number
    customSendTime?: string | null
    schedulerType: SequenceStepSchedulerTypeEnum
    sendTimeType: SequenceStepSendTimeTypeEnum
    emailOpenedCount: number
    emailRepliedCount: number
    emailClickedCount: number
    dropOffsCount: number
    TemplateMessage?: {
      __typename?: 'TemplateMessage'
      id: string
      message?: string | null
      title?: string | null
    } | null
  }
}

export type DeleteSequenceStepMutationVariables = Exact<{
  input: MutationDeleteSequenceStepInput
}>

export type DeleteSequenceStepMutation = { __typename?: 'Mutation'; DeleteSequenceStep: boolean }

export type UpdateSequenceStepMutationVariables = Exact<{
  input: UpdateSequenceStepInput
}>

export type UpdateSequenceStepMutation = {
  __typename?: 'Mutation'
  UpdateSequenceStep: {
    __typename?: 'SequenceStep'
    id: string
    replyPreviousThread: boolean
    subject?: string | null
    templateMessageId?: number | null
    body?: string | null
    spreadStrategy?: SequenceStepSpreadStrategyEnum | null
    afterPreviousStep?: number | null
    emailLimitPerDay?: number | null
    stepNumber: number
    customSendTime?: string | null
    schedulerType: SequenceStepSchedulerTypeEnum
    sendTimeType: SequenceStepSendTimeTypeEnum
    emailOpenedCount: number
    emailRepliedCount: number
    emailClickedCount: number
    dropOffsCount: number
    TemplateMessage?: {
      __typename?: 'TemplateMessage'
      id: string
      message?: string | null
      title?: string | null
    } | null
  }
}

export type ArchiveSequenceMutationVariables = Exact<{
  input: ArchiveSequenceInput
}>

export type ArchiveSequenceMutation = {
  __typename?: 'Mutation'
  ArchiveSequence: { __typename?: 'SequenceOperationResponse'; message?: string | null; success: boolean }
}

export type BulkEnrollCandidatesInSequenceMutationVariables = Exact<{
  input: BulkEnrollCandidatesInSequenceInput
}>

export type BulkEnrollCandidatesInSequenceMutation = {
  __typename?: 'Mutation'
  BulkEnrollCandidatesInSequence: {
    __typename?: 'BulkSequenceOperationResponse'
    count: number
    message?: string | null
    success: boolean
  }
}

export type BulkUnenrollCandidatesFromSequenceMutationVariables = Exact<{
  input: BulkUnenrollCandidatesFromSequenceInput
}>

export type BulkUnenrollCandidatesFromSequenceMutation = {
  __typename?: 'Mutation'
  BulkUnenrollCandidatesFromSequence: {
    __typename?: 'BulkSequenceOperationResponse'
    count: number
    message?: string | null
    success: boolean
  }
}

export type BulkUpdateSequenceCandidateStatusMutationVariables = Exact<{
  input: BulkUpdateSequenceCandidateStatusInput
}>

export type BulkUpdateSequenceCandidateStatusMutation = {
  __typename?: 'Mutation'
  BulkUpdateSequenceCandidateStatus: {
    __typename?: 'BulkSequenceOperationResponse'
    count: number
    message?: string | null
    success: boolean
  }
}

export type CreateFavoriteSequenceMutationVariables = Exact<{
  input: CreateFavoriteSequenceInput
}>

export type CreateFavoriteSequenceMutation = {
  __typename?: 'Mutation'
  CreateFavoriteSequence?: {
    __typename?: 'Sequence'
    id: string
    name: string
    description?: string | null
    companyUserId: number
    associatedRequisitionIds: Array<number>
    associatedTalentPoolIds: Array<number>
    visibility: SequenceVisibilityEnum
    createdAt: any
    numberOfSteps: number
    sequenceStatus: SequenceStatusEnum
    numberOfActives: number
    numberOfCompleted: number
    ownerName?: string | null
    ownerCompanyUserId?: number | null
    isFavorite: boolean
    candidatesCount: number
    emailBouncedCount: number
    emailClickedCount: number
    emailOpenedCount: number
    emailRepliedCount: number
    SequenceSetting: {
      __typename?: 'SequenceSetting'
      id: string
      includeUnsubscribeLink: boolean
      connectedEmailSettingsId: number
      sequenceScheduleSettingId: number
      cc?: any | null
      bcc?: any | null
      SequenceScheduleSetting: {
        __typename?: 'SequenceScheduleSetting'
        id: string
        name?: string | null
        endTime?: string | null
        daysOfWeek?: any | null
        timeZone?: string | null
        startTime?: string | null
        isDefault: boolean
        useContactLocalTime: boolean
      }
      ConnectedEmailSettings: {
        __typename?: 'ConnectedEmailSettings'
        id: string
        email: string
        provider: ConnectedEmailProviderEnum
        dailyLimit?: number | null
        hourlyLimit?: number | null
        minutesBetweenEmails?: number | null
        allowSendOnBehalf?: boolean | null
        optOutEnabled?: boolean | null
        emailSignatureEnabled?: boolean | null
        optOutMessage?: string | null
        emailSignature?: string | null
        createdAt?: any | null
        updatedAt?: any | null
      }
    }
    SequenceSteps: Array<{
      __typename?: 'SequenceStep'
      id: string
      replyPreviousThread: boolean
      subject?: string | null
      templateMessageId?: number | null
      body?: string | null
      spreadStrategy?: SequenceStepSpreadStrategyEnum | null
      afterPreviousStep?: number | null
      emailLimitPerDay?: number | null
      stepNumber: number
      customSendTime?: string | null
      schedulerType: SequenceStepSchedulerTypeEnum
      sendTimeType: SequenceStepSendTimeTypeEnum
      emailOpenedCount: number
      emailRepliedCount: number
      emailClickedCount: number
      dropOffsCount: number
      TemplateMessage?: {
        __typename?: 'TemplateMessage'
        id: string
        message?: string | null
        title?: string | null
      } | null
    }>
  } | null
}

export type CreateSequenceMutationVariables = Exact<{
  input: CreateSequenceInput
}>

export type CreateSequenceMutation = {
  __typename?: 'Mutation'
  CreateSequence: {
    __typename?: 'Sequence'
    id: string
    name: string
    description?: string | null
    companyUserId: number
    associatedRequisitionIds: Array<number>
    associatedTalentPoolIds: Array<number>
    visibility: SequenceVisibilityEnum
    createdAt: any
    numberOfSteps: number
    sequenceStatus: SequenceStatusEnum
    numberOfActives: number
    numberOfCompleted: number
    ownerName?: string | null
    ownerCompanyUserId?: number | null
    isFavorite: boolean
    candidatesCount: number
    emailBouncedCount: number
    emailClickedCount: number
    emailOpenedCount: number
    emailRepliedCount: number
    SequenceSetting: {
      __typename?: 'SequenceSetting'
      id: string
      includeUnsubscribeLink: boolean
      connectedEmailSettingsId: number
      sequenceScheduleSettingId: number
      cc?: any | null
      bcc?: any | null
      SequenceScheduleSetting: {
        __typename?: 'SequenceScheduleSetting'
        id: string
        name?: string | null
        endTime?: string | null
        daysOfWeek?: any | null
        timeZone?: string | null
        startTime?: string | null
        isDefault: boolean
        useContactLocalTime: boolean
      }
      ConnectedEmailSettings: {
        __typename?: 'ConnectedEmailSettings'
        id: string
        email: string
        provider: ConnectedEmailProviderEnum
        dailyLimit?: number | null
        hourlyLimit?: number | null
        minutesBetweenEmails?: number | null
        allowSendOnBehalf?: boolean | null
        optOutEnabled?: boolean | null
        emailSignatureEnabled?: boolean | null
        optOutMessage?: string | null
        emailSignature?: string | null
        createdAt?: any | null
        updatedAt?: any | null
      }
    }
    SequenceSteps: Array<{
      __typename?: 'SequenceStep'
      id: string
      replyPreviousThread: boolean
      subject?: string | null
      templateMessageId?: number | null
      body?: string | null
      spreadStrategy?: SequenceStepSpreadStrategyEnum | null
      afterPreviousStep?: number | null
      emailLimitPerDay?: number | null
      stepNumber: number
      customSendTime?: string | null
      schedulerType: SequenceStepSchedulerTypeEnum
      sendTimeType: SequenceStepSendTimeTypeEnum
      emailOpenedCount: number
      emailRepliedCount: number
      emailClickedCount: number
      dropOffsCount: number
      TemplateMessage?: {
        __typename?: 'TemplateMessage'
        id: string
        message?: string | null
        title?: string | null
      } | null
    }>
  }
}

export type DeleteFavoriteSequenceMutationVariables = Exact<{
  input: DeleteFavoriteSequenceInput
}>

export type DeleteFavoriteSequenceMutation = {
  __typename?: 'Mutation'
  DeleteFavoriteSequence?: {
    __typename?: 'Sequence'
    id: string
    name: string
    description?: string | null
    companyUserId: number
    associatedRequisitionIds: Array<number>
    associatedTalentPoolIds: Array<number>
    visibility: SequenceVisibilityEnum
    createdAt: any
    numberOfSteps: number
    sequenceStatus: SequenceStatusEnum
    numberOfActives: number
    numberOfCompleted: number
    ownerName?: string | null
    ownerCompanyUserId?: number | null
    isFavorite: boolean
    candidatesCount: number
    emailBouncedCount: number
    emailClickedCount: number
    emailOpenedCount: number
    emailRepliedCount: number
    SequenceSetting: {
      __typename?: 'SequenceSetting'
      id: string
      includeUnsubscribeLink: boolean
      connectedEmailSettingsId: number
      sequenceScheduleSettingId: number
      cc?: any | null
      bcc?: any | null
      SequenceScheduleSetting: {
        __typename?: 'SequenceScheduleSetting'
        id: string
        name?: string | null
        endTime?: string | null
        daysOfWeek?: any | null
        timeZone?: string | null
        startTime?: string | null
        isDefault: boolean
        useContactLocalTime: boolean
      }
      ConnectedEmailSettings: {
        __typename?: 'ConnectedEmailSettings'
        id: string
        email: string
        provider: ConnectedEmailProviderEnum
        dailyLimit?: number | null
        hourlyLimit?: number | null
        minutesBetweenEmails?: number | null
        allowSendOnBehalf?: boolean | null
        optOutEnabled?: boolean | null
        emailSignatureEnabled?: boolean | null
        optOutMessage?: string | null
        emailSignature?: string | null
        createdAt?: any | null
        updatedAt?: any | null
      }
    }
    SequenceSteps: Array<{
      __typename?: 'SequenceStep'
      id: string
      replyPreviousThread: boolean
      subject?: string | null
      templateMessageId?: number | null
      body?: string | null
      spreadStrategy?: SequenceStepSpreadStrategyEnum | null
      afterPreviousStep?: number | null
      emailLimitPerDay?: number | null
      stepNumber: number
      customSendTime?: string | null
      schedulerType: SequenceStepSchedulerTypeEnum
      sendTimeType: SequenceStepSendTimeTypeEnum
      emailOpenedCount: number
      emailRepliedCount: number
      emailClickedCount: number
      dropOffsCount: number
      TemplateMessage?: {
        __typename?: 'TemplateMessage'
        id: string
        message?: string | null
        title?: string | null
      } | null
    }>
  } | null
}

export type DeleteSequenceMutationVariables = Exact<{
  input: SequenceOperationInput
}>

export type DeleteSequenceMutation = {
  __typename?: 'Mutation'
  DeleteSequence: { __typename?: 'SequenceOperationResponse'; message?: string | null; success: boolean }
}

export type PauseSequenceMutationVariables = Exact<{
  input: SequenceOperationInput
}>

export type PauseSequenceMutation = {
  __typename?: 'Mutation'
  PauseSequence: { __typename?: 'SequenceOperationResponse'; message?: string | null; success: boolean }
}

export type ResumeSequenceMutationVariables = Exact<{
  input: SequenceOperationInput
}>

export type ResumeSequenceMutation = {
  __typename?: 'Mutation'
  ResumeSequence: { __typename?: 'SequenceOperationResponse'; message?: string | null; success: boolean }
}

export type UnarchiveSequenceMutationVariables = Exact<{
  input: SequenceOperationInput
}>

export type UnarchiveSequenceMutation = {
  __typename?: 'Mutation'
  UnarchiveSequence: { __typename?: 'SequenceOperationResponse'; message?: string | null; success: boolean }
}

export type UnsubscribeCandidateFromSequenceMutationVariables = Exact<{
  input: UnsubscribeCandidateFromEmailsInput
}>

export type UnsubscribeCandidateFromSequenceMutation = {
  __typename?: 'Mutation'
  UnsubscribeCandidateFromSequence: {
    __typename?: 'UnsubscribeCandidateFromEmailsResponse'
    message: string
    candidateProfileId: number
    sequenceId: string
  }
}

export type UpdateSequenceMutationVariables = Exact<{
  input: UpdateSequenceInput
}>

export type UpdateSequenceMutation = {
  __typename?: 'Mutation'
  UpdateSequence: {
    __typename?: 'Sequence'
    id: string
    name: string
    description?: string | null
    companyUserId: number
    associatedRequisitionIds: Array<number>
    associatedTalentPoolIds: Array<number>
    visibility: SequenceVisibilityEnum
    createdAt: any
    numberOfSteps: number
    sequenceStatus: SequenceStatusEnum
    numberOfActives: number
    numberOfCompleted: number
    ownerName?: string | null
    ownerCompanyUserId?: number | null
    isFavorite: boolean
    candidatesCount: number
    emailBouncedCount: number
    emailClickedCount: number
    emailOpenedCount: number
    emailRepliedCount: number
    SequenceSetting: {
      __typename?: 'SequenceSetting'
      id: string
      includeUnsubscribeLink: boolean
      connectedEmailSettingsId: number
      sequenceScheduleSettingId: number
      cc?: any | null
      bcc?: any | null
      SequenceScheduleSetting: {
        __typename?: 'SequenceScheduleSetting'
        id: string
        name?: string | null
        endTime?: string | null
        daysOfWeek?: any | null
        timeZone?: string | null
        startTime?: string | null
        isDefault: boolean
        useContactLocalTime: boolean
      }
      ConnectedEmailSettings: {
        __typename?: 'ConnectedEmailSettings'
        id: string
        email: string
        provider: ConnectedEmailProviderEnum
        dailyLimit?: number | null
        hourlyLimit?: number | null
        minutesBetweenEmails?: number | null
        allowSendOnBehalf?: boolean | null
        optOutEnabled?: boolean | null
        emailSignatureEnabled?: boolean | null
        optOutMessage?: string | null
        emailSignature?: string | null
        createdAt?: any | null
        updatedAt?: any | null
      }
    }
    SequenceSteps: Array<{
      __typename?: 'SequenceStep'
      id: string
      replyPreviousThread: boolean
      subject?: string | null
      templateMessageId?: number | null
      body?: string | null
      spreadStrategy?: SequenceStepSpreadStrategyEnum | null
      afterPreviousStep?: number | null
      emailLimitPerDay?: number | null
      stepNumber: number
      customSendTime?: string | null
      schedulerType: SequenceStepSchedulerTypeEnum
      sendTimeType: SequenceStepSendTimeTypeEnum
      emailOpenedCount: number
      emailRepliedCount: number
      emailClickedCount: number
      dropOffsCount: number
      TemplateMessage?: {
        __typename?: 'TemplateMessage'
        id: string
        message?: string | null
        title?: string | null
      } | null
    }>
  }
}

export type DeleteSkillMutationVariables = Exact<{
  input: Array<DeleteSkillInput> | DeleteSkillInput
}>

export type DeleteSkillMutation = { __typename?: 'Mutation'; DeleteSkill: Array<boolean> }

export type UpsertSkillMutationVariables = Exact<{
  input: Array<UpsertSkillInput> | UpsertSkillInput
}>

export type UpsertSkillMutation = {
  __typename?: 'Mutation'
  UpsertSkill?: Array<{ __typename?: 'Skill'; id: string; name?: string | null }> | null
}

export type CreateSourceTrackingEventMutationVariables = Exact<{
  input: CreateSourceTrackingEventInput
}>

export type CreateSourceTrackingEventMutation = { __typename?: 'Mutation'; CreateSourceTrackingEvent: boolean }

export type CreateSourceTrackingLinkMutationVariables = Exact<{
  input: CreateSourceTrackingLinkInput
}>

export type CreateSourceTrackingLinkMutation = {
  __typename?: 'Mutation'
  CreateSourceTrackingLink?: {
    __typename?: 'SourceTrackingLink'
    id: string
    jobListingId: number
    genericListingLink?: boolean | null
    name: string
    shortCode: string
    isDeleted?: boolean | null
    companyUserId: number
    whoGetsCredit?: number | null
    candidateSourceNameId?: number | null
    countViews: number
    countUniqueViews: number
    countClicksToApply: number
    countApplies: number
    createdAt: any
    updatedAt: any
    redirectUrl: string
    jobListing: {
      __typename?: 'JobListing'
      id: number
      publicListingId?: string | null
      listingTitle?: string | null
      Requisition?: { __typename?: 'Requisition'; id: string; jobName?: string | null } | null
    }
    companyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    whoGetsCreditCompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    candidateSourceName?: {
      __typename?: 'CandidateSourceName'
      id: number
      name: string
      sourceCategory?: SourceCategoryEnum | null
      customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
    } | null
  } | null
}

export type EditSourceTrackingLinkMutationVariables = Exact<{
  input: EditSourceTrackingLinkInput
}>

export type EditSourceTrackingLinkMutation = {
  __typename?: 'Mutation'
  EditSourceTrackingLink?: {
    __typename?: 'SourceTrackingLink'
    id: string
    jobListingId: number
    genericListingLink?: boolean | null
    name: string
    shortCode: string
    isDeleted?: boolean | null
    companyUserId: number
    whoGetsCredit?: number | null
    candidateSourceNameId?: number | null
    countViews: number
    countUniqueViews: number
    countClicksToApply: number
    countApplies: number
    createdAt: any
    updatedAt: any
    redirectUrl: string
    jobListing: {
      __typename?: 'JobListing'
      id: number
      publicListingId?: string | null
      listingTitle?: string | null
      Requisition?: { __typename?: 'Requisition'; id: string; jobName?: string | null } | null
    }
    companyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    whoGetsCreditCompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    candidateSourceName?: {
      __typename?: 'CandidateSourceName'
      id: number
      name: string
      sourceCategory?: SourceCategoryEnum | null
      customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
    } | null
  } | null
}

export type DeleteStageCollaboratorMutationVariables = Exact<{
  input: DeleteStageCollaboratorInput
}>

export type DeleteStageCollaboratorMutation = {
  __typename?: 'Mutation'
  DeleteStageCollaborator: { __typename?: 'StageCollaborator'; id: string }
}

export type UpsertScreenStageCollaboratorMutationVariables = Exact<{
  input: UpsertStageCollaboratorInput
}>

export type UpsertScreenStageCollaboratorMutation = {
  __typename?: 'Mutation'
  UpsertStageCollaborator?: {
    __typename: 'StageCollaborator'
    id: string
    CompanyUser?: {
      __typename: 'CompanyUser'
      id: string
      profileImage?: string | null
      UserInvitation?: {
        __typename: 'UserInvitation'
        id: number
        email?: string | null
        ScalisUser?: {
          __typename: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
  } | null
}

export type UpsertStageCollaboratorMutationVariables = Exact<{
  input: UpsertStageCollaboratorInput
}>

export type UpsertStageCollaboratorMutation = {
  __typename?: 'Mutation'
  UpsertStageCollaborator?: {
    __typename?: 'StageCollaborator'
    id: string
    requisitionId?: number | null
    companyUserId?: number | null
    templateStageId?: number | null
    roleId?: number | null
    requisitionJobDescriptionId?: number | null
  } | null
}

export type DeleteStageSettingsMutationVariables = Exact<{
  input: DeleteStageSettingsInput
}>

export type DeleteStageSettingsMutation = {
  __typename?: 'Mutation'
  DeleteStageSettings: { __typename?: 'StageSettings'; id: string }
}

export type UpsertStageSettingsMutationVariables = Exact<{
  input: UpsertStageSettingsInput
}>

export type UpsertStageSettingsMutation = {
  __typename?: 'Mutation'
  UpsertStageSettings?: {
    __typename?: 'StageSettings'
    id: string
    jobPipelineId?: number | null
    templateStageId?: number | null
    scorecardTemplateId?: number | null
  } | null
}

export type HtmlToBase64MutationVariables = Exact<{
  input: HtmlToBase64Input
}>

export type HtmlToBase64Mutation = {
  __typename?: 'Mutation'
  HtmlToBase64?: { __typename?: 'HtmlToBase64Output'; pdf: string } | null
}

export type HtmlToDocxMutationVariables = Exact<{
  input: HtmlToDocxInput
}>

export type HtmlToDocxMutation = {
  __typename?: 'Mutation'
  HtmlToDocx?: {
    __typename?: 'HtmlToDocxOutput'
    filename: string
    size?: number | null
    url?: string | null
    dir?: string | null
  } | null
}

export type ArchiveTalentPoolMutationVariables = Exact<{
  input: ArchiveTalentPoolInput
}>

export type ArchiveTalentPoolMutation = {
  __typename?: 'Mutation'
  ArchiveTalentPool: {
    __typename?: 'TalentPool'
    associatedRequisitionIds: Array<number>
    companyId: number
    companyUserId?: number | null
    contributorCompanyUserIds: Array<number>
    description?: string | null
    id: string
    isArchived?: boolean | null
    isFavorite: boolean
    isVisibleTo: TalentPoolVisibilityEnum
    name: string
    ownerCompanyUserId?: number | null
    ownerName?: string | null
    tags: Array<string>
    count: number
    talentPoolType: TalentPoolTypeEnum
    updatedAt: any
  }
}

export type BulkAddCandidatesToTalentPoolMutationVariables = Exact<{
  input: BulkAddCandidatesToTalentPoolInput
}>

export type BulkAddCandidatesToTalentPoolMutation = {
  __typename?: 'Mutation'
  BulkAddCandidatesToTalentPool: {
    __typename?: 'BulkTalentPoolOperationResponse'
    count: number
    message?: string | null
    success: boolean
  }
}

export type BulkMoveCandidatesToTalentPoolMutationVariables = Exact<{
  input: BulkMoveCandidatesToTalentPoolInput
}>

export type BulkMoveCandidatesToTalentPoolMutation = {
  __typename?: 'Mutation'
  BulkMoveCandidatesToTalentPool: {
    __typename?: 'BulkTalentPoolOperationResponse'
    count: number
    message?: string | null
    success: boolean
  }
}

export type BulkRemoveCandidatesFromTalentPoolMutationVariables = Exact<{
  input: BulkRemoveCandidatesFromTalentPoolInput
}>

export type BulkRemoveCandidatesFromTalentPoolMutation = {
  __typename?: 'Mutation'
  BulkRemoveCandidatesFromTalentPool: {
    __typename?: 'BulkTalentPoolOperationResponse'
    count: number
    message?: string | null
    success: boolean
  }
}

export type BulkUpdateCandidatesProspectOwnerMutationVariables = Exact<{
  input: BulkUpdateCandidatesProspectOwnerInput
}>

export type BulkUpdateCandidatesProspectOwnerMutation = {
  __typename?: 'Mutation'
  BulkUpdateCandidatesProspectOwner: {
    __typename?: 'BulkTalentPoolOperationResponse'
    count: number
    message?: string | null
  }
}

export type BulkUpdateCandidatesProspectStatusMutationVariables = Exact<{
  input: BulkUpdateCandidatesProspectStatusInput
}>

export type BulkUpdateCandidatesProspectStatusMutation = {
  __typename?: 'Mutation'
  BulkUpdateCandidatesProspectStatus: {
    __typename?: 'BulkTalentPoolOperationResponse'
    count: number
    message?: string | null
  }
}

export type CreateFavoriteTalentPoolMutationVariables = Exact<{
  input: CreateFavoriteTalentPoolInput
}>

export type CreateFavoriteTalentPoolMutation = {
  __typename?: 'Mutation'
  CreateFavoriteTalentPool?: {
    __typename?: 'TalentPool'
    associatedRequisitionIds: Array<number>
    companyId: number
    companyUserId?: number | null
    contributorCompanyUserIds: Array<number>
    description?: string | null
    id: string
    isArchived?: boolean | null
    isFavorite: boolean
    isVisibleTo: TalentPoolVisibilityEnum
    name: string
    ownerCompanyUserId?: number | null
    ownerName?: string | null
    tags: Array<string>
    count: number
    talentPoolType: TalentPoolTypeEnum
    updatedAt: any
  } | null
}

export type CreateTalentPoolProspectStatusMutationVariables = Exact<{
  input: CreateTalentPoolProspectStatusInput
}>

export type CreateTalentPoolProspectStatusMutation = {
  __typename?: 'Mutation'
  CreateTalentPoolProspectStatus: {
    __typename?: 'TalentPoolProspectStatus'
    id: string
    colorNumber: number
    status: string
  }
}

export type CreateTalentPoolMutationVariables = Exact<{
  input: CreateTalentPoolInput
}>

export type CreateTalentPoolMutation = {
  __typename?: 'Mutation'
  CreateTalentPool: {
    __typename?: 'TalentPool'
    associatedRequisitionIds: Array<number>
    companyId: number
    companyUserId?: number | null
    contributorCompanyUserIds: Array<number>
    description?: string | null
    id: string
    isArchived?: boolean | null
    isFavorite: boolean
    isVisibleTo: TalentPoolVisibilityEnum
    name: string
    ownerCompanyUserId?: number | null
    ownerName?: string | null
    tags: Array<string>
    count: number
    talentPoolType: TalentPoolTypeEnum
    updatedAt: any
  }
}

export type DeleteFavoriteTalentPoolMutationVariables = Exact<{
  input: DeleteFavoriteTalentPoolInput
}>

export type DeleteFavoriteTalentPoolMutation = {
  __typename?: 'Mutation'
  DeleteFavoriteTalentPool?: {
    __typename?: 'TalentPool'
    associatedRequisitionIds: Array<number>
    companyId: number
    companyUserId?: number | null
    contributorCompanyUserIds: Array<number>
    description?: string | null
    id: string
    isArchived?: boolean | null
    isFavorite: boolean
    isVisibleTo: TalentPoolVisibilityEnum
    name: string
    ownerCompanyUserId?: number | null
    ownerName?: string | null
    tags: Array<string>
    count: number
    talentPoolType: TalentPoolTypeEnum
    updatedAt: any
  } | null
}

export type DeleteTalentPoolProspectStatusMutationVariables = Exact<{
  input: DeleteTalentPoolProspectStatusInput
}>

export type DeleteTalentPoolProspectStatusMutation = {
  __typename?: 'Mutation'
  DeleteTalentPoolProspectStatus: {
    __typename?: 'TalentPoolProspectStatus'
    id: string
    colorNumber: number
    status: string
  }
}

export type DeleteTalentPoolMutationVariables = Exact<{
  input: DeleteTalentPoolInput
}>

export type DeleteTalentPoolMutation = {
  __typename?: 'Mutation'
  DeleteTalentPool: { __typename?: 'DeleteTalentPoolResponse'; message?: string | null; success: boolean }
}

export type EditTalentPoolProspectStatusMutationVariables = Exact<{
  input: EditTalentPoolProspectStatusInput
}>

export type EditTalentPoolProspectStatusMutation = {
  __typename?: 'Mutation'
  EditTalentPoolProspectStatus: {
    __typename?: 'TalentPoolProspectStatus'
    id: string
    colorNumber: number
    status: string
  }
}

export type EditTalentPoolMutationVariables = Exact<{
  input: EditTalentPoolInput
}>

export type EditTalentPoolMutation = {
  __typename?: 'Mutation'
  EditTalentPool: {
    __typename?: 'TalentPool'
    associatedRequisitionIds: Array<number>
    companyId: number
    companyUserId?: number | null
    contributorCompanyUserIds: Array<number>
    description?: string | null
    id: string
    isArchived?: boolean | null
    isFavorite: boolean
    isVisibleTo: TalentPoolVisibilityEnum
    name: string
    ownerCompanyUserId?: number | null
    ownerName?: string | null
    tags: Array<string>
    count: number
    talentPoolType: TalentPoolTypeEnum
    updatedAt: any
  }
}

export type UnarchiveTalentPoolMutationVariables = Exact<{
  input: UnarchiveTalentPoolInput
}>

export type UnarchiveTalentPoolMutation = {
  __typename?: 'Mutation'
  UnarchiveTalentPool: {
    __typename?: 'TalentPool'
    associatedRequisitionIds: Array<number>
    companyId: number
    companyUserId?: number | null
    contributorCompanyUserIds: Array<number>
    description?: string | null
    id: string
    isArchived?: boolean | null
    isFavorite: boolean
    isVisibleTo: TalentPoolVisibilityEnum
    name: string
    ownerCompanyUserId?: number | null
    ownerName?: string | null
    tags: Array<string>
    count: number
    talentPoolType: TalentPoolTypeEnum
    updatedAt: any
  }
}

export type DeleteTemplateMessageMutationVariables = Exact<{
  input: DeleteTemplateMessageInput
}>

export type DeleteTemplateMessageMutation = {
  __typename?: 'Mutation'
  DeleteTemplateMessage: { __typename?: 'TemplateMessage'; id: string }
}

export type UpsertTemplateMessageMutationVariables = Exact<{
  input: UpsertTemplateMessageInput
}>

export type UpsertTemplateMessageMutation = {
  __typename?: 'Mutation'
  UpsertTemplateMessage?: {
    __typename?: 'TemplateMessage'
    id: string
    title?: string | null
    message?: string | null
    messageType?: MessageTypeEnum | null
    messageOwner?: MessageOwnerEnum | null
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type DeleteTemplateMilestoneMutationVariables = Exact<{
  input: DeleteTemplateMilestoneInput
}>

export type DeleteTemplateMilestoneMutation = {
  __typename?: 'Mutation'
  DeleteTemplateMilestone: { __typename?: 'TemplateMilestone'; id: string }
}

export type UpsertTemplateMilestoneMutationVariables = Exact<{
  input: UpsertTemplateMilestoneInput
}>

export type UpsertTemplateMilestoneMutation = {
  __typename?: 'Mutation'
  UpsertTemplateMilestone?: {
    __typename?: 'TemplateMilestone'
    id: string
    templatePipelineId?: number | null
    name?: NameEnum | null
    rankOrder?: number | null
    archived?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    TemplateStage?: Array<{
      __typename?: 'TemplateStage'
      id: string
      templatePipelineId?: number | null
      visibility?: TemplateStageVisibilityEnum | null
      name?: string | null
      templateMilestoneId?: number | null
      rankOrder?: number | null
      archived?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
    }> | null
  } | null
}

export type DeleteTemplatePipelineMutationVariables = Exact<{
  input: DeleteTemplatePipelineInput
}>

export type DeleteTemplatePipelineMutation = {
  __typename?: 'Mutation'
  DeleteTemplatePipeline: { __typename?: 'TemplatePipeline'; id: string }
}

export type UpsertTemplatePipelineMutationVariables = Exact<{
  input: UpsertTemplatePipelineInput
}>

export type UpsertTemplatePipelineMutation = {
  __typename?: 'Mutation'
  UpsertTemplatePipeline?: {
    __typename?: 'TemplatePipeline'
    id: string
    companyId?: number | null
    companyUserId?: number | null
    name?: string | null
    companyDepartmentId?: number | null
    archived?: boolean | null
    pipelinedUsed?: boolean | null
    ghostPipeline?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    deletedAt?: any | null
    TemplateMilestones?: Array<{
      __typename?: 'TemplateMilestone'
      id: string
      templatePipelineId?: number | null
      name?: NameEnum | null
      rankOrder?: number | null
      archived?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      TemplateStage?: Array<{
        __typename?: 'TemplateStage'
        id: string
        templatePipelineId?: number | null
        visibility?: TemplateStageVisibilityEnum | null
        name?: string | null
        templateMilestoneId?: number | null
        rankOrder?: number | null
        archived?: boolean | null
        createdAt?: any | null
        updatedAt?: any | null
      }> | null
    }> | null
  } | null
}

export type DeleteTemplateStageMutationVariables = Exact<{
  input: DeleteTemplateStageInput
}>

export type DeleteTemplateStageMutation = {
  __typename?: 'Mutation'
  DeleteTemplateStage: { __typename?: 'TemplateStage'; id: string }
}

export type UpsertTemplateStageMutationVariables = Exact<{
  input: UpsertTemplateStageInput
}>

export type UpsertTemplateStageMutation = {
  __typename?: 'Mutation'
  UpsertTemplateStage?: {
    __typename?: 'TemplateStage'
    id: string
    templatePipelineId?: number | null
    visibility?: TemplateStageVisibilityEnum | null
    name?: string | null
    templateMilestoneId?: number | null
    rankOrder?: number | null
    archived?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
  } | null
}

export type UploadS3FileMutationVariables = Exact<{
  input: UploadS3FileInput
}>

export type UploadS3FileMutation = {
  __typename?: 'Mutation'
  UploadS3File?: { __typename?: 'UploadS3FileOutput'; fileKey: string; filePath: string } | null
}

export type CreateUploadedCandidateMutationVariables = Exact<{
  input: CreateUploadedCandidateInput
}>

export type CreateUploadedCandidateMutation = {
  __typename?: 'Mutation'
  CreateUploadedCandidate: {
    __typename?: 'UploadedCandidate'
    id: number
    linkedinProfile?: string | null
    lastName?: string | null
    firstName?: string | null
    emailAddress?: string | null
    companyUserId?: number | null
    companyId?: number | null
    profileImage?: string | null
    profileUrl?: string | null
    uploadedCandidateType?: UploadedCandidateTypeEnum | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      profileType: ProfileTypeEnum
      CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
    } | null
    UploadedCandidateWebsiteOrSocialMedia: Array<{
      __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
      id: number
      websiteURL: string
      type: WebsiteTypeEnum
    }>
    UploadedCandidateAchievement: Array<{
      __typename?: 'UploadedCandidateAchievement'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      searchDescription?: string | null
    }>
    UploadedCandidateCertificateOrLicense: Array<{
      __typename?: 'UploadedCandidateCertificateOrLicense'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      searchDescription?: string | null
    }>
    UploadedCandidateEducation?: Array<{
      __typename?: 'UploadedCandidateEducation'
      id: number
      institutionName?: string | null
      currentlyStudying?: boolean | null
      educationLevel?: EducationLevelEnum | null
      startDate?: any | null
      endDate?: any | null
      areasOfStudy?: any | null
      majors?: any | null
      minors?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
      hideCumGPA?: boolean | null
      hideDepartmentGPA?: boolean | null
      departmentCumGPA?: number | null
      departmentCumGPAScale?: number | null
      additionalInformation?: string | null
    }> | null
    highestEducation?: Array<{
      __typename?: 'UploadedCandidateEducation'
      id: number
      institutionName?: string | null
      currentlyStudying?: boolean | null
      educationLevel?: EducationLevelEnum | null
      startDate?: any | null
      endDate?: any | null
      areasOfStudy?: any | null
      majors?: any | null
      minors?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
      hideCumGPA?: boolean | null
      hideDepartmentGPA?: boolean | null
      departmentCumGPA?: number | null
      departmentCumGPAScale?: number | null
      additionalInformation?: string | null
    }> | null
    UploadedCandidateExperience?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      startDate?: any | null
      endDate?: any | null
      companyLogo?: string | null
      locationType?: string | null
      location?: string | null
      shortFormDesc?: any | null
      longFormDesc?: string | null
      searchShortFormDesc?: string | null
      searchLongFormDesc?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      payType?: string | null
      jobPay?: number | null
      additionalComp?: boolean | null
      jobTitle?: string | null
      employerName?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      workPlaceCandidate?: WorkPlaceCandidateEnum | null
      isCurrentJob?: boolean | null
      jobType?: JobTypeEnum | null
      isCurrentlyWorking?: boolean | null
      description?: string | null
    }> | null
    ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
    currentJob?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      startDate?: any | null
      endDate?: any | null
      companyLogo?: string | null
      locationType?: string | null
      location?: string | null
      shortFormDesc?: any | null
      longFormDesc?: string | null
      searchShortFormDesc?: string | null
      searchLongFormDesc?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      payType?: string | null
      jobPay?: number | null
      additionalComp?: boolean | null
      jobTitle?: string | null
      employerName?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      workPlaceCandidate?: WorkPlaceCandidateEnum | null
      isCurrentJob?: boolean | null
      jobType?: JobTypeEnum | null
      isCurrentlyWorking?: boolean | null
      description?: string | null
    }> | null
    mostRecentJob?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      startDate?: any | null
      endDate?: any | null
      companyLogo?: string | null
      locationType?: string | null
      location?: string | null
      shortFormDesc?: any | null
      longFormDesc?: string | null
      searchShortFormDesc?: string | null
      searchLongFormDesc?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      payType?: string | null
      jobPay?: number | null
      additionalComp?: boolean | null
      jobTitle?: string | null
      employerName?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      workPlaceCandidate?: WorkPlaceCandidateEnum | null
      isCurrentJob?: boolean | null
      jobType?: JobTypeEnum | null
      isCurrentlyWorking?: boolean | null
      description?: string | null
    }> | null
    UploadedCandidateJobSeekerSkill?: Array<{
      __typename?: 'UploadedCandidateJobSeekerSkills'
      id: number
      sequenceNumber?: number | null
      level?: string | null
      name?: string | null
      yearsOfExp?: number | null
    }> | null
    UploadedCandidateVolunteerWork: Array<{
      __typename?: 'UploadedCandidateVolunteerWork'
      id: number
      volunteerJobTitle?: string | null
      organizationName?: string | null
      isCurrentlyWorking?: boolean | null
      roleType?: RoleTypeEnum | null
      startDate?: any | null
      endDate?: any | null
      description?: any | null
      searchDescription?: string | null
      location?: string | null
    }>
    EnrichedEmail: Array<{
      __typename?: 'EnrichedEmail'
      id: string
      emailAddress?: string | null
      enrichedEmailType?: EnrichedEmailTypeEnum | null
      uploadedCandidateId?: number | null
      recommended?: boolean | null
    }>
    EnrichedPhoneNumber: Array<{
      __typename?: 'EnrichedPhoneNumber'
      id: string
      phoneNumber?: string | null
      uploadedCandidateId?: number | null
      recommended?: boolean | null
    }>
  }
}

export type ExtractSocialProfileMutationVariables = Exact<{
  html: Scalars['String']['input']
  uploadedCandidateType: UploadedCandidateTypeEnum
  mockEnrichmentEnabled?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ExtractSocialProfileMutation = {
  __typename?: 'Mutation'
  ExtractSocialProfile: {
    __typename: 'UploadedCandidate'
    id: number
    firstName?: string | null
    lastName?: string | null
    emailAddress?: string | null
    linkedinProfile?: string | null
    profileUrl?: string | null
    profileImage?: string | null
    uploadedCandidateType?: UploadedCandidateTypeEnum | null
    UploadedCandidateAchievement: Array<{
      __typename?: 'UploadedCandidateAchievement'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      searchDescription?: string | null
    }>
    UploadedCandidateCertificateOrLicense: Array<{
      __typename?: 'UploadedCandidateCertificateOrLicense'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      searchDescription?: string | null
    }>
    UploadedCandidateEducation?: Array<{
      __typename?: 'UploadedCandidateEducation'
      id: number
      institutionName?: string | null
      currentlyStudying?: boolean | null
      educationLevel?: EducationLevelEnum | null
      startDate?: any | null
      endDate?: any | null
      areasOfStudy?: any | null
      majors?: any | null
      minors?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
      hideCumGPA?: boolean | null
      hideDepartmentGPA?: boolean | null
      departmentCumGPA?: number | null
      departmentCumGPAScale?: number | null
      additionalInformation?: string | null
    }> | null
    UploadedCandidateExperience?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      companyLogo?: string | null
      startDate?: any | null
      endDate?: any | null
      locationType?: string | null
      location?: string | null
      shortFormDesc?: any | null
      longFormDesc?: string | null
      searchShortFormDesc?: string | null
      searchLongFormDesc?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      payType?: string | null
      jobPay?: number | null
      additionalComp?: boolean | null
      jobTitle?: string | null
      employerName?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      workPlaceCandidate?: WorkPlaceCandidateEnum | null
      isCurrentJob?: boolean | null
      jobType?: JobTypeEnum | null
      isCurrentlyWorking?: boolean | null
      description?: string | null
    }> | null
    UploadedCandidateJobSeekerSkill?: Array<{
      __typename?: 'UploadedCandidateJobSeekerSkills'
      id: number
      sequenceNumber?: number | null
      level?: string | null
      name?: string | null
      yearsOfExp?: number | null
    }> | null
    UploadedCandidateVolunteerWork: Array<{
      __typename?: 'UploadedCandidateVolunteerWork'
      id: number
      volunteerJobTitle?: string | null
      organizationName?: string | null
      isCurrentlyWorking?: boolean | null
      roleType?: RoleTypeEnum | null
      startDate?: any | null
      endDate?: any | null
      description?: any | null
      searchDescription?: string | null
      location?: string | null
    }>
    UploadedCandidateWebsiteOrSocialMedia: Array<{
      __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
      id: number
      websiteURL: string
      type: WebsiteTypeEnum
    }>
  }
}

export type ParseResumeBasicInfoMutationVariables = Exact<{
  input: ParseResumeBasicInfoInput
}>

export type ParseResumeBasicInfoMutation = {
  __typename?: 'Mutation'
  ParseResumeBasicInfo: {
    __typename?: 'ParsedResumeData'
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    phone?: string | null
    linkedin?: string | null
  }
}

export type UpdateAccountInformationMutationVariables = Exact<{
  input: UpdateScalisUserDataInput
}>

export type UpdateAccountInformationMutation = {
  __typename?: 'Mutation'
  UpdateScalisUserData: {
    __typename?: 'ScalisUser'
    firstName?: string | null
    lastName?: string | null
    Address?: Array<{
      __typename?: 'Address'
      id: number
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      country?: string | null
      postalCode?: string | null
      timeZone?: string | null
      longitude?: string | null
      latitude?: string | null
    }> | null
    ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
  }
}

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never }>

export type DeleteAccountMutation = {
  __typename?: 'Mutation'
  DisableUserAccount?: { __typename?: 'ScalisUser'; id: number } | null
}

export type UpsertEmailMutationVariables = Exact<{
  input: UpsertEmailInput
}>

export type UpsertEmailMutation = {
  __typename?: 'Mutation'
  UpsertEmail: {
    __typename?: 'ScalisUser'
    EmailVerification?: Array<{
      __typename: 'EmailVerification'
      id: number
      emailAddress?: string | null
      isPrimary?: boolean | null
      isVisibleToEmployers?: boolean | null
      activeStatus?: boolean | null
    }> | null
  }
}

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput
}>

export type ChangePasswordMutation = {
  __typename?: 'Mutation'
  ChangePassword?: { __typename: 'ScalisUser'; id: number } | null
}

export type ResendResetPasswordEmailMutationVariables = Exact<{
  input: ResendResetPasswordEmailInput
}>

export type ResendResetPasswordEmailMutation = {
  __typename?: 'Mutation'
  ResendResetPasswordEmail: Array<{ __typename: 'EmailVerification'; id: number }>
}

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput
}>

export type ResetPasswordMutation = {
  __typename?: 'Mutation'
  ResetPassword?: { __typename: 'ScalisUser'; id: number } | null
}

export type SendResetPasswordEmailMutationVariables = Exact<{
  input: SendResetPasswordEmailInput
}>

export type SendResetPasswordEmailMutation = {
  __typename?: 'Mutation'
  SendResetPasswordEmail: Array<{ __typename: 'EmailVerification'; id: number; emailAddress?: string | null }>
}

export type VerifyEmailCodeResetPasswordMutationVariables = Exact<{
  input: VerifyEmailCodeInput
}>

export type VerifyEmailCodeResetPasswordMutation = {
  __typename?: 'Mutation'
  VerifyEmailCode: { __typename: 'ScalisUser'; id: number }
}

export type VerifyPasswordCodeMutationVariables = Exact<{
  input: VerifyPasswordCodeInput
}>

export type VerifyPasswordCodeMutation = {
  __typename?: 'Mutation'
  VerifyPasswordCode: { __typename: 'ScalisUser'; id: number }
}

export type SearchActivityLogsFilterContentQueryVariables = Exact<{
  input: SearchActivityLogsFilterContentInput
}>

export type SearchActivityLogsFilterContentQuery = {
  __typename?: 'Query'
  SearchActivityLogsFilterContent: {
    __typename?: 'SearchActivityLogsFilterContentOutput'
    filterContent?: Array<{ __typename?: 'activityLogsFilterContentItem'; id?: number | null; value: string }> | null
  }
}

export type GetAiCreditBalanceQueryVariables = Exact<{ [key: string]: never }>

export type GetAiCreditBalanceQuery = {
  __typename?: 'Query'
  GetAiCreditBalance?: {
    __typename?: 'AiCreditBalance'
    totalCredits: number
    usedCredits: number
    availableCredits: number
  } | null
}

export type GetAiCreditPackagesQueryVariables = Exact<{ [key: string]: never }>

export type GetAiCreditPackagesQuery = {
  __typename?: 'Query'
  GetAiCreditPackages: Array<{
    __typename?: 'AiCreditPackage'
    id: string
    name: string
    creditsAmount: number
    totalPrice: number
    pricePerCredit: number
    vatAmount: number
    description?: string | null
    sortOrder: number
  }>
}

export type AiCreditPackageFragment = {
  __typename?: 'AiCreditPackage'
  id: string
  name: string
  creditsAmount: number
  totalPrice: number
  pricePerCredit: number
  vatAmount: number
  description?: string | null
  sortOrder: number
}

export type GetAiNotetakerTranscriptQueryVariables = Exact<{
  input: GetAiNotetakerTranscriptInput
}>

export type GetAiNotetakerTranscriptQuery = {
  __typename?: 'Query'
  GetAiNotetakerTranscript: {
    __typename?: 'TranscriptResponse'
    transcriptText?: string | null
    summary?: string | null
    recordingUrl?: string | null
    transcriptUrl?: string | null
    urlExpiresAt: any
    transcript?: Array<{
      __typename?: 'TranscriptEntry'
      speaker: string
      text: string
      start: number
      end: number
    }> | null
    metadata: {
      __typename?: 'TranscriptMetadata'
      totalDuration?: number | null
      speakerCount?: number | null
      totalEntries?: number | null
      interviewStartTime?: string | null
      timeZone?: string | null
      lastUpdated: any
    }
  }
}

export type GetCandidateRecommendationsHighlightsQueryVariables = Exact<{
  jobListing?: InputMaybe<GetCandidateRecommendationInputJobListing>
  jobListingId?: InputMaybe<Scalars['String']['input']>
  recommendations: Array<CandidateRecommendationHighlightsInput> | CandidateRecommendationHighlightsInput
}>

export type GetCandidateRecommendationsHighlightsQuery = {
  __typename?: 'Query'
  GetCandidateRecommendationsHighlights?: Array<{
    __typename?: 'CandidateRecommendationsHighlights'
    id: string
    summary: string
    scores: {
      __typename?: 'CandidateRecommendationScores'
      sections: Array<{
        __typename?: 'Section'
        name?: string | null
        score?: number | null
        details?: Array<{
          __typename?: 'ScoreDetails'
          exactMatch?: boolean | null
          explanation?: string | null
          name?: string | null
          similarTo?: string | null
          verifiedFrom?: string | null
        }> | null
      }>
    }
    highlights: Array<{ __typename?: 'CandidateRecommendationHighlight'; icon: string; name: string; summary: string }>
  }> | null
}

export type CandidateRecommendationsHighlightsFragment = {
  __typename?: 'CandidateRecommendationsHighlights'
  id: string
  summary: string
  scores: {
    __typename?: 'CandidateRecommendationScores'
    sections: Array<{
      __typename?: 'Section'
      name?: string | null
      score?: number | null
      details?: Array<{
        __typename?: 'ScoreDetails'
        exactMatch?: boolean | null
        explanation?: string | null
        name?: string | null
        similarTo?: string | null
        verifiedFrom?: string | null
      }> | null
    }>
  }
  highlights: Array<{ __typename?: 'CandidateRecommendationHighlight'; icon: string; name: string; summary: string }>
}

export type GetCandidateRecommendationQueryVariables = Exact<{
  filters?: InputMaybe<GetCandidateRecommendationInputFilters>
  jobListingId?: InputMaybe<Scalars['String']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  jobListing?: InputMaybe<GetCandidateRecommendationInputJobListing>
  pagination?: InputMaybe<GetCandidateRecommendationInputPagination>
}>

export type GetCandidateRecommendationQuery = {
  __typename?: 'Query'
  GetCandidateRecommendation?: {
    __typename?: 'GetCandidateRecommendationOutput'
    results?: Array<{
      __typename?: 'CandidateRecommendation'
      id?: string | null
      publicListingId?: string | null
      headline?: string | null
      summary?: string | null
      industry?: string | null
      isActive?: boolean | null
      createdAt?: string | null
      updatedAt?: string | null
      interests?: Array<string> | null
      imageUrl?: string | null
      source?: CandidateRecommendationSourceEnumType | null
      achievements?: {
        __typename?: 'CandidateRecommendationAchievements'
        list?: Array<{
          __typename?: 'CandidateRecommendationAchievement'
          endDate?: string | null
          startDate?: string | null
          summary?: string | null
          title: string
        }> | null
      } | null
      certifications?: {
        __typename?: 'CandidateRecommendationCertifications'
        list?: Array<{
          __typename?: 'CandidateRecommendationCertification'
          endDate?: string | null
          startDate?: string | null
          summary?: string | null
          title: string
          organization: {
            __typename?: 'Organization'
            id?: string | null
            description?: string | null
            founded?: number | null
            imageUrl?: string | null
            industries?: Array<string> | null
            name?: string | null
            type?: string | null
            url?: string | null
            funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
            headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
            location?: {
              __typename?: 'CandidateRecommendationLocation'
              address?: string | null
              address2?: string | null
              city?: string | null
              continent?: string | null
              country?: string | null
              name?: string | null
              postalCode?: string | null
              region?: string | null
              coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
            } | null
          }
        }> | null
      } | null
      contact?: {
        __typename?: 'CandidateRecommendationContact'
        demographics?: {
          __typename?: 'Demographics'
          gender?: string | null
          race?: string | null
          veteranStatus?: string | null
        } | null
        emails?: Array<{ __typename?: 'Email'; email?: string | null; isCurrent: boolean; type: string }> | null
        name: {
          __typename?: 'Name'
          first?: string | null
          full?: string | null
          last?: string | null
          middle?: string | null
        }
        phones?: Array<{
          __typename?: 'Phone'
          isCurrent?: boolean | null
          number?: string | null
          type: string
        }> | null
      } | null
      educations?: {
        __typename?: 'CandidateRecommendationEducations'
        list?: Array<{
          __typename?: 'CandidateRecommendationEducation'
          endDate?: string | null
          isCurrent: boolean
          level?: string | null
          majors?: Array<string> | null
          minors?: Array<string> | null
          startDate?: string | null
          summary?: string | null
          title?: string | null
          gpa?: { __typename?: 'Gpa'; scale?: number | null; value?: number | null } | null
          organization: {
            __typename?: 'Organization'
            id?: string | null
            description?: string | null
            founded?: number | null
            imageUrl?: string | null
            industries?: Array<string> | null
            name?: string | null
            type?: string | null
            url?: string | null
            funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
            headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
            location?: {
              __typename?: 'CandidateRecommendationLocation'
              address?: string | null
              address2?: string | null
              city?: string | null
              continent?: string | null
              country?: string | null
              name?: string | null
              postalCode?: string | null
              region?: string | null
              coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
            } | null
          }
        }> | null
        tenure?: { __typename?: 'Tenure'; unit: string; value: number } | null
      } | null
      experiences?: {
        __typename?: 'CandidateRecommendationExperiences'
        lastChangedAt?: string | null
        lastVerifiedAt?: string | null
        list?: Array<{
          __typename?: 'CandidateRecommendationExperience'
          employmentType?: string | null
          isCurrent?: boolean | null
          locationType?: string | null
          payType?: string | null
          startDate?: string | null
          endDate?: string | null
          summary?: string | null
          title?: string | null
          location?: {
            __typename?: 'CandidateRecommendationLocation'
            address?: string | null
            address2?: string | null
            city?: string | null
            continent?: string | null
            country?: string | null
            name?: string | null
            postalCode?: string | null
            region?: string | null
            coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
          } | null
          organization?: {
            __typename?: 'Organization'
            id?: string | null
            description?: string | null
            founded?: number | null
            imageUrl?: string | null
            industries?: Array<string> | null
            name?: string | null
            type?: string | null
            url?: string | null
            funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
            headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
            location?: {
              __typename?: 'CandidateRecommendationLocation'
              address?: string | null
              address2?: string | null
              city?: string | null
              continent?: string | null
              country?: string | null
              name?: string | null
              postalCode?: string | null
              region?: string | null
              coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
            } | null
          } | null
          position?: {
            __typename?: 'Position'
            class?: string | null
            isManagement?: boolean | null
            levels?: Array<string> | null
            role?: string | null
            subRole?: string | null
            teamSize?: string | null
          } | null
          tenure?: { __typename?: 'Tenure'; unit: string; value: number } | null
        }> | null
        tenure?: {
          __typename?: 'CandidateRecommendationExperienceTenure'
          avg?: number | null
          count?: number | null
          current?: number | null
          unit: string
          value: number
        } | null
      } | null
      languages?: Array<{ __typename?: 'Language'; name: string; proficiency?: string | null }> | null
      location?: {
        __typename?: 'CandidateRecommendationLocation'
        address?: string | null
        address2?: string | null
        city?: string | null
        continent?: string | null
        country?: string | null
        name?: string | null
        postalCode?: string | null
        region?: string | null
        coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
      } | null
      scores?: {
        __typename?: 'CandidateRecommendationScores'
        overall?: number | null
        highlights?: Array<{
          __typename?: 'CandidateRecommendationHighlight'
          icon: string
          name: string
          summary: string
        }> | null
        sections: Array<{
          __typename?: 'Section'
          name?: string | null
          score?: number | null
          details?: Array<{
            __typename?: 'ScoreDetails'
            exactMatch?: boolean | null
            explanation?: string | null
            name?: string | null
            similarTo?: string | null
            verifiedFrom?: string | null
          }> | null
        }>
      } | null
      skills?: {
        __typename?: 'CandidateRecommendationSkills'
        list?: Array<{ __typename?: 'CandidateRecommendationSkill'; name: string }> | null
      } | null
      socials?: Array<{
        __typename?: 'Social'
        id?: string | null
        imageUrl?: string | null
        type: string
        url?: string | null
        username?: string | null
      }> | null
      volunteerWork?: {
        __typename?: 'CandidateRecommendationVolunteerWorks'
        list?: Array<{
          __typename?: 'CandidateRecommendationVolunteerWork'
          endDate?: string | null
          isCurrent?: boolean | null
          startDate?: string | null
          summary?: string | null
          title?: string | null
          position: {
            __typename?: 'Position'
            class?: string | null
            isManagement?: boolean | null
            levels?: Array<string> | null
            role?: string | null
            subRole?: string | null
            teamSize?: string | null
          }
          organization: {
            __typename?: 'Organization'
            id?: string | null
            description?: string | null
            founded?: number | null
            imageUrl?: string | null
            industries?: Array<string> | null
            name?: string | null
            type?: string | null
            url?: string | null
            funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
            headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
            location?: {
              __typename?: 'CandidateRecommendationLocation'
              address?: string | null
              address2?: string | null
              city?: string | null
              continent?: string | null
              country?: string | null
              name?: string | null
              postalCode?: string | null
              region?: string | null
              coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
            } | null
          }
        }> | null
        tenure?: { __typename?: 'Tenure'; unit: string; value: number } | null
      } | null
    }> | null
    pagination?: {
      __typename?: 'GetCandidateRecommendationOutputPagination'
      count?: number | null
      page?: number | null
      size?: number | null
      totalPages?: number | null
    } | null
  } | null
}

export type CandidateRecommendationFragment = {
  __typename?: 'CandidateRecommendation'
  id?: string | null
  publicListingId?: string | null
  headline?: string | null
  summary?: string | null
  industry?: string | null
  isActive?: boolean | null
  createdAt?: string | null
  updatedAt?: string | null
  interests?: Array<string> | null
  imageUrl?: string | null
  source?: CandidateRecommendationSourceEnumType | null
  achievements?: {
    __typename?: 'CandidateRecommendationAchievements'
    list?: Array<{
      __typename?: 'CandidateRecommendationAchievement'
      endDate?: string | null
      startDate?: string | null
      summary?: string | null
      title: string
    }> | null
  } | null
  certifications?: {
    __typename?: 'CandidateRecommendationCertifications'
    list?: Array<{
      __typename?: 'CandidateRecommendationCertification'
      endDate?: string | null
      startDate?: string | null
      summary?: string | null
      title: string
      organization: {
        __typename?: 'Organization'
        id?: string | null
        description?: string | null
        founded?: number | null
        imageUrl?: string | null
        industries?: Array<string> | null
        name?: string | null
        type?: string | null
        url?: string | null
        funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
        headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
        location?: {
          __typename?: 'CandidateRecommendationLocation'
          address?: string | null
          address2?: string | null
          city?: string | null
          continent?: string | null
          country?: string | null
          name?: string | null
          postalCode?: string | null
          region?: string | null
          coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
        } | null
      }
    }> | null
  } | null
  contact?: {
    __typename?: 'CandidateRecommendationContact'
    demographics?: {
      __typename?: 'Demographics'
      gender?: string | null
      race?: string | null
      veteranStatus?: string | null
    } | null
    emails?: Array<{ __typename?: 'Email'; email?: string | null; isCurrent: boolean; type: string }> | null
    name: {
      __typename?: 'Name'
      first?: string | null
      full?: string | null
      last?: string | null
      middle?: string | null
    }
    phones?: Array<{ __typename?: 'Phone'; isCurrent?: boolean | null; number?: string | null; type: string }> | null
  } | null
  educations?: {
    __typename?: 'CandidateRecommendationEducations'
    list?: Array<{
      __typename?: 'CandidateRecommendationEducation'
      endDate?: string | null
      isCurrent: boolean
      level?: string | null
      majors?: Array<string> | null
      minors?: Array<string> | null
      startDate?: string | null
      summary?: string | null
      title?: string | null
      gpa?: { __typename?: 'Gpa'; scale?: number | null; value?: number | null } | null
      organization: {
        __typename?: 'Organization'
        id?: string | null
        description?: string | null
        founded?: number | null
        imageUrl?: string | null
        industries?: Array<string> | null
        name?: string | null
        type?: string | null
        url?: string | null
        funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
        headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
        location?: {
          __typename?: 'CandidateRecommendationLocation'
          address?: string | null
          address2?: string | null
          city?: string | null
          continent?: string | null
          country?: string | null
          name?: string | null
          postalCode?: string | null
          region?: string | null
          coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
        } | null
      }
    }> | null
    tenure?: { __typename?: 'Tenure'; unit: string; value: number } | null
  } | null
  experiences?: {
    __typename?: 'CandidateRecommendationExperiences'
    lastChangedAt?: string | null
    lastVerifiedAt?: string | null
    list?: Array<{
      __typename?: 'CandidateRecommendationExperience'
      employmentType?: string | null
      isCurrent?: boolean | null
      locationType?: string | null
      payType?: string | null
      startDate?: string | null
      endDate?: string | null
      summary?: string | null
      title?: string | null
      location?: {
        __typename?: 'CandidateRecommendationLocation'
        address?: string | null
        address2?: string | null
        city?: string | null
        continent?: string | null
        country?: string | null
        name?: string | null
        postalCode?: string | null
        region?: string | null
        coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
      } | null
      organization?: {
        __typename?: 'Organization'
        id?: string | null
        description?: string | null
        founded?: number | null
        imageUrl?: string | null
        industries?: Array<string> | null
        name?: string | null
        type?: string | null
        url?: string | null
        funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
        headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
        location?: {
          __typename?: 'CandidateRecommendationLocation'
          address?: string | null
          address2?: string | null
          city?: string | null
          continent?: string | null
          country?: string | null
          name?: string | null
          postalCode?: string | null
          region?: string | null
          coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
        } | null
      } | null
      position?: {
        __typename?: 'Position'
        class?: string | null
        isManagement?: boolean | null
        levels?: Array<string> | null
        role?: string | null
        subRole?: string | null
        teamSize?: string | null
      } | null
      tenure?: { __typename?: 'Tenure'; unit: string; value: number } | null
    }> | null
    tenure?: {
      __typename?: 'CandidateRecommendationExperienceTenure'
      avg?: number | null
      count?: number | null
      current?: number | null
      unit: string
      value: number
    } | null
  } | null
  languages?: Array<{ __typename?: 'Language'; name: string; proficiency?: string | null }> | null
  location?: {
    __typename?: 'CandidateRecommendationLocation'
    address?: string | null
    address2?: string | null
    city?: string | null
    continent?: string | null
    country?: string | null
    name?: string | null
    postalCode?: string | null
    region?: string | null
    coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
  } | null
  scores?: {
    __typename?: 'CandidateRecommendationScores'
    overall?: number | null
    highlights?: Array<{
      __typename?: 'CandidateRecommendationHighlight'
      icon: string
      name: string
      summary: string
    }> | null
    sections: Array<{
      __typename?: 'Section'
      name?: string | null
      score?: number | null
      details?: Array<{
        __typename?: 'ScoreDetails'
        exactMatch?: boolean | null
        explanation?: string | null
        name?: string | null
        similarTo?: string | null
        verifiedFrom?: string | null
      }> | null
    }>
  } | null
  skills?: {
    __typename?: 'CandidateRecommendationSkills'
    list?: Array<{ __typename?: 'CandidateRecommendationSkill'; name: string }> | null
  } | null
  socials?: Array<{
    __typename?: 'Social'
    id?: string | null
    imageUrl?: string | null
    type: string
    url?: string | null
    username?: string | null
  }> | null
  volunteerWork?: {
    __typename?: 'CandidateRecommendationVolunteerWorks'
    list?: Array<{
      __typename?: 'CandidateRecommendationVolunteerWork'
      endDate?: string | null
      isCurrent?: boolean | null
      startDate?: string | null
      summary?: string | null
      title?: string | null
      position: {
        __typename?: 'Position'
        class?: string | null
        isManagement?: boolean | null
        levels?: Array<string> | null
        role?: string | null
        subRole?: string | null
        teamSize?: string | null
      }
      organization: {
        __typename?: 'Organization'
        id?: string | null
        description?: string | null
        founded?: number | null
        imageUrl?: string | null
        industries?: Array<string> | null
        name?: string | null
        type?: string | null
        url?: string | null
        funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
        headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
        location?: {
          __typename?: 'CandidateRecommendationLocation'
          address?: string | null
          address2?: string | null
          city?: string | null
          continent?: string | null
          country?: string | null
          name?: string | null
          postalCode?: string | null
          region?: string | null
          coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
        } | null
      }
    }> | null
    tenure?: { __typename?: 'Tenure'; unit: string; value: number } | null
  } | null
}

export type OrganizationFragment = {
  __typename?: 'Organization'
  id?: string | null
  description?: string | null
  founded?: number | null
  imageUrl?: string | null
  industries?: Array<string> | null
  name?: string | null
  type?: string | null
  url?: string | null
  funding?: { __typename?: 'OrganizationFunding'; lastFundingRound?: string | null } | null
  headcount?: { __typename?: 'OrganizationHeadcount'; bucket?: string | null; size?: number | null } | null
  location?: {
    __typename?: 'CandidateRecommendationLocation'
    address?: string | null
    address2?: string | null
    city?: string | null
    continent?: string | null
    country?: string | null
    name?: string | null
    postalCode?: string | null
    region?: string | null
    coordinates?: { __typename?: 'Coordinates'; lat?: number | null; lon?: number | null } | null
  } | null
}

export type SocialFragment = {
  __typename?: 'Social'
  id?: string | null
  imageUrl?: string | null
  type: string
  url?: string | null
  username?: string | null
}

export type GetNewMatchesCountQueryVariables = Exact<{
  requisitionId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetNewMatchesCountQuery = {
  __typename?: 'Query'
  GetCandidateRecommendation?: {
    __typename?: 'GetCandidateRecommendationOutput'
    pagination?: { __typename?: 'GetCandidateRecommendationOutputPagination'; count?: number | null } | null
  } | null
}

export type GetPublicJobListingQueryVariables = Exact<{
  publicListingId: Scalars['String']['input']
}>

export type GetPublicJobListingQuery = {
  __typename?: 'Query'
  GetPublicJobListing?: {
    __typename?: 'JobListing'
    externalTitle?: string | null
    externalListingId?: string | null
    displayPayOnListing?: boolean | null
    id: number
    industry?: IndustryEnum | null
    JobListingScreeningQuestion?: Array<{
      __typename?: 'JobListingScreeningQuestion'
      id: string
      active?: boolean | null
      displaySequenceNumber?: number | null
      screeningQuestionId?: number | null
      ScreeningQuestion?: {
        __typename?: 'ScreeningQuestion'
        id: string
        companyId?: number | null
        questionTitle?: string | null
        questionType?: QuestionTypeEnum | null
        ansOptions?: string | null
        isTemplateQuestion?: boolean | null
        isGlobalQuestion?: boolean | null
        globalQuestionOrder?: number | null
        maxVal?: number | null
        minVal?: number | null
        preferredAnswer?: string | null
        questionDesc?: string | null
        valStatus?: string | null
      } | null
    }> | null
    Requisition?: { __typename?: 'Requisition'; Company?: { __typename?: 'Company'; id: string } | null } | null
  } | null
}

export type GetUserHasFinishedOnboardingQueryVariables = Exact<{ [key: string]: never }>

export type GetUserHasFinishedOnboardingQuery = {
  __typename?: 'Query'
  Me?: {
    __typename?: 'ScalisUser'
    id: number
    JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; id: number; hasFinishedOnboarding: boolean } | null
  } | null
}

export type GetUserProfileDataQueryVariables = Exact<{ [key: string]: never }>

export type GetUserProfileDataQuery = {
  __typename?: 'Query'
  Me?: {
    __typename?: 'ScalisUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    completedAt?: any | null
    currentStage?: string | null
    profileImage?: string | null
    EmailVerification?: Array<{
      __typename?: 'EmailVerification'
      emailAddress?: string | null
      emailVerified?: boolean | null
      isPrimary?: boolean | null
    }> | null
    JobSeekerInfo?: {
      __typename?: 'JobSeekerInfo'
      id: number
      aboutMe?: string | null
      searchingJobs?: boolean | null
    } | null
    JobSeekerHeader?: Array<{
      __typename?: 'JobSeekerHeader'
      id: number
      profileHeadline?: string | null
      jobDisplayedId?: number | null
      educationDisplayedId?: number | null
    }> | null
    ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
    Address?: Array<{
      __typename?: 'Address'
      id: number
      city?: string | null
      state?: string | null
      country?: string | null
      addressLine1?: string | null
      addressLine2?: string | null
      postalCode?: string | null
      timeZone?: string | null
      longitude?: string | null
      latitude?: string | null
    }> | null
    Achievement?: Array<{
      __typename?: 'Achievement'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      organization?: {
        __typename?: 'CompanyGlobal'
        id?: string | null
        name?: string | null
        logo?: string | null
        website?: string | null
      } | null
    }> | null
    CertificateOrLicense?: Array<{
      __typename?: 'CertificateOrLicense'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      organization?: {
        __typename?: 'CompanyGlobal'
        id?: string | null
        name?: string | null
        logo?: string | null
        website?: string | null
      } | null
    }> | null
    JobSeekerSkill?: Array<{
      __typename?: 'JobSeekerSkills'
      id: number
      sequenceNumber?: number | null
      level?: string | null
      name?: string | null
      yearsOfExp?: number | null
    }> | null
    DemographicInfo?: Array<{
      __typename?: 'DemographicInfo'
      gender?: GenderEnum | null
      raceEthnicity?: string | null
      veteranStatus?: VeteranStatusEnum | null
    }> | null
    WebsiteOrSocialMedia?: Array<{
      __typename?: 'WebsiteOrSocialMedia'
      websiteURL: string
      type: WebsiteTypeEnum
    }> | null
    VolunteerWork?: Array<{
      __typename?: 'VolunteerWork'
      id: number
      roleType?: RoleTypeEnum | null
      volunteerJobTitle?: string | null
      organizationName?: string | null
      location?: string | null
      startDate?: any | null
      endDate?: any | null
      isCurrentlyWorking?: boolean | null
      description?: any | null
      searchDescription?: string | null
      organization?: {
        __typename?: 'CompanyGlobal'
        id?: string | null
        name?: string | null
        logo?: string | null
        website?: string | null
      } | null
    }> | null
    Experience?: Array<{
      __typename?: 'Experience'
      id: number
      jobTitle?: string | null
      employerName?: string | null
      jobType?: JobTypeEnum | null
      locationType?: string | null
      location?: string | null
      startDate?: any | null
      endDate?: any | null
      isCurrentlyWorking?: boolean | null
      isCurrentJob?: boolean | null
      description?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      jobSeekerSkillExperiences?: Array<{
        __typename?: 'JobSeekerSkillExperience'
        id: number
        jobSeekerSkill?: { __typename?: 'JobSeekerSkill'; id: number; displayName?: string | null } | null
      }> | null
      organization?: {
        __typename?: 'CompanyGlobal'
        logo?: string | null
        name?: string | null
        website?: string | null
      } | null
    }> | null
    Education?: Array<{
      __typename?: 'Education'
      id: number
      institutionName?: string | null
      educationLevel?: EducationLevelEnum | null
      areasOfStudy?: any | null
      startDate?: any | null
      endDate?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
      majors?: any | null
      minors?: any | null
      hideCumGPA?: boolean | null
      hideDepartmentGPA?: boolean | null
      departmentCumGPA?: number | null
      additionalInformation?: string | null
      currentlyStudying?: boolean | null
      organization?: {
        __typename?: 'CompanyGlobal'
        logo?: string | null
        name?: string | null
        website?: string | null
      } | null
    }> | null
    ScalisUserUploadedDocument?: Array<{
      __typename?: 'ScalisUserUploadedDocument'
      id: number
      documentPath?: string | null
      documentName?: string | null
      documentType: DocumentTypeEnum
      createdAt: any
    }> | null
  } | null
}

export type GetApplicationFormCountQueryVariables = Exact<{
  input: ListApplicationFormInput
}>

export type GetApplicationFormCountQuery = {
  __typename?: 'Query'
  CountApplicationForms: { __typename?: 'ApplicationFormsCount'; count: number }
}

export type GetApplicationFormQueryVariables = Exact<{
  input: GetApplicationFormInput
}>

export type GetApplicationFormQuery = {
  __typename?: 'Query'
  GetApplicationForm?: {
    __typename?: 'ApplicationForm'
    id: string
    name?: string | null
    companyId?: number | null
    companyDepartmentId?: number | null
    companyOfficeId?: number | null
    ApplicationFormScreeningQuestion?: Array<{
      __typename?: 'ApplicationFormScreeningQuestion'
      id: string
      screeningQuestionId?: number | null
      rankOrder?: number | null
      isActive?: boolean | null
      ScreeningQuestion?: {
        __typename?: 'ScreeningQuestion'
        id: string
        questionTitle?: string | null
        questionType?: QuestionTypeEnum | null
        questionDesc?: string | null
        isTemplateQuestion?: boolean | null
        isActiveGlobally?: boolean | null
        isRejectionQuestion?: boolean | null
        ansOptions?: string | null
        preferredAnswer?: string | null
        minVal?: number | null
        maxVal?: number | null
        valStatus?: string | null
      } | null
    }> | null
  } | null
}

export type ListApplicationFormScreeningQuestionsQueryVariables = Exact<{
  input: ListApplicationFormScreeningQuestionInput
}>

export type ListApplicationFormScreeningQuestionsQuery = {
  __typename?: 'Query'
  ListApplicationFormScreeningQuestions?: Array<{
    __typename?: 'ApplicationFormScreeningQuestion'
    id: string
    applicationFormId?: number | null
    screeningQuestionId?: number | null
    rankOrder?: number | null
    isActive?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    ApplicationForm?: {
      __typename?: 'ApplicationForm'
      id: string
      name?: string | null
      companyId?: number | null
    } | null
    ScreeningQuestion?: {
      __typename?: 'ScreeningQuestion'
      id: string
      questionTitle?: string | null
      questionType?: QuestionTypeEnum | null
      questionDesc?: string | null
      isTemplateQuestion?: boolean | null
      isActiveGlobally?: boolean | null
      isRejectionQuestion?: boolean | null
      ansOptions?: string | null
      preferredAnswer?: string | null
      minVal?: number | null
      maxVal?: number | null
      valStatus?: string | null
    } | null
  }> | null
}

export type ListApplicationFormsTitlesQueryVariables = Exact<{
  input: ListApplicationFormInput
}>

export type ListApplicationFormsTitlesQuery = {
  __typename?: 'Query'
  ListApplicationForms: {
    __typename?: 'PaginatedApplicationForms'
    items: Array<{
      __typename?: 'ApplicationForm'
      id: string
      name?: string | null
      companyId?: number | null
      companyDepartmentId?: number | null
      companyOfficeId?: number | null
    }>
  }
}

export type ListApplicationFormsQueryVariables = Exact<{
  input: ListApplicationFormInput
}>

export type ListApplicationFormsQuery = {
  __typename?: 'Query'
  ListApplicationForms: {
    __typename?: 'PaginatedApplicationForms'
    total: number
    items: Array<{
      __typename?: 'ApplicationForm'
      id: string
      name?: string | null
      companyId?: number | null
      companyDepartmentId?: number | null
      companyOfficeId?: number | null
      companyUserId?: number | null
      isArchived?: boolean | null
      isEdited?: boolean | null
      isDeleted?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            firstName?: string | null
            lastName?: string | null
            profileImage?: string | null
          } | null
        } | null
      } | null
      CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
      CompanyOffice?: { __typename?: 'CompanyOffice'; id: string } | null
      ApplicationFormScreeningQuestion?: Array<{
        __typename?: 'ApplicationFormScreeningQuestion'
        id: string
        screeningQuestionId?: number | null
        rankOrder?: number | null
        isActive?: boolean | null
        ScreeningQuestion?: {
          __typename?: 'ScreeningQuestion'
          id: string
          questionTitle?: string | null
          questionType?: QuestionTypeEnum | null
          questionDesc?: string | null
          isRejectionQuestion?: boolean | null
        } | null
      }> | null
    }>
  }
}

export type ApprovalWorkflowReviewerResponseMutationVariables = Exact<{
  input: ApprovalWorkflowReviewerResponseInput
}>

export type ApprovalWorkflowReviewerResponseMutation = {
  __typename?: 'Mutation'
  ApprovalWorkflowReviewerResponse: {
    __typename?: 'ApprovalWorkflowReviewerResponse'
    workflowVersionId: number
    stepId: number
    reviewerStatusId: number
    response: string
    workflowStatus: string
    stepStatus: string
  }
}

export type CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables = Exact<{
  input: CheckApprovalWorkflowRequirementWithOpeningDataInput
}>

export type CheckApprovalWorkflowRequirementWithOpeningDataQuery = {
  __typename?: 'Query'
  CheckApprovalWorkflowRequirementWithOpeningData: {
    __typename?: 'ApprovalWorkflowRequirementResponse'
    requiresApproval: boolean
    workflowId?: number | null
    matchingWorkflowIds?: Array<number> | null
    workflowSteps?: Array<{
      __typename?: 'ApprovalWorkflowStep'
      id: number
      rankOrder: number
      approvalStrictnessLevel: string
      finalStep: boolean
      reviewers: Array<{
        __typename?: 'ApprovalWorkflowReviewer'
        id: number
        companyUserId?: number | null
        companyUserGroupId?: number | null
        hiringTeamRole?: string | null
      }>
    }> | null
  }
}

export type ApprovalWorkflowStepFragment = {
  __typename?: 'ApprovalWorkflowStep'
  id: number
  rankOrder: number
  approvalStrictnessLevel: string
  finalStep: boolean
  reviewers: Array<{
    __typename?: 'ApprovalWorkflowReviewer'
    id: number
    companyUserId?: number | null
    companyUserGroupId?: number | null
    hiringTeamRole?: string | null
  }>
}

export type ApprovalWorkflowReviewerFragment = {
  __typename?: 'ApprovalWorkflowReviewer'
  id: number
  companyUserId?: number | null
  companyUserGroupId?: number | null
  hiringTeamRole?: string | null
}

export type CheckApprovalWorkflowRequirementQueryVariables = Exact<{
  input: CheckApprovalWorkflowRequirementInput
}>

export type CheckApprovalWorkflowRequirementQuery = {
  __typename?: 'Query'
  CheckApprovalWorkflowRequirement: {
    __typename?: 'ApprovalWorkflowRequirementResponse'
    requiresApproval: boolean
    workflowId?: number | null
    matchingWorkflowIds?: Array<number> | null
    workflowSteps?: Array<{
      __typename?: 'ApprovalWorkflowStep'
      id: number
      rankOrder: number
      approvalStrictnessLevel: string
      finalStep: boolean
      reviewers: Array<{
        __typename?: 'ApprovalWorkflowReviewer'
        id: number
        companyUserId?: number | null
        companyUserGroupId?: number | null
        hiringTeamRole?: string | null
      }>
    }> | null
  }
}

export type CreateApprovalWorkflowInstanceMutationVariables = Exact<{
  input: CreateApprovalWorkflowInstanceInput
}>

export type CreateApprovalWorkflowInstanceMutation = {
  __typename?: 'Mutation'
  CreateApprovalWorkflowInstance: { __typename?: 'ApprovalWorkflowInstanceResponse'; workflowVersionId: number }
}

export type CreateApprovalWorkflowSettingsMutationVariables = Exact<{
  input: CreateApprovalWorkflowSettingsInput
}>

export type CreateApprovalWorkflowSettingsMutation = {
  __typename?: 'Mutation'
  CreateApprovalWorkflowSettings?: {
    __typename?: 'CompanyApprovalSetting'
    id: string
    requireJobApproval: boolean
    requireOpeningApproval: boolean
    requireOfferApproval: boolean
    defaultJobApprovalWorkflowId?: number | null
    defaultOpeningApprovalWorkflowId?: number | null
    defaultOfferApprovalWorkflowId?: number | null
  } | null
}

export type CreateTemplateApprovalWorkflowMutationVariables = Exact<{
  input: CreateTemplateApprovalWorkflowInput
}>

export type CreateTemplateApprovalWorkflowMutation = {
  __typename?: 'Mutation'
  CreateTemplateApprovalWorkflow?: {
    __typename?: 'TemplateApprovalWorkflow'
    id: string
    name: string
    description?: any | null
    createdAt: any
    updatedAt: any
    approvalWorkflowType: ApprovalWorkflowTypeEnum
    approvalConditions: any
    isActive: boolean
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
          profileImage?: string | null
        } | null
      } | null
    }
    workflowSteps: Array<{
      __typename?: 'TemplateApprovalWorkflowStep'
      id: string
      rankOrder: number
      approvalStrictnessLevel: ApprovalStrictnessLevelEnum
      Reviewers: Array<{
        __typename?: 'TemplateApprovalReviewer'
        id: string
        hiringTeamRole?: RoleEnum | null
        CompanyUser?: {
          __typename?: 'CompanyUser'
          id: string
          UserInvitation?: {
            __typename?: 'UserInvitation'
            id: number
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              firstName?: string | null
              lastName?: string | null
              profileImage?: string | null
            } | null
          } | null
        } | null
        CompanyUserGroup?: { __typename?: 'CompanyUserGroup'; id: string; name: string } | null
      }>
    }>
  } | null
}

export type DeleteTemplateApprovalWorkflowMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteTemplateApprovalWorkflowMutation = {
  __typename?: 'Mutation'
  DeleteTemplateApprovalWorkflow?: {
    __typename?: 'TemplateApprovalWorkflow'
    id: string
    isDeleted: boolean
    isActive: boolean
  } | null
}

export type EditApprovalWorkflowInstanceMutationVariables = Exact<{
  input: EditApprovalWorkflowInstanceInput
}>

export type EditApprovalWorkflowInstanceMutation = {
  __typename?: 'Mutation'
  EditApprovalWorkflowInstance: { __typename?: 'ApprovalWorkflowInstanceResponse'; workflowVersionId: number }
}

export type EditApprovalWorkflowSettingsMutationVariables = Exact<{
  input: EditApprovalWorkflowSettingsInput
}>

export type EditApprovalWorkflowSettingsMutation = {
  __typename?: 'Mutation'
  EditApprovalWorkflowSettings?: {
    __typename?: 'CompanyApprovalSetting'
    id: string
    requireJobApproval: boolean
    requireOpeningApproval: boolean
    requireOfferApproval: boolean
    defaultJobApprovalWorkflowId?: number | null
    defaultOpeningApprovalWorkflowId?: number | null
    defaultOfferApprovalWorkflowId?: number | null
  } | null
}

export type EditTemplateApprovalWorkflowMutationVariables = Exact<{
  input: EditTemplateApprovalWorkflowInput
}>

export type EditTemplateApprovalWorkflowMutation = {
  __typename?: 'Mutation'
  EditTemplateApprovalWorkflow?: {
    __typename?: 'TemplateApprovalWorkflow'
    id: string
    name: string
    description?: any | null
    createdAt: any
    updatedAt: any
    approvalWorkflowType: ApprovalWorkflowTypeEnum
    approvalConditions: any
    isActive: boolean
    companyUser: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
          profileImage?: string | null
        } | null
      } | null
    }
    workflowSteps: Array<{
      __typename?: 'TemplateApprovalWorkflowStep'
      id: string
      rankOrder: number
      approvalStrictnessLevel: ApprovalStrictnessLevelEnum
      Reviewers: Array<{
        __typename?: 'TemplateApprovalReviewer'
        id: string
        hiringTeamRole?: RoleEnum | null
        CompanyUser?: {
          __typename?: 'CompanyUser'
          id: string
          UserInvitation?: {
            __typename?: 'UserInvitation'
            id: number
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              firstName?: string | null
              lastName?: string | null
              profileImage?: string | null
            } | null
          } | null
        } | null
        CompanyUserGroup?: { __typename?: 'CompanyUserGroup'; id: string; name: string } | null
      }>
    }>
  } | null
}

export type GetApprovalWorkflowInstanceQueryVariables = Exact<{
  input: GetApprovalWorkflowInstanceInput
}>

export type GetApprovalWorkflowInstanceQuery = {
  __typename?: 'Query'
  GetApprovalWorkflowInstance?: {
    __typename?: 'ApprovalWorkflowInstanceDetails'
    workflowVersionId: number
    externalId: string
    version: number
    status: string
    createdAt: any
    updatedAt: any
    canRespondToAnyStep: boolean
    steps: Array<{
      __typename?: 'ApprovalWorkflowInstanceStep'
      id: number
      approvalWorkflowVersionId: number
      rankOrder: number
      approvalStepStatus: ApprovalWorkflowStatusEnum
      approvalStrictnessLevel: string
      finalStep: boolean
      createdAt: any
      updatedAt: any
      canRespond: boolean
      reviewers: Array<{
        __typename?: 'ApprovalWorkflowInstanceStepReviewer'
        id: number
        status: string
        companyUserId?: number | null
        hiringTeamRole?: string | null
        companyUserGroupId?: number | null
        respondedToBy?: number | null
        comments?: string | null
        respondedAt?: any | null
        canRespond: boolean
      }>
    }>
  } | null
}

export type ApprovalWorkflowInstanceStepFragment = {
  __typename?: 'ApprovalWorkflowInstanceStep'
  id: number
  approvalWorkflowVersionId: number
  rankOrder: number
  approvalStepStatus: ApprovalWorkflowStatusEnum
  approvalStrictnessLevel: string
  finalStep: boolean
  createdAt: any
  updatedAt: any
  canRespond: boolean
  reviewers: Array<{
    __typename?: 'ApprovalWorkflowInstanceStepReviewer'
    id: number
    status: string
    companyUserId?: number | null
    hiringTeamRole?: string | null
    companyUserGroupId?: number | null
    respondedToBy?: number | null
    comments?: string | null
    respondedAt?: any | null
    canRespond: boolean
  }>
}

export type ApprovalWorkflowInstanceStepReviewerFragment = {
  __typename?: 'ApprovalWorkflowInstanceStepReviewer'
  id: number
  status: string
  companyUserId?: number | null
  hiringTeamRole?: string | null
  companyUserGroupId?: number | null
  respondedToBy?: number | null
  comments?: string | null
  respondedAt?: any | null
  canRespond: boolean
}

export type GetApprovalWorkflowSettingsQueryVariables = Exact<{ [key: string]: never }>

export type GetApprovalWorkflowSettingsQuery = {
  __typename?: 'Query'
  GetApprovalWorkflowSettings?: {
    __typename?: 'CompanyApprovalSetting'
    id: string
    requireJobApproval: boolean
    requireOpeningApproval: boolean
    requireOfferApproval: boolean
    defaultJobApprovalWorkflowId?: number | null
    defaultOpeningApprovalWorkflowId?: number | null
    defaultOfferApprovalWorkflowId?: number | null
    defaultJobApprovalWorkflow?: {
      __typename?: 'TemplateApprovalWorkflow'
      id: string
      approvalWorkflowType: ApprovalWorkflowTypeEnum
      approvalConditions: any
      isActive: boolean
    } | null
    defaultOpeningApprovalWorkflow?: {
      __typename?: 'TemplateApprovalWorkflow'
      id: string
      approvalWorkflowType: ApprovalWorkflowTypeEnum
      approvalConditions: any
      isActive: boolean
    } | null
    defaultOfferApprovalWorkflow?: {
      __typename?: 'TemplateApprovalWorkflow'
      id: string
      approvalWorkflowType: ApprovalWorkflowTypeEnum
      approvalConditions: any
      isActive: boolean
    } | null
  } | null
}

export type ListTemplateApprovalWorkflowsQueryVariables = Exact<{
  input: ListTemplateApprovalWorkflowsInput
}>

export type ListTemplateApprovalWorkflowsQuery = {
  __typename?: 'Query'
  ListTemplateApprovalWorkflows: {
    __typename?: 'PaginatedTemplateApprovalWorkflows'
    total: number
    items: Array<{
      __typename?: 'TemplateApprovalWorkflow'
      id: string
      name: string
      description?: any | null
      createdAt: any
      updatedAt: any
      approvalWorkflowType: ApprovalWorkflowTypeEnum
      approvalConditions: any
      isActive: boolean
      companyUser: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
            profileImage?: string | null
          } | null
        } | null
      }
      workflowSteps: Array<{
        __typename?: 'TemplateApprovalWorkflowStep'
        id: string
        rankOrder: number
        finalStep: boolean
        approvalStrictnessLevel: ApprovalStrictnessLevelEnum
        Reviewers: Array<{
          __typename?: 'TemplateApprovalReviewer'
          id: string
          hiringTeamRole?: RoleEnum | null
          CompanyUser?: {
            __typename?: 'CompanyUser'
            id: string
            UserInvitation?: {
              __typename?: 'UserInvitation'
              id: number
              ScalisUser?: {
                __typename?: 'ScalisUser'
                id: number
                firstName?: string | null
                lastName?: string | null
                profileImage?: string | null
              } | null
            } | null
          } | null
          CompanyUserGroup?: { __typename?: 'CompanyUserGroup'; id: string; name: string } | null
        }>
      }>
    }>
  }
}

export type CompanyUserInfoFragment = {
  __typename?: 'CompanyUser'
  id: string
  UserInvitation?: {
    __typename?: 'UserInvitation'
    id: number
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  } | null
}

export type ToggleTemplateApprovalWorkflowStatusMutationVariables = Exact<{
  input: ToggleTemplateApprovalWorkflowStatusInput
}>

export type ToggleTemplateApprovalWorkflowStatusMutation = {
  __typename?: 'Mutation'
  ToggleTemplateApprovalWorkflowStatus?: {
    __typename?: 'TemplateApprovalWorkflow'
    id: string
    isActive: boolean
    updatedAt: any
  } | null
}

export type GetCalendarSettingsQueryVariables = Exact<{ [key: string]: never }>

export type GetCalendarSettingsQuery = {
  __typename?: 'Query'
  GetCalendarSettings?: {
    __typename?: 'CalendarSettings'
    id: string
    availability?: any | null
    provider: string
    timeZone?: string | null
    hourDisplay: number
    email: string
    companyUserId: number
    nylasGrantId: string
    Calendars?: Array<{
      __typename?: 'Calendar'
      id: string
      nylasCalendarId: string
      calendarSettingsId: number
      name: string
      isPrimary: boolean
      color?: string | null
      CalendarEvents?: Array<{
        __typename?: 'CalendarEvent'
        id: string
        nylasEventStatus?: NylasEventStatusesEnum | null
        nylasCalendarEventId?: string | null
        title?: string | null
        eventType?: EventTypeEnum | null
        description?: string | null
        startTime?: any | null
        endTime?: any | null
        timeZone?: string | null
        location?: string | null
        repeats?: RepeatsEnum | null
        reminders?: any | null
        employers?: any | null
        conferencing?: any | null
        masterEventId?: string | null
        regardingCandidates?: any | null
        regardingJobs?: any | null
        internalGuests?: any | null
        candidates?: any | null
        isScalisEvent?: boolean | null
      }> | null
    }> | null
  } | null
}

export type GetCandidateApplicationByListingQueryVariables = Exact<{
  candidateProfileId: Scalars['Int']['input']
  publicListingId: Scalars['String']['input']
}>

export type GetCandidateApplicationByListingQuery = {
  __typename?: 'Query'
  GetCandidateApplication?: Array<{
    __typename?: 'CandidateApplication'
    id: string
    candidateProfileId?: number | null
    JobListing?: {
      __typename?: 'JobListing'
      id: number
      Requisition?: { __typename?: 'Requisition'; id: string; jobName?: string | null } | null
    } | null
  }> | null
}

export type GetApplicationOverviewQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetApplicationOverviewQuery = {
  __typename?: 'Query'
  GetCandidateApplication?: Array<{
    __typename?: 'CandidateApplication'
    id: string
    applicationStatus?: ApplicationStatusEnum | null
    appliedAt?: any | null
    applicationType?: string | null
    Company?: {
      __typename?: 'Company'
      Address: Array<{ __typename?: 'Address'; city?: string | null; state?: string | null; country?: string | null }>
      CompanyInfo?: { __typename?: 'CompanyInfo'; companyName?: string | null; logo?: string | null } | null
    } | null
    JobListing?: {
      __typename?: 'JobListing'
      externalListingId?: string | null
      externalTitle?: string | null
      publicListingId?: string | null
      id: number
      jobRequisitionId?: number | null
      stateAndOrCountry?: string | null
      workplaceType?: WorkplaceTypeEnum | null
      Requisition?: {
        __typename?: 'Requisition'
        id: string
        jobName?: string | null
        extRequisitionId?: string | null
      } | null
      Address?: Array<{
        __typename?: 'Address'
        timeZone?: string | null
        state?: string | null
        longitude?: string | null
        latitude?: string | null
        country?: string | null
        activeStatus?: boolean | null
        addressLine1?: string | null
        addressLine2?: string | null
        addressType?: string | null
        city?: string | null
        postalCode?: string | null
      }> | null
    } | null
    LastPublicTemplateStage?: {
      __typename?: 'TemplateStage'
      id: string
      name?: string | null
      TemplateMilestone?: { __typename?: 'TemplateMilestone'; name?: NameEnum | null } | null
    } | null
    TemplateStage?: {
      __typename?: 'TemplateStage'
      id: string
      name?: string | null
      visibility?: TemplateStageVisibilityEnum | null
      TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
      TemplatePipeline?: {
        __typename?: 'TemplatePipeline'
        TemplateMilestones?: Array<{
          __typename?: 'TemplateMilestone'
          id: string
          name?: NameEnum | null
          rankOrder?: number | null
          TemplateStage?: Array<{
            __typename?: 'TemplateStage'
            name?: string | null
            id: string
            rankOrder?: number | null
            visibility?: TemplateStageVisibilityEnum | null
          }> | null
        }> | null
      } | null
    } | null
    CandidateInterview?: Array<{
      __typename?: 'CandidateInterview'
      stageId?: number | null
      interviewData?: any | null
      id: string
      status?: CandidateInterviewStatusEnum | null
      companyUserId?: number | null
      applicationId?: number | null
      CalendarEvent: Array<{
        __typename?: 'CalendarEvent'
        title?: string | null
        timeZone?: string | null
        startTime?: any | null
        repeats?: RepeatsEnum | null
        reminders?: any | null
        regardingJobs?: any | null
        regardingCandidates?: any | null
        nylasEventStatus?: NylasEventStatusesEnum | null
        nylasCalendarEventId?: string | null
        masterEventId?: string | null
        location?: string | null
        isScalisEvent?: boolean | null
        internalGuests?: any | null
        id: string
        eventType?: EventTypeEnum | null
        employers?: any | null
        endTime?: any | null
        description?: string | null
        conferencing?: any | null
        companyUserId?: number | null
        candidates?: any | null
        calendarId?: number | null
        EventAttachments?: Array<{
          __typename?: 'EventAttachment'
          id: string
          file?: string | null
          eventId: number
        }> | null
        Calendar?: { __typename?: 'Calendar'; name: string; id: string; isPrimary: boolean } | null
        CompanyUser?: {
          __typename?: 'CompanyUser'
          UserInvitation?: {
            __typename?: 'UserInvitation'
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              activeStatus?: boolean | null
              profileImage?: string | null
              firstName?: string | null
              lastName?: string | null
            } | null
          } | null
        } | null
      }>
    }> | null
    ApplicantNotes?: Array<{
      __typename?: 'ApplicantNotes'
      userNoteId?: number | null
      id: string
      candidateApplicationId?: number | null
      updatedAt?: any | null
      UserNote?: { __typename?: 'UserNote'; id: string; noteText?: any | null } | null
    }> | null
    SchedulerLinkInvite?: Array<{
      __typename?: 'SchedulerLinkInvite'
      stageId: number
      nylasConfigurationId: string
      message?: string | null
      interviewData?: any | null
      id: string
      durationMinutes?: number | null
      companyUserId: number
      candidateData?: any | null
      calendarId: number
      applicationId: number
      TemplateStage?: {
        __typename?: 'TemplateStage'
        name?: string | null
        id: string
        rankOrder?: number | null
      } | null
    }> | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }> | null
}

export type GetCandidatesApplicationsByStageQueryVariables = Exact<{
  milestoneNotIn?: InputMaybe<Array<NameEnum> | NameEnum>
  milestoneIn?: InputMaybe<Array<NameEnum> | NameEnum>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}>

export type GetCandidatesApplicationsByStageQuery = {
  __typename?: 'Query'
  GetTemplateStage?: Array<{
    __typename?: 'TemplateStage'
    id: string
    CandidateApplicationByStage?: Array<{
      __typename?: 'CandidateApplication'
      id: string
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          linkedinProfile?: string | null
          lastName?: string | null
          firstName?: string | null
          emailAddress?: string | null
          companyUserId?: number | null
          companyId?: number | null
          profileImage?: string | null
          profileUrl?: string | null
          uploadedCandidateType?: UploadedCandidateTypeEnum | null
          CandidateProfile?: {
            __typename?: 'CandidateProfile'
            id: string
            profileType: ProfileTypeEnum
            CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
          } | null
          UploadedCandidateWebsiteOrSocialMedia: Array<{
            __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
            id: number
            websiteURL: string
            type: WebsiteTypeEnum
          }>
          UploadedCandidateAchievement: Array<{
            __typename?: 'UploadedCandidateAchievement'
            id: number
            name?: string | null
            issuingAuthority?: string | null
            issueYear?: number | null
            description?: any | null
            searchDescription?: string | null
          }>
          UploadedCandidateCertificateOrLicense: Array<{
            __typename?: 'UploadedCandidateCertificateOrLicense'
            id: number
            name?: string | null
            issuingAuthority?: string | null
            issueYear?: number | null
            description?: any | null
            searchDescription?: string | null
          }>
          UploadedCandidateEducation?: Array<{
            __typename?: 'UploadedCandidateEducation'
            id: number
            institutionName?: string | null
            currentlyStudying?: boolean | null
            educationLevel?: EducationLevelEnum | null
            startDate?: any | null
            endDate?: any | null
            areasOfStudy?: any | null
            majors?: any | null
            minors?: any | null
            cumGPA?: number | null
            cumGPAScale?: number | null
            hideCumGPA?: boolean | null
            hideDepartmentGPA?: boolean | null
            departmentCumGPA?: number | null
            departmentCumGPAScale?: number | null
            additionalInformation?: string | null
          }> | null
          highestEducation?: Array<{
            __typename?: 'UploadedCandidateEducation'
            id: number
            institutionName?: string | null
            currentlyStudying?: boolean | null
            educationLevel?: EducationLevelEnum | null
            startDate?: any | null
            endDate?: any | null
            areasOfStudy?: any | null
            majors?: any | null
            minors?: any | null
            cumGPA?: number | null
            cumGPAScale?: number | null
            hideCumGPA?: boolean | null
            hideDepartmentGPA?: boolean | null
            departmentCumGPA?: number | null
            departmentCumGPAScale?: number | null
            additionalInformation?: string | null
          }> | null
          UploadedCandidateExperience?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            startDate?: any | null
            endDate?: any | null
            companyLogo?: string | null
            locationType?: string | null
            location?: string | null
            shortFormDesc?: any | null
            longFormDesc?: string | null
            searchShortFormDesc?: string | null
            searchLongFormDesc?: string | null
            industry?: IndustryEnum | null
            subIndustry?: string | null
            payType?: string | null
            jobPay?: number | null
            additionalComp?: boolean | null
            jobTitle?: string | null
            employerName?: string | null
            managementPosition?: boolean | null
            teamSize?: TeamSizeEnum | null
            workPlaceCandidate?: WorkPlaceCandidateEnum | null
            isCurrentJob?: boolean | null
            jobType?: JobTypeEnum | null
            isCurrentlyWorking?: boolean | null
            description?: string | null
          }> | null
          ExperienceTenure?: {
            __typename?: 'experienceTenure'
            average: number
            longest: number
            shortest: number
          } | null
          currentJob?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            startDate?: any | null
            endDate?: any | null
            companyLogo?: string | null
            locationType?: string | null
            location?: string | null
            shortFormDesc?: any | null
            longFormDesc?: string | null
            searchShortFormDesc?: string | null
            searchLongFormDesc?: string | null
            industry?: IndustryEnum | null
            subIndustry?: string | null
            payType?: string | null
            jobPay?: number | null
            additionalComp?: boolean | null
            jobTitle?: string | null
            employerName?: string | null
            managementPosition?: boolean | null
            teamSize?: TeamSizeEnum | null
            workPlaceCandidate?: WorkPlaceCandidateEnum | null
            isCurrentJob?: boolean | null
            jobType?: JobTypeEnum | null
            isCurrentlyWorking?: boolean | null
            description?: string | null
          }> | null
          mostRecentJob?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            startDate?: any | null
            endDate?: any | null
            companyLogo?: string | null
            locationType?: string | null
            location?: string | null
            shortFormDesc?: any | null
            longFormDesc?: string | null
            searchShortFormDesc?: string | null
            searchLongFormDesc?: string | null
            industry?: IndustryEnum | null
            subIndustry?: string | null
            payType?: string | null
            jobPay?: number | null
            additionalComp?: boolean | null
            jobTitle?: string | null
            employerName?: string | null
            managementPosition?: boolean | null
            teamSize?: TeamSizeEnum | null
            workPlaceCandidate?: WorkPlaceCandidateEnum | null
            isCurrentJob?: boolean | null
            jobType?: JobTypeEnum | null
            isCurrentlyWorking?: boolean | null
            description?: string | null
          }> | null
          UploadedCandidateJobSeekerSkill?: Array<{
            __typename?: 'UploadedCandidateJobSeekerSkills'
            id: number
            sequenceNumber?: number | null
            level?: string | null
            name?: string | null
            yearsOfExp?: number | null
          }> | null
          UploadedCandidateVolunteerWork: Array<{
            __typename?: 'UploadedCandidateVolunteerWork'
            id: number
            volunteerJobTitle?: string | null
            organizationName?: string | null
            isCurrentlyWorking?: boolean | null
            roleType?: RoleTypeEnum | null
            startDate?: any | null
            endDate?: any | null
            description?: any | null
            searchDescription?: string | null
            location?: string | null
          }>
          EnrichedEmail: Array<{
            __typename?: 'EnrichedEmail'
            id: string
            emailAddress?: string | null
            enrichedEmailType?: EnrichedEmailTypeEnum | null
            uploadedCandidateId?: number | null
            recommended?: boolean | null
          }>
          EnrichedPhoneNumber: Array<{
            __typename?: 'EnrichedPhoneNumber'
            id: string
            phoneNumber?: string | null
            uploadedCandidateId?: number | null
            recommended?: boolean | null
          }>
        } | null
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          lastName?: string | null
          firstName?: string | null
          EmailVerification?: Array<{
            __typename?: 'EmailVerification'
            id: number
            isVisibleToEmployers?: boolean | null
            isPrimary?: boolean | null
            emailAddress?: string | null
          }> | null
        } | null
      } | null
    }> | null
  }> | null
}

export type GetRejectCandidateQuestionsQueryVariables = Exact<{ [key: string]: never }>

export type GetRejectCandidateQuestionsQuery = {
  __typename?: 'Query'
  GetRejectCandidateQuestions?: Array<{
    __typename?: 'RejectCandidateQuestion'
    sequence?: number | null
    required?: boolean | null
    question?: string | null
    id: number
  }> | null
}

export type SearchCandidatesFilterContentQueryVariables = Exact<{
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  publicListingId?: InputMaybe<Scalars['String']['input']>
  filterType: FilterContentTypeEnum
  search: Scalars['String']['input']
}>

export type SearchCandidatesFilterContentQuery = {
  __typename?: 'Query'
  SearchCandidatesFilterContent: {
    __typename?: 'SearchCandidatesFilterContentOutput'
    filterContent?: Array<{ __typename?: 'filterContentItem'; value: string; id?: number | null }> | null
  }
}

export type GetCandidateCollaboratorQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetCandidateCollaboratorQuery = {
  __typename?: 'Query'
  GetCandidateCollaborator?: {
    __typename?: 'CandidateCollaborator'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    requisitionId?: number | null
    companyUserId?: number | null
    candidateProfileId?: number | null
    roleId?: number | null
    requisitionJobDescriptionId?: number | null
    role?: { __typename?: 'Role'; id: string; name: string } | null
  } | null
}

export type ListCandidateEmailsQueryVariables = Exact<{
  input: ListCandidateEmailsInput
}>

export type ListCandidateEmailsQuery = {
  __typename?: 'Query'
  ListCandidateEmails: Array<{
    __typename?: 'CandidateEmail'
    email: string
    source: CandidateEmailSource
    isPrimary: boolean
    isVerified?: boolean | null
    createdAt?: any | null
  }>
}

export type GetCandidateFiltersQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCandidateFiltersQuery = {
  __typename?: 'Query'
  GetCandidateFilter?: Array<{ __typename?: 'CandidateFilter'; id: string; name: string; filters: any }> | null
}

export type GetCandidateLabelsQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetCandidateLabelsQuery = {
  __typename?: 'Query'
  GetOneCandidateProfile?: {
    __typename?: 'CandidateProfile'
    id: string
    CandidateLabels?: Array<{
      __typename?: 'CandidateLabel'
      id: string
      colorNumber: number
      labelName: string
    }> | null
  } | null
}

export type ListCandidateLabelsQueryVariables = Exact<{
  input: ListCandidateLabelsInput
}>

export type ListCandidateLabelsQuery = {
  __typename?: 'Query'
  ListCandidateLabels: {
    __typename?: 'PaginatedCandidateLabels'
    total: number
    items: Array<{
      __typename?: 'CandidateLabel'
      id: string
      labelName: string
      colorNumber: number
      companyId: number
      companyUserId: number
      createdAt: any
      updatedAt: any
      candidateProfilesCount: number
      company: { __typename?: 'Company'; id: string }
      companyUser: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          email?: string | null
          ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
        } | null
      }
    }>
  }
}

export type GetCandidateInterviewsProfileApplicationFragment = {
  __typename?: 'CandidateApplication'
  viewedProfile?: boolean | null
  viewedAt?: any | null
  templateStageId?: number | null
  matchScore?: number | null
  lastUpdatedStatusAt?: any | null
  jobListingId?: number | null
  interviewScheduling?: InterviewSchedulingEnum | null
  id: string
  deleted?: any | null
  createdAt?: any | null
  companyId?: number | null
  candidateProfileId?: number | null
  appliedAt?: any | null
  applicationType?: string | null
  applicationTimestamp?: any | null
  applicationCreationType?: string | null
  applicationStatus?: ApplicationStatusEnum | null
  CandidateInterview?: Array<{
    __typename?: 'CandidateInterview'
    stageId?: number | null
    interviewData?: any | null
    id: string
    status?: CandidateInterviewStatusEnum | null
    companyUserId?: number | null
    applicationId?: number | null
    integrationsNylasNotetakerId?: number | null
    CalendarEvent: Array<{
      __typename?: 'CalendarEvent'
      title?: string | null
      timeZone?: string | null
      startTime?: any | null
      repeats?: RepeatsEnum | null
      reminders?: any | null
      regardingJobs?: any | null
      regardingCandidates?: any | null
      nylasEventStatus?: NylasEventStatusesEnum | null
      nylasCalendarEventId?: string | null
      masterEventId?: string | null
      location?: string | null
      isScalisEvent?: boolean | null
      internalGuests?: any | null
      id: string
      eventType?: EventTypeEnum | null
      employers?: any | null
      endTime?: any | null
      description?: string | null
      conferencing?: any | null
      companyUserId?: number | null
      candidates?: any | null
      calendarId?: number | null
      EventAttachments?: Array<{
        __typename?: 'EventAttachment'
        id: string
        file?: string | null
        eventId: number
      }> | null
      Calendar?: { __typename?: 'Calendar'; name: string; id: string; isPrimary: boolean } | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
    }>
  }> | null
  TemplateStage?: {
    __typename?: 'TemplateStage'
    id: string
    name?: string | null
    visibility?: TemplateStageVisibilityEnum | null
    TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
    TemplatePipeline?: {
      __typename?: 'TemplatePipeline'
      id: string
      TemplateMilestones?: Array<{
        __typename?: 'TemplateMilestone'
        id: string
        name?: NameEnum | null
        rankOrder?: number | null
        TemplateStage?: Array<{
          __typename?: 'TemplateStage'
          name?: string | null
          id: string
          rankOrder?: number | null
          visibility?: TemplateStageVisibilityEnum | null
        }> | null
      }> | null
    } | null
  } | null
  JobListing?: {
    __typename?: 'JobListing'
    externalListingId?: string | null
    externalTitle?: string | null
    publicListingId?: string | null
    id: number
    jobRequisitionId?: number | null
    stateAndOrCountry?: string | null
    workplaceType?: WorkplaceTypeEnum | null
    Requisition?: {
      __typename?: 'Requisition'
      id: string
      jobName?: string | null
      extRequisitionId?: string | null
    } | null
    Address?: Array<{
      __typename?: 'Address'
      id: number
      timeZone?: string | null
      state?: string | null
      longitude?: string | null
      latitude?: string | null
      country?: string | null
      activeStatus?: boolean | null
      addressLine1?: string | null
      addressLine2?: string | null
      addressType?: string | null
      city?: string | null
      postalCode?: string | null
    }> | null
  } | null
  CandidateScorecard?: Array<{
    __typename?: 'CandidateScorecard'
    id: string
    status?: ScorecardStatusTypeEnum | null
    templateStageId?: number | null
    companyUserId?: number | null
    ScorecardTemplate?: { __typename?: 'ScorecardTemplate'; id: string; scorecardName?: string | null } | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
  }> | null
}

export type GetCandidateInterviewsQueryVariables = Exact<{
  candidateProfileId: Scalars['Int']['input']
}>

export type GetCandidateInterviewsQuery = {
  __typename?: 'Query'
  GetOneCandidateProfile?: {
    __typename?: 'CandidateProfile'
    CandidateApplication: Array<{
      __typename?: 'CandidateApplication'
      viewedProfile?: boolean | null
      viewedAt?: any | null
      templateStageId?: number | null
      matchScore?: number | null
      lastUpdatedStatusAt?: any | null
      jobListingId?: number | null
      interviewScheduling?: InterviewSchedulingEnum | null
      id: string
      deleted?: any | null
      createdAt?: any | null
      companyId?: number | null
      candidateProfileId?: number | null
      appliedAt?: any | null
      applicationType?: string | null
      applicationTimestamp?: any | null
      applicationCreationType?: string | null
      applicationStatus?: ApplicationStatusEnum | null
      CandidateInterview?: Array<{
        __typename?: 'CandidateInterview'
        stageId?: number | null
        interviewData?: any | null
        id: string
        status?: CandidateInterviewStatusEnum | null
        companyUserId?: number | null
        applicationId?: number | null
        integrationsNylasNotetakerId?: number | null
        CalendarEvent: Array<{
          __typename?: 'CalendarEvent'
          title?: string | null
          timeZone?: string | null
          startTime?: any | null
          repeats?: RepeatsEnum | null
          reminders?: any | null
          regardingJobs?: any | null
          regardingCandidates?: any | null
          nylasEventStatus?: NylasEventStatusesEnum | null
          nylasCalendarEventId?: string | null
          masterEventId?: string | null
          location?: string | null
          isScalisEvent?: boolean | null
          internalGuests?: any | null
          id: string
          eventType?: EventTypeEnum | null
          employers?: any | null
          endTime?: any | null
          description?: string | null
          conferencing?: any | null
          companyUserId?: number | null
          candidates?: any | null
          calendarId?: number | null
          EventAttachments?: Array<{
            __typename?: 'EventAttachment'
            id: string
            file?: string | null
            eventId: number
          }> | null
          Calendar?: { __typename?: 'Calendar'; name: string; id: string; isPrimary: boolean } | null
          CompanyUser?: {
            __typename?: 'CompanyUser'
            id: string
            UserInvitation?: {
              __typename?: 'UserInvitation'
              id: number
              ScalisUser?: {
                __typename?: 'ScalisUser'
                id: number
                activeStatus?: boolean | null
                profileImage?: string | null
                firstName?: string | null
                lastName?: string | null
              } | null
            } | null
          } | null
        }>
      }> | null
      TemplateStage?: {
        __typename?: 'TemplateStage'
        id: string
        name?: string | null
        visibility?: TemplateStageVisibilityEnum | null
        TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
        TemplatePipeline?: {
          __typename?: 'TemplatePipeline'
          id: string
          TemplateMilestones?: Array<{
            __typename?: 'TemplateMilestone'
            id: string
            name?: NameEnum | null
            rankOrder?: number | null
            TemplateStage?: Array<{
              __typename?: 'TemplateStage'
              name?: string | null
              id: string
              rankOrder?: number | null
              visibility?: TemplateStageVisibilityEnum | null
            }> | null
          }> | null
        } | null
      } | null
      JobListing?: {
        __typename?: 'JobListing'
        externalListingId?: string | null
        externalTitle?: string | null
        publicListingId?: string | null
        id: number
        jobRequisitionId?: number | null
        stateAndOrCountry?: string | null
        workplaceType?: WorkplaceTypeEnum | null
        Requisition?: {
          __typename?: 'Requisition'
          id: string
          jobName?: string | null
          extRequisitionId?: string | null
        } | null
        Address?: Array<{
          __typename?: 'Address'
          id: number
          timeZone?: string | null
          state?: string | null
          longitude?: string | null
          latitude?: string | null
          country?: string | null
          activeStatus?: boolean | null
          addressLine1?: string | null
          addressLine2?: string | null
          addressType?: string | null
          city?: string | null
          postalCode?: string | null
        }> | null
      } | null
      CandidateScorecard?: Array<{
        __typename?: 'CandidateScorecard'
        id: string
        status?: ScorecardStatusTypeEnum | null
        templateStageId?: number | null
        companyUserId?: number | null
        ScorecardTemplate?: { __typename?: 'ScorecardTemplate'; id: string; scorecardName?: string | null } | null
        CompanyUser?: {
          __typename?: 'CompanyUser'
          id: string
          UserInvitation?: {
            __typename?: 'UserInvitation'
            id: number
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              activeStatus?: boolean | null
              profileImage?: string | null
              firstName?: string | null
              lastName?: string | null
            } | null
          } | null
        } | null
      }> | null
    }>
  } | null
}

export type GetCandidateProfilesQueryVariables = Exact<{
  candidateProfileIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  applicationFilters?: InputMaybe<ApplicationFiltersOnCandidateProfile>
}>

export type GetCandidateProfilesQuery = {
  __typename?: 'Query'
  GetCandidateProfile?: Array<{
    __typename?: 'CandidateProfile'
    id: string
    uploadedCandidateId?: number | null
    scalisUserId?: number | null
    profileType: ProfileTypeEnum
    primaryEmail?: string | null
    CustomCandidateProfileFieldValues?: Array<{
      __typename?: 'CustomCandidateProfileFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateProfileField?: {
        __typename?: 'CustomCandidateProfileField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }> | null
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      activeStatus?: boolean | null
      profileImage?: string | null
      firstName?: string | null
      lastName?: string | null
      Experience?: Array<{
        __typename?: 'Experience'
        id: number
        employerName?: string | null
        isCurrentlyWorking?: boolean | null
        isCurrentJob?: boolean | null
        jobTitle?: string | null
      }> | null
      Education?: Array<{
        __typename?: 'Education'
        id: number
        educationLevel?: EducationLevelEnum | null
        institutionName?: string | null
      }> | null
      ContactInfo?: Array<{ __typename?: 'ContactInfo'; phoneNumber?: string | null; id: number }> | null
      EmailVerification?: Array<{
        __typename?: 'EmailVerification'
        isVisibleToEmployers?: boolean | null
        isPrimary?: boolean | null
        emailVerified?: boolean | null
        id: number
        emailAddress?: string | null
        activeStatus?: boolean | null
      }> | null
    } | null
    UploadedCandidate?: {
      __typename?: 'UploadedCandidate'
      id: number
      linkedinProfile?: string | null
      lastName?: string | null
      firstName?: string | null
      emailAddress?: string | null
      companyUserId?: number | null
      companyId?: number | null
      profileImage?: string | null
      profileUrl?: string | null
      uploadedCandidateType?: UploadedCandidateTypeEnum | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        profileType: ProfileTypeEnum
        CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
      } | null
      UploadedCandidateWebsiteOrSocialMedia: Array<{
        __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
        id: number
        websiteURL: string
        type: WebsiteTypeEnum
      }>
      UploadedCandidateAchievement: Array<{
        __typename?: 'UploadedCandidateAchievement'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateCertificateOrLicense: Array<{
        __typename?: 'UploadedCandidateCertificateOrLicense'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      highestEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      UploadedCandidateExperience?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
      currentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      mostRecentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      UploadedCandidateJobSeekerSkill?: Array<{
        __typename?: 'UploadedCandidateJobSeekerSkills'
        id: number
        sequenceNumber?: number | null
        level?: string | null
        name?: string | null
        yearsOfExp?: number | null
      }> | null
      UploadedCandidateVolunteerWork: Array<{
        __typename?: 'UploadedCandidateVolunteerWork'
        id: number
        volunteerJobTitle?: string | null
        organizationName?: string | null
        isCurrentlyWorking?: boolean | null
        roleType?: RoleTypeEnum | null
        startDate?: any | null
        endDate?: any | null
        description?: any | null
        searchDescription?: string | null
        location?: string | null
      }>
      EnrichedEmail: Array<{
        __typename?: 'EnrichedEmail'
        id: string
        emailAddress?: string | null
        enrichedEmailType?: EnrichedEmailTypeEnum | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
      EnrichedPhoneNumber: Array<{
        __typename?: 'EnrichedPhoneNumber'
        id: string
        phoneNumber?: string | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
    } | null
    CandidateApplication: Array<{
      __typename?: 'CandidateApplication'
      id: string
      matchScore?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      applicationType?: string | null
      applicationCreationType?: string | null
      updatedAt?: any | null
      appliedAt?: any | null
      lastUpdatedStatusAt?: any | null
      templateStageId?: number | null
      jobListingId?: number | null
      averageRating?: number | null
      lastActivityDate?: any | null
      duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
    }>
  }> | null
}

export type GetCandidateStatsQueryVariables = Exact<{
  jobListingId: Scalars['String']['input']
  candidateProfileId: Scalars['Int']['input']
}>

export type GetCandidateStatsQuery = {
  __typename?: 'Query'
  GetCandidateStats?: {
    __typename?: 'CandidateStats'
    skillsMatched?: number | null
    screeningQuestions?: string | null
    matchPercentage?: number | null
    experience?: string | null
    distance?: string | null
    opportunity?: {
      __typename?: 'CandidateStatsOpportunity'
      candidateApplicationId?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      customApplicationStatusId?: number | null
      customStatusIconType?: string | null
      customStatusIconUnicode?: string | null
      customStatusColorHexCode?: string | null
      customApplicationStatusName?: string | null
      appliedAt?: string | null
      currentStageId?: number | null
      jobListingId?: string | null
      jobListingTitle?: string | null
      lastUpdatedStatusAt?: string | null
      location?: string | null
      milestoneType?: NameEnum | null
      duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
      requisitionId?: string | null
      internalRequisitionId?: number | null
      requisitionJobName?: string | null
      stageName?: string | null
      stages: Array<{ __typename?: 'CandidateStatsOpportunityStage'; id: number; name: string }>
    } | null
  } | null
}

export type GetCompanyUsersUploadCandidateQueryVariables = Exact<{ [key: string]: never }>

export type GetCompanyUsersUploadCandidateQuery = {
  __typename?: 'Query'
  GetCompanyUsers?: Array<{
    __typename?: 'CompanyUser'
    id: string
    companyUserStatus?: CompanyUserStatusEnum | null
    UserInvitation?: {
      __typename?: 'UserInvitation'
      id: number
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        firstName?: string | null
        lastName?: string | null
        activeStatus?: boolean | null
      } | null
    } | null
  }> | null
}

export type GetOneCandidateProfileQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetOneCandidateProfileQuery = {
  __typename?: 'Query'
  GetOneCandidateProfile?: {
    __typename?: 'CandidateProfile'
    id: string
    profileType: ProfileTypeEnum
    uploadedCandidateId?: number | null
    scalisUserId?: number | null
    primaryEmail?: string | null
    ActivityLog: Array<{
      __typename?: 'ActivityLog'
      id: string
      activity?: any | null
      userAction?: UserActionEnum | null
      templateStageId?: number | null
      previousTemplateStageId?: number | null
      activityTimestamp?: any | null
      companyCandidateTouchpointId?: number | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
        } | null
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
      CompanyCandidateTouchpoint?: { __typename?: 'CompanyCandidateTouchpoint'; id: string; name: string } | null
    }>
    CompanyProvidedEmail: Array<{ __typename?: 'CompanyProvidedEmail'; id: string; email: string }>
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
      currentJob?: Array<{
        __typename?: 'Experience'
        id: number
        employerName?: string | null
        isCurrentlyWorking?: boolean | null
        isCurrentJob?: boolean | null
        jobTitle?: string | null
      }> | null
      highestEducation?: Array<{
        __typename?: 'Education'
        id: number
        educationLevel?: EducationLevelEnum | null
        institutionName?: string | null
      }> | null
      WebsiteOrSocialMedia?: Array<{
        __typename?: 'WebsiteOrSocialMedia'
        type: WebsiteTypeEnum
        websiteURL: string
        id: number
      }> | null
      ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
      EmailVerification?: Array<{
        __typename?: 'EmailVerification'
        id: number
        emailAddress?: string | null
        isVisibleToEmployers?: boolean | null
        isPrimary?: boolean | null
        activeStatus?: boolean | null
      }> | null
      JobSeekerHeader?: Array<{
        __typename?: 'JobSeekerHeader'
        id: number
        profileHeadline?: string | null
        jobDisplayedId?: number | null
        educationDisplayedId?: number | null
      }> | null
      Education?: Array<{
        __typename?: 'Education'
        id: number
        institutionName?: string | null
        educationLevel?: EducationLevelEnum | null
        areasOfStudy?: any | null
        minors?: any | null
        majors?: any | null
        endDate?: any | null
        startDate?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
      }> | null
      Experience?: Array<{
        __typename?: 'Experience'
        id: number
        jobTitle?: string | null
        employerName?: string | null
        longFormDesc?: string | null
        startDate?: any | null
        endDate?: any | null
        jobType?: JobTypeEnum | null
        location?: string | null
        locationType?: string | null
        description?: string | null
        isCurrentlyWorking?: boolean | null
        isCurrentJob?: boolean | null
      }> | null
      JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; aboutMe?: string | null; id: number } | null
      VolunteerWork?: Array<{
        __typename?: 'VolunteerWork'
        id: number
        volunteerJobTitle?: string | null
        organizationName?: string | null
        roleType?: RoleTypeEnum | null
        startDate?: any | null
        endDate?: any | null
        isCurrentlyWorking?: boolean | null
        description?: any | null
        location?: string | null
      }> | null
      DemographicInfo?: Array<{
        __typename?: 'DemographicInfo'
        workHistory?: boolean | null
        veteranStatus?: VeteranStatusEnum | null
        raceEthnicity?: string | null
        id: number
        gender?: GenderEnum | null
      }> | null
      JobSeekerSkill?: Array<{
        __typename?: 'JobSeekerSkills'
        id: number
        level?: string | null
        name?: string | null
        sequenceNumber?: number | null
        yearsOfExp?: number | null
      }> | null
      CertificateOrLicense?: Array<{
        __typename?: 'CertificateOrLicense'
        id: number
        issuingAuthority?: string | null
        name?: string | null
        description?: any | null
        issueYear?: number | null
      }> | null
      Achievement?: Array<{
        __typename?: 'Achievement'
        id: number
        issuingAuthority?: string | null
        description?: any | null
        issueYear?: number | null
        name?: string | null
      }> | null
      Address?: Array<{ __typename?: 'Address'; id: number; city?: string | null; state?: string | null }> | null
    } | null
    ProfileDetails?: {
      __typename?: 'ProfileDetails'
      id: string
      phoneNumber?: string | null
      profileLink?: string | null
      timezone?: string | null
      CandidateSource: Array<{
        __typename?: 'CandidateSource'
        id: number
        companyUser?: { __typename?: 'CompanyUser'; id: string } | null
        jobListing?: {
          __typename?: 'JobListing'
          id: number
          externalTitle?: string | null
          Requisition?: { __typename?: 'Requisition'; extRequisitionId?: string | null; jobName?: string | null } | null
        } | null
        candidateSourceName?: {
          __typename?: 'CandidateSourceName'
          id: number
          name: string
          sourceCategory?: SourceCategoryEnum | null
          customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
        } | null
      }>
      CandidateProfileLocation: Array<{
        __typename?: 'CandidateProfileLocation'
        id: number
        city?: string | null
        state?: string | null
        country?: string | null
      }>
      CandidateMedalistDesignation: Array<{
        __typename?: 'CandidateMedalistDesignation'
        id: number
        medalistDesignation?: string | null
        jobListing?: { __typename?: 'JobListing'; id: number; externalTitle?: string | null } | null
      }>
    } | null
    CandidateApplication: Array<{
      __typename?: 'CandidateApplication'
      id: string
      matchScore?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      applicationType?: string | null
      applicationCreationType?: string | null
      updatedAt?: any | null
      appliedAt?: any | null
      lastUpdatedStatusAt?: any | null
      templateStageId?: number | null
      jobListingId?: number | null
      averageRating?: number | null
      lastActivityDate?: any | null
      duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
      CustomCandidateApplicationFieldValues?: Array<{
        __typename?: 'CustomCandidateApplicationFieldValue'
        id: string
        value?: any | null
        updatedAt?: any | null
        customCandidateApplicationField?: {
          __typename?: 'CustomCandidateApplicationField'
          id: string
          name?: string | null
          type?: CustomCandidateFieldTypeEnum | null
          schema?: any | null
          visibility?: CustomFieldVisibilityEnum | null
          provider?: CustomFieldProviderEnum | null
          systemTokenName?: string | null
        } | null
      }> | null
      CustomApplicationStatus?: {
        __typename?: 'CustomApplicationStatus'
        id: string
        applicationStatusName: string
        iconType: IconTypeEnum
        iconUnicode?: string | null
        colorHexCode: string
        createdAt: any
        updatedAt: any
      } | null
      CandidateInterview?: Array<{
        __typename?: 'CandidateInterview'
        id: string
        stageId?: number | null
        status?: CandidateInterviewStatusEnum | null
      }> | null
      JobListing?: {
        __typename?: 'JobListing'
        id: number
        publicListingId?: string | null
        externalTitle?: string | null
        listingTitle?: string | null
        workplaceType?: WorkplaceTypeEnum | null
        stateAndOrCountry?: string | null
        Address?: Array<{
          __typename?: 'Address'
          id: number
          city?: string | null
          state?: string | null
          country?: string | null
        }> | null
        Requisition?: {
          __typename?: 'Requisition'
          id: string
          extRequisitionId?: string | null
          jobName?: string | null
        } | null
      } | null
      TemplateStage?: {
        __typename?: 'TemplateStage'
        id: string
        name?: string | null
        TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
        TemplatePipeline?: {
          __typename?: 'TemplatePipeline'
          id: string
          TemplateMilestones?: Array<{
            __typename?: 'TemplateMilestone'
            id: string
            rankOrder?: number | null
            TemplateStage?: Array<{
              __typename?: 'TemplateStage'
              id: string
              rankOrder?: number | null
              name?: string | null
            }> | null
          }> | null
        } | null
      } | null
      CandidateApplicationRating?: Array<{
        __typename?: 'CandidateApplicationRating'
        id: string
        score?: number | null
      }> | null
      UploadedDocumentCandidateApplication?: Array<{
        __typename?: 'UploadedDocumentCandidateApplication'
        id: string
        updatedAt?: any | null
        UploadedDocument: {
          __typename?: 'UploadedDocument'
          id: number
          documentPath?: string | null
          documentName?: string | null
          createdAt?: any | null
        }
        CompanyUser?: {
          __typename?: 'CompanyUser'
          id: string
          profileImage?: string | null
          UserInvitation?: {
            __typename?: 'UserInvitation'
            id: number
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              firstName?: string | null
              lastName?: string | null
            } | null
          } | null
        } | null
      }> | null
      CandidateApplicationNote?: Array<{
        __typename?: 'CandidateApplicationNote'
        id: number
        privateStatus?: boolean | null
        userNote: { __typename?: 'UserNote'; id: string; noteText?: any | null; updatedAt?: any | null }
        companyUser?: {
          __typename?: 'CompanyUser'
          id: string
          profileImage?: string | null
          UserInvitation?: {
            __typename?: 'UserInvitation'
            id: number
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              firstName?: string | null
              lastName?: string | null
            } | null
          } | null
        } | null
        candidateApplication?: {
          __typename?: 'CandidateApplication'
          id: string
          JobListing?: { __typename?: 'JobListing'; id: number; publicListingId?: string | null } | null
        } | null
      }> | null
      ActivityLog?: Array<{
        __typename?: 'ActivityLog'
        id: string
        activity?: any | null
        userAction?: UserActionEnum | null
        templateStageId?: number | null
        previousTemplateStageId?: number | null
        activityTimestamp?: any | null
        companyCandidateTouchpointId?: number | null
        CompanyUser?: {
          __typename?: 'CompanyUser'
          id: string
          UserInvitation?: {
            __typename?: 'UserInvitation'
            id: number
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              profileImage?: string | null
              firstName?: string | null
              lastName?: string | null
            } | null
          } | null
        } | null
        CandidateProfile?: {
          __typename?: 'CandidateProfile'
          id: string
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
          UploadedCandidate?: {
            __typename?: 'UploadedCandidate'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
        CompanyCandidateTouchpoint?: { __typename?: 'CompanyCandidateTouchpoint'; id: string; name: string } | null
      }> | null
    }>
    CandidateApplicationRating: Array<{ __typename?: 'CandidateApplicationRating'; id: string; score?: number | null }>
    UploadedDocumentCandidateProfile: Array<{
      __typename?: 'UploadedDocumentCandidateProfile'
      id: string
      updatedAt?: any | null
      UploadedDocument?: {
        __typename?: 'UploadedDocument'
        id: number
        documentPath?: string | null
        documentName?: string | null
        createdAt?: any | null
      } | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
    }>
    CandidateProfileNote: Array<{
      __typename?: 'CandidateProfileNote'
      id: number
      privateStatus?: boolean | null
      userNote: { __typename?: 'UserNote'; id: string; noteText?: any | null; updatedAt?: any | null }
      companyUser?: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
    }>
    UploadedCandidate?: {
      __typename?: 'UploadedCandidate'
      id: number
      linkedinProfile?: string | null
      lastName?: string | null
      firstName?: string | null
      emailAddress?: string | null
      companyUserId?: number | null
      companyId?: number | null
      profileImage?: string | null
      profileUrl?: string | null
      uploadedCandidateType?: UploadedCandidateTypeEnum | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        profileType: ProfileTypeEnum
        CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
      } | null
      UploadedCandidateWebsiteOrSocialMedia: Array<{
        __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
        id: number
        websiteURL: string
        type: WebsiteTypeEnum
      }>
      UploadedCandidateAchievement: Array<{
        __typename?: 'UploadedCandidateAchievement'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateCertificateOrLicense: Array<{
        __typename?: 'UploadedCandidateCertificateOrLicense'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      highestEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      UploadedCandidateExperience?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
      currentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      mostRecentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      UploadedCandidateJobSeekerSkill?: Array<{
        __typename?: 'UploadedCandidateJobSeekerSkills'
        id: number
        sequenceNumber?: number | null
        level?: string | null
        name?: string | null
        yearsOfExp?: number | null
      }> | null
      UploadedCandidateVolunteerWork: Array<{
        __typename?: 'UploadedCandidateVolunteerWork'
        id: number
        volunteerJobTitle?: string | null
        organizationName?: string | null
        isCurrentlyWorking?: boolean | null
        roleType?: RoleTypeEnum | null
        startDate?: any | null
        endDate?: any | null
        description?: any | null
        searchDescription?: string | null
        location?: string | null
      }>
      EnrichedEmail: Array<{
        __typename?: 'EnrichedEmail'
        id: string
        emailAddress?: string | null
        enrichedEmailType?: EnrichedEmailTypeEnum | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
      EnrichedPhoneNumber: Array<{
        __typename?: 'EnrichedPhoneNumber'
        id: string
        phoneNumber?: string | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
    } | null
    CandidateLabels?: Array<{
      __typename?: 'CandidateLabel'
      id: string
      colorNumber: number
      labelName: string
    }> | null
    CustomCandidateProfileFieldValues?: Array<{
      __typename?: 'CustomCandidateProfileFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateProfileField?: {
        __typename?: 'CustomCandidateProfileField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }> | null
  } | null
}

export type GetSequenceEnrollmentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SortByCandidateProfile>
  sortDirection?: InputMaybe<SortDirection>
  sequenceId?: InputMaybe<Scalars['String']['input']>
}>

export type GetSequenceEnrollmentsQuery = {
  __typename?: 'Query'
  GetCandidateProfile?: Array<{
    __typename?: 'CandidateProfile'
    id: string
    profileType: ProfileTypeEnum
    SequenceCandidateStatus?: SequenceCandidateStatusEnum | null
    lastContactedDate?: any | null
    enrollmentDate?: any | null
    hasSent: boolean
    hasOpened: boolean
    hasReplied: boolean
    CandidateLabels?: Array<{
      __typename?: 'CandidateLabel'
      id: string
      colorNumber: number
      labelName: string
    }> | null
    lastStepCompleted?: { __typename?: 'SequenceStep'; id: string; stepNumber: number } | null
    CandidateApplicationRating: Array<{ __typename?: 'CandidateApplicationRating'; id: string; score?: number | null }>
    CandidateApplication: Array<{
      __typename?: 'CandidateApplication'
      id: string
      matchScore?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      applicationType?: string | null
      applicationCreationType?: string | null
      updatedAt?: any | null
      appliedAt?: any | null
      lastUpdatedStatusAt?: any | null
      templateStageId?: number | null
      jobListingId?: number | null
      averageRating?: number | null
      lastActivityDate?: any | null
      duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
      JobListing?: { __typename?: 'JobListing'; id: number; publicListingId?: string | null } | null
    }>
    UploadedCandidate?: {
      __typename?: 'UploadedCandidate'
      id: number
      linkedinProfile?: string | null
      lastName?: string | null
      firstName?: string | null
      emailAddress?: string | null
      companyUserId?: number | null
      companyId?: number | null
      profileImage?: string | null
      profileUrl?: string | null
      uploadedCandidateType?: UploadedCandidateTypeEnum | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        profileType: ProfileTypeEnum
        CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
      } | null
      UploadedCandidateWebsiteOrSocialMedia: Array<{
        __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
        id: number
        websiteURL: string
        type: WebsiteTypeEnum
      }>
      UploadedCandidateAchievement: Array<{
        __typename?: 'UploadedCandidateAchievement'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateCertificateOrLicense: Array<{
        __typename?: 'UploadedCandidateCertificateOrLicense'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      highestEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      UploadedCandidateExperience?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
      currentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      mostRecentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      UploadedCandidateJobSeekerSkill?: Array<{
        __typename?: 'UploadedCandidateJobSeekerSkills'
        id: number
        sequenceNumber?: number | null
        level?: string | null
        name?: string | null
        yearsOfExp?: number | null
      }> | null
      UploadedCandidateVolunteerWork: Array<{
        __typename?: 'UploadedCandidateVolunteerWork'
        id: number
        volunteerJobTitle?: string | null
        organizationName?: string | null
        isCurrentlyWorking?: boolean | null
        roleType?: RoleTypeEnum | null
        startDate?: any | null
        endDate?: any | null
        description?: any | null
        searchDescription?: string | null
        location?: string | null
      }>
      EnrichedEmail: Array<{
        __typename?: 'EnrichedEmail'
        id: string
        emailAddress?: string | null
        enrichedEmailType?: EnrichedEmailTypeEnum | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
      EnrichedPhoneNumber: Array<{
        __typename?: 'EnrichedPhoneNumber'
        id: string
        phoneNumber?: string | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
    } | null
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      activeStatus?: boolean | null
      profileImage?: string | null
      firstName?: string | null
      lastName?: string | null
      currentJob?: Array<{
        __typename?: 'Experience'
        id: number
        jobTitle?: string | null
        employerName?: string | null
      }> | null
      EmailVerification?: Array<{
        __typename?: 'EmailVerification'
        id: number
        isPrimary?: boolean | null
        emailAddress?: string | null
        isVisibleToEmployers?: boolean | null
      }> | null
    } | null
  }> | null
  CountCandidateProfile?: { __typename?: 'countOutput'; count: number } | null
}

export type GetSequenceProspectsOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>
  currentSequenceId: Scalars['String']['input']
}>

export type GetSequenceProspectsOptionsQuery = {
  __typename?: 'Query'
  GetCandidateProfile?: Array<{
    __typename?: 'CandidateProfile'
    id: string
    isEnrolledInSequence: boolean
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      EmailVerification?: Array<{
        __typename?: 'EmailVerification'
        id: number
        isPrimary?: boolean | null
        emailAddress?: string | null
      }> | null
    } | null
    UploadedCandidate?: {
      __typename?: 'UploadedCandidate'
      id: number
      firstName?: string | null
      lastName?: string | null
      emailAddress?: string | null
      EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
    } | null
  }> | null
}

export type GetTalentPoolQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  applicationFilters?: InputMaybe<ApplicationFiltersOnCandidateProfile>
  customCandidateProfileFields?: InputMaybe<
    Array<CustomCandidateProfileFieldFilter> | CustomCandidateProfileFieldFilter
  >
  sortBy?: InputMaybe<SortByCandidateProfile>
  sortDirection?: InputMaybe<SortDirection>
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetTalentPoolQuery = {
  __typename?: 'Query'
  GetCandidateProfile?: Array<{
    __typename?: 'CandidateProfile'
    id: string
    profileType: ProfileTypeEnum
    primaryEmail?: string | null
    CandidateLabels?: Array<{
      __typename?: 'CandidateLabel'
      id: string
      colorNumber: number
      labelName: string
    }> | null
    ProspectStatus?: { __typename?: 'TalentPoolProspectStatus'; id: string; colorNumber: number; status: string } | null
    ProspectOwner?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    CandidateApplicationRating: Array<{ __typename?: 'CandidateApplicationRating'; id: string; score?: number | null }>
    CandidateApplication: Array<{
      __typename?: 'CandidateApplication'
      id: string
      matchScore?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      applicationType?: string | null
      applicationCreationType?: string | null
      updatedAt?: any | null
      appliedAt?: any | null
      lastUpdatedStatusAt?: any | null
      templateStageId?: number | null
      jobListingId?: number | null
      averageRating?: number | null
      lastActivityDate?: any | null
      duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
      JobListing?: { __typename?: 'JobListing'; id: number; publicListingId?: string | null } | null
      CandidateSource?: Array<{
        __typename?: 'CandidateSource'
        id: number
        candidateSourceName?: {
          __typename?: 'CandidateSourceName'
          id: number
          name: string
          sourceCategory?: SourceCategoryEnum | null
          customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
        } | null
      }> | null
    }>
    UploadedCandidate?: {
      __typename?: 'UploadedCandidate'
      id: number
      linkedinProfile?: string | null
      lastName?: string | null
      firstName?: string | null
      emailAddress?: string | null
      companyUserId?: number | null
      companyId?: number | null
      profileImage?: string | null
      profileUrl?: string | null
      uploadedCandidateType?: UploadedCandidateTypeEnum | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        profileType: ProfileTypeEnum
        CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
      } | null
      UploadedCandidateWebsiteOrSocialMedia: Array<{
        __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
        id: number
        websiteURL: string
        type: WebsiteTypeEnum
      }>
      UploadedCandidateAchievement: Array<{
        __typename?: 'UploadedCandidateAchievement'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateCertificateOrLicense: Array<{
        __typename?: 'UploadedCandidateCertificateOrLicense'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      highestEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      UploadedCandidateExperience?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
      currentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      mostRecentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      UploadedCandidateJobSeekerSkill?: Array<{
        __typename?: 'UploadedCandidateJobSeekerSkills'
        id: number
        sequenceNumber?: number | null
        level?: string | null
        name?: string | null
        yearsOfExp?: number | null
      }> | null
      UploadedCandidateVolunteerWork: Array<{
        __typename?: 'UploadedCandidateVolunteerWork'
        id: number
        volunteerJobTitle?: string | null
        organizationName?: string | null
        isCurrentlyWorking?: boolean | null
        roleType?: RoleTypeEnum | null
        startDate?: any | null
        endDate?: any | null
        description?: any | null
        searchDescription?: string | null
        location?: string | null
      }>
      EnrichedEmail: Array<{
        __typename?: 'EnrichedEmail'
        id: string
        emailAddress?: string | null
        enrichedEmailType?: EnrichedEmailTypeEnum | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
      EnrichedPhoneNumber: Array<{
        __typename?: 'EnrichedPhoneNumber'
        id: string
        phoneNumber?: string | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
    } | null
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      activeStatus?: boolean | null
      profileImage?: string | null
      firstName?: string | null
      lastName?: string | null
      mostRecentJob?: Array<{
        __typename?: 'Experience'
        id: number
        industry?: IndustryEnum | null
        jobTitle?: string | null
        employerName?: string | null
      }> | null
      currentJob?: Array<{
        __typename?: 'Experience'
        id: number
        jobTitle?: string | null
        employerName?: string | null
      }> | null
      highestEducation?: Array<{
        __typename?: 'Education'
        id: number
        educationLevel?: EducationLevelEnum | null
        institutionName?: string | null
      }> | null
      ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
      Address?: Array<{
        __typename?: 'Address'
        id: number
        country?: string | null
        city?: string | null
        state?: string | null
      }> | null
      EmailVerification?: Array<{
        __typename?: 'EmailVerification'
        id: number
        isPrimary?: boolean | null
        emailAddress?: string | null
        isVisibleToEmployers?: boolean | null
      }> | null
      JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; id: number; jobSeekerId?: number | null } | null
      ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
    } | null
    ProfileDetails?: {
      __typename?: 'ProfileDetails'
      id: string
      phoneNumber?: string | null
      CandidateSource: Array<{
        __typename?: 'CandidateSource'
        id: number
        candidateSourceName?: {
          __typename?: 'CandidateSourceName'
          id: number
          name: string
          sourceCategory?: SourceCategoryEnum | null
          customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
        } | null
      }>
    } | null
    CustomCandidateProfileFieldValues?: Array<{
      __typename?: 'CustomCandidateProfileFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateProfileField?: {
        __typename?: 'CustomCandidateProfileField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }> | null
  }> | null
  CountCandidateProfile?: { __typename?: 'countOutput'; count: number } | null
}

export type ListDuplicateApplicationsQueryVariables = Exact<{
  candidateProfileId: Scalars['Int']['input']
  requisitionId: Scalars['Int']['input']
}>

export type ListDuplicateApplicationsQuery = {
  __typename?: 'Query'
  ListDuplicateApplications?: Array<{
    __typename?: 'CandidateApplication'
    id: string
    applicationStatus?: ApplicationStatusEnum | null
    appliedAt?: any | null
    templateStageId?: number | null
    lastUpdatedStatusAt?: any | null
    duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
        Experience?: Array<{ __typename?: 'Experience'; jobTitle?: string | null; employerName?: string | null }> | null
        EmailVerification?: Array<{
          __typename?: 'EmailVerification'
          emailAddress?: string | null
          isPrimary?: boolean | null
        }> | null
        WebsiteOrSocialMedia?: Array<{
          __typename?: 'WebsiteOrSocialMedia'
          type: WebsiteTypeEnum
          websiteURL: string
        }> | null
      } | null
      ProfileDetails?: {
        __typename?: 'ProfileDetails'
        phoneNumber?: string | null
        profileLink?: string | null
        timezone?: string | null
      } | null
    } | null
    JobListing?: {
      __typename?: 'JobListing'
      id: number
      listingTitle?: string | null
      externalTitle?: string | null
      stateAndOrCountry?: string | null
      Address?: Array<{
        __typename?: 'Address'
        id: number
        city?: string | null
        state?: string | null
        country?: string | null
      }> | null
      Requisition?: {
        __typename?: 'Requisition'
        id: string
        extRequisitionId?: string | null
        jobName?: string | null
      } | null
    } | null
    TemplateStage?: {
      __typename?: 'TemplateStage'
      name?: string | null
      TemplateMilestone?: { __typename?: 'TemplateMilestone'; name?: NameEnum | null } | null
      TemplatePipeline?: {
        __typename?: 'TemplatePipeline'
        TemplateStage?: Array<{ __typename?: 'TemplateStage'; id: string; name?: string | null }> | null
      } | null
    } | null
    CustomApplicationStatus?: {
      __typename?: 'CustomApplicationStatus'
      id: string
      applicationStatusName: string
      iconType: IconTypeEnum
      iconUnicode?: string | null
      colorHexCode: string
      createdAt: any
      updatedAt: any
    } | null
  }> | null
}

export type GetCandidateSourceNamesQueryVariables = Exact<{
  input: CandidateSourceNameInput
}>

export type GetCandidateSourceNamesQuery = {
  __typename?: 'Query'
  GetCandidateSourceNames?: Array<{
    __typename?: 'CandidateSourceName'
    id: number
    name: string
    sourceCategory?: SourceCategoryEnum | null
    companyId?: number | null
    createdAt?: any | null
    updatedAt?: any | null
    customSourceCategory?: {
      __typename?: 'CustomSourceCategory'
      id: number
      sourceCategoryName: string
      externalId?: string | null
      companyId: number
      companyUserId: number
      createdAt: any
      updatedAt: any
    } | null
  }> | null
}

export type ListCustomSourceCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type ListCustomSourceCategoriesQuery = {
  __typename?: 'Query'
  ListCustomSourceCategories?: Array<{
    __typename?: 'CustomSourceCategory'
    id: number
    companyId: number
    companyUserId: number
    sourceCategoryName: string
    externalId?: string | null
    createdAt: any
    updatedAt: any
    company: { __typename?: 'Company'; id: string }
    companyUser: { __typename?: 'CompanyUser'; id: string }
    candidateSourceNames: Array<{
      __typename?: 'CandidateSourceName'
      id: number
      name: string
      sourceCategory?: SourceCategoryEnum | null
      createdAt?: any | null
      updatedAt?: any | null
    }>
  }> | null
}

export type GetCandidateTouchpointActivityLogQueryVariables = Exact<{
  input: GetCandidateTouchpointActivityLogInput
}>

export type GetCandidateTouchpointActivityLogQuery = {
  __typename?: 'Query'
  GetCandidateTouchpointActivityLog?: {
    __typename?: 'ActivityLog'
    id: string
    candidateProfileId?: number | null
    candidateApplicationId?: number | null
    companyCandidateTouchpointId?: number | null
    activityTimestamp?: any | null
    activity?: any | null
    userAction?: UserActionEnum | null
    isDeleted?: boolean | null
    createdAt: any
    updatedAt: any
    companyUserId?: number | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      primaryEmail?: string | null
      ScalisUser?: {
        __typename?: 'ScalisUser'
        firstName?: string | null
        lastName?: string | null
        profileImage?: string | null
      } | null
    } | null
    CandidateApplication?: {
      __typename?: 'CandidateApplication'
      id: string
      applicationStatus?: ApplicationStatusEnum | null
      appliedAt?: any | null
      JobListing?: { __typename?: 'JobListing'; id: number } | null
      TemplateStage?: { __typename?: 'TemplateStage'; id: string; name?: string | null } | null
    } | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        email?: string | null
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    } | null
  } | null
}

export type ListCompanyCandidateTouchpointsQueryVariables = Exact<{
  input?: InputMaybe<ListCompanyCandidateTouchpointsInput>
}>

export type ListCompanyCandidateTouchpointsQuery = {
  __typename?: 'Query'
  ListCompanyCandidateTouchpoints?: {
    __typename?: 'PaginatedCompanyCandidateTouchpoints'
    total: number
    page: number
    limit: number
    totalPages: number
    items: Array<{
      __typename?: 'CompanyCandidateTouchpoint'
      id: string
      name: string
      companyId?: number | null
      companyUserId?: number | null
      isDeleted?: boolean | null
      isDefault?: boolean | null
      isArchived?: boolean | null
      createdAt: any
      updatedAt: any
      activityLogs: Array<{
        __typename?: 'ActivityLog'
        id: string
        activityTimestamp?: any | null
        activity?: any | null
        CandidateProfile?: {
          __typename?: 'CandidateProfile'
          id: string
          primaryEmail?: string | null
          ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
        } | null
        CandidateApplication?: {
          __typename?: 'CandidateApplication'
          id: string
          applicationStatus?: ApplicationStatusEnum | null
        } | null
      }>
    }>
  } | null
}

export type GetPipelineCompanyUserViewQueryVariables = Exact<{
  input: GetPipelineCompanyUserViewInput
}>

export type GetPipelineCompanyUserViewQuery = {
  __typename?: 'Query'
  GetPipelineCompanyUserView: {
    __typename?: 'GetPipelineCompanyUserViewResponse'
    list: Array<{
      __typename?: 'ViewLinkWithUserPreference'
      userPreferenceObject?: {
        __typename?: 'CompanyUserView'
        id: string
        companyUserId: number
        rankOrder: number
        requisitionTalentPoolCompanySavedViewId: number
        requisitionTalentPoolCompanySavedView: {
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
          isPinned: boolean
          companySavedViewId: number
          hasPinnedSavedViewForCurrentRequisition: boolean
          belongsToCurrentRequisition: boolean
          wasRemovedForCurrentUser: boolean
          companySavedView: {
            __typename?: 'CompanySavedView'
            id: string
            name: string
            viewLayout: CompanySavedViewLayoutEnum
            companyUserId?: number | null
            viewLocation: CompanySavedViewLocationEnum
            viewType: CompanySavedViewTypeEnum
            isVisibleTo: CompanySavedViewVisibilityEnum
            sorting: any
            columnVisibility: any
            columnOrder: any
            columnSizing: any
            candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
            requisitionTalentPoolCompanySavedViews: Array<{
              __typename?: 'RequisitionTalentPoolCompanySavedView'
              id: string
            }>
          }
        }
      } | null
      viewLink: {
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
        isPinned: boolean
        companySavedViewId: number
        hasPinnedSavedViewForCurrentRequisition: boolean
        belongsToCurrentRequisition: boolean
        wasRemovedForCurrentUser: boolean
        companySavedView: {
          __typename?: 'CompanySavedView'
          id: string
          name: string
          viewLayout: CompanySavedViewLayoutEnum
          companyUserId?: number | null
          viewLocation: CompanySavedViewLocationEnum
          viewType: CompanySavedViewTypeEnum
          isVisibleTo: CompanySavedViewVisibilityEnum
          sorting: any
          columnVisibility: any
          columnOrder: any
          columnSizing: any
          candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
          requisitionTalentPoolCompanySavedViews: Array<{
            __typename?: 'RequisitionTalentPoolCompanySavedView'
            id: string
          }>
        }
      }
    }>
    createdByMe: Array<{
      __typename?: 'RequisitionTalentPoolCompanySavedView'
      id: string
      isPinned: boolean
      companySavedViewId: number
      hasPinnedSavedViewForCurrentRequisition: boolean
      belongsToCurrentRequisition: boolean
      wasRemovedForCurrentUser: boolean
      companySavedView: {
        __typename?: 'CompanySavedView'
        id: string
        name: string
        viewLayout: CompanySavedViewLayoutEnum
        companyUserId?: number | null
        viewLocation: CompanySavedViewLocationEnum
        viewType: CompanySavedViewTypeEnum
        isVisibleTo: CompanySavedViewVisibilityEnum
        sorting: any
        columnVisibility: any
        columnOrder: any
        columnSizing: any
        candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
        requisitionTalentPoolCompanySavedViews: Array<{
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
        }>
      }
    }>
    defaultViews: Array<{
      __typename?: 'RequisitionTalentPoolCompanySavedView'
      id: string
      isPinned: boolean
      companySavedViewId: number
      hasPinnedSavedViewForCurrentRequisition: boolean
      belongsToCurrentRequisition: boolean
      wasRemovedForCurrentUser: boolean
      companySavedView: {
        __typename?: 'CompanySavedView'
        id: string
        name: string
        viewLayout: CompanySavedViewLayoutEnum
        companyUserId?: number | null
        viewLocation: CompanySavedViewLocationEnum
        viewType: CompanySavedViewTypeEnum
        isVisibleTo: CompanySavedViewVisibilityEnum
        sorting: any
        columnVisibility: any
        columnOrder: any
        columnSizing: any
        candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
        requisitionTalentPoolCompanySavedViews: Array<{
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
        }>
      }
    }>
    savedByOthers: Array<{
      __typename?: 'RequisitionTalentPoolCompanySavedView'
      id: string
      isPinned: boolean
      companySavedViewId: number
      hasPinnedSavedViewForCurrentRequisition: boolean
      belongsToCurrentRequisition: boolean
      wasRemovedForCurrentUser: boolean
      companySavedView: {
        __typename?: 'CompanySavedView'
        id: string
        name: string
        viewLayout: CompanySavedViewLayoutEnum
        companyUserId?: number | null
        viewLocation: CompanySavedViewLocationEnum
        viewType: CompanySavedViewTypeEnum
        isVisibleTo: CompanySavedViewVisibilityEnum
        sorting: any
        columnVisibility: any
        columnOrder: any
        columnSizing: any
        candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
        requisitionTalentPoolCompanySavedViews: Array<{
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
        }>
      }
    }>
  }
}

export type ListCompanyUserGroupsQueryVariables = Exact<{
  input: ListCompanyUserGroupsInput
}>

export type ListCompanyUserGroupsQuery = {
  __typename?: 'Query'
  ListCompanyUserGroups: Array<{
    __typename?: 'CompanyUserGroup'
    id: string
    name: string
    externalId?: string | null
    createdAt: any
    updatedAt: any
    deleted: boolean
    createdBy: {
      __typename?: 'CompanyUser'
      id: string
      profileImage?: string | null
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
        } | null
      } | null
    }
    Offices: Array<{
      __typename?: 'CompanyUserGroupCompanyOffice'
      CompanyOffice: {
        __typename?: 'CompanyOffice'
        id: string
        officeName?: string | null
        externalId?: string | null
      }
    }>
    Departments: Array<{
      __typename?: 'CompanyUserGroupCompanyDepartment'
      CompanyDepartment: {
        __typename?: 'CompanyDepartment'
        id: string
        departmentName?: string | null
        externalId?: string | null
      }
    }>
    Members: Array<{
      __typename?: 'CompanyUserGroupCompanyUser'
      CompanyUser: {
        __typename?: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
            EmailVerification?: Array<{ __typename?: 'EmailVerification'; emailAddress?: string | null }> | null
          } | null
        } | null
      }
    }>
  }>
}

export type GetCompanyUsersOptionsQueryVariables = Exact<{ [key: string]: never }>

export type GetCompanyUsersOptionsQuery = {
  __typename?: 'Query'
  GetCompanyUsers?: Array<{
    __typename?: 'CompanyUser'
    id: string
    UserInvitation?: {
      __typename?: 'UserInvitation'
      id: number
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        firstName?: string | null
        lastName?: string | null
        profileImage?: string | null
        EmailVerification?: Array<{
          __typename?: 'EmailVerification'
          id: number
          isPrimary?: boolean | null
          emailAddress?: string | null
        }> | null
      } | null
    } | null
  }> | null
}

export type GetInterviewerCalendarsQueryVariables = Exact<{ [key: string]: never }>

export type GetInterviewerCalendarsQuery = {
  __typename?: 'Query'
  GetCalendarSettings?: {
    __typename?: 'CalendarSettings'
    id: string
    timeZone?: string | null
    provider: string
    email: string
    companyUserId: number
    Calendars?: Array<{
      __typename?: 'Calendar'
      id: string
      nylasCalendarId: string
      name: string
      isPrimary: boolean
      color?: string | null
      calendarSettingsId: number
    }> | null
  } | null
  GetCompanyUsers?: Array<{
    __typename?: 'CompanyUser'
    id: string
    profileImage?: string | null
    companyId: number
    UserInvitation?: {
      __typename?: 'UserInvitation'
      id: number
      email?: string | null
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
    CalendarSettings?: {
      __typename?: 'CalendarSettings'
      id: string
      availability?: any | null
      provider: string
      timeZone?: string | null
      hourDisplay: number
      email: string
      Calendars?: Array<{
        __typename?: 'Calendar'
        id: string
        nylasCalendarId: string
        calendarSettingsId: number
        name: string
        isPrimary: boolean
        color?: string | null
        CalendarEvents?: Array<{
          __typename?: 'CalendarEvent'
          id: string
          nylasEventStatus?: NylasEventStatusesEnum | null
          nylasCalendarEventId?: string | null
          title?: string | null
          eventType?: EventTypeEnum | null
          description?: string | null
          startTime?: any | null
          endTime?: any | null
          timeZone?: string | null
          location?: string | null
          repeats?: RepeatsEnum | null
          reminders?: any | null
          employers?: any | null
          conferencing?: any | null
          masterEventId?: string | null
          regardingCandidates?: any | null
          regardingJobs?: any | null
          internalGuests?: any | null
          candidates?: any | null
          isScalisEvent?: boolean | null
          CandidateInterview?: {
            __typename?: 'CandidateInterview'
            stageId?: number | null
            status?: CandidateInterviewStatusEnum | null
            TemplateStage?: {
              __typename?: 'TemplateStage'
              TemplateMilestone?: { __typename?: 'TemplateMilestone'; name?: NameEnum | null } | null
            } | null
          } | null
        }> | null
      }> | null
    } | null
  }> | null
}

export type GetStageCompanyUsersQueryVariables = Exact<{ [key: string]: never }>

export type GetStageCompanyUsersQuery = {
  __typename?: 'Query'
  GetCompanyUsers?: Array<{
    __typename: 'CompanyUser'
    id: string
    companyId: number
    profileImage?: string | null
    UserInvitation?: {
      __typename: 'UserInvitation'
      id: number
      email?: string | null
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }> | null
}

export type GetCompanyDepartmentsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCompanyDepartmentsQuery = {
  __typename?: 'Query'
  GetCompanyInfo?: Array<{
    __typename?: 'Company'
    CompanyDepartment: Array<{
      __typename?: 'CompanyDepartment'
      type?: CompanyDepartmentTypeEnum | null
      subordinateTo?: number | null
      id: string
      externalId?: string | null
      departmentName?: string | null
      ParentCompanyDepartment?: { __typename?: 'CompanyDepartment'; departmentName?: string | null; id: string } | null
    }>
  }> | null
}

export type GetCompanyInfoSettingsFormQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCompanyInfoSettingsFormQuery = {
  __typename?: 'Query'
  GetCompanyInfo?: Array<{
    __typename?: 'Company'
    subdomain?: string | null
    id: string
    CompanyInfo?: {
      __typename?: 'CompanyInfo'
      logo?: string | null
      companyType?: string | null
      companyName?: string | null
      industry?: IndustryEnum | null
      subIndustry?: SubIndustryTypeEnum | null
      phoneNumber?: string | null
      website?: string | null
      linkedin?: string | null
      linkedinId?: string | null
      employeeCount?: EmployeeCountEnum | null
      yearsInOperation?: number | null
    } | null
    Address: Array<{
      __typename?: 'Address'
      id: number
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      country?: string | null
      postalCode?: string | null
      timeZone?: string | null
      longitude?: string | null
      latitude?: string | null
    }>
  }> | null
}

export type GetCompanyOfficesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCompanyOfficesQuery = {
  __typename?: 'Query'
  GetCompanyInfo?: Array<{
    __typename?: 'Company'
    CompanyOffice: Array<{
      __typename?: 'CompanyOffice'
      externalId?: string | null
      officeName?: string | null
      id: string
      Address?: {
        __typename?: 'Address'
        id: number
        addressLine1?: string | null
        addressLine2?: string | null
        city?: string | null
        state?: string | null
        country?: string | null
        postalCode?: string | null
        timeZone?: string | null
        longitude?: string | null
        latitude?: string | null
      } | null
    }>
  }> | null
}

export type GetCompanyUsersCandidateProfileQueryVariables = Exact<{ [key: string]: never }>

export type GetCompanyUsersCandidateProfileQuery = {
  __typename?: 'Query'
  GetCompanyUsers?: Array<{
    __typename?: 'CompanyUser'
    id: string
    companyUserStatus?: CompanyUserStatusEnum | null
    UserInvitation?: {
      __typename?: 'UserInvitation'
      id: number
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }> | null
}

export type GetCompanyUsersQueryVariables = Exact<{
  input?: InputMaybe<GetCompanyUsersInput>
}>

export type GetCompanyUsersQuery = {
  __typename?: 'Query'
  GetCompanyUsers?: Array<{
    __typename?: 'CompanyUser'
    id: string
    companyId: number
    companyUserStatus?: CompanyUserStatusEnum | null
    profileImage?: string | null
    UserRoles?: Array<{
      __typename?: 'UserRoles'
      roleId: number
      userId: number
      role: { __typename?: 'Role'; id: string; name: string }
    }> | null
    UserInvitation?: {
      __typename?: 'UserInvitation'
      id: number
      email?: string | null
      invitedAs?: RoleEnum | null
      invitationStatus?: InvitationStatusEnum | null
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  }> | null
}

export type GetCompanyWithSubdomainQueryVariables = Exact<{
  subdomain?: InputMaybe<Scalars['String']['input']>
}>

export type GetCompanyWithSubdomainQuery = {
  __typename?: 'Query'
  GetCompanyInfo?: Array<{
    __typename?: 'Company'
    id: string
    subdomain?: string | null
    CompanyInfo?: { __typename?: 'CompanyInfo'; id: string; logo?: string | null; companyName?: string | null } | null
  }> | null
}

export type GetUserInvitationsQueryVariables = Exact<{ [key: string]: never }>

export type GetUserInvitationsQuery = {
  __typename?: 'Query'
  GetUserInvitations?: Array<{
    __typename?: 'UserInvitation'
    scalisUserId?: number | null
    invitedAs?: RoleEnum | null
    invitationStatus?: InvitationStatusEnum | null
    id: number
    email?: string | null
    deletedAt?: any | null
    companyId?: number | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      companyId: number
      companyUserStatus?: CompanyUserStatusEnum | null
      id: string
      profileImage?: string | null
      userInvitationId?: number | null
      UserRoles?: Array<{
        __typename?: 'UserRoles'
        userId: number
        roleId: number
        role: { __typename?: 'Role'; id: string; name: string }
      }> | null
    } | null
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      activeStatus?: boolean | null
      profileImage?: string | null
      firstName?: string | null
      lastName?: string | null
    } | null
  }> | null
}

export type ListCompanyDepartmentsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type ListCompanyDepartmentsQuery = {
  __typename?: 'Query'
  ListCompanyDepartments?: Array<{
    __typename?: 'CompanyDepartment'
    id: string
    companyId?: number | null
    departmentName?: string | null
    subordinateTo?: number | null
    externalId?: string | null
    createdAt?: any | null
    updatedAt?: any | null
  }> | null
}

export type ListCompanyOfficesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type ListCompanyOfficesQuery = {
  __typename?: 'Query'
  ListCompanyOffices?: Array<{
    __typename?: 'CompanyOffice'
    id: string
    companyId?: number | null
    officeName?: string | null
    externalId?: string | null
    addressId?: number | null
    createdAt?: any | null
    updatedAt?: any | null
    Address?: {
      __typename?: 'Address'
      id: number
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      country?: string | null
      postalCode?: string | null
      timeZone?: string | null
    } | null
  }> | null
}

export type SearchCompanyGlobalQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>
}>

export type SearchCompanyGlobalQuery = {
  __typename?: 'Query'
  SearchCompanyGlobal?: Array<{
    __typename?: 'SearchCompanyGlobalResultType'
    description?: string | null
    id: string
    logo?: string | null
    name?: string | null
    website?: string | null
  }> | null
}

export type GetConnectedEmailSettingsQueryVariables = Exact<{ [key: string]: never }>

export type GetConnectedEmailSettingsQuery = {
  __typename?: 'Query'
  GetConnectedEmailSettings?: Array<{
    __typename?: 'ConnectedEmailSettings'
    id: string
    email: string
    provider: ConnectedEmailProviderEnum
    createdAt?: any | null
    updatedAt?: any | null
  }> | null
}

export type ListCustomApplicationStatusesQueryVariables = Exact<{
  input: ListCustomApplicationStatusInput
}>

export type ListCustomApplicationStatusesQuery = {
  __typename?: 'Query'
  ListCustomApplicationStatuses: {
    __typename?: 'PaginatedCustomApplicationStatus'
    total: number
    items: Array<{
      __typename?: 'CustomApplicationStatus'
      _count: number
      id: string
      applicationStatusName: string
      iconType: IconTypeEnum
      iconUnicode?: string | null
      colorHexCode: string
      createdAt: any
      updatedAt: any
      company: { __typename?: 'Company'; id: string }
      companyUser: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          email?: string | null
          ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
        } | null
      }
    }>
  }
}

export type GetCustomApplicationFieldsQueryVariables = Exact<{
  input?: InputMaybe<GetCustomCandidateApplicationFieldsInput>
}>

export type GetCustomApplicationFieldsQuery = {
  __typename?: 'Query'
  GetCustomCandidateApplicationFields?: Array<{
    __typename?: 'CustomCandidateApplicationField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    systemTokenName?: string | null
    visibility?: CustomFieldVisibilityEnum | null
    schema?: any | null
    provider?: CustomFieldProviderEnum | null
    isArchived?: boolean | null
    updatedAt?: any | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
    customCandidateApplicationFieldRequisitions?: Array<{
      __typename?: 'CustomCandidateApplicationFieldRequisition'
      id?: number | null
      requisition?: {
        __typename?: 'Requisition'
        id: string
        jobName?: string | null
        JobListing?: Array<{
          __typename?: 'JobListing'
          id: number
          externalTitle?: string | null
          listingTitle?: string | null
        }> | null
      } | null
    }> | null
    customCandidateApplicationFieldValues: Array<{
      __typename?: 'CustomCandidateApplicationFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateApplicationField?: {
        __typename?: 'CustomCandidateApplicationField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }>
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  }> | null
}

export type GetCustomJobRequisitionFieldValuesQueryVariables = Exact<{
  input: GetCustomJobRequisitionFieldValuesInput
}>

export type GetCustomJobRequisitionFieldValuesQuery = {
  __typename?: 'Query'
  GetCustomJobRequisitionFieldValues?: Array<{
    __typename?: 'CustomJobRequisitionFieldValue'
    id: string
    requisitionId?: number | null
    customJobRequisitionFieldId?: number | null
    value?: any | null
    companyUserId: number
    createdAt?: any | null
    updatedAt?: any | null
    customJobRequisitionField?: {
      __typename?: 'CustomJobRequisitionField'
      id: string
      name: string
      type: CustomJobRequisitionFieldTypeEnum
      systemTokenName?: string | null
      visibility: CustomFieldVisibilityEnum
      schema: any
      provider: CustomFieldProviderEnum
      isArchived: boolean
      isRequired: boolean
      updatedAt: any
      tooltip?: boolean | null
      tooltipText?: string | null
      createdBy?: {
        __typename?: 'CustomFieldCreatedByUser'
        id: number
        firstName?: string | null
        lastName?: string | null
        profileImage?: string | null
      } | null
    } | null
  }> | null
}

export type GetCustomJobRequisitionFieldsQueryVariables = Exact<{
  input: GetCustomJobRequisitionFieldsInput
}>

export type GetCustomJobRequisitionFieldsQuery = {
  __typename?: 'Query'
  GetCustomJobRequisitionFields?: Array<{
    __typename?: 'CustomJobRequisitionField'
    id: string
    name: string
    type: CustomJobRequisitionFieldTypeEnum
    systemTokenName?: string | null
    visibility: CustomFieldVisibilityEnum
    schema: any
    provider: CustomFieldProviderEnum
    isArchived: boolean
    isRequired: boolean
    updatedAt: any
    tooltip?: boolean | null
    tooltipText?: string | null
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
  }> | null
}

export type GetCustomProfileFieldsQueryVariables = Exact<{
  input?: InputMaybe<GetCustomCandidateProfileFieldsInput>
}>

export type GetCustomProfileFieldsQuery = {
  __typename?: 'Query'
  GetCustomCandidateProfileFields?: Array<{
    __typename?: 'CustomCandidateProfileField'
    id: string
    name?: string | null
    type?: CustomCandidateFieldTypeEnum | null
    systemTokenName?: string | null
    visibility?: CustomFieldVisibilityEnum | null
    schema?: any | null
    provider?: CustomFieldProviderEnum | null
    isArchived?: boolean | null
    updatedAt?: any | null
    tooltip?: boolean | null
    tooltipText?: string | null
    showWhenUploadingCandidate?: boolean | null
    requireWhenUploadingCandidate?: boolean | null
    createdBy?: {
      __typename?: 'CustomFieldCreatedByUser'
      id: number
      firstName?: string | null
      lastName?: string | null
      profileImage?: string | null
    } | null
    customCandidateProfileFieldValues?: Array<{
      __typename?: 'CustomCandidateProfileFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateProfileField?: {
        __typename?: 'CustomCandidateProfileField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }> | null
  }> | null
}

export type DeleteOfferCustomFieldMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteOfferCustomFieldMutation = {
  __typename?: 'Mutation'
  DeleteOfferCustomField: { __typename?: 'OfferCustomField'; id: number }
}

export type GetOfferCustomFieldQueryVariables = Exact<{ [key: string]: never }>

export type GetOfferCustomFieldQuery = {
  __typename?: 'Query'
  GetOfferCustomField?: Array<{
    __typename?: 'OfferCustomField'
    id: number
    fieldConfigurationType: CustomFieldInputTypeEnum
    fieldName: string
    fieldDescription?: string | null
    generateSystemToken: boolean
    systemTokenName?: string | null
    fieldRequired: boolean
    triggerNewOfferVersion: boolean
    multipleChoiceOptions?: any | null
    updatedAt?: any | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    CandidateOfferCustomField?: Array<{
      __typename?: 'CandidateOfferCustomField'
      id: number
      fieldValue?: any | null
    }> | null
    OfferTemplateCondition?: Array<{
      __typename?: 'OfferTemplateCondition'
      id: string
      officeId?: number | null
      payType?: PayTypeEnum | null
      employmentType?: JobTypeEnum | null
      departmentId?: number | null
    }> | null
  }> | null
}

export type OfferCustomFieldFragment = {
  __typename?: 'OfferCustomField'
  id: number
  fieldConfigurationType: CustomFieldInputTypeEnum
  fieldName: string
  fieldDescription?: string | null
  generateSystemToken: boolean
  systemTokenName?: string | null
  fieldRequired: boolean
  triggerNewOfferVersion: boolean
  multipleChoiceOptions?: any | null
  updatedAt?: any | null
  CandidateOfferCustomField?: Array<{
    __typename?: 'CandidateOfferCustomField'
    id: number
    fieldValue?: any | null
  }> | null
  OfferTemplateCondition?: Array<{
    __typename?: 'OfferTemplateCondition'
    id: string
    officeId?: number | null
    payType?: PayTypeEnum | null
    employmentType?: JobTypeEnum | null
    departmentId?: number | null
  }> | null
}

export type UpsertOfferCustomFieldMutationVariables = Exact<{
  input: UpsertOfferCustomFieldInput
}>

export type UpsertOfferCustomFieldMutation = {
  __typename?: 'Mutation'
  UpsertOfferCustomField?: {
    __typename?: 'OfferCustomField'
    id: number
    fieldConfigurationType: CustomFieldInputTypeEnum
    fieldName: string
    fieldDescription?: string | null
    generateSystemToken: boolean
    systemTokenName?: string | null
    fieldRequired: boolean
    triggerNewOfferVersion: boolean
    multipleChoiceOptions?: any | null
    updatedAt?: any | null
    CandidateOfferCustomField?: Array<{
      __typename?: 'CandidateOfferCustomField'
      id: number
      fieldValue?: any | null
    }> | null
    OfferTemplateCondition?: Array<{
      __typename?: 'OfferTemplateCondition'
      id: string
      officeId?: number | null
      payType?: PayTypeEnum | null
      employmentType?: JobTypeEnum | null
      departmentId?: number | null
    }> | null
  } | null
}

export type UpsertOfferTemplateConditionMutationVariables = Exact<{
  input: Array<UpsertOfferTemplateConditionInput> | UpsertOfferTemplateConditionInput
}>

export type UpsertOfferTemplateConditionMutation = {
  __typename?: 'Mutation'
  UpsertOfferTemplateCondition?: Array<{
    __typename?: 'OfferTemplateCondition'
    id: string
    conditionType: ConditionTypeEnum
    customFieldId?: number | null
    departmentId?: number | null
    employmentType?: JobTypeEnum | null
    offerDocumentTemplateId?: number | null
    officeId?: number | null
    payType?: PayTypeEnum | null
    sectionTemplateId?: number | null
  } | null> | null
}

export type CreateDocumentTemplateMutationVariables = Exact<{
  input: CreateDocumentTemplateInput
}>

export type CreateDocumentTemplateMutation = {
  __typename?: 'Mutation'
  CreateDocumentTemplate: { __typename?: 'OfferDocumentTemplate'; id: string }
}

export type DeleteOfferDocumentTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DeleteOfferDocumentTemplateMutation = {
  __typename?: 'Mutation'
  DeleteOfferDocumentTemplate: { __typename?: 'OfferDocumentTemplate'; id: string }
}

export type DownloadDocumentTemplateMutationVariables = Exact<{
  input: DownloadDocumentTemplateInput
}>

export type DownloadDocumentTemplateMutation = {
  __typename?: 'Mutation'
  DownloadDocumentTemplate: { __typename?: 'DownloadDocumentTemplateOutput'; temporaryUrl: string }
}

export type GenerateFilesFromHtmlMutationVariables = Exact<{
  html: Scalars['String']['input']
}>

export type GenerateFilesFromHtmlMutation = {
  __typename?: 'Mutation'
  GenerateFilesFromHtml?: { __typename?: 'GenerateFilesFromHtmlOutput'; pdfKey: string } | null
}

export type GetCompanyOfficesDepartmentsQueryVariables = Exact<{ [key: string]: never }>

export type GetCompanyOfficesDepartmentsQuery = {
  __typename?: 'Query'
  ListCompanyDepartments?: Array<{
    __typename?: 'CompanyDepartment'
    id: string
    departmentName?: string | null
  }> | null
  ListCompanyOffices?: Array<{ __typename?: 'CompanyOffice'; id: string; officeName?: string | null }> | null
}

export type GetDocumentTemplateConditionsQueryVariables = Exact<{
  documentTemplateId: Scalars['Int']['input']
}>

export type GetDocumentTemplateConditionsQuery = {
  __typename?: 'Query'
  GetOfferTemplateCondition?: Array<{
    __typename?: 'OfferTemplateCondition'
    id: string
    departmentId?: number | null
    employmentType?: JobTypeEnum | null
    payType?: PayTypeEnum | null
    officeId?: number | null
  }> | null
}

export type GetDefaultTokenQueryVariables = Exact<{ [key: string]: never }>

export type GetDefaultTokenQuery = {
  __typename?: 'Query'
  GetDefaultToken?: Array<{
    __typename?: 'DefaultToken'
    id: string
    categoryName: TokenCategoryNameEnum
    tokenName: TokenNameEnum
  }> | null
}

export type GetOfferDocumentTemplateQueryVariables = Exact<{
  input: GetOfferDocumentTemplateInput
}>

export type GetOfferDocumentTemplateQuery = {
  __typename?: 'Query'
  GetOfferDocumentTemplate?: Array<{
    __typename?: 'OfferDocumentTemplate'
    id: string
    updatedAt?: any | null
    documentTemplateName: string
    documentType: OfferDocumentTemplateTypeEnum
    documentTemplateStatus: OfferDocumentTemplateStatusEnum
    documentTemplateText: string
    documentFilePath?: string | null
    documentFileName?: string | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
  }> | null
}

export type UpdateDocumentTemplateMutationVariables = Exact<{
  input: UpdateDocumentTemplateInput
}>

export type UpdateDocumentTemplateMutation = {
  __typename?: 'Mutation'
  UpdateDocumentTemplate: {
    __typename?: 'OfferDocumentTemplate'
    id: string
    documentTemplateName: string
    documentTemplateText: string
    documentTemplateStatus: OfferDocumentTemplateStatusEnum
    documentType: OfferDocumentTemplateTypeEnum
  }
}

export type ValidateDocumentTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type ValidateDocumentTemplateMutation = {
  __typename?: 'Mutation'
  ValidateOfferDocumentTemplate: {
    __typename?: 'OfferDocumentTemplate'
    id: string
    documentTemplateStatus: OfferDocumentTemplateStatusEnum
    validationResult?: any | null
  }
}

export type GetEmailRecordsQueryVariables = Exact<{
  input: GetEmailRecordsInput
}>

export type GetEmailRecordsQuery = {
  __typename?: 'Query'
  GetEmailRecords?: {
    __typename?: 'EmailRecordsResponse'
    emails: Array<{
      __typename?: 'EmailRecord'
      id: string
      createdAt: any
      subject?: string | null
      message?: string | null
      hasOpened?: boolean | null
      hasReplied?: boolean | null
      hasBounced?: boolean | null
      emailThreadId: string
      candidateApplicationId?: number | null
      to: Array<{ __typename?: 'EmailContact'; companyUserId?: number | null; name?: string | null }>
      from: Array<{ __typename?: 'EmailContact'; companyUserId?: number | null; name?: string | null }>
    }>
  } | null
}

export type GetEmailThreadQueryVariables = Exact<{
  input: GetThreadInput
}>

export type GetEmailThreadQuery = {
  __typename?: 'Query'
  GetEmailThread?: {
    __typename?: 'ThreadResponse'
    thread: {
      __typename?: 'EmailThread'
      id: string
      EmailRecord: Array<{
        __typename?: 'EmailRecord'
        id: string
        createdAt: any
        subject?: string | null
        message?: string | null
        hasOpened?: boolean | null
        hasReplied?: boolean | null
        hasBounced?: boolean | null
        sequenceId?: string | null
        to: Array<{
          __typename?: 'EmailContact'
          companyUserId?: number | null
          profileImage?: string | null
          name?: string | null
          email: string
        }>
        from: Array<{
          __typename?: 'EmailContact'
          companyUserId?: number | null
          profileImage?: string | null
          name?: string | null
          email: string
        }>
      }>
    }
  } | null
}

export type ListFieldTokensQueryVariables = Exact<{
  input?: InputMaybe<FieldTokenInput>
}>

export type ListFieldTokensQuery = {
  __typename?: 'Query'
  ListFieldTokens?: {
    __typename?: 'ListFieldTokensResponse'
    defaultTokens: Array<{
      __typename?: 'DefaultToken'
      categoryName: TokenCategoryNameEnum
      columnName?: string | null
      createdAt?: any | null
      id: string
      isAggregatedToken: boolean
      tableName?: string | null
      tokenName: TokenNameEnum
      tokenType: Array<DefaultTokenTypeEnum>
    }>
    customTokens: Array<{
      __typename?: 'CompanyCustomFieldToken'
      companyId: number
      createdAt: any
      customCandidateApplicationFieldId?: number | null
      customCandidateProfileFieldId?: number | null
      id: number
      offerCustomFieldId?: number | null
      updatedAt: any
      Company: {
        __typename?: 'Company'
        createdAt?: any | null
        externalId?: string | null
        id: string
        lastActivity?: any | null
        subdomain?: string | null
        updatedAt?: any | null
      }
      CustomCandidateApplicationField?: {
        __typename?: 'CustomCandidateApplicationField'
        companyId?: number | null
        createdAt?: any | null
        id: string
        isArchived?: boolean | null
        linkedToScreeningQuestion?: boolean | null
        name?: string | null
        provider?: CustomFieldProviderEnum | null
        schema?: any | null
        systemTokenName?: string | null
        tooltip?: boolean | null
        tooltipText?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        updatedAt?: any | null
        visibility?: CustomFieldVisibilityEnum | null
      } | null
      CustomCandidateProfileField?: {
        __typename?: 'CustomCandidateProfileField'
        companyId?: number | null
        createdAt?: any | null
        id: string
        isArchived?: boolean | null
        name?: string | null
        provider?: CustomFieldProviderEnum | null
        requisitionId?: number | null
        schema?: any | null
        systemTokenName?: string | null
        tooltip?: boolean | null
        tooltipText?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        updatedAt?: any | null
        visibility?: CustomFieldVisibilityEnum | null
      } | null
      OfferCustomField?: {
        __typename?: 'OfferCustomField'
        companyId?: number | null
        companyUserId?: number | null
        createdAt?: any | null
        fieldConfigurationType: CustomFieldInputTypeEnum
        fieldDescription?: string | null
        fieldName: string
        fieldRequired: boolean
        generateSystemToken: boolean
        id: number
        multipleChoiceOptions?: any | null
        systemTokenName?: string | null
        templateConditionId?: number | null
        triggerNewOfferVersion: boolean
        updatedAt?: any | null
      } | null
    }>
  } | null
}

export type GetCreditsUsageLimitQueryVariables = Exact<{ [key: string]: never }>

export type GetCreditsUsageLimitQuery = {
  __typename?: 'Query'
  GetFeatureUsageLimit?: { __typename?: 'AIFeatureUsageLimit'; limit: number; usage: number } | null
}

export type GetGlobalListingSetupQueryVariables = Exact<{
  companyId: Scalars['Int']['input']
}>

export type GetGlobalListingSetupQuery = {
  __typename?: 'Query'
  getGlobalListingSetup?: {
    __typename?: 'GlobalListingSetup'
    id: number
    aboutCompanyStatement?: any | null
    footerStatement?: any | null
    companyId: number
    createdAt: any
    isAboutCompanyActive: boolean
    isFooterStatementActive: boolean
    updatedAt: any
  } | null
}

export type GetGlobalScreeningQuestionsQueryVariables = Exact<{
  input: GetGlobalScreeningQuestionInput
}>

export type GetGlobalScreeningQuestionsQuery = {
  __typename?: 'Query'
  GetGlobalScreeningQuestions?: Array<{
    __typename?: 'ScreeningQuestion'
    id: string
    questionTitle?: string | null
    questionDesc?: string | null
    questionType?: QuestionTypeEnum | null
    ansOptions?: string | null
    isRejectionQuestion?: boolean | null
    rejectMessage?: string | null
    preferredAnswer?: string | null
    isActiveGlobally?: boolean | null
    globalQuestionOrder?: number | null
    createdAt?: any | null
    updatedAt?: any | null
  }> | null
}

export type ListGlobalScreeningQuestionsQueryVariables = Exact<{
  input: ListGlobalScreeningQuestionInput
}>

export type ListGlobalScreeningQuestionsQuery = {
  __typename?: 'Query'
  ListGlobalScreeningQuestions?: Array<{
    __typename?: 'ScreeningQuestion'
    id: string
    questionTitle?: string | null
    questionDesc?: string | null
    questionType?: QuestionTypeEnum | null
    ansOptions?: string | null
    minVal?: number | null
    maxVal?: number | null
    valStatus?: string | null
    isRejectionQuestion?: boolean | null
    rejectMessage?: string | null
    preferredAnswer?: string | null
    isActiveGlobally?: boolean | null
    globalQuestionOrder?: number | null
    createdAt?: any | null
    updatedAt?: any | null
  }> | null
}

export type GetHiringTeamMemberQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetHiringTeamMemberQuery = {
  __typename?: 'Query'
  GetHiringTeamMember?: {
    __typename?: 'HiringTeamMember'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    companyUserId?: number | null
    roleId?: number | null
    requisitionId?: number | null
    requisitionJobDescriptionId?: number | null
    role?: { __typename?: 'Role'; id: string; name: string } | null
  } | null
}

export type GetCompanyDataForCreatingInterviewerPoolQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCompanyDataForCreatingInterviewerPoolQuery = {
  __typename?: 'Query'
  ListCompanyOffices?: Array<{ __typename?: 'CompanyOffice'; id: string; officeName?: string | null }> | null
  GetCompanyInfo?: Array<{
    __typename?: 'Company'
    CompanyDepartment: Array<{ __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null }>
    CompanyOffice: Array<{ __typename?: 'CompanyOffice'; id: string; officeName?: string | null }>
  }> | null
  GetSkills?: Array<{ __typename?: 'Skill'; id: string; name?: string | null }> | null
  GetRequisitions?: Array<{
    __typename?: 'Requisition'
    id: string
    jobName?: string | null
    extRequisitionId?: string | null
    JobOpening?: Array<{ __typename?: 'JobOpening'; id: string; jobRequisitionId?: number | null }> | null
  }> | null
}

export type GetInterviewerPoolsQueryVariables = Exact<{
  input?: InputMaybe<GetInterviewerPoolsInput>
}>

export type GetInterviewerPoolsQuery = {
  __typename?: 'Query'
  GetInterviewerPools?: Array<{
    __typename?: 'InterviewerPool'
    id: string
    name: string
    description?: string | null
    maxWeeklyInterviews?: number | null
    maxDailyInterviews?: number | null
    updatedAt?: any | null
    isArchived: boolean
    Offices?: Array<{
      __typename?: 'InterviewerPoolOffice'
      id: string
      CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
    }> | null
    Departments?: Array<{
      __typename?: 'InterviewerPoolDepartment'
      id: string
      CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
    }> | null
    Skills?: Array<{
      __typename?: 'InterviewerPoolSkill'
      id: string
      Skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
    }> | null
    Jobs?: Array<{
      __typename?: 'InterviewerPoolJob'
      id: string
      requisitionId: number
      Requisition?: { __typename?: 'Requisition'; jobName?: string | null } | null
    }> | null
    Members?: Array<{
      __typename?: 'InterviewerPoolMember'
      companyUserId: number
      interviewsTodayCount?: number | null
      interviewsThisWeekCount?: number | null
      interviewsLastWeekCount?: number | null
      id: string
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          email?: string | null
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
            profileImage?: string | null
          } | null
        } | null
      } | null
    }> | null
  }> | null
}

export type GetCampaignJobFunctionsQueryVariables = Exact<{ [key: string]: never }>

export type GetCampaignJobFunctionsQuery = {
  __typename?: 'Query'
  CampaignJobFunctions?: Array<{ __typename?: 'JobFunction'; name: string; id: string }> | null
}

export type GetJobCampaignEducationLevelsQueryVariables = Exact<{ [key: string]: never }>

export type GetJobCampaignEducationLevelsQuery = {
  __typename?: 'Query'
  GetJobCampaignEducationLevels?: Array<{
    __typename?: 'JobCampaignEducationLevel'
    id: number
    name: Array<{ __typename?: 'educationLevel'; languageCode: string; value: string }>
  }> | null
}

export type GetJobCampaignIndustriesQueryVariables = Exact<{ [key: string]: never }>

export type GetJobCampaignIndustriesQuery = {
  __typename?: 'Query'
  JobCampaignIndustries?: Array<{ __typename?: 'JobCampaignIndustry'; id: number; name: string }> | null
}

export type SearchJobCampaignLocationsQueryVariables = Exact<{
  input: SearchJobCampaignLocationsInput
}>

export type SearchJobCampaignLocationsQuery = {
  __typename?: 'Query'
  SearchJobCampaignLocations?: Array<{
    __typename?: 'JobCampaignLocation'
    id: number
    fully_qualified_place_name?: string | null
  }> | null
}

export type GetJobCampaignProductsByIdQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type GetJobCampaignProductsByIdQuery = {
  __typename?: 'Query'
  GetJobCampaignProductsById?: {
    __typename?: 'JobCampaignProducts'
    results?: Array<{
      __typename?: 'JobCampaignProduct'
      product_id: string
      audience_group: string
      title: string
      description: string
      homepage: string
      cross_postings: Array<string>
      duration: { __typename?: 'Duration'; period: number; range: string }
      industries: Array<{ __typename?: 'JobCampaignIndustry'; id: number; name: string }>
      job_functions: Array<{ __typename?: 'JobFunction'; id: string; name: string }>
      locations: Array<{ __typename?: 'JobCampaignLocation'; canonical_name: string; id: number }>
      logo_rectangle_url?: Array<{ __typename?: 'Logo'; url: string }> | null
      vonq_price: Array<{ __typename?: 'Price'; amount: number; currency: string }>
      time_to_process: { __typename?: 'ProcessTime'; period: number; range: string }
    }> | null
  } | null
}

export type GetJobCampaignProductsQueryVariables = Exact<{
  input?: InputMaybe<ProductFiltersInput>
}>

export type GetJobCampaignProductsQuery = {
  __typename?: 'Query'
  GetJobCampaignProducts?: {
    __typename?: 'JobCampaignProducts'
    count: number
    results?: Array<{
      __typename?: 'JobCampaignProduct'
      product_id: string
      audience_group: string
      title: string
      description: string
      homepage: string
      cross_postings: Array<string>
      duration: { __typename?: 'Duration'; period: number; range: string }
      industries: Array<{ __typename?: 'JobCampaignIndustry'; id: number; name: string }>
      job_functions: Array<{ __typename?: 'JobFunction'; id: string; name: string }>
      locations: Array<{ __typename?: 'JobCampaignLocation'; canonical_name: string; id: number }>
      logo_rectangle_url?: Array<{ __typename?: 'Logo'; url: string }> | null
      vonq_price: Array<{ __typename?: 'Price'; amount: number; currency: string }>
      time_to_process: { __typename?: 'ProcessTime'; period: number; range: string }
    }> | null
  } | null
}

export type GetJobCampaignSeniorityQueryVariables = Exact<{ [key: string]: never }>

export type GetJobCampaignSeniorityQuery = {
  __typename?: 'Query'
  GetJobCampaignSeniority: Array<{
    __typename?: 'JobCampaignSeniority'
    id: number
    name: Array<{ __typename?: 'SeniorityLevel'; languageCode: string; value: string }>
  }>
}

export type GetOrderQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetOrderQuery = {
  __typename?: 'Query'
  GetOrders: Array<{
    __typename?: 'Order'
    Campaigns?: {
      __typename?: 'JobCampaignResponse'
      data: Array<{
        __typename?: 'JobCampaign'
        campaignName: string
        orderedProducts: Array<string>
        labels?: { __typename?: 'JobCampaignLabels'; jobListingId?: string | null } | null
        targetGroup?: {
          __typename?: 'TargetGroup'
          seniority: Array<{ __typename?: 'TargetGroupItem'; description: string; vonqId: string }>
          jobCategory: Array<{ __typename?: 'TargetGroupItem'; vonqId: string; description: string }>
          industry: Array<{ __typename?: 'TargetGroupItem'; vonqId: string; description: string }>
          educationLevel: Array<{ __typename?: 'TargetGroupItem'; vonqId: string; description: string }>
        } | null
      }>
    } | null
  }>
}

export type GetRequisitionOrdersQueryVariables = Exact<{
  requisitionId: Scalars['Int']['input']
}>

export type GetRequisitionOrdersQuery = {
  __typename?: 'Query'
  GetRequisition?: {
    __typename?: 'Requisition'
    id: string
    isIncomplete: boolean
    Orders?: Array<{
      __typename?: 'Order'
      id: number
      total: number
      applicantsCount?: any | null
      campaignTraffic?: any | null
      Campaigns?: {
        __typename?: 'JobCampaignResponse'
        data: Array<{
          __typename?: 'JobCampaign'
          campaignId: string
          campaignName: string
          createdOn: string
          status: CampaignStatuses
          viewsCount?: any | null
          postings: Array<{ __typename?: 'Posting'; clicks: number }>
          targetGroup?: {
            __typename?: 'TargetGroup'
            seniority: Array<{ __typename?: 'TargetGroupItem'; vonqId: string; description: string }>
            jobCategory: Array<{ __typename?: 'TargetGroupItem'; description: string; vonqId: string }>
            industry: Array<{ __typename?: 'TargetGroupItem'; description: string; vonqId: string }>
            educationLevel: Array<{ __typename?: 'TargetGroupItem'; description: string; vonqId: string }>
          } | null
          labels?: { __typename?: 'JobCampaignLabels'; jobListingId?: string | null } | null
        }>
      } | null
    }> | null
    JobListing?: Array<{
      __typename?: 'JobListing'
      id: number
      workplaceType?: WorkplaceTypeEnum | null
      listingTitle?: string | null
      publicListingId?: string | null
      Address?: Array<{
        __typename?: 'Address'
        country?: string | null
        state?: string | null
        city?: string | null
      }> | null
    }> | null
  } | null
}

export type GetIsCandidateAppliedQueryVariables = Exact<{
  publicListingId: Scalars['String']['input']
}>

export type GetIsCandidateAppliedQuery = {
  __typename?: 'Query'
  GetCandidateApplication?: Array<{ __typename?: 'CandidateApplication'; id: string }> | null
}

export type GetJobListingsPipelineQueryVariables = Exact<{
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetJobListingsPipelineQuery = {
  __typename?: 'Query'
  GetJobListing?: Array<{
    __typename?: 'JobListing'
    id: number
    externalTitle?: string | null
    publicListingId?: string | null
    JobListingJobPipeline?: {
      __typename?: 'JobListingJobPipeline'
      id: string
      JobPipeline?: {
        __typename?: 'JobPipeline'
        id: string
        TemplatePipeline?: {
          __typename?: 'TemplatePipeline'
          id: string
          name?: string | null
          TemplateMilestones?: Array<{
            __typename?: 'TemplateMilestone'
            id: string
            name?: NameEnum | null
            rankOrder?: number | null
            TemplateStage?: Array<{
              __typename?: 'TemplateStage'
              rankOrder?: number | null
              name?: string | null
              id: string
              visibility?: TemplateStageVisibilityEnum | null
            }> | null
          }> | null
        } | null
      } | null
    } | null
    Requisition?: { __typename?: 'Requisition'; id: string; jobName?: string | null } | null
  }> | null
}

export type GetJobListingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetJobListingQuery = {
  __typename?: 'Query'
  GetJobListing?: Array<{
    __typename?: 'JobListing'
    id: number
    publicListingId?: string | null
    jobRequisitionId?: number | null
    listingTitle?: string | null
    externalTitle?: string | null
    workplaceType?: WorkplaceTypeEnum | null
    publicDescription?: string | null
    displayPayOnListing?: boolean | null
    industry?: IndustryEnum | null
    subIndustry?: SubIndustryTypeEnum | null
    companyDefault?: boolean | null
    stateAndOrCountry?: string | null
    internalMatchingDescription?: string | null
    searchPublicDescription?: string | null
    searchInternalMatchingDescription?: string | null
    postedAt?: any | null
    acceptingCandidates?: boolean | null
    stage?: StageEnum | null
    createdAt?: any | null
    updatedAt?: any | null
    Address?: Array<{
      __typename?: 'Address'
      id: number
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      country?: string | null
      postalCode?: string | null
      timeZone?: string | null
    }> | null
    JobListingScreeningQuestion?: Array<{
      __typename?: 'JobListingScreeningQuestion'
      id: string
      jobListingId?: number | null
      displaySequenceNumber?: number | null
      screeningQuestionId?: number | null
      createdAt?: any | null
      updatedAt?: any | null
      ScreeningQuestion?: {
        __typename?: 'ScreeningQuestion'
        id: string
        isTemplateQuestion?: boolean | null
        questionTitle?: string | null
        questionDesc?: string | null
        questionType?: QuestionTypeEnum | null
        minVal?: number | null
        maxVal?: number | null
        valStatus?: string | null
        ansOptions?: string | null
        isRejectionQuestion?: boolean | null
        isGlobalQuestion?: boolean | null
        rejectMessage?: string | null
        templateMessageId?: number | null
        preferredAnswer?: string | null
        companyId?: number | null
        companyUserId?: number | null
        createdAt?: any | null
        updatedAt?: any | null
      } | null
    }> | null
  }> | null
}

export type GetJobListingsIdTitleQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetJobListingsIdTitleQuery = {
  __typename?: 'Query'
  GetJobListing?: Array<{ __typename: 'JobListing'; id: number; listingTitle?: string | null }> | null
}

export type GetJobPipelineQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  templatePipelineId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetJobPipelineQuery = {
  __typename?: 'Query'
  GetJobPipeline?: Array<{
    __typename?: 'JobPipeline'
    id: string
    title?: string | null
    jobRequisitionId?: number | null
    templatePipelineId?: number | null
    TemplatePipeline?: {
      __typename?: 'TemplatePipeline'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      companyId?: number | null
      companyUserId?: number | null
      name?: string | null
      companyDepartmentId?: number | null
      archived?: boolean | null
      pipelinedUsed?: boolean | null
      ghostPipeline?: boolean | null
      deletedAt?: any | null
      TemplateMilestones?: Array<{
        __typename?: 'TemplateMilestone'
        createdAt?: any | null
        updatedAt?: any | null
        id: string
        templatePipelineId?: number | null
        name?: NameEnum | null
        rankOrder?: number | null
        archived?: boolean | null
      }> | null
      TemplateStage?: Array<{
        __typename?: 'TemplateStage'
        createdAt?: any | null
        updatedAt?: any | null
        id: string
        templatePipelineId?: number | null
        visibility?: TemplateStageVisibilityEnum | null
        name?: string | null
        templateMilestoneId?: number | null
        rankOrder?: number | null
        archived?: boolean | null
      }> | null
    } | null
    StageSettings?: Array<{
      __typename?: 'StageSettings'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      jobPipelineId?: number | null
      templateStageId?: number | null
      scorecardTemplateId?: number | null
    }> | null
  }> | null
}

export type GetJobSearchPreferenceQueryVariables = Exact<{
  input?: InputMaybe<GetJobSearchPreferenceInput>
}>

export type GetJobSearchPreferenceQuery = {
  __typename?: 'Query'
  GetJobSearchPreference?: {
    __typename?: 'JobSearchPreference'
    id: number
    scalisUserId: number
    includeJobTitles?: any | null
    excludeJobTitles?: any | null
    jobType?: JobTypeEnum | null
    datePosted?: DatePostedEnum | null
    workplaceTypePreference?: any | null
    workplaceLocationPreference?: any | null
    relocationTypePreference?: RelocationTypePreferenceEnum | null
    relocationLocationPreference?: any | null
    minimumPayPreference?: string | null
    visaSponsorship?: boolean | null
    benefits?: any | null
    industryPreference?: any | null
    desiredCompanySize?: any | null
    minimumRequiredExperience?: string | null
    maxRequiredExperience?: string | null
    companyStage?: any | null
    createdAt: any
    updatedAt: any
  } | null
}

export type CountCandidateApplicationQueryVariables = Exact<{
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  matchScore?: InputMaybe<MatchScore>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  lastActivity?: InputMaybe<LastActivity>
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum> | ApplicationStatusEnum>
  applicationStatusNotIn?: InputMaybe<Array<ApplicationStatusEnum> | ApplicationStatusEnum>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum> | ApplicationTypeEnum>
  sourceName?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  medalistDesignation?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  creditedCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  companies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  educationLevel?: InputMaybe<Array<EducationLevelEnum> | EducationLevelEnum>
  jobTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  majors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  schools?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  timezones?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  veteranStatus?: InputMaybe<Array<VeteranStatusEnum> | VeteranStatusEnum>
  willingToRelocate?: InputMaybe<Array<WillingToRelocateEnum> | WillingToRelocateEnum>
  yearsOfExperience?: InputMaybe<YearsOfExperience>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  profileType?: InputMaybe<ProfileTypeEnum>
  search?: InputMaybe<Scalars['String']['input']>
}>

export type CountCandidateApplicationQuery = {
  __typename?: 'Query'
  CountCandidateApplication?: { __typename?: 'countOutput'; count: number } | null
}

export type GetCandidateApplicationPipelineViewQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  matchScore?: InputMaybe<MatchScore>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  lastActivity?: InputMaybe<LastActivity>
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum> | ApplicationStatusEnum>
  customApplicationStatusIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum> | ApplicationTypeEnum>
  sourceName?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  medalistDesignation?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  creditedCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  companies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  educationLevel?: InputMaybe<Array<EducationLevelEnum> | EducationLevelEnum>
  jobTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  majors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  schools?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  timezones?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  veteranStatus?: InputMaybe<Array<VeteranStatusEnum> | VeteranStatusEnum>
  willingToRelocate?: InputMaybe<Array<WillingToRelocateEnum> | WillingToRelocateEnum>
  yearsOfExperience?: InputMaybe<YearsOfExperience>
  requisitionId: Scalars['Int']['input']
  profileType?: InputMaybe<ProfileTypeEnum>
  labels?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  customCandidateApplicationFields?: InputMaybe<
    Array<CustomCandidateApplicationFieldFilter> | CustomCandidateApplicationFieldFilter
  >
  customCandidateProfileFields?: InputMaybe<
    Array<CustomCandidateProfileFieldFilter> | CustomCandidateProfileFieldFilter
  >
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SortByApplication>
  sortDirection?: InputMaybe<SortDirection>
}>

export type GetCandidateApplicationPipelineViewQuery = {
  __typename?: 'Query'
  GetCandidateApplicationPipelineView?: Array<{
    __typename?: 'CandidateApplicationPipelineView'
    count: number
    candidateApplications: Array<{
      __typename?: 'CandidateApplication'
      id: string
      matchScore?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      applicationType?: string | null
      applicationCreationType?: string | null
      updatedAt?: any | null
      appliedAt?: any | null
      lastUpdatedStatusAt?: any | null
      templateStageId?: number | null
      jobListingId?: number | null
      averageRating?: number | null
      lastActivityDate?: any | null
      duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
      CustomApplicationStatus?: {
        __typename?: 'CustomApplicationStatus'
        id: string
        applicationStatusName: string
        iconType: IconTypeEnum
        iconUnicode?: string | null
        colorHexCode: string
        createdAt: any
        updatedAt: any
      } | null
      CandidateInterview?: Array<{
        __typename?: 'CandidateInterview'
        id: string
        stageId?: number | null
        status?: CandidateInterviewStatusEnum | null
      }> | null
      CustomCandidateApplicationFieldValues?: Array<{
        __typename?: 'CustomCandidateApplicationFieldValue'
        id: string
        value?: any | null
        updatedAt?: any | null
        customCandidateApplicationField?: {
          __typename?: 'CustomCandidateApplicationField'
          id: string
          name?: string | null
          type?: CustomCandidateFieldTypeEnum | null
          schema?: any | null
          visibility?: CustomFieldVisibilityEnum | null
          provider?: CustomFieldProviderEnum | null
          systemTokenName?: string | null
        } | null
      }> | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        profileType: ProfileTypeEnum
        CandidateLabels?: Array<{
          __typename?: 'CandidateLabel'
          id: string
          colorNumber: number
          labelName: string
        }> | null
        ProspectStatus?: {
          __typename?: 'TalentPoolProspectStatus'
          id: string
          colorNumber: number
          status: string
        } | null
        ProspectOwner?: {
          __typename?: 'CompanyUser'
          id: string
          UserInvitation?: {
            __typename?: 'UserInvitation'
            ScalisUser?: {
              __typename?: 'ScalisUser'
              id: number
              activeStatus?: boolean | null
              profileImage?: string | null
              firstName?: string | null
              lastName?: string | null
            } | null
          } | null
        } | null
        CustomCandidateProfileFieldValues?: Array<{
          __typename?: 'CustomCandidateProfileFieldValue'
          id: string
          value?: any | null
          updatedAt?: any | null
          customCandidateProfileField?: {
            __typename?: 'CustomCandidateProfileField'
            id: string
            name?: string | null
            type?: CustomCandidateFieldTypeEnum | null
            schema?: any | null
            visibility?: CustomFieldVisibilityEnum | null
            provider?: CustomFieldProviderEnum | null
            systemTokenName?: string | null
          } | null
        }> | null
        CandidateApplicationRating: Array<{
          __typename?: 'CandidateApplicationRating'
          id: string
          score?: number | null
        }>
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          mostRecentJob?: Array<{
            __typename?: 'Experience'
            id: number
            industry?: IndustryEnum | null
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          currentJob?: Array<{
            __typename?: 'Experience'
            id: number
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          highestEducation?: Array<{
            __typename?: 'Education'
            id: number
            educationLevel?: EducationLevelEnum | null
            institutionName?: string | null
          }> | null
          ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
          Address?: Array<{
            __typename?: 'Address'
            id: number
            country?: string | null
            city?: string | null
            state?: string | null
          }> | null
          EmailVerification?: Array<{
            __typename?: 'EmailVerification'
            id: number
            isPrimary?: boolean | null
            emailAddress?: string | null
            isVisibleToEmployers?: boolean | null
          }> | null
          JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; id: number; jobSeekerId?: number | null } | null
          ExperienceTenure?: {
            __typename?: 'experienceTenure'
            average: number
            longest: number
            shortest: number
          } | null
        } | null
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          linkedinProfile?: string | null
          lastName?: string | null
          firstName?: string | null
          emailAddress?: string | null
          companyUserId?: number | null
          companyId?: number | null
          profileImage?: string | null
          profileUrl?: string | null
          uploadedCandidateType?: UploadedCandidateTypeEnum | null
          CandidateProfile?: {
            __typename?: 'CandidateProfile'
            id: string
            profileType: ProfileTypeEnum
            CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
          } | null
          UploadedCandidateWebsiteOrSocialMedia: Array<{
            __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
            id: number
            websiteURL: string
            type: WebsiteTypeEnum
          }>
          UploadedCandidateAchievement: Array<{
            __typename?: 'UploadedCandidateAchievement'
            id: number
            name?: string | null
            issuingAuthority?: string | null
            issueYear?: number | null
            description?: any | null
            searchDescription?: string | null
          }>
          UploadedCandidateCertificateOrLicense: Array<{
            __typename?: 'UploadedCandidateCertificateOrLicense'
            id: number
            name?: string | null
            issuingAuthority?: string | null
            issueYear?: number | null
            description?: any | null
            searchDescription?: string | null
          }>
          UploadedCandidateEducation?: Array<{
            __typename?: 'UploadedCandidateEducation'
            id: number
            institutionName?: string | null
            currentlyStudying?: boolean | null
            educationLevel?: EducationLevelEnum | null
            startDate?: any | null
            endDate?: any | null
            areasOfStudy?: any | null
            majors?: any | null
            minors?: any | null
            cumGPA?: number | null
            cumGPAScale?: number | null
            hideCumGPA?: boolean | null
            hideDepartmentGPA?: boolean | null
            departmentCumGPA?: number | null
            departmentCumGPAScale?: number | null
            additionalInformation?: string | null
          }> | null
          highestEducation?: Array<{
            __typename?: 'UploadedCandidateEducation'
            id: number
            institutionName?: string | null
            currentlyStudying?: boolean | null
            educationLevel?: EducationLevelEnum | null
            startDate?: any | null
            endDate?: any | null
            areasOfStudy?: any | null
            majors?: any | null
            minors?: any | null
            cumGPA?: number | null
            cumGPAScale?: number | null
            hideCumGPA?: boolean | null
            hideDepartmentGPA?: boolean | null
            departmentCumGPA?: number | null
            departmentCumGPAScale?: number | null
            additionalInformation?: string | null
          }> | null
          UploadedCandidateExperience?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            startDate?: any | null
            endDate?: any | null
            companyLogo?: string | null
            locationType?: string | null
            location?: string | null
            shortFormDesc?: any | null
            longFormDesc?: string | null
            searchShortFormDesc?: string | null
            searchLongFormDesc?: string | null
            industry?: IndustryEnum | null
            subIndustry?: string | null
            payType?: string | null
            jobPay?: number | null
            additionalComp?: boolean | null
            jobTitle?: string | null
            employerName?: string | null
            managementPosition?: boolean | null
            teamSize?: TeamSizeEnum | null
            workPlaceCandidate?: WorkPlaceCandidateEnum | null
            isCurrentJob?: boolean | null
            jobType?: JobTypeEnum | null
            isCurrentlyWorking?: boolean | null
            description?: string | null
          }> | null
          ExperienceTenure?: {
            __typename?: 'experienceTenure'
            average: number
            longest: number
            shortest: number
          } | null
          currentJob?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            startDate?: any | null
            endDate?: any | null
            companyLogo?: string | null
            locationType?: string | null
            location?: string | null
            shortFormDesc?: any | null
            longFormDesc?: string | null
            searchShortFormDesc?: string | null
            searchLongFormDesc?: string | null
            industry?: IndustryEnum | null
            subIndustry?: string | null
            payType?: string | null
            jobPay?: number | null
            additionalComp?: boolean | null
            jobTitle?: string | null
            employerName?: string | null
            managementPosition?: boolean | null
            teamSize?: TeamSizeEnum | null
            workPlaceCandidate?: WorkPlaceCandidateEnum | null
            isCurrentJob?: boolean | null
            jobType?: JobTypeEnum | null
            isCurrentlyWorking?: boolean | null
            description?: string | null
          }> | null
          mostRecentJob?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            startDate?: any | null
            endDate?: any | null
            companyLogo?: string | null
            locationType?: string | null
            location?: string | null
            shortFormDesc?: any | null
            longFormDesc?: string | null
            searchShortFormDesc?: string | null
            searchLongFormDesc?: string | null
            industry?: IndustryEnum | null
            subIndustry?: string | null
            payType?: string | null
            jobPay?: number | null
            additionalComp?: boolean | null
            jobTitle?: string | null
            employerName?: string | null
            managementPosition?: boolean | null
            teamSize?: TeamSizeEnum | null
            workPlaceCandidate?: WorkPlaceCandidateEnum | null
            isCurrentJob?: boolean | null
            jobType?: JobTypeEnum | null
            isCurrentlyWorking?: boolean | null
            description?: string | null
          }> | null
          UploadedCandidateJobSeekerSkill?: Array<{
            __typename?: 'UploadedCandidateJobSeekerSkills'
            id: number
            sequenceNumber?: number | null
            level?: string | null
            name?: string | null
            yearsOfExp?: number | null
          }> | null
          UploadedCandidateVolunteerWork: Array<{
            __typename?: 'UploadedCandidateVolunteerWork'
            id: number
            volunteerJobTitle?: string | null
            organizationName?: string | null
            isCurrentlyWorking?: boolean | null
            roleType?: RoleTypeEnum | null
            startDate?: any | null
            endDate?: any | null
            description?: any | null
            searchDescription?: string | null
            location?: string | null
          }>
          EnrichedEmail: Array<{
            __typename?: 'EnrichedEmail'
            id: string
            emailAddress?: string | null
            enrichedEmailType?: EnrichedEmailTypeEnum | null
            uploadedCandidateId?: number | null
            recommended?: boolean | null
          }>
          EnrichedPhoneNumber: Array<{
            __typename?: 'EnrichedPhoneNumber'
            id: string
            phoneNumber?: string | null
            uploadedCandidateId?: number | null
            recommended?: boolean | null
          }>
        } | null
        ProfileDetails?: {
          __typename?: 'ProfileDetails'
          id: string
          phoneNumber?: string | null
          CandidateSource: Array<{
            __typename?: 'CandidateSource'
            id: number
            candidateSourceName?: {
              __typename?: 'CandidateSourceName'
              id: number
              name: string
              sourceCategory?: SourceCategoryEnum | null
              customSourceCategory?: {
                __typename?: 'CustomSourceCategory'
                id: number
                sourceCategoryName: string
              } | null
            } | null
          }>
        } | null
      } | null
      CandidateSource?: Array<{
        __typename?: 'CandidateSource'
        id: number
        candidateSourceName?: {
          __typename?: 'CandidateSourceName'
          id: number
          name: string
          sourceCategory?: SourceCategoryEnum | null
          customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
        } | null
      }> | null
      JobListing?: {
        __typename?: 'JobListing'
        id: number
        publicListingId?: string | null
        Requisition?: {
          __typename?: 'Requisition'
          id: string
          jobName?: string | null
          extRequisitionId?: string | null
        } | null
      } | null
      CandidateScorecard?: Array<{
        __typename?: 'CandidateScorecard'
        id: string
        status?: ScorecardStatusTypeEnum | null
        scorecardTemplateId?: number | null
      }> | null
    }>
    milestone: {
      __typename?: 'TemplateMilestone'
      id: string
      templatePipelineId?: number | null
      name?: NameEnum | null
      rankOrder?: number | null
      archived?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
    }
    stage: {
      __typename?: 'TemplateStage'
      id: string
      templatePipelineId?: number | null
      visibility?: TemplateStageVisibilityEnum | null
      name?: string | null
      templateMilestoneId?: number | null
      rankOrder?: number | null
      archived?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
    }
  }> | null
}

export type GetCandidateApplicationQueryVariables = Exact<{
  publicListingIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  matchScore?: InputMaybe<MatchScore>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  skills?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  lastActivity?: InputMaybe<LastActivity>
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum> | ApplicationStatusEnum>
  applicationStatusNotIn?: InputMaybe<Array<ApplicationStatusEnum> | ApplicationStatusEnum>
  customApplicationStatusIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum> | ApplicationTypeEnum>
  sourceName?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  medalistDesignation?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  creditedCompanyUserIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  companies?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  educationLevel?: InputMaybe<Array<EducationLevelEnum> | EducationLevelEnum>
  jobTitles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  majors?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  nonTraditionalStatus?: InputMaybe<Scalars['Boolean']['input']>
  schools?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  timezones?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  veteranStatus?: InputMaybe<Array<VeteranStatusEnum> | VeteranStatusEnum>
  willingToRelocate?: InputMaybe<Array<WillingToRelocateEnum> | WillingToRelocateEnum>
  yearsOfExperience?: InputMaybe<YearsOfExperience>
  requisitionId?: InputMaybe<Scalars['Int']['input']>
  profileType?: InputMaybe<ProfileTypeEnum>
  labels?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  search?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortByApplication>
  sortDirection?: InputMaybe<SortDirection>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
}>

export type GetCandidateApplicationQuery = {
  __typename?: 'Query'
  GetCandidateApplication?: Array<{
    __typename?: 'CandidateApplication'
    id: string
    matchScore?: number | null
    applicationStatus?: ApplicationStatusEnum | null
    applicationType?: string | null
    applicationCreationType?: string | null
    updatedAt?: any | null
    appliedAt?: any | null
    lastUpdatedStatusAt?: any | null
    templateStageId?: number | null
    jobListingId?: number | null
    averageRating?: number | null
    lastActivityDate?: any | null
    duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
    CandidateInterview?: Array<{
      __typename?: 'CandidateInterview'
      id: string
      stageId?: number | null
      status?: CandidateInterviewStatusEnum | null
    }> | null
    CustomApplicationStatus?: {
      __typename?: 'CustomApplicationStatus'
      id: string
      applicationStatusName: string
      iconType: IconTypeEnum
      iconUnicode?: string | null
      colorHexCode: string
      createdAt: any
      updatedAt: any
    } | null
    CustomCandidateApplicationFieldValues?: Array<{
      __typename?: 'CustomCandidateApplicationFieldValue'
      id: string
      value?: any | null
      updatedAt?: any | null
      customCandidateApplicationField?: {
        __typename?: 'CustomCandidateApplicationField'
        id: string
        name?: string | null
        type?: CustomCandidateFieldTypeEnum | null
        schema?: any | null
        visibility?: CustomFieldVisibilityEnum | null
        provider?: CustomFieldProviderEnum | null
        systemTokenName?: string | null
      } | null
    }> | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      profileType: ProfileTypeEnum
      CustomCandidateProfileFieldValues?: Array<{
        __typename?: 'CustomCandidateProfileFieldValue'
        id: string
        value?: any | null
        updatedAt?: any | null
        customCandidateProfileField?: {
          __typename?: 'CustomCandidateProfileField'
          id: string
          name?: string | null
          type?: CustomCandidateFieldTypeEnum | null
          schema?: any | null
          visibility?: CustomFieldVisibilityEnum | null
          provider?: CustomFieldProviderEnum | null
          systemTokenName?: string | null
        } | null
      }> | null
      CandidateLabels?: Array<{
        __typename?: 'CandidateLabel'
        id: string
        colorNumber: number
        labelName: string
      }> | null
      ProspectStatus?: {
        __typename?: 'TalentPoolProspectStatus'
        id: string
        colorNumber: number
        status: string
      } | null
      ProspectOwner?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
      CandidateApplicationRating: Array<{
        __typename?: 'CandidateApplicationRating'
        id: string
        score?: number | null
      }>
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
        mostRecentJob?: Array<{
          __typename?: 'Experience'
          id: number
          industry?: IndustryEnum | null
          jobTitle?: string | null
          employerName?: string | null
        }> | null
        currentJob?: Array<{
          __typename?: 'Experience'
          id: number
          jobTitle?: string | null
          employerName?: string | null
        }> | null
        highestEducation?: Array<{
          __typename?: 'Education'
          id: number
          educationLevel?: EducationLevelEnum | null
          institutionName?: string | null
        }> | null
        ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
        Address?: Array<{
          __typename?: 'Address'
          id: number
          country?: string | null
          city?: string | null
          state?: string | null
        }> | null
        EmailVerification?: Array<{
          __typename?: 'EmailVerification'
          id: number
          isPrimary?: boolean | null
          emailAddress?: string | null
          isVisibleToEmployers?: boolean | null
        }> | null
        JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; id: number; jobSeekerId?: number | null } | null
        ExperienceTenure?: {
          __typename?: 'experienceTenure'
          average: number
          longest: number
          shortest: number
        } | null
      } | null
      UploadedCandidate?: {
        __typename?: 'UploadedCandidate'
        id: number
        linkedinProfile?: string | null
        lastName?: string | null
        firstName?: string | null
        emailAddress?: string | null
        companyUserId?: number | null
        companyId?: number | null
        profileImage?: string | null
        profileUrl?: string | null
        uploadedCandidateType?: UploadedCandidateTypeEnum | null
        CandidateProfile?: {
          __typename?: 'CandidateProfile'
          id: string
          profileType: ProfileTypeEnum
          CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
        } | null
        UploadedCandidateWebsiteOrSocialMedia: Array<{
          __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
          id: number
          websiteURL: string
          type: WebsiteTypeEnum
        }>
        UploadedCandidateAchievement: Array<{
          __typename?: 'UploadedCandidateAchievement'
          id: number
          name?: string | null
          issuingAuthority?: string | null
          issueYear?: number | null
          description?: any | null
          searchDescription?: string | null
        }>
        UploadedCandidateCertificateOrLicense: Array<{
          __typename?: 'UploadedCandidateCertificateOrLicense'
          id: number
          name?: string | null
          issuingAuthority?: string | null
          issueYear?: number | null
          description?: any | null
          searchDescription?: string | null
        }>
        UploadedCandidateEducation?: Array<{
          __typename?: 'UploadedCandidateEducation'
          id: number
          institutionName?: string | null
          currentlyStudying?: boolean | null
          educationLevel?: EducationLevelEnum | null
          startDate?: any | null
          endDate?: any | null
          areasOfStudy?: any | null
          majors?: any | null
          minors?: any | null
          cumGPA?: number | null
          cumGPAScale?: number | null
          hideCumGPA?: boolean | null
          hideDepartmentGPA?: boolean | null
          departmentCumGPA?: number | null
          departmentCumGPAScale?: number | null
          additionalInformation?: string | null
        }> | null
        highestEducation?: Array<{
          __typename?: 'UploadedCandidateEducation'
          id: number
          institutionName?: string | null
          currentlyStudying?: boolean | null
          educationLevel?: EducationLevelEnum | null
          startDate?: any | null
          endDate?: any | null
          areasOfStudy?: any | null
          majors?: any | null
          minors?: any | null
          cumGPA?: number | null
          cumGPAScale?: number | null
          hideCumGPA?: boolean | null
          hideDepartmentGPA?: boolean | null
          departmentCumGPA?: number | null
          departmentCumGPAScale?: number | null
          additionalInformation?: string | null
        }> | null
        UploadedCandidateExperience?: Array<{
          __typename?: 'UploadedCandidateExperience'
          id: number
          startDate?: any | null
          endDate?: any | null
          companyLogo?: string | null
          locationType?: string | null
          location?: string | null
          shortFormDesc?: any | null
          longFormDesc?: string | null
          searchShortFormDesc?: string | null
          searchLongFormDesc?: string | null
          industry?: IndustryEnum | null
          subIndustry?: string | null
          payType?: string | null
          jobPay?: number | null
          additionalComp?: boolean | null
          jobTitle?: string | null
          employerName?: string | null
          managementPosition?: boolean | null
          teamSize?: TeamSizeEnum | null
          workPlaceCandidate?: WorkPlaceCandidateEnum | null
          isCurrentJob?: boolean | null
          jobType?: JobTypeEnum | null
          isCurrentlyWorking?: boolean | null
          description?: string | null
        }> | null
        ExperienceTenure?: {
          __typename?: 'experienceTenure'
          average: number
          longest: number
          shortest: number
        } | null
        currentJob?: Array<{
          __typename?: 'UploadedCandidateExperience'
          id: number
          startDate?: any | null
          endDate?: any | null
          companyLogo?: string | null
          locationType?: string | null
          location?: string | null
          shortFormDesc?: any | null
          longFormDesc?: string | null
          searchShortFormDesc?: string | null
          searchLongFormDesc?: string | null
          industry?: IndustryEnum | null
          subIndustry?: string | null
          payType?: string | null
          jobPay?: number | null
          additionalComp?: boolean | null
          jobTitle?: string | null
          employerName?: string | null
          managementPosition?: boolean | null
          teamSize?: TeamSizeEnum | null
          workPlaceCandidate?: WorkPlaceCandidateEnum | null
          isCurrentJob?: boolean | null
          jobType?: JobTypeEnum | null
          isCurrentlyWorking?: boolean | null
          description?: string | null
        }> | null
        mostRecentJob?: Array<{
          __typename?: 'UploadedCandidateExperience'
          id: number
          startDate?: any | null
          endDate?: any | null
          companyLogo?: string | null
          locationType?: string | null
          location?: string | null
          shortFormDesc?: any | null
          longFormDesc?: string | null
          searchShortFormDesc?: string | null
          searchLongFormDesc?: string | null
          industry?: IndustryEnum | null
          subIndustry?: string | null
          payType?: string | null
          jobPay?: number | null
          additionalComp?: boolean | null
          jobTitle?: string | null
          employerName?: string | null
          managementPosition?: boolean | null
          teamSize?: TeamSizeEnum | null
          workPlaceCandidate?: WorkPlaceCandidateEnum | null
          isCurrentJob?: boolean | null
          jobType?: JobTypeEnum | null
          isCurrentlyWorking?: boolean | null
          description?: string | null
        }> | null
        UploadedCandidateJobSeekerSkill?: Array<{
          __typename?: 'UploadedCandidateJobSeekerSkills'
          id: number
          sequenceNumber?: number | null
          level?: string | null
          name?: string | null
          yearsOfExp?: number | null
        }> | null
        UploadedCandidateVolunteerWork: Array<{
          __typename?: 'UploadedCandidateVolunteerWork'
          id: number
          volunteerJobTitle?: string | null
          organizationName?: string | null
          isCurrentlyWorking?: boolean | null
          roleType?: RoleTypeEnum | null
          startDate?: any | null
          endDate?: any | null
          description?: any | null
          searchDescription?: string | null
          location?: string | null
        }>
        EnrichedEmail: Array<{
          __typename?: 'EnrichedEmail'
          id: string
          emailAddress?: string | null
          enrichedEmailType?: EnrichedEmailTypeEnum | null
          uploadedCandidateId?: number | null
          recommended?: boolean | null
        }>
        EnrichedPhoneNumber: Array<{
          __typename?: 'EnrichedPhoneNumber'
          id: string
          phoneNumber?: string | null
          uploadedCandidateId?: number | null
          recommended?: boolean | null
        }>
      } | null
      ProfileDetails?: {
        __typename?: 'ProfileDetails'
        id: string
        phoneNumber?: string | null
        CandidateSource: Array<{
          __typename?: 'CandidateSource'
          id: number
          candidateSourceName?: {
            __typename?: 'CandidateSourceName'
            id: number
            name: string
            sourceCategory?: SourceCategoryEnum | null
            customSourceCategory?: {
              __typename?: 'CustomSourceCategory'
              id: number
              sourceCategoryName: string
            } | null
          } | null
        }>
      } | null
    } | null
    CandidateSource?: Array<{
      __typename?: 'CandidateSource'
      id: number
      candidateSourceName?: {
        __typename?: 'CandidateSourceName'
        id: number
        name: string
        sourceCategory?: SourceCategoryEnum | null
        customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
      } | null
    }> | null
    JobListing?: {
      __typename?: 'JobListing'
      id: number
      publicListingId?: string | null
      externalTitle?: string | null
      Requisition?: {
        __typename?: 'Requisition'
        id: string
        jobName?: string | null
        extRequisitionId?: string | null
      } | null
    } | null
    CandidateScorecard?: Array<{
      __typename?: 'CandidateScorecard'
      id: string
      status?: ScorecardStatusTypeEnum | null
      scorecardTemplateId?: number | null
    }> | null
    TemplateStage?: {
      __typename?: 'TemplateStage'
      id: string
      TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
    } | null
  }> | null
}

export type GetCandidatesToAdvanceOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>
  templateStageIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
  requisitionId: Scalars['Int']['input']
}>

export type GetCandidatesToAdvanceOptionsQuery = {
  __typename?: 'Query'
  GetCandidateApplicationPipelineView?: Array<{
    __typename?: 'CandidateApplicationPipelineView'
    candidateApplications: Array<{
      __typename?: 'CandidateApplication'
      id: string
      matchScore?: number | null
      applicationStatus?: ApplicationStatusEnum | null
      applicationType?: string | null
      applicationCreationType?: string | null
      updatedAt?: any | null
      appliedAt?: any | null
      lastUpdatedStatusAt?: any | null
      templateStageId?: number | null
      jobListingId?: number | null
      averageRating?: number | null
      lastActivityDate?: any | null
      duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
      CandidateInterview?: Array<{
        __typename?: 'CandidateInterview'
        id: string
        stageId?: number | null
        status?: CandidateInterviewStatusEnum | null
      }> | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
          EmailVerification?: Array<{
            __typename?: 'EmailVerification'
            id: number
            isPrimary?: boolean | null
            emailAddress?: string | null
          }> | null
        } | null
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          firstName?: string | null
          lastName?: string | null
          emailAddress?: string | null
          EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
        } | null
      } | null
    }>
  }> | null
}

export type CountCandidateApplicationsQueryVariables = Exact<{
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
}>

export type CountCandidateApplicationsQuery = {
  __typename?: 'Query'
  InterviewRequests?: { __typename?: 'countOutput'; count: number } | null
  ActiveApplications?: { __typename?: 'countOutput'; count: number } | null
  InterviewScheduled?: { __typename?: 'countOutput'; count: number } | null
  TotalApplications?: { __typename?: 'countOutput'; count: number } | null
}

export type DetailCandidateApplicationQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type DetailCandidateApplicationQuery = {
  __typename?: 'Query'
  GetCandidateApplication?: Array<{
    __typename?: 'CandidateApplication'
    applicationStatus?: ApplicationStatusEnum | null
    candidateProfileId?: number | null
    jobListingId?: number | null
    templateStageId?: number | null
    CandidateProfile?: { __typename?: 'CandidateProfile'; scalisUserId?: number | null } | null
    JobListing?: {
      __typename?: 'JobListing'
      externalTitle?: string | null
      JobListingJobPipeline?: {
        __typename?: 'JobListingJobPipeline'
        JobPipeline?: {
          __typename?: 'JobPipeline'
          title?: string | null
          TemplatePipeline?: {
            __typename?: 'TemplatePipeline'
            TemplateMilestones?: Array<{
              __typename?: 'TemplateMilestone'
              TemplateStage?: Array<{
                __typename?: 'TemplateStage'
                id: string
                name?: string | null
                visibility?: TemplateStageVisibilityEnum | null
                templatePipelineId?: number | null
                templateMilestoneId?: number | null
                rankOrder?: number | null
                archived?: boolean | null
                createdAt?: any | null
                updatedAt?: any | null
              }> | null
            }> | null
          } | null
        } | null
      } | null
    } | null
    Company?: {
      __typename?: 'Company'
      CompanyInfo?: { __typename?: 'CompanyInfo'; companyName?: string | null; logo?: string | null; id: string } | null
    } | null
  }> | null
}

export type DetailJobListingQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  jobRequisitionId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type DetailJobListingQuery = {
  __typename?: 'Query'
  GetJobListing?: Array<{
    __typename?: 'JobListing'
    externalTitle?: string | null
    publicDescription?: string | null
    postedAt?: any | null
    workplaceType?: WorkplaceTypeEnum | null
    Requisition?: {
      __typename?: 'Requisition'
      benefits?: any | null
      jobLevel?: JobLevelEnum | null
      jobType?: JobTypeEnum | null
      maxPay?: number | null
      minPay?: number | null
      payType?: PayTypeEnum | null
      isIncomplete: boolean
      Company?: {
        __typename?: 'Company'
        Address: Array<{
          __typename?: 'Address'
          city?: string | null
          country?: string | null
          state?: string | null
          id: number
          addressLine1?: string | null
          addressLine2?: string | null
          postalCode?: string | null
          timeZone?: string | null
          longitude?: string | null
          latitude?: string | null
        }>
        CompanyInfo?: {
          __typename?: 'CompanyInfo'
          companyName?: string | null
          logo?: string | null
          id: string
        } | null
      } | null
      RequisitionSkills?: Array<{
        __typename?: 'RequisitionSkill'
        id: string
        requisitionId?: number | null
        skillId?: number | null
        displayName?: string | null
        level?: string | null
        yearsOfExp?: number | null
        sequenceNumber?: number | null
        createdAt?: any | null
        updatedAt?: any | null
        skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
      }> | null
    } | null
  }> | null
}

export type ListApplicantNoteQueryVariables = Exact<{
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
}>

export type ListApplicantNoteQuery = {
  __typename?: 'Query'
  GetApplicantNotes?: Array<{
    __typename?: 'ApplicantNotes'
    id: string
    createdAt?: any | null
    candidateApplicationId?: number | null
    scalisUserId?: number | null
    UserNote?: { __typename?: 'UserNote'; id: string; noteText?: any | null } | null
  }> | null
}

export type ListBookmarkedJobQueryVariables = Exact<{ [key: string]: never }>

export type ListBookmarkedJobQuery = {
  __typename?: 'Query'
  GetBookmarkedJob?: Array<{
    __typename?: 'BookmarkedJobResultsType'
    id: string
    jobListingId?: string | null
    publicListingId?: string | null
    scalisUserId?: string | null
    source: string
    title: string
    company: { __typename?: 'BookmarkedJobCompany'; logo?: string | null; name: string }
    locations: Array<{
      __typename?: 'BookmarkedJobLocations'
      city?: string | null
      country?: string | null
      state?: string | null
    }>
  }> | null
}

export type ListCandidateApplicationQueryVariables = Exact<{
  applicationStatus?: InputMaybe<Array<ApplicationStatusEnum> | ApplicationStatusEnum>
  applicationType?: InputMaybe<Array<ApplicationTypeEnum> | ApplicationTypeEnum>
  id?: InputMaybe<Scalars['Int']['input']>
  scalisUserId?: InputMaybe<Scalars['Int']['input']>
}>

export type ListCandidateApplicationQuery = {
  __typename?: 'Query'
  GetCandidateApplication?: Array<{
    __typename?: 'CandidateApplication'
    applicationCreationType?: string | null
    applicationStatus?: ApplicationStatusEnum | null
    applicationTimestamp?: any | null
    applicationType?: string | null
    appliedAt?: any | null
    candidateProfileId?: number | null
    createdAt?: any | null
    companyId?: number | null
    jobListingId?: number | null
    deleted?: any | null
    id: string
    matchScore?: number | null
    lastUpdatedStatusAt?: any | null
    templateStageId?: number | null
    updatedAt?: any | null
    viewedProfile?: boolean | null
    viewedAt?: any | null
    Company?: {
      __typename?: 'Company'
      createdAt?: any | null
      externalId?: string | null
      id: string
      lastActivity?: any | null
      subdomain?: string | null
      updatedAt?: any | null
      CompanyInfo?: {
        __typename?: 'CompanyInfo'
        companyId?: number | null
        companyName?: string | null
        id: string
        logo?: string | null
        atsNeeds?: string | null
        companyType?: string | null
        employeeCount?: EmployeeCountEnum | null
        createdAt?: any | null
        hearAboutUs?: string | null
        industry?: IndustryEnum | null
        hiringNeeds?: string | null
        phoneNumber?: string | null
        positionsToFill?: PositionsToFillEnum | null
        updatedAt?: any | null
        recruitingOrStaffing?: boolean | null
        subIndustry?: SubIndustryTypeEnum | null
        usingATS?: boolean | null
        website?: string | null
        yearsInOperation?: number | null
      } | null
      Address: Array<{
        __typename?: 'Address'
        activeStatus?: boolean | null
        addressLine1?: string | null
        addressLine2?: string | null
        addressType?: string | null
        city?: string | null
        contactName?: string | null
        createdAt?: any | null
        country?: string | null
        id: number
        latitude?: string | null
        longitude?: string | null
        postalCode?: string | null
        scalisUserId?: number | null
        timeZone?: string | null
        state?: string | null
        updatedAt?: any | null
      }>
      CompanyDepartment: Array<{
        __typename?: 'CompanyDepartment'
        companyId?: number | null
        createdAt?: any | null
        departmentName?: string | null
        externalId?: string | null
        id: string
        subordinateTo?: number | null
        updatedAt?: any | null
      }>
      CompanyOffice: Array<{
        __typename?: 'CompanyOffice'
        companyId?: number | null
        createdAt?: any | null
        externalId?: string | null
        id: string
        officeName?: string | null
        updatedAt?: any | null
      }>
    } | null
    JobListing?: {
      __typename?: 'JobListing'
      acceptingCandidates?: boolean | null
      deletedAt?: any | null
      externalTitle?: string | null
      id: number
      internalMatchingDescription?: string | null
      jobRequisitionId?: number | null
      listingTitle?: string | null
      postedAt?: any | null
      publicDescription?: string | null
      publicListingId?: string | null
      searchInternalMatchingDescription?: string | null
      searchPublicDescription?: string | null
      stage?: StageEnum | null
      workplaceType?: WorkplaceTypeEnum | null
      JobListingJobPipeline?: {
        __typename?: 'JobListingJobPipeline'
        id: string
        jobListingId?: number | null
        jobPipelineId?: number | null
        JobPipeline?: {
          __typename?: 'JobPipeline'
          id: string
          title?: string | null
          jobRequisitionId?: number | null
          templatePipelineId?: number | null
        } | null
      } | null
    } | null
    TemplateStage?: {
      __typename?: 'TemplateStage'
      archived?: boolean | null
      createdAt?: any | null
      id: string
      name?: string | null
      rankOrder?: number | null
      templateMilestoneId?: number | null
      templatePipelineId?: number | null
      updatedAt?: any | null
      visibility?: TemplateStageVisibilityEnum | null
      TemplateMilestone?: {
        __typename?: 'TemplateMilestone'
        archived?: boolean | null
        id: string
        name?: NameEnum | null
        rankOrder?: number | null
        templatePipelineId?: number | null
      } | null
    } | null
  }> | null
}

export type GetBookmarkedJobQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortByBoomarkedJob>
  sortDirection?: InputMaybe<SortDirection>
  page?: InputMaybe<Scalars['Int']['input']>
}>

export type GetBookmarkedJobQuery = {
  __typename?: 'Query'
  GetBookmarkedJob?: Array<{
    __typename?: 'BookmarkedJobResultsType'
    id: string
    jobListingId?: string | null
    publicListingId?: string | null
    source: string
    title: string
    company: { __typename?: 'BookmarkedJobCompany'; logo?: string | null; name: string }
    locations: Array<{
      __typename?: 'BookmarkedJobLocations'
      city?: string | null
      country?: string | null
      state?: string | null
    }>
  }> | null
  CountBookmarkedJob?: { __typename?: 'countBookmarkedJob'; count: number } | null
}

export type GetJobseekerDashboardApplicationsQueryVariables = Exact<{
  limit?: Scalars['Int']['input']
  page?: Scalars['Int']['input']
  sortBy?: InputMaybe<SortByApplication>
  sortDirection?: InputMaybe<SortDirection>
  search?: InputMaybe<Scalars['String']['input']>
}>

export type GetJobseekerDashboardApplicationsQuery = {
  __typename?: 'Query'
  GetCandidateApplication?: Array<{
    __typename?: 'CandidateApplication'
    id: string
    applicationStatus?: ApplicationStatusEnum | null
    appliedAt?: any | null
    applicationType?: string | null
    Company?: {
      __typename?: 'Company'
      Address: Array<{ __typename?: 'Address'; city?: string | null; state?: string | null; country?: string | null }>
      CompanyInfo?: { __typename?: 'CompanyInfo'; companyName?: string | null; logo?: string | null } | null
    } | null
    JobListing?: {
      __typename?: 'JobListing'
      externalTitle?: string | null
      publicListingId?: string | null
      id: number
      stateAndOrCountry?: string | null
      workplaceType?: WorkplaceTypeEnum | null
      Address?: Array<{
        __typename?: 'Address'
        timeZone?: string | null
        state?: string | null
        postalCode?: string | null
        longitude?: string | null
        latitude?: string | null
        id: number
        country?: string | null
        city?: string | null
        addressType?: string | null
        addressLine2?: string | null
        addressLine1?: string | null
        activeStatus?: boolean | null
      }> | null
    } | null
    LastPublicTemplateStage?: {
      __typename?: 'TemplateStage'
      id: string
      name?: string | null
      TemplateMilestone?: { __typename?: 'TemplateMilestone'; name?: NameEnum | null } | null
    } | null
    TemplateStage?: {
      __typename?: 'TemplateStage'
      name?: string | null
      id: string
      TemplateMilestone?: { __typename?: 'TemplateMilestone'; name?: NameEnum | null; id: string } | null
    } | null
  }> | null
  CountCandidateApplication?: { __typename?: 'countOutput'; count: number } | null
}

export type GetJobseekerDashboardMetricsQueryVariables = Exact<{ [key: string]: never }>

export type GetJobseekerDashboardMetricsQuery = {
  __typename?: 'Query'
  active?: { __typename?: 'countOutput'; count: number } | null
  bookmarked?: { __typename?: 'countBookmarkedJob'; count: number } | null
  interviews?: { __typename?: 'countOutput'; count: number } | null
  invites?: { __typename?: 'countOutput'; count: number } | null
  rejected?: { __typename?: 'countOutput'; count: number } | null
  total?: { __typename?: 'countOutput'; count: number } | null
}

export type GetExternalJobApplicationQueryVariables = Exact<{
  status?: InputMaybe<Array<ExternalApplicationStatus> | ExternalApplicationStatus>
  search?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  sortBy?: InputMaybe<SortByExternalApplication>
  sortDirection?: InputMaybe<SortDirection>
}>

export type GetExternalJobApplicationQuery = {
  __typename?: 'Query'
  GetExternalJobApplication?: Array<{
    __typename?: 'ExternalJobApplication'
    status?: ExternalApplicationStatus | null
    location: string
    jobUrl: string
    jobTitle: string
    jobId: string
    id: string
    employerName: string
    appliedAt?: any | null
    updatedAt?: any | null
  }> | null
  CountExternalJobApplication?: { __typename?: 'countOutput'; count: number } | null
}

export type GetJobSeekerJobInvitesQueryVariables = Exact<{
  listingTitleSearch?: InputMaybe<Scalars['String']['input']>
  sortBy?: InputMaybe<SortByJobInvite>
  sortDirection?: InputMaybe<SortDirection>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetJobSeekerJobInvitesQuery = {
  __typename?: 'Query'
  CountJobInvite?: { __typename?: 'countOutput'; count: number } | null
  GetJobInvite?: Array<{
    __typename?: 'JobInvite'
    token?: number | null
    sentAt?: any | null
    jobListingId?: number | null
    inviteStatus?: InviteStatusEnum | null
    id: string
    dismissed?: boolean | null
    candidateApplicationId?: number | null
    JobListing?: {
      __typename?: 'JobListing'
      id: number
      listingTitle?: string | null
      publicListingId?: string | null
      externalTitle?: string | null
      Requisition?: {
        __typename?: 'Requisition'
        Company?: {
          __typename?: 'Company'
          id: string
          CompanyInfo?: { __typename?: 'CompanyInfo'; companyName?: string | null; id: string } | null
        } | null
      } | null
    } | null
  }> | null
}

export type GetScalisUserQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetScalisUserQuery = {
  __typename?: 'Query'
  GetScalisUser?: {
    __typename?: 'ScalisUser'
    id: number
    completedAt?: any | null
    currentStage?: string | null
    profileImage?: string | null
    Address?: Array<{
      __typename?: 'Address'
      activeStatus?: boolean | null
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      country?: string | null
      contactName?: string | null
      addressType?: string | null
      createdAt?: any | null
      id: number
      latitude?: string | null
      longitude?: string | null
      state?: string | null
      timeZone?: string | null
      updatedAt?: any | null
      postalCode?: string | null
    }> | null
    JobSeekerInfo?: {
      __typename?: 'JobSeekerInfo'
      canStartNewJob?: CanStartNewJobEnum | null
      consideringOffers?: boolean | null
      currPrefRoles?: any | null
      createdAt?: any | null
      desiredPay?: number | null
      employStatus?: boolean | null
      id: number
      jobSeekerId?: number | null
      jobLevel?: string | null
      jobType?: string | null
      locationsWillRelocate?: any | null
      jobTypePref?: JobTypePrefEnum | null
      messageUserId?: string | null
      nonTraditionalStatus?: boolean | null
      searchStatus?: string | null
      payType?: string | null
      searchingJobs?: boolean | null
      teamSize?: TeamSizeEnum | null
      updatedAt?: any | null
      tryingToRelocate?: string | null
      yearsOfExperience?: number | null
      willingToRelocate?: string | null
      yearsInWorkforce?: number | null
    } | null
    ScalisUserUploadedDocument?: Array<{
      __typename?: 'ScalisUserUploadedDocument'
      id: number
      documentPath?: string | null
      documentName?: string | null
      documentType: DocumentTypeEnum
      createdAt: any
      deletedAt?: any | null
    }> | null
  } | null
}

export type ListJobQueryVariables = Exact<{ [key: string]: never }>

export type ListJobQuery = {
  __typename?: 'Query'
  GetJobListing?: Array<{
    __typename?: 'JobListing'
    acceptingCandidates?: boolean | null
    deletedAt?: any | null
    externalTitle?: string | null
    id: number
    internalMatchingDescription?: string | null
    jobRequisitionId?: number | null
    listingTitle?: string | null
    postedAt?: any | null
    publicDescription?: string | null
    publicListingId?: string | null
    searchPublicDescription?: string | null
    searchInternalMatchingDescription?: string | null
    stage?: StageEnum | null
    workplaceType?: WorkplaceTypeEnum | null
    Requisition?: {
      __typename?: 'Requisition'
      jobLevel?: JobLevelEnum | null
      jobType?: JobTypeEnum | null
      Company?: {
        __typename?: 'Company'
        Address: Array<{
          __typename?: 'Address'
          id: number
          addressLine1?: string | null
          addressLine2?: string | null
          city?: string | null
          state?: string | null
          country?: string | null
          postalCode?: string | null
          timeZone?: string | null
          longitude?: string | null
          latitude?: string | null
        }>
        CompanyInfo?: {
          __typename?: 'CompanyInfo'
          companyId?: number | null
          id: string
          companyName?: string | null
          logo?: string | null
        } | null
      } | null
    } | null
  }> | null
}

export type LoggedUserQueryVariables = Exact<{ [key: string]: never }>

export type LoggedUserQuery = {
  __typename?: 'Query'
  Me?: {
    __typename?: 'ScalisUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    completedAt?: any | null
    currentStage?: string | null
    profileImage?: string | null
    JobSeekerInfo?: { __typename?: 'JobSeekerInfo'; aboutMe?: string | null } | null
    Address?: Array<{
      __typename?: 'Address'
      city?: string | null
      state?: string | null
      country?: string | null
    }> | null
    Achievement?: Array<{
      __typename?: 'Achievement'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
    }> | null
    CertificateOrLicense?: Array<{
      __typename?: 'CertificateOrLicense'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
    }> | null
    JobSeekerSkill?: Array<{
      __typename?: 'JobSeekerSkills'
      id: number
      sequenceNumber?: number | null
      level?: string | null
      name?: string | null
      yearsOfExp?: number | null
    }> | null
    DemographicInfo?: Array<{
      __typename?: 'DemographicInfo'
      gender?: GenderEnum | null
      raceEthnicity?: string | null
      veteranStatus?: VeteranStatusEnum | null
    }> | null
    WebsiteOrSocialMedia?: Array<{ __typename?: 'WebsiteOrSocialMedia'; id: number; websiteURL: string }> | null
    VolunteerWork?: Array<{
      __typename?: 'VolunteerWork'
      id: number
      roleType?: RoleTypeEnum | null
      volunteerJobTitle?: string | null
      organizationName?: string | null
      location?: string | null
      startDate?: any | null
      isCurrentlyWorking?: boolean | null
      description?: any | null
    }> | null
    Experience?: Array<{
      __typename?: 'Experience'
      id: number
      jobTitle?: string | null
      employerName?: string | null
      longFormDesc?: string | null
      startDate?: any | null
      endDate?: any | null
      jobType?: JobTypeEnum | null
      location?: string | null
      locationType?: string | null
      description?: string | null
      isCurrentlyWorking?: boolean | null
      isCurrentJob?: boolean | null
    }> | null
    Education?: Array<{
      __typename?: 'Education'
      id: number
      institutionName?: string | null
      educationLevel?: EducationLevelEnum | null
      areasOfStudy?: any | null
      startDate?: any | null
      endDate?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
    }> | null
  } | null
}

export type GetChatUsersJsv2QueryVariables = Exact<{ [key: string]: never }>

export type GetChatUsersJsv2Query = {
  __typename?: 'Query'
  GetChatUsersJSV2: Array<{
    __typename?: 'ChatUserInfoJS'
    firstName: string
    lastName: string
    userId?: number | null
  }>
}

export type GetChatUsersV2QueryVariables = Exact<{ [key: string]: never }>

export type GetChatUsersV2Query = {
  __typename?: 'Query'
  GetChatUsersV2: Array<{ __typename?: 'ChatUserInfo'; firstName: string; lastName: string; userId?: number | null }>
}

export type GetChatsJsv2QueryVariables = Exact<{ [key: string]: never }>

export type GetChatsJsv2Query = {
  __typename?: 'Query'
  GetChatsJSV2: Array<{
    __typename?: 'ChatInfoJS'
    firstName?: string | null
    lastName?: string | null
    companyName?: string | null
    chatId?: string | null
    userId?: number | null
  }>
}

export type GetChatsV2QueryVariables = Exact<{ [key: string]: never }>

export type GetChatsV2Query = {
  __typename?: 'Query'
  GetChatsV2: Array<{
    __typename?: 'ChatInfo'
    firstName: string
    lastName: string
    userId?: number | null
    chatId?: string | null
  }>
}

export type CreateCandidateOfferFileMutationVariables = Exact<{
  input: CreateCandidateOfferFileInput
}>

export type CreateCandidateOfferFileMutation = {
  __typename?: 'Mutation'
  CreateCandidateOfferFile: Array<{ __typename?: 'CandidateOfferFile'; id: number }>
}

export type DeleteCandidateOfferFileMutationVariables = Exact<{
  input: DeleteCandidateOfferFileInput
}>

export type DeleteCandidateOfferFileMutation = {
  __typename?: 'Mutation'
  DeleteCandidateOfferFile: { __typename?: 'CandidateOfferFile'; id: number }
}

export type GetCandidateOfferCustomFieldQueryVariables = Exact<{
  input: GetCandidateOfferCustomFieldInput
}>

export type GetCandidateOfferCustomFieldQuery = {
  __typename?: 'Query'
  GetCandidateOfferCustomField?: Array<{
    __typename?: 'CandidateOfferCustomField'
    id: number
    fieldValue?: any | null
    candidateOfferVersionId: number
    offerCustomFieldId: number
  }> | null
}

export type GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables = Exact<{
  input: GetCandidateOfferVersionEmbeddedClaimUrlInput
}>

export type GetCandidateOfferVersionEmbeddedClaimUrlQuery = {
  __typename?: 'Query'
  GetCandidateOfferVersionEmbeddedClaimUrl: {
    __typename?: 'GetCandidateOfferVersionEmbeddedClaimUrlResult'
    clientId?: string | null
    claimUrl?: string | null
    signatureRequestId?: string | null
  }
}

export type GetCandidateOfferQueryVariables = Exact<{
  candidateApplicationId: Scalars['Int']['input']
}>

export type GetCandidateOfferQuery = {
  __typename?: 'Query'
  GetCandidateOffer?: Array<{
    __typename?: 'CandidateOffer'
    id: number
    CandidateOfferVersion?: Array<{
      __typename?: 'CandidateOfferVersion'
      id: number
      candidateOfferId: number
      version: number
      candidateName: string
      jobTitle: string
      manager?: string | null
      startDate?: any | null
      jobType: JobTypeEnum
      payType: PayTypeEnum
      benefits?: any | null
      expirationDate?: any | null
      companyOfficeId?: number | null
      compensation: number
      additionalCompensation?: any | null
      offerStatus: OfferStatusEnum
      lastUpdatedStatusAt?: any | null
      createdAt?: any | null
      CandidateOfferCustomField?: Array<{
        __typename?: 'CandidateOfferCustomField'
        id: number
        fieldValue?: any | null
        OfferCustomField: {
          __typename?: 'OfferCustomField'
          id: number
          fieldName: string
          fieldConfigurationType: CustomFieldInputTypeEnum
          triggerNewOfferVersion: boolean
        }
      }> | null
      CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
      CandidateOfferFile?: Array<{
        __typename?: 'CandidateOfferFile'
        id: number
        fileName: string
        filePath: string
        fileType: OfferFileTypeEnum
        createdAt?: any | null
      }> | null
      CandidateOfferVersionSignature?: Array<{
        __typename?: 'CandidateOfferVersionSignature'
        id: number
        emailAddress: string
        name?: string | null
        signedAt?: any | null
        viewedAt?: any | null
        createdAt?: any | null
      }> | null
    }> | null
  }> | null
}

export type CandidateOfferVersionFragment = {
  __typename?: 'CandidateOfferVersion'
  id: number
  candidateOfferId: number
  version: number
  candidateName: string
  jobTitle: string
  manager?: string | null
  startDate?: any | null
  jobType: JobTypeEnum
  payType: PayTypeEnum
  benefits?: any | null
  expirationDate?: any | null
  companyOfficeId?: number | null
  compensation: number
  additionalCompensation?: any | null
  offerStatus: OfferStatusEnum
  lastUpdatedStatusAt?: any | null
  createdAt?: any | null
  CandidateOfferCustomField?: Array<{
    __typename?: 'CandidateOfferCustomField'
    id: number
    fieldValue?: any | null
    OfferCustomField: {
      __typename?: 'OfferCustomField'
      id: number
      fieldName: string
      fieldConfigurationType: CustomFieldInputTypeEnum
      triggerNewOfferVersion: boolean
    }
  }> | null
  CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
  CandidateOfferFile?: Array<{
    __typename?: 'CandidateOfferFile'
    id: number
    fileName: string
    filePath: string
    fileType: OfferFileTypeEnum
    createdAt?: any | null
  }> | null
  CandidateOfferVersionSignature?: Array<{
    __typename?: 'CandidateOfferVersionSignature'
    id: number
    emailAddress: string
    name?: string | null
    signedAt?: any | null
    viewedAt?: any | null
    createdAt?: any | null
  }> | null
}

export type GetCompanyOfficeListQueryVariables = Exact<{ [key: string]: never }>

export type GetCompanyOfficeListQuery = {
  __typename?: 'Query'
  ListCompanyOffices?: Array<{ __typename?: 'CompanyOffice'; id: string; officeName?: string | null }> | null
}

export type GetOfferLetterDocumentTemplateQueryVariables = Exact<{ [key: string]: never }>

export type GetOfferLetterDocumentTemplateQuery = {
  __typename?: 'Query'
  GetOfferDocumentTemplate?: Array<{
    __typename?: 'OfferDocumentTemplate'
    id: string
    documentTemplateName: string
    documentTemplateText: string
  }> | null
}

export type OfferDocumentTemplateFragment = {
  __typename?: 'OfferDocumentTemplate'
  id: string
  documentTemplateName: string
  documentTemplateText: string
}

export type GetMyProfileQueryVariables = Exact<{ [key: string]: never }>

export type GetMyProfileQuery = {
  __typename?: 'Query'
  Me?: {
    __typename?: 'ScalisUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    profileImage?: string | null
    EmailVerification?: Array<{ __typename?: 'EmailVerification'; id: number; emailAddress?: string | null }> | null
  } | null
}

export type SendCandidateOfferMutationVariables = Exact<{
  input: SendCandidateOfferInput
}>

export type SendCandidateOfferMutation = { __typename?: 'Mutation'; SendCandidateOffer: boolean }

export type CandidateOfferVersionSignatureSendEmailReminderMutationVariables = Exact<{
  input: CandidateOfferVersionSignatureSendReminderInput
}>

export type CandidateOfferVersionSignatureSendEmailReminderMutation = {
  __typename?: 'Mutation'
  CandidateOfferVersionSignatureSendEmailReminder: Array<{
    __typename?: 'CandidateOfferVersionSignaturesSendEmailReminderResult'
    id: number
    emailAddress: string
    error?: string | null
  }>
}

export type UpdateCandidateOfferVersionStatusMutationVariables = Exact<{
  input: UpdateCandidateOfferVersionStatusInput
}>

export type UpdateCandidateOfferVersionStatusMutation = {
  __typename?: 'Mutation'
  UpdateCandidateOfferVersionStatus: {
    __typename?: 'CandidateOfferVersion'
    id: number
    candidateOfferId: number
    version: number
    candidateName: string
    jobTitle: string
    manager?: string | null
    startDate?: any | null
    jobType: JobTypeEnum
    payType: PayTypeEnum
    benefits?: any | null
    expirationDate?: any | null
    companyOfficeId?: number | null
    compensation: number
    additionalCompensation?: any | null
    offerStatus: OfferStatusEnum
    lastUpdatedStatusAt?: any | null
    createdAt?: any | null
  }
}

export type UpsertCandidateOfferCustomFieldMutationVariables = Exact<{
  input: UpsertCandidateOfferCustomFieldInput
}>

export type UpsertCandidateOfferCustomFieldMutation = {
  __typename?: 'Mutation'
  UpsertCandidateOfferCustomField?: {
    __typename?: 'CandidateOfferCustomField'
    id: number
    fieldValue?: any | null
    candidateOfferVersionId: number
    offerCustomFieldId: number
  } | null
}

export type UpsertCandidateOfferFileMutationVariables = Exact<{
  input: UpsertCandidateOfferFileInput
}>

export type UpsertCandidateOfferFileMutation = {
  __typename?: 'Mutation'
  UpsertCandidateOfferFile?: { __typename?: 'CandidateOfferFile'; id: number } | null
}

export type UpsertCandidateOfferVersionMutationVariables = Exact<{
  input: UpsertCandidateOfferVersionInput
}>

export type UpsertCandidateOfferVersionMutation = {
  __typename?: 'Mutation'
  UpsertCandidateOfferVersion?: {
    __typename?: 'CandidateOfferVersion'
    id: number
    offerStatus: OfferStatusEnum
    CandidateOfferVersionSignature?: Array<{
      __typename?: 'CandidateOfferVersionSignature'
      id: number
      emailAddress: string
      name?: string | null
      signedAt?: any | null
      viewedAt?: any | null
      createdAt?: any | null
    }> | null
  } | null
}

export type UpsertCandidateOfferMutationVariables = Exact<{
  input: UpsertCandidateOfferInput
}>

export type UpsertCandidateOfferMutation = {
  __typename?: 'Mutation'
  UpsertCandidateOffer?: {
    __typename?: 'CandidateOffer'
    id: number
    CandidateOfferVersion?: Array<{
      __typename?: 'CandidateOfferVersion'
      id: number
      candidateOfferId: number
      version: number
      candidateName: string
      jobTitle: string
      manager?: string | null
      startDate?: any | null
      jobType: JobTypeEnum
      payType: PayTypeEnum
      benefits?: any | null
      expirationDate?: any | null
      companyOfficeId?: number | null
      compensation: number
      additionalCompensation?: any | null
      offerStatus: OfferStatusEnum
      lastUpdatedStatusAt?: any | null
      createdAt?: any | null
      CandidateOfferCustomField?: Array<{
        __typename?: 'CandidateOfferCustomField'
        id: number
        fieldValue?: any | null
        OfferCustomField: {
          __typename?: 'OfferCustomField'
          id: number
          fieldName: string
          fieldConfigurationType: CustomFieldInputTypeEnum
          triggerNewOfferVersion: boolean
        }
      }> | null
      CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
      CandidateOfferFile?: Array<{
        __typename?: 'CandidateOfferFile'
        id: number
        fileName: string
        filePath: string
        fileType: OfferFileTypeEnum
        createdAt?: any | null
      }> | null
      CandidateOfferVersionSignature?: Array<{
        __typename?: 'CandidateOfferVersionSignature'
        id: number
        emailAddress: string
        name?: string | null
        signedAt?: any | null
        viewedAt?: any | null
        createdAt?: any | null
      }> | null
    }> | null
  } | null
}

export type GetPlaceQueryVariables = Exact<{
  placeId: Scalars['String']['input']
}>

export type GetPlaceQuery = {
  __typename?: 'Query'
  GetPlace: {
    __typename?: 'place'
    addressComponents: Array<{
      __typename?: 'addressComponent'
      longText?: string | null
      shortText?: string | null
      types?: Array<string> | null
    }>
    location: { __typename?: 'location'; latitude: number; longitude: number }
  }
}

export type GetPlacesPredictionQueryVariables = Exact<{
  input: Scalars['String']['input']
}>

export type GetPlacesPredictionQuery = {
  __typename?: 'Query'
  GetPlacesPrediction: Array<{ __typename?: 'placePrediction'; placeId: string; description: string }>
}

export type GetListReferralsQueryVariables = Exact<{
  input?: InputMaybe<FilterReferralsInput>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetListReferralsQuery = {
  __typename?: 'Query'
  ListReferrals: Array<{
    __typename?: 'UploadedCandidate'
    id: number
    firstName?: string | null
    lastName?: string | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      ProfileDetails?: {
        __typename?: 'ProfileDetails'
        id: string
        CandidateSource: Array<{
          __typename?: 'CandidateSource'
          id: number
          companyUser?: {
            __typename?: 'CompanyUser'
            id: string
            UserInvitation?: {
              __typename?: 'UserInvitation'
              ScalisUser?: {
                __typename?: 'ScalisUser'
                id: number
                activeStatus?: boolean | null
                profileImage?: string | null
                firstName?: string | null
                lastName?: string | null
              } | null
            } | null
          } | null
          candidateSourceName?: {
            __typename?: 'CandidateSourceName'
            id: number
            name: string
            sourceCategory?: SourceCategoryEnum | null
            customSourceCategory?: {
              __typename?: 'CustomSourceCategory'
              id: number
              sourceCategoryName: string
            } | null
          } | null
        }>
      } | null
      CandidateApplication: Array<{
        __typename?: 'CandidateApplication'
        id: string
        createdAt?: any | null
        updatedAt?: any | null
        applicationStatus?: ApplicationStatusEnum | null
        JobListing?: {
          __typename?: 'JobListing'
          id: number
          externalTitle?: string | null
          acceptingCandidates?: boolean | null
          publicListingId?: string | null
        } | null
        TemplateStage?: {
          __typename?: 'TemplateStage'
          id: string
          name?: string | null
          TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
        } | null
      }>
    } | null
  }>
}

export type GetReferralCountQueryVariables = Exact<{
  input?: InputMaybe<FilterReferralsInput>
}>

export type GetReferralCountQuery = {
  __typename?: 'Query'
  CountReferrals: { __typename?: 'ReferralsCount'; count: number }
}

export type GetReferralsStatsQueryVariables = Exact<{
  input: FilterReferralsInput
}>

export type GetReferralsStatsQuery = {
  __typename?: 'Query'
  ReferralsStats: {
    __typename?: 'ReferralsStats'
    totalReferrals: number
    myReferrals: number
    totalReferralsByMilestone: any
  }
}

export type ReplaceTokensQueryVariables = Exact<{
  input: ReplaceTokensInput
}>

export type ReplaceTokensQuery = {
  __typename?: 'Query'
  ReplaceTokens?: { __typename?: 'ReplaceTokensOutput'; result: string } | null
}

export type GetCoreReportCsvQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetCoreReportCsvQuery = {
  __typename?: 'Query'
  GetCoreReportCsv?: { __typename?: 'CoreReportCsvOutput'; base64: string } | null
}

export type GetReportDataQueryVariables = Exact<{
  id: Scalars['Int']['input']
  generateAvailableFilters: Scalars['Boolean']['input']
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  filters?: InputMaybe<Array<FilterCriteriaInput> | FilterCriteriaInput>
}>

export type GetReportDataQuery = {
  __typename?: 'Query'
  GetCoreReportData?: {
    __typename?: 'CoreReportDataOutput'
    coreReportId: number
    data: any
    schema: any
    total: number
    availableFilters?: Array<{
      __typename?: 'AvailableFilterOutput'
      column: string
      label: string
      type: CoreReportFilterTypeEnum
      values?: Array<string> | null
    }> | null
  } | null
}

export type GetReportFiltersQueryVariables = Exact<{
  id: Scalars['Int']['input']
  generateAvailableFilters: Scalars['Boolean']['input']
}>

export type GetReportFiltersQuery = {
  __typename?: 'Query'
  GetCoreReportData?: {
    __typename?: 'CoreReportDataOutput'
    coreReportId: number
    availableFilters?: Array<{
      __typename?: 'AvailableFilterOutput'
      column: string
      label: string
      type: CoreReportFilterTypeEnum
      values?: Array<string> | null
    }> | null
  } | null
}

export type GetReportQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetReportQuery = {
  __typename?: 'Query'
  GetCoreReport?: Array<{
    __typename?: 'CoreReport'
    reportName: CoreReportNameEnum
    isFavorite: boolean
    updatedAt: any
    createdAt: any
    companyId: number
    id: number
  }> | null
}

export type GetReportsQueryVariables = Exact<{
  tab: ReportFilterTabEnum
}>

export type GetReportsQuery = {
  __typename?: 'Query'
  CountCoreReport: number
  GetCoreReport?: Array<{
    __typename?: 'CoreReport'
    reportName: CoreReportNameEnum
    isFavorite: boolean
    updatedAt: any
    createdAt: any
    companyId: number
    id: number
  }> | null
}

export type GetScheduledReportQueryVariables = Exact<{
  coreReportId: Scalars['Int']['input']
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type GetScheduledReportQuery = {
  __typename?: 'Query'
  GetScheduledReport?: Array<{
    __typename?: 'ScheduledReport'
    coreReportId: number
    customDaysOfWeek?: any | null
    customTime?: string | null
    deleted?: any | null
    endDate?: any | null
    id: number
    recipients: any
    repeat?: RepeatTypeEnum | null
    reportSchedulerType: ReportSchedulerTypeEnum
    startDate?: any | null
  }> | null
}

export type GetSharedReportsQueryVariables = Exact<{
  coreReportId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetSharedReportsQuery = {
  __typename?: 'Query'
  GetSharedCoreReport?: Array<{
    __typename?: 'SharedCoreReport'
    email: string
    id: string
    coreReportId: number
    companyUserId: number
  }> | null
}

export type GetRequisitionAndOpeningsIdQueryVariables = Exact<{ [key: string]: never }>

export type GetRequisitionAndOpeningsIdQuery = {
  __typename?: 'Query'
  GetRequisitions?: Array<{
    __typename?: 'Requisition'
    id: string
    extRequisitionId?: string | null
    isIncomplete: boolean
    jobName?: string | null
    JobOpening?: Array<{
      __typename?: 'JobOpening'
      id: string
      extOpeningId?: string | null
      jobRequisitionId?: number | null
    }> | null
  }> | null
}

export type GetRequisitionExtIdQueryVariables = Exact<{ [key: string]: never }>

export type GetRequisitionExtIdQuery = {
  __typename?: 'Query'
  GetRequisitionExtId?: {
    __typename?: 'RequisitionExtId'
    id: string
    companyId?: number | null
    extId?: number | null
  } | null
}

export type GetRequisitionJobDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetRequisitionJobDetailsQuery = {
  __typename?: 'Query'
  GetRequisition?: {
    __typename?: 'Requisition'
    id: string
    jobStatus?: JobStatusEnum | null
    openedAt?: any | null
    jobName?: string | null
    extRequisitionId?: string | null
    jobType?: JobTypeEnum | null
    jobLevel?: JobLevelEnum | null
    travelType?: TravelTypeEnum | null
    payType?: PayTypeEnum | null
    minPay?: number | null
    maxPay?: number | null
    additionalComp?: any | null
    benefits?: any | null
    isIncomplete: boolean
    createdAt?: any | null
    updatedAt?: any | null
    CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
    CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
    JobOpening?: Array<{
      __typename?: 'JobOpening'
      id: string
      jobRequisitionId?: number | null
      openingStatus?: OpeningStatusEnum | null
      extOpeningId?: string | null
      companyId?: number | null
      targetHireDate?: any | null
      openingType?: OpeningTypeEnum | null
      filledDate?: any | null
      startDate?: any | null
      filledByApplication?: number | null
      filledByCandidate?: number | null
      closedReason?: ClosedReasonEnum | null
      closedDate?: any | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        ScalisUser?: { __typename?: 'ScalisUser'; firstName?: string | null; lastName?: string | null } | null
      } | null
    }> | null
    CustomJobRequisitionFieldValue?: Array<{
      __typename?: 'CustomJobRequisitionFieldValue'
      id: string
      requisitionId?: number | null
      customJobRequisitionFieldId?: number | null
      value?: any | null
      companyUserId: number
      createdAt?: any | null
      updatedAt?: any | null
      customJobRequisitionField?: {
        __typename?: 'CustomJobRequisitionField'
        id: string
        name: string
        type: CustomJobRequisitionFieldTypeEnum
        systemTokenName?: string | null
        visibility: CustomFieldVisibilityEnum
        schema: any
        provider: CustomFieldProviderEnum
        isArchived: boolean
        isRequired: boolean
        updatedAt: any
        tooltip?: boolean | null
        tooltipText?: string | null
        createdBy?: {
          __typename?: 'CustomFieldCreatedByUser'
          id: number
          firstName?: string | null
          lastName?: string | null
          profileImage?: string | null
        } | null
      } | null
    }> | null
  } | null
}

export type GetRequisitionListingsQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetRequisitionListingsQuery = {
  __typename?: 'Query'
  GetRequisition?: {
    __typename?: 'Requisition'
    id: string
    companyId?: number | null
    jobName?: string | null
    jobType?: JobTypeEnum | null
    jobLevel?: JobLevelEnum | null
    jobStatus?: JobStatusEnum | null
    openedAt?: any | null
    isIncomplete: boolean
    payType?: PayTypeEnum | null
    minPay?: number | null
    maxPay?: number | null
    benefits?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    Company?: {
      __typename?: 'Company'
      id: string
      CompanyInfo?: { __typename?: 'CompanyInfo'; id: string; companyName?: string | null; logo?: string | null } | null
    } | null
    RequisitionJobDescription?: Array<{
      __typename?: 'RequisitionJobDescription'
      id: string
      requisitionId?: number | null
      description?: string | null
    }> | null
    RequisitionSkills?: Array<{
      __typename?: 'RequisitionSkill'
      id: string
      level?: string | null
      yearsOfExp?: number | null
      displayName?: string | null
      skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
    }> | null
    JobListing?: Array<{
      __typename?: 'JobListing'
      id: number
      publicListingId?: string | null
      jobRequisitionId?: number | null
      listingTitle?: string | null
      externalTitle?: string | null
      workplaceType?: WorkplaceTypeEnum | null
      publicDescription?: string | null
      displayPayOnListing?: boolean | null
      industry?: IndustryEnum | null
      subIndustry?: SubIndustryTypeEnum | null
      companyDefault?: boolean | null
      stateAndOrCountry?: string | null
      internalMatchingDescription?: string | null
      searchPublicDescription?: string | null
      searchInternalMatchingDescription?: string | null
      postedAt?: any | null
      acceptingCandidates?: boolean | null
      stage?: StageEnum | null
      deletedAt?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      CandidateApplication?: Array<{
        __typename?: 'CandidateApplication'
        id: string
        matchScore?: number | null
        applicationStatus?: ApplicationStatusEnum | null
        applicationType?: string | null
        applicationCreationType?: string | null
        updatedAt?: any | null
        appliedAt?: any | null
        lastUpdatedStatusAt?: any | null
        templateStageId?: number | null
        jobListingId?: number | null
        averageRating?: number | null
        lastActivityDate?: any | null
        duplicationStatus?: CandidateApplicationDuplicationStatusEnum | null
      }> | null
      Address?: Array<{
        __typename?: 'Address'
        id: number
        addressLine1?: string | null
        addressLine2?: string | null
        city?: string | null
        state?: string | null
        country?: string | null
        postalCode?: string | null
        timeZone?: string | null
        longitude?: string | null
        latitude?: string | null
      }> | null
      JobListingScreeningQuestion?: Array<{
        __typename?: 'JobListingScreeningQuestion'
        id: string
        jobListingId?: number | null
        displaySequenceNumber?: number | null
        screeningQuestionId?: number | null
        createdAt?: any | null
        updatedAt?: any | null
        ScreeningQuestion?: {
          __typename?: 'ScreeningQuestion'
          id: string
          isTemplateQuestion?: boolean | null
          questionTitle?: string | null
          questionDesc?: string | null
          questionType?: QuestionTypeEnum | null
          minVal?: number | null
          maxVal?: number | null
          valStatus?: string | null
          ansOptions?: string | null
          isRejectionQuestion?: boolean | null
          isGlobalQuestion?: boolean | null
          rejectMessage?: string | null
          templateMessageId?: number | null
          preferredAnswer?: string | null
          companyId?: number | null
          companyUserId?: number | null
          createdAt?: any | null
          updatedAt?: any | null
        } | null
      }> | null
    }> | null
  } | null
}

export type GetRequisitionPipelineQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetRequisitionPipelineQuery = {
  __typename?: 'Query'
  GetRequisition?: {
    __typename: 'Requisition'
    id: string
    companyId?: number | null
    jobName?: string | null
    extRequisitionId?: string | null
    isIncomplete: boolean
    JobListing?: Array<{
      __typename: 'JobListing'
      id: number
      listingTitle?: string | null
      acceptingCandidates?: boolean | null
    }> | null
    JobPipeline?: {
      __typename: 'JobPipeline'
      id: string
      title?: string | null
      TemplatePipeline?: {
        __typename: 'TemplatePipeline'
        id: string
        name?: string | null
        ghostPipeline?: boolean | null
        TemplateMilestones?: Array<{
          __typename: 'TemplateMilestone'
          id: string
          name?: NameEnum | null
          rankOrder?: number | null
          TemplateStage?: Array<{
            __typename: 'TemplateStage'
            id: string
            name?: string | null
            rankOrder?: number | null
            visibility?: TemplateStageVisibilityEnum | null
            CandidateApplicationByStage?: Array<{ __typename?: 'CandidateApplication'; id: string }> | null
          }> | null
        }> | null
      } | null
    } | null
  } | null
}

export type GetRequisitionPipelinesQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetRequisitionPipelinesQuery = {
  __typename?: 'Query'
  GetRequisition?: {
    __typename?: 'Requisition'
    id: string
    openedAt?: any | null
    isIncomplete: boolean
    createdAt?: any | null
    updatedAt?: any | null
    JobPipeline?: {
      __typename?: 'JobPipeline'
      id: string
      title?: string | null
      JobListingJobPipeline?: Array<{ __typename?: 'JobListingJobPipeline'; id: string }> | null
      TemplatePipeline?: {
        __typename?: 'TemplatePipeline'
        id: string
        name?: string | null
        ghostPipeline?: boolean | null
        pipelinedUsed?: boolean | null
        archived?: boolean | null
        createdAt?: any | null
        updatedAt?: any | null
        deletedAt?: any | null
        CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
        TemplateMilestones?: Array<{
          __typename?: 'TemplateMilestone'
          id: string
          name?: NameEnum | null
          rankOrder?: number | null
          archived?: boolean | null
          createdAt?: any | null
          updatedAt?: any | null
          TemplateStage?: Array<{
            __typename?: 'TemplateStage'
            id: string
            visibility?: TemplateStageVisibilityEnum | null
            name?: string | null
            templateMilestoneId?: number | null
            rankOrder?: number | null
            archived?: boolean | null
            createdAt?: any | null
            updatedAt?: any | null
            CandidateApplicationByStage?: Array<{ __typename?: 'CandidateApplication'; id: string }> | null
          }> | null
        }> | null
      } | null
    } | null
  } | null
}

export type GetRequisitionSkillsAndPreferencesQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetRequisitionSkillsAndPreferencesQuery = {
  __typename?: 'Query'
  GetRequisition?: {
    __typename?: 'Requisition'
    id: string
    openedAt?: any | null
    locationDistancePref?: number | null
    educationLevelPref?: EducationLevelPrefEnum | null
    yearsOfExperiencePref?: YearsOfExperienceEnum | null
    nonTraditionalPref?: boolean | null
    veteranPref?: boolean | null
    diverseHirePref?: boolean | null
    collegeGradPref?: boolean | null
    isIncomplete: boolean
    createdAt?: any | null
    updatedAt?: any | null
    RequisitionSkills?: Array<{
      __typename?: 'RequisitionSkill'
      id: string
      requisitionId?: number | null
      skillId?: number | null
      sequenceNumber?: number | null
      level?: string | null
      yearsOfExp?: number | null
      displayName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
    }> | null
  } | null
}

export type GetRequisitionQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetRequisitionQuery = {
  __typename?: 'Query'
  GetRequisition?: {
    __typename?: 'Requisition'
    id: string
    companyUserId?: number | null
    jobStatus?: JobStatusEnum | null
    jobName?: string | null
    extRequisitionId?: string | null
    jobType?: JobTypeEnum | null
    jobLevel?: JobLevelEnum | null
    travelType?: TravelTypeEnum | null
    payType?: PayTypeEnum | null
    minPay?: number | null
    maxPay?: number | null
    additionalComp?: any | null
    benefits?: any | null
    locationDistancePref?: number | null
    educationLevelPref?: EducationLevelPrefEnum | null
    yearsOfExperiencePref?: YearsOfExperienceEnum | null
    nonTraditionalPref?: boolean | null
    veteranPref?: boolean | null
    diverseHirePref?: boolean | null
    collegeGradPref?: boolean | null
    isIncomplete: boolean
    primaryContact?: number | null
    createdAt?: any | null
    updatedAt?: any | null
    Company?: {
      __typename?: 'Company'
      id: string
      CompanyInfo?: { __typename?: 'CompanyInfo'; id: string; companyName?: string | null; logo?: string | null } | null
    } | null
    CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
    CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
    JobOpening?: Array<{
      __typename?: 'JobOpening'
      id: string
      jobRequisitionId?: number | null
      openingStatus?: OpeningStatusEnum | null
      extOpeningId?: string | null
      companyId?: number | null
      targetHireDate?: any | null
      openingType?: OpeningTypeEnum | null
      filledDate?: any | null
      startDate?: any | null
      filledByApplication?: number | null
      filledByCandidate?: number | null
      closedReason?: ClosedReasonEnum | null
      closedDate?: any | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        CandidateApplicationRating: Array<{
          __typename?: 'CandidateApplicationRating'
          id: string
          score?: number | null
        }>
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
        CandidateCollaborator: Array<{ __typename?: 'CandidateCollaborator'; id: string }>
        ProfileDetails?: {
          __typename?: 'ProfileDetails'
          id: string
          CandidateMedalistDesignation: Array<{ __typename?: 'CandidateMedalistDesignation'; id: number }>
          CandidateProfileLocation: Array<{ __typename?: 'CandidateProfileLocation'; id: number }>
          CandidateSource: Array<{ __typename?: 'CandidateSource'; id: number }>
        } | null
      } | null
    }> | null
    RequisitionJobDescription?: Array<{
      __typename?: 'RequisitionJobDescription'
      id: string
      description?: string | null
    }> | null
    RequisitionSkills?: Array<{
      __typename?: 'RequisitionSkill'
      id: string
      requisitionId?: number | null
      skillId?: number | null
      sequenceNumber?: number | null
      level?: string | null
      yearsOfExp?: number | null
      displayName?: string | null
      createdAt?: any | null
      updatedAt?: any | null
      skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
    }> | null
    CustomJobRequisitionFieldValue?: Array<{
      __typename?: 'CustomJobRequisitionFieldValue'
      id: string
      requisitionId?: number | null
      customJobRequisitionFieldId?: number | null
      value?: any | null
      companyUserId: number
      createdAt?: any | null
      updatedAt?: any | null
      customJobRequisitionField?: {
        __typename?: 'CustomJobRequisitionField'
        id: string
        name: string
        type: CustomJobRequisitionFieldTypeEnum
        systemTokenName?: string | null
        visibility: CustomFieldVisibilityEnum
        schema: any
        provider: CustomFieldProviderEnum
        isArchived: boolean
        isRequired: boolean
        updatedAt: any
        tooltip?: boolean | null
        tooltipText?: string | null
        createdBy?: {
          __typename?: 'CustomFieldCreatedByUser'
          id: number
          firstName?: string | null
          lastName?: string | null
          profileImage?: string | null
        } | null
      } | null
    }> | null
    JobListing?: Array<{
      __typename?: 'JobListing'
      id: number
      publicListingId?: string | null
      jobRequisitionId?: number | null
      listingTitle?: string | null
      externalTitle?: string | null
      workplaceType?: WorkplaceTypeEnum | null
      publicDescription?: string | null
      displayPayOnListing?: boolean | null
      industry?: IndustryEnum | null
      subIndustry?: SubIndustryTypeEnum | null
      companyDefault?: boolean | null
      stateAndOrCountry?: string | null
      internalMatchingDescription?: string | null
      searchPublicDescription?: string | null
      searchInternalMatchingDescription?: string | null
      postedAt?: any | null
      acceptingCandidates?: boolean | null
      stage?: StageEnum | null
      deletedAt?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      Address?: Array<{
        __typename?: 'Address'
        id: number
        addressLine1?: string | null
        addressLine2?: string | null
        city?: string | null
        state?: string | null
        country?: string | null
        postalCode?: string | null
        timeZone?: string | null
      }> | null
      JobListingScreeningQuestion?: Array<{
        __typename?: 'JobListingScreeningQuestion'
        id: string
        jobListingId?: number | null
        displaySequenceNumber?: number | null
        screeningQuestionId?: number | null
        active?: boolean | null
        hasApplications?: boolean | null
        createdAt?: any | null
        updatedAt?: any | null
        ScreeningQuestion?: {
          __typename?: 'ScreeningQuestion'
          id: string
          isTemplateQuestion?: boolean | null
          questionTitle?: string | null
          questionDesc?: string | null
          questionType?: QuestionTypeEnum | null
          minVal?: number | null
          maxVal?: number | null
          valStatus?: string | null
          ansOptions?: string | null
          isRejectionQuestion?: boolean | null
          rejectMessage?: string | null
          templateMessageId?: number | null
          preferredAnswer?: string | null
          isGlobalQuestion?: boolean | null
          companyId?: number | null
          companyUserId?: number | null
          createdAt?: any | null
          updatedAt?: any | null
        } | null
      }> | null
      CandidateApplication?: Array<{
        __typename?: 'CandidateApplication'
        id: string
        applicationType?: string | null
        applicationStatus?: ApplicationStatusEnum | null
        applicationTimestamp?: any | null
        interviewScheduling?: InterviewSchedulingEnum | null
        TemplateStage?: {
          __typename?: 'TemplateStage'
          id: string
          TemplateMilestone?: { __typename?: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
        } | null
        CandidateProfile?: {
          __typename?: 'CandidateProfile'
          id: string
          CandidateApplicationRating: Array<{
            __typename?: 'CandidateApplicationRating'
            id: string
            score?: number | null
          }>
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
          CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
          CandidateCollaborator: Array<{ __typename?: 'CandidateCollaborator'; id: string }>
          ProfileDetails?: {
            __typename?: 'ProfileDetails'
            id: string
            CandidateMedalistDesignation: Array<{ __typename?: 'CandidateMedalistDesignation'; id: number }>
            CandidateProfileLocation: Array<{ __typename?: 'CandidateProfileLocation'; id: number }>
            CandidateSource: Array<{ __typename?: 'CandidateSource'; id: number }>
          } | null
        } | null
        CandidateApplicationRating?: Array<{
          __typename?: 'CandidateApplicationRating'
          id: string
          score?: number | null
        }> | null
      }> | null
    }> | null
    HiringTeamMember?: Array<{
      __typename?: 'HiringTeamMember'
      id: string
      role?: { __typename?: 'Role'; id: string; name: string } | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        companyId: number
        companyUserStatus?: CompanyUserStatusEnum | null
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          email?: string | null
          invitedAs?: RoleEnum | null
          invitationStatus?: InvitationStatusEnum | null
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
    }> | null
  } | null
}

export type GetRequisitionsAndListingsQueryVariables = Exact<{ [key: string]: never }>

export type GetRequisitionsAndListingsQuery = {
  __typename?: 'Query'
  GetRequisitions?: Array<{
    __typename?: 'Requisition'
    id: string
    jobName?: string | null
    extRequisitionId?: string | null
    JobListing?: Array<{
      __typename?: 'JobListing'
      id: number
      publicListingId?: string | null
      jobRequisitionId?: number | null
      listingTitle?: string | null
      externalTitle?: string | null
      workplaceType?: WorkplaceTypeEnum | null
      publicDescription?: string | null
      displayPayOnListing?: boolean | null
      industry?: IndustryEnum | null
      subIndustry?: SubIndustryTypeEnum | null
      companyDefault?: boolean | null
      stateAndOrCountry?: string | null
      internalMatchingDescription?: string | null
      searchPublicDescription?: string | null
      searchInternalMatchingDescription?: string | null
      postedAt?: any | null
      acceptingCandidates?: boolean | null
      stage?: StageEnum | null
      createdAt?: any | null
      updatedAt?: any | null
      CandidateApplication?: Array<{
        __typename?: 'CandidateApplication'
        id: string
        applicationStatus?: ApplicationStatusEnum | null
        TemplateStage?: { __typename?: 'TemplateStage'; id: string; templateMilestoneId?: number | null } | null
      }> | null
    }> | null
  }> | null
}

export type GetRequisitionsOptionsQueryVariables = Exact<{ [key: string]: never }>

export type GetRequisitionsOptionsQuery = {
  __typename?: 'Query'
  GetRequisitions?: Array<{
    __typename?: 'Requisition'
    id: string
    jobName?: string | null
    extRequisitionId?: string | null
  }> | null
}

export type GetRequisitionsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  companyId?: InputMaybe<Scalars['Int']['input']>
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  companyOfficeId?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  lastActivity?: InputMaybe<RequisitionLastActivity>
  status?: InputMaybe<JobStatusEnum>
  pipeline?: InputMaybe<Scalars['String']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetRequisitionsQuery = {
  __typename?: 'Query'
  GetRequisitions?: Array<{
    __typename?: 'Requisition'
    id: string
    jobStatus?: JobStatusEnum | null
    jobName?: string | null
    extRequisitionId?: string | null
    jobType?: JobTypeEnum | null
    jobLevel?: JobLevelEnum | null
    travelType?: TravelTypeEnum | null
    payType?: PayTypeEnum | null
    minPay?: number | null
    maxPay?: number | null
    additionalComp?: any | null
    benefits?: any | null
    locationDistancePref?: number | null
    educationLevelPref?: EducationLevelPrefEnum | null
    yearsOfExperiencePref?: YearsOfExperienceEnum | null
    nonTraditionalPref?: boolean | null
    veteranPref?: boolean | null
    diverseHirePref?: boolean | null
    collegeGradPref?: boolean | null
    isIncomplete: boolean
    createdAt?: any | null
    updatedAt?: any | null
    CompanyDepartment?: { __typename?: 'CompanyDepartment'; id: string; departmentName?: string | null } | null
    CompanyOffice?: { __typename?: 'CompanyOffice'; id: string; officeName?: string | null } | null
    JobOpening?: Array<{
      __typename?: 'JobOpening'
      id: string
      openingStatus?: OpeningStatusEnum | null
      extOpeningId?: string | null
      targetHireDate?: any | null
      openingType?: OpeningTypeEnum | null
      closedReason?: ClosedReasonEnum | null
      closedDate?: any | null
      filledDate?: any | null
      startDate?: any | null
    }> | null
    RequisitionJobDescription?: Array<{
      __typename?: 'RequisitionJobDescription'
      id: string
      description?: string | null
    }> | null
    RequisitionSkills?: Array<{
      __typename?: 'RequisitionSkill'
      id: string
      requisitionId?: number | null
      skillId?: number | null
      displayName?: string | null
      level?: string | null
      yearsOfExp?: number | null
      sequenceNumber?: number | null
      createdAt?: any | null
      updatedAt?: any | null
      skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
    }> | null
    JobListing?: Array<{
      __typename?: 'JobListing'
      id: number
      publicListingId?: string | null
      jobRequisitionId?: number | null
      listingTitle?: string | null
      externalTitle?: string | null
      workplaceType?: WorkplaceTypeEnum | null
      publicDescription?: string | null
      displayPayOnListing?: boolean | null
      industry?: IndustryEnum | null
      subIndustry?: SubIndustryTypeEnum | null
      companyDefault?: boolean | null
      stateAndOrCountry?: string | null
      internalMatchingDescription?: string | null
      searchPublicDescription?: string | null
      searchInternalMatchingDescription?: string | null
      postedAt?: any | null
      acceptingCandidates?: boolean | null
      stage?: StageEnum | null
      deletedAt?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      Address?: Array<{
        __typename?: 'Address'
        id: number
        addressLine1?: string | null
        addressLine2?: string | null
        city?: string | null
        state?: string | null
        country?: string | null
        postalCode?: string | null
        timeZone?: string | null
      }> | null
      JobListingScreeningQuestion?: Array<{
        __typename?: 'JobListingScreeningQuestion'
        id: string
        jobListingId?: number | null
        displaySequenceNumber?: number | null
        screeningQuestionId?: number | null
        createdAt?: any | null
        updatedAt?: any | null
        ScreeningQuestion?: {
          __typename?: 'ScreeningQuestion'
          id: string
          isTemplateQuestion?: boolean | null
          questionTitle?: string | null
          questionDesc?: string | null
          questionType?: QuestionTypeEnum | null
          minVal?: number | null
          maxVal?: number | null
          valStatus?: string | null
          ansOptions?: string | null
          isRejectionQuestion?: boolean | null
          rejectMessage?: string | null
          templateMessageId?: number | null
          preferredAnswer?: string | null
          isGlobalQuestion?: boolean | null
          companyId?: number | null
          companyUserId?: number | null
          createdAt?: any | null
          updatedAt?: any | null
        } | null
      }> | null
      CandidateApplication?: Array<{
        __typename?: 'CandidateApplication'
        id: string
        applicationStatus?: ApplicationStatusEnum | null
        TemplateStage?: { __typename?: 'TemplateStage'; id: string; templateMilestoneId?: number | null } | null
      }> | null
    }> | null
    JobPipeline?: {
      __typename?: 'JobPipeline'
      id: string
      title?: string | null
      TemplatePipeline?: {
        __typename?: 'TemplatePipeline'
        id: string
        companyId?: number | null
        companyUserId?: number | null
        name?: string | null
        companyDepartmentId?: number | null
        archived?: boolean | null
        pipelinedUsed?: boolean | null
        ghostPipeline?: boolean | null
        createdAt?: any | null
        updatedAt?: any | null
        deletedAt?: any | null
        TemplateMilestones?: Array<{
          __typename?: 'TemplateMilestone'
          id: string
          templatePipelineId?: number | null
          name?: NameEnum | null
          rankOrder?: number | null
          archived?: boolean | null
          createdAt?: any | null
          updatedAt?: any | null
          TemplateStage?: Array<{
            __typename?: 'TemplateStage'
            id: string
            templatePipelineId?: number | null
            visibility?: TemplateStageVisibilityEnum | null
            name?: string | null
            templateMilestoneId?: number | null
            rankOrder?: number | null
            archived?: boolean | null
            createdAt?: any | null
            updatedAt?: any | null
          }> | null
        }> | null
      } | null
    } | null
    HiringTeamMember?: Array<{
      __typename?: 'HiringTeamMember'
      id: string
      role?: { __typename?: 'Role'; id: string; name: string } | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        companyId: number
        companyUserStatus?: CompanyUserStatusEnum | null
        profileImage?: string | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          id: number
          email?: string | null
          invitedAs?: RoleEnum | null
          invitationStatus?: InvitationStatusEnum | null
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
    }> | null
  }> | null
}

export type GetSideBarRequisitionsQueryVariables = Exact<{
  status?: InputMaybe<JobStatusEnum>
}>

export type GetSideBarRequisitionsQuery = {
  __typename?: 'Query'
  GetRequisitions?: Array<{
    __typename?: 'Requisition'
    id: string
    jobStatus?: JobStatusEnum | null
    jobName?: string | null
    extRequisitionId?: string | null
    isIncomplete: boolean
    JobPipeline?: {
      __typename?: 'JobPipeline'
      id: string
      title?: string | null
      TemplatePipeline?: {
        __typename?: 'TemplatePipeline'
        id: string
        deletedAt?: any | null
        TemplateMilestones?: Array<{
          __typename?: 'TemplateMilestone'
          id: string
          name?: NameEnum | null
          rankOrder?: number | null
          TemplateStage?: Array<{
            __typename?: 'TemplateStage'
            id: string
            name?: string | null
            rankOrder?: number | null
          }> | null
        }> | null
      } | null
    } | null
  }> | null
}

export type GetRequisitionJobDescriptionByRequisitionQueryVariables = Exact<{
  requisitionId: Scalars['Int']['input']
}>

export type GetRequisitionJobDescriptionByRequisitionQuery = {
  __typename?: 'Query'
  GetRequisitionJobDescriptionByRequisition?: {
    __typename?: 'RequisitionJobDescription'
    id: string
    requisitionId?: number | null
    description?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    requisition?: { __typename?: 'Requisition'; id: string; openedAt?: any | null } | null
  } | null
}

export type GetRequisitionJobDescriptionQueryVariables = Exact<{
  requisitionId: Scalars['Int']['input']
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type GetRequisitionJobDescriptionQuery = {
  __typename?: 'Query'
  GetRequisitionJobDescription?: Array<{
    __typename?: 'RequisitionJobDescription'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    requisitionId?: number | null
    description?: string | null
    hiringTeamMember?: Array<{
      __typename?: 'HiringTeamMember'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      companyUserId?: number | null
      roleId?: number | null
      requisitionId?: number | null
      requisitionJobDescriptionId?: number | null
      role?: { __typename?: 'Role'; id: string; name: string } | null
    }> | null
    candidateCollaborator?: Array<{
      __typename?: 'CandidateCollaborator'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      requisitionId?: number | null
      companyUserId?: number | null
      candidateProfileId?: number | null
      roleId?: number | null
      requisitionJobDescriptionId?: number | null
      role?: { __typename?: 'Role'; id: string; name: string } | null
    }> | null
    stageCollaborator?: Array<{
      __typename?: 'StageCollaborator'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      requisitionId?: number | null
      companyUserId?: number | null
      templateStageId?: number | null
      roleId?: number | null
      requisitionJobDescriptionId?: number | null
      role?: { __typename?: 'Role'; id: string; name: string } | null
    }> | null
  }> | null
}

export type GetTemplateJobDescriptionQueryVariables = Exact<{
  companyUserId?: InputMaybe<Scalars['Int']['input']>
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}>

export type GetTemplateJobDescriptionQuery = {
  __typename?: 'Query'
  GetTemplateJobDescription?: Array<{
    __typename?: 'TemplateJobDescription'
    id: string
    companyId?: number | null
    companyUserId?: number | null
    name?: string | null
    description?: string | null
    companyDepartmentId?: string | null
    createdAt?: any | null
    updatedAt?: any | null
    companyDepartment?: {
      __typename?: 'CompanyDepartment'
      id: string
      companyId?: number | null
      departmentName?: string | null
      subordinateTo?: number | null
      externalId?: string | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null
  }> | null
}

export type GetRequisitionSkillQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetRequisitionSkillQuery = {
  __typename?: 'Query'
  GetRequisitionSkill?: {
    __typename?: 'RequisitionSkill'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    requisitionId?: number | null
    skillId?: number | null
    displayName?: string | null
    level?: string | null
    yearsOfExp?: number | null
    sequenceNumber?: number | null
    skill?: { __typename?: 'Skill'; id: string; name?: string | null } | null
  } | null
}

export type GetJobListingScreeningQuestionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  jobListingId?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<SortDirection>
  candidateApplicationId?: InputMaybe<Scalars['Int']['input']>
}>

export type GetJobListingScreeningQuestionQuery = {
  __typename?: 'Query'
  GetJobListingScreeningQuestion?: Array<{
    __typename?: 'JobListingScreeningQuestion'
    id: string
    jobListingId?: number | null
    displaySequenceNumber?: number | null
    screeningQuestionId?: number | null
    createdAt?: any | null
    updatedAt?: any | null
    ScreeningQuestion?: {
      __typename?: 'ScreeningQuestion'
      id: string
      isTemplateQuestion?: boolean | null
      questionTitle?: string | null
      questionDesc?: string | null
      questionType?: QuestionTypeEnum | null
      minVal?: number | null
      maxVal?: number | null
      valStatus?: string | null
      ansOptions?: string | null
      isRejectionQuestion?: boolean | null
      rejectMessage?: string | null
      templateMessageId?: number | null
      preferredAnswer?: string | null
      companyId?: number | null
      companyUserId?: number | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null
    CandidateAnswer?: {
      __typename?: 'ScreeningQuestionAnswer'
      id: string
      answer?: string | null
      answerStatus?: boolean | null
      candidateApplicationId?: number | null
      listingScreeningQuestionId?: number | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null
  }> | null
}

export type GetRolesQueryVariables = Exact<{ [key: string]: never }>

export type GetRolesQuery = {
  __typename?: 'Query'
  GetRoles?: Array<{ __typename?: 'Role'; id: string; name: string }> | null
}

export type GetCompanyUserPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type GetCompanyUserPermissionsQuery = {
  __typename?: 'Query'
  GetCompanyUserPermissions: {
    __typename?: 'CompanyUserPermissions'
    orgLevelRole: RoleEnum
    jobLevelPermissions: Array<{
      __typename?: 'JobLevelPermission'
      requisitionId: number
      hiringTeamRole?: RoleEnum | null
      stageCollaborator: Array<{
        __typename?: 'StageCollaboratorPermission'
        templateStageId?: number | null
        role: RoleEnum
      }>
    }>
  }
}

export type GetEmailActivationQueryVariables = Exact<{
  email: Scalars['String']['input']
}>

export type GetEmailActivationQuery = { __typename?: 'Query'; GetEmailActivation: boolean }

export type GetUserCompaniesQueryVariables = Exact<{ [key: string]: never }>

export type GetUserCompaniesQuery = {
  __typename?: 'Query'
  Me?: {
    __typename?: 'ScalisUser'
    UserInvitation?: Array<{
      __typename?: 'UserInvitation'
      Company?: {
        __typename?: 'Company'
        id: string
        subdomain?: string | null
        createdAt?: any | null
        externalId?: string | null
        lastActivity?: any | null
        updatedAt?: any | null
        CompanyInfo?: {
          __typename?: 'CompanyInfo'
          id: string
          companyName?: string | null
          companyType?: string | null
          companyId?: number | null
          updatedAt?: any | null
          logo?: string | null
        } | null
      } | null
    }> | null
  } | null
}

export type GetSchedulerLinkSettingsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type GetSchedulerLinkSettingsQuery = {
  __typename?: 'Query'
  GetSchedulerLinkSettings?: {
    __typename?: 'SchedulerLinkSettings'
    id: string
    minimumHour: number
    rollingDays: number
    maxInterviewsPerDay: number
  } | null
}

export type GetScorecardTemplateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
}>

export type GetScorecardTemplateQuery = {
  __typename?: 'Query'
  GetScorecardTemplate?: Array<{
    __typename?: 'ScorecardTemplate'
    id: string
    archived?: boolean | null
    department?: string | null
    scorecardName?: string | null
    scorecardDescription?: string | null
    visible?: boolean | null
    companyTemplate?: boolean | null
    timestampAt?: any | null
    createdAt?: any | null
    ScorecardTemplateSection: Array<{
      __typename?: 'ScorecardTemplateSection'
      id: string
      rankOrder?: number | null
      scorecardTemplateId?: number | null
      sectionName?: string | null
      sectionType?: SectionTypeEnum | null
      ScorecardTemplateQuestion: Array<{
        __typename?: 'ScorecardTemplateQuestion'
        id: string
        answerOptions?: any | null
        preferredAnswer?: string | null
        questionDescription?: string | null
        questionText?: string | null
        questionType?: ScorecardQuestionTypeEnum | null
        scoreAnswer?: boolean | null
        scorecardTemplateSectionId?: number | null
        skillId?: number | null
        skillDisplayName?: string | null
        CandidateScorecardAnswers?: Array<{
          __typename?: 'CandidateScorecardAnswers'
          id: string
          answer?: any | null
          answerPreferredStatus?: boolean | null
          candidateScorecardId?: number | null
          dateAnswer?: any | null
          scoreAnswer?: number | null
          scorecardTemplateQuestionId?: number | null
        }> | null
      }>
    }>
  }> | null
}

export type GetCompareScorecardTemplatesQuestionFragment = {
  __typename?: 'ScorecardTemplateQuestion'
  id: string
  answerOptions?: any | null
  preferredAnswer?: string | null
  questionDescription?: string | null
  questionText?: string | null
  questionType?: ScorecardQuestionTypeEnum | null
  scoreAnswer?: boolean | null
  scorecardTemplateSectionId?: number | null
  skillDisplayName?: string | null
  CandidateScorecardAnswers?: Array<{
    __typename?: 'CandidateScorecardAnswers'
    answer?: any | null
    answerPreferredStatus?: boolean | null
    candidateScorecardId?: number | null
    dateAnswer?: any | null
    id: string
    overallRecommendation?: OverallRecommendationEnum | null
    scoreAnswer?: number | null
    scorecardTemplateQuestionId?: number | null
  }> | null
}

export type GetCompareScorecardTemplatesCandidateScorecardFragment = {
  __typename?: 'CandidateScorecard'
  id: string
  companyUserId?: number | null
  candidateApplicationId?: number | null
  additionalInformation?: string | null
  scorecardTemplateId?: number | null
  status?: ScorecardStatusTypeEnum | null
  templateStageId?: number | null
  CompanyUser?: {
    __typename?: 'CompanyUser'
    companyId: number
    companyUserStatus?: CompanyUserStatusEnum | null
    id: string
    profileImage?: string | null
    userInvitationId?: number | null
    UserInvitation?: {
      __typename?: 'UserInvitation'
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  } | null
  CandidateApplication?: {
    __typename?: 'CandidateApplication'
    id: string
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      ScalisUser?: {
        __typename?: 'ScalisUser'
        currentStage?: string | null
        completedAt?: any | null
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
      UploadedCandidate?: {
        __typename?: 'UploadedCandidate'
        id: number
        linkedinProfile?: string | null
        lastName?: string | null
        firstName?: string | null
        emailAddress?: string | null
        companyUserId?: number | null
        companyId?: number | null
        profileImage?: string | null
        profileUrl?: string | null
        uploadedCandidateType?: UploadedCandidateTypeEnum | null
        CandidateProfile?: {
          __typename?: 'CandidateProfile'
          id: string
          profileType: ProfileTypeEnum
          CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
        } | null
        UploadedCandidateWebsiteOrSocialMedia: Array<{
          __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
          id: number
          websiteURL: string
          type: WebsiteTypeEnum
        }>
        UploadedCandidateAchievement: Array<{
          __typename?: 'UploadedCandidateAchievement'
          id: number
          name?: string | null
          issuingAuthority?: string | null
          issueYear?: number | null
          description?: any | null
          searchDescription?: string | null
        }>
        UploadedCandidateCertificateOrLicense: Array<{
          __typename?: 'UploadedCandidateCertificateOrLicense'
          id: number
          name?: string | null
          issuingAuthority?: string | null
          issueYear?: number | null
          description?: any | null
          searchDescription?: string | null
        }>
        UploadedCandidateEducation?: Array<{
          __typename?: 'UploadedCandidateEducation'
          id: number
          institutionName?: string | null
          currentlyStudying?: boolean | null
          educationLevel?: EducationLevelEnum | null
          startDate?: any | null
          endDate?: any | null
          areasOfStudy?: any | null
          majors?: any | null
          minors?: any | null
          cumGPA?: number | null
          cumGPAScale?: number | null
          hideCumGPA?: boolean | null
          hideDepartmentGPA?: boolean | null
          departmentCumGPA?: number | null
          departmentCumGPAScale?: number | null
          additionalInformation?: string | null
        }> | null
        highestEducation?: Array<{
          __typename?: 'UploadedCandidateEducation'
          id: number
          institutionName?: string | null
          currentlyStudying?: boolean | null
          educationLevel?: EducationLevelEnum | null
          startDate?: any | null
          endDate?: any | null
          areasOfStudy?: any | null
          majors?: any | null
          minors?: any | null
          cumGPA?: number | null
          cumGPAScale?: number | null
          hideCumGPA?: boolean | null
          hideDepartmentGPA?: boolean | null
          departmentCumGPA?: number | null
          departmentCumGPAScale?: number | null
          additionalInformation?: string | null
        }> | null
        UploadedCandidateExperience?: Array<{
          __typename?: 'UploadedCandidateExperience'
          id: number
          startDate?: any | null
          endDate?: any | null
          companyLogo?: string | null
          locationType?: string | null
          location?: string | null
          shortFormDesc?: any | null
          longFormDesc?: string | null
          searchShortFormDesc?: string | null
          searchLongFormDesc?: string | null
          industry?: IndustryEnum | null
          subIndustry?: string | null
          payType?: string | null
          jobPay?: number | null
          additionalComp?: boolean | null
          jobTitle?: string | null
          employerName?: string | null
          managementPosition?: boolean | null
          teamSize?: TeamSizeEnum | null
          workPlaceCandidate?: WorkPlaceCandidateEnum | null
          isCurrentJob?: boolean | null
          jobType?: JobTypeEnum | null
          isCurrentlyWorking?: boolean | null
          description?: string | null
        }> | null
        ExperienceTenure?: {
          __typename?: 'experienceTenure'
          average: number
          longest: number
          shortest: number
        } | null
        currentJob?: Array<{
          __typename?: 'UploadedCandidateExperience'
          id: number
          startDate?: any | null
          endDate?: any | null
          companyLogo?: string | null
          locationType?: string | null
          location?: string | null
          shortFormDesc?: any | null
          longFormDesc?: string | null
          searchShortFormDesc?: string | null
          searchLongFormDesc?: string | null
          industry?: IndustryEnum | null
          subIndustry?: string | null
          payType?: string | null
          jobPay?: number | null
          additionalComp?: boolean | null
          jobTitle?: string | null
          employerName?: string | null
          managementPosition?: boolean | null
          teamSize?: TeamSizeEnum | null
          workPlaceCandidate?: WorkPlaceCandidateEnum | null
          isCurrentJob?: boolean | null
          jobType?: JobTypeEnum | null
          isCurrentlyWorking?: boolean | null
          description?: string | null
        }> | null
        mostRecentJob?: Array<{
          __typename?: 'UploadedCandidateExperience'
          id: number
          startDate?: any | null
          endDate?: any | null
          companyLogo?: string | null
          locationType?: string | null
          location?: string | null
          shortFormDesc?: any | null
          longFormDesc?: string | null
          searchShortFormDesc?: string | null
          searchLongFormDesc?: string | null
          industry?: IndustryEnum | null
          subIndustry?: string | null
          payType?: string | null
          jobPay?: number | null
          additionalComp?: boolean | null
          jobTitle?: string | null
          employerName?: string | null
          managementPosition?: boolean | null
          teamSize?: TeamSizeEnum | null
          workPlaceCandidate?: WorkPlaceCandidateEnum | null
          isCurrentJob?: boolean | null
          jobType?: JobTypeEnum | null
          isCurrentlyWorking?: boolean | null
          description?: string | null
        }> | null
        UploadedCandidateJobSeekerSkill?: Array<{
          __typename?: 'UploadedCandidateJobSeekerSkills'
          id: number
          sequenceNumber?: number | null
          level?: string | null
          name?: string | null
          yearsOfExp?: number | null
        }> | null
        UploadedCandidateVolunteerWork: Array<{
          __typename?: 'UploadedCandidateVolunteerWork'
          id: number
          volunteerJobTitle?: string | null
          organizationName?: string | null
          isCurrentlyWorking?: boolean | null
          roleType?: RoleTypeEnum | null
          startDate?: any | null
          endDate?: any | null
          description?: any | null
          searchDescription?: string | null
          location?: string | null
        }>
        EnrichedEmail: Array<{
          __typename?: 'EnrichedEmail'
          id: string
          emailAddress?: string | null
          enrichedEmailType?: EnrichedEmailTypeEnum | null
          uploadedCandidateId?: number | null
          recommended?: boolean | null
        }>
        EnrichedPhoneNumber: Array<{
          __typename?: 'EnrichedPhoneNumber'
          id: string
          phoneNumber?: string | null
          uploadedCandidateId?: number | null
          recommended?: boolean | null
        }>
      } | null
    } | null
  } | null
  CandidateScorecardAnswers: Array<{
    __typename?: 'CandidateScorecardAnswers'
    answer?: any | null
    answerPreferredStatus?: boolean | null
    candidateScorecardId?: number | null
    dateAnswer?: any | null
    id: string
    overallRecommendation?: OverallRecommendationEnum | null
    scoreAnswer?: number | null
    scorecardTemplateQuestionId?: number | null
    ScorecardTemplateQuestion?: {
      __typename?: 'ScorecardTemplateQuestion'
      skillDisplayName?: string | null
      answerOptions?: any | null
      id: string
      preferredAnswer?: string | null
      questionDescription?: string | null
      questionText?: string | null
      questionType?: ScorecardQuestionTypeEnum | null
      scoreAnswer?: boolean | null
      scorecardTemplateSectionId?: number | null
      skillId?: number | null
    } | null
  }>
}

export type GetScorecardTemplatesForCompareScorecardQueryVariables = Exact<{
  input: GetScorecardTemplatesInput
}>

export type GetScorecardTemplatesForCompareScorecardQuery = {
  __typename?: 'Query'
  GetScorecardTemplates?: Array<{
    __typename?: 'ScorecardTemplate'
    id: string
    archived?: boolean | null
    department?: string | null
    scorecardName?: string | null
    companyTemplate?: boolean | null
    timestampAt?: any | null
    createdAt?: any | null
    ScorecardTemplateSection: Array<{
      __typename?: 'ScorecardTemplateSection'
      id: string
      rankOrder?: number | null
      scorecardTemplateId?: number | null
      sectionName?: string | null
      sectionType?: SectionTypeEnum | null
      ScorecardTemplateQuestion: Array<{
        __typename?: 'ScorecardTemplateQuestion'
        id: string
        answerOptions?: any | null
        preferredAnswer?: string | null
        questionDescription?: string | null
        questionText?: string | null
        questionType?: ScorecardQuestionTypeEnum | null
        scoreAnswer?: boolean | null
        scorecardTemplateSectionId?: number | null
        skillDisplayName?: string | null
        CandidateScorecardAnswers?: Array<{
          __typename?: 'CandidateScorecardAnswers'
          answer?: any | null
          answerPreferredStatus?: boolean | null
          candidateScorecardId?: number | null
          dateAnswer?: any | null
          id: string
          overallRecommendation?: OverallRecommendationEnum | null
          scoreAnswer?: number | null
          scorecardTemplateQuestionId?: number | null
        }> | null
      }>
    }>
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    CandidateScorecard: Array<{
      __typename?: 'CandidateScorecard'
      id: string
      companyUserId?: number | null
      candidateApplicationId?: number | null
      additionalInformation?: string | null
      scorecardTemplateId?: number | null
      status?: ScorecardStatusTypeEnum | null
      templateStageId?: number | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        companyId: number
        companyUserStatus?: CompanyUserStatusEnum | null
        id: string
        profileImage?: string | null
        userInvitationId?: number | null
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
      CandidateApplication?: {
        __typename?: 'CandidateApplication'
        id: string
        CandidateProfile?: {
          __typename?: 'CandidateProfile'
          id: string
          ScalisUser?: {
            __typename?: 'ScalisUser'
            currentStage?: string | null
            completedAt?: any | null
            id: number
            activeStatus?: boolean | null
            profileImage?: string | null
            firstName?: string | null
            lastName?: string | null
          } | null
          UploadedCandidate?: {
            __typename?: 'UploadedCandidate'
            id: number
            linkedinProfile?: string | null
            lastName?: string | null
            firstName?: string | null
            emailAddress?: string | null
            companyUserId?: number | null
            companyId?: number | null
            profileImage?: string | null
            profileUrl?: string | null
            uploadedCandidateType?: UploadedCandidateTypeEnum | null
            CandidateProfile?: {
              __typename?: 'CandidateProfile'
              id: string
              profileType: ProfileTypeEnum
              CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
            } | null
            UploadedCandidateWebsiteOrSocialMedia: Array<{
              __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
              id: number
              websiteURL: string
              type: WebsiteTypeEnum
            }>
            UploadedCandidateAchievement: Array<{
              __typename?: 'UploadedCandidateAchievement'
              id: number
              name?: string | null
              issuingAuthority?: string | null
              issueYear?: number | null
              description?: any | null
              searchDescription?: string | null
            }>
            UploadedCandidateCertificateOrLicense: Array<{
              __typename?: 'UploadedCandidateCertificateOrLicense'
              id: number
              name?: string | null
              issuingAuthority?: string | null
              issueYear?: number | null
              description?: any | null
              searchDescription?: string | null
            }>
            UploadedCandidateEducation?: Array<{
              __typename?: 'UploadedCandidateEducation'
              id: number
              institutionName?: string | null
              currentlyStudying?: boolean | null
              educationLevel?: EducationLevelEnum | null
              startDate?: any | null
              endDate?: any | null
              areasOfStudy?: any | null
              majors?: any | null
              minors?: any | null
              cumGPA?: number | null
              cumGPAScale?: number | null
              hideCumGPA?: boolean | null
              hideDepartmentGPA?: boolean | null
              departmentCumGPA?: number | null
              departmentCumGPAScale?: number | null
              additionalInformation?: string | null
            }> | null
            highestEducation?: Array<{
              __typename?: 'UploadedCandidateEducation'
              id: number
              institutionName?: string | null
              currentlyStudying?: boolean | null
              educationLevel?: EducationLevelEnum | null
              startDate?: any | null
              endDate?: any | null
              areasOfStudy?: any | null
              majors?: any | null
              minors?: any | null
              cumGPA?: number | null
              cumGPAScale?: number | null
              hideCumGPA?: boolean | null
              hideDepartmentGPA?: boolean | null
              departmentCumGPA?: number | null
              departmentCumGPAScale?: number | null
              additionalInformation?: string | null
            }> | null
            UploadedCandidateExperience?: Array<{
              __typename?: 'UploadedCandidateExperience'
              id: number
              startDate?: any | null
              endDate?: any | null
              companyLogo?: string | null
              locationType?: string | null
              location?: string | null
              shortFormDesc?: any | null
              longFormDesc?: string | null
              searchShortFormDesc?: string | null
              searchLongFormDesc?: string | null
              industry?: IndustryEnum | null
              subIndustry?: string | null
              payType?: string | null
              jobPay?: number | null
              additionalComp?: boolean | null
              jobTitle?: string | null
              employerName?: string | null
              managementPosition?: boolean | null
              teamSize?: TeamSizeEnum | null
              workPlaceCandidate?: WorkPlaceCandidateEnum | null
              isCurrentJob?: boolean | null
              jobType?: JobTypeEnum | null
              isCurrentlyWorking?: boolean | null
              description?: string | null
            }> | null
            ExperienceTenure?: {
              __typename?: 'experienceTenure'
              average: number
              longest: number
              shortest: number
            } | null
            currentJob?: Array<{
              __typename?: 'UploadedCandidateExperience'
              id: number
              startDate?: any | null
              endDate?: any | null
              companyLogo?: string | null
              locationType?: string | null
              location?: string | null
              shortFormDesc?: any | null
              longFormDesc?: string | null
              searchShortFormDesc?: string | null
              searchLongFormDesc?: string | null
              industry?: IndustryEnum | null
              subIndustry?: string | null
              payType?: string | null
              jobPay?: number | null
              additionalComp?: boolean | null
              jobTitle?: string | null
              employerName?: string | null
              managementPosition?: boolean | null
              teamSize?: TeamSizeEnum | null
              workPlaceCandidate?: WorkPlaceCandidateEnum | null
              isCurrentJob?: boolean | null
              jobType?: JobTypeEnum | null
              isCurrentlyWorking?: boolean | null
              description?: string | null
            }> | null
            mostRecentJob?: Array<{
              __typename?: 'UploadedCandidateExperience'
              id: number
              startDate?: any | null
              endDate?: any | null
              companyLogo?: string | null
              locationType?: string | null
              location?: string | null
              shortFormDesc?: any | null
              longFormDesc?: string | null
              searchShortFormDesc?: string | null
              searchLongFormDesc?: string | null
              industry?: IndustryEnum | null
              subIndustry?: string | null
              payType?: string | null
              jobPay?: number | null
              additionalComp?: boolean | null
              jobTitle?: string | null
              employerName?: string | null
              managementPosition?: boolean | null
              teamSize?: TeamSizeEnum | null
              workPlaceCandidate?: WorkPlaceCandidateEnum | null
              isCurrentJob?: boolean | null
              jobType?: JobTypeEnum | null
              isCurrentlyWorking?: boolean | null
              description?: string | null
            }> | null
            UploadedCandidateJobSeekerSkill?: Array<{
              __typename?: 'UploadedCandidateJobSeekerSkills'
              id: number
              sequenceNumber?: number | null
              level?: string | null
              name?: string | null
              yearsOfExp?: number | null
            }> | null
            UploadedCandidateVolunteerWork: Array<{
              __typename?: 'UploadedCandidateVolunteerWork'
              id: number
              volunteerJobTitle?: string | null
              organizationName?: string | null
              isCurrentlyWorking?: boolean | null
              roleType?: RoleTypeEnum | null
              startDate?: any | null
              endDate?: any | null
              description?: any | null
              searchDescription?: string | null
              location?: string | null
            }>
            EnrichedEmail: Array<{
              __typename?: 'EnrichedEmail'
              id: string
              emailAddress?: string | null
              enrichedEmailType?: EnrichedEmailTypeEnum | null
              uploadedCandidateId?: number | null
              recommended?: boolean | null
            }>
            EnrichedPhoneNumber: Array<{
              __typename?: 'EnrichedPhoneNumber'
              id: string
              phoneNumber?: string | null
              uploadedCandidateId?: number | null
              recommended?: boolean | null
            }>
          } | null
        } | null
      } | null
      CandidateScorecardAnswers: Array<{
        __typename?: 'CandidateScorecardAnswers'
        answer?: any | null
        answerPreferredStatus?: boolean | null
        candidateScorecardId?: number | null
        dateAnswer?: any | null
        id: string
        overallRecommendation?: OverallRecommendationEnum | null
        scoreAnswer?: number | null
        scorecardTemplateQuestionId?: number | null
        ScorecardTemplateQuestion?: {
          __typename?: 'ScorecardTemplateQuestion'
          skillDisplayName?: string | null
          answerOptions?: any | null
          id: string
          preferredAnswer?: string | null
          questionDescription?: string | null
          questionText?: string | null
          questionType?: ScorecardQuestionTypeEnum | null
          scoreAnswer?: boolean | null
          scorecardTemplateSectionId?: number | null
          skillId?: number | null
        } | null
      }>
    }>
  }> | null
}

export type GetScorecardTemplatesQueryVariables = Exact<{
  archived?: InputMaybe<Scalars['Boolean']['input']>
  visible?: InputMaybe<Scalars['Boolean']['input']>
  sortBy?: InputMaybe<SortByScorecardTemplate>
  sortDirection?: InputMaybe<SortDirection>
}>

export type GetScorecardTemplatesQuery = {
  __typename?: 'Query'
  GetScorecardTemplate?: Array<{
    __typename?: 'ScorecardTemplate'
    id: string
    archived?: boolean | null
    department?: string | null
    scorecardName?: string | null
    scorecardDescription?: string | null
    visible?: boolean | null
    companyTemplate?: boolean | null
    timestampAt?: any | null
    createdAt?: any | null
    ScorecardTemplateSection: Array<{
      __typename?: 'ScorecardTemplateSection'
      id: string
      rankOrder?: number | null
      scorecardTemplateId?: number | null
      sectionName?: string | null
      sectionType?: SectionTypeEnum | null
      ScorecardTemplateQuestion: Array<{
        __typename?: 'ScorecardTemplateQuestion'
        id: string
        answerOptions?: any | null
        preferredAnswer?: string | null
        questionDescription?: string | null
        questionText?: string | null
        questionType?: ScorecardQuestionTypeEnum | null
        scoreAnswer?: boolean | null
        scorecardTemplateSectionId?: number | null
        skillId?: number | null
        skillDisplayName?: string | null
      }>
    }>
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
  }> | null
}

export type ListTemplateScreeningQuestionsQueryVariables = Exact<{
  input: ListTemplateScreeningQuestionInput
}>

export type ListTemplateScreeningQuestionsQuery = {
  __typename?: 'Query'
  ListTemplateScreeningQuestions: {
    __typename?: 'PaginatedScreeningQuestions'
    total: number
    items: Array<{
      __typename?: 'ScreeningQuestion'
      id: string
      questionTitle?: string | null
      questionDesc?: string | null
      questionType?: QuestionTypeEnum | null
      minVal?: number | null
      maxVal?: number | null
      valStatus?: string | null
      ansOptions?: string | null
      isRejectionQuestion?: boolean | null
      rejectMessage?: string | null
      preferredAnswer?: string | null
      preferredAnswerType?: PreferredAnswerTypeEnum | null
      multipleSelectPreferredAnswers?: any | null
      selectionDisplay?: SelectionDisplayEnum | null
      isTemplateQuestion?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      CompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            firstName?: string | null
            lastName?: string | null
            profileImage?: string | null
          } | null
        } | null
      } | null
    }>
  }
}

export type GetSearchResultsQueryVariables = Exact<{
  companyAlias?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  companyId?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  department?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  educationLevel?: InputMaybe<Array<EducationLevelPrefEnum> | EducationLevelPrefEnum>
  employment?: InputMaybe<Array<JobTypeEnum> | JobTypeEnum>
  experienceLevel?: InputMaybe<Array<JobLevelEnum> | JobLevelEnum>
  id?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  payment?: InputMaybe<Array<PayTypeEnum> | PayTypeEnum>
  search?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SearchSortEnum>
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  workplace?: InputMaybe<Array<LocationTypeEnum> | LocationTypeEnum>
  location?: InputMaybe<Scalars['String']['input']>
  postedAt?: InputMaybe<PostedAtEnum>
  industry?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>
  isScalis?: InputMaybe<Scalars['Boolean']['input']>
  companyHeadcount?: InputMaybe<Array<CompanyHeadcountEnum> | CompanyHeadcountEnum>
  source?: InputMaybe<Array<SourceTypeEnum> | SourceTypeEnum>
  visaSponsorship?: InputMaybe<Scalars['Boolean']['input']>
  salary?: InputMaybe<SalaryInputType>
}>

export type GetSearchResultsQuery = {
  __typename?: 'Query'
  Search?: {
    __typename?: 'SearchResult'
    count: number
    filters: Array<{
      __typename?: 'FiltersType'
      key: string
      values: Array<{ __typename?: 'FilterValueType'; count: number; value: string }>
    }>
    results: Array<{
      __typename?: 'JobSearchResultType'
      benefits?: Array<string> | null
      createdAt?: string | null
      department?: string | null
      description: string
      descriptionHtml?: string | null
      educationLevel?: EducationLevelPrefEnum | null
      employment?: JobTypeEnum | null
      experienceLevel?: JobLevelEnum | null
      id: string
      isApplied?: boolean | null
      isBookmarked?: boolean | null
      payment?: PayTypeEnum | null
      skills?: Array<string> | null
      source?: SourceTypeEnum | null
      title: string
      url: string
      workplace?: LocationTypeEnum | null
      company?: {
        __typename?: 'CompanyType'
        alias?: string | null
        id: string
        logo?: string | null
        name?: string | null
        location?: {
          __typename?: 'LocationType'
          city?: string | null
          continent?: string | null
          country?: string | null
          region?: string | null
          state?: string | null
        } | null
      } | null
      locations?: Array<{
        __typename?: 'LocationType'
        city?: string | null
        region?: string | null
        country?: string | null
        continent?: string | null
        state?: string | null
      }> | null
      salary?: { __typename?: 'SalaryType'; min?: number | null; max?: number | null; currency?: string | null } | null
    }>
  } | null
}

export type DeleteOfferSectionTemplateMutationVariables = Exact<{
  input: DeleteOfferSectionTemplateInput
}>

export type DeleteOfferSectionTemplateMutation = {
  __typename?: 'Mutation'
  DeleteOfferSectionTemplate: { __typename?: 'OfferSectionTemplate'; id: number }
}

export type GetOfferSectionTemplateQueryVariables = Exact<{ [key: string]: never }>

export type GetOfferSectionTemplateQuery = {
  __typename?: 'Query'
  GetOfferSectionTemplate?: Array<{
    __typename?: 'OfferSectionTemplate'
    id: number
    sectionTemplateName: string
    sectionToken: string
    sectionTemplateText: string
    sectionTemplateStatus: TokenStatusEnum
    tokenDescription?: string | null
    updatedAt?: any | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    OfferTemplateCondition?: Array<{
      __typename?: 'OfferTemplateCondition'
      id: string
      officeId?: number | null
      payType?: PayTypeEnum | null
      employmentType?: JobTypeEnum | null
      departmentId?: number | null
    }> | null
  }> | null
}

export type OfferSectionTemplateFragment = {
  __typename?: 'OfferSectionTemplate'
  id: number
  sectionTemplateName: string
  sectionToken: string
  sectionTemplateText: string
  sectionTemplateStatus: TokenStatusEnum
  tokenDescription?: string | null
  updatedAt?: any | null
  CompanyUser?: {
    __typename?: 'CompanyUser'
    id: string
    UserInvitation?: {
      __typename?: 'UserInvitation'
      id: number
      ScalisUser?: {
        __typename?: 'ScalisUser'
        id: number
        activeStatus?: boolean | null
        profileImage?: string | null
        firstName?: string | null
        lastName?: string | null
      } | null
    } | null
  } | null
  OfferTemplateCondition?: Array<{
    __typename?: 'OfferTemplateCondition'
    id: string
    officeId?: number | null
    payType?: PayTypeEnum | null
    employmentType?: JobTypeEnum | null
    departmentId?: number | null
  }> | null
}

export type UpsertOfferSectionTemplateMutationVariables = Exact<{
  input: UpsertOfferSectionTemplateInput
}>

export type UpsertOfferSectionTemplateMutation = {
  __typename?: 'Mutation'
  UpsertOfferSectionTemplate?: {
    __typename?: 'OfferSectionTemplate'
    id: number
    sectionTemplateName: string
    sectionToken: string
    sectionTemplateText: string
    sectionTemplateStatus: TokenStatusEnum
    tokenDescription?: string | null
    updatedAt?: any | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    OfferTemplateCondition?: Array<{
      __typename?: 'OfferTemplateCondition'
      id: string
      officeId?: number | null
      payType?: PayTypeEnum | null
      employmentType?: JobTypeEnum | null
      departmentId?: number | null
    }> | null
  } | null
}

export type ValidateOfferSectionTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type ValidateOfferSectionTemplateMutation = {
  __typename?: 'Mutation'
  ValidateOfferSectionTemplate: {
    __typename?: 'OfferSectionTemplate'
    id: number
    sectionTemplateStatus: TokenStatusEnum
    validationResult?: any | null
  }
}

export type GetSequenceScheduleSettingsQueryVariables = Exact<{ [key: string]: never }>

export type GetSequenceScheduleSettingsQuery = {
  __typename?: 'Query'
  GetSequenceScheduleSettings: Array<{
    __typename?: 'SequenceScheduleSetting'
    id: string
    name?: string | null
    endTime?: string | null
    daysOfWeek?: any | null
    timeZone?: string | null
    startTime?: string | null
    isDefault: boolean
    useContactLocalTime: boolean
  }>
}

export type GetSequenceActivityLogsQueryVariables = Exact<{
  input: GetSequenceActivityLogsInput
  sequenceId: Scalars['String']['input']
}>

export type GetSequenceActivityLogsQuery = {
  __typename?: 'Query'
  GetSequenceActivityLogs?: {
    __typename?: 'SequenceActivityLogsResponse'
    count: number
    emailsSent: Array<{
      __typename?: 'SequenceActivityLog'
      id: string
      eventType: SequenceActivityLogEventTypeEnum
      SequenceCandidate: {
        __typename?: 'SequenceCandidate'
        id: string
        CandidateProfile: {
          __typename?: 'CandidateProfile'
          id: string
          hasSent: boolean
          hasOpened: boolean
          hasReplied: boolean
          hasBounced: boolean
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
          UploadedCandidate?: {
            __typename?: 'UploadedCandidate'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
        }
      }
      EmailRecord?: {
        __typename?: 'EmailRecord'
        id: string
        subject?: string | null
        message?: string | null
        createdAt: any
        to: Array<{ __typename?: 'EmailContact'; name?: string | null }>
      } | null
    }>
  } | null
}

export type GetSequenceByIdQueryVariables = Exact<{
  input: GetSequenceByIdInput
}>

export type GetSequenceByIdQuery = {
  __typename?: 'Query'
  GetSequenceById?: {
    __typename?: 'Sequence'
    id: string
    name: string
    description?: string | null
    companyUserId: number
    associatedRequisitionIds: Array<number>
    associatedTalentPoolIds: Array<number>
    visibility: SequenceVisibilityEnum
    createdAt: any
    numberOfSteps: number
    sequenceStatus: SequenceStatusEnum
    numberOfActives: number
    numberOfCompleted: number
    ownerName?: string | null
    ownerCompanyUserId?: number | null
    isFavorite: boolean
    candidatesCount: number
    emailBouncedCount: number
    emailClickedCount: number
    emailOpenedCount: number
    emailRepliedCount: number
    SequenceSetting: {
      __typename?: 'SequenceSetting'
      id: string
      includeUnsubscribeLink: boolean
      connectedEmailSettingsId: number
      sequenceScheduleSettingId: number
      cc?: any | null
      bcc?: any | null
      SequenceScheduleSetting: {
        __typename?: 'SequenceScheduleSetting'
        id: string
        name?: string | null
        endTime?: string | null
        daysOfWeek?: any | null
        timeZone?: string | null
        startTime?: string | null
        isDefault: boolean
        useContactLocalTime: boolean
      }
      ConnectedEmailSettings: {
        __typename?: 'ConnectedEmailSettings'
        id: string
        email: string
        provider: ConnectedEmailProviderEnum
        dailyLimit?: number | null
        hourlyLimit?: number | null
        minutesBetweenEmails?: number | null
        allowSendOnBehalf?: boolean | null
        optOutEnabled?: boolean | null
        emailSignatureEnabled?: boolean | null
        optOutMessage?: string | null
        emailSignature?: string | null
        createdAt?: any | null
        updatedAt?: any | null
      }
    }
    SequenceSteps: Array<{
      __typename?: 'SequenceStep'
      id: string
      replyPreviousThread: boolean
      subject?: string | null
      templateMessageId?: number | null
      body?: string | null
      spreadStrategy?: SequenceStepSpreadStrategyEnum | null
      afterPreviousStep?: number | null
      emailLimitPerDay?: number | null
      stepNumber: number
      customSendTime?: string | null
      schedulerType: SequenceStepSchedulerTypeEnum
      sendTimeType: SequenceStepSendTimeTypeEnum
      emailOpenedCount: number
      emailRepliedCount: number
      emailClickedCount: number
      dropOffsCount: number
      TemplateMessage?: {
        __typename?: 'TemplateMessage'
        id: string
        message?: string | null
        title?: string | null
      } | null
    }>
  } | null
}

export type GetSequenceCandidateActivityLogsQueryVariables = Exact<{
  input: GetSequenceCandidateActivityLogsInput
  sequenceId: Scalars['String']['input']
}>

export type GetSequenceCandidateActivityLogsQuery = {
  __typename?: 'Query'
  GetSequenceCandidateActivityLogs?: {
    __typename?: 'SequenceCandidateActivityLogsResponse'
    count: number
    sequenceCandidate: {
      __typename?: 'SequenceCandidate'
      id: string
      CandidateProfile: {
        __typename?: 'CandidateProfile'
        id: string
        hasSent: boolean
        hasOpened: boolean
        hasReplied: boolean
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          EmailVerification?: Array<{
            __typename?: 'EmailVerification'
            id: number
            isPrimary?: boolean | null
            emailAddress?: string | null
          }> | null
          ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
          WebsiteOrSocialMedia?: Array<{
            __typename?: 'WebsiteOrSocialMedia'
            id: number
            type: WebsiteTypeEnum
            websiteURL: string
          }> | null
        } | null
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          firstName?: string | null
          lastName?: string | null
          emailAddress?: string | null
          profileImage?: string | null
          linkedinProfile?: string | null
          EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
          EnrichedPhoneNumber: Array<{
            __typename?: 'EnrichedPhoneNumber'
            id: string
            recommended?: boolean | null
            phoneNumber?: string | null
          }>
        } | null
      }
    }
    thread: Array<{
      __typename?: 'SequenceActivityLog'
      id: string
      eventType: SequenceActivityLogEventTypeEnum
      EmailRecord?: {
        __typename?: 'EmailRecord'
        id: string
        createdAt: any
        subject?: string | null
        message?: string | null
        to: Array<{
          __typename?: 'EmailContact'
          companyUserId?: number | null
          profileImage?: string | null
          name?: string | null
        }>
        from: Array<{
          __typename?: 'EmailContact'
          companyUserId?: number | null
          profileImage?: string | null
          name?: string | null
        }>
      } | null
      SequenceStep?: {
        __typename?: 'SequenceStep'
        id: string
        stepNumber: number
        afterPreviousStep?: number | null
        schedulerType: SequenceStepSchedulerTypeEnum
      } | null
    }>
  } | null
}

export type GetSequenceCandidateEngagementQueryVariables = Exact<{
  input: GetSequenceCandidateEngagementInput
}>

export type GetSequenceCandidateEngagementQuery = {
  __typename?: 'Query'
  GetSequenceCandidateEngagement?: {
    __typename?: 'SequenceCandidateEngagementResponse'
    countSent: number
    countReplied: number
    countOpened: number
    opened: Array<{
      __typename?: 'SequenceCandidate'
      id: string
      CandidateProfile: {
        __typename?: 'CandidateProfile'
        id: string
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          WebsiteOrSocialMedia?: Array<{
            __typename?: 'WebsiteOrSocialMedia'
            id: number
            type: WebsiteTypeEnum
            websiteURL: string
          }> | null
          currentJob?: Array<{
            __typename?: 'Experience'
            id: number
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          EmailVerification?: Array<{
            __typename?: 'EmailVerification'
            id: number
            isPrimary?: boolean | null
            emailAddress?: string | null
          }> | null
        } | null
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          linkedinProfile?: string | null
          emailAddress?: string | null
          currentJob?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
        } | null
      }
    }>
    replied: Array<{
      __typename?: 'SequenceCandidate'
      id: string
      CandidateProfile: {
        __typename?: 'CandidateProfile'
        id: string
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          WebsiteOrSocialMedia?: Array<{
            __typename?: 'WebsiteOrSocialMedia'
            id: number
            type: WebsiteTypeEnum
            websiteURL: string
          }> | null
          currentJob?: Array<{
            __typename?: 'Experience'
            id: number
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          EmailVerification?: Array<{
            __typename?: 'EmailVerification'
            id: number
            isPrimary?: boolean | null
            emailAddress?: string | null
          }> | null
        } | null
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          linkedinProfile?: string | null
          emailAddress?: string | null
          currentJob?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
        } | null
      }
    }>
    sent: Array<{
      __typename?: 'SequenceCandidate'
      id: string
      CandidateProfile: {
        __typename?: 'CandidateProfile'
        id: string
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          WebsiteOrSocialMedia?: Array<{
            __typename?: 'WebsiteOrSocialMedia'
            id: number
            type: WebsiteTypeEnum
            websiteURL: string
          }> | null
          currentJob?: Array<{
            __typename?: 'Experience'
            id: number
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          EmailVerification?: Array<{
            __typename?: 'EmailVerification'
            id: number
            isPrimary?: boolean | null
            emailAddress?: string | null
          }> | null
        } | null
        UploadedCandidate?: {
          __typename?: 'UploadedCandidate'
          id: number
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
          linkedinProfile?: string | null
          emailAddress?: string | null
          currentJob?: Array<{
            __typename?: 'UploadedCandidateExperience'
            id: number
            jobTitle?: string | null
            employerName?: string | null
          }> | null
          EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
        } | null
      }
    }>
  } | null
}

export type SequenceCandidateEngagementCandidateProfileFragment = {
  __typename?: 'CandidateProfile'
  ScalisUser?: {
    __typename?: 'ScalisUser'
    id: number
    profileImage?: string | null
    firstName?: string | null
    lastName?: string | null
    WebsiteOrSocialMedia?: Array<{
      __typename?: 'WebsiteOrSocialMedia'
      id: number
      type: WebsiteTypeEnum
      websiteURL: string
    }> | null
    currentJob?: Array<{
      __typename?: 'Experience'
      id: number
      jobTitle?: string | null
      employerName?: string | null
    }> | null
    EmailVerification?: Array<{
      __typename?: 'EmailVerification'
      id: number
      isPrimary?: boolean | null
      emailAddress?: string | null
    }> | null
  } | null
  UploadedCandidate?: {
    __typename?: 'UploadedCandidate'
    id: number
    profileImage?: string | null
    firstName?: string | null
    lastName?: string | null
    linkedinProfile?: string | null
    emailAddress?: string | null
    currentJob?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      jobTitle?: string | null
      employerName?: string | null
    }> | null
    EnrichedEmail: Array<{ __typename?: 'EnrichedEmail'; id: string; emailAddress?: string | null }>
  } | null
}

export type GetSequenceWithMetricsQueryVariables = Exact<{
  sequenceId: Scalars['String']['input']
}>

export type GetSequenceWithMetricsQuery = {
  __typename?: 'Query'
  GetSequenceById?: {
    __typename?: 'Sequence'
    id: string
    name: string
    description?: string | null
    companyUserId: number
    associatedRequisitionIds: Array<number>
    associatedTalentPoolIds: Array<number>
    visibility: SequenceVisibilityEnum
    createdAt: any
    numberOfSteps: number
    sequenceStatus: SequenceStatusEnum
    numberOfActives: number
    numberOfCompleted: number
    ownerName?: string | null
    ownerCompanyUserId?: number | null
    isFavorite: boolean
    candidatesCount: number
    emailBouncedCount: number
    emailClickedCount: number
    emailOpenedCount: number
    emailRepliedCount: number
    SequenceSetting: {
      __typename?: 'SequenceSetting'
      id: string
      includeUnsubscribeLink: boolean
      connectedEmailSettingsId: number
      sequenceScheduleSettingId: number
      cc?: any | null
      bcc?: any | null
      SequenceScheduleSetting: {
        __typename?: 'SequenceScheduleSetting'
        id: string
        name?: string | null
        endTime?: string | null
        daysOfWeek?: any | null
        timeZone?: string | null
        startTime?: string | null
        isDefault: boolean
        useContactLocalTime: boolean
      }
      ConnectedEmailSettings: {
        __typename?: 'ConnectedEmailSettings'
        id: string
        email: string
        provider: ConnectedEmailProviderEnum
        dailyLimit?: number | null
        hourlyLimit?: number | null
        minutesBetweenEmails?: number | null
        allowSendOnBehalf?: boolean | null
        optOutEnabled?: boolean | null
        emailSignatureEnabled?: boolean | null
        optOutMessage?: string | null
        emailSignature?: string | null
        createdAt?: any | null
        updatedAt?: any | null
      }
    }
    SequenceSteps: Array<{
      __typename?: 'SequenceStep'
      id: string
      replyPreviousThread: boolean
      subject?: string | null
      templateMessageId?: number | null
      body?: string | null
      spreadStrategy?: SequenceStepSpreadStrategyEnum | null
      afterPreviousStep?: number | null
      emailLimitPerDay?: number | null
      stepNumber: number
      customSendTime?: string | null
      schedulerType: SequenceStepSchedulerTypeEnum
      sendTimeType: SequenceStepSendTimeTypeEnum
      emailOpenedCount: number
      emailRepliedCount: number
      emailClickedCount: number
      dropOffsCount: number
      TemplateMessage?: {
        __typename?: 'TemplateMessage'
        id: string
        message?: string | null
        title?: string | null
      } | null
    }>
  } | null
  GetSequenceMetrics?: {
    __typename?: 'SequenceMetricsResponse'
    bounceRate: number
    completed: number
    currentlyActive: number
    emailClickRate: number
    emailOpenRate: number
    replyRate: number
    totalEnrolled: number
  } | null
}

export type GetSequenceWithRecipientsQueryVariables = Exact<{
  sequenceId: Scalars['String']['input']
}>

export type GetSequenceWithRecipientsQuery = {
  __typename?: 'Query'
  GetSequenceById?: {
    __typename?: 'Sequence'
    id: string
    name: string
    description?: string | null
    companyUserId: number
    associatedRequisitionIds: Array<number>
    associatedTalentPoolIds: Array<number>
    visibility: SequenceVisibilityEnum
    createdAt: any
    numberOfSteps: number
    sequenceStatus: SequenceStatusEnum
    numberOfActives: number
    numberOfCompleted: number
    ownerName?: string | null
    ownerCompanyUserId?: number | null
    isFavorite: boolean
    candidatesCount: number
    emailBouncedCount: number
    emailClickedCount: number
    emailOpenedCount: number
    emailRepliedCount: number
    SequenceSetting: {
      __typename?: 'SequenceSetting'
      id: string
      includeUnsubscribeLink: boolean
      connectedEmailSettingsId: number
      sequenceScheduleSettingId: number
      cc?: any | null
      bcc?: any | null
      SequenceScheduleSetting: {
        __typename?: 'SequenceScheduleSetting'
        id: string
        name?: string | null
        endTime?: string | null
        daysOfWeek?: any | null
        timeZone?: string | null
        startTime?: string | null
        isDefault: boolean
        useContactLocalTime: boolean
      }
      ConnectedEmailSettings: {
        __typename?: 'ConnectedEmailSettings'
        id: string
        email: string
        provider: ConnectedEmailProviderEnum
        dailyLimit?: number | null
        hourlyLimit?: number | null
        minutesBetweenEmails?: number | null
        allowSendOnBehalf?: boolean | null
        optOutEnabled?: boolean | null
        emailSignatureEnabled?: boolean | null
        optOutMessage?: string | null
        emailSignature?: string | null
        createdAt?: any | null
        updatedAt?: any | null
      }
    }
    SequenceSteps: Array<{
      __typename?: 'SequenceStep'
      id: string
      replyPreviousThread: boolean
      subject?: string | null
      templateMessageId?: number | null
      body?: string | null
      spreadStrategy?: SequenceStepSpreadStrategyEnum | null
      afterPreviousStep?: number | null
      emailLimitPerDay?: number | null
      stepNumber: number
      customSendTime?: string | null
      schedulerType: SequenceStepSchedulerTypeEnum
      sendTimeType: SequenceStepSendTimeTypeEnum
      emailOpenedCount: number
      emailRepliedCount: number
      emailClickedCount: number
      dropOffsCount: number
      TemplateMessage?: {
        __typename?: 'TemplateMessage'
        id: string
        message?: string | null
        title?: string | null
      } | null
    }>
  } | null
  GetCandidateProfile?: Array<{
    __typename?: 'CandidateProfile'
    id: string
    UploadedCandidate?: {
      __typename?: 'UploadedCandidate'
      id: number
      linkedinProfile?: string | null
      lastName?: string | null
      firstName?: string | null
      emailAddress?: string | null
      companyUserId?: number | null
      companyId?: number | null
      profileImage?: string | null
      profileUrl?: string | null
      uploadedCandidateType?: UploadedCandidateTypeEnum | null
      CandidateProfile?: {
        __typename?: 'CandidateProfile'
        id: string
        profileType: ProfileTypeEnum
        CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
      } | null
      UploadedCandidateWebsiteOrSocialMedia: Array<{
        __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
        id: number
        websiteURL: string
        type: WebsiteTypeEnum
      }>
      UploadedCandidateAchievement: Array<{
        __typename?: 'UploadedCandidateAchievement'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateCertificateOrLicense: Array<{
        __typename?: 'UploadedCandidateCertificateOrLicense'
        id: number
        name?: string | null
        issuingAuthority?: string | null
        issueYear?: number | null
        description?: any | null
        searchDescription?: string | null
      }>
      UploadedCandidateEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      highestEducation?: Array<{
        __typename?: 'UploadedCandidateEducation'
        id: number
        institutionName?: string | null
        currentlyStudying?: boolean | null
        educationLevel?: EducationLevelEnum | null
        startDate?: any | null
        endDate?: any | null
        areasOfStudy?: any | null
        majors?: any | null
        minors?: any | null
        cumGPA?: number | null
        cumGPAScale?: number | null
        hideCumGPA?: boolean | null
        hideDepartmentGPA?: boolean | null
        departmentCumGPA?: number | null
        departmentCumGPAScale?: number | null
        additionalInformation?: string | null
      }> | null
      UploadedCandidateExperience?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
      currentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      mostRecentJob?: Array<{
        __typename?: 'UploadedCandidateExperience'
        id: number
        startDate?: any | null
        endDate?: any | null
        companyLogo?: string | null
        locationType?: string | null
        location?: string | null
        shortFormDesc?: any | null
        longFormDesc?: string | null
        searchShortFormDesc?: string | null
        searchLongFormDesc?: string | null
        industry?: IndustryEnum | null
        subIndustry?: string | null
        payType?: string | null
        jobPay?: number | null
        additionalComp?: boolean | null
        jobTitle?: string | null
        employerName?: string | null
        managementPosition?: boolean | null
        teamSize?: TeamSizeEnum | null
        workPlaceCandidate?: WorkPlaceCandidateEnum | null
        isCurrentJob?: boolean | null
        jobType?: JobTypeEnum | null
        isCurrentlyWorking?: boolean | null
        description?: string | null
      }> | null
      UploadedCandidateJobSeekerSkill?: Array<{
        __typename?: 'UploadedCandidateJobSeekerSkills'
        id: number
        sequenceNumber?: number | null
        level?: string | null
        name?: string | null
        yearsOfExp?: number | null
      }> | null
      UploadedCandidateVolunteerWork: Array<{
        __typename?: 'UploadedCandidateVolunteerWork'
        id: number
        volunteerJobTitle?: string | null
        organizationName?: string | null
        isCurrentlyWorking?: boolean | null
        roleType?: RoleTypeEnum | null
        startDate?: any | null
        endDate?: any | null
        description?: any | null
        searchDescription?: string | null
        location?: string | null
      }>
      EnrichedEmail: Array<{
        __typename?: 'EnrichedEmail'
        id: string
        emailAddress?: string | null
        enrichedEmailType?: EnrichedEmailTypeEnum | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
      EnrichedPhoneNumber: Array<{
        __typename?: 'EnrichedPhoneNumber'
        id: string
        phoneNumber?: string | null
        uploadedCandidateId?: number | null
        recommended?: boolean | null
      }>
    } | null
    ScalisUser?: {
      __typename?: 'ScalisUser'
      id: number
      activeStatus?: boolean | null
      profileImage?: string | null
      firstName?: string | null
      lastName?: string | null
      WebsiteOrSocialMedia?: Array<{
        __typename?: 'WebsiteOrSocialMedia'
        id: number
        websiteURL: string
        type: WebsiteTypeEnum
      }> | null
      currentJob?: Array<{
        __typename?: 'Experience'
        id: number
        jobTitle?: string | null
        employerName?: string | null
      }> | null
    } | null
  }> | null
}

export type GetSequencesQueryVariables = Exact<{
  input: GetSequencesInput
}>

export type GetSequencesQuery = {
  __typename?: 'Query'
  GetSequences?: {
    __typename?: 'SequencesResponse'
    activeSequences: Array<{
      __typename?: 'Sequence'
      id: string
      name: string
      description?: string | null
      companyUserId: number
      associatedRequisitionIds: Array<number>
      associatedTalentPoolIds: Array<number>
      visibility: SequenceVisibilityEnum
      createdAt: any
      numberOfSteps: number
      sequenceStatus: SequenceStatusEnum
      numberOfActives: number
      numberOfCompleted: number
      ownerName?: string | null
      ownerCompanyUserId?: number | null
      isFavorite: boolean
      candidatesCount: number
      emailBouncedCount: number
      emailClickedCount: number
      emailOpenedCount: number
      emailRepliedCount: number
      SequenceSetting: {
        __typename?: 'SequenceSetting'
        id: string
        includeUnsubscribeLink: boolean
        connectedEmailSettingsId: number
        sequenceScheduleSettingId: number
        cc?: any | null
        bcc?: any | null
        SequenceScheduleSetting: {
          __typename?: 'SequenceScheduleSetting'
          id: string
          name?: string | null
          endTime?: string | null
          daysOfWeek?: any | null
          timeZone?: string | null
          startTime?: string | null
          isDefault: boolean
          useContactLocalTime: boolean
        }
        ConnectedEmailSettings: {
          __typename?: 'ConnectedEmailSettings'
          id: string
          email: string
          provider: ConnectedEmailProviderEnum
          dailyLimit?: number | null
          hourlyLimit?: number | null
          minutesBetweenEmails?: number | null
          allowSendOnBehalf?: boolean | null
          optOutEnabled?: boolean | null
          emailSignatureEnabled?: boolean | null
          optOutMessage?: string | null
          emailSignature?: string | null
          createdAt?: any | null
          updatedAt?: any | null
        }
      }
      SequenceSteps: Array<{
        __typename?: 'SequenceStep'
        id: string
        replyPreviousThread: boolean
        subject?: string | null
        templateMessageId?: number | null
        body?: string | null
        spreadStrategy?: SequenceStepSpreadStrategyEnum | null
        afterPreviousStep?: number | null
        emailLimitPerDay?: number | null
        stepNumber: number
        customSendTime?: string | null
        schedulerType: SequenceStepSchedulerTypeEnum
        sendTimeType: SequenceStepSendTimeTypeEnum
        emailOpenedCount: number
        emailRepliedCount: number
        emailClickedCount: number
        dropOffsCount: number
        TemplateMessage?: {
          __typename?: 'TemplateMessage'
          id: string
          message?: string | null
          title?: string | null
        } | null
      }>
    }>
    allSequences: Array<{
      __typename?: 'Sequence'
      id: string
      name: string
      description?: string | null
      companyUserId: number
      associatedRequisitionIds: Array<number>
      associatedTalentPoolIds: Array<number>
      visibility: SequenceVisibilityEnum
      createdAt: any
      numberOfSteps: number
      sequenceStatus: SequenceStatusEnum
      numberOfActives: number
      numberOfCompleted: number
      ownerName?: string | null
      ownerCompanyUserId?: number | null
      isFavorite: boolean
      candidatesCount: number
      emailBouncedCount: number
      emailClickedCount: number
      emailOpenedCount: number
      emailRepliedCount: number
      SequenceSetting: {
        __typename?: 'SequenceSetting'
        id: string
        includeUnsubscribeLink: boolean
        connectedEmailSettingsId: number
        sequenceScheduleSettingId: number
        cc?: any | null
        bcc?: any | null
        SequenceScheduleSetting: {
          __typename?: 'SequenceScheduleSetting'
          id: string
          name?: string | null
          endTime?: string | null
          daysOfWeek?: any | null
          timeZone?: string | null
          startTime?: string | null
          isDefault: boolean
          useContactLocalTime: boolean
        }
        ConnectedEmailSettings: {
          __typename?: 'ConnectedEmailSettings'
          id: string
          email: string
          provider: ConnectedEmailProviderEnum
          dailyLimit?: number | null
          hourlyLimit?: number | null
          minutesBetweenEmails?: number | null
          allowSendOnBehalf?: boolean | null
          optOutEnabled?: boolean | null
          emailSignatureEnabled?: boolean | null
          optOutMessage?: string | null
          emailSignature?: string | null
          createdAt?: any | null
          updatedAt?: any | null
        }
      }
      SequenceSteps: Array<{
        __typename?: 'SequenceStep'
        id: string
        replyPreviousThread: boolean
        subject?: string | null
        templateMessageId?: number | null
        body?: string | null
        spreadStrategy?: SequenceStepSpreadStrategyEnum | null
        afterPreviousStep?: number | null
        emailLimitPerDay?: number | null
        stepNumber: number
        customSendTime?: string | null
        schedulerType: SequenceStepSchedulerTypeEnum
        sendTimeType: SequenceStepSendTimeTypeEnum
        emailOpenedCount: number
        emailRepliedCount: number
        emailClickedCount: number
        dropOffsCount: number
        TemplateMessage?: {
          __typename?: 'TemplateMessage'
          id: string
          message?: string | null
          title?: string | null
        } | null
      }>
    }>
    archived: Array<{
      __typename?: 'Sequence'
      id: string
      name: string
      description?: string | null
      companyUserId: number
      associatedRequisitionIds: Array<number>
      associatedTalentPoolIds: Array<number>
      visibility: SequenceVisibilityEnum
      createdAt: any
      numberOfSteps: number
      sequenceStatus: SequenceStatusEnum
      numberOfActives: number
      numberOfCompleted: number
      ownerName?: string | null
      ownerCompanyUserId?: number | null
      isFavorite: boolean
      candidatesCount: number
      emailBouncedCount: number
      emailClickedCount: number
      emailOpenedCount: number
      emailRepliedCount: number
      SequenceSetting: {
        __typename?: 'SequenceSetting'
        id: string
        includeUnsubscribeLink: boolean
        connectedEmailSettingsId: number
        sequenceScheduleSettingId: number
        cc?: any | null
        bcc?: any | null
        SequenceScheduleSetting: {
          __typename?: 'SequenceScheduleSetting'
          id: string
          name?: string | null
          endTime?: string | null
          daysOfWeek?: any | null
          timeZone?: string | null
          startTime?: string | null
          isDefault: boolean
          useContactLocalTime: boolean
        }
        ConnectedEmailSettings: {
          __typename?: 'ConnectedEmailSettings'
          id: string
          email: string
          provider: ConnectedEmailProviderEnum
          dailyLimit?: number | null
          hourlyLimit?: number | null
          minutesBetweenEmails?: number | null
          allowSendOnBehalf?: boolean | null
          optOutEnabled?: boolean | null
          emailSignatureEnabled?: boolean | null
          optOutMessage?: string | null
          emailSignature?: string | null
          createdAt?: any | null
          updatedAt?: any | null
        }
      }
      SequenceSteps: Array<{
        __typename?: 'SequenceStep'
        id: string
        replyPreviousThread: boolean
        subject?: string | null
        templateMessageId?: number | null
        body?: string | null
        spreadStrategy?: SequenceStepSpreadStrategyEnum | null
        afterPreviousStep?: number | null
        emailLimitPerDay?: number | null
        stepNumber: number
        customSendTime?: string | null
        schedulerType: SequenceStepSchedulerTypeEnum
        sendTimeType: SequenceStepSendTimeTypeEnum
        emailOpenedCount: number
        emailRepliedCount: number
        emailClickedCount: number
        dropOffsCount: number
        TemplateMessage?: {
          __typename?: 'TemplateMessage'
          id: string
          message?: string | null
          title?: string | null
        } | null
      }>
    }>
    ownedByMe: Array<{
      __typename?: 'Sequence'
      id: string
      name: string
      description?: string | null
      companyUserId: number
      associatedRequisitionIds: Array<number>
      associatedTalentPoolIds: Array<number>
      visibility: SequenceVisibilityEnum
      createdAt: any
      numberOfSteps: number
      sequenceStatus: SequenceStatusEnum
      numberOfActives: number
      numberOfCompleted: number
      ownerName?: string | null
      ownerCompanyUserId?: number | null
      isFavorite: boolean
      candidatesCount: number
      emailBouncedCount: number
      emailClickedCount: number
      emailOpenedCount: number
      emailRepliedCount: number
      SequenceSetting: {
        __typename?: 'SequenceSetting'
        id: string
        includeUnsubscribeLink: boolean
        connectedEmailSettingsId: number
        sequenceScheduleSettingId: number
        cc?: any | null
        bcc?: any | null
        SequenceScheduleSetting: {
          __typename?: 'SequenceScheduleSetting'
          id: string
          name?: string | null
          endTime?: string | null
          daysOfWeek?: any | null
          timeZone?: string | null
          startTime?: string | null
          isDefault: boolean
          useContactLocalTime: boolean
        }
        ConnectedEmailSettings: {
          __typename?: 'ConnectedEmailSettings'
          id: string
          email: string
          provider: ConnectedEmailProviderEnum
          dailyLimit?: number | null
          hourlyLimit?: number | null
          minutesBetweenEmails?: number | null
          allowSendOnBehalf?: boolean | null
          optOutEnabled?: boolean | null
          emailSignatureEnabled?: boolean | null
          optOutMessage?: string | null
          emailSignature?: string | null
          createdAt?: any | null
          updatedAt?: any | null
        }
      }
      SequenceSteps: Array<{
        __typename?: 'SequenceStep'
        id: string
        replyPreviousThread: boolean
        subject?: string | null
        templateMessageId?: number | null
        body?: string | null
        spreadStrategy?: SequenceStepSpreadStrategyEnum | null
        afterPreviousStep?: number | null
        emailLimitPerDay?: number | null
        stepNumber: number
        customSendTime?: string | null
        schedulerType: SequenceStepSchedulerTypeEnum
        sendTimeType: SequenceStepSendTimeTypeEnum
        emailOpenedCount: number
        emailRepliedCount: number
        emailClickedCount: number
        dropOffsCount: number
        TemplateMessage?: {
          __typename?: 'TemplateMessage'
          id: string
          message?: string | null
          title?: string | null
        } | null
      }>
    }>
    sharedWithMe: Array<{
      __typename?: 'Sequence'
      id: string
      name: string
      description?: string | null
      companyUserId: number
      associatedRequisitionIds: Array<number>
      associatedTalentPoolIds: Array<number>
      visibility: SequenceVisibilityEnum
      createdAt: any
      numberOfSteps: number
      sequenceStatus: SequenceStatusEnum
      numberOfActives: number
      numberOfCompleted: number
      ownerName?: string | null
      ownerCompanyUserId?: number | null
      isFavorite: boolean
      candidatesCount: number
      emailBouncedCount: number
      emailClickedCount: number
      emailOpenedCount: number
      emailRepliedCount: number
      SequenceSetting: {
        __typename?: 'SequenceSetting'
        id: string
        includeUnsubscribeLink: boolean
        connectedEmailSettingsId: number
        sequenceScheduleSettingId: number
        cc?: any | null
        bcc?: any | null
        SequenceScheduleSetting: {
          __typename?: 'SequenceScheduleSetting'
          id: string
          name?: string | null
          endTime?: string | null
          daysOfWeek?: any | null
          timeZone?: string | null
          startTime?: string | null
          isDefault: boolean
          useContactLocalTime: boolean
        }
        ConnectedEmailSettings: {
          __typename?: 'ConnectedEmailSettings'
          id: string
          email: string
          provider: ConnectedEmailProviderEnum
          dailyLimit?: number | null
          hourlyLimit?: number | null
          minutesBetweenEmails?: number | null
          allowSendOnBehalf?: boolean | null
          optOutEnabled?: boolean | null
          emailSignatureEnabled?: boolean | null
          optOutMessage?: string | null
          emailSignature?: string | null
          createdAt?: any | null
          updatedAt?: any | null
        }
      }
      SequenceSteps: Array<{
        __typename?: 'SequenceStep'
        id: string
        replyPreviousThread: boolean
        subject?: string | null
        templateMessageId?: number | null
        body?: string | null
        spreadStrategy?: SequenceStepSpreadStrategyEnum | null
        afterPreviousStep?: number | null
        emailLimitPerDay?: number | null
        stepNumber: number
        customSendTime?: string | null
        schedulerType: SequenceStepSchedulerTypeEnum
        sendTimeType: SequenceStepSendTimeTypeEnum
        emailOpenedCount: number
        emailRepliedCount: number
        emailClickedCount: number
        dropOffsCount: number
        TemplateMessage?: {
          __typename?: 'TemplateMessage'
          id: string
          message?: string | null
          title?: string | null
        } | null
      }>
    }>
  } | null
}

export type GetSkillsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  experienceId?: InputMaybe<Scalars['Int']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type GetSkillsQuery = {
  __typename?: 'Query'
  GetSkills?: Array<{ __typename?: 'Skill'; id: string; name?: string | null }> | null
}

export type ListSourceTrackingLinksQueryVariables = Exact<{
  input: ListSourceTrackingLinksInput
}>

export type ListSourceTrackingLinksQuery = {
  __typename?: 'Query'
  ListSourceTrackingLinks?: {
    __typename?: 'PaginatedSourceTrackingLinks'
    total: number
    items: Array<{
      __typename?: 'SourceTrackingLink'
      id: string
      jobListingId: number
      genericListingLink?: boolean | null
      name: string
      shortCode: string
      isDeleted?: boolean | null
      companyUserId: number
      whoGetsCredit?: number | null
      candidateSourceNameId?: number | null
      countViews: number
      countUniqueViews: number
      countClicksToApply: number
      countApplies: number
      createdAt: any
      updatedAt: any
      redirectUrl: string
      jobListing: {
        __typename?: 'JobListing'
        id: number
        publicListingId?: string | null
        listingTitle?: string | null
        Requisition?: { __typename?: 'Requisition'; id: string; jobName?: string | null } | null
      }
      companyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
      whoGetsCreditCompanyUser?: {
        __typename?: 'CompanyUser'
        id: string
        UserInvitation?: {
          __typename?: 'UserInvitation'
          ScalisUser?: {
            __typename?: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
      candidateSourceName?: {
        __typename?: 'CandidateSourceName'
        id: number
        name: string
        sourceCategory?: SourceCategoryEnum | null
        customSourceCategory?: { __typename?: 'CustomSourceCategory'; id: number; sourceCategoryName: string } | null
      } | null
    }>
  } | null
}

export type GetScreenStageCollaboratorsQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetScreenStageCollaboratorsQuery = {
  __typename?: 'Query'
  GetTemplateStage?: Array<{
    __typename?: 'TemplateStage'
    StageCollaborator?: Array<{
      __typename: 'StageCollaborator'
      id: string
      CompanyUser?: {
        __typename: 'CompanyUser'
        id: string
        profileImage?: string | null
        UserInvitation?: {
          __typename: 'UserInvitation'
          id: number
          email?: string | null
          ScalisUser?: {
            __typename: 'ScalisUser'
            id: number
            firstName?: string | null
            lastName?: string | null
          } | null
        } | null
      } | null
    }> | null
  }> | null
}

export type GetStageCollaboratorQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetStageCollaboratorQuery = {
  __typename?: 'Query'
  GetStageCollaborator?: {
    __typename?: 'StageCollaborator'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    requisitionId?: number | null
    companyUserId?: number | null
    templateStageId?: number | null
    roleId?: number | null
    requisitionJobDescriptionId?: number | null
    role?: { __typename?: 'Role'; id: string; name: string } | null
  } | null
}

export type GetStageSettingsQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetStageSettingsQuery = {
  __typename?: 'Query'
  GetStageSettings?: {
    __typename?: 'StageSettings'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    jobPipelineId?: number | null
    templateStageId?: number | null
    scorecardTemplateId?: number | null
    JobPipeline?: {
      __typename?: 'JobPipeline'
      id: string
      title?: string | null
      jobRequisitionId?: number | null
      templatePipelineId?: number | null
    } | null
    TemplateStage?: {
      __typename?: 'TemplateStage'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      templatePipelineId?: number | null
      visibility?: TemplateStageVisibilityEnum | null
      name?: string | null
      templateMilestoneId?: number | null
      rankOrder?: number | null
      archived?: boolean | null
    } | null
  } | null
}

export type GetCandidateProspectStatusQueryVariables = Exact<{
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
  candidateProfileId?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>
}>

export type GetCandidateProspectStatusQuery = {
  __typename?: 'Query'
  GetCandidateProfile?: Array<{
    __typename?: 'CandidateProfile'
    id: string
    ProspectStatus?: { __typename?: 'TalentPoolProspectStatus'; id: string; colorNumber: number; status: string } | null
  }> | null
}

export type GetCustomTalentPoolQueryVariables = Exact<{
  input: GetCustomTalentPoolInput
}>

export type GetCustomTalentPoolQuery = {
  __typename?: 'Query'
  GetCustomTalentPool: {
    __typename?: 'TalentPool'
    associatedRequisitionIds: Array<number>
    companyId: number
    companyUserId?: number | null
    contributorCompanyUserIds: Array<number>
    description?: string | null
    id: string
    isArchived?: boolean | null
    isFavorite: boolean
    isVisibleTo: TalentPoolVisibilityEnum
    name: string
    ownerCompanyUserId?: number | null
    ownerName?: string | null
    tags: Array<string>
    count: number
    talentPoolType: TalentPoolTypeEnum
    updatedAt: any
  }
}

export type GetTalentPoolProspectStatusQueryVariables = Exact<{
  input: GetTalentPoolProspectStatusInput
}>

export type GetTalentPoolProspectStatusQuery = {
  __typename?: 'Query'
  GetTalentPoolProspectStatus: Array<{
    __typename?: 'TalentPoolProspectStatus'
    id: string
    colorNumber: number
    status: string
  }>
}

export type GetTalentPoolsOptionsQueryVariables = Exact<{ [key: string]: never }>

export type GetTalentPoolsOptionsQuery = {
  __typename?: 'Query'
  GetTalentPools: {
    __typename?: 'TalentPoolsResponse'
    allCustomTalentPools: Array<{ __typename?: 'TalentPool'; id: string; name: string }>
  }
}

export type GetTalentPoolsQueryVariables = Exact<{
  input?: InputMaybe<GetTalentPoolsInput>
}>

export type GetTalentPoolsQuery = {
  __typename?: 'Query'
  GetTalentPools: {
    __typename?: 'TalentPoolsResponse'
    views: {
      __typename?: 'TalentPoolsViews'
      list: Array<{
        __typename?: 'ViewLinkWithUserPreference'
        userPreferenceObject?: {
          __typename?: 'CompanyUserView'
          id: string
          companyUserId: number
          rankOrder: number
          requisitionTalentPoolCompanySavedViewId: number
          requisitionTalentPoolCompanySavedView: {
            __typename?: 'RequisitionTalentPoolCompanySavedView'
            id: string
            isPinned: boolean
            companySavedViewId: number
            hasPinnedSavedViewForCurrentRequisition: boolean
            belongsToCurrentRequisition: boolean
            wasRemovedForCurrentUser: boolean
            companySavedView: {
              __typename?: 'CompanySavedView'
              id: string
              name: string
              viewLayout: CompanySavedViewLayoutEnum
              companyUserId?: number | null
              viewLocation: CompanySavedViewLocationEnum
              viewType: CompanySavedViewTypeEnum
              isVisibleTo: CompanySavedViewVisibilityEnum
              sorting: any
              columnVisibility: any
              columnOrder: any
              columnSizing: any
              candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
              requisitionTalentPoolCompanySavedViews: Array<{
                __typename?: 'RequisitionTalentPoolCompanySavedView'
                id: string
              }>
            }
          }
        } | null
        viewLink: {
          __typename?: 'RequisitionTalentPoolCompanySavedView'
          id: string
          isPinned: boolean
          companySavedViewId: number
          hasPinnedSavedViewForCurrentRequisition: boolean
          belongsToCurrentRequisition: boolean
          wasRemovedForCurrentUser: boolean
          companySavedView: {
            __typename?: 'CompanySavedView'
            id: string
            name: string
            viewLayout: CompanySavedViewLayoutEnum
            companyUserId?: number | null
            viewLocation: CompanySavedViewLocationEnum
            viewType: CompanySavedViewTypeEnum
            isVisibleTo: CompanySavedViewVisibilityEnum
            sorting: any
            columnVisibility: any
            columnOrder: any
            columnSizing: any
            candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
            requisitionTalentPoolCompanySavedViews: Array<{
              __typename?: 'RequisitionTalentPoolCompanySavedView'
              id: string
            }>
          }
        }
      }>
      createdByMe: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
        isPinned: boolean
        companySavedViewId: number
        hasPinnedSavedViewForCurrentRequisition: boolean
        belongsToCurrentRequisition: boolean
        wasRemovedForCurrentUser: boolean
        companySavedView: {
          __typename?: 'CompanySavedView'
          id: string
          name: string
          viewLayout: CompanySavedViewLayoutEnum
          companyUserId?: number | null
          viewLocation: CompanySavedViewLocationEnum
          viewType: CompanySavedViewTypeEnum
          isVisibleTo: CompanySavedViewVisibilityEnum
          sorting: any
          columnVisibility: any
          columnOrder: any
          columnSizing: any
          candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
          requisitionTalentPoolCompanySavedViews: Array<{
            __typename?: 'RequisitionTalentPoolCompanySavedView'
            id: string
          }>
        }
      }>
      defaultViews: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
        isPinned: boolean
        companySavedViewId: number
        hasPinnedSavedViewForCurrentRequisition: boolean
        belongsToCurrentRequisition: boolean
        wasRemovedForCurrentUser: boolean
        companySavedView: {
          __typename?: 'CompanySavedView'
          id: string
          name: string
          viewLayout: CompanySavedViewLayoutEnum
          companyUserId?: number | null
          viewLocation: CompanySavedViewLocationEnum
          viewType: CompanySavedViewTypeEnum
          isVisibleTo: CompanySavedViewVisibilityEnum
          sorting: any
          columnVisibility: any
          columnOrder: any
          columnSizing: any
          candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
          requisitionTalentPoolCompanySavedViews: Array<{
            __typename?: 'RequisitionTalentPoolCompanySavedView'
            id: string
          }>
        }
      }>
      savedByOthers: Array<{
        __typename?: 'RequisitionTalentPoolCompanySavedView'
        id: string
        isPinned: boolean
        companySavedViewId: number
        hasPinnedSavedViewForCurrentRequisition: boolean
        belongsToCurrentRequisition: boolean
        wasRemovedForCurrentUser: boolean
        companySavedView: {
          __typename?: 'CompanySavedView'
          id: string
          name: string
          viewLayout: CompanySavedViewLayoutEnum
          companyUserId?: number | null
          viewLocation: CompanySavedViewLocationEnum
          viewType: CompanySavedViewTypeEnum
          isVisibleTo: CompanySavedViewVisibilityEnum
          sorting: any
          columnVisibility: any
          columnOrder: any
          columnSizing: any
          candidateFilter?: { __typename?: 'CandidateFilter'; id: string; name: string; filters: any } | null
          requisitionTalentPoolCompanySavedViews: Array<{
            __typename?: 'RequisitionTalentPoolCompanySavedView'
            id: string
          }>
        }
      }>
    }
    defaultTalentPools: Array<{
      __typename?: 'TalentPool'
      associatedRequisitionIds: Array<number>
      companyId: number
      companyUserId?: number | null
      contributorCompanyUserIds: Array<number>
      description?: string | null
      id: string
      isArchived?: boolean | null
      isFavorite: boolean
      isVisibleTo: TalentPoolVisibilityEnum
      name: string
      ownerCompanyUserId?: number | null
      ownerName?: string | null
      tags: Array<string>
      count: number
      talentPoolType: TalentPoolTypeEnum
      updatedAt: any
    }>
    allCustomTalentPools: Array<{
      __typename?: 'TalentPool'
      associatedRequisitionIds: Array<number>
      companyId: number
      companyUserId?: number | null
      contributorCompanyUserIds: Array<number>
      description?: string | null
      id: string
      isArchived?: boolean | null
      isFavorite: boolean
      isVisibleTo: TalentPoolVisibilityEnum
      name: string
      ownerCompanyUserId?: number | null
      ownerName?: string | null
      tags: Array<string>
      count: number
      talentPoolType: TalentPoolTypeEnum
      updatedAt: any
    }>
    favorites: Array<{
      __typename?: 'TalentPool'
      associatedRequisitionIds: Array<number>
      companyId: number
      companyUserId?: number | null
      contributorCompanyUserIds: Array<number>
      description?: string | null
      id: string
      isArchived?: boolean | null
      isFavorite: boolean
      isVisibleTo: TalentPoolVisibilityEnum
      name: string
      ownerCompanyUserId?: number | null
      ownerName?: string | null
      tags: Array<string>
      count: number
      talentPoolType: TalentPoolTypeEnum
      updatedAt: any
    }>
    myTalentPools: Array<{
      __typename?: 'TalentPool'
      associatedRequisitionIds: Array<number>
      companyId: number
      companyUserId?: number | null
      contributorCompanyUserIds: Array<number>
      description?: string | null
      id: string
      isArchived?: boolean | null
      isFavorite: boolean
      isVisibleTo: TalentPoolVisibilityEnum
      name: string
      ownerCompanyUserId?: number | null
      ownerName?: string | null
      tags: Array<string>
      count: number
      talentPoolType: TalentPoolTypeEnum
      updatedAt: any
    }>
    sharedWithMe: Array<{
      __typename?: 'TalentPool'
      associatedRequisitionIds: Array<number>
      companyId: number
      companyUserId?: number | null
      contributorCompanyUserIds: Array<number>
      description?: string | null
      id: string
      isArchived?: boolean | null
      isFavorite: boolean
      isVisibleTo: TalentPoolVisibilityEnum
      name: string
      ownerCompanyUserId?: number | null
      ownerName?: string | null
      tags: Array<string>
      count: number
      talentPoolType: TalentPoolTypeEnum
      updatedAt: any
    }>
    archived: Array<{
      __typename?: 'TalentPool'
      associatedRequisitionIds: Array<number>
      companyId: number
      companyUserId?: number | null
      contributorCompanyUserIds: Array<number>
      description?: string | null
      id: string
      isArchived?: boolean | null
      isFavorite: boolean
      isVisibleTo: TalentPoolVisibilityEnum
      name: string
      ownerCompanyUserId?: number | null
      ownerName?: string | null
      tags: Array<string>
      count: number
      talentPoolType: TalentPoolTypeEnum
      updatedAt: any
    }>
  }
}

export type SearchTalentPoolFilterContentQueryVariables = Exact<{
  talentPoolId?: InputMaybe<Scalars['Int']['input']>
  filterType: FilterContentTypeEnum
  search: Scalars['String']['input']
}>

export type SearchTalentPoolFilterContentQuery = {
  __typename?: 'Query'
  SearchTalentPoolFilterContent: Array<{ __typename?: 'filterContentItem'; id?: number | null; value: string }>
}

export type ListTemplateMessagesOptionsQueryVariables = Exact<{
  input: ListTemplateMessageInput
}>

export type ListTemplateMessagesOptionsQuery = {
  __typename?: 'Query'
  ListTemplateMessages?: Array<{
    __typename?: 'TemplateMessage'
    id: string
    title?: string | null
    message?: string | null
  }> | null
}

export type ListTemplateMessagesQueryVariables = Exact<{
  input: ListTemplateMessageInput
}>

export type ListTemplateMessagesQuery = {
  __typename?: 'Query'
  ListTemplateMessages?: Array<{
    __typename?: 'TemplateMessage'
    id: string
    title?: string | null
    message?: string | null
    messageType?: MessageTypeEnum | null
    messageOwner?: MessageOwnerEnum | null
    ccEmails?: any | null
    bccEmails?: any | null
    emailSubject?: string | null
    senderAddressId?: number | null
    createdAt?: any | null
    updatedAt?: any | null
    ConnectedEmailSettings?: { __typename?: 'ConnectedEmailSettings'; id: string; email: string } | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      profileImage?: string | null
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          firstName?: string | null
          lastName?: string | null
          profileImage?: string | null
        } | null
      } | null
    } | null
  }> | null
}

export type GetTemplateMilestoneQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetTemplateMilestoneQuery = {
  __typename?: 'Query'
  GetTemplateMilestone?: {
    __typename?: 'TemplateMilestone'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    templatePipelineId?: number | null
    name?: NameEnum | null
    rankOrder?: number | null
    archived?: boolean | null
    TemplatePipeline?: {
      __typename?: 'TemplatePipeline'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      companyId?: number | null
      companyUserId?: number | null
      name?: string | null
      companyDepartmentId?: number | null
      archived?: boolean | null
      pipelinedUsed?: boolean | null
      ghostPipeline?: boolean | null
      deletedAt?: any | null
    } | null
    TemplateStage?: Array<{
      __typename?: 'TemplateStage'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      templatePipelineId?: number | null
      visibility?: TemplateStageVisibilityEnum | null
      name?: string | null
      templateMilestoneId?: number | null
      rankOrder?: number | null
      archived?: boolean | null
    }> | null
  } | null
}

export type GetTemplatePipelineQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetTemplatePipelineQuery = {
  __typename?: 'Query'
  GetTemplatePipeline?: {
    __typename?: 'TemplatePipeline'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    companyId?: number | null
    companyUserId?: number | null
    name?: string | null
    companyDepartmentId?: number | null
    archived?: boolean | null
    pipelinedUsed?: boolean | null
    ghostPipeline?: boolean | null
    deletedAt?: any | null
    TemplateMilestones?: Array<{
      __typename?: 'TemplateMilestone'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      templatePipelineId?: number | null
      name?: NameEnum | null
      rankOrder?: number | null
      archived?: boolean | null
    }> | null
    TemplateStage?: Array<{
      __typename?: 'TemplateStage'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      templatePipelineId?: number | null
      visibility?: TemplateStageVisibilityEnum | null
      name?: string | null
      templateMilestoneId?: number | null
      rankOrder?: number | null
      archived?: boolean | null
    }> | null
    JobPipeline?: Array<{
      __typename?: 'JobPipeline'
      id: string
      title?: string | null
      jobRequisitionId?: number | null
      templatePipelineId?: number | null
    }> | null
    CompanyDepartment?: {
      __typename?: 'CompanyDepartment'
      id: string
      companyId?: number | null
      departmentName?: string | null
      subordinateTo?: number | null
      externalId?: string | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null
  } | null
}

export type ListTemplatePipelinesQueryVariables = Exact<{
  companyDepartmentId?: InputMaybe<Scalars['Int']['input']>
  archived?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ListTemplatePipelinesQuery = {
  __typename?: 'Query'
  ListTemplatePipelines?: Array<{
    __typename?: 'TemplatePipeline'
    id: string
    name?: string | null
    companyDepartmentId?: number | null
    pipelinedUsed?: boolean | null
    archived?: boolean | null
    createdAt?: any | null
    updatedAt?: any | null
    deletedAt?: any | null
    CompanyDepartment?: {
      __typename?: 'CompanyDepartment'
      id: string
      departmentName?: string | null
      subordinateTo?: number | null
      externalId?: string | null
      createdAt?: any | null
      updatedAt?: any | null
    } | null
    CompanyUser?: {
      __typename?: 'CompanyUser'
      id: string
      profileImage?: string | null
      UserInvitation?: {
        __typename?: 'UserInvitation'
        id: number
        ScalisUser?: {
          __typename?: 'ScalisUser'
          id: number
          activeStatus?: boolean | null
          profileImage?: string | null
          firstName?: string | null
          lastName?: string | null
        } | null
      } | null
    } | null
    TemplateMilestones?: Array<{
      __typename?: 'TemplateMilestone'
      id: string
      name?: NameEnum | null
      rankOrder?: number | null
      TemplateStage?: Array<{
        __typename?: 'TemplateStage'
        id: string
        rankOrder?: number | null
        name?: string | null
        visibility?: TemplateStageVisibilityEnum | null
      }> | null
    }> | null
    TemplateStage?: Array<{ __typename?: 'TemplateStage'; id: string; name?: string | null }> | null
  }> | null
}

export type GetTemplateStageModalDataQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetTemplateStageModalDataQuery = {
  __typename?: 'Query'
  GetTemplateStage?: Array<{
    __typename: 'TemplateStage'
    id: string
    name?: string | null
    TemplateMilestone?: { __typename: 'TemplateMilestone'; id: string; name?: NameEnum | null } | null
    TemplatePipeline?: {
      __typename: 'TemplatePipeline'
      id: string
      JobPipeline?: Array<{ __typename: 'JobPipeline'; id: string; jobRequisitionId?: number | null }> | null
    } | null
  }> | null
}

export type GetTemplateStageQueryVariables = Exact<{
  id: Scalars['Int']['input']
}>

export type GetTemplateStageQuery = {
  __typename?: 'Query'
  GetTemplateStage?: Array<{
    __typename?: 'TemplateStage'
    createdAt?: any | null
    updatedAt?: any | null
    id: string
    templatePipelineId?: number | null
    visibility?: TemplateStageVisibilityEnum | null
    name?: string | null
    templateMilestoneId?: number | null
    rankOrder?: number | null
    archived?: boolean | null
    StageSettings?: Array<{
      __typename?: 'StageSettings'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      jobPipelineId?: number | null
      templateStageId?: number | null
      scorecardTemplateId?: number | null
    }> | null
    TemplateMilestone?: {
      __typename?: 'TemplateMilestone'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      templatePipelineId?: number | null
      name?: NameEnum | null
      rankOrder?: number | null
      archived?: boolean | null
    } | null
    TemplatePipeline?: {
      __typename?: 'TemplatePipeline'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      companyId?: number | null
      companyUserId?: number | null
      name?: string | null
      companyDepartmentId?: number | null
      archived?: boolean | null
      pipelinedUsed?: boolean | null
      ghostPipeline?: boolean | null
      deletedAt?: any | null
    } | null
    StageCollaborator?: Array<{
      __typename?: 'StageCollaborator'
      createdAt?: any | null
      updatedAt?: any | null
      id: string
      requisitionId?: number | null
      companyUserId?: number | null
      templateStageId?: number | null
      roleId?: number | null
      requisitionJobDescriptionId?: number | null
      role?: { __typename?: 'Role'; id: string; name: string } | null
    }> | null
  }> | null
}

export type GetTemporaryS3UrlQueryVariables = Exact<{
  input: GetTemporaryS3UrlInput
}>

export type GetTemporaryS3UrlQuery = {
  __typename?: 'Query'
  GetTemporaryS3Url?: { __typename?: 'GetTemporaryS3UrlOutput'; tempUrl: string } | null
}

export type GetUploadedCandidateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>
  profileUrl?: InputMaybe<Scalars['String']['input']>
}>

export type GetUploadedCandidateQuery = {
  __typename?: 'Query'
  GetUploadedCandidate?: {
    __typename?: 'UploadedCandidate'
    id: number
    linkedinProfile?: string | null
    lastName?: string | null
    firstName?: string | null
    emailAddress?: string | null
    companyUserId?: number | null
    companyId?: number | null
    profileImage?: string | null
    profileUrl?: string | null
    uploadedCandidateType?: UploadedCandidateTypeEnum | null
    CandidateProfile?: {
      __typename?: 'CandidateProfile'
      id: string
      profileType: ProfileTypeEnum
      CandidateApplication: Array<{ __typename?: 'CandidateApplication'; id: string }>
    } | null
    UploadedCandidateWebsiteOrSocialMedia: Array<{
      __typename?: 'UploadedCandidateWebsiteOrSocialMedia'
      id: number
      websiteURL: string
      type: WebsiteTypeEnum
    }>
    UploadedCandidateAchievement: Array<{
      __typename?: 'UploadedCandidateAchievement'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      searchDescription?: string | null
    }>
    UploadedCandidateCertificateOrLicense: Array<{
      __typename?: 'UploadedCandidateCertificateOrLicense'
      id: number
      name?: string | null
      issuingAuthority?: string | null
      issueYear?: number | null
      description?: any | null
      searchDescription?: string | null
    }>
    UploadedCandidateEducation?: Array<{
      __typename?: 'UploadedCandidateEducation'
      id: number
      institutionName?: string | null
      currentlyStudying?: boolean | null
      educationLevel?: EducationLevelEnum | null
      startDate?: any | null
      endDate?: any | null
      areasOfStudy?: any | null
      majors?: any | null
      minors?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
      hideCumGPA?: boolean | null
      hideDepartmentGPA?: boolean | null
      departmentCumGPA?: number | null
      departmentCumGPAScale?: number | null
      additionalInformation?: string | null
    }> | null
    highestEducation?: Array<{
      __typename?: 'UploadedCandidateEducation'
      id: number
      institutionName?: string | null
      currentlyStudying?: boolean | null
      educationLevel?: EducationLevelEnum | null
      startDate?: any | null
      endDate?: any | null
      areasOfStudy?: any | null
      majors?: any | null
      minors?: any | null
      cumGPA?: number | null
      cumGPAScale?: number | null
      hideCumGPA?: boolean | null
      hideDepartmentGPA?: boolean | null
      departmentCumGPA?: number | null
      departmentCumGPAScale?: number | null
      additionalInformation?: string | null
    }> | null
    UploadedCandidateExperience?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      startDate?: any | null
      endDate?: any | null
      companyLogo?: string | null
      locationType?: string | null
      location?: string | null
      shortFormDesc?: any | null
      longFormDesc?: string | null
      searchShortFormDesc?: string | null
      searchLongFormDesc?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      payType?: string | null
      jobPay?: number | null
      additionalComp?: boolean | null
      jobTitle?: string | null
      employerName?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      workPlaceCandidate?: WorkPlaceCandidateEnum | null
      isCurrentJob?: boolean | null
      jobType?: JobTypeEnum | null
      isCurrentlyWorking?: boolean | null
      description?: string | null
    }> | null
    ExperienceTenure?: { __typename?: 'experienceTenure'; average: number; longest: number; shortest: number } | null
    currentJob?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      startDate?: any | null
      endDate?: any | null
      companyLogo?: string | null
      locationType?: string | null
      location?: string | null
      shortFormDesc?: any | null
      longFormDesc?: string | null
      searchShortFormDesc?: string | null
      searchLongFormDesc?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      payType?: string | null
      jobPay?: number | null
      additionalComp?: boolean | null
      jobTitle?: string | null
      employerName?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      workPlaceCandidate?: WorkPlaceCandidateEnum | null
      isCurrentJob?: boolean | null
      jobType?: JobTypeEnum | null
      isCurrentlyWorking?: boolean | null
      description?: string | null
    }> | null
    mostRecentJob?: Array<{
      __typename?: 'UploadedCandidateExperience'
      id: number
      startDate?: any | null
      endDate?: any | null
      companyLogo?: string | null
      locationType?: string | null
      location?: string | null
      shortFormDesc?: any | null
      longFormDesc?: string | null
      searchShortFormDesc?: string | null
      searchLongFormDesc?: string | null
      industry?: IndustryEnum | null
      subIndustry?: string | null
      payType?: string | null
      jobPay?: number | null
      additionalComp?: boolean | null
      jobTitle?: string | null
      employerName?: string | null
      managementPosition?: boolean | null
      teamSize?: TeamSizeEnum | null
      workPlaceCandidate?: WorkPlaceCandidateEnum | null
      isCurrentJob?: boolean | null
      jobType?: JobTypeEnum | null
      isCurrentlyWorking?: boolean | null
      description?: string | null
    }> | null
    UploadedCandidateJobSeekerSkill?: Array<{
      __typename?: 'UploadedCandidateJobSeekerSkills'
      id: number
      sequenceNumber?: number | null
      level?: string | null
      name?: string | null
      yearsOfExp?: number | null
    }> | null
    UploadedCandidateVolunteerWork: Array<{
      __typename?: 'UploadedCandidateVolunteerWork'
      id: number
      volunteerJobTitle?: string | null
      organizationName?: string | null
      isCurrentlyWorking?: boolean | null
      roleType?: RoleTypeEnum | null
      startDate?: any | null
      endDate?: any | null
      description?: any | null
      searchDescription?: string | null
      location?: string | null
    }>
    EnrichedEmail: Array<{
      __typename?: 'EnrichedEmail'
      id: string
      emailAddress?: string | null
      enrichedEmailType?: EnrichedEmailTypeEnum | null
      uploadedCandidateId?: number | null
      recommended?: boolean | null
    }>
    EnrichedPhoneNumber: Array<{
      __typename?: 'EnrichedPhoneNumber'
      id: string
      phoneNumber?: string | null
      uploadedCandidateId?: number | null
      recommended?: boolean | null
    }>
  } | null
}

export type GetAccountInformationQueryVariables = Exact<{ [key: string]: never }>

export type GetAccountInformationQuery = {
  __typename?: 'Query'
  Me?: {
    __typename?: 'ScalisUser'
    id: number
    firstName?: string | null
    lastName?: string | null
    Address?: Array<{
      __typename?: 'Address'
      id: number
      addressLine1?: string | null
      addressLine2?: string | null
      city?: string | null
      state?: string | null
      country?: string | null
      postalCode?: string | null
      timeZone?: string | null
      longitude?: string | null
      latitude?: string | null
    }> | null
    ContactInfo?: Array<{ __typename?: 'ContactInfo'; id: number; phoneNumber?: string | null }> | null
  } | null
}

export type GetEmailsQueryVariables = Exact<{
  scalisUserId: Scalars['Int']['input']
}>

export type GetEmailsQuery = {
  __typename?: 'Query'
  GetScalisUser?: {
    __typename?: 'ScalisUser'
    EmailVerification?: Array<{
      __typename: 'EmailVerification'
      id: number
      emailAddress?: string | null
      isPrimary?: boolean | null
      isVisibleToEmployers?: boolean | null
      activeStatus?: boolean | null
      emailVerified?: boolean | null
    }> | null
  } | null
}

export type GetScalisUserIdQueryVariables = Exact<{ [key: string]: never }>

export type GetScalisUserIdQuery = { __typename?: 'Query'; Me?: { __typename?: 'ScalisUser'; id: number } | null }

export const ScalisUserNameFragmentDoc = gql`
  fragment ScalisUserName on ScalisUser {
    firstName
    lastName
  }
`
export const CandidateProfileIdsFragmentDoc = gql`
  fragment CandidateProfileIds on CandidateProfile {
    ScalisUser {
      id
    }
    UploadedCandidate {
      id
    }
  }
`
export const CandidateProfileNameFragmentDoc = gql`
  fragment CandidateProfileName on CandidateProfile {
    ScalisUser {
      ...ScalisUserName
    }
    UploadedCandidate {
      firstName
      lastName
    }
  }
  ${ScalisUserNameFragmentDoc}
`
export const ActivityLogFragmentDoc = gql`
  fragment ActivityLog on ActivityLog {
    id
    activity
    userAction
    templateStageId
    previousTemplateStageId
    activityTimestamp
    companyCandidateTouchpointId
    CompanyUser {
      id
      UserInvitation {
        id
        ScalisUser {
          id
          profileImage
          ...ScalisUserName
        }
      }
    }
    CandidateProfile {
      id
      ...CandidateProfileIds
      ...CandidateProfileName
    }
    CompanyCandidateTouchpoint {
      id
      name
    }
  }
  ${ScalisUserNameFragmentDoc}
  ${CandidateProfileIdsFragmentDoc}
  ${CandidateProfileNameFragmentDoc}
`
export const AddressFragmentFragmentDoc = gql`
  fragment AddressFragment on Address {
    id
    addressLine1
    addressLine2
    city
    state
    country
    postalCode
    timeZone
    longitude
    latitude
  }
`
export const ApplicantNotesFragmentFragmentDoc = gql`
  fragment ApplicantNotesFragment on ApplicantNotes {
    id
    createdAt
    candidateApplicationId
    scalisUserId
    UserNote {
      id
      noteText
    }
  }
`
export const CandidateApplicationFragmentDoc = gql`
  fragment CandidateApplication on CandidateApplication {
    id
    matchScore
    applicationStatus
    applicationType
    applicationCreationType
    updatedAt
    appliedAt
    lastUpdatedStatusAt
    templateStageId
    jobListingId
    averageRating
    lastActivityDate
    duplicationStatus
  }
`
export const CandidateCollaboratorFragmentFragmentDoc = gql`
  fragment CandidateCollaboratorFragment on CandidateCollaborator {
    id
    requisitionId
    companyUserId
    candidateProfileId
    roleId
    requisitionJobDescriptionId
  }
`
export const CandidateInterviewFragmentDoc = gql`
  fragment CandidateInterview on CandidateInterview {
    id
    stageId
    status
  }
`
export const CandidateLabelFragmentDoc = gql`
  fragment CandidateLabel on CandidateLabel {
    id
    colorNumber
    labelName
  }
`
export const CandidateProfilePhoneFragmentDoc = gql`
  fragment CandidateProfilePhone on CandidateProfile {
    ScalisUser {
      ContactInfo {
        id
        phoneNumber
      }
    }
    UploadedCandidate {
      EnrichedPhoneNumber {
        id
        recommended
        phoneNumber
      }
    }
  }
`
export const CandidateSourceFragmentDoc = gql`
  fragment CandidateSource on CandidateSource {
    id
    candidateSourceName {
      id
      name
      sourceCategory
      customSourceCategory {
        id
        sourceCategoryName
      }
    }
  }
`
export const CompanyDepartmentFragmentFragmentDoc = gql`
  fragment CompanyDepartmentFragment on CompanyDepartment {
    id
    companyId
    departmentName
    subordinateTo
    externalId
    createdAt
    updatedAt
  }
`
export const CompanyInfoFragmentFragmentDoc = gql`
  fragment CompanyInfoFragment on CompanyInfo {
    id
    companyName
    logo
  }
`
export const CompanyUserFragmentFragmentDoc = gql`
  fragment CompanyUserFragment on CompanyUser {
    id
    companyId
    companyUserStatus
    profileImage
  }
`
export const CompanyRequiredFieldsFragmentDoc = gql`
  fragment CompanyRequiredFields on Company {
    Address {
      activeStatus
      addressLine1
      addressLine2
      addressType
      city
      contactName
      createdAt
      country
      id
      latitude
      longitude
      postalCode
      scalisUserId
      timeZone
      state
      updatedAt
    }
    CompanyInfo {
      atsNeeds
      companyId
      companyType
      employeeCount
      companyName
      createdAt
      hearAboutUs
      industry
      hiringNeeds
      id
      logo
      phoneNumber
      positionsToFill
      updatedAt
      recruitingOrStaffing
      subIndustry
      usingATS
      website
      yearsInOperation
    }
    CompanyDepartment {
      companyId
      createdAt
      departmentName
      externalId
      id
      subordinateTo
      updatedAt
    }
    CompanyOffice {
      companyId
      createdAt
      externalId
      id
      officeName
      updatedAt
    }
    createdAt
    externalId
    id
    lastActivity
    subdomain
    updatedAt
  }
`
export const CoreReportFragmentDoc = gql`
  fragment CoreReport on CoreReport {
    reportName
    isFavorite
    updatedAt
    createdAt
    companyId
    id
  }
`
export const CurrentJobFragmentDoc = gql`
  fragment CurrentJob on ScalisUser {
    currentJob: Experience(onlyCurrentJob: true) {
      id
      jobTitle
      employerName
    }
  }
`
export const CustomApplicationStatusFragmentDoc = gql`
  fragment CustomApplicationStatus on CustomApplicationStatus {
    id
    applicationStatusName
    iconType
    iconUnicode
    colorHexCode
    createdAt
    updatedAt
  }
`
export const CustomCandidateApplicationFieldValueFragmentDoc = gql`
  fragment CustomCandidateApplicationFieldValue on CustomCandidateApplicationFieldValue {
    id
    value
    updatedAt
    customCandidateApplicationField {
      id
      name
      type
      schema
      visibility
      provider
      systemTokenName
    }
  }
`
export const CustomCandidateApplicationFieldFragmentDoc = gql`
  fragment CustomCandidateApplicationField on CustomCandidateApplicationField {
    id
    name
    type
    systemTokenName
    visibility
    schema
    provider
    isArchived
    updatedAt
    tooltip
    tooltipText
    showWhenUploadingCandidate
    requireWhenUploadingCandidate
    customCandidateApplicationFieldRequisitions {
      id
      requisition {
        id
        jobName
        JobListing {
          id
          externalTitle
          listingTitle
        }
      }
    }
    customCandidateApplicationFieldValues {
      ...CustomCandidateApplicationFieldValue
    }
    createdBy {
      id
      firstName
      lastName
      profileImage
    }
  }
  ${CustomCandidateApplicationFieldValueFragmentDoc}
`
export const CustomCandidateApplicationFieldOutputFragmentDoc = gql`
  fragment CustomCandidateApplicationFieldOutput on CustomCandidateApplicationFieldOutput {
    id
    name
    companyId
    schema
    type
    requisitionIds
    isArchived
    visibility
    provider
    systemTokenName
    tooltip
    tooltipText
    showWhenUploadingCandidate
    requireWhenUploadingCandidate
  }
`
export const CustomCandidateProfileFieldValueFragmentDoc = gql`
  fragment CustomCandidateProfileFieldValue on CustomCandidateProfileFieldValue {
    id
    value
    updatedAt
    customCandidateProfileField {
      id
      name
      type
      schema
      visibility
      provider
      systemTokenName
    }
  }
`
export const CustomCandidateProfileFieldFragmentDoc = gql`
  fragment CustomCandidateProfileField on CustomCandidateProfileField {
    id
    name
    type
    systemTokenName
    visibility
    schema
    provider
    isArchived
    updatedAt
    tooltip
    tooltipText
    showWhenUploadingCandidate
    requireWhenUploadingCandidate
    createdBy {
      id
      firstName
      lastName
      profileImage
    }
    customCandidateProfileFieldValues {
      ...CustomCandidateProfileFieldValue
    }
  }
  ${CustomCandidateProfileFieldValueFragmentDoc}
`
export const CustomCandidateProfileFieldOutputFragmentDoc = gql`
  fragment CustomCandidateProfileFieldOutput on CustomCandidateProfileFieldOutput {
    id
    name
    companyId
    schema
    type
    requisitionId
    isArchived
    visibility
    provider
    systemTokenName
    tooltip
    tooltipText
    showWhenUploadingCandidate
    requireWhenUploadingCandidate
  }
`
export const CustomJobRequisitionFieldOutputFragmentDoc = gql`
  fragment CustomJobRequisitionFieldOutput on CustomJobRequisitionField {
    id
    name
    companyId
    schema
    type
    isRequired
    isArchived
    visibility
    provider
    systemTokenName
    tooltip
    tooltipText
    createdAt
    updatedAt
  }
`
export const CustomJobRequisitionFieldFragmentDoc = gql`
  fragment CustomJobRequisitionField on CustomJobRequisitionField {
    id
    name
    type
    systemTokenName
    visibility
    schema
    provider
    isArchived
    isRequired
    updatedAt
    tooltip
    tooltipText
    createdBy {
      id
      firstName
      lastName
      profileImage
    }
  }
`
export const CustomJobRequisitionFieldValueFragmentDoc = gql`
  fragment CustomJobRequisitionFieldValue on CustomJobRequisitionFieldValue {
    id
    requisitionId
    customJobRequisitionFieldId
    value
    companyUserId
    createdAt
    updatedAt
    customJobRequisitionField {
      ...CustomJobRequisitionField
    }
  }
  ${CustomJobRequisitionFieldFragmentDoc}
`
export const ExperienceFragmentDoc = gql`
  fragment Experience on Experience {
    id
    jobTitle
    employerName
    longFormDesc
    startDate
    endDate
    jobType
    location
    locationType
    description
    isCurrentlyWorking
    isCurrentJob
  }
`
export const HiringTeamMemberFragmentFragmentDoc = gql`
  fragment HiringTeamMemberFragment on HiringTeamMember {
    id
    companyUserId
    roleId
    requisitionId
    requisitionJobDescriptionId
    role {
      id
      name
    }
  }
`
export const JobCampaignProductFragmentFragmentDoc = gql`
  fragment JobCampaignProductFragment on JobCampaignProduct {
    product_id
    audience_group
    title
    description
    homepage
    cross_postings
    duration {
      period
      range
    }
    industries {
      id
      name
    }
    job_functions {
      id
      name
    }
    locations {
      canonical_name
      id
    }
    logo_rectangle_url {
      url
    }
    vonq_price {
      amount
      currency
    }
    time_to_process {
      period
      range
    }
  }
`
export const RequisitionJobDescriptionFragmentFragmentDoc = gql`
  fragment RequisitionJobDescriptionFragment on RequisitionJobDescription {
    id
    requisitionId
    description
  }
`
export const JobListingJobPipelineFragmentFragmentDoc = gql`
  fragment JobListingJobPipelineFragment on JobListingJobPipeline {
    id
    jobListingId
    jobPipelineId
  }
`
export const JobListingScreeningQuestionFragmentFragmentDoc = gql`
  fragment JobListingScreeningQuestionFragment on JobListingScreeningQuestion {
    id
    jobListingId
    displaySequenceNumber
    screeningQuestionId
  }
`
export const JobListingFragmentFragmentDoc = gql`
  fragment JobListingFragment on JobListing {
    id
    publicListingId
    jobRequisitionId
    listingTitle
    externalTitle
    workplaceType
    publicDescription
    displayPayOnListing
    industry
    subIndustry
    companyDefault
    stateAndOrCountry
    internalMatchingDescription
    searchPublicDescription
    searchInternalMatchingDescription
    postedAt
    acceptingCandidates
    stage
    CandidateApplication {
      id
      applicationStatus
      TemplateStage {
        id
        templateMilestoneId
      }
    }
    createdAt
    updatedAt
  }
`
export const JobOpeningFragmentDoc = gql`
  fragment JobOpening on JobOpening {
    id
    jobRequisitionId
    openingStatus
    extOpeningId
    companyId
    targetHireDate
    openingType
    filledDate
    startDate
    filledByApplication
    filledByCandidate
    closedReason
    closedDate
  }
`
export const JobPipelineFragmentFragmentDoc = gql`
  fragment JobPipelineFragment on JobPipeline {
    id
    title
    jobRequisitionId
    templatePipelineId
  }
`
export const JobSearchPreferenceFragmentFragmentDoc = gql`
  fragment JobSearchPreferenceFragment on JobSearchPreference {
    id
    scalisUserId
    includeJobTitles
    excludeJobTitles
    jobType
    datePosted
    workplaceTypePreference
    workplaceLocationPreference
    relocationTypePreference
    relocationLocationPreference
    minimumPayPreference
    visaSponsorship
    benefits
    industryPreference
    desiredCompanySize
    minimumRequiredExperience
    maxRequiredExperience
    companyStage
    createdAt
    updatedAt
  }
`
export const ProspectStatusFragmentDoc = gql`
  fragment ProspectStatus on TalentPoolProspectStatus {
    id
    colorNumber
    status
  }
`
export const RequisitionSkillsFragmentFragmentDoc = gql`
  fragment RequisitionSkillsFragment on RequisitionSkill {
    id
    requisitionId
    skillId
    displayName
    level
    yearsOfExp
    sequenceNumber
    createdAt
    updatedAt
    skill {
      id
      name
    }
  }
`
export const RequisitionFragmentFragmentDoc = gql`
  fragment RequisitionFragment on Requisition {
    id
    jobStatus
    openedAt
    jobName
    extRequisitionId
    jobType
    jobLevel
    travelType
    payType
    minPay
    maxPay
    additionalComp
    benefits
    locationDistancePref
    educationLevelPref
    yearsOfExperiencePref
    nonTraditionalPref
    veteranPref
    diverseHirePref
    collegeGradPref
    isIncomplete
    CompanyDepartment {
      id
      departmentName
    }
    CompanyOffice {
      id
      officeName
    }
    createdAt
    updatedAt
  }
`
export const RoleFragmentFragmentDoc = gql`
  fragment RoleFragment on Role {
    id
    name
  }
`
export const ScalisUserAboutFragmentFragmentDoc = gql`
  fragment ScalisUserAboutFragment on ScalisUser {
    JobSeekerInfo {
      id
      aboutMe
      searchingJobs
    }
  }
`
export const ScalisUserAchievementsFragmentFragmentDoc = gql`
  fragment ScalisUserAchievementsFragment on ScalisUser {
    Achievement {
      id
      name
      issuingAuthority
      issueYear
      description
    }
  }
`
export const ScalisUserCertificatesOrLicensesFragmentFragmentDoc = gql`
  fragment ScalisUserCertificatesOrLicensesFragment on ScalisUser {
    CertificateOrLicense {
      id
      name
      issuingAuthority
      issueYear
      description
    }
  }
`
export const ScalisUserDemographicInfoFragmentFragmentDoc = gql`
  fragment ScalisUserDemographicInfoFragment on ScalisUser {
    DemographicInfo {
      gender
      raceEthnicity
      veteranStatus
    }
  }
`
export const ScalisUserEducationFragmentFragmentDoc = gql`
  fragment ScalisUserEducationFragment on ScalisUser {
    Education {
      id
      institutionName
      educationLevel
      areasOfStudy
      startDate
      endDate
      cumGPA
      cumGPAScale
      majors
      minors
      hideCumGPA
      hideDepartmentGPA
      departmentCumGPA
      additionalInformation
      currentlyStudying
      organization {
        logo
        name
        website
      }
    }
  }
`
export const ScalisUserExperienceFragmentFragmentDoc = gql`
  fragment ScalisUserExperienceFragment on ScalisUser {
    Experience {
      id
      jobTitle
      employerName
      jobType
      locationType
      location
      startDate
      endDate
      isCurrentlyWorking
      isCurrentJob
      description
      industry
      subIndustry
      managementPosition
      teamSize
      isCurrentlyWorking
      jobSeekerSkillExperiences {
        id
        jobSeekerSkill {
          id
          displayName
        }
      }
      organization {
        logo
        name
        website
      }
    }
  }
`
export const ScalisUserSkillsFragmentFragmentDoc = gql`
  fragment ScalisUserSkillsFragment on ScalisUser {
    JobSeekerSkill {
      id
      sequenceNumber
      level
      name
      yearsOfExp
    }
  }
`
export const ScalisUserVolunteerWorkFragmentFragmentDoc = gql`
  fragment ScalisUserVolunteerWorkFragment on ScalisUser {
    VolunteerWork {
      id
      roleType
      volunteerJobTitle
      organizationName
      location
      startDate
      endDate
      isCurrentlyWorking
      description
      searchDescription
    }
  }
`
export const ScalisUserWebsiteOrSocialMediaFragmentDoc = gql`
  fragment ScalisUserWebsiteOrSocialMedia on ScalisUser {
    WebsiteOrSocialMedia {
      id
      websiteURL
      type
    }
  }
`
export const ScheduledReportFragmentDoc = gql`
  fragment ScheduledReport on ScheduledReport {
    coreReportId
    customDaysOfWeek
    customTime
    deleted
    endDate
    id
    recipients
    repeat
    reportSchedulerType
    startDate
  }
`
export const ScreenStageCollaboratorFragmentFragmentDoc = gql`
  fragment ScreenStageCollaboratorFragment on StageCollaborator {
    __typename
    id
    CompanyUser {
      __typename
      id
      profileImage
      UserInvitation {
        __typename
        id
        email
        ScalisUser {
          __typename
          id
          firstName
          lastName
        }
      }
    }
  }
`
export const ScreeningQuestionFragmentFragmentDoc = gql`
  fragment ScreeningQuestionFragment on ScreeningQuestion {
    id
    isTemplateQuestion
    questionTitle
    questionDesc
    questionType
    minVal
    maxVal
    valStatus
    ansOptions
    isRejectionQuestion
    isGlobalQuestion
    rejectMessage
    templateMessageId
    preferredAnswer
    companyId
    companyUserId
    createdAt
    updatedAt
  }
`
export const SequenceMetricsResponseFragmentDoc = gql`
  fragment SequenceMetricsResponse on SequenceMetricsResponse {
    bounceRate
    completed
    currentlyActive
    emailClickRate
    emailOpenRate
    replyRate
    totalEnrolled
  }
`
export const SequenceScheduleSettingFragmentDoc = gql`
  fragment SequenceScheduleSetting on SequenceScheduleSetting {
    id
    name
    endTime
    daysOfWeek
    timeZone
    startTime
    isDefault
    useContactLocalTime
  }
`
export const ConnectedEmailSettingsFragmentDoc = gql`
  fragment ConnectedEmailSettings on ConnectedEmailSettings {
    id
    email
    provider
    dailyLimit
    hourlyLimit
    minutesBetweenEmails
    allowSendOnBehalf
    optOutEnabled
    emailSignatureEnabled
    optOutMessage
    emailSignature
    createdAt
    updatedAt
  }
`
export const SequenceSettingFragmentDoc = gql`
  fragment SequenceSetting on SequenceSetting {
    id
    includeUnsubscribeLink
    connectedEmailSettingsId
    sequenceScheduleSettingId
    cc
    bcc
    SequenceScheduleSetting {
      ...SequenceScheduleSetting
    }
    ConnectedEmailSettings {
      ...ConnectedEmailSettings
    }
  }
  ${SequenceScheduleSettingFragmentDoc}
  ${ConnectedEmailSettingsFragmentDoc}
`
export const TemplateMessageFragmentDoc = gql`
  fragment TemplateMessage on TemplateMessage {
    id
    message
    title
  }
`
export const SequenceStepFragmentDoc = gql`
  fragment SequenceStep on SequenceStep {
    id
    replyPreviousThread
    subject
    templateMessageId
    body
    spreadStrategy
    afterPreviousStep
    emailLimitPerDay
    stepNumber
    customSendTime
    schedulerType
    sendTimeType
    emailOpenedCount
    emailRepliedCount
    emailClickedCount
    dropOffsCount
    TemplateMessage {
      ...TemplateMessage
    }
  }
  ${TemplateMessageFragmentDoc}
`
export const SequenceFragmentDoc = gql`
  fragment Sequence on Sequence {
    id
    name
    description
    companyUserId
    associatedRequisitionIds
    associatedTalentPoolIds
    visibility
    createdAt
    numberOfSteps
    sequenceStatus
    numberOfActives
    numberOfCompleted
    ownerName
    ownerCompanyUserId
    isFavorite
    candidatesCount
    emailBouncedCount
    emailClickedCount
    emailOpenedCount
    emailRepliedCount
    SequenceSetting {
      ...SequenceSetting
    }
    SequenceSteps {
      ...SequenceStep
    }
  }
  ${SequenceSettingFragmentDoc}
  ${SequenceStepFragmentDoc}
`
export const SharedCoreReportFragmentDoc = gql`
  fragment SharedCoreReport on SharedCoreReport {
    email
    id
    coreReportId
    companyUserId
  }
`
export const SkillFragmentFragmentDoc = gql`
  fragment SkillFragment on Skill {
    id
    name
  }
`
export const SourceTrackingLinkFragmentDoc = gql`
  fragment SourceTrackingLink on SourceTrackingLink {
    id
    jobListingId
    genericListingLink
    name
    shortCode
    isDeleted
    companyUserId
    whoGetsCredit
    candidateSourceNameId
    countViews
    countUniqueViews
    countClicksToApply
    countApplies
    createdAt
    updatedAt
    redirectUrl
    jobListing {
      id
      publicListingId
      listingTitle
      Requisition {
        id
        jobName
      }
    }
    companyUser {
      id
      UserInvitation {
        ScalisUser {
          id
          firstName
          lastName
        }
      }
    }
    whoGetsCreditCompanyUser {
      id
      UserInvitation {
        ScalisUser {
          id
          firstName
          lastName
        }
      }
    }
    candidateSourceName {
      id
      name
      sourceCategory
      customSourceCategory {
        id
        sourceCategoryName
      }
    }
  }
`
export const StageCollaboratorFragmentFragmentDoc = gql`
  fragment StageCollaboratorFragment on StageCollaborator {
    id
    requisitionId
    companyUserId
    templateStageId
    roleId
    requisitionJobDescriptionId
  }
`
export const StageSettingsFragmentFragmentDoc = gql`
  fragment StageSettingsFragment on StageSettings {
    id
    jobPipelineId
    templateStageId
    scorecardTemplateId
  }
`
export const TalentPoolFragmentDoc = gql`
  fragment TalentPool on TalentPool {
    associatedRequisitionIds
    companyId
    companyUserId
    contributorCompanyUserIds
    description
    id
    isArchived
    isFavorite
    isVisibleTo
    name
    ownerCompanyUserId
    ownerName
    tags
    count
    talentPoolType
    updatedAt
  }
`
export const TemplateStageKanbanFragmentDoc = gql`
  fragment TemplateStageKanban on TemplateStage {
    id
    name
    rankOrder
    visibility
    CandidateApplicationByStage(requisitionId: $id) {
      id
    }
  }
`
export const TemplateMilestoneKanbanFragmentDoc = gql`
  fragment TemplateMilestoneKanban on TemplateMilestone {
    __typename
    id
    name
    rankOrder
    TemplateStage {
      __typename
      ...TemplateStageKanban
    }
  }
  ${TemplateStageKanbanFragmentDoc}
`
export const TemplateMilestoneFragmentDoc = gql`
  fragment TemplateMilestone on TemplateMilestone {
    id
    templatePipelineId
    name
    rankOrder
    archived
    createdAt
    updatedAt
  }
`
export const TemplatePipelineFragmentFragmentDoc = gql`
  fragment TemplatePipelineFragment on TemplatePipeline {
    id
    companyId
    companyUserId
    name
    companyDepartmentId
    archived
    pipelinedUsed
    ghostPipeline
    createdAt
    updatedAt
    deletedAt
  }
`
export const TemplateStageFragmentDoc = gql`
  fragment TemplateStage on TemplateStage {
    id
    templatePipelineId
    visibility
    name
    templateMilestoneId
    rankOrder
    archived
    createdAt
    updatedAt
  }
`
export const UserInvitationFragmentFragmentDoc = gql`
  fragment UserInvitationFragment on UserInvitation {
    id
    email
    invitedAs
    invitationStatus
  }
`
export const UserNoteFragmentFragmentDoc = gql`
  fragment UserNoteFragment on UserNote {
    id
    noteText
  }
`
export const CandidateFilterFragmentDoc = gql`
  fragment CandidateFilter on CandidateFilter {
    id
    name
    filters
  }
`
export const CompanySavedViewFragmentDoc = gql`
  fragment CompanySavedView on CompanySavedView {
    id
    name
    viewLayout
    companyUserId
    viewLocation
    viewType
    isVisibleTo
    sorting
    columnVisibility
    columnOrder
    columnSizing
    candidateFilter {
      ...CandidateFilter
    }
    requisitionTalentPoolCompanySavedViews {
      id
    }
  }
  ${CandidateFilterFragmentDoc}
`
export const RequisitionTalentPoolCompanySavedViewFragmentDoc = gql`
  fragment RequisitionTalentPoolCompanySavedView on RequisitionTalentPoolCompanySavedView {
    id
    isPinned
    companySavedViewId
    hasPinnedSavedViewForCurrentRequisition
    belongsToCurrentRequisition
    wasRemovedForCurrentUser
    companySavedView {
      ...CompanySavedView
    }
  }
  ${CompanySavedViewFragmentDoc}
`
export const CompanyUserViewFragmentDoc = gql`
  fragment CompanyUserView on CompanyUserView {
    id
    companyUserId
    rankOrder
    requisitionTalentPoolCompanySavedViewId
    requisitionTalentPoolCompanySavedView {
      ...RequisitionTalentPoolCompanySavedView
    }
  }
  ${RequisitionTalentPoolCompanySavedViewFragmentDoc}
`
export const ViewLinkWithUserPreferenceFragmentDoc = gql`
  fragment ViewLinkWithUserPreference on ViewLinkWithUserPreference {
    userPreferenceObject {
      ...CompanyUserView
    }
    viewLink {
      ...RequisitionTalentPoolCompanySavedView
    }
  }
  ${CompanyUserViewFragmentDoc}
  ${RequisitionTalentPoolCompanySavedViewFragmentDoc}
`
export const AiCreditPackageFragmentDoc = gql`
  fragment AiCreditPackage on AiCreditPackage {
    id
    name
    creditsAmount
    totalPrice
    pricePerCredit
    vatAmount
    description
    sortOrder
  }
`
export const CandidateRecommendationsHighlightsFragmentDoc = gql`
  fragment CandidateRecommendationsHighlights on CandidateRecommendationsHighlights {
    id
    summary
    scores {
      sections {
        name
        score
        details {
          exactMatch
          explanation
          name
          similarTo
          verifiedFrom
        }
      }
    }
    highlights {
      icon
      name
      summary
    }
  }
`
export const OrganizationFragmentDoc = gql`
  fragment Organization on Organization {
    id
    description
    founded
    funding {
      lastFundingRound
    }
    headcount {
      bucket
      size
    }
    imageUrl
    industries
    location {
      address
      address2
      city
      continent
      coordinates {
        lat
        lon
      }
      country
      name
      postalCode
      region
    }
    name
    type
    url
  }
`
export const SocialFragmentDoc = gql`
  fragment Social on Social {
    id
    imageUrl
    type
    url
    username
  }
`
export const CandidateRecommendationFragmentDoc = gql`
  fragment CandidateRecommendation on CandidateRecommendation {
    id
    publicListingId
    headline
    summary
    industry
    isActive
    createdAt
    updatedAt
    interests
    imageUrl
    source
    achievements {
      list {
        endDate
        startDate
        summary
        title
      }
    }
    certifications {
      list {
        endDate
        organization {
          ...Organization
        }
        startDate
        summary
        title
      }
    }
    contact {
      demographics {
        gender
        race
        veteranStatus
      }
      emails {
        email
        isCurrent
        type
      }
      name {
        first
        full
        last
        middle
      }
      phones {
        isCurrent
        number
        type
      }
    }
    educations {
      list {
        endDate
        gpa {
          scale
          value
        }
        isCurrent
        level
        majors
        minors
        organization {
          ...Organization
        }
        startDate
        summary
        title
      }
      tenure {
        unit
        value
      }
    }
    experiences {
      lastChangedAt
      lastVerifiedAt
      list {
        employmentType
        isCurrent
        location {
          address
          address2
          city
          continent
          coordinates {
            lat
            lon
          }
          country
          name
          postalCode
          region
        }
        locationType
        organization {
          ...Organization
        }
        payType
        position {
          class
          isManagement
          levels
          role
          subRole
          teamSize
        }
        startDate
        endDate
        summary
        tenure {
          unit
          value
        }
        title
      }
      tenure {
        avg
        count
        current
        unit
        value
      }
    }
    languages {
      name
      proficiency
    }
    location {
      address
      address2
      city
      continent
      coordinates {
        lat
        lon
      }
      country
      name
      postalCode
      region
    }
    scores {
      overall
      highlights {
        icon
        name
        summary
      }
      sections {
        name
        score
        details {
          exactMatch
          explanation
          name
          similarTo
          verifiedFrom
        }
      }
    }
    skills {
      list {
        name
      }
    }
    socials {
      ...Social
    }
    volunteerWork {
      list {
        endDate
        isCurrent
        position {
          class
          isManagement
          levels
          role
          subRole
          teamSize
        }
        organization {
          ...Organization
        }
        startDate
        summary
        title
      }
      tenure {
        unit
        value
      }
    }
  }
  ${OrganizationFragmentDoc}
  ${SocialFragmentDoc}
`
export const ApprovalWorkflowReviewerFragmentDoc = gql`
  fragment ApprovalWorkflowReviewer on ApprovalWorkflowReviewer {
    id
    companyUserId
    companyUserGroupId
    hiringTeamRole
  }
`
export const ApprovalWorkflowStepFragmentDoc = gql`
  fragment ApprovalWorkflowStep on ApprovalWorkflowStep {
    id
    rankOrder
    approvalStrictnessLevel
    finalStep
    reviewers {
      ...ApprovalWorkflowReviewer
    }
  }
  ${ApprovalWorkflowReviewerFragmentDoc}
`
export const ApprovalWorkflowInstanceStepReviewerFragmentDoc = gql`
  fragment ApprovalWorkflowInstanceStepReviewer on ApprovalWorkflowInstanceStepReviewer {
    id
    status
    companyUserId
    hiringTeamRole
    companyUserGroupId
    respondedToBy
    comments
    respondedAt
    canRespond
  }
`
export const ApprovalWorkflowInstanceStepFragmentDoc = gql`
  fragment ApprovalWorkflowInstanceStep on ApprovalWorkflowInstanceStep {
    id
    approvalWorkflowVersionId
    rankOrder
    approvalStepStatus
    approvalStrictnessLevel
    finalStep
    createdAt
    updatedAt
    canRespond
    reviewers {
      ...ApprovalWorkflowInstanceStepReviewer
    }
  }
  ${ApprovalWorkflowInstanceStepReviewerFragmentDoc}
`
export const CompanyUserInfoFragmentDoc = gql`
  fragment CompanyUserInfo on CompanyUser {
    id
    UserInvitation {
      id
      ScalisUser {
        id
        firstName
        lastName
        profileImage
      }
    }
  }
`
export const ScalisUserFragmentDoc = gql`
  fragment ScalisUser on ScalisUser {
    id
    activeStatus
    profileImage
    ...ScalisUserName
  }
  ${ScalisUserNameFragmentDoc}
`
export const GetCandidateInterviewsProfileApplicationFragmentDoc = gql`
  fragment GetCandidateInterviewsProfileApplication on CandidateApplication {
    CandidateInterview {
      CalendarEvent {
        EventAttachments {
          id
          file
          eventId
        }
        Calendar {
          name
          id
          isPrimary
        }
        title
        timeZone
        startTime
        repeats
        reminders
        regardingJobs
        regardingCandidates
        nylasEventStatus
        nylasCalendarEventId
        masterEventId
        location
        isScalisEvent
        internalGuests
        id
        eventType
        employers
        endTime
        description
        conferencing
        companyUserId
        candidates
        calendarId
        CompanyUser {
          id
          UserInvitation {
            id
            ScalisUser {
              ...ScalisUser
            }
          }
        }
      }
      stageId
      interviewData
      id
      status
      companyUserId
      applicationId
      integrationsNylasNotetakerId
    }
    viewedProfile
    viewedAt
    templateStageId
    matchScore
    lastUpdatedStatusAt
    jobListingId
    interviewScheduling
    id
    deleted
    createdAt
    companyId
    candidateProfileId
    appliedAt
    applicationType
    applicationTimestamp
    applicationCreationType
    applicationStatus
    TemplateStage {
      id
      name
      visibility
      TemplateMilestone {
        id
        name
      }
      TemplatePipeline {
        id
        TemplateMilestones {
          id
          name
          rankOrder
          TemplateStage {
            name
            id
            rankOrder
            visibility
          }
        }
      }
    }
    JobListing {
      externalListingId
      externalTitle
      publicListingId
      id
      Requisition {
        id
        jobName
        extRequisitionId
      }
      jobRequisitionId
      stateAndOrCountry
      workplaceType
      Address {
        id
        timeZone
        state
        longitude
        latitude
        country
        activeStatus
        addressLine1
        addressLine2
        addressType
        city
        postalCode
      }
    }
    CandidateScorecard {
      id
      status
      templateStageId
      companyUserId
      ScorecardTemplate {
        id
        scorecardName
      }
      CompanyUser {
        id
        UserInvitation {
          id
          ScalisUser {
            ...ScalisUser
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`
export const OfferCustomFieldFragmentDoc = gql`
  fragment OfferCustomField on OfferCustomField {
    id
    fieldConfigurationType
    fieldName
    fieldDescription
    generateSystemToken
    systemTokenName
    fieldRequired
    triggerNewOfferVersion
    multipleChoiceOptions
    updatedAt
    CandidateOfferCustomField {
      id
      fieldValue
    }
    OfferTemplateCondition {
      id
      officeId
      payType
      employmentType
      departmentId
    }
  }
`
export const CandidateOfferVersionFragmentDoc = gql`
  fragment CandidateOfferVersion on CandidateOfferVersion {
    id
    candidateOfferId
    version
    candidateName
    jobTitle
    manager
    startDate
    jobType
    payType
    benefits
    expirationDate
    companyOfficeId
    compensation
    additionalCompensation
    offerStatus
    lastUpdatedStatusAt
    createdAt
    CandidateOfferCustomField {
      id
      fieldValue
      OfferCustomField {
        id
        fieldName
        fieldConfigurationType
        triggerNewOfferVersion
      }
    }
    CompanyOffice {
      id
      officeName
    }
    CandidateOfferFile {
      id
      fileName
      filePath
      fileType
      createdAt
    }
    CandidateOfferVersionSignature {
      id
      emailAddress
      name
      signedAt
      viewedAt
      createdAt
    }
  }
`
export const OfferDocumentTemplateFragmentDoc = gql`
  fragment OfferDocumentTemplate on OfferDocumentTemplate {
    id
    documentTemplateName
    documentTemplateText
  }
`
export const GetCompareScorecardTemplatesQuestionFragmentDoc = gql`
  fragment GetCompareScorecardTemplatesQuestion on ScorecardTemplateQuestion {
    id
    answerOptions
    preferredAnswer
    questionDescription
    questionText
    questionType
    scoreAnswer
    scorecardTemplateSectionId
    skillDisplayName
    CandidateScorecardAnswers {
      answer
      answerPreferredStatus
      candidateScorecardId
      dateAnswer
      id
      overallRecommendation
      scoreAnswer
      scorecardTemplateQuestionId
    }
  }
`
export const UploadedCandidateWebsiteOrSocialMediaFragmentDoc = gql`
  fragment UploadedCandidateWebsiteOrSocialMedia on UploadedCandidateWebsiteOrSocialMedia {
    id
    websiteURL
    type
  }
`
export const UploadedCandidateAchievementFragmentDoc = gql`
  fragment UploadedCandidateAchievement on UploadedCandidateAchievement {
    id
    name
    issuingAuthority
    issueYear
    description
    searchDescription
  }
`
export const UploadedCandidateCertificateOrLicenseFragmentDoc = gql`
  fragment UploadedCandidateCertificateOrLicense on UploadedCandidateCertificateOrLicense {
    id
    name
    issuingAuthority
    issueYear
    description
    searchDescription
  }
`
export const UploadedCandidateEducationFragmentDoc = gql`
  fragment UploadedCandidateEducation on UploadedCandidateEducation {
    id
    institutionName
    currentlyStudying
    educationLevel
    startDate
    endDate
    areasOfStudy
    majors
    minors
    cumGPA
    cumGPAScale
    hideCumGPA
    hideDepartmentGPA
    departmentCumGPA
    departmentCumGPAScale
    additionalInformation
  }
`
export const UploadedCandidateExperienceFragmentDoc = gql`
  fragment UploadedCandidateExperience on UploadedCandidateExperience {
    id
    startDate
    endDate
    companyLogo
    locationType
    location
    shortFormDesc
    longFormDesc
    searchShortFormDesc
    searchLongFormDesc
    industry
    subIndustry
    payType
    jobPay
    additionalComp
    jobTitle
    employerName
    managementPosition
    teamSize
    workPlaceCandidate
    isCurrentJob
    jobType
    isCurrentlyWorking
    description
  }
`
export const UploadedCandidateJobSeekerSkillsFragmentDoc = gql`
  fragment UploadedCandidateJobSeekerSkills on UploadedCandidateJobSeekerSkills {
    id
    sequenceNumber
    level
    name
    yearsOfExp
  }
`
export const UploadedCandidateVolunteerWorkFragmentDoc = gql`
  fragment UploadedCandidateVolunteerWork on UploadedCandidateVolunteerWork {
    id
    volunteerJobTitle
    organizationName
    isCurrentlyWorking
    roleType
    startDate
    endDate
    description
    searchDescription
    location
  }
`
export const UploadedCandidateFragmentDoc = gql`
  fragment UploadedCandidate on UploadedCandidate {
    id
    linkedinProfile
    lastName
    firstName
    emailAddress
    companyUserId
    companyId
    profileImage
    profileUrl
    uploadedCandidateType
    CandidateProfile {
      id
      profileType
      CandidateApplication {
        id
      }
    }
    UploadedCandidateWebsiteOrSocialMedia {
      ...UploadedCandidateWebsiteOrSocialMedia
    }
    UploadedCandidateAchievement {
      ...UploadedCandidateAchievement
    }
    UploadedCandidateCertificateOrLicense {
      ...UploadedCandidateCertificateOrLicense
    }
    UploadedCandidateEducation {
      ...UploadedCandidateEducation
    }
    highestEducation: UploadedCandidateEducation(highestEducation: true) {
      ...UploadedCandidateEducation
    }
    UploadedCandidateExperience {
      ...UploadedCandidateExperience
    }
    ExperienceTenure {
      average
      longest
      shortest
    }
    currentJob: UploadedCandidateExperience(onlyCurrentJob: true) {
      ...UploadedCandidateExperience
    }
    mostRecentJob: UploadedCandidateExperience(onlyMostRecentJob: true) {
      ...UploadedCandidateExperience
    }
    UploadedCandidateJobSeekerSkill {
      ...UploadedCandidateJobSeekerSkills
    }
    UploadedCandidateVolunteerWork {
      ...UploadedCandidateVolunteerWork
    }
    UploadedCandidateWebsiteOrSocialMedia {
      ...UploadedCandidateWebsiteOrSocialMedia
    }
    EnrichedEmail {
      id
      emailAddress
      enrichedEmailType
      uploadedCandidateId
      recommended
    }
    EnrichedPhoneNumber {
      id
      phoneNumber
      uploadedCandidateId
      recommended
    }
  }
  ${UploadedCandidateWebsiteOrSocialMediaFragmentDoc}
  ${UploadedCandidateAchievementFragmentDoc}
  ${UploadedCandidateCertificateOrLicenseFragmentDoc}
  ${UploadedCandidateEducationFragmentDoc}
  ${UploadedCandidateExperienceFragmentDoc}
  ${UploadedCandidateJobSeekerSkillsFragmentDoc}
  ${UploadedCandidateVolunteerWorkFragmentDoc}
`
export const GetCompareScorecardTemplatesCandidateScorecardFragmentDoc = gql`
  fragment GetCompareScorecardTemplatesCandidateScorecard on CandidateScorecard {
    id
    companyUserId
    candidateApplicationId
    additionalInformation
    scorecardTemplateId
    status
    templateStageId
    CompanyUser {
      companyId
      companyUserStatus
      id
      profileImage
      userInvitationId
      UserInvitation {
        ScalisUser {
          ...ScalisUser
        }
      }
    }
    CandidateApplication {
      CandidateProfile {
        id
        ScalisUser {
          ...ScalisUser
          currentStage
          completedAt
        }
        UploadedCandidate {
          id
          ...UploadedCandidate
        }
      }
      id
    }
    CandidateScorecardAnswers {
      answer
      answerPreferredStatus
      candidateScorecardId
      dateAnswer
      id
      overallRecommendation
      scoreAnswer
      scorecardTemplateQuestionId
      ScorecardTemplateQuestion {
        skillDisplayName
        answerOptions
        id
        preferredAnswer
        questionDescription
        questionText
        questionType
        scoreAnswer
        scorecardTemplateSectionId
        skillId
      }
    }
  }
  ${ScalisUserFragmentDoc}
  ${UploadedCandidateFragmentDoc}
`
export const OfferSectionTemplateFragmentDoc = gql`
  fragment OfferSectionTemplate on OfferSectionTemplate {
    id
    sectionTemplateName
    sectionToken
    sectionTemplateText
    sectionTemplateStatus
    tokenDescription
    updatedAt
    CompanyUser {
      id
      UserInvitation {
        id
        ScalisUser {
          ...ScalisUser
        }
      }
    }
    OfferTemplateCondition {
      id
      officeId
      payType
      employmentType
      departmentId
    }
  }
  ${ScalisUserFragmentDoc}
`
export const CandidateProfileProfileImageFragmentDoc = gql`
  fragment CandidateProfileProfileImage on CandidateProfile {
    ScalisUser {
      profileImage
    }
    UploadedCandidate {
      profileImage
    }
  }
`
export const CandidateProfileLinkedInFragmentDoc = gql`
  fragment CandidateProfileLinkedIn on CandidateProfile {
    ScalisUser {
      WebsiteOrSocialMedia {
        id
        type
        websiteURL
      }
    }
    UploadedCandidate {
      linkedinProfile
    }
  }
`
export const CandidateProfileCurrentJobFragmentDoc = gql`
  fragment CandidateProfileCurrentJob on CandidateProfile {
    ScalisUser {
      currentJob: Experience(onlyCurrentJob: true) {
        id
        jobTitle
        employerName
      }
    }
    UploadedCandidate {
      currentJob: UploadedCandidateExperience(onlyCurrentJob: true) {
        id
        jobTitle
        employerName
      }
    }
  }
`
export const CandidateProfileEmailFragmentDoc = gql`
  fragment CandidateProfileEmail on CandidateProfile {
    ScalisUser {
      EmailVerification {
        id
        isPrimary
        emailAddress
      }
    }
    UploadedCandidate {
      emailAddress
      EnrichedEmail {
        id
        emailAddress
      }
    }
  }
`
export const SequenceCandidateEngagementCandidateProfileFragmentDoc = gql`
  fragment SequenceCandidateEngagementCandidateProfile on CandidateProfile {
    ...CandidateProfileIds
    ...CandidateProfileProfileImage
    ...CandidateProfileName
    ...CandidateProfileLinkedIn
    ...CandidateProfileCurrentJob
    ...CandidateProfileEmail
  }
  ${CandidateProfileIdsFragmentDoc}
  ${CandidateProfileProfileImageFragmentDoc}
  ${CandidateProfileNameFragmentDoc}
  ${CandidateProfileLinkedInFragmentDoc}
  ${CandidateProfileCurrentJobFragmentDoc}
  ${CandidateProfileEmailFragmentDoc}
`
export const UpsertAddressFormDocument = gql`
  mutation UpsertAddressForm($input: UpsertAddressInput!) {
    UpsertAddress(input: $input) {
      __typename
      id
    }
  }
`
export type UpsertAddressFormMutationFn = Apollo.MutationFunction<
  UpsertAddressFormMutation,
  UpsertAddressFormMutationVariables
>

/**
 * __useUpsertAddressFormMutation__
 *
 * To run a mutation, you first call `useUpsertAddressFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAddressFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAddressFormMutation, { data, loading, error }] = useUpsertAddressFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAddressFormMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertAddressFormMutation, UpsertAddressFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertAddressFormMutation, UpsertAddressFormMutationVariables>(
    UpsertAddressFormDocument,
    options,
  )
}
export type UpsertAddressFormMutationHookResult = ReturnType<typeof useUpsertAddressFormMutation>
export type UpsertAddressFormMutationResult = Apollo.MutationResult<UpsertAddressFormMutation>
export type UpsertAddressFormMutationOptions = Apollo.BaseMutationOptions<
  UpsertAddressFormMutation,
  UpsertAddressFormMutationVariables
>
export const PurchaseAiCreditsDocument = gql`
  mutation PurchaseAiCredits($input: PurchaseAiCreditsInput!) {
    PurchaseAiCredits(input: $input) {
      orderReference
      clientSecret
      packageInfo
      price
    }
  }
`
export type PurchaseAiCreditsMutationFn = Apollo.MutationFunction<
  PurchaseAiCreditsMutation,
  PurchaseAiCreditsMutationVariables
>

/**
 * __usePurchaseAiCreditsMutation__
 *
 * To run a mutation, you first call `usePurchaseAiCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseAiCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseAiCreditsMutation, { data, loading, error }] = usePurchaseAiCreditsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurchaseAiCreditsMutation(
  baseOptions?: Apollo.MutationHookOptions<PurchaseAiCreditsMutation, PurchaseAiCreditsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<PurchaseAiCreditsMutation, PurchaseAiCreditsMutationVariables>(
    PurchaseAiCreditsDocument,
    options,
  )
}
export type PurchaseAiCreditsMutationHookResult = ReturnType<typeof usePurchaseAiCreditsMutation>
export type PurchaseAiCreditsMutationResult = Apollo.MutationResult<PurchaseAiCreditsMutation>
export type PurchaseAiCreditsMutationOptions = Apollo.BaseMutationOptions<
  PurchaseAiCreditsMutation,
  PurchaseAiCreditsMutationVariables
>
export const CreateAiSourcingEventDocument = gql`
  mutation CreateAiSourcingEvent($input: CreateAiSourcingEventInput!) {
    CreateAiSourcingEvent(input: $input)
  }
`
export type CreateAiSourcingEventMutationFn = Apollo.MutationFunction<
  CreateAiSourcingEventMutation,
  CreateAiSourcingEventMutationVariables
>

/**
 * __useCreateAiSourcingEventMutation__
 *
 * To run a mutation, you first call `useCreateAiSourcingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiSourcingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiSourcingEventMutation, { data, loading, error }] = useCreateAiSourcingEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiSourcingEventMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAiSourcingEventMutation, CreateAiSourcingEventMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAiSourcingEventMutation, CreateAiSourcingEventMutationVariables>(
    CreateAiSourcingEventDocument,
    options,
  )
}
export type CreateAiSourcingEventMutationHookResult = ReturnType<typeof useCreateAiSourcingEventMutation>
export type CreateAiSourcingEventMutationResult = Apollo.MutationResult<CreateAiSourcingEventMutation>
export type CreateAiSourcingEventMutationOptions = Apollo.BaseMutationOptions<
  CreateAiSourcingEventMutation,
  CreateAiSourcingEventMutationVariables
>
export const DiscardCandidateRecommendationDocument = gql`
  mutation DiscardCandidateRecommendation($input: DiscardCandidateRecommendationInput!) {
    DiscardCandidateRecommendation(input: $input) {
      id
      companyId
      companyUserId
      requisitionId
      candidateId
      rate
      reason
      isDeleted
      createdAt
      updatedAt
    }
  }
`
export type DiscardCandidateRecommendationMutationFn = Apollo.MutationFunction<
  DiscardCandidateRecommendationMutation,
  DiscardCandidateRecommendationMutationVariables
>

/**
 * __useDiscardCandidateRecommendationMutation__
 *
 * To run a mutation, you first call `useDiscardCandidateRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardCandidateRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardCandidateRecommendationMutation, { data, loading, error }] = useDiscardCandidateRecommendationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardCandidateRecommendationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DiscardCandidateRecommendationMutation,
    DiscardCandidateRecommendationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DiscardCandidateRecommendationMutation, DiscardCandidateRecommendationMutationVariables>(
    DiscardCandidateRecommendationDocument,
    options,
  )
}
export type DiscardCandidateRecommendationMutationHookResult = ReturnType<
  typeof useDiscardCandidateRecommendationMutation
>
export type DiscardCandidateRecommendationMutationResult = Apollo.MutationResult<DiscardCandidateRecommendationMutation>
export type DiscardCandidateRecommendationMutationOptions = Apollo.BaseMutationOptions<
  DiscardCandidateRecommendationMutation,
  DiscardCandidateRecommendationMutationVariables
>
export const SelectRecommendedCandidateDocument = gql`
  mutation SelectRecommendedCandidate($input: SelectRecommendedCandidateInput!) {
    SelectRecommendedCandidate(input: $input) {
      id
    }
  }
`
export type SelectRecommendedCandidateMutationFn = Apollo.MutationFunction<
  SelectRecommendedCandidateMutation,
  SelectRecommendedCandidateMutationVariables
>

/**
 * __useSelectRecommendedCandidateMutation__
 *
 * To run a mutation, you first call `useSelectRecommendedCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectRecommendedCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectRecommendedCandidateMutation, { data, loading, error }] = useSelectRecommendedCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectRecommendedCandidateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelectRecommendedCandidateMutation,
    SelectRecommendedCandidateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SelectRecommendedCandidateMutation, SelectRecommendedCandidateMutationVariables>(
    SelectRecommendedCandidateDocument,
    options,
  )
}
export type SelectRecommendedCandidateMutationHookResult = ReturnType<typeof useSelectRecommendedCandidateMutation>
export type SelectRecommendedCandidateMutationResult = Apollo.MutationResult<SelectRecommendedCandidateMutation>
export type SelectRecommendedCandidateMutationOptions = Apollo.BaseMutationOptions<
  SelectRecommendedCandidateMutation,
  SelectRecommendedCandidateMutationVariables
>
export const DeleteAchievementDocument = gql`
  mutation DeleteAchievement($input: DeleteAchievementInput!) {
    DeleteAchievement(input: $input)
  }
`
export type DeleteAchievementMutationFn = Apollo.MutationFunction<
  DeleteAchievementMutation,
  DeleteAchievementMutationVariables
>

/**
 * __useDeleteAchievementMutation__
 *
 * To run a mutation, you first call `useDeleteAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAchievementMutation, { data, loading, error }] = useDeleteAchievementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAchievementMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAchievementMutation, DeleteAchievementMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteAchievementMutation, DeleteAchievementMutationVariables>(
    DeleteAchievementDocument,
    options,
  )
}
export type DeleteAchievementMutationHookResult = ReturnType<typeof useDeleteAchievementMutation>
export type DeleteAchievementMutationResult = Apollo.MutationResult<DeleteAchievementMutation>
export type DeleteAchievementMutationOptions = Apollo.BaseMutationOptions<
  DeleteAchievementMutation,
  DeleteAchievementMutationVariables
>
export const DeleteCertificateOrLicenseDocument = gql`
  mutation DeleteCertificateOrLicense($input: DeleteCertificateOrLicenseInput!) {
    DeleteCertificateOrLicense(input: $input)
  }
`
export type DeleteCertificateOrLicenseMutationFn = Apollo.MutationFunction<
  DeleteCertificateOrLicenseMutation,
  DeleteCertificateOrLicenseMutationVariables
>

/**
 * __useDeleteCertificateOrLicenseMutation__
 *
 * To run a mutation, you first call `useDeleteCertificateOrLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificateOrLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificateOrLicenseMutation, { data, loading, error }] = useDeleteCertificateOrLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCertificateOrLicenseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCertificateOrLicenseMutation,
    DeleteCertificateOrLicenseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCertificateOrLicenseMutation, DeleteCertificateOrLicenseMutationVariables>(
    DeleteCertificateOrLicenseDocument,
    options,
  )
}
export type DeleteCertificateOrLicenseMutationHookResult = ReturnType<typeof useDeleteCertificateOrLicenseMutation>
export type DeleteCertificateOrLicenseMutationResult = Apollo.MutationResult<DeleteCertificateOrLicenseMutation>
export type DeleteCertificateOrLicenseMutationOptions = Apollo.BaseMutationOptions<
  DeleteCertificateOrLicenseMutation,
  DeleteCertificateOrLicenseMutationVariables
>
export const DeleteEducationDocument = gql`
  mutation DeleteEducation($input: DeleteEducationInput!) {
    DeleteEducation(input: $input)
  }
`
export type DeleteEducationMutationFn = Apollo.MutationFunction<
  DeleteEducationMutation,
  DeleteEducationMutationVariables
>

/**
 * __useDeleteEducationMutation__
 *
 * To run a mutation, you first call `useDeleteEducationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEducationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEducationMutation, { data, loading, error }] = useDeleteEducationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEducationMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEducationMutation, DeleteEducationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteEducationMutation, DeleteEducationMutationVariables>(DeleteEducationDocument, options)
}
export type DeleteEducationMutationHookResult = ReturnType<typeof useDeleteEducationMutation>
export type DeleteEducationMutationResult = Apollo.MutationResult<DeleteEducationMutation>
export type DeleteEducationMutationOptions = Apollo.BaseMutationOptions<
  DeleteEducationMutation,
  DeleteEducationMutationVariables
>
export const DeleteExperienceDocument = gql`
  mutation DeleteExperience($input: DeleteExperienceInput!) {
    DeleteExperience(input: $input)
  }
`
export type DeleteExperienceMutationFn = Apollo.MutationFunction<
  DeleteExperienceMutation,
  DeleteExperienceMutationVariables
>

/**
 * __useDeleteExperienceMutation__
 *
 * To run a mutation, you first call `useDeleteExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperienceMutation, { data, loading, error }] = useDeleteExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExperienceMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteExperienceMutation, DeleteExperienceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteExperienceMutation, DeleteExperienceMutationVariables>(
    DeleteExperienceDocument,
    options,
  )
}
export type DeleteExperienceMutationHookResult = ReturnType<typeof useDeleteExperienceMutation>
export type DeleteExperienceMutationResult = Apollo.MutationResult<DeleteExperienceMutation>
export type DeleteExperienceMutationOptions = Apollo.BaseMutationOptions<
  DeleteExperienceMutation,
  DeleteExperienceMutationVariables
>
export const DeleteJobSeekerSkillDocument = gql`
  mutation DeleteJobSeekerSkill($input: DeleteJobSeekerSkillInput!) {
    DeleteJobSeekerSkill(input: $input)
  }
`
export type DeleteJobSeekerSkillMutationFn = Apollo.MutationFunction<
  DeleteJobSeekerSkillMutation,
  DeleteJobSeekerSkillMutationVariables
>

/**
 * __useDeleteJobSeekerSkillMutation__
 *
 * To run a mutation, you first call `useDeleteJobSeekerSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobSeekerSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobSeekerSkillMutation, { data, loading, error }] = useDeleteJobSeekerSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobSeekerSkillMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteJobSeekerSkillMutation, DeleteJobSeekerSkillMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteJobSeekerSkillMutation, DeleteJobSeekerSkillMutationVariables>(
    DeleteJobSeekerSkillDocument,
    options,
  )
}
export type DeleteJobSeekerSkillMutationHookResult = ReturnType<typeof useDeleteJobSeekerSkillMutation>
export type DeleteJobSeekerSkillMutationResult = Apollo.MutationResult<DeleteJobSeekerSkillMutation>
export type DeleteJobSeekerSkillMutationOptions = Apollo.BaseMutationOptions<
  DeleteJobSeekerSkillMutation,
  DeleteJobSeekerSkillMutationVariables
>
export const DeleteVolunteerWorkDocument = gql`
  mutation DeleteVolunteerWork($input: DeleteVolunteerWorkInput!) {
    DeleteVolunteerWork(input: $input)
  }
`
export type DeleteVolunteerWorkMutationFn = Apollo.MutationFunction<
  DeleteVolunteerWorkMutation,
  DeleteVolunteerWorkMutationVariables
>

/**
 * __useDeleteVolunteerWorkMutation__
 *
 * To run a mutation, you first call `useDeleteVolunteerWorkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolunteerWorkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolunteerWorkMutation, { data, loading, error }] = useDeleteVolunteerWorkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteVolunteerWorkMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteVolunteerWorkMutation, DeleteVolunteerWorkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteVolunteerWorkMutation, DeleteVolunteerWorkMutationVariables>(
    DeleteVolunteerWorkDocument,
    options,
  )
}
export type DeleteVolunteerWorkMutationHookResult = ReturnType<typeof useDeleteVolunteerWorkMutation>
export type DeleteVolunteerWorkMutationResult = Apollo.MutationResult<DeleteVolunteerWorkMutation>
export type DeleteVolunteerWorkMutationOptions = Apollo.BaseMutationOptions<
  DeleteVolunteerWorkMutation,
  DeleteVolunteerWorkMutationVariables
>
export const RemoveSkillFromExperienceDocument = gql`
  mutation RemoveSkillFromExperience($input: [RemoveSkillFromExperienceInput!]!) {
    RemoveSkillFromExperience(input: $input)
  }
`
export type RemoveSkillFromExperienceMutationFn = Apollo.MutationFunction<
  RemoveSkillFromExperienceMutation,
  RemoveSkillFromExperienceMutationVariables
>

/**
 * __useRemoveSkillFromExperienceMutation__
 *
 * To run a mutation, you first call `useRemoveSkillFromExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSkillFromExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSkillFromExperienceMutation, { data, loading, error }] = useRemoveSkillFromExperienceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSkillFromExperienceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSkillFromExperienceMutation,
    RemoveSkillFromExperienceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveSkillFromExperienceMutation, RemoveSkillFromExperienceMutationVariables>(
    RemoveSkillFromExperienceDocument,
    options,
  )
}
export type RemoveSkillFromExperienceMutationHookResult = ReturnType<typeof useRemoveSkillFromExperienceMutation>
export type RemoveSkillFromExperienceMutationResult = Apollo.MutationResult<RemoveSkillFromExperienceMutation>
export type RemoveSkillFromExperienceMutationOptions = Apollo.BaseMutationOptions<
  RemoveSkillFromExperienceMutation,
  RemoveSkillFromExperienceMutationVariables
>
export const CreateCandidateApplicationFromJobSeekerDocument = gql`
  mutation CreateCandidateApplicationFromJobSeeker($input: CreateCandidateApplicationFromJobSeekerInput!) {
    CreateCandidateApplicationFromJobSeeker(input: $input) {
      id
    }
  }
`
export type CreateCandidateApplicationFromJobSeekerMutationFn = Apollo.MutationFunction<
  CreateCandidateApplicationFromJobSeekerMutation,
  CreateCandidateApplicationFromJobSeekerMutationVariables
>

/**
 * __useCreateCandidateApplicationFromJobSeekerMutation__
 *
 * To run a mutation, you first call `useCreateCandidateApplicationFromJobSeekerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateApplicationFromJobSeekerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateApplicationFromJobSeekerMutation, { data, loading, error }] = useCreateCandidateApplicationFromJobSeekerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateApplicationFromJobSeekerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCandidateApplicationFromJobSeekerMutation,
    CreateCandidateApplicationFromJobSeekerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCandidateApplicationFromJobSeekerMutation,
    CreateCandidateApplicationFromJobSeekerMutationVariables
  >(CreateCandidateApplicationFromJobSeekerDocument, options)
}
export type CreateCandidateApplicationFromJobSeekerMutationHookResult = ReturnType<
  typeof useCreateCandidateApplicationFromJobSeekerMutation
>
export type CreateCandidateApplicationFromJobSeekerMutationResult =
  Apollo.MutationResult<CreateCandidateApplicationFromJobSeekerMutation>
export type CreateCandidateApplicationFromJobSeekerMutationOptions = Apollo.BaseMutationOptions<
  CreateCandidateApplicationFromJobSeekerMutation,
  CreateCandidateApplicationFromJobSeekerMutationVariables
>
export const UpdateScalisUserBasicInformationDocument = gql`
  mutation UpdateScalisUserBasicInformation($input: UpdateScalisUserDataInput!) {
    UpdateScalisUserData(input: $input) {
      ContactInfo {
        id
        phoneNumber
        scalisUserId
      }
      DemographicInfo {
        gender
        id
        raceEthnicity
        veteranStatus
      }
      firstName
      lastName
    }
  }
`
export type UpdateScalisUserBasicInformationMutationFn = Apollo.MutationFunction<
  UpdateScalisUserBasicInformationMutation,
  UpdateScalisUserBasicInformationMutationVariables
>

/**
 * __useUpdateScalisUserBasicInformationMutation__
 *
 * To run a mutation, you first call `useUpdateScalisUserBasicInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScalisUserBasicInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScalisUserBasicInformationMutation, { data, loading, error }] = useUpdateScalisUserBasicInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScalisUserBasicInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScalisUserBasicInformationMutation,
    UpdateScalisUserBasicInformationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateScalisUserBasicInformationMutation,
    UpdateScalisUserBasicInformationMutationVariables
  >(UpdateScalisUserBasicInformationDocument, options)
}
export type UpdateScalisUserBasicInformationMutationHookResult = ReturnType<
  typeof useUpdateScalisUserBasicInformationMutation
>
export type UpdateScalisUserBasicInformationMutationResult =
  Apollo.MutationResult<UpdateScalisUserBasicInformationMutation>
export type UpdateScalisUserBasicInformationMutationOptions = Apollo.BaseMutationOptions<
  UpdateScalisUserBasicInformationMutation,
  UpdateScalisUserBasicInformationMutationVariables
>
export const UpsertExperienceSkillsDocument = gql`
  mutation UpsertExperienceSkills(
    $upsertInput: [UpsertExperienceSkillInput!]!
    $deleteInput: [RemoveSkillFromExperienceInput!]!
  ) {
    UpsertExperienceSkill(input: $upsertInput) {
      id
      level
      name
      yearsOfExp
    }
    RemoveSkillFromExperience(input: $deleteInput)
  }
`
export type UpsertExperienceSkillsMutationFn = Apollo.MutationFunction<
  UpsertExperienceSkillsMutation,
  UpsertExperienceSkillsMutationVariables
>

/**
 * __useUpsertExperienceSkillsMutation__
 *
 * To run a mutation, you first call `useUpsertExperienceSkillsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertExperienceSkillsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertExperienceSkillsMutation, { data, loading, error }] = useUpsertExperienceSkillsMutation({
 *   variables: {
 *      upsertInput: // value for 'upsertInput'
 *      deleteInput: // value for 'deleteInput'
 *   },
 * });
 */
export function useUpsertExperienceSkillsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertExperienceSkillsMutation, UpsertExperienceSkillsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertExperienceSkillsMutation, UpsertExperienceSkillsMutationVariables>(
    UpsertExperienceSkillsDocument,
    options,
  )
}
export type UpsertExperienceSkillsMutationHookResult = ReturnType<typeof useUpsertExperienceSkillsMutation>
export type UpsertExperienceSkillsMutationResult = Apollo.MutationResult<UpsertExperienceSkillsMutation>
export type UpsertExperienceSkillsMutationOptions = Apollo.BaseMutationOptions<
  UpsertExperienceSkillsMutation,
  UpsertExperienceSkillsMutationVariables
>
export const UpdateScalisUserAboutMeDocument = gql`
  mutation UpdateScalisUserAboutMe($id: Int!, $aboutMe: String) {
    UpdateScalisUserData(input: { id: $id, JobSeekerInfo: { aboutMe: $aboutMe } }) {
      id
      JobSeekerInfo {
        id
        aboutMe
      }
    }
  }
`
export type UpdateScalisUserAboutMeMutationFn = Apollo.MutationFunction<
  UpdateScalisUserAboutMeMutation,
  UpdateScalisUserAboutMeMutationVariables
>

/**
 * __useUpdateScalisUserAboutMeMutation__
 *
 * To run a mutation, you first call `useUpdateScalisUserAboutMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScalisUserAboutMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScalisUserAboutMeMutation, { data, loading, error }] = useUpdateScalisUserAboutMeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aboutMe: // value for 'aboutMe'
 *   },
 * });
 */
export function useUpdateScalisUserAboutMeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateScalisUserAboutMeMutation, UpdateScalisUserAboutMeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScalisUserAboutMeMutation, UpdateScalisUserAboutMeMutationVariables>(
    UpdateScalisUserAboutMeDocument,
    options,
  )
}
export type UpdateScalisUserAboutMeMutationHookResult = ReturnType<typeof useUpdateScalisUserAboutMeMutation>
export type UpdateScalisUserAboutMeMutationResult = Apollo.MutationResult<UpdateScalisUserAboutMeMutation>
export type UpdateScalisUserAboutMeMutationOptions = Apollo.BaseMutationOptions<
  UpdateScalisUserAboutMeMutation,
  UpdateScalisUserAboutMeMutationVariables
>
export const UpdateScalisUserDataBasicDocument = gql`
  mutation UpdateScalisUserDataBasic($input: UpdateScalisUserDataInput!) {
    UpdateScalisUserData(input: $input) {
      id
      firstName
      lastName
      profileImage
    }
  }
`
export type UpdateScalisUserDataBasicMutationFn = Apollo.MutationFunction<
  UpdateScalisUserDataBasicMutation,
  UpdateScalisUserDataBasicMutationVariables
>

/**
 * __useUpdateScalisUserDataBasicMutation__
 *
 * To run a mutation, you first call `useUpdateScalisUserDataBasicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScalisUserDataBasicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScalisUserDataBasicMutation, { data, loading, error }] = useUpdateScalisUserDataBasicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScalisUserDataBasicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScalisUserDataBasicMutation,
    UpdateScalisUserDataBasicMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScalisUserDataBasicMutation, UpdateScalisUserDataBasicMutationVariables>(
    UpdateScalisUserDataBasicDocument,
    options,
  )
}
export type UpdateScalisUserDataBasicMutationHookResult = ReturnType<typeof useUpdateScalisUserDataBasicMutation>
export type UpdateScalisUserDataBasicMutationResult = Apollo.MutationResult<UpdateScalisUserDataBasicMutation>
export type UpdateScalisUserDataBasicMutationOptions = Apollo.BaseMutationOptions<
  UpdateScalisUserDataBasicMutation,
  UpdateScalisUserDataBasicMutationVariables
>
export const UpdateScalisUserDataDocument = gql`
  mutation UpdateScalisUserData($input: UpdateScalisUserDataInput!) {
    UpdateScalisUserData(input: $input) {
      id
      firstName
      lastName
      profileImage
      Address {
        ...AddressFragment
      }
      ...ScalisUserAboutFragment
      ...ScalisUserSkillsFragment
      ...ScalisUserExperienceFragment
      ...ScalisUserVolunteerWorkFragment
      ...ScalisUserEducationFragment
      ...ScalisUserCertificatesOrLicensesFragment
      ...ScalisUserAchievementsFragment
      ...ScalisUserDemographicInfoFragment
      ...ScalisUserWebsiteOrSocialMedia
    }
  }
  ${AddressFragmentFragmentDoc}
  ${ScalisUserAboutFragmentFragmentDoc}
  ${ScalisUserSkillsFragmentFragmentDoc}
  ${ScalisUserExperienceFragmentFragmentDoc}
  ${ScalisUserVolunteerWorkFragmentFragmentDoc}
  ${ScalisUserEducationFragmentFragmentDoc}
  ${ScalisUserCertificatesOrLicensesFragmentFragmentDoc}
  ${ScalisUserAchievementsFragmentFragmentDoc}
  ${ScalisUserDemographicInfoFragmentFragmentDoc}
  ${ScalisUserWebsiteOrSocialMediaFragmentDoc}
`
export type UpdateScalisUserDataMutationFn = Apollo.MutationFunction<
  UpdateScalisUserDataMutation,
  UpdateScalisUserDataMutationVariables
>

/**
 * __useUpdateScalisUserDataMutation__
 *
 * To run a mutation, you first call `useUpdateScalisUserDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScalisUserDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScalisUserDataMutation, { data, loading, error }] = useUpdateScalisUserDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScalisUserDataMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateScalisUserDataMutation, UpdateScalisUserDataMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScalisUserDataMutation, UpdateScalisUserDataMutationVariables>(
    UpdateScalisUserDataDocument,
    options,
  )
}
export type UpdateScalisUserDataMutationHookResult = ReturnType<typeof useUpdateScalisUserDataMutation>
export type UpdateScalisUserDataMutationResult = Apollo.MutationResult<UpdateScalisUserDataMutation>
export type UpdateScalisUserDataMutationOptions = Apollo.BaseMutationOptions<
  UpdateScalisUserDataMutation,
  UpdateScalisUserDataMutationVariables
>
export const UpdateScalisUserIsSearchingJobsDocument = gql`
  mutation UpdateScalisUserIsSearchingJobs($id: Int!, $searchingJobs: Boolean) {
    UpdateScalisUserData(input: { id: $id, JobSeekerInfo: { searchingJobs: $searchingJobs } }) {
      id
      JobSeekerInfo {
        id
        searchingJobs
      }
    }
  }
`
export type UpdateScalisUserIsSearchingJobsMutationFn = Apollo.MutationFunction<
  UpdateScalisUserIsSearchingJobsMutation,
  UpdateScalisUserIsSearchingJobsMutationVariables
>

/**
 * __useUpdateScalisUserIsSearchingJobsMutation__
 *
 * To run a mutation, you first call `useUpdateScalisUserIsSearchingJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScalisUserIsSearchingJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScalisUserIsSearchingJobsMutation, { data, loading, error }] = useUpdateScalisUserIsSearchingJobsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      searchingJobs: // value for 'searchingJobs'
 *   },
 * });
 */
export function useUpdateScalisUserIsSearchingJobsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScalisUserIsSearchingJobsMutation,
    UpdateScalisUserIsSearchingJobsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScalisUserIsSearchingJobsMutation, UpdateScalisUserIsSearchingJobsMutationVariables>(
    UpdateScalisUserIsSearchingJobsDocument,
    options,
  )
}
export type UpdateScalisUserIsSearchingJobsMutationHookResult = ReturnType<
  typeof useUpdateScalisUserIsSearchingJobsMutation
>
export type UpdateScalisUserIsSearchingJobsMutationResult =
  Apollo.MutationResult<UpdateScalisUserIsSearchingJobsMutation>
export type UpdateScalisUserIsSearchingJobsMutationOptions = Apollo.BaseMutationOptions<
  UpdateScalisUserIsSearchingJobsMutation,
  UpdateScalisUserIsSearchingJobsMutationVariables
>
export const UpdateScalisUserNameDocument = gql`
  mutation UpdateScalisUserName($input: UpdateScalisUserDataInput!) {
    UpdateScalisUserData(input: $input) {
      id
      firstName
      lastName
    }
  }
`
export type UpdateScalisUserNameMutationFn = Apollo.MutationFunction<
  UpdateScalisUserNameMutation,
  UpdateScalisUserNameMutationVariables
>

/**
 * __useUpdateScalisUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateScalisUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScalisUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScalisUserNameMutation, { data, loading, error }] = useUpdateScalisUserNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScalisUserNameMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateScalisUserNameMutation, UpdateScalisUserNameMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScalisUserNameMutation, UpdateScalisUserNameMutationVariables>(
    UpdateScalisUserNameDocument,
    options,
  )
}
export type UpdateScalisUserNameMutationHookResult = ReturnType<typeof useUpdateScalisUserNameMutation>
export type UpdateScalisUserNameMutationResult = Apollo.MutationResult<UpdateScalisUserNameMutation>
export type UpdateScalisUserNameMutationOptions = Apollo.BaseMutationOptions<
  UpdateScalisUserNameMutation,
  UpdateScalisUserNameMutationVariables
>
export const UpdateScalisUserResumeDocument = gql`
  mutation UpdateScalisUserResume(
    $id: Int!
    $aboutMe: String
    $jobSeekerSkills: [JobSeekerSkillInput!]
    $experiences: [ExperienceInput!]
    $volunteerWorks: [VolunteerWorkInput!]
    $educations: [EducationInput!]
    $certificateOrLicenses: [CertificateOrLicenseInput!]
    $achievements: [AchievementInput!]
  ) {
    UpdateScalisUserData(
      input: {
        id: $id
        JobSeekerInfo: { aboutMe: $aboutMe }
        JobSeekerSkill: $jobSeekerSkills
        Experience: $experiences
        VolunteerWork: $volunteerWorks
        Education: $educations
        CertificateOrLicense: $certificateOrLicenses
        Achievement: $achievements
      }
    ) {
      id
      JobSeekerInfo {
        id
        aboutMe
      }
      JobSeekerSkill {
        id
        level
        name
        sequenceNumber
        yearsOfExp
      }
      Experience {
        id
        description
      }
      VolunteerWork {
        id
        description
      }
      Education {
        id
        additionalInformation
      }
      CertificateOrLicense {
        id
        description
      }
      Achievement {
        id
        description
      }
    }
  }
`
export type UpdateScalisUserResumeMutationFn = Apollo.MutationFunction<
  UpdateScalisUserResumeMutation,
  UpdateScalisUserResumeMutationVariables
>

/**
 * __useUpdateScalisUserResumeMutation__
 *
 * To run a mutation, you first call `useUpdateScalisUserResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScalisUserResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScalisUserResumeMutation, { data, loading, error }] = useUpdateScalisUserResumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aboutMe: // value for 'aboutMe'
 *      jobSeekerSkills: // value for 'jobSeekerSkills'
 *      experiences: // value for 'experiences'
 *      volunteerWorks: // value for 'volunteerWorks'
 *      educations: // value for 'educations'
 *      certificateOrLicenses: // value for 'certificateOrLicenses'
 *      achievements: // value for 'achievements'
 *   },
 * });
 */
export function useUpdateScalisUserResumeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateScalisUserResumeMutation, UpdateScalisUserResumeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScalisUserResumeMutation, UpdateScalisUserResumeMutationVariables>(
    UpdateScalisUserResumeDocument,
    options,
  )
}
export type UpdateScalisUserResumeMutationHookResult = ReturnType<typeof useUpdateScalisUserResumeMutation>
export type UpdateScalisUserResumeMutationResult = Apollo.MutationResult<UpdateScalisUserResumeMutation>
export type UpdateScalisUserResumeMutationOptions = Apollo.BaseMutationOptions<
  UpdateScalisUserResumeMutation,
  UpdateScalisUserResumeMutationVariables
>
export const UpsertApplicationFormScreeningQuestionDocument = gql`
  mutation UpsertApplicationFormScreeningQuestion($input: UpsertApplicationFormScreeningQuestionInput!) {
    UpsertApplicationFormScreeningQuestion(input: $input) {
      id
      applicationFormId
      screeningQuestionId
      rankOrder
      isActive
      createdAt
      updatedAt
      ScreeningQuestion {
        id
        questionTitle
        questionDesc
        questionType
        ansOptions
        minVal
        maxVal
        valStatus
        preferredAnswer
      }
    }
  }
`
export type UpsertApplicationFormScreeningQuestionMutationFn = Apollo.MutationFunction<
  UpsertApplicationFormScreeningQuestionMutation,
  UpsertApplicationFormScreeningQuestionMutationVariables
>

/**
 * __useUpsertApplicationFormScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useUpsertApplicationFormScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertApplicationFormScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertApplicationFormScreeningQuestionMutation, { data, loading, error }] = useUpsertApplicationFormScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertApplicationFormScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertApplicationFormScreeningQuestionMutation,
    UpsertApplicationFormScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpsertApplicationFormScreeningQuestionMutation,
    UpsertApplicationFormScreeningQuestionMutationVariables
  >(UpsertApplicationFormScreeningQuestionDocument, options)
}
export type UpsertApplicationFormScreeningQuestionMutationHookResult = ReturnType<
  typeof useUpsertApplicationFormScreeningQuestionMutation
>
export type UpsertApplicationFormScreeningQuestionMutationResult =
  Apollo.MutationResult<UpsertApplicationFormScreeningQuestionMutation>
export type UpsertApplicationFormScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  UpsertApplicationFormScreeningQuestionMutation,
  UpsertApplicationFormScreeningQuestionMutationVariables
>
export const UpsertApplicationFormDocument = gql`
  mutation UpsertApplicationForm($input: UpsertApplicationFormInput!) {
    UpsertApplicationForm(input: $input) {
      id
      name
      companyId
      companyDepartmentId
      companyUserId
      isEdited
      createdAt
      updatedAt
      CompanyDepartment {
        id
      }
      CompanyUser {
        id
      }
    }
  }
`
export type UpsertApplicationFormMutationFn = Apollo.MutationFunction<
  UpsertApplicationFormMutation,
  UpsertApplicationFormMutationVariables
>

/**
 * __useUpsertApplicationFormMutation__
 *
 * To run a mutation, you first call `useUpsertApplicationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertApplicationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertApplicationFormMutation, { data, loading, error }] = useUpsertApplicationFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertApplicationFormMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertApplicationFormMutation, UpsertApplicationFormMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertApplicationFormMutation, UpsertApplicationFormMutationVariables>(
    UpsertApplicationFormDocument,
    options,
  )
}
export type UpsertApplicationFormMutationHookResult = ReturnType<typeof useUpsertApplicationFormMutation>
export type UpsertApplicationFormMutationResult = Apollo.MutationResult<UpsertApplicationFormMutation>
export type UpsertApplicationFormMutationOptions = Apollo.BaseMutationOptions<
  UpsertApplicationFormMutation,
  UpsertApplicationFormMutationVariables
>
export const SignUpDocument = gql`
  mutation SignUp($email: String!, $password: String!) {
    SignUp(input: { email: $email, password: $password }) {
      id
    }
  }
`
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options)
}
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>
export const ExchangeWebSocketTokenDocument = gql`
  mutation ExchangeWebSocketToken($input: ExchangeWebSocketTokenInput!) {
    ExchangeWebSocketToken(input: $input)
  }
`
export type ExchangeWebSocketTokenMutationFn = Apollo.MutationFunction<
  ExchangeWebSocketTokenMutation,
  ExchangeWebSocketTokenMutationVariables
>

/**
 * __useExchangeWebSocketTokenMutation__
 *
 * To run a mutation, you first call `useExchangeWebSocketTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeWebSocketTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeWebSocketTokenMutation, { data, loading, error }] = useExchangeWebSocketTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExchangeWebSocketTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<ExchangeWebSocketTokenMutation, ExchangeWebSocketTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ExchangeWebSocketTokenMutation, ExchangeWebSocketTokenMutationVariables>(
    ExchangeWebSocketTokenDocument,
    options,
  )
}
export type ExchangeWebSocketTokenMutationHookResult = ReturnType<typeof useExchangeWebSocketTokenMutation>
export type ExchangeWebSocketTokenMutationResult = Apollo.MutationResult<ExchangeWebSocketTokenMutation>
export type ExchangeWebSocketTokenMutationOptions = Apollo.BaseMutationOptions<
  ExchangeWebSocketTokenMutation,
  ExchangeWebSocketTokenMutationVariables
>
export const DeleteBookmarkedJobDocument = gql`
  mutation DeleteBookmarkedJob($input: DeleteBookmarkedJobInput!) {
    DeleteBookmarkedJob(input: $input) {
      publicListingId
    }
  }
`
export type DeleteBookmarkedJobMutationFn = Apollo.MutationFunction<
  DeleteBookmarkedJobMutation,
  DeleteBookmarkedJobMutationVariables
>

/**
 * __useDeleteBookmarkedJobMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkedJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkedJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkedJobMutation, { data, loading, error }] = useDeleteBookmarkedJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBookmarkedJobMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkedJobMutation, DeleteBookmarkedJobMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteBookmarkedJobMutation, DeleteBookmarkedJobMutationVariables>(
    DeleteBookmarkedJobDocument,
    options,
  )
}
export type DeleteBookmarkedJobMutationHookResult = ReturnType<typeof useDeleteBookmarkedJobMutation>
export type DeleteBookmarkedJobMutationResult = Apollo.MutationResult<DeleteBookmarkedJobMutation>
export type DeleteBookmarkedJobMutationOptions = Apollo.BaseMutationOptions<
  DeleteBookmarkedJobMutation,
  DeleteBookmarkedJobMutationVariables
>
export const ConnectCalendarDocument = gql`
  mutation ConnectCalendar($input: ConnectCalendarInput!) {
    ConnectCalendar(input: $input) {
      authUrl
    }
  }
`
export type ConnectCalendarMutationFn = Apollo.MutationFunction<
  ConnectCalendarMutation,
  ConnectCalendarMutationVariables
>

/**
 * __useConnectCalendarMutation__
 *
 * To run a mutation, you first call `useConnectCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectCalendarMutation, { data, loading, error }] = useConnectCalendarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<ConnectCalendarMutation, ConnectCalendarMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ConnectCalendarMutation, ConnectCalendarMutationVariables>(ConnectCalendarDocument, options)
}
export type ConnectCalendarMutationHookResult = ReturnType<typeof useConnectCalendarMutation>
export type ConnectCalendarMutationResult = Apollo.MutationResult<ConnectCalendarMutation>
export type ConnectCalendarMutationOptions = Apollo.BaseMutationOptions<
  ConnectCalendarMutation,
  ConnectCalendarMutationVariables
>
export const DisconnectCalendarDocument = gql`
  mutation DisconnectCalendar($input: DisconnectCalendarInput!) {
    DisconnectCalendar(input: $input) {
      success
    }
  }
`
export type DisconnectCalendarMutationFn = Apollo.MutationFunction<
  DisconnectCalendarMutation,
  DisconnectCalendarMutationVariables
>

/**
 * __useDisconnectCalendarMutation__
 *
 * To run a mutation, you first call `useDisconnectCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectCalendarMutation, { data, loading, error }] = useDisconnectCalendarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<DisconnectCalendarMutation, DisconnectCalendarMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DisconnectCalendarMutation, DisconnectCalendarMutationVariables>(
    DisconnectCalendarDocument,
    options,
  )
}
export type DisconnectCalendarMutationHookResult = ReturnType<typeof useDisconnectCalendarMutation>
export type DisconnectCalendarMutationResult = Apollo.MutationResult<DisconnectCalendarMutation>
export type DisconnectCalendarMutationOptions = Apollo.BaseMutationOptions<
  DisconnectCalendarMutation,
  DisconnectCalendarMutationVariables
>
export const EditCalendarSettingsDocument = gql`
  mutation EditCalendarSettings($input: EditCalendarSettingsInput!) {
    EditCalendarSettings(input: $input) {
      id
      companyUserId
      email
      provider
      nylasGrantId
      availability
      timeZone
    }
  }
`
export type EditCalendarSettingsMutationFn = Apollo.MutationFunction<
  EditCalendarSettingsMutation,
  EditCalendarSettingsMutationVariables
>

/**
 * __useEditCalendarSettingsMutation__
 *
 * To run a mutation, you first call `useEditCalendarSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCalendarSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCalendarSettingsMutation, { data, loading, error }] = useEditCalendarSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCalendarSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<EditCalendarSettingsMutation, EditCalendarSettingsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCalendarSettingsMutation, EditCalendarSettingsMutationVariables>(
    EditCalendarSettingsDocument,
    options,
  )
}
export type EditCalendarSettingsMutationHookResult = ReturnType<typeof useEditCalendarSettingsMutation>
export type EditCalendarSettingsMutationResult = Apollo.MutationResult<EditCalendarSettingsMutation>
export type EditCalendarSettingsMutationOptions = Apollo.BaseMutationOptions<
  EditCalendarSettingsMutation,
  EditCalendarSettingsMutationVariables
>
export const ExchangeNylasTokenDocument = gql`
  mutation ExchangeNylasToken($input: ExchangeNylasTokenInput!) {
    ExchangeNylasToken(input: $input) {
      id
      availability
      provider
      timeZone
      hourDisplay
      email
      Calendars {
        id
        name
        isPrimary
        color
        CalendarEvents {
          id
          nylasEventStatus
          title
          eventType
          description
          startTime
          endTime
          timeZone
          location
          repeats
          reminders
          employers
          conferencing
          masterEventId
          regardingCandidates
          regardingJobs
          internalGuests
          candidates
          isScalisEvent
        }
      }
    }
  }
`
export type ExchangeNylasTokenMutationFn = Apollo.MutationFunction<
  ExchangeNylasTokenMutation,
  ExchangeNylasTokenMutationVariables
>

/**
 * __useExchangeNylasTokenMutation__
 *
 * To run a mutation, you first call `useExchangeNylasTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeNylasTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeNylasTokenMutation, { data, loading, error }] = useExchangeNylasTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExchangeNylasTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<ExchangeNylasTokenMutation, ExchangeNylasTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ExchangeNylasTokenMutation, ExchangeNylasTokenMutationVariables>(
    ExchangeNylasTokenDocument,
    options,
  )
}
export type ExchangeNylasTokenMutationHookResult = ReturnType<typeof useExchangeNylasTokenMutation>
export type ExchangeNylasTokenMutationResult = Apollo.MutationResult<ExchangeNylasTokenMutation>
export type ExchangeNylasTokenMutationOptions = Apollo.BaseMutationOptions<
  ExchangeNylasTokenMutation,
  ExchangeNylasTokenMutationVariables
>
export const SyncCalendarDocument = gql`
  mutation SyncCalendar {
    SyncCalendar {
      id
    }
  }
`
export type SyncCalendarMutationFn = Apollo.MutationFunction<SyncCalendarMutation, SyncCalendarMutationVariables>

/**
 * __useSyncCalendarMutation__
 *
 * To run a mutation, you first call `useSyncCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCalendarMutation, { data, loading, error }] = useSyncCalendarMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<SyncCalendarMutation, SyncCalendarMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SyncCalendarMutation, SyncCalendarMutationVariables>(SyncCalendarDocument, options)
}
export type SyncCalendarMutationHookResult = ReturnType<typeof useSyncCalendarMutation>
export type SyncCalendarMutationResult = Apollo.MutationResult<SyncCalendarMutation>
export type SyncCalendarMutationOptions = Apollo.BaseMutationOptions<
  SyncCalendarMutation,
  SyncCalendarMutationVariables
>
export const DeleteCandidateApplicationNoteDocument = gql`
  mutation DeleteCandidateApplicationNote($input: DeleteCandidateApplicationNoteInput!) {
    DeleteCandidateApplicationNote(input: $input) {
      id
    }
  }
`
export type DeleteCandidateApplicationNoteMutationFn = Apollo.MutationFunction<
  DeleteCandidateApplicationNoteMutation,
  DeleteCandidateApplicationNoteMutationVariables
>

/**
 * __useDeleteCandidateApplicationNoteMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateApplicationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateApplicationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateApplicationNoteMutation, { data, loading, error }] = useDeleteCandidateApplicationNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateApplicationNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateApplicationNoteMutation,
    DeleteCandidateApplicationNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateApplicationNoteMutation, DeleteCandidateApplicationNoteMutationVariables>(
    DeleteCandidateApplicationNoteDocument,
    options,
  )
}
export type DeleteCandidateApplicationNoteMutationHookResult = ReturnType<
  typeof useDeleteCandidateApplicationNoteMutation
>
export type DeleteCandidateApplicationNoteMutationResult = Apollo.MutationResult<DeleteCandidateApplicationNoteMutation>
export type DeleteCandidateApplicationNoteMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateApplicationNoteMutation,
  DeleteCandidateApplicationNoteMutationVariables
>
export const UpsertCandidateApplicationNoteDocument = gql`
  mutation UpsertCandidateApplicationNote($input: UpsertCandidateApplicationNoteInput!) {
    UpsertCandidateApplicationNote(input: $input) {
      id
    }
  }
`
export type UpsertCandidateApplicationNoteMutationFn = Apollo.MutationFunction<
  UpsertCandidateApplicationNoteMutation,
  UpsertCandidateApplicationNoteMutationVariables
>

/**
 * __useUpsertCandidateApplicationNoteMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateApplicationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateApplicationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateApplicationNoteMutation, { data, loading, error }] = useUpsertCandidateApplicationNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateApplicationNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidateApplicationNoteMutation,
    UpsertCandidateApplicationNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateApplicationNoteMutation, UpsertCandidateApplicationNoteMutationVariables>(
    UpsertCandidateApplicationNoteDocument,
    options,
  )
}
export type UpsertCandidateApplicationNoteMutationHookResult = ReturnType<
  typeof useUpsertCandidateApplicationNoteMutation
>
export type UpsertCandidateApplicationNoteMutationResult = Apollo.MutationResult<UpsertCandidateApplicationNoteMutation>
export type UpsertCandidateApplicationNoteMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateApplicationNoteMutation,
  UpsertCandidateApplicationNoteMutationVariables
>
export const UpsertCandidateApplicationRatingDocument = gql`
  mutation UpsertCandidateApplicationRating($input: UpsertCandidateApplicationRatingInput!) {
    UpsertCandidateApplicationRating(input: $input) {
      id
      candidateProfileId
      candidateApplicationId
      companyUserId
      score
      createdAt
      updatedAt
    }
  }
`
export type UpsertCandidateApplicationRatingMutationFn = Apollo.MutationFunction<
  UpsertCandidateApplicationRatingMutation,
  UpsertCandidateApplicationRatingMutationVariables
>

/**
 * __useUpsertCandidateApplicationRatingMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateApplicationRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateApplicationRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateApplicationRatingMutation, { data, loading, error }] = useUpsertCandidateApplicationRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateApplicationRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidateApplicationRatingMutation,
    UpsertCandidateApplicationRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpsertCandidateApplicationRatingMutation,
    UpsertCandidateApplicationRatingMutationVariables
  >(UpsertCandidateApplicationRatingDocument, options)
}
export type UpsertCandidateApplicationRatingMutationHookResult = ReturnType<
  typeof useUpsertCandidateApplicationRatingMutation
>
export type UpsertCandidateApplicationRatingMutationResult =
  Apollo.MutationResult<UpsertCandidateApplicationRatingMutation>
export type UpsertCandidateApplicationRatingMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateApplicationRatingMutation,
  UpsertCandidateApplicationRatingMutationVariables
>
export const AdvanceCandidateApplicationDocument = gql`
  mutation AdvanceCandidateApplication($input: AdvanceCandidateApplicationInput!) {
    AdvanceCandidateApplication(input: $input) {
      id
    }
  }
`
export type AdvanceCandidateApplicationMutationFn = Apollo.MutationFunction<
  AdvanceCandidateApplicationMutation,
  AdvanceCandidateApplicationMutationVariables
>

/**
 * __useAdvanceCandidateApplicationMutation__
 *
 * To run a mutation, you first call `useAdvanceCandidateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdvanceCandidateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [advanceCandidateApplicationMutation, { data, loading, error }] = useAdvanceCandidateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdvanceCandidateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdvanceCandidateApplicationMutation,
    AdvanceCandidateApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AdvanceCandidateApplicationMutation, AdvanceCandidateApplicationMutationVariables>(
    AdvanceCandidateApplicationDocument,
    options,
  )
}
export type AdvanceCandidateApplicationMutationHookResult = ReturnType<typeof useAdvanceCandidateApplicationMutation>
export type AdvanceCandidateApplicationMutationResult = Apollo.MutationResult<AdvanceCandidateApplicationMutation>
export type AdvanceCandidateApplicationMutationOptions = Apollo.BaseMutationOptions<
  AdvanceCandidateApplicationMutation,
  AdvanceCandidateApplicationMutationVariables
>
export const CreateCustomStatusAndEditApplicationStatusDocument = gql`
  mutation CreateCustomStatusAndEditApplicationStatus($input: CreateCustomStatusAndEditApplicationStatusInput!) {
    CreateCustomStatusAndEditApplicationStatus(input: $input) {
      id
      applicationStatus
      customApplicationStatusId
      lastUpdatedStatusAt
      CustomApplicationStatus {
        ...CustomApplicationStatus
      }
    }
  }
  ${CustomApplicationStatusFragmentDoc}
`
export type CreateCustomStatusAndEditApplicationStatusMutationFn = Apollo.MutationFunction<
  CreateCustomStatusAndEditApplicationStatusMutation,
  CreateCustomStatusAndEditApplicationStatusMutationVariables
>

/**
 * __useCreateCustomStatusAndEditApplicationStatusMutation__
 *
 * To run a mutation, you first call `useCreateCustomStatusAndEditApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomStatusAndEditApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomStatusAndEditApplicationStatusMutation, { data, loading, error }] = useCreateCustomStatusAndEditApplicationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomStatusAndEditApplicationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomStatusAndEditApplicationStatusMutation,
    CreateCustomStatusAndEditApplicationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCustomStatusAndEditApplicationStatusMutation,
    CreateCustomStatusAndEditApplicationStatusMutationVariables
  >(CreateCustomStatusAndEditApplicationStatusDocument, options)
}
export type CreateCustomStatusAndEditApplicationStatusMutationHookResult = ReturnType<
  typeof useCreateCustomStatusAndEditApplicationStatusMutation
>
export type CreateCustomStatusAndEditApplicationStatusMutationResult =
  Apollo.MutationResult<CreateCustomStatusAndEditApplicationStatusMutation>
export type CreateCustomStatusAndEditApplicationStatusMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomStatusAndEditApplicationStatusMutation,
  CreateCustomStatusAndEditApplicationStatusMutationVariables
>
export const CreateUploadedDocumentCandidateApplicationDocument = gql`
  mutation CreateUploadedDocumentCandidateApplication($input: CreateUploadedDocumentCandidateApplicationInput!) {
    CreateUploadedDocumentCandidateApplication(input: $input) {
      id
    }
  }
`
export type CreateUploadedDocumentCandidateApplicationMutationFn = Apollo.MutationFunction<
  CreateUploadedDocumentCandidateApplicationMutation,
  CreateUploadedDocumentCandidateApplicationMutationVariables
>

/**
 * __useCreateUploadedDocumentCandidateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateUploadedDocumentCandidateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadedDocumentCandidateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadedDocumentCandidateApplicationMutation, { data, loading, error }] = useCreateUploadedDocumentCandidateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadedDocumentCandidateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUploadedDocumentCandidateApplicationMutation,
    CreateUploadedDocumentCandidateApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateUploadedDocumentCandidateApplicationMutation,
    CreateUploadedDocumentCandidateApplicationMutationVariables
  >(CreateUploadedDocumentCandidateApplicationDocument, options)
}
export type CreateUploadedDocumentCandidateApplicationMutationHookResult = ReturnType<
  typeof useCreateUploadedDocumentCandidateApplicationMutation
>
export type CreateUploadedDocumentCandidateApplicationMutationResult =
  Apollo.MutationResult<CreateUploadedDocumentCandidateApplicationMutation>
export type CreateUploadedDocumentCandidateApplicationMutationOptions = Apollo.BaseMutationOptions<
  CreateUploadedDocumentCandidateApplicationMutation,
  CreateUploadedDocumentCandidateApplicationMutationVariables
>
export const DeleteUploadedDocumentCandidateApplicationDocument = gql`
  mutation DeleteUploadedDocumentCandidateApplication($input: DeleteUploadedDocumentCandidateApplicationInput!) {
    DeleteUploadedDocumentCandidateApplication(input: $input) {
      id
    }
  }
`
export type DeleteUploadedDocumentCandidateApplicationMutationFn = Apollo.MutationFunction<
  DeleteUploadedDocumentCandidateApplicationMutation,
  DeleteUploadedDocumentCandidateApplicationMutationVariables
>

/**
 * __useDeleteUploadedDocumentCandidateApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteUploadedDocumentCandidateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadedDocumentCandidateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadedDocumentCandidateApplicationMutation, { data, loading, error }] = useDeleteUploadedDocumentCandidateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUploadedDocumentCandidateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUploadedDocumentCandidateApplicationMutation,
    DeleteUploadedDocumentCandidateApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteUploadedDocumentCandidateApplicationMutation,
    DeleteUploadedDocumentCandidateApplicationMutationVariables
  >(DeleteUploadedDocumentCandidateApplicationDocument, options)
}
export type DeleteUploadedDocumentCandidateApplicationMutationHookResult = ReturnType<
  typeof useDeleteUploadedDocumentCandidateApplicationMutation
>
export type DeleteUploadedDocumentCandidateApplicationMutationResult =
  Apollo.MutationResult<DeleteUploadedDocumentCandidateApplicationMutation>
export type DeleteUploadedDocumentCandidateApplicationMutationOptions = Apollo.BaseMutationOptions<
  DeleteUploadedDocumentCandidateApplicationMutation,
  DeleteUploadedDocumentCandidateApplicationMutationVariables
>
export const EditCandidateApplicationStatusDocument = gql`
  mutation EditCandidateApplicationStatus($input: EditCandidateApplicationStatusInput!) {
    EditCandidateApplicationStatus(input: $input) {
      id
      applicationStatus
      customApplicationStatusId
      lastUpdatedStatusAt
      CustomApplicationStatus {
        ...CustomApplicationStatus
      }
    }
  }
  ${CustomApplicationStatusFragmentDoc}
`
export type EditCandidateApplicationStatusMutationFn = Apollo.MutationFunction<
  EditCandidateApplicationStatusMutation,
  EditCandidateApplicationStatusMutationVariables
>

/**
 * __useEditCandidateApplicationStatusMutation__
 *
 * To run a mutation, you first call `useEditCandidateApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCandidateApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCandidateApplicationStatusMutation, { data, loading, error }] = useEditCandidateApplicationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCandidateApplicationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCandidateApplicationStatusMutation,
    EditCandidateApplicationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCandidateApplicationStatusMutation, EditCandidateApplicationStatusMutationVariables>(
    EditCandidateApplicationStatusDocument,
    options,
  )
}
export type EditCandidateApplicationStatusMutationHookResult = ReturnType<
  typeof useEditCandidateApplicationStatusMutation
>
export type EditCandidateApplicationStatusMutationResult = Apollo.MutationResult<EditCandidateApplicationStatusMutation>
export type EditCandidateApplicationStatusMutationOptions = Apollo.BaseMutationOptions<
  EditCandidateApplicationStatusMutation,
  EditCandidateApplicationStatusMutationVariables
>
export const InviteCandidatesToApplyDocument = gql`
  mutation InviteCandidatesToApply($input: InviteCandidatesToApplyInput!) {
    InviteCandidatesToApply(input: $input) {
      uploadedCandidatesToReviewStage {
        jobListingId
        candidateProfileId
      }
      sent {
        token
        sentAt
        jobListingId
        inviteStatus
        id
        dismissed
        candidateApplicationId
      }
      profileNotFound {
        jobListingId
        candidateProfileId
      }
      isPreviouslyInvited {
        jobListingId
        candidateProfileId
      }
    }
  }
`
export type InviteCandidatesToApplyMutationFn = Apollo.MutationFunction<
  InviteCandidatesToApplyMutation,
  InviteCandidatesToApplyMutationVariables
>

/**
 * __useInviteCandidatesToApplyMutation__
 *
 * To run a mutation, you first call `useInviteCandidatesToApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCandidatesToApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCandidatesToApplyMutation, { data, loading, error }] = useInviteCandidatesToApplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteCandidatesToApplyMutation(
  baseOptions?: Apollo.MutationHookOptions<InviteCandidatesToApplyMutation, InviteCandidatesToApplyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<InviteCandidatesToApplyMutation, InviteCandidatesToApplyMutationVariables>(
    InviteCandidatesToApplyDocument,
    options,
  )
}
export type InviteCandidatesToApplyMutationHookResult = ReturnType<typeof useInviteCandidatesToApplyMutation>
export type InviteCandidatesToApplyMutationResult = Apollo.MutationResult<InviteCandidatesToApplyMutation>
export type InviteCandidatesToApplyMutationOptions = Apollo.BaseMutationOptions<
  InviteCandidatesToApplyMutation,
  InviteCandidatesToApplyMutationVariables
>
export const MoveCandidateBackStageDocument = gql`
  mutation MoveCandidateBackStage($input: MoveCandidateBackStageInput!) {
    MoveCandidateBackStage(input: $input) {
      id
      templateStageId
      applicationStatus
      lastUpdatedStatusAt
    }
  }
`
export type MoveCandidateBackStageMutationFn = Apollo.MutationFunction<
  MoveCandidateBackStageMutation,
  MoveCandidateBackStageMutationVariables
>

/**
 * __useMoveCandidateBackStageMutation__
 *
 * To run a mutation, you first call `useMoveCandidateBackStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCandidateBackStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCandidateBackStageMutation, { data, loading, error }] = useMoveCandidateBackStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveCandidateBackStageMutation(
  baseOptions?: Apollo.MutationHookOptions<MoveCandidateBackStageMutation, MoveCandidateBackStageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MoveCandidateBackStageMutation, MoveCandidateBackStageMutationVariables>(
    MoveCandidateBackStageDocument,
    options,
  )
}
export type MoveCandidateBackStageMutationHookResult = ReturnType<typeof useMoveCandidateBackStageMutation>
export type MoveCandidateBackStageMutationResult = Apollo.MutationResult<MoveCandidateBackStageMutation>
export type MoveCandidateBackStageMutationOptions = Apollo.BaseMutationOptions<
  MoveCandidateBackStageMutation,
  MoveCandidateBackStageMutationVariables
>
export const QueueBulkRejectCandidatesDocument = gql`
  mutation QueueBulkRejectCandidates($input: BulkRejectCandidatesInput!) {
    QueueuBulkRejectCandidates(input: $input)
  }
`
export type QueueBulkRejectCandidatesMutationFn = Apollo.MutationFunction<
  QueueBulkRejectCandidatesMutation,
  QueueBulkRejectCandidatesMutationVariables
>

/**
 * __useQueueBulkRejectCandidatesMutation__
 *
 * To run a mutation, you first call `useQueueBulkRejectCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueBulkRejectCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueBulkRejectCandidatesMutation, { data, loading, error }] = useQueueBulkRejectCandidatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueueBulkRejectCandidatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    QueueBulkRejectCandidatesMutation,
    QueueBulkRejectCandidatesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<QueueBulkRejectCandidatesMutation, QueueBulkRejectCandidatesMutationVariables>(
    QueueBulkRejectCandidatesDocument,
    options,
  )
}
export type QueueBulkRejectCandidatesMutationHookResult = ReturnType<typeof useQueueBulkRejectCandidatesMutation>
export type QueueBulkRejectCandidatesMutationResult = Apollo.MutationResult<QueueBulkRejectCandidatesMutation>
export type QueueBulkRejectCandidatesMutationOptions = Apollo.BaseMutationOptions<
  QueueBulkRejectCandidatesMutation,
  QueueBulkRejectCandidatesMutationVariables
>
export const RejectCandidatesDocument = gql`
  mutation RejectCandidates($input: RejectCandidatesInput!, $delaySeconds: Int) {
    RejectCandidates(input: $input, delaySeconds: $delaySeconds) {
      jobId
    }
  }
`
export type RejectCandidatesMutationFn = Apollo.MutationFunction<
  RejectCandidatesMutation,
  RejectCandidatesMutationVariables
>

/**
 * __useRejectCandidatesMutation__
 *
 * To run a mutation, you first call `useRejectCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCandidatesMutation, { data, loading, error }] = useRejectCandidatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      delaySeconds: // value for 'delaySeconds'
 *   },
 * });
 */
export function useRejectCandidatesMutation(
  baseOptions?: Apollo.MutationHookOptions<RejectCandidatesMutation, RejectCandidatesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RejectCandidatesMutation, RejectCandidatesMutationVariables>(
    RejectCandidatesDocument,
    options,
  )
}
export type RejectCandidatesMutationHookResult = ReturnType<typeof useRejectCandidatesMutation>
export type RejectCandidatesMutationResult = Apollo.MutationResult<RejectCandidatesMutation>
export type RejectCandidatesMutationOptions = Apollo.BaseMutationOptions<
  RejectCandidatesMutation,
  RejectCandidatesMutationVariables
>
export const ResolveDuplicateApplicationsDocument = gql`
  mutation ResolveDuplicateApplications($input: ResolveDuplicateApplicationsInput!) {
    ResolveDuplicateApplications(input: $input)
  }
`
export type ResolveDuplicateApplicationsMutationFn = Apollo.MutationFunction<
  ResolveDuplicateApplicationsMutation,
  ResolveDuplicateApplicationsMutationVariables
>

/**
 * __useResolveDuplicateApplicationsMutation__
 *
 * To run a mutation, you first call `useResolveDuplicateApplicationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveDuplicateApplicationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveDuplicateApplicationsMutation, { data, loading, error }] = useResolveDuplicateApplicationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveDuplicateApplicationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResolveDuplicateApplicationsMutation,
    ResolveDuplicateApplicationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResolveDuplicateApplicationsMutation, ResolveDuplicateApplicationsMutationVariables>(
    ResolveDuplicateApplicationsDocument,
    options,
  )
}
export type ResolveDuplicateApplicationsMutationHookResult = ReturnType<typeof useResolveDuplicateApplicationsMutation>
export type ResolveDuplicateApplicationsMutationResult = Apollo.MutationResult<ResolveDuplicateApplicationsMutation>
export type ResolveDuplicateApplicationsMutationOptions = Apollo.BaseMutationOptions<
  ResolveDuplicateApplicationsMutation,
  ResolveDuplicateApplicationsMutationVariables
>
export const SendCandidatesToSourcingStageDocument = gql`
  mutation SendCandidatesToSourcingStage($input: SendCandidatesToSourcingStageInput!) {
    SendCandidatesToSourcingStage(input: $input) {
      profileNotFound {
        candidateProfileId
      }
      candidateApplications {
        id
      }
      alreadyHasActiveApplication {
        candidateProfileId
      }
    }
  }
`
export type SendCandidatesToSourcingStageMutationFn = Apollo.MutationFunction<
  SendCandidatesToSourcingStageMutation,
  SendCandidatesToSourcingStageMutationVariables
>

/**
 * __useSendCandidatesToSourcingStageMutation__
 *
 * To run a mutation, you first call `useSendCandidatesToSourcingStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCandidatesToSourcingStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCandidatesToSourcingStageMutation, { data, loading, error }] = useSendCandidatesToSourcingStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCandidatesToSourcingStageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendCandidatesToSourcingStageMutation,
    SendCandidatesToSourcingStageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendCandidatesToSourcingStageMutation, SendCandidatesToSourcingStageMutationVariables>(
    SendCandidatesToSourcingStageDocument,
    options,
  )
}
export type SendCandidatesToSourcingStageMutationHookResult = ReturnType<
  typeof useSendCandidatesToSourcingStageMutation
>
export type SendCandidatesToSourcingStageMutationResult = Apollo.MutationResult<SendCandidatesToSourcingStageMutation>
export type SendCandidatesToSourcingStageMutationOptions = Apollo.BaseMutationOptions<
  SendCandidatesToSourcingStageMutation,
  SendCandidatesToSourcingStageMutationVariables
>
export const StartCandidateApplicationDocument = gql`
  mutation StartCandidateApplication($input: StartCandidateApplicationInput!) {
    StartCandidateApplication(input: $input) {
      id
    }
  }
`
export type StartCandidateApplicationMutationFn = Apollo.MutationFunction<
  StartCandidateApplicationMutation,
  StartCandidateApplicationMutationVariables
>

/**
 * __useStartCandidateApplicationMutation__
 *
 * To run a mutation, you first call `useStartCandidateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCandidateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCandidateApplicationMutation, { data, loading, error }] = useStartCandidateApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCandidateApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartCandidateApplicationMutation,
    StartCandidateApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<StartCandidateApplicationMutation, StartCandidateApplicationMutationVariables>(
    StartCandidateApplicationDocument,
    options,
  )
}
export type StartCandidateApplicationMutationHookResult = ReturnType<typeof useStartCandidateApplicationMutation>
export type StartCandidateApplicationMutationResult = Apollo.MutationResult<StartCandidateApplicationMutation>
export type StartCandidateApplicationMutationOptions = Apollo.BaseMutationOptions<
  StartCandidateApplicationMutation,
  StartCandidateApplicationMutationVariables
>
export const UndoRejectCandidatesDocument = gql`
  mutation UndoRejectCandidates($input: UndoRejectCandidatesInput!) {
    UndoRejectCandidates(input: $input)
  }
`
export type UndoRejectCandidatesMutationFn = Apollo.MutationFunction<
  UndoRejectCandidatesMutation,
  UndoRejectCandidatesMutationVariables
>

/**
 * __useUndoRejectCandidatesMutation__
 *
 * To run a mutation, you first call `useUndoRejectCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoRejectCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoRejectCandidatesMutation, { data, loading, error }] = useUndoRejectCandidatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUndoRejectCandidatesMutation(
  baseOptions?: Apollo.MutationHookOptions<UndoRejectCandidatesMutation, UndoRejectCandidatesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UndoRejectCandidatesMutation, UndoRejectCandidatesMutationVariables>(
    UndoRejectCandidatesDocument,
    options,
  )
}
export type UndoRejectCandidatesMutationHookResult = ReturnType<typeof useUndoRejectCandidatesMutation>
export type UndoRejectCandidatesMutationResult = Apollo.MutationResult<UndoRejectCandidatesMutation>
export type UndoRejectCandidatesMutationOptions = Apollo.BaseMutationOptions<
  UndoRejectCandidatesMutation,
  UndoRejectCandidatesMutationVariables
>
export const DeleteCandidateCollaboratorDocument = gql`
  mutation DeleteCandidateCollaborator($input: DeleteCandidateCollaboratorInput!) {
    DeleteCandidateCollaborator(input: $input) {
      id
    }
  }
`
export type DeleteCandidateCollaboratorMutationFn = Apollo.MutationFunction<
  DeleteCandidateCollaboratorMutation,
  DeleteCandidateCollaboratorMutationVariables
>

/**
 * __useDeleteCandidateCollaboratorMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateCollaboratorMutation, { data, loading, error }] = useDeleteCandidateCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateCollaboratorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateCollaboratorMutation,
    DeleteCandidateCollaboratorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateCollaboratorMutation, DeleteCandidateCollaboratorMutationVariables>(
    DeleteCandidateCollaboratorDocument,
    options,
  )
}
export type DeleteCandidateCollaboratorMutationHookResult = ReturnType<typeof useDeleteCandidateCollaboratorMutation>
export type DeleteCandidateCollaboratorMutationResult = Apollo.MutationResult<DeleteCandidateCollaboratorMutation>
export type DeleteCandidateCollaboratorMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateCollaboratorMutation,
  DeleteCandidateCollaboratorMutationVariables
>
export const UpsertCandidateCollaboratorDocument = gql`
  mutation UpsertCandidateCollaborator($input: UpsertCandidateCollaboratorInput!) {
    UpsertCandidateCollaborator(input: $input) {
      ...CandidateCollaboratorFragment
    }
  }
  ${CandidateCollaboratorFragmentFragmentDoc}
`
export type UpsertCandidateCollaboratorMutationFn = Apollo.MutationFunction<
  UpsertCandidateCollaboratorMutation,
  UpsertCandidateCollaboratorMutationVariables
>

/**
 * __useUpsertCandidateCollaboratorMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateCollaboratorMutation, { data, loading, error }] = useUpsertCandidateCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateCollaboratorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidateCollaboratorMutation,
    UpsertCandidateCollaboratorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateCollaboratorMutation, UpsertCandidateCollaboratorMutationVariables>(
    UpsertCandidateCollaboratorDocument,
    options,
  )
}
export type UpsertCandidateCollaboratorMutationHookResult = ReturnType<typeof useUpsertCandidateCollaboratorMutation>
export type UpsertCandidateCollaboratorMutationResult = Apollo.MutationResult<UpsertCandidateCollaboratorMutation>
export type UpsertCandidateCollaboratorMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateCollaboratorMutation,
  UpsertCandidateCollaboratorMutationVariables
>
export const CreateCompanyProvidedCandidateEmailDocument = gql`
  mutation CreateCompanyProvidedCandidateEmail($input: CreateCompanyProvidedEmailInput!) {
    CreateCompanyProvidedCandidateEmail(input: $input) {
      id
      email
      candidateProfileId
      createdAt
      updatedAt
    }
  }
`
export type CreateCompanyProvidedCandidateEmailMutationFn = Apollo.MutationFunction<
  CreateCompanyProvidedCandidateEmailMutation,
  CreateCompanyProvidedCandidateEmailMutationVariables
>

/**
 * __useCreateCompanyProvidedCandidateEmailMutation__
 *
 * To run a mutation, you first call `useCreateCompanyProvidedCandidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyProvidedCandidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyProvidedCandidateEmailMutation, { data, loading, error }] = useCreateCompanyProvidedCandidateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyProvidedCandidateEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCompanyProvidedCandidateEmailMutation,
    CreateCompanyProvidedCandidateEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCompanyProvidedCandidateEmailMutation,
    CreateCompanyProvidedCandidateEmailMutationVariables
  >(CreateCompanyProvidedCandidateEmailDocument, options)
}
export type CreateCompanyProvidedCandidateEmailMutationHookResult = ReturnType<
  typeof useCreateCompanyProvidedCandidateEmailMutation
>
export type CreateCompanyProvidedCandidateEmailMutationResult =
  Apollo.MutationResult<CreateCompanyProvidedCandidateEmailMutation>
export type CreateCompanyProvidedCandidateEmailMutationOptions = Apollo.BaseMutationOptions<
  CreateCompanyProvidedCandidateEmailMutation,
  CreateCompanyProvidedCandidateEmailMutationVariables
>
export const DeleteCompanyProvidedCandidateEmailDocument = gql`
  mutation DeleteCompanyProvidedCandidateEmail($input: DeleteCompanyProvidedEmailInput!) {
    DeleteCompanyProvidedCandidateEmail(input: $input)
  }
`
export type DeleteCompanyProvidedCandidateEmailMutationFn = Apollo.MutationFunction<
  DeleteCompanyProvidedCandidateEmailMutation,
  DeleteCompanyProvidedCandidateEmailMutationVariables
>

/**
 * __useDeleteCompanyProvidedCandidateEmailMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyProvidedCandidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyProvidedCandidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyProvidedCandidateEmailMutation, { data, loading, error }] = useDeleteCompanyProvidedCandidateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyProvidedCandidateEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCompanyProvidedCandidateEmailMutation,
    DeleteCompanyProvidedCandidateEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCompanyProvidedCandidateEmailMutation,
    DeleteCompanyProvidedCandidateEmailMutationVariables
  >(DeleteCompanyProvidedCandidateEmailDocument, options)
}
export type DeleteCompanyProvidedCandidateEmailMutationHookResult = ReturnType<
  typeof useDeleteCompanyProvidedCandidateEmailMutation
>
export type DeleteCompanyProvidedCandidateEmailMutationResult =
  Apollo.MutationResult<DeleteCompanyProvidedCandidateEmailMutation>
export type DeleteCompanyProvidedCandidateEmailMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyProvidedCandidateEmailMutation,
  DeleteCompanyProvidedCandidateEmailMutationVariables
>
export const EditCompanyProvidedCandidateEmailDocument = gql`
  mutation EditCompanyProvidedCandidateEmail($input: EditCompanyProvidedEmailInput!) {
    EditCompanyProvidedCandidateEmail(input: $input) {
      id
      email
      candidateProfileId
      createdAt
      updatedAt
    }
  }
`
export type EditCompanyProvidedCandidateEmailMutationFn = Apollo.MutationFunction<
  EditCompanyProvidedCandidateEmailMutation,
  EditCompanyProvidedCandidateEmailMutationVariables
>

/**
 * __useEditCompanyProvidedCandidateEmailMutation__
 *
 * To run a mutation, you first call `useEditCompanyProvidedCandidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyProvidedCandidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyProvidedCandidateEmailMutation, { data, loading, error }] = useEditCompanyProvidedCandidateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyProvidedCandidateEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCompanyProvidedCandidateEmailMutation,
    EditCompanyProvidedCandidateEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    EditCompanyProvidedCandidateEmailMutation,
    EditCompanyProvidedCandidateEmailMutationVariables
  >(EditCompanyProvidedCandidateEmailDocument, options)
}
export type EditCompanyProvidedCandidateEmailMutationHookResult = ReturnType<
  typeof useEditCompanyProvidedCandidateEmailMutation
>
export type EditCompanyProvidedCandidateEmailMutationResult =
  Apollo.MutationResult<EditCompanyProvidedCandidateEmailMutation>
export type EditCompanyProvidedCandidateEmailMutationOptions = Apollo.BaseMutationOptions<
  EditCompanyProvidedCandidateEmailMutation,
  EditCompanyProvidedCandidateEmailMutationVariables
>
export const UpsertCandidatePrimaryEmailDocument = gql`
  mutation UpsertCandidatePrimaryEmail($input: UpsertCandidatePrimaryEmailInput!) {
    UpsertCandidatePrimaryEmail(input: $input) {
      id
      primaryEmail
      updatedAt
    }
  }
`
export type UpsertCandidatePrimaryEmailMutationFn = Apollo.MutationFunction<
  UpsertCandidatePrimaryEmailMutation,
  UpsertCandidatePrimaryEmailMutationVariables
>

/**
 * __useUpsertCandidatePrimaryEmailMutation__
 *
 * To run a mutation, you first call `useUpsertCandidatePrimaryEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidatePrimaryEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidatePrimaryEmailMutation, { data, loading, error }] = useUpsertCandidatePrimaryEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidatePrimaryEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidatePrimaryEmailMutation,
    UpsertCandidatePrimaryEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidatePrimaryEmailMutation, UpsertCandidatePrimaryEmailMutationVariables>(
    UpsertCandidatePrimaryEmailDocument,
    options,
  )
}
export type UpsertCandidatePrimaryEmailMutationHookResult = ReturnType<typeof useUpsertCandidatePrimaryEmailMutation>
export type UpsertCandidatePrimaryEmailMutationResult = Apollo.MutationResult<UpsertCandidatePrimaryEmailMutation>
export type UpsertCandidatePrimaryEmailMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidatePrimaryEmailMutation,
  UpsertCandidatePrimaryEmailMutationVariables
>
export const CreateCandidateFilterDocument = gql`
  mutation CreateCandidateFilter($input: CreateCandidateFilterInput!) {
    CreateCandidateFilter(input: $input) {
      ...CandidateFilter
    }
  }
  ${CandidateFilterFragmentDoc}
`
export type CreateCandidateFilterMutationFn = Apollo.MutationFunction<
  CreateCandidateFilterMutation,
  CreateCandidateFilterMutationVariables
>

/**
 * __useCreateCandidateFilterMutation__
 *
 * To run a mutation, you first call `useCreateCandidateFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateFilterMutation, { data, loading, error }] = useCreateCandidateFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCandidateFilterMutation, CreateCandidateFilterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCandidateFilterMutation, CreateCandidateFilterMutationVariables>(
    CreateCandidateFilterDocument,
    options,
  )
}
export type CreateCandidateFilterMutationHookResult = ReturnType<typeof useCreateCandidateFilterMutation>
export type CreateCandidateFilterMutationResult = Apollo.MutationResult<CreateCandidateFilterMutation>
export type CreateCandidateFilterMutationOptions = Apollo.BaseMutationOptions<
  CreateCandidateFilterMutation,
  CreateCandidateFilterMutationVariables
>
export const DeleteCandidateFilterDocument = gql`
  mutation DeleteCandidateFilter($input: DeleteCandidateFilterInput!) {
    DeleteCandidateFilter(input: $input) {
      ...CandidateFilter
    }
  }
  ${CandidateFilterFragmentDoc}
`
export type DeleteCandidateFilterMutationFn = Apollo.MutationFunction<
  DeleteCandidateFilterMutation,
  DeleteCandidateFilterMutationVariables
>

/**
 * __useDeleteCandidateFilterMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateFilterMutation, { data, loading, error }] = useDeleteCandidateFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCandidateFilterMutation, DeleteCandidateFilterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateFilterMutation, DeleteCandidateFilterMutationVariables>(
    DeleteCandidateFilterDocument,
    options,
  )
}
export type DeleteCandidateFilterMutationHookResult = ReturnType<typeof useDeleteCandidateFilterMutation>
export type DeleteCandidateFilterMutationResult = Apollo.MutationResult<DeleteCandidateFilterMutation>
export type DeleteCandidateFilterMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateFilterMutation,
  DeleteCandidateFilterMutationVariables
>
export const UpdateCandidateFilterDocument = gql`
  mutation UpdateCandidateFilter($input: UpdateCandidateFilterInput!) {
    UpdateCandidateFilter(input: $input) {
      ...CandidateFilter
    }
  }
  ${CandidateFilterFragmentDoc}
`
export type UpdateCandidateFilterMutationFn = Apollo.MutationFunction<
  UpdateCandidateFilterMutation,
  UpdateCandidateFilterMutationVariables
>

/**
 * __useUpdateCandidateFilterMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateFilterMutation, { data, loading, error }] = useUpdateCandidateFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidateFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCandidateFilterMutation, UpdateCandidateFilterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCandidateFilterMutation, UpdateCandidateFilterMutationVariables>(
    UpdateCandidateFilterDocument,
    options,
  )
}
export type UpdateCandidateFilterMutationHookResult = ReturnType<typeof useUpdateCandidateFilterMutation>
export type UpdateCandidateFilterMutationResult = Apollo.MutationResult<UpdateCandidateFilterMutation>
export type UpdateCandidateFilterMutationOptions = Apollo.BaseMutationOptions<
  UpdateCandidateFilterMutation,
  UpdateCandidateFilterMutationVariables
>
export const CreateAndAssignCandidateLabelDocument = gql`
  mutation CreateAndAssignCandidateLabel($input: CreateAndAssignCandidateLabelInput!) {
    CreateAndAssignCandidateLabel(input: $input) {
      ...CandidateLabel
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateProfiles {
        id
      }
    }
  }
  ${CandidateLabelFragmentDoc}
`
export type CreateAndAssignCandidateLabelMutationFn = Apollo.MutationFunction<
  CreateAndAssignCandidateLabelMutation,
  CreateAndAssignCandidateLabelMutationVariables
>

/**
 * __useCreateAndAssignCandidateLabelMutation__
 *
 * To run a mutation, you first call `useCreateAndAssignCandidateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndAssignCandidateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndAssignCandidateLabelMutation, { data, loading, error }] = useCreateAndAssignCandidateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAndAssignCandidateLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAndAssignCandidateLabelMutation,
    CreateAndAssignCandidateLabelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateAndAssignCandidateLabelMutation, CreateAndAssignCandidateLabelMutationVariables>(
    CreateAndAssignCandidateLabelDocument,
    options,
  )
}
export type CreateAndAssignCandidateLabelMutationHookResult = ReturnType<
  typeof useCreateAndAssignCandidateLabelMutation
>
export type CreateAndAssignCandidateLabelMutationResult = Apollo.MutationResult<CreateAndAssignCandidateLabelMutation>
export type CreateAndAssignCandidateLabelMutationOptions = Apollo.BaseMutationOptions<
  CreateAndAssignCandidateLabelMutation,
  CreateAndAssignCandidateLabelMutationVariables
>
export const CreateCandidateLabelDocument = gql`
  mutation CreateCandidateLabel($input: CreateCandidateLabelInput!) {
    CreateCandidateLabel(input: $input) {
      id
      labelName
      colorNumber
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateProfiles {
        id
      }
    }
  }
`
export type CreateCandidateLabelMutationFn = Apollo.MutationFunction<
  CreateCandidateLabelMutation,
  CreateCandidateLabelMutationVariables
>

/**
 * __useCreateCandidateLabelMutation__
 *
 * To run a mutation, you first call `useCreateCandidateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateLabelMutation, { data, loading, error }] = useCreateCandidateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCandidateLabelMutation, CreateCandidateLabelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCandidateLabelMutation, CreateCandidateLabelMutationVariables>(
    CreateCandidateLabelDocument,
    options,
  )
}
export type CreateCandidateLabelMutationHookResult = ReturnType<typeof useCreateCandidateLabelMutation>
export type CreateCandidateLabelMutationResult = Apollo.MutationResult<CreateCandidateLabelMutation>
export type CreateCandidateLabelMutationOptions = Apollo.BaseMutationOptions<
  CreateCandidateLabelMutation,
  CreateCandidateLabelMutationVariables
>
export const DeleteCandidateLabelDocument = gql`
  mutation DeleteCandidateLabel($input: DeleteCandidateLabelInput!) {
    DeleteCandidateLabel(input: $input) {
      id
      labelName
      colorNumber
      companyId
      companyUserId
    }
  }
`
export type DeleteCandidateLabelMutationFn = Apollo.MutationFunction<
  DeleteCandidateLabelMutation,
  DeleteCandidateLabelMutationVariables
>

/**
 * __useDeleteCandidateLabelMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateLabelMutation, { data, loading, error }] = useDeleteCandidateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCandidateLabelMutation, DeleteCandidateLabelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateLabelMutation, DeleteCandidateLabelMutationVariables>(
    DeleteCandidateLabelDocument,
    options,
  )
}
export type DeleteCandidateLabelMutationHookResult = ReturnType<typeof useDeleteCandidateLabelMutation>
export type DeleteCandidateLabelMutationResult = Apollo.MutationResult<DeleteCandidateLabelMutation>
export type DeleteCandidateLabelMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateLabelMutation,
  DeleteCandidateLabelMutationVariables
>
export const EditCandidateLabelDocument = gql`
  mutation EditCandidateLabel($input: EditCandidateLabelInput!) {
    EditCandidateLabel(input: $input) {
      id
      labelName
      colorNumber
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateProfiles {
        id
      }
    }
  }
`
export type EditCandidateLabelMutationFn = Apollo.MutationFunction<
  EditCandidateLabelMutation,
  EditCandidateLabelMutationVariables
>

/**
 * __useEditCandidateLabelMutation__
 *
 * To run a mutation, you first call `useEditCandidateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCandidateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCandidateLabelMutation, { data, loading, error }] = useEditCandidateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCandidateLabelMutation(
  baseOptions?: Apollo.MutationHookOptions<EditCandidateLabelMutation, EditCandidateLabelMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCandidateLabelMutation, EditCandidateLabelMutationVariables>(
    EditCandidateLabelDocument,
    options,
  )
}
export type EditCandidateLabelMutationHookResult = ReturnType<typeof useEditCandidateLabelMutation>
export type EditCandidateLabelMutationResult = Apollo.MutationResult<EditCandidateLabelMutation>
export type EditCandidateLabelMutationOptions = Apollo.BaseMutationOptions<
  EditCandidateLabelMutation,
  EditCandidateLabelMutationVariables
>
export const ManageCandidateLabelsDocument = gql`
  mutation ManageCandidateLabels($input: ManageCandidateLabelsInput!) {
    ManageCandidateLabels(input: $input) {
      id
      labelName
      colorNumber
      companyId
      companyUserId
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateProfiles {
        id
      }
    }
  }
`
export type ManageCandidateLabelsMutationFn = Apollo.MutationFunction<
  ManageCandidateLabelsMutation,
  ManageCandidateLabelsMutationVariables
>

/**
 * __useManageCandidateLabelsMutation__
 *
 * To run a mutation, you first call `useManageCandidateLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageCandidateLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageCandidateLabelsMutation, { data, loading, error }] = useManageCandidateLabelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManageCandidateLabelsMutation(
  baseOptions?: Apollo.MutationHookOptions<ManageCandidateLabelsMutation, ManageCandidateLabelsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ManageCandidateLabelsMutation, ManageCandidateLabelsMutationVariables>(
    ManageCandidateLabelsDocument,
    options,
  )
}
export type ManageCandidateLabelsMutationHookResult = ReturnType<typeof useManageCandidateLabelsMutation>
export type ManageCandidateLabelsMutationResult = Apollo.MutationResult<ManageCandidateLabelsMutation>
export type ManageCandidateLabelsMutationOptions = Apollo.BaseMutationOptions<
  ManageCandidateLabelsMutation,
  ManageCandidateLabelsMutationVariables
>
export const MergeCandidateLabelsDocument = gql`
  mutation MergeCandidateLabels($input: MergeCandidateLabelsInput!) {
    MergeCandidateLabels(input: $input) {
      id
      labelName
      colorNumber
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateProfiles {
        id
      }
    }
  }
`
export type MergeCandidateLabelsMutationFn = Apollo.MutationFunction<
  MergeCandidateLabelsMutation,
  MergeCandidateLabelsMutationVariables
>

/**
 * __useMergeCandidateLabelsMutation__
 *
 * To run a mutation, you first call `useMergeCandidateLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCandidateLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCandidateLabelsMutation, { data, loading, error }] = useMergeCandidateLabelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeCandidateLabelsMutation(
  baseOptions?: Apollo.MutationHookOptions<MergeCandidateLabelsMutation, MergeCandidateLabelsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MergeCandidateLabelsMutation, MergeCandidateLabelsMutationVariables>(
    MergeCandidateLabelsDocument,
    options,
  )
}
export type MergeCandidateLabelsMutationHookResult = ReturnType<typeof useMergeCandidateLabelsMutation>
export type MergeCandidateLabelsMutationResult = Apollo.MutationResult<MergeCandidateLabelsMutation>
export type MergeCandidateLabelsMutationOptions = Apollo.BaseMutationOptions<
  MergeCandidateLabelsMutation,
  MergeCandidateLabelsMutationVariables
>
export const DeleteCandidateMedalistDesignationDocument = gql`
  mutation DeleteCandidateMedalistDesignation($input: DeleteCandidateMedalistDesignationInput!) {
    DeleteCandidateMedalistDesignation(input: $input) {
      id
    }
  }
`
export type DeleteCandidateMedalistDesignationMutationFn = Apollo.MutationFunction<
  DeleteCandidateMedalistDesignationMutation,
  DeleteCandidateMedalistDesignationMutationVariables
>

/**
 * __useDeleteCandidateMedalistDesignationMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateMedalistDesignationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateMedalistDesignationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateMedalistDesignationMutation, { data, loading, error }] = useDeleteCandidateMedalistDesignationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateMedalistDesignationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateMedalistDesignationMutation,
    DeleteCandidateMedalistDesignationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCandidateMedalistDesignationMutation,
    DeleteCandidateMedalistDesignationMutationVariables
  >(DeleteCandidateMedalistDesignationDocument, options)
}
export type DeleteCandidateMedalistDesignationMutationHookResult = ReturnType<
  typeof useDeleteCandidateMedalistDesignationMutation
>
export type DeleteCandidateMedalistDesignationMutationResult =
  Apollo.MutationResult<DeleteCandidateMedalistDesignationMutation>
export type DeleteCandidateMedalistDesignationMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateMedalistDesignationMutation,
  DeleteCandidateMedalistDesignationMutationVariables
>
export const DeleteCandidateProfileLocationDocument = gql`
  mutation DeleteCandidateProfileLocation($input: DeleteCandidateProfileLocationInput!) {
    DeleteCandidateProfileLocation(input: $input) {
      id
    }
  }
`
export type DeleteCandidateProfileLocationMutationFn = Apollo.MutationFunction<
  DeleteCandidateProfileLocationMutation,
  DeleteCandidateProfileLocationMutationVariables
>

/**
 * __useDeleteCandidateProfileLocationMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateProfileLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateProfileLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateProfileLocationMutation, { data, loading, error }] = useDeleteCandidateProfileLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateProfileLocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateProfileLocationMutation,
    DeleteCandidateProfileLocationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateProfileLocationMutation, DeleteCandidateProfileLocationMutationVariables>(
    DeleteCandidateProfileLocationDocument,
    options,
  )
}
export type DeleteCandidateProfileLocationMutationHookResult = ReturnType<
  typeof useDeleteCandidateProfileLocationMutation
>
export type DeleteCandidateProfileLocationMutationResult = Apollo.MutationResult<DeleteCandidateProfileLocationMutation>
export type DeleteCandidateProfileLocationMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateProfileLocationMutation,
  DeleteCandidateProfileLocationMutationVariables
>
export const DeleteCandidateProfileNoteDocument = gql`
  mutation DeleteCandidateProfileNote($input: DeleteCandidateProfileNoteInput!) {
    DeleteCandidateProfileNote(input: $input) {
      id
    }
  }
`
export type DeleteCandidateProfileNoteMutationFn = Apollo.MutationFunction<
  DeleteCandidateProfileNoteMutation,
  DeleteCandidateProfileNoteMutationVariables
>

/**
 * __useDeleteCandidateProfileNoteMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateProfileNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateProfileNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateProfileNoteMutation, { data, loading, error }] = useDeleteCandidateProfileNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateProfileNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateProfileNoteMutation,
    DeleteCandidateProfileNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateProfileNoteMutation, DeleteCandidateProfileNoteMutationVariables>(
    DeleteCandidateProfileNoteDocument,
    options,
  )
}
export type DeleteCandidateProfileNoteMutationHookResult = ReturnType<typeof useDeleteCandidateProfileNoteMutation>
export type DeleteCandidateProfileNoteMutationResult = Apollo.MutationResult<DeleteCandidateProfileNoteMutation>
export type DeleteCandidateProfileNoteMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateProfileNoteMutation,
  DeleteCandidateProfileNoteMutationVariables
>
export const UpsertCandidateProfileNoteDocument = gql`
  mutation UpsertCandidateProfileNote($input: UpsertCandidateProfileNoteInput!) {
    UpsertCandidateProfileNote(input: $input) {
      id
    }
  }
`
export type UpsertCandidateProfileNoteMutationFn = Apollo.MutationFunction<
  UpsertCandidateProfileNoteMutation,
  UpsertCandidateProfileNoteMutationVariables
>

/**
 * __useUpsertCandidateProfileNoteMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateProfileNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateProfileNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateProfileNoteMutation, { data, loading, error }] = useUpsertCandidateProfileNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateProfileNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidateProfileNoteMutation,
    UpsertCandidateProfileNoteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateProfileNoteMutation, UpsertCandidateProfileNoteMutationVariables>(
    UpsertCandidateProfileNoteDocument,
    options,
  )
}
export type UpsertCandidateProfileNoteMutationHookResult = ReturnType<typeof useUpsertCandidateProfileNoteMutation>
export type UpsertCandidateProfileNoteMutationResult = Apollo.MutationResult<UpsertCandidateProfileNoteMutation>
export type UpsertCandidateProfileNoteMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateProfileNoteMutation,
  UpsertCandidateProfileNoteMutationVariables
>
export const CreateCandidateSourceDocument = gql`
  mutation CreateCandidateSource($input: CandidateSourceInput!) {
    CreateCandidateSource(input: $input) {
      id
    }
  }
`
export type CreateCandidateSourceMutationFn = Apollo.MutationFunction<
  CreateCandidateSourceMutation,
  CreateCandidateSourceMutationVariables
>

/**
 * __useCreateCandidateSourceMutation__
 *
 * To run a mutation, you first call `useCreateCandidateSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateSourceMutation, { data, loading, error }] = useCreateCandidateSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCandidateSourceMutation, CreateCandidateSourceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCandidateSourceMutation, CreateCandidateSourceMutationVariables>(
    CreateCandidateSourceDocument,
    options,
  )
}
export type CreateCandidateSourceMutationHookResult = ReturnType<typeof useCreateCandidateSourceMutation>
export type CreateCandidateSourceMutationResult = Apollo.MutationResult<CreateCandidateSourceMutation>
export type CreateCandidateSourceMutationOptions = Apollo.BaseMutationOptions<
  CreateCandidateSourceMutation,
  CreateCandidateSourceMutationVariables
>
export const CreateUploadedDocumentCandidateProfileDocument = gql`
  mutation CreateUploadedDocumentCandidateProfile($input: CreateUploadedDocumentCandidateProfileInput!) {
    CreateUploadedDocumentCandidateProfile(input: $input) {
      id
    }
  }
`
export type CreateUploadedDocumentCandidateProfileMutationFn = Apollo.MutationFunction<
  CreateUploadedDocumentCandidateProfileMutation,
  CreateUploadedDocumentCandidateProfileMutationVariables
>

/**
 * __useCreateUploadedDocumentCandidateProfileMutation__
 *
 * To run a mutation, you first call `useCreateUploadedDocumentCandidateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadedDocumentCandidateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadedDocumentCandidateProfileMutation, { data, loading, error }] = useCreateUploadedDocumentCandidateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadedDocumentCandidateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUploadedDocumentCandidateProfileMutation,
    CreateUploadedDocumentCandidateProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateUploadedDocumentCandidateProfileMutation,
    CreateUploadedDocumentCandidateProfileMutationVariables
  >(CreateUploadedDocumentCandidateProfileDocument, options)
}
export type CreateUploadedDocumentCandidateProfileMutationHookResult = ReturnType<
  typeof useCreateUploadedDocumentCandidateProfileMutation
>
export type CreateUploadedDocumentCandidateProfileMutationResult =
  Apollo.MutationResult<CreateUploadedDocumentCandidateProfileMutation>
export type CreateUploadedDocumentCandidateProfileMutationOptions = Apollo.BaseMutationOptions<
  CreateUploadedDocumentCandidateProfileMutation,
  CreateUploadedDocumentCandidateProfileMutationVariables
>
export const DeleteCandidateApplicationFromRequisitionDocument = gql`
  mutation DeleteCandidateApplicationFromRequisition($input: DeleteCandidateApplicationFromRequisitionInput!) {
    DeleteCandidateApplicationFromRequisition(input: $input) {
      success
      message
    }
  }
`
export type DeleteCandidateApplicationFromRequisitionMutationFn = Apollo.MutationFunction<
  DeleteCandidateApplicationFromRequisitionMutation,
  DeleteCandidateApplicationFromRequisitionMutationVariables
>

/**
 * __useDeleteCandidateApplicationFromRequisitionMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateApplicationFromRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateApplicationFromRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateApplicationFromRequisitionMutation, { data, loading, error }] = useDeleteCandidateApplicationFromRequisitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateApplicationFromRequisitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateApplicationFromRequisitionMutation,
    DeleteCandidateApplicationFromRequisitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCandidateApplicationFromRequisitionMutation,
    DeleteCandidateApplicationFromRequisitionMutationVariables
  >(DeleteCandidateApplicationFromRequisitionDocument, options)
}
export type DeleteCandidateApplicationFromRequisitionMutationHookResult = ReturnType<
  typeof useDeleteCandidateApplicationFromRequisitionMutation
>
export type DeleteCandidateApplicationFromRequisitionMutationResult =
  Apollo.MutationResult<DeleteCandidateApplicationFromRequisitionMutation>
export type DeleteCandidateApplicationFromRequisitionMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateApplicationFromRequisitionMutation,
  DeleteCandidateApplicationFromRequisitionMutationVariables
>
export const DeleteCandidateSourceDocument = gql`
  mutation DeleteCandidateSource($input: DeleteCandidateSourceInput!) {
    DeleteCandidateSource(input: $input) {
      id
    }
  }
`
export type DeleteCandidateSourceMutationFn = Apollo.MutationFunction<
  DeleteCandidateSourceMutation,
  DeleteCandidateSourceMutationVariables
>

/**
 * __useDeleteCandidateSourceMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateSourceMutation, { data, loading, error }] = useDeleteCandidateSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCandidateSourceMutation, DeleteCandidateSourceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateSourceMutation, DeleteCandidateSourceMutationVariables>(
    DeleteCandidateSourceDocument,
    options,
  )
}
export type DeleteCandidateSourceMutationHookResult = ReturnType<typeof useDeleteCandidateSourceMutation>
export type DeleteCandidateSourceMutationResult = Apollo.MutationResult<DeleteCandidateSourceMutation>
export type DeleteCandidateSourceMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateSourceMutation,
  DeleteCandidateSourceMutationVariables
>
export const DeleteUploadedDocumentCandidateProfileDocument = gql`
  mutation DeleteUploadedDocumentCandidateProfile($input: DeleteUploadedDocumentCandidateProfileInput!) {
    DeleteUploadedDocumentCandidateProfile(input: $input) {
      id
    }
  }
`
export type DeleteUploadedDocumentCandidateProfileMutationFn = Apollo.MutationFunction<
  DeleteUploadedDocumentCandidateProfileMutation,
  DeleteUploadedDocumentCandidateProfileMutationVariables
>

/**
 * __useDeleteUploadedDocumentCandidateProfileMutation__
 *
 * To run a mutation, you first call `useDeleteUploadedDocumentCandidateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadedDocumentCandidateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadedDocumentCandidateProfileMutation, { data, loading, error }] = useDeleteUploadedDocumentCandidateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUploadedDocumentCandidateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUploadedDocumentCandidateProfileMutation,
    DeleteUploadedDocumentCandidateProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteUploadedDocumentCandidateProfileMutation,
    DeleteUploadedDocumentCandidateProfileMutationVariables
  >(DeleteUploadedDocumentCandidateProfileDocument, options)
}
export type DeleteUploadedDocumentCandidateProfileMutationHookResult = ReturnType<
  typeof useDeleteUploadedDocumentCandidateProfileMutation
>
export type DeleteUploadedDocumentCandidateProfileMutationResult =
  Apollo.MutationResult<DeleteUploadedDocumentCandidateProfileMutation>
export type DeleteUploadedDocumentCandidateProfileMutationOptions = Apollo.BaseMutationOptions<
  DeleteUploadedDocumentCandidateProfileMutation,
  DeleteUploadedDocumentCandidateProfileMutationVariables
>
export const SendEmailToCandidateProfileDocument = gql`
  mutation SendEmailToCandidateProfile($input: SendEmailToCandidateProfileInput!) {
    SendEmailToCandidateProfile(input: $input)
  }
`
export type SendEmailToCandidateProfileMutationFn = Apollo.MutationFunction<
  SendEmailToCandidateProfileMutation,
  SendEmailToCandidateProfileMutationVariables
>

/**
 * __useSendEmailToCandidateProfileMutation__
 *
 * To run a mutation, you first call `useSendEmailToCandidateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailToCandidateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailToCandidateProfileMutation, { data, loading, error }] = useSendEmailToCandidateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailToCandidateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendEmailToCandidateProfileMutation,
    SendEmailToCandidateProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendEmailToCandidateProfileMutation, SendEmailToCandidateProfileMutationVariables>(
    SendEmailToCandidateProfileDocument,
    options,
  )
}
export type SendEmailToCandidateProfileMutationHookResult = ReturnType<typeof useSendEmailToCandidateProfileMutation>
export type SendEmailToCandidateProfileMutationResult = Apollo.MutationResult<SendEmailToCandidateProfileMutation>
export type SendEmailToCandidateProfileMutationOptions = Apollo.BaseMutationOptions<
  SendEmailToCandidateProfileMutation,
  SendEmailToCandidateProfileMutationVariables
>
export const UpsertCandidateProfileDocument = gql`
  mutation UpsertCandidateProfile($input: UpsertCandidateProfileInput!) {
    UpsertCandidateProfile(input: $input) {
      id
      CompanyProvidedEmail {
        id
        email
      }
    }
  }
`
export type UpsertCandidateProfileMutationFn = Apollo.MutationFunction<
  UpsertCandidateProfileMutation,
  UpsertCandidateProfileMutationVariables
>

/**
 * __useUpsertCandidateProfileMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateProfileMutation, { data, loading, error }] = useUpsertCandidateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertCandidateProfileMutation, UpsertCandidateProfileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateProfileMutation, UpsertCandidateProfileMutationVariables>(
    UpsertCandidateProfileDocument,
    options,
  )
}
export type UpsertCandidateProfileMutationHookResult = ReturnType<typeof useUpsertCandidateProfileMutation>
export type UpsertCandidateProfileMutationResult = Apollo.MutationResult<UpsertCandidateProfileMutation>
export type UpsertCandidateProfileMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateProfileMutation,
  UpsertCandidateProfileMutationVariables
>
export const DeleteCandidateScorecardDocument = gql`
  mutation DeleteCandidateScorecard($input: DeleteCandidateScorecardInput!) {
    DeleteCandidateScorecard(input: $input) {
      id
    }
  }
`
export type DeleteCandidateScorecardMutationFn = Apollo.MutationFunction<
  DeleteCandidateScorecardMutation,
  DeleteCandidateScorecardMutationVariables
>

/**
 * __useDeleteCandidateScorecardMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateScorecardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateScorecardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateScorecardMutation, { data, loading, error }] = useDeleteCandidateScorecardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateScorecardMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCandidateScorecardMutation, DeleteCandidateScorecardMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateScorecardMutation, DeleteCandidateScorecardMutationVariables>(
    DeleteCandidateScorecardDocument,
    options,
  )
}
export type DeleteCandidateScorecardMutationHookResult = ReturnType<typeof useDeleteCandidateScorecardMutation>
export type DeleteCandidateScorecardMutationResult = Apollo.MutationResult<DeleteCandidateScorecardMutation>
export type DeleteCandidateScorecardMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateScorecardMutation,
  DeleteCandidateScorecardMutationVariables
>
export const GetCandidateScorecardDocument = gql`
  query GetCandidateScorecard($input: GetCandidateScorecardInput!) {
    GetCandidateScorecard(input: $input) {
      id
      additionalInformation
      candidateApplicationId
      companyUserId
      scorecardTemplateId
      status
      templateStageId
      updatedAt
      createdAt
      ScorecardTemplate {
        id
        scorecardName
        department
        createdAt
        companyTemplate
        archived
        companyId
        timestampAt
      }
      CandidateApplication {
        id
        candidateProfileId
        applicationStatus
        CustomApplicationStatus {
          ...CustomApplicationStatus
        }
        JobListing {
          id
          externalTitle
          Requisition {
            id
            extRequisitionId
            jobName
          }
        }
      }
      CandidateScorecardAnswers {
        answer
        answerPreferredStatus
        candidateScorecardId
        dateAnswer
        id
        scoreAnswer
        scorecardTemplateQuestionId
        overallRecommendation
      }
      TemplateStage {
        name
        id
        createdAt
        archived
        rankOrder
        templateMilestoneId
        templatePipelineId
        updatedAt
        visibility
        TemplateMilestone {
          id
          name
        }
      }
      CompanyUser {
        UserInvitation {
          ScalisUser {
            ...ScalisUser
          }
        }
      }
    }
  }
  ${CustomApplicationStatusFragmentDoc}
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetCandidateScorecardQuery__
 *
 * To run a query within a React component, call `useGetCandidateScorecardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateScorecardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateScorecardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateScorecardQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateScorecardQuery, GetCandidateScorecardQueryVariables> &
    ({ variables: GetCandidateScorecardQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateScorecardQuery, GetCandidateScorecardQueryVariables>(
    GetCandidateScorecardDocument,
    options,
  )
}
export function useGetCandidateScorecardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateScorecardQuery, GetCandidateScorecardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateScorecardQuery, GetCandidateScorecardQueryVariables>(
    GetCandidateScorecardDocument,
    options,
  )
}
export function useGetCandidateScorecardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateScorecardQuery, GetCandidateScorecardQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateScorecardQuery, GetCandidateScorecardQueryVariables>(
    GetCandidateScorecardDocument,
    options,
  )
}
export type GetCandidateScorecardQueryHookResult = ReturnType<typeof useGetCandidateScorecardQuery>
export type GetCandidateScorecardLazyQueryHookResult = ReturnType<typeof useGetCandidateScorecardLazyQuery>
export type GetCandidateScorecardSuspenseQueryHookResult = ReturnType<typeof useGetCandidateScorecardSuspenseQuery>
export type GetCandidateScorecardQueryResult = Apollo.QueryResult<
  GetCandidateScorecardQuery,
  GetCandidateScorecardQueryVariables
>
export const SendReminderCandidateScorecardDocument = gql`
  mutation SendReminderCandidateScorecard($input: SendReminderCandidateScorecardInput!) {
    SendReminderCandidateScorecard(input: $input) {
      id
    }
  }
`
export type SendReminderCandidateScorecardMutationFn = Apollo.MutationFunction<
  SendReminderCandidateScorecardMutation,
  SendReminderCandidateScorecardMutationVariables
>

/**
 * __useSendReminderCandidateScorecardMutation__
 *
 * To run a mutation, you first call `useSendReminderCandidateScorecardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReminderCandidateScorecardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReminderCandidateScorecardMutation, { data, loading, error }] = useSendReminderCandidateScorecardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendReminderCandidateScorecardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendReminderCandidateScorecardMutation,
    SendReminderCandidateScorecardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendReminderCandidateScorecardMutation, SendReminderCandidateScorecardMutationVariables>(
    SendReminderCandidateScorecardDocument,
    options,
  )
}
export type SendReminderCandidateScorecardMutationHookResult = ReturnType<
  typeof useSendReminderCandidateScorecardMutation
>
export type SendReminderCandidateScorecardMutationResult = Apollo.MutationResult<SendReminderCandidateScorecardMutation>
export type SendReminderCandidateScorecardMutationOptions = Apollo.BaseMutationOptions<
  SendReminderCandidateScorecardMutation,
  SendReminderCandidateScorecardMutationVariables
>
export const UpsertCandidateScorecardAnswersDocument = gql`
  mutation UpsertCandidateScorecardAnswers($input: UpsertCandidateScorecardAnswersInput!) {
    UpsertCandidateScorecardAnswers(input: $input) {
      id
      answer
      answerPreferredStatus
      candidateScorecardId
      dateAnswer
      scoreAnswer
      scorecardTemplateQuestionId
    }
  }
`
export type UpsertCandidateScorecardAnswersMutationFn = Apollo.MutationFunction<
  UpsertCandidateScorecardAnswersMutation,
  UpsertCandidateScorecardAnswersMutationVariables
>

/**
 * __useUpsertCandidateScorecardAnswersMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateScorecardAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateScorecardAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateScorecardAnswersMutation, { data, loading, error }] = useUpsertCandidateScorecardAnswersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateScorecardAnswersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidateScorecardAnswersMutation,
    UpsertCandidateScorecardAnswersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateScorecardAnswersMutation, UpsertCandidateScorecardAnswersMutationVariables>(
    UpsertCandidateScorecardAnswersDocument,
    options,
  )
}
export type UpsertCandidateScorecardAnswersMutationHookResult = ReturnType<
  typeof useUpsertCandidateScorecardAnswersMutation
>
export type UpsertCandidateScorecardAnswersMutationResult =
  Apollo.MutationResult<UpsertCandidateScorecardAnswersMutation>
export type UpsertCandidateScorecardAnswersMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateScorecardAnswersMutation,
  UpsertCandidateScorecardAnswersMutationVariables
>
export const UpsertCandidateScorecardDocument = gql`
  mutation UpsertCandidateScorecard($input: UpsertCandidateScorecardInput!) {
    UpsertCandidateScorecard(input: $input) {
      id
      scorecardTemplateId
      status
      templateStageId
      companyUserId
      candidateApplicationId
      additionalInformation
    }
  }
`
export type UpsertCandidateScorecardMutationFn = Apollo.MutationFunction<
  UpsertCandidateScorecardMutation,
  UpsertCandidateScorecardMutationVariables
>

/**
 * __useUpsertCandidateScorecardMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateScorecardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateScorecardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateScorecardMutation, { data, loading, error }] = useUpsertCandidateScorecardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateScorecardMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertCandidateScorecardMutation, UpsertCandidateScorecardMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateScorecardMutation, UpsertCandidateScorecardMutationVariables>(
    UpsertCandidateScorecardDocument,
    options,
  )
}
export type UpsertCandidateScorecardMutationHookResult = ReturnType<typeof useUpsertCandidateScorecardMutation>
export type UpsertCandidateScorecardMutationResult = Apollo.MutationResult<UpsertCandidateScorecardMutation>
export type UpsertCandidateScorecardMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateScorecardMutation,
  UpsertCandidateScorecardMutationVariables
>
export const CreateCandidateSourceNameDocument = gql`
  mutation CreateCandidateSourceName($input: CandidateSourceNameCreateInput!) {
    CreateCandidateSourceName(input: $input) {
      id
      name
      sourceCategory
    }
  }
`
export type CreateCandidateSourceNameMutationFn = Apollo.MutationFunction<
  CreateCandidateSourceNameMutation,
  CreateCandidateSourceNameMutationVariables
>

/**
 * __useCreateCandidateSourceNameMutation__
 *
 * To run a mutation, you first call `useCreateCandidateSourceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateSourceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateSourceNameMutation, { data, loading, error }] = useCreateCandidateSourceNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateSourceNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCandidateSourceNameMutation,
    CreateCandidateSourceNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCandidateSourceNameMutation, CreateCandidateSourceNameMutationVariables>(
    CreateCandidateSourceNameDocument,
    options,
  )
}
export type CreateCandidateSourceNameMutationHookResult = ReturnType<typeof useCreateCandidateSourceNameMutation>
export type CreateCandidateSourceNameMutationResult = Apollo.MutationResult<CreateCandidateSourceNameMutation>
export type CreateCandidateSourceNameMutationOptions = Apollo.BaseMutationOptions<
  CreateCandidateSourceNameMutation,
  CreateCandidateSourceNameMutationVariables
>
export const CreateCustomSourceCategoryDocument = gql`
  mutation CreateCustomSourceCategory($input: CreateCustomSourceCategoryInput!) {
    CreateCustomSourceCategory(input: $input) {
      id
      sourceCategoryName
      externalId
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateSourceNames {
        id
        name
      }
    }
  }
`
export type CreateCustomSourceCategoryMutationFn = Apollo.MutationFunction<
  CreateCustomSourceCategoryMutation,
  CreateCustomSourceCategoryMutationVariables
>

/**
 * __useCreateCustomSourceCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCustomSourceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomSourceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomSourceCategoryMutation, { data, loading, error }] = useCreateCustomSourceCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomSourceCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomSourceCategoryMutation,
    CreateCustomSourceCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCustomSourceCategoryMutation, CreateCustomSourceCategoryMutationVariables>(
    CreateCustomSourceCategoryDocument,
    options,
  )
}
export type CreateCustomSourceCategoryMutationHookResult = ReturnType<typeof useCreateCustomSourceCategoryMutation>
export type CreateCustomSourceCategoryMutationResult = Apollo.MutationResult<CreateCustomSourceCategoryMutation>
export type CreateCustomSourceCategoryMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomSourceCategoryMutation,
  CreateCustomSourceCategoryMutationVariables
>
export const DeleteCustomSourceCategoryDocument = gql`
  mutation DeleteCustomSourceCategory($input: DeleteCustomSourceCategoryInput!) {
    DeleteCustomSourceCategory(input: $input) {
      id
      sourceCategoryName
      externalId
      companyId
      companyUserId
    }
  }
`
export type DeleteCustomSourceCategoryMutationFn = Apollo.MutationFunction<
  DeleteCustomSourceCategoryMutation,
  DeleteCustomSourceCategoryMutationVariables
>

/**
 * __useDeleteCustomSourceCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCustomSourceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomSourceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomSourceCategoryMutation, { data, loading, error }] = useDeleteCustomSourceCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomSourceCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomSourceCategoryMutation,
    DeleteCustomSourceCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCustomSourceCategoryMutation, DeleteCustomSourceCategoryMutationVariables>(
    DeleteCustomSourceCategoryDocument,
    options,
  )
}
export type DeleteCustomSourceCategoryMutationHookResult = ReturnType<typeof useDeleteCustomSourceCategoryMutation>
export type DeleteCustomSourceCategoryMutationResult = Apollo.MutationResult<DeleteCustomSourceCategoryMutation>
export type DeleteCustomSourceCategoryMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomSourceCategoryMutation,
  DeleteCustomSourceCategoryMutationVariables
>
export const EditCustomSourceCategoryDocument = gql`
  mutation EditCustomSourceCategory($input: EditCustomSourceCategoryInput!) {
    EditCustomSourceCategory(input: $input) {
      id
      sourceCategoryName
      externalId
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateSourceNames {
        id
        name
      }
    }
  }
`
export type EditCustomSourceCategoryMutationFn = Apollo.MutationFunction<
  EditCustomSourceCategoryMutation,
  EditCustomSourceCategoryMutationVariables
>

/**
 * __useEditCustomSourceCategoryMutation__
 *
 * To run a mutation, you first call `useEditCustomSourceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomSourceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomSourceCategoryMutation, { data, loading, error }] = useEditCustomSourceCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCustomSourceCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<EditCustomSourceCategoryMutation, EditCustomSourceCategoryMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCustomSourceCategoryMutation, EditCustomSourceCategoryMutationVariables>(
    EditCustomSourceCategoryDocument,
    options,
  )
}
export type EditCustomSourceCategoryMutationHookResult = ReturnType<typeof useEditCustomSourceCategoryMutation>
export type EditCustomSourceCategoryMutationResult = Apollo.MutationResult<EditCustomSourceCategoryMutation>
export type EditCustomSourceCategoryMutationOptions = Apollo.BaseMutationOptions<
  EditCustomSourceCategoryMutation,
  EditCustomSourceCategoryMutationVariables
>
export const MergeCustomSourceCategoryDocument = gql`
  mutation MergeCustomSourceCategory($input: MergeCustomSourceCategoryInput!) {
    MergeCustomSourceCategory(input: $input) {
      id
      sourceCategoryName
      externalId
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      candidateSourceNames {
        id
        name
      }
    }
  }
`
export type MergeCustomSourceCategoryMutationFn = Apollo.MutationFunction<
  MergeCustomSourceCategoryMutation,
  MergeCustomSourceCategoryMutationVariables
>

/**
 * __useMergeCustomSourceCategoryMutation__
 *
 * To run a mutation, you first call `useMergeCustomSourceCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCustomSourceCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCustomSourceCategoryMutation, { data, loading, error }] = useMergeCustomSourceCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeCustomSourceCategoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MergeCustomSourceCategoryMutation,
    MergeCustomSourceCategoryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MergeCustomSourceCategoryMutation, MergeCustomSourceCategoryMutationVariables>(
    MergeCustomSourceCategoryDocument,
    options,
  )
}
export type MergeCustomSourceCategoryMutationHookResult = ReturnType<typeof useMergeCustomSourceCategoryMutation>
export type MergeCustomSourceCategoryMutationResult = Apollo.MutationResult<MergeCustomSourceCategoryMutation>
export type MergeCustomSourceCategoryMutationOptions = Apollo.BaseMutationOptions<
  MergeCustomSourceCategoryMutation,
  MergeCustomSourceCategoryMutationVariables
>
export const DeleteCandidateSourceNameDocument = gql`
  mutation DeleteCandidateSourceName($input: DeleteCandidateSourceNameInput!) {
    DeleteCandidateSourceName(input: $input) {
      id
      name
      sourceCategory
      companyId
    }
  }
`
export type DeleteCandidateSourceNameMutationFn = Apollo.MutationFunction<
  DeleteCandidateSourceNameMutation,
  DeleteCandidateSourceNameMutationVariables
>

/**
 * __useDeleteCandidateSourceNameMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateSourceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateSourceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateSourceNameMutation, { data, loading, error }] = useDeleteCandidateSourceNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateSourceNameMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateSourceNameMutation,
    DeleteCandidateSourceNameMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateSourceNameMutation, DeleteCandidateSourceNameMutationVariables>(
    DeleteCandidateSourceNameDocument,
    options,
  )
}
export type DeleteCandidateSourceNameMutationHookResult = ReturnType<typeof useDeleteCandidateSourceNameMutation>
export type DeleteCandidateSourceNameMutationResult = Apollo.MutationResult<DeleteCandidateSourceNameMutation>
export type DeleteCandidateSourceNameMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateSourceNameMutation,
  DeleteCandidateSourceNameMutationVariables
>
export const EditCandidateSourceNameDocument = gql`
  mutation EditCandidateSourceName($input: EditCandidateSourceNameInput!) {
    EditCandidateSourceName(input: $input) {
      id
      name
      sourceCategory
      companyId
      customSourceCategory {
        id
        sourceCategoryName
      }
    }
  }
`
export type EditCandidateSourceNameMutationFn = Apollo.MutationFunction<
  EditCandidateSourceNameMutation,
  EditCandidateSourceNameMutationVariables
>

/**
 * __useEditCandidateSourceNameMutation__
 *
 * To run a mutation, you first call `useEditCandidateSourceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCandidateSourceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCandidateSourceNameMutation, { data, loading, error }] = useEditCandidateSourceNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCandidateSourceNameMutation(
  baseOptions?: Apollo.MutationHookOptions<EditCandidateSourceNameMutation, EditCandidateSourceNameMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCandidateSourceNameMutation, EditCandidateSourceNameMutationVariables>(
    EditCandidateSourceNameDocument,
    options,
  )
}
export type EditCandidateSourceNameMutationHookResult = ReturnType<typeof useEditCandidateSourceNameMutation>
export type EditCandidateSourceNameMutationResult = Apollo.MutationResult<EditCandidateSourceNameMutation>
export type EditCandidateSourceNameMutationOptions = Apollo.BaseMutationOptions<
  EditCandidateSourceNameMutation,
  EditCandidateSourceNameMutationVariables
>
export const MergeCandidateSourceNameDocument = gql`
  mutation MergeCandidateSourceName($input: MergeCandidateSourceNameInput!) {
    MergeCandidateSourceName(input: $input) {
      id
      name
      sourceCategory
      companyId
      customSourceCategory {
        id
        sourceCategoryName
      }
    }
  }
`
export type MergeCandidateSourceNameMutationFn = Apollo.MutationFunction<
  MergeCandidateSourceNameMutation,
  MergeCandidateSourceNameMutationVariables
>

/**
 * __useMergeCandidateSourceNameMutation__
 *
 * To run a mutation, you first call `useMergeCandidateSourceNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCandidateSourceNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCandidateSourceNameMutation, { data, loading, error }] = useMergeCandidateSourceNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeCandidateSourceNameMutation(
  baseOptions?: Apollo.MutationHookOptions<MergeCandidateSourceNameMutation, MergeCandidateSourceNameMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MergeCandidateSourceNameMutation, MergeCandidateSourceNameMutationVariables>(
    MergeCandidateSourceNameDocument,
    options,
  )
}
export type MergeCandidateSourceNameMutationHookResult = ReturnType<typeof useMergeCandidateSourceNameMutation>
export type MergeCandidateSourceNameMutationResult = Apollo.MutationResult<MergeCandidateSourceNameMutation>
export type MergeCandidateSourceNameMutationOptions = Apollo.BaseMutationOptions<
  MergeCandidateSourceNameMutation,
  MergeCandidateSourceNameMutationVariables
>
export const CreateCandidateTouchpointActivityLogDocument = gql`
  mutation CreateCandidateTouchpointActivityLog($input: CreateTouchpointActivityLogInput!) {
    CreateCandidateTouchpointActivityLog(input: $input) {
      id
      candidateProfileId
      candidateApplicationId
      companyCandidateTouchpointId
      activityTimestamp
      activity
      userAction
      isDeleted
      createdAt
      updatedAt
      companyUserId
      CandidateProfile {
        id
        primaryEmail
        ScalisUser {
          firstName
          lastName
        }
      }
      CandidateApplication {
        id
        applicationStatus
        appliedAt
      }
      CompanyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
    }
  }
`
export type CreateCandidateTouchpointActivityLogMutationFn = Apollo.MutationFunction<
  CreateCandidateTouchpointActivityLogMutation,
  CreateCandidateTouchpointActivityLogMutationVariables
>

/**
 * __useCreateCandidateTouchpointActivityLogMutation__
 *
 * To run a mutation, you first call `useCreateCandidateTouchpointActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateTouchpointActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateTouchpointActivityLogMutation, { data, loading, error }] = useCreateCandidateTouchpointActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateTouchpointActivityLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCandidateTouchpointActivityLogMutation,
    CreateCandidateTouchpointActivityLogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCandidateTouchpointActivityLogMutation,
    CreateCandidateTouchpointActivityLogMutationVariables
  >(CreateCandidateTouchpointActivityLogDocument, options)
}
export type CreateCandidateTouchpointActivityLogMutationHookResult = ReturnType<
  typeof useCreateCandidateTouchpointActivityLogMutation
>
export type CreateCandidateTouchpointActivityLogMutationResult =
  Apollo.MutationResult<CreateCandidateTouchpointActivityLogMutation>
export type CreateCandidateTouchpointActivityLogMutationOptions = Apollo.BaseMutationOptions<
  CreateCandidateTouchpointActivityLogMutation,
  CreateCandidateTouchpointActivityLogMutationVariables
>
export const CreateCompanyCandidateTouchpointDocument = gql`
  mutation CreateCompanyCandidateTouchpoint($input: CreateCompanyCandidateTouchpointInput!) {
    CreateCompanyCandidateTouchpoint(input: $input) {
      id
      name
      companyId
      companyUserId
      isDeleted
      createdAt
      updatedAt
    }
  }
`
export type CreateCompanyCandidateTouchpointMutationFn = Apollo.MutationFunction<
  CreateCompanyCandidateTouchpointMutation,
  CreateCompanyCandidateTouchpointMutationVariables
>

/**
 * __useCreateCompanyCandidateTouchpointMutation__
 *
 * To run a mutation, you first call `useCreateCompanyCandidateTouchpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyCandidateTouchpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyCandidateTouchpointMutation, { data, loading, error }] = useCreateCompanyCandidateTouchpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyCandidateTouchpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCompanyCandidateTouchpointMutation,
    CreateCompanyCandidateTouchpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCompanyCandidateTouchpointMutation,
    CreateCompanyCandidateTouchpointMutationVariables
  >(CreateCompanyCandidateTouchpointDocument, options)
}
export type CreateCompanyCandidateTouchpointMutationHookResult = ReturnType<
  typeof useCreateCompanyCandidateTouchpointMutation
>
export type CreateCompanyCandidateTouchpointMutationResult =
  Apollo.MutationResult<CreateCompanyCandidateTouchpointMutation>
export type CreateCompanyCandidateTouchpointMutationOptions = Apollo.BaseMutationOptions<
  CreateCompanyCandidateTouchpointMutation,
  CreateCompanyCandidateTouchpointMutationVariables
>
export const DeleteCandidateTouchpointActivityLogDocument = gql`
  mutation DeleteCandidateTouchpointActivityLog($input: DeleteCandidateTouchpointActivityLogInput!) {
    DeleteCandidateTouchpointActivityLog(input: $input)
  }
`
export type DeleteCandidateTouchpointActivityLogMutationFn = Apollo.MutationFunction<
  DeleteCandidateTouchpointActivityLogMutation,
  DeleteCandidateTouchpointActivityLogMutationVariables
>

/**
 * __useDeleteCandidateTouchpointActivityLogMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateTouchpointActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateTouchpointActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateTouchpointActivityLogMutation, { data, loading, error }] = useDeleteCandidateTouchpointActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateTouchpointActivityLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCandidateTouchpointActivityLogMutation,
    DeleteCandidateTouchpointActivityLogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCandidateTouchpointActivityLogMutation,
    DeleteCandidateTouchpointActivityLogMutationVariables
  >(DeleteCandidateTouchpointActivityLogDocument, options)
}
export type DeleteCandidateTouchpointActivityLogMutationHookResult = ReturnType<
  typeof useDeleteCandidateTouchpointActivityLogMutation
>
export type DeleteCandidateTouchpointActivityLogMutationResult =
  Apollo.MutationResult<DeleteCandidateTouchpointActivityLogMutation>
export type DeleteCandidateTouchpointActivityLogMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateTouchpointActivityLogMutation,
  DeleteCandidateTouchpointActivityLogMutationVariables
>
export const DeleteCompanyCandidateTouchpointDocument = gql`
  mutation DeleteCompanyCandidateTouchpoint($input: DeleteCompanyCandidateTouchpointInput!) {
    DeleteCompanyCandidateTouchpoint(input: $input) {
      id
      name
    }
  }
`
export type DeleteCompanyCandidateTouchpointMutationFn = Apollo.MutationFunction<
  DeleteCompanyCandidateTouchpointMutation,
  DeleteCompanyCandidateTouchpointMutationVariables
>

/**
 * __useDeleteCompanyCandidateTouchpointMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyCandidateTouchpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyCandidateTouchpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyCandidateTouchpointMutation, { data, loading, error }] = useDeleteCompanyCandidateTouchpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyCandidateTouchpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCompanyCandidateTouchpointMutation,
    DeleteCompanyCandidateTouchpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCompanyCandidateTouchpointMutation,
    DeleteCompanyCandidateTouchpointMutationVariables
  >(DeleteCompanyCandidateTouchpointDocument, options)
}
export type DeleteCompanyCandidateTouchpointMutationHookResult = ReturnType<
  typeof useDeleteCompanyCandidateTouchpointMutation
>
export type DeleteCompanyCandidateTouchpointMutationResult =
  Apollo.MutationResult<DeleteCompanyCandidateTouchpointMutation>
export type DeleteCompanyCandidateTouchpointMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyCandidateTouchpointMutation,
  DeleteCompanyCandidateTouchpointMutationVariables
>
export const EditCandidateTouchpointActivityLogDocument = gql`
  mutation EditCandidateTouchpointActivityLog($input: EditCandidateTouchpointActivityLogInput!) {
    EditCandidateTouchpointActivityLog(input: $input) {
      id
      candidateProfileId
      candidateApplicationId
      companyCandidateTouchpointId
      activityTimestamp
      activity
      userAction
      isDeleted
      createdAt
      updatedAt
      companyUserId
      CandidateProfile {
        id
        primaryEmail
        ScalisUser {
          firstName
          lastName
        }
      }
      CandidateApplication {
        id
        applicationStatus
        appliedAt
      }
      CompanyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
    }
  }
`
export type EditCandidateTouchpointActivityLogMutationFn = Apollo.MutationFunction<
  EditCandidateTouchpointActivityLogMutation,
  EditCandidateTouchpointActivityLogMutationVariables
>

/**
 * __useEditCandidateTouchpointActivityLogMutation__
 *
 * To run a mutation, you first call `useEditCandidateTouchpointActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCandidateTouchpointActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCandidateTouchpointActivityLogMutation, { data, loading, error }] = useEditCandidateTouchpointActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCandidateTouchpointActivityLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCandidateTouchpointActivityLogMutation,
    EditCandidateTouchpointActivityLogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    EditCandidateTouchpointActivityLogMutation,
    EditCandidateTouchpointActivityLogMutationVariables
  >(EditCandidateTouchpointActivityLogDocument, options)
}
export type EditCandidateTouchpointActivityLogMutationHookResult = ReturnType<
  typeof useEditCandidateTouchpointActivityLogMutation
>
export type EditCandidateTouchpointActivityLogMutationResult =
  Apollo.MutationResult<EditCandidateTouchpointActivityLogMutation>
export type EditCandidateTouchpointActivityLogMutationOptions = Apollo.BaseMutationOptions<
  EditCandidateTouchpointActivityLogMutation,
  EditCandidateTouchpointActivityLogMutationVariables
>
export const EditCompanyCandidateTouchpointDocument = gql`
  mutation EditCompanyCandidateTouchpoint($input: EditCompanyCandidateTouchpointInput!) {
    EditCompanyCandidateTouchpoint(input: $input) {
      id
      name
      companyId
      companyUserId
      isDeleted
      createdAt
      updatedAt
    }
  }
`
export type EditCompanyCandidateTouchpointMutationFn = Apollo.MutationFunction<
  EditCompanyCandidateTouchpointMutation,
  EditCompanyCandidateTouchpointMutationVariables
>

/**
 * __useEditCompanyCandidateTouchpointMutation__
 *
 * To run a mutation, you first call `useEditCompanyCandidateTouchpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyCandidateTouchpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyCandidateTouchpointMutation, { data, loading, error }] = useEditCompanyCandidateTouchpointMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyCandidateTouchpointMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCompanyCandidateTouchpointMutation,
    EditCompanyCandidateTouchpointMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCompanyCandidateTouchpointMutation, EditCompanyCandidateTouchpointMutationVariables>(
    EditCompanyCandidateTouchpointDocument,
    options,
  )
}
export type EditCompanyCandidateTouchpointMutationHookResult = ReturnType<
  typeof useEditCompanyCandidateTouchpointMutation
>
export type EditCompanyCandidateTouchpointMutationResult = Apollo.MutationResult<EditCompanyCandidateTouchpointMutation>
export type EditCompanyCandidateTouchpointMutationOptions = Apollo.BaseMutationOptions<
  EditCompanyCandidateTouchpointMutation,
  EditCompanyCandidateTouchpointMutationVariables
>
export const AddSavedViewDocument = gql`
  mutation AddSavedView($input: AddSavedViewInput!) {
    AddSavedView(input: $input)
  }
`
export type AddSavedViewMutationFn = Apollo.MutationFunction<AddSavedViewMutation, AddSavedViewMutationVariables>

/**
 * __useAddSavedViewMutation__
 *
 * To run a mutation, you first call `useAddSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSavedViewMutation, { data, loading, error }] = useAddSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSavedViewMutation(
  baseOptions?: Apollo.MutationHookOptions<AddSavedViewMutation, AddSavedViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddSavedViewMutation, AddSavedViewMutationVariables>(AddSavedViewDocument, options)
}
export type AddSavedViewMutationHookResult = ReturnType<typeof useAddSavedViewMutation>
export type AddSavedViewMutationResult = Apollo.MutationResult<AddSavedViewMutation>
export type AddSavedViewMutationOptions = Apollo.BaseMutationOptions<
  AddSavedViewMutation,
  AddSavedViewMutationVariables
>
export const CreateSavedViewDocument = gql`
  mutation CreateSavedView($input: CreateSavedViewInput!) {
    CreateSavedView(input: $input) {
      companyUserView {
        ...CompanyUserView
      }
      requisitionTalentPoolSavedView {
        ...RequisitionTalentPoolCompanySavedView
      }
      savedView {
        ...CompanySavedView
      }
    }
  }
  ${CompanyUserViewFragmentDoc}
  ${RequisitionTalentPoolCompanySavedViewFragmentDoc}
  ${CompanySavedViewFragmentDoc}
`
export type CreateSavedViewMutationFn = Apollo.MutationFunction<
  CreateSavedViewMutation,
  CreateSavedViewMutationVariables
>

/**
 * __useCreateSavedViewMutation__
 *
 * To run a mutation, you first call `useCreateSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedViewMutation, { data, loading, error }] = useCreateSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedViewMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSavedViewMutation, CreateSavedViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSavedViewMutation, CreateSavedViewMutationVariables>(CreateSavedViewDocument, options)
}
export type CreateSavedViewMutationHookResult = ReturnType<typeof useCreateSavedViewMutation>
export type CreateSavedViewMutationResult = Apollo.MutationResult<CreateSavedViewMutation>
export type CreateSavedViewMutationOptions = Apollo.BaseMutationOptions<
  CreateSavedViewMutation,
  CreateSavedViewMutationVariables
>
export const DeleteSavedViewDocument = gql`
  mutation DeleteSavedView($input: DeleteSavedViewInput!) {
    DeleteSavedView(input: $input) {
      message
      success
    }
  }
`
export type DeleteSavedViewMutationFn = Apollo.MutationFunction<
  DeleteSavedViewMutation,
  DeleteSavedViewMutationVariables
>

/**
 * __useDeleteSavedViewMutation__
 *
 * To run a mutation, you first call `useDeleteSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedViewMutation, { data, loading, error }] = useDeleteSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSavedViewMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSavedViewMutation, DeleteSavedViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSavedViewMutation, DeleteSavedViewMutationVariables>(DeleteSavedViewDocument, options)
}
export type DeleteSavedViewMutationHookResult = ReturnType<typeof useDeleteSavedViewMutation>
export type DeleteSavedViewMutationResult = Apollo.MutationResult<DeleteSavedViewMutation>
export type DeleteSavedViewMutationOptions = Apollo.BaseMutationOptions<
  DeleteSavedViewMutation,
  DeleteSavedViewMutationVariables
>
export const EditCompanyUserViewOrderDocument = gql`
  mutation EditCompanyUserViewOrder($input: EditCompanyUserViewOrderInput!) {
    EditCompanyUserViewOrder(input: $input) {
      ...CompanyUserView
    }
  }
  ${CompanyUserViewFragmentDoc}
`
export type EditCompanyUserViewOrderMutationFn = Apollo.MutationFunction<
  EditCompanyUserViewOrderMutation,
  EditCompanyUserViewOrderMutationVariables
>

/**
 * __useEditCompanyUserViewOrderMutation__
 *
 * To run a mutation, you first call `useEditCompanyUserViewOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyUserViewOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyUserViewOrderMutation, { data, loading, error }] = useEditCompanyUserViewOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCompanyUserViewOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<EditCompanyUserViewOrderMutation, EditCompanyUserViewOrderMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCompanyUserViewOrderMutation, EditCompanyUserViewOrderMutationVariables>(
    EditCompanyUserViewOrderDocument,
    options,
  )
}
export type EditCompanyUserViewOrderMutationHookResult = ReturnType<typeof useEditCompanyUserViewOrderMutation>
export type EditCompanyUserViewOrderMutationResult = Apollo.MutationResult<EditCompanyUserViewOrderMutation>
export type EditCompanyUserViewOrderMutationOptions = Apollo.BaseMutationOptions<
  EditCompanyUserViewOrderMutation,
  EditCompanyUserViewOrderMutationVariables
>
export const EditSavedViewDocument = gql`
  mutation EditSavedView($input: EditSavedViewInput!) {
    EditSavedView(input: $input) {
      companyUserViews {
        ...CompanyUserView
      }
      companySavedView {
        ...CompanySavedView
      }
    }
  }
  ${CompanyUserViewFragmentDoc}
  ${CompanySavedViewFragmentDoc}
`
export type EditSavedViewMutationFn = Apollo.MutationFunction<EditSavedViewMutation, EditSavedViewMutationVariables>

/**
 * __useEditSavedViewMutation__
 *
 * To run a mutation, you first call `useEditSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSavedViewMutation, { data, loading, error }] = useEditSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSavedViewMutation(
  baseOptions?: Apollo.MutationHookOptions<EditSavedViewMutation, EditSavedViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditSavedViewMutation, EditSavedViewMutationVariables>(EditSavedViewDocument, options)
}
export type EditSavedViewMutationHookResult = ReturnType<typeof useEditSavedViewMutation>
export type EditSavedViewMutationResult = Apollo.MutationResult<EditSavedViewMutation>
export type EditSavedViewMutationOptions = Apollo.BaseMutationOptions<
  EditSavedViewMutation,
  EditSavedViewMutationVariables
>
export const PinSavedViewDocument = gql`
  mutation PinSavedView($input: PinSavedViewInput!) {
    PinSavedView(input: $input) {
      ...RequisitionTalentPoolCompanySavedView
    }
  }
  ${RequisitionTalentPoolCompanySavedViewFragmentDoc}
`
export type PinSavedViewMutationFn = Apollo.MutationFunction<PinSavedViewMutation, PinSavedViewMutationVariables>

/**
 * __usePinSavedViewMutation__
 *
 * To run a mutation, you first call `usePinSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePinSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pinSavedViewMutation, { data, loading, error }] = usePinSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePinSavedViewMutation(
  baseOptions?: Apollo.MutationHookOptions<PinSavedViewMutation, PinSavedViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<PinSavedViewMutation, PinSavedViewMutationVariables>(PinSavedViewDocument, options)
}
export type PinSavedViewMutationHookResult = ReturnType<typeof usePinSavedViewMutation>
export type PinSavedViewMutationResult = Apollo.MutationResult<PinSavedViewMutation>
export type PinSavedViewMutationOptions = Apollo.BaseMutationOptions<
  PinSavedViewMutation,
  PinSavedViewMutationVariables
>
export const RemoveSavedViewDocument = gql`
  mutation RemoveSavedView($input: RemoveSavedViewInput!) {
    RemoveSavedView(input: $input) {
      message
      success
    }
  }
`
export type RemoveSavedViewMutationFn = Apollo.MutationFunction<
  RemoveSavedViewMutation,
  RemoveSavedViewMutationVariables
>

/**
 * __useRemoveSavedViewMutation__
 *
 * To run a mutation, you first call `useRemoveSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSavedViewMutation, { data, loading, error }] = useRemoveSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSavedViewMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveSavedViewMutation, RemoveSavedViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<RemoveSavedViewMutation, RemoveSavedViewMutationVariables>(RemoveSavedViewDocument, options)
}
export type RemoveSavedViewMutationHookResult = ReturnType<typeof useRemoveSavedViewMutation>
export type RemoveSavedViewMutationResult = Apollo.MutationResult<RemoveSavedViewMutation>
export type RemoveSavedViewMutationOptions = Apollo.BaseMutationOptions<
  RemoveSavedViewMutation,
  RemoveSavedViewMutationVariables
>
export const UnpinSavedViewDocument = gql`
  mutation UnpinSavedView($input: UnpinSavedViewInput!) {
    UnpinSavedView(input: $input) {
      ...RequisitionTalentPoolCompanySavedView
    }
  }
  ${RequisitionTalentPoolCompanySavedViewFragmentDoc}
`
export type UnpinSavedViewMutationFn = Apollo.MutationFunction<UnpinSavedViewMutation, UnpinSavedViewMutationVariables>

/**
 * __useUnpinSavedViewMutation__
 *
 * To run a mutation, you first call `useUnpinSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinSavedViewMutation, { data, loading, error }] = useUnpinSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnpinSavedViewMutation(
  baseOptions?: Apollo.MutationHookOptions<UnpinSavedViewMutation, UnpinSavedViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UnpinSavedViewMutation, UnpinSavedViewMutationVariables>(UnpinSavedViewDocument, options)
}
export type UnpinSavedViewMutationHookResult = ReturnType<typeof useUnpinSavedViewMutation>
export type UnpinSavedViewMutationResult = Apollo.MutationResult<UnpinSavedViewMutation>
export type UnpinSavedViewMutationOptions = Apollo.BaseMutationOptions<
  UnpinSavedViewMutation,
  UnpinSavedViewMutationVariables
>
export const UpdateCompanyUserViewOrderDocument = gql`
  mutation UpdateCompanyUserViewOrder($input: UpdateCompanyUserViewOrderInput!) {
    UpdateCompanyUserViewOrder(input: $input)
  }
`
export type UpdateCompanyUserViewOrderMutationFn = Apollo.MutationFunction<
  UpdateCompanyUserViewOrderMutation,
  UpdateCompanyUserViewOrderMutationVariables
>

/**
 * __useUpdateCompanyUserViewOrderMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserViewOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserViewOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserViewOrderMutation, { data, loading, error }] = useUpdateCompanyUserViewOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyUserViewOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCompanyUserViewOrderMutation,
    UpdateCompanyUserViewOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCompanyUserViewOrderMutation, UpdateCompanyUserViewOrderMutationVariables>(
    UpdateCompanyUserViewOrderDocument,
    options,
  )
}
export type UpdateCompanyUserViewOrderMutationHookResult = ReturnType<typeof useUpdateCompanyUserViewOrderMutation>
export type UpdateCompanyUserViewOrderMutationResult = Apollo.MutationResult<UpdateCompanyUserViewOrderMutation>
export type UpdateCompanyUserViewOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateCompanyUserViewOrderMutation,
  UpdateCompanyUserViewOrderMutationVariables
>
export const CreateCompanyUserGroupDocument = gql`
  mutation CreateCompanyUserGroup($input: CreateCompanyUserGroupInput!) {
    CreateCompanyUserGroup(input: $input) {
      id
      name
      createdAt
      updatedAt
      deleted
      createdBy {
        id
        profileImage
        UserInvitation {
          ScalisUser {
            ...ScalisUser
            EmailVerification {
              emailAddress
            }
          }
        }
      }
      Offices {
        CompanyOffice {
          id
          officeName
          externalId
        }
      }
      Departments {
        CompanyDepartment {
          id
          departmentName
          externalId
        }
      }
      Members {
        CompanyUser {
          id
          profileImage
          UserInvitation {
            ScalisUser {
              ...ScalisUser
              EmailVerification {
                emailAddress
              }
            }
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`
export type CreateCompanyUserGroupMutationFn = Apollo.MutationFunction<
  CreateCompanyUserGroupMutation,
  CreateCompanyUserGroupMutationVariables
>

/**
 * __useCreateCompanyUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateCompanyUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyUserGroupMutation, { data, loading, error }] = useCreateCompanyUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCompanyUserGroupMutation, CreateCompanyUserGroupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCompanyUserGroupMutation, CreateCompanyUserGroupMutationVariables>(
    CreateCompanyUserGroupDocument,
    options,
  )
}
export type CreateCompanyUserGroupMutationHookResult = ReturnType<typeof useCreateCompanyUserGroupMutation>
export type CreateCompanyUserGroupMutationResult = Apollo.MutationResult<CreateCompanyUserGroupMutation>
export type CreateCompanyUserGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateCompanyUserGroupMutation,
  CreateCompanyUserGroupMutationVariables
>
export const CreateUsersInCompanyUserGroupDocument = gql`
  mutation CreateUsersInCompanyUserGroup($input: CreateUsersInCompanyUserGroupInput!) {
    CreateUsersInCompanyUserGroup(input: $input) {
      id
      name
      createdAt
      updatedAt
      deleted
      Members {
        CompanyUser {
          id
          profileImage
          UserInvitation {
            ScalisUser {
              ...ScalisUser
              EmailVerification {
                emailAddress
              }
            }
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`
export type CreateUsersInCompanyUserGroupMutationFn = Apollo.MutationFunction<
  CreateUsersInCompanyUserGroupMutation,
  CreateUsersInCompanyUserGroupMutationVariables
>

/**
 * __useCreateUsersInCompanyUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUsersInCompanyUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUsersInCompanyUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUsersInCompanyUserGroupMutation, { data, loading, error }] = useCreateUsersInCompanyUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUsersInCompanyUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUsersInCompanyUserGroupMutation,
    CreateUsersInCompanyUserGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateUsersInCompanyUserGroupMutation, CreateUsersInCompanyUserGroupMutationVariables>(
    CreateUsersInCompanyUserGroupDocument,
    options,
  )
}
export type CreateUsersInCompanyUserGroupMutationHookResult = ReturnType<
  typeof useCreateUsersInCompanyUserGroupMutation
>
export type CreateUsersInCompanyUserGroupMutationResult = Apollo.MutationResult<CreateUsersInCompanyUserGroupMutation>
export type CreateUsersInCompanyUserGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateUsersInCompanyUserGroupMutation,
  CreateUsersInCompanyUserGroupMutationVariables
>
export const DeleteCompanyUserGroupDocument = gql`
  mutation DeleteCompanyUserGroup($input: DeleteCompanyUserGroupInput!) {
    DeleteCompanyUserGroup(input: $input) {
      id
      name
      createdAt
      updatedAt
      deleted
    }
  }
`
export type DeleteCompanyUserGroupMutationFn = Apollo.MutationFunction<
  DeleteCompanyUserGroupMutation,
  DeleteCompanyUserGroupMutationVariables
>

/**
 * __useDeleteCompanyUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyUserGroupMutation, { data, loading, error }] = useDeleteCompanyUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCompanyUserGroupMutation, DeleteCompanyUserGroupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCompanyUserGroupMutation, DeleteCompanyUserGroupMutationVariables>(
    DeleteCompanyUserGroupDocument,
    options,
  )
}
export type DeleteCompanyUserGroupMutationHookResult = ReturnType<typeof useDeleteCompanyUserGroupMutation>
export type DeleteCompanyUserGroupMutationResult = Apollo.MutationResult<DeleteCompanyUserGroupMutation>
export type DeleteCompanyUserGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyUserGroupMutation,
  DeleteCompanyUserGroupMutationVariables
>
export const DeleteUsersFromCompanyUserGroupDocument = gql`
  mutation DeleteUsersFromCompanyUserGroup($input: DeleteUsersFromCompanyUserGroupInput!) {
    DeleteUsersFromCompanyUserGroup(input: $input) {
      id
      name
      createdAt
      updatedAt
      deleted
      Members {
        CompanyUser {
          id
          profileImage
          UserInvitation {
            ScalisUser {
              ...ScalisUser
              EmailVerification {
                emailAddress
              }
            }
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`
export type DeleteUsersFromCompanyUserGroupMutationFn = Apollo.MutationFunction<
  DeleteUsersFromCompanyUserGroupMutation,
  DeleteUsersFromCompanyUserGroupMutationVariables
>

/**
 * __useDeleteUsersFromCompanyUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUsersFromCompanyUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUsersFromCompanyUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUsersFromCompanyUserGroupMutation, { data, loading, error }] = useDeleteUsersFromCompanyUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUsersFromCompanyUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUsersFromCompanyUserGroupMutation,
    DeleteUsersFromCompanyUserGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteUsersFromCompanyUserGroupMutation, DeleteUsersFromCompanyUserGroupMutationVariables>(
    DeleteUsersFromCompanyUserGroupDocument,
    options,
  )
}
export type DeleteUsersFromCompanyUserGroupMutationHookResult = ReturnType<
  typeof useDeleteUsersFromCompanyUserGroupMutation
>
export type DeleteUsersFromCompanyUserGroupMutationResult =
  Apollo.MutationResult<DeleteUsersFromCompanyUserGroupMutation>
export type DeleteUsersFromCompanyUserGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteUsersFromCompanyUserGroupMutation,
  DeleteUsersFromCompanyUserGroupMutationVariables
>
export const UpdateCompanyUserGroupDocument = gql`
  mutation UpdateCompanyUserGroup($input: UpdateCompanyUserGroupInput!) {
    UpdateCompanyUserGroup(input: $input) {
      id
      name
      createdAt
      updatedAt
      deleted
      Members {
        CompanyUser {
          id
          profileImage
          UserInvitation {
            ScalisUser {
              ...ScalisUser
              EmailVerification {
                emailAddress
              }
            }
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`
export type UpdateCompanyUserGroupMutationFn = Apollo.MutationFunction<
  UpdateCompanyUserGroupMutation,
  UpdateCompanyUserGroupMutationVariables
>

/**
 * __useUpdateCompanyUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserGroupMutation, { data, loading, error }] = useUpdateCompanyUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCompanyUserGroupMutation, UpdateCompanyUserGroupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCompanyUserGroupMutation, UpdateCompanyUserGroupMutationVariables>(
    UpdateCompanyUserGroupDocument,
    options,
  )
}
export type UpdateCompanyUserGroupMutationHookResult = ReturnType<typeof useUpdateCompanyUserGroupMutation>
export type UpdateCompanyUserGroupMutationResult = Apollo.MutationResult<UpdateCompanyUserGroupMutation>
export type UpdateCompanyUserGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateCompanyUserGroupMutation,
  UpdateCompanyUserGroupMutationVariables
>
export const UpdateUsersInCompanyUserGroupDocument = gql`
  mutation UpdateUsersInCompanyUserGroup($input: UpdateUsersInCompanyUserGroupInput!) {
    UpdateUsersInCompanyUserGroup(input: $input) {
      id
      name
      createdAt
      updatedAt
      deleted
      Members {
        CompanyUser {
          id
          profileImage
          UserInvitation {
            ScalisUser {
              ...ScalisUser
              EmailVerification {
                emailAddress
              }
            }
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`
export type UpdateUsersInCompanyUserGroupMutationFn = Apollo.MutationFunction<
  UpdateUsersInCompanyUserGroupMutation,
  UpdateUsersInCompanyUserGroupMutationVariables
>

/**
 * __useUpdateUsersInCompanyUserGroupMutation__
 *
 * To run a mutation, you first call `useUpdateUsersInCompanyUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersInCompanyUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersInCompanyUserGroupMutation, { data, loading, error }] = useUpdateUsersInCompanyUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUsersInCompanyUserGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUsersInCompanyUserGroupMutation,
    UpdateUsersInCompanyUserGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUsersInCompanyUserGroupMutation, UpdateUsersInCompanyUserGroupMutationVariables>(
    UpdateUsersInCompanyUserGroupDocument,
    options,
  )
}
export type UpdateUsersInCompanyUserGroupMutationHookResult = ReturnType<
  typeof useUpdateUsersInCompanyUserGroupMutation
>
export type UpdateUsersInCompanyUserGroupMutationResult = Apollo.MutationResult<UpdateUsersInCompanyUserGroupMutation>
export type UpdateUsersInCompanyUserGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateUsersInCompanyUserGroupMutation,
  UpdateUsersInCompanyUserGroupMutationVariables
>
export const ActivateCompanyUserDocument = gql`
  mutation ActivateCompanyUser($input: ActivateCompanyUserInput!) {
    ActivateCompanyUser(input: $input) {
      id
    }
  }
`
export type ActivateCompanyUserMutationFn = Apollo.MutationFunction<
  ActivateCompanyUserMutation,
  ActivateCompanyUserMutationVariables
>

/**
 * __useActivateCompanyUserMutation__
 *
 * To run a mutation, you first call `useActivateCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCompanyUserMutation, { data, loading, error }] = useActivateCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateCompanyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<ActivateCompanyUserMutation, ActivateCompanyUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ActivateCompanyUserMutation, ActivateCompanyUserMutationVariables>(
    ActivateCompanyUserDocument,
    options,
  )
}
export type ActivateCompanyUserMutationHookResult = ReturnType<typeof useActivateCompanyUserMutation>
export type ActivateCompanyUserMutationResult = Apollo.MutationResult<ActivateCompanyUserMutation>
export type ActivateCompanyUserMutationOptions = Apollo.BaseMutationOptions<
  ActivateCompanyUserMutation,
  ActivateCompanyUserMutationVariables
>
export const CreateCompanyUserFromInvitationDocument = gql`
  mutation CreateCompanyUserFromInvitation($input: CreateCompanyUserFromInvitationInput!) {
    CreateCompanyUserFromInvitation(input: $input) {
      id
    }
  }
`
export type CreateCompanyUserFromInvitationMutationFn = Apollo.MutationFunction<
  CreateCompanyUserFromInvitationMutation,
  CreateCompanyUserFromInvitationMutationVariables
>

/**
 * __useCreateCompanyUserFromInvitationMutation__
 *
 * To run a mutation, you first call `useCreateCompanyUserFromInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyUserFromInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyUserFromInvitationMutation, { data, loading, error }] = useCreateCompanyUserFromInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyUserFromInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCompanyUserFromInvitationMutation,
    CreateCompanyUserFromInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCompanyUserFromInvitationMutation, CreateCompanyUserFromInvitationMutationVariables>(
    CreateCompanyUserFromInvitationDocument,
    options,
  )
}
export type CreateCompanyUserFromInvitationMutationHookResult = ReturnType<
  typeof useCreateCompanyUserFromInvitationMutation
>
export type CreateCompanyUserFromInvitationMutationResult =
  Apollo.MutationResult<CreateCompanyUserFromInvitationMutation>
export type CreateCompanyUserFromInvitationMutationOptions = Apollo.BaseMutationOptions<
  CreateCompanyUserFromInvitationMutation,
  CreateCompanyUserFromInvitationMutationVariables
>
export const DeleteCompanyUserFromWorkspaceDocument = gql`
  mutation DeleteCompanyUserFromWorkspace($input: DeleteCompanyUserFromWorkspaceInput!) {
    DeleteCompanyUserFromWorkspace(input: $input) {
      id
    }
  }
`
export type DeleteCompanyUserFromWorkspaceMutationFn = Apollo.MutationFunction<
  DeleteCompanyUserFromWorkspaceMutation,
  DeleteCompanyUserFromWorkspaceMutationVariables
>

/**
 * __useDeleteCompanyUserFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyUserFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyUserFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyUserFromWorkspaceMutation, { data, loading, error }] = useDeleteCompanyUserFromWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyUserFromWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCompanyUserFromWorkspaceMutation,
    DeleteCompanyUserFromWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCompanyUserFromWorkspaceMutation, DeleteCompanyUserFromWorkspaceMutationVariables>(
    DeleteCompanyUserFromWorkspaceDocument,
    options,
  )
}
export type DeleteCompanyUserFromWorkspaceMutationHookResult = ReturnType<
  typeof useDeleteCompanyUserFromWorkspaceMutation
>
export type DeleteCompanyUserFromWorkspaceMutationResult = Apollo.MutationResult<DeleteCompanyUserFromWorkspaceMutation>
export type DeleteCompanyUserFromWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyUserFromWorkspaceMutation,
  DeleteCompanyUserFromWorkspaceMutationVariables
>
export const DeleteInvitationFromWorkspaceDocument = gql`
  mutation DeleteInvitationFromWorkspace($input: DeleteInvitationFromWorkspaceInput!) {
    DeleteInvitationFromWorkspace(input: $input) {
      id
    }
  }
`
export type DeleteInvitationFromWorkspaceMutationFn = Apollo.MutationFunction<
  DeleteInvitationFromWorkspaceMutation,
  DeleteInvitationFromWorkspaceMutationVariables
>

/**
 * __useDeleteInvitationFromWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteInvitationFromWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitationFromWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationFromWorkspaceMutation, { data, loading, error }] = useDeleteInvitationFromWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvitationFromWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInvitationFromWorkspaceMutation,
    DeleteInvitationFromWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteInvitationFromWorkspaceMutation, DeleteInvitationFromWorkspaceMutationVariables>(
    DeleteInvitationFromWorkspaceDocument,
    options,
  )
}
export type DeleteInvitationFromWorkspaceMutationHookResult = ReturnType<
  typeof useDeleteInvitationFromWorkspaceMutation
>
export type DeleteInvitationFromWorkspaceMutationResult = Apollo.MutationResult<DeleteInvitationFromWorkspaceMutation>
export type DeleteInvitationFromWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  DeleteInvitationFromWorkspaceMutation,
  DeleteInvitationFromWorkspaceMutationVariables
>
export const InviteUserDocument = gql`
  mutation InviteUser($input: InviteUserInput!) {
    InviteUser(input: $input) {
      id
    }
  }
`
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options)
}
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>
export const UpdateCompanyUserRoleDocument = gql`
  mutation UpdateCompanyUserRole($input: UpdateCompanyUserRoleInput!) {
    UpdateCompanyUserRole(input: $input) {
      id
    }
  }
`
export type UpdateCompanyUserRoleMutationFn = Apollo.MutationFunction<
  UpdateCompanyUserRoleMutation,
  UpdateCompanyUserRoleMutationVariables
>

/**
 * __useUpdateCompanyUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserRoleMutation, { data, loading, error }] = useUpdateCompanyUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyUserRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCompanyUserRoleMutation, UpdateCompanyUserRoleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCompanyUserRoleMutation, UpdateCompanyUserRoleMutationVariables>(
    UpdateCompanyUserRoleDocument,
    options,
  )
}
export type UpdateCompanyUserRoleMutationHookResult = ReturnType<typeof useUpdateCompanyUserRoleMutation>
export type UpdateCompanyUserRoleMutationResult = Apollo.MutationResult<UpdateCompanyUserRoleMutation>
export type UpdateCompanyUserRoleMutationOptions = Apollo.BaseMutationOptions<
  UpdateCompanyUserRoleMutation,
  UpdateCompanyUserRoleMutationVariables
>
export const CreateCompanyDocument = gql`
  mutation CreateCompany($input: CreateCompanyInput!) {
    CreateCompany(input: $input) {
      __typename
      id
    }
  }
`
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options)
}
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<
  CreateCompanyMutation,
  CreateCompanyMutationVariables
>
export const DeleteCompanyDepartmentDocument = gql`
  mutation DeleteCompanyDepartment($input: DeleteCompanyDepartmentInput!) {
    DeleteCompanyDepartment(input: $input) {
      __typename
      id
    }
  }
`
export type DeleteCompanyDepartmentMutationFn = Apollo.MutationFunction<
  DeleteCompanyDepartmentMutation,
  DeleteCompanyDepartmentMutationVariables
>

/**
 * __useDeleteCompanyDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyDepartmentMutation, { data, loading, error }] = useDeleteCompanyDepartmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCompanyDepartmentMutation, DeleteCompanyDepartmentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCompanyDepartmentMutation, DeleteCompanyDepartmentMutationVariables>(
    DeleteCompanyDepartmentDocument,
    options,
  )
}
export type DeleteCompanyDepartmentMutationHookResult = ReturnType<typeof useDeleteCompanyDepartmentMutation>
export type DeleteCompanyDepartmentMutationResult = Apollo.MutationResult<DeleteCompanyDepartmentMutation>
export type DeleteCompanyDepartmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyDepartmentMutation,
  DeleteCompanyDepartmentMutationVariables
>
export const DeleteCompanyOfficeDocument = gql`
  mutation DeleteCompanyOffice($input: DeleteCompanyOfficeInput!) {
    DeleteCompanyOffice(input: $input) {
      __typename
      id
    }
  }
`
export type DeleteCompanyOfficeMutationFn = Apollo.MutationFunction<
  DeleteCompanyOfficeMutation,
  DeleteCompanyOfficeMutationVariables
>

/**
 * __useDeleteCompanyOfficeMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyOfficeMutation, { data, loading, error }] = useDeleteCompanyOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyOfficeMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCompanyOfficeMutation, DeleteCompanyOfficeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCompanyOfficeMutation, DeleteCompanyOfficeMutationVariables>(
    DeleteCompanyOfficeDocument,
    options,
  )
}
export type DeleteCompanyOfficeMutationHookResult = ReturnType<typeof useDeleteCompanyOfficeMutation>
export type DeleteCompanyOfficeMutationResult = Apollo.MutationResult<DeleteCompanyOfficeMutation>
export type DeleteCompanyOfficeMutationOptions = Apollo.BaseMutationOptions<
  DeleteCompanyOfficeMutation,
  DeleteCompanyOfficeMutationVariables
>
export const UpdateCompanyDocument = gql`
  mutation UpdateCompany($input: UpdateCompanyDataInput!) {
    UpdateCompanyData(input: $input) {
      __typename
      id
    }
  }
`
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options)
}
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables
>
export const DisconnectConnectedEmailDocument = gql`
  mutation DisconnectConnectedEmail($input: DisconnectConnectedEmailInput!) {
    DisconnectConnectedEmail(input: $input) {
      success
    }
  }
`
export type DisconnectConnectedEmailMutationFn = Apollo.MutationFunction<
  DisconnectConnectedEmailMutation,
  DisconnectConnectedEmailMutationVariables
>

/**
 * __useDisconnectConnectedEmailMutation__
 *
 * To run a mutation, you first call `useDisconnectConnectedEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectConnectedEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectConnectedEmailMutation, { data, loading, error }] = useDisconnectConnectedEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectConnectedEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<DisconnectConnectedEmailMutation, DisconnectConnectedEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DisconnectConnectedEmailMutation, DisconnectConnectedEmailMutationVariables>(
    DisconnectConnectedEmailDocument,
    options,
  )
}
export type DisconnectConnectedEmailMutationHookResult = ReturnType<typeof useDisconnectConnectedEmailMutation>
export type DisconnectConnectedEmailMutationResult = Apollo.MutationResult<DisconnectConnectedEmailMutation>
export type DisconnectConnectedEmailMutationOptions = Apollo.BaseMutationOptions<
  DisconnectConnectedEmailMutation,
  DisconnectConnectedEmailMutationVariables
>
export const ExchangeConnectedEmailTokenDocument = gql`
  mutation ExchangeConnectedEmailToken($input: ExchangeConnectedEmailTokenInput!) {
    ExchangeConnectedEmailToken(input: $input) {
      id
      email
      provider
      createdAt
      updatedAt
    }
  }
`
export type ExchangeConnectedEmailTokenMutationFn = Apollo.MutationFunction<
  ExchangeConnectedEmailTokenMutation,
  ExchangeConnectedEmailTokenMutationVariables
>

/**
 * __useExchangeConnectedEmailTokenMutation__
 *
 * To run a mutation, you first call `useExchangeConnectedEmailTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeConnectedEmailTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeConnectedEmailTokenMutation, { data, loading, error }] = useExchangeConnectedEmailTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExchangeConnectedEmailTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExchangeConnectedEmailTokenMutation,
    ExchangeConnectedEmailTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ExchangeConnectedEmailTokenMutation, ExchangeConnectedEmailTokenMutationVariables>(
    ExchangeConnectedEmailTokenDocument,
    options,
  )
}
export type ExchangeConnectedEmailTokenMutationHookResult = ReturnType<typeof useExchangeConnectedEmailTokenMutation>
export type ExchangeConnectedEmailTokenMutationResult = Apollo.MutationResult<ExchangeConnectedEmailTokenMutation>
export type ExchangeConnectedEmailTokenMutationOptions = Apollo.BaseMutationOptions<
  ExchangeConnectedEmailTokenMutation,
  ExchangeConnectedEmailTokenMutationVariables
>
export const GetConnectedEmailAuthUrlDocument = gql`
  mutation GetConnectedEmailAuthUrl($input: GetConnectedEmailAuthUrlInput!) {
    GetConnectedEmailAuthUrl(input: $input) {
      authUrl
    }
  }
`
export type GetConnectedEmailAuthUrlMutationFn = Apollo.MutationFunction<
  GetConnectedEmailAuthUrlMutation,
  GetConnectedEmailAuthUrlMutationVariables
>

/**
 * __useGetConnectedEmailAuthUrlMutation__
 *
 * To run a mutation, you first call `useGetConnectedEmailAuthUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedEmailAuthUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getConnectedEmailAuthUrlMutation, { data, loading, error }] = useGetConnectedEmailAuthUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetConnectedEmailAuthUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<GetConnectedEmailAuthUrlMutation, GetConnectedEmailAuthUrlMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GetConnectedEmailAuthUrlMutation, GetConnectedEmailAuthUrlMutationVariables>(
    GetConnectedEmailAuthUrlDocument,
    options,
  )
}
export type GetConnectedEmailAuthUrlMutationHookResult = ReturnType<typeof useGetConnectedEmailAuthUrlMutation>
export type GetConnectedEmailAuthUrlMutationResult = Apollo.MutationResult<GetConnectedEmailAuthUrlMutation>
export type GetConnectedEmailAuthUrlMutationOptions = Apollo.BaseMutationOptions<
  GetConnectedEmailAuthUrlMutation,
  GetConnectedEmailAuthUrlMutationVariables
>
export const UpdateConnectedEmailSettingsDocument = gql`
  mutation UpdateConnectedEmailSettings($input: UpdateConnectedEmailSettingsInput!) {
    UpdateConnectedEmailSettings(input: $input) {
      ...ConnectedEmailSettings
    }
  }
  ${ConnectedEmailSettingsFragmentDoc}
`
export type UpdateConnectedEmailSettingsMutationFn = Apollo.MutationFunction<
  UpdateConnectedEmailSettingsMutation,
  UpdateConnectedEmailSettingsMutationVariables
>

/**
 * __useUpdateConnectedEmailSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateConnectedEmailSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectedEmailSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectedEmailSettingsMutation, { data, loading, error }] = useUpdateConnectedEmailSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConnectedEmailSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateConnectedEmailSettingsMutation,
    UpdateConnectedEmailSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateConnectedEmailSettingsMutation, UpdateConnectedEmailSettingsMutationVariables>(
    UpdateConnectedEmailSettingsDocument,
    options,
  )
}
export type UpdateConnectedEmailSettingsMutationHookResult = ReturnType<typeof useUpdateConnectedEmailSettingsMutation>
export type UpdateConnectedEmailSettingsMutationResult = Apollo.MutationResult<UpdateConnectedEmailSettingsMutation>
export type UpdateConnectedEmailSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateConnectedEmailSettingsMutation,
  UpdateConnectedEmailSettingsMutationVariables
>
export const CreateCustomApplicationStatusDocument = gql`
  mutation CreateCustomApplicationStatus($input: CreateCustomApplicationStatusInput!) {
    CreateCustomApplicationStatus(input: $input) {
      id
      applicationStatusName
      colorHexCode
      iconUnicode
      iconType
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      _count
    }
  }
`
export type CreateCustomApplicationStatusMutationFn = Apollo.MutationFunction<
  CreateCustomApplicationStatusMutation,
  CreateCustomApplicationStatusMutationVariables
>

/**
 * __useCreateCustomApplicationStatusMutation__
 *
 * To run a mutation, you first call `useCreateCustomApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomApplicationStatusMutation, { data, loading, error }] = useCreateCustomApplicationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomApplicationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomApplicationStatusMutation,
    CreateCustomApplicationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCustomApplicationStatusMutation, CreateCustomApplicationStatusMutationVariables>(
    CreateCustomApplicationStatusDocument,
    options,
  )
}
export type CreateCustomApplicationStatusMutationHookResult = ReturnType<
  typeof useCreateCustomApplicationStatusMutation
>
export type CreateCustomApplicationStatusMutationResult = Apollo.MutationResult<CreateCustomApplicationStatusMutation>
export type CreateCustomApplicationStatusMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomApplicationStatusMutation,
  CreateCustomApplicationStatusMutationVariables
>
export const DeleteCustomApplicationStatusDocument = gql`
  mutation DeleteCustomApplicationStatus($input: DeleteCustomApplicationStatusInput!) {
    DeleteCustomApplicationStatus(input: $input) {
      success
      message
    }
  }
`
export type DeleteCustomApplicationStatusMutationFn = Apollo.MutationFunction<
  DeleteCustomApplicationStatusMutation,
  DeleteCustomApplicationStatusMutationVariables
>

/**
 * __useDeleteCustomApplicationStatusMutation__
 *
 * To run a mutation, you first call `useDeleteCustomApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomApplicationStatusMutation, { data, loading, error }] = useDeleteCustomApplicationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomApplicationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomApplicationStatusMutation,
    DeleteCustomApplicationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCustomApplicationStatusMutation, DeleteCustomApplicationStatusMutationVariables>(
    DeleteCustomApplicationStatusDocument,
    options,
  )
}
export type DeleteCustomApplicationStatusMutationHookResult = ReturnType<
  typeof useDeleteCustomApplicationStatusMutation
>
export type DeleteCustomApplicationStatusMutationResult = Apollo.MutationResult<DeleteCustomApplicationStatusMutation>
export type DeleteCustomApplicationStatusMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomApplicationStatusMutation,
  DeleteCustomApplicationStatusMutationVariables
>
export const EditCustomApplicationStatusDocument = gql`
  mutation EditCustomApplicationStatus($input: EditCustomApplicationStatusInput!) {
    EditCustomApplicationStatus(input: $input) {
      id
      applicationStatusName
      colorHexCode
      iconUnicode
      iconType
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      _count
    }
  }
`
export type EditCustomApplicationStatusMutationFn = Apollo.MutationFunction<
  EditCustomApplicationStatusMutation,
  EditCustomApplicationStatusMutationVariables
>

/**
 * __useEditCustomApplicationStatusMutation__
 *
 * To run a mutation, you first call `useEditCustomApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomApplicationStatusMutation, { data, loading, error }] = useEditCustomApplicationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCustomApplicationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCustomApplicationStatusMutation,
    EditCustomApplicationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCustomApplicationStatusMutation, EditCustomApplicationStatusMutationVariables>(
    EditCustomApplicationStatusDocument,
    options,
  )
}
export type EditCustomApplicationStatusMutationHookResult = ReturnType<typeof useEditCustomApplicationStatusMutation>
export type EditCustomApplicationStatusMutationResult = Apollo.MutationResult<EditCustomApplicationStatusMutation>
export type EditCustomApplicationStatusMutationOptions = Apollo.BaseMutationOptions<
  EditCustomApplicationStatusMutation,
  EditCustomApplicationStatusMutationVariables
>
export const MergeCustomApplicationStatusDocument = gql`
  mutation MergeCustomApplicationStatus($input: MergeCustomApplicationStatusInput!) {
    MergeCustomApplicationStatus(input: $input) {
      id
      applicationStatusName
      colorHexCode
      iconUnicode
      iconType
      companyId
      companyUserId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      _count
    }
  }
`
export type MergeCustomApplicationStatusMutationFn = Apollo.MutationFunction<
  MergeCustomApplicationStatusMutation,
  MergeCustomApplicationStatusMutationVariables
>

/**
 * __useMergeCustomApplicationStatusMutation__
 *
 * To run a mutation, you first call `useMergeCustomApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCustomApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCustomApplicationStatusMutation, { data, loading, error }] = useMergeCustomApplicationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeCustomApplicationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MergeCustomApplicationStatusMutation,
    MergeCustomApplicationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MergeCustomApplicationStatusMutation, MergeCustomApplicationStatusMutationVariables>(
    MergeCustomApplicationStatusDocument,
    options,
  )
}
export type MergeCustomApplicationStatusMutationHookResult = ReturnType<typeof useMergeCustomApplicationStatusMutation>
export type MergeCustomApplicationStatusMutationResult = Apollo.MutationResult<MergeCustomApplicationStatusMutation>
export type MergeCustomApplicationStatusMutationOptions = Apollo.BaseMutationOptions<
  MergeCustomApplicationStatusMutation,
  MergeCustomApplicationStatusMutationVariables
>
export const AssociateCustomFieldWithRequisitionDocument = gql`
  mutation AssociateCustomFieldWithRequisition($input: AssociateCustomFieldWithRequisitionInput!) {
    AssociateCustomFieldWithRequisition(input: $input) {
      message
      success
    }
  }
`
export type AssociateCustomFieldWithRequisitionMutationFn = Apollo.MutationFunction<
  AssociateCustomFieldWithRequisitionMutation,
  AssociateCustomFieldWithRequisitionMutationVariables
>

/**
 * __useAssociateCustomFieldWithRequisitionMutation__
 *
 * To run a mutation, you first call `useAssociateCustomFieldWithRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateCustomFieldWithRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateCustomFieldWithRequisitionMutation, { data, loading, error }] = useAssociateCustomFieldWithRequisitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateCustomFieldWithRequisitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssociateCustomFieldWithRequisitionMutation,
    AssociateCustomFieldWithRequisitionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AssociateCustomFieldWithRequisitionMutation,
    AssociateCustomFieldWithRequisitionMutationVariables
  >(AssociateCustomFieldWithRequisitionDocument, options)
}
export type AssociateCustomFieldWithRequisitionMutationHookResult = ReturnType<
  typeof useAssociateCustomFieldWithRequisitionMutation
>
export type AssociateCustomFieldWithRequisitionMutationResult =
  Apollo.MutationResult<AssociateCustomFieldWithRequisitionMutation>
export type AssociateCustomFieldWithRequisitionMutationOptions = Apollo.BaseMutationOptions<
  AssociateCustomFieldWithRequisitionMutation,
  AssociateCustomFieldWithRequisitionMutationVariables
>
export const ArchiveCustomCandidateApplicationFieldDocument = gql`
  mutation ArchiveCustomCandidateApplicationField($input: ArchiveCustomCandidateApplicationFieldInput!) {
    ArchiveCustomCandidateApplicationField(input: $input) {
      ...CustomCandidateApplicationField
    }
  }
  ${CustomCandidateApplicationFieldFragmentDoc}
`
export type ArchiveCustomCandidateApplicationFieldMutationFn = Apollo.MutationFunction<
  ArchiveCustomCandidateApplicationFieldMutation,
  ArchiveCustomCandidateApplicationFieldMutationVariables
>

/**
 * __useArchiveCustomCandidateApplicationFieldMutation__
 *
 * To run a mutation, you first call `useArchiveCustomCandidateApplicationFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomCandidateApplicationFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomCandidateApplicationFieldMutation, { data, loading, error }] = useArchiveCustomCandidateApplicationFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCustomCandidateApplicationFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveCustomCandidateApplicationFieldMutation,
    ArchiveCustomCandidateApplicationFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ArchiveCustomCandidateApplicationFieldMutation,
    ArchiveCustomCandidateApplicationFieldMutationVariables
  >(ArchiveCustomCandidateApplicationFieldDocument, options)
}
export type ArchiveCustomCandidateApplicationFieldMutationHookResult = ReturnType<
  typeof useArchiveCustomCandidateApplicationFieldMutation
>
export type ArchiveCustomCandidateApplicationFieldMutationResult =
  Apollo.MutationResult<ArchiveCustomCandidateApplicationFieldMutation>
export type ArchiveCustomCandidateApplicationFieldMutationOptions = Apollo.BaseMutationOptions<
  ArchiveCustomCandidateApplicationFieldMutation,
  ArchiveCustomCandidateApplicationFieldMutationVariables
>
export const CreateCustomCandidateApplicationFieldDocument = gql`
  mutation CreateCustomCandidateApplicationField($input: CreateCustomCandidateApplicationFieldInput!) {
    CreateCustomCandidateApplicationField(input: $input) {
      ...CustomCandidateApplicationFieldOutput
    }
  }
  ${CustomCandidateApplicationFieldOutputFragmentDoc}
`
export type CreateCustomCandidateApplicationFieldMutationFn = Apollo.MutationFunction<
  CreateCustomCandidateApplicationFieldMutation,
  CreateCustomCandidateApplicationFieldMutationVariables
>

/**
 * __useCreateCustomCandidateApplicationFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomCandidateApplicationFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomCandidateApplicationFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomCandidateApplicationFieldMutation, { data, loading, error }] = useCreateCustomCandidateApplicationFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomCandidateApplicationFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomCandidateApplicationFieldMutation,
    CreateCustomCandidateApplicationFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCustomCandidateApplicationFieldMutation,
    CreateCustomCandidateApplicationFieldMutationVariables
  >(CreateCustomCandidateApplicationFieldDocument, options)
}
export type CreateCustomCandidateApplicationFieldMutationHookResult = ReturnType<
  typeof useCreateCustomCandidateApplicationFieldMutation
>
export type CreateCustomCandidateApplicationFieldMutationResult =
  Apollo.MutationResult<CreateCustomCandidateApplicationFieldMutation>
export type CreateCustomCandidateApplicationFieldMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomCandidateApplicationFieldMutation,
  CreateCustomCandidateApplicationFieldMutationVariables
>
export const DeleteCustomCandidateApplicationFieldDocument = gql`
  mutation DeleteCustomCandidateApplicationField($input: DeleteCustomCandidateApplicationFieldInput!) {
    DeleteCustomCandidateApplicationField(input: $input) {
      success
      message
    }
  }
`
export type DeleteCustomCandidateApplicationFieldMutationFn = Apollo.MutationFunction<
  DeleteCustomCandidateApplicationFieldMutation,
  DeleteCustomCandidateApplicationFieldMutationVariables
>

/**
 * __useDeleteCustomCandidateApplicationFieldMutation__
 *
 * To run a mutation, you first call `useDeleteCustomCandidateApplicationFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomCandidateApplicationFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomCandidateApplicationFieldMutation, { data, loading, error }] = useDeleteCustomCandidateApplicationFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomCandidateApplicationFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomCandidateApplicationFieldMutation,
    DeleteCustomCandidateApplicationFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCustomCandidateApplicationFieldMutation,
    DeleteCustomCandidateApplicationFieldMutationVariables
  >(DeleteCustomCandidateApplicationFieldDocument, options)
}
export type DeleteCustomCandidateApplicationFieldMutationHookResult = ReturnType<
  typeof useDeleteCustomCandidateApplicationFieldMutation
>
export type DeleteCustomCandidateApplicationFieldMutationResult =
  Apollo.MutationResult<DeleteCustomCandidateApplicationFieldMutation>
export type DeleteCustomCandidateApplicationFieldMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomCandidateApplicationFieldMutation,
  DeleteCustomCandidateApplicationFieldMutationVariables
>
export const EditCustomCandidateApplicationFieldDocument = gql`
  mutation EditCustomCandidateApplicationField($input: EditCustomCandidateApplicationFieldInput!) {
    EditCustomCandidateApplicationField(input: $input) {
      ...CustomCandidateApplicationFieldOutput
    }
  }
  ${CustomCandidateApplicationFieldOutputFragmentDoc}
`
export type EditCustomCandidateApplicationFieldMutationFn = Apollo.MutationFunction<
  EditCustomCandidateApplicationFieldMutation,
  EditCustomCandidateApplicationFieldMutationVariables
>

/**
 * __useEditCustomCandidateApplicationFieldMutation__
 *
 * To run a mutation, you first call `useEditCustomCandidateApplicationFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomCandidateApplicationFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomCandidateApplicationFieldMutation, { data, loading, error }] = useEditCustomCandidateApplicationFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCustomCandidateApplicationFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCustomCandidateApplicationFieldMutation,
    EditCustomCandidateApplicationFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    EditCustomCandidateApplicationFieldMutation,
    EditCustomCandidateApplicationFieldMutationVariables
  >(EditCustomCandidateApplicationFieldDocument, options)
}
export type EditCustomCandidateApplicationFieldMutationHookResult = ReturnType<
  typeof useEditCustomCandidateApplicationFieldMutation
>
export type EditCustomCandidateApplicationFieldMutationResult =
  Apollo.MutationResult<EditCustomCandidateApplicationFieldMutation>
export type EditCustomCandidateApplicationFieldMutationOptions = Apollo.BaseMutationOptions<
  EditCustomCandidateApplicationFieldMutation,
  EditCustomCandidateApplicationFieldMutationVariables
>
export const UnarchiveCustomCandidateApplicationFieldDocument = gql`
  mutation UnarchiveCustomCandidateApplicationField($input: UnarchiveCustomCandidateApplicationFieldInput!) {
    UnarchiveCustomCandidateApplicationField(input: $input) {
      ...CustomCandidateApplicationField
    }
  }
  ${CustomCandidateApplicationFieldFragmentDoc}
`
export type UnarchiveCustomCandidateApplicationFieldMutationFn = Apollo.MutationFunction<
  UnarchiveCustomCandidateApplicationFieldMutation,
  UnarchiveCustomCandidateApplicationFieldMutationVariables
>

/**
 * __useUnarchiveCustomCandidateApplicationFieldMutation__
 *
 * To run a mutation, you first call `useUnarchiveCustomCandidateApplicationFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveCustomCandidateApplicationFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveCustomCandidateApplicationFieldMutation, { data, loading, error }] = useUnarchiveCustomCandidateApplicationFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveCustomCandidateApplicationFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveCustomCandidateApplicationFieldMutation,
    UnarchiveCustomCandidateApplicationFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnarchiveCustomCandidateApplicationFieldMutation,
    UnarchiveCustomCandidateApplicationFieldMutationVariables
  >(UnarchiveCustomCandidateApplicationFieldDocument, options)
}
export type UnarchiveCustomCandidateApplicationFieldMutationHookResult = ReturnType<
  typeof useUnarchiveCustomCandidateApplicationFieldMutation
>
export type UnarchiveCustomCandidateApplicationFieldMutationResult =
  Apollo.MutationResult<UnarchiveCustomCandidateApplicationFieldMutation>
export type UnarchiveCustomCandidateApplicationFieldMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveCustomCandidateApplicationFieldMutation,
  UnarchiveCustomCandidateApplicationFieldMutationVariables
>
export const ArchiveCustomCandidateProfileFieldDocument = gql`
  mutation ArchiveCustomCandidateProfileField($input: ArchiveCustomCandidateProfileFieldInput!) {
    ArchiveCustomCandidateProfileField(input: $input) {
      ...CustomCandidateProfileField
    }
  }
  ${CustomCandidateProfileFieldFragmentDoc}
`
export type ArchiveCustomCandidateProfileFieldMutationFn = Apollo.MutationFunction<
  ArchiveCustomCandidateProfileFieldMutation,
  ArchiveCustomCandidateProfileFieldMutationVariables
>

/**
 * __useArchiveCustomCandidateProfileFieldMutation__
 *
 * To run a mutation, you first call `useArchiveCustomCandidateProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomCandidateProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomCandidateProfileFieldMutation, { data, loading, error }] = useArchiveCustomCandidateProfileFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCustomCandidateProfileFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveCustomCandidateProfileFieldMutation,
    ArchiveCustomCandidateProfileFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ArchiveCustomCandidateProfileFieldMutation,
    ArchiveCustomCandidateProfileFieldMutationVariables
  >(ArchiveCustomCandidateProfileFieldDocument, options)
}
export type ArchiveCustomCandidateProfileFieldMutationHookResult = ReturnType<
  typeof useArchiveCustomCandidateProfileFieldMutation
>
export type ArchiveCustomCandidateProfileFieldMutationResult =
  Apollo.MutationResult<ArchiveCustomCandidateProfileFieldMutation>
export type ArchiveCustomCandidateProfileFieldMutationOptions = Apollo.BaseMutationOptions<
  ArchiveCustomCandidateProfileFieldMutation,
  ArchiveCustomCandidateProfileFieldMutationVariables
>
export const CreateCustomCandidateProfileFieldDocument = gql`
  mutation CreateCustomCandidateProfileField($input: CreateCustomCandidateProfileFieldInput!) {
    CreateCustomCandidateProfileField(input: $input) {
      ...CustomCandidateProfileFieldOutput
    }
  }
  ${CustomCandidateProfileFieldOutputFragmentDoc}
`
export type CreateCustomCandidateProfileFieldMutationFn = Apollo.MutationFunction<
  CreateCustomCandidateProfileFieldMutation,
  CreateCustomCandidateProfileFieldMutationVariables
>

/**
 * __useCreateCustomCandidateProfileFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomCandidateProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomCandidateProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomCandidateProfileFieldMutation, { data, loading, error }] = useCreateCustomCandidateProfileFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomCandidateProfileFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomCandidateProfileFieldMutation,
    CreateCustomCandidateProfileFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCustomCandidateProfileFieldMutation,
    CreateCustomCandidateProfileFieldMutationVariables
  >(CreateCustomCandidateProfileFieldDocument, options)
}
export type CreateCustomCandidateProfileFieldMutationHookResult = ReturnType<
  typeof useCreateCustomCandidateProfileFieldMutation
>
export type CreateCustomCandidateProfileFieldMutationResult =
  Apollo.MutationResult<CreateCustomCandidateProfileFieldMutation>
export type CreateCustomCandidateProfileFieldMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomCandidateProfileFieldMutation,
  CreateCustomCandidateProfileFieldMutationVariables
>
export const DeleteCustomCandidateProfileFieldDocument = gql`
  mutation DeleteCustomCandidateProfileField($input: DeleteCustomCandidateProfileFieldInput!) {
    DeleteCustomCandidateProfileField(input: $input) {
      success
      message
    }
  }
`
export type DeleteCustomCandidateProfileFieldMutationFn = Apollo.MutationFunction<
  DeleteCustomCandidateProfileFieldMutation,
  DeleteCustomCandidateProfileFieldMutationVariables
>

/**
 * __useDeleteCustomCandidateProfileFieldMutation__
 *
 * To run a mutation, you first call `useDeleteCustomCandidateProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomCandidateProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomCandidateProfileFieldMutation, { data, loading, error }] = useDeleteCustomCandidateProfileFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomCandidateProfileFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomCandidateProfileFieldMutation,
    DeleteCustomCandidateProfileFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCustomCandidateProfileFieldMutation,
    DeleteCustomCandidateProfileFieldMutationVariables
  >(DeleteCustomCandidateProfileFieldDocument, options)
}
export type DeleteCustomCandidateProfileFieldMutationHookResult = ReturnType<
  typeof useDeleteCustomCandidateProfileFieldMutation
>
export type DeleteCustomCandidateProfileFieldMutationResult =
  Apollo.MutationResult<DeleteCustomCandidateProfileFieldMutation>
export type DeleteCustomCandidateProfileFieldMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomCandidateProfileFieldMutation,
  DeleteCustomCandidateProfileFieldMutationVariables
>
export const EditCustomCandidateProfileFieldDocument = gql`
  mutation EditCustomCandidateProfileField($input: EditCustomCandidateProfileFieldInput!) {
    EditCustomCandidateProfileField(input: $input) {
      ...CustomCandidateProfileFieldOutput
    }
  }
  ${CustomCandidateProfileFieldOutputFragmentDoc}
`
export type EditCustomCandidateProfileFieldMutationFn = Apollo.MutationFunction<
  EditCustomCandidateProfileFieldMutation,
  EditCustomCandidateProfileFieldMutationVariables
>

/**
 * __useEditCustomCandidateProfileFieldMutation__
 *
 * To run a mutation, you first call `useEditCustomCandidateProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomCandidateProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomCandidateProfileFieldMutation, { data, loading, error }] = useEditCustomCandidateProfileFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCustomCandidateProfileFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCustomCandidateProfileFieldMutation,
    EditCustomCandidateProfileFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCustomCandidateProfileFieldMutation, EditCustomCandidateProfileFieldMutationVariables>(
    EditCustomCandidateProfileFieldDocument,
    options,
  )
}
export type EditCustomCandidateProfileFieldMutationHookResult = ReturnType<
  typeof useEditCustomCandidateProfileFieldMutation
>
export type EditCustomCandidateProfileFieldMutationResult =
  Apollo.MutationResult<EditCustomCandidateProfileFieldMutation>
export type EditCustomCandidateProfileFieldMutationOptions = Apollo.BaseMutationOptions<
  EditCustomCandidateProfileFieldMutation,
  EditCustomCandidateProfileFieldMutationVariables
>
export const UnarchiveCustomCandidateProfileFieldDocument = gql`
  mutation UnarchiveCustomCandidateProfileField($input: UnarchiveCustomCandidateProfileFieldInput!) {
    UnarchiveCustomCandidateProfileField(input: $input) {
      ...CustomCandidateProfileField
    }
  }
  ${CustomCandidateProfileFieldFragmentDoc}
`
export type UnarchiveCustomCandidateProfileFieldMutationFn = Apollo.MutationFunction<
  UnarchiveCustomCandidateProfileFieldMutation,
  UnarchiveCustomCandidateProfileFieldMutationVariables
>

/**
 * __useUnarchiveCustomCandidateProfileFieldMutation__
 *
 * To run a mutation, you first call `useUnarchiveCustomCandidateProfileFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveCustomCandidateProfileFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveCustomCandidateProfileFieldMutation, { data, loading, error }] = useUnarchiveCustomCandidateProfileFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveCustomCandidateProfileFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveCustomCandidateProfileFieldMutation,
    UnarchiveCustomCandidateProfileFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnarchiveCustomCandidateProfileFieldMutation,
    UnarchiveCustomCandidateProfileFieldMutationVariables
  >(UnarchiveCustomCandidateProfileFieldDocument, options)
}
export type UnarchiveCustomCandidateProfileFieldMutationHookResult = ReturnType<
  typeof useUnarchiveCustomCandidateProfileFieldMutation
>
export type UnarchiveCustomCandidateProfileFieldMutationResult =
  Apollo.MutationResult<UnarchiveCustomCandidateProfileFieldMutation>
export type UnarchiveCustomCandidateProfileFieldMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveCustomCandidateProfileFieldMutation,
  UnarchiveCustomCandidateProfileFieldMutationVariables
>
export const CreateCustomCandidateApplicationFieldValueDocument = gql`
  mutation CreateCustomCandidateApplicationFieldValue($input: CreateCustomCandidateApplicationFieldValueInput!) {
    CreateCustomCandidateApplicationFieldValue(input: $input) {
      ...CustomCandidateApplicationFieldValue
    }
  }
  ${CustomCandidateApplicationFieldValueFragmentDoc}
`
export type CreateCustomCandidateApplicationFieldValueMutationFn = Apollo.MutationFunction<
  CreateCustomCandidateApplicationFieldValueMutation,
  CreateCustomCandidateApplicationFieldValueMutationVariables
>

/**
 * __useCreateCustomCandidateApplicationFieldValueMutation__
 *
 * To run a mutation, you first call `useCreateCustomCandidateApplicationFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomCandidateApplicationFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomCandidateApplicationFieldValueMutation, { data, loading, error }] = useCreateCustomCandidateApplicationFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomCandidateApplicationFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomCandidateApplicationFieldValueMutation,
    CreateCustomCandidateApplicationFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCustomCandidateApplicationFieldValueMutation,
    CreateCustomCandidateApplicationFieldValueMutationVariables
  >(CreateCustomCandidateApplicationFieldValueDocument, options)
}
export type CreateCustomCandidateApplicationFieldValueMutationHookResult = ReturnType<
  typeof useCreateCustomCandidateApplicationFieldValueMutation
>
export type CreateCustomCandidateApplicationFieldValueMutationResult =
  Apollo.MutationResult<CreateCustomCandidateApplicationFieldValueMutation>
export type CreateCustomCandidateApplicationFieldValueMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomCandidateApplicationFieldValueMutation,
  CreateCustomCandidateApplicationFieldValueMutationVariables
>
export const CreateCustomCandidateProfileFieldValueDocument = gql`
  mutation CreateCustomCandidateProfileFieldValue($input: CreateCustomCandidateProfileFieldValueInput!) {
    CreateCustomCandidateProfileFieldValue(input: $input) {
      ...CustomCandidateProfileFieldValue
    }
  }
  ${CustomCandidateProfileFieldValueFragmentDoc}
`
export type CreateCustomCandidateProfileFieldValueMutationFn = Apollo.MutationFunction<
  CreateCustomCandidateProfileFieldValueMutation,
  CreateCustomCandidateProfileFieldValueMutationVariables
>

/**
 * __useCreateCustomCandidateProfileFieldValueMutation__
 *
 * To run a mutation, you first call `useCreateCustomCandidateProfileFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomCandidateProfileFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomCandidateProfileFieldValueMutation, { data, loading, error }] = useCreateCustomCandidateProfileFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomCandidateProfileFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomCandidateProfileFieldValueMutation,
    CreateCustomCandidateProfileFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCustomCandidateProfileFieldValueMutation,
    CreateCustomCandidateProfileFieldValueMutationVariables
  >(CreateCustomCandidateProfileFieldValueDocument, options)
}
export type CreateCustomCandidateProfileFieldValueMutationHookResult = ReturnType<
  typeof useCreateCustomCandidateProfileFieldValueMutation
>
export type CreateCustomCandidateProfileFieldValueMutationResult =
  Apollo.MutationResult<CreateCustomCandidateProfileFieldValueMutation>
export type CreateCustomCandidateProfileFieldValueMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomCandidateProfileFieldValueMutation,
  CreateCustomCandidateProfileFieldValueMutationVariables
>
export const DeleteCustomCandidateApplicationFieldValueDocument = gql`
  mutation DeleteCustomCandidateApplicationFieldValue($input: DeleteCustomCandidateApplicationFieldValueInput!) {
    DeleteCustomCandidateApplicationFieldValue(input: $input) {
      success
      message
    }
  }
`
export type DeleteCustomCandidateApplicationFieldValueMutationFn = Apollo.MutationFunction<
  DeleteCustomCandidateApplicationFieldValueMutation,
  DeleteCustomCandidateApplicationFieldValueMutationVariables
>

/**
 * __useDeleteCustomCandidateApplicationFieldValueMutation__
 *
 * To run a mutation, you first call `useDeleteCustomCandidateApplicationFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomCandidateApplicationFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomCandidateApplicationFieldValueMutation, { data, loading, error }] = useDeleteCustomCandidateApplicationFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomCandidateApplicationFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomCandidateApplicationFieldValueMutation,
    DeleteCustomCandidateApplicationFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCustomCandidateApplicationFieldValueMutation,
    DeleteCustomCandidateApplicationFieldValueMutationVariables
  >(DeleteCustomCandidateApplicationFieldValueDocument, options)
}
export type DeleteCustomCandidateApplicationFieldValueMutationHookResult = ReturnType<
  typeof useDeleteCustomCandidateApplicationFieldValueMutation
>
export type DeleteCustomCandidateApplicationFieldValueMutationResult =
  Apollo.MutationResult<DeleteCustomCandidateApplicationFieldValueMutation>
export type DeleteCustomCandidateApplicationFieldValueMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomCandidateApplicationFieldValueMutation,
  DeleteCustomCandidateApplicationFieldValueMutationVariables
>
export const DeleteCustomCandidateProfileFieldValueDocument = gql`
  mutation DeleteCustomCandidateProfileFieldValue($input: DeleteCustomCandidateProfileFieldValueInput!) {
    DeleteCustomCandidateProfileFieldValue(input: $input) {
      message
      success
    }
  }
`
export type DeleteCustomCandidateProfileFieldValueMutationFn = Apollo.MutationFunction<
  DeleteCustomCandidateProfileFieldValueMutation,
  DeleteCustomCandidateProfileFieldValueMutationVariables
>

/**
 * __useDeleteCustomCandidateProfileFieldValueMutation__
 *
 * To run a mutation, you first call `useDeleteCustomCandidateProfileFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomCandidateProfileFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomCandidateProfileFieldValueMutation, { data, loading, error }] = useDeleteCustomCandidateProfileFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomCandidateProfileFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomCandidateProfileFieldValueMutation,
    DeleteCustomCandidateProfileFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCustomCandidateProfileFieldValueMutation,
    DeleteCustomCandidateProfileFieldValueMutationVariables
  >(DeleteCustomCandidateProfileFieldValueDocument, options)
}
export type DeleteCustomCandidateProfileFieldValueMutationHookResult = ReturnType<
  typeof useDeleteCustomCandidateProfileFieldValueMutation
>
export type DeleteCustomCandidateProfileFieldValueMutationResult =
  Apollo.MutationResult<DeleteCustomCandidateProfileFieldValueMutation>
export type DeleteCustomCandidateProfileFieldValueMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomCandidateProfileFieldValueMutation,
  DeleteCustomCandidateProfileFieldValueMutationVariables
>
export const ArchiveCustomJobRequisitionFieldDocument = gql`
  mutation ArchiveCustomJobRequisitionField($input: ArchiveCustomJobRequisitionFieldInput!) {
    ArchiveCustomJobRequisitionField(input: $input) {
      ...CustomJobRequisitionField
    }
  }
  ${CustomJobRequisitionFieldFragmentDoc}
`
export type ArchiveCustomJobRequisitionFieldMutationFn = Apollo.MutationFunction<
  ArchiveCustomJobRequisitionFieldMutation,
  ArchiveCustomJobRequisitionFieldMutationVariables
>

/**
 * __useArchiveCustomJobRequisitionFieldMutation__
 *
 * To run a mutation, you first call `useArchiveCustomJobRequisitionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomJobRequisitionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomJobRequisitionFieldMutation, { data, loading, error }] = useArchiveCustomJobRequisitionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCustomJobRequisitionFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveCustomJobRequisitionFieldMutation,
    ArchiveCustomJobRequisitionFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ArchiveCustomJobRequisitionFieldMutation,
    ArchiveCustomJobRequisitionFieldMutationVariables
  >(ArchiveCustomJobRequisitionFieldDocument, options)
}
export type ArchiveCustomJobRequisitionFieldMutationHookResult = ReturnType<
  typeof useArchiveCustomJobRequisitionFieldMutation
>
export type ArchiveCustomJobRequisitionFieldMutationResult =
  Apollo.MutationResult<ArchiveCustomJobRequisitionFieldMutation>
export type ArchiveCustomJobRequisitionFieldMutationOptions = Apollo.BaseMutationOptions<
  ArchiveCustomJobRequisitionFieldMutation,
  ArchiveCustomJobRequisitionFieldMutationVariables
>
export const CreateCustomJobRequisitionFieldValueDocument = gql`
  mutation CreateCustomJobRequisitionFieldValue($input: CreateCustomJobRequisitionFieldValueInput!) {
    CreateCustomJobRequisitionFieldValue(input: $input) {
      id
      requisitionId
      customJobRequisitionFieldId
      value
      companyUserId
      createdAt
      updatedAt
    }
  }
`
export type CreateCustomJobRequisitionFieldValueMutationFn = Apollo.MutationFunction<
  CreateCustomJobRequisitionFieldValueMutation,
  CreateCustomJobRequisitionFieldValueMutationVariables
>

/**
 * __useCreateCustomJobRequisitionFieldValueMutation__
 *
 * To run a mutation, you first call `useCreateCustomJobRequisitionFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomJobRequisitionFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomJobRequisitionFieldValueMutation, { data, loading, error }] = useCreateCustomJobRequisitionFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomJobRequisitionFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomJobRequisitionFieldValueMutation,
    CreateCustomJobRequisitionFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCustomJobRequisitionFieldValueMutation,
    CreateCustomJobRequisitionFieldValueMutationVariables
  >(CreateCustomJobRequisitionFieldValueDocument, options)
}
export type CreateCustomJobRequisitionFieldValueMutationHookResult = ReturnType<
  typeof useCreateCustomJobRequisitionFieldValueMutation
>
export type CreateCustomJobRequisitionFieldValueMutationResult =
  Apollo.MutationResult<CreateCustomJobRequisitionFieldValueMutation>
export type CreateCustomJobRequisitionFieldValueMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomJobRequisitionFieldValueMutation,
  CreateCustomJobRequisitionFieldValueMutationVariables
>
export const CreateCustomJobRequisitionFieldDocument = gql`
  mutation CreateCustomJobRequisitionField($input: CreateCustomJobRequisitionFieldInput!) {
    CreateCustomJobRequisitionField(input: $input) {
      ...CustomJobRequisitionFieldOutput
    }
  }
  ${CustomJobRequisitionFieldOutputFragmentDoc}
`
export type CreateCustomJobRequisitionFieldMutationFn = Apollo.MutationFunction<
  CreateCustomJobRequisitionFieldMutation,
  CreateCustomJobRequisitionFieldMutationVariables
>

/**
 * __useCreateCustomJobRequisitionFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomJobRequisitionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomJobRequisitionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomJobRequisitionFieldMutation, { data, loading, error }] = useCreateCustomJobRequisitionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomJobRequisitionFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomJobRequisitionFieldMutation,
    CreateCustomJobRequisitionFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCustomJobRequisitionFieldMutation, CreateCustomJobRequisitionFieldMutationVariables>(
    CreateCustomJobRequisitionFieldDocument,
    options,
  )
}
export type CreateCustomJobRequisitionFieldMutationHookResult = ReturnType<
  typeof useCreateCustomJobRequisitionFieldMutation
>
export type CreateCustomJobRequisitionFieldMutationResult =
  Apollo.MutationResult<CreateCustomJobRequisitionFieldMutation>
export type CreateCustomJobRequisitionFieldMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomJobRequisitionFieldMutation,
  CreateCustomJobRequisitionFieldMutationVariables
>
export const DeleteCustomJobRequisitionFieldDocument = gql`
  mutation DeleteCustomJobRequisitionField($input: DeleteCustomJobRequisitionFieldInput!) {
    DeleteCustomJobRequisitionField(input: $input) {
      success
      message
    }
  }
`
export type DeleteCustomJobRequisitionFieldMutationFn = Apollo.MutationFunction<
  DeleteCustomJobRequisitionFieldMutation,
  DeleteCustomJobRequisitionFieldMutationVariables
>

/**
 * __useDeleteCustomJobRequisitionFieldMutation__
 *
 * To run a mutation, you first call `useDeleteCustomJobRequisitionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomJobRequisitionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomJobRequisitionFieldMutation, { data, loading, error }] = useDeleteCustomJobRequisitionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomJobRequisitionFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCustomJobRequisitionFieldMutation,
    DeleteCustomJobRequisitionFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCustomJobRequisitionFieldMutation, DeleteCustomJobRequisitionFieldMutationVariables>(
    DeleteCustomJobRequisitionFieldDocument,
    options,
  )
}
export type DeleteCustomJobRequisitionFieldMutationHookResult = ReturnType<
  typeof useDeleteCustomJobRequisitionFieldMutation
>
export type DeleteCustomJobRequisitionFieldMutationResult =
  Apollo.MutationResult<DeleteCustomJobRequisitionFieldMutation>
export type DeleteCustomJobRequisitionFieldMutationOptions = Apollo.BaseMutationOptions<
  DeleteCustomJobRequisitionFieldMutation,
  DeleteCustomJobRequisitionFieldMutationVariables
>
export const EditCustomJobRequisitionFieldValueDocument = gql`
  mutation EditCustomJobRequisitionFieldValue($input: EditCustomJobRequisitionFieldValueInput!) {
    EditCustomJobRequisitionFieldValue(input: $input) {
      id
      requisitionId
      customJobRequisitionFieldId
      value
      companyUserId
      createdAt
      updatedAt
    }
  }
`
export type EditCustomJobRequisitionFieldValueMutationFn = Apollo.MutationFunction<
  EditCustomJobRequisitionFieldValueMutation,
  EditCustomJobRequisitionFieldValueMutationVariables
>

/**
 * __useEditCustomJobRequisitionFieldValueMutation__
 *
 * To run a mutation, you first call `useEditCustomJobRequisitionFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomJobRequisitionFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomJobRequisitionFieldValueMutation, { data, loading, error }] = useEditCustomJobRequisitionFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCustomJobRequisitionFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCustomJobRequisitionFieldValueMutation,
    EditCustomJobRequisitionFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    EditCustomJobRequisitionFieldValueMutation,
    EditCustomJobRequisitionFieldValueMutationVariables
  >(EditCustomJobRequisitionFieldValueDocument, options)
}
export type EditCustomJobRequisitionFieldValueMutationHookResult = ReturnType<
  typeof useEditCustomJobRequisitionFieldValueMutation
>
export type EditCustomJobRequisitionFieldValueMutationResult =
  Apollo.MutationResult<EditCustomJobRequisitionFieldValueMutation>
export type EditCustomJobRequisitionFieldValueMutationOptions = Apollo.BaseMutationOptions<
  EditCustomJobRequisitionFieldValueMutation,
  EditCustomJobRequisitionFieldValueMutationVariables
>
export const EditCustomJobRequisitionFieldDocument = gql`
  mutation EditCustomJobRequisitionField($input: EditCustomJobRequisitionFieldInput!) {
    EditCustomJobRequisitionField(input: $input) {
      ...CustomJobRequisitionFieldOutput
    }
  }
  ${CustomJobRequisitionFieldOutputFragmentDoc}
`
export type EditCustomJobRequisitionFieldMutationFn = Apollo.MutationFunction<
  EditCustomJobRequisitionFieldMutation,
  EditCustomJobRequisitionFieldMutationVariables
>

/**
 * __useEditCustomJobRequisitionFieldMutation__
 *
 * To run a mutation, you first call `useEditCustomJobRequisitionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomJobRequisitionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomJobRequisitionFieldMutation, { data, loading, error }] = useEditCustomJobRequisitionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCustomJobRequisitionFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCustomJobRequisitionFieldMutation,
    EditCustomJobRequisitionFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditCustomJobRequisitionFieldMutation, EditCustomJobRequisitionFieldMutationVariables>(
    EditCustomJobRequisitionFieldDocument,
    options,
  )
}
export type EditCustomJobRequisitionFieldMutationHookResult = ReturnType<
  typeof useEditCustomJobRequisitionFieldMutation
>
export type EditCustomJobRequisitionFieldMutationResult = Apollo.MutationResult<EditCustomJobRequisitionFieldMutation>
export type EditCustomJobRequisitionFieldMutationOptions = Apollo.BaseMutationOptions<
  EditCustomJobRequisitionFieldMutation,
  EditCustomJobRequisitionFieldMutationVariables
>
export const UnarchiveCustomJobRequisitionFieldDocument = gql`
  mutation UnarchiveCustomJobRequisitionField($input: UnarchiveCustomJobRequisitionFieldInput!) {
    UnarchiveCustomJobRequisitionField(input: $input) {
      ...CustomJobRequisitionField
    }
  }
  ${CustomJobRequisitionFieldFragmentDoc}
`
export type UnarchiveCustomJobRequisitionFieldMutationFn = Apollo.MutationFunction<
  UnarchiveCustomJobRequisitionFieldMutation,
  UnarchiveCustomJobRequisitionFieldMutationVariables
>

/**
 * __useUnarchiveCustomJobRequisitionFieldMutation__
 *
 * To run a mutation, you first call `useUnarchiveCustomJobRequisitionFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveCustomJobRequisitionFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveCustomJobRequisitionFieldMutation, { data, loading, error }] = useUnarchiveCustomJobRequisitionFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveCustomJobRequisitionFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveCustomJobRequisitionFieldMutation,
    UnarchiveCustomJobRequisitionFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnarchiveCustomJobRequisitionFieldMutation,
    UnarchiveCustomJobRequisitionFieldMutationVariables
  >(UnarchiveCustomJobRequisitionFieldDocument, options)
}
export type UnarchiveCustomJobRequisitionFieldMutationHookResult = ReturnType<
  typeof useUnarchiveCustomJobRequisitionFieldMutation
>
export type UnarchiveCustomJobRequisitionFieldMutationResult =
  Apollo.MutationResult<UnarchiveCustomJobRequisitionFieldMutation>
export type UnarchiveCustomJobRequisitionFieldMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveCustomJobRequisitionFieldMutation,
  UnarchiveCustomJobRequisitionFieldMutationVariables
>
export const UpdateCustomCandidateApplicationFieldValueDocument = gql`
  mutation UpdateCustomCandidateApplicationFieldValue($input: UpdateCustomCandidateApplicationFieldValueInput!) {
    UpdateCustomCandidateApplicationFieldValue(input: $input) {
      ...CustomCandidateApplicationFieldValue
    }
  }
  ${CustomCandidateApplicationFieldValueFragmentDoc}
`
export type UpdateCustomCandidateApplicationFieldValueMutationFn = Apollo.MutationFunction<
  UpdateCustomCandidateApplicationFieldValueMutation,
  UpdateCustomCandidateApplicationFieldValueMutationVariables
>

/**
 * __useUpdateCustomCandidateApplicationFieldValueMutation__
 *
 * To run a mutation, you first call `useUpdateCustomCandidateApplicationFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomCandidateApplicationFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomCandidateApplicationFieldValueMutation, { data, loading, error }] = useUpdateCustomCandidateApplicationFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomCandidateApplicationFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomCandidateApplicationFieldValueMutation,
    UpdateCustomCandidateApplicationFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCustomCandidateApplicationFieldValueMutation,
    UpdateCustomCandidateApplicationFieldValueMutationVariables
  >(UpdateCustomCandidateApplicationFieldValueDocument, options)
}
export type UpdateCustomCandidateApplicationFieldValueMutationHookResult = ReturnType<
  typeof useUpdateCustomCandidateApplicationFieldValueMutation
>
export type UpdateCustomCandidateApplicationFieldValueMutationResult =
  Apollo.MutationResult<UpdateCustomCandidateApplicationFieldValueMutation>
export type UpdateCustomCandidateApplicationFieldValueMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomCandidateApplicationFieldValueMutation,
  UpdateCustomCandidateApplicationFieldValueMutationVariables
>
export const UpdateCustomCandidateProfileFieldValueDocument = gql`
  mutation UpdateCustomCandidateProfileFieldValue($input: UpdateCustomCandidateProfileFieldValueInput!) {
    UpdateCustomCandidateProfileFieldValue(input: $input) {
      ...CustomCandidateProfileFieldValue
    }
  }
  ${CustomCandidateProfileFieldValueFragmentDoc}
`
export type UpdateCustomCandidateProfileFieldValueMutationFn = Apollo.MutationFunction<
  UpdateCustomCandidateProfileFieldValueMutation,
  UpdateCustomCandidateProfileFieldValueMutationVariables
>

/**
 * __useUpdateCustomCandidateProfileFieldValueMutation__
 *
 * To run a mutation, you first call `useUpdateCustomCandidateProfileFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomCandidateProfileFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomCandidateProfileFieldValueMutation, { data, loading, error }] = useUpdateCustomCandidateProfileFieldValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomCandidateProfileFieldValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomCandidateProfileFieldValueMutation,
    UpdateCustomCandidateProfileFieldValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCustomCandidateProfileFieldValueMutation,
    UpdateCustomCandidateProfileFieldValueMutationVariables
  >(UpdateCustomCandidateProfileFieldValueDocument, options)
}
export type UpdateCustomCandidateProfileFieldValueMutationHookResult = ReturnType<
  typeof useUpdateCustomCandidateProfileFieldValueMutation
>
export type UpdateCustomCandidateProfileFieldValueMutationResult =
  Apollo.MutationResult<UpdateCustomCandidateProfileFieldValueMutation>
export type UpdateCustomCandidateProfileFieldValueMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomCandidateProfileFieldValueMutation,
  UpdateCustomCandidateProfileFieldValueMutationVariables
>
export const UpsertGlobalListingSetupDocument = gql`
  mutation UpsertGlobalListingSetup($input: GlobalListingSetupInput!) {
    upsertGlobalListingSetup(input: $input) {
      id
      aboutCompanyStatement
      footerStatement
      companyId
      isAboutCompanyActive
      isFooterStatementActive
      updatedAt
    }
  }
`
export type UpsertGlobalListingSetupMutationFn = Apollo.MutationFunction<
  UpsertGlobalListingSetupMutation,
  UpsertGlobalListingSetupMutationVariables
>

/**
 * __useUpsertGlobalListingSetupMutation__
 *
 * To run a mutation, you first call `useUpsertGlobalListingSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGlobalListingSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGlobalListingSetupMutation, { data, loading, error }] = useUpsertGlobalListingSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertGlobalListingSetupMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertGlobalListingSetupMutation, UpsertGlobalListingSetupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertGlobalListingSetupMutation, UpsertGlobalListingSetupMutationVariables>(
    UpsertGlobalListingSetupDocument,
    options,
  )
}
export type UpsertGlobalListingSetupMutationHookResult = ReturnType<typeof useUpsertGlobalListingSetupMutation>
export type UpsertGlobalListingSetupMutationResult = Apollo.MutationResult<UpsertGlobalListingSetupMutation>
export type UpsertGlobalListingSetupMutationOptions = Apollo.BaseMutationOptions<
  UpsertGlobalListingSetupMutation,
  UpsertGlobalListingSetupMutationVariables
>
export const DeleteGlobalScreeningQuestionDocument = gql`
  mutation DeleteGlobalScreeningQuestion($input: DeleteGlobalScreeningQuestionInput!) {
    DeleteGlobalScreeningQuestion(input: $input) {
      id
      questionTitle
      questionDesc
    }
  }
`
export type DeleteGlobalScreeningQuestionMutationFn = Apollo.MutationFunction<
  DeleteGlobalScreeningQuestionMutation,
  DeleteGlobalScreeningQuestionMutationVariables
>

/**
 * __useDeleteGlobalScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteGlobalScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlobalScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlobalScreeningQuestionMutation, { data, loading, error }] = useDeleteGlobalScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGlobalScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGlobalScreeningQuestionMutation,
    DeleteGlobalScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteGlobalScreeningQuestionMutation, DeleteGlobalScreeningQuestionMutationVariables>(
    DeleteGlobalScreeningQuestionDocument,
    options,
  )
}
export type DeleteGlobalScreeningQuestionMutationHookResult = ReturnType<
  typeof useDeleteGlobalScreeningQuestionMutation
>
export type DeleteGlobalScreeningQuestionMutationResult = Apollo.MutationResult<DeleteGlobalScreeningQuestionMutation>
export type DeleteGlobalScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  DeleteGlobalScreeningQuestionMutation,
  DeleteGlobalScreeningQuestionMutationVariables
>
export const EditGlobalScreeningQuestionDocument = gql`
  mutation EditGlobalScreeningQuestion($input: EditGlobalScreeningQuestionInput!) {
    EditGlobalScreeningQuestion(input: $input) {
      id
      questionTitle
      questionDesc
      questionType
      minVal
      maxVal
      valStatus
      ansOptions
      isRejectionQuestion
      rejectMessage
      preferredAnswer
      isGlobalQuestion
      isActiveGlobally
      globalQuestionOrder
      isEdited
      isReplacedBy
      isDeleted
      companyId
      companyUserId
      createdAt
      updatedAt
    }
  }
`
export type EditGlobalScreeningQuestionMutationFn = Apollo.MutationFunction<
  EditGlobalScreeningQuestionMutation,
  EditGlobalScreeningQuestionMutationVariables
>

/**
 * __useEditGlobalScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useEditGlobalScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGlobalScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGlobalScreeningQuestionMutation, { data, loading, error }] = useEditGlobalScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditGlobalScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditGlobalScreeningQuestionMutation,
    EditGlobalScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditGlobalScreeningQuestionMutation, EditGlobalScreeningQuestionMutationVariables>(
    EditGlobalScreeningQuestionDocument,
    options,
  )
}
export type EditGlobalScreeningQuestionMutationHookResult = ReturnType<typeof useEditGlobalScreeningQuestionMutation>
export type EditGlobalScreeningQuestionMutationResult = Apollo.MutationResult<EditGlobalScreeningQuestionMutation>
export type EditGlobalScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  EditGlobalScreeningQuestionMutation,
  EditGlobalScreeningQuestionMutationVariables
>
export const InsertGlobalScreeningQuestionDocument = gql`
  mutation InsertGlobalScreeningQuestion($input: [InsertGlobalScreeningQuestionInput!]!) {
    InsertGlobalScreeningQuestion(input: $input) {
      id
      questionTitle
      questionDesc
      questionType
      ansOptions
      isRejectionQuestion
      rejectMessage
      preferredAnswer
      isActiveGlobally
      globalQuestionOrder
      createdAt
      updatedAt
    }
  }
`
export type InsertGlobalScreeningQuestionMutationFn = Apollo.MutationFunction<
  InsertGlobalScreeningQuestionMutation,
  InsertGlobalScreeningQuestionMutationVariables
>

/**
 * __useInsertGlobalScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useInsertGlobalScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGlobalScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGlobalScreeningQuestionMutation, { data, loading, error }] = useInsertGlobalScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertGlobalScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InsertGlobalScreeningQuestionMutation,
    InsertGlobalScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<InsertGlobalScreeningQuestionMutation, InsertGlobalScreeningQuestionMutationVariables>(
    InsertGlobalScreeningQuestionDocument,
    options,
  )
}
export type InsertGlobalScreeningQuestionMutationHookResult = ReturnType<
  typeof useInsertGlobalScreeningQuestionMutation
>
export type InsertGlobalScreeningQuestionMutationResult = Apollo.MutationResult<InsertGlobalScreeningQuestionMutation>
export type InsertGlobalScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  InsertGlobalScreeningQuestionMutation,
  InsertGlobalScreeningQuestionMutationVariables
>
export const DeleteHiringTeamMemberDocument = gql`
  mutation DeleteHiringTeamMember($input: DeleteHiringTeamMemberInput!) {
    DeleteHiringTeamMember(input: $input) {
      id
    }
  }
`
export type DeleteHiringTeamMemberMutationFn = Apollo.MutationFunction<
  DeleteHiringTeamMemberMutation,
  DeleteHiringTeamMemberMutationVariables
>

/**
 * __useDeleteHiringTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteHiringTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHiringTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHiringTeamMemberMutation, { data, loading, error }] = useDeleteHiringTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteHiringTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteHiringTeamMemberMutation, DeleteHiringTeamMemberMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteHiringTeamMemberMutation, DeleteHiringTeamMemberMutationVariables>(
    DeleteHiringTeamMemberDocument,
    options,
  )
}
export type DeleteHiringTeamMemberMutationHookResult = ReturnType<typeof useDeleteHiringTeamMemberMutation>
export type DeleteHiringTeamMemberMutationResult = Apollo.MutationResult<DeleteHiringTeamMemberMutation>
export type DeleteHiringTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  DeleteHiringTeamMemberMutation,
  DeleteHiringTeamMemberMutationVariables
>
export const UpsertHiringTeamMemberDocument = gql`
  mutation UpsertHiringTeamMember($input: UpsertHiringTeamMemberInput!) {
    UpsertHiringTeamMember(input: $input) {
      ...HiringTeamMemberFragment
    }
  }
  ${HiringTeamMemberFragmentFragmentDoc}
`
export type UpsertHiringTeamMemberMutationFn = Apollo.MutationFunction<
  UpsertHiringTeamMemberMutation,
  UpsertHiringTeamMemberMutationVariables
>

/**
 * __useUpsertHiringTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpsertHiringTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHiringTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHiringTeamMemberMutation, { data, loading, error }] = useUpsertHiringTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertHiringTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertHiringTeamMemberMutation, UpsertHiringTeamMemberMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertHiringTeamMemberMutation, UpsertHiringTeamMemberMutationVariables>(
    UpsertHiringTeamMemberDocument,
    options,
  )
}
export type UpsertHiringTeamMemberMutationHookResult = ReturnType<typeof useUpsertHiringTeamMemberMutation>
export type UpsertHiringTeamMemberMutationResult = Apollo.MutationResult<UpsertHiringTeamMemberMutation>
export type UpsertHiringTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  UpsertHiringTeamMemberMutation,
  UpsertHiringTeamMemberMutationVariables
>
export const ArchiveInterviewerPoolDocument = gql`
  mutation ArchiveInterviewerPool($input: ArchiveInterviewerPoolInput!) {
    ArchiveInterviewerPool(input: $input) {
      id
      isArchived
      name
    }
  }
`
export type ArchiveInterviewerPoolMutationFn = Apollo.MutationFunction<
  ArchiveInterviewerPoolMutation,
  ArchiveInterviewerPoolMutationVariables
>

/**
 * __useArchiveInterviewerPoolMutation__
 *
 * To run a mutation, you first call `useArchiveInterviewerPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveInterviewerPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveInterviewerPoolMutation, { data, loading, error }] = useArchiveInterviewerPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveInterviewerPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveInterviewerPoolMutation, ArchiveInterviewerPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ArchiveInterviewerPoolMutation, ArchiveInterviewerPoolMutationVariables>(
    ArchiveInterviewerPoolDocument,
    options,
  )
}
export type ArchiveInterviewerPoolMutationHookResult = ReturnType<typeof useArchiveInterviewerPoolMutation>
export type ArchiveInterviewerPoolMutationResult = Apollo.MutationResult<ArchiveInterviewerPoolMutation>
export type ArchiveInterviewerPoolMutationOptions = Apollo.BaseMutationOptions<
  ArchiveInterviewerPoolMutation,
  ArchiveInterviewerPoolMutationVariables
>
export const CreateInterviewerPoolDocument = gql`
  mutation CreateInterviewerPool($input: CreateInterviewerPoolInput!) {
    CreateInterviewerPool(input: $input) {
      id
      name
      description
      maxWeeklyInterviews
      maxDailyInterviews
      updatedAt
      isArchived
      Offices {
        id
        CompanyOffice {
          id
          officeName
        }
      }
      Departments {
        id
        CompanyDepartment {
          id
          departmentName
        }
      }
      Skills {
        id
        Skill {
          id
          name
        }
      }
      Members {
        companyUserId
        interviewsTodayCount
        interviewsThisWeekCount
        interviewsLastWeekCount
        id
        CompanyUser {
          id
          UserInvitation {
            email
            ScalisUser {
              id
              firstName
              lastName
              profileImage
            }
          }
        }
      }
    }
  }
`
export type CreateInterviewerPoolMutationFn = Apollo.MutationFunction<
  CreateInterviewerPoolMutation,
  CreateInterviewerPoolMutationVariables
>

/**
 * __useCreateInterviewerPoolMutation__
 *
 * To run a mutation, you first call `useCreateInterviewerPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterviewerPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterviewerPoolMutation, { data, loading, error }] = useCreateInterviewerPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInterviewerPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInterviewerPoolMutation, CreateInterviewerPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInterviewerPoolMutation, CreateInterviewerPoolMutationVariables>(
    CreateInterviewerPoolDocument,
    options,
  )
}
export type CreateInterviewerPoolMutationHookResult = ReturnType<typeof useCreateInterviewerPoolMutation>
export type CreateInterviewerPoolMutationResult = Apollo.MutationResult<CreateInterviewerPoolMutation>
export type CreateInterviewerPoolMutationOptions = Apollo.BaseMutationOptions<
  CreateInterviewerPoolMutation,
  CreateInterviewerPoolMutationVariables
>
export const UnarchiveInterviewerPoolDocument = gql`
  mutation UnarchiveInterviewerPool($input: UnarchiveInterviewerPoolInput!) {
    UnarchiveInterviewerPool(input: $input) {
      id
      isArchived
      name
    }
  }
`
export type UnarchiveInterviewerPoolMutationFn = Apollo.MutationFunction<
  UnarchiveInterviewerPoolMutation,
  UnarchiveInterviewerPoolMutationVariables
>

/**
 * __useUnarchiveInterviewerPoolMutation__
 *
 * To run a mutation, you first call `useUnarchiveInterviewerPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveInterviewerPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveInterviewerPoolMutation, { data, loading, error }] = useUnarchiveInterviewerPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveInterviewerPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<UnarchiveInterviewerPoolMutation, UnarchiveInterviewerPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UnarchiveInterviewerPoolMutation, UnarchiveInterviewerPoolMutationVariables>(
    UnarchiveInterviewerPoolDocument,
    options,
  )
}
export type UnarchiveInterviewerPoolMutationHookResult = ReturnType<typeof useUnarchiveInterviewerPoolMutation>
export type UnarchiveInterviewerPoolMutationResult = Apollo.MutationResult<UnarchiveInterviewerPoolMutation>
export type UnarchiveInterviewerPoolMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveInterviewerPoolMutation,
  UnarchiveInterviewerPoolMutationVariables
>
export const CreateInterviewDocument = gql`
  mutation CreateInterview($input: CreateInterviewInput!) {
    CreateInterview(input: $input) {
      status
      stageId
      interviewData
      id
      companyUserId
      applicationId
    }
  }
`
export type CreateInterviewMutationFn = Apollo.MutationFunction<
  CreateInterviewMutation,
  CreateInterviewMutationVariables
>

/**
 * __useCreateInterviewMutation__
 *
 * To run a mutation, you first call `useCreateInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterviewMutation, { data, loading, error }] = useCreateInterviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInterviewMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateInterviewMutation, CreateInterviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateInterviewMutation, CreateInterviewMutationVariables>(CreateInterviewDocument, options)
}
export type CreateInterviewMutationHookResult = ReturnType<typeof useCreateInterviewMutation>
export type CreateInterviewMutationResult = Apollo.MutationResult<CreateInterviewMutation>
export type CreateInterviewMutationOptions = Apollo.BaseMutationOptions<
  CreateInterviewMutation,
  CreateInterviewMutationVariables
>
export const CreateSchedulerLinkDocument = gql`
  mutation CreateSchedulerLink($input: CreateSchedulerLinkInviteInput!) {
    CreateSchedulerLinkInvite(input: $input)
  }
`
export type CreateSchedulerLinkMutationFn = Apollo.MutationFunction<
  CreateSchedulerLinkMutation,
  CreateSchedulerLinkMutationVariables
>

/**
 * __useCreateSchedulerLinkMutation__
 *
 * To run a mutation, you first call `useCreateSchedulerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchedulerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchedulerLinkMutation, { data, loading, error }] = useCreateSchedulerLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSchedulerLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSchedulerLinkMutation, CreateSchedulerLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSchedulerLinkMutation, CreateSchedulerLinkMutationVariables>(
    CreateSchedulerLinkDocument,
    options,
  )
}
export type CreateSchedulerLinkMutationHookResult = ReturnType<typeof useCreateSchedulerLinkMutation>
export type CreateSchedulerLinkMutationResult = Apollo.MutationResult<CreateSchedulerLinkMutation>
export type CreateSchedulerLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateSchedulerLinkMutation,
  CreateSchedulerLinkMutationVariables
>
export const DeleteInterviewDocument = gql`
  mutation DeleteInterview($input: DeleteInterviewInput!) {
    DeleteInterview(input: $input)
  }
`
export type DeleteInterviewMutationFn = Apollo.MutationFunction<
  DeleteInterviewMutation,
  DeleteInterviewMutationVariables
>

/**
 * __useDeleteInterviewMutation__
 *
 * To run a mutation, you first call `useDeleteInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInterviewMutation, { data, loading, error }] = useDeleteInterviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInterviewMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteInterviewMutation, DeleteInterviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteInterviewMutation, DeleteInterviewMutationVariables>(DeleteInterviewDocument, options)
}
export type DeleteInterviewMutationHookResult = ReturnType<typeof useDeleteInterviewMutation>
export type DeleteInterviewMutationResult = Apollo.MutationResult<DeleteInterviewMutation>
export type DeleteInterviewMutationOptions = Apollo.BaseMutationOptions<
  DeleteInterviewMutation,
  DeleteInterviewMutationVariables
>
export const DeleteSchedulerLinkInviteDocument = gql`
  mutation DeleteSchedulerLinkInvite($input: DeleteSchedulerLinkInviteInput!) {
    DeleteSchedulerLinkInvite(input: $input)
  }
`
export type DeleteSchedulerLinkInviteMutationFn = Apollo.MutationFunction<
  DeleteSchedulerLinkInviteMutation,
  DeleteSchedulerLinkInviteMutationVariables
>

/**
 * __useDeleteSchedulerLinkInviteMutation__
 *
 * To run a mutation, you first call `useDeleteSchedulerLinkInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchedulerLinkInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchedulerLinkInviteMutation, { data, loading, error }] = useDeleteSchedulerLinkInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSchedulerLinkInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSchedulerLinkInviteMutation,
    DeleteSchedulerLinkInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSchedulerLinkInviteMutation, DeleteSchedulerLinkInviteMutationVariables>(
    DeleteSchedulerLinkInviteDocument,
    options,
  )
}
export type DeleteSchedulerLinkInviteMutationHookResult = ReturnType<typeof useDeleteSchedulerLinkInviteMutation>
export type DeleteSchedulerLinkInviteMutationResult = Apollo.MutationResult<DeleteSchedulerLinkInviteMutation>
export type DeleteSchedulerLinkInviteMutationOptions = Apollo.BaseMutationOptions<
  DeleteSchedulerLinkInviteMutation,
  DeleteSchedulerLinkInviteMutationVariables
>
export const ResendSchedulerLinkInviteDocument = gql`
  mutation ResendSchedulerLinkInvite($input: ResendSchedulerLinkInviteInput!) {
    ResendSchedulerLinkInvite(input: $input)
  }
`
export type ResendSchedulerLinkInviteMutationFn = Apollo.MutationFunction<
  ResendSchedulerLinkInviteMutation,
  ResendSchedulerLinkInviteMutationVariables
>

/**
 * __useResendSchedulerLinkInviteMutation__
 *
 * To run a mutation, you first call `useResendSchedulerLinkInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSchedulerLinkInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSchedulerLinkInviteMutation, { data, loading, error }] = useResendSchedulerLinkInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendSchedulerLinkInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendSchedulerLinkInviteMutation,
    ResendSchedulerLinkInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendSchedulerLinkInviteMutation, ResendSchedulerLinkInviteMutationVariables>(
    ResendSchedulerLinkInviteDocument,
    options,
  )
}
export type ResendSchedulerLinkInviteMutationHookResult = ReturnType<typeof useResendSchedulerLinkInviteMutation>
export type ResendSchedulerLinkInviteMutationResult = Apollo.MutationResult<ResendSchedulerLinkInviteMutation>
export type ResendSchedulerLinkInviteMutationOptions = Apollo.BaseMutationOptions<
  ResendSchedulerLinkInviteMutation,
  ResendSchedulerLinkInviteMutationVariables
>
export const UpdateInterviewDocument = gql`
  mutation UpdateInterview($input: UpdateInterviewInput!) {
    UpdateInterview(input: $input) {
      status
      stageId
      interviewData
      id
      companyUserId
      applicationId
    }
  }
`
export type UpdateInterviewMutationFn = Apollo.MutationFunction<
  UpdateInterviewMutation,
  UpdateInterviewMutationVariables
>

/**
 * __useUpdateInterviewMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewMutation, { data, loading, error }] = useUpdateInterviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateInterviewMutation, UpdateInterviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateInterviewMutation, UpdateInterviewMutationVariables>(UpdateInterviewDocument, options)
}
export type UpdateInterviewMutationHookResult = ReturnType<typeof useUpdateInterviewMutation>
export type UpdateInterviewMutationResult = Apollo.MutationResult<UpdateInterviewMutation>
export type UpdateInterviewMutationOptions = Apollo.BaseMutationOptions<
  UpdateInterviewMutation,
  UpdateInterviewMutationVariables
>
export const CountCampaignViewDocument = gql`
  mutation CountCampaignView($input: CountCampaignViewInput!) {
    CountCampaignView(input: $input) {
      message
      viewCount
    }
  }
`
export type CountCampaignViewMutationFn = Apollo.MutationFunction<
  CountCampaignViewMutation,
  CountCampaignViewMutationVariables
>

/**
 * __useCountCampaignViewMutation__
 *
 * To run a mutation, you first call `useCountCampaignViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountCampaignViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countCampaignViewMutation, { data, loading, error }] = useCountCampaignViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCountCampaignViewMutation(
  baseOptions?: Apollo.MutationHookOptions<CountCampaignViewMutation, CountCampaignViewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CountCampaignViewMutation, CountCampaignViewMutationVariables>(
    CountCampaignViewDocument,
    options,
  )
}
export type CountCampaignViewMutationHookResult = ReturnType<typeof useCountCampaignViewMutation>
export type CountCampaignViewMutationResult = Apollo.MutationResult<CountCampaignViewMutation>
export type CountCampaignViewMutationOptions = Apollo.BaseMutationOptions<
  CountCampaignViewMutation,
  CountCampaignViewMutationVariables
>
export const OrderJobCampaignDocument = gql`
  mutation OrderJobCampaign($input: OrderCampaignInput!) {
    OrderJobCampaign(input: $input) {
      ... on JobCampaignCreation {
        orderReference
        clientSecret
        deliveryTime {
          totalDays
          daysToSetup
          daysToProcess
        }
        price {
          subTotal
          total
          vat
        }
      }
      ... on CampaignValidationErrors {
        errors {
          company
          orderedProducts {
            message
          }
          orderedProductsSpecs {
            message
          }
          postingDetails {
            fields
          }
          targetGroup {
            fields
          }
          recruiterInfo {
            fields
          }
        }
      }
    }
  }
`
export type OrderJobCampaignMutationFn = Apollo.MutationFunction<
  OrderJobCampaignMutation,
  OrderJobCampaignMutationVariables
>

/**
 * __useOrderJobCampaignMutation__
 *
 * To run a mutation, you first call `useOrderJobCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderJobCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderJobCampaignMutation, { data, loading, error }] = useOrderJobCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderJobCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<OrderJobCampaignMutation, OrderJobCampaignMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OrderJobCampaignMutation, OrderJobCampaignMutationVariables>(
    OrderJobCampaignDocument,
    options,
  )
}
export type OrderJobCampaignMutationHookResult = ReturnType<typeof useOrderJobCampaignMutation>
export type OrderJobCampaignMutationResult = Apollo.MutationResult<OrderJobCampaignMutation>
export type OrderJobCampaignMutationOptions = Apollo.BaseMutationOptions<
  OrderJobCampaignMutation,
  OrderJobCampaignMutationVariables
>
export const UpdateJobInviteDocument = gql`
  mutation UpdateJobInvite($input: UpdateJobInviteInput!) {
    UpdateJobInvite(input: $input) {
      id
    }
  }
`
export type UpdateJobInviteMutationFn = Apollo.MutationFunction<
  UpdateJobInviteMutation,
  UpdateJobInviteMutationVariables
>

/**
 * __useUpdateJobInviteMutation__
 *
 * To run a mutation, you first call `useUpdateJobInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobInviteMutation, { data, loading, error }] = useUpdateJobInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateJobInviteMutation, UpdateJobInviteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateJobInviteMutation, UpdateJobInviteMutationVariables>(UpdateJobInviteDocument, options)
}
export type UpdateJobInviteMutationHookResult = ReturnType<typeof useUpdateJobInviteMutation>
export type UpdateJobInviteMutationResult = Apollo.MutationResult<UpdateJobInviteMutation>
export type UpdateJobInviteMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobInviteMutation,
  UpdateJobInviteMutationVariables
>
export const DeleteJobListingDocument = gql`
  mutation DeleteJobListing($input: DeleteJobListingInput!) {
    DeleteJobListing(input: $input) {
      id
    }
  }
`
export type DeleteJobListingMutationFn = Apollo.MutationFunction<
  DeleteJobListingMutation,
  DeleteJobListingMutationVariables
>

/**
 * __useDeleteJobListingMutation__
 *
 * To run a mutation, you first call `useDeleteJobListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobListingMutation, { data, loading, error }] = useDeleteJobListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobListingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteJobListingMutation, DeleteJobListingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteJobListingMutation, DeleteJobListingMutationVariables>(
    DeleteJobListingDocument,
    options,
  )
}
export type DeleteJobListingMutationHookResult = ReturnType<typeof useDeleteJobListingMutation>
export type DeleteJobListingMutationResult = Apollo.MutationResult<DeleteJobListingMutation>
export type DeleteJobListingMutationOptions = Apollo.BaseMutationOptions<
  DeleteJobListingMutation,
  DeleteJobListingMutationVariables
>
export const UpsertJobListingDocument = gql`
  mutation UpsertJobListing($input: UpsertJobListingInput!) {
    UpsertJobListing(input: $input) {
      ...JobListingFragment
      Address {
        ...AddressFragment
      }
      JobListingScreeningQuestion {
        ...JobListingScreeningQuestionFragment
        ScreeningQuestion {
          ...ScreeningQuestionFragment
        }
      }
    }
  }
  ${JobListingFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${JobListingScreeningQuestionFragmentFragmentDoc}
  ${ScreeningQuestionFragmentFragmentDoc}
`
export type UpsertJobListingMutationFn = Apollo.MutationFunction<
  UpsertJobListingMutation,
  UpsertJobListingMutationVariables
>

/**
 * __useUpsertJobListingMutation__
 *
 * To run a mutation, you first call `useUpsertJobListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertJobListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertJobListingMutation, { data, loading, error }] = useUpsertJobListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertJobListingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertJobListingMutation, UpsertJobListingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertJobListingMutation, UpsertJobListingMutationVariables>(
    UpsertJobListingDocument,
    options,
  )
}
export type UpsertJobListingMutationHookResult = ReturnType<typeof useUpsertJobListingMutation>
export type UpsertJobListingMutationResult = Apollo.MutationResult<UpsertJobListingMutation>
export type UpsertJobListingMutationOptions = Apollo.BaseMutationOptions<
  UpsertJobListingMutation,
  UpsertJobListingMutationVariables
>
export const SwapRequisitionPipelineDocument = gql`
  mutation SwapRequisitionPipeline($input: SwapRequisitionPipelineInput!) {
    SwapRequisitionPipeline(input: $input) {
      ...JobPipelineFragment
      TemplatePipeline {
        ...TemplatePipelineFragment
        TemplateMilestones {
          ...TemplateMilestone
          TemplateStage {
            ...TemplateStage
          }
        }
      }
    }
  }
  ${JobPipelineFragmentFragmentDoc}
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
`
export type SwapRequisitionPipelineMutationFn = Apollo.MutationFunction<
  SwapRequisitionPipelineMutation,
  SwapRequisitionPipelineMutationVariables
>

/**
 * __useSwapRequisitionPipelineMutation__
 *
 * To run a mutation, you first call `useSwapRequisitionPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwapRequisitionPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [swapRequisitionPipelineMutation, { data, loading, error }] = useSwapRequisitionPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwapRequisitionPipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<SwapRequisitionPipelineMutation, SwapRequisitionPipelineMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SwapRequisitionPipelineMutation, SwapRequisitionPipelineMutationVariables>(
    SwapRequisitionPipelineDocument,
    options,
  )
}
export type SwapRequisitionPipelineMutationHookResult = ReturnType<typeof useSwapRequisitionPipelineMutation>
export type SwapRequisitionPipelineMutationResult = Apollo.MutationResult<SwapRequisitionPipelineMutation>
export type SwapRequisitionPipelineMutationOptions = Apollo.BaseMutationOptions<
  SwapRequisitionPipelineMutation,
  SwapRequisitionPipelineMutationVariables
>
export const UpsertJobPipelineDocument = gql`
  mutation UpsertJobPipeline($input: UpsertJobPipelineInput!) {
    UpsertJobPipeline(input: $input) {
      ...JobPipelineFragment
      TemplatePipeline {
        ...TemplatePipelineFragment
        TemplateMilestones {
          ...TemplateMilestone
          TemplateStage {
            ...TemplateStage
          }
        }
      }
    }
  }
  ${JobPipelineFragmentFragmentDoc}
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
`
export type UpsertJobPipelineMutationFn = Apollo.MutationFunction<
  UpsertJobPipelineMutation,
  UpsertJobPipelineMutationVariables
>

/**
 * __useUpsertJobPipelineMutation__
 *
 * To run a mutation, you first call `useUpsertJobPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertJobPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertJobPipelineMutation, { data, loading, error }] = useUpsertJobPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertJobPipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertJobPipelineMutation, UpsertJobPipelineMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertJobPipelineMutation, UpsertJobPipelineMutationVariables>(
    UpsertJobPipelineDocument,
    options,
  )
}
export type UpsertJobPipelineMutationHookResult = ReturnType<typeof useUpsertJobPipelineMutation>
export type UpsertJobPipelineMutationResult = Apollo.MutationResult<UpsertJobPipelineMutation>
export type UpsertJobPipelineMutationOptions = Apollo.BaseMutationOptions<
  UpsertJobPipelineMutation,
  UpsertJobPipelineMutationVariables
>
export const CreateJobSearchPreferenceDocument = gql`
  mutation CreateJobSearchPreference($input: CreateJobSearchPreferenceInput!) {
    CreateJobSearchPreference(input: $input) {
      ...JobSearchPreferenceFragment
    }
  }
  ${JobSearchPreferenceFragmentFragmentDoc}
`
export type CreateJobSearchPreferenceMutationFn = Apollo.MutationFunction<
  CreateJobSearchPreferenceMutation,
  CreateJobSearchPreferenceMutationVariables
>

/**
 * __useCreateJobSearchPreferenceMutation__
 *
 * To run a mutation, you first call `useCreateJobSearchPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobSearchPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobSearchPreferenceMutation, { data, loading, error }] = useCreateJobSearchPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobSearchPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateJobSearchPreferenceMutation,
    CreateJobSearchPreferenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateJobSearchPreferenceMutation, CreateJobSearchPreferenceMutationVariables>(
    CreateJobSearchPreferenceDocument,
    options,
  )
}
export type CreateJobSearchPreferenceMutationHookResult = ReturnType<typeof useCreateJobSearchPreferenceMutation>
export type CreateJobSearchPreferenceMutationResult = Apollo.MutationResult<CreateJobSearchPreferenceMutation>
export type CreateJobSearchPreferenceMutationOptions = Apollo.BaseMutationOptions<
  CreateJobSearchPreferenceMutation,
  CreateJobSearchPreferenceMutationVariables
>
export const UpdateJobSearchPreferenceDocument = gql`
  mutation UpdateJobSearchPreference($input: UpdateJobSearchPreferenceInput!) {
    UpdateJobSearchPreference(input: $input) {
      ...JobSearchPreferenceFragment
    }
  }
  ${JobSearchPreferenceFragmentFragmentDoc}
`
export type UpdateJobSearchPreferenceMutationFn = Apollo.MutationFunction<
  UpdateJobSearchPreferenceMutation,
  UpdateJobSearchPreferenceMutationVariables
>

/**
 * __useUpdateJobSearchPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateJobSearchPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobSearchPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobSearchPreferenceMutation, { data, loading, error }] = useUpdateJobSearchPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobSearchPreferenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateJobSearchPreferenceMutation,
    UpdateJobSearchPreferenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateJobSearchPreferenceMutation, UpdateJobSearchPreferenceMutationVariables>(
    UpdateJobSearchPreferenceDocument,
    options,
  )
}
export type UpdateJobSearchPreferenceMutationHookResult = ReturnType<typeof useUpdateJobSearchPreferenceMutation>
export type UpdateJobSearchPreferenceMutationResult = Apollo.MutationResult<UpdateJobSearchPreferenceMutation>
export type UpdateJobSearchPreferenceMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobSearchPreferenceMutation,
  UpdateJobSearchPreferenceMutationVariables
>
export const CreateApplicantNotesDocument = gql`
  mutation CreateApplicantNotes($input: CreateApplicantNotesInput!) {
    CreateApplicantNotes(input: $input) {
      id
    }
  }
`
export type CreateApplicantNotesMutationFn = Apollo.MutationFunction<
  CreateApplicantNotesMutation,
  CreateApplicantNotesMutationVariables
>

/**
 * __useCreateApplicantNotesMutation__
 *
 * To run a mutation, you first call `useCreateApplicantNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicantNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicantNotesMutation, { data, loading, error }] = useCreateApplicantNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicantNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateApplicantNotesMutation, CreateApplicantNotesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateApplicantNotesMutation, CreateApplicantNotesMutationVariables>(
    CreateApplicantNotesDocument,
    options,
  )
}
export type CreateApplicantNotesMutationHookResult = ReturnType<typeof useCreateApplicantNotesMutation>
export type CreateApplicantNotesMutationResult = Apollo.MutationResult<CreateApplicantNotesMutation>
export type CreateApplicantNotesMutationOptions = Apollo.BaseMutationOptions<
  CreateApplicantNotesMutation,
  CreateApplicantNotesMutationVariables
>
export const CreateBookmarkedJobDocument = gql`
  mutation CreateBookmarkedJob($input: CreateBookmarkedJobInput!) {
    CreateBookmarkedJob(input: $input) {
      id
      jobListingId
    }
  }
`
export type CreateBookmarkedJobMutationFn = Apollo.MutationFunction<
  CreateBookmarkedJobMutation,
  CreateBookmarkedJobMutationVariables
>

/**
 * __useCreateBookmarkedJobMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkedJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkedJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkedJobMutation, { data, loading, error }] = useCreateBookmarkedJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBookmarkedJobMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateBookmarkedJobMutation, CreateBookmarkedJobMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateBookmarkedJobMutation, CreateBookmarkedJobMutationVariables>(
    CreateBookmarkedJobDocument,
    options,
  )
}
export type CreateBookmarkedJobMutationHookResult = ReturnType<typeof useCreateBookmarkedJobMutation>
export type CreateBookmarkedJobMutationResult = Apollo.MutationResult<CreateBookmarkedJobMutation>
export type CreateBookmarkedJobMutationOptions = Apollo.BaseMutationOptions<
  CreateBookmarkedJobMutation,
  CreateBookmarkedJobMutationVariables
>
export const CreateJobSeekerAccountDocument = gql`
  mutation CreateJobSeekerAccount($input: CreateJobSeekerAccountInput!) {
    CreateJobSeekerAccount(input: $input) {
      id
    }
  }
`
export type CreateJobSeekerAccountMutationFn = Apollo.MutationFunction<
  CreateJobSeekerAccountMutation,
  CreateJobSeekerAccountMutationVariables
>

/**
 * __useCreateJobSeekerAccountMutation__
 *
 * To run a mutation, you first call `useCreateJobSeekerAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobSeekerAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobSeekerAccountMutation, { data, loading, error }] = useCreateJobSeekerAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobSeekerAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateJobSeekerAccountMutation, CreateJobSeekerAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateJobSeekerAccountMutation, CreateJobSeekerAccountMutationVariables>(
    CreateJobSeekerAccountDocument,
    options,
  )
}
export type CreateJobSeekerAccountMutationHookResult = ReturnType<typeof useCreateJobSeekerAccountMutation>
export type CreateJobSeekerAccountMutationResult = Apollo.MutationResult<CreateJobSeekerAccountMutation>
export type CreateJobSeekerAccountMutationOptions = Apollo.BaseMutationOptions<
  CreateJobSeekerAccountMutation,
  CreateJobSeekerAccountMutationVariables
>
export const DeleteApplicantNotesDocument = gql`
  mutation DeleteApplicantNotes($input: DeleteApplicantNotesInput!) {
    DeleteApplicantNotes(input: $input) {
      id
    }
  }
`
export type DeleteApplicantNotesMutationFn = Apollo.MutationFunction<
  DeleteApplicantNotesMutation,
  DeleteApplicantNotesMutationVariables
>

/**
 * __useDeleteApplicantNotesMutation__
 *
 * To run a mutation, you first call `useDeleteApplicantNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicantNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicantNotesMutation, { data, loading, error }] = useDeleteApplicantNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteApplicantNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteApplicantNotesMutation, DeleteApplicantNotesMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteApplicantNotesMutation, DeleteApplicantNotesMutationVariables>(
    DeleteApplicantNotesDocument,
    options,
  )
}
export type DeleteApplicantNotesMutationHookResult = ReturnType<typeof useDeleteApplicantNotesMutation>
export type DeleteApplicantNotesMutationResult = Apollo.MutationResult<DeleteApplicantNotesMutation>
export type DeleteApplicantNotesMutationOptions = Apollo.BaseMutationOptions<
  DeleteApplicantNotesMutation,
  DeleteApplicantNotesMutationVariables
>
export const DeleteExternalJobApplicationDocument = gql`
  mutation DeleteExternalJobApplication($input: DeleteExternalApplicationInput!) {
    DeleteExternalJobApplication(input: $input) {
      message
    }
  }
`
export type DeleteExternalJobApplicationMutationFn = Apollo.MutationFunction<
  DeleteExternalJobApplicationMutation,
  DeleteExternalJobApplicationMutationVariables
>

/**
 * __useDeleteExternalJobApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteExternalJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalJobApplicationMutation, { data, loading, error }] = useDeleteExternalJobApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExternalJobApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteExternalJobApplicationMutation,
    DeleteExternalJobApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteExternalJobApplicationMutation, DeleteExternalJobApplicationMutationVariables>(
    DeleteExternalJobApplicationDocument,
    options,
  )
}
export type DeleteExternalJobApplicationMutationHookResult = ReturnType<typeof useDeleteExternalJobApplicationMutation>
export type DeleteExternalJobApplicationMutationResult = Apollo.MutationResult<DeleteExternalJobApplicationMutation>
export type DeleteExternalJobApplicationMutationOptions = Apollo.BaseMutationOptions<
  DeleteExternalJobApplicationMutation,
  DeleteExternalJobApplicationMutationVariables
>
export const ResendEmailVerificationDocument = gql`
  mutation ResendEmailVerification($input: ResendEmailVerificationInput!) {
    ResendEmailVerification(input: $input) {
      EmailVerification {
        activeStatus
        createdAt
        emailAddress
        emailVerified
        id
        isPrimary
        scalisUserId
        updatedAt
      }
    }
  }
`
export type ResendEmailVerificationMutationFn = Apollo.MutationFunction<
  ResendEmailVerificationMutation,
  ResendEmailVerificationMutationVariables
>

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendEmailVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(
    ResendEmailVerificationDocument,
    options,
  )
}
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>
export type ResendEmailVerificationMutationResult = Apollo.MutationResult<ResendEmailVerificationMutation>
export type ResendEmailVerificationMutationOptions = Apollo.BaseMutationOptions<
  ResendEmailVerificationMutation,
  ResendEmailVerificationMutationVariables
>
export const SendJobListingDocument = gql`
  mutation SendJobListing($input: SendJobListingInput!) {
    SendJobListing(input: $input) {
      publicListingId
    }
  }
`
export type SendJobListingMutationFn = Apollo.MutationFunction<SendJobListingMutation, SendJobListingMutationVariables>

/**
 * __useSendJobListingMutation__
 *
 * To run a mutation, you first call `useSendJobListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendJobListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendJobListingMutation, { data, loading, error }] = useSendJobListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendJobListingMutation(
  baseOptions?: Apollo.MutationHookOptions<SendJobListingMutation, SendJobListingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendJobListingMutation, SendJobListingMutationVariables>(SendJobListingDocument, options)
}
export type SendJobListingMutationHookResult = ReturnType<typeof useSendJobListingMutation>
export type SendJobListingMutationResult = Apollo.MutationResult<SendJobListingMutation>
export type SendJobListingMutationOptions = Apollo.BaseMutationOptions<
  SendJobListingMutation,
  SendJobListingMutationVariables
>
export const ShareJobListingDocument = gql`
  mutation ShareJobListing($input: SendJobListingInput!) {
    SendJobListing(input: $input) {
      email
      recipients
      publicListingId
      message
    }
  }
`
export type ShareJobListingMutationFn = Apollo.MutationFunction<
  ShareJobListingMutation,
  ShareJobListingMutationVariables
>

/**
 * __useShareJobListingMutation__
 *
 * To run a mutation, you first call `useShareJobListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareJobListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareJobListingMutation, { data, loading, error }] = useShareJobListingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareJobListingMutation(
  baseOptions?: Apollo.MutationHookOptions<ShareJobListingMutation, ShareJobListingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ShareJobListingMutation, ShareJobListingMutationVariables>(ShareJobListingDocument, options)
}
export type ShareJobListingMutationHookResult = ReturnType<typeof useShareJobListingMutation>
export type ShareJobListingMutationResult = Apollo.MutationResult<ShareJobListingMutation>
export type ShareJobListingMutationOptions = Apollo.BaseMutationOptions<
  ShareJobListingMutation,
  ShareJobListingMutationVariables
>
export const UpsertExternalJobApplicationDocument = gql`
  mutation UpsertExternalJobApplication($input: ExternalApplicationInput!) {
    UpsertExternalJobApplication(input: $input) {
      id
    }
  }
`
export type UpsertExternalJobApplicationMutationFn = Apollo.MutationFunction<
  UpsertExternalJobApplicationMutation,
  UpsertExternalJobApplicationMutationVariables
>

/**
 * __useUpsertExternalJobApplicationMutation__
 *
 * To run a mutation, you first call `useUpsertExternalJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertExternalJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertExternalJobApplicationMutation, { data, loading, error }] = useUpsertExternalJobApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertExternalJobApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertExternalJobApplicationMutation,
    UpsertExternalJobApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertExternalJobApplicationMutation, UpsertExternalJobApplicationMutationVariables>(
    UpsertExternalJobApplicationDocument,
    options,
  )
}
export type UpsertExternalJobApplicationMutationHookResult = ReturnType<typeof useUpsertExternalJobApplicationMutation>
export type UpsertExternalJobApplicationMutationResult = Apollo.MutationResult<UpsertExternalJobApplicationMutation>
export type UpsertExternalJobApplicationMutationOptions = Apollo.BaseMutationOptions<
  UpsertExternalJobApplicationMutation,
  UpsertExternalJobApplicationMutationVariables
>
export const VerifyEmailCodeDocument = gql`
  mutation VerifyEmailCode($input: VerifyEmailCodeInput!) {
    VerifyEmailCode(input: $input) {
      EmailVerification {
        activeStatus
        createdAt
        emailVerified
        emailAddress
        id
        isPrimary
        scalisUserId
        updatedAt
      }
    }
  }
`
export type VerifyEmailCodeMutationFn = Apollo.MutationFunction<
  VerifyEmailCodeMutation,
  VerifyEmailCodeMutationVariables
>

/**
 * __useVerifyEmailCodeMutation__
 *
 * To run a mutation, you first call `useVerifyEmailCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailCodeMutation, { data, loading, error }] = useVerifyEmailCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyEmailCodeMutation, VerifyEmailCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<VerifyEmailCodeMutation, VerifyEmailCodeMutationVariables>(VerifyEmailCodeDocument, options)
}
export type VerifyEmailCodeMutationHookResult = ReturnType<typeof useVerifyEmailCodeMutation>
export type VerifyEmailCodeMutationResult = Apollo.MutationResult<VerifyEmailCodeMutation>
export type VerifyEmailCodeMutationOptions = Apollo.BaseMutationOptions<
  VerifyEmailCodeMutation,
  VerifyEmailCodeMutationVariables
>
export const WithdrawApplicationDocument = gql`
  mutation WithdrawApplication($input: DeleteCandidateApplicationInput!) {
    DeleteCandidateApplication(input: $input) {
      id
    }
  }
`
export type WithdrawApplicationMutationFn = Apollo.MutationFunction<
  WithdrawApplicationMutation,
  WithdrawApplicationMutationVariables
>

/**
 * __useWithdrawApplicationMutation__
 *
 * To run a mutation, you first call `useWithdrawApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawApplicationMutation, { data, loading, error }] = useWithdrawApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<WithdrawApplicationMutation, WithdrawApplicationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<WithdrawApplicationMutation, WithdrawApplicationMutationVariables>(
    WithdrawApplicationDocument,
    options,
  )
}
export type WithdrawApplicationMutationHookResult = ReturnType<typeof useWithdrawApplicationMutation>
export type WithdrawApplicationMutationResult = Apollo.MutationResult<WithdrawApplicationMutation>
export type WithdrawApplicationMutationOptions = Apollo.BaseMutationOptions<
  WithdrawApplicationMutation,
  WithdrawApplicationMutationVariables
>
export const CreateChatV2Document = gql`
  mutation CreateChatV2($input: CreateChatV2Input!) {
    CreateChatV2(input: $input) {
      coUserId
      scUserId
      chatId
    }
  }
`
export type CreateChatV2MutationFn = Apollo.MutationFunction<CreateChatV2Mutation, CreateChatV2MutationVariables>

/**
 * __useCreateChatV2Mutation__
 *
 * To run a mutation, you first call `useCreateChatV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatV2Mutation, { data, loading, error }] = useCreateChatV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatV2Mutation(
  baseOptions?: Apollo.MutationHookOptions<CreateChatV2Mutation, CreateChatV2MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateChatV2Mutation, CreateChatV2MutationVariables>(CreateChatV2Document, options)
}
export type CreateChatV2MutationHookResult = ReturnType<typeof useCreateChatV2Mutation>
export type CreateChatV2MutationResult = Apollo.MutationResult<CreateChatV2Mutation>
export type CreateChatV2MutationOptions = Apollo.BaseMutationOptions<
  CreateChatV2Mutation,
  CreateChatV2MutationVariables
>
export const GenerateKnockTokenDocument = gql`
  mutation GenerateKnockToken($input: GenerateKnockTokenInput) {
    GenerateKnockToken(input: $input) {
      token
    }
  }
`
export type GenerateKnockTokenMutationFn = Apollo.MutationFunction<
  GenerateKnockTokenMutation,
  GenerateKnockTokenMutationVariables
>

/**
 * __useGenerateKnockTokenMutation__
 *
 * To run a mutation, you first call `useGenerateKnockTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateKnockTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateKnockTokenMutation, { data, loading, error }] = useGenerateKnockTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateKnockTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<GenerateKnockTokenMutation, GenerateKnockTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GenerateKnockTokenMutation, GenerateKnockTokenMutationVariables>(
    GenerateKnockTokenDocument,
    options,
  )
}
export type GenerateKnockTokenMutationHookResult = ReturnType<typeof useGenerateKnockTokenMutation>
export type GenerateKnockTokenMutationResult = Apollo.MutationResult<GenerateKnockTokenMutation>
export type GenerateKnockTokenMutationOptions = Apollo.BaseMutationOptions<
  GenerateKnockTokenMutation,
  GenerateKnockTokenMutationVariables
>
export const IdentifyKnockUserDocument = gql`
  mutation IdentifyKnockUser($input: IdentifyKnockUserInput!) {
    IdentifyKnockUser(input: $input) {
      success
    }
  }
`
export type IdentifyKnockUserMutationFn = Apollo.MutationFunction<
  IdentifyKnockUserMutation,
  IdentifyKnockUserMutationVariables
>

/**
 * __useIdentifyKnockUserMutation__
 *
 * To run a mutation, you first call `useIdentifyKnockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdentifyKnockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [identifyKnockUserMutation, { data, loading, error }] = useIdentifyKnockUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIdentifyKnockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<IdentifyKnockUserMutation, IdentifyKnockUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IdentifyKnockUserMutation, IdentifyKnockUserMutationVariables>(
    IdentifyKnockUserDocument,
    options,
  )
}
export type IdentifyKnockUserMutationHookResult = ReturnType<typeof useIdentifyKnockUserMutation>
export type IdentifyKnockUserMutationResult = Apollo.MutationResult<IdentifyKnockUserMutation>
export type IdentifyKnockUserMutationOptions = Apollo.BaseMutationOptions<
  IdentifyKnockUserMutation,
  IdentifyKnockUserMutationVariables
>
export const CancelScheduleReportDocument = gql`
  mutation CancelScheduleReport($input: CancelScheduledReportInput!) {
    CancelScheduledReport(input: $input) {
      id
    }
  }
`
export type CancelScheduleReportMutationFn = Apollo.MutationFunction<
  CancelScheduleReportMutation,
  CancelScheduleReportMutationVariables
>

/**
 * __useCancelScheduleReportMutation__
 *
 * To run a mutation, you first call `useCancelScheduleReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduleReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduleReportMutation, { data, loading, error }] = useCancelScheduleReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelScheduleReportMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelScheduleReportMutation, CancelScheduleReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CancelScheduleReportMutation, CancelScheduleReportMutationVariables>(
    CancelScheduleReportDocument,
    options,
  )
}
export type CancelScheduleReportMutationHookResult = ReturnType<typeof useCancelScheduleReportMutation>
export type CancelScheduleReportMutationResult = Apollo.MutationResult<CancelScheduleReportMutation>
export type CancelScheduleReportMutationOptions = Apollo.BaseMutationOptions<
  CancelScheduleReportMutation,
  CancelScheduleReportMutationVariables
>
export const CreateFavoriteReportDocument = gql`
  mutation CreateFavoriteReport($input: FavoriteReportInput!) {
    CreateFavoriteReport(input: $input) {
      id
      coreReportId
      CoreReport {
        ...CoreReport
      }
    }
  }
  ${CoreReportFragmentDoc}
`
export type CreateFavoriteReportMutationFn = Apollo.MutationFunction<
  CreateFavoriteReportMutation,
  CreateFavoriteReportMutationVariables
>

/**
 * __useCreateFavoriteReportMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteReportMutation, { data, loading, error }] = useCreateFavoriteReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoriteReportMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFavoriteReportMutation, CreateFavoriteReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFavoriteReportMutation, CreateFavoriteReportMutationVariables>(
    CreateFavoriteReportDocument,
    options,
  )
}
export type CreateFavoriteReportMutationHookResult = ReturnType<typeof useCreateFavoriteReportMutation>
export type CreateFavoriteReportMutationResult = Apollo.MutationResult<CreateFavoriteReportMutation>
export type CreateFavoriteReportMutationOptions = Apollo.BaseMutationOptions<
  CreateFavoriteReportMutation,
  CreateFavoriteReportMutationVariables
>
export const CreateScheduleReportDocument = gql`
  mutation CreateScheduleReport($input: CreateScheduledReportInput!) {
    ScheduleReport(input: $input) {
      CoreReport {
        ...CoreReport
        ScheduledReport {
          ...ScheduledReport
        }
      }
    }
  }
  ${CoreReportFragmentDoc}
  ${ScheduledReportFragmentDoc}
`
export type CreateScheduleReportMutationFn = Apollo.MutationFunction<
  CreateScheduleReportMutation,
  CreateScheduleReportMutationVariables
>

/**
 * __useCreateScheduleReportMutation__
 *
 * To run a mutation, you first call `useCreateScheduleReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleReportMutation, { data, loading, error }] = useCreateScheduleReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleReportMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateScheduleReportMutation, CreateScheduleReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateScheduleReportMutation, CreateScheduleReportMutationVariables>(
    CreateScheduleReportDocument,
    options,
  )
}
export type CreateScheduleReportMutationHookResult = ReturnType<typeof useCreateScheduleReportMutation>
export type CreateScheduleReportMutationResult = Apollo.MutationResult<CreateScheduleReportMutation>
export type CreateScheduleReportMutationOptions = Apollo.BaseMutationOptions<
  CreateScheduleReportMutation,
  CreateScheduleReportMutationVariables
>
export const CreateSharedReportDocument = gql`
  mutation CreateSharedReport($input: SharedReportInput!) {
    CreateSharedReport(input: $input) {
      ...SharedCoreReport
      createdAt
    }
  }
  ${SharedCoreReportFragmentDoc}
`
export type CreateSharedReportMutationFn = Apollo.MutationFunction<
  CreateSharedReportMutation,
  CreateSharedReportMutationVariables
>

/**
 * __useCreateSharedReportMutation__
 *
 * To run a mutation, you first call `useCreateSharedReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedReportMutation, { data, loading, error }] = useCreateSharedReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSharedReportMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSharedReportMutation, CreateSharedReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSharedReportMutation, CreateSharedReportMutationVariables>(
    CreateSharedReportDocument,
    options,
  )
}
export type CreateSharedReportMutationHookResult = ReturnType<typeof useCreateSharedReportMutation>
export type CreateSharedReportMutationResult = Apollo.MutationResult<CreateSharedReportMutation>
export type CreateSharedReportMutationOptions = Apollo.BaseMutationOptions<
  CreateSharedReportMutation,
  CreateSharedReportMutationVariables
>
export const DeleteFavoriteReportDocument = gql`
  mutation DeleteFavoriteReport($input: FavoriteReportInput!) {
    DeleteFavoriteReport(input: $input) {
      id
      coreReportId
      CoreReport {
        ...CoreReport
      }
    }
  }
  ${CoreReportFragmentDoc}
`
export type DeleteFavoriteReportMutationFn = Apollo.MutationFunction<
  DeleteFavoriteReportMutation,
  DeleteFavoriteReportMutationVariables
>

/**
 * __useDeleteFavoriteReportMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteReportMutation, { data, loading, error }] = useDeleteFavoriteReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFavoriteReportMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFavoriteReportMutation, DeleteFavoriteReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFavoriteReportMutation, DeleteFavoriteReportMutationVariables>(
    DeleteFavoriteReportDocument,
    options,
  )
}
export type DeleteFavoriteReportMutationHookResult = ReturnType<typeof useDeleteFavoriteReportMutation>
export type DeleteFavoriteReportMutationResult = Apollo.MutationResult<DeleteFavoriteReportMutation>
export type DeleteFavoriteReportMutationOptions = Apollo.BaseMutationOptions<
  DeleteFavoriteReportMutation,
  DeleteFavoriteReportMutationVariables
>
export const DeleteSharedReportDocument = gql`
  mutation DeleteSharedReport($input: SharedReportInput!) {
    DeleteSharedReport(input: $input)
  }
`
export type DeleteSharedReportMutationFn = Apollo.MutationFunction<
  DeleteSharedReportMutation,
  DeleteSharedReportMutationVariables
>

/**
 * __useDeleteSharedReportMutation__
 *
 * To run a mutation, you first call `useDeleteSharedReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSharedReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSharedReportMutation, { data, loading, error }] = useDeleteSharedReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSharedReportMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSharedReportMutation, DeleteSharedReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSharedReportMutation, DeleteSharedReportMutationVariables>(
    DeleteSharedReportDocument,
    options,
  )
}
export type DeleteSharedReportMutationHookResult = ReturnType<typeof useDeleteSharedReportMutation>
export type DeleteSharedReportMutationResult = Apollo.MutationResult<DeleteSharedReportMutation>
export type DeleteSharedReportMutationOptions = Apollo.BaseMutationOptions<
  DeleteSharedReportMutation,
  DeleteSharedReportMutationVariables
>
export const UpdateScheduleReportDocument = gql`
  mutation UpdateScheduleReport($input: UpdateScheduledReportInput!) {
    UpdateScheduledReport(input: $input) {
      CoreReport {
        ...CoreReport
        ScheduledReport {
          ...ScheduledReport
        }
      }
    }
  }
  ${CoreReportFragmentDoc}
  ${ScheduledReportFragmentDoc}
`
export type UpdateScheduleReportMutationFn = Apollo.MutationFunction<
  UpdateScheduleReportMutation,
  UpdateScheduleReportMutationVariables
>

/**
 * __useUpdateScheduleReportMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleReportMutation, { data, loading, error }] = useUpdateScheduleReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleReportMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateScheduleReportMutation, UpdateScheduleReportMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateScheduleReportMutation, UpdateScheduleReportMutationVariables>(
    UpdateScheduleReportDocument,
    options,
  )
}
export type UpdateScheduleReportMutationHookResult = ReturnType<typeof useUpdateScheduleReportMutation>
export type UpdateScheduleReportMutationResult = Apollo.MutationResult<UpdateScheduleReportMutation>
export type UpdateScheduleReportMutationOptions = Apollo.BaseMutationOptions<
  UpdateScheduleReportMutation,
  UpdateScheduleReportMutationVariables
>
export const DeleteRequisitionDocument = gql`
  mutation DeleteRequisition($input: DeleteRequisitionInput!) {
    DeleteRequisition(input: $input) {
      id
    }
  }
`
export type DeleteRequisitionMutationFn = Apollo.MutationFunction<
  DeleteRequisitionMutation,
  DeleteRequisitionMutationVariables
>

/**
 * __useDeleteRequisitionMutation__
 *
 * To run a mutation, you first call `useDeleteRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequisitionMutation, { data, loading, error }] = useDeleteRequisitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRequisitionMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteRequisitionMutation, DeleteRequisitionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteRequisitionMutation, DeleteRequisitionMutationVariables>(
    DeleteRequisitionDocument,
    options,
  )
}
export type DeleteRequisitionMutationHookResult = ReturnType<typeof useDeleteRequisitionMutation>
export type DeleteRequisitionMutationResult = Apollo.MutationResult<DeleteRequisitionMutation>
export type DeleteRequisitionMutationOptions = Apollo.BaseMutationOptions<
  DeleteRequisitionMutation,
  DeleteRequisitionMutationVariables
>
export const DeleteRequisitionJobDescriptionDocument = gql`
  mutation DeleteRequisitionJobDescription($input: DeleteRequisitionJobDescriptionInput!) {
    DeleteRequisitionJobDescription(input: $input) {
      id
    }
  }
`
export type DeleteRequisitionJobDescriptionMutationFn = Apollo.MutationFunction<
  DeleteRequisitionJobDescriptionMutation,
  DeleteRequisitionJobDescriptionMutationVariables
>

/**
 * __useDeleteRequisitionJobDescriptionMutation__
 *
 * To run a mutation, you first call `useDeleteRequisitionJobDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequisitionJobDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequisitionJobDescriptionMutation, { data, loading, error }] = useDeleteRequisitionJobDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRequisitionJobDescriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRequisitionJobDescriptionMutation,
    DeleteRequisitionJobDescriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteRequisitionJobDescriptionMutation, DeleteRequisitionJobDescriptionMutationVariables>(
    DeleteRequisitionJobDescriptionDocument,
    options,
  )
}
export type DeleteRequisitionJobDescriptionMutationHookResult = ReturnType<
  typeof useDeleteRequisitionJobDescriptionMutation
>
export type DeleteRequisitionJobDescriptionMutationResult =
  Apollo.MutationResult<DeleteRequisitionJobDescriptionMutation>
export type DeleteRequisitionJobDescriptionMutationOptions = Apollo.BaseMutationOptions<
  DeleteRequisitionJobDescriptionMutation,
  DeleteRequisitionJobDescriptionMutationVariables
>
export const DeleteTemplateJobDescriptionDocument = gql`
  mutation DeleteTemplateJobDescription($input: DeleteTemplateJobDescriptionInput!) {
    DeleteTemplateJobDescription(input: $input) {
      id
    }
  }
`
export type DeleteTemplateJobDescriptionMutationFn = Apollo.MutationFunction<
  DeleteTemplateJobDescriptionMutation,
  DeleteTemplateJobDescriptionMutationVariables
>

/**
 * __useDeleteTemplateJobDescriptionMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateJobDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateJobDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateJobDescriptionMutation, { data, loading, error }] = useDeleteTemplateJobDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplateJobDescriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTemplateJobDescriptionMutation,
    DeleteTemplateJobDescriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTemplateJobDescriptionMutation, DeleteTemplateJobDescriptionMutationVariables>(
    DeleteTemplateJobDescriptionDocument,
    options,
  )
}
export type DeleteTemplateJobDescriptionMutationHookResult = ReturnType<typeof useDeleteTemplateJobDescriptionMutation>
export type DeleteTemplateJobDescriptionMutationResult = Apollo.MutationResult<DeleteTemplateJobDescriptionMutation>
export type DeleteTemplateJobDescriptionMutationOptions = Apollo.BaseMutationOptions<
  DeleteTemplateJobDescriptionMutation,
  DeleteTemplateJobDescriptionMutationVariables
>
export const UpsertRequisitionJobDescriptionDocument = gql`
  mutation UpsertRequisitionJobDescription($input: UpsertRequisitionJobDescriptionInput!) {
    UpsertRequisitionJobDescription(input: $input) {
      ...RequisitionJobDescriptionFragment
    }
  }
  ${RequisitionJobDescriptionFragmentFragmentDoc}
`
export type UpsertRequisitionJobDescriptionMutationFn = Apollo.MutationFunction<
  UpsertRequisitionJobDescriptionMutation,
  UpsertRequisitionJobDescriptionMutationVariables
>

/**
 * __useUpsertRequisitionJobDescriptionMutation__
 *
 * To run a mutation, you first call `useUpsertRequisitionJobDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRequisitionJobDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRequisitionJobDescriptionMutation, { data, loading, error }] = useUpsertRequisitionJobDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertRequisitionJobDescriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertRequisitionJobDescriptionMutation,
    UpsertRequisitionJobDescriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertRequisitionJobDescriptionMutation, UpsertRequisitionJobDescriptionMutationVariables>(
    UpsertRequisitionJobDescriptionDocument,
    options,
  )
}
export type UpsertRequisitionJobDescriptionMutationHookResult = ReturnType<
  typeof useUpsertRequisitionJobDescriptionMutation
>
export type UpsertRequisitionJobDescriptionMutationResult =
  Apollo.MutationResult<UpsertRequisitionJobDescriptionMutation>
export type UpsertRequisitionJobDescriptionMutationOptions = Apollo.BaseMutationOptions<
  UpsertRequisitionJobDescriptionMutation,
  UpsertRequisitionJobDescriptionMutationVariables
>
export const UpsertTemplateJobDescriptionDocument = gql`
  mutation UpsertTemplateJobDescription($input: UpsertTemplateJobDescriptionInput!) {
    UpsertTemplateJobDescription(input: $input) {
      id
      name
      description
      companyDepartmentId
    }
  }
`
export type UpsertTemplateJobDescriptionMutationFn = Apollo.MutationFunction<
  UpsertTemplateJobDescriptionMutation,
  UpsertTemplateJobDescriptionMutationVariables
>

/**
 * __useUpsertTemplateJobDescriptionMutation__
 *
 * To run a mutation, you first call `useUpsertTemplateJobDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTemplateJobDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTemplateJobDescriptionMutation, { data, loading, error }] = useUpsertTemplateJobDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTemplateJobDescriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertTemplateJobDescriptionMutation,
    UpsertTemplateJobDescriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertTemplateJobDescriptionMutation, UpsertTemplateJobDescriptionMutationVariables>(
    UpsertTemplateJobDescriptionDocument,
    options,
  )
}
export type UpsertTemplateJobDescriptionMutationHookResult = ReturnType<typeof useUpsertTemplateJobDescriptionMutation>
export type UpsertTemplateJobDescriptionMutationResult = Apollo.MutationResult<UpsertTemplateJobDescriptionMutation>
export type UpsertTemplateJobDescriptionMutationOptions = Apollo.BaseMutationOptions<
  UpsertTemplateJobDescriptionMutation,
  UpsertTemplateJobDescriptionMutationVariables
>
export const DeleteJobOpeningDocument = gql`
  mutation DeleteJobOpening($input: DeleteJobOpeningInput!) {
    DeleteJobOpening(input: $input) {
      id
    }
  }
`
export type DeleteJobOpeningMutationFn = Apollo.MutationFunction<
  DeleteJobOpeningMutation,
  DeleteJobOpeningMutationVariables
>

/**
 * __useDeleteJobOpeningMutation__
 *
 * To run a mutation, you first call `useDeleteJobOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobOpeningMutation, { data, loading, error }] = useDeleteJobOpeningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobOpeningMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteJobOpeningMutation, DeleteJobOpeningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteJobOpeningMutation, DeleteJobOpeningMutationVariables>(
    DeleteJobOpeningDocument,
    options,
  )
}
export type DeleteJobOpeningMutationHookResult = ReturnType<typeof useDeleteJobOpeningMutation>
export type DeleteJobOpeningMutationResult = Apollo.MutationResult<DeleteJobOpeningMutation>
export type DeleteJobOpeningMutationOptions = Apollo.BaseMutationOptions<
  DeleteJobOpeningMutation,
  DeleteJobOpeningMutationVariables
>
export const UpsertJobOpeningDocument = gql`
  mutation UpsertJobOpening($input: UpsertJobOpeningInput!) {
    UpsertJobOpening(input: $input) {
      ...JobOpening
    }
  }
  ${JobOpeningFragmentDoc}
`
export type UpsertJobOpeningMutationFn = Apollo.MutationFunction<
  UpsertJobOpeningMutation,
  UpsertJobOpeningMutationVariables
>

/**
 * __useUpsertJobOpeningMutation__
 *
 * To run a mutation, you first call `useUpsertJobOpeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertJobOpeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertJobOpeningMutation, { data, loading, error }] = useUpsertJobOpeningMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertJobOpeningMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertJobOpeningMutation, UpsertJobOpeningMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertJobOpeningMutation, UpsertJobOpeningMutationVariables>(
    UpsertJobOpeningDocument,
    options,
  )
}
export type UpsertJobOpeningMutationHookResult = ReturnType<typeof useUpsertJobOpeningMutation>
export type UpsertJobOpeningMutationResult = Apollo.MutationResult<UpsertJobOpeningMutation>
export type UpsertJobOpeningMutationOptions = Apollo.BaseMutationOptions<
  UpsertJobOpeningMutation,
  UpsertJobOpeningMutationVariables
>
export const DeleteRequisitionSkillDocument = gql`
  mutation DeleteRequisitionSkill($input: DeleteRequisitionSkillInput!) {
    DeleteRequisitionSkill(input: $input) {
      id
    }
  }
`
export type DeleteRequisitionSkillMutationFn = Apollo.MutationFunction<
  DeleteRequisitionSkillMutation,
  DeleteRequisitionSkillMutationVariables
>

/**
 * __useDeleteRequisitionSkillMutation__
 *
 * To run a mutation, you first call `useDeleteRequisitionSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequisitionSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequisitionSkillMutation, { data, loading, error }] = useDeleteRequisitionSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRequisitionSkillMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteRequisitionSkillMutation, DeleteRequisitionSkillMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteRequisitionSkillMutation, DeleteRequisitionSkillMutationVariables>(
    DeleteRequisitionSkillDocument,
    options,
  )
}
export type DeleteRequisitionSkillMutationHookResult = ReturnType<typeof useDeleteRequisitionSkillMutation>
export type DeleteRequisitionSkillMutationResult = Apollo.MutationResult<DeleteRequisitionSkillMutation>
export type DeleteRequisitionSkillMutationOptions = Apollo.BaseMutationOptions<
  DeleteRequisitionSkillMutation,
  DeleteRequisitionSkillMutationVariables
>
export const UpsertRequisitionSkillDocument = gql`
  mutation UpsertRequisitionSkill($input: UpsertRequisitionSkillInput!) {
    UpsertRequisitionSkill(input: $input) {
      ...RequisitionSkillsFragment
    }
  }
  ${RequisitionSkillsFragmentFragmentDoc}
`
export type UpsertRequisitionSkillMutationFn = Apollo.MutationFunction<
  UpsertRequisitionSkillMutation,
  UpsertRequisitionSkillMutationVariables
>

/**
 * __useUpsertRequisitionSkillMutation__
 *
 * To run a mutation, you first call `useUpsertRequisitionSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRequisitionSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRequisitionSkillMutation, { data, loading, error }] = useUpsertRequisitionSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertRequisitionSkillMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertRequisitionSkillMutation, UpsertRequisitionSkillMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertRequisitionSkillMutation, UpsertRequisitionSkillMutationVariables>(
    UpsertRequisitionSkillDocument,
    options,
  )
}
export type UpsertRequisitionSkillMutationHookResult = ReturnType<typeof useUpsertRequisitionSkillMutation>
export type UpsertRequisitionSkillMutationResult = Apollo.MutationResult<UpsertRequisitionSkillMutation>
export type UpsertRequisitionSkillMutationOptions = Apollo.BaseMutationOptions<
  UpsertRequisitionSkillMutation,
  UpsertRequisitionSkillMutationVariables
>
export const DeleteJobListingScreeningQuestionDocument = gql`
  mutation DeleteJobListingScreeningQuestion($input: DeleteJobListingScreeningQuestionInput!) {
    DeleteJobListingScreeningQuestion(input: $input) {
      id
    }
  }
`
export type DeleteJobListingScreeningQuestionMutationFn = Apollo.MutationFunction<
  DeleteJobListingScreeningQuestionMutation,
  DeleteJobListingScreeningQuestionMutationVariables
>

/**
 * __useDeleteJobListingScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteJobListingScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobListingScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobListingScreeningQuestionMutation, { data, loading, error }] = useDeleteJobListingScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobListingScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteJobListingScreeningQuestionMutation,
    DeleteJobListingScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteJobListingScreeningQuestionMutation,
    DeleteJobListingScreeningQuestionMutationVariables
  >(DeleteJobListingScreeningQuestionDocument, options)
}
export type DeleteJobListingScreeningQuestionMutationHookResult = ReturnType<
  typeof useDeleteJobListingScreeningQuestionMutation
>
export type DeleteJobListingScreeningQuestionMutationResult =
  Apollo.MutationResult<DeleteJobListingScreeningQuestionMutation>
export type DeleteJobListingScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  DeleteJobListingScreeningQuestionMutation,
  DeleteJobListingScreeningQuestionMutationVariables
>
export const DeleteScreeningQuestionDocument = gql`
  mutation DeleteScreeningQuestion($input: DeleteScreeningQuestionInput!) {
    DeleteScreeningQuestion(input: $input) {
      id
    }
  }
`
export type DeleteScreeningQuestionMutationFn = Apollo.MutationFunction<
  DeleteScreeningQuestionMutation,
  DeleteScreeningQuestionMutationVariables
>

/**
 * __useDeleteScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScreeningQuestionMutation, { data, loading, error }] = useDeleteScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteScreeningQuestionMutation, DeleteScreeningQuestionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteScreeningQuestionMutation, DeleteScreeningQuestionMutationVariables>(
    DeleteScreeningQuestionDocument,
    options,
  )
}
export type DeleteScreeningQuestionMutationHookResult = ReturnType<typeof useDeleteScreeningQuestionMutation>
export type DeleteScreeningQuestionMutationResult = Apollo.MutationResult<DeleteScreeningQuestionMutation>
export type DeleteScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  DeleteScreeningQuestionMutation,
  DeleteScreeningQuestionMutationVariables
>
export const UpsertJobListingScreeningQuestionDocument = gql`
  mutation UpsertJobListingScreeningQuestion($input: UpsertJobListingScreeningQuestionInput!) {
    UpsertJobListingScreeningQuestion(input: $input) {
      ...JobListingScreeningQuestionFragment
      ScreeningQuestion {
        ...ScreeningQuestionFragment
      }
    }
  }
  ${JobListingScreeningQuestionFragmentFragmentDoc}
  ${ScreeningQuestionFragmentFragmentDoc}
`
export type UpsertJobListingScreeningQuestionMutationFn = Apollo.MutationFunction<
  UpsertJobListingScreeningQuestionMutation,
  UpsertJobListingScreeningQuestionMutationVariables
>

/**
 * __useUpsertJobListingScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useUpsertJobListingScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertJobListingScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertJobListingScreeningQuestionMutation, { data, loading, error }] = useUpsertJobListingScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertJobListingScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertJobListingScreeningQuestionMutation,
    UpsertJobListingScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpsertJobListingScreeningQuestionMutation,
    UpsertJobListingScreeningQuestionMutationVariables
  >(UpsertJobListingScreeningQuestionDocument, options)
}
export type UpsertJobListingScreeningQuestionMutationHookResult = ReturnType<
  typeof useUpsertJobListingScreeningQuestionMutation
>
export type UpsertJobListingScreeningQuestionMutationResult =
  Apollo.MutationResult<UpsertJobListingScreeningQuestionMutation>
export type UpsertJobListingScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  UpsertJobListingScreeningQuestionMutation,
  UpsertJobListingScreeningQuestionMutationVariables
>
export const UpsertScreeningQuestionDocument = gql`
  mutation UpsertScreeningQuestion($input: UpsertScreeningQuestionInput!) {
    UpsertScreeningQuestion(input: $input) {
      ...ScreeningQuestionFragment
    }
  }
  ${ScreeningQuestionFragmentFragmentDoc}
`
export type UpsertScreeningQuestionMutationFn = Apollo.MutationFunction<
  UpsertScreeningQuestionMutation,
  UpsertScreeningQuestionMutationVariables
>

/**
 * __useUpsertScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useUpsertScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertScreeningQuestionMutation, { data, loading, error }] = useUpsertScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertScreeningQuestionMutation, UpsertScreeningQuestionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertScreeningQuestionMutation, UpsertScreeningQuestionMutationVariables>(
    UpsertScreeningQuestionDocument,
    options,
  )
}
export type UpsertScreeningQuestionMutationHookResult = ReturnType<typeof useUpsertScreeningQuestionMutation>
export type UpsertScreeningQuestionMutationResult = Apollo.MutationResult<UpsertScreeningQuestionMutation>
export type UpsertScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  UpsertScreeningQuestionMutation,
  UpsertScreeningQuestionMutationVariables
>
export const UpdateRequisitionApplicabilityDocument = gql`
  mutation UpdateRequisitionApplicability($id: Int, $jobListings: [UpsertJobListingInput!]) {
    UpsertRequisition(input: { id: $id, jobListings: $jobListings }) {
      __typename
      id
      JobListing {
        __typename
        id
        acceptingCandidates
      }
    }
  }
`
export type UpdateRequisitionApplicabilityMutationFn = Apollo.MutationFunction<
  UpdateRequisitionApplicabilityMutation,
  UpdateRequisitionApplicabilityMutationVariables
>

/**
 * __useUpdateRequisitionApplicabilityMutation__
 *
 * To run a mutation, you first call `useUpdateRequisitionApplicabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequisitionApplicabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequisitionApplicabilityMutation, { data, loading, error }] = useUpdateRequisitionApplicabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      jobListings: // value for 'jobListings'
 *   },
 * });
 */
export function useUpdateRequisitionApplicabilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRequisitionApplicabilityMutation,
    UpdateRequisitionApplicabilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateRequisitionApplicabilityMutation, UpdateRequisitionApplicabilityMutationVariables>(
    UpdateRequisitionApplicabilityDocument,
    options,
  )
}
export type UpdateRequisitionApplicabilityMutationHookResult = ReturnType<
  typeof useUpdateRequisitionApplicabilityMutation
>
export type UpdateRequisitionApplicabilityMutationResult = Apollo.MutationResult<UpdateRequisitionApplicabilityMutation>
export type UpdateRequisitionApplicabilityMutationOptions = Apollo.BaseMutationOptions<
  UpdateRequisitionApplicabilityMutation,
  UpdateRequisitionApplicabilityMutationVariables
>
export const UpsertRequisitionDocument = gql`
  mutation UpsertRequisition($input: UpsertRequisitionInput!) {
    UpsertRequisition(input: $input) {
      ...RequisitionFragment
      JobOpening {
        ...JobOpening
      }
      RequisitionJobDescription {
        ...RequisitionJobDescriptionFragment
      }
      RequisitionSkills {
        ...RequisitionSkillsFragment
      }
      JobListing {
        ...JobListingFragment
        Address {
          ...AddressFragment
        }
        JobListingScreeningQuestion {
          ...JobListingScreeningQuestionFragment
          ScreeningQuestion {
            ...ScreeningQuestionFragment
          }
        }
        deletedAt
      }
      JobPipeline {
        ...JobPipelineFragment
        TemplatePipeline {
          ...TemplatePipelineFragment
          TemplateMilestones {
            ...TemplateMilestone
            TemplateStage {
              ...TemplateStage
            }
          }
        }
      }
      HiringTeamMember {
        ...HiringTeamMemberFragment
        CompanyUser {
          ...CompanyUserFragment
          UserInvitation {
            ...UserInvitationFragment
            ScalisUser {
              ...ScalisUser
            }
          }
        }
      }
      CandidateCollaborator {
        ...CandidateCollaboratorFragment
      }
      StageCollaborator {
        ...StageCollaboratorFragment
      }
    }
  }
  ${RequisitionFragmentFragmentDoc}
  ${JobOpeningFragmentDoc}
  ${RequisitionJobDescriptionFragmentFragmentDoc}
  ${RequisitionSkillsFragmentFragmentDoc}
  ${JobListingFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${JobListingScreeningQuestionFragmentFragmentDoc}
  ${ScreeningQuestionFragmentFragmentDoc}
  ${JobPipelineFragmentFragmentDoc}
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
  ${HiringTeamMemberFragmentFragmentDoc}
  ${CompanyUserFragmentFragmentDoc}
  ${UserInvitationFragmentFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${CandidateCollaboratorFragmentFragmentDoc}
  ${StageCollaboratorFragmentFragmentDoc}
`
export type UpsertRequisitionMutationFn = Apollo.MutationFunction<
  UpsertRequisitionMutation,
  UpsertRequisitionMutationVariables
>

/**
 * __useUpsertRequisitionMutation__
 *
 * To run a mutation, you first call `useUpsertRequisitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRequisitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRequisitionMutation, { data, loading, error }] = useUpsertRequisitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertRequisitionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertRequisitionMutation, UpsertRequisitionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertRequisitionMutation, UpsertRequisitionMutationVariables>(
    UpsertRequisitionDocument,
    options,
  )
}
export type UpsertRequisitionMutationHookResult = ReturnType<typeof useUpsertRequisitionMutation>
export type UpsertRequisitionMutationResult = Apollo.MutationResult<UpsertRequisitionMutation>
export type UpsertRequisitionMutationOptions = Apollo.BaseMutationOptions<
  UpsertRequisitionMutation,
  UpsertRequisitionMutationVariables
>
export const CreateScalisUserUploadedDocumentDocument = gql`
  mutation CreateScalisUserUploadedDocument($input: CreateScalisUserUploadedDocumentInput!) {
    CreateScalisUserUploadedDocument(input: $input) {
      id
      documentPath
      documentName
      documentType
    }
  }
`
export type CreateScalisUserUploadedDocumentMutationFn = Apollo.MutationFunction<
  CreateScalisUserUploadedDocumentMutation,
  CreateScalisUserUploadedDocumentMutationVariables
>

/**
 * __useCreateScalisUserUploadedDocumentMutation__
 *
 * To run a mutation, you first call `useCreateScalisUserUploadedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScalisUserUploadedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScalisUserUploadedDocumentMutation, { data, loading, error }] = useCreateScalisUserUploadedDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScalisUserUploadedDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScalisUserUploadedDocumentMutation,
    CreateScalisUserUploadedDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateScalisUserUploadedDocumentMutation,
    CreateScalisUserUploadedDocumentMutationVariables
  >(CreateScalisUserUploadedDocumentDocument, options)
}
export type CreateScalisUserUploadedDocumentMutationHookResult = ReturnType<
  typeof useCreateScalisUserUploadedDocumentMutation
>
export type CreateScalisUserUploadedDocumentMutationResult =
  Apollo.MutationResult<CreateScalisUserUploadedDocumentMutation>
export type CreateScalisUserUploadedDocumentMutationOptions = Apollo.BaseMutationOptions<
  CreateScalisUserUploadedDocumentMutation,
  CreateScalisUserUploadedDocumentMutationVariables
>
export const DeleteScalisUserUploadedDocumentDocument = gql`
  mutation DeleteScalisUserUploadedDocument($input: DeleteScalisUserUploadedDocumentInput!) {
    DeleteScalisUserUploadedDocument(input: $input) {
      success
    }
  }
`
export type DeleteScalisUserUploadedDocumentMutationFn = Apollo.MutationFunction<
  DeleteScalisUserUploadedDocumentMutation,
  DeleteScalisUserUploadedDocumentMutationVariables
>

/**
 * __useDeleteScalisUserUploadedDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteScalisUserUploadedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScalisUserUploadedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScalisUserUploadedDocumentMutation, { data, loading, error }] = useDeleteScalisUserUploadedDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteScalisUserUploadedDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteScalisUserUploadedDocumentMutation,
    DeleteScalisUserUploadedDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteScalisUserUploadedDocumentMutation,
    DeleteScalisUserUploadedDocumentMutationVariables
  >(DeleteScalisUserUploadedDocumentDocument, options)
}
export type DeleteScalisUserUploadedDocumentMutationHookResult = ReturnType<
  typeof useDeleteScalisUserUploadedDocumentMutation
>
export type DeleteScalisUserUploadedDocumentMutationResult =
  Apollo.MutationResult<DeleteScalisUserUploadedDocumentMutation>
export type DeleteScalisUserUploadedDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteScalisUserUploadedDocumentMutation,
  DeleteScalisUserUploadedDocumentMutationVariables
>
export const UpdateSchedulerLinkSettingsDocument = gql`
  mutation UpdateSchedulerLinkSettings($input: UpdateSchedulerLinkSettingsInput!) {
    UpdateSchedulerLinkSettings(input: $input) {
      id
      minimumHour
      rollingDays
      maxInterviewsPerDay
    }
  }
`
export type UpdateSchedulerLinkSettingsMutationFn = Apollo.MutationFunction<
  UpdateSchedulerLinkSettingsMutation,
  UpdateSchedulerLinkSettingsMutationVariables
>

/**
 * __useUpdateSchedulerLinkSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSchedulerLinkSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchedulerLinkSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchedulerLinkSettingsMutation, { data, loading, error }] = useUpdateSchedulerLinkSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchedulerLinkSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchedulerLinkSettingsMutation,
    UpdateSchedulerLinkSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSchedulerLinkSettingsMutation, UpdateSchedulerLinkSettingsMutationVariables>(
    UpdateSchedulerLinkSettingsDocument,
    options,
  )
}
export type UpdateSchedulerLinkSettingsMutationHookResult = ReturnType<typeof useUpdateSchedulerLinkSettingsMutation>
export type UpdateSchedulerLinkSettingsMutationResult = Apollo.MutationResult<UpdateSchedulerLinkSettingsMutation>
export type UpdateSchedulerLinkSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchedulerLinkSettingsMutation,
  UpdateSchedulerLinkSettingsMutationVariables
>
export const DeleteScorecardTemplateDocument = gql`
  mutation DeleteScorecardTemplate($input: DeleteScorecardTemplateInput!) {
    DeleteScorecardTemplate(input: $input) {
      id
    }
  }
`
export type DeleteScorecardTemplateMutationFn = Apollo.MutationFunction<
  DeleteScorecardTemplateMutation,
  DeleteScorecardTemplateMutationVariables
>

/**
 * __useDeleteScorecardTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteScorecardTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScorecardTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScorecardTemplateMutation, { data, loading, error }] = useDeleteScorecardTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteScorecardTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteScorecardTemplateMutation, DeleteScorecardTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteScorecardTemplateMutation, DeleteScorecardTemplateMutationVariables>(
    DeleteScorecardTemplateDocument,
    options,
  )
}
export type DeleteScorecardTemplateMutationHookResult = ReturnType<typeof useDeleteScorecardTemplateMutation>
export type DeleteScorecardTemplateMutationResult = Apollo.MutationResult<DeleteScorecardTemplateMutation>
export type DeleteScorecardTemplateMutationOptions = Apollo.BaseMutationOptions<
  DeleteScorecardTemplateMutation,
  DeleteScorecardTemplateMutationVariables
>
export const ToggleScorecardTemplateArchiveDocument = gql`
  mutation ToggleScorecardTemplateArchive($input: ToggleScorecardTemplateArchiveInput!) {
    ToggleScorecardTemplateArchive(input: $input) {
      id
      scorecardName
      archived
      department
      companyId
      createdAt
    }
  }
`
export type ToggleScorecardTemplateArchiveMutationFn = Apollo.MutationFunction<
  ToggleScorecardTemplateArchiveMutation,
  ToggleScorecardTemplateArchiveMutationVariables
>

/**
 * __useToggleScorecardTemplateArchiveMutation__
 *
 * To run a mutation, you first call `useToggleScorecardTemplateArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleScorecardTemplateArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleScorecardTemplateArchiveMutation, { data, loading, error }] = useToggleScorecardTemplateArchiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleScorecardTemplateArchiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleScorecardTemplateArchiveMutation,
    ToggleScorecardTemplateArchiveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ToggleScorecardTemplateArchiveMutation, ToggleScorecardTemplateArchiveMutationVariables>(
    ToggleScorecardTemplateArchiveDocument,
    options,
  )
}
export type ToggleScorecardTemplateArchiveMutationHookResult = ReturnType<
  typeof useToggleScorecardTemplateArchiveMutation
>
export type ToggleScorecardTemplateArchiveMutationResult = Apollo.MutationResult<ToggleScorecardTemplateArchiveMutation>
export type ToggleScorecardTemplateArchiveMutationOptions = Apollo.BaseMutationOptions<
  ToggleScorecardTemplateArchiveMutation,
  ToggleScorecardTemplateArchiveMutationVariables
>
export const UpsertScorecardTemplateDocument = gql`
  mutation UpsertScorecardTemplate($input: UpsertScorecardTemplateInput!) {
    UpsertScorecardTemplate(input: $input) {
      id
      scorecardName
      scorecardDescription
      visible
      department
      companyId
      createdAt
    }
  }
`
export type UpsertScorecardTemplateMutationFn = Apollo.MutationFunction<
  UpsertScorecardTemplateMutation,
  UpsertScorecardTemplateMutationVariables
>

/**
 * __useUpsertScorecardTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertScorecardTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertScorecardTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertScorecardTemplateMutation, { data, loading, error }] = useUpsertScorecardTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertScorecardTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertScorecardTemplateMutation, UpsertScorecardTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertScorecardTemplateMutation, UpsertScorecardTemplateMutationVariables>(
    UpsertScorecardTemplateDocument,
    options,
  )
}
export type UpsertScorecardTemplateMutationHookResult = ReturnType<typeof useUpsertScorecardTemplateMutation>
export type UpsertScorecardTemplateMutationResult = Apollo.MutationResult<UpsertScorecardTemplateMutation>
export type UpsertScorecardTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpsertScorecardTemplateMutation,
  UpsertScorecardTemplateMutationVariables
>
export const CreateTemplateScreeningQuestionDocument = gql`
  mutation CreateTemplateScreeningQuestion($input: CreateTemplateScreeningQuestionInput!) {
    CreateTemplateScreeningQuestion(input: $input) {
      id
      questionTitle
      questionDesc
      questionType
      minVal
      maxVal
      valStatus
      ansOptions
      isRejectionQuestion
      rejectMessage
      preferredAnswer
      preferredAnswerType
      multipleSelectPreferredAnswers
      selectionDisplay
      isTemplateQuestion
      createdAt
      updatedAt
    }
  }
`
export type CreateTemplateScreeningQuestionMutationFn = Apollo.MutationFunction<
  CreateTemplateScreeningQuestionMutation,
  CreateTemplateScreeningQuestionMutationVariables
>

/**
 * __useCreateTemplateScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useCreateTemplateScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateScreeningQuestionMutation, { data, loading, error }] = useCreateTemplateScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTemplateScreeningQuestionMutation,
    CreateTemplateScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTemplateScreeningQuestionMutation, CreateTemplateScreeningQuestionMutationVariables>(
    CreateTemplateScreeningQuestionDocument,
    options,
  )
}
export type CreateTemplateScreeningQuestionMutationHookResult = ReturnType<
  typeof useCreateTemplateScreeningQuestionMutation
>
export type CreateTemplateScreeningQuestionMutationResult =
  Apollo.MutationResult<CreateTemplateScreeningQuestionMutation>
export type CreateTemplateScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  CreateTemplateScreeningQuestionMutation,
  CreateTemplateScreeningQuestionMutationVariables
>
export const EditTemplateScreeningQuestionDocument = gql`
  mutation EditTemplateScreeningQuestion($input: EditTemplateScreeningQuestionInput!) {
    editTemplateScreeningQuestion(input: $input) {
      id
      questionTitle
      questionDesc
      questionType
      minVal
      maxVal
      valStatus
      ansOptions
      isRejectionQuestion
      rejectMessage
      preferredAnswer
      preferredAnswerType
      multipleSelectPreferredAnswers
      selectionDisplay
      isTemplateQuestion
      createdAt
      updatedAt
    }
  }
`
export type EditTemplateScreeningQuestionMutationFn = Apollo.MutationFunction<
  EditTemplateScreeningQuestionMutation,
  EditTemplateScreeningQuestionMutationVariables
>

/**
 * __useEditTemplateScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useEditTemplateScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTemplateScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTemplateScreeningQuestionMutation, { data, loading, error }] = useEditTemplateScreeningQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTemplateScreeningQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditTemplateScreeningQuestionMutation,
    EditTemplateScreeningQuestionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditTemplateScreeningQuestionMutation, EditTemplateScreeningQuestionMutationVariables>(
    EditTemplateScreeningQuestionDocument,
    options,
  )
}
export type EditTemplateScreeningQuestionMutationHookResult = ReturnType<
  typeof useEditTemplateScreeningQuestionMutation
>
export type EditTemplateScreeningQuestionMutationResult = Apollo.MutationResult<EditTemplateScreeningQuestionMutation>
export type EditTemplateScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<
  EditTemplateScreeningQuestionMutation,
  EditTemplateScreeningQuestionMutationVariables
>
export const CreateSequenceScheduleSettingDocument = gql`
  mutation CreateSequenceScheduleSetting($input: CreateSequenceScheduleSettingInput!) {
    CreateSequenceScheduleSetting(input: $input) {
      ...SequenceScheduleSetting
    }
  }
  ${SequenceScheduleSettingFragmentDoc}
`
export type CreateSequenceScheduleSettingMutationFn = Apollo.MutationFunction<
  CreateSequenceScheduleSettingMutation,
  CreateSequenceScheduleSettingMutationVariables
>

/**
 * __useCreateSequenceScheduleSettingMutation__
 *
 * To run a mutation, you first call `useCreateSequenceScheduleSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSequenceScheduleSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSequenceScheduleSettingMutation, { data, loading, error }] = useCreateSequenceScheduleSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSequenceScheduleSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSequenceScheduleSettingMutation,
    CreateSequenceScheduleSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSequenceScheduleSettingMutation, CreateSequenceScheduleSettingMutationVariables>(
    CreateSequenceScheduleSettingDocument,
    options,
  )
}
export type CreateSequenceScheduleSettingMutationHookResult = ReturnType<
  typeof useCreateSequenceScheduleSettingMutation
>
export type CreateSequenceScheduleSettingMutationResult = Apollo.MutationResult<CreateSequenceScheduleSettingMutation>
export type CreateSequenceScheduleSettingMutationOptions = Apollo.BaseMutationOptions<
  CreateSequenceScheduleSettingMutation,
  CreateSequenceScheduleSettingMutationVariables
>
export const DeleteSequenceScheduleSettingDocument = gql`
  mutation DeleteSequenceScheduleSetting($input: DeleteSequenceScheduleSettingInput!) {
    DeleteSequenceScheduleSetting(input: $input) {
      message
      success
    }
  }
`
export type DeleteSequenceScheduleSettingMutationFn = Apollo.MutationFunction<
  DeleteSequenceScheduleSettingMutation,
  DeleteSequenceScheduleSettingMutationVariables
>

/**
 * __useDeleteSequenceScheduleSettingMutation__
 *
 * To run a mutation, you first call `useDeleteSequenceScheduleSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSequenceScheduleSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSequenceScheduleSettingMutation, { data, loading, error }] = useDeleteSequenceScheduleSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSequenceScheduleSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSequenceScheduleSettingMutation,
    DeleteSequenceScheduleSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSequenceScheduleSettingMutation, DeleteSequenceScheduleSettingMutationVariables>(
    DeleteSequenceScheduleSettingDocument,
    options,
  )
}
export type DeleteSequenceScheduleSettingMutationHookResult = ReturnType<
  typeof useDeleteSequenceScheduleSettingMutation
>
export type DeleteSequenceScheduleSettingMutationResult = Apollo.MutationResult<DeleteSequenceScheduleSettingMutation>
export type DeleteSequenceScheduleSettingMutationOptions = Apollo.BaseMutationOptions<
  DeleteSequenceScheduleSettingMutation,
  DeleteSequenceScheduleSettingMutationVariables
>
export const MarkDefaultSequenceScheduleSettingDocument = gql`
  mutation MarkDefaultSequenceScheduleSetting($input: MarkDefaultSequenceScheduleSettingInput!) {
    MarkDefaultSequenceScheduleSetting(input: $input) {
      ...SequenceScheduleSetting
    }
  }
  ${SequenceScheduleSettingFragmentDoc}
`
export type MarkDefaultSequenceScheduleSettingMutationFn = Apollo.MutationFunction<
  MarkDefaultSequenceScheduleSettingMutation,
  MarkDefaultSequenceScheduleSettingMutationVariables
>

/**
 * __useMarkDefaultSequenceScheduleSettingMutation__
 *
 * To run a mutation, you first call `useMarkDefaultSequenceScheduleSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkDefaultSequenceScheduleSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markDefaultSequenceScheduleSettingMutation, { data, loading, error }] = useMarkDefaultSequenceScheduleSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkDefaultSequenceScheduleSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkDefaultSequenceScheduleSettingMutation,
    MarkDefaultSequenceScheduleSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    MarkDefaultSequenceScheduleSettingMutation,
    MarkDefaultSequenceScheduleSettingMutationVariables
  >(MarkDefaultSequenceScheduleSettingDocument, options)
}
export type MarkDefaultSequenceScheduleSettingMutationHookResult = ReturnType<
  typeof useMarkDefaultSequenceScheduleSettingMutation
>
export type MarkDefaultSequenceScheduleSettingMutationResult =
  Apollo.MutationResult<MarkDefaultSequenceScheduleSettingMutation>
export type MarkDefaultSequenceScheduleSettingMutationOptions = Apollo.BaseMutationOptions<
  MarkDefaultSequenceScheduleSettingMutation,
  MarkDefaultSequenceScheduleSettingMutationVariables
>
export const UpdateSequenceScheduleSettingDocument = gql`
  mutation UpdateSequenceScheduleSetting($input: UpdateSequenceScheduleSettingInput!) {
    UpdateSequenceScheduleSetting(input: $input) {
      ...SequenceScheduleSetting
    }
  }
  ${SequenceScheduleSettingFragmentDoc}
`
export type UpdateSequenceScheduleSettingMutationFn = Apollo.MutationFunction<
  UpdateSequenceScheduleSettingMutation,
  UpdateSequenceScheduleSettingMutationVariables
>

/**
 * __useUpdateSequenceScheduleSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSequenceScheduleSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSequenceScheduleSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSequenceScheduleSettingMutation, { data, loading, error }] = useUpdateSequenceScheduleSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSequenceScheduleSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSequenceScheduleSettingMutation,
    UpdateSequenceScheduleSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSequenceScheduleSettingMutation, UpdateSequenceScheduleSettingMutationVariables>(
    UpdateSequenceScheduleSettingDocument,
    options,
  )
}
export type UpdateSequenceScheduleSettingMutationHookResult = ReturnType<
  typeof useUpdateSequenceScheduleSettingMutation
>
export type UpdateSequenceScheduleSettingMutationResult = Apollo.MutationResult<UpdateSequenceScheduleSettingMutation>
export type UpdateSequenceScheduleSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateSequenceScheduleSettingMutation,
  UpdateSequenceScheduleSettingMutationVariables
>
export const UpdateSequenceSettingDocument = gql`
  mutation UpdateSequenceSetting($input: UpdateSequenceSettingInput!) {
    UpdateSequenceSetting(input: $input) {
      ...SequenceSetting
    }
  }
  ${SequenceSettingFragmentDoc}
`
export type UpdateSequenceSettingMutationFn = Apollo.MutationFunction<
  UpdateSequenceSettingMutation,
  UpdateSequenceSettingMutationVariables
>

/**
 * __useUpdateSequenceSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSequenceSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSequenceSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSequenceSettingMutation, { data, loading, error }] = useUpdateSequenceSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSequenceSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSequenceSettingMutation, UpdateSequenceSettingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSequenceSettingMutation, UpdateSequenceSettingMutationVariables>(
    UpdateSequenceSettingDocument,
    options,
  )
}
export type UpdateSequenceSettingMutationHookResult = ReturnType<typeof useUpdateSequenceSettingMutation>
export type UpdateSequenceSettingMutationResult = Apollo.MutationResult<UpdateSequenceSettingMutation>
export type UpdateSequenceSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateSequenceSettingMutation,
  UpdateSequenceSettingMutationVariables
>
export const AddStepToSequenceDocument = gql`
  mutation AddStepToSequence($input: CreateSequenceStepInput!, $sequenceId: String!) {
    AddStepToSequence(input: $input, sequenceId: $sequenceId) {
      ...SequenceStep
    }
  }
  ${SequenceStepFragmentDoc}
`
export type AddStepToSequenceMutationFn = Apollo.MutationFunction<
  AddStepToSequenceMutation,
  AddStepToSequenceMutationVariables
>

/**
 * __useAddStepToSequenceMutation__
 *
 * To run a mutation, you first call `useAddStepToSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStepToSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStepToSequenceMutation, { data, loading, error }] = useAddStepToSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useAddStepToSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<AddStepToSequenceMutation, AddStepToSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AddStepToSequenceMutation, AddStepToSequenceMutationVariables>(
    AddStepToSequenceDocument,
    options,
  )
}
export type AddStepToSequenceMutationHookResult = ReturnType<typeof useAddStepToSequenceMutation>
export type AddStepToSequenceMutationResult = Apollo.MutationResult<AddStepToSequenceMutation>
export type AddStepToSequenceMutationOptions = Apollo.BaseMutationOptions<
  AddStepToSequenceMutation,
  AddStepToSequenceMutationVariables
>
export const DeleteSequenceStepDocument = gql`
  mutation DeleteSequenceStep($input: MutationDeleteSequenceStepInput!) {
    DeleteSequenceStep(input: $input)
  }
`
export type DeleteSequenceStepMutationFn = Apollo.MutationFunction<
  DeleteSequenceStepMutation,
  DeleteSequenceStepMutationVariables
>

/**
 * __useDeleteSequenceStepMutation__
 *
 * To run a mutation, you first call `useDeleteSequenceStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSequenceStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSequenceStepMutation, { data, loading, error }] = useDeleteSequenceStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSequenceStepMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSequenceStepMutation, DeleteSequenceStepMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSequenceStepMutation, DeleteSequenceStepMutationVariables>(
    DeleteSequenceStepDocument,
    options,
  )
}
export type DeleteSequenceStepMutationHookResult = ReturnType<typeof useDeleteSequenceStepMutation>
export type DeleteSequenceStepMutationResult = Apollo.MutationResult<DeleteSequenceStepMutation>
export type DeleteSequenceStepMutationOptions = Apollo.BaseMutationOptions<
  DeleteSequenceStepMutation,
  DeleteSequenceStepMutationVariables
>
export const UpdateSequenceStepDocument = gql`
  mutation UpdateSequenceStep($input: UpdateSequenceStepInput!) {
    UpdateSequenceStep(input: $input) {
      ...SequenceStep
    }
  }
  ${SequenceStepFragmentDoc}
`
export type UpdateSequenceStepMutationFn = Apollo.MutationFunction<
  UpdateSequenceStepMutation,
  UpdateSequenceStepMutationVariables
>

/**
 * __useUpdateSequenceStepMutation__
 *
 * To run a mutation, you first call `useUpdateSequenceStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSequenceStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSequenceStepMutation, { data, loading, error }] = useUpdateSequenceStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSequenceStepMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSequenceStepMutation, UpdateSequenceStepMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSequenceStepMutation, UpdateSequenceStepMutationVariables>(
    UpdateSequenceStepDocument,
    options,
  )
}
export type UpdateSequenceStepMutationHookResult = ReturnType<typeof useUpdateSequenceStepMutation>
export type UpdateSequenceStepMutationResult = Apollo.MutationResult<UpdateSequenceStepMutation>
export type UpdateSequenceStepMutationOptions = Apollo.BaseMutationOptions<
  UpdateSequenceStepMutation,
  UpdateSequenceStepMutationVariables
>
export const ArchiveSequenceDocument = gql`
  mutation ArchiveSequence($input: ArchiveSequenceInput!) {
    ArchiveSequence(input: $input) {
      message
      success
    }
  }
`
export type ArchiveSequenceMutationFn = Apollo.MutationFunction<
  ArchiveSequenceMutation,
  ArchiveSequenceMutationVariables
>

/**
 * __useArchiveSequenceMutation__
 *
 * To run a mutation, you first call `useArchiveSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSequenceMutation, { data, loading, error }] = useArchiveSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveSequenceMutation, ArchiveSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ArchiveSequenceMutation, ArchiveSequenceMutationVariables>(ArchiveSequenceDocument, options)
}
export type ArchiveSequenceMutationHookResult = ReturnType<typeof useArchiveSequenceMutation>
export type ArchiveSequenceMutationResult = Apollo.MutationResult<ArchiveSequenceMutation>
export type ArchiveSequenceMutationOptions = Apollo.BaseMutationOptions<
  ArchiveSequenceMutation,
  ArchiveSequenceMutationVariables
>
export const BulkEnrollCandidatesInSequenceDocument = gql`
  mutation BulkEnrollCandidatesInSequence($input: BulkEnrollCandidatesInSequenceInput!) {
    BulkEnrollCandidatesInSequence(input: $input) {
      count
      message
      success
    }
  }
`
export type BulkEnrollCandidatesInSequenceMutationFn = Apollo.MutationFunction<
  BulkEnrollCandidatesInSequenceMutation,
  BulkEnrollCandidatesInSequenceMutationVariables
>

/**
 * __useBulkEnrollCandidatesInSequenceMutation__
 *
 * To run a mutation, you first call `useBulkEnrollCandidatesInSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEnrollCandidatesInSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEnrollCandidatesInSequenceMutation, { data, loading, error }] = useBulkEnrollCandidatesInSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkEnrollCandidatesInSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkEnrollCandidatesInSequenceMutation,
    BulkEnrollCandidatesInSequenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<BulkEnrollCandidatesInSequenceMutation, BulkEnrollCandidatesInSequenceMutationVariables>(
    BulkEnrollCandidatesInSequenceDocument,
    options,
  )
}
export type BulkEnrollCandidatesInSequenceMutationHookResult = ReturnType<
  typeof useBulkEnrollCandidatesInSequenceMutation
>
export type BulkEnrollCandidatesInSequenceMutationResult = Apollo.MutationResult<BulkEnrollCandidatesInSequenceMutation>
export type BulkEnrollCandidatesInSequenceMutationOptions = Apollo.BaseMutationOptions<
  BulkEnrollCandidatesInSequenceMutation,
  BulkEnrollCandidatesInSequenceMutationVariables
>
export const BulkUnenrollCandidatesFromSequenceDocument = gql`
  mutation BulkUnenrollCandidatesFromSequence($input: BulkUnenrollCandidatesFromSequenceInput!) {
    BulkUnenrollCandidatesFromSequence(input: $input) {
      count
      message
      success
    }
  }
`
export type BulkUnenrollCandidatesFromSequenceMutationFn = Apollo.MutationFunction<
  BulkUnenrollCandidatesFromSequenceMutation,
  BulkUnenrollCandidatesFromSequenceMutationVariables
>

/**
 * __useBulkUnenrollCandidatesFromSequenceMutation__
 *
 * To run a mutation, you first call `useBulkUnenrollCandidatesFromSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnenrollCandidatesFromSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnenrollCandidatesFromSequenceMutation, { data, loading, error }] = useBulkUnenrollCandidatesFromSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUnenrollCandidatesFromSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUnenrollCandidatesFromSequenceMutation,
    BulkUnenrollCandidatesFromSequenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkUnenrollCandidatesFromSequenceMutation,
    BulkUnenrollCandidatesFromSequenceMutationVariables
  >(BulkUnenrollCandidatesFromSequenceDocument, options)
}
export type BulkUnenrollCandidatesFromSequenceMutationHookResult = ReturnType<
  typeof useBulkUnenrollCandidatesFromSequenceMutation
>
export type BulkUnenrollCandidatesFromSequenceMutationResult =
  Apollo.MutationResult<BulkUnenrollCandidatesFromSequenceMutation>
export type BulkUnenrollCandidatesFromSequenceMutationOptions = Apollo.BaseMutationOptions<
  BulkUnenrollCandidatesFromSequenceMutation,
  BulkUnenrollCandidatesFromSequenceMutationVariables
>
export const BulkUpdateSequenceCandidateStatusDocument = gql`
  mutation BulkUpdateSequenceCandidateStatus($input: BulkUpdateSequenceCandidateStatusInput!) {
    BulkUpdateSequenceCandidateStatus(input: $input) {
      count
      message
      success
    }
  }
`
export type BulkUpdateSequenceCandidateStatusMutationFn = Apollo.MutationFunction<
  BulkUpdateSequenceCandidateStatusMutation,
  BulkUpdateSequenceCandidateStatusMutationVariables
>

/**
 * __useBulkUpdateSequenceCandidateStatusMutation__
 *
 * To run a mutation, you first call `useBulkUpdateSequenceCandidateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateSequenceCandidateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateSequenceCandidateStatusMutation, { data, loading, error }] = useBulkUpdateSequenceCandidateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateSequenceCandidateStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUpdateSequenceCandidateStatusMutation,
    BulkUpdateSequenceCandidateStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkUpdateSequenceCandidateStatusMutation,
    BulkUpdateSequenceCandidateStatusMutationVariables
  >(BulkUpdateSequenceCandidateStatusDocument, options)
}
export type BulkUpdateSequenceCandidateStatusMutationHookResult = ReturnType<
  typeof useBulkUpdateSequenceCandidateStatusMutation
>
export type BulkUpdateSequenceCandidateStatusMutationResult =
  Apollo.MutationResult<BulkUpdateSequenceCandidateStatusMutation>
export type BulkUpdateSequenceCandidateStatusMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateSequenceCandidateStatusMutation,
  BulkUpdateSequenceCandidateStatusMutationVariables
>
export const CreateFavoriteSequenceDocument = gql`
  mutation CreateFavoriteSequence($input: CreateFavoriteSequenceInput!) {
    CreateFavoriteSequence(input: $input) {
      ...Sequence
    }
  }
  ${SequenceFragmentDoc}
`
export type CreateFavoriteSequenceMutationFn = Apollo.MutationFunction<
  CreateFavoriteSequenceMutation,
  CreateFavoriteSequenceMutationVariables
>

/**
 * __useCreateFavoriteSequenceMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteSequenceMutation, { data, loading, error }] = useCreateFavoriteSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoriteSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFavoriteSequenceMutation, CreateFavoriteSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFavoriteSequenceMutation, CreateFavoriteSequenceMutationVariables>(
    CreateFavoriteSequenceDocument,
    options,
  )
}
export type CreateFavoriteSequenceMutationHookResult = ReturnType<typeof useCreateFavoriteSequenceMutation>
export type CreateFavoriteSequenceMutationResult = Apollo.MutationResult<CreateFavoriteSequenceMutation>
export type CreateFavoriteSequenceMutationOptions = Apollo.BaseMutationOptions<
  CreateFavoriteSequenceMutation,
  CreateFavoriteSequenceMutationVariables
>
export const CreateSequenceDocument = gql`
  mutation CreateSequence($input: CreateSequenceInput!) {
    CreateSequence(input: $input) {
      ...Sequence
    }
  }
  ${SequenceFragmentDoc}
`
export type CreateSequenceMutationFn = Apollo.MutationFunction<CreateSequenceMutation, CreateSequenceMutationVariables>

/**
 * __useCreateSequenceMutation__
 *
 * To run a mutation, you first call `useCreateSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSequenceMutation, { data, loading, error }] = useCreateSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSequenceMutation, CreateSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSequenceMutation, CreateSequenceMutationVariables>(CreateSequenceDocument, options)
}
export type CreateSequenceMutationHookResult = ReturnType<typeof useCreateSequenceMutation>
export type CreateSequenceMutationResult = Apollo.MutationResult<CreateSequenceMutation>
export type CreateSequenceMutationOptions = Apollo.BaseMutationOptions<
  CreateSequenceMutation,
  CreateSequenceMutationVariables
>
export const DeleteFavoriteSequenceDocument = gql`
  mutation DeleteFavoriteSequence($input: DeleteFavoriteSequenceInput!) {
    DeleteFavoriteSequence(input: $input) {
      ...Sequence
    }
  }
  ${SequenceFragmentDoc}
`
export type DeleteFavoriteSequenceMutationFn = Apollo.MutationFunction<
  DeleteFavoriteSequenceMutation,
  DeleteFavoriteSequenceMutationVariables
>

/**
 * __useDeleteFavoriteSequenceMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteSequenceMutation, { data, loading, error }] = useDeleteFavoriteSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFavoriteSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFavoriteSequenceMutation, DeleteFavoriteSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFavoriteSequenceMutation, DeleteFavoriteSequenceMutationVariables>(
    DeleteFavoriteSequenceDocument,
    options,
  )
}
export type DeleteFavoriteSequenceMutationHookResult = ReturnType<typeof useDeleteFavoriteSequenceMutation>
export type DeleteFavoriteSequenceMutationResult = Apollo.MutationResult<DeleteFavoriteSequenceMutation>
export type DeleteFavoriteSequenceMutationOptions = Apollo.BaseMutationOptions<
  DeleteFavoriteSequenceMutation,
  DeleteFavoriteSequenceMutationVariables
>
export const DeleteSequenceDocument = gql`
  mutation DeleteSequence($input: SequenceOperationInput!) {
    DeleteSequence(input: $input) {
      message
      success
    }
  }
`
export type DeleteSequenceMutationFn = Apollo.MutationFunction<DeleteSequenceMutation, DeleteSequenceMutationVariables>

/**
 * __useDeleteSequenceMutation__
 *
 * To run a mutation, you first call `useDeleteSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSequenceMutation, { data, loading, error }] = useDeleteSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSequenceMutation, DeleteSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSequenceMutation, DeleteSequenceMutationVariables>(DeleteSequenceDocument, options)
}
export type DeleteSequenceMutationHookResult = ReturnType<typeof useDeleteSequenceMutation>
export type DeleteSequenceMutationResult = Apollo.MutationResult<DeleteSequenceMutation>
export type DeleteSequenceMutationOptions = Apollo.BaseMutationOptions<
  DeleteSequenceMutation,
  DeleteSequenceMutationVariables
>
export const PauseSequenceDocument = gql`
  mutation PauseSequence($input: SequenceOperationInput!) {
    PauseSequence(input: $input) {
      message
      success
    }
  }
`
export type PauseSequenceMutationFn = Apollo.MutationFunction<PauseSequenceMutation, PauseSequenceMutationVariables>

/**
 * __usePauseSequenceMutation__
 *
 * To run a mutation, you first call `usePauseSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSequenceMutation, { data, loading, error }] = usePauseSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<PauseSequenceMutation, PauseSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<PauseSequenceMutation, PauseSequenceMutationVariables>(PauseSequenceDocument, options)
}
export type PauseSequenceMutationHookResult = ReturnType<typeof usePauseSequenceMutation>
export type PauseSequenceMutationResult = Apollo.MutationResult<PauseSequenceMutation>
export type PauseSequenceMutationOptions = Apollo.BaseMutationOptions<
  PauseSequenceMutation,
  PauseSequenceMutationVariables
>
export const ResumeSequenceDocument = gql`
  mutation ResumeSequence($input: SequenceOperationInput!) {
    ResumeSequence(input: $input) {
      message
      success
    }
  }
`
export type ResumeSequenceMutationFn = Apollo.MutationFunction<ResumeSequenceMutation, ResumeSequenceMutationVariables>

/**
 * __useResumeSequenceMutation__
 *
 * To run a mutation, you first call `useResumeSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSequenceMutation, { data, loading, error }] = useResumeSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<ResumeSequenceMutation, ResumeSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResumeSequenceMutation, ResumeSequenceMutationVariables>(ResumeSequenceDocument, options)
}
export type ResumeSequenceMutationHookResult = ReturnType<typeof useResumeSequenceMutation>
export type ResumeSequenceMutationResult = Apollo.MutationResult<ResumeSequenceMutation>
export type ResumeSequenceMutationOptions = Apollo.BaseMutationOptions<
  ResumeSequenceMutation,
  ResumeSequenceMutationVariables
>
export const UnarchiveSequenceDocument = gql`
  mutation UnarchiveSequence($input: SequenceOperationInput!) {
    UnarchiveSequence(input: $input) {
      message
      success
    }
  }
`
export type UnarchiveSequenceMutationFn = Apollo.MutationFunction<
  UnarchiveSequenceMutation,
  UnarchiveSequenceMutationVariables
>

/**
 * __useUnarchiveSequenceMutation__
 *
 * To run a mutation, you first call `useUnarchiveSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveSequenceMutation, { data, loading, error }] = useUnarchiveSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<UnarchiveSequenceMutation, UnarchiveSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UnarchiveSequenceMutation, UnarchiveSequenceMutationVariables>(
    UnarchiveSequenceDocument,
    options,
  )
}
export type UnarchiveSequenceMutationHookResult = ReturnType<typeof useUnarchiveSequenceMutation>
export type UnarchiveSequenceMutationResult = Apollo.MutationResult<UnarchiveSequenceMutation>
export type UnarchiveSequenceMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveSequenceMutation,
  UnarchiveSequenceMutationVariables
>
export const UnsubscribeCandidateFromSequenceDocument = gql`
  mutation UnsubscribeCandidateFromSequence($input: UnsubscribeCandidateFromEmailsInput!) {
    UnsubscribeCandidateFromSequence(input: $input) {
      message
      candidateProfileId
      sequenceId
    }
  }
`
export type UnsubscribeCandidateFromSequenceMutationFn = Apollo.MutationFunction<
  UnsubscribeCandidateFromSequenceMutation,
  UnsubscribeCandidateFromSequenceMutationVariables
>

/**
 * __useUnsubscribeCandidateFromSequenceMutation__
 *
 * To run a mutation, you first call `useUnsubscribeCandidateFromSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeCandidateFromSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeCandidateFromSequenceMutation, { data, loading, error }] = useUnsubscribeCandidateFromSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsubscribeCandidateFromSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnsubscribeCandidateFromSequenceMutation,
    UnsubscribeCandidateFromSequenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnsubscribeCandidateFromSequenceMutation,
    UnsubscribeCandidateFromSequenceMutationVariables
  >(UnsubscribeCandidateFromSequenceDocument, options)
}
export type UnsubscribeCandidateFromSequenceMutationHookResult = ReturnType<
  typeof useUnsubscribeCandidateFromSequenceMutation
>
export type UnsubscribeCandidateFromSequenceMutationResult =
  Apollo.MutationResult<UnsubscribeCandidateFromSequenceMutation>
export type UnsubscribeCandidateFromSequenceMutationOptions = Apollo.BaseMutationOptions<
  UnsubscribeCandidateFromSequenceMutation,
  UnsubscribeCandidateFromSequenceMutationVariables
>
export const UpdateSequenceDocument = gql`
  mutation UpdateSequence($input: UpdateSequenceInput!) {
    UpdateSequence(input: $input) {
      ...Sequence
    }
  }
  ${SequenceFragmentDoc}
`
export type UpdateSequenceMutationFn = Apollo.MutationFunction<UpdateSequenceMutation, UpdateSequenceMutationVariables>

/**
 * __useUpdateSequenceMutation__
 *
 * To run a mutation, you first call `useUpdateSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSequenceMutation, { data, loading, error }] = useUpdateSequenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSequenceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateSequenceMutation, UpdateSequenceMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateSequenceMutation, UpdateSequenceMutationVariables>(UpdateSequenceDocument, options)
}
export type UpdateSequenceMutationHookResult = ReturnType<typeof useUpdateSequenceMutation>
export type UpdateSequenceMutationResult = Apollo.MutationResult<UpdateSequenceMutation>
export type UpdateSequenceMutationOptions = Apollo.BaseMutationOptions<
  UpdateSequenceMutation,
  UpdateSequenceMutationVariables
>
export const DeleteSkillDocument = gql`
  mutation DeleteSkill($input: [DeleteSkillInput!]!) {
    DeleteSkill(input: $input)
  }
`
export type DeleteSkillMutationFn = Apollo.MutationFunction<DeleteSkillMutation, DeleteSkillMutationVariables>

/**
 * __useDeleteSkillMutation__
 *
 * To run a mutation, you first call `useDeleteSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSkillMutation, { data, loading, error }] = useDeleteSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSkillMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteSkillMutation, DeleteSkillMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteSkillMutation, DeleteSkillMutationVariables>(DeleteSkillDocument, options)
}
export type DeleteSkillMutationHookResult = ReturnType<typeof useDeleteSkillMutation>
export type DeleteSkillMutationResult = Apollo.MutationResult<DeleteSkillMutation>
export type DeleteSkillMutationOptions = Apollo.BaseMutationOptions<DeleteSkillMutation, DeleteSkillMutationVariables>
export const UpsertSkillDocument = gql`
  mutation UpsertSkill($input: [UpsertSkillInput!]!) {
    UpsertSkill(input: $input) {
      ...SkillFragment
    }
  }
  ${SkillFragmentFragmentDoc}
`
export type UpsertSkillMutationFn = Apollo.MutationFunction<UpsertSkillMutation, UpsertSkillMutationVariables>

/**
 * __useUpsertSkillMutation__
 *
 * To run a mutation, you first call `useUpsertSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSkillMutation, { data, loading, error }] = useUpsertSkillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSkillMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertSkillMutation, UpsertSkillMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertSkillMutation, UpsertSkillMutationVariables>(UpsertSkillDocument, options)
}
export type UpsertSkillMutationHookResult = ReturnType<typeof useUpsertSkillMutation>
export type UpsertSkillMutationResult = Apollo.MutationResult<UpsertSkillMutation>
export type UpsertSkillMutationOptions = Apollo.BaseMutationOptions<UpsertSkillMutation, UpsertSkillMutationVariables>
export const CreateSourceTrackingEventDocument = gql`
  mutation CreateSourceTrackingEvent($input: CreateSourceTrackingEventInput!) {
    CreateSourceTrackingEvent(input: $input)
  }
`
export type CreateSourceTrackingEventMutationFn = Apollo.MutationFunction<
  CreateSourceTrackingEventMutation,
  CreateSourceTrackingEventMutationVariables
>

/**
 * __useCreateSourceTrackingEventMutation__
 *
 * To run a mutation, you first call `useCreateSourceTrackingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourceTrackingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourceTrackingEventMutation, { data, loading, error }] = useCreateSourceTrackingEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSourceTrackingEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSourceTrackingEventMutation,
    CreateSourceTrackingEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSourceTrackingEventMutation, CreateSourceTrackingEventMutationVariables>(
    CreateSourceTrackingEventDocument,
    options,
  )
}
export type CreateSourceTrackingEventMutationHookResult = ReturnType<typeof useCreateSourceTrackingEventMutation>
export type CreateSourceTrackingEventMutationResult = Apollo.MutationResult<CreateSourceTrackingEventMutation>
export type CreateSourceTrackingEventMutationOptions = Apollo.BaseMutationOptions<
  CreateSourceTrackingEventMutation,
  CreateSourceTrackingEventMutationVariables
>
export const CreateSourceTrackingLinkDocument = gql`
  mutation CreateSourceTrackingLink($input: CreateSourceTrackingLinkInput!) {
    CreateSourceTrackingLink(input: $input) {
      ...SourceTrackingLink
    }
  }
  ${SourceTrackingLinkFragmentDoc}
`
export type CreateSourceTrackingLinkMutationFn = Apollo.MutationFunction<
  CreateSourceTrackingLinkMutation,
  CreateSourceTrackingLinkMutationVariables
>

/**
 * __useCreateSourceTrackingLinkMutation__
 *
 * To run a mutation, you first call `useCreateSourceTrackingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourceTrackingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourceTrackingLinkMutation, { data, loading, error }] = useCreateSourceTrackingLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSourceTrackingLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateSourceTrackingLinkMutation, CreateSourceTrackingLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSourceTrackingLinkMutation, CreateSourceTrackingLinkMutationVariables>(
    CreateSourceTrackingLinkDocument,
    options,
  )
}
export type CreateSourceTrackingLinkMutationHookResult = ReturnType<typeof useCreateSourceTrackingLinkMutation>
export type CreateSourceTrackingLinkMutationResult = Apollo.MutationResult<CreateSourceTrackingLinkMutation>
export type CreateSourceTrackingLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateSourceTrackingLinkMutation,
  CreateSourceTrackingLinkMutationVariables
>
export const EditSourceTrackingLinkDocument = gql`
  mutation EditSourceTrackingLink($input: EditSourceTrackingLinkInput!) {
    EditSourceTrackingLink(input: $input) {
      ...SourceTrackingLink
    }
  }
  ${SourceTrackingLinkFragmentDoc}
`
export type EditSourceTrackingLinkMutationFn = Apollo.MutationFunction<
  EditSourceTrackingLinkMutation,
  EditSourceTrackingLinkMutationVariables
>

/**
 * __useEditSourceTrackingLinkMutation__
 *
 * To run a mutation, you first call `useEditSourceTrackingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSourceTrackingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSourceTrackingLinkMutation, { data, loading, error }] = useEditSourceTrackingLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSourceTrackingLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<EditSourceTrackingLinkMutation, EditSourceTrackingLinkMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditSourceTrackingLinkMutation, EditSourceTrackingLinkMutationVariables>(
    EditSourceTrackingLinkDocument,
    options,
  )
}
export type EditSourceTrackingLinkMutationHookResult = ReturnType<typeof useEditSourceTrackingLinkMutation>
export type EditSourceTrackingLinkMutationResult = Apollo.MutationResult<EditSourceTrackingLinkMutation>
export type EditSourceTrackingLinkMutationOptions = Apollo.BaseMutationOptions<
  EditSourceTrackingLinkMutation,
  EditSourceTrackingLinkMutationVariables
>
export const DeleteStageCollaboratorDocument = gql`
  mutation DeleteStageCollaborator($input: DeleteStageCollaboratorInput!) {
    DeleteStageCollaborator(input: $input) {
      id
    }
  }
`
export type DeleteStageCollaboratorMutationFn = Apollo.MutationFunction<
  DeleteStageCollaboratorMutation,
  DeleteStageCollaboratorMutationVariables
>

/**
 * __useDeleteStageCollaboratorMutation__
 *
 * To run a mutation, you first call `useDeleteStageCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStageCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStageCollaboratorMutation, { data, loading, error }] = useDeleteStageCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStageCollaboratorMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteStageCollaboratorMutation, DeleteStageCollaboratorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteStageCollaboratorMutation, DeleteStageCollaboratorMutationVariables>(
    DeleteStageCollaboratorDocument,
    options,
  )
}
export type DeleteStageCollaboratorMutationHookResult = ReturnType<typeof useDeleteStageCollaboratorMutation>
export type DeleteStageCollaboratorMutationResult = Apollo.MutationResult<DeleteStageCollaboratorMutation>
export type DeleteStageCollaboratorMutationOptions = Apollo.BaseMutationOptions<
  DeleteStageCollaboratorMutation,
  DeleteStageCollaboratorMutationVariables
>
export const UpsertScreenStageCollaboratorDocument = gql`
  mutation UpsertScreenStageCollaborator($input: UpsertStageCollaboratorInput!) {
    UpsertStageCollaborator(input: $input) {
      ...ScreenStageCollaboratorFragment
    }
  }
  ${ScreenStageCollaboratorFragmentFragmentDoc}
`
export type UpsertScreenStageCollaboratorMutationFn = Apollo.MutationFunction<
  UpsertScreenStageCollaboratorMutation,
  UpsertScreenStageCollaboratorMutationVariables
>

/**
 * __useUpsertScreenStageCollaboratorMutation__
 *
 * To run a mutation, you first call `useUpsertScreenStageCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertScreenStageCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertScreenStageCollaboratorMutation, { data, loading, error }] = useUpsertScreenStageCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertScreenStageCollaboratorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertScreenStageCollaboratorMutation,
    UpsertScreenStageCollaboratorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertScreenStageCollaboratorMutation, UpsertScreenStageCollaboratorMutationVariables>(
    UpsertScreenStageCollaboratorDocument,
    options,
  )
}
export type UpsertScreenStageCollaboratorMutationHookResult = ReturnType<
  typeof useUpsertScreenStageCollaboratorMutation
>
export type UpsertScreenStageCollaboratorMutationResult = Apollo.MutationResult<UpsertScreenStageCollaboratorMutation>
export type UpsertScreenStageCollaboratorMutationOptions = Apollo.BaseMutationOptions<
  UpsertScreenStageCollaboratorMutation,
  UpsertScreenStageCollaboratorMutationVariables
>
export const UpsertStageCollaboratorDocument = gql`
  mutation UpsertStageCollaborator($input: UpsertStageCollaboratorInput!) {
    UpsertStageCollaborator(input: $input) {
      ...StageCollaboratorFragment
    }
  }
  ${StageCollaboratorFragmentFragmentDoc}
`
export type UpsertStageCollaboratorMutationFn = Apollo.MutationFunction<
  UpsertStageCollaboratorMutation,
  UpsertStageCollaboratorMutationVariables
>

/**
 * __useUpsertStageCollaboratorMutation__
 *
 * To run a mutation, you first call `useUpsertStageCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStageCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStageCollaboratorMutation, { data, loading, error }] = useUpsertStageCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertStageCollaboratorMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertStageCollaboratorMutation, UpsertStageCollaboratorMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertStageCollaboratorMutation, UpsertStageCollaboratorMutationVariables>(
    UpsertStageCollaboratorDocument,
    options,
  )
}
export type UpsertStageCollaboratorMutationHookResult = ReturnType<typeof useUpsertStageCollaboratorMutation>
export type UpsertStageCollaboratorMutationResult = Apollo.MutationResult<UpsertStageCollaboratorMutation>
export type UpsertStageCollaboratorMutationOptions = Apollo.BaseMutationOptions<
  UpsertStageCollaboratorMutation,
  UpsertStageCollaboratorMutationVariables
>
export const DeleteStageSettingsDocument = gql`
  mutation DeleteStageSettings($input: DeleteStageSettingsInput!) {
    DeleteStageSettings(input: $input) {
      id
    }
  }
`
export type DeleteStageSettingsMutationFn = Apollo.MutationFunction<
  DeleteStageSettingsMutation,
  DeleteStageSettingsMutationVariables
>

/**
 * __useDeleteStageSettingsMutation__
 *
 * To run a mutation, you first call `useDeleteStageSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStageSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStageSettingsMutation, { data, loading, error }] = useDeleteStageSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStageSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteStageSettingsMutation, DeleteStageSettingsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteStageSettingsMutation, DeleteStageSettingsMutationVariables>(
    DeleteStageSettingsDocument,
    options,
  )
}
export type DeleteStageSettingsMutationHookResult = ReturnType<typeof useDeleteStageSettingsMutation>
export type DeleteStageSettingsMutationResult = Apollo.MutationResult<DeleteStageSettingsMutation>
export type DeleteStageSettingsMutationOptions = Apollo.BaseMutationOptions<
  DeleteStageSettingsMutation,
  DeleteStageSettingsMutationVariables
>
export const UpsertStageSettingsDocument = gql`
  mutation UpsertStageSettings($input: UpsertStageSettingsInput!) {
    UpsertStageSettings(input: $input) {
      ...StageSettingsFragment
    }
  }
  ${StageSettingsFragmentFragmentDoc}
`
export type UpsertStageSettingsMutationFn = Apollo.MutationFunction<
  UpsertStageSettingsMutation,
  UpsertStageSettingsMutationVariables
>

/**
 * __useUpsertStageSettingsMutation__
 *
 * To run a mutation, you first call `useUpsertStageSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStageSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStageSettingsMutation, { data, loading, error }] = useUpsertStageSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertStageSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertStageSettingsMutation, UpsertStageSettingsMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertStageSettingsMutation, UpsertStageSettingsMutationVariables>(
    UpsertStageSettingsDocument,
    options,
  )
}
export type UpsertStageSettingsMutationHookResult = ReturnType<typeof useUpsertStageSettingsMutation>
export type UpsertStageSettingsMutationResult = Apollo.MutationResult<UpsertStageSettingsMutation>
export type UpsertStageSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpsertStageSettingsMutation,
  UpsertStageSettingsMutationVariables
>
export const HtmlToBase64Document = gql`
  mutation HtmlToBase64($input: HtmlToBase64Input!) {
    HtmlToBase64(input: $input) {
      pdf
    }
  }
`
export type HtmlToBase64MutationFn = Apollo.MutationFunction<HtmlToBase64Mutation, HtmlToBase64MutationVariables>

/**
 * __useHtmlToBase64Mutation__
 *
 * To run a mutation, you first call `useHtmlToBase64Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHtmlToBase64Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [htmlToBase64Mutation, { data, loading, error }] = useHtmlToBase64Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHtmlToBase64Mutation(
  baseOptions?: Apollo.MutationHookOptions<HtmlToBase64Mutation, HtmlToBase64MutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<HtmlToBase64Mutation, HtmlToBase64MutationVariables>(HtmlToBase64Document, options)
}
export type HtmlToBase64MutationHookResult = ReturnType<typeof useHtmlToBase64Mutation>
export type HtmlToBase64MutationResult = Apollo.MutationResult<HtmlToBase64Mutation>
export type HtmlToBase64MutationOptions = Apollo.BaseMutationOptions<
  HtmlToBase64Mutation,
  HtmlToBase64MutationVariables
>
export const HtmlToDocxDocument = gql`
  mutation HtmlToDocx($input: HtmlToDocxInput!) {
    HtmlToDocx(input: $input) {
      filename
      size
      url
      dir
    }
  }
`
export type HtmlToDocxMutationFn = Apollo.MutationFunction<HtmlToDocxMutation, HtmlToDocxMutationVariables>

/**
 * __useHtmlToDocxMutation__
 *
 * To run a mutation, you first call `useHtmlToDocxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHtmlToDocxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [htmlToDocxMutation, { data, loading, error }] = useHtmlToDocxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHtmlToDocxMutation(
  baseOptions?: Apollo.MutationHookOptions<HtmlToDocxMutation, HtmlToDocxMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<HtmlToDocxMutation, HtmlToDocxMutationVariables>(HtmlToDocxDocument, options)
}
export type HtmlToDocxMutationHookResult = ReturnType<typeof useHtmlToDocxMutation>
export type HtmlToDocxMutationResult = Apollo.MutationResult<HtmlToDocxMutation>
export type HtmlToDocxMutationOptions = Apollo.BaseMutationOptions<HtmlToDocxMutation, HtmlToDocxMutationVariables>
export const ArchiveTalentPoolDocument = gql`
  mutation ArchiveTalentPool($input: ArchiveTalentPoolInput!) {
    ArchiveTalentPool(input: $input) {
      ...TalentPool
    }
  }
  ${TalentPoolFragmentDoc}
`
export type ArchiveTalentPoolMutationFn = Apollo.MutationFunction<
  ArchiveTalentPoolMutation,
  ArchiveTalentPoolMutationVariables
>

/**
 * __useArchiveTalentPoolMutation__
 *
 * To run a mutation, you first call `useArchiveTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTalentPoolMutation, { data, loading, error }] = useArchiveTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<ArchiveTalentPoolMutation, ArchiveTalentPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ArchiveTalentPoolMutation, ArchiveTalentPoolMutationVariables>(
    ArchiveTalentPoolDocument,
    options,
  )
}
export type ArchiveTalentPoolMutationHookResult = ReturnType<typeof useArchiveTalentPoolMutation>
export type ArchiveTalentPoolMutationResult = Apollo.MutationResult<ArchiveTalentPoolMutation>
export type ArchiveTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  ArchiveTalentPoolMutation,
  ArchiveTalentPoolMutationVariables
>
export const BulkAddCandidatesToTalentPoolDocument = gql`
  mutation BulkAddCandidatesToTalentPool($input: BulkAddCandidatesToTalentPoolInput!) {
    BulkAddCandidatesToTalentPool(input: $input) {
      count
      message
      success
    }
  }
`
export type BulkAddCandidatesToTalentPoolMutationFn = Apollo.MutationFunction<
  BulkAddCandidatesToTalentPoolMutation,
  BulkAddCandidatesToTalentPoolMutationVariables
>

/**
 * __useBulkAddCandidatesToTalentPoolMutation__
 *
 * To run a mutation, you first call `useBulkAddCandidatesToTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddCandidatesToTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddCandidatesToTalentPoolMutation, { data, loading, error }] = useBulkAddCandidatesToTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAddCandidatesToTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkAddCandidatesToTalentPoolMutation,
    BulkAddCandidatesToTalentPoolMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<BulkAddCandidatesToTalentPoolMutation, BulkAddCandidatesToTalentPoolMutationVariables>(
    BulkAddCandidatesToTalentPoolDocument,
    options,
  )
}
export type BulkAddCandidatesToTalentPoolMutationHookResult = ReturnType<
  typeof useBulkAddCandidatesToTalentPoolMutation
>
export type BulkAddCandidatesToTalentPoolMutationResult = Apollo.MutationResult<BulkAddCandidatesToTalentPoolMutation>
export type BulkAddCandidatesToTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  BulkAddCandidatesToTalentPoolMutation,
  BulkAddCandidatesToTalentPoolMutationVariables
>
export const BulkMoveCandidatesToTalentPoolDocument = gql`
  mutation BulkMoveCandidatesToTalentPool($input: BulkMoveCandidatesToTalentPoolInput!) {
    BulkMoveCandidatesToTalentPool(input: $input) {
      count
      message
      success
    }
  }
`
export type BulkMoveCandidatesToTalentPoolMutationFn = Apollo.MutationFunction<
  BulkMoveCandidatesToTalentPoolMutation,
  BulkMoveCandidatesToTalentPoolMutationVariables
>

/**
 * __useBulkMoveCandidatesToTalentPoolMutation__
 *
 * To run a mutation, you first call `useBulkMoveCandidatesToTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMoveCandidatesToTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMoveCandidatesToTalentPoolMutation, { data, loading, error }] = useBulkMoveCandidatesToTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkMoveCandidatesToTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkMoveCandidatesToTalentPoolMutation,
    BulkMoveCandidatesToTalentPoolMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<BulkMoveCandidatesToTalentPoolMutation, BulkMoveCandidatesToTalentPoolMutationVariables>(
    BulkMoveCandidatesToTalentPoolDocument,
    options,
  )
}
export type BulkMoveCandidatesToTalentPoolMutationHookResult = ReturnType<
  typeof useBulkMoveCandidatesToTalentPoolMutation
>
export type BulkMoveCandidatesToTalentPoolMutationResult = Apollo.MutationResult<BulkMoveCandidatesToTalentPoolMutation>
export type BulkMoveCandidatesToTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  BulkMoveCandidatesToTalentPoolMutation,
  BulkMoveCandidatesToTalentPoolMutationVariables
>
export const BulkRemoveCandidatesFromTalentPoolDocument = gql`
  mutation BulkRemoveCandidatesFromTalentPool($input: BulkRemoveCandidatesFromTalentPoolInput!) {
    BulkRemoveCandidatesFromTalentPool(input: $input) {
      count
      message
      success
    }
  }
`
export type BulkRemoveCandidatesFromTalentPoolMutationFn = Apollo.MutationFunction<
  BulkRemoveCandidatesFromTalentPoolMutation,
  BulkRemoveCandidatesFromTalentPoolMutationVariables
>

/**
 * __useBulkRemoveCandidatesFromTalentPoolMutation__
 *
 * To run a mutation, you first call `useBulkRemoveCandidatesFromTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveCandidatesFromTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveCandidatesFromTalentPoolMutation, { data, loading, error }] = useBulkRemoveCandidatesFromTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkRemoveCandidatesFromTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkRemoveCandidatesFromTalentPoolMutation,
    BulkRemoveCandidatesFromTalentPoolMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkRemoveCandidatesFromTalentPoolMutation,
    BulkRemoveCandidatesFromTalentPoolMutationVariables
  >(BulkRemoveCandidatesFromTalentPoolDocument, options)
}
export type BulkRemoveCandidatesFromTalentPoolMutationHookResult = ReturnType<
  typeof useBulkRemoveCandidatesFromTalentPoolMutation
>
export type BulkRemoveCandidatesFromTalentPoolMutationResult =
  Apollo.MutationResult<BulkRemoveCandidatesFromTalentPoolMutation>
export type BulkRemoveCandidatesFromTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  BulkRemoveCandidatesFromTalentPoolMutation,
  BulkRemoveCandidatesFromTalentPoolMutationVariables
>
export const BulkUpdateCandidatesProspectOwnerDocument = gql`
  mutation BulkUpdateCandidatesProspectOwner($input: BulkUpdateCandidatesProspectOwnerInput!) {
    BulkUpdateCandidatesProspectOwner(input: $input) {
      count
      message
      message
    }
  }
`
export type BulkUpdateCandidatesProspectOwnerMutationFn = Apollo.MutationFunction<
  BulkUpdateCandidatesProspectOwnerMutation,
  BulkUpdateCandidatesProspectOwnerMutationVariables
>

/**
 * __useBulkUpdateCandidatesProspectOwnerMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCandidatesProspectOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCandidatesProspectOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCandidatesProspectOwnerMutation, { data, loading, error }] = useBulkUpdateCandidatesProspectOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateCandidatesProspectOwnerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUpdateCandidatesProspectOwnerMutation,
    BulkUpdateCandidatesProspectOwnerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkUpdateCandidatesProspectOwnerMutation,
    BulkUpdateCandidatesProspectOwnerMutationVariables
  >(BulkUpdateCandidatesProspectOwnerDocument, options)
}
export type BulkUpdateCandidatesProspectOwnerMutationHookResult = ReturnType<
  typeof useBulkUpdateCandidatesProspectOwnerMutation
>
export type BulkUpdateCandidatesProspectOwnerMutationResult =
  Apollo.MutationResult<BulkUpdateCandidatesProspectOwnerMutation>
export type BulkUpdateCandidatesProspectOwnerMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateCandidatesProspectOwnerMutation,
  BulkUpdateCandidatesProspectOwnerMutationVariables
>
export const BulkUpdateCandidatesProspectStatusDocument = gql`
  mutation BulkUpdateCandidatesProspectStatus($input: BulkUpdateCandidatesProspectStatusInput!) {
    BulkUpdateCandidatesProspectStatus(input: $input) {
      count
      message
      count
    }
  }
`
export type BulkUpdateCandidatesProspectStatusMutationFn = Apollo.MutationFunction<
  BulkUpdateCandidatesProspectStatusMutation,
  BulkUpdateCandidatesProspectStatusMutationVariables
>

/**
 * __useBulkUpdateCandidatesProspectStatusMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCandidatesProspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCandidatesProspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCandidatesProspectStatusMutation, { data, loading, error }] = useBulkUpdateCandidatesProspectStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateCandidatesProspectStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkUpdateCandidatesProspectStatusMutation,
    BulkUpdateCandidatesProspectStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BulkUpdateCandidatesProspectStatusMutation,
    BulkUpdateCandidatesProspectStatusMutationVariables
  >(BulkUpdateCandidatesProspectStatusDocument, options)
}
export type BulkUpdateCandidatesProspectStatusMutationHookResult = ReturnType<
  typeof useBulkUpdateCandidatesProspectStatusMutation
>
export type BulkUpdateCandidatesProspectStatusMutationResult =
  Apollo.MutationResult<BulkUpdateCandidatesProspectStatusMutation>
export type BulkUpdateCandidatesProspectStatusMutationOptions = Apollo.BaseMutationOptions<
  BulkUpdateCandidatesProspectStatusMutation,
  BulkUpdateCandidatesProspectStatusMutationVariables
>
export const CreateFavoriteTalentPoolDocument = gql`
  mutation CreateFavoriteTalentPool($input: CreateFavoriteTalentPoolInput!) {
    CreateFavoriteTalentPool(input: $input) {
      ...TalentPool
    }
  }
  ${TalentPoolFragmentDoc}
`
export type CreateFavoriteTalentPoolMutationFn = Apollo.MutationFunction<
  CreateFavoriteTalentPoolMutation,
  CreateFavoriteTalentPoolMutationVariables
>

/**
 * __useCreateFavoriteTalentPoolMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteTalentPoolMutation, { data, loading, error }] = useCreateFavoriteTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoriteTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateFavoriteTalentPoolMutation, CreateFavoriteTalentPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFavoriteTalentPoolMutation, CreateFavoriteTalentPoolMutationVariables>(
    CreateFavoriteTalentPoolDocument,
    options,
  )
}
export type CreateFavoriteTalentPoolMutationHookResult = ReturnType<typeof useCreateFavoriteTalentPoolMutation>
export type CreateFavoriteTalentPoolMutationResult = Apollo.MutationResult<CreateFavoriteTalentPoolMutation>
export type CreateFavoriteTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  CreateFavoriteTalentPoolMutation,
  CreateFavoriteTalentPoolMutationVariables
>
export const CreateTalentPoolProspectStatusDocument = gql`
  mutation CreateTalentPoolProspectStatus($input: CreateTalentPoolProspectStatusInput!) {
    CreateTalentPoolProspectStatus(input: $input) {
      ...ProspectStatus
    }
  }
  ${ProspectStatusFragmentDoc}
`
export type CreateTalentPoolProspectStatusMutationFn = Apollo.MutationFunction<
  CreateTalentPoolProspectStatusMutation,
  CreateTalentPoolProspectStatusMutationVariables
>

/**
 * __useCreateTalentPoolProspectStatusMutation__
 *
 * To run a mutation, you first call `useCreateTalentPoolProspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentPoolProspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentPoolProspectStatusMutation, { data, loading, error }] = useCreateTalentPoolProspectStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTalentPoolProspectStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTalentPoolProspectStatusMutation,
    CreateTalentPoolProspectStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTalentPoolProspectStatusMutation, CreateTalentPoolProspectStatusMutationVariables>(
    CreateTalentPoolProspectStatusDocument,
    options,
  )
}
export type CreateTalentPoolProspectStatusMutationHookResult = ReturnType<
  typeof useCreateTalentPoolProspectStatusMutation
>
export type CreateTalentPoolProspectStatusMutationResult = Apollo.MutationResult<CreateTalentPoolProspectStatusMutation>
export type CreateTalentPoolProspectStatusMutationOptions = Apollo.BaseMutationOptions<
  CreateTalentPoolProspectStatusMutation,
  CreateTalentPoolProspectStatusMutationVariables
>
export const CreateTalentPoolDocument = gql`
  mutation CreateTalentPool($input: CreateTalentPoolInput!) {
    CreateTalentPool(input: $input) {
      ...TalentPool
    }
  }
  ${TalentPoolFragmentDoc}
`
export type CreateTalentPoolMutationFn = Apollo.MutationFunction<
  CreateTalentPoolMutation,
  CreateTalentPoolMutationVariables
>

/**
 * __useCreateTalentPoolMutation__
 *
 * To run a mutation, you first call `useCreateTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTalentPoolMutation, { data, loading, error }] = useCreateTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTalentPoolMutation, CreateTalentPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTalentPoolMutation, CreateTalentPoolMutationVariables>(
    CreateTalentPoolDocument,
    options,
  )
}
export type CreateTalentPoolMutationHookResult = ReturnType<typeof useCreateTalentPoolMutation>
export type CreateTalentPoolMutationResult = Apollo.MutationResult<CreateTalentPoolMutation>
export type CreateTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  CreateTalentPoolMutation,
  CreateTalentPoolMutationVariables
>
export const DeleteFavoriteTalentPoolDocument = gql`
  mutation DeleteFavoriteTalentPool($input: DeleteFavoriteTalentPoolInput!) {
    DeleteFavoriteTalentPool(input: $input) {
      ...TalentPool
    }
  }
  ${TalentPoolFragmentDoc}
`
export type DeleteFavoriteTalentPoolMutationFn = Apollo.MutationFunction<
  DeleteFavoriteTalentPoolMutation,
  DeleteFavoriteTalentPoolMutationVariables
>

/**
 * __useDeleteFavoriteTalentPoolMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteTalentPoolMutation, { data, loading, error }] = useDeleteFavoriteTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFavoriteTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFavoriteTalentPoolMutation, DeleteFavoriteTalentPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFavoriteTalentPoolMutation, DeleteFavoriteTalentPoolMutationVariables>(
    DeleteFavoriteTalentPoolDocument,
    options,
  )
}
export type DeleteFavoriteTalentPoolMutationHookResult = ReturnType<typeof useDeleteFavoriteTalentPoolMutation>
export type DeleteFavoriteTalentPoolMutationResult = Apollo.MutationResult<DeleteFavoriteTalentPoolMutation>
export type DeleteFavoriteTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  DeleteFavoriteTalentPoolMutation,
  DeleteFavoriteTalentPoolMutationVariables
>
export const DeleteTalentPoolProspectStatusDocument = gql`
  mutation DeleteTalentPoolProspectStatus($input: DeleteTalentPoolProspectStatusInput!) {
    DeleteTalentPoolProspectStatus(input: $input) {
      ...ProspectStatus
    }
  }
  ${ProspectStatusFragmentDoc}
`
export type DeleteTalentPoolProspectStatusMutationFn = Apollo.MutationFunction<
  DeleteTalentPoolProspectStatusMutation,
  DeleteTalentPoolProspectStatusMutationVariables
>

/**
 * __useDeleteTalentPoolProspectStatusMutation__
 *
 * To run a mutation, you first call `useDeleteTalentPoolProspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTalentPoolProspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTalentPoolProspectStatusMutation, { data, loading, error }] = useDeleteTalentPoolProspectStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTalentPoolProspectStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTalentPoolProspectStatusMutation,
    DeleteTalentPoolProspectStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTalentPoolProspectStatusMutation, DeleteTalentPoolProspectStatusMutationVariables>(
    DeleteTalentPoolProspectStatusDocument,
    options,
  )
}
export type DeleteTalentPoolProspectStatusMutationHookResult = ReturnType<
  typeof useDeleteTalentPoolProspectStatusMutation
>
export type DeleteTalentPoolProspectStatusMutationResult = Apollo.MutationResult<DeleteTalentPoolProspectStatusMutation>
export type DeleteTalentPoolProspectStatusMutationOptions = Apollo.BaseMutationOptions<
  DeleteTalentPoolProspectStatusMutation,
  DeleteTalentPoolProspectStatusMutationVariables
>
export const DeleteTalentPoolDocument = gql`
  mutation DeleteTalentPool($input: DeleteTalentPoolInput!) {
    DeleteTalentPool(input: $input) {
      message
      success
    }
  }
`
export type DeleteTalentPoolMutationFn = Apollo.MutationFunction<
  DeleteTalentPoolMutation,
  DeleteTalentPoolMutationVariables
>

/**
 * __useDeleteTalentPoolMutation__
 *
 * To run a mutation, you first call `useDeleteTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTalentPoolMutation, { data, loading, error }] = useDeleteTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTalentPoolMutation, DeleteTalentPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTalentPoolMutation, DeleteTalentPoolMutationVariables>(
    DeleteTalentPoolDocument,
    options,
  )
}
export type DeleteTalentPoolMutationHookResult = ReturnType<typeof useDeleteTalentPoolMutation>
export type DeleteTalentPoolMutationResult = Apollo.MutationResult<DeleteTalentPoolMutation>
export type DeleteTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  DeleteTalentPoolMutation,
  DeleteTalentPoolMutationVariables
>
export const EditTalentPoolProspectStatusDocument = gql`
  mutation EditTalentPoolProspectStatus($input: EditTalentPoolProspectStatusInput!) {
    EditTalentPoolProspectStatus(input: $input) {
      ...ProspectStatus
    }
  }
  ${ProspectStatusFragmentDoc}
`
export type EditTalentPoolProspectStatusMutationFn = Apollo.MutationFunction<
  EditTalentPoolProspectStatusMutation,
  EditTalentPoolProspectStatusMutationVariables
>

/**
 * __useEditTalentPoolProspectStatusMutation__
 *
 * To run a mutation, you first call `useEditTalentPoolProspectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTalentPoolProspectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTalentPoolProspectStatusMutation, { data, loading, error }] = useEditTalentPoolProspectStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTalentPoolProspectStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditTalentPoolProspectStatusMutation,
    EditTalentPoolProspectStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditTalentPoolProspectStatusMutation, EditTalentPoolProspectStatusMutationVariables>(
    EditTalentPoolProspectStatusDocument,
    options,
  )
}
export type EditTalentPoolProspectStatusMutationHookResult = ReturnType<typeof useEditTalentPoolProspectStatusMutation>
export type EditTalentPoolProspectStatusMutationResult = Apollo.MutationResult<EditTalentPoolProspectStatusMutation>
export type EditTalentPoolProspectStatusMutationOptions = Apollo.BaseMutationOptions<
  EditTalentPoolProspectStatusMutation,
  EditTalentPoolProspectStatusMutationVariables
>
export const EditTalentPoolDocument = gql`
  mutation EditTalentPool($input: EditTalentPoolInput!) {
    EditTalentPool(input: $input) {
      ...TalentPool
    }
  }
  ${TalentPoolFragmentDoc}
`
export type EditTalentPoolMutationFn = Apollo.MutationFunction<EditTalentPoolMutation, EditTalentPoolMutationVariables>

/**
 * __useEditTalentPoolMutation__
 *
 * To run a mutation, you first call `useEditTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTalentPoolMutation, { data, loading, error }] = useEditTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<EditTalentPoolMutation, EditTalentPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditTalentPoolMutation, EditTalentPoolMutationVariables>(EditTalentPoolDocument, options)
}
export type EditTalentPoolMutationHookResult = ReturnType<typeof useEditTalentPoolMutation>
export type EditTalentPoolMutationResult = Apollo.MutationResult<EditTalentPoolMutation>
export type EditTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  EditTalentPoolMutation,
  EditTalentPoolMutationVariables
>
export const UnarchiveTalentPoolDocument = gql`
  mutation UnarchiveTalentPool($input: UnarchiveTalentPoolInput!) {
    UnarchiveTalentPool(input: $input) {
      ...TalentPool
    }
  }
  ${TalentPoolFragmentDoc}
`
export type UnarchiveTalentPoolMutationFn = Apollo.MutationFunction<
  UnarchiveTalentPoolMutation,
  UnarchiveTalentPoolMutationVariables
>

/**
 * __useUnarchiveTalentPoolMutation__
 *
 * To run a mutation, you first call `useUnarchiveTalentPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveTalentPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveTalentPoolMutation, { data, loading, error }] = useUnarchiveTalentPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveTalentPoolMutation(
  baseOptions?: Apollo.MutationHookOptions<UnarchiveTalentPoolMutation, UnarchiveTalentPoolMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UnarchiveTalentPoolMutation, UnarchiveTalentPoolMutationVariables>(
    UnarchiveTalentPoolDocument,
    options,
  )
}
export type UnarchiveTalentPoolMutationHookResult = ReturnType<typeof useUnarchiveTalentPoolMutation>
export type UnarchiveTalentPoolMutationResult = Apollo.MutationResult<UnarchiveTalentPoolMutation>
export type UnarchiveTalentPoolMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveTalentPoolMutation,
  UnarchiveTalentPoolMutationVariables
>
export const DeleteTemplateMessageDocument = gql`
  mutation DeleteTemplateMessage($input: DeleteTemplateMessageInput!) {
    DeleteTemplateMessage(input: $input) {
      id
    }
  }
`
export type DeleteTemplateMessageMutationFn = Apollo.MutationFunction<
  DeleteTemplateMessageMutation,
  DeleteTemplateMessageMutationVariables
>

/**
 * __useDeleteTemplateMessageMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMessageMutation, { data, loading, error }] = useDeleteTemplateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplateMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMessageMutation, DeleteTemplateMessageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTemplateMessageMutation, DeleteTemplateMessageMutationVariables>(
    DeleteTemplateMessageDocument,
    options,
  )
}
export type DeleteTemplateMessageMutationHookResult = ReturnType<typeof useDeleteTemplateMessageMutation>
export type DeleteTemplateMessageMutationResult = Apollo.MutationResult<DeleteTemplateMessageMutation>
export type DeleteTemplateMessageMutationOptions = Apollo.BaseMutationOptions<
  DeleteTemplateMessageMutation,
  DeleteTemplateMessageMutationVariables
>
export const UpsertTemplateMessageDocument = gql`
  mutation UpsertTemplateMessage($input: UpsertTemplateMessageInput!) {
    UpsertTemplateMessage(input: $input) {
      id
      title
      message
      messageType
      messageOwner
      createdAt
      updatedAt
    }
  }
`
export type UpsertTemplateMessageMutationFn = Apollo.MutationFunction<
  UpsertTemplateMessageMutation,
  UpsertTemplateMessageMutationVariables
>

/**
 * __useUpsertTemplateMessageMutation__
 *
 * To run a mutation, you first call `useUpsertTemplateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTemplateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTemplateMessageMutation, { data, loading, error }] = useUpsertTemplateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTemplateMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertTemplateMessageMutation, UpsertTemplateMessageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertTemplateMessageMutation, UpsertTemplateMessageMutationVariables>(
    UpsertTemplateMessageDocument,
    options,
  )
}
export type UpsertTemplateMessageMutationHookResult = ReturnType<typeof useUpsertTemplateMessageMutation>
export type UpsertTemplateMessageMutationResult = Apollo.MutationResult<UpsertTemplateMessageMutation>
export type UpsertTemplateMessageMutationOptions = Apollo.BaseMutationOptions<
  UpsertTemplateMessageMutation,
  UpsertTemplateMessageMutationVariables
>
export const DeleteTemplateMilestoneDocument = gql`
  mutation DeleteTemplateMilestone($input: DeleteTemplateMilestoneInput!) {
    DeleteTemplateMilestone(input: $input) {
      id
    }
  }
`
export type DeleteTemplateMilestoneMutationFn = Apollo.MutationFunction<
  DeleteTemplateMilestoneMutation,
  DeleteTemplateMilestoneMutationVariables
>

/**
 * __useDeleteTemplateMilestoneMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMilestoneMutation, { data, loading, error }] = useDeleteTemplateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplateMilestoneMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMilestoneMutation, DeleteTemplateMilestoneMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTemplateMilestoneMutation, DeleteTemplateMilestoneMutationVariables>(
    DeleteTemplateMilestoneDocument,
    options,
  )
}
export type DeleteTemplateMilestoneMutationHookResult = ReturnType<typeof useDeleteTemplateMilestoneMutation>
export type DeleteTemplateMilestoneMutationResult = Apollo.MutationResult<DeleteTemplateMilestoneMutation>
export type DeleteTemplateMilestoneMutationOptions = Apollo.BaseMutationOptions<
  DeleteTemplateMilestoneMutation,
  DeleteTemplateMilestoneMutationVariables
>
export const UpsertTemplateMilestoneDocument = gql`
  mutation UpsertTemplateMilestone($input: UpsertTemplateMilestoneInput!) {
    UpsertTemplateMilestone(input: $input) {
      ...TemplateMilestone
      TemplateStage {
        ...TemplateStage
      }
    }
  }
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
`
export type UpsertTemplateMilestoneMutationFn = Apollo.MutationFunction<
  UpsertTemplateMilestoneMutation,
  UpsertTemplateMilestoneMutationVariables
>

/**
 * __useUpsertTemplateMilestoneMutation__
 *
 * To run a mutation, you first call `useUpsertTemplateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTemplateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTemplateMilestoneMutation, { data, loading, error }] = useUpsertTemplateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTemplateMilestoneMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertTemplateMilestoneMutation, UpsertTemplateMilestoneMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertTemplateMilestoneMutation, UpsertTemplateMilestoneMutationVariables>(
    UpsertTemplateMilestoneDocument,
    options,
  )
}
export type UpsertTemplateMilestoneMutationHookResult = ReturnType<typeof useUpsertTemplateMilestoneMutation>
export type UpsertTemplateMilestoneMutationResult = Apollo.MutationResult<UpsertTemplateMilestoneMutation>
export type UpsertTemplateMilestoneMutationOptions = Apollo.BaseMutationOptions<
  UpsertTemplateMilestoneMutation,
  UpsertTemplateMilestoneMutationVariables
>
export const DeleteTemplatePipelineDocument = gql`
  mutation DeleteTemplatePipeline($input: DeleteTemplatePipelineInput!) {
    DeleteTemplatePipeline(input: $input) {
      id
    }
  }
`
export type DeleteTemplatePipelineMutationFn = Apollo.MutationFunction<
  DeleteTemplatePipelineMutation,
  DeleteTemplatePipelineMutationVariables
>

/**
 * __useDeleteTemplatePipelineMutation__
 *
 * To run a mutation, you first call `useDeleteTemplatePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplatePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplatePipelineMutation, { data, loading, error }] = useDeleteTemplatePipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplatePipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTemplatePipelineMutation, DeleteTemplatePipelineMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTemplatePipelineMutation, DeleteTemplatePipelineMutationVariables>(
    DeleteTemplatePipelineDocument,
    options,
  )
}
export type DeleteTemplatePipelineMutationHookResult = ReturnType<typeof useDeleteTemplatePipelineMutation>
export type DeleteTemplatePipelineMutationResult = Apollo.MutationResult<DeleteTemplatePipelineMutation>
export type DeleteTemplatePipelineMutationOptions = Apollo.BaseMutationOptions<
  DeleteTemplatePipelineMutation,
  DeleteTemplatePipelineMutationVariables
>
export const UpsertTemplatePipelineDocument = gql`
  mutation UpsertTemplatePipeline($input: UpsertTemplatePipelineInput!) {
    UpsertTemplatePipeline(input: $input) {
      ...TemplatePipelineFragment
      TemplateMilestones {
        ...TemplateMilestone
        TemplateStage {
          ...TemplateStage
        }
      }
    }
  }
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
`
export type UpsertTemplatePipelineMutationFn = Apollo.MutationFunction<
  UpsertTemplatePipelineMutation,
  UpsertTemplatePipelineMutationVariables
>

/**
 * __useUpsertTemplatePipelineMutation__
 *
 * To run a mutation, you first call `useUpsertTemplatePipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTemplatePipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTemplatePipelineMutation, { data, loading, error }] = useUpsertTemplatePipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTemplatePipelineMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertTemplatePipelineMutation, UpsertTemplatePipelineMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertTemplatePipelineMutation, UpsertTemplatePipelineMutationVariables>(
    UpsertTemplatePipelineDocument,
    options,
  )
}
export type UpsertTemplatePipelineMutationHookResult = ReturnType<typeof useUpsertTemplatePipelineMutation>
export type UpsertTemplatePipelineMutationResult = Apollo.MutationResult<UpsertTemplatePipelineMutation>
export type UpsertTemplatePipelineMutationOptions = Apollo.BaseMutationOptions<
  UpsertTemplatePipelineMutation,
  UpsertTemplatePipelineMutationVariables
>
export const DeleteTemplateStageDocument = gql`
  mutation DeleteTemplateStage($input: DeleteTemplateStageInput!) {
    DeleteTemplateStage(input: $input) {
      id
    }
  }
`
export type DeleteTemplateStageMutationFn = Apollo.MutationFunction<
  DeleteTemplateStageMutation,
  DeleteTemplateStageMutationVariables
>

/**
 * __useDeleteTemplateStageMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateStageMutation, { data, loading, error }] = useDeleteTemplateStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTemplateStageMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTemplateStageMutation, DeleteTemplateStageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTemplateStageMutation, DeleteTemplateStageMutationVariables>(
    DeleteTemplateStageDocument,
    options,
  )
}
export type DeleteTemplateStageMutationHookResult = ReturnType<typeof useDeleteTemplateStageMutation>
export type DeleteTemplateStageMutationResult = Apollo.MutationResult<DeleteTemplateStageMutation>
export type DeleteTemplateStageMutationOptions = Apollo.BaseMutationOptions<
  DeleteTemplateStageMutation,
  DeleteTemplateStageMutationVariables
>
export const UpsertTemplateStageDocument = gql`
  mutation UpsertTemplateStage($input: UpsertTemplateStageInput!) {
    UpsertTemplateStage(input: $input) {
      ...TemplateStage
    }
  }
  ${TemplateStageFragmentDoc}
`
export type UpsertTemplateStageMutationFn = Apollo.MutationFunction<
  UpsertTemplateStageMutation,
  UpsertTemplateStageMutationVariables
>

/**
 * __useUpsertTemplateStageMutation__
 *
 * To run a mutation, you first call `useUpsertTemplateStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTemplateStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTemplateStageMutation, { data, loading, error }] = useUpsertTemplateStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTemplateStageMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertTemplateStageMutation, UpsertTemplateStageMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertTemplateStageMutation, UpsertTemplateStageMutationVariables>(
    UpsertTemplateStageDocument,
    options,
  )
}
export type UpsertTemplateStageMutationHookResult = ReturnType<typeof useUpsertTemplateStageMutation>
export type UpsertTemplateStageMutationResult = Apollo.MutationResult<UpsertTemplateStageMutation>
export type UpsertTemplateStageMutationOptions = Apollo.BaseMutationOptions<
  UpsertTemplateStageMutation,
  UpsertTemplateStageMutationVariables
>
export const UploadS3FileDocument = gql`
  mutation UploadS3File($input: UploadS3FileInput!) {
    UploadS3File(input: $input) {
      fileKey
      filePath
    }
  }
`
export type UploadS3FileMutationFn = Apollo.MutationFunction<UploadS3FileMutation, UploadS3FileMutationVariables>

/**
 * __useUploadS3FileMutation__
 *
 * To run a mutation, you first call `useUploadS3FileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadS3FileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadS3FileMutation, { data, loading, error }] = useUploadS3FileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadS3FileMutation(
  baseOptions?: Apollo.MutationHookOptions<UploadS3FileMutation, UploadS3FileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UploadS3FileMutation, UploadS3FileMutationVariables>(UploadS3FileDocument, options)
}
export type UploadS3FileMutationHookResult = ReturnType<typeof useUploadS3FileMutation>
export type UploadS3FileMutationResult = Apollo.MutationResult<UploadS3FileMutation>
export type UploadS3FileMutationOptions = Apollo.BaseMutationOptions<
  UploadS3FileMutation,
  UploadS3FileMutationVariables
>
export const CreateUploadedCandidateDocument = gql`
  mutation CreateUploadedCandidate($input: CreateUploadedCandidateInput!) {
    CreateUploadedCandidate(input: $input) {
      ...UploadedCandidate
    }
  }
  ${UploadedCandidateFragmentDoc}
`
export type CreateUploadedCandidateMutationFn = Apollo.MutationFunction<
  CreateUploadedCandidateMutation,
  CreateUploadedCandidateMutationVariables
>

/**
 * __useCreateUploadedCandidateMutation__
 *
 * To run a mutation, you first call `useCreateUploadedCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadedCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadedCandidateMutation, { data, loading, error }] = useCreateUploadedCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadedCandidateMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUploadedCandidateMutation, CreateUploadedCandidateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateUploadedCandidateMutation, CreateUploadedCandidateMutationVariables>(
    CreateUploadedCandidateDocument,
    options,
  )
}
export type CreateUploadedCandidateMutationHookResult = ReturnType<typeof useCreateUploadedCandidateMutation>
export type CreateUploadedCandidateMutationResult = Apollo.MutationResult<CreateUploadedCandidateMutation>
export type CreateUploadedCandidateMutationOptions = Apollo.BaseMutationOptions<
  CreateUploadedCandidateMutation,
  CreateUploadedCandidateMutationVariables
>
export const ExtractSocialProfileDocument = gql`
  mutation ExtractSocialProfile(
    $html: String!
    $uploadedCandidateType: UploadedCandidateTypeEnum!
    $mockEnrichmentEnabled: Boolean
  ) {
    ExtractSocialProfile(
      html: $html
      uploadedCandidateType: $uploadedCandidateType
      mockEnrichmentEnabled: $mockEnrichmentEnabled
    ) {
      __typename
      id
      firstName
      lastName
      emailAddress
      linkedinProfile
      profileUrl
      profileImage
      uploadedCandidateType
      UploadedCandidateAchievement {
        id
        name
        issuingAuthority
        issueYear
        description
        searchDescription
      }
      UploadedCandidateCertificateOrLicense {
        id
        name
        issuingAuthority
        issueYear
        description
        searchDescription
      }
      UploadedCandidateEducation {
        id
        institutionName
        currentlyStudying
        educationLevel
        startDate
        endDate
        areasOfStudy
        majors
        minors
        cumGPA
        cumGPAScale
        hideCumGPA
        hideDepartmentGPA
        departmentCumGPA
        departmentCumGPAScale
        additionalInformation
      }
      UploadedCandidateExperience {
        id
        companyLogo
        startDate
        endDate
        locationType
        location
        shortFormDesc
        longFormDesc
        searchShortFormDesc
        searchLongFormDesc
        industry
        subIndustry
        payType
        jobPay
        additionalComp
        jobTitle
        employerName
        managementPosition
        teamSize
        workPlaceCandidate
        isCurrentJob
        jobType
        isCurrentlyWorking
        description
      }
      UploadedCandidateJobSeekerSkill {
        id
        sequenceNumber
        level
        name
        yearsOfExp
      }
      UploadedCandidateVolunteerWork {
        id
        volunteerJobTitle
        organizationName
        isCurrentlyWorking
        roleType
        startDate
        endDate
        description
        searchDescription
        location
      }
      UploadedCandidateWebsiteOrSocialMedia {
        id
        websiteURL
        type
      }
    }
  }
`
export type ExtractSocialProfileMutationFn = Apollo.MutationFunction<
  ExtractSocialProfileMutation,
  ExtractSocialProfileMutationVariables
>

/**
 * __useExtractSocialProfileMutation__
 *
 * To run a mutation, you first call `useExtractSocialProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractSocialProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractSocialProfileMutation, { data, loading, error }] = useExtractSocialProfileMutation({
 *   variables: {
 *      html: // value for 'html'
 *      uploadedCandidateType: // value for 'uploadedCandidateType'
 *      mockEnrichmentEnabled: // value for 'mockEnrichmentEnabled'
 *   },
 * });
 */
export function useExtractSocialProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<ExtractSocialProfileMutation, ExtractSocialProfileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ExtractSocialProfileMutation, ExtractSocialProfileMutationVariables>(
    ExtractSocialProfileDocument,
    options,
  )
}
export type ExtractSocialProfileMutationHookResult = ReturnType<typeof useExtractSocialProfileMutation>
export type ExtractSocialProfileMutationResult = Apollo.MutationResult<ExtractSocialProfileMutation>
export type ExtractSocialProfileMutationOptions = Apollo.BaseMutationOptions<
  ExtractSocialProfileMutation,
  ExtractSocialProfileMutationVariables
>
export const ParseResumeBasicInfoDocument = gql`
  mutation ParseResumeBasicInfo($input: ParseResumeBasicInfoInput!) {
    ParseResumeBasicInfo(input: $input) {
      firstName
      lastName
      email
      phone
      linkedin
    }
  }
`
export type ParseResumeBasicInfoMutationFn = Apollo.MutationFunction<
  ParseResumeBasicInfoMutation,
  ParseResumeBasicInfoMutationVariables
>

/**
 * __useParseResumeBasicInfoMutation__
 *
 * To run a mutation, you first call `useParseResumeBasicInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseResumeBasicInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseResumeBasicInfoMutation, { data, loading, error }] = useParseResumeBasicInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useParseResumeBasicInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<ParseResumeBasicInfoMutation, ParseResumeBasicInfoMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ParseResumeBasicInfoMutation, ParseResumeBasicInfoMutationVariables>(
    ParseResumeBasicInfoDocument,
    options,
  )
}
export type ParseResumeBasicInfoMutationHookResult = ReturnType<typeof useParseResumeBasicInfoMutation>
export type ParseResumeBasicInfoMutationResult = Apollo.MutationResult<ParseResumeBasicInfoMutation>
export type ParseResumeBasicInfoMutationOptions = Apollo.BaseMutationOptions<
  ParseResumeBasicInfoMutation,
  ParseResumeBasicInfoMutationVariables
>
export const UpdateAccountInformationDocument = gql`
  mutation UpdateAccountInformation($input: UpdateScalisUserDataInput!) {
    UpdateScalisUserData(input: $input) {
      firstName
      lastName
      Address {
        ...AddressFragment
      }
      ContactInfo {
        id
        phoneNumber
      }
    }
  }
  ${AddressFragmentFragmentDoc}
`
export type UpdateAccountInformationMutationFn = Apollo.MutationFunction<
  UpdateAccountInformationMutation,
  UpdateAccountInformationMutationVariables
>

/**
 * __useUpdateAccountInformationMutation__
 *
 * To run a mutation, you first call `useUpdateAccountInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountInformationMutation, { data, loading, error }] = useUpdateAccountInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAccountInformationMutation, UpdateAccountInformationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateAccountInformationMutation, UpdateAccountInformationMutationVariables>(
    UpdateAccountInformationDocument,
    options,
  )
}
export type UpdateAccountInformationMutationHookResult = ReturnType<typeof useUpdateAccountInformationMutation>
export type UpdateAccountInformationMutationResult = Apollo.MutationResult<UpdateAccountInformationMutation>
export type UpdateAccountInformationMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountInformationMutation,
  UpdateAccountInformationMutationVariables
>
export const DeleteAccountDocument = gql`
  mutation DeleteAccount {
    DisableUserAccount {
      id
    }
  }
`
export type DeleteAccountMutationFn = Apollo.MutationFunction<DeleteAccountMutation, DeleteAccountMutationVariables>

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options)
}
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccountMutation,
  DeleteAccountMutationVariables
>
export const UpsertEmailDocument = gql`
  mutation UpsertEmail($input: UpsertEmailInput!) {
    UpsertEmail(input: $input) {
      EmailVerification {
        __typename
        id
        emailAddress
        isPrimary
        isVisibleToEmployers
        activeStatus
      }
    }
  }
`
export type UpsertEmailMutationFn = Apollo.MutationFunction<UpsertEmailMutation, UpsertEmailMutationVariables>

/**
 * __useUpsertEmailMutation__
 *
 * To run a mutation, you first call `useUpsertEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEmailMutation, { data, loading, error }] = useUpsertEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertEmailMutation, UpsertEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertEmailMutation, UpsertEmailMutationVariables>(UpsertEmailDocument, options)
}
export type UpsertEmailMutationHookResult = ReturnType<typeof useUpsertEmailMutation>
export type UpsertEmailMutationResult = Apollo.MutationResult<UpsertEmailMutation>
export type UpsertEmailMutationOptions = Apollo.BaseMutationOptions<UpsertEmailMutation, UpsertEmailMutationVariables>
export const ChangePasswordDocument = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    ChangePassword(input: $input) {
      __typename
      id
    }
  }
`
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options)
}
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>
export const ResendResetPasswordEmailDocument = gql`
  mutation ResendResetPasswordEmail($input: ResendResetPasswordEmailInput!) {
    ResendResetPasswordEmail(input: $input) {
      __typename
      id
    }
  }
`
export type ResendResetPasswordEmailMutationFn = Apollo.MutationFunction<
  ResendResetPasswordEmailMutation,
  ResendResetPasswordEmailMutationVariables
>

/**
 * __useResendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useResendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendResetPasswordEmailMutation, { data, loading, error }] = useResendResetPasswordEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendResetPasswordEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<ResendResetPasswordEmailMutation, ResendResetPasswordEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResendResetPasswordEmailMutation, ResendResetPasswordEmailMutationVariables>(
    ResendResetPasswordEmailDocument,
    options,
  )
}
export type ResendResetPasswordEmailMutationHookResult = ReturnType<typeof useResendResetPasswordEmailMutation>
export type ResendResetPasswordEmailMutationResult = Apollo.MutationResult<ResendResetPasswordEmailMutation>
export type ResendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<
  ResendResetPasswordEmailMutation,
  ResendResetPasswordEmailMutationVariables
>
export const ResetPasswordDocument = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    ResetPassword(input: $input) {
      __typename
      id
    }
  }
`
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options)
}
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>
export const SendResetPasswordEmailDocument = gql`
  mutation SendResetPasswordEmail($input: SendResetPasswordEmailInput!) {
    SendResetPasswordEmail(input: $input) {
      __typename
      id
      emailAddress
    }
  }
`
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables
>

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(
    SendResetPasswordEmailDocument,
    options,
  )
}
export type SendResetPasswordEmailMutationHookResult = ReturnType<typeof useSendResetPasswordEmailMutation>
export type SendResetPasswordEmailMutationResult = Apollo.MutationResult<SendResetPasswordEmailMutation>
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<
  SendResetPasswordEmailMutation,
  SendResetPasswordEmailMutationVariables
>
export const VerifyEmailCodeResetPasswordDocument = gql`
  mutation VerifyEmailCodeResetPassword($input: VerifyEmailCodeInput!) {
    VerifyEmailCode(input: $input) {
      __typename
      id
    }
  }
`
export type VerifyEmailCodeResetPasswordMutationFn = Apollo.MutationFunction<
  VerifyEmailCodeResetPasswordMutation,
  VerifyEmailCodeResetPasswordMutationVariables
>

/**
 * __useVerifyEmailCodeResetPasswordMutation__
 *
 * To run a mutation, you first call `useVerifyEmailCodeResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailCodeResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailCodeResetPasswordMutation, { data, loading, error }] = useVerifyEmailCodeResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailCodeResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyEmailCodeResetPasswordMutation,
    VerifyEmailCodeResetPasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<VerifyEmailCodeResetPasswordMutation, VerifyEmailCodeResetPasswordMutationVariables>(
    VerifyEmailCodeResetPasswordDocument,
    options,
  )
}
export type VerifyEmailCodeResetPasswordMutationHookResult = ReturnType<typeof useVerifyEmailCodeResetPasswordMutation>
export type VerifyEmailCodeResetPasswordMutationResult = Apollo.MutationResult<VerifyEmailCodeResetPasswordMutation>
export type VerifyEmailCodeResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  VerifyEmailCodeResetPasswordMutation,
  VerifyEmailCodeResetPasswordMutationVariables
>
export const VerifyPasswordCodeDocument = gql`
  mutation VerifyPasswordCode($input: VerifyPasswordCodeInput!) {
    VerifyPasswordCode(input: $input) {
      __typename
      id
    }
  }
`
export type VerifyPasswordCodeMutationFn = Apollo.MutationFunction<
  VerifyPasswordCodeMutation,
  VerifyPasswordCodeMutationVariables
>

/**
 * __useVerifyPasswordCodeMutation__
 *
 * To run a mutation, you first call `useVerifyPasswordCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPasswordCodeMutation, { data, loading, error }] = useVerifyPasswordCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyPasswordCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<VerifyPasswordCodeMutation, VerifyPasswordCodeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<VerifyPasswordCodeMutation, VerifyPasswordCodeMutationVariables>(
    VerifyPasswordCodeDocument,
    options,
  )
}
export type VerifyPasswordCodeMutationHookResult = ReturnType<typeof useVerifyPasswordCodeMutation>
export type VerifyPasswordCodeMutationResult = Apollo.MutationResult<VerifyPasswordCodeMutation>
export type VerifyPasswordCodeMutationOptions = Apollo.BaseMutationOptions<
  VerifyPasswordCodeMutation,
  VerifyPasswordCodeMutationVariables
>
export const SearchActivityLogsFilterContentDocument = gql`
  query SearchActivityLogsFilterContent($input: SearchActivityLogsFilterContentInput!) {
    SearchActivityLogsFilterContent(input: $input) {
      filterContent {
        id
        value
      }
    }
  }
`

/**
 * __useSearchActivityLogsFilterContentQuery__
 *
 * To run a query within a React component, call `useSearchActivityLogsFilterContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchActivityLogsFilterContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchActivityLogsFilterContentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchActivityLogsFilterContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchActivityLogsFilterContentQuery,
    SearchActivityLogsFilterContentQueryVariables
  > &
    ({ variables: SearchActivityLogsFilterContentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchActivityLogsFilterContentQuery, SearchActivityLogsFilterContentQueryVariables>(
    SearchActivityLogsFilterContentDocument,
    options,
  )
}
export function useSearchActivityLogsFilterContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchActivityLogsFilterContentQuery,
    SearchActivityLogsFilterContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchActivityLogsFilterContentQuery, SearchActivityLogsFilterContentQueryVariables>(
    SearchActivityLogsFilterContentDocument,
    options,
  )
}
export function useSearchActivityLogsFilterContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SearchActivityLogsFilterContentQuery,
        SearchActivityLogsFilterContentQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchActivityLogsFilterContentQuery, SearchActivityLogsFilterContentQueryVariables>(
    SearchActivityLogsFilterContentDocument,
    options,
  )
}
export type SearchActivityLogsFilterContentQueryHookResult = ReturnType<typeof useSearchActivityLogsFilterContentQuery>
export type SearchActivityLogsFilterContentLazyQueryHookResult = ReturnType<
  typeof useSearchActivityLogsFilterContentLazyQuery
>
export type SearchActivityLogsFilterContentSuspenseQueryHookResult = ReturnType<
  typeof useSearchActivityLogsFilterContentSuspenseQuery
>
export type SearchActivityLogsFilterContentQueryResult = Apollo.QueryResult<
  SearchActivityLogsFilterContentQuery,
  SearchActivityLogsFilterContentQueryVariables
>
export const GetAiCreditBalanceDocument = gql`
  query GetAiCreditBalance {
    GetAiCreditBalance {
      totalCredits
      usedCredits
      availableCredits
    }
  }
`

/**
 * __useGetAiCreditBalanceQuery__
 *
 * To run a query within a React component, call `useGetAiCreditBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiCreditBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiCreditBalanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiCreditBalanceQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAiCreditBalanceQuery, GetAiCreditBalanceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAiCreditBalanceQuery, GetAiCreditBalanceQueryVariables>(GetAiCreditBalanceDocument, options)
}
export function useGetAiCreditBalanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAiCreditBalanceQuery, GetAiCreditBalanceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAiCreditBalanceQuery, GetAiCreditBalanceQueryVariables>(
    GetAiCreditBalanceDocument,
    options,
  )
}
export function useGetAiCreditBalanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAiCreditBalanceQuery, GetAiCreditBalanceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAiCreditBalanceQuery, GetAiCreditBalanceQueryVariables>(
    GetAiCreditBalanceDocument,
    options,
  )
}
export type GetAiCreditBalanceQueryHookResult = ReturnType<typeof useGetAiCreditBalanceQuery>
export type GetAiCreditBalanceLazyQueryHookResult = ReturnType<typeof useGetAiCreditBalanceLazyQuery>
export type GetAiCreditBalanceSuspenseQueryHookResult = ReturnType<typeof useGetAiCreditBalanceSuspenseQuery>
export type GetAiCreditBalanceQueryResult = Apollo.QueryResult<
  GetAiCreditBalanceQuery,
  GetAiCreditBalanceQueryVariables
>
export const GetAiCreditPackagesDocument = gql`
  query GetAiCreditPackages {
    GetAiCreditPackages {
      ...AiCreditPackage
    }
  }
  ${AiCreditPackageFragmentDoc}
`

/**
 * __useGetAiCreditPackagesQuery__
 *
 * To run a query within a React component, call `useGetAiCreditPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiCreditPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiCreditPackagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAiCreditPackagesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAiCreditPackagesQuery, GetAiCreditPackagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAiCreditPackagesQuery, GetAiCreditPackagesQueryVariables>(
    GetAiCreditPackagesDocument,
    options,
  )
}
export function useGetAiCreditPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAiCreditPackagesQuery, GetAiCreditPackagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAiCreditPackagesQuery, GetAiCreditPackagesQueryVariables>(
    GetAiCreditPackagesDocument,
    options,
  )
}
export function useGetAiCreditPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAiCreditPackagesQuery, GetAiCreditPackagesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAiCreditPackagesQuery, GetAiCreditPackagesQueryVariables>(
    GetAiCreditPackagesDocument,
    options,
  )
}
export type GetAiCreditPackagesQueryHookResult = ReturnType<typeof useGetAiCreditPackagesQuery>
export type GetAiCreditPackagesLazyQueryHookResult = ReturnType<typeof useGetAiCreditPackagesLazyQuery>
export type GetAiCreditPackagesSuspenseQueryHookResult = ReturnType<typeof useGetAiCreditPackagesSuspenseQuery>
export type GetAiCreditPackagesQueryResult = Apollo.QueryResult<
  GetAiCreditPackagesQuery,
  GetAiCreditPackagesQueryVariables
>
export const GetAiNotetakerTranscriptDocument = gql`
  query GetAiNotetakerTranscript($input: GetAiNotetakerTranscriptInput!) {
    GetAiNotetakerTranscript(input: $input) {
      transcript {
        speaker
        text
        start
        end
      }
      transcriptText
      summary
      recordingUrl
      transcriptUrl
      metadata {
        totalDuration
        speakerCount
        totalEntries
        interviewStartTime
        timeZone
        lastUpdated
      }
      urlExpiresAt
    }
  }
`

/**
 * __useGetAiNotetakerTranscriptQuery__
 *
 * To run a query within a React component, call `useGetAiNotetakerTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiNotetakerTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiNotetakerTranscriptQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAiNotetakerTranscriptQuery(
  baseOptions: Apollo.QueryHookOptions<GetAiNotetakerTranscriptQuery, GetAiNotetakerTranscriptQueryVariables> &
    ({ variables: GetAiNotetakerTranscriptQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAiNotetakerTranscriptQuery, GetAiNotetakerTranscriptQueryVariables>(
    GetAiNotetakerTranscriptDocument,
    options,
  )
}
export function useGetAiNotetakerTranscriptLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAiNotetakerTranscriptQuery, GetAiNotetakerTranscriptQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAiNotetakerTranscriptQuery, GetAiNotetakerTranscriptQueryVariables>(
    GetAiNotetakerTranscriptDocument,
    options,
  )
}
export function useGetAiNotetakerTranscriptSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAiNotetakerTranscriptQuery, GetAiNotetakerTranscriptQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAiNotetakerTranscriptQuery, GetAiNotetakerTranscriptQueryVariables>(
    GetAiNotetakerTranscriptDocument,
    options,
  )
}
export type GetAiNotetakerTranscriptQueryHookResult = ReturnType<typeof useGetAiNotetakerTranscriptQuery>
export type GetAiNotetakerTranscriptLazyQueryHookResult = ReturnType<typeof useGetAiNotetakerTranscriptLazyQuery>
export type GetAiNotetakerTranscriptSuspenseQueryHookResult = ReturnType<
  typeof useGetAiNotetakerTranscriptSuspenseQuery
>
export type GetAiNotetakerTranscriptQueryResult = Apollo.QueryResult<
  GetAiNotetakerTranscriptQuery,
  GetAiNotetakerTranscriptQueryVariables
>
export const GetCandidateRecommendationsHighlightsDocument = gql`
  query GetCandidateRecommendationsHighlights(
    $jobListing: GetCandidateRecommendationInputJobListing
    $jobListingId: String
    $recommendations: [CandidateRecommendationHighlightsInput!]!
  ) {
    GetCandidateRecommendationsHighlights(
      jobListing: $jobListing
      jobListingId: $jobListingId
      recommendations: $recommendations
    ) {
      ...CandidateRecommendationsHighlights
    }
  }
  ${CandidateRecommendationsHighlightsFragmentDoc}
`

/**
 * __useGetCandidateRecommendationsHighlightsQuery__
 *
 * To run a query within a React component, call `useGetCandidateRecommendationsHighlightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateRecommendationsHighlightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateRecommendationsHighlightsQuery({
 *   variables: {
 *      jobListing: // value for 'jobListing'
 *      jobListingId: // value for 'jobListingId'
 *      recommendations: // value for 'recommendations'
 *   },
 * });
 */
export function useGetCandidateRecommendationsHighlightsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCandidateRecommendationsHighlightsQuery,
    GetCandidateRecommendationsHighlightsQueryVariables
  > &
    ({ variables: GetCandidateRecommendationsHighlightsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCandidateRecommendationsHighlightsQuery,
    GetCandidateRecommendationsHighlightsQueryVariables
  >(GetCandidateRecommendationsHighlightsDocument, options)
}
export function useGetCandidateRecommendationsHighlightsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidateRecommendationsHighlightsQuery,
    GetCandidateRecommendationsHighlightsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCandidateRecommendationsHighlightsQuery,
    GetCandidateRecommendationsHighlightsQueryVariables
  >(GetCandidateRecommendationsHighlightsDocument, options)
}
export function useGetCandidateRecommendationsHighlightsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCandidateRecommendationsHighlightsQuery,
        GetCandidateRecommendationsHighlightsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetCandidateRecommendationsHighlightsQuery,
    GetCandidateRecommendationsHighlightsQueryVariables
  >(GetCandidateRecommendationsHighlightsDocument, options)
}
export type GetCandidateRecommendationsHighlightsQueryHookResult = ReturnType<
  typeof useGetCandidateRecommendationsHighlightsQuery
>
export type GetCandidateRecommendationsHighlightsLazyQueryHookResult = ReturnType<
  typeof useGetCandidateRecommendationsHighlightsLazyQuery
>
export type GetCandidateRecommendationsHighlightsSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateRecommendationsHighlightsSuspenseQuery
>
export type GetCandidateRecommendationsHighlightsQueryResult = Apollo.QueryResult<
  GetCandidateRecommendationsHighlightsQuery,
  GetCandidateRecommendationsHighlightsQueryVariables
>
export const GetCandidateRecommendationDocument = gql`
  query GetCandidateRecommendation(
    $filters: GetCandidateRecommendationInputFilters
    $jobListingId: String
    $requisitionId: Int
    $jobListing: GetCandidateRecommendationInputJobListing
    $pagination: GetCandidateRecommendationInputPagination
  ) {
    GetCandidateRecommendation(
      filters: $filters
      jobListingId: $jobListingId
      requisitionId: $requisitionId
      jobListing: $jobListing
      pagination: $pagination
    ) {
      results {
        ...CandidateRecommendation
      }
      pagination {
        count
        page
        size
        totalPages
      }
    }
  }
  ${CandidateRecommendationFragmentDoc}
`

/**
 * __useGetCandidateRecommendationQuery__
 *
 * To run a query within a React component, call `useGetCandidateRecommendationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateRecommendationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateRecommendationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      jobListingId: // value for 'jobListingId'
 *      requisitionId: // value for 'requisitionId'
 *      jobListing: // value for 'jobListing'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetCandidateRecommendationQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCandidateRecommendationQuery, GetCandidateRecommendationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateRecommendationQuery, GetCandidateRecommendationQueryVariables>(
    GetCandidateRecommendationDocument,
    options,
  )
}
export function useGetCandidateRecommendationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateRecommendationQuery, GetCandidateRecommendationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateRecommendationQuery, GetCandidateRecommendationQueryVariables>(
    GetCandidateRecommendationDocument,
    options,
  )
}
export function useGetCandidateRecommendationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateRecommendationQuery, GetCandidateRecommendationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateRecommendationQuery, GetCandidateRecommendationQueryVariables>(
    GetCandidateRecommendationDocument,
    options,
  )
}
export type GetCandidateRecommendationQueryHookResult = ReturnType<typeof useGetCandidateRecommendationQuery>
export type GetCandidateRecommendationLazyQueryHookResult = ReturnType<typeof useGetCandidateRecommendationLazyQuery>
export type GetCandidateRecommendationSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateRecommendationSuspenseQuery
>
export type GetCandidateRecommendationQueryResult = Apollo.QueryResult<
  GetCandidateRecommendationQuery,
  GetCandidateRecommendationQueryVariables
>
export const GetNewMatchesCountDocument = gql`
  query GetNewMatchesCount($requisitionId: Int) {
    GetCandidateRecommendation(requisitionId: $requisitionId) {
      pagination {
        count
      }
    }
  }
`

/**
 * __useGetNewMatchesCountQuery__
 *
 * To run a query within a React component, call `useGetNewMatchesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewMatchesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewMatchesCountQuery({
 *   variables: {
 *      requisitionId: // value for 'requisitionId'
 *   },
 * });
 */
export function useGetNewMatchesCountQuery(
  baseOptions?: Apollo.QueryHookOptions<GetNewMatchesCountQuery, GetNewMatchesCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetNewMatchesCountQuery, GetNewMatchesCountQueryVariables>(GetNewMatchesCountDocument, options)
}
export function useGetNewMatchesCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetNewMatchesCountQuery, GetNewMatchesCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetNewMatchesCountQuery, GetNewMatchesCountQueryVariables>(
    GetNewMatchesCountDocument,
    options,
  )
}
export function useGetNewMatchesCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetNewMatchesCountQuery, GetNewMatchesCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetNewMatchesCountQuery, GetNewMatchesCountQueryVariables>(
    GetNewMatchesCountDocument,
    options,
  )
}
export type GetNewMatchesCountQueryHookResult = ReturnType<typeof useGetNewMatchesCountQuery>
export type GetNewMatchesCountLazyQueryHookResult = ReturnType<typeof useGetNewMatchesCountLazyQuery>
export type GetNewMatchesCountSuspenseQueryHookResult = ReturnType<typeof useGetNewMatchesCountSuspenseQuery>
export type GetNewMatchesCountQueryResult = Apollo.QueryResult<
  GetNewMatchesCountQuery,
  GetNewMatchesCountQueryVariables
>
export const GetPublicJobListingDocument = gql`
  query GetPublicJobListing($publicListingId: String!) {
    GetPublicJobListing(publicListingId: $publicListingId) {
      JobListingScreeningQuestion {
        id
        active
        ScreeningQuestion {
          id
          companyId
          questionTitle
          questionType
          ansOptions
          isTemplateQuestion
          isGlobalQuestion
          globalQuestionOrder
          maxVal
          minVal
          preferredAnswer
          questionDesc
          valStatus
        }
        displaySequenceNumber
        screeningQuestionId
      }
      externalTitle
      externalListingId
      displayPayOnListing
      id
      industry
      Requisition {
        Company {
          id
        }
      }
    }
  }
`

/**
 * __useGetPublicJobListingQuery__
 *
 * To run a query within a React component, call `useGetPublicJobListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicJobListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicJobListingQuery({
 *   variables: {
 *      publicListingId: // value for 'publicListingId'
 *   },
 * });
 */
export function useGetPublicJobListingQuery(
  baseOptions: Apollo.QueryHookOptions<GetPublicJobListingQuery, GetPublicJobListingQueryVariables> &
    ({ variables: GetPublicJobListingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPublicJobListingQuery, GetPublicJobListingQueryVariables>(
    GetPublicJobListingDocument,
    options,
  )
}
export function useGetPublicJobListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPublicJobListingQuery, GetPublicJobListingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPublicJobListingQuery, GetPublicJobListingQueryVariables>(
    GetPublicJobListingDocument,
    options,
  )
}
export function useGetPublicJobListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPublicJobListingQuery, GetPublicJobListingQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetPublicJobListingQuery, GetPublicJobListingQueryVariables>(
    GetPublicJobListingDocument,
    options,
  )
}
export type GetPublicJobListingQueryHookResult = ReturnType<typeof useGetPublicJobListingQuery>
export type GetPublicJobListingLazyQueryHookResult = ReturnType<typeof useGetPublicJobListingLazyQuery>
export type GetPublicJobListingSuspenseQueryHookResult = ReturnType<typeof useGetPublicJobListingSuspenseQuery>
export type GetPublicJobListingQueryResult = Apollo.QueryResult<
  GetPublicJobListingQuery,
  GetPublicJobListingQueryVariables
>
export const GetUserHasFinishedOnboardingDocument = gql`
  query GetUserHasFinishedOnboarding {
    Me {
      id
      JobSeekerInfo {
        id
        hasFinishedOnboarding
      }
    }
  }
`

/**
 * __useGetUserHasFinishedOnboardingQuery__
 *
 * To run a query within a React component, call `useGetUserHasFinishedOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserHasFinishedOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserHasFinishedOnboardingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserHasFinishedOnboardingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserHasFinishedOnboardingQuery, GetUserHasFinishedOnboardingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserHasFinishedOnboardingQuery, GetUserHasFinishedOnboardingQueryVariables>(
    GetUserHasFinishedOnboardingDocument,
    options,
  )
}
export function useGetUserHasFinishedOnboardingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserHasFinishedOnboardingQuery,
    GetUserHasFinishedOnboardingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserHasFinishedOnboardingQuery, GetUserHasFinishedOnboardingQueryVariables>(
    GetUserHasFinishedOnboardingDocument,
    options,
  )
}
export function useGetUserHasFinishedOnboardingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserHasFinishedOnboardingQuery, GetUserHasFinishedOnboardingQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUserHasFinishedOnboardingQuery, GetUserHasFinishedOnboardingQueryVariables>(
    GetUserHasFinishedOnboardingDocument,
    options,
  )
}
export type GetUserHasFinishedOnboardingQueryHookResult = ReturnType<typeof useGetUserHasFinishedOnboardingQuery>
export type GetUserHasFinishedOnboardingLazyQueryHookResult = ReturnType<
  typeof useGetUserHasFinishedOnboardingLazyQuery
>
export type GetUserHasFinishedOnboardingSuspenseQueryHookResult = ReturnType<
  typeof useGetUserHasFinishedOnboardingSuspenseQuery
>
export type GetUserHasFinishedOnboardingQueryResult = Apollo.QueryResult<
  GetUserHasFinishedOnboardingQuery,
  GetUserHasFinishedOnboardingQueryVariables
>
export const GetUserProfileDataDocument = gql`
  query GetUserProfileData {
    Me {
      id
      firstName
      lastName
      completedAt
      currentStage
      profileImage
      EmailVerification {
        emailAddress
        emailVerified
        isPrimary
      }
      JobSeekerInfo {
        id
        aboutMe
        searchingJobs
      }
      JobSeekerHeader {
        id
        profileHeadline
        jobDisplayedId
        educationDisplayedId
      }
      ContactInfo {
        id
        phoneNumber
      }
      Address {
        id
        city
        state
        country
        addressLine1
        addressLine2
        postalCode
        timeZone
        longitude
        latitude
      }
      Achievement {
        id
        name
        issuingAuthority
        issueYear
        description
        organization {
          id
          name
          logo
          website
        }
      }
      CertificateOrLicense {
        id
        name
        issuingAuthority
        issueYear
        description
        organization {
          id
          name
          logo
          website
        }
      }
      JobSeekerSkill {
        id
        sequenceNumber
        level
        name
        yearsOfExp
      }
      DemographicInfo {
        gender
        raceEthnicity
        veteranStatus
      }
      WebsiteOrSocialMedia {
        websiteURL
        type
      }
      VolunteerWork {
        id
        roleType
        volunteerJobTitle
        organizationName
        location
        startDate
        endDate
        isCurrentlyWorking
        description
        searchDescription
        organization {
          id
          name
          logo
          website
        }
      }
      Experience {
        id
        jobTitle
        employerName
        jobType
        locationType
        location
        startDate
        endDate
        isCurrentlyWorking
        isCurrentJob
        description
        industry
        subIndustry
        managementPosition
        teamSize
        jobSeekerSkillExperiences {
          id
          jobSeekerSkill {
            id
            displayName
          }
        }
        organization {
          logo
          name
          website
        }
      }
      Education {
        id
        institutionName
        educationLevel
        areasOfStudy
        startDate
        endDate
        cumGPA
        cumGPAScale
        majors
        minors
        hideCumGPA
        hideDepartmentGPA
        departmentCumGPA
        additionalInformation
        currentlyStudying
        organization {
          logo
          name
          website
        }
      }
      ScalisUserUploadedDocument {
        id
        documentPath
        documentName
        documentType
        createdAt
      }
    }
  }
`

/**
 * __useGetUserProfileDataQuery__
 *
 * To run a query within a React component, call `useGetUserProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProfileDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProfileDataQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserProfileDataQuery, GetUserProfileDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserProfileDataQuery, GetUserProfileDataQueryVariables>(GetUserProfileDataDocument, options)
}
export function useGetUserProfileDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserProfileDataQuery, GetUserProfileDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserProfileDataQuery, GetUserProfileDataQueryVariables>(
    GetUserProfileDataDocument,
    options,
  )
}
export function useGetUserProfileDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserProfileDataQuery, GetUserProfileDataQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUserProfileDataQuery, GetUserProfileDataQueryVariables>(
    GetUserProfileDataDocument,
    options,
  )
}
export type GetUserProfileDataQueryHookResult = ReturnType<typeof useGetUserProfileDataQuery>
export type GetUserProfileDataLazyQueryHookResult = ReturnType<typeof useGetUserProfileDataLazyQuery>
export type GetUserProfileDataSuspenseQueryHookResult = ReturnType<typeof useGetUserProfileDataSuspenseQuery>
export type GetUserProfileDataQueryResult = Apollo.QueryResult<
  GetUserProfileDataQuery,
  GetUserProfileDataQueryVariables
>
export const GetApplicationFormCountDocument = gql`
  query GetApplicationFormCount($input: ListApplicationFormInput!) {
    CountApplicationForms(input: $input) {
      count
    }
  }
`

/**
 * __useGetApplicationFormCountQuery__
 *
 * To run a query within a React component, call `useGetApplicationFormCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationFormCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationFormCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApplicationFormCountQuery(
  baseOptions: Apollo.QueryHookOptions<GetApplicationFormCountQuery, GetApplicationFormCountQueryVariables> &
    ({ variables: GetApplicationFormCountQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetApplicationFormCountQuery, GetApplicationFormCountQueryVariables>(
    GetApplicationFormCountDocument,
    options,
  )
}
export function useGetApplicationFormCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationFormCountQuery, GetApplicationFormCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetApplicationFormCountQuery, GetApplicationFormCountQueryVariables>(
    GetApplicationFormCountDocument,
    options,
  )
}
export function useGetApplicationFormCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApplicationFormCountQuery, GetApplicationFormCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetApplicationFormCountQuery, GetApplicationFormCountQueryVariables>(
    GetApplicationFormCountDocument,
    options,
  )
}
export type GetApplicationFormCountQueryHookResult = ReturnType<typeof useGetApplicationFormCountQuery>
export type GetApplicationFormCountLazyQueryHookResult = ReturnType<typeof useGetApplicationFormCountLazyQuery>
export type GetApplicationFormCountSuspenseQueryHookResult = ReturnType<typeof useGetApplicationFormCountSuspenseQuery>
export type GetApplicationFormCountQueryResult = Apollo.QueryResult<
  GetApplicationFormCountQuery,
  GetApplicationFormCountQueryVariables
>
export const GetApplicationFormDocument = gql`
  query GetApplicationForm($input: GetApplicationFormInput!) {
    GetApplicationForm(input: $input) {
      id
      name
      companyId
      companyDepartmentId
      companyOfficeId
      ApplicationFormScreeningQuestion {
        id
        screeningQuestionId
        rankOrder
        isActive
        ScreeningQuestion {
          id
          questionTitle
          questionType
          questionDesc
          isTemplateQuestion
          isActiveGlobally
          isRejectionQuestion
          ansOptions
          preferredAnswer
          minVal
          maxVal
          valStatus
        }
      }
    }
  }
`

/**
 * __useGetApplicationFormQuery__
 *
 * To run a query within a React component, call `useGetApplicationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationFormQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApplicationFormQuery(
  baseOptions: Apollo.QueryHookOptions<GetApplicationFormQuery, GetApplicationFormQueryVariables> &
    ({ variables: GetApplicationFormQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetApplicationFormQuery, GetApplicationFormQueryVariables>(GetApplicationFormDocument, options)
}
export function useGetApplicationFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationFormQuery, GetApplicationFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetApplicationFormQuery, GetApplicationFormQueryVariables>(
    GetApplicationFormDocument,
    options,
  )
}
export function useGetApplicationFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApplicationFormQuery, GetApplicationFormQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetApplicationFormQuery, GetApplicationFormQueryVariables>(
    GetApplicationFormDocument,
    options,
  )
}
export type GetApplicationFormQueryHookResult = ReturnType<typeof useGetApplicationFormQuery>
export type GetApplicationFormLazyQueryHookResult = ReturnType<typeof useGetApplicationFormLazyQuery>
export type GetApplicationFormSuspenseQueryHookResult = ReturnType<typeof useGetApplicationFormSuspenseQuery>
export type GetApplicationFormQueryResult = Apollo.QueryResult<
  GetApplicationFormQuery,
  GetApplicationFormQueryVariables
>
export const ListApplicationFormScreeningQuestionsDocument = gql`
  query ListApplicationFormScreeningQuestions($input: ListApplicationFormScreeningQuestionInput!) {
    ListApplicationFormScreeningQuestions(input: $input) {
      id
      applicationFormId
      screeningQuestionId
      rankOrder
      isActive
      createdAt
      updatedAt
      ApplicationForm {
        id
        name
        companyId
      }
      ScreeningQuestion {
        id
        questionTitle
        questionType
        questionDesc
        isTemplateQuestion
        isActiveGlobally
        isRejectionQuestion
        ansOptions
        preferredAnswer
        minVal
        maxVal
        valStatus
      }
    }
  }
`

/**
 * __useListApplicationFormScreeningQuestionsQuery__
 *
 * To run a query within a React component, call `useListApplicationFormScreeningQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationFormScreeningQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationFormScreeningQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListApplicationFormScreeningQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListApplicationFormScreeningQuestionsQuery,
    ListApplicationFormScreeningQuestionsQueryVariables
  > &
    ({ variables: ListApplicationFormScreeningQuestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ListApplicationFormScreeningQuestionsQuery,
    ListApplicationFormScreeningQuestionsQueryVariables
  >(ListApplicationFormScreeningQuestionsDocument, options)
}
export function useListApplicationFormScreeningQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListApplicationFormScreeningQuestionsQuery,
    ListApplicationFormScreeningQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ListApplicationFormScreeningQuestionsQuery,
    ListApplicationFormScreeningQuestionsQueryVariables
  >(ListApplicationFormScreeningQuestionsDocument, options)
}
export function useListApplicationFormScreeningQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListApplicationFormScreeningQuestionsQuery,
        ListApplicationFormScreeningQuestionsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ListApplicationFormScreeningQuestionsQuery,
    ListApplicationFormScreeningQuestionsQueryVariables
  >(ListApplicationFormScreeningQuestionsDocument, options)
}
export type ListApplicationFormScreeningQuestionsQueryHookResult = ReturnType<
  typeof useListApplicationFormScreeningQuestionsQuery
>
export type ListApplicationFormScreeningQuestionsLazyQueryHookResult = ReturnType<
  typeof useListApplicationFormScreeningQuestionsLazyQuery
>
export type ListApplicationFormScreeningQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useListApplicationFormScreeningQuestionsSuspenseQuery
>
export type ListApplicationFormScreeningQuestionsQueryResult = Apollo.QueryResult<
  ListApplicationFormScreeningQuestionsQuery,
  ListApplicationFormScreeningQuestionsQueryVariables
>
export const ListApplicationFormsTitlesDocument = gql`
  query ListApplicationFormsTitles($input: ListApplicationFormInput!) {
    ListApplicationForms(input: $input) {
      items {
        id
        name
        companyId
        companyDepartmentId
        companyOfficeId
      }
    }
  }
`

/**
 * __useListApplicationFormsTitlesQuery__
 *
 * To run a query within a React component, call `useListApplicationFormsTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationFormsTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationFormsTitlesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListApplicationFormsTitlesQuery(
  baseOptions: Apollo.QueryHookOptions<ListApplicationFormsTitlesQuery, ListApplicationFormsTitlesQueryVariables> &
    ({ variables: ListApplicationFormsTitlesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListApplicationFormsTitlesQuery, ListApplicationFormsTitlesQueryVariables>(
    ListApplicationFormsTitlesDocument,
    options,
  )
}
export function useListApplicationFormsTitlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationFormsTitlesQuery, ListApplicationFormsTitlesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListApplicationFormsTitlesQuery, ListApplicationFormsTitlesQueryVariables>(
    ListApplicationFormsTitlesDocument,
    options,
  )
}
export function useListApplicationFormsTitlesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListApplicationFormsTitlesQuery, ListApplicationFormsTitlesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListApplicationFormsTitlesQuery, ListApplicationFormsTitlesQueryVariables>(
    ListApplicationFormsTitlesDocument,
    options,
  )
}
export type ListApplicationFormsTitlesQueryHookResult = ReturnType<typeof useListApplicationFormsTitlesQuery>
export type ListApplicationFormsTitlesLazyQueryHookResult = ReturnType<typeof useListApplicationFormsTitlesLazyQuery>
export type ListApplicationFormsTitlesSuspenseQueryHookResult = ReturnType<
  typeof useListApplicationFormsTitlesSuspenseQuery
>
export type ListApplicationFormsTitlesQueryResult = Apollo.QueryResult<
  ListApplicationFormsTitlesQuery,
  ListApplicationFormsTitlesQueryVariables
>
export const ListApplicationFormsDocument = gql`
  query ListApplicationForms($input: ListApplicationFormInput!) {
    ListApplicationForms(input: $input) {
      items {
        id
        name
        companyId
        companyDepartmentId
        companyOfficeId
        companyUserId
        isArchived
        isEdited
        isDeleted
        createdAt
        updatedAt
        CompanyUser {
          id
          UserInvitation {
            ScalisUser {
              firstName
              lastName
              profileImage
            }
          }
        }
        CompanyDepartment {
          id
          departmentName
        }
        CompanyOffice {
          id
        }
        ApplicationFormScreeningQuestion {
          id
          screeningQuestionId
          rankOrder
          isActive
          ScreeningQuestion {
            id
            questionTitle
            questionType
            questionDesc
            isRejectionQuestion
          }
        }
      }
      total
    }
  }
`

/**
 * __useListApplicationFormsQuery__
 *
 * To run a query within a React component, call `useListApplicationFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicationFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicationFormsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListApplicationFormsQuery(
  baseOptions: Apollo.QueryHookOptions<ListApplicationFormsQuery, ListApplicationFormsQueryVariables> &
    ({ variables: ListApplicationFormsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListApplicationFormsQuery, ListApplicationFormsQueryVariables>(
    ListApplicationFormsDocument,
    options,
  )
}
export function useListApplicationFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListApplicationFormsQuery, ListApplicationFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListApplicationFormsQuery, ListApplicationFormsQueryVariables>(
    ListApplicationFormsDocument,
    options,
  )
}
export function useListApplicationFormsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListApplicationFormsQuery, ListApplicationFormsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListApplicationFormsQuery, ListApplicationFormsQueryVariables>(
    ListApplicationFormsDocument,
    options,
  )
}
export type ListApplicationFormsQueryHookResult = ReturnType<typeof useListApplicationFormsQuery>
export type ListApplicationFormsLazyQueryHookResult = ReturnType<typeof useListApplicationFormsLazyQuery>
export type ListApplicationFormsSuspenseQueryHookResult = ReturnType<typeof useListApplicationFormsSuspenseQuery>
export type ListApplicationFormsQueryResult = Apollo.QueryResult<
  ListApplicationFormsQuery,
  ListApplicationFormsQueryVariables
>
export const ApprovalWorkflowReviewerResponseDocument = gql`
  mutation ApprovalWorkflowReviewerResponse($input: ApprovalWorkflowReviewerResponseInput!) {
    ApprovalWorkflowReviewerResponse(input: $input) {
      workflowVersionId
      stepId
      reviewerStatusId
      response
      workflowStatus
      stepStatus
    }
  }
`
export type ApprovalWorkflowReviewerResponseMutationFn = Apollo.MutationFunction<
  ApprovalWorkflowReviewerResponseMutation,
  ApprovalWorkflowReviewerResponseMutationVariables
>

/**
 * __useApprovalWorkflowReviewerResponseMutation__
 *
 * To run a mutation, you first call `useApprovalWorkflowReviewerResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApprovalWorkflowReviewerResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approvalWorkflowReviewerResponseMutation, { data, loading, error }] = useApprovalWorkflowReviewerResponseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApprovalWorkflowReviewerResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApprovalWorkflowReviewerResponseMutation,
    ApprovalWorkflowReviewerResponseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ApprovalWorkflowReviewerResponseMutation,
    ApprovalWorkflowReviewerResponseMutationVariables
  >(ApprovalWorkflowReviewerResponseDocument, options)
}
export type ApprovalWorkflowReviewerResponseMutationHookResult = ReturnType<
  typeof useApprovalWorkflowReviewerResponseMutation
>
export type ApprovalWorkflowReviewerResponseMutationResult =
  Apollo.MutationResult<ApprovalWorkflowReviewerResponseMutation>
export type ApprovalWorkflowReviewerResponseMutationOptions = Apollo.BaseMutationOptions<
  ApprovalWorkflowReviewerResponseMutation,
  ApprovalWorkflowReviewerResponseMutationVariables
>
export const CheckApprovalWorkflowRequirementWithOpeningDataDocument = gql`
  query CheckApprovalWorkflowRequirementWithOpeningData($input: CheckApprovalWorkflowRequirementWithOpeningDataInput!) {
    CheckApprovalWorkflowRequirementWithOpeningData(input: $input) {
      requiresApproval
      workflowId
      matchingWorkflowIds
      workflowSteps {
        ...ApprovalWorkflowStep
      }
    }
  }
  ${ApprovalWorkflowStepFragmentDoc}
`

/**
 * __useCheckApprovalWorkflowRequirementWithOpeningDataQuery__
 *
 * To run a query within a React component, call `useCheckApprovalWorkflowRequirementWithOpeningDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckApprovalWorkflowRequirementWithOpeningDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckApprovalWorkflowRequirementWithOpeningDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckApprovalWorkflowRequirementWithOpeningDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckApprovalWorkflowRequirementWithOpeningDataQuery,
    CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables
  > &
    ({ variables: CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CheckApprovalWorkflowRequirementWithOpeningDataQuery,
    CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables
  >(CheckApprovalWorkflowRequirementWithOpeningDataDocument, options)
}
export function useCheckApprovalWorkflowRequirementWithOpeningDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckApprovalWorkflowRequirementWithOpeningDataQuery,
    CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CheckApprovalWorkflowRequirementWithOpeningDataQuery,
    CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables
  >(CheckApprovalWorkflowRequirementWithOpeningDataDocument, options)
}
export function useCheckApprovalWorkflowRequirementWithOpeningDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckApprovalWorkflowRequirementWithOpeningDataQuery,
        CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CheckApprovalWorkflowRequirementWithOpeningDataQuery,
    CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables
  >(CheckApprovalWorkflowRequirementWithOpeningDataDocument, options)
}
export type CheckApprovalWorkflowRequirementWithOpeningDataQueryHookResult = ReturnType<
  typeof useCheckApprovalWorkflowRequirementWithOpeningDataQuery
>
export type CheckApprovalWorkflowRequirementWithOpeningDataLazyQueryHookResult = ReturnType<
  typeof useCheckApprovalWorkflowRequirementWithOpeningDataLazyQuery
>
export type CheckApprovalWorkflowRequirementWithOpeningDataSuspenseQueryHookResult = ReturnType<
  typeof useCheckApprovalWorkflowRequirementWithOpeningDataSuspenseQuery
>
export type CheckApprovalWorkflowRequirementWithOpeningDataQueryResult = Apollo.QueryResult<
  CheckApprovalWorkflowRequirementWithOpeningDataQuery,
  CheckApprovalWorkflowRequirementWithOpeningDataQueryVariables
>
export const CheckApprovalWorkflowRequirementDocument = gql`
  query CheckApprovalWorkflowRequirement($input: CheckApprovalWorkflowRequirementInput!) {
    CheckApprovalWorkflowRequirement(input: $input) {
      requiresApproval
      workflowId
      matchingWorkflowIds
      workflowSteps {
        ...ApprovalWorkflowStep
      }
    }
  }
  ${ApprovalWorkflowStepFragmentDoc}
`

/**
 * __useCheckApprovalWorkflowRequirementQuery__
 *
 * To run a query within a React component, call `useCheckApprovalWorkflowRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckApprovalWorkflowRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckApprovalWorkflowRequirementQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckApprovalWorkflowRequirementQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckApprovalWorkflowRequirementQuery,
    CheckApprovalWorkflowRequirementQueryVariables
  > &
    ({ variables: CheckApprovalWorkflowRequirementQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CheckApprovalWorkflowRequirementQuery, CheckApprovalWorkflowRequirementQueryVariables>(
    CheckApprovalWorkflowRequirementDocument,
    options,
  )
}
export function useCheckApprovalWorkflowRequirementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckApprovalWorkflowRequirementQuery,
    CheckApprovalWorkflowRequirementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CheckApprovalWorkflowRequirementQuery, CheckApprovalWorkflowRequirementQueryVariables>(
    CheckApprovalWorkflowRequirementDocument,
    options,
  )
}
export function useCheckApprovalWorkflowRequirementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckApprovalWorkflowRequirementQuery,
        CheckApprovalWorkflowRequirementQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CheckApprovalWorkflowRequirementQuery, CheckApprovalWorkflowRequirementQueryVariables>(
    CheckApprovalWorkflowRequirementDocument,
    options,
  )
}
export type CheckApprovalWorkflowRequirementQueryHookResult = ReturnType<
  typeof useCheckApprovalWorkflowRequirementQuery
>
export type CheckApprovalWorkflowRequirementLazyQueryHookResult = ReturnType<
  typeof useCheckApprovalWorkflowRequirementLazyQuery
>
export type CheckApprovalWorkflowRequirementSuspenseQueryHookResult = ReturnType<
  typeof useCheckApprovalWorkflowRequirementSuspenseQuery
>
export type CheckApprovalWorkflowRequirementQueryResult = Apollo.QueryResult<
  CheckApprovalWorkflowRequirementQuery,
  CheckApprovalWorkflowRequirementQueryVariables
>
export const CreateApprovalWorkflowInstanceDocument = gql`
  mutation CreateApprovalWorkflowInstance($input: CreateApprovalWorkflowInstanceInput!) {
    CreateApprovalWorkflowInstance(input: $input) {
      workflowVersionId
    }
  }
`
export type CreateApprovalWorkflowInstanceMutationFn = Apollo.MutationFunction<
  CreateApprovalWorkflowInstanceMutation,
  CreateApprovalWorkflowInstanceMutationVariables
>

/**
 * __useCreateApprovalWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useCreateApprovalWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApprovalWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApprovalWorkflowInstanceMutation, { data, loading, error }] = useCreateApprovalWorkflowInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApprovalWorkflowInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateApprovalWorkflowInstanceMutation,
    CreateApprovalWorkflowInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateApprovalWorkflowInstanceMutation, CreateApprovalWorkflowInstanceMutationVariables>(
    CreateApprovalWorkflowInstanceDocument,
    options,
  )
}
export type CreateApprovalWorkflowInstanceMutationHookResult = ReturnType<
  typeof useCreateApprovalWorkflowInstanceMutation
>
export type CreateApprovalWorkflowInstanceMutationResult = Apollo.MutationResult<CreateApprovalWorkflowInstanceMutation>
export type CreateApprovalWorkflowInstanceMutationOptions = Apollo.BaseMutationOptions<
  CreateApprovalWorkflowInstanceMutation,
  CreateApprovalWorkflowInstanceMutationVariables
>
export const CreateApprovalWorkflowSettingsDocument = gql`
  mutation CreateApprovalWorkflowSettings($input: CreateApprovalWorkflowSettingsInput!) {
    CreateApprovalWorkflowSettings(input: $input) {
      id
      requireJobApproval
      requireOpeningApproval
      requireOfferApproval
      defaultJobApprovalWorkflowId
      defaultOpeningApprovalWorkflowId
      defaultOfferApprovalWorkflowId
    }
  }
`
export type CreateApprovalWorkflowSettingsMutationFn = Apollo.MutationFunction<
  CreateApprovalWorkflowSettingsMutation,
  CreateApprovalWorkflowSettingsMutationVariables
>

/**
 * __useCreateApprovalWorkflowSettingsMutation__
 *
 * To run a mutation, you first call `useCreateApprovalWorkflowSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApprovalWorkflowSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApprovalWorkflowSettingsMutation, { data, loading, error }] = useCreateApprovalWorkflowSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApprovalWorkflowSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateApprovalWorkflowSettingsMutation,
    CreateApprovalWorkflowSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateApprovalWorkflowSettingsMutation, CreateApprovalWorkflowSettingsMutationVariables>(
    CreateApprovalWorkflowSettingsDocument,
    options,
  )
}
export type CreateApprovalWorkflowSettingsMutationHookResult = ReturnType<
  typeof useCreateApprovalWorkflowSettingsMutation
>
export type CreateApprovalWorkflowSettingsMutationResult = Apollo.MutationResult<CreateApprovalWorkflowSettingsMutation>
export type CreateApprovalWorkflowSettingsMutationOptions = Apollo.BaseMutationOptions<
  CreateApprovalWorkflowSettingsMutation,
  CreateApprovalWorkflowSettingsMutationVariables
>
export const CreateTemplateApprovalWorkflowDocument = gql`
  mutation CreateTemplateApprovalWorkflow($input: CreateTemplateApprovalWorkflowInput!) {
    CreateTemplateApprovalWorkflow(input: $input) {
      id
      name
      description
      createdAt
      updatedAt
      companyUser {
        ...CompanyUserInfo
      }
      approvalWorkflowType
      approvalConditions
      isActive
      workflowSteps {
        id
        rankOrder
        approvalStrictnessLevel
        Reviewers {
          id
          CompanyUser {
            ...CompanyUserInfo
          }
          CompanyUserGroup {
            id
            name
          }
          hiringTeamRole
        }
      }
    }
  }
  ${CompanyUserInfoFragmentDoc}
`
export type CreateTemplateApprovalWorkflowMutationFn = Apollo.MutationFunction<
  CreateTemplateApprovalWorkflowMutation,
  CreateTemplateApprovalWorkflowMutationVariables
>

/**
 * __useCreateTemplateApprovalWorkflowMutation__
 *
 * To run a mutation, you first call `useCreateTemplateApprovalWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateApprovalWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateApprovalWorkflowMutation, { data, loading, error }] = useCreateTemplateApprovalWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateApprovalWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTemplateApprovalWorkflowMutation,
    CreateTemplateApprovalWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateTemplateApprovalWorkflowMutation, CreateTemplateApprovalWorkflowMutationVariables>(
    CreateTemplateApprovalWorkflowDocument,
    options,
  )
}
export type CreateTemplateApprovalWorkflowMutationHookResult = ReturnType<
  typeof useCreateTemplateApprovalWorkflowMutation
>
export type CreateTemplateApprovalWorkflowMutationResult = Apollo.MutationResult<CreateTemplateApprovalWorkflowMutation>
export type CreateTemplateApprovalWorkflowMutationOptions = Apollo.BaseMutationOptions<
  CreateTemplateApprovalWorkflowMutation,
  CreateTemplateApprovalWorkflowMutationVariables
>
export const DeleteTemplateApprovalWorkflowDocument = gql`
  mutation DeleteTemplateApprovalWorkflow($id: Int!) {
    DeleteTemplateApprovalWorkflow(id: $id) {
      id
      isDeleted
      isActive
    }
  }
`
export type DeleteTemplateApprovalWorkflowMutationFn = Apollo.MutationFunction<
  DeleteTemplateApprovalWorkflowMutation,
  DeleteTemplateApprovalWorkflowMutationVariables
>

/**
 * __useDeleteTemplateApprovalWorkflowMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateApprovalWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateApprovalWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateApprovalWorkflowMutation, { data, loading, error }] = useDeleteTemplateApprovalWorkflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateApprovalWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTemplateApprovalWorkflowMutation,
    DeleteTemplateApprovalWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteTemplateApprovalWorkflowMutation, DeleteTemplateApprovalWorkflowMutationVariables>(
    DeleteTemplateApprovalWorkflowDocument,
    options,
  )
}
export type DeleteTemplateApprovalWorkflowMutationHookResult = ReturnType<
  typeof useDeleteTemplateApprovalWorkflowMutation
>
export type DeleteTemplateApprovalWorkflowMutationResult = Apollo.MutationResult<DeleteTemplateApprovalWorkflowMutation>
export type DeleteTemplateApprovalWorkflowMutationOptions = Apollo.BaseMutationOptions<
  DeleteTemplateApprovalWorkflowMutation,
  DeleteTemplateApprovalWorkflowMutationVariables
>
export const EditApprovalWorkflowInstanceDocument = gql`
  mutation EditApprovalWorkflowInstance($input: EditApprovalWorkflowInstanceInput!) {
    EditApprovalWorkflowInstance(input: $input) {
      workflowVersionId
    }
  }
`
export type EditApprovalWorkflowInstanceMutationFn = Apollo.MutationFunction<
  EditApprovalWorkflowInstanceMutation,
  EditApprovalWorkflowInstanceMutationVariables
>

/**
 * __useEditApprovalWorkflowInstanceMutation__
 *
 * To run a mutation, you first call `useEditApprovalWorkflowInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditApprovalWorkflowInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editApprovalWorkflowInstanceMutation, { data, loading, error }] = useEditApprovalWorkflowInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditApprovalWorkflowInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditApprovalWorkflowInstanceMutation,
    EditApprovalWorkflowInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditApprovalWorkflowInstanceMutation, EditApprovalWorkflowInstanceMutationVariables>(
    EditApprovalWorkflowInstanceDocument,
    options,
  )
}
export type EditApprovalWorkflowInstanceMutationHookResult = ReturnType<typeof useEditApprovalWorkflowInstanceMutation>
export type EditApprovalWorkflowInstanceMutationResult = Apollo.MutationResult<EditApprovalWorkflowInstanceMutation>
export type EditApprovalWorkflowInstanceMutationOptions = Apollo.BaseMutationOptions<
  EditApprovalWorkflowInstanceMutation,
  EditApprovalWorkflowInstanceMutationVariables
>
export const EditApprovalWorkflowSettingsDocument = gql`
  mutation EditApprovalWorkflowSettings($input: EditApprovalWorkflowSettingsInput!) {
    EditApprovalWorkflowSettings(input: $input) {
      id
      requireJobApproval
      requireOpeningApproval
      requireOfferApproval
      defaultJobApprovalWorkflowId
      defaultOpeningApprovalWorkflowId
      defaultOfferApprovalWorkflowId
    }
  }
`
export type EditApprovalWorkflowSettingsMutationFn = Apollo.MutationFunction<
  EditApprovalWorkflowSettingsMutation,
  EditApprovalWorkflowSettingsMutationVariables
>

/**
 * __useEditApprovalWorkflowSettingsMutation__
 *
 * To run a mutation, you first call `useEditApprovalWorkflowSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditApprovalWorkflowSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editApprovalWorkflowSettingsMutation, { data, loading, error }] = useEditApprovalWorkflowSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditApprovalWorkflowSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditApprovalWorkflowSettingsMutation,
    EditApprovalWorkflowSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditApprovalWorkflowSettingsMutation, EditApprovalWorkflowSettingsMutationVariables>(
    EditApprovalWorkflowSettingsDocument,
    options,
  )
}
export type EditApprovalWorkflowSettingsMutationHookResult = ReturnType<typeof useEditApprovalWorkflowSettingsMutation>
export type EditApprovalWorkflowSettingsMutationResult = Apollo.MutationResult<EditApprovalWorkflowSettingsMutation>
export type EditApprovalWorkflowSettingsMutationOptions = Apollo.BaseMutationOptions<
  EditApprovalWorkflowSettingsMutation,
  EditApprovalWorkflowSettingsMutationVariables
>
export const EditTemplateApprovalWorkflowDocument = gql`
  mutation EditTemplateApprovalWorkflow($input: EditTemplateApprovalWorkflowInput!) {
    EditTemplateApprovalWorkflow(input: $input) {
      id
      name
      description
      createdAt
      updatedAt
      companyUser {
        ...CompanyUserInfo
      }
      approvalWorkflowType
      approvalConditions
      isActive
      workflowSteps {
        id
        rankOrder
        approvalStrictnessLevel
        Reviewers {
          id
          CompanyUser {
            ...CompanyUserInfo
          }
          CompanyUserGroup {
            id
            name
          }
          hiringTeamRole
        }
      }
    }
  }
  ${CompanyUserInfoFragmentDoc}
`
export type EditTemplateApprovalWorkflowMutationFn = Apollo.MutationFunction<
  EditTemplateApprovalWorkflowMutation,
  EditTemplateApprovalWorkflowMutationVariables
>

/**
 * __useEditTemplateApprovalWorkflowMutation__
 *
 * To run a mutation, you first call `useEditTemplateApprovalWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTemplateApprovalWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTemplateApprovalWorkflowMutation, { data, loading, error }] = useEditTemplateApprovalWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTemplateApprovalWorkflowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditTemplateApprovalWorkflowMutation,
    EditTemplateApprovalWorkflowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<EditTemplateApprovalWorkflowMutation, EditTemplateApprovalWorkflowMutationVariables>(
    EditTemplateApprovalWorkflowDocument,
    options,
  )
}
export type EditTemplateApprovalWorkflowMutationHookResult = ReturnType<typeof useEditTemplateApprovalWorkflowMutation>
export type EditTemplateApprovalWorkflowMutationResult = Apollo.MutationResult<EditTemplateApprovalWorkflowMutation>
export type EditTemplateApprovalWorkflowMutationOptions = Apollo.BaseMutationOptions<
  EditTemplateApprovalWorkflowMutation,
  EditTemplateApprovalWorkflowMutationVariables
>
export const GetApprovalWorkflowInstanceDocument = gql`
  query GetApprovalWorkflowInstance($input: GetApprovalWorkflowInstanceInput!) {
    GetApprovalWorkflowInstance(input: $input) {
      workflowVersionId
      externalId
      version
      status
      createdAt
      updatedAt
      canRespondToAnyStep
      steps {
        ...ApprovalWorkflowInstanceStep
      }
    }
  }
  ${ApprovalWorkflowInstanceStepFragmentDoc}
`

/**
 * __useGetApprovalWorkflowInstanceQuery__
 *
 * To run a query within a React component, call `useGetApprovalWorkflowInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalWorkflowInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalWorkflowInstanceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetApprovalWorkflowInstanceQuery(
  baseOptions: Apollo.QueryHookOptions<GetApprovalWorkflowInstanceQuery, GetApprovalWorkflowInstanceQueryVariables> &
    ({ variables: GetApprovalWorkflowInstanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetApprovalWorkflowInstanceQuery, GetApprovalWorkflowInstanceQueryVariables>(
    GetApprovalWorkflowInstanceDocument,
    options,
  )
}
export function useGetApprovalWorkflowInstanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApprovalWorkflowInstanceQuery,
    GetApprovalWorkflowInstanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetApprovalWorkflowInstanceQuery, GetApprovalWorkflowInstanceQueryVariables>(
    GetApprovalWorkflowInstanceDocument,
    options,
  )
}
export function useGetApprovalWorkflowInstanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApprovalWorkflowInstanceQuery, GetApprovalWorkflowInstanceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetApprovalWorkflowInstanceQuery, GetApprovalWorkflowInstanceQueryVariables>(
    GetApprovalWorkflowInstanceDocument,
    options,
  )
}
export type GetApprovalWorkflowInstanceQueryHookResult = ReturnType<typeof useGetApprovalWorkflowInstanceQuery>
export type GetApprovalWorkflowInstanceLazyQueryHookResult = ReturnType<typeof useGetApprovalWorkflowInstanceLazyQuery>
export type GetApprovalWorkflowInstanceSuspenseQueryHookResult = ReturnType<
  typeof useGetApprovalWorkflowInstanceSuspenseQuery
>
export type GetApprovalWorkflowInstanceQueryResult = Apollo.QueryResult<
  GetApprovalWorkflowInstanceQuery,
  GetApprovalWorkflowInstanceQueryVariables
>
export const GetApprovalWorkflowSettingsDocument = gql`
  query GetApprovalWorkflowSettings {
    GetApprovalWorkflowSettings {
      id
      requireJobApproval
      requireOpeningApproval
      requireOfferApproval
      defaultJobApprovalWorkflowId
      defaultOpeningApprovalWorkflowId
      defaultOfferApprovalWorkflowId
      defaultJobApprovalWorkflow {
        id
        approvalWorkflowType
        approvalConditions
        isActive
      }
      defaultOpeningApprovalWorkflow {
        id
        approvalWorkflowType
        approvalConditions
        isActive
      }
      defaultOfferApprovalWorkflow {
        id
        approvalWorkflowType
        approvalConditions
        isActive
      }
    }
  }
`

/**
 * __useGetApprovalWorkflowSettingsQuery__
 *
 * To run a query within a React component, call `useGetApprovalWorkflowSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalWorkflowSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalWorkflowSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApprovalWorkflowSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetApprovalWorkflowSettingsQuery, GetApprovalWorkflowSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetApprovalWorkflowSettingsQuery, GetApprovalWorkflowSettingsQueryVariables>(
    GetApprovalWorkflowSettingsDocument,
    options,
  )
}
export function useGetApprovalWorkflowSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetApprovalWorkflowSettingsQuery,
    GetApprovalWorkflowSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetApprovalWorkflowSettingsQuery, GetApprovalWorkflowSettingsQueryVariables>(
    GetApprovalWorkflowSettingsDocument,
    options,
  )
}
export function useGetApprovalWorkflowSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApprovalWorkflowSettingsQuery, GetApprovalWorkflowSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetApprovalWorkflowSettingsQuery, GetApprovalWorkflowSettingsQueryVariables>(
    GetApprovalWorkflowSettingsDocument,
    options,
  )
}
export type GetApprovalWorkflowSettingsQueryHookResult = ReturnType<typeof useGetApprovalWorkflowSettingsQuery>
export type GetApprovalWorkflowSettingsLazyQueryHookResult = ReturnType<typeof useGetApprovalWorkflowSettingsLazyQuery>
export type GetApprovalWorkflowSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetApprovalWorkflowSettingsSuspenseQuery
>
export type GetApprovalWorkflowSettingsQueryResult = Apollo.QueryResult<
  GetApprovalWorkflowSettingsQuery,
  GetApprovalWorkflowSettingsQueryVariables
>
export const ListTemplateApprovalWorkflowsDocument = gql`
  query ListTemplateApprovalWorkflows($input: ListTemplateApprovalWorkflowsInput!) {
    ListTemplateApprovalWorkflows(input: $input) {
      items {
        id
        name
        description
        createdAt
        updatedAt
        companyUser {
          ...CompanyUserInfo
        }
        approvalWorkflowType
        approvalConditions
        isActive
        workflowSteps {
          id
          rankOrder
          finalStep
          approvalStrictnessLevel
          Reviewers {
            id
            CompanyUser {
              ...CompanyUserInfo
            }
            CompanyUserGroup {
              id
              name
            }
            hiringTeamRole
          }
        }
      }
      total
    }
  }
  ${CompanyUserInfoFragmentDoc}
`

/**
 * __useListTemplateApprovalWorkflowsQuery__
 *
 * To run a query within a React component, call `useListTemplateApprovalWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplateApprovalWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplateApprovalWorkflowsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListTemplateApprovalWorkflowsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTemplateApprovalWorkflowsQuery,
    ListTemplateApprovalWorkflowsQueryVariables
  > &
    ({ variables: ListTemplateApprovalWorkflowsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListTemplateApprovalWorkflowsQuery, ListTemplateApprovalWorkflowsQueryVariables>(
    ListTemplateApprovalWorkflowsDocument,
    options,
  )
}
export function useListTemplateApprovalWorkflowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTemplateApprovalWorkflowsQuery,
    ListTemplateApprovalWorkflowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListTemplateApprovalWorkflowsQuery, ListTemplateApprovalWorkflowsQueryVariables>(
    ListTemplateApprovalWorkflowsDocument,
    options,
  )
}
export function useListTemplateApprovalWorkflowsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTemplateApprovalWorkflowsQuery, ListTemplateApprovalWorkflowsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListTemplateApprovalWorkflowsQuery, ListTemplateApprovalWorkflowsQueryVariables>(
    ListTemplateApprovalWorkflowsDocument,
    options,
  )
}
export type ListTemplateApprovalWorkflowsQueryHookResult = ReturnType<typeof useListTemplateApprovalWorkflowsQuery>
export type ListTemplateApprovalWorkflowsLazyQueryHookResult = ReturnType<
  typeof useListTemplateApprovalWorkflowsLazyQuery
>
export type ListTemplateApprovalWorkflowsSuspenseQueryHookResult = ReturnType<
  typeof useListTemplateApprovalWorkflowsSuspenseQuery
>
export type ListTemplateApprovalWorkflowsQueryResult = Apollo.QueryResult<
  ListTemplateApprovalWorkflowsQuery,
  ListTemplateApprovalWorkflowsQueryVariables
>
export const ToggleTemplateApprovalWorkflowStatusDocument = gql`
  mutation ToggleTemplateApprovalWorkflowStatus($input: ToggleTemplateApprovalWorkflowStatusInput!) {
    ToggleTemplateApprovalWorkflowStatus(input: $input) {
      id
      isActive
      updatedAt
    }
  }
`
export type ToggleTemplateApprovalWorkflowStatusMutationFn = Apollo.MutationFunction<
  ToggleTemplateApprovalWorkflowStatusMutation,
  ToggleTemplateApprovalWorkflowStatusMutationVariables
>

/**
 * __useToggleTemplateApprovalWorkflowStatusMutation__
 *
 * To run a mutation, you first call `useToggleTemplateApprovalWorkflowStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTemplateApprovalWorkflowStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTemplateApprovalWorkflowStatusMutation, { data, loading, error }] = useToggleTemplateApprovalWorkflowStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleTemplateApprovalWorkflowStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleTemplateApprovalWorkflowStatusMutation,
    ToggleTemplateApprovalWorkflowStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ToggleTemplateApprovalWorkflowStatusMutation,
    ToggleTemplateApprovalWorkflowStatusMutationVariables
  >(ToggleTemplateApprovalWorkflowStatusDocument, options)
}
export type ToggleTemplateApprovalWorkflowStatusMutationHookResult = ReturnType<
  typeof useToggleTemplateApprovalWorkflowStatusMutation
>
export type ToggleTemplateApprovalWorkflowStatusMutationResult =
  Apollo.MutationResult<ToggleTemplateApprovalWorkflowStatusMutation>
export type ToggleTemplateApprovalWorkflowStatusMutationOptions = Apollo.BaseMutationOptions<
  ToggleTemplateApprovalWorkflowStatusMutation,
  ToggleTemplateApprovalWorkflowStatusMutationVariables
>
export const GetCalendarSettingsDocument = gql`
  query GetCalendarSettings {
    GetCalendarSettings {
      id
      availability
      provider
      timeZone
      hourDisplay
      email
      companyUserId
      nylasGrantId
      Calendars {
        id
        nylasCalendarId
        calendarSettingsId
        name
        isPrimary
        color
        CalendarEvents {
          id
          nylasEventStatus
          nylasCalendarEventId
          title
          eventType
          description
          startTime
          endTime
          timeZone
          location
          repeats
          reminders
          employers
          conferencing
          masterEventId
          regardingCandidates
          regardingJobs
          internalGuests
          candidates
          isScalisEvent
        }
      }
    }
  }
`

/**
 * __useGetCalendarSettingsQuery__
 *
 * To run a query within a React component, call `useGetCalendarSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCalendarSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCalendarSettingsQuery, GetCalendarSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCalendarSettingsQuery, GetCalendarSettingsQueryVariables>(
    GetCalendarSettingsDocument,
    options,
  )
}
export function useGetCalendarSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCalendarSettingsQuery, GetCalendarSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCalendarSettingsQuery, GetCalendarSettingsQueryVariables>(
    GetCalendarSettingsDocument,
    options,
  )
}
export function useGetCalendarSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCalendarSettingsQuery, GetCalendarSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCalendarSettingsQuery, GetCalendarSettingsQueryVariables>(
    GetCalendarSettingsDocument,
    options,
  )
}
export type GetCalendarSettingsQueryHookResult = ReturnType<typeof useGetCalendarSettingsQuery>
export type GetCalendarSettingsLazyQueryHookResult = ReturnType<typeof useGetCalendarSettingsLazyQuery>
export type GetCalendarSettingsSuspenseQueryHookResult = ReturnType<typeof useGetCalendarSettingsSuspenseQuery>
export type GetCalendarSettingsQueryResult = Apollo.QueryResult<
  GetCalendarSettingsQuery,
  GetCalendarSettingsQueryVariables
>
export const GetCandidateApplicationByListingDocument = gql`
  query GetCandidateApplicationByListing($candidateProfileId: Int!, $publicListingId: String!) {
    GetCandidateApplication(candidateProfileId: [$candidateProfileId], publicListingIds: [$publicListingId]) {
      id
      candidateProfileId
      JobListing {
        id
        Requisition {
          id
          jobName
        }
      }
    }
  }
`

/**
 * __useGetCandidateApplicationByListingQuery__
 *
 * To run a query within a React component, call `useGetCandidateApplicationByListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateApplicationByListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateApplicationByListingQuery({
 *   variables: {
 *      candidateProfileId: // value for 'candidateProfileId'
 *      publicListingId: // value for 'publicListingId'
 *   },
 * });
 */
export function useGetCandidateApplicationByListingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCandidateApplicationByListingQuery,
    GetCandidateApplicationByListingQueryVariables
  > &
    ({ variables: GetCandidateApplicationByListingQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateApplicationByListingQuery, GetCandidateApplicationByListingQueryVariables>(
    GetCandidateApplicationByListingDocument,
    options,
  )
}
export function useGetCandidateApplicationByListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidateApplicationByListingQuery,
    GetCandidateApplicationByListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateApplicationByListingQuery, GetCandidateApplicationByListingQueryVariables>(
    GetCandidateApplicationByListingDocument,
    options,
  )
}
export function useGetCandidateApplicationByListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCandidateApplicationByListingQuery,
        GetCandidateApplicationByListingQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateApplicationByListingQuery, GetCandidateApplicationByListingQueryVariables>(
    GetCandidateApplicationByListingDocument,
    options,
  )
}
export type GetCandidateApplicationByListingQueryHookResult = ReturnType<
  typeof useGetCandidateApplicationByListingQuery
>
export type GetCandidateApplicationByListingLazyQueryHookResult = ReturnType<
  typeof useGetCandidateApplicationByListingLazyQuery
>
export type GetCandidateApplicationByListingSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateApplicationByListingSuspenseQuery
>
export type GetCandidateApplicationByListingQueryResult = Apollo.QueryResult<
  GetCandidateApplicationByListingQuery,
  GetCandidateApplicationByListingQueryVariables
>
export const GetApplicationOverviewDocument = gql`
  query GetApplicationOverview($id: Int!) {
    GetCandidateApplication(templateMilestoneNotIn: SOURCING, id: $id) {
      id
      applicationStatus
      appliedAt
      Company {
        Address {
          city
          state
          country
        }
        CompanyInfo {
          companyName
          logo
        }
      }
      JobListing {
        externalListingId
        externalTitle
        publicListingId
        id
        Requisition {
          id
          jobName
          extRequisitionId
        }
        jobRequisitionId
        stateAndOrCountry
        workplaceType
        Address {
          timeZone
          state
          longitude
          latitude
          country
          activeStatus
          addressLine1
          addressLine2
          addressType
          city
          postalCode
        }
      }
      LastPublicTemplateStage {
        id
        name
        TemplateMilestone {
          name
        }
      }
      applicationType
      TemplateStage {
        id
        name
        visibility
        TemplateMilestone {
          id
          name
        }
        TemplatePipeline {
          TemplateMilestones {
            id
            name
            rankOrder
            TemplateStage {
              name
              id
              rankOrder
              visibility
            }
          }
        }
      }
      CandidateInterview {
        CalendarEvent {
          EventAttachments {
            id
            file
            eventId
          }
          Calendar {
            name
            id
            isPrimary
          }
          title
          timeZone
          startTime
          repeats
          reminders
          regardingJobs
          regardingCandidates
          nylasEventStatus
          nylasCalendarEventId
          masterEventId
          location
          isScalisEvent
          internalGuests
          id
          eventType
          employers
          endTime
          description
          conferencing
          companyUserId
          candidates
          calendarId
          CompanyUser {
            UserInvitation {
              ScalisUser {
                ...ScalisUser
              }
            }
          }
        }
        stageId
        interviewData
        id
        status
        companyUserId
        applicationId
      }
      ApplicantNotes {
        userNoteId
        id
        candidateApplicationId
        updatedAt
        UserNote {
          id
          noteText
        }
      }
      SchedulerLinkInvite {
        stageId
        nylasConfigurationId
        message
        interviewData
        id
        durationMinutes
        companyUserId
        candidateData
        calendarId
        applicationId
        TemplateStage {
          name
          id
          rankOrder
        }
      }
      CandidateProfile {
        ScalisUser {
          ...ScalisUser
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetApplicationOverviewQuery__
 *
 * To run a query within a React component, call `useGetApplicationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<GetApplicationOverviewQuery, GetApplicationOverviewQueryVariables> &
    ({ variables: GetApplicationOverviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetApplicationOverviewQuery, GetApplicationOverviewQueryVariables>(
    GetApplicationOverviewDocument,
    options,
  )
}
export function useGetApplicationOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationOverviewQuery, GetApplicationOverviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetApplicationOverviewQuery, GetApplicationOverviewQueryVariables>(
    GetApplicationOverviewDocument,
    options,
  )
}
export function useGetApplicationOverviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetApplicationOverviewQuery, GetApplicationOverviewQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetApplicationOverviewQuery, GetApplicationOverviewQueryVariables>(
    GetApplicationOverviewDocument,
    options,
  )
}
export type GetApplicationOverviewQueryHookResult = ReturnType<typeof useGetApplicationOverviewQuery>
export type GetApplicationOverviewLazyQueryHookResult = ReturnType<typeof useGetApplicationOverviewLazyQuery>
export type GetApplicationOverviewSuspenseQueryHookResult = ReturnType<typeof useGetApplicationOverviewSuspenseQuery>
export type GetApplicationOverviewQueryResult = Apollo.QueryResult<
  GetApplicationOverviewQuery,
  GetApplicationOverviewQueryVariables
>
export const GetCandidatesApplicationsByStageDocument = gql`
  query GetCandidatesApplicationsByStage(
    $milestoneNotIn: [NameEnum!]
    $milestoneIn: [NameEnum!]
    $requisitionId: Int
    $id: Int
    $page: Int
    $limit: Int
    $search: String
  ) {
    GetTemplateStage(
      requisitionId: $requisitionId
      milestoneNotIn: $milestoneNotIn
      milestoneIn: $milestoneIn
      id: $id
    ) {
      id
      CandidateApplicationByStage(requisitionId: $requisitionId, page: $page, limit: $limit, search: $search) {
        id
        CandidateProfile {
          id
          UploadedCandidate {
            ...UploadedCandidate
          }
          ScalisUser {
            id
            lastName
            firstName
            EmailVerification {
              id
              isVisibleToEmployers
              isPrimary
              emailAddress
            }
          }
        }
      }
    }
  }
  ${UploadedCandidateFragmentDoc}
`

/**
 * __useGetCandidatesApplicationsByStageQuery__
 *
 * To run a query within a React component, call `useGetCandidatesApplicationsByStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidatesApplicationsByStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidatesApplicationsByStageQuery({
 *   variables: {
 *      milestoneNotIn: // value for 'milestoneNotIn'
 *      milestoneIn: // value for 'milestoneIn'
 *      requisitionId: // value for 'requisitionId'
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCandidatesApplicationsByStageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCandidatesApplicationsByStageQuery,
    GetCandidatesApplicationsByStageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidatesApplicationsByStageQuery, GetCandidatesApplicationsByStageQueryVariables>(
    GetCandidatesApplicationsByStageDocument,
    options,
  )
}
export function useGetCandidatesApplicationsByStageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidatesApplicationsByStageQuery,
    GetCandidatesApplicationsByStageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidatesApplicationsByStageQuery, GetCandidatesApplicationsByStageQueryVariables>(
    GetCandidatesApplicationsByStageDocument,
    options,
  )
}
export function useGetCandidatesApplicationsByStageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCandidatesApplicationsByStageQuery,
        GetCandidatesApplicationsByStageQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidatesApplicationsByStageQuery, GetCandidatesApplicationsByStageQueryVariables>(
    GetCandidatesApplicationsByStageDocument,
    options,
  )
}
export type GetCandidatesApplicationsByStageQueryHookResult = ReturnType<
  typeof useGetCandidatesApplicationsByStageQuery
>
export type GetCandidatesApplicationsByStageLazyQueryHookResult = ReturnType<
  typeof useGetCandidatesApplicationsByStageLazyQuery
>
export type GetCandidatesApplicationsByStageSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidatesApplicationsByStageSuspenseQuery
>
export type GetCandidatesApplicationsByStageQueryResult = Apollo.QueryResult<
  GetCandidatesApplicationsByStageQuery,
  GetCandidatesApplicationsByStageQueryVariables
>
export const GetRejectCandidateQuestionsDocument = gql`
  query GetRejectCandidateQuestions {
    GetRejectCandidateQuestions {
      sequence
      required
      question
      id
    }
  }
`

/**
 * __useGetRejectCandidateQuestionsQuery__
 *
 * To run a query within a React component, call `useGetRejectCandidateQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRejectCandidateQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRejectCandidateQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRejectCandidateQuestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRejectCandidateQuestionsQuery, GetRejectCandidateQuestionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRejectCandidateQuestionsQuery, GetRejectCandidateQuestionsQueryVariables>(
    GetRejectCandidateQuestionsDocument,
    options,
  )
}
export function useGetRejectCandidateQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRejectCandidateQuestionsQuery,
    GetRejectCandidateQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRejectCandidateQuestionsQuery, GetRejectCandidateQuestionsQueryVariables>(
    GetRejectCandidateQuestionsDocument,
    options,
  )
}
export function useGetRejectCandidateQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRejectCandidateQuestionsQuery, GetRejectCandidateQuestionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRejectCandidateQuestionsQuery, GetRejectCandidateQuestionsQueryVariables>(
    GetRejectCandidateQuestionsDocument,
    options,
  )
}
export type GetRejectCandidateQuestionsQueryHookResult = ReturnType<typeof useGetRejectCandidateQuestionsQuery>
export type GetRejectCandidateQuestionsLazyQueryHookResult = ReturnType<typeof useGetRejectCandidateQuestionsLazyQuery>
export type GetRejectCandidateQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetRejectCandidateQuestionsSuspenseQuery
>
export type GetRejectCandidateQuestionsQueryResult = Apollo.QueryResult<
  GetRejectCandidateQuestionsQuery,
  GetRejectCandidateQuestionsQueryVariables
>
export const SearchCandidatesFilterContentDocument = gql`
  query SearchCandidatesFilterContent(
    $jobListingId: Int
    $requisitionId: Int
    $publicListingId: String
    $filterType: FilterContentTypeEnum!
    $search: String!
  ) {
    SearchCandidatesFilterContent(
      filterType: $filterType
      search: $search
      requisitionId: $requisitionId
      jobListingId: $jobListingId
      publicListingId: $publicListingId
    ) {
      filterContent {
        value
        id
      }
    }
  }
`

/**
 * __useSearchCandidatesFilterContentQuery__
 *
 * To run a query within a React component, call `useSearchCandidatesFilterContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCandidatesFilterContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCandidatesFilterContentQuery({
 *   variables: {
 *      jobListingId: // value for 'jobListingId'
 *      requisitionId: // value for 'requisitionId'
 *      publicListingId: // value for 'publicListingId'
 *      filterType: // value for 'filterType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchCandidatesFilterContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchCandidatesFilterContentQuery,
    SearchCandidatesFilterContentQueryVariables
  > &
    ({ variables: SearchCandidatesFilterContentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchCandidatesFilterContentQuery, SearchCandidatesFilterContentQueryVariables>(
    SearchCandidatesFilterContentDocument,
    options,
  )
}
export function useSearchCandidatesFilterContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchCandidatesFilterContentQuery,
    SearchCandidatesFilterContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchCandidatesFilterContentQuery, SearchCandidatesFilterContentQueryVariables>(
    SearchCandidatesFilterContentDocument,
    options,
  )
}
export function useSearchCandidatesFilterContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchCandidatesFilterContentQuery, SearchCandidatesFilterContentQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchCandidatesFilterContentQuery, SearchCandidatesFilterContentQueryVariables>(
    SearchCandidatesFilterContentDocument,
    options,
  )
}
export type SearchCandidatesFilterContentQueryHookResult = ReturnType<typeof useSearchCandidatesFilterContentQuery>
export type SearchCandidatesFilterContentLazyQueryHookResult = ReturnType<
  typeof useSearchCandidatesFilterContentLazyQuery
>
export type SearchCandidatesFilterContentSuspenseQueryHookResult = ReturnType<
  typeof useSearchCandidatesFilterContentSuspenseQuery
>
export type SearchCandidatesFilterContentQueryResult = Apollo.QueryResult<
  SearchCandidatesFilterContentQuery,
  SearchCandidatesFilterContentQueryVariables
>
export const GetCandidateCollaboratorDocument = gql`
  query GetCandidateCollaborator($id: Int!) {
    GetCandidateCollaborator(id: $id) {
      ...CandidateCollaboratorFragment
      createdAt
      updatedAt
      role {
        ...RoleFragment
      }
    }
  }
  ${CandidateCollaboratorFragmentFragmentDoc}
  ${RoleFragmentFragmentDoc}
`

/**
 * __useGetCandidateCollaboratorQuery__
 *
 * To run a query within a React component, call `useGetCandidateCollaboratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateCollaboratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateCollaboratorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCandidateCollaboratorQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateCollaboratorQuery, GetCandidateCollaboratorQueryVariables> &
    ({ variables: GetCandidateCollaboratorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateCollaboratorQuery, GetCandidateCollaboratorQueryVariables>(
    GetCandidateCollaboratorDocument,
    options,
  )
}
export function useGetCandidateCollaboratorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateCollaboratorQuery, GetCandidateCollaboratorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateCollaboratorQuery, GetCandidateCollaboratorQueryVariables>(
    GetCandidateCollaboratorDocument,
    options,
  )
}
export function useGetCandidateCollaboratorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateCollaboratorQuery, GetCandidateCollaboratorQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateCollaboratorQuery, GetCandidateCollaboratorQueryVariables>(
    GetCandidateCollaboratorDocument,
    options,
  )
}
export type GetCandidateCollaboratorQueryHookResult = ReturnType<typeof useGetCandidateCollaboratorQuery>
export type GetCandidateCollaboratorLazyQueryHookResult = ReturnType<typeof useGetCandidateCollaboratorLazyQuery>
export type GetCandidateCollaboratorSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateCollaboratorSuspenseQuery
>
export type GetCandidateCollaboratorQueryResult = Apollo.QueryResult<
  GetCandidateCollaboratorQuery,
  GetCandidateCollaboratorQueryVariables
>
export const ListCandidateEmailsDocument = gql`
  query ListCandidateEmails($input: ListCandidateEmailsInput!) {
    ListCandidateEmails(input: $input) {
      email
      source
      isPrimary
      isVerified
      createdAt
    }
  }
`

/**
 * __useListCandidateEmailsQuery__
 *
 * To run a query within a React component, call `useListCandidateEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateEmailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCandidateEmailsQuery(
  baseOptions: Apollo.QueryHookOptions<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables> &
    ({ variables: ListCandidateEmailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>(
    ListCandidateEmailsDocument,
    options,
  )
}
export function useListCandidateEmailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>(
    ListCandidateEmailsDocument,
    options,
  )
}
export function useListCandidateEmailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCandidateEmailsQuery, ListCandidateEmailsQueryVariables>(
    ListCandidateEmailsDocument,
    options,
  )
}
export type ListCandidateEmailsQueryHookResult = ReturnType<typeof useListCandidateEmailsQuery>
export type ListCandidateEmailsLazyQueryHookResult = ReturnType<typeof useListCandidateEmailsLazyQuery>
export type ListCandidateEmailsSuspenseQueryHookResult = ReturnType<typeof useListCandidateEmailsSuspenseQuery>
export type ListCandidateEmailsQueryResult = Apollo.QueryResult<
  ListCandidateEmailsQuery,
  ListCandidateEmailsQueryVariables
>
export const GetCandidateFiltersDocument = gql`
  query GetCandidateFilters($id: Int) {
    GetCandidateFilter(id: $id) {
      ...CandidateFilter
    }
  }
  ${CandidateFilterFragmentDoc}
`

/**
 * __useGetCandidateFiltersQuery__
 *
 * To run a query within a React component, call `useGetCandidateFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateFiltersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCandidateFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCandidateFiltersQuery, GetCandidateFiltersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateFiltersQuery, GetCandidateFiltersQueryVariables>(
    GetCandidateFiltersDocument,
    options,
  )
}
export function useGetCandidateFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateFiltersQuery, GetCandidateFiltersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateFiltersQuery, GetCandidateFiltersQueryVariables>(
    GetCandidateFiltersDocument,
    options,
  )
}
export function useGetCandidateFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateFiltersQuery, GetCandidateFiltersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateFiltersQuery, GetCandidateFiltersQueryVariables>(
    GetCandidateFiltersDocument,
    options,
  )
}
export type GetCandidateFiltersQueryHookResult = ReturnType<typeof useGetCandidateFiltersQuery>
export type GetCandidateFiltersLazyQueryHookResult = ReturnType<typeof useGetCandidateFiltersLazyQuery>
export type GetCandidateFiltersSuspenseQueryHookResult = ReturnType<typeof useGetCandidateFiltersSuspenseQuery>
export type GetCandidateFiltersQueryResult = Apollo.QueryResult<
  GetCandidateFiltersQuery,
  GetCandidateFiltersQueryVariables
>
export const GetCandidateLabelsDocument = gql`
  query GetCandidateLabels($id: Int!) {
    GetOneCandidateProfile(id: $id) {
      id
      CandidateLabels {
        ...CandidateLabel
      }
    }
  }
  ${CandidateLabelFragmentDoc}
`

/**
 * __useGetCandidateLabelsQuery__
 *
 * To run a query within a React component, call `useGetCandidateLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateLabelsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCandidateLabelsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateLabelsQuery, GetCandidateLabelsQueryVariables> &
    ({ variables: GetCandidateLabelsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateLabelsQuery, GetCandidateLabelsQueryVariables>(GetCandidateLabelsDocument, options)
}
export function useGetCandidateLabelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateLabelsQuery, GetCandidateLabelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateLabelsQuery, GetCandidateLabelsQueryVariables>(
    GetCandidateLabelsDocument,
    options,
  )
}
export function useGetCandidateLabelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateLabelsQuery, GetCandidateLabelsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateLabelsQuery, GetCandidateLabelsQueryVariables>(
    GetCandidateLabelsDocument,
    options,
  )
}
export type GetCandidateLabelsQueryHookResult = ReturnType<typeof useGetCandidateLabelsQuery>
export type GetCandidateLabelsLazyQueryHookResult = ReturnType<typeof useGetCandidateLabelsLazyQuery>
export type GetCandidateLabelsSuspenseQueryHookResult = ReturnType<typeof useGetCandidateLabelsSuspenseQuery>
export type GetCandidateLabelsQueryResult = Apollo.QueryResult<
  GetCandidateLabelsQuery,
  GetCandidateLabelsQueryVariables
>
export const ListCandidateLabelsDocument = gql`
  query ListCandidateLabels($input: ListCandidateLabelsInput!) {
    ListCandidateLabels(input: $input) {
      items {
        id
        labelName
        colorNumber
        companyId
        companyUserId
        createdAt
        updatedAt
        company {
          id
        }
        companyUser {
          id
          UserInvitation {
            email
            ScalisUser {
              firstName
              lastName
            }
          }
        }
        candidateProfilesCount
      }
      total
    }
  }
`

/**
 * __useListCandidateLabelsQuery__
 *
 * To run a query within a React component, call `useListCandidateLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateLabelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCandidateLabelsQuery(
  baseOptions: Apollo.QueryHookOptions<ListCandidateLabelsQuery, ListCandidateLabelsQueryVariables> &
    ({ variables: ListCandidateLabelsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCandidateLabelsQuery, ListCandidateLabelsQueryVariables>(
    ListCandidateLabelsDocument,
    options,
  )
}
export function useListCandidateLabelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateLabelsQuery, ListCandidateLabelsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCandidateLabelsQuery, ListCandidateLabelsQueryVariables>(
    ListCandidateLabelsDocument,
    options,
  )
}
export function useListCandidateLabelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCandidateLabelsQuery, ListCandidateLabelsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCandidateLabelsQuery, ListCandidateLabelsQueryVariables>(
    ListCandidateLabelsDocument,
    options,
  )
}
export type ListCandidateLabelsQueryHookResult = ReturnType<typeof useListCandidateLabelsQuery>
export type ListCandidateLabelsLazyQueryHookResult = ReturnType<typeof useListCandidateLabelsLazyQuery>
export type ListCandidateLabelsSuspenseQueryHookResult = ReturnType<typeof useListCandidateLabelsSuspenseQuery>
export type ListCandidateLabelsQueryResult = Apollo.QueryResult<
  ListCandidateLabelsQuery,
  ListCandidateLabelsQueryVariables
>
export const GetCandidateInterviewsDocument = gql`
  query GetCandidateInterviews($candidateProfileId: Int!) {
    GetOneCandidateProfile(id: $candidateProfileId) {
      CandidateApplication {
        ...GetCandidateInterviewsProfileApplication
      }
    }
  }
  ${GetCandidateInterviewsProfileApplicationFragmentDoc}
`

/**
 * __useGetCandidateInterviewsQuery__
 *
 * To run a query within a React component, call `useGetCandidateInterviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateInterviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateInterviewsQuery({
 *   variables: {
 *      candidateProfileId: // value for 'candidateProfileId'
 *   },
 * });
 */
export function useGetCandidateInterviewsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateInterviewsQuery, GetCandidateInterviewsQueryVariables> &
    ({ variables: GetCandidateInterviewsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateInterviewsQuery, GetCandidateInterviewsQueryVariables>(
    GetCandidateInterviewsDocument,
    options,
  )
}
export function useGetCandidateInterviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateInterviewsQuery, GetCandidateInterviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateInterviewsQuery, GetCandidateInterviewsQueryVariables>(
    GetCandidateInterviewsDocument,
    options,
  )
}
export function useGetCandidateInterviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateInterviewsQuery, GetCandidateInterviewsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateInterviewsQuery, GetCandidateInterviewsQueryVariables>(
    GetCandidateInterviewsDocument,
    options,
  )
}
export type GetCandidateInterviewsQueryHookResult = ReturnType<typeof useGetCandidateInterviewsQuery>
export type GetCandidateInterviewsLazyQueryHookResult = ReturnType<typeof useGetCandidateInterviewsLazyQuery>
export type GetCandidateInterviewsSuspenseQueryHookResult = ReturnType<typeof useGetCandidateInterviewsSuspenseQuery>
export type GetCandidateInterviewsQueryResult = Apollo.QueryResult<
  GetCandidateInterviewsQuery,
  GetCandidateInterviewsQueryVariables
>
export const GetCandidateProfilesDocument = gql`
  query GetCandidateProfiles(
    $candidateProfileIds: [Int!]
    $page: Int
    $limit: Int
    $applicationFilters: ApplicationFiltersOnCandidateProfile
  ) {
    GetCandidateProfile(
      candidateProfileIds: $candidateProfileIds
      page: $page
      limit: $limit
      applicationFilters: $applicationFilters
    ) {
      id
      uploadedCandidateId
      scalisUserId
      profileType
      primaryEmail
      CustomCandidateProfileFieldValues {
        ...CustomCandidateProfileFieldValue
      }
      ScalisUser {
        ...ScalisUser
        Experience(onlyCurrentJob: true) {
          id
          employerName
          isCurrentlyWorking
          isCurrentJob
          jobTitle
        }
        Education(highestEducation: true) {
          id
          educationLevel
          institutionName
        }
        ContactInfo {
          phoneNumber
          id
        }
        EmailVerification {
          isVisibleToEmployers
          isPrimary
          emailVerified
          id
          emailAddress
          activeStatus
        }
      }
      UploadedCandidate {
        ...UploadedCandidate
      }
      CandidateApplication {
        ...CandidateApplication
      }
    }
  }
  ${CustomCandidateProfileFieldValueFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${UploadedCandidateFragmentDoc}
  ${CandidateApplicationFragmentDoc}
`

/**
 * __useGetCandidateProfilesQuery__
 *
 * To run a query within a React component, call `useGetCandidateProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateProfilesQuery({
 *   variables: {
 *      candidateProfileIds: // value for 'candidateProfileIds'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      applicationFilters: // value for 'applicationFilters'
 *   },
 * });
 */
export function useGetCandidateProfilesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCandidateProfilesQuery, GetCandidateProfilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateProfilesQuery, GetCandidateProfilesQueryVariables>(
    GetCandidateProfilesDocument,
    options,
  )
}
export function useGetCandidateProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateProfilesQuery, GetCandidateProfilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateProfilesQuery, GetCandidateProfilesQueryVariables>(
    GetCandidateProfilesDocument,
    options,
  )
}
export function useGetCandidateProfilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateProfilesQuery, GetCandidateProfilesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateProfilesQuery, GetCandidateProfilesQueryVariables>(
    GetCandidateProfilesDocument,
    options,
  )
}
export type GetCandidateProfilesQueryHookResult = ReturnType<typeof useGetCandidateProfilesQuery>
export type GetCandidateProfilesLazyQueryHookResult = ReturnType<typeof useGetCandidateProfilesLazyQuery>
export type GetCandidateProfilesSuspenseQueryHookResult = ReturnType<typeof useGetCandidateProfilesSuspenseQuery>
export type GetCandidateProfilesQueryResult = Apollo.QueryResult<
  GetCandidateProfilesQuery,
  GetCandidateProfilesQueryVariables
>
export const GetCandidateStatsDocument = gql`
  query GetCandidateStats($jobListingId: String!, $candidateProfileId: Int!) {
    GetCandidateStats(jobListingId: $jobListingId, candidateProfileId: $candidateProfileId) {
      skillsMatched
      screeningQuestions
      opportunity {
        candidateApplicationId
        applicationStatus
        customApplicationStatusId
        customStatusIconType
        customStatusIconUnicode
        customStatusColorHexCode
        customApplicationStatusName
        appliedAt
        currentStageId
        jobListingId
        jobListingTitle
        lastUpdatedStatusAt
        location
        milestoneType
        duplicationStatus
        requisitionId
        internalRequisitionId
        requisitionJobName
        stageName
        stages {
          id
          name
        }
      }
      matchPercentage
      experience
      distance
    }
  }
`

/**
 * __useGetCandidateStatsQuery__
 *
 * To run a query within a React component, call `useGetCandidateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateStatsQuery({
 *   variables: {
 *      jobListingId: // value for 'jobListingId'
 *      candidateProfileId: // value for 'candidateProfileId'
 *   },
 * });
 */
export function useGetCandidateStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateStatsQuery, GetCandidateStatsQueryVariables> &
    ({ variables: GetCandidateStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateStatsQuery, GetCandidateStatsQueryVariables>(GetCandidateStatsDocument, options)
}
export function useGetCandidateStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateStatsQuery, GetCandidateStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateStatsQuery, GetCandidateStatsQueryVariables>(
    GetCandidateStatsDocument,
    options,
  )
}
export function useGetCandidateStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateStatsQuery, GetCandidateStatsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateStatsQuery, GetCandidateStatsQueryVariables>(
    GetCandidateStatsDocument,
    options,
  )
}
export type GetCandidateStatsQueryHookResult = ReturnType<typeof useGetCandidateStatsQuery>
export type GetCandidateStatsLazyQueryHookResult = ReturnType<typeof useGetCandidateStatsLazyQuery>
export type GetCandidateStatsSuspenseQueryHookResult = ReturnType<typeof useGetCandidateStatsSuspenseQuery>
export type GetCandidateStatsQueryResult = Apollo.QueryResult<GetCandidateStatsQuery, GetCandidateStatsQueryVariables>
export const GetCompanyUsersUploadCandidateDocument = gql`
  query GetCompanyUsersUploadCandidate {
    GetCompanyUsers {
      id
      companyUserStatus
      UserInvitation {
        id
        ScalisUser {
          id
          firstName
          lastName
          activeStatus
        }
      }
    }
  }
`

/**
 * __useGetCompanyUsersUploadCandidateQuery__
 *
 * To run a query within a React component, call `useGetCompanyUsersUploadCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUsersUploadCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUsersUploadCandidateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyUsersUploadCandidateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyUsersUploadCandidateQuery,
    GetCompanyUsersUploadCandidateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyUsersUploadCandidateQuery, GetCompanyUsersUploadCandidateQueryVariables>(
    GetCompanyUsersUploadCandidateDocument,
    options,
  )
}
export function useGetCompanyUsersUploadCandidateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyUsersUploadCandidateQuery,
    GetCompanyUsersUploadCandidateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyUsersUploadCandidateQuery, GetCompanyUsersUploadCandidateQueryVariables>(
    GetCompanyUsersUploadCandidateDocument,
    options,
  )
}
export function useGetCompanyUsersUploadCandidateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCompanyUsersUploadCandidateQuery,
        GetCompanyUsersUploadCandidateQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyUsersUploadCandidateQuery, GetCompanyUsersUploadCandidateQueryVariables>(
    GetCompanyUsersUploadCandidateDocument,
    options,
  )
}
export type GetCompanyUsersUploadCandidateQueryHookResult = ReturnType<typeof useGetCompanyUsersUploadCandidateQuery>
export type GetCompanyUsersUploadCandidateLazyQueryHookResult = ReturnType<
  typeof useGetCompanyUsersUploadCandidateLazyQuery
>
export type GetCompanyUsersUploadCandidateSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyUsersUploadCandidateSuspenseQuery
>
export type GetCompanyUsersUploadCandidateQueryResult = Apollo.QueryResult<
  GetCompanyUsersUploadCandidateQuery,
  GetCompanyUsersUploadCandidateQueryVariables
>
export const GetOneCandidateProfileDocument = gql`
  query GetOneCandidateProfile($id: Int!) {
    GetOneCandidateProfile(id: $id) {
      id
      profileType
      uploadedCandidateId
      scalisUserId
      primaryEmail
      ActivityLog {
        ...ActivityLog
      }
      CompanyProvidedEmail {
        id
        email
      }
      ScalisUser {
        id
        firstName
        lastName
        profileImage
        currentJob: Experience(onlyCurrentJob: true) {
          id
          employerName
          isCurrentlyWorking
          isCurrentJob
          jobTitle
        }
        highestEducation: Education(highestEducation: true) {
          id
          educationLevel
          institutionName
        }
        WebsiteOrSocialMedia {
          type
          websiteURL
        }
        ContactInfo {
          id
          phoneNumber
        }
        EmailVerification {
          id
          emailAddress
          isVisibleToEmployers
          isPrimary
          emailAddress
          activeStatus
        }
        JobSeekerHeader {
          id
          profileHeadline
          jobDisplayedId
          educationDisplayedId
        }
        Education {
          id
          institutionName
          educationLevel
          areasOfStudy
          minors
          majors
          endDate
          startDate
          cumGPA
          cumGPAScale
        }
        Experience {
          ...Experience
        }
        JobSeekerInfo {
          aboutMe
          id
        }
        VolunteerWork {
          id
          volunteerJobTitle
          organizationName
          roleType
          startDate
          endDate
          isCurrentlyWorking
          description
          location
        }
        DemographicInfo {
          workHistory
          veteranStatus
          raceEthnicity
          id
          gender
        }
        JobSeekerSkill {
          id
          level
          name
          sequenceNumber
          yearsOfExp
        }
        CertificateOrLicense {
          id
          issuingAuthority
          name
          description
          issueYear
        }
        Achievement {
          id
          issuingAuthority
          description
          issueYear
          name
        }
        WebsiteOrSocialMedia {
          type
          websiteURL
          id
        }
        Address {
          id
          city
          state
        }
      }
      ProfileDetails {
        id
        phoneNumber
        profileLink
        timezone
        CandidateSource {
          ...CandidateSource
          companyUser {
            id
          }
          jobListing {
            id
            externalTitle
            Requisition {
              extRequisitionId
              jobName
            }
          }
        }
        CandidateProfileLocation {
          id
          city
          state
          country
        }
        CandidateMedalistDesignation {
          id
          medalistDesignation
          jobListing {
            id
            externalTitle
          }
        }
      }
      CandidateApplication {
        ...CandidateApplication
        CustomCandidateApplicationFieldValues {
          ...CustomCandidateApplicationFieldValue
        }
        CustomApplicationStatus {
          ...CustomApplicationStatus
        }
        CandidateInterview {
          ...CandidateInterview
        }
        JobListing {
          id
          publicListingId
          externalTitle
          listingTitle
          workplaceType
          stateAndOrCountry
          Address {
            id
            city
            state
            country
          }
          Requisition {
            id
            extRequisitionId
            jobName
          }
        }
        TemplateStage {
          id
          name
          TemplateMilestone {
            id
            name
          }
          TemplatePipeline {
            id
            TemplateMilestones {
              id
              rankOrder
              TemplateStage {
                id
                rankOrder
                name
              }
            }
          }
        }
        CandidateApplicationRating {
          id
          score
        }
        UploadedDocumentCandidateApplication {
          id
          updatedAt
          UploadedDocument {
            id
            documentPath
            documentName
            createdAt
          }
          CompanyUser {
            id
            profileImage
            UserInvitation {
              id
              ScalisUser {
                id
                firstName
                lastName
              }
            }
          }
        }
        CandidateApplicationNote {
          id
          privateStatus
          userNote {
            id
            noteText
            updatedAt
          }
          companyUser {
            id
            profileImage
            UserInvitation {
              id
              ScalisUser {
                id
                firstName
                lastName
              }
            }
          }
          candidateApplication {
            id
            JobListing {
              id
              publicListingId
            }
          }
        }
        ActivityLog {
          ...ActivityLog
        }
      }
      CandidateApplicationRating {
        id
        score
      }
      UploadedDocumentCandidateProfile {
        id
        updatedAt
        UploadedDocument {
          id
          documentPath
          documentName
          createdAt
        }
        CompanyUser {
          id
          profileImage
          UserInvitation {
            id
            ScalisUser {
              id
              firstName
              lastName
            }
          }
        }
      }
      CandidateProfileNote {
        id
        privateStatus
        userNote {
          id
          noteText
          updatedAt
        }
        companyUser {
          id
          profileImage
          UserInvitation {
            id
            ScalisUser {
              id
              firstName
              lastName
            }
          }
        }
      }
      UploadedCandidate {
        ...UploadedCandidate
      }
      CandidateLabels {
        ...CandidateLabel
      }
      CustomCandidateProfileFieldValues {
        ...CustomCandidateProfileFieldValue
      }
    }
  }
  ${ActivityLogFragmentDoc}
  ${ExperienceFragmentDoc}
  ${CandidateSourceFragmentDoc}
  ${CandidateApplicationFragmentDoc}
  ${CustomCandidateApplicationFieldValueFragmentDoc}
  ${CustomApplicationStatusFragmentDoc}
  ${CandidateInterviewFragmentDoc}
  ${UploadedCandidateFragmentDoc}
  ${CandidateLabelFragmentDoc}
  ${CustomCandidateProfileFieldValueFragmentDoc}
`

/**
 * __useGetOneCandidateProfileQuery__
 *
 * To run a query within a React component, call `useGetOneCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneCandidateProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOneCandidateProfileQuery(
  baseOptions: Apollo.QueryHookOptions<GetOneCandidateProfileQuery, GetOneCandidateProfileQueryVariables> &
    ({ variables: GetOneCandidateProfileQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOneCandidateProfileQuery, GetOneCandidateProfileQueryVariables>(
    GetOneCandidateProfileDocument,
    options,
  )
}
export function useGetOneCandidateProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOneCandidateProfileQuery, GetOneCandidateProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOneCandidateProfileQuery, GetOneCandidateProfileQueryVariables>(
    GetOneCandidateProfileDocument,
    options,
  )
}
export function useGetOneCandidateProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOneCandidateProfileQuery, GetOneCandidateProfileQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOneCandidateProfileQuery, GetOneCandidateProfileQueryVariables>(
    GetOneCandidateProfileDocument,
    options,
  )
}
export type GetOneCandidateProfileQueryHookResult = ReturnType<typeof useGetOneCandidateProfileQuery>
export type GetOneCandidateProfileLazyQueryHookResult = ReturnType<typeof useGetOneCandidateProfileLazyQuery>
export type GetOneCandidateProfileSuspenseQueryHookResult = ReturnType<typeof useGetOneCandidateProfileSuspenseQuery>
export type GetOneCandidateProfileQueryResult = Apollo.QueryResult<
  GetOneCandidateProfileQuery,
  GetOneCandidateProfileQueryVariables
>
export const GetSequenceEnrollmentsDocument = gql`
  query GetSequenceEnrollments(
    $limit: Int
    $page: Int
    $sortBy: SortByCandidateProfile
    $sortDirection: SortDirection
    $sequenceId: String
  ) {
    GetCandidateProfile(
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
      sequenceId: $sequenceId
    ) {
      id
      profileType
      CandidateLabels {
        ...CandidateLabel
      }
      SequenceCandidateStatus(sequenceId: $sequenceId)
      lastStepCompleted(sequenceId: $sequenceId) {
        id
        stepNumber
      }
      lastContactedDate(sequenceId: $sequenceId)
      enrollmentDate(sequenceId: $sequenceId)
      hasSent(sequenceId: $sequenceId)
      hasOpened(sequenceId: $sequenceId)
      hasReplied(sequenceId: $sequenceId)
      CandidateApplicationRating {
        id
        score
      }
      CandidateApplication {
        ...CandidateApplication
        JobListing {
          id
          publicListingId
        }
      }
      UploadedCandidate {
        ...UploadedCandidate
      }
      ScalisUser {
        ...ScalisUser
        currentJob: Experience(onlyCurrentJob: true) {
          id
          jobTitle
          employerName
        }
        EmailVerification {
          id
          isPrimary
          emailAddress
          isVisibleToEmployers
        }
      }
    }
    CountCandidateProfile(sequenceId: $sequenceId) {
      count
    }
  }
  ${CandidateLabelFragmentDoc}
  ${CandidateApplicationFragmentDoc}
  ${UploadedCandidateFragmentDoc}
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetSequenceEnrollmentsQuery__
 *
 * To run a query within a React component, call `useGetSequenceEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceEnrollmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useGetSequenceEnrollmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSequenceEnrollmentsQuery, GetSequenceEnrollmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceEnrollmentsQuery, GetSequenceEnrollmentsQueryVariables>(
    GetSequenceEnrollmentsDocument,
    options,
  )
}
export function useGetSequenceEnrollmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSequenceEnrollmentsQuery, GetSequenceEnrollmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceEnrollmentsQuery, GetSequenceEnrollmentsQueryVariables>(
    GetSequenceEnrollmentsDocument,
    options,
  )
}
export function useGetSequenceEnrollmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSequenceEnrollmentsQuery, GetSequenceEnrollmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceEnrollmentsQuery, GetSequenceEnrollmentsQueryVariables>(
    GetSequenceEnrollmentsDocument,
    options,
  )
}
export type GetSequenceEnrollmentsQueryHookResult = ReturnType<typeof useGetSequenceEnrollmentsQuery>
export type GetSequenceEnrollmentsLazyQueryHookResult = ReturnType<typeof useGetSequenceEnrollmentsLazyQuery>
export type GetSequenceEnrollmentsSuspenseQueryHookResult = ReturnType<typeof useGetSequenceEnrollmentsSuspenseQuery>
export type GetSequenceEnrollmentsQueryResult = Apollo.QueryResult<
  GetSequenceEnrollmentsQuery,
  GetSequenceEnrollmentsQueryVariables
>
export const GetSequenceProspectsOptionsDocument = gql`
  query GetSequenceProspectsOptions($search: String, $currentSequenceId: String!) {
    GetCandidateProfile(applicationFilters: { search: $search }) {
      id
      ...CandidateProfileIds
      ...CandidateProfileName
      ...CandidateProfileEmail
      isEnrolledInSequence(currentSequenceId: $currentSequenceId)
    }
  }
  ${CandidateProfileIdsFragmentDoc}
  ${CandidateProfileNameFragmentDoc}
  ${CandidateProfileEmailFragmentDoc}
`

/**
 * __useGetSequenceProspectsOptionsQuery__
 *
 * To run a query within a React component, call `useGetSequenceProspectsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceProspectsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceProspectsOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      currentSequenceId: // value for 'currentSequenceId'
 *   },
 * });
 */
export function useGetSequenceProspectsOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSequenceProspectsOptionsQuery, GetSequenceProspectsOptionsQueryVariables> &
    ({ variables: GetSequenceProspectsOptionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceProspectsOptionsQuery, GetSequenceProspectsOptionsQueryVariables>(
    GetSequenceProspectsOptionsDocument,
    options,
  )
}
export function useGetSequenceProspectsOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSequenceProspectsOptionsQuery,
    GetSequenceProspectsOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceProspectsOptionsQuery, GetSequenceProspectsOptionsQueryVariables>(
    GetSequenceProspectsOptionsDocument,
    options,
  )
}
export function useGetSequenceProspectsOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSequenceProspectsOptionsQuery, GetSequenceProspectsOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceProspectsOptionsQuery, GetSequenceProspectsOptionsQueryVariables>(
    GetSequenceProspectsOptionsDocument,
    options,
  )
}
export type GetSequenceProspectsOptionsQueryHookResult = ReturnType<typeof useGetSequenceProspectsOptionsQuery>
export type GetSequenceProspectsOptionsLazyQueryHookResult = ReturnType<typeof useGetSequenceProspectsOptionsLazyQuery>
export type GetSequenceProspectsOptionsSuspenseQueryHookResult = ReturnType<
  typeof useGetSequenceProspectsOptionsSuspenseQuery
>
export type GetSequenceProspectsOptionsQueryResult = Apollo.QueryResult<
  GetSequenceProspectsOptionsQuery,
  GetSequenceProspectsOptionsQueryVariables
>
export const GetTalentPoolDocument = gql`
  query GetTalentPool(
    $limit: Int
    $page: Int
    $applicationFilters: ApplicationFiltersOnCandidateProfile
    $customCandidateProfileFields: [CustomCandidateProfileFieldFilter!]
    $sortBy: SortByCandidateProfile
    $sortDirection: SortDirection
    $talentPoolId: Int
  ) {
    GetCandidateProfile(
      page: $page
      limit: $limit
      applicationFilters: $applicationFilters
      customCandidateProfileFields: $customCandidateProfileFields
      sortBy: $sortBy
      sortDirection: $sortDirection
      talentPoolId: $talentPoolId
    ) {
      id
      profileType
      primaryEmail
      CandidateLabels {
        ...CandidateLabel
      }
      ProspectStatus(talentPoolId: $talentPoolId) {
        ...ProspectStatus
      }
      ProspectOwner(talentPoolId: $talentPoolId) {
        id
        UserInvitation {
          ScalisUser {
            ...ScalisUser
          }
        }
      }
      CandidateApplicationRating {
        id
        score
      }
      CandidateApplication {
        ...CandidateApplication
        JobListing {
          id
          publicListingId
        }
        CandidateSource {
          ...CandidateSource
        }
      }
      UploadedCandidate {
        ...UploadedCandidate
      }
      ScalisUser {
        ...ScalisUser
        mostRecentJob: Experience(onlyMostRecentJob: true) {
          id
          industry
          jobTitle
          employerName
        }
        currentJob: Experience(onlyCurrentJob: true) {
          id
          jobTitle
          employerName
        }
        highestEducation: Education(highestEducation: true) {
          id
          educationLevel
          institutionName
        }
        ContactInfo {
          id
          phoneNumber
        }
        Address {
          id
          country
          city
          state
        }
        EmailVerification {
          id
          isPrimary
          emailAddress
          isVisibleToEmployers
        }
        JobSeekerInfo {
          id
          jobSeekerId
        }
        ExperienceTenure {
          average
          longest
          shortest
        }
      }
      UploadedCandidate {
        ...UploadedCandidate
      }
      ProfileDetails {
        id
        phoneNumber
        CandidateSource {
          ...CandidateSource
        }
      }
      CustomCandidateProfileFieldValues {
        ...CustomCandidateProfileFieldValue
      }
    }
    CountCandidateProfile(applicationFilters: $applicationFilters, talentPoolId: $talentPoolId) {
      count
    }
  }
  ${CandidateLabelFragmentDoc}
  ${ProspectStatusFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${CandidateApplicationFragmentDoc}
  ${CandidateSourceFragmentDoc}
  ${UploadedCandidateFragmentDoc}
  ${CustomCandidateProfileFieldValueFragmentDoc}
`

/**
 * __useGetTalentPoolQuery__
 *
 * To run a query within a React component, call `useGetTalentPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentPoolQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      applicationFilters: // value for 'applicationFilters'
 *      customCandidateProfileFields: // value for 'customCandidateProfileFields'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      talentPoolId: // value for 'talentPoolId'
 *   },
 * });
 */
export function useGetTalentPoolQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTalentPoolQuery, GetTalentPoolQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTalentPoolQuery, GetTalentPoolQueryVariables>(GetTalentPoolDocument, options)
}
export function useGetTalentPoolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTalentPoolQuery, GetTalentPoolQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTalentPoolQuery, GetTalentPoolQueryVariables>(GetTalentPoolDocument, options)
}
export function useGetTalentPoolSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentPoolQuery, GetTalentPoolQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTalentPoolQuery, GetTalentPoolQueryVariables>(GetTalentPoolDocument, options)
}
export type GetTalentPoolQueryHookResult = ReturnType<typeof useGetTalentPoolQuery>
export type GetTalentPoolLazyQueryHookResult = ReturnType<typeof useGetTalentPoolLazyQuery>
export type GetTalentPoolSuspenseQueryHookResult = ReturnType<typeof useGetTalentPoolSuspenseQuery>
export type GetTalentPoolQueryResult = Apollo.QueryResult<GetTalentPoolQuery, GetTalentPoolQueryVariables>
export const ListDuplicateApplicationsDocument = gql`
  query ListDuplicateApplications($candidateProfileId: Int!, $requisitionId: Int!) {
    ListDuplicateApplications(candidateProfileId: $candidateProfileId, requisitionId: $requisitionId) {
      id
      applicationStatus
      appliedAt
      templateStageId
      CandidateProfile {
        id
        ScalisUser {
          ...ScalisUser
          Experience(onlyCurrentJob: true) {
            jobTitle
            employerName
          }
          EmailVerification {
            emailAddress
            isPrimary
          }
          WebsiteOrSocialMedia {
            type
            websiteURL
          }
        }
        ProfileDetails {
          phoneNumber
          profileLink
          timezone
        }
      }
      JobListing {
        id
        listingTitle
        externalTitle
        stateAndOrCountry
        Address {
          id
          city
          state
          country
        }
        Requisition {
          id
          extRequisitionId
          jobName
        }
      }
      lastUpdatedStatusAt
      duplicationStatus
      TemplateStage {
        name
        TemplateMilestone {
          name
        }
        TemplatePipeline {
          TemplateStage {
            id
            name
          }
        }
      }
      CustomApplicationStatus {
        ...CustomApplicationStatus
      }
    }
  }
  ${ScalisUserFragmentDoc}
  ${CustomApplicationStatusFragmentDoc}
`

/**
 * __useListDuplicateApplicationsQuery__
 *
 * To run a query within a React component, call `useListDuplicateApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDuplicateApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDuplicateApplicationsQuery({
 *   variables: {
 *      candidateProfileId: // value for 'candidateProfileId'
 *      requisitionId: // value for 'requisitionId'
 *   },
 * });
 */
export function useListDuplicateApplicationsQuery(
  baseOptions: Apollo.QueryHookOptions<ListDuplicateApplicationsQuery, ListDuplicateApplicationsQueryVariables> &
    ({ variables: ListDuplicateApplicationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListDuplicateApplicationsQuery, ListDuplicateApplicationsQueryVariables>(
    ListDuplicateApplicationsDocument,
    options,
  )
}
export function useListDuplicateApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDuplicateApplicationsQuery, ListDuplicateApplicationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListDuplicateApplicationsQuery, ListDuplicateApplicationsQueryVariables>(
    ListDuplicateApplicationsDocument,
    options,
  )
}
export function useListDuplicateApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListDuplicateApplicationsQuery, ListDuplicateApplicationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListDuplicateApplicationsQuery, ListDuplicateApplicationsQueryVariables>(
    ListDuplicateApplicationsDocument,
    options,
  )
}
export type ListDuplicateApplicationsQueryHookResult = ReturnType<typeof useListDuplicateApplicationsQuery>
export type ListDuplicateApplicationsLazyQueryHookResult = ReturnType<typeof useListDuplicateApplicationsLazyQuery>
export type ListDuplicateApplicationsSuspenseQueryHookResult = ReturnType<
  typeof useListDuplicateApplicationsSuspenseQuery
>
export type ListDuplicateApplicationsQueryResult = Apollo.QueryResult<
  ListDuplicateApplicationsQuery,
  ListDuplicateApplicationsQueryVariables
>
export const GetCandidateSourceNamesDocument = gql`
  query GetCandidateSourceNames($input: CandidateSourceNameInput!) {
    GetCandidateSourceNames(input: $input) {
      id
      name
      sourceCategory
      companyId
      createdAt
      updatedAt
      customSourceCategory {
        id
        sourceCategoryName
        externalId
        companyId
        companyUserId
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useGetCandidateSourceNamesQuery__
 *
 * To run a query within a React component, call `useGetCandidateSourceNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateSourceNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateSourceNamesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateSourceNamesQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateSourceNamesQuery, GetCandidateSourceNamesQueryVariables> &
    ({ variables: GetCandidateSourceNamesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateSourceNamesQuery, GetCandidateSourceNamesQueryVariables>(
    GetCandidateSourceNamesDocument,
    options,
  )
}
export function useGetCandidateSourceNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateSourceNamesQuery, GetCandidateSourceNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateSourceNamesQuery, GetCandidateSourceNamesQueryVariables>(
    GetCandidateSourceNamesDocument,
    options,
  )
}
export function useGetCandidateSourceNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateSourceNamesQuery, GetCandidateSourceNamesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateSourceNamesQuery, GetCandidateSourceNamesQueryVariables>(
    GetCandidateSourceNamesDocument,
    options,
  )
}
export type GetCandidateSourceNamesQueryHookResult = ReturnType<typeof useGetCandidateSourceNamesQuery>
export type GetCandidateSourceNamesLazyQueryHookResult = ReturnType<typeof useGetCandidateSourceNamesLazyQuery>
export type GetCandidateSourceNamesSuspenseQueryHookResult = ReturnType<typeof useGetCandidateSourceNamesSuspenseQuery>
export type GetCandidateSourceNamesQueryResult = Apollo.QueryResult<
  GetCandidateSourceNamesQuery,
  GetCandidateSourceNamesQueryVariables
>
export const ListCustomSourceCategoriesDocument = gql`
  query ListCustomSourceCategories {
    ListCustomSourceCategories {
      id
      companyId
      companyUserId
      sourceCategoryName
      externalId
      createdAt
      updatedAt
      company {
        id
      }
      companyUser {
        id
      }
      candidateSourceNames {
        id
        name
        sourceCategory
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useListCustomSourceCategoriesQuery__
 *
 * To run a query within a React component, call `useListCustomSourceCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomSourceCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomSourceCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCustomSourceCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCustomSourceCategoriesQuery, ListCustomSourceCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCustomSourceCategoriesQuery, ListCustomSourceCategoriesQueryVariables>(
    ListCustomSourceCategoriesDocument,
    options,
  )
}
export function useListCustomSourceCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCustomSourceCategoriesQuery, ListCustomSourceCategoriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCustomSourceCategoriesQuery, ListCustomSourceCategoriesQueryVariables>(
    ListCustomSourceCategoriesDocument,
    options,
  )
}
export function useListCustomSourceCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCustomSourceCategoriesQuery, ListCustomSourceCategoriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCustomSourceCategoriesQuery, ListCustomSourceCategoriesQueryVariables>(
    ListCustomSourceCategoriesDocument,
    options,
  )
}
export type ListCustomSourceCategoriesQueryHookResult = ReturnType<typeof useListCustomSourceCategoriesQuery>
export type ListCustomSourceCategoriesLazyQueryHookResult = ReturnType<typeof useListCustomSourceCategoriesLazyQuery>
export type ListCustomSourceCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useListCustomSourceCategoriesSuspenseQuery
>
export type ListCustomSourceCategoriesQueryResult = Apollo.QueryResult<
  ListCustomSourceCategoriesQuery,
  ListCustomSourceCategoriesQueryVariables
>
export const GetCandidateTouchpointActivityLogDocument = gql`
  query GetCandidateTouchpointActivityLog($input: GetCandidateTouchpointActivityLogInput!) {
    GetCandidateTouchpointActivityLog(input: $input) {
      id
      candidateProfileId
      candidateApplicationId
      companyCandidateTouchpointId
      activityTimestamp
      activity
      userAction
      isDeleted
      createdAt
      updatedAt
      companyUserId
      CandidateProfile {
        id
        primaryEmail
        ScalisUser {
          firstName
          lastName
          profileImage
        }
      }
      CandidateApplication {
        id
        applicationStatus
        appliedAt
        JobListing {
          id
        }
        TemplateStage {
          id
          name
        }
      }
      CompanyUser {
        id
        UserInvitation {
          email
          ScalisUser {
            firstName
            lastName
          }
        }
      }
    }
  }
`

/**
 * __useGetCandidateTouchpointActivityLogQuery__
 *
 * To run a query within a React component, call `useGetCandidateTouchpointActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateTouchpointActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateTouchpointActivityLogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateTouchpointActivityLogQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCandidateTouchpointActivityLogQuery,
    GetCandidateTouchpointActivityLogQueryVariables
  > &
    ({ variables: GetCandidateTouchpointActivityLogQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateTouchpointActivityLogQuery, GetCandidateTouchpointActivityLogQueryVariables>(
    GetCandidateTouchpointActivityLogDocument,
    options,
  )
}
export function useGetCandidateTouchpointActivityLogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidateTouchpointActivityLogQuery,
    GetCandidateTouchpointActivityLogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateTouchpointActivityLogQuery, GetCandidateTouchpointActivityLogQueryVariables>(
    GetCandidateTouchpointActivityLogDocument,
    options,
  )
}
export function useGetCandidateTouchpointActivityLogSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCandidateTouchpointActivityLogQuery,
        GetCandidateTouchpointActivityLogQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetCandidateTouchpointActivityLogQuery,
    GetCandidateTouchpointActivityLogQueryVariables
  >(GetCandidateTouchpointActivityLogDocument, options)
}
export type GetCandidateTouchpointActivityLogQueryHookResult = ReturnType<
  typeof useGetCandidateTouchpointActivityLogQuery
>
export type GetCandidateTouchpointActivityLogLazyQueryHookResult = ReturnType<
  typeof useGetCandidateTouchpointActivityLogLazyQuery
>
export type GetCandidateTouchpointActivityLogSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateTouchpointActivityLogSuspenseQuery
>
export type GetCandidateTouchpointActivityLogQueryResult = Apollo.QueryResult<
  GetCandidateTouchpointActivityLogQuery,
  GetCandidateTouchpointActivityLogQueryVariables
>
export const ListCompanyCandidateTouchpointsDocument = gql`
  query ListCompanyCandidateTouchpoints($input: ListCompanyCandidateTouchpointsInput) {
    ListCompanyCandidateTouchpoints(input: $input) {
      items {
        id
        name
        companyId
        companyUserId
        isDeleted
        isDefault
        isArchived
        createdAt
        updatedAt
        activityLogs {
          id
          activityTimestamp
          activity
          CandidateProfile {
            id
            primaryEmail
            ScalisUser {
              firstName
              lastName
            }
          }
          CandidateApplication {
            id
            applicationStatus
          }
        }
      }
      total
      page
      limit
      totalPages
    }
  }
`

/**
 * __useListCompanyCandidateTouchpointsQuery__
 *
 * To run a query within a React component, call `useListCompanyCandidateTouchpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyCandidateTouchpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyCandidateTouchpointsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCompanyCandidateTouchpointsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListCompanyCandidateTouchpointsQuery,
    ListCompanyCandidateTouchpointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCompanyCandidateTouchpointsQuery, ListCompanyCandidateTouchpointsQueryVariables>(
    ListCompanyCandidateTouchpointsDocument,
    options,
  )
}
export function useListCompanyCandidateTouchpointsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCompanyCandidateTouchpointsQuery,
    ListCompanyCandidateTouchpointsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCompanyCandidateTouchpointsQuery, ListCompanyCandidateTouchpointsQueryVariables>(
    ListCompanyCandidateTouchpointsDocument,
    options,
  )
}
export function useListCompanyCandidateTouchpointsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListCompanyCandidateTouchpointsQuery,
        ListCompanyCandidateTouchpointsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCompanyCandidateTouchpointsQuery, ListCompanyCandidateTouchpointsQueryVariables>(
    ListCompanyCandidateTouchpointsDocument,
    options,
  )
}
export type ListCompanyCandidateTouchpointsQueryHookResult = ReturnType<typeof useListCompanyCandidateTouchpointsQuery>
export type ListCompanyCandidateTouchpointsLazyQueryHookResult = ReturnType<
  typeof useListCompanyCandidateTouchpointsLazyQuery
>
export type ListCompanyCandidateTouchpointsSuspenseQueryHookResult = ReturnType<
  typeof useListCompanyCandidateTouchpointsSuspenseQuery
>
export type ListCompanyCandidateTouchpointsQueryResult = Apollo.QueryResult<
  ListCompanyCandidateTouchpointsQuery,
  ListCompanyCandidateTouchpointsQueryVariables
>
export const GetPipelineCompanyUserViewDocument = gql`
  query GetPipelineCompanyUserView($input: GetPipelineCompanyUserViewInput!) {
    GetPipelineCompanyUserView(input: $input) {
      list {
        ...ViewLinkWithUserPreference
      }
      createdByMe {
        ...RequisitionTalentPoolCompanySavedView
      }
      defaultViews {
        ...RequisitionTalentPoolCompanySavedView
      }
      savedByOthers {
        ...RequisitionTalentPoolCompanySavedView
      }
    }
  }
  ${ViewLinkWithUserPreferenceFragmentDoc}
  ${RequisitionTalentPoolCompanySavedViewFragmentDoc}
`

/**
 * __useGetPipelineCompanyUserViewQuery__
 *
 * To run a query within a React component, call `useGetPipelineCompanyUserViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineCompanyUserViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineCompanyUserViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPipelineCompanyUserViewQuery(
  baseOptions: Apollo.QueryHookOptions<GetPipelineCompanyUserViewQuery, GetPipelineCompanyUserViewQueryVariables> &
    ({ variables: GetPipelineCompanyUserViewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPipelineCompanyUserViewQuery, GetPipelineCompanyUserViewQueryVariables>(
    GetPipelineCompanyUserViewDocument,
    options,
  )
}
export function useGetPipelineCompanyUserViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPipelineCompanyUserViewQuery, GetPipelineCompanyUserViewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPipelineCompanyUserViewQuery, GetPipelineCompanyUserViewQueryVariables>(
    GetPipelineCompanyUserViewDocument,
    options,
  )
}
export function useGetPipelineCompanyUserViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPipelineCompanyUserViewQuery, GetPipelineCompanyUserViewQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetPipelineCompanyUserViewQuery, GetPipelineCompanyUserViewQueryVariables>(
    GetPipelineCompanyUserViewDocument,
    options,
  )
}
export type GetPipelineCompanyUserViewQueryHookResult = ReturnType<typeof useGetPipelineCompanyUserViewQuery>
export type GetPipelineCompanyUserViewLazyQueryHookResult = ReturnType<typeof useGetPipelineCompanyUserViewLazyQuery>
export type GetPipelineCompanyUserViewSuspenseQueryHookResult = ReturnType<
  typeof useGetPipelineCompanyUserViewSuspenseQuery
>
export type GetPipelineCompanyUserViewQueryResult = Apollo.QueryResult<
  GetPipelineCompanyUserViewQuery,
  GetPipelineCompanyUserViewQueryVariables
>
export const ListCompanyUserGroupsDocument = gql`
  query ListCompanyUserGroups($input: ListCompanyUserGroupsInput!) {
    ListCompanyUserGroups(input: $input) {
      id
      name
      externalId
      createdAt
      updatedAt
      deleted
      createdBy {
        id
        profileImage
        UserInvitation {
          ScalisUser {
            ...ScalisUser
            EmailVerification {
              emailAddress
            }
          }
        }
      }
      Offices {
        CompanyOffice {
          id
          officeName
          externalId
        }
      }
      Departments {
        CompanyDepartment {
          id
          departmentName
          externalId
        }
      }
      Members {
        CompanyUser {
          id
          profileImage
          UserInvitation {
            ScalisUser {
              ...ScalisUser
              EmailVerification {
                emailAddress
              }
            }
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useListCompanyUserGroupsQuery__
 *
 * To run a query within a React component, call `useListCompanyUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyUserGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCompanyUserGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<ListCompanyUserGroupsQuery, ListCompanyUserGroupsQueryVariables> &
    ({ variables: ListCompanyUserGroupsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCompanyUserGroupsQuery, ListCompanyUserGroupsQueryVariables>(
    ListCompanyUserGroupsDocument,
    options,
  )
}
export function useListCompanyUserGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCompanyUserGroupsQuery, ListCompanyUserGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCompanyUserGroupsQuery, ListCompanyUserGroupsQueryVariables>(
    ListCompanyUserGroupsDocument,
    options,
  )
}
export function useListCompanyUserGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCompanyUserGroupsQuery, ListCompanyUserGroupsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCompanyUserGroupsQuery, ListCompanyUserGroupsQueryVariables>(
    ListCompanyUserGroupsDocument,
    options,
  )
}
export type ListCompanyUserGroupsQueryHookResult = ReturnType<typeof useListCompanyUserGroupsQuery>
export type ListCompanyUserGroupsLazyQueryHookResult = ReturnType<typeof useListCompanyUserGroupsLazyQuery>
export type ListCompanyUserGroupsSuspenseQueryHookResult = ReturnType<typeof useListCompanyUserGroupsSuspenseQuery>
export type ListCompanyUserGroupsQueryResult = Apollo.QueryResult<
  ListCompanyUserGroupsQuery,
  ListCompanyUserGroupsQueryVariables
>
export const GetCompanyUsersOptionsDocument = gql`
  query GetCompanyUsersOptions {
    GetCompanyUsers {
      id
      UserInvitation {
        id
        ScalisUser {
          id
          firstName
          lastName
          profileImage
          EmailVerification {
            id
            isPrimary
            emailAddress
          }
        }
      }
    }
  }
`

/**
 * __useGetCompanyUsersOptionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyUsersOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUsersOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUsersOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyUsersOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyUsersOptionsQuery, GetCompanyUsersOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyUsersOptionsQuery, GetCompanyUsersOptionsQueryVariables>(
    GetCompanyUsersOptionsDocument,
    options,
  )
}
export function useGetCompanyUsersOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyUsersOptionsQuery, GetCompanyUsersOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyUsersOptionsQuery, GetCompanyUsersOptionsQueryVariables>(
    GetCompanyUsersOptionsDocument,
    options,
  )
}
export function useGetCompanyUsersOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyUsersOptionsQuery, GetCompanyUsersOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyUsersOptionsQuery, GetCompanyUsersOptionsQueryVariables>(
    GetCompanyUsersOptionsDocument,
    options,
  )
}
export type GetCompanyUsersOptionsQueryHookResult = ReturnType<typeof useGetCompanyUsersOptionsQuery>
export type GetCompanyUsersOptionsLazyQueryHookResult = ReturnType<typeof useGetCompanyUsersOptionsLazyQuery>
export type GetCompanyUsersOptionsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyUsersOptionsSuspenseQuery>
export type GetCompanyUsersOptionsQueryResult = Apollo.QueryResult<
  GetCompanyUsersOptionsQuery,
  GetCompanyUsersOptionsQueryVariables
>
export const GetInterviewerCalendarsDocument = gql`
  query GetInterviewerCalendars {
    GetCalendarSettings {
      Calendars {
        id
        nylasCalendarId
        name
        isPrimary
        color
        calendarSettingsId
      }
      id
      timeZone
      provider
      email
      companyUserId
    }
    GetCompanyUsers {
      id
      profileImage
      companyId
      UserInvitation {
        id
        email
        ScalisUser {
          ...ScalisUser
        }
      }
      CalendarSettings {
        id
        availability
        provider
        timeZone
        hourDisplay
        email
        Calendars {
          id
          nylasCalendarId
          calendarSettingsId
          name
          isPrimary
          color
          CalendarEvents {
            id
            nylasEventStatus
            nylasCalendarEventId
            title
            eventType
            description
            startTime
            endTime
            timeZone
            location
            repeats
            reminders
            employers
            conferencing
            masterEventId
            regardingCandidates
            regardingJobs
            internalGuests
            candidates
            isScalisEvent
            CandidateInterview {
              stageId
              status
              TemplateStage {
                TemplateMilestone {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetInterviewerCalendarsQuery__
 *
 * To run a query within a React component, call `useGetInterviewerCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterviewerCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterviewerCalendarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterviewerCalendarsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInterviewerCalendarsQuery, GetInterviewerCalendarsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInterviewerCalendarsQuery, GetInterviewerCalendarsQueryVariables>(
    GetInterviewerCalendarsDocument,
    options,
  )
}
export function useGetInterviewerCalendarsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInterviewerCalendarsQuery, GetInterviewerCalendarsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInterviewerCalendarsQuery, GetInterviewerCalendarsQueryVariables>(
    GetInterviewerCalendarsDocument,
    options,
  )
}
export function useGetInterviewerCalendarsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInterviewerCalendarsQuery, GetInterviewerCalendarsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInterviewerCalendarsQuery, GetInterviewerCalendarsQueryVariables>(
    GetInterviewerCalendarsDocument,
    options,
  )
}
export type GetInterviewerCalendarsQueryHookResult = ReturnType<typeof useGetInterviewerCalendarsQuery>
export type GetInterviewerCalendarsLazyQueryHookResult = ReturnType<typeof useGetInterviewerCalendarsLazyQuery>
export type GetInterviewerCalendarsSuspenseQueryHookResult = ReturnType<typeof useGetInterviewerCalendarsSuspenseQuery>
export type GetInterviewerCalendarsQueryResult = Apollo.QueryResult<
  GetInterviewerCalendarsQuery,
  GetInterviewerCalendarsQueryVariables
>
export const GetStageCompanyUsersDocument = gql`
  query GetStageCompanyUsers {
    GetCompanyUsers {
      __typename
      id
      companyId
      profileImage
      UserInvitation {
        __typename
        id
        email
        ScalisUser {
          ...ScalisUser
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetStageCompanyUsersQuery__
 *
 * To run a query within a React component, call `useGetStageCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStageCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStageCompanyUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStageCompanyUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetStageCompanyUsersQuery, GetStageCompanyUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetStageCompanyUsersQuery, GetStageCompanyUsersQueryVariables>(
    GetStageCompanyUsersDocument,
    options,
  )
}
export function useGetStageCompanyUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStageCompanyUsersQuery, GetStageCompanyUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetStageCompanyUsersQuery, GetStageCompanyUsersQueryVariables>(
    GetStageCompanyUsersDocument,
    options,
  )
}
export function useGetStageCompanyUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetStageCompanyUsersQuery, GetStageCompanyUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetStageCompanyUsersQuery, GetStageCompanyUsersQueryVariables>(
    GetStageCompanyUsersDocument,
    options,
  )
}
export type GetStageCompanyUsersQueryHookResult = ReturnType<typeof useGetStageCompanyUsersQuery>
export type GetStageCompanyUsersLazyQueryHookResult = ReturnType<typeof useGetStageCompanyUsersLazyQuery>
export type GetStageCompanyUsersSuspenseQueryHookResult = ReturnType<typeof useGetStageCompanyUsersSuspenseQuery>
export type GetStageCompanyUsersQueryResult = Apollo.QueryResult<
  GetStageCompanyUsersQuery,
  GetStageCompanyUsersQueryVariables
>
export const GetCompanyDepartmentsDocument = gql`
  query GetCompanyDepartments($companyId: Int) {
    GetCompanyInfo(id: $companyId) {
      CompanyDepartment {
        ParentCompanyDepartment {
          departmentName
          id
        }
        type
        subordinateTo
        id
        externalId
        departmentName
      }
    }
  }
`

/**
 * __useGetCompanyDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDepartmentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>(
    GetCompanyDepartmentsDocument,
    options,
  )
}
export function useGetCompanyDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>(
    GetCompanyDepartmentsDocument,
    options,
  )
}
export function useGetCompanyDepartmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>(
    GetCompanyDepartmentsDocument,
    options,
  )
}
export type GetCompanyDepartmentsQueryHookResult = ReturnType<typeof useGetCompanyDepartmentsQuery>
export type GetCompanyDepartmentsLazyQueryHookResult = ReturnType<typeof useGetCompanyDepartmentsLazyQuery>
export type GetCompanyDepartmentsSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDepartmentsSuspenseQuery>
export type GetCompanyDepartmentsQueryResult = Apollo.QueryResult<
  GetCompanyDepartmentsQuery,
  GetCompanyDepartmentsQueryVariables
>
export const GetCompanyInfoSettingsFormDocument = gql`
  query GetCompanyInfoSettingsForm($id: Int) {
    GetCompanyInfo(id: $id) {
      subdomain
      id
      CompanyInfo {
        logo
        companyType
        companyName
        industry
        subIndustry
        phoneNumber
        website
        linkedin
        linkedinId
        employeeCount
        yearsInOperation
      }
      Address {
        ...AddressFragment
      }
    }
  }
  ${AddressFragmentFragmentDoc}
`

/**
 * __useGetCompanyInfoSettingsFormQuery__
 *
 * To run a query within a React component, call `useGetCompanyInfoSettingsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInfoSettingsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInfoSettingsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyInfoSettingsFormQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyInfoSettingsFormQuery, GetCompanyInfoSettingsFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyInfoSettingsFormQuery, GetCompanyInfoSettingsFormQueryVariables>(
    GetCompanyInfoSettingsFormDocument,
    options,
  )
}
export function useGetCompanyInfoSettingsFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInfoSettingsFormQuery, GetCompanyInfoSettingsFormQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyInfoSettingsFormQuery, GetCompanyInfoSettingsFormQueryVariables>(
    GetCompanyInfoSettingsFormDocument,
    options,
  )
}
export function useGetCompanyInfoSettingsFormSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyInfoSettingsFormQuery, GetCompanyInfoSettingsFormQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyInfoSettingsFormQuery, GetCompanyInfoSettingsFormQueryVariables>(
    GetCompanyInfoSettingsFormDocument,
    options,
  )
}
export type GetCompanyInfoSettingsFormQueryHookResult = ReturnType<typeof useGetCompanyInfoSettingsFormQuery>
export type GetCompanyInfoSettingsFormLazyQueryHookResult = ReturnType<typeof useGetCompanyInfoSettingsFormLazyQuery>
export type GetCompanyInfoSettingsFormSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyInfoSettingsFormSuspenseQuery
>
export type GetCompanyInfoSettingsFormQueryResult = Apollo.QueryResult<
  GetCompanyInfoSettingsFormQuery,
  GetCompanyInfoSettingsFormQueryVariables
>
export const GetCompanyOfficesDocument = gql`
  query GetCompanyOffices($companyId: Int) {
    GetCompanyInfo(id: $companyId) {
      CompanyOffice {
        Address {
          ...AddressFragment
        }
        externalId
        officeName
        id
      }
    }
  }
  ${AddressFragmentFragmentDoc}
`

/**
 * __useGetCompanyOfficesQuery__
 *
 * To run a query within a React component, call `useGetCompanyOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOfficesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyOfficesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyOfficesQuery, GetCompanyOfficesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyOfficesQuery, GetCompanyOfficesQueryVariables>(GetCompanyOfficesDocument, options)
}
export function useGetCompanyOfficesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyOfficesQuery, GetCompanyOfficesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyOfficesQuery, GetCompanyOfficesQueryVariables>(
    GetCompanyOfficesDocument,
    options,
  )
}
export function useGetCompanyOfficesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyOfficesQuery, GetCompanyOfficesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyOfficesQuery, GetCompanyOfficesQueryVariables>(
    GetCompanyOfficesDocument,
    options,
  )
}
export type GetCompanyOfficesQueryHookResult = ReturnType<typeof useGetCompanyOfficesQuery>
export type GetCompanyOfficesLazyQueryHookResult = ReturnType<typeof useGetCompanyOfficesLazyQuery>
export type GetCompanyOfficesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyOfficesSuspenseQuery>
export type GetCompanyOfficesQueryResult = Apollo.QueryResult<GetCompanyOfficesQuery, GetCompanyOfficesQueryVariables>
export const GetCompanyUsersCandidateProfileDocument = gql`
  query GetCompanyUsersCandidateProfile {
    GetCompanyUsers {
      id
      companyUserStatus
      UserInvitation {
        id
        ScalisUser {
          ...ScalisUser
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetCompanyUsersCandidateProfileQuery__
 *
 * To run a query within a React component, call `useGetCompanyUsersCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUsersCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUsersCandidateProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyUsersCandidateProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyUsersCandidateProfileQuery,
    GetCompanyUsersCandidateProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyUsersCandidateProfileQuery, GetCompanyUsersCandidateProfileQueryVariables>(
    GetCompanyUsersCandidateProfileDocument,
    options,
  )
}
export function useGetCompanyUsersCandidateProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyUsersCandidateProfileQuery,
    GetCompanyUsersCandidateProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyUsersCandidateProfileQuery, GetCompanyUsersCandidateProfileQueryVariables>(
    GetCompanyUsersCandidateProfileDocument,
    options,
  )
}
export function useGetCompanyUsersCandidateProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCompanyUsersCandidateProfileQuery,
        GetCompanyUsersCandidateProfileQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyUsersCandidateProfileQuery, GetCompanyUsersCandidateProfileQueryVariables>(
    GetCompanyUsersCandidateProfileDocument,
    options,
  )
}
export type GetCompanyUsersCandidateProfileQueryHookResult = ReturnType<typeof useGetCompanyUsersCandidateProfileQuery>
export type GetCompanyUsersCandidateProfileLazyQueryHookResult = ReturnType<
  typeof useGetCompanyUsersCandidateProfileLazyQuery
>
export type GetCompanyUsersCandidateProfileSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyUsersCandidateProfileSuspenseQuery
>
export type GetCompanyUsersCandidateProfileQueryResult = Apollo.QueryResult<
  GetCompanyUsersCandidateProfileQuery,
  GetCompanyUsersCandidateProfileQueryVariables
>
export const GetCompanyUsersDocument = gql`
  query GetCompanyUsers($input: GetCompanyUsersInput) {
    GetCompanyUsers(input: $input) {
      id
      companyId
      companyUserStatus
      profileImage
      UserRoles {
        roleId
        userId
        role {
          id
          name
        }
      }
      UserInvitation {
        id
        email
        invitedAs
        invitationStatus
        ScalisUser {
          ...ScalisUser
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetCompanyUsersQuery__
 *
 * To run a query within a React component, call `useGetCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCompanyUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>(GetCompanyUsersDocument, options)
}
export function useGetCompanyUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>(GetCompanyUsersDocument, options)
}
export function useGetCompanyUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>(GetCompanyUsersDocument, options)
}
export type GetCompanyUsersQueryHookResult = ReturnType<typeof useGetCompanyUsersQuery>
export type GetCompanyUsersLazyQueryHookResult = ReturnType<typeof useGetCompanyUsersLazyQuery>
export type GetCompanyUsersSuspenseQueryHookResult = ReturnType<typeof useGetCompanyUsersSuspenseQuery>
export type GetCompanyUsersQueryResult = Apollo.QueryResult<GetCompanyUsersQuery, GetCompanyUsersQueryVariables>
export const GetCompanyWithSubdomainDocument = gql`
  query GetCompanyWithSubdomain($subdomain: String) {
    GetCompanyInfo(subdomain: $subdomain) {
      id
      subdomain
      CompanyInfo {
        id
        logo
        companyName
      }
    }
  }
`

/**
 * __useGetCompanyWithSubdomainQuery__
 *
 * To run a query within a React component, call `useGetCompanyWithSubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyWithSubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyWithSubdomainQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useGetCompanyWithSubdomainQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyWithSubdomainQuery, GetCompanyWithSubdomainQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyWithSubdomainQuery, GetCompanyWithSubdomainQueryVariables>(
    GetCompanyWithSubdomainDocument,
    options,
  )
}
export function useGetCompanyWithSubdomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyWithSubdomainQuery, GetCompanyWithSubdomainQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyWithSubdomainQuery, GetCompanyWithSubdomainQueryVariables>(
    GetCompanyWithSubdomainDocument,
    options,
  )
}
export function useGetCompanyWithSubdomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyWithSubdomainQuery, GetCompanyWithSubdomainQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyWithSubdomainQuery, GetCompanyWithSubdomainQueryVariables>(
    GetCompanyWithSubdomainDocument,
    options,
  )
}
export type GetCompanyWithSubdomainQueryHookResult = ReturnType<typeof useGetCompanyWithSubdomainQuery>
export type GetCompanyWithSubdomainLazyQueryHookResult = ReturnType<typeof useGetCompanyWithSubdomainLazyQuery>
export type GetCompanyWithSubdomainSuspenseQueryHookResult = ReturnType<typeof useGetCompanyWithSubdomainSuspenseQuery>
export type GetCompanyWithSubdomainQueryResult = Apollo.QueryResult<
  GetCompanyWithSubdomainQuery,
  GetCompanyWithSubdomainQueryVariables
>
export const GetUserInvitationsDocument = gql`
  query GetUserInvitations {
    GetUserInvitations {
      scalisUserId
      invitedAs
      invitationStatus
      id
      email
      deletedAt
      companyId
      CompanyUser {
        UserRoles {
          userId
          roleId
          role {
            id
            name
          }
        }
        companyId
        companyUserStatus
        id
        profileImage
        userInvitationId
      }
      ScalisUser {
        ...ScalisUser
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetUserInvitationsQuery__
 *
 * To run a query within a React component, call `useGetUserInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInvitationsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserInvitationsQuery, GetUserInvitationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserInvitationsQuery, GetUserInvitationsQueryVariables>(GetUserInvitationsDocument, options)
}
export function useGetUserInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserInvitationsQuery, GetUserInvitationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserInvitationsQuery, GetUserInvitationsQueryVariables>(
    GetUserInvitationsDocument,
    options,
  )
}
export function useGetUserInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserInvitationsQuery, GetUserInvitationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUserInvitationsQuery, GetUserInvitationsQueryVariables>(
    GetUserInvitationsDocument,
    options,
  )
}
export type GetUserInvitationsQueryHookResult = ReturnType<typeof useGetUserInvitationsQuery>
export type GetUserInvitationsLazyQueryHookResult = ReturnType<typeof useGetUserInvitationsLazyQuery>
export type GetUserInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetUserInvitationsSuspenseQuery>
export type GetUserInvitationsQueryResult = Apollo.QueryResult<
  GetUserInvitationsQuery,
  GetUserInvitationsQueryVariables
>
export const ListCompanyDepartmentsDocument = gql`
  query ListCompanyDepartments($id: Int) {
    ListCompanyDepartments(id: $id) {
      id
      companyId
      departmentName
      subordinateTo
      externalId
      createdAt
      updatedAt
    }
  }
`

/**
 * __useListCompanyDepartmentsQuery__
 *
 * To run a query within a React component, call `useListCompanyDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyDepartmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListCompanyDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCompanyDepartmentsQuery, ListCompanyDepartmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCompanyDepartmentsQuery, ListCompanyDepartmentsQueryVariables>(
    ListCompanyDepartmentsDocument,
    options,
  )
}
export function useListCompanyDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCompanyDepartmentsQuery, ListCompanyDepartmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCompanyDepartmentsQuery, ListCompanyDepartmentsQueryVariables>(
    ListCompanyDepartmentsDocument,
    options,
  )
}
export function useListCompanyDepartmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCompanyDepartmentsQuery, ListCompanyDepartmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCompanyDepartmentsQuery, ListCompanyDepartmentsQueryVariables>(
    ListCompanyDepartmentsDocument,
    options,
  )
}
export type ListCompanyDepartmentsQueryHookResult = ReturnType<typeof useListCompanyDepartmentsQuery>
export type ListCompanyDepartmentsLazyQueryHookResult = ReturnType<typeof useListCompanyDepartmentsLazyQuery>
export type ListCompanyDepartmentsSuspenseQueryHookResult = ReturnType<typeof useListCompanyDepartmentsSuspenseQuery>
export type ListCompanyDepartmentsQueryResult = Apollo.QueryResult<
  ListCompanyDepartmentsQuery,
  ListCompanyDepartmentsQueryVariables
>
export const ListCompanyOfficesDocument = gql`
  query ListCompanyOffices($id: Int) {
    ListCompanyOffices(id: $id) {
      id
      companyId
      officeName
      externalId
      addressId
      createdAt
      updatedAt
      Address {
        id
        addressLine1
        addressLine2
        city
        state
        country
        postalCode
        timeZone
      }
    }
  }
`

/**
 * __useListCompanyOfficesQuery__
 *
 * To run a query within a React component, call `useListCompanyOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyOfficesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListCompanyOfficesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCompanyOfficesQuery, ListCompanyOfficesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCompanyOfficesQuery, ListCompanyOfficesQueryVariables>(ListCompanyOfficesDocument, options)
}
export function useListCompanyOfficesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCompanyOfficesQuery, ListCompanyOfficesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCompanyOfficesQuery, ListCompanyOfficesQueryVariables>(
    ListCompanyOfficesDocument,
    options,
  )
}
export function useListCompanyOfficesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCompanyOfficesQuery, ListCompanyOfficesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCompanyOfficesQuery, ListCompanyOfficesQueryVariables>(
    ListCompanyOfficesDocument,
    options,
  )
}
export type ListCompanyOfficesQueryHookResult = ReturnType<typeof useListCompanyOfficesQuery>
export type ListCompanyOfficesLazyQueryHookResult = ReturnType<typeof useListCompanyOfficesLazyQuery>
export type ListCompanyOfficesSuspenseQueryHookResult = ReturnType<typeof useListCompanyOfficesSuspenseQuery>
export type ListCompanyOfficesQueryResult = Apollo.QueryResult<
  ListCompanyOfficesQuery,
  ListCompanyOfficesQueryVariables
>
export const SearchCompanyGlobalDocument = gql`
  query SearchCompanyGlobal($search: String) {
    SearchCompanyGlobal(search: $search) {
      description
      id
      logo
      name
      website
    }
  }
`

/**
 * __useSearchCompanyGlobalQuery__
 *
 * To run a query within a React component, call `useSearchCompanyGlobalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompanyGlobalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompanyGlobalQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchCompanyGlobalQuery(
  baseOptions?: Apollo.QueryHookOptions<SearchCompanyGlobalQuery, SearchCompanyGlobalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchCompanyGlobalQuery, SearchCompanyGlobalQueryVariables>(
    SearchCompanyGlobalDocument,
    options,
  )
}
export function useSearchCompanyGlobalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchCompanyGlobalQuery, SearchCompanyGlobalQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchCompanyGlobalQuery, SearchCompanyGlobalQueryVariables>(
    SearchCompanyGlobalDocument,
    options,
  )
}
export function useSearchCompanyGlobalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchCompanyGlobalQuery, SearchCompanyGlobalQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchCompanyGlobalQuery, SearchCompanyGlobalQueryVariables>(
    SearchCompanyGlobalDocument,
    options,
  )
}
export type SearchCompanyGlobalQueryHookResult = ReturnType<typeof useSearchCompanyGlobalQuery>
export type SearchCompanyGlobalLazyQueryHookResult = ReturnType<typeof useSearchCompanyGlobalLazyQuery>
export type SearchCompanyGlobalSuspenseQueryHookResult = ReturnType<typeof useSearchCompanyGlobalSuspenseQuery>
export type SearchCompanyGlobalQueryResult = Apollo.QueryResult<
  SearchCompanyGlobalQuery,
  SearchCompanyGlobalQueryVariables
>
export const GetConnectedEmailSettingsDocument = gql`
  query GetConnectedEmailSettings {
    GetConnectedEmailSettings {
      id
      email
      provider
      createdAt
      updatedAt
    }
  }
`

/**
 * __useGetConnectedEmailSettingsQuery__
 *
 * To run a query within a React component, call `useGetConnectedEmailSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedEmailSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedEmailSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectedEmailSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetConnectedEmailSettingsQuery, GetConnectedEmailSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetConnectedEmailSettingsQuery, GetConnectedEmailSettingsQueryVariables>(
    GetConnectedEmailSettingsDocument,
    options,
  )
}
export function useGetConnectedEmailSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedEmailSettingsQuery, GetConnectedEmailSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetConnectedEmailSettingsQuery, GetConnectedEmailSettingsQueryVariables>(
    GetConnectedEmailSettingsDocument,
    options,
  )
}
export function useGetConnectedEmailSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetConnectedEmailSettingsQuery, GetConnectedEmailSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetConnectedEmailSettingsQuery, GetConnectedEmailSettingsQueryVariables>(
    GetConnectedEmailSettingsDocument,
    options,
  )
}
export type GetConnectedEmailSettingsQueryHookResult = ReturnType<typeof useGetConnectedEmailSettingsQuery>
export type GetConnectedEmailSettingsLazyQueryHookResult = ReturnType<typeof useGetConnectedEmailSettingsLazyQuery>
export type GetConnectedEmailSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetConnectedEmailSettingsSuspenseQuery
>
export type GetConnectedEmailSettingsQueryResult = Apollo.QueryResult<
  GetConnectedEmailSettingsQuery,
  GetConnectedEmailSettingsQueryVariables
>
export const ListCustomApplicationStatusesDocument = gql`
  query ListCustomApplicationStatuses($input: ListCustomApplicationStatusInput!) {
    ListCustomApplicationStatuses(input: $input) {
      items {
        ...CustomApplicationStatus
        company {
          id
        }
        companyUser {
          id
          UserInvitation {
            email
            ScalisUser {
              firstName
              lastName
            }
          }
        }
        _count
      }
      total
    }
  }
  ${CustomApplicationStatusFragmentDoc}
`

/**
 * __useListCustomApplicationStatusesQuery__
 *
 * To run a query within a React component, call `useListCustomApplicationStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomApplicationStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomApplicationStatusesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCustomApplicationStatusesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListCustomApplicationStatusesQuery,
    ListCustomApplicationStatusesQueryVariables
  > &
    ({ variables: ListCustomApplicationStatusesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCustomApplicationStatusesQuery, ListCustomApplicationStatusesQueryVariables>(
    ListCustomApplicationStatusesDocument,
    options,
  )
}
export function useListCustomApplicationStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListCustomApplicationStatusesQuery,
    ListCustomApplicationStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCustomApplicationStatusesQuery, ListCustomApplicationStatusesQueryVariables>(
    ListCustomApplicationStatusesDocument,
    options,
  )
}
export function useListCustomApplicationStatusesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCustomApplicationStatusesQuery, ListCustomApplicationStatusesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCustomApplicationStatusesQuery, ListCustomApplicationStatusesQueryVariables>(
    ListCustomApplicationStatusesDocument,
    options,
  )
}
export type ListCustomApplicationStatusesQueryHookResult = ReturnType<typeof useListCustomApplicationStatusesQuery>
export type ListCustomApplicationStatusesLazyQueryHookResult = ReturnType<
  typeof useListCustomApplicationStatusesLazyQuery
>
export type ListCustomApplicationStatusesSuspenseQueryHookResult = ReturnType<
  typeof useListCustomApplicationStatusesSuspenseQuery
>
export type ListCustomApplicationStatusesQueryResult = Apollo.QueryResult<
  ListCustomApplicationStatusesQuery,
  ListCustomApplicationStatusesQueryVariables
>
export const GetCustomApplicationFieldsDocument = gql`
  query GetCustomApplicationFields($input: GetCustomCandidateApplicationFieldsInput) {
    GetCustomCandidateApplicationFields(input: $input) {
      ...CustomCandidateApplicationField
    }
  }
  ${CustomCandidateApplicationFieldFragmentDoc}
`

/**
 * __useGetCustomApplicationFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomApplicationFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomApplicationFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomApplicationFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomApplicationFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCustomApplicationFieldsQuery, GetCustomApplicationFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCustomApplicationFieldsQuery, GetCustomApplicationFieldsQueryVariables>(
    GetCustomApplicationFieldsDocument,
    options,
  )
}
export function useGetCustomApplicationFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomApplicationFieldsQuery, GetCustomApplicationFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCustomApplicationFieldsQuery, GetCustomApplicationFieldsQueryVariables>(
    GetCustomApplicationFieldsDocument,
    options,
  )
}
export function useGetCustomApplicationFieldsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomApplicationFieldsQuery, GetCustomApplicationFieldsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCustomApplicationFieldsQuery, GetCustomApplicationFieldsQueryVariables>(
    GetCustomApplicationFieldsDocument,
    options,
  )
}
export type GetCustomApplicationFieldsQueryHookResult = ReturnType<typeof useGetCustomApplicationFieldsQuery>
export type GetCustomApplicationFieldsLazyQueryHookResult = ReturnType<typeof useGetCustomApplicationFieldsLazyQuery>
export type GetCustomApplicationFieldsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomApplicationFieldsSuspenseQuery
>
export type GetCustomApplicationFieldsQueryResult = Apollo.QueryResult<
  GetCustomApplicationFieldsQuery,
  GetCustomApplicationFieldsQueryVariables
>
export const GetCustomJobRequisitionFieldValuesDocument = gql`
  query GetCustomJobRequisitionFieldValues($input: GetCustomJobRequisitionFieldValuesInput!) {
    GetCustomJobRequisitionFieldValues(input: $input) {
      ...CustomJobRequisitionFieldValue
    }
  }
  ${CustomJobRequisitionFieldValueFragmentDoc}
`

/**
 * __useGetCustomJobRequisitionFieldValuesQuery__
 *
 * To run a query within a React component, call `useGetCustomJobRequisitionFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomJobRequisitionFieldValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomJobRequisitionFieldValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomJobRequisitionFieldValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomJobRequisitionFieldValuesQuery,
    GetCustomJobRequisitionFieldValuesQueryVariables
  > &
    ({ variables: GetCustomJobRequisitionFieldValuesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCustomJobRequisitionFieldValuesQuery, GetCustomJobRequisitionFieldValuesQueryVariables>(
    GetCustomJobRequisitionFieldValuesDocument,
    options,
  )
}
export function useGetCustomJobRequisitionFieldValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomJobRequisitionFieldValuesQuery,
    GetCustomJobRequisitionFieldValuesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCustomJobRequisitionFieldValuesQuery, GetCustomJobRequisitionFieldValuesQueryVariables>(
    GetCustomJobRequisitionFieldValuesDocument,
    options,
  )
}
export function useGetCustomJobRequisitionFieldValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCustomJobRequisitionFieldValuesQuery,
        GetCustomJobRequisitionFieldValuesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetCustomJobRequisitionFieldValuesQuery,
    GetCustomJobRequisitionFieldValuesQueryVariables
  >(GetCustomJobRequisitionFieldValuesDocument, options)
}
export type GetCustomJobRequisitionFieldValuesQueryHookResult = ReturnType<
  typeof useGetCustomJobRequisitionFieldValuesQuery
>
export type GetCustomJobRequisitionFieldValuesLazyQueryHookResult = ReturnType<
  typeof useGetCustomJobRequisitionFieldValuesLazyQuery
>
export type GetCustomJobRequisitionFieldValuesSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomJobRequisitionFieldValuesSuspenseQuery
>
export type GetCustomJobRequisitionFieldValuesQueryResult = Apollo.QueryResult<
  GetCustomJobRequisitionFieldValuesQuery,
  GetCustomJobRequisitionFieldValuesQueryVariables
>
export const GetCustomJobRequisitionFieldsDocument = gql`
  query GetCustomJobRequisitionFields($input: GetCustomJobRequisitionFieldsInput!) {
    GetCustomJobRequisitionFields(input: $input) {
      ...CustomJobRequisitionField
    }
  }
  ${CustomJobRequisitionFieldFragmentDoc}
`

/**
 * __useGetCustomJobRequisitionFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomJobRequisitionFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomJobRequisitionFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomJobRequisitionFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomJobRequisitionFieldsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCustomJobRequisitionFieldsQuery,
    GetCustomJobRequisitionFieldsQueryVariables
  > &
    ({ variables: GetCustomJobRequisitionFieldsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCustomJobRequisitionFieldsQuery, GetCustomJobRequisitionFieldsQueryVariables>(
    GetCustomJobRequisitionFieldsDocument,
    options,
  )
}
export function useGetCustomJobRequisitionFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCustomJobRequisitionFieldsQuery,
    GetCustomJobRequisitionFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCustomJobRequisitionFieldsQuery, GetCustomJobRequisitionFieldsQueryVariables>(
    GetCustomJobRequisitionFieldsDocument,
    options,
  )
}
export function useGetCustomJobRequisitionFieldsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomJobRequisitionFieldsQuery, GetCustomJobRequisitionFieldsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCustomJobRequisitionFieldsQuery, GetCustomJobRequisitionFieldsQueryVariables>(
    GetCustomJobRequisitionFieldsDocument,
    options,
  )
}
export type GetCustomJobRequisitionFieldsQueryHookResult = ReturnType<typeof useGetCustomJobRequisitionFieldsQuery>
export type GetCustomJobRequisitionFieldsLazyQueryHookResult = ReturnType<
  typeof useGetCustomJobRequisitionFieldsLazyQuery
>
export type GetCustomJobRequisitionFieldsSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomJobRequisitionFieldsSuspenseQuery
>
export type GetCustomJobRequisitionFieldsQueryResult = Apollo.QueryResult<
  GetCustomJobRequisitionFieldsQuery,
  GetCustomJobRequisitionFieldsQueryVariables
>
export const GetCustomProfileFieldsDocument = gql`
  query GetCustomProfileFields($input: GetCustomCandidateProfileFieldsInput) {
    GetCustomCandidateProfileFields(input: $input) {
      ...CustomCandidateProfileField
    }
  }
  ${CustomCandidateProfileFieldFragmentDoc}
`

/**
 * __useGetCustomProfileFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomProfileFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomProfileFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomProfileFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomProfileFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCustomProfileFieldsQuery, GetCustomProfileFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCustomProfileFieldsQuery, GetCustomProfileFieldsQueryVariables>(
    GetCustomProfileFieldsDocument,
    options,
  )
}
export function useGetCustomProfileFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomProfileFieldsQuery, GetCustomProfileFieldsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCustomProfileFieldsQuery, GetCustomProfileFieldsQueryVariables>(
    GetCustomProfileFieldsDocument,
    options,
  )
}
export function useGetCustomProfileFieldsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomProfileFieldsQuery, GetCustomProfileFieldsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCustomProfileFieldsQuery, GetCustomProfileFieldsQueryVariables>(
    GetCustomProfileFieldsDocument,
    options,
  )
}
export type GetCustomProfileFieldsQueryHookResult = ReturnType<typeof useGetCustomProfileFieldsQuery>
export type GetCustomProfileFieldsLazyQueryHookResult = ReturnType<typeof useGetCustomProfileFieldsLazyQuery>
export type GetCustomProfileFieldsSuspenseQueryHookResult = ReturnType<typeof useGetCustomProfileFieldsSuspenseQuery>
export type GetCustomProfileFieldsQueryResult = Apollo.QueryResult<
  GetCustomProfileFieldsQuery,
  GetCustomProfileFieldsQueryVariables
>
export const DeleteOfferCustomFieldDocument = gql`
  mutation DeleteOfferCustomField($id: Int!) {
    DeleteOfferCustomField(input: { id: $id }) {
      id
    }
  }
`
export type DeleteOfferCustomFieldMutationFn = Apollo.MutationFunction<
  DeleteOfferCustomFieldMutation,
  DeleteOfferCustomFieldMutationVariables
>

/**
 * __useDeleteOfferCustomFieldMutation__
 *
 * To run a mutation, you first call `useDeleteOfferCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferCustomFieldMutation, { data, loading, error }] = useDeleteOfferCustomFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferCustomFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteOfferCustomFieldMutation, DeleteOfferCustomFieldMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteOfferCustomFieldMutation, DeleteOfferCustomFieldMutationVariables>(
    DeleteOfferCustomFieldDocument,
    options,
  )
}
export type DeleteOfferCustomFieldMutationHookResult = ReturnType<typeof useDeleteOfferCustomFieldMutation>
export type DeleteOfferCustomFieldMutationResult = Apollo.MutationResult<DeleteOfferCustomFieldMutation>
export type DeleteOfferCustomFieldMutationOptions = Apollo.BaseMutationOptions<
  DeleteOfferCustomFieldMutation,
  DeleteOfferCustomFieldMutationVariables
>
export const GetOfferCustomFieldDocument = gql`
  query GetOfferCustomField {
    GetOfferCustomField(input: {}) {
      ...OfferCustomField
      CompanyUser {
        id
        UserInvitation {
          id
          ScalisUser {
            ...ScalisUser
          }
        }
      }
    }
  }
  ${OfferCustomFieldFragmentDoc}
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetOfferCustomFieldQuery__
 *
 * To run a query within a React component, call `useGetOfferCustomFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferCustomFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferCustomFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferCustomFieldQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOfferCustomFieldQuery, GetOfferCustomFieldQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOfferCustomFieldQuery, GetOfferCustomFieldQueryVariables>(
    GetOfferCustomFieldDocument,
    options,
  )
}
export function useGetOfferCustomFieldLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOfferCustomFieldQuery, GetOfferCustomFieldQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOfferCustomFieldQuery, GetOfferCustomFieldQueryVariables>(
    GetOfferCustomFieldDocument,
    options,
  )
}
export function useGetOfferCustomFieldSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOfferCustomFieldQuery, GetOfferCustomFieldQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOfferCustomFieldQuery, GetOfferCustomFieldQueryVariables>(
    GetOfferCustomFieldDocument,
    options,
  )
}
export type GetOfferCustomFieldQueryHookResult = ReturnType<typeof useGetOfferCustomFieldQuery>
export type GetOfferCustomFieldLazyQueryHookResult = ReturnType<typeof useGetOfferCustomFieldLazyQuery>
export type GetOfferCustomFieldSuspenseQueryHookResult = ReturnType<typeof useGetOfferCustomFieldSuspenseQuery>
export type GetOfferCustomFieldQueryResult = Apollo.QueryResult<
  GetOfferCustomFieldQuery,
  GetOfferCustomFieldQueryVariables
>
export const UpsertOfferCustomFieldDocument = gql`
  mutation UpsertOfferCustomField($input: UpsertOfferCustomFieldInput!) {
    UpsertOfferCustomField(input: $input) {
      ...OfferCustomField
    }
  }
  ${OfferCustomFieldFragmentDoc}
`
export type UpsertOfferCustomFieldMutationFn = Apollo.MutationFunction<
  UpsertOfferCustomFieldMutation,
  UpsertOfferCustomFieldMutationVariables
>

/**
 * __useUpsertOfferCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpsertOfferCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOfferCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOfferCustomFieldMutation, { data, loading, error }] = useUpsertOfferCustomFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOfferCustomFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertOfferCustomFieldMutation, UpsertOfferCustomFieldMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertOfferCustomFieldMutation, UpsertOfferCustomFieldMutationVariables>(
    UpsertOfferCustomFieldDocument,
    options,
  )
}
export type UpsertOfferCustomFieldMutationHookResult = ReturnType<typeof useUpsertOfferCustomFieldMutation>
export type UpsertOfferCustomFieldMutationResult = Apollo.MutationResult<UpsertOfferCustomFieldMutation>
export type UpsertOfferCustomFieldMutationOptions = Apollo.BaseMutationOptions<
  UpsertOfferCustomFieldMutation,
  UpsertOfferCustomFieldMutationVariables
>
export const UpsertOfferTemplateConditionDocument = gql`
  mutation UpsertOfferTemplateCondition($input: [UpsertOfferTemplateConditionInput!]!) {
    UpsertOfferTemplateCondition(input: $input) {
      id
      conditionType
      customFieldId
      departmentId
      employmentType
      offerDocumentTemplateId
      officeId
      payType
      sectionTemplateId
    }
  }
`
export type UpsertOfferTemplateConditionMutationFn = Apollo.MutationFunction<
  UpsertOfferTemplateConditionMutation,
  UpsertOfferTemplateConditionMutationVariables
>

/**
 * __useUpsertOfferTemplateConditionMutation__
 *
 * To run a mutation, you first call `useUpsertOfferTemplateConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOfferTemplateConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOfferTemplateConditionMutation, { data, loading, error }] = useUpsertOfferTemplateConditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOfferTemplateConditionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertOfferTemplateConditionMutation,
    UpsertOfferTemplateConditionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertOfferTemplateConditionMutation, UpsertOfferTemplateConditionMutationVariables>(
    UpsertOfferTemplateConditionDocument,
    options,
  )
}
export type UpsertOfferTemplateConditionMutationHookResult = ReturnType<typeof useUpsertOfferTemplateConditionMutation>
export type UpsertOfferTemplateConditionMutationResult = Apollo.MutationResult<UpsertOfferTemplateConditionMutation>
export type UpsertOfferTemplateConditionMutationOptions = Apollo.BaseMutationOptions<
  UpsertOfferTemplateConditionMutation,
  UpsertOfferTemplateConditionMutationVariables
>
export const CreateDocumentTemplateDocument = gql`
  mutation CreateDocumentTemplate($input: CreateDocumentTemplateInput!) {
    CreateDocumentTemplate(input: $input) {
      id
    }
  }
`
export type CreateDocumentTemplateMutationFn = Apollo.MutationFunction<
  CreateDocumentTemplateMutation,
  CreateDocumentTemplateMutationVariables
>

/**
 * __useCreateDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useCreateDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentTemplateMutation, { data, loading, error }] = useCreateDocumentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDocumentTemplateMutation, CreateDocumentTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateDocumentTemplateMutation, CreateDocumentTemplateMutationVariables>(
    CreateDocumentTemplateDocument,
    options,
  )
}
export type CreateDocumentTemplateMutationHookResult = ReturnType<typeof useCreateDocumentTemplateMutation>
export type CreateDocumentTemplateMutationResult = Apollo.MutationResult<CreateDocumentTemplateMutation>
export type CreateDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateDocumentTemplateMutation,
  CreateDocumentTemplateMutationVariables
>
export const DeleteOfferDocumentTemplateDocument = gql`
  mutation DeleteOfferDocumentTemplate($id: Int!) {
    DeleteOfferDocumentTemplate(input: { id: $id }) {
      id
    }
  }
`
export type DeleteOfferDocumentTemplateMutationFn = Apollo.MutationFunction<
  DeleteOfferDocumentTemplateMutation,
  DeleteOfferDocumentTemplateMutationVariables
>

/**
 * __useDeleteOfferDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteOfferDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferDocumentTemplateMutation, { data, loading, error }] = useDeleteOfferDocumentTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferDocumentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOfferDocumentTemplateMutation,
    DeleteOfferDocumentTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteOfferDocumentTemplateMutation, DeleteOfferDocumentTemplateMutationVariables>(
    DeleteOfferDocumentTemplateDocument,
    options,
  )
}
export type DeleteOfferDocumentTemplateMutationHookResult = ReturnType<typeof useDeleteOfferDocumentTemplateMutation>
export type DeleteOfferDocumentTemplateMutationResult = Apollo.MutationResult<DeleteOfferDocumentTemplateMutation>
export type DeleteOfferDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<
  DeleteOfferDocumentTemplateMutation,
  DeleteOfferDocumentTemplateMutationVariables
>
export const DownloadDocumentTemplateDocument = gql`
  mutation DownloadDocumentTemplate($input: DownloadDocumentTemplateInput!) {
    DownloadDocumentTemplate(input: $input) {
      temporaryUrl
    }
  }
`
export type DownloadDocumentTemplateMutationFn = Apollo.MutationFunction<
  DownloadDocumentTemplateMutation,
  DownloadDocumentTemplateMutationVariables
>

/**
 * __useDownloadDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useDownloadDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDocumentTemplateMutation, { data, loading, error }] = useDownloadDocumentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadDocumentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<DownloadDocumentTemplateMutation, DownloadDocumentTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DownloadDocumentTemplateMutation, DownloadDocumentTemplateMutationVariables>(
    DownloadDocumentTemplateDocument,
    options,
  )
}
export type DownloadDocumentTemplateMutationHookResult = ReturnType<typeof useDownloadDocumentTemplateMutation>
export type DownloadDocumentTemplateMutationResult = Apollo.MutationResult<DownloadDocumentTemplateMutation>
export type DownloadDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<
  DownloadDocumentTemplateMutation,
  DownloadDocumentTemplateMutationVariables
>
export const GenerateFilesFromHtmlDocument = gql`
  mutation GenerateFilesFromHtml($html: String!) {
    GenerateFilesFromHtml(input: { html: $html }) {
      pdfKey
    }
  }
`
export type GenerateFilesFromHtmlMutationFn = Apollo.MutationFunction<
  GenerateFilesFromHtmlMutation,
  GenerateFilesFromHtmlMutationVariables
>

/**
 * __useGenerateFilesFromHtmlMutation__
 *
 * To run a mutation, you first call `useGenerateFilesFromHtmlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFilesFromHtmlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFilesFromHtmlMutation, { data, loading, error }] = useGenerateFilesFromHtmlMutation({
 *   variables: {
 *      html: // value for 'html'
 *   },
 * });
 */
export function useGenerateFilesFromHtmlMutation(
  baseOptions?: Apollo.MutationHookOptions<GenerateFilesFromHtmlMutation, GenerateFilesFromHtmlMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<GenerateFilesFromHtmlMutation, GenerateFilesFromHtmlMutationVariables>(
    GenerateFilesFromHtmlDocument,
    options,
  )
}
export type GenerateFilesFromHtmlMutationHookResult = ReturnType<typeof useGenerateFilesFromHtmlMutation>
export type GenerateFilesFromHtmlMutationResult = Apollo.MutationResult<GenerateFilesFromHtmlMutation>
export type GenerateFilesFromHtmlMutationOptions = Apollo.BaseMutationOptions<
  GenerateFilesFromHtmlMutation,
  GenerateFilesFromHtmlMutationVariables
>
export const GetCompanyOfficesDepartmentsDocument = gql`
  query GetCompanyOfficesDepartments {
    ListCompanyDepartments {
      id
      departmentName
    }
    ListCompanyOffices {
      id
      officeName
    }
  }
`

/**
 * __useGetCompanyOfficesDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetCompanyOfficesDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOfficesDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOfficesDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyOfficesDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyOfficesDepartmentsQuery, GetCompanyOfficesDepartmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyOfficesDepartmentsQuery, GetCompanyOfficesDepartmentsQueryVariables>(
    GetCompanyOfficesDepartmentsDocument,
    options,
  )
}
export function useGetCompanyOfficesDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyOfficesDepartmentsQuery,
    GetCompanyOfficesDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyOfficesDepartmentsQuery, GetCompanyOfficesDepartmentsQueryVariables>(
    GetCompanyOfficesDepartmentsDocument,
    options,
  )
}
export function useGetCompanyOfficesDepartmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyOfficesDepartmentsQuery, GetCompanyOfficesDepartmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyOfficesDepartmentsQuery, GetCompanyOfficesDepartmentsQueryVariables>(
    GetCompanyOfficesDepartmentsDocument,
    options,
  )
}
export type GetCompanyOfficesDepartmentsQueryHookResult = ReturnType<typeof useGetCompanyOfficesDepartmentsQuery>
export type GetCompanyOfficesDepartmentsLazyQueryHookResult = ReturnType<
  typeof useGetCompanyOfficesDepartmentsLazyQuery
>
export type GetCompanyOfficesDepartmentsSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyOfficesDepartmentsSuspenseQuery
>
export type GetCompanyOfficesDepartmentsQueryResult = Apollo.QueryResult<
  GetCompanyOfficesDepartmentsQuery,
  GetCompanyOfficesDepartmentsQueryVariables
>
export const GetDocumentTemplateConditionsDocument = gql`
  query GetDocumentTemplateConditions($documentTemplateId: Int!) {
    GetOfferTemplateCondition(input: { offerDocumentTemplateId: $documentTemplateId }) {
      id
      departmentId
      employmentType
      payType
      officeId
    }
  }
`

/**
 * __useGetDocumentTemplateConditionsQuery__
 *
 * To run a query within a React component, call `useGetDocumentTemplateConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentTemplateConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentTemplateConditionsQuery({
 *   variables: {
 *      documentTemplateId: // value for 'documentTemplateId'
 *   },
 * });
 */
export function useGetDocumentTemplateConditionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDocumentTemplateConditionsQuery,
    GetDocumentTemplateConditionsQueryVariables
  > &
    ({ variables: GetDocumentTemplateConditionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDocumentTemplateConditionsQuery, GetDocumentTemplateConditionsQueryVariables>(
    GetDocumentTemplateConditionsDocument,
    options,
  )
}
export function useGetDocumentTemplateConditionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDocumentTemplateConditionsQuery,
    GetDocumentTemplateConditionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDocumentTemplateConditionsQuery, GetDocumentTemplateConditionsQueryVariables>(
    GetDocumentTemplateConditionsDocument,
    options,
  )
}
export function useGetDocumentTemplateConditionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDocumentTemplateConditionsQuery, GetDocumentTemplateConditionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDocumentTemplateConditionsQuery, GetDocumentTemplateConditionsQueryVariables>(
    GetDocumentTemplateConditionsDocument,
    options,
  )
}
export type GetDocumentTemplateConditionsQueryHookResult = ReturnType<typeof useGetDocumentTemplateConditionsQuery>
export type GetDocumentTemplateConditionsLazyQueryHookResult = ReturnType<
  typeof useGetDocumentTemplateConditionsLazyQuery
>
export type GetDocumentTemplateConditionsSuspenseQueryHookResult = ReturnType<
  typeof useGetDocumentTemplateConditionsSuspenseQuery
>
export type GetDocumentTemplateConditionsQueryResult = Apollo.QueryResult<
  GetDocumentTemplateConditionsQuery,
  GetDocumentTemplateConditionsQueryVariables
>
export const GetDefaultTokenDocument = gql`
  query GetDefaultToken {
    GetDefaultToken(input: {}) {
      id
      categoryName
      tokenName
    }
  }
`

/**
 * __useGetDefaultTokenQuery__
 *
 * To run a query within a React component, call `useGetDefaultTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<GetDefaultTokenQuery, GetDefaultTokenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetDefaultTokenQuery, GetDefaultTokenQueryVariables>(GetDefaultTokenDocument, options)
}
export function useGetDefaultTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultTokenQuery, GetDefaultTokenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetDefaultTokenQuery, GetDefaultTokenQueryVariables>(GetDefaultTokenDocument, options)
}
export function useGetDefaultTokenSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultTokenQuery, GetDefaultTokenQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetDefaultTokenQuery, GetDefaultTokenQueryVariables>(GetDefaultTokenDocument, options)
}
export type GetDefaultTokenQueryHookResult = ReturnType<typeof useGetDefaultTokenQuery>
export type GetDefaultTokenLazyQueryHookResult = ReturnType<typeof useGetDefaultTokenLazyQuery>
export type GetDefaultTokenSuspenseQueryHookResult = ReturnType<typeof useGetDefaultTokenSuspenseQuery>
export type GetDefaultTokenQueryResult = Apollo.QueryResult<GetDefaultTokenQuery, GetDefaultTokenQueryVariables>
export const GetOfferDocumentTemplateDocument = gql`
  query GetOfferDocumentTemplate($input: GetOfferDocumentTemplateInput!) {
    GetOfferDocumentTemplate(input: $input) {
      id
      updatedAt
      documentTemplateName
      documentType
      documentTemplateStatus
      documentTemplateText
      documentFilePath
      documentFileName
      CompanyUser {
        id
        UserInvitation {
          id
          ScalisUser {
            ...ScalisUser
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetOfferDocumentTemplateQuery__
 *
 * To run a query within a React component, call `useGetOfferDocumentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferDocumentTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferDocumentTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOfferDocumentTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<GetOfferDocumentTemplateQuery, GetOfferDocumentTemplateQueryVariables> &
    ({ variables: GetOfferDocumentTemplateQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOfferDocumentTemplateQuery, GetOfferDocumentTemplateQueryVariables>(
    GetOfferDocumentTemplateDocument,
    options,
  )
}
export function useGetOfferDocumentTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOfferDocumentTemplateQuery, GetOfferDocumentTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOfferDocumentTemplateQuery, GetOfferDocumentTemplateQueryVariables>(
    GetOfferDocumentTemplateDocument,
    options,
  )
}
export function useGetOfferDocumentTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOfferDocumentTemplateQuery, GetOfferDocumentTemplateQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOfferDocumentTemplateQuery, GetOfferDocumentTemplateQueryVariables>(
    GetOfferDocumentTemplateDocument,
    options,
  )
}
export type GetOfferDocumentTemplateQueryHookResult = ReturnType<typeof useGetOfferDocumentTemplateQuery>
export type GetOfferDocumentTemplateLazyQueryHookResult = ReturnType<typeof useGetOfferDocumentTemplateLazyQuery>
export type GetOfferDocumentTemplateSuspenseQueryHookResult = ReturnType<
  typeof useGetOfferDocumentTemplateSuspenseQuery
>
export type GetOfferDocumentTemplateQueryResult = Apollo.QueryResult<
  GetOfferDocumentTemplateQuery,
  GetOfferDocumentTemplateQueryVariables
>
export const UpdateDocumentTemplateDocument = gql`
  mutation UpdateDocumentTemplate($input: UpdateDocumentTemplateInput!) {
    UpdateDocumentTemplate(input: $input) {
      id
      documentTemplateName
      documentTemplateText
      documentTemplateStatus
      documentType
    }
  }
`
export type UpdateDocumentTemplateMutationFn = Apollo.MutationFunction<
  UpdateDocumentTemplateMutation,
  UpdateDocumentTemplateMutationVariables
>

/**
 * __useUpdateDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentTemplateMutation, { data, loading, error }] = useUpdateDocumentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDocumentTemplateMutation, UpdateDocumentTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateDocumentTemplateMutation, UpdateDocumentTemplateMutationVariables>(
    UpdateDocumentTemplateDocument,
    options,
  )
}
export type UpdateDocumentTemplateMutationHookResult = ReturnType<typeof useUpdateDocumentTemplateMutation>
export type UpdateDocumentTemplateMutationResult = Apollo.MutationResult<UpdateDocumentTemplateMutation>
export type UpdateDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateDocumentTemplateMutation,
  UpdateDocumentTemplateMutationVariables
>
export const ValidateDocumentTemplateDocument = gql`
  mutation ValidateDocumentTemplate($id: Int!) {
    ValidateOfferDocumentTemplate(input: { id: $id }) {
      id
      documentTemplateStatus
      validationResult
    }
  }
`
export type ValidateDocumentTemplateMutationFn = Apollo.MutationFunction<
  ValidateDocumentTemplateMutation,
  ValidateDocumentTemplateMutationVariables
>

/**
 * __useValidateDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useValidateDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateDocumentTemplateMutation, { data, loading, error }] = useValidateDocumentTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateDocumentTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<ValidateDocumentTemplateMutation, ValidateDocumentTemplateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ValidateDocumentTemplateMutation, ValidateDocumentTemplateMutationVariables>(
    ValidateDocumentTemplateDocument,
    options,
  )
}
export type ValidateDocumentTemplateMutationHookResult = ReturnType<typeof useValidateDocumentTemplateMutation>
export type ValidateDocumentTemplateMutationResult = Apollo.MutationResult<ValidateDocumentTemplateMutation>
export type ValidateDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<
  ValidateDocumentTemplateMutation,
  ValidateDocumentTemplateMutationVariables
>
export const GetEmailRecordsDocument = gql`
  query GetEmailRecords($input: GetEmailRecordsInput!) {
    GetEmailRecords(input: $input) {
      emails {
        id
        createdAt
        subject
        message
        hasOpened
        hasReplied
        hasBounced
        emailThreadId
        candidateApplicationId
        to {
          companyUserId
          name
        }
        from {
          companyUserId
          name
        }
      }
    }
  }
`

/**
 * __useGetEmailRecordsQuery__
 *
 * To run a query within a React component, call `useGetEmailRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailRecordsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmailRecordsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmailRecordsQuery, GetEmailRecordsQueryVariables> &
    ({ variables: GetEmailRecordsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetEmailRecordsQuery, GetEmailRecordsQueryVariables>(GetEmailRecordsDocument, options)
}
export function useGetEmailRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmailRecordsQuery, GetEmailRecordsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetEmailRecordsQuery, GetEmailRecordsQueryVariables>(GetEmailRecordsDocument, options)
}
export function useGetEmailRecordsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailRecordsQuery, GetEmailRecordsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetEmailRecordsQuery, GetEmailRecordsQueryVariables>(GetEmailRecordsDocument, options)
}
export type GetEmailRecordsQueryHookResult = ReturnType<typeof useGetEmailRecordsQuery>
export type GetEmailRecordsLazyQueryHookResult = ReturnType<typeof useGetEmailRecordsLazyQuery>
export type GetEmailRecordsSuspenseQueryHookResult = ReturnType<typeof useGetEmailRecordsSuspenseQuery>
export type GetEmailRecordsQueryResult = Apollo.QueryResult<GetEmailRecordsQuery, GetEmailRecordsQueryVariables>
export const GetEmailThreadDocument = gql`
  query GetEmailThread($input: GetThreadInput!) {
    GetEmailThread(input: $input) {
      thread {
        id
        EmailRecord {
          id
          createdAt
          subject
          message
          hasOpened
          hasReplied
          hasBounced
          sequenceId
          to {
            companyUserId
            profileImage
            name
            email
          }
          from {
            companyUserId
            profileImage
            name
            email
          }
        }
      }
    }
  }
`

/**
 * __useGetEmailThreadQuery__
 *
 * To run a query within a React component, call `useGetEmailThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailThreadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmailThreadQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables> &
    ({ variables: GetEmailThreadQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(GetEmailThreadDocument, options)
}
export function useGetEmailThreadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(GetEmailThreadDocument, options)
}
export function useGetEmailThreadSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(GetEmailThreadDocument, options)
}
export type GetEmailThreadQueryHookResult = ReturnType<typeof useGetEmailThreadQuery>
export type GetEmailThreadLazyQueryHookResult = ReturnType<typeof useGetEmailThreadLazyQuery>
export type GetEmailThreadSuspenseQueryHookResult = ReturnType<typeof useGetEmailThreadSuspenseQuery>
export type GetEmailThreadQueryResult = Apollo.QueryResult<GetEmailThreadQuery, GetEmailThreadQueryVariables>
export const ListFieldTokensDocument = gql`
  query ListFieldTokens($input: FieldTokenInput) {
    ListFieldTokens(input: $input) {
      defaultTokens {
        categoryName
        columnName
        createdAt
        id
        isAggregatedToken
        tableName
        tokenName
        tokenType
      }
      customTokens {
        companyId
        createdAt
        customCandidateApplicationFieldId
        customCandidateProfileFieldId
        id
        offerCustomFieldId
        updatedAt
        Company {
          createdAt
          externalId
          id
          lastActivity
          subdomain
          updatedAt
        }
        CustomCandidateApplicationField {
          companyId
          createdAt
          id
          isArchived
          linkedToScreeningQuestion
          name
          provider
          schema
          systemTokenName
          tooltip
          tooltipText
          type
          updatedAt
          visibility
        }
        CustomCandidateProfileField {
          companyId
          createdAt
          id
          isArchived
          name
          provider
          requisitionId
          schema
          systemTokenName
          tooltip
          tooltipText
          type
          updatedAt
          visibility
        }
        OfferCustomField {
          companyId
          companyUserId
          createdAt
          fieldConfigurationType
          fieldDescription
          fieldName
          fieldRequired
          generateSystemToken
          id
          multipleChoiceOptions
          systemTokenName
          templateConditionId
          triggerNewOfferVersion
          updatedAt
        }
      }
    }
  }
`

/**
 * __useListFieldTokensQuery__
 *
 * To run a query within a React component, call `useListFieldTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFieldTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFieldTokensQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListFieldTokensQuery(
  baseOptions?: Apollo.QueryHookOptions<ListFieldTokensQuery, ListFieldTokensQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListFieldTokensQuery, ListFieldTokensQueryVariables>(ListFieldTokensDocument, options)
}
export function useListFieldTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListFieldTokensQuery, ListFieldTokensQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListFieldTokensQuery, ListFieldTokensQueryVariables>(ListFieldTokensDocument, options)
}
export function useListFieldTokensSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFieldTokensQuery, ListFieldTokensQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListFieldTokensQuery, ListFieldTokensQueryVariables>(ListFieldTokensDocument, options)
}
export type ListFieldTokensQueryHookResult = ReturnType<typeof useListFieldTokensQuery>
export type ListFieldTokensLazyQueryHookResult = ReturnType<typeof useListFieldTokensLazyQuery>
export type ListFieldTokensSuspenseQueryHookResult = ReturnType<typeof useListFieldTokensSuspenseQuery>
export type ListFieldTokensQueryResult = Apollo.QueryResult<ListFieldTokensQuery, ListFieldTokensQueryVariables>
export const GetCreditsUsageLimitDocument = gql`
  query GetCreditsUsageLimit {
    GetFeatureUsageLimit {
      limit
      usage
    }
  }
`

/**
 * __useGetCreditsUsageLimitQuery__
 *
 * To run a query within a React component, call `useGetCreditsUsageLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditsUsageLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditsUsageLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditsUsageLimitQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCreditsUsageLimitQuery, GetCreditsUsageLimitQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCreditsUsageLimitQuery, GetCreditsUsageLimitQueryVariables>(
    GetCreditsUsageLimitDocument,
    options,
  )
}
export function useGetCreditsUsageLimitLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCreditsUsageLimitQuery, GetCreditsUsageLimitQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCreditsUsageLimitQuery, GetCreditsUsageLimitQueryVariables>(
    GetCreditsUsageLimitDocument,
    options,
  )
}
export function useGetCreditsUsageLimitSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCreditsUsageLimitQuery, GetCreditsUsageLimitQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCreditsUsageLimitQuery, GetCreditsUsageLimitQueryVariables>(
    GetCreditsUsageLimitDocument,
    options,
  )
}
export type GetCreditsUsageLimitQueryHookResult = ReturnType<typeof useGetCreditsUsageLimitQuery>
export type GetCreditsUsageLimitLazyQueryHookResult = ReturnType<typeof useGetCreditsUsageLimitLazyQuery>
export type GetCreditsUsageLimitSuspenseQueryHookResult = ReturnType<typeof useGetCreditsUsageLimitSuspenseQuery>
export type GetCreditsUsageLimitQueryResult = Apollo.QueryResult<
  GetCreditsUsageLimitQuery,
  GetCreditsUsageLimitQueryVariables
>
export const GetGlobalListingSetupDocument = gql`
  query GetGlobalListingSetup($companyId: Int!) {
    getGlobalListingSetup(companyId: $companyId) {
      id
      aboutCompanyStatement
      footerStatement
      companyId
      createdAt
      isAboutCompanyActive
      isFooterStatementActive
      updatedAt
    }
  }
`

/**
 * __useGetGlobalListingSetupQuery__
 *
 * To run a query within a React component, call `useGetGlobalListingSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalListingSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalListingSetupQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGlobalListingSetupQuery(
  baseOptions: Apollo.QueryHookOptions<GetGlobalListingSetupQuery, GetGlobalListingSetupQueryVariables> &
    ({ variables: GetGlobalListingSetupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetGlobalListingSetupQuery, GetGlobalListingSetupQueryVariables>(
    GetGlobalListingSetupDocument,
    options,
  )
}
export function useGetGlobalListingSetupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalListingSetupQuery, GetGlobalListingSetupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetGlobalListingSetupQuery, GetGlobalListingSetupQueryVariables>(
    GetGlobalListingSetupDocument,
    options,
  )
}
export function useGetGlobalListingSetupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGlobalListingSetupQuery, GetGlobalListingSetupQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetGlobalListingSetupQuery, GetGlobalListingSetupQueryVariables>(
    GetGlobalListingSetupDocument,
    options,
  )
}
export type GetGlobalListingSetupQueryHookResult = ReturnType<typeof useGetGlobalListingSetupQuery>
export type GetGlobalListingSetupLazyQueryHookResult = ReturnType<typeof useGetGlobalListingSetupLazyQuery>
export type GetGlobalListingSetupSuspenseQueryHookResult = ReturnType<typeof useGetGlobalListingSetupSuspenseQuery>
export type GetGlobalListingSetupQueryResult = Apollo.QueryResult<
  GetGlobalListingSetupQuery,
  GetGlobalListingSetupQueryVariables
>
export const GetGlobalScreeningQuestionsDocument = gql`
  query GetGlobalScreeningQuestions($input: GetGlobalScreeningQuestionInput!) {
    GetGlobalScreeningQuestions(input: $input) {
      id
      questionTitle
      questionDesc
      questionType
      ansOptions
      isRejectionQuestion
      rejectMessage
      preferredAnswer
      isActiveGlobally
      globalQuestionOrder
      createdAt
      updatedAt
    }
  }
`

/**
 * __useGetGlobalScreeningQuestionsQuery__
 *
 * To run a query within a React component, call `useGetGlobalScreeningQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalScreeningQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalScreeningQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGlobalScreeningQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetGlobalScreeningQuestionsQuery, GetGlobalScreeningQuestionsQueryVariables> &
    ({ variables: GetGlobalScreeningQuestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetGlobalScreeningQuestionsQuery, GetGlobalScreeningQuestionsQueryVariables>(
    GetGlobalScreeningQuestionsDocument,
    options,
  )
}
export function useGetGlobalScreeningQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGlobalScreeningQuestionsQuery,
    GetGlobalScreeningQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetGlobalScreeningQuestionsQuery, GetGlobalScreeningQuestionsQueryVariables>(
    GetGlobalScreeningQuestionsDocument,
    options,
  )
}
export function useGetGlobalScreeningQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetGlobalScreeningQuestionsQuery, GetGlobalScreeningQuestionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetGlobalScreeningQuestionsQuery, GetGlobalScreeningQuestionsQueryVariables>(
    GetGlobalScreeningQuestionsDocument,
    options,
  )
}
export type GetGlobalScreeningQuestionsQueryHookResult = ReturnType<typeof useGetGlobalScreeningQuestionsQuery>
export type GetGlobalScreeningQuestionsLazyQueryHookResult = ReturnType<typeof useGetGlobalScreeningQuestionsLazyQuery>
export type GetGlobalScreeningQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useGetGlobalScreeningQuestionsSuspenseQuery
>
export type GetGlobalScreeningQuestionsQueryResult = Apollo.QueryResult<
  GetGlobalScreeningQuestionsQuery,
  GetGlobalScreeningQuestionsQueryVariables
>
export const ListGlobalScreeningQuestionsDocument = gql`
  query ListGlobalScreeningQuestions($input: ListGlobalScreeningQuestionInput!) {
    ListGlobalScreeningQuestions(input: $input) {
      id
      questionTitle
      questionDesc
      questionType
      ansOptions
      minVal
      maxVal
      valStatus
      isRejectionQuestion
      rejectMessage
      preferredAnswer
      isActiveGlobally
      globalQuestionOrder
      createdAt
      updatedAt
    }
  }
`

/**
 * __useListGlobalScreeningQuestionsQuery__
 *
 * To run a query within a React component, call `useListGlobalScreeningQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGlobalScreeningQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGlobalScreeningQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListGlobalScreeningQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<ListGlobalScreeningQuestionsQuery, ListGlobalScreeningQuestionsQueryVariables> &
    ({ variables: ListGlobalScreeningQuestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListGlobalScreeningQuestionsQuery, ListGlobalScreeningQuestionsQueryVariables>(
    ListGlobalScreeningQuestionsDocument,
    options,
  )
}
export function useListGlobalScreeningQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListGlobalScreeningQuestionsQuery,
    ListGlobalScreeningQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListGlobalScreeningQuestionsQuery, ListGlobalScreeningQuestionsQueryVariables>(
    ListGlobalScreeningQuestionsDocument,
    options,
  )
}
export function useListGlobalScreeningQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListGlobalScreeningQuestionsQuery, ListGlobalScreeningQuestionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListGlobalScreeningQuestionsQuery, ListGlobalScreeningQuestionsQueryVariables>(
    ListGlobalScreeningQuestionsDocument,
    options,
  )
}
export type ListGlobalScreeningQuestionsQueryHookResult = ReturnType<typeof useListGlobalScreeningQuestionsQuery>
export type ListGlobalScreeningQuestionsLazyQueryHookResult = ReturnType<
  typeof useListGlobalScreeningQuestionsLazyQuery
>
export type ListGlobalScreeningQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useListGlobalScreeningQuestionsSuspenseQuery
>
export type ListGlobalScreeningQuestionsQueryResult = Apollo.QueryResult<
  ListGlobalScreeningQuestionsQuery,
  ListGlobalScreeningQuestionsQueryVariables
>
export const GetHiringTeamMemberDocument = gql`
  query GetHiringTeamMember($id: Int!) {
    GetHiringTeamMember(id: $id) {
      ...HiringTeamMemberFragment
      createdAt
      updatedAt
      role {
        ...RoleFragment
      }
    }
  }
  ${HiringTeamMemberFragmentFragmentDoc}
  ${RoleFragmentFragmentDoc}
`

/**
 * __useGetHiringTeamMemberQuery__
 *
 * To run a query within a React component, call `useGetHiringTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHiringTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHiringTeamMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHiringTeamMemberQuery(
  baseOptions: Apollo.QueryHookOptions<GetHiringTeamMemberQuery, GetHiringTeamMemberQueryVariables> &
    ({ variables: GetHiringTeamMemberQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetHiringTeamMemberQuery, GetHiringTeamMemberQueryVariables>(
    GetHiringTeamMemberDocument,
    options,
  )
}
export function useGetHiringTeamMemberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetHiringTeamMemberQuery, GetHiringTeamMemberQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetHiringTeamMemberQuery, GetHiringTeamMemberQueryVariables>(
    GetHiringTeamMemberDocument,
    options,
  )
}
export function useGetHiringTeamMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetHiringTeamMemberQuery, GetHiringTeamMemberQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetHiringTeamMemberQuery, GetHiringTeamMemberQueryVariables>(
    GetHiringTeamMemberDocument,
    options,
  )
}
export type GetHiringTeamMemberQueryHookResult = ReturnType<typeof useGetHiringTeamMemberQuery>
export type GetHiringTeamMemberLazyQueryHookResult = ReturnType<typeof useGetHiringTeamMemberLazyQuery>
export type GetHiringTeamMemberSuspenseQueryHookResult = ReturnType<typeof useGetHiringTeamMemberSuspenseQuery>
export type GetHiringTeamMemberQueryResult = Apollo.QueryResult<
  GetHiringTeamMemberQuery,
  GetHiringTeamMemberQueryVariables
>
export const GetCompanyDataForCreatingInterviewerPoolDocument = gql`
  query GetCompanyDataForCreatingInterviewerPool($companyId: Int) {
    ListCompanyOffices {
      id
      officeName
    }
    GetCompanyInfo(id: $companyId) {
      CompanyDepartment {
        id
        departmentName
      }
      CompanyOffice {
        id
        officeName
      }
    }
    GetSkills {
      id
      name
    }
    GetRequisitions {
      id
      jobName
      extRequisitionId
      JobOpening {
        id
        jobRequisitionId
      }
    }
  }
`

/**
 * __useGetCompanyDataForCreatingInterviewerPoolQuery__
 *
 * To run a query within a React component, call `useGetCompanyDataForCreatingInterviewerPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDataForCreatingInterviewerPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDataForCreatingInterviewerPoolQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyDataForCreatingInterviewerPoolQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCompanyDataForCreatingInterviewerPoolQuery,
    GetCompanyDataForCreatingInterviewerPoolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCompanyDataForCreatingInterviewerPoolQuery,
    GetCompanyDataForCreatingInterviewerPoolQueryVariables
  >(GetCompanyDataForCreatingInterviewerPoolDocument, options)
}
export function useGetCompanyDataForCreatingInterviewerPoolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompanyDataForCreatingInterviewerPoolQuery,
    GetCompanyDataForCreatingInterviewerPoolQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCompanyDataForCreatingInterviewerPoolQuery,
    GetCompanyDataForCreatingInterviewerPoolQueryVariables
  >(GetCompanyDataForCreatingInterviewerPoolDocument, options)
}
export function useGetCompanyDataForCreatingInterviewerPoolSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCompanyDataForCreatingInterviewerPoolQuery,
        GetCompanyDataForCreatingInterviewerPoolQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetCompanyDataForCreatingInterviewerPoolQuery,
    GetCompanyDataForCreatingInterviewerPoolQueryVariables
  >(GetCompanyDataForCreatingInterviewerPoolDocument, options)
}
export type GetCompanyDataForCreatingInterviewerPoolQueryHookResult = ReturnType<
  typeof useGetCompanyDataForCreatingInterviewerPoolQuery
>
export type GetCompanyDataForCreatingInterviewerPoolLazyQueryHookResult = ReturnType<
  typeof useGetCompanyDataForCreatingInterviewerPoolLazyQuery
>
export type GetCompanyDataForCreatingInterviewerPoolSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyDataForCreatingInterviewerPoolSuspenseQuery
>
export type GetCompanyDataForCreatingInterviewerPoolQueryResult = Apollo.QueryResult<
  GetCompanyDataForCreatingInterviewerPoolQuery,
  GetCompanyDataForCreatingInterviewerPoolQueryVariables
>
export const GetInterviewerPoolsDocument = gql`
  query GetInterviewerPools($input: GetInterviewerPoolsInput) {
    GetInterviewerPools(input: $input) {
      id
      name
      description
      maxWeeklyInterviews
      maxDailyInterviews
      updatedAt
      isArchived
      Offices {
        id
        CompanyOffice {
          id
          officeName
        }
      }
      Departments {
        id
        CompanyDepartment {
          id
          departmentName
        }
      }
      Skills {
        id
        Skill {
          id
          name
        }
      }
      Jobs {
        id
        requisitionId
        Requisition {
          jobName
        }
      }
      Members {
        companyUserId
        interviewsTodayCount
        interviewsThisWeekCount
        interviewsLastWeekCount
        id
        CompanyUser {
          id
          UserInvitation {
            email
            ScalisUser {
              id
              firstName
              lastName
              profileImage
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetInterviewerPoolsQuery__
 *
 * To run a query within a React component, call `useGetInterviewerPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterviewerPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterviewerPoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInterviewerPoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInterviewerPoolsQuery, GetInterviewerPoolsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetInterviewerPoolsQuery, GetInterviewerPoolsQueryVariables>(
    GetInterviewerPoolsDocument,
    options,
  )
}
export function useGetInterviewerPoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetInterviewerPoolsQuery, GetInterviewerPoolsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetInterviewerPoolsQuery, GetInterviewerPoolsQueryVariables>(
    GetInterviewerPoolsDocument,
    options,
  )
}
export function useGetInterviewerPoolsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInterviewerPoolsQuery, GetInterviewerPoolsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetInterviewerPoolsQuery, GetInterviewerPoolsQueryVariables>(
    GetInterviewerPoolsDocument,
    options,
  )
}
export type GetInterviewerPoolsQueryHookResult = ReturnType<typeof useGetInterviewerPoolsQuery>
export type GetInterviewerPoolsLazyQueryHookResult = ReturnType<typeof useGetInterviewerPoolsLazyQuery>
export type GetInterviewerPoolsSuspenseQueryHookResult = ReturnType<typeof useGetInterviewerPoolsSuspenseQuery>
export type GetInterviewerPoolsQueryResult = Apollo.QueryResult<
  GetInterviewerPoolsQuery,
  GetInterviewerPoolsQueryVariables
>
export const GetCampaignJobFunctionsDocument = gql`
  query GetCampaignJobFunctions {
    CampaignJobFunctions {
      name
      id
    }
  }
`

/**
 * __useGetCampaignJobFunctionsQuery__
 *
 * To run a query within a React component, call `useGetCampaignJobFunctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignJobFunctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignJobFunctionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCampaignJobFunctionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCampaignJobFunctionsQuery, GetCampaignJobFunctionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCampaignJobFunctionsQuery, GetCampaignJobFunctionsQueryVariables>(
    GetCampaignJobFunctionsDocument,
    options,
  )
}
export function useGetCampaignJobFunctionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignJobFunctionsQuery, GetCampaignJobFunctionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCampaignJobFunctionsQuery, GetCampaignJobFunctionsQueryVariables>(
    GetCampaignJobFunctionsDocument,
    options,
  )
}
export function useGetCampaignJobFunctionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCampaignJobFunctionsQuery, GetCampaignJobFunctionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCampaignJobFunctionsQuery, GetCampaignJobFunctionsQueryVariables>(
    GetCampaignJobFunctionsDocument,
    options,
  )
}
export type GetCampaignJobFunctionsQueryHookResult = ReturnType<typeof useGetCampaignJobFunctionsQuery>
export type GetCampaignJobFunctionsLazyQueryHookResult = ReturnType<typeof useGetCampaignJobFunctionsLazyQuery>
export type GetCampaignJobFunctionsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignJobFunctionsSuspenseQuery>
export type GetCampaignJobFunctionsQueryResult = Apollo.QueryResult<
  GetCampaignJobFunctionsQuery,
  GetCampaignJobFunctionsQueryVariables
>
export const GetJobCampaignEducationLevelsDocument = gql`
  query GetJobCampaignEducationLevels {
    GetJobCampaignEducationLevels {
      name {
        languageCode
        value
      }
      id
    }
  }
`

/**
 * __useGetJobCampaignEducationLevelsQuery__
 *
 * To run a query within a React component, call `useGetJobCampaignEducationLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCampaignEducationLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCampaignEducationLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobCampaignEducationLevelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobCampaignEducationLevelsQuery,
    GetJobCampaignEducationLevelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobCampaignEducationLevelsQuery, GetJobCampaignEducationLevelsQueryVariables>(
    GetJobCampaignEducationLevelsDocument,
    options,
  )
}
export function useGetJobCampaignEducationLevelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobCampaignEducationLevelsQuery,
    GetJobCampaignEducationLevelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobCampaignEducationLevelsQuery, GetJobCampaignEducationLevelsQueryVariables>(
    GetJobCampaignEducationLevelsDocument,
    options,
  )
}
export function useGetJobCampaignEducationLevelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobCampaignEducationLevelsQuery, GetJobCampaignEducationLevelsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobCampaignEducationLevelsQuery, GetJobCampaignEducationLevelsQueryVariables>(
    GetJobCampaignEducationLevelsDocument,
    options,
  )
}
export type GetJobCampaignEducationLevelsQueryHookResult = ReturnType<typeof useGetJobCampaignEducationLevelsQuery>
export type GetJobCampaignEducationLevelsLazyQueryHookResult = ReturnType<
  typeof useGetJobCampaignEducationLevelsLazyQuery
>
export type GetJobCampaignEducationLevelsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobCampaignEducationLevelsSuspenseQuery
>
export type GetJobCampaignEducationLevelsQueryResult = Apollo.QueryResult<
  GetJobCampaignEducationLevelsQuery,
  GetJobCampaignEducationLevelsQueryVariables
>
export const GetJobCampaignIndustriesDocument = gql`
  query GetJobCampaignIndustries {
    JobCampaignIndustries {
      id
      name
    }
  }
`

/**
 * __useGetJobCampaignIndustriesQuery__
 *
 * To run a query within a React component, call `useGetJobCampaignIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCampaignIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCampaignIndustriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobCampaignIndustriesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobCampaignIndustriesQuery, GetJobCampaignIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobCampaignIndustriesQuery, GetJobCampaignIndustriesQueryVariables>(
    GetJobCampaignIndustriesDocument,
    options,
  )
}
export function useGetJobCampaignIndustriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobCampaignIndustriesQuery, GetJobCampaignIndustriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobCampaignIndustriesQuery, GetJobCampaignIndustriesQueryVariables>(
    GetJobCampaignIndustriesDocument,
    options,
  )
}
export function useGetJobCampaignIndustriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobCampaignIndustriesQuery, GetJobCampaignIndustriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobCampaignIndustriesQuery, GetJobCampaignIndustriesQueryVariables>(
    GetJobCampaignIndustriesDocument,
    options,
  )
}
export type GetJobCampaignIndustriesQueryHookResult = ReturnType<typeof useGetJobCampaignIndustriesQuery>
export type GetJobCampaignIndustriesLazyQueryHookResult = ReturnType<typeof useGetJobCampaignIndustriesLazyQuery>
export type GetJobCampaignIndustriesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobCampaignIndustriesSuspenseQuery
>
export type GetJobCampaignIndustriesQueryResult = Apollo.QueryResult<
  GetJobCampaignIndustriesQuery,
  GetJobCampaignIndustriesQueryVariables
>
export const SearchJobCampaignLocationsDocument = gql`
  query SearchJobCampaignLocations($input: SearchJobCampaignLocationsInput!) {
    SearchJobCampaignLocations(input: $input) {
      id
      fully_qualified_place_name
    }
  }
`

/**
 * __useSearchJobCampaignLocationsQuery__
 *
 * To run a query within a React component, call `useSearchJobCampaignLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJobCampaignLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchJobCampaignLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchJobCampaignLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchJobCampaignLocationsQuery, SearchJobCampaignLocationsQueryVariables> &
    ({ variables: SearchJobCampaignLocationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchJobCampaignLocationsQuery, SearchJobCampaignLocationsQueryVariables>(
    SearchJobCampaignLocationsDocument,
    options,
  )
}
export function useSearchJobCampaignLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchJobCampaignLocationsQuery, SearchJobCampaignLocationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchJobCampaignLocationsQuery, SearchJobCampaignLocationsQueryVariables>(
    SearchJobCampaignLocationsDocument,
    options,
  )
}
export function useSearchJobCampaignLocationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchJobCampaignLocationsQuery, SearchJobCampaignLocationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchJobCampaignLocationsQuery, SearchJobCampaignLocationsQueryVariables>(
    SearchJobCampaignLocationsDocument,
    options,
  )
}
export type SearchJobCampaignLocationsQueryHookResult = ReturnType<typeof useSearchJobCampaignLocationsQuery>
export type SearchJobCampaignLocationsLazyQueryHookResult = ReturnType<typeof useSearchJobCampaignLocationsLazyQuery>
export type SearchJobCampaignLocationsSuspenseQueryHookResult = ReturnType<
  typeof useSearchJobCampaignLocationsSuspenseQuery
>
export type SearchJobCampaignLocationsQueryResult = Apollo.QueryResult<
  SearchJobCampaignLocationsQuery,
  SearchJobCampaignLocationsQueryVariables
>
export const GetJobCampaignProductsByIdDocument = gql`
  query GetJobCampaignProductsById($ids: [String!]!) {
    GetJobCampaignProductsById(input: { ids: $ids }) {
      results {
        ...JobCampaignProductFragment
      }
    }
  }
  ${JobCampaignProductFragmentFragmentDoc}
`

/**
 * __useGetJobCampaignProductsByIdQuery__
 *
 * To run a query within a React component, call `useGetJobCampaignProductsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCampaignProductsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCampaignProductsByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetJobCampaignProductsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetJobCampaignProductsByIdQuery, GetJobCampaignProductsByIdQueryVariables> &
    ({ variables: GetJobCampaignProductsByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobCampaignProductsByIdQuery, GetJobCampaignProductsByIdQueryVariables>(
    GetJobCampaignProductsByIdDocument,
    options,
  )
}
export function useGetJobCampaignProductsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobCampaignProductsByIdQuery, GetJobCampaignProductsByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobCampaignProductsByIdQuery, GetJobCampaignProductsByIdQueryVariables>(
    GetJobCampaignProductsByIdDocument,
    options,
  )
}
export function useGetJobCampaignProductsByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobCampaignProductsByIdQuery, GetJobCampaignProductsByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobCampaignProductsByIdQuery, GetJobCampaignProductsByIdQueryVariables>(
    GetJobCampaignProductsByIdDocument,
    options,
  )
}
export type GetJobCampaignProductsByIdQueryHookResult = ReturnType<typeof useGetJobCampaignProductsByIdQuery>
export type GetJobCampaignProductsByIdLazyQueryHookResult = ReturnType<typeof useGetJobCampaignProductsByIdLazyQuery>
export type GetJobCampaignProductsByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetJobCampaignProductsByIdSuspenseQuery
>
export type GetJobCampaignProductsByIdQueryResult = Apollo.QueryResult<
  GetJobCampaignProductsByIdQuery,
  GetJobCampaignProductsByIdQueryVariables
>
export const GetJobCampaignProductsDocument = gql`
  query GetJobCampaignProducts($input: ProductFiltersInput) {
    GetJobCampaignProducts(input: $input) {
      count
      results {
        ...JobCampaignProductFragment
      }
    }
  }
  ${JobCampaignProductFragmentFragmentDoc}
`

/**
 * __useGetJobCampaignProductsQuery__
 *
 * To run a query within a React component, call `useGetJobCampaignProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCampaignProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCampaignProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJobCampaignProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobCampaignProductsQuery, GetJobCampaignProductsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobCampaignProductsQuery, GetJobCampaignProductsQueryVariables>(
    GetJobCampaignProductsDocument,
    options,
  )
}
export function useGetJobCampaignProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobCampaignProductsQuery, GetJobCampaignProductsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobCampaignProductsQuery, GetJobCampaignProductsQueryVariables>(
    GetJobCampaignProductsDocument,
    options,
  )
}
export function useGetJobCampaignProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobCampaignProductsQuery, GetJobCampaignProductsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobCampaignProductsQuery, GetJobCampaignProductsQueryVariables>(
    GetJobCampaignProductsDocument,
    options,
  )
}
export type GetJobCampaignProductsQueryHookResult = ReturnType<typeof useGetJobCampaignProductsQuery>
export type GetJobCampaignProductsLazyQueryHookResult = ReturnType<typeof useGetJobCampaignProductsLazyQuery>
export type GetJobCampaignProductsSuspenseQueryHookResult = ReturnType<typeof useGetJobCampaignProductsSuspenseQuery>
export type GetJobCampaignProductsQueryResult = Apollo.QueryResult<
  GetJobCampaignProductsQuery,
  GetJobCampaignProductsQueryVariables
>
export const GetJobCampaignSeniorityDocument = gql`
  query GetJobCampaignSeniority {
    GetJobCampaignSeniority {
      id
      name {
        languageCode
        value
      }
    }
  }
`

/**
 * __useGetJobCampaignSeniorityQuery__
 *
 * To run a query within a React component, call `useGetJobCampaignSeniorityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobCampaignSeniorityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobCampaignSeniorityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobCampaignSeniorityQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobCampaignSeniorityQuery, GetJobCampaignSeniorityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobCampaignSeniorityQuery, GetJobCampaignSeniorityQueryVariables>(
    GetJobCampaignSeniorityDocument,
    options,
  )
}
export function useGetJobCampaignSeniorityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobCampaignSeniorityQuery, GetJobCampaignSeniorityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobCampaignSeniorityQuery, GetJobCampaignSeniorityQueryVariables>(
    GetJobCampaignSeniorityDocument,
    options,
  )
}
export function useGetJobCampaignSenioritySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobCampaignSeniorityQuery, GetJobCampaignSeniorityQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobCampaignSeniorityQuery, GetJobCampaignSeniorityQueryVariables>(
    GetJobCampaignSeniorityDocument,
    options,
  )
}
export type GetJobCampaignSeniorityQueryHookResult = ReturnType<typeof useGetJobCampaignSeniorityQuery>
export type GetJobCampaignSeniorityLazyQueryHookResult = ReturnType<typeof useGetJobCampaignSeniorityLazyQuery>
export type GetJobCampaignSenioritySuspenseQueryHookResult = ReturnType<typeof useGetJobCampaignSenioritySuspenseQuery>
export type GetJobCampaignSeniorityQueryResult = Apollo.QueryResult<
  GetJobCampaignSeniorityQuery,
  GetJobCampaignSeniorityQueryVariables
>
export const GetOrderDocument = gql`
  query GetOrder($id: Int!) {
    GetOrders(input: { id: $id }) {
      Campaigns {
        data {
          campaignName
          orderedProducts
          labels {
            jobListingId
          }
          targetGroup {
            seniority {
              description
              vonqId
            }
            jobCategory {
              vonqId
              description
            }
            industry {
              vonqId
              description
            }
            educationLevel {
              vonqId
              description
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuery(
  baseOptions: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables> &
    ({ variables: GetOrderQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options)
}
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options)
}
export function useGetOrderSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options)
}
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>
export type GetOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrderSuspenseQuery>
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>
export const GetRequisitionOrdersDocument = gql`
  query GetRequisitionOrders($requisitionId: Int!) {
    GetRequisition(id: $requisitionId) {
      id
      isIncomplete
      Orders {
        id
        total
        applicantsCount
        campaignTraffic
        Campaigns {
          data {
            campaignId
            campaignName
            createdOn
            status
            viewsCount
            postings {
              clicks
            }
            targetGroup {
              seniority {
                vonqId
                description
              }
              jobCategory {
                description
                vonqId
              }
              industry {
                description
                vonqId
              }
              educationLevel {
                description
                vonqId
              }
            }
            labels {
              jobListingId
            }
          }
        }
      }
      JobListing {
        id
        workplaceType
        listingTitle
        publicListingId
        Address {
          country
          state
          city
        }
      }
    }
  }
`

/**
 * __useGetRequisitionOrdersQuery__
 *
 * To run a query within a React component, call `useGetRequisitionOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionOrdersQuery({
 *   variables: {
 *      requisitionId: // value for 'requisitionId'
 *   },
 * });
 */
export function useGetRequisitionOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionOrdersQuery, GetRequisitionOrdersQueryVariables> &
    ({ variables: GetRequisitionOrdersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionOrdersQuery, GetRequisitionOrdersQueryVariables>(
    GetRequisitionOrdersDocument,
    options,
  )
}
export function useGetRequisitionOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionOrdersQuery, GetRequisitionOrdersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionOrdersQuery, GetRequisitionOrdersQueryVariables>(
    GetRequisitionOrdersDocument,
    options,
  )
}
export function useGetRequisitionOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionOrdersQuery, GetRequisitionOrdersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionOrdersQuery, GetRequisitionOrdersQueryVariables>(
    GetRequisitionOrdersDocument,
    options,
  )
}
export type GetRequisitionOrdersQueryHookResult = ReturnType<typeof useGetRequisitionOrdersQuery>
export type GetRequisitionOrdersLazyQueryHookResult = ReturnType<typeof useGetRequisitionOrdersLazyQuery>
export type GetRequisitionOrdersSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionOrdersSuspenseQuery>
export type GetRequisitionOrdersQueryResult = Apollo.QueryResult<
  GetRequisitionOrdersQuery,
  GetRequisitionOrdersQueryVariables
>
export const GetIsCandidateAppliedDocument = gql`
  query GetIsCandidateApplied($publicListingId: String!) {
    GetCandidateApplication(publicListingIds: [$publicListingId]) {
      id
    }
  }
`

/**
 * __useGetIsCandidateAppliedQuery__
 *
 * To run a query within a React component, call `useGetIsCandidateAppliedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsCandidateAppliedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsCandidateAppliedQuery({
 *   variables: {
 *      publicListingId: // value for 'publicListingId'
 *   },
 * });
 */
export function useGetIsCandidateAppliedQuery(
  baseOptions: Apollo.QueryHookOptions<GetIsCandidateAppliedQuery, GetIsCandidateAppliedQueryVariables> &
    ({ variables: GetIsCandidateAppliedQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetIsCandidateAppliedQuery, GetIsCandidateAppliedQueryVariables>(
    GetIsCandidateAppliedDocument,
    options,
  )
}
export function useGetIsCandidateAppliedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetIsCandidateAppliedQuery, GetIsCandidateAppliedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetIsCandidateAppliedQuery, GetIsCandidateAppliedQueryVariables>(
    GetIsCandidateAppliedDocument,
    options,
  )
}
export function useGetIsCandidateAppliedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetIsCandidateAppliedQuery, GetIsCandidateAppliedQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetIsCandidateAppliedQuery, GetIsCandidateAppliedQueryVariables>(
    GetIsCandidateAppliedDocument,
    options,
  )
}
export type GetIsCandidateAppliedQueryHookResult = ReturnType<typeof useGetIsCandidateAppliedQuery>
export type GetIsCandidateAppliedLazyQueryHookResult = ReturnType<typeof useGetIsCandidateAppliedLazyQuery>
export type GetIsCandidateAppliedSuspenseQueryHookResult = ReturnType<typeof useGetIsCandidateAppliedSuspenseQuery>
export type GetIsCandidateAppliedQueryResult = Apollo.QueryResult<
  GetIsCandidateAppliedQuery,
  GetIsCandidateAppliedQueryVariables
>
export const GetJobListingsPipelineDocument = gql`
  query GetJobListingsPipeline($jobRequisitionId: Int) {
    GetJobListing(jobRequisitionId: $jobRequisitionId) {
      JobListingJobPipeline {
        id
        JobPipeline {
          id
          TemplatePipeline {
            id
            name
            TemplateMilestones {
              id
              name
              rankOrder
              TemplateStage {
                rankOrder
                name
                id
                visibility
              }
            }
          }
        }
      }
      id
      externalTitle
      publicListingId
      Requisition {
        id
        jobName
      }
    }
  }
`

/**
 * __useGetJobListingsPipelineQuery__
 *
 * To run a query within a React component, call `useGetJobListingsPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobListingsPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobListingsPipelineQuery({
 *   variables: {
 *      jobRequisitionId: // value for 'jobRequisitionId'
 *   },
 * });
 */
export function useGetJobListingsPipelineQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobListingsPipelineQuery, GetJobListingsPipelineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobListingsPipelineQuery, GetJobListingsPipelineQueryVariables>(
    GetJobListingsPipelineDocument,
    options,
  )
}
export function useGetJobListingsPipelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobListingsPipelineQuery, GetJobListingsPipelineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobListingsPipelineQuery, GetJobListingsPipelineQueryVariables>(
    GetJobListingsPipelineDocument,
    options,
  )
}
export function useGetJobListingsPipelineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobListingsPipelineQuery, GetJobListingsPipelineQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobListingsPipelineQuery, GetJobListingsPipelineQueryVariables>(
    GetJobListingsPipelineDocument,
    options,
  )
}
export type GetJobListingsPipelineQueryHookResult = ReturnType<typeof useGetJobListingsPipelineQuery>
export type GetJobListingsPipelineLazyQueryHookResult = ReturnType<typeof useGetJobListingsPipelineLazyQuery>
export type GetJobListingsPipelineSuspenseQueryHookResult = ReturnType<typeof useGetJobListingsPipelineSuspenseQuery>
export type GetJobListingsPipelineQueryResult = Apollo.QueryResult<
  GetJobListingsPipelineQuery,
  GetJobListingsPipelineQueryVariables
>
export const GetJobListingDocument = gql`
  query GetJobListing($id: Int, $jobRequisitionId: Int, $page: Int, $limit: Int) {
    GetJobListing(id: $id, jobRequisitionId: $jobRequisitionId, page: $page, limit: $limit) {
      Address {
        id
        addressLine1
        addressLine2
        city
        state
        country
        postalCode
        timeZone
      }
      JobListingScreeningQuestion {
        id
        jobListingId
        displaySequenceNumber
        screeningQuestionId
        createdAt
        updatedAt
        ScreeningQuestion {
          id
          isTemplateQuestion
          questionTitle
          questionDesc
          questionType
          minVal
          maxVal
          valStatus
          ansOptions
          isRejectionQuestion
          isGlobalQuestion
          rejectMessage
          templateMessageId
          preferredAnswer
          companyId
          companyUserId
          createdAt
          updatedAt
        }
      }
      id
      publicListingId
      jobRequisitionId
      listingTitle
      externalTitle
      workplaceType
      publicDescription
      displayPayOnListing
      industry
      subIndustry
      companyDefault
      stateAndOrCountry
      internalMatchingDescription
      searchPublicDescription
      searchInternalMatchingDescription
      postedAt
      acceptingCandidates
      stage
      createdAt
      updatedAt
    }
  }
`

/**
 * __useGetJobListingQuery__
 *
 * To run a query within a React component, call `useGetJobListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      jobRequisitionId: // value for 'jobRequisitionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetJobListingQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobListingQuery, GetJobListingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobListingQuery, GetJobListingQueryVariables>(GetJobListingDocument, options)
}
export function useGetJobListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobListingQuery, GetJobListingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobListingQuery, GetJobListingQueryVariables>(GetJobListingDocument, options)
}
export function useGetJobListingSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobListingQuery, GetJobListingQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobListingQuery, GetJobListingQueryVariables>(GetJobListingDocument, options)
}
export type GetJobListingQueryHookResult = ReturnType<typeof useGetJobListingQuery>
export type GetJobListingLazyQueryHookResult = ReturnType<typeof useGetJobListingLazyQuery>
export type GetJobListingSuspenseQueryHookResult = ReturnType<typeof useGetJobListingSuspenseQuery>
export type GetJobListingQueryResult = Apollo.QueryResult<GetJobListingQuery, GetJobListingQueryVariables>
export const GetJobListingsIdTitleDocument = gql`
  query GetJobListingsIdTitle($page: Int, $limit: Int) {
    GetJobListing(page: $page, limit: $limit) {
      __typename
      id
      listingTitle
    }
  }
`

/**
 * __useGetJobListingsIdTitleQuery__
 *
 * To run a query within a React component, call `useGetJobListingsIdTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobListingsIdTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobListingsIdTitleQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetJobListingsIdTitleQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobListingsIdTitleQuery, GetJobListingsIdTitleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobListingsIdTitleQuery, GetJobListingsIdTitleQueryVariables>(
    GetJobListingsIdTitleDocument,
    options,
  )
}
export function useGetJobListingsIdTitleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobListingsIdTitleQuery, GetJobListingsIdTitleQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobListingsIdTitleQuery, GetJobListingsIdTitleQueryVariables>(
    GetJobListingsIdTitleDocument,
    options,
  )
}
export function useGetJobListingsIdTitleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobListingsIdTitleQuery, GetJobListingsIdTitleQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobListingsIdTitleQuery, GetJobListingsIdTitleQueryVariables>(
    GetJobListingsIdTitleDocument,
    options,
  )
}
export type GetJobListingsIdTitleQueryHookResult = ReturnType<typeof useGetJobListingsIdTitleQuery>
export type GetJobListingsIdTitleLazyQueryHookResult = ReturnType<typeof useGetJobListingsIdTitleLazyQuery>
export type GetJobListingsIdTitleSuspenseQueryHookResult = ReturnType<typeof useGetJobListingsIdTitleSuspenseQuery>
export type GetJobListingsIdTitleQueryResult = Apollo.QueryResult<
  GetJobListingsIdTitleQuery,
  GetJobListingsIdTitleQueryVariables
>
export const GetJobPipelineDocument = gql`
  query GetJobPipeline($id: Int, $jobRequisitionId: Int, $templatePipelineId: Int) {
    GetJobPipeline(id: $id) {
      ...JobPipelineFragment
      TemplatePipeline {
        ...TemplatePipelineFragment
        createdAt
        updatedAt
        TemplateMilestones {
          ...TemplateMilestone
          createdAt
          updatedAt
        }
        TemplateStage {
          ...TemplateStage
          createdAt
          updatedAt
        }
      }
      StageSettings {
        ...StageSettingsFragment
        createdAt
        updatedAt
      }
    }
  }
  ${JobPipelineFragmentFragmentDoc}
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
  ${StageSettingsFragmentFragmentDoc}
`

/**
 * __useGetJobPipelineQuery__
 *
 * To run a query within a React component, call `useGetJobPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPipelineQuery({
 *   variables: {
 *      id: // value for 'id'
 *      jobRequisitionId: // value for 'jobRequisitionId'
 *      templatePipelineId: // value for 'templatePipelineId'
 *   },
 * });
 */
export function useGetJobPipelineQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobPipelineQuery, GetJobPipelineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobPipelineQuery, GetJobPipelineQueryVariables>(GetJobPipelineDocument, options)
}
export function useGetJobPipelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobPipelineQuery, GetJobPipelineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobPipelineQuery, GetJobPipelineQueryVariables>(GetJobPipelineDocument, options)
}
export function useGetJobPipelineSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobPipelineQuery, GetJobPipelineQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobPipelineQuery, GetJobPipelineQueryVariables>(GetJobPipelineDocument, options)
}
export type GetJobPipelineQueryHookResult = ReturnType<typeof useGetJobPipelineQuery>
export type GetJobPipelineLazyQueryHookResult = ReturnType<typeof useGetJobPipelineLazyQuery>
export type GetJobPipelineSuspenseQueryHookResult = ReturnType<typeof useGetJobPipelineSuspenseQuery>
export type GetJobPipelineQueryResult = Apollo.QueryResult<GetJobPipelineQuery, GetJobPipelineQueryVariables>
export const GetJobSearchPreferenceDocument = gql`
  query GetJobSearchPreference($input: GetJobSearchPreferenceInput) {
    GetJobSearchPreference(input: $input) {
      ...JobSearchPreferenceFragment
    }
  }
  ${JobSearchPreferenceFragmentFragmentDoc}
`

/**
 * __useGetJobSearchPreferenceQuery__
 *
 * To run a query within a React component, call `useGetJobSearchPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSearchPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSearchPreferenceQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJobSearchPreferenceQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobSearchPreferenceQuery, GetJobSearchPreferenceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobSearchPreferenceQuery, GetJobSearchPreferenceQueryVariables>(
    GetJobSearchPreferenceDocument,
    options,
  )
}
export function useGetJobSearchPreferenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobSearchPreferenceQuery, GetJobSearchPreferenceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobSearchPreferenceQuery, GetJobSearchPreferenceQueryVariables>(
    GetJobSearchPreferenceDocument,
    options,
  )
}
export function useGetJobSearchPreferenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobSearchPreferenceQuery, GetJobSearchPreferenceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobSearchPreferenceQuery, GetJobSearchPreferenceQueryVariables>(
    GetJobSearchPreferenceDocument,
    options,
  )
}
export type GetJobSearchPreferenceQueryHookResult = ReturnType<typeof useGetJobSearchPreferenceQuery>
export type GetJobSearchPreferenceLazyQueryHookResult = ReturnType<typeof useGetJobSearchPreferenceLazyQuery>
export type GetJobSearchPreferenceSuspenseQueryHookResult = ReturnType<typeof useGetJobSearchPreferenceSuspenseQuery>
export type GetJobSearchPreferenceQueryResult = Apollo.QueryResult<
  GetJobSearchPreferenceQuery,
  GetJobSearchPreferenceQueryVariables
>
export const CountCandidateApplicationDocument = gql`
  query CountCandidateApplication(
    $publicListingIds: [String!]
    $templateStageIds: [Int!]
    $matchScore: MatchScore
    $candidateProfileId: [Int!]
    $skills: [String!]
    $lastActivity: LastActivity
    $applicationStatus: [ApplicationStatusEnum!]
    $applicationStatusNotIn: [ApplicationStatusEnum!]
    $applicationType: [ApplicationTypeEnum!]
    $sourceName: [String!]
    $medalistDesignation: [String!]
    $creditedCompanyUserIds: [Int!]
    $companies: [String!]
    $educationLevel: [EducationLevelEnum!]
    $jobTitles: [String!]
    $majors: [String!]
    $nonTraditionalStatus: Boolean
    $schools: [String!]
    $timezones: [String!]
    $veteranStatus: [VeteranStatusEnum!]
    $willingToRelocate: [WillingToRelocateEnum!]
    $yearsOfExperience: YearsOfExperience
    $requisitionId: Int
    $profileType: ProfileTypeEnum
    $search: String
  ) {
    CountCandidateApplication(
      publicListingIds: $publicListingIds
      templateStageIds: $templateStageIds
      matchScore: $matchScore
      candidateProfileId: $candidateProfileId
      skills: $skills
      lastActivity: $lastActivity
      applicationStatus: $applicationStatus
      applicationStatusNotIn: $applicationStatusNotIn
      applicationType: $applicationType
      sourceName: $sourceName
      medalistDesignation: $medalistDesignation
      creditedCompanyUserIds: $creditedCompanyUserIds
      companies: $companies
      educationLevel: $educationLevel
      jobTitles: $jobTitles
      majors: $majors
      nonTraditionalStatus: $nonTraditionalStatus
      schools: $schools
      timezones: $timezones
      veteranStatus: $veteranStatus
      willingToRelocate: $willingToRelocate
      yearsOfExperience: $yearsOfExperience
      requisitionId: $requisitionId
      profileType: $profileType
      search: $search
    ) {
      count
    }
  }
`

/**
 * __useCountCandidateApplicationQuery__
 *
 * To run a query within a React component, call `useCountCandidateApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCandidateApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCandidateApplicationQuery({
 *   variables: {
 *      publicListingIds: // value for 'publicListingIds'
 *      templateStageIds: // value for 'templateStageIds'
 *      matchScore: // value for 'matchScore'
 *      candidateProfileId: // value for 'candidateProfileId'
 *      skills: // value for 'skills'
 *      lastActivity: // value for 'lastActivity'
 *      applicationStatus: // value for 'applicationStatus'
 *      applicationStatusNotIn: // value for 'applicationStatusNotIn'
 *      applicationType: // value for 'applicationType'
 *      sourceName: // value for 'sourceName'
 *      medalistDesignation: // value for 'medalistDesignation'
 *      creditedCompanyUserIds: // value for 'creditedCompanyUserIds'
 *      companies: // value for 'companies'
 *      educationLevel: // value for 'educationLevel'
 *      jobTitles: // value for 'jobTitles'
 *      majors: // value for 'majors'
 *      nonTraditionalStatus: // value for 'nonTraditionalStatus'
 *      schools: // value for 'schools'
 *      timezones: // value for 'timezones'
 *      veteranStatus: // value for 'veteranStatus'
 *      willingToRelocate: // value for 'willingToRelocate'
 *      yearsOfExperience: // value for 'yearsOfExperience'
 *      requisitionId: // value for 'requisitionId'
 *      profileType: // value for 'profileType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCountCandidateApplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<CountCandidateApplicationQuery, CountCandidateApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CountCandidateApplicationQuery, CountCandidateApplicationQueryVariables>(
    CountCandidateApplicationDocument,
    options,
  )
}
export function useCountCandidateApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountCandidateApplicationQuery, CountCandidateApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CountCandidateApplicationQuery, CountCandidateApplicationQueryVariables>(
    CountCandidateApplicationDocument,
    options,
  )
}
export function useCountCandidateApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountCandidateApplicationQuery, CountCandidateApplicationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CountCandidateApplicationQuery, CountCandidateApplicationQueryVariables>(
    CountCandidateApplicationDocument,
    options,
  )
}
export type CountCandidateApplicationQueryHookResult = ReturnType<typeof useCountCandidateApplicationQuery>
export type CountCandidateApplicationLazyQueryHookResult = ReturnType<typeof useCountCandidateApplicationLazyQuery>
export type CountCandidateApplicationSuspenseQueryHookResult = ReturnType<
  typeof useCountCandidateApplicationSuspenseQuery
>
export type CountCandidateApplicationQueryResult = Apollo.QueryResult<
  CountCandidateApplicationQuery,
  CountCandidateApplicationQueryVariables
>
export const GetCandidateApplicationPipelineViewDocument = gql`
  query GetCandidateApplicationPipelineView(
    $search: String
    $publicListingIds: [String!]
    $templateStageIds: [Int!]
    $matchScore: MatchScore
    $candidateProfileId: [Int!]
    $skills: [String!]
    $lastActivity: LastActivity
    $applicationStatus: [ApplicationStatusEnum!]
    $customApplicationStatusIds: [Int!]
    $applicationType: [ApplicationTypeEnum!]
    $sourceName: [String!]
    $medalistDesignation: [String!]
    $creditedCompanyUserIds: [Int!]
    $companies: [String!]
    $educationLevel: [EducationLevelEnum!]
    $jobTitles: [String!]
    $majors: [String!]
    $nonTraditionalStatus: Boolean
    $schools: [String!]
    $timezones: [String!]
    $veteranStatus: [VeteranStatusEnum!]
    $willingToRelocate: [WillingToRelocateEnum!]
    $yearsOfExperience: YearsOfExperience
    $requisitionId: Int!
    $profileType: ProfileTypeEnum
    $labels: [Int!]
    $customCandidateApplicationFields: [CustomCandidateApplicationFieldFilter!]
    $customCandidateProfileFields: [CustomCandidateProfileFieldFilter!]
    $page: Int
    $limit: Int
    $sortBy: SortByApplication
    $sortDirection: SortDirection
  ) {
    GetCandidateApplicationPipelineView(
      search: $search
      publicListingIds: $publicListingIds
      templateStageIds: $templateStageIds
      matchScore: $matchScore
      candidateProfileId: $candidateProfileId
      skills: $skills
      lastActivity: $lastActivity
      applicationStatus: $applicationStatus
      customApplicationStatusIds: $customApplicationStatusIds
      applicationType: $applicationType
      sourceName: $sourceName
      medalistDesignation: $medalistDesignation
      creditedCompanyUserIds: $creditedCompanyUserIds
      companies: $companies
      educationLevel: $educationLevel
      jobTitles: $jobTitles
      majors: $majors
      nonTraditionalStatus: $nonTraditionalStatus
      schools: $schools
      timezones: $timezones
      veteranStatus: $veteranStatus
      willingToRelocate: $willingToRelocate
      yearsOfExperience: $yearsOfExperience
      requisitionId: $requisitionId
      profileType: $profileType
      labels: $labels
      customCandidateApplicationFields: $customCandidateApplicationFields
      customCandidateProfileFields: $customCandidateProfileFields
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      candidateApplications {
        ...CandidateApplication
        CustomApplicationStatus {
          ...CustomApplicationStatus
        }
        CandidateInterview {
          id
          stageId
          status
        }
        CustomCandidateApplicationFieldValues {
          ...CustomCandidateApplicationFieldValue
        }
        CandidateProfile {
          id
          profileType
          CandidateLabels {
            ...CandidateLabel
          }
          ProspectStatus {
            ...ProspectStatus
          }
          ProspectOwner {
            id
            UserInvitation {
              ScalisUser {
                ...ScalisUser
              }
            }
          }
          CustomCandidateProfileFieldValues {
            ...CustomCandidateProfileFieldValue
          }
          CandidateApplicationRating {
            id
            score
          }
          ScalisUser {
            ...ScalisUser
            mostRecentJob: Experience(onlyMostRecentJob: true) {
              id
              industry
              jobTitle
              employerName
            }
            currentJob: Experience(onlyCurrentJob: true) {
              id
              jobTitle
              employerName
            }
            highestEducation: Education(highestEducation: true) {
              id
              educationLevel
              institutionName
            }
            ContactInfo {
              id
              phoneNumber
            }
            Address {
              id
              country
              city
              state
            }
            EmailVerification {
              id
              isPrimary
              emailAddress
              isVisibleToEmployers
            }
            JobSeekerInfo {
              id
              jobSeekerId
            }
            ExperienceTenure {
              average
              longest
              shortest
            }
          }
          UploadedCandidate {
            ...UploadedCandidate
          }
          ProfileDetails {
            id
            phoneNumber
            CandidateSource {
              ...CandidateSource
            }
          }
          CandidateLabels {
            ...CandidateLabel
          }
        }
        CandidateSource {
          ...CandidateSource
        }
        JobListing {
          id
          publicListingId
          Requisition {
            id
            jobName
            extRequisitionId
          }
        }
        CandidateScorecard {
          id
          status
          scorecardTemplateId
        }
      }
      milestone {
        ...TemplateMilestone
      }
      stage {
        ...TemplateStage
      }
      count
    }
  }
  ${CandidateApplicationFragmentDoc}
  ${CustomApplicationStatusFragmentDoc}
  ${CustomCandidateApplicationFieldValueFragmentDoc}
  ${CandidateLabelFragmentDoc}
  ${ProspectStatusFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${CustomCandidateProfileFieldValueFragmentDoc}
  ${UploadedCandidateFragmentDoc}
  ${CandidateSourceFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
`

/**
 * __useGetCandidateApplicationPipelineViewQuery__
 *
 * To run a query within a React component, call `useGetCandidateApplicationPipelineViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateApplicationPipelineViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateApplicationPipelineViewQuery({
 *   variables: {
 *      search: // value for 'search'
 *      publicListingIds: // value for 'publicListingIds'
 *      templateStageIds: // value for 'templateStageIds'
 *      matchScore: // value for 'matchScore'
 *      candidateProfileId: // value for 'candidateProfileId'
 *      skills: // value for 'skills'
 *      lastActivity: // value for 'lastActivity'
 *      applicationStatus: // value for 'applicationStatus'
 *      customApplicationStatusIds: // value for 'customApplicationStatusIds'
 *      applicationType: // value for 'applicationType'
 *      sourceName: // value for 'sourceName'
 *      medalistDesignation: // value for 'medalistDesignation'
 *      creditedCompanyUserIds: // value for 'creditedCompanyUserIds'
 *      companies: // value for 'companies'
 *      educationLevel: // value for 'educationLevel'
 *      jobTitles: // value for 'jobTitles'
 *      majors: // value for 'majors'
 *      nonTraditionalStatus: // value for 'nonTraditionalStatus'
 *      schools: // value for 'schools'
 *      timezones: // value for 'timezones'
 *      veteranStatus: // value for 'veteranStatus'
 *      willingToRelocate: // value for 'willingToRelocate'
 *      yearsOfExperience: // value for 'yearsOfExperience'
 *      requisitionId: // value for 'requisitionId'
 *      profileType: // value for 'profileType'
 *      labels: // value for 'labels'
 *      customCandidateApplicationFields: // value for 'customCandidateApplicationFields'
 *      customCandidateProfileFields: // value for 'customCandidateProfileFields'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetCandidateApplicationPipelineViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCandidateApplicationPipelineViewQuery,
    GetCandidateApplicationPipelineViewQueryVariables
  > &
    ({ variables: GetCandidateApplicationPipelineViewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateApplicationPipelineViewQuery, GetCandidateApplicationPipelineViewQueryVariables>(
    GetCandidateApplicationPipelineViewDocument,
    options,
  )
}
export function useGetCandidateApplicationPipelineViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidateApplicationPipelineViewQuery,
    GetCandidateApplicationPipelineViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCandidateApplicationPipelineViewQuery,
    GetCandidateApplicationPipelineViewQueryVariables
  >(GetCandidateApplicationPipelineViewDocument, options)
}
export function useGetCandidateApplicationPipelineViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCandidateApplicationPipelineViewQuery,
        GetCandidateApplicationPipelineViewQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetCandidateApplicationPipelineViewQuery,
    GetCandidateApplicationPipelineViewQueryVariables
  >(GetCandidateApplicationPipelineViewDocument, options)
}
export type GetCandidateApplicationPipelineViewQueryHookResult = ReturnType<
  typeof useGetCandidateApplicationPipelineViewQuery
>
export type GetCandidateApplicationPipelineViewLazyQueryHookResult = ReturnType<
  typeof useGetCandidateApplicationPipelineViewLazyQuery
>
export type GetCandidateApplicationPipelineViewSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateApplicationPipelineViewSuspenseQuery
>
export type GetCandidateApplicationPipelineViewQueryResult = Apollo.QueryResult<
  GetCandidateApplicationPipelineViewQuery,
  GetCandidateApplicationPipelineViewQueryVariables
>
export const GetCandidateApplicationDocument = gql`
  query GetCandidateApplication(
    $publicListingIds: [String!]
    $templateStageIds: [Int!]
    $matchScore: MatchScore
    $candidateProfileId: [Int!]
    $skills: [String!]
    $lastActivity: LastActivity
    $applicationStatus: [ApplicationStatusEnum!]
    $applicationStatusNotIn: [ApplicationStatusEnum!]
    $customApplicationStatusIds: [Int!]
    $applicationType: [ApplicationTypeEnum!]
    $sourceName: [String!]
    $medalistDesignation: [String!]
    $creditedCompanyUserIds: [Int!]
    $companies: [String!]
    $educationLevel: [EducationLevelEnum!]
    $jobTitles: [String!]
    $majors: [String!]
    $nonTraditionalStatus: Boolean
    $schools: [String!]
    $timezones: [String!]
    $veteranStatus: [VeteranStatusEnum!]
    $willingToRelocate: [WillingToRelocateEnum!]
    $yearsOfExperience: YearsOfExperience
    $requisitionId: Int
    $profileType: ProfileTypeEnum
    $labels: [Int!]
    $search: String
    $sortBy: SortByApplication
    $sortDirection: SortDirection
    $limit: Int
    $page: Int
  ) {
    GetCandidateApplication(
      publicListingIds: $publicListingIds
      templateStageIds: $templateStageIds
      matchScore: $matchScore
      candidateProfileId: $candidateProfileId
      skills: $skills
      lastActivity: $lastActivity
      applicationStatus: $applicationStatus
      applicationStatusNotIn: $applicationStatusNotIn
      customApplicationStatusIds: $customApplicationStatusIds
      applicationType: $applicationType
      sourceName: $sourceName
      medalistDesignation: $medalistDesignation
      creditedCompanyUserIds: $creditedCompanyUserIds
      companies: $companies
      educationLevel: $educationLevel
      jobTitles: $jobTitles
      majors: $majors
      nonTraditionalStatus: $nonTraditionalStatus
      schools: $schools
      timezones: $timezones
      veteranStatus: $veteranStatus
      willingToRelocate: $willingToRelocate
      yearsOfExperience: $yearsOfExperience
      requisitionId: $requisitionId
      profileType: $profileType
      search: $search
      labels: $labels
      limit: $limit
      page: $page
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      ...CandidateApplication
      CandidateInterview {
        id
        stageId
        status
      }
      CustomApplicationStatus {
        ...CustomApplicationStatus
      }
      CustomCandidateApplicationFieldValues {
        ...CustomCandidateApplicationFieldValue
      }
      CandidateProfile {
        id
        profileType
        CustomCandidateProfileFieldValues {
          ...CustomCandidateProfileFieldValue
        }
        CandidateLabels {
          ...CandidateLabel
        }
        ProspectStatus {
          ...ProspectStatus
        }
        ProspectOwner {
          id
          UserInvitation {
            ScalisUser {
              ...ScalisUser
            }
          }
        }
        CandidateApplicationRating {
          id
          score
        }
        ScalisUser {
          ...ScalisUser
          mostRecentJob: Experience(onlyMostRecentJob: true) {
            id
            industry
            jobTitle
            employerName
          }
          currentJob: Experience(onlyCurrentJob: true) {
            id
            jobTitle
            employerName
          }
          highestEducation: Education(highestEducation: true) {
            id
            educationLevel
            institutionName
          }
          ContactInfo {
            id
            phoneNumber
          }
          Address {
            id
            country
            city
            state
          }
          EmailVerification {
            id
            isPrimary
            emailAddress
            isVisibleToEmployers
          }
          JobSeekerInfo {
            id
            jobSeekerId
          }
          ExperienceTenure {
            average
            longest
            shortest
          }
        }
        UploadedCandidate {
          ...UploadedCandidate
        }
        ProfileDetails {
          id
          phoneNumber
          CandidateSource {
            ...CandidateSource
          }
        }
        CandidateLabels {
          ...CandidateLabel
        }
      }
      CandidateSource {
        ...CandidateSource
      }
      JobListing {
        id
        publicListingId
        externalTitle
        Requisition {
          id
          jobName
          extRequisitionId
        }
      }
      CandidateScorecard {
        id
        status
        scorecardTemplateId
      }
      TemplateStage {
        id
        TemplateMilestone {
          id
          name
        }
      }
    }
  }
  ${CandidateApplicationFragmentDoc}
  ${CustomApplicationStatusFragmentDoc}
  ${CustomCandidateApplicationFieldValueFragmentDoc}
  ${CustomCandidateProfileFieldValueFragmentDoc}
  ${CandidateLabelFragmentDoc}
  ${ProspectStatusFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${UploadedCandidateFragmentDoc}
  ${CandidateSourceFragmentDoc}
`

/**
 * __useGetCandidateApplicationQuery__
 *
 * To run a query within a React component, call `useGetCandidateApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateApplicationQuery({
 *   variables: {
 *      publicListingIds: // value for 'publicListingIds'
 *      templateStageIds: // value for 'templateStageIds'
 *      matchScore: // value for 'matchScore'
 *      candidateProfileId: // value for 'candidateProfileId'
 *      skills: // value for 'skills'
 *      lastActivity: // value for 'lastActivity'
 *      applicationStatus: // value for 'applicationStatus'
 *      applicationStatusNotIn: // value for 'applicationStatusNotIn'
 *      customApplicationStatusIds: // value for 'customApplicationStatusIds'
 *      applicationType: // value for 'applicationType'
 *      sourceName: // value for 'sourceName'
 *      medalistDesignation: // value for 'medalistDesignation'
 *      creditedCompanyUserIds: // value for 'creditedCompanyUserIds'
 *      companies: // value for 'companies'
 *      educationLevel: // value for 'educationLevel'
 *      jobTitles: // value for 'jobTitles'
 *      majors: // value for 'majors'
 *      nonTraditionalStatus: // value for 'nonTraditionalStatus'
 *      schools: // value for 'schools'
 *      timezones: // value for 'timezones'
 *      veteranStatus: // value for 'veteranStatus'
 *      willingToRelocate: // value for 'willingToRelocate'
 *      yearsOfExperience: // value for 'yearsOfExperience'
 *      requisitionId: // value for 'requisitionId'
 *      profileType: // value for 'profileType'
 *      labels: // value for 'labels'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetCandidateApplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCandidateApplicationQuery, GetCandidateApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateApplicationQuery, GetCandidateApplicationQueryVariables>(
    GetCandidateApplicationDocument,
    options,
  )
}
export function useGetCandidateApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateApplicationQuery, GetCandidateApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateApplicationQuery, GetCandidateApplicationQueryVariables>(
    GetCandidateApplicationDocument,
    options,
  )
}
export function useGetCandidateApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateApplicationQuery, GetCandidateApplicationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateApplicationQuery, GetCandidateApplicationQueryVariables>(
    GetCandidateApplicationDocument,
    options,
  )
}
export type GetCandidateApplicationQueryHookResult = ReturnType<typeof useGetCandidateApplicationQuery>
export type GetCandidateApplicationLazyQueryHookResult = ReturnType<typeof useGetCandidateApplicationLazyQuery>
export type GetCandidateApplicationSuspenseQueryHookResult = ReturnType<typeof useGetCandidateApplicationSuspenseQuery>
export type GetCandidateApplicationQueryResult = Apollo.QueryResult<
  GetCandidateApplicationQuery,
  GetCandidateApplicationQueryVariables
>
export const GetCandidatesToAdvanceOptionsDocument = gql`
  query GetCandidatesToAdvanceOptions(
    $search: String
    $templateStageIds: [Int!]
    $candidateProfileId: [Int!]
    $requisitionId: Int!
  ) {
    GetCandidateApplicationPipelineView(
      search: $search
      templateStageIds: $templateStageIds
      candidateProfileId: $candidateProfileId
      requisitionId: $requisitionId
    ) {
      candidateApplications {
        ...CandidateApplication
        CandidateInterview {
          ...CandidateInterview
        }
        CandidateProfile {
          id
          ...CandidateProfileIds
          ...CandidateProfileName
          ...CandidateProfileEmail
        }
      }
    }
  }
  ${CandidateApplicationFragmentDoc}
  ${CandidateInterviewFragmentDoc}
  ${CandidateProfileIdsFragmentDoc}
  ${CandidateProfileNameFragmentDoc}
  ${CandidateProfileEmailFragmentDoc}
`

/**
 * __useGetCandidatesToAdvanceOptionsQuery__
 *
 * To run a query within a React component, call `useGetCandidatesToAdvanceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidatesToAdvanceOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidatesToAdvanceOptionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      templateStageIds: // value for 'templateStageIds'
 *      candidateProfileId: // value for 'candidateProfileId'
 *      requisitionId: // value for 'requisitionId'
 *   },
 * });
 */
export function useGetCandidatesToAdvanceOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCandidatesToAdvanceOptionsQuery,
    GetCandidatesToAdvanceOptionsQueryVariables
  > &
    ({ variables: GetCandidatesToAdvanceOptionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidatesToAdvanceOptionsQuery, GetCandidatesToAdvanceOptionsQueryVariables>(
    GetCandidatesToAdvanceOptionsDocument,
    options,
  )
}
export function useGetCandidatesToAdvanceOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidatesToAdvanceOptionsQuery,
    GetCandidatesToAdvanceOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidatesToAdvanceOptionsQuery, GetCandidatesToAdvanceOptionsQueryVariables>(
    GetCandidatesToAdvanceOptionsDocument,
    options,
  )
}
export function useGetCandidatesToAdvanceOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidatesToAdvanceOptionsQuery, GetCandidatesToAdvanceOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidatesToAdvanceOptionsQuery, GetCandidatesToAdvanceOptionsQueryVariables>(
    GetCandidatesToAdvanceOptionsDocument,
    options,
  )
}
export type GetCandidatesToAdvanceOptionsQueryHookResult = ReturnType<typeof useGetCandidatesToAdvanceOptionsQuery>
export type GetCandidatesToAdvanceOptionsLazyQueryHookResult = ReturnType<
  typeof useGetCandidatesToAdvanceOptionsLazyQuery
>
export type GetCandidatesToAdvanceOptionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidatesToAdvanceOptionsSuspenseQuery
>
export type GetCandidatesToAdvanceOptionsQueryResult = Apollo.QueryResult<
  GetCandidatesToAdvanceOptionsQuery,
  GetCandidatesToAdvanceOptionsQueryVariables
>
export const CountCandidateApplicationsDocument = gql`
  query CountCandidateApplications($scalisUserId: Int) {
    InterviewRequests: CountCandidateApplication(applicationStatus: INTERVIEW_REQUESTED, scalisUserId: $scalisUserId) {
      count
    }
    ActiveApplications: CountCandidateApplication(
      applicationStatusNotIn: [INVITE_DECLINED, REJECTED, PROSPECT]
      scalisUserId: $scalisUserId
    ) {
      count
    }
    InterviewScheduled: CountCandidateApplication(applicationStatus: INTERVIEW_SCHEDULED, scalisUserId: $scalisUserId) {
      count
    }
    TotalApplications: CountCandidateApplication(scalisUserId: $scalisUserId) {
      count
    }
  }
`

/**
 * __useCountCandidateApplicationsQuery__
 *
 * To run a query within a React component, call `useCountCandidateApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCandidateApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCandidateApplicationsQuery({
 *   variables: {
 *      scalisUserId: // value for 'scalisUserId'
 *   },
 * });
 */
export function useCountCandidateApplicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<CountCandidateApplicationsQuery, CountCandidateApplicationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CountCandidateApplicationsQuery, CountCandidateApplicationsQueryVariables>(
    CountCandidateApplicationsDocument,
    options,
  )
}
export function useCountCandidateApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CountCandidateApplicationsQuery, CountCandidateApplicationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CountCandidateApplicationsQuery, CountCandidateApplicationsQueryVariables>(
    CountCandidateApplicationsDocument,
    options,
  )
}
export function useCountCandidateApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CountCandidateApplicationsQuery, CountCandidateApplicationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CountCandidateApplicationsQuery, CountCandidateApplicationsQueryVariables>(
    CountCandidateApplicationsDocument,
    options,
  )
}
export type CountCandidateApplicationsQueryHookResult = ReturnType<typeof useCountCandidateApplicationsQuery>
export type CountCandidateApplicationsLazyQueryHookResult = ReturnType<typeof useCountCandidateApplicationsLazyQuery>
export type CountCandidateApplicationsSuspenseQueryHookResult = ReturnType<
  typeof useCountCandidateApplicationsSuspenseQuery
>
export type CountCandidateApplicationsQueryResult = Apollo.QueryResult<
  CountCandidateApplicationsQuery,
  CountCandidateApplicationsQueryVariables
>
export const DetailCandidateApplicationDocument = gql`
  query DetailCandidateApplication($id: Int!) {
    GetCandidateApplication(id: $id) {
      CandidateProfile {
        scalisUserId
      }
      JobListing {
        externalTitle
        JobListingJobPipeline {
          JobPipeline {
            title
            TemplatePipeline {
              TemplateMilestones {
                TemplateStage {
                  ...TemplateStage
                  id
                  name
                  visibility
                }
              }
            }
          }
        }
      }
      Company {
        CompanyInfo {
          ...CompanyInfoFragment
          companyName
          logo
        }
      }
      applicationStatus
      candidateProfileId
      jobListingId
      templateStageId
    }
  }
  ${TemplateStageFragmentDoc}
  ${CompanyInfoFragmentFragmentDoc}
`

/**
 * __useDetailCandidateApplicationQuery__
 *
 * To run a query within a React component, call `useDetailCandidateApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailCandidateApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailCandidateApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailCandidateApplicationQuery(
  baseOptions: Apollo.QueryHookOptions<DetailCandidateApplicationQuery, DetailCandidateApplicationQueryVariables> &
    ({ variables: DetailCandidateApplicationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DetailCandidateApplicationQuery, DetailCandidateApplicationQueryVariables>(
    DetailCandidateApplicationDocument,
    options,
  )
}
export function useDetailCandidateApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DetailCandidateApplicationQuery, DetailCandidateApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DetailCandidateApplicationQuery, DetailCandidateApplicationQueryVariables>(
    DetailCandidateApplicationDocument,
    options,
  )
}
export function useDetailCandidateApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DetailCandidateApplicationQuery, DetailCandidateApplicationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DetailCandidateApplicationQuery, DetailCandidateApplicationQueryVariables>(
    DetailCandidateApplicationDocument,
    options,
  )
}
export type DetailCandidateApplicationQueryHookResult = ReturnType<typeof useDetailCandidateApplicationQuery>
export type DetailCandidateApplicationLazyQueryHookResult = ReturnType<typeof useDetailCandidateApplicationLazyQuery>
export type DetailCandidateApplicationSuspenseQueryHookResult = ReturnType<
  typeof useDetailCandidateApplicationSuspenseQuery
>
export type DetailCandidateApplicationQueryResult = Apollo.QueryResult<
  DetailCandidateApplicationQuery,
  DetailCandidateApplicationQueryVariables
>
export const DetailJobListingDocument = gql`
  query DetailJobListing($id: Int, $jobRequisitionId: Int, $page: Int, $limit: Int) {
    GetJobListing(id: $id, jobRequisitionId: $jobRequisitionId, page: $page, limit: $limit) {
      externalTitle
      publicDescription
      postedAt
      workplaceType
      Requisition {
        Company {
          Address {
            ...AddressFragment
            city
            country
            state
          }
          CompanyInfo {
            ...CompanyInfoFragment
            companyName
            logo
          }
        }
        RequisitionSkills {
          ...RequisitionSkillsFragment
          skill {
            ...SkillFragment
          }
        }
        benefits
        jobLevel
        jobType
        maxPay
        minPay
        payType
        isIncomplete
      }
    }
  }
  ${AddressFragmentFragmentDoc}
  ${CompanyInfoFragmentFragmentDoc}
  ${RequisitionSkillsFragmentFragmentDoc}
  ${SkillFragmentFragmentDoc}
`

/**
 * __useDetailJobListingQuery__
 *
 * To run a query within a React component, call `useDetailJobListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailJobListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailJobListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      jobRequisitionId: // value for 'jobRequisitionId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDetailJobListingQuery(
  baseOptions?: Apollo.QueryHookOptions<DetailJobListingQuery, DetailJobListingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DetailJobListingQuery, DetailJobListingQueryVariables>(DetailJobListingDocument, options)
}
export function useDetailJobListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DetailJobListingQuery, DetailJobListingQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DetailJobListingQuery, DetailJobListingQueryVariables>(DetailJobListingDocument, options)
}
export function useDetailJobListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DetailJobListingQuery, DetailJobListingQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DetailJobListingQuery, DetailJobListingQueryVariables>(
    DetailJobListingDocument,
    options,
  )
}
export type DetailJobListingQueryHookResult = ReturnType<typeof useDetailJobListingQuery>
export type DetailJobListingLazyQueryHookResult = ReturnType<typeof useDetailJobListingLazyQuery>
export type DetailJobListingSuspenseQueryHookResult = ReturnType<typeof useDetailJobListingSuspenseQuery>
export type DetailJobListingQueryResult = Apollo.QueryResult<DetailJobListingQuery, DetailJobListingQueryVariables>
export const ListApplicantNoteDocument = gql`
  query ListApplicantNote($candidateApplicationId: Int) {
    GetApplicantNotes(candidateApplicationId: $candidateApplicationId) {
      id
      createdAt
      candidateApplicationId
      scalisUserId
      UserNote {
        ...UserNoteFragment
        id
        noteText
      }
    }
  }
  ${UserNoteFragmentFragmentDoc}
`

/**
 * __useListApplicantNoteQuery__
 *
 * To run a query within a React component, call `useListApplicantNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApplicantNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApplicantNoteQuery({
 *   variables: {
 *      candidateApplicationId: // value for 'candidateApplicationId'
 *   },
 * });
 */
export function useListApplicantNoteQuery(
  baseOptions?: Apollo.QueryHookOptions<ListApplicantNoteQuery, ListApplicantNoteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListApplicantNoteQuery, ListApplicantNoteQueryVariables>(ListApplicantNoteDocument, options)
}
export function useListApplicantNoteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListApplicantNoteQuery, ListApplicantNoteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListApplicantNoteQuery, ListApplicantNoteQueryVariables>(
    ListApplicantNoteDocument,
    options,
  )
}
export function useListApplicantNoteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListApplicantNoteQuery, ListApplicantNoteQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListApplicantNoteQuery, ListApplicantNoteQueryVariables>(
    ListApplicantNoteDocument,
    options,
  )
}
export type ListApplicantNoteQueryHookResult = ReturnType<typeof useListApplicantNoteQuery>
export type ListApplicantNoteLazyQueryHookResult = ReturnType<typeof useListApplicantNoteLazyQuery>
export type ListApplicantNoteSuspenseQueryHookResult = ReturnType<typeof useListApplicantNoteSuspenseQuery>
export type ListApplicantNoteQueryResult = Apollo.QueryResult<ListApplicantNoteQuery, ListApplicantNoteQueryVariables>
export const ListBookmarkedJobDocument = gql`
  query ListBookmarkedJob {
    GetBookmarkedJob {
      company {
        logo
        name
      }
      id
      jobListingId
      locations {
        city
        country
        state
      }
      publicListingId
      scalisUserId
      source
      title
    }
  }
`

/**
 * __useListBookmarkedJobQuery__
 *
 * To run a query within a React component, call `useListBookmarkedJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBookmarkedJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBookmarkedJobQuery({
 *   variables: {
 *   },
 * });
 */
export function useListBookmarkedJobQuery(
  baseOptions?: Apollo.QueryHookOptions<ListBookmarkedJobQuery, ListBookmarkedJobQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListBookmarkedJobQuery, ListBookmarkedJobQueryVariables>(ListBookmarkedJobDocument, options)
}
export function useListBookmarkedJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListBookmarkedJobQuery, ListBookmarkedJobQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListBookmarkedJobQuery, ListBookmarkedJobQueryVariables>(
    ListBookmarkedJobDocument,
    options,
  )
}
export function useListBookmarkedJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListBookmarkedJobQuery, ListBookmarkedJobQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListBookmarkedJobQuery, ListBookmarkedJobQueryVariables>(
    ListBookmarkedJobDocument,
    options,
  )
}
export type ListBookmarkedJobQueryHookResult = ReturnType<typeof useListBookmarkedJobQuery>
export type ListBookmarkedJobLazyQueryHookResult = ReturnType<typeof useListBookmarkedJobLazyQuery>
export type ListBookmarkedJobSuspenseQueryHookResult = ReturnType<typeof useListBookmarkedJobSuspenseQuery>
export type ListBookmarkedJobQueryResult = Apollo.QueryResult<ListBookmarkedJobQuery, ListBookmarkedJobQueryVariables>
export const ListCandidateApplicationDocument = gql`
  query ListCandidateApplication(
    $applicationStatus: [ApplicationStatusEnum!]
    $applicationType: [ApplicationTypeEnum!]
    $id: Int
    $scalisUserId: Int
  ) {
    GetCandidateApplication(
      applicationStatus: $applicationStatus
      applicationType: $applicationType
      id: $id
      scalisUserId: $scalisUserId
    ) {
      Company {
        ...CompanyRequiredFields
        CompanyInfo {
          companyId
          companyName
          id
        }
      }
      JobListing {
        JobListingJobPipeline {
          JobPipeline {
            id
            title
            jobRequisitionId
            templatePipelineId
          }
          id
          jobListingId
          jobPipelineId
        }
        acceptingCandidates
        deletedAt
        externalTitle
        id
        internalMatchingDescription
        jobRequisitionId
        listingTitle
        postedAt
        publicDescription
        publicListingId
        searchInternalMatchingDescription
        searchPublicDescription
        stage
        workplaceType
      }
      TemplateStage {
        TemplateMilestone {
          archived
          id
          name
          rankOrder
          templatePipelineId
        }
        archived
        createdAt
        id
        name
        rankOrder
        templateMilestoneId
        templatePipelineId
        updatedAt
        visibility
      }
      Company {
        CompanyInfo {
          companyName
          logo
        }
      }
      applicationCreationType
      applicationStatus
      applicationTimestamp
      applicationType
      appliedAt
      candidateProfileId
      createdAt
      companyId
      jobListingId
      deleted
      id
      matchScore
      lastUpdatedStatusAt
      templateStageId
      updatedAt
      viewedProfile
      viewedAt
    }
  }
  ${CompanyRequiredFieldsFragmentDoc}
`

/**
 * __useListCandidateApplicationQuery__
 *
 * To run a query within a React component, call `useListCandidateApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidateApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidateApplicationQuery({
 *   variables: {
 *      applicationStatus: // value for 'applicationStatus'
 *      applicationType: // value for 'applicationType'
 *      id: // value for 'id'
 *      scalisUserId: // value for 'scalisUserId'
 *   },
 * });
 */
export function useListCandidateApplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCandidateApplicationQuery, ListCandidateApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListCandidateApplicationQuery, ListCandidateApplicationQueryVariables>(
    ListCandidateApplicationDocument,
    options,
  )
}
export function useListCandidateApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCandidateApplicationQuery, ListCandidateApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListCandidateApplicationQuery, ListCandidateApplicationQueryVariables>(
    ListCandidateApplicationDocument,
    options,
  )
}
export function useListCandidateApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListCandidateApplicationQuery, ListCandidateApplicationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListCandidateApplicationQuery, ListCandidateApplicationQueryVariables>(
    ListCandidateApplicationDocument,
    options,
  )
}
export type ListCandidateApplicationQueryHookResult = ReturnType<typeof useListCandidateApplicationQuery>
export type ListCandidateApplicationLazyQueryHookResult = ReturnType<typeof useListCandidateApplicationLazyQuery>
export type ListCandidateApplicationSuspenseQueryHookResult = ReturnType<
  typeof useListCandidateApplicationSuspenseQuery
>
export type ListCandidateApplicationQueryResult = Apollo.QueryResult<
  ListCandidateApplicationQuery,
  ListCandidateApplicationQueryVariables
>
export const GetBookmarkedJobDocument = gql`
  query GetBookmarkedJob(
    $limit: Int
    $listingTitleSearch: String
    $sortBy: SortByBoomarkedJob
    $sortDirection: SortDirection
    $page: Int
  ) {
    GetBookmarkedJob(
      sortDirection: $sortDirection
      sortBy: $sortBy
      page: $page
      listingTitleSearch: $listingTitleSearch
      limit: $limit
    ) {
      company {
        logo
        name
      }
      id
      jobListingId
      locations {
        city
        country
        state
      }
      publicListingId
      source
      title
    }
    CountBookmarkedJob(listingTitleSearch: $listingTitleSearch) {
      count
    }
  }
`

/**
 * __useGetBookmarkedJobQuery__
 *
 * To run a query within a React component, call `useGetBookmarkedJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkedJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkedJobQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      listingTitleSearch: // value for 'listingTitleSearch'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetBookmarkedJobQuery(
  baseOptions?: Apollo.QueryHookOptions<GetBookmarkedJobQuery, GetBookmarkedJobQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetBookmarkedJobQuery, GetBookmarkedJobQueryVariables>(GetBookmarkedJobDocument, options)
}
export function useGetBookmarkedJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBookmarkedJobQuery, GetBookmarkedJobQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetBookmarkedJobQuery, GetBookmarkedJobQueryVariables>(GetBookmarkedJobDocument, options)
}
export function useGetBookmarkedJobSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBookmarkedJobQuery, GetBookmarkedJobQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetBookmarkedJobQuery, GetBookmarkedJobQueryVariables>(
    GetBookmarkedJobDocument,
    options,
  )
}
export type GetBookmarkedJobQueryHookResult = ReturnType<typeof useGetBookmarkedJobQuery>
export type GetBookmarkedJobLazyQueryHookResult = ReturnType<typeof useGetBookmarkedJobLazyQuery>
export type GetBookmarkedJobSuspenseQueryHookResult = ReturnType<typeof useGetBookmarkedJobSuspenseQuery>
export type GetBookmarkedJobQueryResult = Apollo.QueryResult<GetBookmarkedJobQuery, GetBookmarkedJobQueryVariables>
export const GetJobseekerDashboardApplicationsDocument = gql`
  query GetJobseekerDashboardApplications(
    $limit: Int! = 10
    $page: Int! = 1
    $sortBy: SortByApplication
    $sortDirection: SortDirection
    $search: String
  ) {
    GetCandidateApplication(
      limit: $limit
      page: $page
      sortBy: $sortBy
      sortDirection: $sortDirection
      templateMilestoneNotIn: SOURCING
      search: $search
    ) {
      id
      applicationStatus
      appliedAt
      Company {
        Address {
          city
          state
          country
        }
        CompanyInfo {
          companyName
          logo
        }
      }
      JobListing {
        externalTitle
        publicListingId
        id
        stateAndOrCountry
        workplaceType
        Address {
          timeZone
          state
          postalCode
          longitude
          latitude
          id
          country
          city
          addressType
          addressLine2
          addressLine1
          activeStatus
        }
      }
      LastPublicTemplateStage {
        id
        name
        TemplateMilestone {
          name
        }
      }
      applicationType
      TemplateStage {
        name
        id
        TemplateMilestone {
          name
          id
        }
      }
    }
    CountCandidateApplication(templateMilestoneNotIn: SOURCING, search: $search) {
      count
    }
  }
`

/**
 * __useGetJobseekerDashboardApplicationsQuery__
 *
 * To run a query within a React component, call `useGetJobseekerDashboardApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobseekerDashboardApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobseekerDashboardApplicationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetJobseekerDashboardApplicationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobseekerDashboardApplicationsQuery,
    GetJobseekerDashboardApplicationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobseekerDashboardApplicationsQuery, GetJobseekerDashboardApplicationsQueryVariables>(
    GetJobseekerDashboardApplicationsDocument,
    options,
  )
}
export function useGetJobseekerDashboardApplicationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobseekerDashboardApplicationsQuery,
    GetJobseekerDashboardApplicationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobseekerDashboardApplicationsQuery, GetJobseekerDashboardApplicationsQueryVariables>(
    GetJobseekerDashboardApplicationsDocument,
    options,
  )
}
export function useGetJobseekerDashboardApplicationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetJobseekerDashboardApplicationsQuery,
        GetJobseekerDashboardApplicationsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetJobseekerDashboardApplicationsQuery,
    GetJobseekerDashboardApplicationsQueryVariables
  >(GetJobseekerDashboardApplicationsDocument, options)
}
export type GetJobseekerDashboardApplicationsQueryHookResult = ReturnType<
  typeof useGetJobseekerDashboardApplicationsQuery
>
export type GetJobseekerDashboardApplicationsLazyQueryHookResult = ReturnType<
  typeof useGetJobseekerDashboardApplicationsLazyQuery
>
export type GetJobseekerDashboardApplicationsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobseekerDashboardApplicationsSuspenseQuery
>
export type GetJobseekerDashboardApplicationsQueryResult = Apollo.QueryResult<
  GetJobseekerDashboardApplicationsQuery,
  GetJobseekerDashboardApplicationsQueryVariables
>
export const GetJobseekerDashboardMetricsDocument = gql`
  query GetJobseekerDashboardMetrics {
    active: CountCandidateApplication(applicationStatusNotIn: [REJECTED]) {
      count
    }
    bookmarked: CountBookmarkedJob {
      count
    }
    interviews: CountCandidateApplication(applicationStatusNotIn: [INTERVIEW_COMPLETED, PROSPECT, REJECTED]) {
      count
    }
    invites: CountCandidateApplication(applicationStatus: [INVITED_TO_APPLY, INVITE_DECLINED]) {
      count
    }
    rejected: CountCandidateApplication(applicationStatus: [REJECTED]) {
      count
    }
    total: CountCandidateApplication {
      count
    }
  }
`

/**
 * __useGetJobseekerDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetJobseekerDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobseekerDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobseekerDashboardMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobseekerDashboardMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobseekerDashboardMetricsQuery, GetJobseekerDashboardMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobseekerDashboardMetricsQuery, GetJobseekerDashboardMetricsQueryVariables>(
    GetJobseekerDashboardMetricsDocument,
    options,
  )
}
export function useGetJobseekerDashboardMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobseekerDashboardMetricsQuery,
    GetJobseekerDashboardMetricsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobseekerDashboardMetricsQuery, GetJobseekerDashboardMetricsQueryVariables>(
    GetJobseekerDashboardMetricsDocument,
    options,
  )
}
export function useGetJobseekerDashboardMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobseekerDashboardMetricsQuery, GetJobseekerDashboardMetricsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobseekerDashboardMetricsQuery, GetJobseekerDashboardMetricsQueryVariables>(
    GetJobseekerDashboardMetricsDocument,
    options,
  )
}
export type GetJobseekerDashboardMetricsQueryHookResult = ReturnType<typeof useGetJobseekerDashboardMetricsQuery>
export type GetJobseekerDashboardMetricsLazyQueryHookResult = ReturnType<
  typeof useGetJobseekerDashboardMetricsLazyQuery
>
export type GetJobseekerDashboardMetricsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobseekerDashboardMetricsSuspenseQuery
>
export type GetJobseekerDashboardMetricsQueryResult = Apollo.QueryResult<
  GetJobseekerDashboardMetricsQuery,
  GetJobseekerDashboardMetricsQueryVariables
>
export const GetExternalJobApplicationDocument = gql`
  query GetExternalJobApplication(
    $status: [ExternalApplicationStatus!]
    $search: String
    $limit: Int
    $page: Int
    $sortBy: SortByExternalApplication
    $sortDirection: SortDirection
  ) {
    GetExternalJobApplication(
      status: $status
      search: $search
      page: $page
      limit: $limit
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      status
      location
      jobUrl
      jobTitle
      jobId
      id
      employerName
      appliedAt
      updatedAt
    }
    CountExternalJobApplication(status: $status, search: $search) {
      count
    }
  }
`

/**
 * __useGetExternalJobApplicationQuery__
 *
 * To run a query within a React component, call `useGetExternalJobApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalJobApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalJobApplicationQuery({
 *   variables: {
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetExternalJobApplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<GetExternalJobApplicationQuery, GetExternalJobApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetExternalJobApplicationQuery, GetExternalJobApplicationQueryVariables>(
    GetExternalJobApplicationDocument,
    options,
  )
}
export function useGetExternalJobApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetExternalJobApplicationQuery, GetExternalJobApplicationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetExternalJobApplicationQuery, GetExternalJobApplicationQueryVariables>(
    GetExternalJobApplicationDocument,
    options,
  )
}
export function useGetExternalJobApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetExternalJobApplicationQuery, GetExternalJobApplicationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetExternalJobApplicationQuery, GetExternalJobApplicationQueryVariables>(
    GetExternalJobApplicationDocument,
    options,
  )
}
export type GetExternalJobApplicationQueryHookResult = ReturnType<typeof useGetExternalJobApplicationQuery>
export type GetExternalJobApplicationLazyQueryHookResult = ReturnType<typeof useGetExternalJobApplicationLazyQuery>
export type GetExternalJobApplicationSuspenseQueryHookResult = ReturnType<
  typeof useGetExternalJobApplicationSuspenseQuery
>
export type GetExternalJobApplicationQueryResult = Apollo.QueryResult<
  GetExternalJobApplicationQuery,
  GetExternalJobApplicationQueryVariables
>
export const GetJobSeekerJobInvitesDocument = gql`
  query GetJobSeekerJobInvites(
    $listingTitleSearch: String
    $sortBy: SortByJobInvite
    $sortDirection: SortDirection
    $page: Int
    $limit: Int
  ) {
    CountJobInvite {
      count
    }
    GetJobInvite(
      inviteStatus: [SENT]
      sortDirection: $sortDirection
      sortBy: $sortBy
      page: $page
      limit: $limit
      listingTitleSearch: $listingTitleSearch
    ) {
      token
      sentAt
      jobListingId
      inviteStatus
      id
      dismissed
      candidateApplicationId
      JobListing {
        id
        listingTitle
        publicListingId
        externalTitle
        Requisition {
          Company {
            id
            CompanyInfo {
              companyName
              id
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetJobSeekerJobInvitesQuery__
 *
 * To run a query within a React component, call `useGetJobSeekerJobInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekerJobInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekerJobInvitesQuery({
 *   variables: {
 *      listingTitleSearch: // value for 'listingTitleSearch'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetJobSeekerJobInvitesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobSeekerJobInvitesQuery, GetJobSeekerJobInvitesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobSeekerJobInvitesQuery, GetJobSeekerJobInvitesQueryVariables>(
    GetJobSeekerJobInvitesDocument,
    options,
  )
}
export function useGetJobSeekerJobInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobSeekerJobInvitesQuery, GetJobSeekerJobInvitesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobSeekerJobInvitesQuery, GetJobSeekerJobInvitesQueryVariables>(
    GetJobSeekerJobInvitesDocument,
    options,
  )
}
export function useGetJobSeekerJobInvitesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetJobSeekerJobInvitesQuery, GetJobSeekerJobInvitesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobSeekerJobInvitesQuery, GetJobSeekerJobInvitesQueryVariables>(
    GetJobSeekerJobInvitesDocument,
    options,
  )
}
export type GetJobSeekerJobInvitesQueryHookResult = ReturnType<typeof useGetJobSeekerJobInvitesQuery>
export type GetJobSeekerJobInvitesLazyQueryHookResult = ReturnType<typeof useGetJobSeekerJobInvitesLazyQuery>
export type GetJobSeekerJobInvitesSuspenseQueryHookResult = ReturnType<typeof useGetJobSeekerJobInvitesSuspenseQuery>
export type GetJobSeekerJobInvitesQueryResult = Apollo.QueryResult<
  GetJobSeekerJobInvitesQuery,
  GetJobSeekerJobInvitesQueryVariables
>
export const GetScalisUserDocument = gql`
  query GetScalisUser($id: Int!) {
    GetScalisUser(id: $id) {
      id
      Address {
        activeStatus
        addressLine1
        addressLine2
        city
        country
        contactName
        addressType
        createdAt
        id
        latitude
        longitude
        state
        timeZone
        updatedAt
        postalCode
      }
      JobSeekerInfo {
        canStartNewJob
        consideringOffers
        currPrefRoles
        createdAt
        desiredPay
        employStatus
        id
        jobSeekerId
        jobLevel
        jobType
        locationsWillRelocate
        jobTypePref
        messageUserId
        nonTraditionalStatus
        searchStatus
        payType
        searchingJobs
        teamSize
        updatedAt
        tryingToRelocate
        yearsOfExperience
        willingToRelocate
        yearsInWorkforce
      }
      completedAt
      currentStage
      profileImage
      ScalisUserUploadedDocument {
        id
        documentPath
        documentName
        documentType
        createdAt
        deletedAt
      }
    }
  }
`

/**
 * __useGetScalisUserQuery__
 *
 * To run a query within a React component, call `useGetScalisUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScalisUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScalisUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScalisUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetScalisUserQuery, GetScalisUserQueryVariables> &
    ({ variables: GetScalisUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScalisUserQuery, GetScalisUserQueryVariables>(GetScalisUserDocument, options)
}
export function useGetScalisUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScalisUserQuery, GetScalisUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScalisUserQuery, GetScalisUserQueryVariables>(GetScalisUserDocument, options)
}
export function useGetScalisUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScalisUserQuery, GetScalisUserQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScalisUserQuery, GetScalisUserQueryVariables>(GetScalisUserDocument, options)
}
export type GetScalisUserQueryHookResult = ReturnType<typeof useGetScalisUserQuery>
export type GetScalisUserLazyQueryHookResult = ReturnType<typeof useGetScalisUserLazyQuery>
export type GetScalisUserSuspenseQueryHookResult = ReturnType<typeof useGetScalisUserSuspenseQuery>
export type GetScalisUserQueryResult = Apollo.QueryResult<GetScalisUserQuery, GetScalisUserQueryVariables>
export const ListJobDocument = gql`
  query ListJob {
    GetJobListing {
      acceptingCandidates
      deletedAt
      externalTitle
      id
      internalMatchingDescription
      jobRequisitionId
      listingTitle
      postedAt
      publicDescription
      publicListingId
      searchPublicDescription
      searchInternalMatchingDescription
      stage
      workplaceType
      Requisition {
        jobLevel
        Company {
          Address {
            ...AddressFragment
          }
          CompanyInfo {
            companyId
            ...CompanyInfoFragment
          }
        }
        jobType
      }
    }
  }
  ${AddressFragmentFragmentDoc}
  ${CompanyInfoFragmentFragmentDoc}
`

/**
 * __useListJobQuery__
 *
 * To run a query within a React component, call `useListJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobQuery({
 *   variables: {
 *   },
 * });
 */
export function useListJobQuery(baseOptions?: Apollo.QueryHookOptions<ListJobQuery, ListJobQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListJobQuery, ListJobQueryVariables>(ListJobDocument, options)
}
export function useListJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobQuery, ListJobQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListJobQuery, ListJobQueryVariables>(ListJobDocument, options)
}
export function useListJobSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListJobQuery, ListJobQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListJobQuery, ListJobQueryVariables>(ListJobDocument, options)
}
export type ListJobQueryHookResult = ReturnType<typeof useListJobQuery>
export type ListJobLazyQueryHookResult = ReturnType<typeof useListJobLazyQuery>
export type ListJobSuspenseQueryHookResult = ReturnType<typeof useListJobSuspenseQuery>
export type ListJobQueryResult = Apollo.QueryResult<ListJobQuery, ListJobQueryVariables>
export const LoggedUserDocument = gql`
  query LoggedUser {
    Me {
      id
      firstName
      lastName
      completedAt
      currentStage
      profileImage
      JobSeekerInfo {
        aboutMe
      }
      Address {
        city
        state
        country
      }
      Achievement {
        id
        name
        issuingAuthority
        issueYear
        description
      }
      CertificateOrLicense {
        id
        name
        issuingAuthority
        issueYear
        description
      }
      JobSeekerSkill {
        id
        sequenceNumber
        level
        name
        yearsOfExp
      }
      DemographicInfo {
        gender
        raceEthnicity
        veteranStatus
      }
      WebsiteOrSocialMedia {
        id
        websiteURL
      }
      VolunteerWork {
        id
        roleType
        volunteerJobTitle
        organizationName
        location
        startDate
        isCurrentlyWorking
        description
      }
      Experience {
        ...Experience
      }
      Education {
        id
        institutionName
        educationLevel
        areasOfStudy
        startDate
        endDate
        cumGPA
        cumGPAScale
      }
    }
  }
  ${ExperienceFragmentDoc}
`

/**
 * __useLoggedUserQuery__
 *
 * To run a query within a React component, call `useLoggedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoggedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoggedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoggedUserQuery(baseOptions?: Apollo.QueryHookOptions<LoggedUserQuery, LoggedUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LoggedUserQuery, LoggedUserQueryVariables>(LoggedUserDocument, options)
}
export function useLoggedUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LoggedUserQuery, LoggedUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LoggedUserQuery, LoggedUserQueryVariables>(LoggedUserDocument, options)
}
export function useLoggedUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoggedUserQuery, LoggedUserQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<LoggedUserQuery, LoggedUserQueryVariables>(LoggedUserDocument, options)
}
export type LoggedUserQueryHookResult = ReturnType<typeof useLoggedUserQuery>
export type LoggedUserLazyQueryHookResult = ReturnType<typeof useLoggedUserLazyQuery>
export type LoggedUserSuspenseQueryHookResult = ReturnType<typeof useLoggedUserSuspenseQuery>
export type LoggedUserQueryResult = Apollo.QueryResult<LoggedUserQuery, LoggedUserQueryVariables>
export const GetChatUsersJsv2Document = gql`
  query GetChatUsersJSV2 {
    GetChatUsersJSV2 {
      firstName
      lastName
      userId
    }
  }
`

/**
 * __useGetChatUsersJsv2Query__
 *
 * To run a query within a React component, call `useGetChatUsersJsv2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetChatUsersJsv2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatUsersJsv2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetChatUsersJsv2Query(
  baseOptions?: Apollo.QueryHookOptions<GetChatUsersJsv2Query, GetChatUsersJsv2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChatUsersJsv2Query, GetChatUsersJsv2QueryVariables>(GetChatUsersJsv2Document, options)
}
export function useGetChatUsersJsv2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChatUsersJsv2Query, GetChatUsersJsv2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChatUsersJsv2Query, GetChatUsersJsv2QueryVariables>(GetChatUsersJsv2Document, options)
}
export function useGetChatUsersJsv2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetChatUsersJsv2Query, GetChatUsersJsv2QueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetChatUsersJsv2Query, GetChatUsersJsv2QueryVariables>(
    GetChatUsersJsv2Document,
    options,
  )
}
export type GetChatUsersJsv2QueryHookResult = ReturnType<typeof useGetChatUsersJsv2Query>
export type GetChatUsersJsv2LazyQueryHookResult = ReturnType<typeof useGetChatUsersJsv2LazyQuery>
export type GetChatUsersJsv2SuspenseQueryHookResult = ReturnType<typeof useGetChatUsersJsv2SuspenseQuery>
export type GetChatUsersJsv2QueryResult = Apollo.QueryResult<GetChatUsersJsv2Query, GetChatUsersJsv2QueryVariables>
export const GetChatUsersV2Document = gql`
  query GetChatUsersV2 {
    GetChatUsersV2 {
      firstName
      lastName
      userId
    }
  }
`

/**
 * __useGetChatUsersV2Query__
 *
 * To run a query within a React component, call `useGetChatUsersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetChatUsersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatUsersV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetChatUsersV2Query(
  baseOptions?: Apollo.QueryHookOptions<GetChatUsersV2Query, GetChatUsersV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChatUsersV2Query, GetChatUsersV2QueryVariables>(GetChatUsersV2Document, options)
}
export function useGetChatUsersV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChatUsersV2Query, GetChatUsersV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChatUsersV2Query, GetChatUsersV2QueryVariables>(GetChatUsersV2Document, options)
}
export function useGetChatUsersV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatUsersV2Query, GetChatUsersV2QueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetChatUsersV2Query, GetChatUsersV2QueryVariables>(GetChatUsersV2Document, options)
}
export type GetChatUsersV2QueryHookResult = ReturnType<typeof useGetChatUsersV2Query>
export type GetChatUsersV2LazyQueryHookResult = ReturnType<typeof useGetChatUsersV2LazyQuery>
export type GetChatUsersV2SuspenseQueryHookResult = ReturnType<typeof useGetChatUsersV2SuspenseQuery>
export type GetChatUsersV2QueryResult = Apollo.QueryResult<GetChatUsersV2Query, GetChatUsersV2QueryVariables>
export const GetChatsJsv2Document = gql`
  query GetChatsJSV2 {
    GetChatsJSV2 {
      firstName
      lastName
      companyName
      chatId
      userId
    }
  }
`

/**
 * __useGetChatsJsv2Query__
 *
 * To run a query within a React component, call `useGetChatsJsv2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsJsv2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsJsv2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetChatsJsv2Query(
  baseOptions?: Apollo.QueryHookOptions<GetChatsJsv2Query, GetChatsJsv2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChatsJsv2Query, GetChatsJsv2QueryVariables>(GetChatsJsv2Document, options)
}
export function useGetChatsJsv2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChatsJsv2Query, GetChatsJsv2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChatsJsv2Query, GetChatsJsv2QueryVariables>(GetChatsJsv2Document, options)
}
export function useGetChatsJsv2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatsJsv2Query, GetChatsJsv2QueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetChatsJsv2Query, GetChatsJsv2QueryVariables>(GetChatsJsv2Document, options)
}
export type GetChatsJsv2QueryHookResult = ReturnType<typeof useGetChatsJsv2Query>
export type GetChatsJsv2LazyQueryHookResult = ReturnType<typeof useGetChatsJsv2LazyQuery>
export type GetChatsJsv2SuspenseQueryHookResult = ReturnType<typeof useGetChatsJsv2SuspenseQuery>
export type GetChatsJsv2QueryResult = Apollo.QueryResult<GetChatsJsv2Query, GetChatsJsv2QueryVariables>
export const GetChatsV2Document = gql`
  query GetChatsV2 {
    GetChatsV2 {
      firstName
      lastName
      userId
      chatId
    }
  }
`

/**
 * __useGetChatsV2Query__
 *
 * To run a query within a React component, call `useGetChatsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useGetChatsV2Query(baseOptions?: Apollo.QueryHookOptions<GetChatsV2Query, GetChatsV2QueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetChatsV2Query, GetChatsV2QueryVariables>(GetChatsV2Document, options)
}
export function useGetChatsV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetChatsV2Query, GetChatsV2QueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetChatsV2Query, GetChatsV2QueryVariables>(GetChatsV2Document, options)
}
export function useGetChatsV2SuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatsV2Query, GetChatsV2QueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetChatsV2Query, GetChatsV2QueryVariables>(GetChatsV2Document, options)
}
export type GetChatsV2QueryHookResult = ReturnType<typeof useGetChatsV2Query>
export type GetChatsV2LazyQueryHookResult = ReturnType<typeof useGetChatsV2LazyQuery>
export type GetChatsV2SuspenseQueryHookResult = ReturnType<typeof useGetChatsV2SuspenseQuery>
export type GetChatsV2QueryResult = Apollo.QueryResult<GetChatsV2Query, GetChatsV2QueryVariables>
export const CreateCandidateOfferFileDocument = gql`
  mutation CreateCandidateOfferFile($input: CreateCandidateOfferFileInput!) {
    CreateCandidateOfferFile(input: $input) {
      id
    }
  }
`
export type CreateCandidateOfferFileMutationFn = Apollo.MutationFunction<
  CreateCandidateOfferFileMutation,
  CreateCandidateOfferFileMutationVariables
>

/**
 * __useCreateCandidateOfferFileMutation__
 *
 * To run a mutation, you first call `useCreateCandidateOfferFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateOfferFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateOfferFileMutation, { data, loading, error }] = useCreateCandidateOfferFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateOfferFileMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCandidateOfferFileMutation, CreateCandidateOfferFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateCandidateOfferFileMutation, CreateCandidateOfferFileMutationVariables>(
    CreateCandidateOfferFileDocument,
    options,
  )
}
export type CreateCandidateOfferFileMutationHookResult = ReturnType<typeof useCreateCandidateOfferFileMutation>
export type CreateCandidateOfferFileMutationResult = Apollo.MutationResult<CreateCandidateOfferFileMutation>
export type CreateCandidateOfferFileMutationOptions = Apollo.BaseMutationOptions<
  CreateCandidateOfferFileMutation,
  CreateCandidateOfferFileMutationVariables
>
export const DeleteCandidateOfferFileDocument = gql`
  mutation DeleteCandidateOfferFile($input: DeleteCandidateOfferFileInput!) {
    DeleteCandidateOfferFile(input: $input) {
      id
    }
  }
`
export type DeleteCandidateOfferFileMutationFn = Apollo.MutationFunction<
  DeleteCandidateOfferFileMutation,
  DeleteCandidateOfferFileMutationVariables
>

/**
 * __useDeleteCandidateOfferFileMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateOfferFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateOfferFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateOfferFileMutation, { data, loading, error }] = useDeleteCandidateOfferFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCandidateOfferFileMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCandidateOfferFileMutation, DeleteCandidateOfferFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteCandidateOfferFileMutation, DeleteCandidateOfferFileMutationVariables>(
    DeleteCandidateOfferFileDocument,
    options,
  )
}
export type DeleteCandidateOfferFileMutationHookResult = ReturnType<typeof useDeleteCandidateOfferFileMutation>
export type DeleteCandidateOfferFileMutationResult = Apollo.MutationResult<DeleteCandidateOfferFileMutation>
export type DeleteCandidateOfferFileMutationOptions = Apollo.BaseMutationOptions<
  DeleteCandidateOfferFileMutation,
  DeleteCandidateOfferFileMutationVariables
>
export const GetCandidateOfferCustomFieldDocument = gql`
  query GetCandidateOfferCustomField($input: GetCandidateOfferCustomFieldInput!) {
    GetCandidateOfferCustomField(input: $input) {
      id
      fieldValue
      candidateOfferVersionId
      offerCustomFieldId
    }
  }
`

/**
 * __useGetCandidateOfferCustomFieldQuery__
 *
 * To run a query within a React component, call `useGetCandidateOfferCustomFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateOfferCustomFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateOfferCustomFieldQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateOfferCustomFieldQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateOfferCustomFieldQuery, GetCandidateOfferCustomFieldQueryVariables> &
    ({ variables: GetCandidateOfferCustomFieldQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateOfferCustomFieldQuery, GetCandidateOfferCustomFieldQueryVariables>(
    GetCandidateOfferCustomFieldDocument,
    options,
  )
}
export function useGetCandidateOfferCustomFieldLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidateOfferCustomFieldQuery,
    GetCandidateOfferCustomFieldQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateOfferCustomFieldQuery, GetCandidateOfferCustomFieldQueryVariables>(
    GetCandidateOfferCustomFieldDocument,
    options,
  )
}
export function useGetCandidateOfferCustomFieldSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateOfferCustomFieldQuery, GetCandidateOfferCustomFieldQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateOfferCustomFieldQuery, GetCandidateOfferCustomFieldQueryVariables>(
    GetCandidateOfferCustomFieldDocument,
    options,
  )
}
export type GetCandidateOfferCustomFieldQueryHookResult = ReturnType<typeof useGetCandidateOfferCustomFieldQuery>
export type GetCandidateOfferCustomFieldLazyQueryHookResult = ReturnType<
  typeof useGetCandidateOfferCustomFieldLazyQuery
>
export type GetCandidateOfferCustomFieldSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateOfferCustomFieldSuspenseQuery
>
export type GetCandidateOfferCustomFieldQueryResult = Apollo.QueryResult<
  GetCandidateOfferCustomFieldQuery,
  GetCandidateOfferCustomFieldQueryVariables
>
export const GetCandidateOfferVersionEmbeddedClaimUrlDocument = gql`
  query GetCandidateOfferVersionEmbeddedClaimUrl($input: GetCandidateOfferVersionEmbeddedClaimUrlInput!) {
    GetCandidateOfferVersionEmbeddedClaimUrl(input: $input) {
      clientId
      claimUrl
      signatureRequestId
    }
  }
`

/**
 * __useGetCandidateOfferVersionEmbeddedClaimUrlQuery__
 *
 * To run a query within a React component, call `useGetCandidateOfferVersionEmbeddedClaimUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateOfferVersionEmbeddedClaimUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateOfferVersionEmbeddedClaimUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateOfferVersionEmbeddedClaimUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCandidateOfferVersionEmbeddedClaimUrlQuery,
    GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables
  > &
    ({ variables: GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetCandidateOfferVersionEmbeddedClaimUrlQuery,
    GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables
  >(GetCandidateOfferVersionEmbeddedClaimUrlDocument, options)
}
export function useGetCandidateOfferVersionEmbeddedClaimUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCandidateOfferVersionEmbeddedClaimUrlQuery,
    GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetCandidateOfferVersionEmbeddedClaimUrlQuery,
    GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables
  >(GetCandidateOfferVersionEmbeddedClaimUrlDocument, options)
}
export function useGetCandidateOfferVersionEmbeddedClaimUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCandidateOfferVersionEmbeddedClaimUrlQuery,
        GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetCandidateOfferVersionEmbeddedClaimUrlQuery,
    GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables
  >(GetCandidateOfferVersionEmbeddedClaimUrlDocument, options)
}
export type GetCandidateOfferVersionEmbeddedClaimUrlQueryHookResult = ReturnType<
  typeof useGetCandidateOfferVersionEmbeddedClaimUrlQuery
>
export type GetCandidateOfferVersionEmbeddedClaimUrlLazyQueryHookResult = ReturnType<
  typeof useGetCandidateOfferVersionEmbeddedClaimUrlLazyQuery
>
export type GetCandidateOfferVersionEmbeddedClaimUrlSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateOfferVersionEmbeddedClaimUrlSuspenseQuery
>
export type GetCandidateOfferVersionEmbeddedClaimUrlQueryResult = Apollo.QueryResult<
  GetCandidateOfferVersionEmbeddedClaimUrlQuery,
  GetCandidateOfferVersionEmbeddedClaimUrlQueryVariables
>
export const GetCandidateOfferDocument = gql`
  query GetCandidateOffer($candidateApplicationId: Int!) {
    GetCandidateOffer(input: { candidateApplicationId: $candidateApplicationId }) {
      id
      CandidateOfferVersion {
        ...CandidateOfferVersion
      }
    }
  }
  ${CandidateOfferVersionFragmentDoc}
`

/**
 * __useGetCandidateOfferQuery__
 *
 * To run a query within a React component, call `useGetCandidateOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateOfferQuery({
 *   variables: {
 *      candidateApplicationId: // value for 'candidateApplicationId'
 *   },
 * });
 */
export function useGetCandidateOfferQuery(
  baseOptions: Apollo.QueryHookOptions<GetCandidateOfferQuery, GetCandidateOfferQueryVariables> &
    ({ variables: GetCandidateOfferQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateOfferQuery, GetCandidateOfferQueryVariables>(GetCandidateOfferDocument, options)
}
export function useGetCandidateOfferLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateOfferQuery, GetCandidateOfferQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateOfferQuery, GetCandidateOfferQueryVariables>(
    GetCandidateOfferDocument,
    options,
  )
}
export function useGetCandidateOfferSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateOfferQuery, GetCandidateOfferQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateOfferQuery, GetCandidateOfferQueryVariables>(
    GetCandidateOfferDocument,
    options,
  )
}
export type GetCandidateOfferQueryHookResult = ReturnType<typeof useGetCandidateOfferQuery>
export type GetCandidateOfferLazyQueryHookResult = ReturnType<typeof useGetCandidateOfferLazyQuery>
export type GetCandidateOfferSuspenseQueryHookResult = ReturnType<typeof useGetCandidateOfferSuspenseQuery>
export type GetCandidateOfferQueryResult = Apollo.QueryResult<GetCandidateOfferQuery, GetCandidateOfferQueryVariables>
export const GetCompanyOfficeListDocument = gql`
  query GetCompanyOfficeList {
    ListCompanyOffices {
      id
      officeName
    }
  }
`

/**
 * __useGetCompanyOfficeListQuery__
 *
 * To run a query within a React component, call `useGetCompanyOfficeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOfficeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOfficeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyOfficeListQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyOfficeListQuery, GetCompanyOfficeListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyOfficeListQuery, GetCompanyOfficeListQueryVariables>(
    GetCompanyOfficeListDocument,
    options,
  )
}
export function useGetCompanyOfficeListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyOfficeListQuery, GetCompanyOfficeListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyOfficeListQuery, GetCompanyOfficeListQueryVariables>(
    GetCompanyOfficeListDocument,
    options,
  )
}
export function useGetCompanyOfficeListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyOfficeListQuery, GetCompanyOfficeListQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyOfficeListQuery, GetCompanyOfficeListQueryVariables>(
    GetCompanyOfficeListDocument,
    options,
  )
}
export type GetCompanyOfficeListQueryHookResult = ReturnType<typeof useGetCompanyOfficeListQuery>
export type GetCompanyOfficeListLazyQueryHookResult = ReturnType<typeof useGetCompanyOfficeListLazyQuery>
export type GetCompanyOfficeListSuspenseQueryHookResult = ReturnType<typeof useGetCompanyOfficeListSuspenseQuery>
export type GetCompanyOfficeListQueryResult = Apollo.QueryResult<
  GetCompanyOfficeListQuery,
  GetCompanyOfficeListQueryVariables
>
export const GetOfferLetterDocumentTemplateDocument = gql`
  query GetOfferLetterDocumentTemplate {
    GetOfferDocumentTemplate(input: { documentType: OFFER_LETTER, documentTemplateStatus: VERIFIED }) {
      ...OfferDocumentTemplate
    }
  }
  ${OfferDocumentTemplateFragmentDoc}
`

/**
 * __useGetOfferLetterDocumentTemplateQuery__
 *
 * To run a query within a React component, call `useGetOfferLetterDocumentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferLetterDocumentTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferLetterDocumentTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferLetterDocumentTemplateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOfferLetterDocumentTemplateQuery,
    GetOfferLetterDocumentTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOfferLetterDocumentTemplateQuery, GetOfferLetterDocumentTemplateQueryVariables>(
    GetOfferLetterDocumentTemplateDocument,
    options,
  )
}
export function useGetOfferLetterDocumentTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOfferLetterDocumentTemplateQuery,
    GetOfferLetterDocumentTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOfferLetterDocumentTemplateQuery, GetOfferLetterDocumentTemplateQueryVariables>(
    GetOfferLetterDocumentTemplateDocument,
    options,
  )
}
export function useGetOfferLetterDocumentTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOfferLetterDocumentTemplateQuery,
        GetOfferLetterDocumentTemplateQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOfferLetterDocumentTemplateQuery, GetOfferLetterDocumentTemplateQueryVariables>(
    GetOfferLetterDocumentTemplateDocument,
    options,
  )
}
export type GetOfferLetterDocumentTemplateQueryHookResult = ReturnType<typeof useGetOfferLetterDocumentTemplateQuery>
export type GetOfferLetterDocumentTemplateLazyQueryHookResult = ReturnType<
  typeof useGetOfferLetterDocumentTemplateLazyQuery
>
export type GetOfferLetterDocumentTemplateSuspenseQueryHookResult = ReturnType<
  typeof useGetOfferLetterDocumentTemplateSuspenseQuery
>
export type GetOfferLetterDocumentTemplateQueryResult = Apollo.QueryResult<
  GetOfferLetterDocumentTemplateQuery,
  GetOfferLetterDocumentTemplateQueryVariables
>
export const GetMyProfileDocument = gql`
  query GetMyProfile {
    Me {
      id
      firstName
      lastName
      profileImage
      EmailVerification {
        id
        emailAddress
      }
    }
  }
`

/**
 * __useGetMyProfileQuery__
 *
 * To run a query within a React component, call `useGetMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, options)
}
export function useGetMyProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, options)
}
export function useGetMyProfileSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyProfileQuery, GetMyProfileQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, options)
}
export type GetMyProfileQueryHookResult = ReturnType<typeof useGetMyProfileQuery>
export type GetMyProfileLazyQueryHookResult = ReturnType<typeof useGetMyProfileLazyQuery>
export type GetMyProfileSuspenseQueryHookResult = ReturnType<typeof useGetMyProfileSuspenseQuery>
export type GetMyProfileQueryResult = Apollo.QueryResult<GetMyProfileQuery, GetMyProfileQueryVariables>
export const SendCandidateOfferDocument = gql`
  mutation SendCandidateOffer($input: SendCandidateOfferInput!) {
    SendCandidateOffer(input: $input)
  }
`
export type SendCandidateOfferMutationFn = Apollo.MutationFunction<
  SendCandidateOfferMutation,
  SendCandidateOfferMutationVariables
>

/**
 * __useSendCandidateOfferMutation__
 *
 * To run a mutation, you first call `useSendCandidateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCandidateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCandidateOfferMutation, { data, loading, error }] = useSendCandidateOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCandidateOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<SendCandidateOfferMutation, SendCandidateOfferMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SendCandidateOfferMutation, SendCandidateOfferMutationVariables>(
    SendCandidateOfferDocument,
    options,
  )
}
export type SendCandidateOfferMutationHookResult = ReturnType<typeof useSendCandidateOfferMutation>
export type SendCandidateOfferMutationResult = Apollo.MutationResult<SendCandidateOfferMutation>
export type SendCandidateOfferMutationOptions = Apollo.BaseMutationOptions<
  SendCandidateOfferMutation,
  SendCandidateOfferMutationVariables
>
export const CandidateOfferVersionSignatureSendEmailReminderDocument = gql`
  mutation CandidateOfferVersionSignatureSendEmailReminder($input: CandidateOfferVersionSignatureSendReminderInput!) {
    CandidateOfferVersionSignatureSendEmailReminder(input: $input) {
      id
      emailAddress
      error
    }
  }
`
export type CandidateOfferVersionSignatureSendEmailReminderMutationFn = Apollo.MutationFunction<
  CandidateOfferVersionSignatureSendEmailReminderMutation,
  CandidateOfferVersionSignatureSendEmailReminderMutationVariables
>

/**
 * __useCandidateOfferVersionSignatureSendEmailReminderMutation__
 *
 * To run a mutation, you first call `useCandidateOfferVersionSignatureSendEmailReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateOfferVersionSignatureSendEmailReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateOfferVersionSignatureSendEmailReminderMutation, { data, loading, error }] = useCandidateOfferVersionSignatureSendEmailReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateOfferVersionSignatureSendEmailReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CandidateOfferVersionSignatureSendEmailReminderMutation,
    CandidateOfferVersionSignatureSendEmailReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CandidateOfferVersionSignatureSendEmailReminderMutation,
    CandidateOfferVersionSignatureSendEmailReminderMutationVariables
  >(CandidateOfferVersionSignatureSendEmailReminderDocument, options)
}
export type CandidateOfferVersionSignatureSendEmailReminderMutationHookResult = ReturnType<
  typeof useCandidateOfferVersionSignatureSendEmailReminderMutation
>
export type CandidateOfferVersionSignatureSendEmailReminderMutationResult =
  Apollo.MutationResult<CandidateOfferVersionSignatureSendEmailReminderMutation>
export type CandidateOfferVersionSignatureSendEmailReminderMutationOptions = Apollo.BaseMutationOptions<
  CandidateOfferVersionSignatureSendEmailReminderMutation,
  CandidateOfferVersionSignatureSendEmailReminderMutationVariables
>
export const UpdateCandidateOfferVersionStatusDocument = gql`
  mutation UpdateCandidateOfferVersionStatus($input: UpdateCandidateOfferVersionStatusInput!) {
    UpdateCandidateOfferVersionStatus(input: $input) {
      id
      candidateOfferId
      version
      candidateName
      jobTitle
      manager
      startDate
      jobType
      payType
      benefits
      expirationDate
      companyOfficeId
      compensation
      additionalCompensation
      offerStatus
      lastUpdatedStatusAt
      createdAt
    }
  }
`
export type UpdateCandidateOfferVersionStatusMutationFn = Apollo.MutationFunction<
  UpdateCandidateOfferVersionStatusMutation,
  UpdateCandidateOfferVersionStatusMutationVariables
>

/**
 * __useUpdateCandidateOfferVersionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateOfferVersionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateOfferVersionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateOfferVersionStatusMutation, { data, loading, error }] = useUpdateCandidateOfferVersionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidateOfferVersionStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCandidateOfferVersionStatusMutation,
    UpdateCandidateOfferVersionStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCandidateOfferVersionStatusMutation,
    UpdateCandidateOfferVersionStatusMutationVariables
  >(UpdateCandidateOfferVersionStatusDocument, options)
}
export type UpdateCandidateOfferVersionStatusMutationHookResult = ReturnType<
  typeof useUpdateCandidateOfferVersionStatusMutation
>
export type UpdateCandidateOfferVersionStatusMutationResult =
  Apollo.MutationResult<UpdateCandidateOfferVersionStatusMutation>
export type UpdateCandidateOfferVersionStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateCandidateOfferVersionStatusMutation,
  UpdateCandidateOfferVersionStatusMutationVariables
>
export const UpsertCandidateOfferCustomFieldDocument = gql`
  mutation UpsertCandidateOfferCustomField($input: UpsertCandidateOfferCustomFieldInput!) {
    UpsertCandidateOfferCustomField(input: $input) {
      id
      fieldValue
      candidateOfferVersionId
      offerCustomFieldId
    }
  }
`
export type UpsertCandidateOfferCustomFieldMutationFn = Apollo.MutationFunction<
  UpsertCandidateOfferCustomFieldMutation,
  UpsertCandidateOfferCustomFieldMutationVariables
>

/**
 * __useUpsertCandidateOfferCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateOfferCustomFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateOfferCustomFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateOfferCustomFieldMutation, { data, loading, error }] = useUpsertCandidateOfferCustomFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateOfferCustomFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidateOfferCustomFieldMutation,
    UpsertCandidateOfferCustomFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateOfferCustomFieldMutation, UpsertCandidateOfferCustomFieldMutationVariables>(
    UpsertCandidateOfferCustomFieldDocument,
    options,
  )
}
export type UpsertCandidateOfferCustomFieldMutationHookResult = ReturnType<
  typeof useUpsertCandidateOfferCustomFieldMutation
>
export type UpsertCandidateOfferCustomFieldMutationResult =
  Apollo.MutationResult<UpsertCandidateOfferCustomFieldMutation>
export type UpsertCandidateOfferCustomFieldMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateOfferCustomFieldMutation,
  UpsertCandidateOfferCustomFieldMutationVariables
>
export const UpsertCandidateOfferFileDocument = gql`
  mutation UpsertCandidateOfferFile($input: UpsertCandidateOfferFileInput!) {
    UpsertCandidateOfferFile(input: $input) {
      id
    }
  }
`
export type UpsertCandidateOfferFileMutationFn = Apollo.MutationFunction<
  UpsertCandidateOfferFileMutation,
  UpsertCandidateOfferFileMutationVariables
>

/**
 * __useUpsertCandidateOfferFileMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateOfferFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateOfferFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateOfferFileMutation, { data, loading, error }] = useUpsertCandidateOfferFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateOfferFileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertCandidateOfferFileMutation, UpsertCandidateOfferFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateOfferFileMutation, UpsertCandidateOfferFileMutationVariables>(
    UpsertCandidateOfferFileDocument,
    options,
  )
}
export type UpsertCandidateOfferFileMutationHookResult = ReturnType<typeof useUpsertCandidateOfferFileMutation>
export type UpsertCandidateOfferFileMutationResult = Apollo.MutationResult<UpsertCandidateOfferFileMutation>
export type UpsertCandidateOfferFileMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateOfferFileMutation,
  UpsertCandidateOfferFileMutationVariables
>
export const UpsertCandidateOfferVersionDocument = gql`
  mutation UpsertCandidateOfferVersion($input: UpsertCandidateOfferVersionInput!) {
    UpsertCandidateOfferVersion(input: $input) {
      id
      offerStatus
      CandidateOfferVersionSignature {
        id
        emailAddress
        name
        signedAt
        viewedAt
        createdAt
      }
    }
  }
`
export type UpsertCandidateOfferVersionMutationFn = Apollo.MutationFunction<
  UpsertCandidateOfferVersionMutation,
  UpsertCandidateOfferVersionMutationVariables
>

/**
 * __useUpsertCandidateOfferVersionMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateOfferVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateOfferVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateOfferVersionMutation, { data, loading, error }] = useUpsertCandidateOfferVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateOfferVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertCandidateOfferVersionMutation,
    UpsertCandidateOfferVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateOfferVersionMutation, UpsertCandidateOfferVersionMutationVariables>(
    UpsertCandidateOfferVersionDocument,
    options,
  )
}
export type UpsertCandidateOfferVersionMutationHookResult = ReturnType<typeof useUpsertCandidateOfferVersionMutation>
export type UpsertCandidateOfferVersionMutationResult = Apollo.MutationResult<UpsertCandidateOfferVersionMutation>
export type UpsertCandidateOfferVersionMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateOfferVersionMutation,
  UpsertCandidateOfferVersionMutationVariables
>
export const UpsertCandidateOfferDocument = gql`
  mutation UpsertCandidateOffer($input: UpsertCandidateOfferInput!) {
    UpsertCandidateOffer(input: $input) {
      id
      CandidateOfferVersion {
        ...CandidateOfferVersion
      }
    }
  }
  ${CandidateOfferVersionFragmentDoc}
`
export type UpsertCandidateOfferMutationFn = Apollo.MutationFunction<
  UpsertCandidateOfferMutation,
  UpsertCandidateOfferMutationVariables
>

/**
 * __useUpsertCandidateOfferMutation__
 *
 * To run a mutation, you first call `useUpsertCandidateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidateOfferMutation, { data, loading, error }] = useUpsertCandidateOfferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidateOfferMutation(
  baseOptions?: Apollo.MutationHookOptions<UpsertCandidateOfferMutation, UpsertCandidateOfferMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertCandidateOfferMutation, UpsertCandidateOfferMutationVariables>(
    UpsertCandidateOfferDocument,
    options,
  )
}
export type UpsertCandidateOfferMutationHookResult = ReturnType<typeof useUpsertCandidateOfferMutation>
export type UpsertCandidateOfferMutationResult = Apollo.MutationResult<UpsertCandidateOfferMutation>
export type UpsertCandidateOfferMutationOptions = Apollo.BaseMutationOptions<
  UpsertCandidateOfferMutation,
  UpsertCandidateOfferMutationVariables
>
export const GetPlaceDocument = gql`
  query GetPlace($placeId: String!) {
    GetPlace(placeId: $placeId) {
      addressComponents {
        longText
        shortText
        types
      }
      location {
        latitude
        longitude
      }
    }
  }
`

/**
 * __useGetPlaceQuery__
 *
 * To run a query within a React component, call `useGetPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useGetPlaceQuery(
  baseOptions: Apollo.QueryHookOptions<GetPlaceQuery, GetPlaceQueryVariables> &
    ({ variables: GetPlaceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPlaceQuery, GetPlaceQueryVariables>(GetPlaceDocument, options)
}
export function useGetPlaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceQuery, GetPlaceQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPlaceQuery, GetPlaceQueryVariables>(GetPlaceDocument, options)
}
export function useGetPlaceSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlaceQuery, GetPlaceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetPlaceQuery, GetPlaceQueryVariables>(GetPlaceDocument, options)
}
export type GetPlaceQueryHookResult = ReturnType<typeof useGetPlaceQuery>
export type GetPlaceLazyQueryHookResult = ReturnType<typeof useGetPlaceLazyQuery>
export type GetPlaceSuspenseQueryHookResult = ReturnType<typeof useGetPlaceSuspenseQuery>
export type GetPlaceQueryResult = Apollo.QueryResult<GetPlaceQuery, GetPlaceQueryVariables>
export const GetPlacesPredictionDocument = gql`
  query GetPlacesPrediction($input: String!) {
    GetPlacesPrediction(input: $input) {
      placeId
      description
    }
  }
`

/**
 * __useGetPlacesPredictionQuery__
 *
 * To run a query within a React component, call `useGetPlacesPredictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacesPredictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacesPredictionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPlacesPredictionQuery(
  baseOptions: Apollo.QueryHookOptions<GetPlacesPredictionQuery, GetPlacesPredictionQueryVariables> &
    ({ variables: GetPlacesPredictionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetPlacesPredictionQuery, GetPlacesPredictionQueryVariables>(
    GetPlacesPredictionDocument,
    options,
  )
}
export function useGetPlacesPredictionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPlacesPredictionQuery, GetPlacesPredictionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetPlacesPredictionQuery, GetPlacesPredictionQueryVariables>(
    GetPlacesPredictionDocument,
    options,
  )
}
export function useGetPlacesPredictionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPlacesPredictionQuery, GetPlacesPredictionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetPlacesPredictionQuery, GetPlacesPredictionQueryVariables>(
    GetPlacesPredictionDocument,
    options,
  )
}
export type GetPlacesPredictionQueryHookResult = ReturnType<typeof useGetPlacesPredictionQuery>
export type GetPlacesPredictionLazyQueryHookResult = ReturnType<typeof useGetPlacesPredictionLazyQuery>
export type GetPlacesPredictionSuspenseQueryHookResult = ReturnType<typeof useGetPlacesPredictionSuspenseQuery>
export type GetPlacesPredictionQueryResult = Apollo.QueryResult<
  GetPlacesPredictionQuery,
  GetPlacesPredictionQueryVariables
>
export const GetListReferralsDocument = gql`
  query GetListReferrals($input: FilterReferralsInput, $page: Int, $limit: Int) {
    ListReferrals(input: $input, page: $page, limit: $limit) {
      id
      firstName
      lastName
      CandidateProfile {
        id
        ProfileDetails {
          id
          CandidateSource {
            ...CandidateSource
            companyUser {
              id
              UserInvitation {
                ScalisUser {
                  ...ScalisUser
                }
              }
            }
          }
        }
        CandidateApplication {
          id
          createdAt
          updatedAt
          applicationStatus
          JobListing {
            id
            externalTitle
            acceptingCandidates
            publicListingId
          }
          TemplateStage {
            id
            name
            TemplateMilestone {
              id
              name
            }
          }
        }
      }
    }
  }
  ${CandidateSourceFragmentDoc}
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetListReferralsQuery__
 *
 * To run a query within a React component, call `useGetListReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListReferralsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetListReferralsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetListReferralsQuery, GetListReferralsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetListReferralsQuery, GetListReferralsQueryVariables>(GetListReferralsDocument, options)
}
export function useGetListReferralsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetListReferralsQuery, GetListReferralsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetListReferralsQuery, GetListReferralsQueryVariables>(GetListReferralsDocument, options)
}
export function useGetListReferralsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetListReferralsQuery, GetListReferralsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetListReferralsQuery, GetListReferralsQueryVariables>(
    GetListReferralsDocument,
    options,
  )
}
export type GetListReferralsQueryHookResult = ReturnType<typeof useGetListReferralsQuery>
export type GetListReferralsLazyQueryHookResult = ReturnType<typeof useGetListReferralsLazyQuery>
export type GetListReferralsSuspenseQueryHookResult = ReturnType<typeof useGetListReferralsSuspenseQuery>
export type GetListReferralsQueryResult = Apollo.QueryResult<GetListReferralsQuery, GetListReferralsQueryVariables>
export const GetReferralCountDocument = gql`
  query GetReferralCount($input: FilterReferralsInput) {
    CountReferrals(input: $input) {
      count
    }
  }
`

/**
 * __useGetReferralCountQuery__
 *
 * To run a query within a React component, call `useGetReferralCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReferralCountQuery(
  baseOptions?: Apollo.QueryHookOptions<GetReferralCountQuery, GetReferralCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReferralCountQuery, GetReferralCountQueryVariables>(GetReferralCountDocument, options)
}
export function useGetReferralCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReferralCountQuery, GetReferralCountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReferralCountQuery, GetReferralCountQueryVariables>(GetReferralCountDocument, options)
}
export function useGetReferralCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReferralCountQuery, GetReferralCountQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetReferralCountQuery, GetReferralCountQueryVariables>(
    GetReferralCountDocument,
    options,
  )
}
export type GetReferralCountQueryHookResult = ReturnType<typeof useGetReferralCountQuery>
export type GetReferralCountLazyQueryHookResult = ReturnType<typeof useGetReferralCountLazyQuery>
export type GetReferralCountSuspenseQueryHookResult = ReturnType<typeof useGetReferralCountSuspenseQuery>
export type GetReferralCountQueryResult = Apollo.QueryResult<GetReferralCountQuery, GetReferralCountQueryVariables>
export const GetReferralsStatsDocument = gql`
  query GetReferralsStats($input: FilterReferralsInput!) {
    ReferralsStats(input: $input) {
      totalReferrals
      myReferrals
      totalReferralsByMilestone
    }
  }
`

/**
 * __useGetReferralsStatsQuery__
 *
 * To run a query within a React component, call `useGetReferralsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralsStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReferralsStatsQuery(
  baseOptions: Apollo.QueryHookOptions<GetReferralsStatsQuery, GetReferralsStatsQueryVariables> &
    ({ variables: GetReferralsStatsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReferralsStatsQuery, GetReferralsStatsQueryVariables>(GetReferralsStatsDocument, options)
}
export function useGetReferralsStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReferralsStatsQuery, GetReferralsStatsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReferralsStatsQuery, GetReferralsStatsQueryVariables>(
    GetReferralsStatsDocument,
    options,
  )
}
export function useGetReferralsStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReferralsStatsQuery, GetReferralsStatsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetReferralsStatsQuery, GetReferralsStatsQueryVariables>(
    GetReferralsStatsDocument,
    options,
  )
}
export type GetReferralsStatsQueryHookResult = ReturnType<typeof useGetReferralsStatsQuery>
export type GetReferralsStatsLazyQueryHookResult = ReturnType<typeof useGetReferralsStatsLazyQuery>
export type GetReferralsStatsSuspenseQueryHookResult = ReturnType<typeof useGetReferralsStatsSuspenseQuery>
export type GetReferralsStatsQueryResult = Apollo.QueryResult<GetReferralsStatsQuery, GetReferralsStatsQueryVariables>
export const ReplaceTokensDocument = gql`
  query ReplaceTokens($input: ReplaceTokensInput!) {
    ReplaceTokens(input: $input) {
      result
    }
  }
`

/**
 * __useReplaceTokensQuery__
 *
 * To run a query within a React component, call `useReplaceTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useReplaceTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReplaceTokensQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceTokensQuery(
  baseOptions: Apollo.QueryHookOptions<ReplaceTokensQuery, ReplaceTokensQueryVariables> &
    ({ variables: ReplaceTokensQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ReplaceTokensQuery, ReplaceTokensQueryVariables>(ReplaceTokensDocument, options)
}
export function useReplaceTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReplaceTokensQuery, ReplaceTokensQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ReplaceTokensQuery, ReplaceTokensQueryVariables>(ReplaceTokensDocument, options)
}
export function useReplaceTokensSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReplaceTokensQuery, ReplaceTokensQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ReplaceTokensQuery, ReplaceTokensQueryVariables>(ReplaceTokensDocument, options)
}
export type ReplaceTokensQueryHookResult = ReturnType<typeof useReplaceTokensQuery>
export type ReplaceTokensLazyQueryHookResult = ReturnType<typeof useReplaceTokensLazyQuery>
export type ReplaceTokensSuspenseQueryHookResult = ReturnType<typeof useReplaceTokensSuspenseQuery>
export type ReplaceTokensQueryResult = Apollo.QueryResult<ReplaceTokensQuery, ReplaceTokensQueryVariables>
export const GetCoreReportCsvDocument = gql`
  query GetCoreReportCsv($id: Int!) {
    GetCoreReportCsv(id: $id) {
      base64
    }
  }
`

/**
 * __useGetCoreReportCsvQuery__
 *
 * To run a query within a React component, call `useGetCoreReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoreReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoreReportCsvQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCoreReportCsvQuery(
  baseOptions: Apollo.QueryHookOptions<GetCoreReportCsvQuery, GetCoreReportCsvQueryVariables> &
    ({ variables: GetCoreReportCsvQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCoreReportCsvQuery, GetCoreReportCsvQueryVariables>(GetCoreReportCsvDocument, options)
}
export function useGetCoreReportCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCoreReportCsvQuery, GetCoreReportCsvQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCoreReportCsvQuery, GetCoreReportCsvQueryVariables>(GetCoreReportCsvDocument, options)
}
export function useGetCoreReportCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCoreReportCsvQuery, GetCoreReportCsvQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCoreReportCsvQuery, GetCoreReportCsvQueryVariables>(
    GetCoreReportCsvDocument,
    options,
  )
}
export type GetCoreReportCsvQueryHookResult = ReturnType<typeof useGetCoreReportCsvQuery>
export type GetCoreReportCsvLazyQueryHookResult = ReturnType<typeof useGetCoreReportCsvLazyQuery>
export type GetCoreReportCsvSuspenseQueryHookResult = ReturnType<typeof useGetCoreReportCsvSuspenseQuery>
export type GetCoreReportCsvQueryResult = Apollo.QueryResult<GetCoreReportCsvQuery, GetCoreReportCsvQueryVariables>
export const GetReportDataDocument = gql`
  query GetReportData(
    $id: Int!
    $generateAvailableFilters: Boolean!
    $page: Int
    $limit: Int
    $filters: [FilterCriteriaInput!]
  ) {
    GetCoreReportData(
      id: $id
      page: $page
      limit: $limit
      generateAvailableFilters: $generateAvailableFilters
      filters: $filters
    ) {
      coreReportId
      data
      schema
      total
      availableFilters {
        column
        label
        type
        values
      }
    }
  }
`

/**
 * __useGetReportDataQuery__
 *
 * To run a query within a React component, call `useGetReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      generateAvailableFilters: // value for 'generateAvailableFilters'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetReportDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetReportDataQuery, GetReportDataQueryVariables> &
    ({ variables: GetReportDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReportDataQuery, GetReportDataQueryVariables>(GetReportDataDocument, options)
}
export function useGetReportDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReportDataQuery, GetReportDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReportDataQuery, GetReportDataQueryVariables>(GetReportDataDocument, options)
}
export function useGetReportDataSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportDataQuery, GetReportDataQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetReportDataQuery, GetReportDataQueryVariables>(GetReportDataDocument, options)
}
export type GetReportDataQueryHookResult = ReturnType<typeof useGetReportDataQuery>
export type GetReportDataLazyQueryHookResult = ReturnType<typeof useGetReportDataLazyQuery>
export type GetReportDataSuspenseQueryHookResult = ReturnType<typeof useGetReportDataSuspenseQuery>
export type GetReportDataQueryResult = Apollo.QueryResult<GetReportDataQuery, GetReportDataQueryVariables>
export const GetReportFiltersDocument = gql`
  query GetReportFilters($id: Int!, $generateAvailableFilters: Boolean!) {
    GetCoreReportData(id: $id, generateAvailableFilters: $generateAvailableFilters) {
      coreReportId
      availableFilters {
        column
        label
        type
        values
      }
    }
  }
`

/**
 * __useGetReportFiltersQuery__
 *
 * To run a query within a React component, call `useGetReportFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFiltersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      generateAvailableFilters: // value for 'generateAvailableFilters'
 *   },
 * });
 */
export function useGetReportFiltersQuery(
  baseOptions: Apollo.QueryHookOptions<GetReportFiltersQuery, GetReportFiltersQueryVariables> &
    ({ variables: GetReportFiltersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReportFiltersQuery, GetReportFiltersQueryVariables>(GetReportFiltersDocument, options)
}
export function useGetReportFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReportFiltersQuery, GetReportFiltersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReportFiltersQuery, GetReportFiltersQueryVariables>(GetReportFiltersDocument, options)
}
export function useGetReportFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReportFiltersQuery, GetReportFiltersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetReportFiltersQuery, GetReportFiltersQueryVariables>(
    GetReportFiltersDocument,
    options,
  )
}
export type GetReportFiltersQueryHookResult = ReturnType<typeof useGetReportFiltersQuery>
export type GetReportFiltersLazyQueryHookResult = ReturnType<typeof useGetReportFiltersLazyQuery>
export type GetReportFiltersSuspenseQueryHookResult = ReturnType<typeof useGetReportFiltersSuspenseQuery>
export type GetReportFiltersQueryResult = Apollo.QueryResult<GetReportFiltersQuery, GetReportFiltersQueryVariables>
export const GetReportDocument = gql`
  query GetReport($id: Int!) {
    GetCoreReport(id: $id) {
      ...CoreReport
    }
  }
  ${CoreReportFragmentDoc}
`

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReportQuery(
  baseOptions: Apollo.QueryHookOptions<GetReportQuery, GetReportQueryVariables> &
    ({ variables: GetReportQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options)
}
export function useGetReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReportQuery, GetReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options)
}
export function useGetReportSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportQuery, GetReportQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options)
}
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>
export type GetReportLazyQueryHookResult = ReturnType<typeof useGetReportLazyQuery>
export type GetReportSuspenseQueryHookResult = ReturnType<typeof useGetReportSuspenseQuery>
export type GetReportQueryResult = Apollo.QueryResult<GetReportQuery, GetReportQueryVariables>
export const GetReportsDocument = gql`
  query GetReports($tab: ReportFilterTabEnum!) {
    GetCoreReport(tab: $tab) {
      ...CoreReport
    }
    CountCoreReport(tab: $tab)
  }
  ${CoreReportFragmentDoc}
`

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useGetReportsQuery(
  baseOptions: Apollo.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables> &
    ({ variables: GetReportsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options)
}
export function useGetReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options)
}
export function useGetReportsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options)
}
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>
export type GetReportsSuspenseQueryHookResult = ReturnType<typeof useGetReportsSuspenseQuery>
export type GetReportsQueryResult = Apollo.QueryResult<GetReportsQuery, GetReportsQueryVariables>
export const GetScheduledReportDocument = gql`
  query GetScheduledReport($coreReportId: Int!, $id: Int) {
    GetScheduledReport(coreReportId: $coreReportId, id: $id) {
      ...ScheduledReport
    }
  }
  ${ScheduledReportFragmentDoc}
`

/**
 * __useGetScheduledReportQuery__
 *
 * To run a query within a React component, call `useGetScheduledReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledReportQuery({
 *   variables: {
 *      coreReportId: // value for 'coreReportId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScheduledReportQuery(
  baseOptions: Apollo.QueryHookOptions<GetScheduledReportQuery, GetScheduledReportQueryVariables> &
    ({ variables: GetScheduledReportQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScheduledReportQuery, GetScheduledReportQueryVariables>(GetScheduledReportDocument, options)
}
export function useGetScheduledReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledReportQuery, GetScheduledReportQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScheduledReportQuery, GetScheduledReportQueryVariables>(
    GetScheduledReportDocument,
    options,
  )
}
export function useGetScheduledReportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScheduledReportQuery, GetScheduledReportQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScheduledReportQuery, GetScheduledReportQueryVariables>(
    GetScheduledReportDocument,
    options,
  )
}
export type GetScheduledReportQueryHookResult = ReturnType<typeof useGetScheduledReportQuery>
export type GetScheduledReportLazyQueryHookResult = ReturnType<typeof useGetScheduledReportLazyQuery>
export type GetScheduledReportSuspenseQueryHookResult = ReturnType<typeof useGetScheduledReportSuspenseQuery>
export type GetScheduledReportQueryResult = Apollo.QueryResult<
  GetScheduledReportQuery,
  GetScheduledReportQueryVariables
>
export const GetSharedReportsDocument = gql`
  query GetSharedReports($coreReportId: Int) {
    GetSharedCoreReport(coreReportId: $coreReportId) {
      ...SharedCoreReport
    }
  }
  ${SharedCoreReportFragmentDoc}
`

/**
 * __useGetSharedReportsQuery__
 *
 * To run a query within a React component, call `useGetSharedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedReportsQuery({
 *   variables: {
 *      coreReportId: // value for 'coreReportId'
 *   },
 * });
 */
export function useGetSharedReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSharedReportsQuery, GetSharedReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSharedReportsQuery, GetSharedReportsQueryVariables>(GetSharedReportsDocument, options)
}
export function useGetSharedReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSharedReportsQuery, GetSharedReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSharedReportsQuery, GetSharedReportsQueryVariables>(GetSharedReportsDocument, options)
}
export function useGetSharedReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSharedReportsQuery, GetSharedReportsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSharedReportsQuery, GetSharedReportsQueryVariables>(
    GetSharedReportsDocument,
    options,
  )
}
export type GetSharedReportsQueryHookResult = ReturnType<typeof useGetSharedReportsQuery>
export type GetSharedReportsLazyQueryHookResult = ReturnType<typeof useGetSharedReportsLazyQuery>
export type GetSharedReportsSuspenseQueryHookResult = ReturnType<typeof useGetSharedReportsSuspenseQuery>
export type GetSharedReportsQueryResult = Apollo.QueryResult<GetSharedReportsQuery, GetSharedReportsQueryVariables>
export const GetRequisitionAndOpeningsIdDocument = gql`
  query GetRequisitionAndOpeningsId {
    GetRequisitions {
      id
      extRequisitionId
      isIncomplete
      jobName
      JobOpening {
        id
        extOpeningId
        jobRequisitionId
      }
    }
  }
`

/**
 * __useGetRequisitionAndOpeningsIdQuery__
 *
 * To run a query within a React component, call `useGetRequisitionAndOpeningsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionAndOpeningsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionAndOpeningsIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequisitionAndOpeningsIdQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRequisitionAndOpeningsIdQuery, GetRequisitionAndOpeningsIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionAndOpeningsIdQuery, GetRequisitionAndOpeningsIdQueryVariables>(
    GetRequisitionAndOpeningsIdDocument,
    options,
  )
}
export function useGetRequisitionAndOpeningsIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRequisitionAndOpeningsIdQuery,
    GetRequisitionAndOpeningsIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionAndOpeningsIdQuery, GetRequisitionAndOpeningsIdQueryVariables>(
    GetRequisitionAndOpeningsIdDocument,
    options,
  )
}
export function useGetRequisitionAndOpeningsIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionAndOpeningsIdQuery, GetRequisitionAndOpeningsIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionAndOpeningsIdQuery, GetRequisitionAndOpeningsIdQueryVariables>(
    GetRequisitionAndOpeningsIdDocument,
    options,
  )
}
export type GetRequisitionAndOpeningsIdQueryHookResult = ReturnType<typeof useGetRequisitionAndOpeningsIdQuery>
export type GetRequisitionAndOpeningsIdLazyQueryHookResult = ReturnType<typeof useGetRequisitionAndOpeningsIdLazyQuery>
export type GetRequisitionAndOpeningsIdSuspenseQueryHookResult = ReturnType<
  typeof useGetRequisitionAndOpeningsIdSuspenseQuery
>
export type GetRequisitionAndOpeningsIdQueryResult = Apollo.QueryResult<
  GetRequisitionAndOpeningsIdQuery,
  GetRequisitionAndOpeningsIdQueryVariables
>
export const GetRequisitionExtIdDocument = gql`
  query GetRequisitionExtId {
    GetRequisitionExtId {
      id
      companyId
      extId
    }
  }
`

/**
 * __useGetRequisitionExtIdQuery__
 *
 * To run a query within a React component, call `useGetRequisitionExtIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionExtIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionExtIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequisitionExtIdQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRequisitionExtIdQuery, GetRequisitionExtIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionExtIdQuery, GetRequisitionExtIdQueryVariables>(
    GetRequisitionExtIdDocument,
    options,
  )
}
export function useGetRequisitionExtIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionExtIdQuery, GetRequisitionExtIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionExtIdQuery, GetRequisitionExtIdQueryVariables>(
    GetRequisitionExtIdDocument,
    options,
  )
}
export function useGetRequisitionExtIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionExtIdQuery, GetRequisitionExtIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionExtIdQuery, GetRequisitionExtIdQueryVariables>(
    GetRequisitionExtIdDocument,
    options,
  )
}
export type GetRequisitionExtIdQueryHookResult = ReturnType<typeof useGetRequisitionExtIdQuery>
export type GetRequisitionExtIdLazyQueryHookResult = ReturnType<typeof useGetRequisitionExtIdLazyQuery>
export type GetRequisitionExtIdSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionExtIdSuspenseQuery>
export type GetRequisitionExtIdQueryResult = Apollo.QueryResult<
  GetRequisitionExtIdQuery,
  GetRequisitionExtIdQueryVariables
>
export const GetRequisitionJobDetailsDocument = gql`
  query GetRequisitionJobDetails($id: Int!) {
    GetRequisition(id: $id) {
      id
      jobStatus
      openedAt
      jobName
      extRequisitionId
      jobType
      jobLevel
      travelType
      payType
      minPay
      maxPay
      additionalComp
      benefits
      isIncomplete
      CompanyDepartment {
        id
        departmentName
      }
      CompanyOffice {
        id
        officeName
      }
      JobOpening {
        ...JobOpening
        CandidateProfile {
          id
          ScalisUser {
            firstName
            lastName
          }
        }
      }
      CustomJobRequisitionFieldValue {
        ...CustomJobRequisitionFieldValue
      }
      createdAt
      updatedAt
    }
  }
  ${JobOpeningFragmentDoc}
  ${CustomJobRequisitionFieldValueFragmentDoc}
`

/**
 * __useGetRequisitionJobDetailsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionJobDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionJobDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionJobDetailsQuery, GetRequisitionJobDetailsQueryVariables> &
    ({ variables: GetRequisitionJobDetailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionJobDetailsQuery, GetRequisitionJobDetailsQueryVariables>(
    GetRequisitionJobDetailsDocument,
    options,
  )
}
export function useGetRequisitionJobDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionJobDetailsQuery, GetRequisitionJobDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionJobDetailsQuery, GetRequisitionJobDetailsQueryVariables>(
    GetRequisitionJobDetailsDocument,
    options,
  )
}
export function useGetRequisitionJobDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionJobDetailsQuery, GetRequisitionJobDetailsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionJobDetailsQuery, GetRequisitionJobDetailsQueryVariables>(
    GetRequisitionJobDetailsDocument,
    options,
  )
}
export type GetRequisitionJobDetailsQueryHookResult = ReturnType<typeof useGetRequisitionJobDetailsQuery>
export type GetRequisitionJobDetailsLazyQueryHookResult = ReturnType<typeof useGetRequisitionJobDetailsLazyQuery>
export type GetRequisitionJobDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetRequisitionJobDetailsSuspenseQuery
>
export type GetRequisitionJobDetailsQueryResult = Apollo.QueryResult<
  GetRequisitionJobDetailsQuery,
  GetRequisitionJobDetailsQueryVariables
>
export const GetRequisitionListingsDocument = gql`
  query GetRequisitionListings($id: Int!) {
    GetRequisition(id: $id) {
      id
      companyId
      Company {
        id
        CompanyInfo {
          ...CompanyInfoFragment
        }
      }
      jobName
      jobType
      jobLevel
      jobStatus
      openedAt
      isIncomplete
      payType
      minPay
      maxPay
      benefits
      RequisitionJobDescription {
        ...RequisitionJobDescriptionFragment
      }
      RequisitionSkills {
        id
        level
        yearsOfExp
        displayName
        skill {
          ...SkillFragment
        }
      }
      JobListing {
        id
        publicListingId
        jobRequisitionId
        listingTitle
        externalTitle
        workplaceType
        publicDescription
        displayPayOnListing
        industry
        subIndustry
        companyDefault
        stateAndOrCountry
        internalMatchingDescription
        searchPublicDescription
        searchInternalMatchingDescription
        postedAt
        acceptingCandidates
        stage
        CandidateApplication {
          ...CandidateApplication
        }
        Address {
          ...AddressFragment
        }
        JobListingScreeningQuestion {
          id
          jobListingId
          displaySequenceNumber
          screeningQuestionId
          createdAt
          updatedAt
          ScreeningQuestion {
            ...ScreeningQuestionFragment
          }
        }
        deletedAt
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
  ${CompanyInfoFragmentFragmentDoc}
  ${RequisitionJobDescriptionFragmentFragmentDoc}
  ${SkillFragmentFragmentDoc}
  ${CandidateApplicationFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${ScreeningQuestionFragmentFragmentDoc}
`

/**
 * __useGetRequisitionListingsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionListingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionListingsQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionListingsQuery, GetRequisitionListingsQueryVariables> &
    ({ variables: GetRequisitionListingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionListingsQuery, GetRequisitionListingsQueryVariables>(
    GetRequisitionListingsDocument,
    options,
  )
}
export function useGetRequisitionListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionListingsQuery, GetRequisitionListingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionListingsQuery, GetRequisitionListingsQueryVariables>(
    GetRequisitionListingsDocument,
    options,
  )
}
export function useGetRequisitionListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionListingsQuery, GetRequisitionListingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionListingsQuery, GetRequisitionListingsQueryVariables>(
    GetRequisitionListingsDocument,
    options,
  )
}
export type GetRequisitionListingsQueryHookResult = ReturnType<typeof useGetRequisitionListingsQuery>
export type GetRequisitionListingsLazyQueryHookResult = ReturnType<typeof useGetRequisitionListingsLazyQuery>
export type GetRequisitionListingsSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionListingsSuspenseQuery>
export type GetRequisitionListingsQueryResult = Apollo.QueryResult<
  GetRequisitionListingsQuery,
  GetRequisitionListingsQueryVariables
>
export const GetRequisitionPipelineDocument = gql`
  query GetRequisitionPipeline($id: Int!) {
    GetRequisition(id: $id) {
      __typename
      id
      companyId
      jobName
      extRequisitionId
      isIncomplete
      JobListing {
        __typename
        id
        listingTitle
        acceptingCandidates
      }
      JobPipeline {
        __typename
        id
        title
        TemplatePipeline {
          __typename
          id
          name
          ghostPipeline
          TemplateMilestones {
            ...TemplateMilestoneKanban
          }
        }
      }
    }
  }
  ${TemplateMilestoneKanbanFragmentDoc}
`

/**
 * __useGetRequisitionPipelineQuery__
 *
 * To run a query within a React component, call `useGetRequisitionPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionPipelineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionPipelineQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionPipelineQuery, GetRequisitionPipelineQueryVariables> &
    ({ variables: GetRequisitionPipelineQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionPipelineQuery, GetRequisitionPipelineQueryVariables>(
    GetRequisitionPipelineDocument,
    options,
  )
}
export function useGetRequisitionPipelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionPipelineQuery, GetRequisitionPipelineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionPipelineQuery, GetRequisitionPipelineQueryVariables>(
    GetRequisitionPipelineDocument,
    options,
  )
}
export function useGetRequisitionPipelineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionPipelineQuery, GetRequisitionPipelineQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionPipelineQuery, GetRequisitionPipelineQueryVariables>(
    GetRequisitionPipelineDocument,
    options,
  )
}
export type GetRequisitionPipelineQueryHookResult = ReturnType<typeof useGetRequisitionPipelineQuery>
export type GetRequisitionPipelineLazyQueryHookResult = ReturnType<typeof useGetRequisitionPipelineLazyQuery>
export type GetRequisitionPipelineSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionPipelineSuspenseQuery>
export type GetRequisitionPipelineQueryResult = Apollo.QueryResult<
  GetRequisitionPipelineQuery,
  GetRequisitionPipelineQueryVariables
>
export const GetRequisitionPipelinesDocument = gql`
  query GetRequisitionPipelines($id: Int!) {
    GetRequisition(id: $id) {
      id
      openedAt
      isIncomplete
      JobPipeline {
        id
        title
        JobListingJobPipeline {
          id
        }
        TemplatePipeline {
          id
          name
          CompanyDepartment {
            id
            departmentName
          }
          ghostPipeline
          pipelinedUsed
          archived
          createdAt
          updatedAt
          deletedAt
          TemplateMilestones {
            id
            name
            rankOrder
            archived
            createdAt
            updatedAt
            TemplateStage {
              id
              visibility
              name
              templateMilestoneId
              rankOrder
              archived
              createdAt
              updatedAt
              CandidateApplicationByStage(requisitionId: $id) {
                id
              }
            }
          }
        }
      }
      createdAt
      updatedAt
    }
  }
`

/**
 * __useGetRequisitionPipelinesQuery__
 *
 * To run a query within a React component, call `useGetRequisitionPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionPipelinesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionPipelinesQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionPipelinesQuery, GetRequisitionPipelinesQueryVariables> &
    ({ variables: GetRequisitionPipelinesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionPipelinesQuery, GetRequisitionPipelinesQueryVariables>(
    GetRequisitionPipelinesDocument,
    options,
  )
}
export function useGetRequisitionPipelinesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionPipelinesQuery, GetRequisitionPipelinesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionPipelinesQuery, GetRequisitionPipelinesQueryVariables>(
    GetRequisitionPipelinesDocument,
    options,
  )
}
export function useGetRequisitionPipelinesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionPipelinesQuery, GetRequisitionPipelinesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionPipelinesQuery, GetRequisitionPipelinesQueryVariables>(
    GetRequisitionPipelinesDocument,
    options,
  )
}
export type GetRequisitionPipelinesQueryHookResult = ReturnType<typeof useGetRequisitionPipelinesQuery>
export type GetRequisitionPipelinesLazyQueryHookResult = ReturnType<typeof useGetRequisitionPipelinesLazyQuery>
export type GetRequisitionPipelinesSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionPipelinesSuspenseQuery>
export type GetRequisitionPipelinesQueryResult = Apollo.QueryResult<
  GetRequisitionPipelinesQuery,
  GetRequisitionPipelinesQueryVariables
>
export const GetRequisitionSkillsAndPreferencesDocument = gql`
  query GetRequisitionSkillsAndPreferences($id: Int!) {
    GetRequisition(id: $id) {
      id
      openedAt
      locationDistancePref
      educationLevelPref
      yearsOfExperiencePref
      nonTraditionalPref
      veteranPref
      diverseHirePref
      collegeGradPref
      isIncomplete
      RequisitionSkills {
        id
        requisitionId
        skillId
        sequenceNumber
        level
        yearsOfExp
        displayName
        createdAt
        updatedAt
        skill {
          id
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`

/**
 * __useGetRequisitionSkillsAndPreferencesQuery__
 *
 * To run a query within a React component, call `useGetRequisitionSkillsAndPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionSkillsAndPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionSkillsAndPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionSkillsAndPreferencesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRequisitionSkillsAndPreferencesQuery,
    GetRequisitionSkillsAndPreferencesQueryVariables
  > &
    ({ variables: GetRequisitionSkillsAndPreferencesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionSkillsAndPreferencesQuery, GetRequisitionSkillsAndPreferencesQueryVariables>(
    GetRequisitionSkillsAndPreferencesDocument,
    options,
  )
}
export function useGetRequisitionSkillsAndPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRequisitionSkillsAndPreferencesQuery,
    GetRequisitionSkillsAndPreferencesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionSkillsAndPreferencesQuery, GetRequisitionSkillsAndPreferencesQueryVariables>(
    GetRequisitionSkillsAndPreferencesDocument,
    options,
  )
}
export function useGetRequisitionSkillsAndPreferencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRequisitionSkillsAndPreferencesQuery,
        GetRequisitionSkillsAndPreferencesQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetRequisitionSkillsAndPreferencesQuery,
    GetRequisitionSkillsAndPreferencesQueryVariables
  >(GetRequisitionSkillsAndPreferencesDocument, options)
}
export type GetRequisitionSkillsAndPreferencesQueryHookResult = ReturnType<
  typeof useGetRequisitionSkillsAndPreferencesQuery
>
export type GetRequisitionSkillsAndPreferencesLazyQueryHookResult = ReturnType<
  typeof useGetRequisitionSkillsAndPreferencesLazyQuery
>
export type GetRequisitionSkillsAndPreferencesSuspenseQueryHookResult = ReturnType<
  typeof useGetRequisitionSkillsAndPreferencesSuspenseQuery
>
export type GetRequisitionSkillsAndPreferencesQueryResult = Apollo.QueryResult<
  GetRequisitionSkillsAndPreferencesQuery,
  GetRequisitionSkillsAndPreferencesQueryVariables
>
export const GetRequisitionDocument = gql`
  query GetRequisition($id: Int!) {
    GetRequisition(id: $id) {
      id
      companyUserId
      Company {
        id
        CompanyInfo {
          id
          companyName
          logo
        }
      }
      jobStatus
      jobName
      extRequisitionId
      jobType
      jobLevel
      travelType
      payType
      minPay
      maxPay
      additionalComp
      benefits
      locationDistancePref
      educationLevelPref
      yearsOfExperiencePref
      nonTraditionalPref
      veteranPref
      diverseHirePref
      collegeGradPref
      isIncomplete
      CompanyDepartment {
        id
        departmentName
      }
      CompanyOffice {
        id
        officeName
      }
      JobOpening {
        ...JobOpening
        CandidateProfile {
          id
          CandidateApplicationRating {
            id
          }
          ScalisUser {
            ...ScalisUser
          }
          CandidateCollaborator {
            id
          }
          ProfileDetails {
            id
            CandidateMedalistDesignation {
              id
            }
            CandidateProfileLocation {
              id
            }
            CandidateSource {
              id
            }
          }
          CandidateApplicationRating {
            id
            score
          }
        }
      }
      RequisitionJobDescription {
        id
        description
      }
      RequisitionSkills {
        id
        requisitionId
        skillId
        sequenceNumber
        level
        yearsOfExp
        displayName
        createdAt
        updatedAt
        skill {
          id
          name
        }
      }
      CustomJobRequisitionFieldValue {
        ...CustomJobRequisitionFieldValue
      }
      JobListing {
        id
        publicListingId
        jobRequisitionId
        listingTitle
        externalTitle
        workplaceType
        publicDescription
        displayPayOnListing
        industry
        subIndustry
        companyDefault
        stateAndOrCountry
        internalMatchingDescription
        searchPublicDescription
        searchInternalMatchingDescription
        postedAt
        acceptingCandidates
        stage
        Address {
          id
          addressLine1
          addressLine2
          city
          state
          country
          postalCode
          timeZone
        }
        JobListingScreeningQuestion {
          id
          jobListingId
          displaySequenceNumber
          screeningQuestionId
          active
          hasApplications
          createdAt
          updatedAt
          ScreeningQuestion {
            id
            isTemplateQuestion
            questionTitle
            questionDesc
            questionType
            minVal
            maxVal
            valStatus
            ansOptions
            isRejectionQuestion
            rejectMessage
            templateMessageId
            preferredAnswer
            isGlobalQuestion
            companyId
            companyUserId
            createdAt
            updatedAt
          }
        }
        CandidateApplication {
          id
          applicationType
          applicationStatus
          applicationTimestamp
          interviewScheduling
          TemplateStage {
            id
            TemplateMilestone {
              id
              name
            }
          }
          CandidateProfile {
            id
            CandidateApplicationRating {
              id
            }
            ScalisUser {
              ...ScalisUser
            }
            CandidateApplication {
              id
            }
            CandidateCollaborator {
              id
            }
            ProfileDetails {
              id
              CandidateMedalistDesignation {
                id
              }
              CandidateProfileLocation {
                id
              }
              CandidateSource {
                id
              }
            }
            CandidateApplicationRating {
              id
              score
            }
          }
          CandidateApplicationRating {
            id
            score
          }
        }
        deletedAt
        createdAt
        updatedAt
      }
      HiringTeamMember {
        id
        role {
          id
          name
        }
        CompanyUser {
          id
          companyId
          companyUserStatus
          profileImage
          UserInvitation {
            id
            email
            invitedAs
            invitationStatus
            ScalisUser {
              ...ScalisUser
            }
          }
        }
      }
      primaryContact
      createdAt
      updatedAt
    }
  }
  ${JobOpeningFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${CustomJobRequisitionFieldValueFragmentDoc}
`

/**
 * __useGetRequisitionQuery__
 *
 * To run a query within a React component, call `useGetRequisitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables> &
    ({ variables: GetRequisitionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionQuery, GetRequisitionQueryVariables>(GetRequisitionDocument, options)
}
export function useGetRequisitionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionQuery, GetRequisitionQueryVariables>(GetRequisitionDocument, options)
}
export function useGetRequisitionSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionQuery, GetRequisitionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionQuery, GetRequisitionQueryVariables>(GetRequisitionDocument, options)
}
export type GetRequisitionQueryHookResult = ReturnType<typeof useGetRequisitionQuery>
export type GetRequisitionLazyQueryHookResult = ReturnType<typeof useGetRequisitionLazyQuery>
export type GetRequisitionSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionSuspenseQuery>
export type GetRequisitionQueryResult = Apollo.QueryResult<GetRequisitionQuery, GetRequisitionQueryVariables>
export const GetRequisitionsAndListingsDocument = gql`
  query GetRequisitionsAndListings {
    GetRequisitions {
      id
      jobName
      extRequisitionId
      JobListing {
        ...JobListingFragment
      }
    }
  }
  ${JobListingFragmentFragmentDoc}
`

/**
 * __useGetRequisitionsAndListingsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionsAndListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionsAndListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionsAndListingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequisitionsAndListingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRequisitionsAndListingsQuery, GetRequisitionsAndListingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionsAndListingsQuery, GetRequisitionsAndListingsQueryVariables>(
    GetRequisitionsAndListingsDocument,
    options,
  )
}
export function useGetRequisitionsAndListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionsAndListingsQuery, GetRequisitionsAndListingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionsAndListingsQuery, GetRequisitionsAndListingsQueryVariables>(
    GetRequisitionsAndListingsDocument,
    options,
  )
}
export function useGetRequisitionsAndListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionsAndListingsQuery, GetRequisitionsAndListingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionsAndListingsQuery, GetRequisitionsAndListingsQueryVariables>(
    GetRequisitionsAndListingsDocument,
    options,
  )
}
export type GetRequisitionsAndListingsQueryHookResult = ReturnType<typeof useGetRequisitionsAndListingsQuery>
export type GetRequisitionsAndListingsLazyQueryHookResult = ReturnType<typeof useGetRequisitionsAndListingsLazyQuery>
export type GetRequisitionsAndListingsSuspenseQueryHookResult = ReturnType<
  typeof useGetRequisitionsAndListingsSuspenseQuery
>
export type GetRequisitionsAndListingsQueryResult = Apollo.QueryResult<
  GetRequisitionsAndListingsQuery,
  GetRequisitionsAndListingsQueryVariables
>
export const GetRequisitionsOptionsDocument = gql`
  query GetRequisitionsOptions {
    GetRequisitions {
      id
      jobName
      extRequisitionId
    }
  }
`

/**
 * __useGetRequisitionsOptionsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequisitionsOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRequisitionsOptionsQuery, GetRequisitionsOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionsOptionsQuery, GetRequisitionsOptionsQueryVariables>(
    GetRequisitionsOptionsDocument,
    options,
  )
}
export function useGetRequisitionsOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionsOptionsQuery, GetRequisitionsOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionsOptionsQuery, GetRequisitionsOptionsQueryVariables>(
    GetRequisitionsOptionsDocument,
    options,
  )
}
export function useGetRequisitionsOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionsOptionsQuery, GetRequisitionsOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionsOptionsQuery, GetRequisitionsOptionsQueryVariables>(
    GetRequisitionsOptionsDocument,
    options,
  )
}
export type GetRequisitionsOptionsQueryHookResult = ReturnType<typeof useGetRequisitionsOptionsQuery>
export type GetRequisitionsOptionsLazyQueryHookResult = ReturnType<typeof useGetRequisitionsOptionsLazyQuery>
export type GetRequisitionsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionsOptionsSuspenseQuery>
export type GetRequisitionsOptionsQueryResult = Apollo.QueryResult<
  GetRequisitionsOptionsQuery,
  GetRequisitionsOptionsQueryVariables
>
export const GetRequisitionsDocument = gql`
  query GetRequisitions(
    $id: Int
    $companyId: Int
    $companyUserId: Int
    $companyDepartmentId: Int
    $companyOfficeId: Int
    $createdAt: DateTime
    $lastActivity: RequisitionLastActivity
    $status: JobStatusEnum
    $pipeline: String
    $page: Int
    $limit: Int
  ) {
    GetRequisitions(
      id: $id
      companyId: $companyId
      companyUserId: $companyUserId
      companyDepartmentId: $companyDepartmentId
      companyOfficeId: $companyOfficeId
      createdAt: $createdAt
      lastActivity: $lastActivity
      status: $status
      pipeline: $pipeline
      page: $page
      limit: $limit
    ) {
      id
      jobStatus
      jobName
      extRequisitionId
      jobType
      jobLevel
      travelType
      payType
      minPay
      maxPay
      additionalComp
      benefits
      locationDistancePref
      educationLevelPref
      yearsOfExperiencePref
      nonTraditionalPref
      veteranPref
      diverseHirePref
      collegeGradPref
      isIncomplete
      CompanyDepartment {
        id
        departmentName
      }
      CompanyOffice {
        id
        officeName
      }
      JobOpening {
        id
        openingStatus
        extOpeningId
        targetHireDate
        openingType
        closedReason
        closedDate
        filledDate
        startDate
      }
      RequisitionJobDescription {
        id
        description
      }
      RequisitionSkills {
        ...RequisitionSkillsFragment
      }
      JobListing {
        id
        publicListingId
        jobRequisitionId
        listingTitle
        externalTitle
        workplaceType
        publicDescription
        displayPayOnListing
        industry
        subIndustry
        companyDefault
        stateAndOrCountry
        internalMatchingDescription
        searchPublicDescription
        searchInternalMatchingDescription
        postedAt
        acceptingCandidates
        stage
        Address {
          id
          addressLine1
          addressLine2
          city
          state
          country
          postalCode
          timeZone
        }
        JobListingScreeningQuestion {
          id
          jobListingId
          displaySequenceNumber
          screeningQuestionId
          createdAt
          updatedAt
          ScreeningQuestion {
            id
            isTemplateQuestion
            questionTitle
            questionDesc
            questionType
            minVal
            maxVal
            valStatus
            ansOptions
            isRejectionQuestion
            rejectMessage
            templateMessageId
            preferredAnswer
            isGlobalQuestion
            companyId
            companyUserId
            createdAt
            updatedAt
          }
        }
        CandidateApplication {
          id
          applicationStatus
          TemplateStage {
            id
            templateMilestoneId
          }
        }
        deletedAt
        createdAt
        updatedAt
      }
      JobPipeline {
        id
        title
        TemplatePipeline {
          ...TemplatePipelineFragment
          TemplateMilestones {
            ...TemplateMilestone
            TemplateStage {
              ...TemplateStage
            }
          }
        }
      }
      HiringTeamMember {
        id
        role {
          id
          name
        }
        CompanyUser {
          ...CompanyUserFragment
          UserInvitation {
            ...UserInvitationFragment
            ScalisUser {
              ...ScalisUser
            }
          }
        }
      }
      createdAt
      updatedAt
    }
  }
  ${RequisitionSkillsFragmentFragmentDoc}
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
  ${CompanyUserFragmentFragmentDoc}
  ${UserInvitationFragmentFragmentDoc}
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetRequisitionsQuery__
 *
 * To run a query within a React component, call `useGetRequisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      companyUserId: // value for 'companyUserId'
 *      companyDepartmentId: // value for 'companyDepartmentId'
 *      companyOfficeId: // value for 'companyOfficeId'
 *      createdAt: // value for 'createdAt'
 *      lastActivity: // value for 'lastActivity'
 *      status: // value for 'status'
 *      pipeline: // value for 'pipeline'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRequisitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionsQuery, GetRequisitionsQueryVariables>(GetRequisitionsDocument, options)
}
export function useGetRequisitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionsQuery, GetRequisitionsQueryVariables>(GetRequisitionsDocument, options)
}
export function useGetRequisitionsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequisitionsQuery, GetRequisitionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionsQuery, GetRequisitionsQueryVariables>(GetRequisitionsDocument, options)
}
export type GetRequisitionsQueryHookResult = ReturnType<typeof useGetRequisitionsQuery>
export type GetRequisitionsLazyQueryHookResult = ReturnType<typeof useGetRequisitionsLazyQuery>
export type GetRequisitionsSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionsSuspenseQuery>
export type GetRequisitionsQueryResult = Apollo.QueryResult<GetRequisitionsQuery, GetRequisitionsQueryVariables>
export const GetSideBarRequisitionsDocument = gql`
  query GetSideBarRequisitions($status: JobStatusEnum) {
    GetRequisitions(status: $status) {
      id
      jobStatus
      jobName
      extRequisitionId
      isIncomplete
      JobPipeline {
        id
        title
        TemplatePipeline {
          id
          deletedAt
          TemplateMilestones {
            id
            name
            rankOrder
            TemplateStage {
              id
              name
              rankOrder
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetSideBarRequisitionsQuery__
 *
 * To run a query within a React component, call `useGetSideBarRequisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSideBarRequisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSideBarRequisitionsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetSideBarRequisitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSideBarRequisitionsQuery, GetSideBarRequisitionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSideBarRequisitionsQuery, GetSideBarRequisitionsQueryVariables>(
    GetSideBarRequisitionsDocument,
    options,
  )
}
export function useGetSideBarRequisitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSideBarRequisitionsQuery, GetSideBarRequisitionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSideBarRequisitionsQuery, GetSideBarRequisitionsQueryVariables>(
    GetSideBarRequisitionsDocument,
    options,
  )
}
export function useGetSideBarRequisitionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSideBarRequisitionsQuery, GetSideBarRequisitionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSideBarRequisitionsQuery, GetSideBarRequisitionsQueryVariables>(
    GetSideBarRequisitionsDocument,
    options,
  )
}
export type GetSideBarRequisitionsQueryHookResult = ReturnType<typeof useGetSideBarRequisitionsQuery>
export type GetSideBarRequisitionsLazyQueryHookResult = ReturnType<typeof useGetSideBarRequisitionsLazyQuery>
export type GetSideBarRequisitionsSuspenseQueryHookResult = ReturnType<typeof useGetSideBarRequisitionsSuspenseQuery>
export type GetSideBarRequisitionsQueryResult = Apollo.QueryResult<
  GetSideBarRequisitionsQuery,
  GetSideBarRequisitionsQueryVariables
>
export const GetRequisitionJobDescriptionByRequisitionDocument = gql`
  query GetRequisitionJobDescriptionByRequisition($requisitionId: Int!) {
    GetRequisitionJobDescriptionByRequisition(requisitionId: $requisitionId) {
      id
      requisitionId
      description
      createdAt
      updatedAt
      requisition {
        id
        openedAt
      }
    }
  }
`

/**
 * __useGetRequisitionJobDescriptionByRequisitionQuery__
 *
 * To run a query within a React component, call `useGetRequisitionJobDescriptionByRequisitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionJobDescriptionByRequisitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionJobDescriptionByRequisitionQuery({
 *   variables: {
 *      requisitionId: // value for 'requisitionId'
 *   },
 * });
 */
export function useGetRequisitionJobDescriptionByRequisitionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRequisitionJobDescriptionByRequisitionQuery,
    GetRequisitionJobDescriptionByRequisitionQueryVariables
  > &
    ({ variables: GetRequisitionJobDescriptionByRequisitionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetRequisitionJobDescriptionByRequisitionQuery,
    GetRequisitionJobDescriptionByRequisitionQueryVariables
  >(GetRequisitionJobDescriptionByRequisitionDocument, options)
}
export function useGetRequisitionJobDescriptionByRequisitionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRequisitionJobDescriptionByRequisitionQuery,
    GetRequisitionJobDescriptionByRequisitionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetRequisitionJobDescriptionByRequisitionQuery,
    GetRequisitionJobDescriptionByRequisitionQueryVariables
  >(GetRequisitionJobDescriptionByRequisitionDocument, options)
}
export function useGetRequisitionJobDescriptionByRequisitionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetRequisitionJobDescriptionByRequisitionQuery,
        GetRequisitionJobDescriptionByRequisitionQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetRequisitionJobDescriptionByRequisitionQuery,
    GetRequisitionJobDescriptionByRequisitionQueryVariables
  >(GetRequisitionJobDescriptionByRequisitionDocument, options)
}
export type GetRequisitionJobDescriptionByRequisitionQueryHookResult = ReturnType<
  typeof useGetRequisitionJobDescriptionByRequisitionQuery
>
export type GetRequisitionJobDescriptionByRequisitionLazyQueryHookResult = ReturnType<
  typeof useGetRequisitionJobDescriptionByRequisitionLazyQuery
>
export type GetRequisitionJobDescriptionByRequisitionSuspenseQueryHookResult = ReturnType<
  typeof useGetRequisitionJobDescriptionByRequisitionSuspenseQuery
>
export type GetRequisitionJobDescriptionByRequisitionQueryResult = Apollo.QueryResult<
  GetRequisitionJobDescriptionByRequisitionQuery,
  GetRequisitionJobDescriptionByRequisitionQueryVariables
>
export const GetRequisitionJobDescriptionDocument = gql`
  query GetRequisitionJobDescription($requisitionId: Int!, $id: Int) {
    GetRequisitionJobDescription(requisitionId: $requisitionId, id: $id) {
      ...RequisitionJobDescriptionFragment
      createdAt
      updatedAt
      hiringTeamMember {
        ...HiringTeamMemberFragment
        createdAt
        updatedAt
        role {
          ...RoleFragment
        }
      }
      candidateCollaborator {
        ...CandidateCollaboratorFragment
        createdAt
        updatedAt
        role {
          ...RoleFragment
        }
      }
      stageCollaborator {
        ...StageCollaboratorFragment
        createdAt
        updatedAt
        role {
          ...RoleFragment
        }
      }
    }
  }
  ${RequisitionJobDescriptionFragmentFragmentDoc}
  ${HiringTeamMemberFragmentFragmentDoc}
  ${RoleFragmentFragmentDoc}
  ${CandidateCollaboratorFragmentFragmentDoc}
  ${StageCollaboratorFragmentFragmentDoc}
`

/**
 * __useGetRequisitionJobDescriptionQuery__
 *
 * To run a query within a React component, call `useGetRequisitionJobDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionJobDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionJobDescriptionQuery({
 *   variables: {
 *      requisitionId: // value for 'requisitionId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionJobDescriptionQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionJobDescriptionQuery, GetRequisitionJobDescriptionQueryVariables> &
    ({ variables: GetRequisitionJobDescriptionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionJobDescriptionQuery, GetRequisitionJobDescriptionQueryVariables>(
    GetRequisitionJobDescriptionDocument,
    options,
  )
}
export function useGetRequisitionJobDescriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRequisitionJobDescriptionQuery,
    GetRequisitionJobDescriptionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionJobDescriptionQuery, GetRequisitionJobDescriptionQueryVariables>(
    GetRequisitionJobDescriptionDocument,
    options,
  )
}
export function useGetRequisitionJobDescriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionJobDescriptionQuery, GetRequisitionJobDescriptionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionJobDescriptionQuery, GetRequisitionJobDescriptionQueryVariables>(
    GetRequisitionJobDescriptionDocument,
    options,
  )
}
export type GetRequisitionJobDescriptionQueryHookResult = ReturnType<typeof useGetRequisitionJobDescriptionQuery>
export type GetRequisitionJobDescriptionLazyQueryHookResult = ReturnType<
  typeof useGetRequisitionJobDescriptionLazyQuery
>
export type GetRequisitionJobDescriptionSuspenseQueryHookResult = ReturnType<
  typeof useGetRequisitionJobDescriptionSuspenseQuery
>
export type GetRequisitionJobDescriptionQueryResult = Apollo.QueryResult<
  GetRequisitionJobDescriptionQuery,
  GetRequisitionJobDescriptionQueryVariables
>
export const GetTemplateJobDescriptionDocument = gql`
  query GetTemplateJobDescription($companyUserId: Int, $companyDepartmentId: Int, $id: Int, $name: String) {
    GetTemplateJobDescription(
      companyUserId: $companyUserId
      companyDepartmentId: $companyDepartmentId
      id: $id
      name: $name
    ) {
      id
      companyId
      companyUserId
      name
      description
      companyDepartmentId
      createdAt
      updatedAt
      companyDepartment {
        id
        companyId
        departmentName
        subordinateTo
        externalId
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useGetTemplateJobDescriptionQuery__
 *
 * To run a query within a React component, call `useGetTemplateJobDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateJobDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateJobDescriptionQuery({
 *   variables: {
 *      companyUserId: // value for 'companyUserId'
 *      companyDepartmentId: // value for 'companyDepartmentId'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetTemplateJobDescriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTemplateJobDescriptionQuery, GetTemplateJobDescriptionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTemplateJobDescriptionQuery, GetTemplateJobDescriptionQueryVariables>(
    GetTemplateJobDescriptionDocument,
    options,
  )
}
export function useGetTemplateJobDescriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateJobDescriptionQuery, GetTemplateJobDescriptionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTemplateJobDescriptionQuery, GetTemplateJobDescriptionQueryVariables>(
    GetTemplateJobDescriptionDocument,
    options,
  )
}
export function useGetTemplateJobDescriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTemplateJobDescriptionQuery, GetTemplateJobDescriptionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTemplateJobDescriptionQuery, GetTemplateJobDescriptionQueryVariables>(
    GetTemplateJobDescriptionDocument,
    options,
  )
}
export type GetTemplateJobDescriptionQueryHookResult = ReturnType<typeof useGetTemplateJobDescriptionQuery>
export type GetTemplateJobDescriptionLazyQueryHookResult = ReturnType<typeof useGetTemplateJobDescriptionLazyQuery>
export type GetTemplateJobDescriptionSuspenseQueryHookResult = ReturnType<
  typeof useGetTemplateJobDescriptionSuspenseQuery
>
export type GetTemplateJobDescriptionQueryResult = Apollo.QueryResult<
  GetTemplateJobDescriptionQuery,
  GetTemplateJobDescriptionQueryVariables
>
export const GetRequisitionSkillDocument = gql`
  query GetRequisitionSkill($id: Int!) {
    GetRequisitionSkill(id: $id) {
      ...RequisitionSkillsFragment
      createdAt
      updatedAt
      skill {
        ...SkillFragment
      }
    }
  }
  ${RequisitionSkillsFragmentFragmentDoc}
  ${SkillFragmentFragmentDoc}
`

/**
 * __useGetRequisitionSkillQuery__
 *
 * To run a query within a React component, call `useGetRequisitionSkillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequisitionSkillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequisitionSkillQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRequisitionSkillQuery(
  baseOptions: Apollo.QueryHookOptions<GetRequisitionSkillQuery, GetRequisitionSkillQueryVariables> &
    ({ variables: GetRequisitionSkillQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRequisitionSkillQuery, GetRequisitionSkillQueryVariables>(
    GetRequisitionSkillDocument,
    options,
  )
}
export function useGetRequisitionSkillLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRequisitionSkillQuery, GetRequisitionSkillQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRequisitionSkillQuery, GetRequisitionSkillQueryVariables>(
    GetRequisitionSkillDocument,
    options,
  )
}
export function useGetRequisitionSkillSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetRequisitionSkillQuery, GetRequisitionSkillQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRequisitionSkillQuery, GetRequisitionSkillQueryVariables>(
    GetRequisitionSkillDocument,
    options,
  )
}
export type GetRequisitionSkillQueryHookResult = ReturnType<typeof useGetRequisitionSkillQuery>
export type GetRequisitionSkillLazyQueryHookResult = ReturnType<typeof useGetRequisitionSkillLazyQuery>
export type GetRequisitionSkillSuspenseQueryHookResult = ReturnType<typeof useGetRequisitionSkillSuspenseQuery>
export type GetRequisitionSkillQueryResult = Apollo.QueryResult<
  GetRequisitionSkillQuery,
  GetRequisitionSkillQueryVariables
>
export const GetJobListingScreeningQuestionDocument = gql`
  query GetJobListingScreeningQuestion(
    $id: Int
    $jobListingId: Int
    $orderBy: SortDirection
    $candidateApplicationId: Int
  ) {
    GetJobListingScreeningQuestion(id: $id, jobListingId: $jobListingId, orderBy: $orderBy) {
      id
      jobListingId
      displaySequenceNumber
      screeningQuestionId
      createdAt
      updatedAt
      ScreeningQuestion {
        id
        isTemplateQuestion
        questionTitle
        questionDesc
        questionType
        minVal
        maxVal
        valStatus
        ansOptions
        isRejectionQuestion
        rejectMessage
        templateMessageId
        preferredAnswer
        companyId
        companyUserId
        createdAt
        updatedAt
      }
      CandidateAnswer(candidateApplicationId: $candidateApplicationId) {
        id
        answer
        answerStatus
        candidateApplicationId
        listingScreeningQuestionId
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useGetJobListingScreeningQuestionQuery__
 *
 * To run a query within a React component, call `useGetJobListingScreeningQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobListingScreeningQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobListingScreeningQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      jobListingId: // value for 'jobListingId'
 *      orderBy: // value for 'orderBy'
 *      candidateApplicationId: // value for 'candidateApplicationId'
 *   },
 * });
 */
export function useGetJobListingScreeningQuestionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobListingScreeningQuestionQuery,
    GetJobListingScreeningQuestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetJobListingScreeningQuestionQuery, GetJobListingScreeningQuestionQueryVariables>(
    GetJobListingScreeningQuestionDocument,
    options,
  )
}
export function useGetJobListingScreeningQuestionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobListingScreeningQuestionQuery,
    GetJobListingScreeningQuestionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetJobListingScreeningQuestionQuery, GetJobListingScreeningQuestionQueryVariables>(
    GetJobListingScreeningQuestionDocument,
    options,
  )
}
export function useGetJobListingScreeningQuestionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetJobListingScreeningQuestionQuery,
        GetJobListingScreeningQuestionQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetJobListingScreeningQuestionQuery, GetJobListingScreeningQuestionQueryVariables>(
    GetJobListingScreeningQuestionDocument,
    options,
  )
}
export type GetJobListingScreeningQuestionQueryHookResult = ReturnType<typeof useGetJobListingScreeningQuestionQuery>
export type GetJobListingScreeningQuestionLazyQueryHookResult = ReturnType<
  typeof useGetJobListingScreeningQuestionLazyQuery
>
export type GetJobListingScreeningQuestionSuspenseQueryHookResult = ReturnType<
  typeof useGetJobListingScreeningQuestionSuspenseQuery
>
export type GetJobListingScreeningQuestionQueryResult = Apollo.QueryResult<
  GetJobListingScreeningQuestionQuery,
  GetJobListingScreeningQuestionQueryVariables
>
export const GetRolesDocument = gql`
  query GetRoles {
    GetRoles {
      id
      name
    }
  }
`

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options)
}
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options)
}
export function useGetRolesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options)
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>
export const GetCompanyUserPermissionsDocument = gql`
  query GetCompanyUserPermissions {
    GetCompanyUserPermissions {
      orgLevelRole
      jobLevelPermissions {
        requisitionId
        stageCollaborator {
          templateStageId
          role
        }
        hiringTeamRole
      }
    }
  }
`

/**
 * __useGetCompanyUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyUserPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCompanyUserPermissionsQuery, GetCompanyUserPermissionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCompanyUserPermissionsQuery, GetCompanyUserPermissionsQueryVariables>(
    GetCompanyUserPermissionsDocument,
    options,
  )
}
export function useGetCompanyUserPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyUserPermissionsQuery, GetCompanyUserPermissionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCompanyUserPermissionsQuery, GetCompanyUserPermissionsQueryVariables>(
    GetCompanyUserPermissionsDocument,
    options,
  )
}
export function useGetCompanyUserPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCompanyUserPermissionsQuery, GetCompanyUserPermissionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCompanyUserPermissionsQuery, GetCompanyUserPermissionsQueryVariables>(
    GetCompanyUserPermissionsDocument,
    options,
  )
}
export type GetCompanyUserPermissionsQueryHookResult = ReturnType<typeof useGetCompanyUserPermissionsQuery>
export type GetCompanyUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetCompanyUserPermissionsLazyQuery>
export type GetCompanyUserPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyUserPermissionsSuspenseQuery
>
export type GetCompanyUserPermissionsQueryResult = Apollo.QueryResult<
  GetCompanyUserPermissionsQuery,
  GetCompanyUserPermissionsQueryVariables
>
export const GetEmailActivationDocument = gql`
  query GetEmailActivation($email: String!) {
    GetEmailActivation(email: $email)
  }
`

/**
 * __useGetEmailActivationQuery__
 *
 * To run a query within a React component, call `useGetEmailActivationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailActivationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailActivationQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetEmailActivationQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmailActivationQuery, GetEmailActivationQueryVariables> &
    ({ variables: GetEmailActivationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetEmailActivationQuery, GetEmailActivationQueryVariables>(GetEmailActivationDocument, options)
}
export function useGetEmailActivationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmailActivationQuery, GetEmailActivationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetEmailActivationQuery, GetEmailActivationQueryVariables>(
    GetEmailActivationDocument,
    options,
  )
}
export function useGetEmailActivationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEmailActivationQuery, GetEmailActivationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetEmailActivationQuery, GetEmailActivationQueryVariables>(
    GetEmailActivationDocument,
    options,
  )
}
export type GetEmailActivationQueryHookResult = ReturnType<typeof useGetEmailActivationQuery>
export type GetEmailActivationLazyQueryHookResult = ReturnType<typeof useGetEmailActivationLazyQuery>
export type GetEmailActivationSuspenseQueryHookResult = ReturnType<typeof useGetEmailActivationSuspenseQuery>
export type GetEmailActivationQueryResult = Apollo.QueryResult<
  GetEmailActivationQuery,
  GetEmailActivationQueryVariables
>
export const GetUserCompaniesDocument = gql`
  query GetUserCompanies {
    Me {
      UserInvitation {
        Company {
          id
          subdomain
          createdAt
          externalId
          lastActivity
          updatedAt
          CompanyInfo {
            id
            companyName
            companyType
            companyId
            updatedAt
            logo
          }
        }
      }
    }
  }
`

/**
 * __useGetUserCompaniesQuery__
 *
 * To run a query within a React component, call `useGetUserCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCompaniesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>(GetUserCompaniesDocument, options)
}
export function useGetUserCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>(GetUserCompaniesDocument, options)
}
export function useGetUserCompaniesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>(
    GetUserCompaniesDocument,
    options,
  )
}
export type GetUserCompaniesQueryHookResult = ReturnType<typeof useGetUserCompaniesQuery>
export type GetUserCompaniesLazyQueryHookResult = ReturnType<typeof useGetUserCompaniesLazyQuery>
export type GetUserCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetUserCompaniesSuspenseQuery>
export type GetUserCompaniesQueryResult = Apollo.QueryResult<GetUserCompaniesQuery, GetUserCompaniesQueryVariables>
export const GetSchedulerLinkSettingsDocument = gql`
  query GetSchedulerLinkSettings($id: Int) {
    GetSchedulerLinkSettings(id: $id) {
      id
      minimumHour
      rollingDays
      maxInterviewsPerDay
    }
  }
`

/**
 * __useGetSchedulerLinkSettingsQuery__
 *
 * To run a query within a React component, call `useGetSchedulerLinkSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulerLinkSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulerLinkSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSchedulerLinkSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSchedulerLinkSettingsQuery, GetSchedulerLinkSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSchedulerLinkSettingsQuery, GetSchedulerLinkSettingsQueryVariables>(
    GetSchedulerLinkSettingsDocument,
    options,
  )
}
export function useGetSchedulerLinkSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulerLinkSettingsQuery, GetSchedulerLinkSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSchedulerLinkSettingsQuery, GetSchedulerLinkSettingsQueryVariables>(
    GetSchedulerLinkSettingsDocument,
    options,
  )
}
export function useGetSchedulerLinkSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSchedulerLinkSettingsQuery, GetSchedulerLinkSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSchedulerLinkSettingsQuery, GetSchedulerLinkSettingsQueryVariables>(
    GetSchedulerLinkSettingsDocument,
    options,
  )
}
export type GetSchedulerLinkSettingsQueryHookResult = ReturnType<typeof useGetSchedulerLinkSettingsQuery>
export type GetSchedulerLinkSettingsLazyQueryHookResult = ReturnType<typeof useGetSchedulerLinkSettingsLazyQuery>
export type GetSchedulerLinkSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetSchedulerLinkSettingsSuspenseQuery
>
export type GetSchedulerLinkSettingsQueryResult = Apollo.QueryResult<
  GetSchedulerLinkSettingsQuery,
  GetSchedulerLinkSettingsQueryVariables
>
export const GetScorecardTemplateDocument = gql`
  query GetScorecardTemplate($id: Int) {
    GetScorecardTemplate(id: $id) {
      id
      archived
      department
      scorecardName
      scorecardDescription
      visible
      companyTemplate
      timestampAt
      createdAt
      ScorecardTemplateSection {
        id
        rankOrder
        scorecardTemplateId
        sectionName
        sectionType
        ScorecardTemplateQuestion {
          id
          answerOptions
          preferredAnswer
          questionDescription
          questionText
          questionType
          scoreAnswer
          scorecardTemplateSectionId
          skillId
          skillDisplayName
          CandidateScorecardAnswers {
            id
            answer
            answerPreferredStatus
            candidateScorecardId
            dateAnswer
            scoreAnswer
            scorecardTemplateQuestionId
          }
        }
      }
    }
  }
`

/**
 * __useGetScorecardTemplateQuery__
 *
 * To run a query within a React component, call `useGetScorecardTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScorecardTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScorecardTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScorecardTemplateQuery(
  baseOptions?: Apollo.QueryHookOptions<GetScorecardTemplateQuery, GetScorecardTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScorecardTemplateQuery, GetScorecardTemplateQueryVariables>(
    GetScorecardTemplateDocument,
    options,
  )
}
export function useGetScorecardTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScorecardTemplateQuery, GetScorecardTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScorecardTemplateQuery, GetScorecardTemplateQueryVariables>(
    GetScorecardTemplateDocument,
    options,
  )
}
export function useGetScorecardTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScorecardTemplateQuery, GetScorecardTemplateQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScorecardTemplateQuery, GetScorecardTemplateQueryVariables>(
    GetScorecardTemplateDocument,
    options,
  )
}
export type GetScorecardTemplateQueryHookResult = ReturnType<typeof useGetScorecardTemplateQuery>
export type GetScorecardTemplateLazyQueryHookResult = ReturnType<typeof useGetScorecardTemplateLazyQuery>
export type GetScorecardTemplateSuspenseQueryHookResult = ReturnType<typeof useGetScorecardTemplateSuspenseQuery>
export type GetScorecardTemplateQueryResult = Apollo.QueryResult<
  GetScorecardTemplateQuery,
  GetScorecardTemplateQueryVariables
>
export const GetScorecardTemplatesForCompareScorecardDocument = gql`
  query GetScorecardTemplatesForCompareScorecard($input: GetScorecardTemplatesInput!) {
    GetScorecardTemplates(input: $input) {
      id
      archived
      department
      scorecardName
      companyTemplate
      timestampAt
      createdAt
      ScorecardTemplateSection {
        id
        rankOrder
        scorecardTemplateId
        sectionName
        sectionType
        ScorecardTemplateQuestion {
          ...GetCompareScorecardTemplatesQuestion
        }
      }
      CompanyUser {
        id
        UserInvitation {
          id
          ScalisUser {
            ...ScalisUser
          }
        }
      }
      CandidateScorecard {
        ...GetCompareScorecardTemplatesCandidateScorecard
      }
    }
  }
  ${GetCompareScorecardTemplatesQuestionFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${GetCompareScorecardTemplatesCandidateScorecardFragmentDoc}
`

/**
 * __useGetScorecardTemplatesForCompareScorecardQuery__
 *
 * To run a query within a React component, call `useGetScorecardTemplatesForCompareScorecardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScorecardTemplatesForCompareScorecardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScorecardTemplatesForCompareScorecardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScorecardTemplatesForCompareScorecardQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScorecardTemplatesForCompareScorecardQuery,
    GetScorecardTemplatesForCompareScorecardQueryVariables
  > &
    ({ variables: GetScorecardTemplatesForCompareScorecardQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetScorecardTemplatesForCompareScorecardQuery,
    GetScorecardTemplatesForCompareScorecardQueryVariables
  >(GetScorecardTemplatesForCompareScorecardDocument, options)
}
export function useGetScorecardTemplatesForCompareScorecardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScorecardTemplatesForCompareScorecardQuery,
    GetScorecardTemplatesForCompareScorecardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetScorecardTemplatesForCompareScorecardQuery,
    GetScorecardTemplatesForCompareScorecardQueryVariables
  >(GetScorecardTemplatesForCompareScorecardDocument, options)
}
export function useGetScorecardTemplatesForCompareScorecardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetScorecardTemplatesForCompareScorecardQuery,
        GetScorecardTemplatesForCompareScorecardQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetScorecardTemplatesForCompareScorecardQuery,
    GetScorecardTemplatesForCompareScorecardQueryVariables
  >(GetScorecardTemplatesForCompareScorecardDocument, options)
}
export type GetScorecardTemplatesForCompareScorecardQueryHookResult = ReturnType<
  typeof useGetScorecardTemplatesForCompareScorecardQuery
>
export type GetScorecardTemplatesForCompareScorecardLazyQueryHookResult = ReturnType<
  typeof useGetScorecardTemplatesForCompareScorecardLazyQuery
>
export type GetScorecardTemplatesForCompareScorecardSuspenseQueryHookResult = ReturnType<
  typeof useGetScorecardTemplatesForCompareScorecardSuspenseQuery
>
export type GetScorecardTemplatesForCompareScorecardQueryResult = Apollo.QueryResult<
  GetScorecardTemplatesForCompareScorecardQuery,
  GetScorecardTemplatesForCompareScorecardQueryVariables
>
export const GetScorecardTemplatesDocument = gql`
  query GetScorecardTemplates(
    $archived: Boolean
    $visible: Boolean
    $sortBy: SortByScorecardTemplate
    $sortDirection: SortDirection
  ) {
    GetScorecardTemplate(archived: $archived, visible: $visible, sortBy: $sortBy, sortDirection: $sortDirection) {
      id
      archived
      department
      scorecardName
      scorecardDescription
      visible
      companyTemplate
      timestampAt
      createdAt
      ScorecardTemplateSection {
        id
        rankOrder
        scorecardTemplateId
        sectionName
        sectionType
        ScorecardTemplateQuestion {
          id
          answerOptions
          preferredAnswer
          questionDescription
          questionText
          questionType
          scoreAnswer
          scorecardTemplateSectionId
          skillId
          skillDisplayName
        }
      }
      CompanyUser {
        id
        UserInvitation {
          ScalisUser {
            ...ScalisUser
          }
        }
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useGetScorecardTemplatesQuery__
 *
 * To run a query within a React component, call `useGetScorecardTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScorecardTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScorecardTemplatesQuery({
 *   variables: {
 *      archived: // value for 'archived'
 *      visible: // value for 'visible'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetScorecardTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetScorecardTemplatesQuery, GetScorecardTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScorecardTemplatesQuery, GetScorecardTemplatesQueryVariables>(
    GetScorecardTemplatesDocument,
    options,
  )
}
export function useGetScorecardTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScorecardTemplatesQuery, GetScorecardTemplatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScorecardTemplatesQuery, GetScorecardTemplatesQueryVariables>(
    GetScorecardTemplatesDocument,
    options,
  )
}
export function useGetScorecardTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScorecardTemplatesQuery, GetScorecardTemplatesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScorecardTemplatesQuery, GetScorecardTemplatesQueryVariables>(
    GetScorecardTemplatesDocument,
    options,
  )
}
export type GetScorecardTemplatesQueryHookResult = ReturnType<typeof useGetScorecardTemplatesQuery>
export type GetScorecardTemplatesLazyQueryHookResult = ReturnType<typeof useGetScorecardTemplatesLazyQuery>
export type GetScorecardTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetScorecardTemplatesSuspenseQuery>
export type GetScorecardTemplatesQueryResult = Apollo.QueryResult<
  GetScorecardTemplatesQuery,
  GetScorecardTemplatesQueryVariables
>
export const ListTemplateScreeningQuestionsDocument = gql`
  query ListTemplateScreeningQuestions($input: ListTemplateScreeningQuestionInput!) {
    ListTemplateScreeningQuestions(input: $input) {
      items {
        id
        questionTitle
        questionDesc
        questionType
        minVal
        maxVal
        valStatus
        ansOptions
        isRejectionQuestion
        rejectMessage
        preferredAnswer
        preferredAnswerType
        multipleSelectPreferredAnswers
        selectionDisplay
        isTemplateQuestion
        CompanyUser {
          id
          UserInvitation {
            ScalisUser {
              firstName
              lastName
              profileImage
            }
          }
        }
        createdAt
        updatedAt
      }
      total
    }
  }
`

/**
 * __useListTemplateScreeningQuestionsQuery__
 *
 * To run a query within a React component, call `useListTemplateScreeningQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplateScreeningQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplateScreeningQuestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListTemplateScreeningQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ListTemplateScreeningQuestionsQuery,
    ListTemplateScreeningQuestionsQueryVariables
  > &
    ({ variables: ListTemplateScreeningQuestionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListTemplateScreeningQuestionsQuery, ListTemplateScreeningQuestionsQueryVariables>(
    ListTemplateScreeningQuestionsDocument,
    options,
  )
}
export function useListTemplateScreeningQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTemplateScreeningQuestionsQuery,
    ListTemplateScreeningQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListTemplateScreeningQuestionsQuery, ListTemplateScreeningQuestionsQueryVariables>(
    ListTemplateScreeningQuestionsDocument,
    options,
  )
}
export function useListTemplateScreeningQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ListTemplateScreeningQuestionsQuery,
        ListTemplateScreeningQuestionsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListTemplateScreeningQuestionsQuery, ListTemplateScreeningQuestionsQueryVariables>(
    ListTemplateScreeningQuestionsDocument,
    options,
  )
}
export type ListTemplateScreeningQuestionsQueryHookResult = ReturnType<typeof useListTemplateScreeningQuestionsQuery>
export type ListTemplateScreeningQuestionsLazyQueryHookResult = ReturnType<
  typeof useListTemplateScreeningQuestionsLazyQuery
>
export type ListTemplateScreeningQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useListTemplateScreeningQuestionsSuspenseQuery
>
export type ListTemplateScreeningQuestionsQueryResult = Apollo.QueryResult<
  ListTemplateScreeningQuestionsQuery,
  ListTemplateScreeningQuestionsQueryVariables
>
export const GetSearchResultsDocument = gql`
  query GetSearchResults(
    $companyAlias: [String!]
    $companyId: [String!]
    $department: [String!]
    $educationLevel: [EducationLevelPrefEnum!]
    $employment: [JobTypeEnum!]
    $experienceLevel: [JobLevelEnum!]
    $id: [String!]
    $limit: Int
    $page: Int
    $payment: [PayTypeEnum!]
    $search: String
    $sort: SearchSortEnum
    $tags: [String!]
    $workplace: [LocationTypeEnum!]
    $location: String
    $postedAt: PostedAtEnum
    $industry: [String!]
    $isScalis: Boolean
    $companyHeadcount: [CompanyHeadcountEnum!]
    $source: [SourceTypeEnum!]
    $visaSponsorship: Boolean
    $salary: SalaryInputType
  ) {
    Search(
      companyAlias: $companyAlias
      companyId: $companyId
      department: $department
      educationLevel: $educationLevel
      employment: $employment
      experienceLevel: $experienceLevel
      id: $id
      limit: $limit
      page: $page
      payment: $payment
      search: $search
      sort: $sort
      tags: $tags
      workplace: $workplace
      location: $location
      postedAt: $postedAt
      industry: $industry
      isScalis: $isScalis
      companyHeadcount: $companyHeadcount
      source: $source
      visaSponsorship: $visaSponsorship
      salary: $salary
    ) {
      count
      filters {
        key
        values {
          count
          value
        }
      }
      results {
        benefits
        company {
          alias
          location {
            city
            continent
            country
            region
            state
          }
          id
          logo
          name
        }
        createdAt
        department
        description
        descriptionHtml
        educationLevel
        employment
        experienceLevel
        id
        isApplied
        isBookmarked
        locations {
          city
          region
          country
          continent
          state
        }
        payment
        salary {
          min
          max
          currency
        }
        skills
        source
        title
        url
        workplace
      }
    }
  }
`

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      companyAlias: // value for 'companyAlias'
 *      companyId: // value for 'companyId'
 *      department: // value for 'department'
 *      educationLevel: // value for 'educationLevel'
 *      employment: // value for 'employment'
 *      experienceLevel: // value for 'experienceLevel'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      payment: // value for 'payment'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      tags: // value for 'tags'
 *      workplace: // value for 'workplace'
 *      location: // value for 'location'
 *      postedAt: // value for 'postedAt'
 *      industry: // value for 'industry'
 *      isScalis: // value for 'isScalis'
 *      companyHeadcount: // value for 'companyHeadcount'
 *      source: // value for 'source'
 *      visaSponsorship: // value for 'visaSponsorship'
 *      salary: // value for 'salary'
 *   },
 * });
 */
export function useGetSearchResultsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options)
}
export function useGetSearchResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options)
}
export function useGetSearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(
    GetSearchResultsDocument,
    options,
  )
}
export type GetSearchResultsQueryHookResult = ReturnType<typeof useGetSearchResultsQuery>
export type GetSearchResultsLazyQueryHookResult = ReturnType<typeof useGetSearchResultsLazyQuery>
export type GetSearchResultsSuspenseQueryHookResult = ReturnType<typeof useGetSearchResultsSuspenseQuery>
export type GetSearchResultsQueryResult = Apollo.QueryResult<GetSearchResultsQuery, GetSearchResultsQueryVariables>
export const DeleteOfferSectionTemplateDocument = gql`
  mutation DeleteOfferSectionTemplate($input: DeleteOfferSectionTemplateInput!) {
    DeleteOfferSectionTemplate(input: $input) {
      id
    }
  }
`
export type DeleteOfferSectionTemplateMutationFn = Apollo.MutationFunction<
  DeleteOfferSectionTemplateMutation,
  DeleteOfferSectionTemplateMutationVariables
>

/**
 * __useDeleteOfferSectionTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteOfferSectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferSectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferSectionTemplateMutation, { data, loading, error }] = useDeleteOfferSectionTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOfferSectionTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOfferSectionTemplateMutation,
    DeleteOfferSectionTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteOfferSectionTemplateMutation, DeleteOfferSectionTemplateMutationVariables>(
    DeleteOfferSectionTemplateDocument,
    options,
  )
}
export type DeleteOfferSectionTemplateMutationHookResult = ReturnType<typeof useDeleteOfferSectionTemplateMutation>
export type DeleteOfferSectionTemplateMutationResult = Apollo.MutationResult<DeleteOfferSectionTemplateMutation>
export type DeleteOfferSectionTemplateMutationOptions = Apollo.BaseMutationOptions<
  DeleteOfferSectionTemplateMutation,
  DeleteOfferSectionTemplateMutationVariables
>
export const GetOfferSectionTemplateDocument = gql`
  query GetOfferSectionTemplate {
    GetOfferSectionTemplate(input: {}) {
      ...OfferSectionTemplate
    }
  }
  ${OfferSectionTemplateFragmentDoc}
`

/**
 * __useGetOfferSectionTemplateQuery__
 *
 * To run a query within a React component, call `useGetOfferSectionTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferSectionTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferSectionTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOfferSectionTemplateQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOfferSectionTemplateQuery, GetOfferSectionTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetOfferSectionTemplateQuery, GetOfferSectionTemplateQueryVariables>(
    GetOfferSectionTemplateDocument,
    options,
  )
}
export function useGetOfferSectionTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOfferSectionTemplateQuery, GetOfferSectionTemplateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetOfferSectionTemplateQuery, GetOfferSectionTemplateQueryVariables>(
    GetOfferSectionTemplateDocument,
    options,
  )
}
export function useGetOfferSectionTemplateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetOfferSectionTemplateQuery, GetOfferSectionTemplateQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetOfferSectionTemplateQuery, GetOfferSectionTemplateQueryVariables>(
    GetOfferSectionTemplateDocument,
    options,
  )
}
export type GetOfferSectionTemplateQueryHookResult = ReturnType<typeof useGetOfferSectionTemplateQuery>
export type GetOfferSectionTemplateLazyQueryHookResult = ReturnType<typeof useGetOfferSectionTemplateLazyQuery>
export type GetOfferSectionTemplateSuspenseQueryHookResult = ReturnType<typeof useGetOfferSectionTemplateSuspenseQuery>
export type GetOfferSectionTemplateQueryResult = Apollo.QueryResult<
  GetOfferSectionTemplateQuery,
  GetOfferSectionTemplateQueryVariables
>
export const UpsertOfferSectionTemplateDocument = gql`
  mutation UpsertOfferSectionTemplate($input: UpsertOfferSectionTemplateInput!) {
    UpsertOfferSectionTemplate(input: $input) {
      ...OfferSectionTemplate
    }
  }
  ${OfferSectionTemplateFragmentDoc}
`
export type UpsertOfferSectionTemplateMutationFn = Apollo.MutationFunction<
  UpsertOfferSectionTemplateMutation,
  UpsertOfferSectionTemplateMutationVariables
>

/**
 * __useUpsertOfferSectionTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertOfferSectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOfferSectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOfferSectionTemplateMutation, { data, loading, error }] = useUpsertOfferSectionTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOfferSectionTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertOfferSectionTemplateMutation,
    UpsertOfferSectionTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpsertOfferSectionTemplateMutation, UpsertOfferSectionTemplateMutationVariables>(
    UpsertOfferSectionTemplateDocument,
    options,
  )
}
export type UpsertOfferSectionTemplateMutationHookResult = ReturnType<typeof useUpsertOfferSectionTemplateMutation>
export type UpsertOfferSectionTemplateMutationResult = Apollo.MutationResult<UpsertOfferSectionTemplateMutation>
export type UpsertOfferSectionTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpsertOfferSectionTemplateMutation,
  UpsertOfferSectionTemplateMutationVariables
>
export const ValidateOfferSectionTemplateDocument = gql`
  mutation ValidateOfferSectionTemplate($id: Int!) {
    ValidateOfferSectionTemplate(input: { id: $id }) {
      id
      sectionTemplateStatus
      validationResult
    }
  }
`
export type ValidateOfferSectionTemplateMutationFn = Apollo.MutationFunction<
  ValidateOfferSectionTemplateMutation,
  ValidateOfferSectionTemplateMutationVariables
>

/**
 * __useValidateOfferSectionTemplateMutation__
 *
 * To run a mutation, you first call `useValidateOfferSectionTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOfferSectionTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOfferSectionTemplateMutation, { data, loading, error }] = useValidateOfferSectionTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useValidateOfferSectionTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateOfferSectionTemplateMutation,
    ValidateOfferSectionTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ValidateOfferSectionTemplateMutation, ValidateOfferSectionTemplateMutationVariables>(
    ValidateOfferSectionTemplateDocument,
    options,
  )
}
export type ValidateOfferSectionTemplateMutationHookResult = ReturnType<typeof useValidateOfferSectionTemplateMutation>
export type ValidateOfferSectionTemplateMutationResult = Apollo.MutationResult<ValidateOfferSectionTemplateMutation>
export type ValidateOfferSectionTemplateMutationOptions = Apollo.BaseMutationOptions<
  ValidateOfferSectionTemplateMutation,
  ValidateOfferSectionTemplateMutationVariables
>
export const GetSequenceScheduleSettingsDocument = gql`
  query GetSequenceScheduleSettings {
    GetSequenceScheduleSettings {
      ...SequenceScheduleSetting
    }
  }
  ${SequenceScheduleSettingFragmentDoc}
`

/**
 * __useGetSequenceScheduleSettingsQuery__
 *
 * To run a query within a React component, call `useGetSequenceScheduleSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceScheduleSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceScheduleSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSequenceScheduleSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSequenceScheduleSettingsQuery, GetSequenceScheduleSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceScheduleSettingsQuery, GetSequenceScheduleSettingsQueryVariables>(
    GetSequenceScheduleSettingsDocument,
    options,
  )
}
export function useGetSequenceScheduleSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSequenceScheduleSettingsQuery,
    GetSequenceScheduleSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceScheduleSettingsQuery, GetSequenceScheduleSettingsQueryVariables>(
    GetSequenceScheduleSettingsDocument,
    options,
  )
}
export function useGetSequenceScheduleSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSequenceScheduleSettingsQuery, GetSequenceScheduleSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceScheduleSettingsQuery, GetSequenceScheduleSettingsQueryVariables>(
    GetSequenceScheduleSettingsDocument,
    options,
  )
}
export type GetSequenceScheduleSettingsQueryHookResult = ReturnType<typeof useGetSequenceScheduleSettingsQuery>
export type GetSequenceScheduleSettingsLazyQueryHookResult = ReturnType<typeof useGetSequenceScheduleSettingsLazyQuery>
export type GetSequenceScheduleSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetSequenceScheduleSettingsSuspenseQuery
>
export type GetSequenceScheduleSettingsQueryResult = Apollo.QueryResult<
  GetSequenceScheduleSettingsQuery,
  GetSequenceScheduleSettingsQueryVariables
>
export const GetSequenceActivityLogsDocument = gql`
  query GetSequenceActivityLogs($input: GetSequenceActivityLogsInput!, $sequenceId: String!) {
    GetSequenceActivityLogs(input: $input) {
      count
      emailsSent {
        id
        eventType
        SequenceCandidate {
          id
          CandidateProfile {
            id
            ...CandidateProfileIds
            ...CandidateProfileName
            hasSent(sequenceId: $sequenceId)
            hasOpened(sequenceId: $sequenceId)
            hasReplied(sequenceId: $sequenceId)
            hasBounced(sequenceId: $sequenceId)
          }
        }
        EmailRecord {
          id
          subject
          message
          createdAt
          to {
            name
          }
        }
      }
    }
  }
  ${CandidateProfileIdsFragmentDoc}
  ${CandidateProfileNameFragmentDoc}
`

/**
 * __useGetSequenceActivityLogsQuery__
 *
 * To run a query within a React component, call `useGetSequenceActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceActivityLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useGetSequenceActivityLogsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSequenceActivityLogsQuery, GetSequenceActivityLogsQueryVariables> &
    ({ variables: GetSequenceActivityLogsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceActivityLogsQuery, GetSequenceActivityLogsQueryVariables>(
    GetSequenceActivityLogsDocument,
    options,
  )
}
export function useGetSequenceActivityLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSequenceActivityLogsQuery, GetSequenceActivityLogsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceActivityLogsQuery, GetSequenceActivityLogsQueryVariables>(
    GetSequenceActivityLogsDocument,
    options,
  )
}
export function useGetSequenceActivityLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSequenceActivityLogsQuery, GetSequenceActivityLogsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceActivityLogsQuery, GetSequenceActivityLogsQueryVariables>(
    GetSequenceActivityLogsDocument,
    options,
  )
}
export type GetSequenceActivityLogsQueryHookResult = ReturnType<typeof useGetSequenceActivityLogsQuery>
export type GetSequenceActivityLogsLazyQueryHookResult = ReturnType<typeof useGetSequenceActivityLogsLazyQuery>
export type GetSequenceActivityLogsSuspenseQueryHookResult = ReturnType<typeof useGetSequenceActivityLogsSuspenseQuery>
export type GetSequenceActivityLogsQueryResult = Apollo.QueryResult<
  GetSequenceActivityLogsQuery,
  GetSequenceActivityLogsQueryVariables
>
export const GetSequenceByIdDocument = gql`
  query GetSequenceById($input: GetSequenceByIdInput!) {
    GetSequenceById(input: $input) {
      ...Sequence
    }
  }
  ${SequenceFragmentDoc}
`

/**
 * __useGetSequenceByIdQuery__
 *
 * To run a query within a React component, call `useGetSequenceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSequenceByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetSequenceByIdQuery, GetSequenceByIdQueryVariables> &
    ({ variables: GetSequenceByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceByIdQuery, GetSequenceByIdQueryVariables>(GetSequenceByIdDocument, options)
}
export function useGetSequenceByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSequenceByIdQuery, GetSequenceByIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceByIdQuery, GetSequenceByIdQueryVariables>(GetSequenceByIdDocument, options)
}
export function useGetSequenceByIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSequenceByIdQuery, GetSequenceByIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceByIdQuery, GetSequenceByIdQueryVariables>(GetSequenceByIdDocument, options)
}
export type GetSequenceByIdQueryHookResult = ReturnType<typeof useGetSequenceByIdQuery>
export type GetSequenceByIdLazyQueryHookResult = ReturnType<typeof useGetSequenceByIdLazyQuery>
export type GetSequenceByIdSuspenseQueryHookResult = ReturnType<typeof useGetSequenceByIdSuspenseQuery>
export type GetSequenceByIdQueryResult = Apollo.QueryResult<GetSequenceByIdQuery, GetSequenceByIdQueryVariables>
export const GetSequenceCandidateActivityLogsDocument = gql`
  query GetSequenceCandidateActivityLogs($input: GetSequenceCandidateActivityLogsInput!, $sequenceId: String!) {
    GetSequenceCandidateActivityLogs(input: $input) {
      count
      sequenceCandidate {
        id
        CandidateProfile {
          id
          ...CandidateProfileIds
          ...CandidateProfileName
          ...CandidateProfileEmail
          ...CandidateProfilePhone
          ...CandidateProfileProfileImage
          ...CandidateProfileLinkedIn
          hasSent(sequenceId: $sequenceId)
          hasOpened(sequenceId: $sequenceId)
          hasReplied(sequenceId: $sequenceId)
        }
      }
      thread {
        id
        eventType
        EmailRecord {
          id
          createdAt
          subject
          message
          to {
            companyUserId
            profileImage
            name
          }
          from {
            companyUserId
            profileImage
            name
          }
        }
        SequenceStep {
          id
          stepNumber
          afterPreviousStep
          schedulerType
        }
      }
    }
  }
  ${CandidateProfileIdsFragmentDoc}
  ${CandidateProfileNameFragmentDoc}
  ${CandidateProfileEmailFragmentDoc}
  ${CandidateProfilePhoneFragmentDoc}
  ${CandidateProfileProfileImageFragmentDoc}
  ${CandidateProfileLinkedInFragmentDoc}
`

/**
 * __useGetSequenceCandidateActivityLogsQuery__
 *
 * To run a query within a React component, call `useGetSequenceCandidateActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceCandidateActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceCandidateActivityLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useGetSequenceCandidateActivityLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSequenceCandidateActivityLogsQuery,
    GetSequenceCandidateActivityLogsQueryVariables
  > &
    ({ variables: GetSequenceCandidateActivityLogsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceCandidateActivityLogsQuery, GetSequenceCandidateActivityLogsQueryVariables>(
    GetSequenceCandidateActivityLogsDocument,
    options,
  )
}
export function useGetSequenceCandidateActivityLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSequenceCandidateActivityLogsQuery,
    GetSequenceCandidateActivityLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceCandidateActivityLogsQuery, GetSequenceCandidateActivityLogsQueryVariables>(
    GetSequenceCandidateActivityLogsDocument,
    options,
  )
}
export function useGetSequenceCandidateActivityLogsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSequenceCandidateActivityLogsQuery,
        GetSequenceCandidateActivityLogsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceCandidateActivityLogsQuery, GetSequenceCandidateActivityLogsQueryVariables>(
    GetSequenceCandidateActivityLogsDocument,
    options,
  )
}
export type GetSequenceCandidateActivityLogsQueryHookResult = ReturnType<
  typeof useGetSequenceCandidateActivityLogsQuery
>
export type GetSequenceCandidateActivityLogsLazyQueryHookResult = ReturnType<
  typeof useGetSequenceCandidateActivityLogsLazyQuery
>
export type GetSequenceCandidateActivityLogsSuspenseQueryHookResult = ReturnType<
  typeof useGetSequenceCandidateActivityLogsSuspenseQuery
>
export type GetSequenceCandidateActivityLogsQueryResult = Apollo.QueryResult<
  GetSequenceCandidateActivityLogsQuery,
  GetSequenceCandidateActivityLogsQueryVariables
>
export const GetSequenceCandidateEngagementDocument = gql`
  query GetSequenceCandidateEngagement($input: GetSequenceCandidateEngagementInput!) {
    GetSequenceCandidateEngagement(input: $input) {
      countSent
      countReplied
      countOpened
      opened {
        id
        CandidateProfile {
          id
          ...SequenceCandidateEngagementCandidateProfile
        }
      }
      replied {
        id
        CandidateProfile {
          id
          ...SequenceCandidateEngagementCandidateProfile
        }
      }
      sent {
        id
        CandidateProfile {
          id
          ...SequenceCandidateEngagementCandidateProfile
        }
      }
    }
  }
  ${SequenceCandidateEngagementCandidateProfileFragmentDoc}
`

/**
 * __useGetSequenceCandidateEngagementQuery__
 *
 * To run a query within a React component, call `useGetSequenceCandidateEngagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceCandidateEngagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceCandidateEngagementQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSequenceCandidateEngagementQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSequenceCandidateEngagementQuery,
    GetSequenceCandidateEngagementQueryVariables
  > &
    ({ variables: GetSequenceCandidateEngagementQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceCandidateEngagementQuery, GetSequenceCandidateEngagementQueryVariables>(
    GetSequenceCandidateEngagementDocument,
    options,
  )
}
export function useGetSequenceCandidateEngagementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSequenceCandidateEngagementQuery,
    GetSequenceCandidateEngagementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceCandidateEngagementQuery, GetSequenceCandidateEngagementQueryVariables>(
    GetSequenceCandidateEngagementDocument,
    options,
  )
}
export function useGetSequenceCandidateEngagementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSequenceCandidateEngagementQuery,
        GetSequenceCandidateEngagementQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceCandidateEngagementQuery, GetSequenceCandidateEngagementQueryVariables>(
    GetSequenceCandidateEngagementDocument,
    options,
  )
}
export type GetSequenceCandidateEngagementQueryHookResult = ReturnType<typeof useGetSequenceCandidateEngagementQuery>
export type GetSequenceCandidateEngagementLazyQueryHookResult = ReturnType<
  typeof useGetSequenceCandidateEngagementLazyQuery
>
export type GetSequenceCandidateEngagementSuspenseQueryHookResult = ReturnType<
  typeof useGetSequenceCandidateEngagementSuspenseQuery
>
export type GetSequenceCandidateEngagementQueryResult = Apollo.QueryResult<
  GetSequenceCandidateEngagementQuery,
  GetSequenceCandidateEngagementQueryVariables
>
export const GetSequenceWithMetricsDocument = gql`
  query GetSequenceWithMetrics($sequenceId: String!) {
    GetSequenceById(input: { sequenceId: $sequenceId }) {
      ...Sequence
    }
    GetSequenceMetrics(input: { sequenceId: $sequenceId }) {
      ...SequenceMetricsResponse
    }
  }
  ${SequenceFragmentDoc}
  ${SequenceMetricsResponseFragmentDoc}
`

/**
 * __useGetSequenceWithMetricsQuery__
 *
 * To run a query within a React component, call `useGetSequenceWithMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceWithMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceWithMetricsQuery({
 *   variables: {
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useGetSequenceWithMetricsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSequenceWithMetricsQuery, GetSequenceWithMetricsQueryVariables> &
    ({ variables: GetSequenceWithMetricsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceWithMetricsQuery, GetSequenceWithMetricsQueryVariables>(
    GetSequenceWithMetricsDocument,
    options,
  )
}
export function useGetSequenceWithMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSequenceWithMetricsQuery, GetSequenceWithMetricsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceWithMetricsQuery, GetSequenceWithMetricsQueryVariables>(
    GetSequenceWithMetricsDocument,
    options,
  )
}
export function useGetSequenceWithMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSequenceWithMetricsQuery, GetSequenceWithMetricsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceWithMetricsQuery, GetSequenceWithMetricsQueryVariables>(
    GetSequenceWithMetricsDocument,
    options,
  )
}
export type GetSequenceWithMetricsQueryHookResult = ReturnType<typeof useGetSequenceWithMetricsQuery>
export type GetSequenceWithMetricsLazyQueryHookResult = ReturnType<typeof useGetSequenceWithMetricsLazyQuery>
export type GetSequenceWithMetricsSuspenseQueryHookResult = ReturnType<typeof useGetSequenceWithMetricsSuspenseQuery>
export type GetSequenceWithMetricsQueryResult = Apollo.QueryResult<
  GetSequenceWithMetricsQuery,
  GetSequenceWithMetricsQueryVariables
>
export const GetSequenceWithRecipientsDocument = gql`
  query GetSequenceWithRecipients($sequenceId: String!) {
    GetSequenceById(input: { sequenceId: $sequenceId }) {
      ...Sequence
    }
    GetCandidateProfile(sequenceId: $sequenceId) {
      id
      UploadedCandidate {
        ...UploadedCandidate
      }
      ScalisUser {
        ...ScalisUser
        ...ScalisUserWebsiteOrSocialMedia
        ...CurrentJob
      }
    }
  }
  ${SequenceFragmentDoc}
  ${UploadedCandidateFragmentDoc}
  ${ScalisUserFragmentDoc}
  ${ScalisUserWebsiteOrSocialMediaFragmentDoc}
  ${CurrentJobFragmentDoc}
`

/**
 * __useGetSequenceWithRecipientsQuery__
 *
 * To run a query within a React component, call `useGetSequenceWithRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequenceWithRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequenceWithRecipientsQuery({
 *   variables: {
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useGetSequenceWithRecipientsQuery(
  baseOptions: Apollo.QueryHookOptions<GetSequenceWithRecipientsQuery, GetSequenceWithRecipientsQueryVariables> &
    ({ variables: GetSequenceWithRecipientsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequenceWithRecipientsQuery, GetSequenceWithRecipientsQueryVariables>(
    GetSequenceWithRecipientsDocument,
    options,
  )
}
export function useGetSequenceWithRecipientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSequenceWithRecipientsQuery, GetSequenceWithRecipientsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequenceWithRecipientsQuery, GetSequenceWithRecipientsQueryVariables>(
    GetSequenceWithRecipientsDocument,
    options,
  )
}
export function useGetSequenceWithRecipientsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSequenceWithRecipientsQuery, GetSequenceWithRecipientsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequenceWithRecipientsQuery, GetSequenceWithRecipientsQueryVariables>(
    GetSequenceWithRecipientsDocument,
    options,
  )
}
export type GetSequenceWithRecipientsQueryHookResult = ReturnType<typeof useGetSequenceWithRecipientsQuery>
export type GetSequenceWithRecipientsLazyQueryHookResult = ReturnType<typeof useGetSequenceWithRecipientsLazyQuery>
export type GetSequenceWithRecipientsSuspenseQueryHookResult = ReturnType<
  typeof useGetSequenceWithRecipientsSuspenseQuery
>
export type GetSequenceWithRecipientsQueryResult = Apollo.QueryResult<
  GetSequenceWithRecipientsQuery,
  GetSequenceWithRecipientsQueryVariables
>
export const GetSequencesDocument = gql`
  query GetSequences($input: GetSequencesInput!) {
    GetSequences(input: $input) {
      activeSequences {
        ...Sequence
      }
      allSequences {
        ...Sequence
      }
      archived {
        ...Sequence
      }
      ownedByMe {
        ...Sequence
      }
      sharedWithMe {
        ...Sequence
      }
    }
  }
  ${SequenceFragmentDoc}
`

/**
 * __useGetSequencesQuery__
 *
 * To run a query within a React component, call `useGetSequencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSequencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSequencesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSequencesQuery(
  baseOptions: Apollo.QueryHookOptions<GetSequencesQuery, GetSequencesQueryVariables> &
    ({ variables: GetSequencesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSequencesQuery, GetSequencesQueryVariables>(GetSequencesDocument, options)
}
export function useGetSequencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSequencesQuery, GetSequencesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSequencesQuery, GetSequencesQueryVariables>(GetSequencesDocument, options)
}
export function useGetSequencesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSequencesQuery, GetSequencesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSequencesQuery, GetSequencesQueryVariables>(GetSequencesDocument, options)
}
export type GetSequencesQueryHookResult = ReturnType<typeof useGetSequencesQuery>
export type GetSequencesLazyQueryHookResult = ReturnType<typeof useGetSequencesLazyQuery>
export type GetSequencesSuspenseQueryHookResult = ReturnType<typeof useGetSequencesSuspenseQuery>
export type GetSequencesQueryResult = Apollo.QueryResult<GetSequencesQuery, GetSequencesQueryVariables>
export const GetSkillsDocument = gql`
  query GetSkills($id: Int, $experienceId: Int, $page: Int, $limit: Int) {
    GetSkills(id: $id, experienceId: $experienceId, page: $page, limit: $limit) {
      ...SkillFragment
    }
  }
  ${SkillFragmentFragmentDoc}
`

/**
 * __useGetSkillsQuery__
 *
 * To run a query within a React component, call `useGetSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkillsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      experienceId: // value for 'experienceId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSkillsQuery(baseOptions?: Apollo.QueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options)
}
export function useGetSkillsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options)
}
export function useGetSkillsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSkillsQuery, GetSkillsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetSkillsQuery, GetSkillsQueryVariables>(GetSkillsDocument, options)
}
export type GetSkillsQueryHookResult = ReturnType<typeof useGetSkillsQuery>
export type GetSkillsLazyQueryHookResult = ReturnType<typeof useGetSkillsLazyQuery>
export type GetSkillsSuspenseQueryHookResult = ReturnType<typeof useGetSkillsSuspenseQuery>
export type GetSkillsQueryResult = Apollo.QueryResult<GetSkillsQuery, GetSkillsQueryVariables>
export const ListSourceTrackingLinksDocument = gql`
  query ListSourceTrackingLinks($input: ListSourceTrackingLinksInput!) {
    ListSourceTrackingLinks(input: $input) {
      items {
        ...SourceTrackingLink
      }
      total
    }
  }
  ${SourceTrackingLinkFragmentDoc}
`

/**
 * __useListSourceTrackingLinksQuery__
 *
 * To run a query within a React component, call `useListSourceTrackingLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSourceTrackingLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSourceTrackingLinksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListSourceTrackingLinksQuery(
  baseOptions: Apollo.QueryHookOptions<ListSourceTrackingLinksQuery, ListSourceTrackingLinksQueryVariables> &
    ({ variables: ListSourceTrackingLinksQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListSourceTrackingLinksQuery, ListSourceTrackingLinksQueryVariables>(
    ListSourceTrackingLinksDocument,
    options,
  )
}
export function useListSourceTrackingLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSourceTrackingLinksQuery, ListSourceTrackingLinksQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListSourceTrackingLinksQuery, ListSourceTrackingLinksQueryVariables>(
    ListSourceTrackingLinksDocument,
    options,
  )
}
export function useListSourceTrackingLinksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListSourceTrackingLinksQuery, ListSourceTrackingLinksQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListSourceTrackingLinksQuery, ListSourceTrackingLinksQueryVariables>(
    ListSourceTrackingLinksDocument,
    options,
  )
}
export type ListSourceTrackingLinksQueryHookResult = ReturnType<typeof useListSourceTrackingLinksQuery>
export type ListSourceTrackingLinksLazyQueryHookResult = ReturnType<typeof useListSourceTrackingLinksLazyQuery>
export type ListSourceTrackingLinksSuspenseQueryHookResult = ReturnType<typeof useListSourceTrackingLinksSuspenseQuery>
export type ListSourceTrackingLinksQueryResult = Apollo.QueryResult<
  ListSourceTrackingLinksQuery,
  ListSourceTrackingLinksQueryVariables
>
export const GetScreenStageCollaboratorsDocument = gql`
  query GetScreenStageCollaborators($id: Int!) {
    GetTemplateStage(id: $id) {
      StageCollaborator {
        ...ScreenStageCollaboratorFragment
      }
    }
  }
  ${ScreenStageCollaboratorFragmentFragmentDoc}
`

/**
 * __useGetScreenStageCollaboratorsQuery__
 *
 * To run a query within a React component, call `useGetScreenStageCollaboratorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenStageCollaboratorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenStageCollaboratorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetScreenStageCollaboratorsQuery(
  baseOptions: Apollo.QueryHookOptions<GetScreenStageCollaboratorsQuery, GetScreenStageCollaboratorsQueryVariables> &
    ({ variables: GetScreenStageCollaboratorsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScreenStageCollaboratorsQuery, GetScreenStageCollaboratorsQueryVariables>(
    GetScreenStageCollaboratorsDocument,
    options,
  )
}
export function useGetScreenStageCollaboratorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScreenStageCollaboratorsQuery,
    GetScreenStageCollaboratorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScreenStageCollaboratorsQuery, GetScreenStageCollaboratorsQueryVariables>(
    GetScreenStageCollaboratorsDocument,
    options,
  )
}
export function useGetScreenStageCollaboratorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetScreenStageCollaboratorsQuery, GetScreenStageCollaboratorsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScreenStageCollaboratorsQuery, GetScreenStageCollaboratorsQueryVariables>(
    GetScreenStageCollaboratorsDocument,
    options,
  )
}
export type GetScreenStageCollaboratorsQueryHookResult = ReturnType<typeof useGetScreenStageCollaboratorsQuery>
export type GetScreenStageCollaboratorsLazyQueryHookResult = ReturnType<typeof useGetScreenStageCollaboratorsLazyQuery>
export type GetScreenStageCollaboratorsSuspenseQueryHookResult = ReturnType<
  typeof useGetScreenStageCollaboratorsSuspenseQuery
>
export type GetScreenStageCollaboratorsQueryResult = Apollo.QueryResult<
  GetScreenStageCollaboratorsQuery,
  GetScreenStageCollaboratorsQueryVariables
>
export const GetStageCollaboratorDocument = gql`
  query GetStageCollaborator($id: Int!) {
    GetStageCollaborator(id: $id) {
      ...StageCollaboratorFragment
      createdAt
      updatedAt
      role {
        ...RoleFragment
      }
    }
  }
  ${StageCollaboratorFragmentFragmentDoc}
  ${RoleFragmentFragmentDoc}
`

/**
 * __useGetStageCollaboratorQuery__
 *
 * To run a query within a React component, call `useGetStageCollaboratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStageCollaboratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStageCollaboratorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStageCollaboratorQuery(
  baseOptions: Apollo.QueryHookOptions<GetStageCollaboratorQuery, GetStageCollaboratorQueryVariables> &
    ({ variables: GetStageCollaboratorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetStageCollaboratorQuery, GetStageCollaboratorQueryVariables>(
    GetStageCollaboratorDocument,
    options,
  )
}
export function useGetStageCollaboratorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStageCollaboratorQuery, GetStageCollaboratorQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetStageCollaboratorQuery, GetStageCollaboratorQueryVariables>(
    GetStageCollaboratorDocument,
    options,
  )
}
export function useGetStageCollaboratorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetStageCollaboratorQuery, GetStageCollaboratorQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetStageCollaboratorQuery, GetStageCollaboratorQueryVariables>(
    GetStageCollaboratorDocument,
    options,
  )
}
export type GetStageCollaboratorQueryHookResult = ReturnType<typeof useGetStageCollaboratorQuery>
export type GetStageCollaboratorLazyQueryHookResult = ReturnType<typeof useGetStageCollaboratorLazyQuery>
export type GetStageCollaboratorSuspenseQueryHookResult = ReturnType<typeof useGetStageCollaboratorSuspenseQuery>
export type GetStageCollaboratorQueryResult = Apollo.QueryResult<
  GetStageCollaboratorQuery,
  GetStageCollaboratorQueryVariables
>
export const GetStageSettingsDocument = gql`
  query GetStageSettings($id: Int!) {
    GetStageSettings(id: $id) {
      ...StageSettingsFragment
      createdAt
      updatedAt
      JobPipeline {
        ...JobPipelineFragment
      }
      TemplateStage {
        ...TemplateStage
        createdAt
        updatedAt
      }
    }
  }
  ${StageSettingsFragmentFragmentDoc}
  ${JobPipelineFragmentFragmentDoc}
  ${TemplateStageFragmentDoc}
`

/**
 * __useGetStageSettingsQuery__
 *
 * To run a query within a React component, call `useGetStageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStageSettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStageSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<GetStageSettingsQuery, GetStageSettingsQueryVariables> &
    ({ variables: GetStageSettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetStageSettingsQuery, GetStageSettingsQueryVariables>(GetStageSettingsDocument, options)
}
export function useGetStageSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStageSettingsQuery, GetStageSettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetStageSettingsQuery, GetStageSettingsQueryVariables>(GetStageSettingsDocument, options)
}
export function useGetStageSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetStageSettingsQuery, GetStageSettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetStageSettingsQuery, GetStageSettingsQueryVariables>(
    GetStageSettingsDocument,
    options,
  )
}
export type GetStageSettingsQueryHookResult = ReturnType<typeof useGetStageSettingsQuery>
export type GetStageSettingsLazyQueryHookResult = ReturnType<typeof useGetStageSettingsLazyQuery>
export type GetStageSettingsSuspenseQueryHookResult = ReturnType<typeof useGetStageSettingsSuspenseQuery>
export type GetStageSettingsQueryResult = Apollo.QueryResult<GetStageSettingsQuery, GetStageSettingsQueryVariables>
export const GetCandidateProspectStatusDocument = gql`
  query GetCandidateProspectStatus($talentPoolId: Int, $candidateProfileId: [Int!]) {
    GetCandidateProfile(candidateProfileIds: $candidateProfileId, talentPoolId: $talentPoolId) {
      id
      ProspectStatus(talentPoolId: $talentPoolId) {
        ...ProspectStatus
      }
    }
  }
  ${ProspectStatusFragmentDoc}
`

/**
 * __useGetCandidateProspectStatusQuery__
 *
 * To run a query within a React component, call `useGetCandidateProspectStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateProspectStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateProspectStatusQuery({
 *   variables: {
 *      talentPoolId: // value for 'talentPoolId'
 *      candidateProfileId: // value for 'candidateProfileId'
 *   },
 * });
 */
export function useGetCandidateProspectStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCandidateProspectStatusQuery, GetCandidateProspectStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCandidateProspectStatusQuery, GetCandidateProspectStatusQueryVariables>(
    GetCandidateProspectStatusDocument,
    options,
  )
}
export function useGetCandidateProspectStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateProspectStatusQuery, GetCandidateProspectStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCandidateProspectStatusQuery, GetCandidateProspectStatusQueryVariables>(
    GetCandidateProspectStatusDocument,
    options,
  )
}
export function useGetCandidateProspectStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCandidateProspectStatusQuery, GetCandidateProspectStatusQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCandidateProspectStatusQuery, GetCandidateProspectStatusQueryVariables>(
    GetCandidateProspectStatusDocument,
    options,
  )
}
export type GetCandidateProspectStatusQueryHookResult = ReturnType<typeof useGetCandidateProspectStatusQuery>
export type GetCandidateProspectStatusLazyQueryHookResult = ReturnType<typeof useGetCandidateProspectStatusLazyQuery>
export type GetCandidateProspectStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetCandidateProspectStatusSuspenseQuery
>
export type GetCandidateProspectStatusQueryResult = Apollo.QueryResult<
  GetCandidateProspectStatusQuery,
  GetCandidateProspectStatusQueryVariables
>
export const GetCustomTalentPoolDocument = gql`
  query GetCustomTalentPool($input: GetCustomTalentPoolInput!) {
    GetCustomTalentPool(input: $input) {
      ...TalentPool
    }
  }
  ${TalentPoolFragmentDoc}
`

/**
 * __useGetCustomTalentPoolQuery__
 *
 * To run a query within a React component, call `useGetCustomTalentPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomTalentPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomTalentPoolQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomTalentPoolQuery(
  baseOptions: Apollo.QueryHookOptions<GetCustomTalentPoolQuery, GetCustomTalentPoolQueryVariables> &
    ({ variables: GetCustomTalentPoolQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCustomTalentPoolQuery, GetCustomTalentPoolQueryVariables>(
    GetCustomTalentPoolDocument,
    options,
  )
}
export function useGetCustomTalentPoolLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomTalentPoolQuery, GetCustomTalentPoolQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCustomTalentPoolQuery, GetCustomTalentPoolQueryVariables>(
    GetCustomTalentPoolDocument,
    options,
  )
}
export function useGetCustomTalentPoolSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetCustomTalentPoolQuery, GetCustomTalentPoolQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCustomTalentPoolQuery, GetCustomTalentPoolQueryVariables>(
    GetCustomTalentPoolDocument,
    options,
  )
}
export type GetCustomTalentPoolQueryHookResult = ReturnType<typeof useGetCustomTalentPoolQuery>
export type GetCustomTalentPoolLazyQueryHookResult = ReturnType<typeof useGetCustomTalentPoolLazyQuery>
export type GetCustomTalentPoolSuspenseQueryHookResult = ReturnType<typeof useGetCustomTalentPoolSuspenseQuery>
export type GetCustomTalentPoolQueryResult = Apollo.QueryResult<
  GetCustomTalentPoolQuery,
  GetCustomTalentPoolQueryVariables
>
export const GetTalentPoolProspectStatusDocument = gql`
  query GetTalentPoolProspectStatus($input: GetTalentPoolProspectStatusInput!) {
    GetTalentPoolProspectStatus(input: $input) {
      ...ProspectStatus
    }
  }
  ${ProspectStatusFragmentDoc}
`

/**
 * __useGetTalentPoolProspectStatusQuery__
 *
 * To run a query within a React component, call `useGetTalentPoolProspectStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentPoolProspectStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentPoolProspectStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTalentPoolProspectStatusQuery(
  baseOptions: Apollo.QueryHookOptions<GetTalentPoolProspectStatusQuery, GetTalentPoolProspectStatusQueryVariables> &
    ({ variables: GetTalentPoolProspectStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTalentPoolProspectStatusQuery, GetTalentPoolProspectStatusQueryVariables>(
    GetTalentPoolProspectStatusDocument,
    options,
  )
}
export function useGetTalentPoolProspectStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTalentPoolProspectStatusQuery,
    GetTalentPoolProspectStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTalentPoolProspectStatusQuery, GetTalentPoolProspectStatusQueryVariables>(
    GetTalentPoolProspectStatusDocument,
    options,
  )
}
export function useGetTalentPoolProspectStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTalentPoolProspectStatusQuery, GetTalentPoolProspectStatusQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTalentPoolProspectStatusQuery, GetTalentPoolProspectStatusQueryVariables>(
    GetTalentPoolProspectStatusDocument,
    options,
  )
}
export type GetTalentPoolProspectStatusQueryHookResult = ReturnType<typeof useGetTalentPoolProspectStatusQuery>
export type GetTalentPoolProspectStatusLazyQueryHookResult = ReturnType<typeof useGetTalentPoolProspectStatusLazyQuery>
export type GetTalentPoolProspectStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetTalentPoolProspectStatusSuspenseQuery
>
export type GetTalentPoolProspectStatusQueryResult = Apollo.QueryResult<
  GetTalentPoolProspectStatusQuery,
  GetTalentPoolProspectStatusQueryVariables
>
export const GetTalentPoolsOptionsDocument = gql`
  query GetTalentPoolsOptions {
    GetTalentPools {
      allCustomTalentPools {
        id
        name
      }
    }
  }
`

/**
 * __useGetTalentPoolsOptionsQuery__
 *
 * To run a query within a React component, call `useGetTalentPoolsOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentPoolsOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentPoolsOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTalentPoolsOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTalentPoolsOptionsQuery, GetTalentPoolsOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTalentPoolsOptionsQuery, GetTalentPoolsOptionsQueryVariables>(
    GetTalentPoolsOptionsDocument,
    options,
  )
}
export function useGetTalentPoolsOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTalentPoolsOptionsQuery, GetTalentPoolsOptionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTalentPoolsOptionsQuery, GetTalentPoolsOptionsQueryVariables>(
    GetTalentPoolsOptionsDocument,
    options,
  )
}
export function useGetTalentPoolsOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTalentPoolsOptionsQuery, GetTalentPoolsOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTalentPoolsOptionsQuery, GetTalentPoolsOptionsQueryVariables>(
    GetTalentPoolsOptionsDocument,
    options,
  )
}
export type GetTalentPoolsOptionsQueryHookResult = ReturnType<typeof useGetTalentPoolsOptionsQuery>
export type GetTalentPoolsOptionsLazyQueryHookResult = ReturnType<typeof useGetTalentPoolsOptionsLazyQuery>
export type GetTalentPoolsOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTalentPoolsOptionsSuspenseQuery>
export type GetTalentPoolsOptionsQueryResult = Apollo.QueryResult<
  GetTalentPoolsOptionsQuery,
  GetTalentPoolsOptionsQueryVariables
>
export const GetTalentPoolsDocument = gql`
  query GetTalentPools($input: GetTalentPoolsInput) {
    GetTalentPools(input: $input) {
      views {
        list {
          ...ViewLinkWithUserPreference
        }
        createdByMe {
          ...RequisitionTalentPoolCompanySavedView
        }
        defaultViews {
          ...RequisitionTalentPoolCompanySavedView
        }
        savedByOthers {
          ...RequisitionTalentPoolCompanySavedView
        }
      }
      defaultTalentPools {
        ...TalentPool
      }
      allCustomTalentPools {
        ...TalentPool
      }
      favorites {
        ...TalentPool
      }
      myTalentPools {
        ...TalentPool
      }
      sharedWithMe {
        ...TalentPool
      }
      archived {
        ...TalentPool
      }
    }
  }
  ${ViewLinkWithUserPreferenceFragmentDoc}
  ${RequisitionTalentPoolCompanySavedViewFragmentDoc}
  ${TalentPoolFragmentDoc}
`

/**
 * __useGetTalentPoolsQuery__
 *
 * To run a query within a React component, call `useGetTalentPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTalentPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTalentPoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTalentPoolsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTalentPoolsQuery, GetTalentPoolsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTalentPoolsQuery, GetTalentPoolsQueryVariables>(GetTalentPoolsDocument, options)
}
export function useGetTalentPoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTalentPoolsQuery, GetTalentPoolsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTalentPoolsQuery, GetTalentPoolsQueryVariables>(GetTalentPoolsDocument, options)
}
export function useGetTalentPoolsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTalentPoolsQuery, GetTalentPoolsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTalentPoolsQuery, GetTalentPoolsQueryVariables>(GetTalentPoolsDocument, options)
}
export type GetTalentPoolsQueryHookResult = ReturnType<typeof useGetTalentPoolsQuery>
export type GetTalentPoolsLazyQueryHookResult = ReturnType<typeof useGetTalentPoolsLazyQuery>
export type GetTalentPoolsSuspenseQueryHookResult = ReturnType<typeof useGetTalentPoolsSuspenseQuery>
export type GetTalentPoolsQueryResult = Apollo.QueryResult<GetTalentPoolsQuery, GetTalentPoolsQueryVariables>
export const SearchTalentPoolFilterContentDocument = gql`
  query SearchTalentPoolFilterContent($talentPoolId: Int, $filterType: FilterContentTypeEnum!, $search: String!) {
    SearchTalentPoolFilterContent(filterType: $filterType, search: $search, talentPoolId: $talentPoolId) {
      id
      value
    }
  }
`

/**
 * __useSearchTalentPoolFilterContentQuery__
 *
 * To run a query within a React component, call `useSearchTalentPoolFilterContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTalentPoolFilterContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTalentPoolFilterContentQuery({
 *   variables: {
 *      talentPoolId: // value for 'talentPoolId'
 *      filterType: // value for 'filterType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchTalentPoolFilterContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchTalentPoolFilterContentQuery,
    SearchTalentPoolFilterContentQueryVariables
  > &
    ({ variables: SearchTalentPoolFilterContentQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchTalentPoolFilterContentQuery, SearchTalentPoolFilterContentQueryVariables>(
    SearchTalentPoolFilterContentDocument,
    options,
  )
}
export function useSearchTalentPoolFilterContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchTalentPoolFilterContentQuery,
    SearchTalentPoolFilterContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchTalentPoolFilterContentQuery, SearchTalentPoolFilterContentQueryVariables>(
    SearchTalentPoolFilterContentDocument,
    options,
  )
}
export function useSearchTalentPoolFilterContentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchTalentPoolFilterContentQuery, SearchTalentPoolFilterContentQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SearchTalentPoolFilterContentQuery, SearchTalentPoolFilterContentQueryVariables>(
    SearchTalentPoolFilterContentDocument,
    options,
  )
}
export type SearchTalentPoolFilterContentQueryHookResult = ReturnType<typeof useSearchTalentPoolFilterContentQuery>
export type SearchTalentPoolFilterContentLazyQueryHookResult = ReturnType<
  typeof useSearchTalentPoolFilterContentLazyQuery
>
export type SearchTalentPoolFilterContentSuspenseQueryHookResult = ReturnType<
  typeof useSearchTalentPoolFilterContentSuspenseQuery
>
export type SearchTalentPoolFilterContentQueryResult = Apollo.QueryResult<
  SearchTalentPoolFilterContentQuery,
  SearchTalentPoolFilterContentQueryVariables
>
export const ListTemplateMessagesOptionsDocument = gql`
  query ListTemplateMessagesOptions($input: ListTemplateMessageInput!) {
    ListTemplateMessages(input: $input) {
      id
      title
      message
    }
  }
`

/**
 * __useListTemplateMessagesOptionsQuery__
 *
 * To run a query within a React component, call `useListTemplateMessagesOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplateMessagesOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplateMessagesOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListTemplateMessagesOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<ListTemplateMessagesOptionsQuery, ListTemplateMessagesOptionsQueryVariables> &
    ({ variables: ListTemplateMessagesOptionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListTemplateMessagesOptionsQuery, ListTemplateMessagesOptionsQueryVariables>(
    ListTemplateMessagesOptionsDocument,
    options,
  )
}
export function useListTemplateMessagesOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListTemplateMessagesOptionsQuery,
    ListTemplateMessagesOptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListTemplateMessagesOptionsQuery, ListTemplateMessagesOptionsQueryVariables>(
    ListTemplateMessagesOptionsDocument,
    options,
  )
}
export function useListTemplateMessagesOptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTemplateMessagesOptionsQuery, ListTemplateMessagesOptionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListTemplateMessagesOptionsQuery, ListTemplateMessagesOptionsQueryVariables>(
    ListTemplateMessagesOptionsDocument,
    options,
  )
}
export type ListTemplateMessagesOptionsQueryHookResult = ReturnType<typeof useListTemplateMessagesOptionsQuery>
export type ListTemplateMessagesOptionsLazyQueryHookResult = ReturnType<typeof useListTemplateMessagesOptionsLazyQuery>
export type ListTemplateMessagesOptionsSuspenseQueryHookResult = ReturnType<
  typeof useListTemplateMessagesOptionsSuspenseQuery
>
export type ListTemplateMessagesOptionsQueryResult = Apollo.QueryResult<
  ListTemplateMessagesOptionsQuery,
  ListTemplateMessagesOptionsQueryVariables
>
export const ListTemplateMessagesDocument = gql`
  query ListTemplateMessages($input: ListTemplateMessageInput!) {
    ListTemplateMessages(input: $input) {
      id
      title
      message
      messageType
      messageOwner
      ccEmails
      bccEmails
      emailSubject
      senderAddressId
      createdAt
      updatedAt
      ConnectedEmailSettings {
        id
        email
      }
      CompanyUser {
        id
        profileImage
        UserInvitation {
          id
          ScalisUser {
            id
            firstName
            lastName
            profileImage
          }
        }
      }
    }
  }
`

/**
 * __useListTemplateMessagesQuery__
 *
 * To run a query within a React component, call `useListTemplateMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplateMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplateMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListTemplateMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<ListTemplateMessagesQuery, ListTemplateMessagesQueryVariables> &
    ({ variables: ListTemplateMessagesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListTemplateMessagesQuery, ListTemplateMessagesQueryVariables>(
    ListTemplateMessagesDocument,
    options,
  )
}
export function useListTemplateMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTemplateMessagesQuery, ListTemplateMessagesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListTemplateMessagesQuery, ListTemplateMessagesQueryVariables>(
    ListTemplateMessagesDocument,
    options,
  )
}
export function useListTemplateMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTemplateMessagesQuery, ListTemplateMessagesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListTemplateMessagesQuery, ListTemplateMessagesQueryVariables>(
    ListTemplateMessagesDocument,
    options,
  )
}
export type ListTemplateMessagesQueryHookResult = ReturnType<typeof useListTemplateMessagesQuery>
export type ListTemplateMessagesLazyQueryHookResult = ReturnType<typeof useListTemplateMessagesLazyQuery>
export type ListTemplateMessagesSuspenseQueryHookResult = ReturnType<typeof useListTemplateMessagesSuspenseQuery>
export type ListTemplateMessagesQueryResult = Apollo.QueryResult<
  ListTemplateMessagesQuery,
  ListTemplateMessagesQueryVariables
>
export const GetTemplateMilestoneDocument = gql`
  query GetTemplateMilestone($id: Int!) {
    GetTemplateMilestone(id: $id) {
      ...TemplateMilestone
      createdAt
      updatedAt
      TemplatePipeline {
        ...TemplatePipelineFragment
        createdAt
        updatedAt
      }
      TemplateStage {
        ...TemplateStage
        createdAt
        updatedAt
      }
    }
  }
  ${TemplateMilestoneFragmentDoc}
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateStageFragmentDoc}
`

/**
 * __useGetTemplateMilestoneQuery__
 *
 * To run a query within a React component, call `useGetTemplateMilestoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateMilestoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateMilestoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTemplateMilestoneQuery(
  baseOptions: Apollo.QueryHookOptions<GetTemplateMilestoneQuery, GetTemplateMilestoneQueryVariables> &
    ({ variables: GetTemplateMilestoneQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTemplateMilestoneQuery, GetTemplateMilestoneQueryVariables>(
    GetTemplateMilestoneDocument,
    options,
  )
}
export function useGetTemplateMilestoneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateMilestoneQuery, GetTemplateMilestoneQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTemplateMilestoneQuery, GetTemplateMilestoneQueryVariables>(
    GetTemplateMilestoneDocument,
    options,
  )
}
export function useGetTemplateMilestoneSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTemplateMilestoneQuery, GetTemplateMilestoneQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTemplateMilestoneQuery, GetTemplateMilestoneQueryVariables>(
    GetTemplateMilestoneDocument,
    options,
  )
}
export type GetTemplateMilestoneQueryHookResult = ReturnType<typeof useGetTemplateMilestoneQuery>
export type GetTemplateMilestoneLazyQueryHookResult = ReturnType<typeof useGetTemplateMilestoneLazyQuery>
export type GetTemplateMilestoneSuspenseQueryHookResult = ReturnType<typeof useGetTemplateMilestoneSuspenseQuery>
export type GetTemplateMilestoneQueryResult = Apollo.QueryResult<
  GetTemplateMilestoneQuery,
  GetTemplateMilestoneQueryVariables
>
export const GetTemplatePipelineDocument = gql`
  query GetTemplatePipeline($id: Int!) {
    GetTemplatePipeline(id: $id) {
      ...TemplatePipelineFragment
      createdAt
      updatedAt
      TemplateMilestones {
        ...TemplateMilestone
        createdAt
        updatedAt
      }
      TemplateStage {
        ...TemplateStage
        createdAt
        updatedAt
      }
      JobPipeline {
        ...JobPipelineFragment
      }
      CompanyDepartment {
        ...CompanyDepartmentFragment
      }
    }
  }
  ${TemplatePipelineFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplateStageFragmentDoc}
  ${JobPipelineFragmentFragmentDoc}
  ${CompanyDepartmentFragmentFragmentDoc}
`

/**
 * __useGetTemplatePipelineQuery__
 *
 * To run a query within a React component, call `useGetTemplatePipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatePipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatePipelineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTemplatePipelineQuery(
  baseOptions: Apollo.QueryHookOptions<GetTemplatePipelineQuery, GetTemplatePipelineQueryVariables> &
    ({ variables: GetTemplatePipelineQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTemplatePipelineQuery, GetTemplatePipelineQueryVariables>(
    GetTemplatePipelineDocument,
    options,
  )
}
export function useGetTemplatePipelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatePipelineQuery, GetTemplatePipelineQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTemplatePipelineQuery, GetTemplatePipelineQueryVariables>(
    GetTemplatePipelineDocument,
    options,
  )
}
export function useGetTemplatePipelineSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTemplatePipelineQuery, GetTemplatePipelineQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTemplatePipelineQuery, GetTemplatePipelineQueryVariables>(
    GetTemplatePipelineDocument,
    options,
  )
}
export type GetTemplatePipelineQueryHookResult = ReturnType<typeof useGetTemplatePipelineQuery>
export type GetTemplatePipelineLazyQueryHookResult = ReturnType<typeof useGetTemplatePipelineLazyQuery>
export type GetTemplatePipelineSuspenseQueryHookResult = ReturnType<typeof useGetTemplatePipelineSuspenseQuery>
export type GetTemplatePipelineQueryResult = Apollo.QueryResult<
  GetTemplatePipelineQuery,
  GetTemplatePipelineQueryVariables
>
export const ListTemplatePipelinesDocument = gql`
  query ListTemplatePipelines($companyDepartmentId: Int, $archived: Boolean) {
    ListTemplatePipelines(companyDepartmentId: $companyDepartmentId, archived: $archived) {
      id
      name
      companyDepartmentId
      pipelinedUsed
      archived
      createdAt
      updatedAt
      deletedAt
      CompanyDepartment {
        id
        departmentName
        subordinateTo
        externalId
        createdAt
        updatedAt
      }
      CompanyUser {
        id
        profileImage
        UserInvitation {
          id
          ScalisUser {
            ...ScalisUser
          }
        }
      }
      TemplateMilestones {
        id
        name
        rankOrder
        TemplateStage {
          id
          rankOrder
          name
          visibility
        }
      }
      TemplateStage {
        id
        name
      }
    }
  }
  ${ScalisUserFragmentDoc}
`

/**
 * __useListTemplatePipelinesQuery__
 *
 * To run a query within a React component, call `useListTemplatePipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTemplatePipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTemplatePipelinesQuery({
 *   variables: {
 *      companyDepartmentId: // value for 'companyDepartmentId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useListTemplatePipelinesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTemplatePipelinesQuery, ListTemplatePipelinesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ListTemplatePipelinesQuery, ListTemplatePipelinesQueryVariables>(
    ListTemplatePipelinesDocument,
    options,
  )
}
export function useListTemplatePipelinesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTemplatePipelinesQuery, ListTemplatePipelinesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ListTemplatePipelinesQuery, ListTemplatePipelinesQueryVariables>(
    ListTemplatePipelinesDocument,
    options,
  )
}
export function useListTemplatePipelinesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListTemplatePipelinesQuery, ListTemplatePipelinesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ListTemplatePipelinesQuery, ListTemplatePipelinesQueryVariables>(
    ListTemplatePipelinesDocument,
    options,
  )
}
export type ListTemplatePipelinesQueryHookResult = ReturnType<typeof useListTemplatePipelinesQuery>
export type ListTemplatePipelinesLazyQueryHookResult = ReturnType<typeof useListTemplatePipelinesLazyQuery>
export type ListTemplatePipelinesSuspenseQueryHookResult = ReturnType<typeof useListTemplatePipelinesSuspenseQuery>
export type ListTemplatePipelinesQueryResult = Apollo.QueryResult<
  ListTemplatePipelinesQuery,
  ListTemplatePipelinesQueryVariables
>
export const GetTemplateStageModalDataDocument = gql`
  query GetTemplateStageModalData($id: Int!) {
    GetTemplateStage(id: $id) {
      __typename
      id
      name
      TemplateMilestone {
        __typename
        id
        name
      }
      TemplatePipeline {
        __typename
        id
        JobPipeline {
          __typename
          id
          jobRequisitionId
        }
      }
    }
  }
`

/**
 * __useGetTemplateStageModalDataQuery__
 *
 * To run a query within a React component, call `useGetTemplateStageModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateStageModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateStageModalDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTemplateStageModalDataQuery(
  baseOptions: Apollo.QueryHookOptions<GetTemplateStageModalDataQuery, GetTemplateStageModalDataQueryVariables> &
    ({ variables: GetTemplateStageModalDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTemplateStageModalDataQuery, GetTemplateStageModalDataQueryVariables>(
    GetTemplateStageModalDataDocument,
    options,
  )
}
export function useGetTemplateStageModalDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateStageModalDataQuery, GetTemplateStageModalDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTemplateStageModalDataQuery, GetTemplateStageModalDataQueryVariables>(
    GetTemplateStageModalDataDocument,
    options,
  )
}
export function useGetTemplateStageModalDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTemplateStageModalDataQuery, GetTemplateStageModalDataQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTemplateStageModalDataQuery, GetTemplateStageModalDataQueryVariables>(
    GetTemplateStageModalDataDocument,
    options,
  )
}
export type GetTemplateStageModalDataQueryHookResult = ReturnType<typeof useGetTemplateStageModalDataQuery>
export type GetTemplateStageModalDataLazyQueryHookResult = ReturnType<typeof useGetTemplateStageModalDataLazyQuery>
export type GetTemplateStageModalDataSuspenseQueryHookResult = ReturnType<
  typeof useGetTemplateStageModalDataSuspenseQuery
>
export type GetTemplateStageModalDataQueryResult = Apollo.QueryResult<
  GetTemplateStageModalDataQuery,
  GetTemplateStageModalDataQueryVariables
>
export const GetTemplateStageDocument = gql`
  query GetTemplateStage($id: Int!) {
    GetTemplateStage(id: $id) {
      ...TemplateStage
      createdAt
      updatedAt
      StageSettings {
        ...StageSettingsFragment
        createdAt
        updatedAt
      }
      TemplateMilestone {
        ...TemplateMilestone
        createdAt
        updatedAt
      }
      TemplatePipeline {
        ...TemplatePipelineFragment
        createdAt
        updatedAt
      }
      StageCollaborator {
        ...StageCollaboratorFragment
        createdAt
        updatedAt
        role {
          ...RoleFragment
        }
      }
    }
  }
  ${TemplateStageFragmentDoc}
  ${StageSettingsFragmentFragmentDoc}
  ${TemplateMilestoneFragmentDoc}
  ${TemplatePipelineFragmentFragmentDoc}
  ${StageCollaboratorFragmentFragmentDoc}
  ${RoleFragmentFragmentDoc}
`

/**
 * __useGetTemplateStageQuery__
 *
 * To run a query within a React component, call `useGetTemplateStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateStageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTemplateStageQuery(
  baseOptions: Apollo.QueryHookOptions<GetTemplateStageQuery, GetTemplateStageQueryVariables> &
    ({ variables: GetTemplateStageQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTemplateStageQuery, GetTemplateStageQueryVariables>(GetTemplateStageDocument, options)
}
export function useGetTemplateStageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateStageQuery, GetTemplateStageQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTemplateStageQuery, GetTemplateStageQueryVariables>(GetTemplateStageDocument, options)
}
export function useGetTemplateStageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTemplateStageQuery, GetTemplateStageQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTemplateStageQuery, GetTemplateStageQueryVariables>(
    GetTemplateStageDocument,
    options,
  )
}
export type GetTemplateStageQueryHookResult = ReturnType<typeof useGetTemplateStageQuery>
export type GetTemplateStageLazyQueryHookResult = ReturnType<typeof useGetTemplateStageLazyQuery>
export type GetTemplateStageSuspenseQueryHookResult = ReturnType<typeof useGetTemplateStageSuspenseQuery>
export type GetTemplateStageQueryResult = Apollo.QueryResult<GetTemplateStageQuery, GetTemplateStageQueryVariables>
export const GetTemporaryS3UrlDocument = gql`
  query GetTemporaryS3Url($input: GetTemporaryS3UrlInput!) {
    GetTemporaryS3Url(input: $input) {
      tempUrl
    }
  }
`

/**
 * __useGetTemporaryS3UrlQuery__
 *
 * To run a query within a React component, call `useGetTemporaryS3UrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemporaryS3UrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemporaryS3UrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTemporaryS3UrlQuery(
  baseOptions: Apollo.QueryHookOptions<GetTemporaryS3UrlQuery, GetTemporaryS3UrlQueryVariables> &
    ({ variables: GetTemporaryS3UrlQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetTemporaryS3UrlQuery, GetTemporaryS3UrlQueryVariables>(GetTemporaryS3UrlDocument, options)
}
export function useGetTemporaryS3UrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTemporaryS3UrlQuery, GetTemporaryS3UrlQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetTemporaryS3UrlQuery, GetTemporaryS3UrlQueryVariables>(
    GetTemporaryS3UrlDocument,
    options,
  )
}
export function useGetTemporaryS3UrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetTemporaryS3UrlQuery, GetTemporaryS3UrlQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetTemporaryS3UrlQuery, GetTemporaryS3UrlQueryVariables>(
    GetTemporaryS3UrlDocument,
    options,
  )
}
export type GetTemporaryS3UrlQueryHookResult = ReturnType<typeof useGetTemporaryS3UrlQuery>
export type GetTemporaryS3UrlLazyQueryHookResult = ReturnType<typeof useGetTemporaryS3UrlLazyQuery>
export type GetTemporaryS3UrlSuspenseQueryHookResult = ReturnType<typeof useGetTemporaryS3UrlSuspenseQuery>
export type GetTemporaryS3UrlQueryResult = Apollo.QueryResult<GetTemporaryS3UrlQuery, GetTemporaryS3UrlQueryVariables>
export const GetUploadedCandidateDocument = gql`
  query GetUploadedCandidate($id: Int, $profileUrl: String) {
    GetUploadedCandidate(id: $id, profileUrl: $profileUrl) {
      ...UploadedCandidate
    }
  }
  ${UploadedCandidateFragmentDoc}
`

/**
 * __useGetUploadedCandidateQuery__
 *
 * To run a query within a React component, call `useGetUploadedCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadedCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadedCandidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      profileUrl: // value for 'profileUrl'
 *   },
 * });
 */
export function useGetUploadedCandidateQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUploadedCandidateQuery, GetUploadedCandidateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetUploadedCandidateQuery, GetUploadedCandidateQueryVariables>(
    GetUploadedCandidateDocument,
    options,
  )
}
export function useGetUploadedCandidateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUploadedCandidateQuery, GetUploadedCandidateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetUploadedCandidateQuery, GetUploadedCandidateQueryVariables>(
    GetUploadedCandidateDocument,
    options,
  )
}
export function useGetUploadedCandidateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUploadedCandidateQuery, GetUploadedCandidateQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetUploadedCandidateQuery, GetUploadedCandidateQueryVariables>(
    GetUploadedCandidateDocument,
    options,
  )
}
export type GetUploadedCandidateQueryHookResult = ReturnType<typeof useGetUploadedCandidateQuery>
export type GetUploadedCandidateLazyQueryHookResult = ReturnType<typeof useGetUploadedCandidateLazyQuery>
export type GetUploadedCandidateSuspenseQueryHookResult = ReturnType<typeof useGetUploadedCandidateSuspenseQuery>
export type GetUploadedCandidateQueryResult = Apollo.QueryResult<
  GetUploadedCandidateQuery,
  GetUploadedCandidateQueryVariables
>
export const GetAccountInformationDocument = gql`
  query GetAccountInformation {
    Me {
      id
      firstName
      lastName
      Address {
        ...AddressFragment
      }
      ContactInfo {
        id
        phoneNumber
      }
    }
  }
  ${AddressFragmentFragmentDoc}
`

/**
 * __useGetAccountInformationQuery__
 *
 * To run a query within a React component, call `useGetAccountInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountInformationQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAccountInformationQuery, GetAccountInformationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAccountInformationQuery, GetAccountInformationQueryVariables>(
    GetAccountInformationDocument,
    options,
  )
}
export function useGetAccountInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountInformationQuery, GetAccountInformationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAccountInformationQuery, GetAccountInformationQueryVariables>(
    GetAccountInformationDocument,
    options,
  )
}
export function useGetAccountInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAccountInformationQuery, GetAccountInformationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetAccountInformationQuery, GetAccountInformationQueryVariables>(
    GetAccountInformationDocument,
    options,
  )
}
export type GetAccountInformationQueryHookResult = ReturnType<typeof useGetAccountInformationQuery>
export type GetAccountInformationLazyQueryHookResult = ReturnType<typeof useGetAccountInformationLazyQuery>
export type GetAccountInformationSuspenseQueryHookResult = ReturnType<typeof useGetAccountInformationSuspenseQuery>
export type GetAccountInformationQueryResult = Apollo.QueryResult<
  GetAccountInformationQuery,
  GetAccountInformationQueryVariables
>
export const GetEmailsDocument = gql`
  query GetEmails($scalisUserId: Int!) {
    GetScalisUser(id: $scalisUserId) {
      EmailVerification {
        __typename
        id
        emailAddress
        isPrimary
        isVisibleToEmployers
        activeStatus
        emailVerified
      }
    }
  }
`

/**
 * __useGetEmailsQuery__
 *
 * To run a query within a React component, call `useGetEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailsQuery({
 *   variables: {
 *      scalisUserId: // value for 'scalisUserId'
 *   },
 * });
 */
export function useGetEmailsQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmailsQuery, GetEmailsQueryVariables> &
    ({ variables: GetEmailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetEmailsQuery, GetEmailsQueryVariables>(GetEmailsDocument, options)
}
export function useGetEmailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmailsQuery, GetEmailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetEmailsQuery, GetEmailsQueryVariables>(GetEmailsDocument, options)
}
export function useGetEmailsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailsQuery, GetEmailsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetEmailsQuery, GetEmailsQueryVariables>(GetEmailsDocument, options)
}
export type GetEmailsQueryHookResult = ReturnType<typeof useGetEmailsQuery>
export type GetEmailsLazyQueryHookResult = ReturnType<typeof useGetEmailsLazyQuery>
export type GetEmailsSuspenseQueryHookResult = ReturnType<typeof useGetEmailsSuspenseQuery>
export type GetEmailsQueryResult = Apollo.QueryResult<GetEmailsQuery, GetEmailsQueryVariables>
export const GetScalisUserIdDocument = gql`
  query GetScalisUserId {
    Me {
      id
    }
  }
`

/**
 * __useGetScalisUserIdQuery__
 *
 * To run a query within a React component, call `useGetScalisUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScalisUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScalisUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScalisUserIdQuery(
  baseOptions?: Apollo.QueryHookOptions<GetScalisUserIdQuery, GetScalisUserIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetScalisUserIdQuery, GetScalisUserIdQueryVariables>(GetScalisUserIdDocument, options)
}
export function useGetScalisUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetScalisUserIdQuery, GetScalisUserIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetScalisUserIdQuery, GetScalisUserIdQueryVariables>(GetScalisUserIdDocument, options)
}
export function useGetScalisUserIdSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScalisUserIdQuery, GetScalisUserIdQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetScalisUserIdQuery, GetScalisUserIdQueryVariables>(GetScalisUserIdDocument, options)
}
export type GetScalisUserIdQueryHookResult = ReturnType<typeof useGetScalisUserIdQuery>
export type GetScalisUserIdLazyQueryHookResult = ReturnType<typeof useGetScalisUserIdLazyQuery>
export type GetScalisUserIdSuspenseQueryHookResult = ReturnType<typeof useGetScalisUserIdSuspenseQuery>
export type GetScalisUserIdQueryResult = Apollo.QueryResult<GetScalisUserIdQuery, GetScalisUserIdQueryVariables>
